(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["tomtom"] = factory();
	else
		root["tomtom"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 100);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
    'use strict';

    function isArray(object) {
        return _.isArray(object);
    }

    /**
     * @ignore
     * Consider NULL as not an object.
     * @param {*} val
     * @return {Boolean}
     */
    function isObject(val) {
        return _.isObject(val);
    }

    /**
     * @ignore
     * Consider NaN and Infinite as not a number.
     * @param {*} val
     * @return {Boolean}
     */
    function isValidNumber(val) {
        return _.isFinite(val);
    }

    /**
     * @ignore
     * @param {*} val
     * @return {Boolean}
     */
    function isNonEmptyString(val) {
        return _.isString(val) && val.length > 0;
    }

    /**
     * @ignore
     * Used instead of Number.isNaN
     * @param {*} val
     * @return {Boolean}
     */
    function numberIsNaN(val) {
        return _.isNaN(val);
    }

    /**
     * @ignore
     * Returns TRUE is the value is not undefined, null or NaN.
     * @param {*} val
     * @return {Boolean}
     */
    function isValidValue(val) {
        return val !== undefined && val !== null && !numberIsNaN(val);
    }

    /**
     * @ignore
     * Returns an function that check if a value passed as argument is an instance of an specific class.
     * @param {Object} classObject
     * @return {Function}
     */
    function createInstanceChecker(classObject) {
        return function (val) {
            return val instanceof classObject;
        };
    }

    function cloneProperties(object, clonedObject) {
        var property;
        for (property in object) {
            if (object.hasOwnProperty(property)) {
                if (isArray(object[property])) {
                    clonedObject[property] = object[property].slice(0);
                } else if (_typeof(object[property]) === 'object') {
                    clonedObject[property] = {};
                    cloneProperties(object[property], clonedObject[property]);
                } else {
                    clonedObject[property] = object[property];
                }
            }
        }
    }

    function getValueOrEmptyObject(value) {
        return value === undefined ? {} : value;
    }

    function addNewField(result, field, newFields) {
        var property;
        result[field] = getValueOrEmptyObject(result[field]);
        for (property in newFields[field]) {
            if (newFields[field].hasOwnProperty(property)) {
                result[field][property] = newFields[field][property];
            }
        }
    }

    function convertToLatLng(value) {
        var convertedValue;
        if (value instanceof L.LatLng) {
            convertedValue = value;
        } else if (isArray(value)) {
            convertedValue = L.latLng(value);
        } else if (value && value.lat && value.lon) {
            convertedValue = L.latLng([value.lat, value.lon]);
        } else if (value && value.lat && value.lng) {
            convertedValue = L.latLng([value.lat, value.lng]);
        }
        return convertedValue;
    }

    function extend(obj, src) {
        var key;
        for (key in src) {
            if (src.hasOwnProperty(key)) {
                obj[key] = src[key];
            }
        }
        return obj;
    }

    return {
        isArray: isArray,
        isEqual: _.isEqual,
        isObject: isObject,
        isString: _.isString,
        isValidNumber: isValidNumber,
        isValidValue: isValidValue,
        isNonEmptyString: isNonEmptyString,
        createInstanceChecker: createInstanceChecker,
        convertToLatLng: convertToLatLng,

        addFields: function addFields(newFields, defaultFields) {
            var field;
            var result = defaultFields || this.defaultFields || {};
            for (field in newFields) {
                if (newFields.hasOwnProperty(field)) {
                    addNewField(result, field, newFields);
                }
            }
            return result;
        },

        clone: function clone(object) {
            var clonedObject = {};
            cloneProperties(object, clonedObject);
            return clonedObject;
        },

        encodeQuery: function encodeQuery(query) {
            return encodeURIComponent(query);
        },

        encodeStringForRegex: function encodeStringForRegex(value) {
            return value.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
        },
        extend: extend,

        /**
         * @param {Object} sourceObj
         * @param {String} deprecatedPropertyName
         * @param {String} deprecatedPropertyReplacement
         */
        addDeprecatedProperty: function addDeprecatedProperty(sourceObj, deprecatedPropertyName, deprecatedPropertyReplacement) {
            Object.defineProperty(sourceObj, deprecatedPropertyName, {
                get: function get() {
                    console.warn('Usage of ' + deprecatedPropertyName + ' property is deprecated. Please use ' + deprecatedPropertyReplacement + ' property.');
                    return this[deprecatedPropertyReplacement];
                }
            });
        },

        pointRegex: /(-?\d+(?:\.\d+)?)(?:\s+|\s*,\s*)(-?\d+(?:\.\d+)?)/,

        circleRegex: /circle\((-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*,\s*(\d+)\)/,

        /**
         * @ignore
         * Returns a function, that, as long as it continues to be invoked, will not
         * be triggered. The function will be called after it stops being called for
         * N milliseconds.
         * @param {Object} context
         * @param {Function} func
         * @param {Number} wait
         * @return {Function}
         */
        debounce: function debounce(context, func, wait) {
            var timeout;
            return function () {
                var later = function later() {
                    timeout = null;
                    func.apply(context, arguments);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },

        isValueNil: function isValueNil(value) {
            return typeof value === 'undefined' || value === null;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* @preserve
 * Leaflet 1.3.0, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2017 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
!function(t,i){ true?i(exports):"function"==typeof define&&define.amd?define(["exports"],i):i(t.L={})}(this,function(t){"use strict";function i(t){var i,e,n,o;for(e=1,n=arguments.length;e<n;e++){o=arguments[e];for(i in o)t[i]=o[i]}return t}function e(t,i){var e=Array.prototype.slice;if(t.bind)return t.bind.apply(t,e.call(arguments,1));var n=e.call(arguments,2);return function(){return t.apply(i,n.length?n.concat(e.call(arguments)):arguments)}}function n(t){return t._leaflet_id=t._leaflet_id||++ti,t._leaflet_id}function o(t,i,e){var n,o,s,r;return r=function(){n=!1,o&&(s.apply(e,o),o=!1)},s=function(){n?o=arguments:(t.apply(e,arguments),setTimeout(r,i),n=!0)}}function s(t,i,e){var n=i[1],o=i[0],s=n-o;return t===n&&e?t:((t-o)%s+s)%s+o}function r(){return!1}function a(t,i){var e=Math.pow(10,void 0===i?6:i);return Math.round(t*e)/e}function h(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}function u(t){return h(t).split(/\s+/)}function l(t,i){t.hasOwnProperty("options")||(t.options=t.options?Qt(t.options):{});for(var e in i)t.options[e]=i[e];return t.options}function c(t,i,e){var n=[];for(var o in t)n.push(encodeURIComponent(e?o.toUpperCase():o)+"="+encodeURIComponent(t[o]));return(i&&-1!==i.indexOf("?")?"&":"?")+n.join("&")}function _(t,i){return t.replace(ii,function(t,e){var n=i[e];if(void 0===n)throw new Error("No value provided for variable "+t);return"function"==typeof n&&(n=n(i)),n})}function d(t,i){for(var e=0;e<t.length;e++)if(t[e]===i)return e;return-1}function p(t){return window["webkit"+t]||window["moz"+t]||window["ms"+t]}function m(t){var i=+new Date,e=Math.max(0,16-(i-oi));return oi=i+e,window.setTimeout(t,e)}function f(t,i,n){if(!n||si!==m)return si.call(window,e(t,i));t.call(i)}function g(t){t&&ri.call(window,t)}function v(){}function y(t){if("undefined"!=typeof L&&L&&L.Mixin){t=ei(t)?t:[t];for(var i=0;i<t.length;i++)t[i]===L.Mixin.Events&&console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.",(new Error).stack)}}function x(t,i,e){this.x=e?Math.round(t):t,this.y=e?Math.round(i):i}function w(t,i,e){return t instanceof x?t:ei(t)?new x(t[0],t[1]):void 0===t||null===t?t:"object"==typeof t&&"x"in t&&"y"in t?new x(t.x,t.y):new x(t,i,e)}function P(t,i){if(t)for(var e=i?[t,i]:t,n=0,o=e.length;n<o;n++)this.extend(e[n])}function b(t,i){return!t||t instanceof P?t:new P(t,i)}function T(t,i){if(t)for(var e=i?[t,i]:t,n=0,o=e.length;n<o;n++)this.extend(e[n])}function z(t,i){return t instanceof T?t:new T(t,i)}function M(t,i,e){if(isNaN(t)||isNaN(i))throw new Error("Invalid LatLng object: ("+t+", "+i+")");this.lat=+t,this.lng=+i,void 0!==e&&(this.alt=+e)}function C(t,i,e){return t instanceof M?t:ei(t)&&"object"!=typeof t[0]?3===t.length?new M(t[0],t[1],t[2]):2===t.length?new M(t[0],t[1]):null:void 0===t||null===t?t:"object"==typeof t&&"lat"in t?new M(t.lat,"lng"in t?t.lng:t.lon,t.alt):void 0===i?null:new M(t,i,e)}function Z(t,i,e,n){if(ei(t))return this._a=t[0],this._b=t[1],this._c=t[2],void(this._d=t[3]);this._a=t,this._b=i,this._c=e,this._d=n}function S(t,i,e,n){return new Z(t,i,e,n)}function E(t){return document.createElementNS("http://www.w3.org/2000/svg",t)}function k(t,i){var e,n,o,s,r,a,h="";for(e=0,o=t.length;e<o;e++){for(n=0,s=(r=t[e]).length;n<s;n++)a=r[n],h+=(n?"L":"M")+a.x+" "+a.y;h+=i?Xi?"z":"x":""}return h||"M0 0"}function I(t){return navigator.userAgent.toLowerCase().indexOf(t)>=0}function A(t,i,e,n){return"touchstart"===i?O(t,e,n):"touchmove"===i?W(t,e,n):"touchend"===i&&H(t,e,n),this}function B(t,i,e){var n=t["_leaflet_"+i+e];return"touchstart"===i?t.removeEventListener(Qi,n,!1):"touchmove"===i?t.removeEventListener(te,n,!1):"touchend"===i&&(t.removeEventListener(ie,n,!1),t.removeEventListener(ee,n,!1)),this}function O(t,i,n){var o=e(function(t){if("mouse"!==t.pointerType&&t.MSPOINTER_TYPE_MOUSE&&t.pointerType!==t.MSPOINTER_TYPE_MOUSE){if(!(ne.indexOf(t.target.tagName)<0))return;$(t)}j(t,i)});t["_leaflet_touchstart"+n]=o,t.addEventListener(Qi,o,!1),se||(document.documentElement.addEventListener(Qi,R,!0),document.documentElement.addEventListener(te,D,!0),document.documentElement.addEventListener(ie,N,!0),document.documentElement.addEventListener(ee,N,!0),se=!0)}function R(t){oe[t.pointerId]=t,re++}function D(t){oe[t.pointerId]&&(oe[t.pointerId]=t)}function N(t){delete oe[t.pointerId],re--}function j(t,i){t.touches=[];for(var e in oe)t.touches.push(oe[e]);t.changedTouches=[t],i(t)}function W(t,i,e){var n=function(t){(t.pointerType!==t.MSPOINTER_TYPE_MOUSE&&"mouse"!==t.pointerType||0!==t.buttons)&&j(t,i)};t["_leaflet_touchmove"+e]=n,t.addEventListener(te,n,!1)}function H(t,i,e){var n=function(t){j(t,i)};t["_leaflet_touchend"+e]=n,t.addEventListener(ie,n,!1),t.addEventListener(ee,n,!1)}function F(t,i,e){function n(t){var i;if(Ui){if(!Pi||"mouse"===t.pointerType)return;i=re}else i=t.touches.length;if(!(i>1)){var e=Date.now(),n=e-(s||e);r=t.touches?t.touches[0]:t,a=n>0&&n<=h,s=e}}function o(t){if(a&&!r.cancelBubble){if(Ui){if(!Pi||"mouse"===t.pointerType)return;var e,n,o={};for(n in r)e=r[n],o[n]=e&&e.bind?e.bind(r):e;r=o}r.type="dblclick",i(r),s=null}}var s,r,a=!1,h=250;return t[ue+ae+e]=n,t[ue+he+e]=o,t[ue+"dblclick"+e]=i,t.addEventListener(ae,n,!1),t.addEventListener(he,o,!1),t.addEventListener("dblclick",i,!1),this}function U(t,i){var e=t[ue+ae+i],n=t[ue+he+i],o=t[ue+"dblclick"+i];return t.removeEventListener(ae,e,!1),t.removeEventListener(he,n,!1),Pi||t.removeEventListener("dblclick",o,!1),this}function V(t,i,e,n){if("object"==typeof i)for(var o in i)G(t,o,i[o],e);else for(var s=0,r=(i=u(i)).length;s<r;s++)G(t,i[s],e,n);return this}function q(t,i,e,n){if("object"==typeof i)for(var o in i)K(t,o,i[o],e);else if(i)for(var s=0,r=(i=u(i)).length;s<r;s++)K(t,i[s],e,n);else{for(var a in t[le])K(t,a,t[le][a]);delete t[le]}return this}function G(t,i,e,o){var s=i+n(e)+(o?"_"+n(o):"");if(t[le]&&t[le][s])return this;var r=function(i){return e.call(o||t,i||window.event)},a=r;Ui&&0===i.indexOf("touch")?A(t,i,r,s):!Vi||"dblclick"!==i||!F||Ui&&Si?"addEventListener"in t?"mousewheel"===i?t.addEventListener("onwheel"in t?"wheel":"mousewheel",r,!1):"mouseenter"===i||"mouseleave"===i?(r=function(i){i=i||window.event,ot(t,i)&&a(i)},t.addEventListener("mouseenter"===i?"mouseover":"mouseout",r,!1)):("click"===i&&Ti&&(r=function(t){st(t,a)}),t.addEventListener(i,r,!1)):"attachEvent"in t&&t.attachEvent("on"+i,r):F(t,r,s),t[le]=t[le]||{},t[le][s]=r}function K(t,i,e,o){var s=i+n(e)+(o?"_"+n(o):""),r=t[le]&&t[le][s];if(!r)return this;Ui&&0===i.indexOf("touch")?B(t,i,s):!Vi||"dblclick"!==i||!U||Ui&&Si?"removeEventListener"in t?"mousewheel"===i?t.removeEventListener("onwheel"in t?"wheel":"mousewheel",r,!1):t.removeEventListener("mouseenter"===i?"mouseover":"mouseleave"===i?"mouseout":i,r,!1):"detachEvent"in t&&t.detachEvent("on"+i,r):U(t,s),t[le][s]=null}function Y(t){return t.stopPropagation?t.stopPropagation():t.originalEvent?t.originalEvent._stopped=!0:t.cancelBubble=!0,nt(t),this}function X(t){return G(t,"mousewheel",Y),this}function J(t){return V(t,"mousedown touchstart dblclick",Y),G(t,"click",et),this}function $(t){return t.preventDefault?t.preventDefault():t.returnValue=!1,this}function Q(t){return $(t),Y(t),this}function tt(t,i){if(!i)return new x(t.clientX,t.clientY);var e=i.getBoundingClientRect(),n=e.width/i.offsetWidth||1,o=e.height/i.offsetHeight||1;return new x(t.clientX/n-e.left-i.clientLeft,t.clientY/o-e.top-i.clientTop)}function it(t){return Pi?t.wheelDeltaY/2:t.deltaY&&0===t.deltaMode?-t.deltaY/ce:t.deltaY&&1===t.deltaMode?20*-t.deltaY:t.deltaY&&2===t.deltaMode?60*-t.deltaY:t.deltaX||t.deltaZ?0:t.wheelDelta?(t.wheelDeltaY||t.wheelDelta)/2:t.detail&&Math.abs(t.detail)<32765?20*-t.detail:t.detail?t.detail/-32765*60:0}function et(t){_e[t.type]=!0}function nt(t){var i=_e[t.type];return _e[t.type]=!1,i}function ot(t,i){var e=i.relatedTarget;if(!e)return!0;try{for(;e&&e!==t;)e=e.parentNode}catch(t){return!1}return e!==t}function st(t,i){var e=t.timeStamp||t.originalEvent&&t.originalEvent.timeStamp,n=pi&&e-pi;n&&n>100&&n<500||t.target._simulatedClick&&!t._simulated?Q(t):(pi=e,i(t))}function rt(t){return"string"==typeof t?document.getElementById(t):t}function at(t,i){var e=t.style[i]||t.currentStyle&&t.currentStyle[i];if((!e||"auto"===e)&&document.defaultView){var n=document.defaultView.getComputedStyle(t,null);e=n?n[i]:null}return"auto"===e?null:e}function ht(t,i,e){var n=document.createElement(t);return n.className=i||"",e&&e.appendChild(n),n}function ut(t){var i=t.parentNode;i&&i.removeChild(t)}function lt(t){for(;t.firstChild;)t.removeChild(t.firstChild)}function ct(t){var i=t.parentNode;i.lastChild!==t&&i.appendChild(t)}function _t(t){var i=t.parentNode;i.firstChild!==t&&i.insertBefore(t,i.firstChild)}function dt(t,i){if(void 0!==t.classList)return t.classList.contains(i);var e=gt(t);return e.length>0&&new RegExp("(^|\\s)"+i+"(\\s|$)").test(e)}function pt(t,i){if(void 0!==t.classList)for(var e=u(i),n=0,o=e.length;n<o;n++)t.classList.add(e[n]);else if(!dt(t,i)){var s=gt(t);ft(t,(s?s+" ":"")+i)}}function mt(t,i){void 0!==t.classList?t.classList.remove(i):ft(t,h((" "+gt(t)+" ").replace(" "+i+" "," ")))}function ft(t,i){void 0===t.className.baseVal?t.className=i:t.className.baseVal=i}function gt(t){return void 0===t.className.baseVal?t.className:t.className.baseVal}function vt(t,i){"opacity"in t.style?t.style.opacity=i:"filter"in t.style&&yt(t,i)}function yt(t,i){var e=!1,n="DXImageTransform.Microsoft.Alpha";try{e=t.filters.item(n)}catch(t){if(1===i)return}i=Math.round(100*i),e?(e.Enabled=100!==i,e.Opacity=i):t.style.filter+=" progid:"+n+"(opacity="+i+")"}function xt(t){for(var i=document.documentElement.style,e=0;e<t.length;e++)if(t[e]in i)return t[e];return!1}function wt(t,i,e){var n=i||new x(0,0);t.style[pe]=(Oi?"translate("+n.x+"px,"+n.y+"px)":"translate3d("+n.x+"px,"+n.y+"px,0)")+(e?" scale("+e+")":"")}function Lt(t,i){t._leaflet_pos=i,Ni?wt(t,i):(t.style.left=i.x+"px",t.style.top=i.y+"px")}function Pt(t){return t._leaflet_pos||new x(0,0)}function bt(){V(window,"dragstart",$)}function Tt(){q(window,"dragstart",$)}function zt(t){for(;-1===t.tabIndex;)t=t.parentNode;t.style&&(Mt(),ve=t,ye=t.style.outline,t.style.outline="none",V(window,"keydown",Mt))}function Mt(){ve&&(ve.style.outline=ye,ve=void 0,ye=void 0,q(window,"keydown",Mt))}function Ct(t,i){if(!i||!t.length)return t.slice();var e=i*i;return t=kt(t,e),t=St(t,e)}function Zt(t,i,e){return Math.sqrt(Rt(t,i,e,!0))}function St(t,i){var e=t.length,n=new(typeof Uint8Array!=void 0+""?Uint8Array:Array)(e);n[0]=n[e-1]=1,Et(t,n,i,0,e-1);var o,s=[];for(o=0;o<e;o++)n[o]&&s.push(t[o]);return s}function Et(t,i,e,n,o){var s,r,a,h=0;for(r=n+1;r<=o-1;r++)(a=Rt(t[r],t[n],t[o],!0))>h&&(s=r,h=a);h>e&&(i[s]=1,Et(t,i,e,n,s),Et(t,i,e,s,o))}function kt(t,i){for(var e=[t[0]],n=1,o=0,s=t.length;n<s;n++)Ot(t[n],t[o])>i&&(e.push(t[n]),o=n);return o<s-1&&e.push(t[s-1]),e}function It(t,i,e,n,o){var s,r,a,h=n?Se:Bt(t,e),u=Bt(i,e);for(Se=u;;){if(!(h|u))return[t,i];if(h&u)return!1;a=Bt(r=At(t,i,s=h||u,e,o),e),s===h?(t=r,h=a):(i=r,u=a)}}function At(t,i,e,n,o){var s,r,a=i.x-t.x,h=i.y-t.y,u=n.min,l=n.max;return 8&e?(s=t.x+a*(l.y-t.y)/h,r=l.y):4&e?(s=t.x+a*(u.y-t.y)/h,r=u.y):2&e?(s=l.x,r=t.y+h*(l.x-t.x)/a):1&e&&(s=u.x,r=t.y+h*(u.x-t.x)/a),new x(s,r,o)}function Bt(t,i){var e=0;return t.x<i.min.x?e|=1:t.x>i.max.x&&(e|=2),t.y<i.min.y?e|=4:t.y>i.max.y&&(e|=8),e}function Ot(t,i){var e=i.x-t.x,n=i.y-t.y;return e*e+n*n}function Rt(t,i,e,n){var o,s=i.x,r=i.y,a=e.x-s,h=e.y-r,u=a*a+h*h;return u>0&&((o=((t.x-s)*a+(t.y-r)*h)/u)>1?(s=e.x,r=e.y):o>0&&(s+=a*o,r+=h*o)),a=t.x-s,h=t.y-r,n?a*a+h*h:new x(s,r)}function Dt(t){return!ei(t[0])||"object"!=typeof t[0][0]&&void 0!==t[0][0]}function Nt(t){return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."),Dt(t)}function jt(t,i,e){var n,o,s,r,a,h,u,l,c,_=[1,4,2,8];for(o=0,u=t.length;o<u;o++)t[o]._code=Bt(t[o],i);for(r=0;r<4;r++){for(l=_[r],n=[],o=0,s=(u=t.length)-1;o<u;s=o++)a=t[o],h=t[s],a._code&l?h._code&l||((c=At(h,a,l,i,e))._code=Bt(c,i),n.push(c)):(h._code&l&&((c=At(h,a,l,i,e))._code=Bt(c,i),n.push(c)),n.push(a));t=n}return t}function Wt(t,i){var e,n,o,s,r="Feature"===t.type?t.geometry:t,a=r?r.coordinates:null,h=[],u=i&&i.pointToLayer,l=i&&i.coordsToLatLng||Ht;if(!a&&!r)return null;switch(r.type){case"Point":return e=l(a),u?u(t,e):new Xe(e);case"MultiPoint":for(o=0,s=a.length;o<s;o++)e=l(a[o]),h.push(u?u(t,e):new Xe(e));return new qe(h);case"LineString":case"MultiLineString":return n=Ft(a,"LineString"===r.type?0:1,l),new tn(n,i);case"Polygon":case"MultiPolygon":return n=Ft(a,"Polygon"===r.type?1:2,l),new en(n,i);case"GeometryCollection":for(o=0,s=r.geometries.length;o<s;o++){var c=Wt({geometry:r.geometries[o],type:"Feature",properties:t.properties},i);c&&h.push(c)}return new qe(h);default:throw new Error("Invalid GeoJSON object.")}}function Ht(t){return new M(t[1],t[0],t[2])}function Ft(t,i,e){for(var n,o=[],s=0,r=t.length;s<r;s++)n=i?Ft(t[s],i-1,e):(e||Ht)(t[s]),o.push(n);return o}function Ut(t,i){return i="number"==typeof i?i:6,void 0!==t.alt?[a(t.lng,i),a(t.lat,i),a(t.alt,i)]:[a(t.lng,i),a(t.lat,i)]}function Vt(t,i,e,n){for(var o=[],s=0,r=t.length;s<r;s++)o.push(i?Vt(t[s],i-1,e,n):Ut(t[s],n));return!i&&e&&o.push(o[0]),o}function qt(t,e){return t.feature?i({},t.feature,{geometry:e}):Gt(e)}function Gt(t){return"Feature"===t.type||"FeatureCollection"===t.type?t:{type:"Feature",properties:{},geometry:t}}function Kt(t,i){return new nn(t,i)}function Yt(t,i){return new dn(t,i)}function Xt(t){return Yi?new fn(t):null}function Jt(t){return Xi||Ji?new xn(t):null}var $t=Object.freeze;Object.freeze=function(t){return t};var Qt=Object.create||function(){function t(){}return function(i){return t.prototype=i,new t}}(),ti=0,ii=/\{ *([\w_-]+) *\}/g,ei=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},ni="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",oi=0,si=window.requestAnimationFrame||p("RequestAnimationFrame")||m,ri=window.cancelAnimationFrame||p("CancelAnimationFrame")||p("CancelRequestAnimationFrame")||function(t){window.clearTimeout(t)},ai=(Object.freeze||Object)({freeze:$t,extend:i,create:Qt,bind:e,lastId:ti,stamp:n,throttle:o,wrapNum:s,falseFn:r,formatNum:a,trim:h,splitWords:u,setOptions:l,getParamString:c,template:_,isArray:ei,indexOf:d,emptyImageUrl:ni,requestFn:si,cancelFn:ri,requestAnimFrame:f,cancelAnimFrame:g});v.extend=function(t){var e=function(){this.initialize&&this.initialize.apply(this,arguments),this.callInitHooks()},n=e.__super__=this.prototype,o=Qt(n);o.constructor=e,e.prototype=o;for(var s in this)this.hasOwnProperty(s)&&"prototype"!==s&&"__super__"!==s&&(e[s]=this[s]);return t.statics&&(i(e,t.statics),delete t.statics),t.includes&&(y(t.includes),i.apply(null,[o].concat(t.includes)),delete t.includes),o.options&&(t.options=i(Qt(o.options),t.options)),i(o,t),o._initHooks=[],o.callInitHooks=function(){if(!this._initHooksCalled){n.callInitHooks&&n.callInitHooks.call(this),this._initHooksCalled=!0;for(var t=0,i=o._initHooks.length;t<i;t++)o._initHooks[t].call(this)}},e},v.include=function(t){return i(this.prototype,t),this},v.mergeOptions=function(t){return i(this.prototype.options,t),this},v.addInitHook=function(t){var i=Array.prototype.slice.call(arguments,1),e="function"==typeof t?t:function(){this[t].apply(this,i)};return this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(e),this};var hi={on:function(t,i,e){if("object"==typeof t)for(var n in t)this._on(n,t[n],i);else for(var o=0,s=(t=u(t)).length;o<s;o++)this._on(t[o],i,e);return this},off:function(t,i,e){if(t)if("object"==typeof t)for(var n in t)this._off(n,t[n],i);else for(var o=0,s=(t=u(t)).length;o<s;o++)this._off(t[o],i,e);else delete this._events;return this},_on:function(t,i,e){this._events=this._events||{};var n=this._events[t];n||(n=[],this._events[t]=n),e===this&&(e=void 0);for(var o={fn:i,ctx:e},s=n,r=0,a=s.length;r<a;r++)if(s[r].fn===i&&s[r].ctx===e)return;s.push(o)},_off:function(t,i,e){var n,o,s;if(this._events&&(n=this._events[t]))if(i){if(e===this&&(e=void 0),n)for(o=0,s=n.length;o<s;o++){var a=n[o];if(a.ctx===e&&a.fn===i)return a.fn=r,this._firingCount&&(this._events[t]=n=n.slice()),void n.splice(o,1)}}else{for(o=0,s=n.length;o<s;o++)n[o].fn=r;delete this._events[t]}},fire:function(t,e,n){if(!this.listens(t,n))return this;var o=i({},e,{type:t,target:this,sourceTarget:e&&e.sourceTarget||this});if(this._events){var s=this._events[t];if(s){this._firingCount=this._firingCount+1||1;for(var r=0,a=s.length;r<a;r++){var h=s[r];h.fn.call(h.ctx||this,o)}this._firingCount--}}return n&&this._propagateEvent(o),this},listens:function(t,i){var e=this._events&&this._events[t];if(e&&e.length)return!0;if(i)for(var n in this._eventParents)if(this._eventParents[n].listens(t,i))return!0;return!1},once:function(t,i,n){if("object"==typeof t){for(var o in t)this.once(o,t[o],i);return this}var s=e(function(){this.off(t,i,n).off(t,s,n)},this);return this.on(t,i,n).on(t,s,n)},addEventParent:function(t){return this._eventParents=this._eventParents||{},this._eventParents[n(t)]=t,this},removeEventParent:function(t){return this._eventParents&&delete this._eventParents[n(t)],this},_propagateEvent:function(t){for(var e in this._eventParents)this._eventParents[e].fire(t.type,i({layer:t.target,propagatedFrom:t.target},t),!0)}};hi.addEventListener=hi.on,hi.removeEventListener=hi.clearAllEventListeners=hi.off,hi.addOneTimeEventListener=hi.once,hi.fireEvent=hi.fire,hi.hasEventListeners=hi.listens;var ui=v.extend(hi),li=Math.trunc||function(t){return t>0?Math.floor(t):Math.ceil(t)};x.prototype={clone:function(){return new x(this.x,this.y)},add:function(t){return this.clone()._add(w(t))},_add:function(t){return this.x+=t.x,this.y+=t.y,this},subtract:function(t){return this.clone()._subtract(w(t))},_subtract:function(t){return this.x-=t.x,this.y-=t.y,this},divideBy:function(t){return this.clone()._divideBy(t)},_divideBy:function(t){return this.x/=t,this.y/=t,this},multiplyBy:function(t){return this.clone()._multiplyBy(t)},_multiplyBy:function(t){return this.x*=t,this.y*=t,this},scaleBy:function(t){return new x(this.x*t.x,this.y*t.y)},unscaleBy:function(t){return new x(this.x/t.x,this.y/t.y)},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},ceil:function(){return this.clone()._ceil()},_ceil:function(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this},trunc:function(){return this.clone()._trunc()},_trunc:function(){return this.x=li(this.x),this.y=li(this.y),this},distanceTo:function(t){var i=(t=w(t)).x-this.x,e=t.y-this.y;return Math.sqrt(i*i+e*e)},equals:function(t){return(t=w(t)).x===this.x&&t.y===this.y},contains:function(t){return t=w(t),Math.abs(t.x)<=Math.abs(this.x)&&Math.abs(t.y)<=Math.abs(this.y)},toString:function(){return"Point("+a(this.x)+", "+a(this.y)+")"}},P.prototype={extend:function(t){return t=w(t),this.min||this.max?(this.min.x=Math.min(t.x,this.min.x),this.max.x=Math.max(t.x,this.max.x),this.min.y=Math.min(t.y,this.min.y),this.max.y=Math.max(t.y,this.max.y)):(this.min=t.clone(),this.max=t.clone()),this},getCenter:function(t){return new x((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,t)},getBottomLeft:function(){return new x(this.min.x,this.max.y)},getTopRight:function(){return new x(this.max.x,this.min.y)},getTopLeft:function(){return this.min},getBottomRight:function(){return this.max},getSize:function(){return this.max.subtract(this.min)},contains:function(t){var i,e;return(t="number"==typeof t[0]||t instanceof x?w(t):b(t))instanceof P?(i=t.min,e=t.max):i=e=t,i.x>=this.min.x&&e.x<=this.max.x&&i.y>=this.min.y&&e.y<=this.max.y},intersects:function(t){t=b(t);var i=this.min,e=this.max,n=t.min,o=t.max,s=o.x>=i.x&&n.x<=e.x,r=o.y>=i.y&&n.y<=e.y;return s&&r},overlaps:function(t){t=b(t);var i=this.min,e=this.max,n=t.min,o=t.max,s=o.x>i.x&&n.x<e.x,r=o.y>i.y&&n.y<e.y;return s&&r},isValid:function(){return!(!this.min||!this.max)}},T.prototype={extend:function(t){var i,e,n=this._southWest,o=this._northEast;if(t instanceof M)i=t,e=t;else{if(!(t instanceof T))return t?this.extend(C(t)||z(t)):this;if(i=t._southWest,e=t._northEast,!i||!e)return this}return n||o?(n.lat=Math.min(i.lat,n.lat),n.lng=Math.min(i.lng,n.lng),o.lat=Math.max(e.lat,o.lat),o.lng=Math.max(e.lng,o.lng)):(this._southWest=new M(i.lat,i.lng),this._northEast=new M(e.lat,e.lng)),this},pad:function(t){var i=this._southWest,e=this._northEast,n=Math.abs(i.lat-e.lat)*t,o=Math.abs(i.lng-e.lng)*t;return new T(new M(i.lat-n,i.lng-o),new M(e.lat+n,e.lng+o))},getCenter:function(){return new M((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new M(this.getNorth(),this.getWest())},getSouthEast:function(){return new M(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(t){t="number"==typeof t[0]||t instanceof M||"lat"in t?C(t):z(t);var i,e,n=this._southWest,o=this._northEast;return t instanceof T?(i=t.getSouthWest(),e=t.getNorthEast()):i=e=t,i.lat>=n.lat&&e.lat<=o.lat&&i.lng>=n.lng&&e.lng<=o.lng},intersects:function(t){t=z(t);var i=this._southWest,e=this._northEast,n=t.getSouthWest(),o=t.getNorthEast(),s=o.lat>=i.lat&&n.lat<=e.lat,r=o.lng>=i.lng&&n.lng<=e.lng;return s&&r},overlaps:function(t){t=z(t);var i=this._southWest,e=this._northEast,n=t.getSouthWest(),o=t.getNorthEast(),s=o.lat>i.lat&&n.lat<e.lat,r=o.lng>i.lng&&n.lng<e.lng;return s&&r},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(",")},equals:function(t,i){return!!t&&(t=z(t),this._southWest.equals(t.getSouthWest(),i)&&this._northEast.equals(t.getNorthEast(),i))},isValid:function(){return!(!this._southWest||!this._northEast)}},M.prototype={equals:function(t,i){return!!t&&(t=C(t),Math.max(Math.abs(this.lat-t.lat),Math.abs(this.lng-t.lng))<=(void 0===i?1e-9:i))},toString:function(t){return"LatLng("+a(this.lat,t)+", "+a(this.lng,t)+")"},distanceTo:function(t){return _i.distance(this,C(t))},wrap:function(){return _i.wrapLatLng(this)},toBounds:function(t){var i=180*t/40075017,e=i/Math.cos(Math.PI/180*this.lat);return z([this.lat-i,this.lng-e],[this.lat+i,this.lng+e])},clone:function(){return new M(this.lat,this.lng,this.alt)}};var ci={latLngToPoint:function(t,i){var e=this.projection.project(t),n=this.scale(i);return this.transformation._transform(e,n)},pointToLatLng:function(t,i){var e=this.scale(i),n=this.transformation.untransform(t,e);return this.projection.unproject(n)},project:function(t){return this.projection.project(t)},unproject:function(t){return this.projection.unproject(t)},scale:function(t){return 256*Math.pow(2,t)},zoom:function(t){return Math.log(t/256)/Math.LN2},getProjectedBounds:function(t){if(this.infinite)return null;var i=this.projection.bounds,e=this.scale(t);return new P(this.transformation.transform(i.min,e),this.transformation.transform(i.max,e))},infinite:!1,wrapLatLng:function(t){var i=this.wrapLng?s(t.lng,this.wrapLng,!0):t.lng;return new M(this.wrapLat?s(t.lat,this.wrapLat,!0):t.lat,i,t.alt)},wrapLatLngBounds:function(t){var i=t.getCenter(),e=this.wrapLatLng(i),n=i.lat-e.lat,o=i.lng-e.lng;if(0===n&&0===o)return t;var s=t.getSouthWest(),r=t.getNorthEast();return new T(new M(s.lat-n,s.lng-o),new M(r.lat-n,r.lng-o))}},_i=i({},ci,{wrapLng:[-180,180],R:6371e3,distance:function(t,i){var e=Math.PI/180,n=t.lat*e,o=i.lat*e,s=Math.sin((i.lat-t.lat)*e/2),r=Math.sin((i.lng-t.lng)*e/2),a=s*s+Math.cos(n)*Math.cos(o)*r*r,h=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));return this.R*h}}),di={R:6378137,MAX_LATITUDE:85.0511287798,project:function(t){var i=Math.PI/180,e=this.MAX_LATITUDE,n=Math.max(Math.min(e,t.lat),-e),o=Math.sin(n*i);return new x(this.R*t.lng*i,this.R*Math.log((1+o)/(1-o))/2)},unproject:function(t){var i=180/Math.PI;return new M((2*Math.atan(Math.exp(t.y/this.R))-Math.PI/2)*i,t.x*i/this.R)},bounds:function(){var t=6378137*Math.PI;return new P([-t,-t],[t,t])}()};Z.prototype={transform:function(t,i){return this._transform(t.clone(),i)},_transform:function(t,i){return i=i||1,t.x=i*(this._a*t.x+this._b),t.y=i*(this._c*t.y+this._d),t},untransform:function(t,i){return i=i||1,new x((t.x/i-this._b)/this._a,(t.y/i-this._d)/this._c)}};var pi,mi,fi,gi,vi=i({},_i,{code:"EPSG:3857",projection:di,transformation:function(){var t=.5/(Math.PI*di.R);return S(t,.5,-t,.5)}()}),yi=i({},vi,{code:"EPSG:900913"}),xi=document.documentElement.style,wi="ActiveXObject"in window,Li=wi&&!document.addEventListener,Pi="msLaunchUri"in navigator&&!("documentMode"in document),bi=I("webkit"),Ti=I("android"),zi=I("android 2")||I("android 3"),Mi=parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1],10),Ci=Ti&&I("Google")&&Mi<537&&!("AudioNode"in window),Zi=!!window.opera,Si=I("chrome"),Ei=I("gecko")&&!bi&&!Zi&&!wi,ki=!Si&&I("safari"),Ii=I("phantom"),Ai="OTransition"in xi,Bi=0===navigator.platform.indexOf("Win"),Oi=wi&&"transition"in xi,Ri="WebKitCSSMatrix"in window&&"m11"in new window.WebKitCSSMatrix&&!zi,Di="MozPerspective"in xi,Ni=!window.L_DISABLE_3D&&(Oi||Ri||Di)&&!Ai&&!Ii,ji="undefined"!=typeof orientation||I("mobile"),Wi=ji&&bi,Hi=ji&&Ri,Fi=!window.PointerEvent&&window.MSPointerEvent,Ui=!(!window.PointerEvent&&!Fi),Vi=!window.L_NO_TOUCH&&(Ui||"ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch),qi=ji&&Zi,Gi=ji&&Ei,Ki=(window.devicePixelRatio||window.screen.deviceXDPI/window.screen.logicalXDPI)>1,Yi=!!document.createElement("canvas").getContext,Xi=!(!document.createElementNS||!E("svg").createSVGRect),Ji=!Xi&&function(){try{var t=document.createElement("div");t.innerHTML='<v:shape adj="1"/>';var i=t.firstChild;return i.style.behavior="url(#default#VML)",i&&"object"==typeof i.adj}catch(t){return!1}}(),$i=(Object.freeze||Object)({ie:wi,ielt9:Li,edge:Pi,webkit:bi,android:Ti,android23:zi,androidStock:Ci,opera:Zi,chrome:Si,gecko:Ei,safari:ki,phantom:Ii,opera12:Ai,win:Bi,ie3d:Oi,webkit3d:Ri,gecko3d:Di,any3d:Ni,mobile:ji,mobileWebkit:Wi,mobileWebkit3d:Hi,msPointer:Fi,pointer:Ui,touch:Vi,mobileOpera:qi,mobileGecko:Gi,retina:Ki,canvas:Yi,svg:Xi,vml:Ji}),Qi=Fi?"MSPointerDown":"pointerdown",te=Fi?"MSPointerMove":"pointermove",ie=Fi?"MSPointerUp":"pointerup",ee=Fi?"MSPointerCancel":"pointercancel",ne=["INPUT","SELECT","OPTION"],oe={},se=!1,re=0,ae=Fi?"MSPointerDown":Ui?"pointerdown":"touchstart",he=Fi?"MSPointerUp":Ui?"pointerup":"touchend",ue="_leaflet_",le="_leaflet_events",ce=Bi&&Si?2*window.devicePixelRatio:Ei?window.devicePixelRatio:1,_e={},de=(Object.freeze||Object)({on:V,off:q,stopPropagation:Y,disableScrollPropagation:X,disableClickPropagation:J,preventDefault:$,stop:Q,getMousePosition:tt,getWheelDelta:it,fakeStop:et,skipped:nt,isExternalTarget:ot,addListener:V,removeListener:q}),pe=xt(["transform","WebkitTransform","OTransform","MozTransform","msTransform"]),me=xt(["webkitTransition","transition","OTransition","MozTransition","msTransition"]),fe="webkitTransition"===me||"OTransition"===me?me+"End":"transitionend";if("onselectstart"in document)mi=function(){V(window,"selectstart",$)},fi=function(){q(window,"selectstart",$)};else{var ge=xt(["userSelect","WebkitUserSelect","OUserSelect","MozUserSelect","msUserSelect"]);mi=function(){if(ge){var t=document.documentElement.style;gi=t[ge],t[ge]="none"}},fi=function(){ge&&(document.documentElement.style[ge]=gi,gi=void 0)}}var ve,ye,xe=(Object.freeze||Object)({TRANSFORM:pe,TRANSITION:me,TRANSITION_END:fe,get:rt,getStyle:at,create:ht,remove:ut,empty:lt,toFront:ct,toBack:_t,hasClass:dt,addClass:pt,removeClass:mt,setClass:ft,getClass:gt,setOpacity:vt,testProp:xt,setTransform:wt,setPosition:Lt,getPosition:Pt,disableTextSelection:mi,enableTextSelection:fi,disableImageDrag:bt,enableImageDrag:Tt,preventOutline:zt,restoreOutline:Mt}),we=ui.extend({run:function(t,i,e,n){this.stop(),this._el=t,this._inProgress=!0,this._duration=e||.25,this._easeOutPower=1/Math.max(n||.5,.2),this._startPos=Pt(t),this._offset=i.subtract(this._startPos),this._startTime=+new Date,this.fire("start"),this._animate()},stop:function(){this._inProgress&&(this._step(!0),this._complete())},_animate:function(){this._animId=f(this._animate,this),this._step()},_step:function(t){var i=+new Date-this._startTime,e=1e3*this._duration;i<e?this._runFrame(this._easeOut(i/e),t):(this._runFrame(1),this._complete())},_runFrame:function(t,i){var e=this._startPos.add(this._offset.multiplyBy(t));i&&e._round(),Lt(this._el,e),this.fire("step")},_complete:function(){g(this._animId),this._inProgress=!1,this.fire("end")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),Le=ui.extend({options:{crs:vi,center:void 0,zoom:void 0,minZoom:void 0,maxZoom:void 0,layers:[],maxBounds:void 0,renderer:void 0,zoomAnimation:!0,zoomAnimationThreshold:4,fadeAnimation:!0,markerZoomAnimation:!0,transform3DLimit:8388608,zoomSnap:1,zoomDelta:1,trackResize:!0},initialize:function(t,i){i=l(this,i),this._initContainer(t),this._initLayout(),this._onResize=e(this._onResize,this),this._initEvents(),i.maxBounds&&this.setMaxBounds(i.maxBounds),void 0!==i.zoom&&(this._zoom=this._limitZoom(i.zoom)),i.center&&void 0!==i.zoom&&this.setView(C(i.center),i.zoom,{reset:!0}),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._sizeChanged=!0,this.callInitHooks(),this._zoomAnimated=me&&Ni&&!qi&&this.options.zoomAnimation,this._zoomAnimated&&(this._createAnimProxy(),V(this._proxy,fe,this._catchTransitionEnd,this)),this._addLayers(this.options.layers)},setView:function(t,e,n){return e=void 0===e?this._zoom:this._limitZoom(e),t=this._limitCenter(C(t),e,this.options.maxBounds),n=n||{},this._stop(),this._loaded&&!n.reset&&!0!==n&&(void 0!==n.animate&&(n.zoom=i({animate:n.animate},n.zoom),n.pan=i({animate:n.animate,duration:n.duration},n.pan)),this._zoom!==e?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,e,n.zoom):this._tryAnimatedPan(t,n.pan))?(clearTimeout(this._sizeTimer),this):(this._resetView(t,e),this)},setZoom:function(t,i){return this._loaded?this.setView(this.getCenter(),t,{zoom:i}):(this._zoom=t,this)},zoomIn:function(t,i){return t=t||(Ni?this.options.zoomDelta:1),this.setZoom(this._zoom+t,i)},zoomOut:function(t,i){return t=t||(Ni?this.options.zoomDelta:1),this.setZoom(this._zoom-t,i)},setZoomAround:function(t,i,e){var n=this.getZoomScale(i),o=this.getSize().divideBy(2),s=(t instanceof x?t:this.latLngToContainerPoint(t)).subtract(o).multiplyBy(1-1/n),r=this.containerPointToLatLng(o.add(s));return this.setView(r,i,{zoom:e})},_getBoundsCenterZoom:function(t,i){i=i||{},t=t.getBounds?t.getBounds():z(t);var e=w(i.paddingTopLeft||i.padding||[0,0]),n=w(i.paddingBottomRight||i.padding||[0,0]),o=this.getBoundsZoom(t,!1,e.add(n));if((o="number"==typeof i.maxZoom?Math.min(i.maxZoom,o):o)===1/0)return{center:t.getCenter(),zoom:o};var s=n.subtract(e).divideBy(2),r=this.project(t.getSouthWest(),o),a=this.project(t.getNorthEast(),o);return{center:this.unproject(r.add(a).divideBy(2).add(s),o),zoom:o}},fitBounds:function(t,i){if(!(t=z(t)).isValid())throw new Error("Bounds are not valid.");var e=this._getBoundsCenterZoom(t,i);return this.setView(e.center,e.zoom,i)},fitWorld:function(t){return this.fitBounds([[-90,-180],[90,180]],t)},panTo:function(t,i){return this.setView(t,this._zoom,{pan:i})},panBy:function(t,i){if(t=w(t).round(),i=i||{},!t.x&&!t.y)return this.fire("moveend");if(!0!==i.animate&&!this.getSize().contains(t))return this._resetView(this.unproject(this.project(this.getCenter()).add(t)),this.getZoom()),this;if(this._panAnim||(this._panAnim=new we,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),i.noMoveStart||this.fire("movestart"),!1!==i.animate){pt(this._mapPane,"leaflet-pan-anim");var e=this._getMapPanePos().subtract(t).round();this._panAnim.run(this._mapPane,e,i.duration||.25,i.easeLinearity)}else this._rawPanBy(t),this.fire("move").fire("moveend");return this},flyTo:function(t,i,e){function n(t){var i=(g*g-m*m+(t?-1:1)*x*x*v*v)/(2*(t?g:m)*x*v),e=Math.sqrt(i*i+1)-i;return e<1e-9?-18:Math.log(e)}function o(t){return(Math.exp(t)-Math.exp(-t))/2}function s(t){return(Math.exp(t)+Math.exp(-t))/2}function r(t){return o(t)/s(t)}function a(t){return m*(s(w)/s(w+y*t))}function h(t){return m*(s(w)*r(w+y*t)-o(w))/x}function u(t){return 1-Math.pow(1-t,1.5)}function l(){var e=(Date.now()-L)/b,n=u(e)*P;e<=1?(this._flyToFrame=f(l,this),this._move(this.unproject(c.add(_.subtract(c).multiplyBy(h(n)/v)),p),this.getScaleZoom(m/a(n),p),{flyTo:!0})):this._move(t,i)._moveEnd(!0)}if(!1===(e=e||{}).animate||!Ni)return this.setView(t,i,e);this._stop();var c=this.project(this.getCenter()),_=this.project(t),d=this.getSize(),p=this._zoom;t=C(t),i=void 0===i?p:i;var m=Math.max(d.x,d.y),g=m*this.getZoomScale(p,i),v=_.distanceTo(c)||1,y=1.42,x=y*y,w=n(0),L=Date.now(),P=(n(1)-w)/y,b=e.duration?1e3*e.duration:1e3*P*.8;return this._moveStart(!0,e.noMoveStart),l.call(this),this},flyToBounds:function(t,i){var e=this._getBoundsCenterZoom(t,i);return this.flyTo(e.center,e.zoom,i)},setMaxBounds:function(t){return(t=z(t)).isValid()?(this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this.options.maxBounds=t,this._loaded&&this._panInsideMaxBounds(),this.on("moveend",this._panInsideMaxBounds)):(this.options.maxBounds=null,this.off("moveend",this._panInsideMaxBounds))},setMinZoom:function(t){var i=this.options.minZoom;return this.options.minZoom=t,this._loaded&&i!==t&&(this.fire("zoomlevelschange"),this.getZoom()<this.options.minZoom)?this.setZoom(t):this},setMaxZoom:function(t){var i=this.options.maxZoom;return this.options.maxZoom=t,this._loaded&&i!==t&&(this.fire("zoomlevelschange"),this.getZoom()>this.options.maxZoom)?this.setZoom(t):this},panInsideBounds:function(t,i){this._enforcingBounds=!0;var e=this.getCenter(),n=this._limitCenter(e,this._zoom,z(t));return e.equals(n)||this.panTo(n,i),this._enforcingBounds=!1,this},invalidateSize:function(t){if(!this._loaded)return this;t=i({animate:!1,pan:!0},!0===t?{animate:!0}:t);var n=this.getSize();this._sizeChanged=!0,this._lastCenter=null;var o=this.getSize(),s=n.divideBy(2).round(),r=o.divideBy(2).round(),a=s.subtract(r);return a.x||a.y?(t.animate&&t.pan?this.panBy(a):(t.pan&&this._rawPanBy(a),this.fire("move"),t.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(e(this.fire,this,"moveend"),200)):this.fire("moveend")),this.fire("resize",{oldSize:n,newSize:o})):this},stop:function(){return this.setZoom(this._limitZoom(this._zoom)),this.options.zoomSnap||this.fire("viewreset"),this._stop()},locate:function(t){if(t=this._locateOptions=i({timeout:1e4,watch:!1},t),!("geolocation"in navigator))return this._handleGeolocationError({code:0,message:"Geolocation not supported."}),this;var n=e(this._handleGeolocationResponse,this),o=e(this._handleGeolocationError,this);return t.watch?this._locationWatchId=navigator.geolocation.watchPosition(n,o,t):navigator.geolocation.getCurrentPosition(n,o,t),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(t){var i=t.code,e=t.message||(1===i?"permission denied":2===i?"position unavailable":"timeout");this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire("locationerror",{code:i,message:"Geolocation error: "+e+"."})},_handleGeolocationResponse:function(t){var i=new M(t.coords.latitude,t.coords.longitude),e=i.toBounds(t.coords.accuracy),n=this._locateOptions;if(n.setView){var o=this.getBoundsZoom(e);this.setView(i,n.maxZoom?Math.min(o,n.maxZoom):o)}var s={latlng:i,bounds:e,timestamp:t.timestamp};for(var r in t.coords)"number"==typeof t.coords[r]&&(s[r]=t.coords[r]);this.fire("locationfound",s)},addHandler:function(t,i){if(!i)return this;var e=this[t]=new i(this);return this._handlers.push(e),this.options[t]&&e.enable(),this},remove:function(){if(this._initEvents(!0),this._containerId!==this._container._leaflet_id)throw new Error("Map container is being reused by another instance");try{delete this._container._leaflet_id,delete this._containerId}catch(t){this._container._leaflet_id=void 0,this._containerId=void 0}void 0!==this._locationWatchId&&this.stopLocate(),this._stop(),ut(this._mapPane),this._clearControlPos&&this._clearControlPos(),this._clearHandlers(),this._loaded&&this.fire("unload");var t;for(t in this._layers)this._layers[t].remove();for(t in this._panes)ut(this._panes[t]);return this._layers=[],this._panes=[],delete this._mapPane,delete this._renderer,this},createPane:function(t,i){var e=ht("div","leaflet-pane"+(t?" leaflet-"+t.replace("Pane","")+"-pane":""),i||this._mapPane);return t&&(this._panes[t]=e),e},getCenter:function(){return this._checkIfLoaded(),this._lastCenter&&!this._moved()?this._lastCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var t=this.getPixelBounds();return new T(this.unproject(t.getBottomLeft()),this.unproject(t.getTopRight()))},getMinZoom:function(){return void 0===this.options.minZoom?this._layersMinZoom||0:this.options.minZoom},getMaxZoom:function(){return void 0===this.options.maxZoom?void 0===this._layersMaxZoom?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(t,i,e){t=z(t),e=w(e||[0,0]);var n=this.getZoom()||0,o=this.getMinZoom(),s=this.getMaxZoom(),r=t.getNorthWest(),a=t.getSouthEast(),h=this.getSize().subtract(e),u=b(this.project(a,n),this.project(r,n)).getSize(),l=Ni?this.options.zoomSnap:1,c=h.x/u.x,_=h.y/u.y,d=i?Math.max(c,_):Math.min(c,_);return n=this.getScaleZoom(d,n),l&&(n=Math.round(n/(l/100))*(l/100),n=i?Math.ceil(n/l)*l:Math.floor(n/l)*l),Math.max(o,Math.min(s,n))},getSize:function(){return this._size&&!this._sizeChanged||(this._size=new x(this._container.clientWidth||0,this._container.clientHeight||0),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(t,i){var e=this._getTopLeftPoint(t,i);return new P(e,e.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._pixelOrigin},getPixelWorldBounds:function(t){return this.options.crs.getProjectedBounds(void 0===t?this.getZoom():t)},getPane:function(t){return"string"==typeof t?this._panes[t]:t},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(t,i){var e=this.options.crs;return i=void 0===i?this._zoom:i,e.scale(t)/e.scale(i)},getScaleZoom:function(t,i){var e=this.options.crs;i=void 0===i?this._zoom:i;var n=e.zoom(t*e.scale(i));return isNaN(n)?1/0:n},project:function(t,i){return i=void 0===i?this._zoom:i,this.options.crs.latLngToPoint(C(t),i)},unproject:function(t,i){return i=void 0===i?this._zoom:i,this.options.crs.pointToLatLng(w(t),i)},layerPointToLatLng:function(t){var i=w(t).add(this.getPixelOrigin());return this.unproject(i)},latLngToLayerPoint:function(t){return this.project(C(t))._round()._subtract(this.getPixelOrigin())},wrapLatLng:function(t){return this.options.crs.wrapLatLng(C(t))},wrapLatLngBounds:function(t){return this.options.crs.wrapLatLngBounds(z(t))},distance:function(t,i){return this.options.crs.distance(C(t),C(i))},containerPointToLayerPoint:function(t){return w(t).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(t){return w(t).add(this._getMapPanePos())},containerPointToLatLng:function(t){var i=this.containerPointToLayerPoint(w(t));return this.layerPointToLatLng(i)},latLngToContainerPoint:function(t){return this.layerPointToContainerPoint(this.latLngToLayerPoint(C(t)))},mouseEventToContainerPoint:function(t){return tt(t,this._container)},mouseEventToLayerPoint:function(t){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t))},mouseEventToLatLng:function(t){return this.layerPointToLatLng(this.mouseEventToLayerPoint(t))},_initContainer:function(t){var i=this._container=rt(t);if(!i)throw new Error("Map container not found.");if(i._leaflet_id)throw new Error("Map container is already initialized.");V(i,"scroll",this._onScroll,this),this._containerId=n(i)},_initLayout:function(){var t=this._container;this._fadeAnimated=this.options.fadeAnimation&&Ni,pt(t,"leaflet-container"+(Vi?" leaflet-touch":"")+(Ki?" leaflet-retina":"")+(Li?" leaflet-oldie":"")+(ki?" leaflet-safari":"")+(this._fadeAnimated?" leaflet-fade-anim":""));var i=at(t,"position");"absolute"!==i&&"relative"!==i&&"fixed"!==i&&(t.style.position="relative"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var t=this._panes={};this._paneRenderers={},this._mapPane=this.createPane("mapPane",this._container),Lt(this._mapPane,new x(0,0)),this.createPane("tilePane"),this.createPane("shadowPane"),this.createPane("overlayPane"),this.createPane("markerPane"),this.createPane("tooltipPane"),this.createPane("popupPane"),this.options.markerZoomAnimation||(pt(t.markerPane,"leaflet-zoom-hide"),pt(t.shadowPane,"leaflet-zoom-hide"))},_resetView:function(t,i){Lt(this._mapPane,new x(0,0));var e=!this._loaded;this._loaded=!0,i=this._limitZoom(i),this.fire("viewprereset");var n=this._zoom!==i;this._moveStart(n,!1)._move(t,i)._moveEnd(n),this.fire("viewreset"),e&&this.fire("load")},_moveStart:function(t,i){return t&&this.fire("zoomstart"),i||this.fire("movestart"),this},_move:function(t,i,e){void 0===i&&(i=this._zoom);var n=this._zoom!==i;return this._zoom=i,this._lastCenter=t,this._pixelOrigin=this._getNewPixelOrigin(t),(n||e&&e.pinch)&&this.fire("zoom",e),this.fire("move",e)},_moveEnd:function(t){return t&&this.fire("zoomend"),this.fire("moveend")},_stop:function(){return g(this._flyToFrame),this._panAnim&&this._panAnim.stop(),this},_rawPanBy:function(t){Lt(this._mapPane,this._getMapPanePos().subtract(t))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_panInsideMaxBounds:function(){this._enforcingBounds||this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error("Set map center and zoom first.")},_initEvents:function(t){this._targets={},this._targets[n(this._container)]=this;var i=t?q:V;i(this._container,"click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress",this._handleDOMEvent,this),this.options.trackResize&&i(window,"resize",this._onResize,this),Ni&&this.options.transform3DLimit&&(t?this.off:this.on).call(this,"moveend",this._onMoveEnd)},_onResize:function(){g(this._resizeRequest),this._resizeRequest=f(function(){this.invalidateSize({debounceMoveend:!0})},this)},_onScroll:function(){this._container.scrollTop=0,this._container.scrollLeft=0},_onMoveEnd:function(){var t=this._getMapPanePos();Math.max(Math.abs(t.x),Math.abs(t.y))>=this.options.transform3DLimit&&this._resetView(this.getCenter(),this.getZoom())},_findEventTargets:function(t,i){for(var e,o=[],s="mouseout"===i||"mouseover"===i,r=t.target||t.srcElement,a=!1;r;){if((e=this._targets[n(r)])&&("click"===i||"preclick"===i)&&!t._simulated&&this._draggableMoved(e)){a=!0;break}if(e&&e.listens(i,!0)){if(s&&!ot(r,t))break;if(o.push(e),s)break}if(r===this._container)break;r=r.parentNode}return o.length||a||s||!ot(r,t)||(o=[this]),o},_handleDOMEvent:function(t){if(this._loaded&&!nt(t)){var i=t.type;"mousedown"!==i&&"keypress"!==i||zt(t.target||t.srcElement),this._fireDOMEvent(t,i)}},_mouseEvents:["click","dblclick","mouseover","mouseout","contextmenu"],_fireDOMEvent:function(t,e,n){if("click"===t.type){var o=i({},t);o.type="preclick",this._fireDOMEvent(o,o.type,n)}if(!t._stopped&&(n=(n||[]).concat(this._findEventTargets(t,e))).length){var s=n[0];"contextmenu"===e&&s.listens(e,!0)&&$(t);var r={originalEvent:t};if("keypress"!==t.type){var a=s.getLatLng&&(!s._radius||s._radius<=10);r.containerPoint=a?this.latLngToContainerPoint(s.getLatLng()):this.mouseEventToContainerPoint(t),r.layerPoint=this.containerPointToLayerPoint(r.containerPoint),r.latlng=a?s.getLatLng():this.layerPointToLatLng(r.layerPoint)}for(var h=0;h<n.length;h++)if(n[h].fire(e,r,!0),r.originalEvent._stopped||!1===n[h].options.bubblingMouseEvents&&-1!==d(this._mouseEvents,e))return}},_draggableMoved:function(t){return(t=t.dragging&&t.dragging.enabled()?t:this).dragging&&t.dragging.moved()||this.boxZoom&&this.boxZoom.moved()},_clearHandlers:function(){for(var t=0,i=this._handlers.length;t<i;t++)this._handlers[t].disable()},whenReady:function(t,i){return this._loaded?t.call(i||this,{target:this}):this.on("load",t,i),this},_getMapPanePos:function(){return Pt(this._mapPane)||new x(0,0)},_moved:function(){var t=this._getMapPanePos();return t&&!t.equals([0,0])},_getTopLeftPoint:function(t,i){return(t&&void 0!==i?this._getNewPixelOrigin(t,i):this.getPixelOrigin()).subtract(this._getMapPanePos())},_getNewPixelOrigin:function(t,i){var e=this.getSize()._divideBy(2);return this.project(t,i)._subtract(e)._add(this._getMapPanePos())._round()},_latLngToNewLayerPoint:function(t,i,e){var n=this._getNewPixelOrigin(e,i);return this.project(t,i)._subtract(n)},_latLngBoundsToNewLayerBounds:function(t,i,e){var n=this._getNewPixelOrigin(e,i);return b([this.project(t.getSouthWest(),i)._subtract(n),this.project(t.getNorthWest(),i)._subtract(n),this.project(t.getSouthEast(),i)._subtract(n),this.project(t.getNorthEast(),i)._subtract(n)])},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(t){return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint())},_limitCenter:function(t,i,e){if(!e)return t;var n=this.project(t,i),o=this.getSize().divideBy(2),s=new P(n.subtract(o),n.add(o)),r=this._getBoundsOffset(s,e,i);return r.round().equals([0,0])?t:this.unproject(n.add(r),i)},_limitOffset:function(t,i){if(!i)return t;var e=this.getPixelBounds(),n=new P(e.min.add(t),e.max.add(t));return t.add(this._getBoundsOffset(n,i))},_getBoundsOffset:function(t,i,e){var n=b(this.project(i.getNorthEast(),e),this.project(i.getSouthWest(),e)),o=n.min.subtract(t.min),s=n.max.subtract(t.max);return new x(this._rebound(o.x,-s.x),this._rebound(o.y,-s.y))},_rebound:function(t,i){return t+i>0?Math.round(t-i)/2:Math.max(0,Math.ceil(t))-Math.max(0,Math.floor(i))},_limitZoom:function(t){var i=this.getMinZoom(),e=this.getMaxZoom(),n=Ni?this.options.zoomSnap:1;return n&&(t=Math.round(t/n)*n),Math.max(i,Math.min(e,t))},_onPanTransitionStep:function(){this.fire("move")},_onPanTransitionEnd:function(){mt(this._mapPane,"leaflet-pan-anim"),this.fire("moveend")},_tryAnimatedPan:function(t,i){var e=this._getCenterOffset(t)._trunc();return!(!0!==(i&&i.animate)&&!this.getSize().contains(e))&&(this.panBy(e,i),!0)},_createAnimProxy:function(){var t=this._proxy=ht("div","leaflet-proxy leaflet-zoom-animated");this._panes.mapPane.appendChild(t),this.on("zoomanim",function(t){var i=pe,e=this._proxy.style[i];wt(this._proxy,this.project(t.center,t.zoom),this.getZoomScale(t.zoom,1)),e===this._proxy.style[i]&&this._animatingZoom&&this._onZoomTransitionEnd()},this),this.on("load moveend",function(){var t=this.getCenter(),i=this.getZoom();wt(this._proxy,this.project(t,i),this.getZoomScale(i,1))},this),this._on("unload",this._destroyAnimProxy,this)},_destroyAnimProxy:function(){ut(this._proxy),delete this._proxy},_catchTransitionEnd:function(t){this._animatingZoom&&t.propertyName.indexOf("transform")>=0&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName("leaflet-zoom-animated").length},_tryAnimatedZoom:function(t,i,e){if(this._animatingZoom)return!0;if(e=e||{},!this._zoomAnimated||!1===e.animate||this._nothingToAnimate()||Math.abs(i-this._zoom)>this.options.zoomAnimationThreshold)return!1;var n=this.getZoomScale(i),o=this._getCenterOffset(t)._divideBy(1-1/n);return!(!0!==e.animate&&!this.getSize().contains(o))&&(f(function(){this._moveStart(!0,!1)._animateZoom(t,i,!0)},this),!0)},_animateZoom:function(t,i,n,o){this._mapPane&&(n&&(this._animatingZoom=!0,this._animateToCenter=t,this._animateToZoom=i,pt(this._mapPane,"leaflet-zoom-anim")),this.fire("zoomanim",{center:t,zoom:i,noUpdate:o}),setTimeout(e(this._onZoomTransitionEnd,this),250))},_onZoomTransitionEnd:function(){this._animatingZoom&&(this._mapPane&&mt(this._mapPane,"leaflet-zoom-anim"),this._animatingZoom=!1,this._move(this._animateToCenter,this._animateToZoom),f(function(){this._moveEnd(!0)},this))}}),Pe=v.extend({options:{position:"topright"},initialize:function(t){l(this,t)},getPosition:function(){return this.options.position},setPosition:function(t){var i=this._map;return i&&i.removeControl(this),this.options.position=t,i&&i.addControl(this),this},getContainer:function(){return this._container},addTo:function(t){this.remove(),this._map=t;var i=this._container=this.onAdd(t),e=this.getPosition(),n=t._controlCorners[e];return pt(i,"leaflet-control"),-1!==e.indexOf("bottom")?n.insertBefore(i,n.firstChild):n.appendChild(i),this},remove:function(){return this._map?(ut(this._container),this.onRemove&&this.onRemove(this._map),this._map=null,this):this},_refocusOnMap:function(t){this._map&&t&&t.screenX>0&&t.screenY>0&&this._map.getContainer().focus()}}),be=function(t){return new Pe(t)};Le.include({addControl:function(t){return t.addTo(this),this},removeControl:function(t){return t.remove(),this},_initControlPos:function(){function t(t,o){var s=e+t+" "+e+o;i[t+o]=ht("div",s,n)}var i=this._controlCorners={},e="leaflet-",n=this._controlContainer=ht("div",e+"control-container",this._container);t("top","left"),t("top","right"),t("bottom","left"),t("bottom","right")},_clearControlPos:function(){for(var t in this._controlCorners)ut(this._controlCorners[t]);ut(this._controlContainer),delete this._controlCorners,delete this._controlContainer}});var Te=Pe.extend({options:{collapsed:!0,position:"topright",autoZIndex:!0,hideSingleBase:!1,sortLayers:!1,sortFunction:function(t,i,e,n){return e<n?-1:n<e?1:0}},initialize:function(t,i,e){l(this,e),this._layerControlInputs=[],this._layers=[],this._lastZIndex=0,this._handlingClick=!1;for(var n in t)this._addLayer(t[n],n);for(n in i)this._addLayer(i[n],n,!0)},onAdd:function(t){this._initLayout(),this._update(),this._map=t,t.on("zoomend",this._checkDisabledLayers,this);for(var i=0;i<this._layers.length;i++)this._layers[i].layer.on("add remove",this._onLayerChange,this);return this._container},addTo:function(t){return Pe.prototype.addTo.call(this,t),this._expandIfNotCollapsed()},onRemove:function(){this._map.off("zoomend",this._checkDisabledLayers,this);for(var t=0;t<this._layers.length;t++)this._layers[t].layer.off("add remove",this._onLayerChange,this)},addBaseLayer:function(t,i){return this._addLayer(t,i),this._map?this._update():this},addOverlay:function(t,i){return this._addLayer(t,i,!0),this._map?this._update():this},removeLayer:function(t){t.off("add remove",this._onLayerChange,this);var i=this._getLayer(n(t));return i&&this._layers.splice(this._layers.indexOf(i),1),this._map?this._update():this},expand:function(){pt(this._container,"leaflet-control-layers-expanded"),this._form.style.height=null;var t=this._map.getSize().y-(this._container.offsetTop+50);return t<this._form.clientHeight?(pt(this._form,"leaflet-control-layers-scrollbar"),this._form.style.height=t+"px"):mt(this._form,"leaflet-control-layers-scrollbar"),this._checkDisabledLayers(),this},collapse:function(){return mt(this._container,"leaflet-control-layers-expanded"),this},_initLayout:function(){var t="leaflet-control-layers",i=this._container=ht("div",t),e=this.options.collapsed;i.setAttribute("aria-haspopup",!0),J(i),X(i);var n=this._form=ht("form",t+"-list");e&&(this._map.on("click",this.collapse,this),Ti||V(i,{mouseenter:this.expand,mouseleave:this.collapse},this));var o=this._layersLink=ht("a",t+"-toggle",i);o.href="#",o.title="Layers",Vi?(V(o,"click",Q),V(o,"click",this.expand,this)):V(o,"focus",this.expand,this),e||this.expand(),this._baseLayersList=ht("div",t+"-base",n),this._separator=ht("div",t+"-separator",n),this._overlaysList=ht("div",t+"-overlays",n),i.appendChild(n)},_getLayer:function(t){for(var i=0;i<this._layers.length;i++)if(this._layers[i]&&n(this._layers[i].layer)===t)return this._layers[i]},_addLayer:function(t,i,n){this._map&&t.on("add remove",this._onLayerChange,this),this._layers.push({layer:t,name:i,overlay:n}),this.options.sortLayers&&this._layers.sort(e(function(t,i){return this.options.sortFunction(t.layer,i.layer,t.name,i.name)},this)),this.options.autoZIndex&&t.setZIndex&&(this._lastZIndex++,t.setZIndex(this._lastZIndex)),this._expandIfNotCollapsed()},_update:function(){if(!this._container)return this;lt(this._baseLayersList),lt(this._overlaysList),this._layerControlInputs=[];var t,i,e,n,o=0;for(e=0;e<this._layers.length;e++)n=this._layers[e],this._addItem(n),i=i||n.overlay,t=t||!n.overlay,o+=n.overlay?0:1;return this.options.hideSingleBase&&(t=t&&o>1,this._baseLayersList.style.display=t?"":"none"),this._separator.style.display=i&&t?"":"none",this},_onLayerChange:function(t){this._handlingClick||this._update();var i=this._getLayer(n(t.target)),e=i.overlay?"add"===t.type?"overlayadd":"overlayremove":"add"===t.type?"baselayerchange":null;e&&this._map.fire(e,i)},_createRadioElement:function(t,i){var e='<input type="radio" class="leaflet-control-layers-selector" name="'+t+'"'+(i?' checked="checked"':"")+"/>",n=document.createElement("div");return n.innerHTML=e,n.firstChild},_addItem:function(t){var i,e=document.createElement("label"),o=this._map.hasLayer(t.layer);t.overlay?((i=document.createElement("input")).type="checkbox",i.className="leaflet-control-layers-selector",i.defaultChecked=o):i=this._createRadioElement("leaflet-base-layers",o),this._layerControlInputs.push(i),i.layerId=n(t.layer),V(i,"click",this._onInputClick,this);var s=document.createElement("span");s.innerHTML=" "+t.name;var r=document.createElement("div");return e.appendChild(r),r.appendChild(i),r.appendChild(s),(t.overlay?this._overlaysList:this._baseLayersList).appendChild(e),this._checkDisabledLayers(),e},_onInputClick:function(){var t,i,e=this._layerControlInputs,n=[],o=[];this._handlingClick=!0;for(var s=e.length-1;s>=0;s--)t=e[s],i=this._getLayer(t.layerId).layer,t.checked?n.push(i):t.checked||o.push(i);for(s=0;s<o.length;s++)this._map.hasLayer(o[s])&&this._map.removeLayer(o[s]);for(s=0;s<n.length;s++)this._map.hasLayer(n[s])||this._map.addLayer(n[s]);this._handlingClick=!1,this._refocusOnMap()},_checkDisabledLayers:function(){for(var t,i,e=this._layerControlInputs,n=this._map.getZoom(),o=e.length-1;o>=0;o--)t=e[o],i=this._getLayer(t.layerId).layer,t.disabled=void 0!==i.options.minZoom&&n<i.options.minZoom||void 0!==i.options.maxZoom&&n>i.options.maxZoom},_expandIfNotCollapsed:function(){return this._map&&!this.options.collapsed&&this.expand(),this},_expand:function(){return this.expand()},_collapse:function(){return this.collapse()}}),ze=Pe.extend({options:{position:"topleft",zoomInText:"+",zoomInTitle:"Zoom in",zoomOutText:"&#x2212;",zoomOutTitle:"Zoom out"},onAdd:function(t){var i="leaflet-control-zoom",e=ht("div",i+" leaflet-bar"),n=this.options;return this._zoomInButton=this._createButton(n.zoomInText,n.zoomInTitle,i+"-in",e,this._zoomIn),this._zoomOutButton=this._createButton(n.zoomOutText,n.zoomOutTitle,i+"-out",e,this._zoomOut),this._updateDisabled(),t.on("zoomend zoomlevelschange",this._updateDisabled,this),e},onRemove:function(t){t.off("zoomend zoomlevelschange",this._updateDisabled,this)},disable:function(){return this._disabled=!0,this._updateDisabled(),this},enable:function(){return this._disabled=!1,this._updateDisabled(),this},_zoomIn:function(t){!this._disabled&&this._map._zoom<this._map.getMaxZoom()&&this._map.zoomIn(this._map.options.zoomDelta*(t.shiftKey?3:1))},_zoomOut:function(t){!this._disabled&&this._map._zoom>this._map.getMinZoom()&&this._map.zoomOut(this._map.options.zoomDelta*(t.shiftKey?3:1))},_createButton:function(t,i,e,n,o){var s=ht("a",e,n);return s.innerHTML=t,s.href="#",s.title=i,s.setAttribute("role","button"),s.setAttribute("aria-label",i),J(s),V(s,"click",Q),V(s,"click",o,this),V(s,"click",this._refocusOnMap,this),s},_updateDisabled:function(){var t=this._map,i="leaflet-disabled";mt(this._zoomInButton,i),mt(this._zoomOutButton,i),(this._disabled||t._zoom===t.getMinZoom())&&pt(this._zoomOutButton,i),(this._disabled||t._zoom===t.getMaxZoom())&&pt(this._zoomInButton,i)}});Le.mergeOptions({zoomControl:!0}),Le.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new ze,this.addControl(this.zoomControl))});var Me=Pe.extend({options:{position:"bottomleft",maxWidth:100,metric:!0,imperial:!0},onAdd:function(t){var i=ht("div","leaflet-control-scale"),e=this.options;return this._addScales(e,"leaflet-control-scale-line",i),t.on(e.updateWhenIdle?"moveend":"move",this._update,this),t.whenReady(this._update,this),i},onRemove:function(t){t.off(this.options.updateWhenIdle?"moveend":"move",this._update,this)},_addScales:function(t,i,e){t.metric&&(this._mScale=ht("div",i,e)),t.imperial&&(this._iScale=ht("div",i,e))},_update:function(){var t=this._map,i=t.getSize().y/2,e=t.distance(t.containerPointToLatLng([0,i]),t.containerPointToLatLng([this.options.maxWidth,i]));this._updateScales(e)},_updateScales:function(t){this.options.metric&&t&&this._updateMetric(t),this.options.imperial&&t&&this._updateImperial(t)},_updateMetric:function(t){var i=this._getRoundNum(t),e=i<1e3?i+" m":i/1e3+" km";this._updateScale(this._mScale,e,i/t)},_updateImperial:function(t){var i,e,n,o=3.2808399*t;o>5280?(i=o/5280,e=this._getRoundNum(i),this._updateScale(this._iScale,e+" mi",e/i)):(n=this._getRoundNum(o),this._updateScale(this._iScale,n+" ft",n/o))},_updateScale:function(t,i,e){t.style.width=Math.round(this.options.maxWidth*e)+"px",t.innerHTML=i},_getRoundNum:function(t){var i=Math.pow(10,(Math.floor(t)+"").length-1),e=t/i;return e=e>=10?10:e>=5?5:e>=3?3:e>=2?2:1,i*e}}),Ce=Pe.extend({options:{position:"bottomright",prefix:'<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'},initialize:function(t){l(this,t),this._attributions={}},onAdd:function(t){t.attributionControl=this,this._container=ht("div","leaflet-control-attribution"),J(this._container);for(var i in t._layers)t._layers[i].getAttribution&&this.addAttribution(t._layers[i].getAttribution());return this._update(),this._container},setPrefix:function(t){return this.options.prefix=t,this._update(),this},addAttribution:function(t){return t?(this._attributions[t]||(this._attributions[t]=0),this._attributions[t]++,this._update(),this):this},removeAttribution:function(t){return t?(this._attributions[t]&&(this._attributions[t]--,this._update()),this):this},_update:function(){if(this._map){var t=[];for(var i in this._attributions)this._attributions[i]&&t.push(i);var e=[];this.options.prefix&&e.push(this.options.prefix),t.length&&e.push(t.join(", ")),this._container.innerHTML=e.join(" | ")}}});Le.mergeOptions({attributionControl:!0}),Le.addInitHook(function(){this.options.attributionControl&&(new Ce).addTo(this)});Pe.Layers=Te,Pe.Zoom=ze,Pe.Scale=Me,Pe.Attribution=Ce,be.layers=function(t,i,e){return new Te(t,i,e)},be.zoom=function(t){return new ze(t)},be.scale=function(t){return new Me(t)},be.attribution=function(t){return new Ce(t)};var Ze=v.extend({initialize:function(t){this._map=t},enable:function(){return this._enabled?this:(this._enabled=!0,this.addHooks(),this)},disable:function(){return this._enabled?(this._enabled=!1,this.removeHooks(),this):this},enabled:function(){return!!this._enabled}});Ze.addTo=function(t,i){return t.addHandler(i,this),this};var Se,Ee={Events:hi},ke=Vi?"touchstart mousedown":"mousedown",Ie={mousedown:"mouseup",touchstart:"touchend",pointerdown:"touchend",MSPointerDown:"touchend"},Ae={mousedown:"mousemove",touchstart:"touchmove",pointerdown:"touchmove",MSPointerDown:"touchmove"},Be=ui.extend({options:{clickTolerance:3},initialize:function(t,i,e,n){l(this,n),this._element=t,this._dragStartTarget=i||t,this._preventOutline=e},enable:function(){this._enabled||(V(this._dragStartTarget,ke,this._onDown,this),this._enabled=!0)},disable:function(){this._enabled&&(Be._dragging===this&&this.finishDrag(),q(this._dragStartTarget,ke,this._onDown,this),this._enabled=!1,this._moved=!1)},_onDown:function(t){if(!t._simulated&&this._enabled&&(this._moved=!1,!dt(this._element,"leaflet-zoom-anim")&&!(Be._dragging||t.shiftKey||1!==t.which&&1!==t.button&&!t.touches||(Be._dragging=this,this._preventOutline&&zt(this._element),bt(),mi(),this._moving)))){this.fire("down");var i=t.touches?t.touches[0]:t;this._startPoint=new x(i.clientX,i.clientY),V(document,Ae[t.type],this._onMove,this),V(document,Ie[t.type],this._onUp,this)}},_onMove:function(t){if(!t._simulated&&this._enabled)if(t.touches&&t.touches.length>1)this._moved=!0;else{var i=t.touches&&1===t.touches.length?t.touches[0]:t,e=new x(i.clientX,i.clientY).subtract(this._startPoint);(e.x||e.y)&&(Math.abs(e.x)+Math.abs(e.y)<this.options.clickTolerance||($(t),this._moved||(this.fire("dragstart"),this._moved=!0,this._startPos=Pt(this._element).subtract(e),pt(document.body,"leaflet-dragging"),this._lastTarget=t.target||t.srcElement,window.SVGElementInstance&&this._lastTarget instanceof SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement),pt(this._lastTarget,"leaflet-drag-target")),this._newPos=this._startPos.add(e),this._moving=!0,g(this._animRequest),this._lastEvent=t,this._animRequest=f(this._updatePosition,this,!0)))}},_updatePosition:function(){var t={originalEvent:this._lastEvent};this.fire("predrag",t),Lt(this._element,this._newPos),this.fire("drag",t)},_onUp:function(t){!t._simulated&&this._enabled&&this.finishDrag()},finishDrag:function(){mt(document.body,"leaflet-dragging"),this._lastTarget&&(mt(this._lastTarget,"leaflet-drag-target"),this._lastTarget=null);for(var t in Ae)q(document,Ae[t],this._onMove,this),q(document,Ie[t],this._onUp,this);Tt(),fi(),this._moved&&this._moving&&(g(this._animRequest),this.fire("dragend",{distance:this._newPos.distanceTo(this._startPos)})),this._moving=!1,Be._dragging=!1}}),Oe=(Object.freeze||Object)({simplify:Ct,pointToSegmentDistance:Zt,closestPointOnSegment:function(t,i,e){return Rt(t,i,e)},clipSegment:It,_getEdgeIntersection:At,_getBitCode:Bt,_sqClosestPointOnSegment:Rt,isFlat:Dt,_flat:Nt}),Re=(Object.freeze||Object)({clipPolygon:jt}),De={project:function(t){return new x(t.lng,t.lat)},unproject:function(t){return new M(t.y,t.x)},bounds:new P([-180,-90],[180,90])},Ne={R:6378137,R_MINOR:6356752.314245179,bounds:new P([-20037508.34279,-15496570.73972],[20037508.34279,18764656.23138]),project:function(t){var i=Math.PI/180,e=this.R,n=t.lat*i,o=this.R_MINOR/e,s=Math.sqrt(1-o*o),r=s*Math.sin(n),a=Math.tan(Math.PI/4-n/2)/Math.pow((1-r)/(1+r),s/2);return n=-e*Math.log(Math.max(a,1e-10)),new x(t.lng*i*e,n)},unproject:function(t){for(var i,e=180/Math.PI,n=this.R,o=this.R_MINOR/n,s=Math.sqrt(1-o*o),r=Math.exp(-t.y/n),a=Math.PI/2-2*Math.atan(r),h=0,u=.1;h<15&&Math.abs(u)>1e-7;h++)i=s*Math.sin(a),i=Math.pow((1-i)/(1+i),s/2),a+=u=Math.PI/2-2*Math.atan(r*i)-a;return new M(a*e,t.x*e/n)}},je=(Object.freeze||Object)({LonLat:De,Mercator:Ne,SphericalMercator:di}),We=i({},_i,{code:"EPSG:3395",projection:Ne,transformation:function(){var t=.5/(Math.PI*Ne.R);return S(t,.5,-t,.5)}()}),He=i({},_i,{code:"EPSG:4326",projection:De,transformation:S(1/180,1,-1/180,.5)}),Fe=i({},ci,{projection:De,transformation:S(1,0,-1,0),scale:function(t){return Math.pow(2,t)},zoom:function(t){return Math.log(t)/Math.LN2},distance:function(t,i){var e=i.lng-t.lng,n=i.lat-t.lat;return Math.sqrt(e*e+n*n)},infinite:!0});ci.Earth=_i,ci.EPSG3395=We,ci.EPSG3857=vi,ci.EPSG900913=yi,ci.EPSG4326=He,ci.Simple=Fe;var Ue=ui.extend({options:{pane:"overlayPane",attribution:null,bubblingMouseEvents:!0},addTo:function(t){return t.addLayer(this),this},remove:function(){return this.removeFrom(this._map||this._mapToAdd)},removeFrom:function(t){return t&&t.removeLayer(this),this},getPane:function(t){return this._map.getPane(t?this.options[t]||t:this.options.pane)},addInteractiveTarget:function(t){return this._map._targets[n(t)]=this,this},removeInteractiveTarget:function(t){return delete this._map._targets[n(t)],this},getAttribution:function(){return this.options.attribution},_layerAdd:function(t){var i=t.target;if(i.hasLayer(this)){if(this._map=i,this._zoomAnimated=i._zoomAnimated,this.getEvents){var e=this.getEvents();i.on(e,this),this.once("remove",function(){i.off(e,this)},this)}this.onAdd(i),this.getAttribution&&i.attributionControl&&i.attributionControl.addAttribution(this.getAttribution()),this.fire("add"),i.fire("layeradd",{layer:this})}}});Le.include({addLayer:function(t){if(!t._layerAdd)throw new Error("The provided object is not a Layer.");var i=n(t);return this._layers[i]?this:(this._layers[i]=t,t._mapToAdd=this,t.beforeAdd&&t.beforeAdd(this),this.whenReady(t._layerAdd,t),this)},removeLayer:function(t){var i=n(t);return this._layers[i]?(this._loaded&&t.onRemove(this),t.getAttribution&&this.attributionControl&&this.attributionControl.removeAttribution(t.getAttribution()),delete this._layers[i],this._loaded&&(this.fire("layerremove",{layer:t}),t.fire("remove")),t._map=t._mapToAdd=null,this):this},hasLayer:function(t){return!!t&&n(t)in this._layers},eachLayer:function(t,i){for(var e in this._layers)t.call(i,this._layers[e]);return this},_addLayers:function(t){for(var i=0,e=(t=t?ei(t)?t:[t]:[]).length;i<e;i++)this.addLayer(t[i])},_addZoomLimit:function(t){!isNaN(t.options.maxZoom)&&isNaN(t.options.minZoom)||(this._zoomBoundLayers[n(t)]=t,this._updateZoomLevels())},_removeZoomLimit:function(t){var i=n(t);this._zoomBoundLayers[i]&&(delete this._zoomBoundLayers[i],this._updateZoomLevels())},_updateZoomLevels:function(){var t=1/0,i=-1/0,e=this._getZoomSpan();for(var n in this._zoomBoundLayers){var o=this._zoomBoundLayers[n].options;t=void 0===o.minZoom?t:Math.min(t,o.minZoom),i=void 0===o.maxZoom?i:Math.max(i,o.maxZoom)}this._layersMaxZoom=i===-1/0?void 0:i,this._layersMinZoom=t===1/0?void 0:t,e!==this._getZoomSpan()&&this.fire("zoomlevelschange"),void 0===this.options.maxZoom&&this._layersMaxZoom&&this.getZoom()>this._layersMaxZoom&&this.setZoom(this._layersMaxZoom),void 0===this.options.minZoom&&this._layersMinZoom&&this.getZoom()<this._layersMinZoom&&this.setZoom(this._layersMinZoom)}});var Ve=Ue.extend({initialize:function(t,i){l(this,i),this._layers={};var e,n;if(t)for(e=0,n=t.length;e<n;e++)this.addLayer(t[e])},addLayer:function(t){var i=this.getLayerId(t);return this._layers[i]=t,this._map&&this._map.addLayer(t),this},removeLayer:function(t){var i=t in this._layers?t:this.getLayerId(t);return this._map&&this._layers[i]&&this._map.removeLayer(this._layers[i]),delete this._layers[i],this},hasLayer:function(t){return!!t&&(t in this._layers||this.getLayerId(t)in this._layers)},clearLayers:function(){return this.eachLayer(this.removeLayer,this)},invoke:function(t){var i,e,n=Array.prototype.slice.call(arguments,1);for(i in this._layers)(e=this._layers[i])[t]&&e[t].apply(e,n);return this},onAdd:function(t){this.eachLayer(t.addLayer,t)},onRemove:function(t){this.eachLayer(t.removeLayer,t)},eachLayer:function(t,i){for(var e in this._layers)t.call(i,this._layers[e]);return this},getLayer:function(t){return this._layers[t]},getLayers:function(){var t=[];return this.eachLayer(t.push,t),t},setZIndex:function(t){return this.invoke("setZIndex",t)},getLayerId:function(t){return n(t)}}),qe=Ve.extend({addLayer:function(t){return this.hasLayer(t)?this:(t.addEventParent(this),Ve.prototype.addLayer.call(this,t),this.fire("layeradd",{layer:t}))},removeLayer:function(t){return this.hasLayer(t)?(t in this._layers&&(t=this._layers[t]),t.removeEventParent(this),Ve.prototype.removeLayer.call(this,t),this.fire("layerremove",{layer:t})):this},setStyle:function(t){return this.invoke("setStyle",t)},bringToFront:function(){return this.invoke("bringToFront")},bringToBack:function(){return this.invoke("bringToBack")},getBounds:function(){var t=new T;for(var i in this._layers){var e=this._layers[i];t.extend(e.getBounds?e.getBounds():e.getLatLng())}return t}}),Ge=v.extend({options:{popupAnchor:[0,0],tooltipAnchor:[0,0]},initialize:function(t){l(this,t)},createIcon:function(t){return this._createIcon("icon",t)},createShadow:function(t){return this._createIcon("shadow",t)},_createIcon:function(t,i){var e=this._getIconUrl(t);if(!e){if("icon"===t)throw new Error("iconUrl not set in Icon options (see the docs).");return null}var n=this._createImg(e,i&&"IMG"===i.tagName?i:null);return this._setIconStyles(n,t),n},_setIconStyles:function(t,i){var e=this.options,n=e[i+"Size"];"number"==typeof n&&(n=[n,n]);var o=w(n),s=w("shadow"===i&&e.shadowAnchor||e.iconAnchor||o&&o.divideBy(2,!0));t.className="leaflet-marker-"+i+" "+(e.className||""),s&&(t.style.marginLeft=-s.x+"px",t.style.marginTop=-s.y+"px"),o&&(t.style.width=o.x+"px",t.style.height=o.y+"px")},_createImg:function(t,i){return i=i||document.createElement("img"),i.src=t,i},_getIconUrl:function(t){return Ki&&this.options[t+"RetinaUrl"]||this.options[t+"Url"]}}),Ke=Ge.extend({options:{iconUrl:"marker-icon.png",iconRetinaUrl:"marker-icon-2x.png",shadowUrl:"marker-shadow.png",iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]},_getIconUrl:function(t){return Ke.imagePath||(Ke.imagePath=this._detectIconPath()),(this.options.imagePath||Ke.imagePath)+Ge.prototype._getIconUrl.call(this,t)},_detectIconPath:function(){var t=ht("div","leaflet-default-icon-path",document.body),i=at(t,"background-image")||at(t,"backgroundImage");return document.body.removeChild(t),i=null===i||0!==i.indexOf("url")?"":i.replace(/^url\(["']?/,"").replace(/marker-icon\.png["']?\)$/,"")}}),Ye=Ze.extend({initialize:function(t){this._marker=t},addHooks:function(){var t=this._marker._icon;this._draggable||(this._draggable=new Be(t,t,!0)),this._draggable.on({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).enable(),pt(t,"leaflet-marker-draggable")},removeHooks:function(){this._draggable.off({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).disable(),this._marker._icon&&mt(this._marker._icon,"leaflet-marker-draggable")},moved:function(){return this._draggable&&this._draggable._moved},_adjustPan:function(t){var i=this._marker,e=i._map,n=this._marker.options.autoPanSpeed,o=this._marker.options.autoPanPadding,s=L.DomUtil.getPosition(i._icon),r=e.getPixelBounds(),a=e.getPixelOrigin(),h=b(r.min._subtract(a).add(o),r.max._subtract(a).subtract(o));if(!h.contains(s)){var u=w((Math.max(h.max.x,s.x)-h.max.x)/(r.max.x-h.max.x)-(Math.min(h.min.x,s.x)-h.min.x)/(r.min.x-h.min.x),(Math.max(h.max.y,s.y)-h.max.y)/(r.max.y-h.max.y)-(Math.min(h.min.y,s.y)-h.min.y)/(r.min.y-h.min.y)).multiplyBy(n);e.panBy(u,{animate:!1}),this._draggable._newPos._add(u),this._draggable._startPos._add(u),L.DomUtil.setPosition(i._icon,this._draggable._newPos),this._onDrag(t),this._panRequest=f(this._adjustPan.bind(this,t))}},_onDragStart:function(){this._oldLatLng=this._marker.getLatLng(),this._marker.closePopup().fire("movestart").fire("dragstart")},_onPreDrag:function(t){this._marker.options.autoPan&&(g(this._panRequest),this._panRequest=f(this._adjustPan.bind(this,t)))},_onDrag:function(t){var i=this._marker,e=i._shadow,n=Pt(i._icon),o=i._map.layerPointToLatLng(n);e&&Lt(e,n),i._latlng=o,t.latlng=o,t.oldLatLng=this._oldLatLng,i.fire("move",t).fire("drag",t)},_onDragEnd:function(t){g(this._panRequest),delete this._oldLatLng,this._marker.fire("moveend").fire("dragend",t)}}),Xe=Ue.extend({options:{icon:new Ke,interactive:!0,draggable:!1,autoPan:!1,autoPanPadding:[50,50],autoPanSpeed:10,keyboard:!0,title:"",alt:"",zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250,pane:"markerPane",bubblingMouseEvents:!1},initialize:function(t,i){l(this,i),this._latlng=C(t)},onAdd:function(t){this._zoomAnimated=this._zoomAnimated&&t.options.markerZoomAnimation,this._zoomAnimated&&t.on("zoomanim",this._animateZoom,this),this._initIcon(),this.update()},onRemove:function(t){this.dragging&&this.dragging.enabled()&&(this.options.draggable=!0,this.dragging.removeHooks()),delete this.dragging,this._zoomAnimated&&t.off("zoomanim",this._animateZoom,this),this._removeIcon(),this._removeShadow()},getEvents:function(){return{zoom:this.update,viewreset:this.update}},getLatLng:function(){return this._latlng},setLatLng:function(t){var i=this._latlng;return this._latlng=C(t),this.update(),this.fire("move",{oldLatLng:i,latlng:this._latlng})},setZIndexOffset:function(t){return this.options.zIndexOffset=t,this.update()},setIcon:function(t){return this.options.icon=t,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup,this._popup.options),this},getElement:function(){return this._icon},update:function(){if(this._icon&&this._map){var t=this._map.latLngToLayerPoint(this._latlng).round();this._setPos(t)}return this},_initIcon:function(){var t=this.options,i="leaflet-zoom-"+(this._zoomAnimated?"animated":"hide"),e=t.icon.createIcon(this._icon),n=!1;e!==this._icon&&(this._icon&&this._removeIcon(),n=!0,t.title&&(e.title=t.title),"IMG"===e.tagName&&(e.alt=t.alt||"")),pt(e,i),t.keyboard&&(e.tabIndex="0"),this._icon=e,t.riseOnHover&&this.on({mouseover:this._bringToFront,mouseout:this._resetZIndex});var o=t.icon.createShadow(this._shadow),s=!1;o!==this._shadow&&(this._removeShadow(),s=!0),o&&(pt(o,i),o.alt=""),this._shadow=o,t.opacity<1&&this._updateOpacity(),n&&this.getPane().appendChild(this._icon),this._initInteraction(),o&&s&&this.getPane("shadowPane").appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&this.off({mouseover:this._bringToFront,mouseout:this._resetZIndex}),ut(this._icon),this.removeInteractiveTarget(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&ut(this._shadow),this._shadow=null},_setPos:function(t){Lt(this._icon,t),this._shadow&&Lt(this._shadow,t),this._zIndex=t.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(t){this._icon.style.zIndex=this._zIndex+t},_animateZoom:function(t){var i=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).round();this._setPos(i)},_initInteraction:function(){if(this.options.interactive&&(pt(this._icon,"leaflet-interactive"),this.addInteractiveTarget(this._icon),Ye)){var t=this.options.draggable;this.dragging&&(t=this.dragging.enabled(),this.dragging.disable()),this.dragging=new Ye(this),t&&this.dragging.enable()}},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},_updateOpacity:function(){var t=this.options.opacity;vt(this._icon,t),this._shadow&&vt(this._shadow,t)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)},_getPopupAnchor:function(){return this.options.icon.options.popupAnchor},_getTooltipAnchor:function(){return this.options.icon.options.tooltipAnchor}}),Je=Ue.extend({options:{stroke:!0,color:"#3388ff",weight:3,opacity:1,lineCap:"round",lineJoin:"round",dashArray:null,dashOffset:null,fill:!1,fillColor:null,fillOpacity:.2,fillRule:"evenodd",interactive:!0,bubblingMouseEvents:!0},beforeAdd:function(t){this._renderer=t.getRenderer(this)},onAdd:function(){this._renderer._initPath(this),this._reset(),this._renderer._addPath(this)},onRemove:function(){this._renderer._removePath(this)},redraw:function(){return this._map&&this._renderer._updatePath(this),this},setStyle:function(t){return l(this,t),this._renderer&&this._renderer._updateStyle(this),this},bringToFront:function(){return this._renderer&&this._renderer._bringToFront(this),this},bringToBack:function(){return this._renderer&&this._renderer._bringToBack(this),this},getElement:function(){return this._path},_reset:function(){this._project(),this._update()},_clickTolerance:function(){return(this.options.stroke?this.options.weight/2:0)+this._renderer.options.tolerance}}),$e=Je.extend({options:{fill:!0,radius:10},initialize:function(t,i){l(this,i),this._latlng=C(t),this._radius=this.options.radius},setLatLng:function(t){return this._latlng=C(t),this.redraw(),this.fire("move",{latlng:this._latlng})},getLatLng:function(){return this._latlng},setRadius:function(t){return this.options.radius=this._radius=t,this.redraw()},getRadius:function(){return this._radius},setStyle:function(t){var i=t&&t.radius||this._radius;return Je.prototype.setStyle.call(this,t),this.setRadius(i),this},_project:function(){this._point=this._map.latLngToLayerPoint(this._latlng),this._updateBounds()},_updateBounds:function(){var t=this._radius,i=this._radiusY||t,e=this._clickTolerance(),n=[t+e,i+e];this._pxBounds=new P(this._point.subtract(n),this._point.add(n))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateCircle(this)},_empty:function(){return this._radius&&!this._renderer._bounds.intersects(this._pxBounds)},_containsPoint:function(t){return t.distanceTo(this._point)<=this._radius+this._clickTolerance()}}),Qe=$e.extend({initialize:function(t,e,n){if("number"==typeof e&&(e=i({},n,{radius:e})),l(this,e),this._latlng=C(t),isNaN(this.options.radius))throw new Error("Circle radius cannot be NaN");this._mRadius=this.options.radius},setRadius:function(t){return this._mRadius=t,this.redraw()},getRadius:function(){return this._mRadius},getBounds:function(){var t=[this._radius,this._radiusY||this._radius];return new T(this._map.layerPointToLatLng(this._point.subtract(t)),this._map.layerPointToLatLng(this._point.add(t)))},setStyle:Je.prototype.setStyle,_project:function(){var t=this._latlng.lng,i=this._latlng.lat,e=this._map,n=e.options.crs;if(n.distance===_i.distance){var o=Math.PI/180,s=this._mRadius/_i.R/o,r=e.project([i+s,t]),a=e.project([i-s,t]),h=r.add(a).divideBy(2),u=e.unproject(h).lat,l=Math.acos((Math.cos(s*o)-Math.sin(i*o)*Math.sin(u*o))/(Math.cos(i*o)*Math.cos(u*o)))/o;(isNaN(l)||0===l)&&(l=s/Math.cos(Math.PI/180*i)),this._point=h.subtract(e.getPixelOrigin()),this._radius=isNaN(l)?0:h.x-e.project([u,t-l]).x,this._radiusY=h.y-r.y}else{var c=n.unproject(n.project(this._latlng).subtract([this._mRadius,0]));this._point=e.latLngToLayerPoint(this._latlng),this._radius=this._point.x-e.latLngToLayerPoint(c).x}this._updateBounds()}}),tn=Je.extend({options:{smoothFactor:1,noClip:!1},initialize:function(t,i){l(this,i),this._setLatLngs(t)},getLatLngs:function(){return this._latlngs},setLatLngs:function(t){return this._setLatLngs(t),this.redraw()},isEmpty:function(){return!this._latlngs.length},closestLayerPoint:function(t){for(var i,e,n=1/0,o=null,s=Rt,r=0,a=this._parts.length;r<a;r++)for(var h=this._parts[r],u=1,l=h.length;u<l;u++){var c=s(t,i=h[u-1],e=h[u],!0);c<n&&(n=c,o=s(t,i,e))}return o&&(o.distance=Math.sqrt(n)),o},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,i,e,n,o,s,r,a=this._rings[0],h=a.length;if(!h)return null;for(t=0,i=0;t<h-1;t++)i+=a[t].distanceTo(a[t+1])/2;if(0===i)return this._map.layerPointToLatLng(a[0]);for(t=0,n=0;t<h-1;t++)if(o=a[t],s=a[t+1],e=o.distanceTo(s),(n+=e)>i)return r=(n-i)/e,this._map.layerPointToLatLng([s.x-r*(s.x-o.x),s.y-r*(s.y-o.y)])},getBounds:function(){return this._bounds},addLatLng:function(t,i){return i=i||this._defaultShape(),t=C(t),i.push(t),this._bounds.extend(t),this.redraw()},_setLatLngs:function(t){this._bounds=new T,this._latlngs=this._convertLatLngs(t)},_defaultShape:function(){return Dt(this._latlngs)?this._latlngs:this._latlngs[0]},_convertLatLngs:function(t){for(var i=[],e=Dt(t),n=0,o=t.length;n<o;n++)e?(i[n]=C(t[n]),this._bounds.extend(i[n])):i[n]=this._convertLatLngs(t[n]);return i},_project:function(){var t=new P;this._rings=[],this._projectLatlngs(this._latlngs,this._rings,t);var i=this._clickTolerance(),e=new x(i,i);this._bounds.isValid()&&t.isValid()&&(t.min._subtract(e),t.max._add(e),this._pxBounds=t)},_projectLatlngs:function(t,i,e){var n,o,s=t[0]instanceof M,r=t.length;if(s){for(o=[],n=0;n<r;n++)o[n]=this._map.latLngToLayerPoint(t[n]),e.extend(o[n]);i.push(o)}else for(n=0;n<r;n++)this._projectLatlngs(t[n],i,e)},_clipPoints:function(){var t=this._renderer._bounds;if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(t))if(this.options.noClip)this._parts=this._rings;else{var i,e,n,o,s,r,a,h=this._parts;for(i=0,n=0,o=this._rings.length;i<o;i++)for(e=0,s=(a=this._rings[i]).length;e<s-1;e++)(r=It(a[e],a[e+1],t,e,!0))&&(h[n]=h[n]||[],h[n].push(r[0]),r[1]===a[e+1]&&e!==s-2||(h[n].push(r[1]),n++))}},_simplifyPoints:function(){for(var t=this._parts,i=this.options.smoothFactor,e=0,n=t.length;e<n;e++)t[e]=Ct(t[e],i)},_update:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),this._updatePath())},_updatePath:function(){this._renderer._updatePoly(this)},_containsPoint:function(t,i){var e,n,o,s,r,a,h=this._clickTolerance();if(!this._pxBounds||!this._pxBounds.contains(t))return!1;for(e=0,s=this._parts.length;e<s;e++)for(n=0,o=(r=(a=this._parts[e]).length)-1;n<r;o=n++)if((i||0!==n)&&Zt(t,a[o],a[n])<=h)return!0;return!1}});tn._flat=Nt;var en=tn.extend({options:{fill:!0},isEmpty:function(){return!this._latlngs.length||!this._latlngs[0].length},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,i,e,n,o,s,r,a,h,u=this._rings[0],l=u.length;if(!l)return null;for(s=r=a=0,t=0,i=l-1;t<l;i=t++)e=u[t],n=u[i],o=e.y*n.x-n.y*e.x,r+=(e.x+n.x)*o,a+=(e.y+n.y)*o,s+=3*o;return h=0===s?u[0]:[r/s,a/s],this._map.layerPointToLatLng(h)},_convertLatLngs:function(t){var i=tn.prototype._convertLatLngs.call(this,t),e=i.length;return e>=2&&i[0]instanceof M&&i[0].equals(i[e-1])&&i.pop(),i},_setLatLngs:function(t){tn.prototype._setLatLngs.call(this,t),Dt(this._latlngs)&&(this._latlngs=[this._latlngs])},_defaultShape:function(){return Dt(this._latlngs[0])?this._latlngs[0]:this._latlngs[0][0]},_clipPoints:function(){var t=this._renderer._bounds,i=this.options.weight,e=new x(i,i);if(t=new P(t.min.subtract(e),t.max.add(e)),this._parts=[],this._pxBounds&&this._pxBounds.intersects(t))if(this.options.noClip)this._parts=this._rings;else for(var n,o=0,s=this._rings.length;o<s;o++)(n=jt(this._rings[o],t,!0)).length&&this._parts.push(n)},_updatePath:function(){this._renderer._updatePoly(this,!0)},_containsPoint:function(t){var i,e,n,o,s,r,a,h,u=!1;if(!this._pxBounds.contains(t))return!1;for(o=0,a=this._parts.length;o<a;o++)for(s=0,r=(h=(i=this._parts[o]).length)-1;s<h;r=s++)e=i[s],n=i[r],e.y>t.y!=n.y>t.y&&t.x<(n.x-e.x)*(t.y-e.y)/(n.y-e.y)+e.x&&(u=!u);return u||tn.prototype._containsPoint.call(this,t,!0)}}),nn=qe.extend({initialize:function(t,i){l(this,i),this._layers={},t&&this.addData(t)},addData:function(t){var i,e,n,o=ei(t)?t:t.features;if(o){for(i=0,e=o.length;i<e;i++)((n=o[i]).geometries||n.geometry||n.features||n.coordinates)&&this.addData(n);return this}var s=this.options;if(s.filter&&!s.filter(t))return this;var r=Wt(t,s);return r?(r.feature=Gt(t),r.defaultOptions=r.options,this.resetStyle(r),s.onEachFeature&&s.onEachFeature(t,r),this.addLayer(r)):this},resetStyle:function(t){return t.options=i({},t.defaultOptions),this._setLayerStyle(t,this.options.style),this},setStyle:function(t){return this.eachLayer(function(i){this._setLayerStyle(i,t)},this)},_setLayerStyle:function(t,i){"function"==typeof i&&(i=i(t.feature)),t.setStyle&&t.setStyle(i)}}),on={toGeoJSON:function(t){return qt(this,{type:"Point",coordinates:Ut(this.getLatLng(),t)})}};Xe.include(on),Qe.include(on),$e.include(on),tn.include({toGeoJSON:function(t){var i=!Dt(this._latlngs),e=Vt(this._latlngs,i?1:0,!1,t);return qt(this,{type:(i?"Multi":"")+"LineString",coordinates:e})}}),en.include({toGeoJSON:function(t){var i=!Dt(this._latlngs),e=i&&!Dt(this._latlngs[0]),n=Vt(this._latlngs,e?2:i?1:0,!0,t);return i||(n=[n]),qt(this,{type:(e?"Multi":"")+"Polygon",coordinates:n})}}),Ve.include({toMultiPoint:function(t){var i=[];return this.eachLayer(function(e){i.push(e.toGeoJSON(t).geometry.coordinates)}),qt(this,{type:"MultiPoint",coordinates:i})},toGeoJSON:function(t){var i=this.feature&&this.feature.geometry&&this.feature.geometry.type;if("MultiPoint"===i)return this.toMultiPoint(t);var e="GeometryCollection"===i,n=[];return this.eachLayer(function(i){if(i.toGeoJSON){var o=i.toGeoJSON(t);if(e)n.push(o.geometry);else{var s=Gt(o);"FeatureCollection"===s.type?n.push.apply(n,s.features):n.push(s)}}}),e?qt(this,{geometries:n,type:"GeometryCollection"}):{type:"FeatureCollection",features:n}}});var sn=Kt,rn=Ue.extend({options:{opacity:1,alt:"",interactive:!1,crossOrigin:!1,errorOverlayUrl:"",zIndex:1,className:""},initialize:function(t,i,e){this._url=t,this._bounds=z(i),l(this,e)},onAdd:function(){this._image||(this._initImage(),this.options.opacity<1&&this._updateOpacity()),this.options.interactive&&(pt(this._image,"leaflet-interactive"),this.addInteractiveTarget(this._image)),this.getPane().appendChild(this._image),this._reset()},onRemove:function(){ut(this._image),this.options.interactive&&this.removeInteractiveTarget(this._image)},setOpacity:function(t){return this.options.opacity=t,this._image&&this._updateOpacity(),this},setStyle:function(t){return t.opacity&&this.setOpacity(t.opacity),this},bringToFront:function(){return this._map&&ct(this._image),this},bringToBack:function(){return this._map&&_t(this._image),this},setUrl:function(t){return this._url=t,this._image&&(this._image.src=t),this},setBounds:function(t){return this._bounds=z(t),this._map&&this._reset(),this},getEvents:function(){var t={zoom:this._reset,viewreset:this._reset};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},getBounds:function(){return this._bounds},getElement:function(){return this._image},_initImage:function(){var t="IMG"===this._url.tagName,i=this._image=t?this._url:ht("img");pt(i,"leaflet-image-layer"),this._zoomAnimated&&pt(i,"leaflet-zoom-animated"),this.options.className&&pt(i,this.options.className),i.onselectstart=r,i.onmousemove=r,i.onload=e(this.fire,this,"load"),i.onerror=e(this._overlayOnError,this,"error"),this.options.crossOrigin&&(i.crossOrigin=""),this.options.zIndex&&this._updateZIndex(),t?this._url=i.src:(i.src=this._url,i.alt=this.options.alt)},_animateZoom:function(t){var i=this._map.getZoomScale(t.zoom),e=this._map._latLngBoundsToNewLayerBounds(this._bounds,t.zoom,t.center).min;wt(this._image,e,i)},_reset:function(){var t=this._image,i=new P(this._map.latLngToLayerPoint(this._bounds.getNorthWest()),this._map.latLngToLayerPoint(this._bounds.getSouthEast())),e=i.getSize();Lt(t,i.min),t.style.width=e.x+"px",t.style.height=e.y+"px"},_updateOpacity:function(){vt(this._image,this.options.opacity)},_updateZIndex:function(){this._image&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._image.style.zIndex=this.options.zIndex)},_overlayOnError:function(){this.fire("error");var t=this.options.errorOverlayUrl;t&&this._url!==t&&(this._url=t,this._image.src=t)}}),an=rn.extend({options:{autoplay:!0,loop:!0},_initImage:function(){var t="VIDEO"===this._url.tagName,i=this._image=t?this._url:ht("video");if(pt(i,"leaflet-image-layer"),this._zoomAnimated&&pt(i,"leaflet-zoom-animated"),i.onselectstart=r,i.onmousemove=r,i.onloadeddata=e(this.fire,this,"load"),t){for(var n=i.getElementsByTagName("source"),o=[],s=0;s<n.length;s++)o.push(n[s].src);this._url=n.length>0?o:[i.src]}else{ei(this._url)||(this._url=[this._url]),i.autoplay=!!this.options.autoplay,i.loop=!!this.options.loop;for(var a=0;a<this._url.length;a++){var h=ht("source");h.src=this._url[a],i.appendChild(h)}}}}),hn=Ue.extend({options:{offset:[0,7],className:"",pane:"popupPane"},initialize:function(t,i){l(this,t),this._source=i},onAdd:function(t){this._zoomAnimated=t._zoomAnimated,this._container||this._initLayout(),t._fadeAnimated&&vt(this._container,0),clearTimeout(this._removeTimeout),this.getPane().appendChild(this._container),this.update(),t._fadeAnimated&&vt(this._container,1),this.bringToFront()},onRemove:function(t){t._fadeAnimated?(vt(this._container,0),this._removeTimeout=setTimeout(e(ut,void 0,this._container),200)):ut(this._container)},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=C(t),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(t){return this._content=t,this.update(),this},getElement:function(){return this._container},update:function(){this._map&&(this._container.style.visibility="hidden",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility="",this._adjustPan())},getEvents:function(){var t={zoom:this._updatePosition,viewreset:this._updatePosition};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},isOpen:function(){return!!this._map&&this._map.hasLayer(this)},bringToFront:function(){return this._map&&ct(this._container),this},bringToBack:function(){return this._map&&_t(this._container),this},_updateContent:function(){if(this._content){var t=this._contentNode,i="function"==typeof this._content?this._content(this._source||this):this._content;if("string"==typeof i)t.innerHTML=i;else{for(;t.hasChildNodes();)t.removeChild(t.firstChild);t.appendChild(i)}this.fire("contentupdate")}},_updatePosition:function(){if(this._map){var t=this._map.latLngToLayerPoint(this._latlng),i=w(this.options.offset),e=this._getAnchor();this._zoomAnimated?Lt(this._container,t.add(e)):i=i.add(t).add(e);var n=this._containerBottom=-i.y,o=this._containerLeft=-Math.round(this._containerWidth/2)+i.x;this._container.style.bottom=n+"px",this._container.style.left=o+"px"}},_getAnchor:function(){return[0,0]}}),un=hn.extend({options:{maxWidth:300,minWidth:50,maxHeight:null,autoPan:!0,autoPanPaddingTopLeft:null,autoPanPaddingBottomRight:null,autoPanPadding:[5,5],keepInView:!1,closeButton:!0,autoClose:!0,closeOnEscapeKey:!0,className:""},openOn:function(t){return t.openPopup(this),this},onAdd:function(t){hn.prototype.onAdd.call(this,t),t.fire("popupopen",{popup:this}),this._source&&(this._source.fire("popupopen",{popup:this},!0),this._source instanceof Je||this._source.on("preclick",Y))},onRemove:function(t){hn.prototype.onRemove.call(this,t),t.fire("popupclose",{popup:this}),this._source&&(this._source.fire("popupclose",{popup:this},!0),this._source instanceof Je||this._source.off("preclick",Y))},getEvents:function(){var t=hn.prototype.getEvents.call(this);return(void 0!==this.options.closeOnClick?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(t.preclick=this._close),this.options.keepInView&&(t.moveend=this._adjustPan),t},_close:function(){this._map&&this._map.closePopup(this)},_initLayout:function(){var t="leaflet-popup",i=this._container=ht("div",t+" "+(this.options.className||"")+" leaflet-zoom-animated"),e=this._wrapper=ht("div",t+"-content-wrapper",i);if(this._contentNode=ht("div",t+"-content",e),J(e),X(this._contentNode),V(e,"contextmenu",Y),this._tipContainer=ht("div",t+"-tip-container",i),this._tip=ht("div",t+"-tip",this._tipContainer),this.options.closeButton){var n=this._closeButton=ht("a",t+"-close-button",i);n.href="#close",n.innerHTML="&#215;",V(n,"click",this._onCloseButtonClick,this)}},_updateLayout:function(){var t=this._contentNode,i=t.style;i.width="",i.whiteSpace="nowrap";var e=t.offsetWidth;e=Math.min(e,this.options.maxWidth),e=Math.max(e,this.options.minWidth),i.width=e+1+"px",i.whiteSpace="",i.height="";var n=t.offsetHeight,o=this.options.maxHeight;o&&n>o?(i.height=o+"px",pt(t,"leaflet-popup-scrolled")):mt(t,"leaflet-popup-scrolled"),this._containerWidth=this._container.offsetWidth},_animateZoom:function(t){var i=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center),e=this._getAnchor();Lt(this._container,i.add(e))},_adjustPan:function(){if(!(!this.options.autoPan||this._map._panAnim&&this._map._panAnim._inProgress)){var t=this._map,i=parseInt(at(this._container,"marginBottom"),10)||0,e=this._container.offsetHeight+i,n=this._containerWidth,o=new x(this._containerLeft,-e-this._containerBottom);o._add(Pt(this._container));var s=t.layerPointToContainerPoint(o),r=w(this.options.autoPanPadding),a=w(this.options.autoPanPaddingTopLeft||r),h=w(this.options.autoPanPaddingBottomRight||r),u=t.getSize(),l=0,c=0;s.x+n+h.x>u.x&&(l=s.x+n-u.x+h.x),s.x-l-a.x<0&&(l=s.x-a.x),s.y+e+h.y>u.y&&(c=s.y+e-u.y+h.y),s.y-c-a.y<0&&(c=s.y-a.y),(l||c)&&t.fire("autopanstart").panBy([l,c])}},_onCloseButtonClick:function(t){this._close(),Q(t)},_getAnchor:function(){return w(this._source&&this._source._getPopupAnchor?this._source._getPopupAnchor():[0,0])}});Le.mergeOptions({closePopupOnClick:!0}),Le.include({openPopup:function(t,i,e){return t instanceof un||(t=new un(e).setContent(t)),i&&t.setLatLng(i),this.hasLayer(t)?this:(this._popup&&this._popup.options.autoClose&&this.closePopup(),this._popup=t,this.addLayer(t))},closePopup:function(t){return t&&t!==this._popup||(t=this._popup,this._popup=null),t&&this.removeLayer(t),this}}),Ue.include({bindPopup:function(t,i){return t instanceof un?(l(t,i),this._popup=t,t._source=this):(this._popup&&!i||(this._popup=new un(i,this)),this._popup.setContent(t)),this._popupHandlersAdded||(this.on({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this.off({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!1,this._popup=null),this},openPopup:function(t,i){if(t instanceof Ue||(i=t,t=this),t instanceof qe)for(var e in this._layers){t=this._layers[e];break}return i||(i=t.getCenter?t.getCenter():t.getLatLng()),this._popup&&this._map&&(this._popup._source=t,this._popup.update(),this._map.openPopup(this._popup,i)),this},closePopup:function(){return this._popup&&this._popup._close(),this},togglePopup:function(t){return this._popup&&(this._popup._map?this.closePopup():this.openPopup(t)),this},isPopupOpen:function(){return!!this._popup&&this._popup.isOpen()},setPopupContent:function(t){return this._popup&&this._popup.setContent(t),this},getPopup:function(){return this._popup},_openPopup:function(t){var i=t.layer||t.target;this._popup&&this._map&&(Q(t),i instanceof Je?this.openPopup(t.layer||t.target,t.latlng):this._map.hasLayer(this._popup)&&this._popup._source===i?this.closePopup():this.openPopup(i,t.latlng))},_movePopup:function(t){this._popup.setLatLng(t.latlng)},_onKeyPress:function(t){13===t.originalEvent.keyCode&&this._openPopup(t)}});var ln=hn.extend({options:{pane:"tooltipPane",offset:[0,0],direction:"auto",permanent:!1,sticky:!1,interactive:!1,opacity:.9},onAdd:function(t){hn.prototype.onAdd.call(this,t),this.setOpacity(this.options.opacity),t.fire("tooltipopen",{tooltip:this}),this._source&&this._source.fire("tooltipopen",{tooltip:this},!0)},onRemove:function(t){hn.prototype.onRemove.call(this,t),t.fire("tooltipclose",{tooltip:this}),this._source&&this._source.fire("tooltipclose",{tooltip:this},!0)},getEvents:function(){var t=hn.prototype.getEvents.call(this);return Vi&&!this.options.permanent&&(t.preclick=this._close),t},_close:function(){this._map&&this._map.closeTooltip(this)},_initLayout:function(){var t="leaflet-tooltip "+(this.options.className||"")+" leaflet-zoom-"+(this._zoomAnimated?"animated":"hide");this._contentNode=this._container=ht("div",t)},_updateLayout:function(){},_adjustPan:function(){},_setPosition:function(t){var i=this._map,e=this._container,n=i.latLngToContainerPoint(i.getCenter()),o=i.layerPointToContainerPoint(t),s=this.options.direction,r=e.offsetWidth,a=e.offsetHeight,h=w(this.options.offset),u=this._getAnchor();"top"===s?t=t.add(w(-r/2+h.x,-a+h.y+u.y,!0)):"bottom"===s?t=t.subtract(w(r/2-h.x,-h.y,!0)):"center"===s?t=t.subtract(w(r/2+h.x,a/2-u.y+h.y,!0)):"right"===s||"auto"===s&&o.x<n.x?(s="right",t=t.add(w(h.x+u.x,u.y-a/2+h.y,!0))):(s="left",t=t.subtract(w(r+u.x-h.x,a/2-u.y-h.y,!0))),mt(e,"leaflet-tooltip-right"),mt(e,"leaflet-tooltip-left"),mt(e,"leaflet-tooltip-top"),mt(e,"leaflet-tooltip-bottom"),pt(e,"leaflet-tooltip-"+s),Lt(e,t)},_updatePosition:function(){var t=this._map.latLngToLayerPoint(this._latlng);this._setPosition(t)},setOpacity:function(t){this.options.opacity=t,this._container&&vt(this._container,t)},_animateZoom:function(t){var i=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center);this._setPosition(i)},_getAnchor:function(){return w(this._source&&this._source._getTooltipAnchor&&!this.options.sticky?this._source._getTooltipAnchor():[0,0])}});Le.include({openTooltip:function(t,i,e){return t instanceof ln||(t=new ln(e).setContent(t)),i&&t.setLatLng(i),this.hasLayer(t)?this:this.addLayer(t)},closeTooltip:function(t){return t&&this.removeLayer(t),this}}),Ue.include({bindTooltip:function(t,i){return t instanceof ln?(l(t,i),this._tooltip=t,t._source=this):(this._tooltip&&!i||(this._tooltip=new ln(i,this)),this._tooltip.setContent(t)),this._initTooltipInteractions(),this._tooltip.options.permanent&&this._map&&this._map.hasLayer(this)&&this.openTooltip(),this},unbindTooltip:function(){return this._tooltip&&(this._initTooltipInteractions(!0),this.closeTooltip(),this._tooltip=null),this},_initTooltipInteractions:function(t){if(t||!this._tooltipHandlersAdded){var i=t?"off":"on",e={remove:this.closeTooltip,move:this._moveTooltip};this._tooltip.options.permanent?e.add=this._openTooltip:(e.mouseover=this._openTooltip,e.mouseout=this.closeTooltip,this._tooltip.options.sticky&&(e.mousemove=this._moveTooltip),Vi&&(e.click=this._openTooltip)),this[i](e),this._tooltipHandlersAdded=!t}},openTooltip:function(t,i){if(t instanceof Ue||(i=t,t=this),t instanceof qe)for(var e in this._layers){t=this._layers[e];break}return i||(i=t.getCenter?t.getCenter():t.getLatLng()),this._tooltip&&this._map&&(this._tooltip._source=t,this._tooltip.update(),this._map.openTooltip(this._tooltip,i),this._tooltip.options.interactive&&this._tooltip._container&&(pt(this._tooltip._container,"leaflet-clickable"),this.addInteractiveTarget(this._tooltip._container))),this},closeTooltip:function(){return this._tooltip&&(this._tooltip._close(),this._tooltip.options.interactive&&this._tooltip._container&&(mt(this._tooltip._container,"leaflet-clickable"),this.removeInteractiveTarget(this._tooltip._container))),this},toggleTooltip:function(t){return this._tooltip&&(this._tooltip._map?this.closeTooltip():this.openTooltip(t)),this},isTooltipOpen:function(){return this._tooltip.isOpen()},setTooltipContent:function(t){return this._tooltip&&this._tooltip.setContent(t),this},getTooltip:function(){return this._tooltip},_openTooltip:function(t){var i=t.layer||t.target;this._tooltip&&this._map&&this.openTooltip(i,this._tooltip.options.sticky?t.latlng:void 0)},_moveTooltip:function(t){var i,e,n=t.latlng;this._tooltip.options.sticky&&t.originalEvent&&(i=this._map.mouseEventToContainerPoint(t.originalEvent),e=this._map.containerPointToLayerPoint(i),n=this._map.layerPointToLatLng(e)),this._tooltip.setLatLng(n)}});var cn=Ge.extend({options:{iconSize:[12,12],html:!1,bgPos:null,className:"leaflet-div-icon"},createIcon:function(t){var i=t&&"DIV"===t.tagName?t:document.createElement("div"),e=this.options;if(i.innerHTML=!1!==e.html?e.html:"",e.bgPos){var n=w(e.bgPos);i.style.backgroundPosition=-n.x+"px "+-n.y+"px"}return this._setIconStyles(i,"icon"),i},createShadow:function(){return null}});Ge.Default=Ke;var _n=Ue.extend({options:{tileSize:256,opacity:1,updateWhenIdle:ji,updateWhenZooming:!0,updateInterval:200,zIndex:1,bounds:null,minZoom:0,maxZoom:void 0,maxNativeZoom:void 0,minNativeZoom:void 0,noWrap:!1,pane:"tilePane",className:"",keepBuffer:2},initialize:function(t){l(this,t)},onAdd:function(){this._initContainer(),this._levels={},this._tiles={},this._resetView(),this._update()},beforeAdd:function(t){t._addZoomLimit(this)},onRemove:function(t){this._removeAllTiles(),ut(this._container),t._removeZoomLimit(this),this._container=null,this._tileZoom=void 0},bringToFront:function(){return this._map&&(ct(this._container),this._setAutoZIndex(Math.max)),this},bringToBack:function(){return this._map&&(_t(this._container),this._setAutoZIndex(Math.min)),this},getContainer:function(){return this._container},setOpacity:function(t){return this.options.opacity=t,this._updateOpacity(),this},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},isLoading:function(){return this._loading},redraw:function(){return this._map&&(this._removeAllTiles(),this._update()),this},getEvents:function(){var t={viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd};return this.options.updateWhenIdle||(this._onMove||(this._onMove=o(this._onMoveEnd,this.options.updateInterval,this)),t.move=this._onMove),this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},createTile:function(){return document.createElement("div")},getTileSize:function(){var t=this.options.tileSize;return t instanceof x?t:new x(t,t)},_updateZIndex:function(){this._container&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(t){for(var i,e=this.getPane().children,n=-t(-1/0,1/0),o=0,s=e.length;o<s;o++)i=e[o].style.zIndex,e[o]!==this._container&&i&&(n=t(n,+i));isFinite(n)&&(this.options.zIndex=n+t(-1,1),this._updateZIndex())},_updateOpacity:function(){if(this._map&&!Li){vt(this._container,this.options.opacity);var t=+new Date,i=!1,e=!1;for(var n in this._tiles){var o=this._tiles[n];if(o.current&&o.loaded){var s=Math.min(1,(t-o.loaded)/200);vt(o.el,s),s<1?i=!0:(o.active?e=!0:this._onOpaqueTile(o),o.active=!0)}}e&&!this._noPrune&&this._pruneTiles(),i&&(g(this._fadeFrame),this._fadeFrame=f(this._updateOpacity,this))}},_onOpaqueTile:r,_initContainer:function(){this._container||(this._container=ht("div","leaflet-layer "+(this.options.className||"")),this._updateZIndex(),this.options.opacity<1&&this._updateOpacity(),this.getPane().appendChild(this._container))},_updateLevels:function(){var t=this._tileZoom,i=this.options.maxZoom;if(void 0!==t){for(var e in this._levels)this._levels[e].el.children.length||e===t?(this._levels[e].el.style.zIndex=i-Math.abs(t-e),this._onUpdateLevel(e)):(ut(this._levels[e].el),this._removeTilesAtZoom(e),this._onRemoveLevel(e),delete this._levels[e]);var n=this._levels[t],o=this._map;return n||((n=this._levels[t]={}).el=ht("div","leaflet-tile-container leaflet-zoom-animated",this._container),n.el.style.zIndex=i,n.origin=o.project(o.unproject(o.getPixelOrigin()),t).round(),n.zoom=t,this._setZoomTransform(n,o.getCenter(),o.getZoom()),n.el.offsetWidth,this._onCreateLevel(n)),this._level=n,n}},_onUpdateLevel:r,_onRemoveLevel:r,_onCreateLevel:r,_pruneTiles:function(){if(this._map){var t,i,e=this._map.getZoom();if(e>this.options.maxZoom||e<this.options.minZoom)this._removeAllTiles();else{for(t in this._tiles)(i=this._tiles[t]).retain=i.current;for(t in this._tiles)if((i=this._tiles[t]).current&&!i.active){var n=i.coords;this._retainParent(n.x,n.y,n.z,n.z-5)||this._retainChildren(n.x,n.y,n.z,n.z+2)}for(t in this._tiles)this._tiles[t].retain||this._removeTile(t)}}},_removeTilesAtZoom:function(t){for(var i in this._tiles)this._tiles[i].coords.z===t&&this._removeTile(i)},_removeAllTiles:function(){for(var t in this._tiles)this._removeTile(t)},_invalidateAll:function(){for(var t in this._levels)ut(this._levels[t].el),this._onRemoveLevel(t),delete this._levels[t];this._removeAllTiles(),this._tileZoom=void 0},_retainParent:function(t,i,e,n){var o=Math.floor(t/2),s=Math.floor(i/2),r=e-1,a=new x(+o,+s);a.z=+r;var h=this._tileCoordsToKey(a),u=this._tiles[h];return u&&u.active?(u.retain=!0,!0):(u&&u.loaded&&(u.retain=!0),r>n&&this._retainParent(o,s,r,n))},_retainChildren:function(t,i,e,n){for(var o=2*t;o<2*t+2;o++)for(var s=2*i;s<2*i+2;s++){var r=new x(o,s);r.z=e+1;var a=this._tileCoordsToKey(r),h=this._tiles[a];h&&h.active?h.retain=!0:(h&&h.loaded&&(h.retain=!0),e+1<n&&this._retainChildren(o,s,e+1,n))}},_resetView:function(t){var i=t&&(t.pinch||t.flyTo);this._setView(this._map.getCenter(),this._map.getZoom(),i,i)},_animateZoom:function(t){this._setView(t.center,t.zoom,!0,t.noUpdate)},_clampZoom:function(t){var i=this.options;return void 0!==i.minNativeZoom&&t<i.minNativeZoom?i.minNativeZoom:void 0!==i.maxNativeZoom&&i.maxNativeZoom<t?i.maxNativeZoom:t},_setView:function(t,i,e,n){var o=this._clampZoom(Math.round(i));(void 0!==this.options.maxZoom&&o>this.options.maxZoom||void 0!==this.options.minZoom&&o<this.options.minZoom)&&(o=void 0);var s=this.options.updateWhenZooming&&o!==this._tileZoom;n&&!s||(this._tileZoom=o,this._abortLoading&&this._abortLoading(),this._updateLevels(),this._resetGrid(),void 0!==o&&this._update(t),e||this._pruneTiles(),this._noPrune=!!e),this._setZoomTransforms(t,i)},_setZoomTransforms:function(t,i){for(var e in this._levels)this._setZoomTransform(this._levels[e],t,i)},_setZoomTransform:function(t,i,e){var n=this._map.getZoomScale(e,t.zoom),o=t.origin.multiplyBy(n).subtract(this._map._getNewPixelOrigin(i,e)).round();Ni?wt(t.el,o,n):Lt(t.el,o)},_resetGrid:function(){var t=this._map,i=t.options.crs,e=this._tileSize=this.getTileSize(),n=this._tileZoom,o=this._map.getPixelWorldBounds(this._tileZoom);o&&(this._globalTileRange=this._pxBoundsToTileRange(o)),this._wrapX=i.wrapLng&&!this.options.noWrap&&[Math.floor(t.project([0,i.wrapLng[0]],n).x/e.x),Math.ceil(t.project([0,i.wrapLng[1]],n).x/e.y)],this._wrapY=i.wrapLat&&!this.options.noWrap&&[Math.floor(t.project([i.wrapLat[0],0],n).y/e.x),Math.ceil(t.project([i.wrapLat[1],0],n).y/e.y)]},_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._update()},_getTiledPixelBounds:function(t){var i=this._map,e=i._animatingZoom?Math.max(i._animateToZoom,i.getZoom()):i.getZoom(),n=i.getZoomScale(e,this._tileZoom),o=i.project(t,this._tileZoom).floor(),s=i.getSize().divideBy(2*n);return new P(o.subtract(s),o.add(s))},_update:function(t){var i=this._map;if(i){var e=this._clampZoom(i.getZoom());if(void 0===t&&(t=i.getCenter()),void 0!==this._tileZoom){var n=this._getTiledPixelBounds(t),o=this._pxBoundsToTileRange(n),s=o.getCenter(),r=[],a=this.options.keepBuffer,h=new P(o.getBottomLeft().subtract([a,-a]),o.getTopRight().add([a,-a]));if(!(isFinite(o.min.x)&&isFinite(o.min.y)&&isFinite(o.max.x)&&isFinite(o.max.y)))throw new Error("Attempted to load an infinite number of tiles");for(var u in this._tiles){var l=this._tiles[u].coords;l.z===this._tileZoom&&h.contains(new x(l.x,l.y))||(this._tiles[u].current=!1)}if(Math.abs(e-this._tileZoom)>1)this._setView(t,e);else{for(var c=o.min.y;c<=o.max.y;c++)for(var _=o.min.x;_<=o.max.x;_++){var d=new x(_,c);if(d.z=this._tileZoom,this._isValidTile(d)){var p=this._tiles[this._tileCoordsToKey(d)];p?p.current=!0:r.push(d)}}if(r.sort(function(t,i){return t.distanceTo(s)-i.distanceTo(s)}),0!==r.length){this._loading||(this._loading=!0,this.fire("loading"));var m=document.createDocumentFragment();for(_=0;_<r.length;_++)this._addTile(r[_],m);this._level.el.appendChild(m)}}}}},_isValidTile:function(t){var i=this._map.options.crs;if(!i.infinite){var e=this._globalTileRange;if(!i.wrapLng&&(t.x<e.min.x||t.x>e.max.x)||!i.wrapLat&&(t.y<e.min.y||t.y>e.max.y))return!1}if(!this.options.bounds)return!0;var n=this._tileCoordsToBounds(t);return z(this.options.bounds).overlaps(n)},_keyToBounds:function(t){return this._tileCoordsToBounds(this._keyToTileCoords(t))},_tileCoordsToNwSe:function(t){var i=this._map,e=this.getTileSize(),n=t.scaleBy(e),o=n.add(e);return[i.unproject(n,t.z),i.unproject(o,t.z)]},_tileCoordsToBounds:function(t){var i=this._tileCoordsToNwSe(t),e=new T(i[0],i[1]);return this.options.noWrap||(e=this._map.wrapLatLngBounds(e)),e},_tileCoordsToKey:function(t){return t.x+":"+t.y+":"+t.z},_keyToTileCoords:function(t){var i=t.split(":"),e=new x(+i[0],+i[1]);return e.z=+i[2],e},_removeTile:function(t){var i=this._tiles[t];i&&(Ci||i.el.setAttribute("src",ni),ut(i.el),delete this._tiles[t],this.fire("tileunload",{tile:i.el,coords:this._keyToTileCoords(t)}))},_initTile:function(t){pt(t,"leaflet-tile");var i=this.getTileSize();t.style.width=i.x+"px",t.style.height=i.y+"px",t.onselectstart=r,t.onmousemove=r,Li&&this.options.opacity<1&&vt(t,this.options.opacity),Ti&&!zi&&(t.style.WebkitBackfaceVisibility="hidden")},_addTile:function(t,i){var n=this._getTilePos(t),o=this._tileCoordsToKey(t),s=this.createTile(this._wrapCoords(t),e(this._tileReady,this,t));this._initTile(s),this.createTile.length<2&&f(e(this._tileReady,this,t,null,s)),Lt(s,n),this._tiles[o]={el:s,coords:t,current:!0},i.appendChild(s),this.fire("tileloadstart",{tile:s,coords:t})},_tileReady:function(t,i,n){if(this._map){i&&this.fire("tileerror",{error:i,tile:n,coords:t});var o=this._tileCoordsToKey(t);(n=this._tiles[o])&&(n.loaded=+new Date,this._map._fadeAnimated?(vt(n.el,0),g(this._fadeFrame),this._fadeFrame=f(this._updateOpacity,this)):(n.active=!0,this._pruneTiles()),i||(pt(n.el,"leaflet-tile-loaded"),this.fire("tileload",{tile:n.el,coords:t})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),Li||!this._map._fadeAnimated?f(this._pruneTiles,this):setTimeout(e(this._pruneTiles,this),250)))}},_getTilePos:function(t){return t.scaleBy(this.getTileSize()).subtract(this._level.origin)},_wrapCoords:function(t){var i=new x(this._wrapX?s(t.x,this._wrapX):t.x,this._wrapY?s(t.y,this._wrapY):t.y);return i.z=t.z,i},_pxBoundsToTileRange:function(t){var i=this.getTileSize();return new P(t.min.unscaleBy(i).floor(),t.max.unscaleBy(i).ceil().subtract([1,1]))},_noTilesToLoad:function(){for(var t in this._tiles)if(!this._tiles[t].loaded)return!1;return!0}}),dn=_n.extend({options:{minZoom:0,maxZoom:18,subdomains:"abc",errorTileUrl:"",zoomOffset:0,tms:!1,zoomReverse:!1,detectRetina:!1,crossOrigin:!1},initialize:function(t,i){this._url=t,(i=l(this,i)).detectRetina&&Ki&&i.maxZoom>0&&(i.tileSize=Math.floor(i.tileSize/2),i.zoomReverse?(i.zoomOffset--,i.minZoom++):(i.zoomOffset++,i.maxZoom--),i.minZoom=Math.max(0,i.minZoom)),"string"==typeof i.subdomains&&(i.subdomains=i.subdomains.split("")),Ti||this.on("tileunload",this._onTileRemove)},setUrl:function(t,i){return this._url=t,i||this.redraw(),this},createTile:function(t,i){var n=document.createElement("img");return V(n,"load",e(this._tileOnLoad,this,i,n)),V(n,"error",e(this._tileOnError,this,i,n)),this.options.crossOrigin&&(n.crossOrigin=""),n.alt="",n.setAttribute("role","presentation"),n.src=this.getTileUrl(t),n},getTileUrl:function(t){var e={r:Ki?"@2x":"",s:this._getSubdomain(t),x:t.x,y:t.y,z:t.z?t.z:this._getZoomForUrl()};if(this._map&&!this._map.options.crs.infinite){var n=this._globalTileRange.max.y-t.y;this.options.tms&&(e.y=n),e["-y"]=n}return _(this._url,i(e,this.options))},_tileOnLoad:function(t,i){Li?setTimeout(e(t,this,null,i),0):t(null,i)},_tileOnError:function(t,i,e){var n=this.options.errorTileUrl;n&&i.getAttribute("src")!==n&&(i.src=n),t(e,i)},_onTileRemove:function(t){t.tile.onload=null},_getZoomForUrl:function(){var t=this._tileZoom,i=this.options.maxZoom,e=this.options.zoomReverse,n=this.options.zoomOffset;return e&&(t=i-t),t+n},_getSubdomain:function(t){var i=Math.abs(t.x+t.y)%this.options.subdomains.length;return this.options.subdomains[i]},_abortLoading:function(){var t,i;for(t in this._tiles)this._tiles[t].coords.z!==this._tileZoom&&((i=this._tiles[t].el).onload=r,i.onerror=r,i.complete||(i.src=ni,ut(i),delete this._tiles[t]))}}),pn=dn.extend({defaultWmsParams:{service:"WMS",request:"GetMap",layers:"",styles:"",format:"image/jpeg",transparent:!1,version:"1.1.1"},options:{crs:null,uppercase:!1},initialize:function(t,e){this._url=t;var n=i({},this.defaultWmsParams);for(var o in e)o in this.options||(n[o]=e[o]);var s=(e=l(this,e)).detectRetina&&Ki?2:1,r=this.getTileSize();n.width=r.x*s,n.height=r.y*s,this.wmsParams=n},onAdd:function(t){this._crs=this.options.crs||t.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var i=this._wmsVersion>=1.3?"crs":"srs";this.wmsParams[i]=this._crs.code,dn.prototype.onAdd.call(this,t)},getTileUrl:function(t){var i=this._tileCoordsToNwSe(t),e=this._crs,n=b(e.project(i[0]),e.project(i[1])),o=n.min,s=n.max,r=(this._wmsVersion>=1.3&&this._crs===He?[o.y,o.x,s.y,s.x]:[o.x,o.y,s.x,s.y]).join(","),a=L.TileLayer.prototype.getTileUrl.call(this,t);return a+c(this.wmsParams,a,this.options.uppercase)+(this.options.uppercase?"&BBOX=":"&bbox=")+r},setParams:function(t,e){return i(this.wmsParams,t),e||this.redraw(),this}});dn.WMS=pn,Yt.wms=function(t,i){return new pn(t,i)};var mn=Ue.extend({options:{padding:.1,tolerance:0},initialize:function(t){l(this,t),n(this),this._layers=this._layers||{}},onAdd:function(){this._container||(this._initContainer(),this._zoomAnimated&&pt(this._container,"leaflet-zoom-animated")),this.getPane().appendChild(this._container),this._update(),this.on("update",this._updatePaths,this)},onRemove:function(){this.off("update",this._updatePaths,this),this._destroyContainer()},getEvents:function(){var t={viewreset:this._reset,zoom:this._onZoom,moveend:this._update,zoomend:this._onZoomEnd};return this._zoomAnimated&&(t.zoomanim=this._onAnimZoom),t},_onAnimZoom:function(t){this._updateTransform(t.center,t.zoom)},_onZoom:function(){this._updateTransform(this._map.getCenter(),this._map.getZoom())},_updateTransform:function(t,i){var e=this._map.getZoomScale(i,this._zoom),n=Pt(this._container),o=this._map.getSize().multiplyBy(.5+this.options.padding),s=this._map.project(this._center,i),r=this._map.project(t,i).subtract(s),a=o.multiplyBy(-e).add(n).add(o).subtract(r);Ni?wt(this._container,a,e):Lt(this._container,a)},_reset:function(){this._update(),this._updateTransform(this._center,this._zoom);for(var t in this._layers)this._layers[t]._reset()},_onZoomEnd:function(){for(var t in this._layers)this._layers[t]._project()},_updatePaths:function(){for(var t in this._layers)this._layers[t]._update()},_update:function(){var t=this.options.padding,i=this._map.getSize(),e=this._map.containerPointToLayerPoint(i.multiplyBy(-t)).round();this._bounds=new P(e,e.add(i.multiplyBy(1+2*t)).round()),this._center=this._map.getCenter(),this._zoom=this._map.getZoom()}}),fn=mn.extend({getEvents:function(){var t=mn.prototype.getEvents.call(this);return t.viewprereset=this._onViewPreReset,t},_onViewPreReset:function(){this._postponeUpdatePaths=!0},onAdd:function(){mn.prototype.onAdd.call(this),this._draw()},_initContainer:function(){var t=this._container=document.createElement("canvas");V(t,"mousemove",o(this._onMouseMove,32,this),this),V(t,"click dblclick mousedown mouseup contextmenu",this._onClick,this),V(t,"mouseout",this._handleMouseOut,this),this._ctx=t.getContext("2d")},_destroyContainer:function(){delete this._ctx,ut(this._container),q(this._container),delete this._container},_updatePaths:function(){if(!this._postponeUpdatePaths){this._redrawBounds=null;for(var t in this._layers)this._layers[t]._update();this._redraw()}},_update:function(){if(!this._map._animatingZoom||!this._bounds){this._drawnLayers={},mn.prototype._update.call(this);var t=this._bounds,i=this._container,e=t.getSize(),n=Ki?2:1;Lt(i,t.min),i.width=n*e.x,i.height=n*e.y,i.style.width=e.x+"px",i.style.height=e.y+"px",Ki&&this._ctx.scale(2,2),this._ctx.translate(-t.min.x,-t.min.y),this.fire("update")}},_reset:function(){mn.prototype._reset.call(this),this._postponeUpdatePaths&&(this._postponeUpdatePaths=!1,this._updatePaths())},_initPath:function(t){this._updateDashArray(t),this._layers[n(t)]=t;var i=t._order={layer:t,prev:this._drawLast,next:null};this._drawLast&&(this._drawLast.next=i),this._drawLast=i,this._drawFirst=this._drawFirst||this._drawLast},_addPath:function(t){this._requestRedraw(t)},_removePath:function(t){var i=t._order,e=i.next,n=i.prev;e?e.prev=n:this._drawLast=n,n?n.next=e:this._drawFirst=e,delete t._order,delete this._layers[L.stamp(t)],this._requestRedraw(t)},_updatePath:function(t){this._extendRedrawBounds(t),t._project(),t._update(),this._requestRedraw(t)},_updateStyle:function(t){this._updateDashArray(t),this._requestRedraw(t)},_updateDashArray:function(t){if(t.options.dashArray){var i,e=t.options.dashArray.split(","),n=[];for(i=0;i<e.length;i++)n.push(Number(e[i]));t.options._dashArray=n}},_requestRedraw:function(t){this._map&&(this._extendRedrawBounds(t),this._redrawRequest=this._redrawRequest||f(this._redraw,this))},_extendRedrawBounds:function(t){if(t._pxBounds){var i=(t.options.weight||0)+1;this._redrawBounds=this._redrawBounds||new P,this._redrawBounds.extend(t._pxBounds.min.subtract([i,i])),this._redrawBounds.extend(t._pxBounds.max.add([i,i]))}},_redraw:function(){this._redrawRequest=null,this._redrawBounds&&(this._redrawBounds.min._floor(),this._redrawBounds.max._ceil()),this._clear(),this._draw(),this._redrawBounds=null},_clear:function(){var t=this._redrawBounds;if(t){var i=t.getSize();this._ctx.clearRect(t.min.x,t.min.y,i.x,i.y)}else this._ctx.clearRect(0,0,this._container.width,this._container.height)},_draw:function(){var t,i=this._redrawBounds;if(this._ctx.save(),i){var e=i.getSize();this._ctx.beginPath(),this._ctx.rect(i.min.x,i.min.y,e.x,e.y),this._ctx.clip()}this._drawing=!0;for(var n=this._drawFirst;n;n=n.next)t=n.layer,(!i||t._pxBounds&&t._pxBounds.intersects(i))&&t._updatePath();this._drawing=!1,this._ctx.restore()},_updatePoly:function(t,i){if(this._drawing){var e,n,o,s,r=t._parts,a=r.length,h=this._ctx;if(a){for(this._drawnLayers[t._leaflet_id]=t,h.beginPath(),e=0;e<a;e++){for(n=0,o=r[e].length;n<o;n++)s=r[e][n],h[n?"lineTo":"moveTo"](s.x,s.y);i&&h.closePath()}this._fillStroke(h,t)}}},_updateCircle:function(t){if(this._drawing&&!t._empty()){var i=t._point,e=this._ctx,n=Math.max(Math.round(t._radius),1),o=(Math.max(Math.round(t._radiusY),1)||n)/n;this._drawnLayers[t._leaflet_id]=t,1!==o&&(e.save(),e.scale(1,o)),e.beginPath(),e.arc(i.x,i.y/o,n,0,2*Math.PI,!1),1!==o&&e.restore(),this._fillStroke(e,t)}},_fillStroke:function(t,i){var e=i.options;e.fill&&(t.globalAlpha=e.fillOpacity,t.fillStyle=e.fillColor||e.color,t.fill(e.fillRule||"evenodd")),e.stroke&&0!==e.weight&&(t.setLineDash&&t.setLineDash(i.options&&i.options._dashArray||[]),t.globalAlpha=e.opacity,t.lineWidth=e.weight,t.strokeStyle=e.color,t.lineCap=e.lineCap,t.lineJoin=e.lineJoin,t.stroke())},_onClick:function(t){for(var i,e,n=this._map.mouseEventToLayerPoint(t),o=this._drawFirst;o;o=o.next)(i=o.layer).options.interactive&&i._containsPoint(n)&&!this._map._draggableMoved(i)&&(e=i);e&&(et(t),this._fireEvent([e],t))},_onMouseMove:function(t){if(this._map&&!this._map.dragging.moving()&&!this._map._animatingZoom){var i=this._map.mouseEventToLayerPoint(t);this._handleMouseHover(t,i)}},_handleMouseOut:function(t){var i=this._hoveredLayer;i&&(mt(this._container,"leaflet-interactive"),this._fireEvent([i],t,"mouseout"),this._hoveredLayer=null)},_handleMouseHover:function(t,i){for(var e,n,o=this._drawFirst;o;o=o.next)(e=o.layer).options.interactive&&e._containsPoint(i)&&(n=e);n!==this._hoveredLayer&&(this._handleMouseOut(t),n&&(pt(this._container,"leaflet-interactive"),this._fireEvent([n],t,"mouseover"),this._hoveredLayer=n)),this._hoveredLayer&&this._fireEvent([this._hoveredLayer],t)},_fireEvent:function(t,i,e){this._map._fireDOMEvent(i,e||i.type,t)},_bringToFront:function(t){var i=t._order,e=i.next,n=i.prev;e&&(e.prev=n,n?n.next=e:e&&(this._drawFirst=e),i.prev=this._drawLast,this._drawLast.next=i,i.next=null,this._drawLast=i,this._requestRedraw(t))},_bringToBack:function(t){var i=t._order,e=i.next,n=i.prev;n&&(n.next=e,e?e.prev=n:n&&(this._drawLast=n),i.prev=null,i.next=this._drawFirst,this._drawFirst.prev=i,this._drawFirst=i,this._requestRedraw(t))}}),gn=function(){try{return document.namespaces.add("lvml","urn:schemas-microsoft-com:vml"),function(t){return document.createElement("<lvml:"+t+' class="lvml">')}}catch(t){return function(t){return document.createElement("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="lvml">')}}}(),vn={_initContainer:function(){this._container=ht("div","leaflet-vml-container")},_update:function(){this._map._animatingZoom||(mn.prototype._update.call(this),this.fire("update"))},_initPath:function(t){var i=t._container=gn("shape");pt(i,"leaflet-vml-shape "+(this.options.className||"")),i.coordsize="1 1",t._path=gn("path"),i.appendChild(t._path),this._updateStyle(t),this._layers[n(t)]=t},_addPath:function(t){var i=t._container;this._container.appendChild(i),t.options.interactive&&t.addInteractiveTarget(i)},_removePath:function(t){var i=t._container;ut(i),t.removeInteractiveTarget(i),delete this._layers[n(t)]},_updateStyle:function(t){var i=t._stroke,e=t._fill,n=t.options,o=t._container;o.stroked=!!n.stroke,o.filled=!!n.fill,n.stroke?(i||(i=t._stroke=gn("stroke")),o.appendChild(i),i.weight=n.weight+"px",i.color=n.color,i.opacity=n.opacity,n.dashArray?i.dashStyle=ei(n.dashArray)?n.dashArray.join(" "):n.dashArray.replace(/( *, *)/g," "):i.dashStyle="",i.endcap=n.lineCap.replace("butt","flat"),i.joinstyle=n.lineJoin):i&&(o.removeChild(i),t._stroke=null),n.fill?(e||(e=t._fill=gn("fill")),o.appendChild(e),e.color=n.fillColor||n.color,e.opacity=n.fillOpacity):e&&(o.removeChild(e),t._fill=null)},_updateCircle:function(t){var i=t._point.round(),e=Math.round(t._radius),n=Math.round(t._radiusY||e);this._setPath(t,t._empty()?"M0 0":"AL "+i.x+","+i.y+" "+e+","+n+" 0,23592600")},_setPath:function(t,i){t._path.v=i},_bringToFront:function(t){ct(t._container)},_bringToBack:function(t){_t(t._container)}},yn=Ji?gn:E,xn=mn.extend({getEvents:function(){var t=mn.prototype.getEvents.call(this);return t.zoomstart=this._onZoomStart,t},_initContainer:function(){this._container=yn("svg"),this._container.setAttribute("pointer-events","none"),this._rootGroup=yn("g"),this._container.appendChild(this._rootGroup)},_destroyContainer:function(){ut(this._container),q(this._container),delete this._container,delete this._rootGroup,delete this._svgSize},_onZoomStart:function(){this._update()},_update:function(){if(!this._map._animatingZoom||!this._bounds){mn.prototype._update.call(this);var t=this._bounds,i=t.getSize(),e=this._container;this._svgSize&&this._svgSize.equals(i)||(this._svgSize=i,e.setAttribute("width",i.x),e.setAttribute("height",i.y)),Lt(e,t.min),e.setAttribute("viewBox",[t.min.x,t.min.y,i.x,i.y].join(" ")),this.fire("update")}},_initPath:function(t){var i=t._path=yn("path");t.options.className&&pt(i,t.options.className),t.options.interactive&&pt(i,"leaflet-interactive"),this._updateStyle(t),this._layers[n(t)]=t},_addPath:function(t){this._rootGroup||this._initContainer(),this._rootGroup.appendChild(t._path),t.addInteractiveTarget(t._path)},_removePath:function(t){ut(t._path),t.removeInteractiveTarget(t._path),delete this._layers[n(t)]},_updatePath:function(t){t._project(),t._update()},_updateStyle:function(t){var i=t._path,e=t.options;i&&(e.stroke?(i.setAttribute("stroke",e.color),i.setAttribute("stroke-opacity",e.opacity),i.setAttribute("stroke-width",e.weight),i.setAttribute("stroke-linecap",e.lineCap),i.setAttribute("stroke-linejoin",e.lineJoin),e.dashArray?i.setAttribute("stroke-dasharray",e.dashArray):i.removeAttribute("stroke-dasharray"),e.dashOffset?i.setAttribute("stroke-dashoffset",e.dashOffset):i.removeAttribute("stroke-dashoffset")):i.setAttribute("stroke","none"),e.fill?(i.setAttribute("fill",e.fillColor||e.color),i.setAttribute("fill-opacity",e.fillOpacity),i.setAttribute("fill-rule",e.fillRule||"evenodd")):i.setAttribute("fill","none"))},_updatePoly:function(t,i){this._setPath(t,k(t._parts,i))},_updateCircle:function(t){var i=t._point,e=Math.max(Math.round(t._radius),1),n="a"+e+","+(Math.max(Math.round(t._radiusY),1)||e)+" 0 1,0 ",o=t._empty()?"M0 0":"M"+(i.x-e)+","+i.y+n+2*e+",0 "+n+2*-e+",0 ";this._setPath(t,o)},_setPath:function(t,i){t._path.setAttribute("d",i)},_bringToFront:function(t){ct(t._path)},_bringToBack:function(t){_t(t._path)}});Ji&&xn.include(vn),Le.include({getRenderer:function(t){var i=t.options.renderer||this._getPaneRenderer(t.options.pane)||this.options.renderer||this._renderer;return i||(i=this._renderer=this.options.preferCanvas&&Xt()||Jt()),this.hasLayer(i)||this.addLayer(i),i},_getPaneRenderer:function(t){if("overlayPane"===t||void 0===t)return!1;var i=this._paneRenderers[t];return void 0===i&&(i=xn&&Jt({pane:t})||fn&&Xt({pane:t}),this._paneRenderers[t]=i),i}});var wn=en.extend({initialize:function(t,i){en.prototype.initialize.call(this,this._boundsToLatLngs(t),i)},setBounds:function(t){return this.setLatLngs(this._boundsToLatLngs(t))},_boundsToLatLngs:function(t){return t=z(t),[t.getSouthWest(),t.getNorthWest(),t.getNorthEast(),t.getSouthEast()]}});xn.create=yn,xn.pointsToPath=k,nn.geometryToLayer=Wt,nn.coordsToLatLng=Ht,nn.coordsToLatLngs=Ft,nn.latLngToCoords=Ut,nn.latLngsToCoords=Vt,nn.getFeature=qt,nn.asFeature=Gt,Le.mergeOptions({boxZoom:!0});var Ln=Ze.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane,this._resetStateTimeout=0,t.on("unload",this._destroy,this)},addHooks:function(){V(this._container,"mousedown",this._onMouseDown,this)},removeHooks:function(){q(this._container,"mousedown",this._onMouseDown,this)},moved:function(){return this._moved},_destroy:function(){ut(this._pane),delete this._pane},_resetState:function(){this._resetStateTimeout=0,this._moved=!1},_clearDeferredResetState:function(){0!==this._resetStateTimeout&&(clearTimeout(this._resetStateTimeout),this._resetStateTimeout=0)},_onMouseDown:function(t){if(!t.shiftKey||1!==t.which&&1!==t.button)return!1;this._clearDeferredResetState(),this._resetState(),mi(),bt(),this._startPoint=this._map.mouseEventToContainerPoint(t),V(document,{contextmenu:Q,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseMove:function(t){this._moved||(this._moved=!0,this._box=ht("div","leaflet-zoom-box",this._container),pt(this._container,"leaflet-crosshair"),this._map.fire("boxzoomstart")),this._point=this._map.mouseEventToContainerPoint(t);var i=new P(this._point,this._startPoint),e=i.getSize();Lt(this._box,i.min),this._box.style.width=e.x+"px",this._box.style.height=e.y+"px"},_finish:function(){this._moved&&(ut(this._box),mt(this._container,"leaflet-crosshair")),fi(),Tt(),q(document,{contextmenu:Q,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseUp:function(t){if((1===t.which||1===t.button)&&(this._finish(),this._moved)){this._clearDeferredResetState(),this._resetStateTimeout=setTimeout(e(this._resetState,this),0);var i=new T(this._map.containerPointToLatLng(this._startPoint),this._map.containerPointToLatLng(this._point));this._map.fitBounds(i).fire("boxzoomend",{boxZoomBounds:i})}},_onKeyDown:function(t){27===t.keyCode&&this._finish()}});Le.addInitHook("addHandler","boxZoom",Ln),Le.mergeOptions({doubleClickZoom:!0});var Pn=Ze.extend({addHooks:function(){this._map.on("dblclick",this._onDoubleClick,this)},removeHooks:function(){this._map.off("dblclick",this._onDoubleClick,this)},_onDoubleClick:function(t){var i=this._map,e=i.getZoom(),n=i.options.zoomDelta,o=t.originalEvent.shiftKey?e-n:e+n;"center"===i.options.doubleClickZoom?i.setZoom(o):i.setZoomAround(t.containerPoint,o)}});Le.addInitHook("addHandler","doubleClickZoom",Pn),Le.mergeOptions({dragging:!0,inertia:!zi,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,easeLinearity:.2,worldCopyJump:!1,maxBoundsViscosity:0});var bn=Ze.extend({addHooks:function(){if(!this._draggable){var t=this._map;this._draggable=new Be(t._mapPane,t._container),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),this._draggable.on("predrag",this._onPreDragLimit,this),t.options.worldCopyJump&&(this._draggable.on("predrag",this._onPreDragWrap,this),t.on("zoomend",this._onZoomEnd,this),t.whenReady(this._onZoomEnd,this))}pt(this._map._container,"leaflet-grab leaflet-touch-drag"),this._draggable.enable(),this._positions=[],this._times=[]},removeHooks:function(){mt(this._map._container,"leaflet-grab"),mt(this._map._container,"leaflet-touch-drag"),this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},moving:function(){return this._draggable&&this._draggable._moving},_onDragStart:function(){var t=this._map;if(t._stop(),this._map.options.maxBounds&&this._map.options.maxBoundsViscosity){var i=z(this._map.options.maxBounds);this._offsetLimit=b(this._map.latLngToContainerPoint(i.getNorthWest()).multiplyBy(-1),this._map.latLngToContainerPoint(i.getSouthEast()).multiplyBy(-1).add(this._map.getSize())),this._viscosity=Math.min(1,Math.max(0,this._map.options.maxBoundsViscosity))}else this._offsetLimit=null;t.fire("movestart").fire("dragstart"),t.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(t){if(this._map.options.inertia){var i=this._lastTime=+new Date,e=this._lastPos=this._draggable._absPos||this._draggable._newPos;this._positions.push(e),this._times.push(i),this._prunePositions(i)}this._map.fire("move",t).fire("drag",t)},_prunePositions:function(t){for(;this._positions.length>1&&t-this._times[0]>50;)this._positions.shift(),this._times.shift()},_onZoomEnd:function(){var t=this._map.getSize().divideBy(2),i=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=i.subtract(t).x,this._worldWidth=this._map.getPixelWorldBounds().getSize().x},_viscousLimit:function(t,i){return t-(t-i)*this._viscosity},_onPreDragLimit:function(){if(this._viscosity&&this._offsetLimit){var t=this._draggable._newPos.subtract(this._draggable._startPos),i=this._offsetLimit;t.x<i.min.x&&(t.x=this._viscousLimit(t.x,i.min.x)),t.y<i.min.y&&(t.y=this._viscousLimit(t.y,i.min.y)),t.x>i.max.x&&(t.x=this._viscousLimit(t.x,i.max.x)),t.y>i.max.y&&(t.y=this._viscousLimit(t.y,i.max.y)),this._draggable._newPos=this._draggable._startPos.add(t)}},_onPreDragWrap:function(){var t=this._worldWidth,i=Math.round(t/2),e=this._initialWorldOffset,n=this._draggable._newPos.x,o=(n-i+e)%t+i-e,s=(n+i+e)%t-i-e,r=Math.abs(o+e)<Math.abs(s+e)?o:s;this._draggable._absPos=this._draggable._newPos.clone(),this._draggable._newPos.x=r},_onDragEnd:function(t){var i=this._map,e=i.options,n=!e.inertia||this._times.length<2;if(i.fire("dragend",t),n)i.fire("moveend");else{this._prunePositions(+new Date);var o=this._lastPos.subtract(this._positions[0]),s=(this._lastTime-this._times[0])/1e3,r=e.easeLinearity,a=o.multiplyBy(r/s),h=a.distanceTo([0,0]),u=Math.min(e.inertiaMaxSpeed,h),l=a.multiplyBy(u/h),c=u/(e.inertiaDeceleration*r),_=l.multiplyBy(-c/2).round();_.x||_.y?(_=i._limitOffset(_,i.options.maxBounds),f(function(){i.panBy(_,{duration:c,easeLinearity:r,noMoveStart:!0,animate:!0})})):i.fire("moveend")}}});Le.addInitHook("addHandler","dragging",bn),Le.mergeOptions({keyboard:!0,keyboardPanDelta:80});var Tn=Ze.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,54,173]},initialize:function(t){this._map=t,this._setPanDelta(t.options.keyboardPanDelta),this._setZoomDelta(t.options.zoomDelta)},addHooks:function(){var t=this._map._container;t.tabIndex<=0&&(t.tabIndex="0"),V(t,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.on({focus:this._addHooks,blur:this._removeHooks},this)},removeHooks:function(){this._removeHooks(),q(this._map._container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.off({focus:this._addHooks,blur:this._removeHooks},this)},_onMouseDown:function(){if(!this._focused){var t=document.body,i=document.documentElement,e=t.scrollTop||i.scrollTop,n=t.scrollLeft||i.scrollLeft;this._map._container.focus(),window.scrollTo(n,e)}},_onFocus:function(){this._focused=!0,this._map.fire("focus")},_onBlur:function(){this._focused=!1,this._map.fire("blur")},_setPanDelta:function(t){var i,e,n=this._panKeys={},o=this.keyCodes;for(i=0,e=o.left.length;i<e;i++)n[o.left[i]]=[-1*t,0];for(i=0,e=o.right.length;i<e;i++)n[o.right[i]]=[t,0];for(i=0,e=o.down.length;i<e;i++)n[o.down[i]]=[0,t];for(i=0,e=o.up.length;i<e;i++)n[o.up[i]]=[0,-1*t]},_setZoomDelta:function(t){var i,e,n=this._zoomKeys={},o=this.keyCodes;for(i=0,e=o.zoomIn.length;i<e;i++)n[o.zoomIn[i]]=t;for(i=0,e=o.zoomOut.length;i<e;i++)n[o.zoomOut[i]]=-t},_addHooks:function(){V(document,"keydown",this._onKeyDown,this)},_removeHooks:function(){q(document,"keydown",this._onKeyDown,this)},_onKeyDown:function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var i,e=t.keyCode,n=this._map;if(e in this._panKeys){if(n._panAnim&&n._panAnim._inProgress)return;i=this._panKeys[e],t.shiftKey&&(i=w(i).multiplyBy(3)),n.panBy(i),n.options.maxBounds&&n.panInsideBounds(n.options.maxBounds)}else if(e in this._zoomKeys)n.setZoom(n.getZoom()+(t.shiftKey?3:1)*this._zoomKeys[e]);else{if(27!==e||!n._popup||!n._popup.options.closeOnEscapeKey)return;n.closePopup()}Q(t)}}});Le.addInitHook("addHandler","keyboard",Tn),Le.mergeOptions({scrollWheelZoom:!0,wheelDebounceTime:40,wheelPxPerZoomLevel:60});var zn=Ze.extend({addHooks:function(){V(this._map._container,"mousewheel",this._onWheelScroll,this),this._delta=0},removeHooks:function(){q(this._map._container,"mousewheel",this._onWheelScroll,this)},_onWheelScroll:function(t){var i=it(t),n=this._map.options.wheelDebounceTime;this._delta+=i,this._lastMousePos=this._map.mouseEventToContainerPoint(t),this._startTime||(this._startTime=+new Date);var o=Math.max(n-(+new Date-this._startTime),0);clearTimeout(this._timer),this._timer=setTimeout(e(this._performZoom,this),o),Q(t)},_performZoom:function(){var t=this._map,i=t.getZoom(),e=this._map.options.zoomSnap||0;t._stop();var n=this._delta/(4*this._map.options.wheelPxPerZoomLevel),o=4*Math.log(2/(1+Math.exp(-Math.abs(n))))/Math.LN2,s=e?Math.ceil(o/e)*e:o,r=t._limitZoom(i+(this._delta>0?s:-s))-i;this._delta=0,this._startTime=null,r&&("center"===t.options.scrollWheelZoom?t.setZoom(i+r):t.setZoomAround(this._lastMousePos,i+r))}});Le.addInitHook("addHandler","scrollWheelZoom",zn),Le.mergeOptions({tap:!0,tapTolerance:15});var Mn=Ze.extend({addHooks:function(){V(this._map._container,"touchstart",this._onDown,this)},removeHooks:function(){q(this._map._container,"touchstart",this._onDown,this)},_onDown:function(t){if(t.touches){if($(t),this._fireClick=!0,t.touches.length>1)return this._fireClick=!1,void clearTimeout(this._holdTimeout);var i=t.touches[0],n=i.target;this._startPos=this._newPos=new x(i.clientX,i.clientY),n.tagName&&"a"===n.tagName.toLowerCase()&&pt(n,"leaflet-active"),this._holdTimeout=setTimeout(e(function(){this._isTapValid()&&(this._fireClick=!1,this._onUp(),this._simulateEvent("contextmenu",i))},this),1e3),this._simulateEvent("mousedown",i),V(document,{touchmove:this._onMove,touchend:this._onUp},this)}},_onUp:function(t){if(clearTimeout(this._holdTimeout),q(document,{touchmove:this._onMove,touchend:this._onUp},this),this._fireClick&&t&&t.changedTouches){var i=t.changedTouches[0],e=i.target;e&&e.tagName&&"a"===e.tagName.toLowerCase()&&mt(e,"leaflet-active"),this._simulateEvent("mouseup",i),this._isTapValid()&&this._simulateEvent("click",i)}},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_onMove:function(t){var i=t.touches[0];this._newPos=new x(i.clientX,i.clientY),this._simulateEvent("mousemove",i)},_simulateEvent:function(t,i){var e=document.createEvent("MouseEvents");e._simulated=!0,i.target._simulatedClick=!0,e.initMouseEvent(t,!0,!0,window,1,i.screenX,i.screenY,i.clientX,i.clientY,!1,!1,!1,!1,0,null),i.target.dispatchEvent(e)}});Vi&&!Ui&&Le.addInitHook("addHandler","tap",Mn),Le.mergeOptions({touchZoom:Vi&&!zi,bounceAtZoomLimits:!0});var Cn=Ze.extend({addHooks:function(){pt(this._map._container,"leaflet-touch-zoom"),V(this._map._container,"touchstart",this._onTouchStart,this)},removeHooks:function(){mt(this._map._container,"leaflet-touch-zoom"),q(this._map._container,"touchstart",this._onTouchStart,this)},_onTouchStart:function(t){var i=this._map;if(t.touches&&2===t.touches.length&&!i._animatingZoom&&!this._zooming){var e=i.mouseEventToContainerPoint(t.touches[0]),n=i.mouseEventToContainerPoint(t.touches[1]);this._centerPoint=i.getSize()._divideBy(2),this._startLatLng=i.containerPointToLatLng(this._centerPoint),"center"!==i.options.touchZoom&&(this._pinchStartLatLng=i.containerPointToLatLng(e.add(n)._divideBy(2))),this._startDist=e.distanceTo(n),this._startZoom=i.getZoom(),this._moved=!1,this._zooming=!0,i._stop(),V(document,"touchmove",this._onTouchMove,this),V(document,"touchend",this._onTouchEnd,this),$(t)}},_onTouchMove:function(t){if(t.touches&&2===t.touches.length&&this._zooming){var i=this._map,n=i.mouseEventToContainerPoint(t.touches[0]),o=i.mouseEventToContainerPoint(t.touches[1]),s=n.distanceTo(o)/this._startDist;if(this._zoom=i.getScaleZoom(s,this._startZoom),!i.options.bounceAtZoomLimits&&(this._zoom<i.getMinZoom()&&s<1||this._zoom>i.getMaxZoom()&&s>1)&&(this._zoom=i._limitZoom(this._zoom)),"center"===i.options.touchZoom){if(this._center=this._startLatLng,1===s)return}else{var r=n._add(o)._divideBy(2)._subtract(this._centerPoint);if(1===s&&0===r.x&&0===r.y)return;this._center=i.unproject(i.project(this._pinchStartLatLng,this._zoom).subtract(r),this._zoom)}this._moved||(i._moveStart(!0,!1),this._moved=!0),g(this._animRequest);var a=e(i._move,i,this._center,this._zoom,{pinch:!0,round:!1});this._animRequest=f(a,this,!0),$(t)}},_onTouchEnd:function(){this._moved&&this._zooming?(this._zooming=!1,g(this._animRequest),q(document,"touchmove",this._onTouchMove),q(document,"touchend",this._onTouchEnd),this._map.options.zoomAnimation?this._map._animateZoom(this._center,this._map._limitZoom(this._zoom),!0,this._map.options.zoomSnap):this._map._resetView(this._center,this._map._limitZoom(this._zoom))):this._zooming=!1}});Le.addInitHook("addHandler","touchZoom",Cn),Le.BoxZoom=Ln,Le.DoubleClickZoom=Pn,Le.Drag=bn,Le.Keyboard=Tn,Le.ScrollWheelZoom=zn,Le.Tap=Mn,Le.TouchZoom=Cn;var Zn=window.L;window.L=t,Object.freeze=$t,t.version="1.3.0",t.noConflict=function(){return window.L=Zn,this},t.Control=Pe,t.control=be,t.Browser=$i,t.Evented=ui,t.Mixin=Ee,t.Util=ai,t.Class=v,t.Handler=Ze,t.extend=i,t.bind=e,t.stamp=n,t.setOptions=l,t.DomEvent=de,t.DomUtil=xe,t.PosAnimation=we,t.Draggable=Be,t.LineUtil=Oe,t.PolyUtil=Re,t.Point=x,t.point=w,t.Bounds=P,t.bounds=b,t.Transformation=Z,t.transformation=S,t.Projection=je,t.LatLng=M,t.latLng=C,t.LatLngBounds=T,t.latLngBounds=z,t.CRS=ci,t.GeoJSON=nn,t.geoJSON=Kt,t.geoJson=sn,t.Layer=Ue,t.LayerGroup=Ve,t.layerGroup=function(t,i){return new Ve(t,i)},t.FeatureGroup=qe,t.featureGroup=function(t){return new qe(t)},t.ImageOverlay=rn,t.imageOverlay=function(t,i,e){return new rn(t,i,e)},t.VideoOverlay=an,t.videoOverlay=function(t,i,e){return new an(t,i,e)},t.DivOverlay=hn,t.Popup=un,t.popup=function(t,i){return new un(t,i)},t.Tooltip=ln,t.tooltip=function(t,i){return new ln(t,i)},t.Icon=Ge,t.icon=function(t){return new Ge(t)},t.DivIcon=cn,t.divIcon=function(t){return new cn(t)},t.Marker=Xe,t.marker=function(t,i){return new Xe(t,i)},t.TileLayer=dn,t.tileLayer=Yt,t.GridLayer=_n,t.gridLayer=function(t){return new _n(t)},t.SVG=xn,t.svg=Jt,t.Renderer=mn,t.Canvas=fn,t.canvas=Xt,t.Path=Je,t.CircleMarker=$e,t.circleMarker=function(t,i){return new $e(t,i)},t.Circle=Qe,t.circle=function(t,i,e){return new Qe(t,i,e)},t.Polyline=tn,t.polyline=function(t,i){return new tn(t,i)},t.Polygon=en,t.polygon=function(t,i){return new en(t,i)},t.Rectangle=wn,t.rectangle=function(t,i){return new wn(t,i)},t.Map=Le,t.map=function(t,i){return new Le(t,i)}});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(57), __webpack_require__(34), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (localeValidator, GeopolViewService, utils) {
    'use strict';

    var roadUseValues = ['LimitedAccess', 'Arterial', 'Terminal', 'Ramp', 'Rotary', 'LocalStreet'],
        routingGuidanceLanguageValues = ['ar', 'af-ZA', 'bg-BG', 'zh-TW', 'cs-CZ', 'da-DK', 'nl-NL', 'en-GB', 'en-US', 'fi-FI', 'fr-FR', 'de-DE', 'el-GR', 'hu-HU', 'id-ID', 'it-IT', 'ko-KR', 'lt-LT', 'ms-MY', 'nb-NO', 'pl-PL', 'pt-BR', 'pt-PT', 'ru-RU', 'sk-SK', 'sl-SI', 'es-ES', 'es-MX', 'sv-SE', 'th-TH', 'tr-TR'],
        trafficIncidentsLanguageValues = ['ca', 'cs', 'da', 'de', 'en', 'es', 'fi', 'fr', 'hu', 'it', 'nl', 'no', 'pl', 'pt', 'sk', 'sv', 'tr'],


    // Up-to-date list available on:
    // https://developer.tomtom.com/search-api/search-api-documentation/supported-languages
    supportedLanguageCodes = ['af-ZA', 'ar', 'bg-BG', 'ca-ES', 'zh-CN', 'zh-TW', 'cs-CZ', 'da-DK', 'nl-BE', 'nl-NL', 'en-AU', 'en-NZ', 'en-GB', 'en-US', 'et-EE', 'fi-FI', 'fr-CA', 'fr-FR', 'de-DE', 'el-GR', 'hr-HR', 'hu-HU', 'it-IT', 'lv-LV', 'lt-LT', 'ms-MY', 'no-NO', 'pl-PL', 'pt-BR', 'pt-PT', 'ru-RU', 'sk-SK', 'sl-SI', 'es-ES', 'es-419', 'sv-SE', 'tr-TR', 'eu-ES', 'gl-ES', 'he-IL', 'id-ID', 'kk-KZ', 'ro-RO', 'sr-RS', 'th-TH', 'uk-UA', 'vi-VN'];

    function isDateRfc3339(dateString) {
        return (/(\d\d\d\d)(-)?(\d\d)(-)?(\d\d)(T)?(\d\d)(:)?(\d\d)(:)?(\d\d)(\.\d+)?(Z|([+-])(\d\d)(:)?(\d\d))/.test(dateString.toString())
        );
    }

    function validateAgainstSetOfValues(value, arrayOfValues, messageIfNotFound) {
        if (arrayOfValues.indexOf(value) === -1) {
            throw new TypeError(messageIfNotFound);
        }
        return value;
    }

    function hasBoundingBoxFields(bbox) {
        return bbox.hasOwnProperty('minLon') && bbox.hasOwnProperty('maxLon') && bbox.hasOwnProperty('minLat') && bbox.hasOwnProperty('maxLat');
    }

    function checkBBoxNormalized(bbox) {
        return parseFloat(bbox.maxLat) <= parseFloat(bbox.minLat) || parseFloat(bbox.maxLon) <= parseFloat(bbox.minLon);
    }

    function isNumberInInterval(numValue, min, max) {
        return isFinite(numValue) && numValue > min && numValue <= max;
    }

    function checkArray(array) {
        return array.constructor.toString().indexOf('Array') < 0;
    }

    function throwTypeErrorWhen(condition, message) {
        if (condition) {
            throw new TypeError(message);
        }
    }

    function isPointValid(point) {
        if (!utils.isString(point) || !utils.pointRegex.test(point)) {
            throw new TypeError('A point is expected, but ' + point + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
        }
        return true;
    }

    function checkLongitude(value) {
        var numValue = parseFloat(value);
        if (!isNumberInInterval(numValue, -180, 180)) {
            throw new TypeError('an longitude <-180,180> is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
        }
        return numValue;
    }

    function checkLatitude(value) {
        var numValue = parseFloat(value);
        if (!isNumberInInterval(numValue, -90, 90)) {
            throw new TypeError('an latitude <-90,90> is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
        }
        return numValue;
    }

    function checkPointObjectOrArray(point) {
        var lat, lon;
        if (Array.isArray(point)) {
            if (!(point.length === 2 && point.filter(isFinite).length === 2)) {
                throw new TypeError('Ivalid point array in route points');
            }
            lat = point[0];
            lon = point[1];
        } else {
            if (!(isFinite(point.lat) && (isFinite(point.lon) || isFinite(point.lng)))) {
                throw new TypeError('Ivalid point object in route points');
            }
            lat = point.lat;
            lon = typeof point.lon !== 'undefined' ? point.lon : point.lng;
        }

        if (!(typeof lat === 'number' || lat instanceof Number) || !(typeof lon === 'number' || lon instanceof Number)) {
            throw new TypeError('Lat and lon components of point should be finite numbers');
        }

        checkLongitude(lon);
        checkLatitude(lat);
    }

    function validateNumberInInterval(min, max, errorMsg, integerRequired) {
        if (utils.isValueNil(min) || utils.isValueNil(max)) {
            throw new TypeError('Number in interval validator requires min and max value parameters');
        }

        return function (value) {
            var numValue = parseFloat(value);

            if (!isNumberInInterval(numValue, min, max) || integerRequired && !Number.isInteger(numValue)) {
                throw new TypeError(errorMsg + ', but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }

            return numValue;
        };
    }

    function validateIntInInterval(min, max, errorMsg) {
        return validateNumberInInterval(min, max, errorMsg, true);
    }

    return {

        /**
         * @ignore
         * Casts to boolean
         * @param {*} value
         * @return {Boolean} casted value
         */
        bool: function bool(value) {
            return value === 'false' ? false : Boolean(value);
        },

        /**
         * @ignore
         * Check whether the given parameter is a float number
         * @param {*} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        number: function number(value) {
            var numValue = parseFloat(value);
            if (!isFinite(numValue)) {
                throw new TypeError('a number is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
            return numValue;
        },

        /**
         * @ignore
         * Check whether the given parameter is a integer greater than or equal 0
         * @param {*} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        naturalInteger: function naturalInteger(value) {
            var numValue = parseFloat(value);
            if (!Number.isInteger(numValue) || numValue < 0) {
                throw new TypeError('a natural integer (greater than or equal 0) is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
            return numValue;
        },

        /**
         * @ignore
         * Check whether the given parameter is a integer greater than 0
         * @param {*} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        positiveInteger: function positiveInteger(value) {
            var numValue = parseFloat(value);
            if (!Number.isInteger(numValue) || numValue <= 0) {
                throw new TypeError('a positive integer (greater than 0) is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
            return numValue;
        },

        integer: function integer(value) {
            var numValue = parseFloat(value);
            if (!Number.isInteger(numValue)) {
                throw new TypeError('an integer is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
            return numValue;
        },

        /**
         * @ignore
         * Check whether the given parameter is a longitude and casts to proper interval <-180, 180>
         * @param {*} value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        longitude: checkLongitude,

        /**
         * @ignore
         * Check whether the given parameter is a latitude and casts to proper interval <-90, 90>
         * @param {*} value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        latitude: checkLatitude,

        /**
         * @ignore
         * Check whether the given parameter is a valid bounding box. Allows to contain whole world and a half on each
         * side.
         * @param {*} bbox The bounding box
         * @return {Object} bbox
         * @throws {TypeError} for invalid parameter
         */
        boundingBox: function boundingBox(bbox) {
            throwTypeErrorWhen(!hasBoundingBoxFields(bbox), 'a bounding box is expected, but ' + bbox + ' [' + (typeof bbox === 'undefined' ? 'undefined' : _typeof(bbox)) + '] given');

            throwTypeErrorWhen(!isNumberInInterval(bbox.minLat, -90, 90), 'a bounding box minimal latitude is expected ' + bbox.minLat + ' [' + _typeof(bbox.minLat) + '] given');

            throwTypeErrorWhen(!isNumberInInterval(bbox.maxLat, -90, 90), 'a bounding box maximal latitude is expected ' + bbox.maxLat + ' [' + _typeof(bbox.maxLat) + '] given');

            throwTypeErrorWhen(!isNumberInInterval(bbox.minLon, -270, 180), 'a bounding box minimal longitude is expected ' + bbox.minLon + ' [' + _typeof(bbox.minLon) + '] given');

            throwTypeErrorWhen(!isNumberInInterval(bbox.maxLon, -180, 270), 'a bounding box maximal longitude is expected ' + bbox.maxLon + ' [' + _typeof(bbox.maxLon) + '] given');

            throwTypeErrorWhen(checkBBoxNormalized(bbox), 'a bounding box expected but max <= min');

            return bbox;
        },

        /**
         * @ignore
         * Check whether the given parameter is a float number in proper interval <min, max>
         * @example
         * var numberBetweenMinusFiveAndFive = validators.numberInInterval(-5,5);
         * numberBetweenMinusFiveAndFive(-10); // false
         * numberBetweenMinusFiveAndFive(3); //true
         *
         * @param {Number} [min] The minimal value
         * @param {Number} [max] The maximal value
         * @return {Function} validator function that checks type and value range
         * @throws {TypeError} when missing min or max value
         */
        numberInInterval: function numberInInterval(min, max) {
            return validateNumberInInterval(min, max, 'a number in interval <' + min + ', ' + max + '> is expected');
        },

        /**
         * @ignore
         * Check whether the given parameter is an integer number in proper interval <min, max>
         * @example
         * var numberBetweenMinusFiveAndFive = validators.numberInInterval(-5,5);
         * numberBetweenMinusFiveAndFive(-10); // false
         * numberBetweenMinusFiveAndFive(3); //true
         *
         * @param {Number} [min] The minimal value
         * @param {Number} [max] The maximal value
         * @return {Function} validator function that checks type and value range
         * @throws {TypeError} when missing min or max value
         */
        integerInInterval: function integerInInterval(min, max) {
            return validateIntInInterval(min, max, 'an integer in interval <' + (min + 1) + ', ' + max + '> is expected');
        },

        /**
         * @ignore
         * Check whether the given parameter is a string
         * @param {String} string
         * @return {String} value
         * @throws {TypeError} for non strings
         */
        string: function string(_string) {
            if (!utils.isString(_string)) {
                throw new TypeError('a string is expected, but ' + _string + ' [' + (typeof _string === 'undefined' ? 'undefined' : _typeof(_string)) + '] given');
            }
            return _string;
        },

        /**
         * @ignore
         * Check whether the given parameter is a geometries zoom value<0, 22>
         * @param {Number} geometriesZoom
         * @return {Number} value
         * @throws {TypeError} for non invalid parameter
         */
        geometriesZoom: function geometriesZoom(_geometriesZoom) {
            return validateNumberInInterval(0, 22, 'a geometries zoom value <0, 22> is expected')(_geometriesZoom);
        },

        /**
         * @ignore
         * Check whether the given parameter is a zoom level value<0, 18>
         * @param {Number} zoomLevel
         * @return {Number} value
         * @throws {TypeError} for non invalid parameter
         */
        zoomLevel: function zoomLevel(_zoomLevel) {
            return validateIntInInterval(0, 18, 'zoom level <0, 18> is expected')(_zoomLevel);
        },

        /**
         * @ignore
         * Check whether the given parameter is a function
         * @param {Function} fun
         * @return {Function} fun
         * @throws {TypeError} for non function
         */
        functionType: function functionType(fun) {
            if (typeof fun !== 'function') {
                throw new TypeError('a function is expected, but ' + fun + '  [' + (typeof fun === 'undefined' ? 'undefined' : _typeof(fun)) + '] given');
            }
            return fun;
        },

        /**
         * @ignore
         * Checks whether the given country name uses ISO 3166 alpha-3 or alpha-2 format.
         * @param {String} name
         * @return {String} name
         * @throws {TypeError} if the country name is not valid
         */
        countryCode: function countryCode(name) {
            if (!(utils.isString(name) && (name.length === 3 || name.length === 2))) {
                throw new TypeError('a 2 or 3-characters long country name is expected, but ' + name + ' [' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)) + '] given');
            }
            return name;
        },

        /**
         * @ignore
         * Checks whether the given language code belongs to predefined set of supported language codes
         * which is a subset of the IETF language tags.
         * @param {String|undefined} langCode
         * @return {String}
         */
        languageCode: function languageCode(langCode) {
            if (!utils.isString(langCode) || supportedLanguageCodes.indexOf(langCode) < 0) {
                throw new TypeError('One of pre-defined language codes was expected: ' + supportedLanguageCodes + ', but ' + langCode + ' [' + (typeof langCode === 'undefined' ? 'undefined' : _typeof(langCode)) + '] given');
            }
            return langCode;
        },

        /**
         * @ignore
         * Checks whether the given country name's list use ISO 3166 alpha-3 or alpha-2 format.
         * @param {String|Array} value
         * @return {String} list
         * @throws {TypeError} if one of the country names is not valid
         */
        countrySet: function countrySet(value) {
            var stringValue;
            throwTypeErrorWhen(!utils.isString(value) && checkArray(value), 'An array of string country names or string (divided with commas) of country ' + 'names (two or three-characters long) is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');

            stringValue = utils.isString(value) ? value : value.join();
            throwTypeErrorWhen(!stringValue.match(/^([a-zA-z]{2,3},)*[a-zA-z]{2,3}$/), 'An array of string country names or string (divided with commas) of country ' + 'names (two or three-characters long) is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');

            return stringValue;
        },

        /**
         * @ignore
         * Checks whether the given country name's list use ISO 3166 alpha-3 or alpha-2 format.
         * @param {Boolean} allowEmpty Specifies that it allows empty array as a valid value
         * @param {String|Array} value
         * @return {String} list
         * @throws {TypeError} if one of the country names is not valid
         */
        countrySetAlpha3: function countrySetAlpha3(allowEmpty, value) {
            var stringValue;
            throwTypeErrorWhen(!utils.isString(value) && checkArray(value), 'An array of string country names or string (divided with commas) of country ' + 'names (three-characters long) is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');

            stringValue = utils.isString(value) ? value : value.join();
            if (allowEmpty && stringValue === '') {
                return value;
            }
            throwTypeErrorWhen(!stringValue.match(/^([a-zA-z]{3},)*[a-zA-z]{3}$/), 'An array of string country names or string (divided with commas) of country ' + 'names (three-characters long) is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');

            return value;
        },

        /**
         * @ignore
         * Checks whether the given point is in proper format
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is in not valid format
         */
        point: function point(value) {
            isPointValid(value);
            return value;
        },

        /**
         * @ignore
         * Check whether the given parameter is a positive integer (greater than 0) and lower than 3
         * @param {Number} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        fuzzinessLevel: function fuzzinessLevel(value) {
            return validateIntInInterval(0, 4, 'Fuzziness level value (a positive integer lower than 5) is expected')(value);
        },

        /**
         * @ignore
         * Check whether the given parameter is a positive integer (greater than 0) and lower than 100
         * @param {Number} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        limit: function limit(value) {
            return validateIntInInterval(0, 100, 'Limit value (a positive integer lower than 100) is expected')(value);
        },

        /**
         * @ignore
         * Check whether the given parameter is an offset - positive integer <0, 1900>
         * @param {Number} value The value
         * @return {Number} value
         * @throws {TypeError} for invalid parameter
         */
        offset: function offset(value) {
            return validateIntInInterval(-1, 1900, 'Offset an integer value <0, 1900> is expected')(value);
        },

        /**
         * @ignore
         * Check whether the given parameter is a plain object (array and functions aren't accepted)
         * @param {Object} object
         * @return {Object} object
         * @throws {TypeError} for non object
         */
        plainObject: function plainObject(object) {
            if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object' || object.constructor !== Object) {
                throw new TypeError('an object is expected, but ' + object + '  [' + (typeof object === 'undefined' ? 'undefined' : _typeof(object)) + '] given');
            }
            return object;
        },

        /**
         * @ignore
         * Check whether the given parameter is an array (objects and functions aren't accepted)
         * @param {Array} array
         * @return {Array} array
         * @throws {TypeError} for non array
         */
        arrayType: function arrayType(array) {
            if (checkArray(array)) {
                throw new TypeError('an array is expected, but ' + array + '  [' + (typeof array === 'undefined' ? 'undefined' : _typeof(array)) + '] given');
            }
            return array;
        },

        arrayOf: function arrayOf(options) {
            return function (values) {
                values.forEach(function (value) {
                    var key;
                    for (key in options) {
                        if (options.hasOwnProperty(key)) {
                            if (value.hasOwnProperty(key) && typeof options[key].validator === 'function') {
                                value[key] = options[key].validator(value[key]);
                            }

                            if (options[key].required === true && !value.hasOwnProperty(key)) {
                                throw new Error('Missing required ' + key);
                            }
                        }
                    }
                });
                return values;
            };
        },

        objectOf: function objectOf(options) {
            return function (value) {
                var key;
                for (key in options) {
                    if (options.hasOwnProperty(key)) {
                        if (value.hasOwnProperty(key) && typeof options[key].validator === 'function') {
                            value[key] = options[key].validator(value[key]);
                        }
                        if (options[key].required === true && !value.hasOwnProperty(key)) {
                            throw new Error('Missing required ' + key);
                        }
                    }
                }
                return value;
            };
        },

        roadUse: function roadUse(value) {
            var elements, i;
            throwTypeErrorWhen(!utils.isString(value) || !value.match(/^\[("\w*",?)+\]$/), 'Road use is expected, but ' + value + '  [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');

            elements = value.replace(/["[\]]/g, '').split(',');
            for (i = 0; i < elements.length; i += 1) {
                throwTypeErrorWhen(roadUseValues.indexOf(elements[i]) < 0, 'Road use (' + roadUseValues + ') is expected, but ' + value + '  [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
            return value;
        },

        oneOfValue: function oneOfValue(values, paramName) {
            return function (value) {
                var message = 'Supported ' + paramName + ' is expected (one of: ' + values + '), but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given';
                return validateAgainstSetOfValues(value, values, message);
            };
        },

        arrayOfValues: function arrayOfValues(values, paramName) {
            return function (value) {
                var i;
                var message = 'Supported ' + paramName + ' type is expected (array with one of: ' + values + '), but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given';
                if (checkArray(value)) {
                    throw new TypeError('an array is expected, but ' + value + '  [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
                }
                for (i = 0; i < value.length; i += 1) {
                    validateAgainstSetOfValues(value[i], values, message);
                }
                return value;
            };
        },

        /**
         * @ignore
         * Checks whether the given departure time is now or in proper rfc3339 format ( 1996-12-19T16:39:57 or
         * 1996-12-19T16:39:57-08:00 ):
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is not valid
         */
        departAt: function departAt(value) {
            if (value === 'now' || isDateRfc3339(value) && Date.now() < Date.parse(value)) {
                return value;
            } else {
                throw new TypeError('Supported departAt is now or rfc3339 format and no earlier than now(), but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
        },

        /**
         * @ignore
         * Checks whether the given arrive time is in proper rfc3339 format ( 1996-12-19T16:39:57 or
         * 1996-12-19T16:39:57-08:00 ):
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is not valid
         */
        arriveAt: function arriveAt(value) {
            if (isDateRfc3339(value) && Date.now() < Date.parse(value)) {
                return value;
            } else {
                throw new TypeError('Supported arriveAt is rfc3339 format, but and no earlier than now() ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
        },

        dateRfc3339: function dateRfc3339(value) {
            if (isDateRfc3339(value)) {
                return value;
            } else {
                throw new TypeError('Expecting date in RFC3339 format, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
        },

        routingGuidanceLanguage: function routingGuidanceLanguage(value) {
            var message = 'Supported routing guidance language is expected to be one of: ' + routingGuidanceLanguageValues + '), but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given';
            return validateAgainstSetOfValues(value, routingGuidanceLanguageValues, message);
        },

        trafficIncidentsLanguage: function trafficIncidentsLanguage(value) {
            var message = 'Supported traffic incidents language is expected to be one of: ' + trafficIncidentsLanguageValues + '), but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given';
            return validateAgainstSetOfValues(value, trafficIncidentsLanguageValues, message);
        },

        /**
         * @ignore
         * Checks whether the given routing locations is in proper format:
         * circle A circle with a center point and a radius (in meters).
         * The radius must be a positive integer with the maximum value of 20050000. Note that larger integer values
         * will not be rejected but lowered to the maximum value. circle(52.37245,4.89406,10000) location    A point or
         * a circle.
         * 52.37245,4.89406
         * circle(52.37245,4.89406,10000)
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is not valid
         */
        routingLocations: function routingLocations(value) {
            var point = utils.pointRegex,
                circle = utils.circleRegex,
                routingLocation;

            if (value.constructor.toString().indexOf('Array') > -1) {
                value = value.join(':');
            }

            routingLocation = new RegExp('^' + point.source + ':(?:(?:' + point.source + '|' + circle.source + '):)*' + point.source + '$');
            if (!value.match(routingLocation)) {
                throw new TypeError('Routing location is expected. But ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
            return value;
        },

        /**
         * @ignore
         * Checks whether the given input is in proper circle format:
         * circle A circle with a center point and a radius (in meters).
         * The radius must be a positive integer with the maximum value of 20050000. Note that larger integer values
         * will not be rejected but lowered to the maximum value. circle(52.37245,4.89406,10000)
         * @param {String} value
         * @return {String} value
         * @throws {TypeError} if the given value is not valid
         */
        circle: function circle(value) {
            var match;
            throwTypeErrorWhen(!utils.isString(value), 'Expecting circle but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');

            match = value.match(/circle\(-?\d*(?:\.\d*)?\s*,\s*-?\d*(?:\.\d*)?\s*,\s*(\d+)\)/);
            throwTypeErrorWhen(!match || parseFloat(match[1]) > 20050000, 'Expecting circle but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');

            return value;
        },

        /**
         * @ignore
         * Checks whether the given input is in proper geometry list format.
         * Geometry list represents list of figures (polygons or circles) objects.
         * Circle contains properties like: type ("CIRCLE"), position (lat & lon) and radius.
         * Polygon contains properties like: type ("POLYGON") and vertices (as a list of points).
         *
         * @param {Array} value
         * @return {Array} value
         * @throws {TypeError} if the given value is not valid
         */
        geometryList: function geometryList(value) {
            var i, geoObject;
            throwTypeErrorWhen(checkArray(value), 'An array of geometry objects is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');

            if (value.length > 0) {
                for (i = 0; i < value.length; i += 1) {
                    geoObject = value[i];
                    throwTypeErrorWhen(!geoObject.hasOwnProperty('type') || !geoObject.hasOwnProperty('vertices') && (!geoObject.hasOwnProperty('position') || !geoObject.hasOwnProperty('radius')), 'An array of geometry objects is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
                }
            } else {
                throw new TypeError('An array of geometry objects is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            }
            return value;
        },
        locale: function locale(serviceType) {
            /**
             * @ignore
             * Checks whether provided value is a valid language code for given serviceType
             * @param {String} value language code to be validated
             * @return {String} provided value if it's valid
             * @throws {TypeError} if the given value is not valid
             */
            return function (value) {
                throwTypeErrorWhen(!localeValidator(value, serviceType), 'Provided language code "' + value + '" is not valid for a given service type: "' + serviceType + '"');
                return value;
            };
        },
        geopolView: function geopolView(serviceType, name) {
            if (!serviceType) {
                throw new Error('Please specify a service type.');
            }

            return function (value) {
                var supportedGeopolViews = GeopolViewService.getSupportedViews(serviceType, 'all').map(function (view) {
                    return view.code;
                });

                throwTypeErrorWhen(supportedGeopolViews.indexOf(value) === -1, name + ': Provided geopolitical view code "' + value + '" is not valid');
                return value;
            };
        },

        /**
         * @ignore
         *
         * Checks if the given value has a property 'route' which is an array of points.
         * By array of points we mean array of an array of { lat, lon }, { lat, lng }, [ num, num ],
         * L.LatLng objects or mixed.
         *
         * @param {Object} value
         *
         * @return {Object} value Stringified array of figures (JSON format).
         * @throws {TypeError} if the given value is not valid
         */
        route: function route(value) {
            var points;

            if (typeof value.points !== 'undefined') {
                points = value.points;
            } else {
                throw new TypeError('Invalid structure of the route object');
            }

            if (points && !(Array.isArray(points) && points.length > 2)) {
                throw new TypeError('Provided route array ' + points + ' is not valid. It should be an array with at least 2 points.');
            }
            points.forEach(checkPointObjectOrArray);
            return value;
        },

        supportingPoints: function supportingPoints(value) {
            if (!utils.isArray(value)) {
                throw new TypeError('Invalid structure of the supporting points');
            }

            if (!value.length || value.length < 2) {
                throw new TypeError('There should be at least two supporting points');
            }
            return value;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * This module extends the Leaflet library in order to display a TomTom map.
 *
 * For a full reference of the Leaflet map API check the official
 * <a href="http://leafletjs.com/reference-${leaflet.version}.html" target="_blank">Leaflet's documentation</a>.
 *
 * We are using leaflet's version ${leaflet.version}.
 *
 * If you want to use vector source in the map the basePath must be specified.
 * Keep this in mind when you switch from raster to vector source, for example when opening our examples in CodePen,
 * otherwise the map will not render properly.
 *
 * Example of how to create a basic map instance:
 *
 * ```html
 * <style type="text/css">
 *   html, body {
 *      width: 100%;
 *      height: 100%;
 *      margin: 0;
 *      padding: 0;
 *  }
 *  #map {
 *      width: 100%;
 *      height: 100%;
 *  }
 * </style>
 *
 * <div id="map"></div>
 *
 * <script>
 *   var mapInstance = new L.Map("map", {key: "<Your API key>"});
 * </script>
 * ```
 *
 * @class Map
 * @extends L.Map (Leaflet's)
 * @module Map
 * @namespace L
 * @constructor
 * @param {HTMLElement|String} id The div element or its id in which the map will be initialized.
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#map-options">Leaflet's Map</a>
 *     class allows.
 *     The additional options, which are TomTom specific, are described below.
 * @param {String} [options.key] API key that can be obtained from
 *     <a href="https://developer.tomtom.com">TomTom's developer portal</a>.
 *     When the key is passed on the map's initialization, it is set globally for all the services. It can be
 *     overwritten with the `tomtom.key()` method globally or per service  with `tomtom.<service_name>.key()` functions.
 *     It is also possible to pass a specific key while working with instances of the services.
 * @param {"main"|"night"} [options.style="main"] The base map style to be used.
 * @param {"basic"|"hybrid"|"labels"} [options.layer="basic"] The base map's layer to be used.
 * @param {"Unified"|"IN"} [options.geopolView] Define the geopolitical view for the new map instance.
 * @param {Boolean|Object} [options.traffic] Allows to easily add the
 *     {{#crossLink "L.TomTomTrafficLayer"}}{{/crossLink}} and
 *     {{#crossLink "L.TomTomTrafficIncidentsLayer"}}{{/crossLink}} layers to the map. A value of this parameter can
 *     be set to an options object as described in the traffic layer documentation.
 *     If traffic layers are added with this option, a mechanism for periodic refresh of the traffic data is provided
 *     (using a proper traffic model id handling). If you pass source parameter set to vector, {{#crossLink "L.TomTomVectorTrafficIncidentsLayer"}}{{/crossLink}}
 *     will be added as a source for incident tiles instead of raster one.
 * @param {Boolean} [options.traffic.noRefresh] Disables periodic updates of traffic layers.
 * @param {Number} [options.traffic.refresh=30000] The traffic incidents information changes and needs to be updated
 *     periodically. By default, it is refreshed every 30 seconds. This parameter's value represents the time
 *     in milliseconds between each update interval. The value must be 0 or greater.
 * @param {Boolean|Object} [options.trafficFlow] Allows to add {{#crossLink "L.TomTomTrafficFlowLayer"}}{{/crossLink}}
 *     to the map. A value of this parameter can be set to the options object as described in the traffic flow layer
 *     documentation. If you specify source set to vector as one of the parameters it will add
 *    {{#crossLink "L.TomTomVectorTrafficFlowLayer"}}{{/crossLink}} instead.
 * @param {Boolean|Object} [options.vectorTrafficFlow] Allows to add {{#crossLink "L.TomTomVectorTrafficFlowLayer"}}
 * {{/crossLink}} to the map. A value of this parameter can be set to the options object as described in the traffic
 * flow layer documentation.
 * @param {Boolean} [options.noLabelsOnTop=false] If a traffic or traffic flow layer is overlayed on the map, then by
 *     default, the labels layer is added on top of these layers. It prevents labels from being covered by the traffic
 *     tubes or traffic flow. With this option, it is possible to disable this behaviour.
 * @param {String|String[]} [options.source="raster"] Sets the initial source and determines which tiles types will be
 *     displayed (raster, vector). If an array is given first item is used as a default source and next items are
 *     initialized but not displayed. If MapboxGL JS dependency is not met vector layer will not initialize.
 * @param {String} [options.glyphsUrl] Glyphs are fonts in PBF required to display labels on vector maps. The Url must
 * contain the {fontstack} and {range} tokens. The SDK distributable already contains the glyphs required by the default
 * vector styles - you just need to provide a path to them on your server.
 * Example of a URL format for this property:
 * ```javascript
 * "http://yourdomain/glyphs/{fontstack}/{range}.pbf"
 * ```
 * @param {String} [options.basePath = '/sdk'] Base path for sdk. It will be used in relative paths - it is especially
 * important for maps with vector sources. E.g if you set this option to `"/myPath"`, default urls for styles will
 * be set to `/myPath/styles/basic_main.json`.
 * This property is used only if you do not provide custom mapping for given url mapping.
 * @param {Object} [options.styleUrlMapping] Overrides the default URLs for vector style files.
 * The default value is as follows:
 * ```javascript
 * {
 *   main: {
 *      basic: '/sdk/styles/basic_main.json',
 *      hybrid: '/sdk/styles/hybrid_main.json',
 *      labels: '/sdk/styles/labels_main.json'
 *   },
 *   night: {
 *      basic: '/sdk/styles/basic_night.json',
 *      hybrid: '/sdk/styles/hybrid_night.json',
 *      labels: '/sdk/styles/labels_night.json'
 *   }
 * }
 * ```
 * @param {String} [options.spriteUrl] Set the base URL for the sprite image and metadata. The extensions .png, .json
 * and scale factor will be appended at the end of URL automatically. The sprite URL is required to display icons
 * like road shields on vector maps.
 * Example of a URL format for this property:
 * ```javascript
 * "http://yourdomain/sprite/sprite"
 * ```
 * @param {Boolean} [options.zoomControl=true] Show a zoom control at the top left corner of the map.
 * @param {Boolean} [options.panControl=false] Enable the pan controls at the top left corner of the map.
 * @param {Boolean} [options.zoomsliderControl=false] Shows a vertical slider to control the zoom level.
 * It is recommended to disable the default zoom control option (`zoomControl=false`) when you use this feature.
 * @param {Boolean} [options.worldCopyJump=true]
 * @param {String} [options.language] Language to be used for map labels. Should be one of supported
 *      IETF language tags described
 *      <a href="https://developer.tomtom.com/maps-api/maps-api-documentation-raster/raster-tile#listOfSupportedLanguages">here</a>.
 *      When data in specified language is not available for a specific label,
 *      <a href="https://developer.tomtom.com/maps-api/maps-api-documentation-raster/raster-tile#defaultLanguageAlgorithm">default language</a>
 *      is used.
 */
/* eslint-enable max-len */

/* This method is implemented in staticMapImageFactory.js but documented here due to a
   yuidoc's bug in the @for tag */
/**
 * Returns an URL string to obtain an static image version of the current map's viewport.
 *
 * This method uses the {{#crossLink "StaticMapImage"}}{{/crossLink}} class to generate an URL to get static image
 * based on the configuration of the current map's instance.
 *
 * @method getStaticMapUrl
 * @return {String} An URL string to the image
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(21), __webpack_require__(109), __webpack_require__(27), __webpack_require__(5), __webpack_require__(52), __webpack_require__(124), __webpack_require__(127), __webpack_require__(136), __webpack_require__(137), __webpack_require__(139), __webpack_require__(141), __webpack_require__(146), __webpack_require__(70), __webpack_require__(23), __webpack_require__(39), __webpack_require__(38), __webpack_require__(31), __webpack_require__(30), __webpack_require__(34), __webpack_require__(33), __webpack_require__(71), __webpack_require__(0), __webpack_require__(76), __webpack_require__(145)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, svgIcon, imagePath, mapboxProvider, security, copyrightCaption, copyright, trafficWithIncidents, trafficFlow, vectorTrafficFlow, vectorTrafficIncidents, labelsLayer, VectorLabelsLayer, tileLayer, VectorLayer, UnitService, globalUnitService, LocaleService, globalLocaleService, GeopolViewService, globalGeopolViewService, RoutingContext, utils, mapUtils) {
    'use strict';

    var EVENTS = {
        /**
         * Fired when attribution was fully loaded. Loaded attribution is passed as event data.
         * @event ATTRIBUTION_LOAD_END
         * @type String
         */
        ATTRIBUTION_LOAD_END: 'tomtom.attributionloadend'
    };

    function roundZoom(map, source) {
        if (source === 'raster') {
            map.setZoom(Math.floor(map.getZoom()));
        }
    }

    L.Map.Events = EVENTS;

    L.Map.mergeOptions({
        worldCopyJump: true
    });

    delete L.Map.prototype.options.minZoom;
    delete L.Map.prototype.options.maxZoom;

    /**
     * Method allows to change a source data for currently shown map. It should be one of sources provided
     * at creation as a property 'options.source'
     *
     * @method setMapSource
     * @param {"raster"|"vector"} source
     */
    L.Map.prototype.setMapSource = function (source) {
        var baseLayers, map, requestedLayer, baseLayer;
        map = this;
        baseLayers = map._ttBaseLayers;
        requestedLayer = baseLayers[source];
        if (!requestedLayer) {
            return;
        }

        for (baseLayer in baseLayers) {
            if (baseLayers.hasOwnProperty(baseLayer)) {
                this.removeLayer(baseLayers[baseLayer]);
            }
        }

        roundZoom(map, source);

        map.addLayer(requestedLayer);
    };

    /**
     * @method getBaseLayers
     * @return {Object} Returns base layers initialized on map
     */
    L.Map.prototype.getBaseLayers = function () {
        return this._ttBaseLayers;
    };

    /**
     * Returns localeService which is bound to this map instance. Please note
     * that if you change value in globalLocaleService this one will be updated
     * too, but not other way around.
     * @method getLocaleService
     * @return {LocaleService}
     */
    L.Map.prototype.getLocaleService = function () {
        return this._localeService;
    };

    /**
     * Returns unitService which is bound to this map instance. Please note
     * that if you change the unit of the global UnitService instance this one will be updated
     * too, but not way around.
     * @method getUnitService
     * @return {UnitService}
     */
    L.Map.prototype.getUnitService = function () {
        return this._unitService;
    };

    /**
     * Returns the GeopolViewService instance which is bound to the map instance.
     * Please note that if you change the geopolitical view of the
     * global L.GeopolViewService instance this one will be updated too
     * but not way around.
     * @method getGeopolViewService
     * @return {GeopolViewService}
     */
    L.Map.prototype.getGeopolViewService = function () {
        return this._geopolViewService;
    };

    L.Control.Attribution.prototype.options = {
        position: 'bottomleft',
        prefix: ''
    };

    L.Icon.Default = svgIcon;
    L.Icon.Default.imagePath = imagePath.get();
    L.Marker.mergeOptions({ icon: new L.Icon.Default() });

    function removeInvalidSources(source) {
        var allowedSources = /^(raster|vector)$/;
        var sourceLenght = source.length;
        var validSource = [];
        var currentSource, i;

        for (i = 0; i < sourceLenght; i++) {
            currentSource = String(source[i]).toLowerCase();
            if (allowedSources.test(source[i])) {
                validSource.push(currentSource);
            }
        }

        return validSource;
    }

    function getSource(map) {
        var source = map.options.source || ['raster'];
        var defaultSource = ['raster'];

        if (utils.isString(source)) {
            source = [source];
        }

        source = removeInvalidSources(source);

        return source.length > 0 ? source : defaultSource;
    }

    function isOlderThanIE11() {
        return window.navigator.userAgent.indexOf('MSIE ') > -1;
    }

    function copyBasePathIfNeeded(map, property) {
        if (!map.options[property].basePath) {
            map.options[property].basePath = map.options.basePath;
        }
    }

    function initTrafficLayer(map) {
        if (map.options.traffic) {
            if (map.options.traffic.source && map.options.traffic.source === 'vector') {
                copyBasePathIfNeeded(map, 'traffic');
                map.addLayer(vectorTrafficIncidents(map.options.traffic));
            } else {
                map.addLayer(trafficWithIncidents(map.options.traffic));
            }
        }
    }

    function initTrafficFlowLayer(map) {
        var vectorLayerAdded = false;
        if (map.options.trafficFlow) {
            if (map.options.trafficFlow.source && map.options.trafficFlow.source === 'vector') {
                copyBasePathIfNeeded(map, 'trafficFlow');
                map.addLayer(vectorTrafficFlow(map.options.trafficFlow));
                vectorLayerAdded = true;
            } else {
                map.addLayer(trafficFlow(map.options.trafficFlow));
            }
        }
        if (map.options.vectorTrafficFlow && !vectorLayerAdded) {
            copyBasePathIfNeeded(map, 'vectorTrafficFlow');
            map.addLayer(vectorTrafficFlow(map.options.vectorTrafficFlow));
        }
    }

    function initLabelsLayers(map) {
        var source = getSource(map);
        var layerInstance;
        var vectorLabelsInstance;
        map._ttLabelsLayers = {};

        if (source.indexOf('raster') !== -1 && !map.options.noLabelsOnTop && !isOlderThanIE11()) {
            //This will not work on IE < 11 due to not supported CSS: pointer-events: none;
            layerInstance = labelsLayer(map.options);
            layerInstance.registerEventHandlers(map);
            L.stamp(layerInstance);
            map._ttLabelsLayers.raster = layerInstance;
        }

        if (source.indexOf('vector') !== -1 && !map.options.noLabelsOnTop && mapboxProvider.isMapboxSet()) {
            vectorLabelsInstance = new VectorLabelsLayer(map.options);
            vectorLabelsInstance.registerEventHandlers(map);
            L.stamp(vectorLabelsInstance);
            map._ttLabelsLayers.vector = vectorLabelsInstance;
        }
    }

    function initZoomFix(map) {
        var mac = navigator.platform === 'MacIntel';
        if (!mac) {
            return;
        }
        map._handlers.filter(function (handler) {
            return '_performZoom' in handler;
        }).forEach(function (handler) {
            var original = handler._performZoom;
            handler._performZoom = function () {
                handler._delta *= 13.25;
                original.apply(handler);
            };
        });
    }

    function createWebGLErrorDiv(map) {
        var div = L.DomUtil.create('div', 'tomtom-webgl-error');
        div.appendChild(document.createTextNode('Unable to initialize vector layer - browser doesn\'t support WebGL!'));
        if (map._controlContainer) {
            map._controlContainer.appendChild(div);
        }
    }

    function isWebGlSupported() {
        var canvas = document.createElement('canvas');
        var webGlContext = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

        if (webGlContext && webGlContext instanceof WebGLRenderingContext) {
            return true;
        }

        return false;
    }

    function resolveMapboxSupport(map) {
        var defaultFallback = 'error';
        var allowedFallbacks = /^(error|raster)$/;
        var source = getSource(map);
        var fallback = map.options.vector ? String(map.options.vector.fallback).toLowerCase() : '';
        fallback = allowedFallbacks.test(fallback) ? fallback : defaultFallback;

        if (source.indexOf('vector') === -1 || mapboxProvider.isMapboxSupported() && isWebGlSupported()) {
            return;
        }

        switch (fallback) {
            case 'raster':
                map.options.source = ['raster'];
                break;
            case 'error':
                if (isWebGlSupported()) {
                    throw new Error('MapBox failed to load. Make sure you\'re using vector library.');
                }

                createWebGLErrorDiv(map);
                throw new Error('Unable to initialize vector layer - browser doesn\'t support WebGL!');
            default:
                throw new Error('Something went wrong with vectorFallback!');
        }
    }

    function getMapOptionsWithGeopolView(map, mapLayer) {
        var options;
        if (!map.options.geopolView) {
            return map.options;
        }
        options = utils.clone(map.options);
        options.geopolView = map._geopolViewService.getCurrentGeopolView().getValueFor('maps', mapLayer);
        return options;
    }

    function recreateLayer(layer) {
        var map = this,
            currentLayer = map._ttBaseLayers ? map._ttBaseLayers[layer] : undefined,
            newLayer;
        /**
         * @ignore
         * Even if we do not make layer active right now, we need to keep up-to-date reference of
         * vector/raster layer. There is a public method 'getBaseLayers()' which is used in map-style.html
         * example, which uses those references to change between vector and raster.
         * So, if we change language while raster is active, vector/raster should be updated too,
         * in case when user wants to add layer using those references
        */
        if (currentLayer) {
            newLayer = layer === 'vector' ? new VectorLayer(getMapOptionsWithGeopolView(map, 'vector')) : new L.TomTomLayer(getMapOptionsWithGeopolView(map, 'raster'));
            L.stamp(newLayer);
            map._ttBaseLayers[layer] = newLayer;
            if (mapUtils.findLayersByName(layer, map).length > 0) {
                map.addLayer(newLayer);
                map.removeLayer(currentLayer);
            }
        }
    }

    function mapLocaleChangedHandler(locale) {
        this.options.language = locale.getValueFor('maps');
        recreateLayer.call(this, 'vector');
        recreateLayer.call(this, 'raster');
    }

    function mapGeopolViewChangedHandler(geopolView) {
        this.options.geopolView = geopolView.getCode();
        recreateLayer.call(this, 'vector');
        recreateLayer.call(this, 'raster');
    }

    function initBaseLayer(map) {
        var source = getSource(map);
        var layers = [];
        var i;
        map._ttBaseLayers = {};

        if (source.indexOf('raster') !== -1) {
            map._ttBaseLayers.raster = tileLayer(getMapOptionsWithGeopolView(map, 'raster'));
            L.stamp(map._ttBaseLayers.raster);
        }

        if (mapboxProvider.tryToSetMapbox() && source.indexOf('vector') !== -1) {
            map._ttBaseLayers.vector = new VectorLayer(getMapOptionsWithGeopolView(map, 'vector'));
            L.stamp(map._ttBaseLayers.vector);
        }

        for (i = 0; i < map.options.layers.length; i++) {
            if (map.options.layers[i].wmsParams) {
                layers.push(L.tileLayer.wms(map.options.layers[i]._url, map.options.layers[i].wmsParams));
            }
        }

        if (!layers.length) {
            switch (source[0]) {
                case 'vector':
                    if (map._ttBaseLayers.vector === undefined) {
                        throw new Error('Can not add vector layer. Mapbox-gl-js dependency not met.');
                    }
                    layers = [map._ttBaseLayers.vector];
                    break;
                case 'raster':
                    layers = [map._ttBaseLayers.raster];
                    break;
                default:
                    throw new Error('Something went wrong with sources!');
            }
        }

        map.options.layers = layers;
    }

    /**
     * @ignore
     * This function ensures that the custom zoom configuration given by the user has the correct format.
     * It convert string numbers to numbers. That's all.
     * @param {L.Map} map
     */
    function initZoomConfig(map) {
        if (isFinite(map.options.zoomDelta)) {
            map.options.zoomDelta = parseFloat(map.options.zoomDelta);
        }
        if (isFinite(map.options.zoomSnap)) {
            map.options.zoomSnap = parseFloat(map.options.zoomSnap);
        }
        if (isFinite(map.options.wheelPxPerZoomLevel)) {
            map.options.wheelPxPerZoomLevel = parseInt(map.options.wheelPxPerZoomLevel, 10);
        }
    }

    function initRoutingContext(map) {
        map._routingContext = new RoutingContext();
    }

    function cleanUp(map) {
        map._localeService.cleanEvents();
        map._geopolViewService.cleanEvents();
    }

    function installUnitServiceSupport(map) {
        map._unitService = new UnitService(globalUnitService);
    }

    function installLocaleServiceSupport(map) {
        map._localeService = new LocaleService(globalLocaleService);
        map._localeService.on(L.LocaleService.Events.LOCALE_CHANGED, mapLocaleChangedHandler.bind(map));
        map._localeService.setCurrentLocale(map.options.language);
        map.options.language = map._localeService.getCurrentLocale().getLanguageCode();
    }

    function installGeopolViewServiceSupport(map) {
        map._geopolViewService = new GeopolViewService(globalGeopolViewService);
        map._geopolViewService.on(L.GeopolViewService.Events.GEOPOL_VIEW_CHANGED, mapGeopolViewChangedHandler.bind(map));
        if (map.options.geopolView) {
            map._geopolViewService.setCurrentGeopolView(map.options.geopolView);
        }
    }

    function initHook() {
        var map = this,
            attributionMarkup = '',
            originalAddAttribution;
        L.Icon.Default.imagePath = imagePath.get(this);
        installUnitServiceSupport(map);
        installLocaleServiceSupport(map);
        installGeopolViewServiceSupport(map);
        try {
            resolveMapboxSupport(map);
            security.setKey(map.options.key);
            initZoomConfig(map);
            initBaseLayer(map);
            initLabelsLayers(map);
            initTrafficFlowLayer(map);
            initTrafficLayer(map);
            initRoutingContext(map);
            initZoomFix(map);

            if (map.getZoom() === undefined) {
                map.setView([0, 0], 2);
            }
            if (!map.options.maxBounds) {
                map.setMaxBounds(L.latLngBounds([[-90, -18000], [90, 18000]]));
            }
            copyrightCaption().go(function (attribution) {
                if (map.attributionControl) {
                    originalAddAttribution = map.attributionControl.addAttribution;
                    map.attributionControl.addAttribution = function () {
                        originalAddAttribution.apply(this, arguments);
                        copyright.updateEventHandler(map);
                    };

                    attributionMarkup += '<a class="tomtomAttribution">';
                    attributionMarkup += attribution;
                    attributionMarkup += '</a>';
                    map.attributionControl.addAttribution(attributionMarkup);
                    map.fire(L.Map.Events.ATTRIBUTION_LOAD_END, { data: attributionMarkup });
                }
            });
        } catch (err) {
            console.error(err);
            cleanUp(map);
            throw err;
        }
    }

    L.Map.addInitHook(initHook);

    return L;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(32)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, Locale) {
    'use strict';

    var trafficIncidentsLanguageMapping, routingGuidanceLanguageMapping;

    function isFunction(fun) {
        return typeof fun === 'function';
    }

    function isArray(array) {
        if (!array) {
            return false;
        }
        return array.constructor.toString().indexOf('Array') > -1;
    }

    function isLatLon(latlon) {
        return latlon.hasOwnProperty('lat') && (latlon.hasOwnProperty('lon') || latlon.hasOwnProperty('lng'));
    }

    function or(first, second) {
        if (first === undefined) {
            return second;
        }
        return first;
    }

    function signOfNumber(val) {
        return val < 0 ? -1 : 1;
    }

    function throwTypeErrorWhen(condition, message) {
        if (condition) {
            throw new TypeError(message);
        }
    }

    function normalizeLatitude(latitude) {
        var numLatitude = parseFloat(latitude);
        var i;
        if (!isFinite(numLatitude)) {
            throw new TypeError('an number is expected, but ' + latitude + ' [' + (typeof latitude === 'undefined' ? 'undefined' : _typeof(latitude)) + '] given');
        }
        if (numLatitude < -90 || numLatitude > 90) {
            i = Math.ceil(Math.abs(numLatitude) / 180);
            return numLatitude - signOfNumber(numLatitude) * 180 * i;
        }
        return numLatitude;
    }

    function normalizeLongitude(longitude) {
        var numLongitude = parseFloat(longitude);
        var i;
        if (!isFinite(numLongitude)) {
            throw new TypeError('an number is expected, but ' + longitude + ' [' + (typeof longitude === 'undefined' ? 'undefined' : _typeof(longitude)) + '] given');
        }
        if (numLongitude < -180 || numLongitude > 180) {
            i = Math.ceil(Math.abs(numLongitude) / 360);
            return numLongitude - signOfNumber(numLongitude) * 360 * i;
        }
        return numLongitude;
    }

    function isXY(xy) {
        return xy.hasOwnProperty('x') && xy.hasOwnProperty('y');
    }

    function isLatitudeLongitude(value) {
        return value.hasOwnProperty('latitude') && value.hasOwnProperty('longitude');
    }

    function isLatLonFunction(value) {
        return isFunction(value.lat) && isFunction(value.lng);
    }

    function castPoint(value) {
        var match;
        if (isArray(value) && value.length === 2) {
            return value;
        }
        if (utils.isString(value)) {
            match = value.match(utils.pointRegex);
            throwTypeErrorWhen(!match || !match[1] || !match[2], 'A point is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
            return [match[1], match[2]];
        }
        if (isLatLonFunction(value)) {
            return [value.lat(), value.lng()];
        }
        if (isLatLon(value)) {
            return [value.lat, or(value.lon, value.lng)];
        }
        if (isXY(value)) {
            return [value.y, value.x];
        }
        if (isLatitudeLongitude(value)) {
            return [value.latitude, value.longitude];
        }
        throw new TypeError('A point is expected, but ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] given');
    }

    function isLatLonBBox(bbox) {
        return bbox.hasOwnProperty('minLon') && bbox.hasOwnProperty('minLat') && bbox.hasOwnProperty('maxLon') && bbox.hasOwnProperty('maxLat');
    }

    function isRightLeftTopBottomBBox(bbox) {
        return bbox.hasOwnProperty('left') && bbox.hasOwnProperty('bottom') && bbox.hasOwnProperty('right') && bbox.hasOwnProperty('top');
    }

    function isWestEastNorthSouthBBox(bbox) {
        return isFunction(bbox.getWest) && isFunction(bbox.getEast) && isFunction(bbox.getSouth) && isFunction(bbox.getNorth);
    }

    function castBoundingBox(bbox) {
        var sw, ne;
        if (isLatLonBBox(bbox)) {
            return bbox;
        }
        if (isRightLeftTopBottomBBox(bbox)) {
            return { minLon: bbox.left, minLat: bbox.bottom, maxLon: bbox.right, maxLat: bbox.top };
        }
        if (isWestEastNorthSouthBBox(bbox)) {
            return { minLon: bbox.getWest(), minLat: bbox.getSouth(), maxLon: bbox.getEast(), maxLat: bbox.getNorth() };
        }
        if (isFunction(bbox.getNorthEast) && isFunction(bbox.getSouthWest)) {
            ne = castPoint(bbox.getNorthEast());
            sw = castPoint(bbox.getSouthWest());
            return { minLon: sw[1], minLat: sw[0], maxLon: ne[1], maxLat: ne[0] };
        }
        if (isArray(bbox) && bbox.length === 4) {
            return { minLon: bbox[0], minLat: bbox[1], maxLon: bbox[2], maxLat: bbox[3] };
        }
        if (isArray(bbox) && bbox.length === 2) {
            sw = castPoint(bbox[0]);
            ne = castPoint(bbox[1]);
            return { minLon: sw[1], minLat: sw[0], maxLon: ne[1], maxLat: ne[0] };
        }
        if (utils.isString(bbox)) {
            bbox = bbox.trim().split(/\s*,\s*/);
            if (bbox.length === 4) {
                return {
                    minLon: parseFloat(bbox[0]),
                    minLat: parseFloat(bbox[1]),
                    maxLon: parseFloat(bbox[2]),
                    maxLat: parseFloat(bbox[3])
                };
            }
        }
        throw new TypeError('Unable to cast ' + bbox + ' [' + (typeof bbox === 'undefined' ? 'undefined' : _typeof(bbox)) + '] to bounding box');
    }

    function normalizeBoundingBox(bbox) {
        var w = bbox.minLon,
            e = bbox.maxLon,
            s = bbox.minLat,
            n = bbox.maxLat,
            right,
            left;
        if (e - w > 360) {
            e = 180;
            w = -180;
        } else {
            if (e > 270) {
                right = Math.ceil(w / 360);
                e -= 360 * right;
                w -= 360 * right;
            }
            if (w < -270) {
                left = Math.ceil(-e / 360);
                e += 360 * left;
                w += 360 * left;
            }
        }
        s = s < -90 ? -90 : s;
        n = n > 90 ? 90 : n;
        return { minLon: w, minLat: s, maxLon: e, maxLat: n };
    }

    trafficIncidentsLanguageMapping = {
        'ca': ['ca', 'cat', 'ca-fr', 'ca_fr', 'ca-es', 'ca_es', 'catalan'],
        'cs': ['cs', 'cze', 'cs-cz', 'cs_cz', 'czech'],
        'da': ['da', 'dan', 'da-dk', 'da_dk', 'danish'],
        'de': ['de', 'ger', 'de-de', 'de_de', 'german'],
        'en': ['en', 'eng', 'en-gb', 'en_gb', 'english', 'us', 'ame', 'en-us', 'en_us', 'english US', 'default'],
        'es': ['es', 'spa', 'es-es', 'es_es', 'spanish', 'mx', 'spm', 'es-mx', 'es_mx', 'spanish MX'],
        'fi': ['fi', 'fin', 'fi-fi', 'fi_fi', 'finnish'],
        'fr': ['fr', 'fre', 'fr-fr', 'fr_fr', 'french'],
        'hu': ['hu', 'hun', 'hu-hu', 'hu_hu', 'hungarian'],
        'it': ['it', 'ita', 'it-it', 'it_it', 'italian'],
        'nl': ['nl', 'dut', 'nl-nl', 'nl_nl', 'dutch'],
        'no': ['no', 'nor', 'no-no', 'no_no', 'norwegian'],
        'pl': ['pl', 'pol', 'pl-pl', 'pl_pl', 'polish'],
        'pt': ['br', 'por', 'pt-br', 'pt_br', 'portuguese', 'pt', 'pob', 'pt-pt', 'pt_pt', 'portuguese BR'],
        'sk': ['sk', 'slo', 'sk-sk', 'sk_sk', 'slovak'],
        'sv': ['sv', 'swe', 'sv-se', 'sv_se', 'swedish'],
        'tr': ['tr', 'tur', 'tr-tr', 'tr_tr', 'turkish'],
        'defaultValue': 'en'
    };
    routingGuidanceLanguageMapping = {
        'ar': ['ar', 'ara', 'ar-ar', 'ar_ar', 'arabic'],
        'af-ZA': ['af', 'afr', 'af-za', 'af_za', 'afrikaans'],
        'bg-BG': ['bg', 'bul', 'bg-bg', 'bg_bg', 'bulgarian'],
        'zh-TW': ['zh', 'chi', 'zh-tw', 'zh_tw', 'chinese'],
        'cs-CZ': ['cs', 'cz', 'cze', 'cs-cz', 'cs_cz', 'czech'],
        'da-DK': ['da', 'dan', 'da-dk', 'da_dk', 'danish'],
        'nl-NL': ['nl', 'dut', 'nl-nl', 'nl_nl', 'dutch'],
        'en-GB': ['en', 'eng', 'en-gb', 'en_gb', 'english', 'default'],
        'en-US': ['us', 'ame', 'en-us', 'en_us', 'english US'],
        'fi-FI': ['fi', 'fin', 'fi-fi', 'fi_fi', 'finnish'],
        'fr-FR': ['fr', 'fre', 'fr-fr', 'fr_fr', 'french'],
        'de-DE': ['de', 'ger', 'de-de', 'de_de', 'german'],
        'el-GR': ['el', 'gre', 'el-gr', 'el_gr', 'greek'],
        'hu-HU': ['hu', 'hun', 'hu-hu', 'hu_hu', 'hungarian'],
        'id-ID': ['id', 'ind', 'id-id', 'id_id', 'indonesian'],
        'it-IT': ['it', 'ita', 'it-it', 'it_it', 'italian'],
        'ko-KR': ['ko', 'kor', 'ko-kr', 'ko_kr', 'korean'],
        'lt-LT': ['lt', 'lit', 'lt-lt', 'lt_lt', 'lithuanian'],
        'ms-MY': ['ms', 'mal', 'ms-my', 'ms_my', 'malay'],
        'nb-NO': ['nb', 'nor', 'nb-no', 'nb_no', 'norwegian'],
        'pl-PL': ['pl', 'pol', 'pl-pl', 'pl_pl', 'polish'],
        'pt-BR': ['br', 'por', 'pt-br', 'pt_br', 'portuguese'],
        'pt-PT': ['pt', 'pob', 'pt-pt', 'pt_pt', 'portuguese BR'],
        'ru-RU': ['ru', 'rus', 'ru-ru', 'ru_ru', 'russian'],
        'sk-SK': ['sk', 'slo', 'sk-sk', 'sk_sk', 'slovak'],
        'sl-SI': ['sl', 'slv', 'sl-si', 'sl_si', 'slovenian'],
        'es-ES': ['es', 'spa', 'es-es', 'es_es', 'spanish'],
        'es-MX': ['mx', 'spm', 'es-mx', 'es_mx', 'spanish MX'],
        'sv-SE': ['sv', 'swe', 'sv-se', 'sv_se', 'swedish'],
        'th-TH': ['th', 'tha', 'th-th', 'th_th', 'thai'],
        'tr-TR': ['tr', 'tur', 'tr-tr', 'tr_tr', 'turkish'],
        'defaultValue': 'en-GB'
    };

    function circleFromString(value) {
        var lat, lon, radius;
        var match = value.match(utils.circleRegex);
        throwTypeErrorWhen(!match || !match[1] || !match[2] || !match[3], 'Unable to cast ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] to circle');

        lat = parseFloat(match[1]);
        lon = parseFloat(match[2]);
        radius = parseFloat(match[3]);
        throwTypeErrorWhen(!isFinite(lat) || !isFinite(lon), 'Unable to cast ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] to circle');

        return 'circle(' + lat + ',' + lon + ',' + radius + ')';
    }

    function castAndNormalizePoint(value) {
        var point = castPoint(value);
        return normalizeLatitude(point[0]) + ',' + normalizeLongitude(point[1]);
    }

    function convertPointOrCircle(value) {
        if (utils.isString(value) && value.indexOf('circle') > -1) {
            return circleFromString(value);
        }
        if (isArray(value) && value.length === 3) {
            return 'circle(' + normalizeLatitude(value[0]) + ',' + normalizeLongitude(value[1]) + ',' + value[2] + ')';
        }
        return castAndNormalizePoint(value);
    }

    function extractPointsFromPolygon(inputPoints) {
        var points = [],
            point;
        for (point in inputPoints) {
            if (inputPoints.hasOwnProperty(point)) {
                points.push(castAndNormalizePoint(inputPoints[point]));
            }
        }
        return points;
    }

    function convertPointToLatitudeLongitude(point) {
        var splitPoint;

        if (typeof point !== 'string') {
            return point;
        }

        splitPoint = point.split(',');

        return {
            latitude: splitPoint[0],
            longitude: splitPoint[1]
        };
    }

    function prepareSupportingPoints(supportingPoints) {
        return supportingPoints.map(convertPointToLatitudeLongitude);
    }

    return {
        boundingBox: function boundingBox(value) {
            return normalizeBoundingBox(castBoundingBox(value));
        },

        longitude: function longitude(value) {
            return normalizeLongitude(value);
        },

        latitude: function latitude(value) {
            return normalizeLatitude(value);
        },

        point: function point(value) {
            return castAndNormalizePoint(value);
        },

        dateTime: function dateTime(value) {
            if (value && value instanceof Date) {
                return value.toISOString();
            }

            if (!value || !utils.isString(value)) {
                throw new TypeError('Unable to cast ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] to datetime value.');
            }
            if (value !== 'now') {
                value = value.replace(/([0-9]{2})-([0-9]{2})-([0-9]{2})/, '$1/$2/$3');
                value = value.replace(/([0-9])T([0-9])/, '$1 $2');
                value = new Date(value).toISOString();
            }
            return value;
        },

        geometryList: function geometryList(value) {
            var figureName, figure;
            throwTypeErrorWhen(!value || !isArray(value), 'Unable to cast ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] to geometry list (array)');

            for (figureName in value) {
                if (value.hasOwnProperty(figureName)) {
                    figure = value[figureName];
                    if (figure.type === 'POLYGON') {
                        figure.vertices = extractPointsFromPolygon(figure.vertices);
                    } else if (figure.type === 'CIRCLE') {
                        figure.position = castAndNormalizePoint(figure.position);
                    }
                }
            }
            return value;
        },

        language: function language(value, options) {
            var locale;
            if (options && options.data && options.data.__serviceType) {
                locale = new Locale(value);
                return locale.getValueFor(options.data.__serviceType);
            }
            return value;
        },

        routingGuidanceLanguage: function routingGuidanceLanguage(value) {
            var language;
            value = value.toLowerCase();
            for (language in routingGuidanceLanguageMapping) {
                // if language is found in one of properties array
                if (routingGuidanceLanguageMapping.hasOwnProperty(language) && routingGuidanceLanguageMapping[language].indexOf(value) > -1) {
                    return language;
                }
            }
            return routingGuidanceLanguageMapping.defaultValue;
        },

        trafficIncidentsLanguage: function trafficIncidentsLanguage(value) {
            var language;
            value = value.toLowerCase();
            for (language in trafficIncidentsLanguageMapping) {
                // if language is found in one of properties array
                if (trafficIncidentsLanguageMapping.hasOwnProperty(language) && trafficIncidentsLanguageMapping[language].indexOf(value) > -1) {
                    return language;
                }
            }
            return trafficIncidentsLanguageMapping.defaultValue;
        },

        routingLocations: function routingLocations(value) {
            var response = [],
                i;
            if (utils.isString(value)) {
                return value;
            }
            if (isArray(value)) {
                throwTypeErrorWhen(value.length < 2, 'Unable to cast ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] to routing locations string');

                // Convert first element to point
                response.push(castAndNormalizePoint(value[0]));

                // Convert elements from 1 to length-2 to point or circle
                for (i = 1; i < value.length - 1; i += 1) {
                    response.push(convertPointOrCircle(value[i]));
                }

                // Convert last element (length-1) to point
                response.push(castAndNormalizePoint(value[value.length - 1]));

                // Join converted elements
                return response.join(':');
            }
            throw new TypeError('Unable to cast ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] to routing locations string');
        },

        roadUse: function roadUse(value) {
            var i;
            if (utils.isString(value)) {
                return '["' + value.replace(/["']|^\s+|\s+$/g, '').split(/[\s,]+/).join('","') + '"]';
            }
            if (isArray(value)) {
                for (i = 0; i < value.length; i += 1) {
                    value[i] = String(value[i]).replace(/["']|^\s+|\s+$/g, '');
                }
                return '["' + value.join('","') + '"]';
            }
            throw new TypeError('Unable to cast ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] to road use string');
        },

        arrayOf: function arrayOf(options) {
            return function (values) {
                var optionName,
                    setDefaultValueHandler = function setDefaultValueHandler(key, defaultValue) {
                    return function (object) {
                        if (!object.hasOwnProperty(key)) {
                            object[key] = defaultValue;
                        }
                    };
                };
                for (optionName in options) {
                    if (options.hasOwnProperty(optionName) && options[optionName].hasOwnProperty('defaultValue')) {
                        values.forEach(setDefaultValueHandler(optionName, options[optionName].defaultValue));
                    }
                }

                values.forEach(function (value) {
                    var key;
                    for (key in value) {
                        if (value.hasOwnProperty(key) && options.hasOwnProperty(key) && typeof options[key].converter === 'function') {

                            value[key] = options[key].converter(value[key]);
                        }
                    }
                });
                return values;
            };
        },

        objectOf: function objectOf(options) {
            return function (value) {
                var key;
                for (key in value) {
                    if (value.hasOwnProperty(key) && options.hasOwnProperty(key) && typeof options[key].converter === 'function') {

                        value[key] = options[key].converter(value[key]);
                    }
                }
                return value;
            };
        },

        arrayOfStrings: function arrayOfStrings(value) {
            if (!value) {
                return [];
            }
            if (utils.isString(value)) {
                value = value.trim().replace(/\s*[,;]\s*/g, ',');
                return value.split(/[,;]+/);
            }
            if (isArray(value)) {
                return value;
            }
            throw new TypeError('Unable to cast ' + value + ' [' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '] to array of strings');
        },

        route: function route(values) {
            return {
                points: values.map(castPoint).map(function (point) {
                    return {
                        lat: point[0],
                        lon: point[1]
                    };
                })
            };
        },

        queryString: function queryString(query) {
            return utils.encodeQuery(query);
        },
        integer: function integer(value) {
            return Math.round(Number(value));
        },

        supportingPoints: function supportingPoints(value) {
            var arrayOfPoints = [],
                i;
            if (utils.isString(value)) {
                value = value.split(':');
            }
            if (isArray(value)) {

                // Convert elements to points
                for (i = 0; i < value.length; i++) {
                    arrayOfPoints.push(castAndNormalizePoint(value[i]));
                }
            } else {
                arrayOfPoints.push(castAndNormalizePoint(value));
            }
            return prepareSupportingPoints(arrayOfPoints);
        },
        constantSpeedConsumption: function constantSpeedConsumption(value) {
            if (typeof value === 'string') {
                return value;
            }

            if (!isArray(value)) {
                throw new TypeError('An array is required');
            }
            return value.join(':');
        },
        avoidAreas: function avoidAreas(value) {
            if (!isArray(value)) {
                throw new TypeError('An array is required');
            }
            return {
                rectangles: value.map(function (area) {
                    return {
                        southWestCorner: convertPointToLatitudeLongitude(castAndNormalizePoint(area.southWestCorner)),
                        northEastCorner: convertPointToLatitudeLongitude(castAndNormalizePoint(area.northEastCorner))
                    };
                })
            };
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
    'use strict';
    /**
     * Name of the default key to be used.
     * @type {String}
     */

    var generalKey = '*';
    var keys = {};

    function checkStringType(parameter, message) {
        if (!Utils.isString(parameter)) {
            throw new TypeError(message);
        }
    }

    return {
        /**
         * Sets key from the 'config' object in security configuration file.
         * @example
         *  security.setKey('keyValue');  // sets global key
         *  security.setKey('service/traffic', 'keyValue'); // sets key for traffic service
         *
         * @method setKey
         * @param {String} name Name of the key to be set
         * @param {String} [value] Value of the key
         */
        setKey: function setKey(name, value) {
            if (arguments.length === 1) {
                value = name;
                name = generalKey;
            }
            if (!value) {
                return;
            }
            checkStringType(name, 'Module name needs to be of type string');
            checkStringType(value, 'API key needs to be of type string');
            keys[name] = value;
        },

        /**
         * Clears keys, this method is meant to be used internally and should not be exposed
         * @example
         *  security._clearKeys();
         *
         * @method _clearKeys
         */
        _clearKeys: function _clearKeys() {
            keys = {};
        },

        /**
         * Returns function to sets key from the 'config' object in security configuration file with predefined module
         * name.
         * @example
         *  var setKey = security.setKeyForName('service/traffic');
         *  setKey('keyValue'); // sets key for traffic service
         *
         * @method setKeyForName
         * @param {String} name Name of the module
         * @return {Function} function that sets key for given module
         */
        setKeyForName: function setKeyForName(name) {
            checkStringType(name, 'Module name needs to be of type string');
            return function (value) {
                checkStringType(value, 'API key needs to be of type string');
                keys[name] = value;
            };
        },

        /**
         * Gets key's value from the "config" object in security configuration file.
         * Returns key value associated with type of given service - if exists - or generalKey otherwise.
         * @example
         *  security.getKey(this); // when used within service context
         *  security.getKey("generalKey");  // when used in other context
         *
         * @method getKey
         * @param {String} name Module name means name of the key
         * @return {String}
         */
        getKey: function getKey(name) {
            if (name) {
                checkStringType(name, 'Module name needs to be of type string');
            }
            return keys[name] || keys[generalKey] || null;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */


var mainConfig = __webpack_require__(18);

module.exports = {
    //copyrights
    'copyrightsWorld': mainConfig['endpoints.copyrightsWorld'],
    'copyrightsBounds': mainConfig['endpoints.copyrightsBounds'],
    'caption': mainConfig['endpoints.caption'],

    //search
    'geocode': mainConfig['endpoints.geocode'],
    'batchGeocodeQuery': mainConfig['endpoints.batchGeocodeQuery'],
    'structuredGeocode': mainConfig['endpoints.structuredGeocode'],
    'batchStructuredGeocodeQuery': mainConfig['endpoints.batchStructuredGeocodeQuery'],
    'search': mainConfig['endpoints.search'],
    'batchSearch': mainConfig['endpoints.batchSearch'],
    'batchSyncSearch': mainConfig['endpoints.batchSyncSearch'],
    'batchSearchQuery': mainConfig['endpoints.batchSearchQuery'],
    'adp': mainConfig['endpoints.adp'],
    'reverseGeocode': mainConfig['endpoints.reverseGeocode'],
    'batchReverseGeocodeQuery': mainConfig['endpoints.batchReverseGeocodeQuery'],

    //traffic
    'trafficIncidents': mainConfig['endpoints.trafficIncidents'],
    'trafficViewport': mainConfig['endpoints.trafficViewport'],
    'flowSegmentData': mainConfig['endpoints.flowSegmentData'],
    'incidentRegions': mainConfig['endpoints.incidentRegions'],

    //layers
    'trafficLayer': mainConfig['endpoints.trafficLayer'],
    'trafficFlowLayer': mainConfig['endpoints.trafficFlowLayer'],
    'tileLayer': mainConfig['endpoints.tileLayer'],

    //routing
    'routing': mainConfig['endpoints.routing'],
    'reachableRange': mainConfig['endpoints.reachableRange'],
    'batchRoutingQuery': mainConfig['endpoints.batchRoutingQuery'],
    'batchRouting': mainConfig['endpoints.batchRouting'],
    'batchSyncRouting': mainConfig['endpoints.batchSyncRouting'],
    'matrixRouting': mainConfig['endpoints.matrixRouting'],
    'matrixSyncRouting': mainConfig['endpoints.matrixSyncRouting'],
    'batchReachableRangeQuery': mainConfig['endpoints.batchReachableRangeQuery'],

    //origin
    'origin': mainConfig.origin
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return {
        POST: 'POST',
        PATH: 'PATH',
        QUERY: 'QUERY',
        OTHER: 'OTHER'
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This module has two utilities:
 *
 * This module create getters and setters for every property of the object passed as first argument and also
 * implement the "go" method which executed an arbitrary function passing all the property values.
 *
 * To create the getters and setters the first argument of the constructor should be an object with the
 * following accepted properties:
 *
 *  - name: String Custom name of the property. If isn't define the name of the property will be used.
 *  - validator: Function(value) If the value isn't valid this function should throw an Error,
 *      otherwise it should return the value validated
 *  - defaultValue: Function() This function have to return the default value
 *  - converter: Function(value) The returned value of this function will be used
 *
 * This is an example of configurations this module could take:
 * @example
 * ```js
 * var properties = {
 *   city: {
 *     name: 'bestCity',
 *     validator: function (name) {
 *       if (typeof name !== 'string' || name.length === 0) throw new Error('City name is not valid');
 *       return name;
 *     },
 *     converter: function (name) {
 *       return name.toLowerCase();
 *     },
 *     defaultValue: function() {
 *       return 'Lodz';
 *     }
 *   }
 * }
 * var config = require('chain')(properties);
 * config.city(); // prints "lodz"
 * config.city('Torun'); // prints "torun"
 * config.city(); // prints "torun"
 * ```
 *
 * Take notice the converter function is always executed, even for the default value.
 *
 * As second argument a function will be expected and this function will be executed using the "go" method
 * returned by this constructor.
 * The additional functions returned by this constructor are: "go", "callback" and "fail".
 *
 * The "go" function will execute the function passed as second argument of the constructor which should
 * implement the next signature: goFunction(properties, callback) .
 *
 * Is expected that the "goFunction" will call the callback function available in the second argument which is the same
 * function defined in fields.callback or the first argument passed to the "go" function.
 *
 * The "go" method can receive two callback arguments: "success" and "fail" which will override the initial callbacks
 * defined during the creation and will be continue to be used in the next execution of the "go" function.
 *
 * If a callback is not provided nor in the fields.callback or as first argument of the "go" call,
 * then the "go" function will return a Promise, otherwise this function will return undefined.
 *
 * @example
 * ```js
 * var properties = {
 *   city: {},
 *   country: {}
 * }
 * var defaults = {city: 'Lima', country: 'Peru'};
 * function sendToBackend(properties, callback) {
 *   // Ajax call sending the properties
 *   // ...
 *   callback("OK");
 * }
 * function onSuccess() {};
 * function onfail() {};
 *
 * var config = require('chain')(properties, sendToBackend, defaults);
 *
 * // Calling "go" passing callbacks
 * config.go(onSuccess, onfail);
 *
 * // Calling go and receive a Promise
 * config.go()
 *   .then(onSuccess)
 *   .catch(onFail);
 * ```
 *
 * Do you think this was difficult to read? Believe me, the most difficult was to write it.
 * @private
 * @class Chain
 * @module Services
 * @constructor
 * @param {Object}   fields
 * @param {Function} fields.callback Default callback function to be executed by "goFunction" function
 * @param {Function} fields.fail Default fail function callback to be executed by "goFunction" function
 * @param {Function} [goFunction] Should have the signature: function(properties, callback): Promise|undefined
 * @param {Object}   [options] Object with the initial values for the properties defined in the "fields" argument
 * @param {Function} [options.fail] Failsafe "fail" function to be executed by "goFunction" callback argument.
 *                                  It will override "fields.fail" (yeah, don't ask me why)
 */

/**
 * Executes a predefined asynchronous task using the current configuration and then execute one of
 * the callback functions based on the success of the result.
 *
 * It receives two optional arguments. The first one is a callback function that will be used when
 * the task is successfully completed. The second one is another callback function
 * that will be used only in case of failure.
 *
 * Both arguments are shortcuts for the <b>callback</b> and <b>fail</b> methods respectively.
 *
 * @example
 * All the ways of using this method:
 * ```js
 * // Defining callbacks as function arguments
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .go(successCallback, failureCallback);
 *
 * // Defining callbacks using setters methods
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .callback(successCallback)
 *   .fail(failureCallback)
 *   .go();
 *
 * // Using the returned Promise
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .go()
 *   .then(successCallback)
 *   .catch(failureCallback);
 * ```
 * The SDK provides a Promise polyfill for browsers (IE<9) without native ECMAScript 6 support.
 *
 * @method go
 * @param {Function} [success] The callback function to be called on case of success
 * @param {Function} [fail] The callback function to be called on case of failure.
 *     If a success callback was not given this argument will be ignored. In that case the returned Promise
 *     should be used to handle the failures.
 * @return {Promise|null} If the success callback is omitted (and wasn't defined one yet) this function
 *     will return a Promise
 */

/**
 * Sets or gets the value of the option `callback`.
 *
 * This callback function will be called only after the <b>go</b> method successfully complete its task.
 *
 * Its first and unique argument passed to the callback will be the result of the request.
 *
 * @example
 * ```js
 * function callbackFn(results) {
 *   console.log(results);
 * }
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .callback(callbackFn)
 *   .go();
 * ```
 *
 * @method callback
 * @chainable
 * @param {Function} [newValue] The new callback function
 * @throws {TypeError} If the given argument is not a function
 * @return {Function} The same service instance or the current callback function if no argument was given
 */

/**
 * Sets or gets the value of the option `fail`.
 *
 * This function is called when an error occurs (e.g. invalid values or a communication error).
 *
 * The callback will receive just one argument which is the error description.
 *
 * This parameter will be ignored if the callback function is not defined and therefore the
 * <b>go</b> method will return a Promise that will be rejected if an error occurs.
 *
 * If you don't specificy a failure callback, the default behavior in case of encounter a problem is to
 * throw an error.
 *
 * @example
 * ```js
 * function successCallback(results) {
 *   console.log(results);
 * }
 * function failureCallback(error) {
 *   console.log(error);
 * }
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .callback(successCallback)
 *   .fail(failureCallback)
 *   .go();
 * ```
 *
 * @method fail
 * @chainable
 * @param {Function} [newValue] The new callback function
 * @throws {TypeError} If the given argument is not a function
 * @return {Function} The same service instance or the current callback function if no argument was given
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(30), __webpack_require__(57), __webpack_require__(33), __webpack_require__(123), __webpack_require__(35), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, globalLocaleService, localeValidator, globalGeopolViewService, geopolViewValidator, GeopolView, parameterApplications) {
    'use strict';

    function checkIsFunction(fun) {
        if (typeof fun !== 'function') {
            throw new TypeError('a function is expected, but ' + fun + ' [' + (typeof fun === 'undefined' ? 'undefined' : _typeof(fun)) + '] given');
        }
        return fun;
    }

    function isUndefined(value) {
        return value === undefined;
    }

    function isFunction(converter) {
        return typeof converter === 'function';
    }

    function chain(data, name, value, validator, converter) {
        var options = {
            data: data,
            name: name
        };

        if (isUndefined(value)) {
            return isUndefined(data[name]) ? null : data[name];
        }
        if (isFunction(converter)) {
            value = converter.call(this, value, options);
        }
        if (isFunction(validator)) {
            value = validator.call(this, value, options);
        }
        data[name] = value;
        return this;
    }

    function checkRequired(fields, data) {
        var field, fieldName;
        for (field in fields) {
            if (fields.hasOwnProperty(field)) {
                fieldName = fields[field].name || field;
                if (fields[field].required === true && !data.hasOwnProperty(fieldName)) {
                    throw new Error('Missing required ' + field);
                }
            }
        }
    }

    function runPostValidators(fields, data) {
        var field;
        var that = this;
        function callValidator(validator) {
            validator.call(that, data[field], data, field);
        }
        for (field in fields) {
            if (fields.hasOwnProperty(field)) {
                if (utils.isArray(fields[field].postValidator)) {
                    fields[field].postValidator.forEach(callValidator);
                } else if (!isUndefined(fields[field].postValidator)) {
                    fields[field].postValidator.call(this, data[field], data, field);
                }
            }
        }
    }

    function createFunction(f, fields, data) {
        return function (value) {
            var fieldName = fields[f].name || f;
            return chain.call(this, data, fieldName, value, fields[f].validator, fields[f].converter);
        };
    }

    function setLanguageIfNeeded(data) {
        var serviceType = data.__serviceType;
        var locale;
        if (!serviceType || data.language && localeValidator(data.language, serviceType)) {
            return;
        }
        locale = globalLocaleService.getCurrentLocale();
        data.language = locale.getValueFor(serviceType);
    }

    function setGeopolViewIfNeeded(data) {
        var geopolView;
        var serviceType = data.__serviceType;
        var supportedServices = GeopolView.getSupportedServices();
        if (!serviceType || supportedServices.indexOf(serviceType) === -1 || data.view && geopolViewValidator(data.view, serviceType)) {
            return;
        }
        geopolView = globalGeopolViewService.getCurrentGeopolView();
        data.view = geopolView.getValueFor(serviceType);
    }

    return function (fields, goFunction, options) {
        var data = {},
            that = this,
            service,
            field;
        options = options || {};
        data.__serviceType = options.__serviceType;
        setLanguageIfNeeded(options);
        setGeopolViewIfNeeded(options);
        fields.callback = {
            validator: checkIsFunction
        };
        fields.fail = {
            validator: checkIsFunction,
            defaultValue: function defaultValue(e) {
                if (utils.isObject(e)) {
                    e = JSON.stringify(e);
                }
                console.error(e || 'Unknown Error');
                throw new Error(e || 'Unknown Error');
            },
            application: parameterApplications.OTHER
        };

        service = {
            go: function go(success, fail) {
                var callback;
                if (success) {
                    data.callback = checkIsFunction(success);
                }
                if (fail) {
                    data.fail = checkIsFunction(fail);
                }
                checkRequired(fields, data);
                runPostValidators(fields, data);
                if (data.callback) {
                    callback = data.callback;
                    delete data.callback;
                    goFunction.call(that, utils.clone(data), callback);
                    return undefined;
                } else {
                    return new Promise(function (resolve, reject) {
                        data.fail = function (error) {
                            reject(error);
                        };
                        goFunction.call(that, utils.clone(data), function (response) {
                            resolve(response);
                        });
                    });
                }
            }
        };

        for (field in fields) {
            if (fields.hasOwnProperty(field)) {
                service[field] = createFunction(field, fields, data);
                if (!isUndefined(fields[field].defaultValue)) {
                    service[field].call(this, fields[field].defaultValue);
                }
                // if options were passed initialize the data
                if (options && options.hasOwnProperty(field)) {
                    service[field].call(this, options[field]);
                }

                if (fields[field].visible === false) {
                    delete service[field];
                }
            }
        }
        if (options && options.fail) {
            data.fail = options.fail;
        }
        return service;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    var names = {
        display: 'services/display',
        vector: 'services/display/vector',
        trafficFlow: 'services/trafficFlow',
        traffic: 'services/traffic',
        search: 'services/search',
        routing: 'services/routing'
    };
    /**
     * Immutable object with the names of the different API keys.
     */
    return Object.freeze(names);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(120), __webpack_require__(121)], __WEBPACK_AMD_DEFINE_RESULT__ = function (batchRequestServiceFactory, singleRequestServiceFactory) {
    return {
        single: singleRequestServiceFactory,
        batch: batchRequestServiceFactory
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(111), __webpack_require__(113)], __WEBPACK_AMD_DEFINE_RESULT__ = function (json, jsonp) {
    'use strict';

    var _useJsonp = false;
    var _useHttp = false;

    return {
        useJsonp: function useJsonp(use) {
            _useJsonp = use;
        },

        useHttp: function useHttp(use) {
            _useHttp = use;
        },

        protocol: function protocol() {
            return _useHttp ? 'http' : 'https';
        },

        get: function get(options) {
            options.protocol = options.protocol || this.protocol();
            return _useJsonp ? jsonp.get(options) : json.get(options);
        },

        post: function post(options) {
            if (_useJsonp) {
                console.warn('Jsonp is not supported, using json request.');
            }
            options.protocol = options.protocol || this.protocol();
            return json.post(options);
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */

function escapeRegExp(input) {
    return input.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&').replace(/\\\{.+?\\\}/g, '.+');
}

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(18)], __WEBPACK_AMD_DEFINE_RESULT__ = function (mainConfig) {
    var productInfo;
    var sdkInfo = mainConfig['analytics.header.sdkName'] + '/' + mainConfig['sdk.version'];
    var headerName = mainConfig['analytics.header.name'];
    var ORIGIN_URL_PATTERN = new RegExp(escapeRegExp(mainConfig.origin));

    return {
        isTomtomOrigin: function isTomtomOrigin(url) {
            return ORIGIN_URL_PATTERN.test(url);
        },
        getHeaderName: function getHeaderName() {
            return headerName;
        },
        getHeaderContent: function getHeaderContent() {
            var prodInfo = productInfo !== undefined ? ' ' + productInfo : '';
            return sdkInfo + prodInfo;
        },

        setProductInfo: function setProductInfo(productId, productVersion) {
            var prodVersion;
            if (!productId) {
                throw new Error('ProductId needs to be set');
            }
            prodVersion = productVersion || productVersion === 0 ? '/' + productVersion : '';
            productInfo = productId + prodVersion;
        },
        getProductInfo: function getProductInfo() {
            return productInfo;
        },
        addAnalyticsHeader: function addAnalyticsHeader(req) {
            req.header(headerName, this.getHeaderContent());
            return req;
        },
        getAnalyticsHeader: function getAnalyticsHeader() {
            var header = {};
            header[headerName] = this.getHeaderContent();
            return header;
        },
        customCreateTile: function customCreateTile(coords, done, layer) {
            var tile = document.createElement('img');
            var tileUrl = layer.getTileUrl(coords);
            var errorTileUrl = layer.options && layer.options.errorTileUrl;

            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        tile.src = URL.createObjectURL(xhr.response); //create <img> with src set to the blob
                    } else if (errorTileUrl) {
                        tile.src = errorTileUrl;
                    }
                    done(null, tile);
                }
            };
            xhr.open('GET', tileUrl, true);
            // don't set responseType before calling open(), this will cause an invalid state error under IE11
            xhr.responseType = 'blob'; //so you can access the response like a normal URL
            xhr.setRequestHeader(this.getHeaderName(), this.getHeaderContent());
            xhr.send();
            if (layer.options.crossOrigin) {
                tile.crossOrigin = '';
            }

            /*
             Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
             http://www.w3.org/TR/WCAG20-TECHS/H67
            */
            tile.alt = '';
            tile.setAttribute('original-src', tileUrl);
            /*
             Set role="presentation" to force screen readers to ignore this
             https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
            */
            tile.setAttribute('role', 'presentation');
            return tile;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    function isArray(a) {
        return a !== undefined && a.constructor.toString().indexOf('Array') > -1;
    }

    function filterArray(result, fields) {
        var i;
        for (i = 0; i < result.length; i += 1) {
            filter(result[i], fields); //eslint-disable-line
        }
    }

    function filterObject(result, fields) {
        var key;
        var filterPrepared = '*' + fields.trim().split(/\s*,\s*/).join('*') + '*';
        for (key in result) {
            if (result.hasOwnProperty(key) && filterPrepared.indexOf('*' + key + '*') < 0) {
                delete result[key];
            }
        }
    }

    function filter(result, fields) {
        if (!fields) {
            return result;
        }
        if (isArray(result)) {
            filterArray(result, fields);
        } else {
            filterObject(result, fields);
        }
        return result;
    }

    function handleArray(array, key) {
        var j;
        var result = [];
        for (j = 0; j < array.length; j += 1) {
            if (array[j][key]) {
                result.push(array[j][key]);
            }
        }
        return result;
    }

    return function (json, path, fields) {
        var i;
        var result = json;
        var pathElements = path.trim().split('.');
        for (i = 0; i < pathElements.length; i += 1) {
            if (!result) {
                return null;
            }
            if (isArray(result)) {
                result = handleArray(result, pathElements[i]);
            } else {
                result = result[pathElements[i]];
            }
        }
        return filter(result, fields);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(62), __webpack_require__(128), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, trafficModelId, security) {
    var DEFAULT_REFRESH_RATE = 30000;
    return {
        add: function add(options, onTrafficUpdateCallback) {
            var refreshRate = DEFAULT_REFRESH_RATE;

            if (utils.isNotNull(options)) {
                if (options._noRefresher) {
                    //This property ensures that the refresher doesn't start, it is used by trafficWithIncidentsLayer
                    //which has it's own timers and we don't want sub-layers to start its own timers
                    return undefined;
                } else if (options.noRefresh) {
                    onTrafficUpdateCallback();
                    return undefined;
                }
                //this ensures that minimal refresh time is 30 seconds
                refreshRate = options.refresh >= DEFAULT_REFRESH_RATE && isFinite(options.refresh) ? options.refresh : DEFAULT_REFRESH_RATE;
            }
            return setInterval(onTrafficUpdateCallback, refreshRate);
        },
        remove: function remove(id) {
            if (id) {
                clearInterval(id);
            }
        },
        addRefresherWithModelId: function addRefresherWithModelId(options, trafficModelIdCallback, context) {
            var effectiveOptions = options ? options : context.options;
            var trafficModelIdService = trafficModelId({ key: security.getKey('services/traffic') });
            function onUpdateCallback() {
                trafficModelIdService.go().then(function (trafficModelId) {
                    trafficModelIdCallback.call(context, trafficModelId);
                });
            }

            if (!effectiveOptions) {
                throw new Error('"options" should be provided');
            }

            if (effectiveOptions._noRefresher) {
                return null;
            }

            onUpdateCallback();
            return this.add(effectiveOptions, onUpdateCallback);
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Static class with util methods to format and convert values from metric to imperial systems.
 *
 * @class UnitFormatConverter
 * @extends L.Evented
 * @module Services
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, globalUnitService) {
    'use strict';

    var UnitFormatConverter;

    /**
     * Event fired when the global measurement unit is changed using the method
     * {{#crossLink "UnitFormatConverter/unitsScheme:method"}}{{/crossLink}}.
     *
     * @event change
     * @param {"metric"|"imperial"} newMeasurementUnit
     */

    /**
     * @ignore
     * @param {String} value Numeric value
     * @return {String}
     */
    function enforceLeadingZero(value) {
        return value < 10 ? '0' + value : value;
    }

    /**
     * Convert a distance in meters to yards.
     * @method convertMetersToYards
     * @param {Number} distanceMeters
     * @return {Number}
     */
    function convertMetersToYards(distanceMeters) {
        return 1.0936133 * distanceMeters;
    }

    /**
     * @ignore
     * @param {Number} distanceMeters
     * @return {Number}
     */
    function convertMetricToMiles(distanceMeters) {
        return 0.000621371192 * distanceMeters;
    }

    /**
     * @ignore
     * @param {Number} distanceMeters
     * @return {String} Distance in miles or yards
     */
    function formatMetricAsImperialDistance(distanceMeters) {
        var yards = convertMetersToYards(distanceMeters),
            miles = convertMetricToMiles(distanceMeters);
        return miles < 1 ? Math.round(yards) + ' yd' : Math.round(miles * 10) / 10 + ' mi';
    }

    /**
     * @ignore
     * @param {Number} distanceMeters
     * @return {String} Distance in kilometers or meters
     */
    function formatAsMetricDistance(distanceMeters) {
        var distance = Math.round(distanceMeters);
        if (distance >= 1000) {
            return Math.round(distance / 100) / 10 + ' km';
        }
        return distance + ' m';
    }

    UnitFormatConverter = L.Evented.extend({
        /**
        * Convert a distance in yards to meters.
         * @method convertYardsToMeters
        * @param {Number} distanceYards Distance in yards
        * @return {Number}
        */
        convertYardsToMeters: function convertYardsToMeters(distanceYards) {
            return Math.round(distanceYards / 1.0936133);
        },

        convertMetersToYards: convertMetersToYards,

        /**
         * Converts the given time in seconds to a string with the the format of 'HH h MM min' or 'MM min SS s'.
         *
         * HH - hours MM - minutes SS - seconds.
         *
         * @method formatTime
         * @param {Number} [seconds] Number of seconds
         * @return {String|undefined} Formatted time
         *
         * @example
         * ```javascript
         * tomtom.unitFormatConverter.formatTime(3600);  / returns 1 h 0 min
         * ```
         */
        formatTime: function formatTime(seconds) {
            var secondsNum, hours, minutes, secondsFormatted, minutesFormatted;
            if (seconds === undefined) {
                return undefined;
            }
            secondsNum = parseInt(seconds, 10);
            hours = Math.floor(secondsNum / 3600);
            minutes = Math.floor((secondsNum - hours * 3600) / 60);
            if (secondsNum < 60) {
                return secondsNum + ' s';
            }
            secondsNum %= 60;
            secondsFormatted = enforceLeadingZero(secondsNum);
            minutes %= 60;
            minutesFormatted = enforceLeadingZero(minutes);
            if (hours > 0) {
                return hours + ':' + minutesFormatted + ' h';
            }
            return minutes + ':' + secondsFormatted + ' min';
        },

        /**
         * Converts a date in the machine format to a more human readable form.
         *
         * Returns a formatted string created from the given date in UTC format.
         *
         * @method formatHourAndMinute
         * @param {String} [dateInMs] Date and time specified in the RFC-3339 format with an optional time zone offset
         * @return {String} Formatted time in hours and minutes
         *
         * @example
         * ```javascript
         * tomtom.unitFormatConverter.formatHourAndMinute('2016-03-01T15:45:58+01:00') // gives '3:45'
         * ```
         */
        formatHourAndMinute: function formatHourAndMinute(dateInMs) {
            var date = new Date(dateInMs);
            var hour = date.getHours(),
                minute = date.getMinutes();
            return hour + ':' + enforceLeadingZero(minute);
        },

        /**
         * Converts distance in meters to a proper display format in SI or imperial units.
         *
         * @method formatDistance
         * @param {Number} distanceMeters Distance in meters
         * @param {Boolean} [imperial=false] Use imperial units
         * @return {String} Aformatted distance
         */
        formatDistance: function formatDistance(distanceMeters, imperial) {
            if (distanceMeters === undefined) {
                return undefined;
            }
            if (imperial) {
                return formatMetricAsImperialDistance(distanceMeters);
            }
            return formatAsMetricDistance(distanceMeters);
        },

        /**
         * Gets ore sets the default units scheme for new widgets and services.
         *
         * @method unitsScheme
         * @param {"imperial"|"metric"} [newUnit] If isn't provided then
         *     this method will only return then current units scheme
         * @return {String} Current units scheme
         * @deprecated Please use <a href="../classes/tomtom.html#method_globalUnitService" class="alert-link">
         * tomtom.globalUnitService()</a> instead.
         */
        unitsScheme: function unitsScheme(newUnit) {
            console.warn('Deprecated. Please use unitService class.');
            if (!newUnit) {
                return globalUnitService.getCurrentUnit().getLabel();
            }

            globalUnitService.setCurrentUnit(newUnit);
            this.fire('change', { newScheme: newUnit });
            return newUnit;
        }
    });

    return new UnitFormatConverter();
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    var unitTypes = {
        metric: 'metric',
        imperial: 'imperial'
    };
    return unitTypes;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Base class for all the Search services.
 *
 * @private
 * @class Search
 * @module Services
 * @uses Chain
 * @uses ProtocolMixin
 * @uses KeyMixin
 * @uses LimitMixin
 * @uses LanguageMixin
 * @uses UnwrapMixin
 *
 * @constructor
 * @param {Object}   [options] Options to be passed to the search call,
 *     or Array of such options objects to perform batch request.
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(92), __webpack_require__(91), __webpack_require__(8), __webpack_require__(2), __webpack_require__(4), __webpack_require__(22), __webpack_require__(0), __webpack_require__(161), __webpack_require__(44), __webpack_require__(162)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restSearch, model, chain, validators, converters, worldEdge, utils, batchModel, searchTypes, searchParams) {
    'use strict';

    var TYPES = {
        search: searchTypes.search,
        poi: searchTypes.poi,
        category: searchTypes.category,
        geometry: searchTypes.geometry,
        nearby: searchTypes.nearby,
        lowBandwidth: searchTypes.lowBandwidth
    },
        fields = searchParams.create();

    var search = restSearch();

    function addBoundingBoxParameters(data, boundingBox) {
        data.topLeft = [boundingBox.maxLat, boundingBox.minLon];
        data.btmRight = [boundingBox.minLat, boundingBox.maxLon];
        return data;
    }

    function callbackBestResult(bestResult, callback) {
        return function (response) {
            callback(bestResult ? response[0] : response);
        };
    }

    function Search(options) {
        this.options = options;
        this.defaultFields = utils.clone(fields);
        this.fields = {};
    }

    Search.prototype.TYPE = TYPES;
    Search.prototype.model = model;
    Search.prototype.construct = function () {
        this.fields = utils.addFields.call(this, this.fields);
        // eslint-disable-next-line vars-on-top
        var batchFields = {
            batchItems: {
                validator: validators.arrayOf(this.fields),
                converter: converters.arrayOf(this.fields)
            }
        };
        this.options = this.options || {};
        this.options.__serviceType = 'search';

        if (Array.isArray(this.options)) {
            return chain.call(this, batchFields, this.handleBatchChain, {
                batchItems: this.options
            });
        } else {
            return chain.call(this, this.fields, this.handleChain, this.options);
        }
    };

    Search.prototype.handleBatchChain = function (data, callback) {
        data.batchItems.forEach(searchParams.modifyRequestOptions);
        search.batch(searchParams.modifyFields(this.fields), data, function (results) {
            callback.call(this, batchModel(results));
        });
    };

    function searchQuery(fields) {
        var modifiedFields = searchParams.modifyFields(fields);
        return function (options, callback) {
            return search.search(modifiedFields, options, callback);
        };
    }

    Search.prototype.handleChain = function (data, callback) {
        searchParams.modifyRequestOptions(data);
        worldEdge(searchQuery(this.fields), this.model, data, callbackBestResult(Boolean(data.bestResult), callback), addBoundingBoxParameters);
    };
    //TODO We should think how to refactor this, code below does some WEIRD trick.
    //Take a look in fuzzySearch.js how it is called - they call just constructor function
    function searchConstructor(options) {
        return new Search(options).construct();
    }

    searchConstructor.prototype.constructor = Search;

    return searchConstructor;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable max-len */

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    var origin = 'api.tomtom.com';
    return {
        'mapboxgl.version': '0.53.0',
        'sdk.version': '4.47.6',
        'analytics.header.name': 'TomTom-User-Agent',
        'analytics.header.sdkName': 'MapsWebSDK',
        'origin': origin,

        // copyrights
        'endpoints.copyrightsWorld': origin + '/map/1/copyrights.{contentType}',
        'endpoints.copyrightsBounds': origin + '/map/1/copyrights/{minLon}/{minLat}/{maxLon}/{maxLat}.{contentType}',
        'endpoints.caption': origin + '/map/1/copyrights/caption.{contentType}',

        // search
        'endpoints.geocode': origin + '/search/2/geocode/{query}.{contentType}',
        'endpoints.batchGeocodeQuery': '/geocode/{query}.{contentType}',
        'endpoints.structuredGeocode': origin + '/search/2/structuredGeocode.{contentType}',
        'endpoints.batchStructuredGeocodeQuery': '/structuredGeocode.{contentType}',
        'endpoints.search': origin + '/search/2/{type}/{query}.{contentType}',
        'endpoints.batchSearch': origin + '/search/2/batch.{contentType}',
        'endpoints.batchSyncSearch': origin + '/search/2/batch/sync.{contentType}',
        'endpoints.batchSearchQuery': '/{type}/{query}.{contentType}',
        'endpoints.adp': origin + '/search/2/additionalData.{contentType}',
        'endpoints.reverseGeocode': origin + '/search/2/{type}/{position}.{contentType}',
        'endpoints.batchReverseGeocodeQuery': '/{type}/{position}.{contentType}',

        // traffic
        'endpoints.trafficIncidents': origin + '/traffic/services/4/incidentDetails/{style}/{minLat},{minLon},{maxLat},{maxLon}/{zoom}/{trafficModelID}/{contentType}',
        'endpoints.trafficViewport': origin + '/traffic/services/4/incidentViewport/0,0,.1,.1/0/0,0,.1,.1/0/false/{contentType}',
        'endpoints.flowSegmentData': origin + '/traffic/services/4/flowSegmentData/{style}/{zoom}/{contentType}',
        'endpoints.incidentRegions': origin + '/traffic/services/4/incidentRegions/{contentType}',

        // layers
        'endpoints.trafficLayer': '{s}.' + origin + '/traffic/map/4/tile/incidents/{style}/{z}/{x}/{y}.png',
        'endpoints.trafficFlowLayer': '{s}.' + origin + '/traffic/map/4/tile/flow/{style}/{z}/{x}/{y}.png',
        'endpoints.tileLayer': '{s}.' + origin + '/map/1/tile/{layer}/{style}/{z}/{x}/{y}.png',

        // routing
        'endpoints.routing': origin + '/routing/1/calculateRoute/{locations}/{contentType}',
        'endpoints.reachableRange': origin + '/routing/1/calculateReachableRange/{origin}/{contentType}',
        'endpoints.batchRouting': origin + '/routing/1/batch/{contentType}',
        'endpoints.batchSyncRouting': origin + '/routing/1/batch/sync/{contentType}',
        'endpoints.batchRoutingQuery': '/calculateRoute/{locations}/{contentType}',
        'endpoints.batchReachableRangeQuery': '/calculateReachableRange/{origin}/{contentType}',
        'endpoints.matrixRouting': origin + '/routing/1/matrix/{contentType}',
        'endpoints.matrixSyncRouting': origin + '/routing/1/matrix/sync/{contentType}',

        //static map image
        'endpoints.staticMapImage': 'https://' + origin + '/map/1/staticimage',

        'vector.glyphs': 'https://' + origin + '/maps-sdk-js/4.47.6/glyphs/{fontstack}/{range}.pbf',
        'vector.sprites': 'https://' + origin + '/maps-sdk-js/4.47.6/sprites/sprite'
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    var ObjectModel = function ObjectModel() {//eslint-disable-line
    };

    ObjectModel.prototype.simplify = function () {
        return Object.assign({}, this);
    };

    return ObjectModel;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * Objects of this class represent Html elements with folding/wraping functionality
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    function Wrapable(htmlElement, wrapFunction) {
        this._htmlElement = htmlElement;
        this._wrapFunction = wrapFunction;
    }

    /**
     * @ignore
     * @return {HtmlElement}
     */
    Wrapable.prototype.getHtmlElement = function () {
        return this._htmlElement;
    };

    /**
     * @ignore
     *  Wraps/folds element
     */
    Wrapable.prototype.wrap = function () {
        this._wrapFunction(this._htmlElement);
    };

    return Wrapable;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Utility class for creating map markers.
 *
 * @class SVGIcon
 * @namespace L
 * @extends L.Icon
 * @module Map
 * @constructor
 * @param {Object} [options]
 * @param {Object} [options.background]
 * @param {Number[]} [options.background.iconSize=[30, 36]]
 * @param {Number[]} [options.background.iconAnchor=[15, 36]]
 * @param {String} [options.background.icon="icon-marker-black"]
 * @param {Boolean} [options.background.noPlainSVG=false]
 * @param {Object} [options.icon]
 * @param {Number[]} [options.icon.iconSize=[30, 30]]
 * @param {Number[]} [options.icon.iconAnchor=[0, 0]]
 * @param {String} [options.icon.icon="icon-flag-white"]
 * @param {Boolean} [options.icon.noPlainSVG=false]
 * @param {Number[]} [options.popupAnchor=[0, -30]]
 * @param {Number} [options.opacity=0.8]
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, Utils) {
    'use strict';

    var defaultOptions;

    function setNodeIconAnchorStyle(options, node) {
        var anchor;
        if (options.iconAnchor) {
            anchor = L.point(options.iconAnchor);
            node.style.marginLeft = -anchor.x + 'px';
            node.style.marginTop = -anchor.y + 'px';
        }
    }

    function setNodeStyleFromStyleOption(options, node) {
        var css;
        for (css in options.style) {
            if (options.style.hasOwnProperty(css)) {
                node.style[css] = options.style[css];
            }
        }
    }
    // TODO: A CSS class name should be used to apply this CSS rules instead of doing it programmatically
    function setNodeStyle(node, options) {
        node.style.width = options.iconSize[0] + 'px';
        node.style.height = options.iconSize[1] + 'px';
        node.style.backgroundSize = options.iconSize[0] + 'px ' + options.iconSize[1] + 'px';
        setNodeIconAnchorStyle(options, node);
        node.style.position = 'absolute';
        node.style.textAlign = 'center';
        node.style.verticalAlign = 'middle';
        node.style.lineHeight = options.iconSize[1] + 'px';
        if (options.style) {
            setNodeStyleFromStyleOption(options, node);
        }
    }

    function extractBackgroundToPlainSVG(node, options) {
        var clonedNode, match, svg;
        clonedNode = node.cloneNode();
        clonedNode.style.display = 'none';
        document.body.appendChild(clonedNode);
        svg = window.getComputedStyle(clonedNode).getPropertyValue('background-image');
        document.body.removeChild(clonedNode);

        if (!svg) {
            return;
        }
        match = svg.match(/(%3Csvg[^"']+%3C%2Fsvg%3E)/i);
        if (!match) {
            return;
        }
        svg = decodeURIComponent(match[1]);
        node.innerHTML = svg;
        node.firstChild.setAttribute('width', options.iconSize[0] + 'px');
        node.firstChild.setAttribute('height', options.iconSize[1] + 'px');
        node.firstChild.setAttribute('style', 'display: block; position: absolute;');
        node.style.backgroundImage = 'none';
    }

    /**
     * @ignore
     * Receive class names as arguments and returns a string with the valid ones.
     * @param   {String[]} classNames  Following jsdoc spec: http://usejsdoc.org/tags-param.html
     * @return  {String}                String with class names
     */
    function concatClassNames(classNames) {
        // eslint-disable-line no-unused-vars
        return classNames.filter(function (className) {
            return Utils.isNonEmptyString(className);
        }).join(' ');
    }

    function createDiv(options, parent, additionalClassName) {
        var classNames = concatClassNames(['icon', options.icon || 'content', additionalClassName]),
            node = L.DomUtil.create('div', classNames, parent);
        setNodeStyle(node, options);
        if (options.icon && !options.noPlainSVG) {
            extractBackgroundToPlainSVG(node, options, options.icon);
        }
        if (options.content) {
            node.innerHTML = options.content;
        }
        return node;
    }

    function createImg(options, parent) {
        var node = L.DomUtil.create('div', 'icon-image', parent),
            img = L.DomUtil.create('img', 'icon-image-img', node);
        img.style.width = options.iconSize[0] + 'px';
        img.style.height = options.iconSize[1] + 'px';
        if (/^http/i.test(options.icon)) {
            img.src = options.icon;
        } else {
            img.src = L.Icon.Default.imagePath + '/' + options.icon;
        }
        setNodeStyle(node, options);
        return node;
    }

    function isFile(name) {
        return (/\.(gif|jpg|jpeg|tiff|png|svg)$/i.test(name)
        );
    }

    function createNode(options, parent, additionalClassName) {
        if (L.Browser.svg && !isFile(options.icon)) {
            return createDiv(options, parent, additionalClassName);
        }
        return createImg(options, parent);
    }

    defaultOptions = {
        background: {
            iconSize: [30, 36],
            iconAnchor: [15, 36],
            icon: 'icon-marker-black',
            noPlainSVG: false
        },
        icon: {
            iconSize: [30, 30],
            iconAnchor: [0, 0],
            icon: 'icon-flag-white',
            noPlainSVG: false
        },
        popupAnchor: [0, -30],
        opacity: 0.8
    };

    function mergeOptions(result, source, option) {
        if (source.hasOwnProperty(option)) {
            result[option] = source[option] ? L.extend({}, defaultOptions[option], source[option]) : null;
        }
    }

    /**
     * @ignore
     *   options: {
     *       background: {
     *           iconSize: L.Browser.retina ? [50, 60] : [30, 36],
     *           iconAnchor: L.Browser.retina ? [25, 60] : [15, 36],
     *           icon: 'marker',
     *           noPlainSVG: false
     *       },
     *       icon: {
     *           iconSize: L.Browser.retina ? [50, 50] : [30, 30],
     *           iconAnchor: [0, 0],
     *           icon: 'flag-white',
     *           noPlainSVG: false
     *       },
     *       content: {
     *           iconSize: [30, 30],
     *           iconAnchor: [0, 0],
     *           content: '',
     *           noPlainSVG: true,
     *           style: {
     *               'color': '#fff',
     *               'font-weight': 'bold',
     *               'font-size': '20px'
     *           }
     *       }
     *       popupAnchor: L.Browser.retina ? [0, -50] : [0, -30],
     *       opacity: 0.8
     */

    L.SVGIcon = L.Icon.extend({
        initialize: function initialize(options) {
            this.options = L.Util.extend({}, defaultOptions, options);
            if (!options) {
                return;
            }
            mergeOptions(this.options, options, 'background');
            mergeOptions(this.options, options, 'icon');
        },

        createIcon: function createIcon() {
            var options = this.options;
            this.container = createNode(options.background || options.icon, null, 'icon-marker');
            if (options.background && options.icon && options.icon.icon) {
                createNode(options.icon, this.container, null);
            }
            if (options.content) {
                this.contentContainer = createDiv(options.content, this.container, null);
            }
            L.DomUtil.setOpacity(this.container, options.opacity);
            return this.container;
        },

        /**
         * Sets the HTML content of the marker.
         * @method setContent
         * @param {String} content Valid HTML string
         */
        setContent: function setContent(content) {
            if (this.contentContainer) {
                this.contentContainer.innerHTML = content;
            }
        },

        /**
         * Changes the opacity of the marker.
         * @method setOpacity
         * @param {Number} opacity Number between 0 and 1
         */
        setOpacity: function setOpacity(opacity) {
            this.options.opacity = opacity;
            L.DomUtil.setOpacity(this.container, opacity);
        }
    });

    L.svgIcon = function (options) {
        return new L.SVGIcon(options);
    };

    return L.SVGIcon;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This module do HTTP requests modifying the request's data to handle bounding box fixes when the are
 * crosses the antimeridian line.
 * @ignore
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
    'use strict';

    function calculateBoundingBox(bBox) {
        if (bBox.minLon < -180) {
            return [{ minLon: -180, minLat: bBox.minLat, maxLon: bBox.maxLon, maxLat: bBox.maxLat }, { minLon: 360 + bBox.minLon, minLat: bBox.minLat, maxLon: 180, maxLat: bBox.maxLat }];
        }

        if (bBox.maxLon > 180) {
            return [{ minLon: bBox.minLon, minLat: bBox.minLat, maxLon: 180, maxLat: bBox.maxLat }, { minLon: -180, minLat: bBox.minLat, maxLon: bBox.maxLon - 360, maxLat: bBox.maxLat }];
        }

        return [bBox];
    }

    function splitOnEdgeOfTheWorld(bBox) {
        if (!bBox) {
            return [];
        }
        return calculateBoundingBox(bBox);
    }

    function responseCollector(numBoundingBoxes, responses, callback, model) {
        return function (response) {
            responses.push(response);
            if (responses.length === numBoundingBoxes) {
                responses = responses.length === 1 ? responses[0] : responses;
                callback(model(responses));
            }
        };
    }

    /**
     * @ignore
     * @param {Object} bbox
     * @param {Object} bbox.topLeftPoint
     * @param {Object} bbox.btmRightPoint
     * @return {LatLngBounds}
     */
    function unwrapBbox(bbox) {
        var wrappedBbox = {
            topLeftPoint: L.latLng(bbox.topLeftPoint.lat, bbox.topLeftPoint.lon).wrap(),
            btmRightPoint: L.latLng(bbox.btmRightPoint.lat, bbox.btmRightPoint.lon).wrap()
        };
        if (wrappedBbox.topLeftPoint.lng > 0 && wrappedBbox.btmRightPoint.lng < 0) {
            return {
                topLeftPoint: {
                    lat: wrappedBbox.topLeftPoint.lat,
                    lon: wrappedBbox.topLeftPoint.lng
                },
                btmRightPoint: {
                    lat: wrappedBbox.btmRightPoint.lat,
                    lon: wrappedBbox.btmRightPoint.lng + 360
                }
            };
        }
        return bbox;
    }

    /**
     * @ignore
     * @param {Object[]} results
     * @return {Object[]}
     */
    function unwrapBboxInResponse(results) {
        return results.map(function (result) {
            if (result.boundingBox) {
                result.boundingBox = unwrapBbox(result.boundingBox);
            }
            if (result.viewport) {
                result.viewport = unwrapBbox(result.viewport);
            }
            return result;
        });
    }

    /**
     * @ignore
     * It returns a new callback function that will handle the unwrapping of bbox values.
     * @param {Object} data
     * @param {Function} originalCallback
     * @return {Function}
     */
    function handleBboxUnwrapping(data, originalCallback) {
        if (data.unwrapBbox) {
            return function (results) {
                originalCallback(unwrapBboxInResponse(results));
            };
        }
        delete data.unwrapBbox;
        return originalCallback;
    }

    function getBoundingBox(data) {
        if (data.boundingBox) {
            return data.boundingBox;
        } else if (utils.isValidValue(data.minLat) && utils.isValidValue(data.minLon) && utils.isValidValue(data.maxLat) && utils.isValidValue(data.maxLon)) {
            return {
                minLat: data.minLat,
                minLon: data.minLon,
                maxLat: data.maxLat,
                maxLon: data.maxLon
            };
        }

        return null;
    }

    return function (service, model, data, callback, addBoundingBoxParameters) {
        var boundingBoxes = splitOnEdgeOfTheWorld(getBoundingBox(data)),
            boundingBoxesLength = boundingBoxes.length || 1,
            responses = [],
            i;
        delete data.boundingBox;

        callback = handleBboxUnwrapping(data, callback);

        for (i = 0; i < boundingBoxesLength; i += 1) {
            data = boundingBoxes[i] ? addBoundingBoxParameters(data, boundingBoxes[i]) : data;
            service(data, responseCollector(boundingBoxesLength, responses, callback, model));
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Tile layer for Leaflet that use the
 * [Maps API - Vector](https://developer.tomtom.com/maps-api/maps-api-documentation/vector)
 * from TomTom.
 *
 * The current vector renderer implementation is based on the
 * [Mapbox GL JS library](https://www.mapbox.com/mapbox-gl-js/api/).
 *
 * The recommended way to use vector maps is by using the "source" option of {{#crossLink "L.Map"}}{{/crossLink}} which
 * will create an instance of this class and immediately attach it to the newly created map instance.
 *
 * @example
 * ```js
 * // Vector layer instance with factory vector styles
 * var vectorLayer = new L.TomTomVectorLayer({
 *   vector: {
 *     key: "<Your API key>"
 *   }
 * });
 * ```
 *
 * @class TomTomVectorLayer
 * @namespace L
 * @module Map
 * @extends L.Class
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#tilelayer-options">Leaflet's TileLayer</a>
 *     allows.
 *     The additional options, which are TomTom specific, are described below.
 * @param {"main"|"night"} [options.style="main"] The base map style to use
 * @param {"basic"|"hybrid"|"labels"} [options.layer="basic"] The base map's layer to use
 * @param {Object} [options.vector] Options specific for vector layer
 * @param {String} [options.vector.key] API key that can be obtained from
 *     [TomTom's developer portal](https://developer.tomtom.com).
 *     When the key is passed on the map's initialization, it is set globally for all the services.
 *     It can be overwritten with the `tomtom.key()` method globally or per service
 *     with `tomtom.<service_name>.key()` functions.
 *     It is also possible to pass a specific key while working with instances of the services.
 * @param {Object} [options.vector.renderer] Mapbox GL JS Map options as described in the
 *     <a href="https://www.mapbox.com/mapbox-gl-js/api/#Map">Mapbox API Docs</a>
 * @param {"error"|"raster"} [options.vector.fallback="error"] Defines the action when the browser doesn't have
 *     support for WebGL (needed by the vector layer).
 *     The possible values are:
 *  - `"error"` will throw a javascript Error informing about the problem.
 *  - `"raster"` will automatically switch to the raster layer.
 *  @param {String} [options.language] Language to be used for map labels. Should be one of supported
 *      IETF language tags described
 *      [here](https://developer.tomtom.com/maps-api/maps-api-documentation-raster/raster-tile#listOfSupportedLanguages).
 *      When data in specified language is not available for a specific label,
 *      <a href="https://developer.tomtom.com/maps-api/maps-api-documentation-raster/raster-tile#defaultLanguageAlgorithm">default language</a>
 *      is used.
 */
/* eslint-enable max-len */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(5), __webpack_require__(138), __webpack_require__(68), __webpack_require__(9), __webpack_require__(69), __webpack_require__(0), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, security, mapboxGLLeaflet, mapTheme, ApiKeyNames, Utils, ServiceUtils, analytics) {
    'use strict';

    var EVENTS = {
        /**
         * Fired immediately after the style was fully loaded.
         * @event STYLE_LOAD_END
         * @type String
         */
        STYLE_LOAD_END: 'tomtom.styleloadend',

        /**
         * Fired when an error occurs during the initialization of the vector layer.
         * @event MAP_ERROR
         * @type String
         */
        MAP_ERROR: 'tomtom.error'
    };

    function mapboxStyleLoadedEventHandler(e) {
        if (e.dataType !== 'style') {
            return;
        }
        this.fire(L.TomTomVectorLayer.Events.STYLE_LOAD_END);
    }

    function mapErrorHandler(event) {
        this.fire(L.TomTomVectorLayer.Events.MAP_ERROR, event);
    }

    function toFront(el) {
        var parent = el.parentNode;
        if (parent.lastChild !== el) {
            parent.appendChild(el);
        }
    }

    function toBack(el) {
        var parent = el.parentNode;
        if (parent.firstChild !== el) {
            parent.insertBefore(el, parent.firstChild);
        }
    }

    L.TomTomVectorLayer = mapboxGLLeaflet.extend({

        Events: EVENTS,

        statics: {
            Events: EVENTS
        },

        /**
         * Name of vector layer. It can be used to differentiate layers.
         * @property name
         * @default "vector"
         * @type String
         */
        name: 'vector',

        onAdd: function onAdd(map) {
            var that = this;
            mapboxGLLeaflet.prototype.onAdd.call(this, map);
            this.bringToBack();
            this._glMap.on('data', this._mapboxStyleLoadedEventHandler);
            this._glMap.on('error', this._mapErrorHandler);
            this._glMap.on('zoomstart', function () {
                that._glMap.once('idle', function () {
                    that._glMap.triggerRepaint();
                });
            });
            Utils.updateMaxZoom(map, this.name);
        },

        onRemove: function onRemove(map) {
            this._glMap.off('data', this._mapboxStyleLoadedEventHandler);
            this._glMap.off('error', this._mapErrorHandler);
            mapboxGLLeaflet.prototype.onRemove.call(this, map);
        },

        _updateZIndex: function _updateZIndex() {
            if (this._glContainer && this.options.zIndex !== undefined && this.options.zIndex !== null) {
                this._glContainer.style.zIndex = this.options.zIndex;
            }
        },

        _setAutoZIndex: function _setAutoZIndex(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var i,
                len,
                zIndex,
                layers = this.getPane().children,
                edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for (i = 0, len = layers.length, zIndex; i < len; i++) {
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._glContainer && zIndex) {
                    edgeZIndex = compare(edgeZIndex, Number(zIndex));
                }
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },

        bringToBack: function bringToBack() {
            if (this._map && this._glContainer) {
                toBack(this._glContainer);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },

        bringToFront: function bringToFront() {
            if (this._map && this._glContainer) {
                toFront(this._glContainer);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },

        _validateUrl: function _validateUrl(url) {
            var pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;

            return Boolean(ServiceUtils.isString(url) && pattern.test(url));
        },

        _getResourcesUrls: function _getResourcesUrls(options) {
            return {
                glyphs: this._validateUrl(options.glyphsUrl) ? options.glyphsUrl : options.basePath + '/glyphs/{fontstack}/{range}.pbf',
                sprite: this._validateUrl(options.spriteUrl) ? options.spriteUrl : options.basePath + '/sprites/sprite'
            };
        },
        /**
         * Returns the vector style object currently applied to the vector layer.
         *
         * @method getStyle
         * @return {Object} A object with the current style or undefined if no style was applied yet.
         */
        getStyle: function getStyle() {
            return this._glMap.style.stylesheet;
        },
        /**
         * Sets the style for the vector layer.
         *
         * It expects an object formatted in compliance with the
         * [Mapbox style specification](https://www.mapbox.com/mapbox-gl-js/style-spec/).
         *
         * @method setStyle
         * @param {Object} style object which will be applied to vectorLayer
         */
        setStyle: function setStyle(style) {
            if (this._glMap) {
                this._glMap.setStyle(style);
            }
        },

        updateOptions: function updateOptions(options) {
            var theme = mapTheme.getTheme([this.options, options], this.name);
            this.options.layer = theme.layer;
            this.options.style = theme.style;
            this.options.renderer.style.theme = theme;
            if (this._glMap) {
                this._glMap.setStyle(this.options.renderer.style);
            }
        },

        _initializeDefaultStyleOptions: function _initializeDefaultStyleOptions(options) {
            var defaultStyleUrls;
            options.basePath = options.basePath !== undefined ? options.basePath : '/sdk';
            defaultStyleUrls = {
                main: {
                    basic: options.basePath + '/styles/basic_main.json',
                    hybrid: options.basePath + '/styles/hybrid_main.json',
                    labels: options.basePath + '/styles/labels_main.json'
                },
                night: {
                    basic: options.basePath + '/styles/basic_night.json',
                    hybrid: options.basePath + '/styles/hybrid_night.json',
                    labels: options.basePath + '/styles/labels_night.json'
                }
            };

            options.styleUrlMapping = L.Util.extend(defaultStyleUrls, options.styleUrlMapping);
            return options;
        },

        initialize: function initialize(options) {
            var theme, vectorOptions, rendererOptions, resourceUrls;
            options = L.extend({}, options);
            this._initializeDefaultStyleOptions(options);
            theme = mapTheme.getTheme([options, options.vector], this.name);
            vectorOptions = L.extend({}, options.vector);
            vectorOptions.renderer = vectorOptions.renderer || {};
            security.setKey(ApiKeyNames.vector, vectorOptions.key);
            resourceUrls = this._getResourcesUrls(options);
            rendererOptions = {
                accessToken: 'no-token',
                style: {
                    resourceUrls: resourceUrls,
                    styleUrlMapping: options.styleUrlMapping,
                    theme: theme,
                    language: options.language,
                    geopolView: options.geopolView,
                    securityKeyName: options.securityKeyName || ApiKeyNames.vector,
                    preSetStyleCallback: options.preSetStyleCallback
                },
                transformRequest: function transformRequest(url) {
                    var headers = {};

                    if (analytics.isTomtomOrigin(url)) {
                        headers[analytics.getHeaderName()] = analytics.getHeaderContent();
                    }

                    return {
                        url: url,
                        headers: headers
                    };
                }
            };
            vectorOptions.renderer = L.extend(rendererOptions, vectorOptions.renderer);
            vectorOptions.minZoom = 2;
            vectorOptions.maxZoom = 22;
            vectorOptions.style = theme.style;
            vectorOptions.layer = theme.layer;
            L.setOptions(this, vectorOptions);
            this._mapboxStyleLoadedEventHandler = mapboxStyleLoadedEventHandler.bind(this);
            this._mapErrorHandler = mapErrorHandler.bind(this);
            mapboxGLLeaflet.prototype.initialize.call(this, vectorOptions);
        }
    });

    ServiceUtils.addDeprecatedProperty(L.TomTomVectorLayer, 'EVENTS', 'Events');

    L.tomTomVectorLayer = function (options) {
        return new L.TomTomVectorLayer(options);
    };

    return L.TomTomVectorLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * This module returns a function that returns a mixin object with helper functions to start listen on layers' events.
 * This module has a soft dependency to the traffic and trafficFlow modules.
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    /**
     * @ignore
     * @param {String} baseName
     * @return {String} Name of the property in the layer instance
     */

    function getFlagName(baseName) {
        return '_' + baseName + 'Added';
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance that could be added to or removed from the map if is necessary
     * @param {String} flagName
     * @return {String} Value of the property in the layer instance
     */
    function getFlag(source, flagName) {
        return source[getFlagName(flagName)];
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance
     * @param {String} baseLayerName
     * @return {Boolean}
     */
    function shouldAddLayer(source, baseLayerName) {
        var mapUseBaseLayer, mapUseTraffic, mapUseTrafficFlow, mapUseVectorTrafficFlow, mapUseVectorIncidents;
        mapUseBaseLayer = Boolean(getFlag(source, baseLayerName));
        mapUseTraffic = Boolean(getFlag(source, 'traffic'));
        mapUseTrafficFlow = Boolean(getFlag(source, 'trafficFlow'));
        mapUseVectorTrafficFlow = Boolean(getFlag(source, 'vectorTrafficFlow'));
        mapUseVectorIncidents = Boolean(getFlag(source, 'vectorTrafficIncidents'));
        return mapUseBaseLayer && (mapUseTraffic || mapUseTrafficFlow || mapUseVectorTrafficFlow || mapUseVectorIncidents);
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance
     * @param {String} baseLayerName
     * @return {Boolean}
     */
    function shouldRemoveLayer(source, baseLayerName) {
        return !shouldAddLayer(source, baseLayerName);
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance that could be added to the map if is necessary
     * @param {L.Map} map
     * @param {String} baseLayerName
     */
    function addIfNecessary(source, map, baseLayerName) {
        if (source._attached) {
            return;
        }
        if (shouldAddLayer(source, baseLayerName)) {
            map.addLayer(source);
            source._attached = true;
        }
    }

    /**
     * @ignore
     * @param {L.Layer} source Layer instance that could be removed from the map if is necessary
     * @param {L.Map} map
     * @param {String} baseLayerName
     */
    function removeIfNecessary(source, map, baseLayerName) {
        if (!source._attached) {
            return;
        }
        if (shouldRemoveLayer(source, baseLayerName)) {
            map.removeLayer(source);
            source._attached = false;
        }
    }

    return function (baseLayerName) {
        return {
            /**
             * @ignore
             * Install listeners to add or remove the current Layer instance (of the
             * class that use this mixin functions) if specific Layer types are added to the map.
             * @param {L.Map} map
             */
            registerEventHandlers: function registerEventHandlers(map) {
                var that = this;

                map.on('layeradd', function (event) {
                    var layerName = event.layer.name;
                    if (!layerName) {
                        return;
                    }
                    that[getFlagName(layerName)] = true;
                    addIfNecessary(that, map, baseLayerName);
                });
                map.on('layerremove', function (event) {
                    var layerName = event.layer.name;
                    if (!layerName) {
                        return;
                    }
                    that[getFlagName(layerName)] = false;
                    removeIfNecessary(that, map, baseLayerName);
                });
            }
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Reverse geocode service implementation.
 *
 * It allows to convert geographical coordinates into textual address representation using the TomTom's
 * [Search API - Reverse Geocode](https://developer.tomtom.com/search-api/search-api-documentation-reverse-geocoding/reverse-geocode).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "ReverseGeocode/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *   {{#crossLink "ReverseGeocode/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * The final response from service is a JSON object with the following structure:
 *
* ```js
 * {
 *   "summary": {
 *       "queryTime": 172,
 *       "numResults": 1
 *   },
 *   "addresses": [
 *       {
 *           "address": { // Structured Address for the result
 *               "buildingNumber": "2515",
 *               "streetNumber": "2515",
 *               "routeNumbers": [],
 *               "street": "Soquel Dr",
 *               "streetName": "Soquel Dr",
 *               "streetNameAndNumber": "2515 Soquel Dr",
 *               "countryCode": "US",
 *               "countrySubdivision": "CA",
 *               "countrySubdivisionName": "California",
 *               "municipality": "Santa Cruz",
 *               "sideOfStreet": "R",
 *               "offsetPosition": "36.988240,-121.974790",
 *               "country": "United States of America",
 *               "countryCodeISO3": "USA",
 *               "freeformAddress": "2515 Soquel Dr\nSanta Cruz CA 95065",
 *               "boundingBox": {
 *                   "northEast": "36.99265,-121.96917",
 *                   "southWest": "36.98365,-121.98043",
 *                   "entity": "position"
 *               },
 *           },
 *           "position": "36.98815,-121.97480",
 *           "matchType": "HouseNumberRange",
 *           "roadUse": [
 *               "LocalStreet"
 *           ]
 *       }
 *   ],
 *   "spatialKeys": []
 * }
 * ```
 *
 * @example
 * ```js
 * function callbackFn(response) {
 *   console.log(response);
 * }
 * tomtom.reverseGeocode()
 *   .position("51.759,19.449")
 *   .go()
 *   .then(callbackFn);
 * ```
 *
 * @class ReverseGeocode
 * @module Services
 * @uses Chain
 * @uses KeyMixin
 * @uses ProtocolMixin
 * @uses RadiusMixin
 * @uses PositionMixin
 * @uses SpatialKeysMixin
 * @uses LanguageMixin
 * @uses ViewMixin
 * @uses HeadingMixin
 * @uses AllowFreeformNewlineMixin
 *
 * @constructor
 * @param {Object}   [options] Options to be passed to the reverse geocode call,
 *     or Array of such options objects to perform batch request.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 *
 * @param {String|Array|Object} options.position Specific longitude and latitude of the location where the address
 *     is supposed to be found.
 *     The possible formats are explained in more detail in the
 *     {{#crossLink "ReverseGeocode/position:method"}}{{/crossLink}} method.
 *     This option is required to make the call.
 * @param {String} [options.key] API Key valid for requested service.
 * @param {Boolean} [options.spatialKeys=false] DEPRECATED! If is enable the response will also contain a proprietary geo-spatial
 *     key information for a specified location
 * @param {Boolean} [options.returnSpeedLimit=false] To enable return of the posted speed limit (where
 *     available).
 * @param {Number} [options.heading] The directional heading of the vehicle in degrees, for travel along a
 *     segment of roadway.
 *     `0` is North, `90` is East and so on, values range from `-360` to `360`.
 *     The precision can include up to one decimal place.
 * @param {Number} [options.radius=10000] The maximum distance in meters from the specified position to consider
 * @param {String} [options.number] If a street number is sent in along with the request, the response
 *     may include the side of the street (Left/Right) and also an offset position for that street number.
 * @param {Boolean} [options.returnRoadUse=false] Requires to include a road use array for reversegeocodes at street level
 * @param {String[]|String} [options.roadUse] To restrict the result to one or a group of the following road uses:
 *      `LimitedAccess`, `Arterial`, `Terminal`, `Ramp`, `Rotary`, `LocalStreet`.
 * @param {String} [options.language] Preferred language and script in which search results (including place names) are returned.
 *     If language is not specified, the default official name will be returned in response. Supported languages are listed in the
 *     documentation of the service. If requested language is not supported, a special error code will be returned.
 * @param {Boolean} [options.returnMatchType] Include information on the type of match the geocoder achieved in the response.
 * @param {Boolean} [options.allowFreeformNewline=false] Format of newlines in the formatted address.
 *     If true, the address will contain newlines.
 *     If false, newlines will be converted to commas.
 * @param {String} [options.view=Unified] The geopolitical view used in subsequent calls
 */
/* eslint-enable */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(83), __webpack_require__(85), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = function (reverseGeocodeBase, reverseGeocodeParams, types) {
    'use strict';

    var ReverseGeocodeBasePrototype = reverseGeocodeBase.prototype.constructor;

    function ReverseGeocode(options) {
        ReverseGeocodeBasePrototype.call(this, options);
        this.fields = reverseGeocodeParams(types.reverseGeocode);
    }

    ReverseGeocode.prototype = new ReverseGeocodeBasePrototype();
    ReverseGeocode.prototype.constructor = ReverseGeocode;

    return function (options) {
        return new ReverseGeocode(options).construct();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash core -o ./dist/lodash.core.js`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.5';

  /** Error message constants. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_PARTIAL_FLAG = 32;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      stringTag = '[object String]';

  /** Used to match HTML entities and HTML characters. */
  var reUnescapedHtml = /[&<>"']/g,
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /*--------------------------------------------------------------------------*/

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    array.push.apply(array, values);
    return array;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return baseMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /*--------------------------------------------------------------------------*/

  /** Used for built-in method references. */
  var arrayProto = Array.prototype,
      objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to generate unique IDs. */
  var idCounter = 0;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Used to restore the original `_` reference in `_.noConflict`. */
  var oldDash = root._;

  /** Built-in value references. */
  var objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsFinite = root.isFinite,
      nativeKeys = overArg(Object.keys, Object),
      nativeMax = Math.max;

  /*------------------------------------------------------------------------*/

  /**
   * Creates a `lodash` object which wraps `value` to enable implicit method
   * chain sequences. Methods that operate on and return arrays, collections,
   * and functions can be chained together. Methods that retrieve a single value
   * or may return a primitive value will automatically end the chain sequence
   * and return the unwrapped value. Otherwise, the value must be unwrapped
   * with `_#value`.
   *
   * Explicit chain sequences, which must be unwrapped with `_#value`, may be
   * enabled using `_.chain`.
   *
   * The execution of chained methods is lazy, that is, it's deferred until
   * `_#value` is implicitly or explicitly called.
   *
   * Lazy evaluation allows several methods to support shortcut fusion.
   * Shortcut fusion is an optimization to merge iteratee calls; this avoids
   * the creation of intermediate arrays and can greatly reduce the number of
   * iteratee executions. Sections of a chain sequence qualify for shortcut
   * fusion if the section is applied to an array and iteratees accept only
   * one argument. The heuristic for whether a section qualifies for shortcut
   * fusion is subject to change.
   *
   * Chaining is supported in custom builds as long as the `_#value` method is
   * directly or indirectly included in the build.
   *
   * In addition to lodash methods, wrappers have `Array` and `String` methods.
   *
   * The wrapper `Array` methods are:
   * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
   *
   * The wrapper `String` methods are:
   * `replace` and `split`
   *
   * The wrapper methods that support shortcut fusion are:
   * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
   * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
   * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
   *
   * The chainable wrapper methods are:
   * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
   * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
   * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
   * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
   * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
   * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
   * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
   * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
   * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
   * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
   * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
   * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
   * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
   * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
   * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
   * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
   * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
   * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
   * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
   * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
   * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
   * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
   * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
   * `zipObject`, `zipObjectDeep`, and `zipWith`
   *
   * The wrapper methods that are **not** chainable by default are:
   * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
   * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
   * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
   * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
   * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
   * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
   * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
   * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
   * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
   * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
   * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
   * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
   * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
   * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
   * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
   * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
   * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
   * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
   * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
   * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
   * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
   * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
   * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
   * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
   * `upperFirst`, `value`, and `words`
   *
   * @name _
   * @constructor
   * @category Seq
   * @param {*} value The value to wrap in a `lodash` instance.
   * @returns {Object} Returns the new `lodash` wrapper instance.
   * @example
   *
   * function square(n) {
   *   return n * n;
   * }
   *
   * var wrapped = _([1, 2, 3]);
   *
   * // Returns an unwrapped value.
   * wrapped.reduce(_.add);
   * // => 6
   *
   * // Returns a wrapped value.
   * var squares = wrapped.map(square);
   *
   * _.isArray(squares);
   * // => false
   *
   * _.isArray(squares.value());
   * // => true
   */
  function lodash(value) {
    return value instanceof LodashWrapper
      ? value
      : new LodashWrapper(value);
  }

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  var baseCreate = (function() {
    function object() {}
    return function(proto) {
      if (!isObject(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object;
      object.prototype = undefined;
      return result;
    };
  }());

  /**
   * The base constructor for creating `lodash` wrapper objects.
   *
   * @private
   * @param {*} value The value to wrap.
   * @param {boolean} [chainAll] Enable explicit method chain sequences.
   */
  function LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
  }

  LodashWrapper.prototype = baseCreate(lodash.prototype);
  LodashWrapper.prototype.constructor = LodashWrapper;

  /*------------------------------------------------------------------------*/

  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
        (value === undefined && !(key in object))) {
      baseAssignValue(object, key, value);
    }
  }

  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function baseAssignValue(object, key, value) {
    object[key] = value;
  }

  /**
   * The base implementation of `_.delay` and `_.defer` which accepts `args`
   * to provide to `func`.
   *
   * @private
   * @param {Function} func The function to delay.
   * @param {number} wait The number of milliseconds to delay invocation.
   * @param {Array} args The arguments to provide to `func`.
   * @returns {number|Object} Returns the timer id or timeout object.
   */
  function baseDelay(func, wait, args) {
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    return setTimeout(function() { func.apply(undefined, args); }, wait);
  }

  /**
   * The base implementation of `_.forEach` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   */
  var baseEach = createBaseEach(baseForOwn);

  /**
   * The base implementation of `_.every` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`
   */
  function baseEvery(collection, predicate) {
    var result = true;
    baseEach(collection, function(value, index, collection) {
      result = !!predicate(value, index, collection);
      return result;
    });
    return result;
  }

  /**
   * The base implementation of methods like `_.max` and `_.min` which accepts a
   * `comparator` to determine the extremum value.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The iteratee invoked per iteration.
   * @param {Function} comparator The comparator used to compare values.
   * @returns {*} Returns the extremum value.
   */
  function baseExtremum(array, iteratee, comparator) {
    var index = -1,
        length = array.length;

    while (++index < length) {
      var value = array[index],
          current = iteratee(value);

      if (current != null && (computed === undefined
            ? (current === current && !false)
            : comparator(current, computed)
          )) {
        var computed = current,
            result = value;
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.filter` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function baseFilter(collection, predicate) {
    var result = [];
    baseEach(collection, function(value, index, collection) {
      if (predicate(value, index, collection)) {
        result.push(value);
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.flatten` with support for restricting flattening.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {number} depth The maximum recursion depth.
   * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
   * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
   * @param {Array} [result=[]] The initial result value.
   * @returns {Array} Returns the new flattened array.
   */
  function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1,
        length = array.length;

    predicate || (predicate = isFlattenable);
    result || (result = []);

    while (++index < length) {
      var value = array[index];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          // Recursively flatten arrays (susceptible to call stack limits).
          baseFlatten(value, depth - 1, predicate, isStrict, result);
        } else {
          arrayPush(result, value);
        }
      } else if (!isStrict) {
        result[result.length] = value;
      }
    }
    return result;
  }

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = createBaseFor();

  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */
  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }

  /**
   * The base implementation of `_.functions` which creates an array of
   * `object` function property names filtered from `props`.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Array} props The property names to filter.
   * @returns {Array} Returns the function names.
   */
  function baseFunctions(object, props) {
    return baseFilter(props, function(key) {
      return isFunction(object[key]);
    });
  }

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    return objectToString(value);
  }

  /**
   * The base implementation of `_.gt` which doesn't coerce arguments.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if `value` is greater than `other`,
   *  else `false`.
   */
  function baseGt(value, other) {
    return value > other;
  }

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  var baseIsArguments = noop;

  /**
   * The base implementation of `_.isDate` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
   */
  function baseIsDate(value) {
    return isObjectLike(value) && baseGetTag(value) == dateTag;
  }

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : baseGetTag(object),
        othTag = othIsArr ? arrayTag : baseGetTag(other);

    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;

    var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;

    stack || (stack = []);
    var objStack = find(stack, function(entry) {
      return entry[0] == object;
    });
    var othStack = find(stack, function(entry) {
      return entry[0] == other;
    });
    if (objStack && othStack) {
      return objStack[1] == other;
    }
    stack.push([object, other]);
    stack.push([other, object]);
    if (isSameTag && !objIsObj) {
      var result = (objIsArr)
        ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
        : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      stack.pop();
      return result;
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;

        var result = equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        stack.pop();
        return result;
      }
    }
    if (!isSameTag) {
      return false;
    }
    var result = equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    stack.pop();
    return result;
  }

  /**
   * The base implementation of `_.isRegExp` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
   */
  function baseIsRegExp(value) {
    return isObjectLike(value) && baseGetTag(value) == regexpTag;
  }

  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */
  function baseIteratee(func) {
    if (typeof func == 'function') {
      return func;
    }
    if (func == null) {
      return identity;
    }
    return (typeof func == 'object' ? baseMatches : baseProperty)(func);
  }

  /**
   * The base implementation of `_.lt` which doesn't coerce arguments.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if `value` is less than `other`,
   *  else `false`.
   */
  function baseLt(value, other) {
    return value < other;
  }

  /**
   * The base implementation of `_.map` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function baseMap(collection, iteratee) {
    var index = -1,
        result = isArrayLike(collection) ? Array(collection.length) : [];

    baseEach(collection, function(value, key, collection) {
      result[++index] = iteratee(value, key, collection);
    });
    return result;
  }

  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatches(source) {
    var props = nativeKeys(source);
    return function(object) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length];
        if (!(key in object &&
              baseIsEqual(source[key], object[key], COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG)
            )) {
          return false;
        }
      }
      return true;
    };
  }

  /**
   * The base implementation of `_.pick` without support for individual
   * property identifiers.
   *
   * @private
   * @param {Object} object The source object.
   * @param {string[]} paths The property paths to pick.
   * @returns {Object} Returns the new object.
   */
  function basePick(object, props) {
    object = Object(object);
    return reduce(props, function(result, key) {
      if (key in object) {
        result[key] = object[key];
      }
      return result;
    }, {});
  }

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }

  /**
   * The base implementation of `_.slice` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function baseSlice(array, start, end) {
    var index = -1,
        length = array.length;

    if (start < 0) {
      start = -start > length ? 0 : (length + start);
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : ((end - start) >>> 0);
    start >>>= 0;

    var result = Array(length);
    while (++index < length) {
      result[index] = array[index + start];
    }
    return result;
  }

  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */
  function copyArray(source) {
    return baseSlice(source, 0, source.length);
  }

  /**
   * The base implementation of `_.some` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function baseSome(collection, predicate) {
    var result;

    baseEach(collection, function(value, index, collection) {
      result = predicate(value, index, collection);
      return !result;
    });
    return !!result;
  }

  /**
   * The base implementation of `wrapperValue` which returns the result of
   * performing a sequence of actions on the unwrapped `value`, where each
   * successive action is supplied the return value of the previous.
   *
   * @private
   * @param {*} value The unwrapped value.
   * @param {Array} actions Actions to perform to resolve the unwrapped value.
   * @returns {*} Returns the resolved value.
   */
  function baseWrapperValue(value, actions) {
    var result = value;
    return reduce(actions, function(result, action) {
      return action.func.apply(action.thisArg, arrayPush([result], action.args));
    }, result);
  }

  /**
   * Compares values to sort them in ascending order.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function compareAscending(value, other) {
    if (value !== other) {
      var valIsDefined = value !== undefined,
          valIsNull = value === null,
          valIsReflexive = value === value,
          valIsSymbol = false;

      var othIsDefined = other !== undefined,
          othIsNull = other === null,
          othIsReflexive = other === other,
          othIsSymbol = false;

      if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
          (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
          (valIsNull && othIsDefined && othIsReflexive) ||
          (!valIsDefined && othIsReflexive) ||
          !valIsReflexive) {
        return 1;
      }
      if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
          (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
          (othIsNull && valIsDefined && valIsReflexive) ||
          (!othIsDefined && valIsReflexive) ||
          !othIsReflexive) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});

    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];

      var newValue = customizer
        ? customizer(object[key], source[key], key, object, source)
        : undefined;

      if (newValue === undefined) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }
    return object;
  }

  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */
  function createAssigner(assigner) {
    return baseRest(function(object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined;

      customizer = (assigner.length > 3 && typeof customizer == 'function')
        ? (length--, customizer)
        : undefined;

      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }

  /**
   * Creates a `baseEach` or `baseEachRight` function.
   *
   * @private
   * @param {Function} eachFunc The function to iterate over a collection.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike(collection)) {
        return eachFunc(collection, iteratee);
      }
      var length = collection.length,
          index = fromRight ? length : -1,
          iterable = Object(collection);

      while ((fromRight ? index-- : ++index < length)) {
        if (iteratee(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }

  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }

  /**
   * Creates a function that produces an instance of `Ctor` regardless of
   * whether it was invoked as part of a `new` expression or by `call` or `apply`.
   *
   * @private
   * @param {Function} Ctor The constructor to wrap.
   * @returns {Function} Returns the new wrapped function.
   */
  function createCtor(Ctor) {
    return function() {
      // Use a `switch` statement to work with class constructors. See
      // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
      // for more details.
      var args = arguments;
      var thisBinding = baseCreate(Ctor.prototype),
          result = Ctor.apply(thisBinding, args);

      // Mimic the constructor's `return` behavior.
      // See https://es5.github.io/#x13.2.2 for more details.
      return isObject(result) ? result : thisBinding;
    };
  }

  /**
   * Creates a `_.find` or `_.findLast` function.
   *
   * @private
   * @param {Function} findIndexFunc The function to find the collection index.
   * @returns {Function} Returns the new find function.
   */
  function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
      var iterable = Object(collection);
      if (!isArrayLike(collection)) {
        var iteratee = baseIteratee(predicate, 3);
        collection = keys(collection);
        predicate = function(key) { return iteratee(iterable[key], key, iterable); };
      }
      var index = findIndexFunc(collection, predicate, fromIndex);
      return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
  }

  /**
   * Creates a function that wraps `func` to invoke it with the `this` binding
   * of `thisArg` and `partials` prepended to the arguments it receives.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} partials The arguments to prepend to those provided to
   *  the new function.
   * @returns {Function} Returns the new wrapped function.
   */
  function createPartial(func, bitmask, thisArg, partials) {
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var isBind = bitmask & WRAP_BIND_FLAG,
        Ctor = createCtor(func);

    function wrapper() {
      var argsIndex = -1,
          argsLength = arguments.length,
          leftIndex = -1,
          leftLength = partials.length,
          args = Array(leftLength + argsLength),
          fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

      while (++leftIndex < leftLength) {
        args[leftIndex] = partials[leftIndex];
      }
      while (argsLength--) {
        args[leftIndex++] = arguments[++argsIndex];
      }
      return fn.apply(isBind ? thisArg : this, args);
    }
    return wrapper;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var index = -1,
        result = true,
        seen = (bitmask & COMPARE_UNORDERED_FLAG) ? [] : undefined;

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      var compared;
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!baseSome(other, function(othValue, othIndex) {
              if (!indexOf(seen, othIndex) &&
                  (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
          result = false;
          break;
        }
      } else if (!(
            arrValue === othValue ||
              equalFunc(arrValue, othValue, bitmask, customizer, stack)
          )) {
        result = false;
        break;
      }
    }
    return result;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == (other + '');

    }
    return false;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = keys(object),
        objLength = objProps.length,
        othProps = keys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    }
    var result = true;

    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      var compared;
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined
            ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
            : compared
          )) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor &&
          ('constructor' in object && 'constructor' in other) &&
          !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
            typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    return result;
  }

  /**
   * A specialized version of `baseRest` which flattens the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @returns {Function} Returns the new function.
   */
  function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + '');
  }

  /**
   * Checks if `value` is a flattenable `arguments` object or array.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
   */
  function isFlattenable(value) {
    return isArray(value) || isArguments(value);
  }

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;

    return !!length &&
      (type == 'number' ||
        (type != 'symbol' && reIsUint.test(value))) &&
          (value > -1 && value % 1 == 0 && value < length);
  }

  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */
  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }
    var type = typeof index;
    if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)
        ) {
      return eq(object[index], value);
    }
    return false;
  }

  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */
  function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
    return function() {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return func.apply(this, otherArgs);
    };
  }

  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var setToString = identity;

  /*------------------------------------------------------------------------*/

  /**
   * Creates an array with all falsey values removed. The values `false`, `null`,
   * `0`, `""`, `undefined`, and `NaN` are falsey.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to compact.
   * @returns {Array} Returns the new array of filtered values.
   * @example
   *
   * _.compact([0, 1, false, 2, '', 3]);
   * // => [1, 2, 3]
   */
  function compact(array) {
    return baseFilter(array, Boolean);
  }

  /**
   * Creates a new array concatenating `array` with any additional arrays
   * and/or values.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Array
   * @param {Array} array The array to concatenate.
   * @param {...*} [values] The values to concatenate.
   * @returns {Array} Returns the new concatenated array.
   * @example
   *
   * var array = [1];
   * var other = _.concat(array, 2, [3], [[4]]);
   *
   * console.log(other);
   * // => [1, 2, 3, [4]]
   *
   * console.log(array);
   * // => [1]
   */
  function concat() {
    var length = arguments.length;
    if (!length) {
      return [];
    }
    var args = Array(length - 1),
        array = arguments[0],
        index = length;

    while (index--) {
      args[index - 1] = arguments[index];
    }
    return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
  }

  /**
   * This method is like `_.find` except that it returns the index of the first
   * element `predicate` returns truthy for instead of the element itself.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Array
   * @param {Array} array The array to inspect.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the found element, else `-1`.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'active': false },
   *   { 'user': 'fred',    'active': false },
   *   { 'user': 'pebbles', 'active': true }
   * ];
   *
   * _.findIndex(users, function(o) { return o.user == 'barney'; });
   * // => 0
   *
   * // The `_.matches` iteratee shorthand.
   * _.findIndex(users, { 'user': 'fred', 'active': false });
   * // => 1
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.findIndex(users, ['active', false]);
   * // => 0
   *
   * // The `_.property` iteratee shorthand.
   * _.findIndex(users, 'active');
   * // => 2
   */
  function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) {
      index = nativeMax(length + index, 0);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
  }

  /**
   * Flattens `array` a single level deep.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to flatten.
   * @returns {Array} Returns the new flattened array.
   * @example
   *
   * _.flatten([1, [2, [3, [4]], 5]]);
   * // => [1, 2, [3, [4]], 5]
   */
  function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
  }

  /**
   * Recursively flattens `array`.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Array
   * @param {Array} array The array to flatten.
   * @returns {Array} Returns the new flattened array.
   * @example
   *
   * _.flattenDeep([1, [2, [3, [4]], 5]]);
   * // => [1, 2, 3, 4, 5]
   */
  function flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, INFINITY) : [];
  }

  /**
   * Gets the first element of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @alias first
   * @category Array
   * @param {Array} array The array to query.
   * @returns {*} Returns the first element of `array`.
   * @example
   *
   * _.head([1, 2, 3]);
   * // => 1
   *
   * _.head([]);
   * // => undefined
   */
  function head(array) {
    return (array && array.length) ? array[0] : undefined;
  }

  /**
   * Gets the index at which the first occurrence of `value` is found in `array`
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons. If `fromIndex` is negative, it's used as the
   * offset from the end of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   * @example
   *
   * _.indexOf([1, 2, 1, 2], 2);
   * // => 1
   *
   * // Search from the `fromIndex`.
   * _.indexOf([1, 2, 1, 2], 2, 2);
   * // => 3
   */
  function indexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (typeof fromIndex == 'number') {
      fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
    } else {
      fromIndex = 0;
    }
    var index = (fromIndex || 0) - 1,
        isReflexive = value === value;

    while (++index < length) {
      var other = array[index];
      if ((isReflexive ? other === value : other !== other)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Gets the last element of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to query.
   * @returns {*} Returns the last element of `array`.
   * @example
   *
   * _.last([1, 2, 3]);
   * // => 3
   */
  function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
  }

  /**
   * Creates a slice of `array` from `start` up to, but not including, `end`.
   *
   * **Note:** This method is used instead of
   * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
   * returned.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Array
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function slice(array, start, end) {
    var length = array == null ? 0 : array.length;
    start = start == null ? 0 : +start;
    end = end === undefined ? length : +end;
    return length ? baseSlice(array, start, end) : [];
  }

  /*------------------------------------------------------------------------*/

  /**
   * Creates a `lodash` wrapper instance that wraps `value` with explicit method
   * chain sequences enabled. The result of such sequences must be unwrapped
   * with `_#value`.
   *
   * @static
   * @memberOf _
   * @since 1.3.0
   * @category Seq
   * @param {*} value The value to wrap.
   * @returns {Object} Returns the new `lodash` wrapper instance.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'age': 36 },
   *   { 'user': 'fred',    'age': 40 },
   *   { 'user': 'pebbles', 'age': 1 }
   * ];
   *
   * var youngest = _
   *   .chain(users)
   *   .sortBy('age')
   *   .map(function(o) {
   *     return o.user + ' is ' + o.age;
   *   })
   *   .head()
   *   .value();
   * // => 'pebbles is 1'
   */
  function chain(value) {
    var result = lodash(value);
    result.__chain__ = true;
    return result;
  }

  /**
   * This method invokes `interceptor` and returns `value`. The interceptor
   * is invoked with one argument; (value). The purpose of this method is to
   * "tap into" a method chain sequence in order to modify intermediate results.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Seq
   * @param {*} value The value to provide to `interceptor`.
   * @param {Function} interceptor The function to invoke.
   * @returns {*} Returns `value`.
   * @example
   *
   * _([1, 2, 3])
   *  .tap(function(array) {
   *    // Mutate input array.
   *    array.pop();
   *  })
   *  .reverse()
   *  .value();
   * // => [2, 1]
   */
  function tap(value, interceptor) {
    interceptor(value);
    return value;
  }

  /**
   * This method is like `_.tap` except that it returns the result of `interceptor`.
   * The purpose of this method is to "pass thru" values replacing intermediate
   * results in a method chain sequence.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Seq
   * @param {*} value The value to provide to `interceptor`.
   * @param {Function} interceptor The function to invoke.
   * @returns {*} Returns the result of `interceptor`.
   * @example
   *
   * _('  abc  ')
   *  .chain()
   *  .trim()
   *  .thru(function(value) {
   *    return [value];
   *  })
   *  .value();
   * // => ['abc']
   */
  function thru(value, interceptor) {
    return interceptor(value);
  }

  /**
   * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
   *
   * @name chain
   * @memberOf _
   * @since 0.1.0
   * @category Seq
   * @returns {Object} Returns the new `lodash` wrapper instance.
   * @example
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36 },
   *   { 'user': 'fred',   'age': 40 }
   * ];
   *
   * // A sequence without explicit chaining.
   * _(users).head();
   * // => { 'user': 'barney', 'age': 36 }
   *
   * // A sequence with explicit chaining.
   * _(users)
   *   .chain()
   *   .head()
   *   .pick('user')
   *   .value();
   * // => { 'user': 'barney' }
   */
  function wrapperChain() {
    return chain(this);
  }

  /**
   * Executes the chain sequence to resolve the unwrapped value.
   *
   * @name value
   * @memberOf _
   * @since 0.1.0
   * @alias toJSON, valueOf
   * @category Seq
   * @returns {*} Returns the resolved unwrapped value.
   * @example
   *
   * _([1, 2, 3]).value();
   * // => [1, 2, 3]
   */
  function wrapperValue() {
    return baseWrapperValue(this.__wrapped__, this.__actions__);
  }

  /*------------------------------------------------------------------------*/

  /**
   * Checks if `predicate` returns truthy for **all** elements of `collection`.
   * Iteration is stopped once `predicate` returns falsey. The predicate is
   * invoked with three arguments: (value, index|key, collection).
   *
   * **Note:** This method returns `true` for
   * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
   * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
   * elements of empty collections.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   * @example
   *
   * _.every([true, 1, null, 'yes'], Boolean);
   * // => false
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36, 'active': false },
   *   { 'user': 'fred',   'age': 40, 'active': false }
   * ];
   *
   * // The `_.matches` iteratee shorthand.
   * _.every(users, { 'user': 'barney', 'active': false });
   * // => false
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.every(users, ['active', false]);
   * // => true
   *
   * // The `_.property` iteratee shorthand.
   * _.every(users, 'active');
   * // => false
   */
  function every(collection, predicate, guard) {
    predicate = guard ? undefined : predicate;
    return baseEvery(collection, baseIteratee(predicate));
  }

  /**
   * Iterates over elements of `collection`, returning an array of all elements
   * `predicate` returns truthy for. The predicate is invoked with three
   * arguments: (value, index|key, collection).
   *
   * **Note:** Unlike `_.remove`, this method returns a new array.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   * @see _.reject
   * @example
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36, 'active': true },
   *   { 'user': 'fred',   'age': 40, 'active': false }
   * ];
   *
   * _.filter(users, function(o) { return !o.active; });
   * // => objects for ['fred']
   *
   * // The `_.matches` iteratee shorthand.
   * _.filter(users, { 'age': 36, 'active': true });
   * // => objects for ['barney']
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.filter(users, ['active', false]);
   * // => objects for ['fred']
   *
   * // The `_.property` iteratee shorthand.
   * _.filter(users, 'active');
   * // => objects for ['barney']
   */
  function filter(collection, predicate) {
    return baseFilter(collection, baseIteratee(predicate));
  }

  /**
   * Iterates over elements of `collection`, returning the first element
   * `predicate` returns truthy for. The predicate is invoked with three
   * arguments: (value, index|key, collection).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {*} Returns the matched element, else `undefined`.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'age': 36, 'active': true },
   *   { 'user': 'fred',    'age': 40, 'active': false },
   *   { 'user': 'pebbles', 'age': 1,  'active': true }
   * ];
   *
   * _.find(users, function(o) { return o.age < 40; });
   * // => object for 'barney'
   *
   * // The `_.matches` iteratee shorthand.
   * _.find(users, { 'age': 1, 'active': true });
   * // => object for 'pebbles'
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.find(users, ['active', false]);
   * // => object for 'fred'
   *
   * // The `_.property` iteratee shorthand.
   * _.find(users, 'active');
   * // => object for 'barney'
   */
  var find = createFind(findIndex);

  /**
   * Iterates over elements of `collection` and invokes `iteratee` for each element.
   * The iteratee is invoked with three arguments: (value, index|key, collection).
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * **Note:** As with other "Collections" methods, objects with a "length"
   * property are iterated like arrays. To avoid this behavior use `_.forIn`
   * or `_.forOwn` for object iteration.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @alias each
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   * @see _.forEachRight
   * @example
   *
   * _.forEach([1, 2], function(value) {
   *   console.log(value);
   * });
   * // => Logs `1` then `2`.
   *
   * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
   *   console.log(key);
   * });
   * // => Logs 'a' then 'b' (iteration order is not guaranteed).
   */
  function forEach(collection, iteratee) {
    return baseEach(collection, baseIteratee(iteratee));
  }

  /**
   * Creates an array of values by running each element in `collection` thru
   * `iteratee`. The iteratee is invoked with three arguments:
   * (value, index|key, collection).
   *
   * Many lodash methods are guarded to work as iteratees for methods like
   * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
   *
   * The guarded methods are:
   * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
   * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
   * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
   * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   * @example
   *
   * function square(n) {
   *   return n * n;
   * }
   *
   * _.map([4, 8], square);
   * // => [16, 64]
   *
   * _.map({ 'a': 4, 'b': 8 }, square);
   * // => [16, 64] (iteration order is not guaranteed)
   *
   * var users = [
   *   { 'user': 'barney' },
   *   { 'user': 'fred' }
   * ];
   *
   * // The `_.property` iteratee shorthand.
   * _.map(users, 'user');
   * // => ['barney', 'fred']
   */
  function map(collection, iteratee) {
    return baseMap(collection, baseIteratee(iteratee));
  }

  /**
   * Reduces `collection` to a value which is the accumulated result of running
   * each element in `collection` thru `iteratee`, where each successive
   * invocation is supplied the return value of the previous. If `accumulator`
   * is not given, the first element of `collection` is used as the initial
   * value. The iteratee is invoked with four arguments:
   * (accumulator, value, index|key, collection).
   *
   * Many lodash methods are guarded to work as iteratees for methods like
   * `_.reduce`, `_.reduceRight`, and `_.transform`.
   *
   * The guarded methods are:
   * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
   * and `sortBy`
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @returns {*} Returns the accumulated value.
   * @see _.reduceRight
   * @example
   *
   * _.reduce([1, 2], function(sum, n) {
   *   return sum + n;
   * }, 0);
   * // => 3
   *
   * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
   *   (result[value] || (result[value] = [])).push(key);
   *   return result;
   * }, {});
   * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
   */
  function reduce(collection, iteratee, accumulator) {
    return baseReduce(collection, baseIteratee(iteratee), accumulator, arguments.length < 3, baseEach);
  }

  /**
   * Gets the size of `collection` by returning its length for array-like
   * values or the number of own enumerable string keyed properties for objects.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object|string} collection The collection to inspect.
   * @returns {number} Returns the collection size.
   * @example
   *
   * _.size([1, 2, 3]);
   * // => 3
   *
   * _.size({ 'a': 1, 'b': 2 });
   * // => 2
   *
   * _.size('pebbles');
   * // => 7
   */
  function size(collection) {
    if (collection == null) {
      return 0;
    }
    collection = isArrayLike(collection) ? collection : nativeKeys(collection);
    return collection.length;
  }

  /**
   * Checks if `predicate` returns truthy for **any** element of `collection`.
   * Iteration is stopped once `predicate` returns truthy. The predicate is
   * invoked with three arguments: (value, index|key, collection).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   * @example
   *
   * _.some([null, 0, 'yes', false], Boolean);
   * // => true
   *
   * var users = [
   *   { 'user': 'barney', 'active': true },
   *   { 'user': 'fred',   'active': false }
   * ];
   *
   * // The `_.matches` iteratee shorthand.
   * _.some(users, { 'user': 'barney', 'active': false });
   * // => false
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.some(users, ['active', false]);
   * // => true
   *
   * // The `_.property` iteratee shorthand.
   * _.some(users, 'active');
   * // => true
   */
  function some(collection, predicate, guard) {
    predicate = guard ? undefined : predicate;
    return baseSome(collection, baseIteratee(predicate));
  }

  /**
   * Creates an array of elements, sorted in ascending order by the results of
   * running each element in a collection thru each iteratee. This method
   * performs a stable sort, that is, it preserves the original sort order of
   * equal elements. The iteratees are invoked with one argument: (value).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {...(Function|Function[])} [iteratees=[_.identity]]
   *  The iteratees to sort by.
   * @returns {Array} Returns the new sorted array.
   * @example
   *
   * var users = [
   *   { 'user': 'fred',   'age': 48 },
   *   { 'user': 'barney', 'age': 36 },
   *   { 'user': 'fred',   'age': 40 },
   *   { 'user': 'barney', 'age': 34 }
   * ];
   *
   * _.sortBy(users, [function(o) { return o.user; }]);
   * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
   *
   * _.sortBy(users, ['user', 'age']);
   * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
   */
  function sortBy(collection, iteratee) {
    var index = 0;
    iteratee = baseIteratee(iteratee);

    return baseMap(baseMap(collection, function(value, key, collection) {
      return { 'value': value, 'index': index++, 'criteria': iteratee(value, key, collection) };
    }).sort(function(object, other) {
      return compareAscending(object.criteria, other.criteria) || (object.index - other.index);
    }), baseProperty('value'));
  }

  /*------------------------------------------------------------------------*/

  /**
   * Creates a function that invokes `func`, with the `this` binding and arguments
   * of the created function, while it's called less than `n` times. Subsequent
   * calls to the created function return the result of the last `func` invocation.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Function
   * @param {number} n The number of calls at which `func` is no longer invoked.
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * jQuery(element).on('click', _.before(5, addContactToList));
   * // => Allows adding up to 4 contacts to the list.
   */
  function before(n, func) {
    var result;
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    n = toInteger(n);
    return function() {
      if (--n > 0) {
        result = func.apply(this, arguments);
      }
      if (n <= 1) {
        func = undefined;
      }
      return result;
    };
  }

  /**
   * Creates a function that invokes `func` with the `this` binding of `thisArg`
   * and `partials` prepended to the arguments it receives.
   *
   * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
   * may be used as a placeholder for partially applied arguments.
   *
   * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
   * property of bound functions.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to bind.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {...*} [partials] The arguments to be partially applied.
   * @returns {Function} Returns the new bound function.
   * @example
   *
   * function greet(greeting, punctuation) {
   *   return greeting + ' ' + this.user + punctuation;
   * }
   *
   * var object = { 'user': 'fred' };
   *
   * var bound = _.bind(greet, object, 'hi');
   * bound('!');
   * // => 'hi fred!'
   *
   * // Bound with placeholders.
   * var bound = _.bind(greet, object, _, '!');
   * bound('hi');
   * // => 'hi fred!'
   */
  var bind = baseRest(function(func, thisArg, partials) {
    return createPartial(func, WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG, thisArg, partials);
  });

  /**
   * Defers invoking the `func` until the current call stack has cleared. Any
   * additional arguments are provided to `func` when it's invoked.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to defer.
   * @param {...*} [args] The arguments to invoke `func` with.
   * @returns {number} Returns the timer id.
   * @example
   *
   * _.defer(function(text) {
   *   console.log(text);
   * }, 'deferred');
   * // => Logs 'deferred' after one millisecond.
   */
  var defer = baseRest(function(func, args) {
    return baseDelay(func, 1, args);
  });

  /**
   * Invokes `func` after `wait` milliseconds. Any additional arguments are
   * provided to `func` when it's invoked.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to delay.
   * @param {number} wait The number of milliseconds to delay invocation.
   * @param {...*} [args] The arguments to invoke `func` with.
   * @returns {number} Returns the timer id.
   * @example
   *
   * _.delay(function(text) {
   *   console.log(text);
   * }, 1000, 'later');
   * // => Logs 'later' after one second.
   */
  var delay = baseRest(function(func, wait, args) {
    return baseDelay(func, toNumber(wait) || 0, args);
  });

  /**
   * Creates a function that negates the result of the predicate `func`. The
   * `func` predicate is invoked with the `this` binding and arguments of the
   * created function.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Function
   * @param {Function} predicate The predicate to negate.
   * @returns {Function} Returns the new negated function.
   * @example
   *
   * function isEven(n) {
   *   return n % 2 == 0;
   * }
   *
   * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
   * // => [1, 3, 5]
   */
  function negate(predicate) {
    if (typeof predicate != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    return function() {
      var args = arguments;
      return !predicate.apply(this, args);
    };
  }

  /**
   * Creates a function that is restricted to invoking `func` once. Repeat calls
   * to the function return the value of the first invocation. The `func` is
   * invoked with the `this` binding and arguments of the created function.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * var initialize = _.once(createApplication);
   * initialize();
   * initialize();
   * // => `createApplication` is invoked once
   */
  function once(func) {
    return before(2, func);
  }

  /*------------------------------------------------------------------------*/

  /**
   * Creates a shallow clone of `value`.
   *
   * **Note:** This method is loosely based on the
   * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
   * and supports cloning arrays, array buffers, booleans, date objects, maps,
   * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
   * arrays. The own enumerable properties of `arguments` objects are cloned
   * as plain objects. An empty object is returned for uncloneable values such
   * as error objects, functions, DOM nodes, and WeakMaps.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to clone.
   * @returns {*} Returns the cloned value.
   * @see _.cloneDeep
   * @example
   *
   * var objects = [{ 'a': 1 }, { 'b': 2 }];
   *
   * var shallow = _.clone(objects);
   * console.log(shallow[0] === objects[0]);
   * // => true
   */
  function clone(value) {
    if (!isObject(value)) {
      return value;
    }
    return isArray(value) ? copyArray(value) : copyObject(value, nativeKeys(value));
  }

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
      !propertyIsEnumerable.call(value, 'callee');
  };

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  /**
   * Checks if `value` is classified as a boolean primitive or object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
   * @example
   *
   * _.isBoolean(false);
   * // => true
   *
   * _.isBoolean(null);
   * // => false
   */
  function isBoolean(value) {
    return value === true || value === false ||
      (isObjectLike(value) && baseGetTag(value) == boolTag);
  }

  /**
   * Checks if `value` is classified as a `Date` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
   * @example
   *
   * _.isDate(new Date);
   * // => true
   *
   * _.isDate('Mon April 23 2012');
   * // => false
   */
  var isDate = baseIsDate;

  /**
   * Checks if `value` is an empty object, collection, map, or set.
   *
   * Objects are considered empty if they have no own enumerable string keyed
   * properties.
   *
   * Array-like values such as `arguments` objects, arrays, buffers, strings, or
   * jQuery-like collections are considered empty if they have a `length` of `0`.
   * Similarly, maps and sets are considered empty if they have a `size` of `0`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is empty, else `false`.
   * @example
   *
   * _.isEmpty(null);
   * // => true
   *
   * _.isEmpty(true);
   * // => true
   *
   * _.isEmpty(1);
   * // => true
   *
   * _.isEmpty([1, 2, 3]);
   * // => false
   *
   * _.isEmpty({ 'a': 1 });
   * // => false
   */
  function isEmpty(value) {
    if (isArrayLike(value) &&
        (isArray(value) || isString(value) ||
          isFunction(value.splice) || isArguments(value))) {
      return !value.length;
    }
    return !nativeKeys(value).length;
  }

  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent.
   *
   * **Note:** This method supports comparing arrays, array buffers, booleans,
   * date objects, error objects, maps, numbers, `Object` objects, regexes,
   * sets, strings, symbols, and typed arrays. `Object` objects are compared
   * by their own, not inherited, enumerable properties. Functions and DOM
   * nodes are compared by strict equality, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.isEqual(object, other);
   * // => true
   *
   * object === other;
   * // => false
   */
  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }

  /**
   * Checks if `value` is a finite primitive number.
   *
   * **Note:** This method is based on
   * [`Number.isFinite`](https://mdn.io/Number/isFinite).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
   * @example
   *
   * _.isFinite(3);
   * // => true
   *
   * _.isFinite(Number.MIN_VALUE);
   * // => true
   *
   * _.isFinite(Infinity);
   * // => false
   *
   * _.isFinite('3');
   * // => false
   */
  function isFinite(value) {
    return typeof value == 'number' && nativeIsFinite(value);
  }

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' &&
      value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }

  /**
   * Checks if `value` is `NaN`.
   *
   * **Note:** This method is based on
   * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
   * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
   * `undefined` and other non-number values.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   * @example
   *
   * _.isNaN(NaN);
   * // => true
   *
   * _.isNaN(new Number(NaN));
   * // => true
   *
   * isNaN(undefined);
   * // => true
   *
   * _.isNaN(undefined);
   * // => false
   */
  function isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return isNumber(value) && value != +value;
  }

  /**
   * Checks if `value` is `null`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
   * @example
   *
   * _.isNull(null);
   * // => true
   *
   * _.isNull(void 0);
   * // => false
   */
  function isNull(value) {
    return value === null;
  }

  /**
   * Checks if `value` is classified as a `Number` primitive or object.
   *
   * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
   * classified as numbers, use the `_.isFinite` method.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a number, else `false`.
   * @example
   *
   * _.isNumber(3);
   * // => true
   *
   * _.isNumber(Number.MIN_VALUE);
   * // => true
   *
   * _.isNumber(Infinity);
   * // => true
   *
   * _.isNumber('3');
   * // => false
   */
  function isNumber(value) {
    return typeof value == 'number' ||
      (isObjectLike(value) && baseGetTag(value) == numberTag);
  }

  /**
   * Checks if `value` is classified as a `RegExp` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
   * @example
   *
   * _.isRegExp(/abc/);
   * // => true
   *
   * _.isRegExp('/abc/');
   * // => false
   */
  var isRegExp = baseIsRegExp;

  /**
   * Checks if `value` is classified as a `String` primitive or object.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a string, else `false`.
   * @example
   *
   * _.isString('abc');
   * // => true
   *
   * _.isString(1);
   * // => false
   */
  function isString(value) {
    return typeof value == 'string' ||
      (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
  }

  /**
   * Checks if `value` is `undefined`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
   * @example
   *
   * _.isUndefined(void 0);
   * // => true
   *
   * _.isUndefined(null);
   * // => false
   */
  function isUndefined(value) {
    return value === undefined;
  }

  /**
   * Converts `value` to an array.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Array} Returns the converted array.
   * @example
   *
   * _.toArray({ 'a': 1, 'b': 2 });
   * // => [1, 2]
   *
   * _.toArray('abc');
   * // => ['a', 'b', 'c']
   *
   * _.toArray(1);
   * // => []
   *
   * _.toArray(null);
   * // => []
   */
  function toArray(value) {
    if (!isArrayLike(value)) {
      return values(value);
    }
    return value.length ? copyArray(value) : [];
  }

  /**
   * Converts `value` to an integer.
   *
   * **Note:** This method is loosely based on
   * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toInteger(3.2);
   * // => 3
   *
   * _.toInteger(Number.MIN_VALUE);
   * // => 0
   *
   * _.toInteger(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toInteger('3.2');
   * // => 3
   */
  var toInteger = Number;

  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */
  var toNumber = Number;

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    if (typeof value == 'string') {
      return value;
    }
    return value == null ? '' : (value + '');
  }

  /*------------------------------------------------------------------------*/

  /**
   * Assigns own enumerable string keyed properties of source objects to the
   * destination object. Source objects are applied from left to right.
   * Subsequent sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object` and is loosely based on
   * [`Object.assign`](https://mdn.io/Object/assign).
   *
   * @static
   * @memberOf _
   * @since 0.10.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @see _.assignIn
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * function Bar() {
   *   this.c = 3;
   * }
   *
   * Foo.prototype.b = 2;
   * Bar.prototype.d = 4;
   *
   * _.assign({ 'a': 0 }, new Foo, new Bar);
   * // => { 'a': 1, 'c': 3 }
   */
  var assign = createAssigner(function(object, source) {
    copyObject(source, nativeKeys(source), object);
  });

  /**
   * This method is like `_.assign` except that it iterates over own and
   * inherited source properties.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @alias extend
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @see _.assign
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * function Bar() {
   *   this.c = 3;
   * }
   *
   * Foo.prototype.b = 2;
   * Bar.prototype.d = 4;
   *
   * _.assignIn({ 'a': 0 }, new Foo, new Bar);
   * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
   */
  var assignIn = createAssigner(function(object, source) {
    copyObject(source, nativeKeysIn(source), object);
  });

  /**
   * Creates an object that inherits from the `prototype` object. If a
   * `properties` object is given, its own enumerable string keyed properties
   * are assigned to the created object.
   *
   * @static
   * @memberOf _
   * @since 2.3.0
   * @category Object
   * @param {Object} prototype The object to inherit from.
   * @param {Object} [properties] The properties to assign to the object.
   * @returns {Object} Returns the new object.
   * @example
   *
   * function Shape() {
   *   this.x = 0;
   *   this.y = 0;
   * }
   *
   * function Circle() {
   *   Shape.call(this);
   * }
   *
   * Circle.prototype = _.create(Shape.prototype, {
   *   'constructor': Circle
   * });
   *
   * var circle = new Circle;
   * circle instanceof Circle;
   * // => true
   *
   * circle instanceof Shape;
   * // => true
   */
  function create(prototype, properties) {
    var result = baseCreate(prototype);
    return properties == null ? result : assign(result, properties);
  }

  /**
   * Assigns own and inherited enumerable string keyed properties of source
   * objects to the destination object for all destination properties that
   * resolve to `undefined`. Source objects are applied from left to right.
   * Once a property is set, additional values of the same property are ignored.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @see _.defaultsDeep
   * @example
   *
   * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
   * // => { 'a': 1, 'b': 2 }
   */
  var defaults = baseRest(function(object, sources) {
    object = Object(object);

    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      length = 1;
    }

    while (++index < length) {
      var source = sources[index];
      var props = keysIn(source);
      var propsIndex = -1;
      var propsLength = props.length;

      while (++propsIndex < propsLength) {
        var key = props[propsIndex];
        var value = object[key];

        if (value === undefined ||
            (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
          object[key] = source[key];
        }
      }
    }

    return object;
  });

  /**
   * Checks if `path` is a direct property of `object`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = { 'a': { 'b': 2 } };
   * var other = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.has(object, 'a');
   * // => true
   *
   * _.has(object, 'a.b');
   * // => true
   *
   * _.has(object, ['a', 'b']);
   * // => true
   *
   * _.has(other, 'a');
   * // => false
   */
  function has(object, path) {
    return object != null && hasOwnProperty.call(object, path);
  }

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  var keys = nativeKeys;

  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */
  var keysIn = nativeKeysIn;

  /**
   * Creates an object composed of the picked `object` properties.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The source object.
   * @param {...(string|string[])} [paths] The property paths to pick.
   * @returns {Object} Returns the new object.
   * @example
   *
   * var object = { 'a': 1, 'b': '2', 'c': 3 };
   *
   * _.pick(object, ['a', 'c']);
   * // => { 'a': 1, 'c': 3 }
   */
  var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
  });

  /**
   * This method is like `_.get` except that if the resolved value is a
   * function it's invoked with the `this` binding of its parent object and
   * its result is returned.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to resolve.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
   *
   * _.result(object, 'a[0].b.c1');
   * // => 3
   *
   * _.result(object, 'a[0].b.c2');
   * // => 4
   *
   * _.result(object, 'a[0].b.c3', 'default');
   * // => 'default'
   *
   * _.result(object, 'a[0].b.c3', _.constant('default'));
   * // => 'default'
   */
  function result(object, path, defaultValue) {
    var value = object == null ? undefined : object[path];
    if (value === undefined) {
      value = defaultValue;
    }
    return isFunction(value) ? value.call(object) : value;
  }

  /**
   * Creates an array of the own enumerable string keyed property values of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property values.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.values(new Foo);
   * // => [1, 2] (iteration order is not guaranteed)
   *
   * _.values('hi');
   * // => ['h', 'i']
   */
  function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
  }

  /*------------------------------------------------------------------------*/

  /**
   * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
   * corresponding HTML entities.
   *
   * **Note:** No other characters are escaped. To escape additional
   * characters use a third-party library like [_he_](https://mths.be/he).
   *
   * Though the ">" character is escaped for symmetry, characters like
   * ">" and "/" don't need escaping in HTML and have no special meaning
   * unless they're part of a tag or unquoted attribute value. See
   * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
   * (under "semi-related fun fact") for more details.
   *
   * When working with HTML you should always
   * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
   * XSS vectors.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category String
   * @param {string} [string=''] The string to escape.
   * @returns {string} Returns the escaped string.
   * @example
   *
   * _.escape('fred, barney, & pebbles');
   * // => 'fred, barney, &amp; pebbles'
   */
  function escape(string) {
    string = toString(string);
    return (string && reHasUnescapedHtml.test(string))
      ? string.replace(reUnescapedHtml, escapeHtmlChar)
      : string;
  }

  /*------------------------------------------------------------------------*/

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  /**
   * Creates a function that invokes `func` with the arguments of the created
   * function. If `func` is a property name, the created function returns the
   * property value for a given element. If `func` is an array or object, the
   * created function returns `true` for elements that contain the equivalent
   * source properties, otherwise it returns `false`.
   *
   * @static
   * @since 4.0.0
   * @memberOf _
   * @category Util
   * @param {*} [func=_.identity] The value to convert to a callback.
   * @returns {Function} Returns the callback.
   * @example
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36, 'active': true },
   *   { 'user': 'fred',   'age': 40, 'active': false }
   * ];
   *
   * // The `_.matches` iteratee shorthand.
   * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
   * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.filter(users, _.iteratee(['user', 'fred']));
   * // => [{ 'user': 'fred', 'age': 40 }]
   *
   * // The `_.property` iteratee shorthand.
   * _.map(users, _.iteratee('user'));
   * // => ['barney', 'fred']
   *
   * // Create custom iteratee shorthands.
   * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
   *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
   *     return func.test(string);
   *   };
   * });
   *
   * _.filter(['abc', 'def'], /ef/);
   * // => ['def']
   */
  var iteratee = baseIteratee;

  /**
   * Creates a function that performs a partial deep comparison between a given
   * object and `source`, returning `true` if the given object has equivalent
   * property values, else `false`.
   *
   * **Note:** The created function is equivalent to `_.isMatch` with `source`
   * partially applied.
   *
   * Partial comparisons will match empty array and empty object `source`
   * values against any array or object value, respectively. See `_.isEqual`
   * for a list of supported value comparisons.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Util
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   * @example
   *
   * var objects = [
   *   { 'a': 1, 'b': 2, 'c': 3 },
   *   { 'a': 4, 'b': 5, 'c': 6 }
   * ];
   *
   * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
   * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
   */
  function matches(source) {
    return baseMatches(assign({}, source));
  }

  /**
   * Adds all own enumerable string keyed function properties of a source
   * object to the destination object. If `object` is a function, then methods
   * are added to its prototype as well.
   *
   * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
   * avoid conflicts caused by modifying the original.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {Function|Object} [object=lodash] The destination object.
   * @param {Object} source The object of functions to add.
   * @param {Object} [options={}] The options object.
   * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
   * @returns {Function|Object} Returns `object`.
   * @example
   *
   * function vowels(string) {
   *   return _.filter(string, function(v) {
   *     return /[aeiou]/i.test(v);
   *   });
   * }
   *
   * _.mixin({ 'vowels': vowels });
   * _.vowels('fred');
   * // => ['e']
   *
   * _('fred').vowels().value();
   * // => ['e']
   *
   * _.mixin({ 'vowels': vowels }, { 'chain': false });
   * _('fred').vowels();
   * // => ['e']
   */
  function mixin(object, source, options) {
    var props = keys(source),
        methodNames = baseFunctions(source, props);

    if (options == null &&
        !(isObject(source) && (methodNames.length || !props.length))) {
      options = source;
      source = object;
      object = this;
      methodNames = baseFunctions(source, keys(source));
    }
    var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
        isFunc = isFunction(object);

    baseEach(methodNames, function(methodName) {
      var func = source[methodName];
      object[methodName] = func;
      if (isFunc) {
        object.prototype[methodName] = function() {
          var chainAll = this.__chain__;
          if (chain || chainAll) {
            var result = object(this.__wrapped__),
                actions = result.__actions__ = copyArray(this.__actions__);

            actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
            result.__chain__ = chainAll;
            return result;
          }
          return func.apply(object, arrayPush([this.value()], arguments));
        };
      }
    });

    return object;
  }

  /**
   * Reverts the `_` variable to its previous value and returns a reference to
   * the `lodash` function.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @returns {Function} Returns the `lodash` function.
   * @example
   *
   * var lodash = _.noConflict();
   */
  function noConflict() {
    if (root._ === this) {
      root._ = oldDash;
    }
    return this;
  }

  /**
   * This method returns `undefined`.
   *
   * @static
   * @memberOf _
   * @since 2.3.0
   * @category Util
   * @example
   *
   * _.times(2, _.noop);
   * // => [undefined, undefined]
   */
  function noop() {
    // No operation performed.
  }

  /**
   * Generates a unique ID. If `prefix` is given, the ID is appended to it.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {string} [prefix=''] The value to prefix the ID with.
   * @returns {string} Returns the unique ID.
   * @example
   *
   * _.uniqueId('contact_');
   * // => 'contact_104'
   *
   * _.uniqueId();
   * // => '105'
   */
  function uniqueId(prefix) {
    var id = ++idCounter;
    return toString(prefix) + id;
  }

  /*------------------------------------------------------------------------*/

  /**
   * Computes the maximum value of `array`. If `array` is empty or falsey,
   * `undefined` is returned.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Math
   * @param {Array} array The array to iterate over.
   * @returns {*} Returns the maximum value.
   * @example
   *
   * _.max([4, 2, 8, 6]);
   * // => 8
   *
   * _.max([]);
   * // => undefined
   */
  function max(array) {
    return (array && array.length)
      ? baseExtremum(array, identity, baseGt)
      : undefined;
  }

  /**
   * Computes the minimum value of `array`. If `array` is empty or falsey,
   * `undefined` is returned.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Math
   * @param {Array} array The array to iterate over.
   * @returns {*} Returns the minimum value.
   * @example
   *
   * _.min([4, 2, 8, 6]);
   * // => 2
   *
   * _.min([]);
   * // => undefined
   */
  function min(array) {
    return (array && array.length)
      ? baseExtremum(array, identity, baseLt)
      : undefined;
  }

  /*------------------------------------------------------------------------*/

  // Add methods that return wrapped values in chain sequences.
  lodash.assignIn = assignIn;
  lodash.before = before;
  lodash.bind = bind;
  lodash.chain = chain;
  lodash.compact = compact;
  lodash.concat = concat;
  lodash.create = create;
  lodash.defaults = defaults;
  lodash.defer = defer;
  lodash.delay = delay;
  lodash.filter = filter;
  lodash.flatten = flatten;
  lodash.flattenDeep = flattenDeep;
  lodash.iteratee = iteratee;
  lodash.keys = keys;
  lodash.map = map;
  lodash.matches = matches;
  lodash.mixin = mixin;
  lodash.negate = negate;
  lodash.once = once;
  lodash.pick = pick;
  lodash.slice = slice;
  lodash.sortBy = sortBy;
  lodash.tap = tap;
  lodash.thru = thru;
  lodash.toArray = toArray;
  lodash.values = values;

  // Add aliases.
  lodash.extend = assignIn;

  // Add methods to `lodash.prototype`.
  mixin(lodash, lodash);

  /*------------------------------------------------------------------------*/

  // Add methods that return unwrapped values in chain sequences.
  lodash.clone = clone;
  lodash.escape = escape;
  lodash.every = every;
  lodash.find = find;
  lodash.forEach = forEach;
  lodash.has = has;
  lodash.head = head;
  lodash.identity = identity;
  lodash.indexOf = indexOf;
  lodash.isArguments = isArguments;
  lodash.isArray = isArray;
  lodash.isBoolean = isBoolean;
  lodash.isDate = isDate;
  lodash.isEmpty = isEmpty;
  lodash.isEqual = isEqual;
  lodash.isFinite = isFinite;
  lodash.isFunction = isFunction;
  lodash.isNaN = isNaN;
  lodash.isNull = isNull;
  lodash.isNumber = isNumber;
  lodash.isObject = isObject;
  lodash.isRegExp = isRegExp;
  lodash.isString = isString;
  lodash.isUndefined = isUndefined;
  lodash.last = last;
  lodash.max = max;
  lodash.min = min;
  lodash.noConflict = noConflict;
  lodash.noop = noop;
  lodash.reduce = reduce;
  lodash.result = result;
  lodash.size = size;
  lodash.some = some;
  lodash.uniqueId = uniqueId;

  // Add aliases.
  lodash.each = forEach;
  lodash.first = head;

  mixin(lodash, (function() {
    var source = {};
    baseForOwn(lodash, function(func, methodName) {
      if (!hasOwnProperty.call(lodash.prototype, methodName)) {
        source[methodName] = func;
      }
    });
    return source;
  }()), { 'chain': false });

  /*------------------------------------------------------------------------*/

  /**
   * The semantic version number.
   *
   * @static
   * @memberOf _
   * @type {string}
   */
  lodash.VERSION = VERSION;

  // Add `Array` methods to `lodash.prototype`.
  baseEach(['pop', 'join', 'replace', 'reverse', 'split', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
    var func = (/^(?:replace|split)$/.test(methodName) ? String.prototype : arrayProto)[methodName],
        chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
        retUnwrapped = /^(?:pop|join|replace|shift)$/.test(methodName);

    lodash.prototype[methodName] = function() {
      var args = arguments;
      if (retUnwrapped && !this.__chain__) {
        var value = this.value();
        return func.apply(isArray(value) ? value : [], args);
      }
      return this[chainName](function(value) {
        return func.apply(isArray(value) ? value : [], args);
      });
    };
  });

  // Add chain sequence methods to the `lodash` wrapper.
  lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

  /*--------------------------------------------------------------------------*/

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = lodash;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return lodash;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = lodash)._ = lodash;
    // Export for CommonJS support.
    freeExports._ = lodash;
  }
  else {
    // Export to the global object.
    root._ = lodash;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47), __webpack_require__(108)(module)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    'use strict';

    var mapboxSetStyleMethodModifier = __webpack_require__(110);
    var mainConfig = __webpack_require__(18);

    var mapboxgl;
    var isRtlPluginSet = false;

    function tryToGetMapbox() {
        var mapbox, rtlPlugin, objectURL;
        try {
            mapbox = __webpack_require__(118);

            //This flag is necessary, because setRTLTextPlugin throws error
            //setRTLTextPlugin cannot be called multiple times
            if (!isRtlPluginSet) {
                rtlPlugin = __webpack_require__(119);
                objectURL = window.URL.createObjectURL(new window.Blob([rtlPlugin], { type: 'text/javascript' }));
                //setRTLTextPlugin expects objectURL
                mapbox.setRTLTextPlugin(objectURL);
                isRtlPluginSet = true;
            }
            mapboxSetStyleMethodModifier.modifySetStyle(mapbox);
            return mapbox;
        } catch (e) {
            /**
             * hack to have optional dependency of mapboxgl
             * If you have some problems with mapbox support uncomment line below.
             * We are swallowing some errors here.
             */
            //console.error(e, e.stack);
            return null;
        }
    }

    mapboxgl = tryToGetMapbox();

    return {
        setMapbox: function setMapbox(mapboxReference) {
            if (mapboxReference && mapboxReference.version !== mainConfig['mapboxgl.version']) {
                console.warn('TomTom Maps SDK for Web expects mapboxgl "' + mainConfig['mapboxgl.version'] + '" version.');
            }
            mapboxgl = mapboxReference;
            mapboxSetStyleMethodModifier.modifySetStyle(mapboxgl);
        },
        tryToSetMapbox: function tryToSetMapbox() {
            if (!this.isMapboxSet()) {
                mapboxgl = tryToGetMapbox();
            }
            return this.isMapboxSet();
        },
        getMapbox: function getMapbox() {
            if (!this.isMapboxSet()) {
                throw new Error('You should provide Mapbox GL JS reference first.');
            }
            return mapboxgl;
        },
        isMapboxSet: function isMapboxSet() {
            return Boolean(mapboxgl);
        },
        isMapboxSupported: function isMapboxSupported() {
            return this.tryToSetMapbox() && mapboxgl.supported();
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    return {
        or: function or(value, defaultValue) {
            return value || defaultValue;
        },

        required: function required(value, error) {
            if (value === undefined || value === null) {
                throw new TypeError(error);
            }
            return value;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (parameterApplications) {

    function isQueryParameter(fieldEntry) {
        var field = fieldEntry[1];
        return !field.application || field.application === parameterApplications.QUERY;
    }

    function isPathParam(fieldEntry) {
        var field = fieldEntry[1];
        return field.application === parameterApplications.PATH;
    }

    function isPostParam(fieldEntry) {
        var field = fieldEntry[1];
        return field.application === parameterApplications.POST;
    }

    function isOtherParam(fieldEntry) {
        var field = fieldEntry[1];
        return field.application === parameterApplications.OTHER;
    }

    function getFieldEntryName(fieldEntry) {
        return fieldEntry[0];
    }

    function toEntry(source) {
        return function (fieldName) {
            var name = source[fieldName] && source[fieldName].name || fieldName;
            return [name, source[fieldName]];
        };
    }

    function createParamsNames(fields, paramsFilterFunction) {
        return Object.keys(fields).map(toEntry(fields)).filter(paramsFilterFunction).map(getFieldEntryName);
    }

    function createQueryParamsNames(fields) {
        return createParamsNames(fields, isQueryParameter);
    }

    function createPathParamsNames(fields) {
        return createParamsNames(fields, isPathParam);
    }

    function createPostParamsNames(fields) {
        return createParamsNames(fields, isPostParam);
    }

    function createOtherParamsNames(fields) {
        return createParamsNames(fields, isOtherParam);
    }

    function createParams(fields, createParamNamesFunction, requestOptions) {
        var params = {};
        createParamNamesFunction(fields).forEach(function (paramName) {
            if (paramName in requestOptions) {
                params[paramName] = requestOptions[paramName];
            }
        });

        return params;
    }

    function createPathParams(fields, requestOptions) {
        return createParams(fields, createPathParamsNames, requestOptions);
    }

    return function (fields, requestOptions) {
        return {
            pathParams: createPathParams(fields, requestOptions),
            queryParams: createParams(fields, createQueryParamsNames, requestOptions),
            postParams: createParams(fields, createPostParamsNames, requestOptions),
            otherParams: createParams(fields, createOtherParamsNames, requestOptions)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_RESULT__ = function (LocaleService) {
    'use strict';

    return new LocaleService();
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Service for store and retrieve an specific locale setting.
 *
 * This service is used by map instances, widgets and services to store their locale
 * configuration.
 *
 * If its constructor receive a LocaleService instance as argument it will start listen changes in the
 * given instance and apply the same change in its own. That behavior allows the instances of this class to
 * be updated in cascade.
 *
 * @example
 * ```js
 * // Will use the global LocaleService
 * // You can obtain the global LocaleService calling tomtom.globalLocaleService()
 * tomtom.nearbySearch()
 *   .go()
 *
 * // Will ignore the global LocaleService and use the provided language
 * tomtom.nearbySearch()
 *   .language('pl-PL')
 *   .go();
 *
 * // Example how to use locales which are set per map instance
 * var mapLanguage = mapInstance.getLocaleService().getCurrentLocale();
 * tomtom.nearbySearch()
 *   .language(mapLanguage)
 *   .go();
 * ```
 *
 * @class LocaleService
 * @module Services
 * @extends L.Evented
 * @constructor
 * @param {LocaleService} [parent] If is defined makes the new instance a "slave" of the given instance
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32), __webpack_require__(1), __webpack_require__(56), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Locale, L, languageTypesMapping, Utils) {
    'use strict';

    var allLocales, trafficLocales, routingLocales, searchLocales, mapsLocales, LocaleService, EVENTS;
    var langsToIgnoreInAllSelector = ['NGT', 'NGT-Latn'];

    function createLocaleArrays(serviceType) {
        var prop, langType;
        var result = [];
        for (prop in languageTypesMapping) {
            if (languageTypesMapping.hasOwnProperty(prop)) {
                langType = languageTypesMapping[prop];

                if (!serviceType && langsToIgnoreInAllSelector.indexOf(prop) === -1 || langType[serviceType] && langType[serviceType].isNative === true) {

                    result.push(new Locale(prop));
                }
            }
        }
        return result.sort(function (a, b) {
            return a.getLabel().localeCompare(b.getLabel());
        });
    }

    allLocales = createLocaleArrays(null);
    trafficLocales = createLocaleArrays('traffic');
    routingLocales = createLocaleArrays('routing');
    searchLocales = createLocaleArrays('search');
    mapsLocales = createLocaleArrays('maps');

    EVENTS = {
        /**
         * Fired after the locale was changed.
         * @event LOCALE_CHANGED
         * @type String
         *
         * @example
         * ```javascript
         * var localeService = new LocaleService();
         * localeService.on(L.LocaleService.Events.LOCALE_CHANGED, function(eventData) {
         *  console.log(eventData);
         * });
         * ```
         */
        'LOCALE_CHANGED': 'config.locale.changed'
    };

    function localeChangedHandler(locale) {
        this.setCurrentLocale(locale.getLanguageCode());
    }

    LocaleService = L.Evented.extend({

        Events: EVENTS,

        initialize: function initialize(parent) {
            if (parent instanceof LocaleService) {
                this.currentLocale = new Locale(parent.getCurrentLocale().getLanguageCode());
                this.parent = parent;
                parent.on(EVENTS.LOCALE_CHANGED, localeChangedHandler, this);
            } else {
                this.currentLocale = new Locale('en-GB');
            }
        },

        /**
         * Sets locale used by a service instance.
         *
         * Fires the event {{#crossLink "LocaleService/LOCALE_CHANGED:event"}}{{/crossLink}}.
         *
         * @method setCurrentLocale
         * @param {String|Locale} [locale="en-GB"] String (with language code) or Locale instance
         */
        setCurrentLocale: function setCurrentLocale(locale) {
            if (!(locale instanceof Locale)) {
                this.currentLocale = new Locale(locale);
            } else {
                this.currentLocale = locale;
            }
            this.fire(EVENTS.LOCALE_CHANGED, this.currentLocale);
        },

        /**
         * Returns the current locale.
         *
         * @method getCurrentLocale
         * @return {Locale}
         */
        getCurrentLocale: function getCurrentLocale() {
            return this.currentLocale;
        },

        cleanEvents: function cleanEvents() {
            this.parent.off(EVENTS.LOCALE_CHANGED, localeChangedHandler, this);
            this.off();
        }
    });

    LocaleService.Events = EVENTS;
    Utils.addDeprecatedProperty(LocaleService.prototype, 'EVENTS', 'Events');

    /**
     * Static method that returns an array with the supported locales which are supported by given
     * service type.
     *
     * @static
     * @method LocaleService.getLocalesFor
     * @param {"traffic"|"routing"|"search"|"maps"|"reverseGeocoder"} [serviceType=null]
     * @return {Locale[]}
     */
    LocaleService.getLocalesFor = function (serviceType) {
        switch (serviceType) {
            case 'traffic':
                return trafficLocales;
            case 'routing':
                return routingLocales;
            case 'search':
            case 'reverseGeocoder':
                return searchLocales;
            case 'maps':
                return mapsLocales;
            default:
                return allLocales;
        }
    };

    L.LocaleService = LocaleService;

    L.localeService = function (parent) {
        return new LocaleService(parent);
    };
    return L.localeService;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Represent a locale configuration.
 *
 * @class Locale
 * @module Models
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56)], __WEBPACK_AMD_DEFINE_RESULT__ = function (languageTypesMapping) {
    'use strict';

    var validServiceTypes = ['routing', 'search', 'traffic', 'maps', 'reverseGeocoder'];

    function isValidServiceType(serviceType) {
        return validServiceTypes.indexOf(serviceType) > -1;
    }

    function Locale(languageCode) {
        if (!languageTypesMapping.hasOwnProperty(languageCode)) {
            console.warn('Incorrect language code passed to Locale constructor. Defaulting to en-GB');
            languageCode = 'en-GB';
        }
        this._languageCode = languageCode;
    }

    /**
     * Returns the label of the locale.
     * @method getLabel
     * @return {String}
     */
    Locale.prototype.getLabel = function () {
        return languageTypesMapping[this._languageCode].label;
    };

    /**
     * Returns the language's code of the locale.
     * @method getLanguageCode
     * @return {String}
     */
    Locale.prototype.getLanguageCode = function () {
        return this._languageCode;
    };

    /**
     * Returns the language's code for the given service type.
     *
     * @method getValueFor
     * @param {"routing"|"search"|"traffic"|"maps"} [serviceType] The service code.
     *  But we aware of these cases:
     *  - If an invalid code is given the language's code for the service "search" will be return.
     *  - If no value is given it will return the same value as the method
     *    {{#crossLink "Locale/getLanguageCode:method"}}{{/crossLink}}.
     * @return {String}
     */
    Locale.prototype.getValueFor = function (serviceType) {
        var value;
        if (!serviceType) {
            return this._languageCode;
        }
        if (!isValidServiceType(serviceType)) {
            console.warn('Unsupported type passed to getValueFor function in Locale.' + 'Expecting: ' + validServiceTypes.join(', ') + '. Defaulting to search');
            serviceType = 'search';
        }

        // Reverse geocoder supports the same set of languages as search
        if (serviceType === 'reverseGeocoder') {
            serviceType = 'search';
        }

        value = languageTypesMapping[this._languageCode][serviceType].fallback;
        return value !== undefined ? value : this._languageCode;
    };

    return Locale;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function (GeopolViewService) {
    'use strict';

    return new GeopolViewService();
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Service for store and retrieve an specific geopolitical view.
 *
 * This service is used by map instances, widgets and services to store their geopolitical
 * view configuration.
 *
 * If its constructor receive a GeopolViewService instance as argument it will start listen changes in the
 * given instance and apply the same change in its own. That behavior allows the instances of this class to
 * be updated in cascade.
 *
 * @class GeopolViewService
 * @module Services
 * @extends L.Evented
 * @constructor
 * @param {GeopolViewService} [parent] If is defined makes the new instance a "slave" of the given instance
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(35), __webpack_require__(1), __webpack_require__(58), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (GeopolView, L, geopolViewsMapping, Utils) {
    'use strict';

    var GeopolViewService;
    var defaultGeopolViewCode = 'Unified';
    var EVENTS = {
        /**
         * Fired after the view was changed.
         * @event GEOPOL_VIEW_CHANGED
         * @type String
         *
         * @example
         * ```javascript
         * var geopolViewService = new GeopolViewService();
         * geopolViewService.on(L.GeopolViewService.Events.GEOPOL_VIEW_CHANGED, function(eventData) {
         *  console.log(eventData);
         * });
         * ```
         */
        'GEOPOL_VIEW_CHANGED': 'config.geopolView.changed'
    };
    /**
     * @ignore
     * @return {GeopolView}
     */
    function getDefaultGeopolView() {
        return new GeopolView(defaultGeopolViewCode);
    }

    GeopolViewService = L.Evented.extend({

        Events: EVENTS,

        initialize: function initialize(parent) {
            if (parent instanceof GeopolViewService) {
                this.current = new GeopolView(parent.getCurrentGeopolView().getCode());
                this._enslaveTo(parent);
            } else {
                this.current = getDefaultGeopolView();
            }
        },

        /**
         * Sets the current geopolitical view.
         *
         * It also fires the event
         * {{#crossLink "GeopolViewService/GEOPOL_VIEW_CHANGED:event"}}{{/crossLink}}.
         *
         * @method setCurrentGeopolView
         * @param {String|GeopolView} [geopolView='Unified'] view code or a GeopolView instance
         */
        setCurrentGeopolView: function setCurrentGeopolView(geopolView) {
            if (Utils.isString(geopolView)) {
                geopolView = new GeopolView(geopolView);
            }
            if (this.current.getCode() !== geopolView.getCode()) {
                this.current = new GeopolView(geopolView.getCode());
                this.fire(EVENTS.GEOPOL_VIEW_CHANGED, this.current);
            }
        },

        /**
         * Returns the current geopolitical view stored in the instance.
         *
         * @method getCurrentGeopolView
         * @return {GeopolView}
         */
        getCurrentGeopolView: function getCurrentGeopolView() {
            return this.current;
        },

        cleanEvents: function cleanEvents() {
            if (this.parent) {
                this.parent.off(EVENTS.GEOPOL_VIEW_CHANGED, this.setCurrentGeopolView, this);
                this.parent = undefined;
            }
            this.off();
        },

        /**
         * Make this instance a slave of another GeopolViewService instance.
         * What it basically means is that this instance will copy the current
         * geopolitical view of the parent instance when it changes.
         *
         * @ignore
         * @param {GeopolViewService} parent
         */
        _enslaveTo: function _enslaveTo(parent) {
            this.parent = parent;
            parent.on(EVENTS.GEOPOL_VIEW_CHANGED, this.setCurrentGeopolView, this);
        }
    });

    /**
     * Static method that returns an array with the supported geopolitical views for the given service.
     *
     * Note: If no arguments are passed to this function it will return ALL the geopolitical views available
     * whether they are supported by a particular service or not. This was kept for backward compatibility.
     *
     * @static
     * @method GeopolViewService.getSupportedViews
     * @param {"search"|"maps"|"reverseGeocoder"} serviceType
     * @param {"raster"|"vector"|"all"} [subType] Only available for maps - Used to specify the subType of a
     * service, for example 'maps - raster' (If you pass 'all' it returns all the geopol views for the given
     * serviceType)
     * @return {GeopolView[]}
     */
    GeopolViewService.getSupportedViews = function (serviceType, subType) {
        var supportedServices = GeopolView.getSupportedServices();
        var supportedViews = [];
        subType = subType || 'all';

        // we keep this for backward compatibility
        if (arguments.length === 0) {
            return Object.keys(geopolViewsMapping).map(function (view) {
                return new GeopolView(view);
            });
        }

        if (supportedServices.indexOf(serviceType) === -1) {
            console.warn(serviceType + ' is not supported. Supported services: ' + supportedServices.join(', '));
            return [];
        }

        if (serviceType !== 'maps' && subType !== 'all' || serviceType === 'maps' && ['raster', 'vector', 'all'].indexOf(subType) === -1) {
            console.warn('Please specify a valid subType for this service. ' + 'Expecting: raster, vector or all (for the full list). Returning undefined.');
            return [];
        }

        Object.keys(geopolViewsMapping).forEach(function (view) {
            var viewMapping = geopolViewsMapping[view][serviceType];

            if (viewMapping && subType !== 'all') {
                viewMapping = viewMapping[subType];
            }

            if (viewMapping && viewMapping.fallback) {
                return;
            }

            supportedViews.push(new GeopolView(view));
        });

        return supportedViews;
    };

    GeopolViewService.Events = EVENTS;

    Utils.addDeprecatedProperty(GeopolViewService.prototype, 'EVENTS', 'Events');

    /**
     * Leaflet factory of this service.
     *
     * @param {GeopolViewService} parent
     * @return {GeopolViewService}
     */
    L.geopolViewService = function (parent) {
        return new GeopolViewService(parent);
    };

    L.GeopolViewService = GeopolViewService;

    return L.GeopolViewService;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * GeopolView class.
 *
 * @class GeopolView
 * @module Models
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(58)], __WEBPACK_AMD_DEFINE_RESULT__ = function (geopolViewsMapping) {
    'use strict';

    var validServiceTypes = ['search', 'maps', 'reverseGeocoder'];

    function isValidServiceType(serviceType) {
        return validServiceTypes.indexOf(serviceType) > -1;
    }

    /**
     * @ignore
     * @param {String} geopolCode
     */
    function GeopolView(geopolCode) {
        if (!geopolViewsMapping.hasOwnProperty(geopolCode)) {
            geopolCode = 'Unified';
            console.warn('Incorrect geopolitical view code passed to GeopolViewService.', 'Defaulting to "' + geopolCode + '".');
        }
        this.code = geopolCode;
    }

    /**
     * Returns the code of the geopolitical view.
     * @method getCode
     * @return {String}
     */
    GeopolView.prototype.getCode = function () {
        return this.code;
    };

    /**
     * Returns the label of the geopolitical view.
     * @method getLabel
     * @return {String}
     */
    GeopolView.prototype.getLabel = function () {
        return geopolViewsMapping[this.code].label;
    };

    /**
     * Returns the geopolitical view code for the given service type.
     *
     * @method getValueFor
     * @param {"search"|"maps"} [serviceType] The service code.
     *  But we aware of these cases:
     *  - If serviceType is not supported undefined will be returned;
     *  - If no value is given it will return the same value as the method
     *    {{#crossLink "GeopolView/getCode:method"}}{{/crossLink}}.
     *  - If a view is not supported for the given service it may fallback to Unified.
     * @param {"raster"|"vector"} [subType] Used to specify the subType of a service,
     * for example 'maps - raster' (Only available for maps);
     * @return {String}
     */
    GeopolView.prototype.getValueFor = function (serviceType, subType) {
        var fallbackValue, serviceMapping;
        if (!serviceType) {
            return this.code;
        }
        if (!isValidServiceType(serviceType)) {
            console.warn('Unsupported service type passed to getValueFor function in geopolView. ' + 'Expecting: ' + validServiceTypes.join(', ') + '. Returning undefined.');
            return undefined;
        }

        if (serviceType !== 'maps' && subType || serviceType === 'maps' && ['raster', 'vector'].indexOf(subType) === -1) {
            console.warn('Please specify a valid subType for this service. ' + 'Expecting: raster or vector. Returning undefined.');
            return undefined;
        }

        serviceMapping = geopolViewsMapping[this.code][serviceType];

        if (serviceMapping && subType) {
            serviceMapping = serviceMapping[subType];
        }

        if (serviceMapping && serviceMapping.fallback) {
            fallbackValue = serviceMapping.fallback;
            console.warn(this.code + ' is not supported by the service "' + serviceType + (subType ? ' - ' + subType : '') + '". Falling back to ' + fallbackValue + '.');
            return fallbackValue;
        }

        return this.code;
    };

    /**
     * Returns supported service types by geopolView
     *
     * @method getSupportedServices
     * @return {Array}
     */
    GeopolView.getSupportedServices = function () {
        return validServiceTypes;
    };

    Object.defineProperty(GeopolView.prototype, 'toString', {
        enumerable: false,
        value: function value() {
            return this.getCode();
        }
    });

    return GeopolView;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
		 _     _
		| |   (_)
		| |_   _ ___
		| __| | / __|
		| |_ _| \__ \
		 \__(_) |___/
		     _/ |
		    |__/

	t.js
	a micro-templating framework in ~400 bytes gzipped

	@author  Jason Mooberry <jasonmoo@me.com>
	@license MIT
	@version 0.1.0

*/
(function() {

	var blockregex = /\{\{(([@!]?)(.+?))\}\}(([\s\S]+?)(\{\{:\1\}\}([\s\S]+?))?)\{\{\/\1\}\}/g,
		valregex = /\{\{([=%])(.+?)\}\}/g;

	function t(template) {
		this.t = template;
	}

	function scrub(val) {
		return new Option(val).text.replace(/"/g,"&quot;");
	}

	function get_value(vars, key) {
		var parts = key.split('.');
		while (parts.length) {
			if (!(parts[0] in vars)) {
				return false;
			}
			vars = vars[parts.shift()];
		}
		return vars;
	}

	function render(fragment, vars) {
		return fragment
			.replace(blockregex, function(_, __, meta, key, inner, if_true, has_else, if_false) {

				var val = get_value(vars,key), temp = "", i;

				if (!val) {

					// handle if not
					if (meta == '!') {
						return render(inner, vars);
					}
					// check for else
					if (has_else) {
						return render(if_false, vars);
					}

					return "";
				}

				// regular if
				if (!meta) {
					return render(if_true, vars);
				}

				// process array/obj iteration
				if (meta == '@') {
					// store any previous vars
					// reuse existing vars
					_ = vars._key;
					__ = vars._val;
					for (i in val) {
						if (val.hasOwnProperty(i)) {
							vars._key = i;
							vars._val = val[i];
							temp += render(inner, vars);
						}
					}
					vars._key = _;
					vars._val = __;
					return temp;
				}

			})
			.replace(valregex, function(_, meta, key) {
				var val = get_value(vars,key);

				if (val || val === 0) {
					return meta == '%' ? scrub(val) : val;
				}
				return "";
			});
	}

	t.prototype.render = function (vars) {
		return render(this.t, vars);
	};

	//AMD, CommonJs, then globals
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return t;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = t;
  } else {
    window.t = window.t || t;
  }
}());


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    return {
        /**
        * This method tries to mitigate a bug causing background bleeding near tiles edges.
        * More info can be found here: LNS-9557
        * When this issue is fixed in Leaflet itself this method may be removed.
        */
        fixTileScale: function fixTileScale() {
            this.on('tileloadstart', function (event) {
                event.tile.style.transform += ' scale(1.002)';
            });
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(39)], __WEBPACK_AMD_DEFINE_RESULT__ = function (UnitService) {
    'use strict';

    return new UnitService();
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Service for store and retrieve an specific unit measurement.
 *
 * This service is used by map instances, widgets and services to store their unit measurement configuration.
 *
 * If its constructor receive a UnitService instance as argument it will start listen changes in the
 * given instance and apply the same change in its own. That behavior allows the instances of this class to
 * be updated in cascade.
 *
 * @class UnitService
 * @module Services
 * @extends L.Evented
 * @constructor
 * @param {UnitService} [parent] If is defined makes the new instance a "slave" of the given instance
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(135), __webpack_require__(1), __webpack_require__(16), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Unit, L, unitTypes, Utils) {
    'use strict';

    var UnitService, supportedUnits;

    var EVENTS = {
        /**
         * Fired after the unit is set.
         *
         * @event UNIT_CHANGED
         * @type String
         *
         * @example
         * ```javascript
         * var unitService = new UnitService();
         * unitService.on(L.UnitService.Events.UNIT_CHANGED, function(eventData) {
         *  console.log(eventData);  
         * });
         * ```
         */
        'UNIT_CHANGED': 'config.unit.changed'
    };

    function createUnitsArray() {
        return Object.keys(unitTypes).map(function (key) {
            return new Unit(key);
        });
    }

    supportedUnits = createUnitsArray();

    UnitService = L.Evented.extend({

        Events: EVENTS,

        initialize: function initialize(parent) {
            if (parent instanceof UnitService) {
                this.currentUnit = new Unit(parent.getCurrentUnit().getLabel());
                this.parent = parent;
                parent.on(EVENTS.UNIT_CHANGED, function (unit) {
                    this.setCurrentUnit(unit.getLabel());
                }, this);
            } else {
                this.currentUnit = new Unit('metric');
            }
        },
        /**
         * Sets a new measurement unit.
         *
         * Fires the event {{#crossLink "UnitService/UNIT_CHANGED:event"}}{{/crossLink}}.
         *
         * @method setCurrentUnit
         * @param {String|Unit} [unit="metric"] accepts a string (`metric`, `imperial`) or a Unit instance
         */
        setCurrentUnit: function setCurrentUnit(unit) {
            if (!(unit instanceof Unit)) {
                unit = new Unit(unit);
            }
            this.currentUnit = unit;
            this.fire(EVENTS.UNIT_CHANGED, this.currentUnit);
        },

        /**
         * Gets currently setted unit.
         *
         * @method getCurrentUnit
         * @return {Unit}
         */
        getCurrentUnit: function getCurrentUnit() {
            return this.currentUnit;
        }
    });

    /**
     * Static method that returns an array with the supported units.
     * @static
     * @method UnitService.getSupportedUnits
     * @return {Unit[]}
     */
    UnitService.getSupportedUnits = function () {
        return supportedUnits;
    };

    L.unitService = function (parent) {
        return new UnitService(parent);
    };

    L.UnitService = UnitService;

    UnitService.Events = EVENTS;
    Utils.addDeprecatedProperty(UnitService.prototype, 'EVENTS', 'Events');

    return L.unitService;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * It allows to calculate a route between two locations using the TomTom's
 * [Routing API - Calculate Route](https://developer.tomtom.com/routing-api/routing-api-documentation-routing/calculate-route);
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method go performs the actual call.
 *
 * The call is asynchronous therefore the user has two options to receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    go method to handle the response.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * ### The types used in routing service
 *  - point - latitude, longitude pair (in EPSG4326 projection), with the following constraints:
 *    - Latitude values must be in the range -90..+90 inclusive.
 *    - Longitude values must be in the range -180..+180 inclusive.
 *    - Example: 52.37245,4.89406
 *
 *  - circle - A circle with a center point and a radius (in meters).
 *    - The radius must be a positive integer with the maximum value of 20050000.
 *    - Note that larger integer values will not be rejected but lowered to the maximum value.
 *    - Example: circle(52.37245,4.89406,10000)
 *
 *  - location - A point or a circle.
 *    - Example: 52.37245,4.89406  circle(52.37245,4.89406,10000)
 *
 *  - dateTime - A date and time specified in RFC-3339 format with an optional time zone offset.
 *    - Example: 1996-12-19T16:39:57  1996-12-19T16:39:57-08:00
 *
 * @class Routing
 * @module Services
 * @uses Chain
 * @uses CommonRoutingParameters
 * @constructor
 *
 * @param {Object} [options] Options to be passed to the routing call,
 *     or Array of such options objects to perform batch request.
 * @param {String} [options.key=global API key] The API key to be used.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 * @param {Number} [options.accelerationEfficiency] Specifies the efficiency of converting chemical energy stored in
 * fuel to kinetic energy when the vehicle accelerates (i.e. KineticEnergyGained/ChemicalEnergyConsumed).
 * @param {Array} [options.allowVignette] List of 3-character ISO 3166-1 alpha-3 country codes of countries in which toll roads with vignettes are allowed.
 * @param {String} [options.alternativeType] Specifies the alternative type of the calculated alternatives compared to the reference route.
 * @param {String} [options.arriveAt] The date and time of arrival at the destination point
 * @param {Number} [options.auxiliaryPowerInkW] Specifies the amount of power consumed for sustaining auxiliary systems, in kilowatts (kW).
 * @param {Number} [options.auxiliaryPowerInLitersPerHour] Specifies the amount of fuel consumed for sustaining
 * auxiliary systems of the vehicle, in liters per hour. It can be used to specify consumption due to devices
 * and systems such as AC systems, radio, heating, etc.
 * @param {String} [options.avoid] Specifies something that the route calculation should try to avoid when
 *     determining the route.
 * @param {Array} [options.avoidAreas] A list of shapes to avoid for planning routes. <a href="#method_avoidAreas">See more</a>
 * @param {Array} [options.avoidVignette] List of 3-character ISO 3166-1 alpha-3 country codes of countries in which all toll roads with vignettes are to be avoided.
 * @param {Boolean} [options.computeBestOrder] Re-order the route waypoints to reduce the route length
 * @param {String} [options.computeTravelTimeFor] Setting this to _all_ provides additional information regards travel times.
 * @param {Array} [options.constantSpeedConsumptionInLitersPerHundredkm] Colon-delimited list of
 * CombustionConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
 * @param {Array} [options.constantSpeedConsumptionInkWhPerHundredkm] Colon-delimited list of
 * ElectricConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
 * @param {Number} [options.currentChargeInkWh] Specifies the current electric energy supply in kilowatt hours (kWh).
 * @param {Number} [options.currentFuelInLiters] Current supply of fuel in liters.
 * @param {Number} [options.decelerationEfficiency] Specifies the efficiency of converting kinetic energy to saved
 * (not consumed) fuel when the vehicle decelerates (i.e. ChemicalEnergySaved/KineticEnergyLost).
 * @param {String} [options.departAt] The date and time of departure from the origin point
 * @param {Number} [options.downhillEfficiency] Specifies the efficiency of converting potential energy to
 * saved (not consumed) fuel when the vehicle loses elevation (i.e. ChemicalEnergySaved/PotentialEnergyLost).
 * @param {Number} [options.fuelEnergyDensityInMJoulesPerLiter] Specifies the amount of chemical energy stored
 * in one liter of fuel in megajoules (MJ). It is used in conjunction with the Efficiency parameters for
 * conversions between saved or consumed energy and fuel.
 * @param {String} [options.hilliness] Degree of hilliness for thrilling route
 * @param {String} [options.instructionsType] If specified, guidance instructions will be returned (if
 *     available)
 * @param {String} [options.language] The language parameter determines the language of the guidance messages
 * @param {String|Array} [options.locations] Locations through which the route is calculated
 * @param {Number} [options.maxAlternatives] Number of desired alternative routes to be calculated
 * @param {Number} [options.maxChargeInkWh] Specifies the maximum electric energy supply in kilowatt hours (kWh)
 * that may be stored in the vehicle's battery.
 * @param {Number} [options.minDeviationDistance=0] At least how far **in meters** the alternative
 *     routes have to follow the reference route
 * @param {Number} [options.minDeviationTime=0] At least how far **in time (seconds)** the alternative
 *     routes have to follow the reference route
 * @param {String} [options.protocol] Protocol's type, one of "http" or "https".

 * @param {String} [options.report] Specifies which data should be reported for diagnosis purposes. Possible values:
 * * effectiveSettings reports the effective parameters or data used when calling the API. In the case of defaulted
 * parameters the default will be reflected where the parameter was not specified by the caller.
 * @param {String} [options.routeRepresentation] Specifies the representation of the set of routes provided as response
 * @param {String} [options.routeType] The type of route requested.
 * @param {String[]} [options.sectionType="travelMode"] Specifies which section types are reported in the route response. <a href="#method_sectionType">See more</a>
 * @param {Array} [options.supportingPoints] Array of supporting points used for constructing the route. <a href="#method_supportingPoints">See more</a>
 * @param {Boolean} [options.traffic] Determines if traffic data should be used to calculate the route
 * @param {String} [options.travelMode] The travel mode for the requested route
 * @param {Number} [options.uphillEfficiency] Specifies the efficiency of converting chemical energy stored in
 * fuel to potential energy when the vehicle gains elevation (i.e. PotentialEnergyGained/ChemicalEnergyConsumed).
 * @param {Number} [options.vehicleAxleWeight] The vehicle axle weight in kg.
 * @param {Boolean} [options.vehicleCommercial] True if vehicle is used for commercial purposes.
 * @param {String} [options.vehicleEngineType] The vehicle engine type.
 * @param {Number} [options.vehicleHeight] The vehicle height in m.
 * @param {Number} [options.vehicleLength] The vehicle length in meters.
 * @param {Array|String} [options.vehicleLoadType] The array of truck cargo classification.
 * @param {Number} [options.vehicleMaxSpeed] The maximal allowed vehicle speed in km/h.
 * @param {Number} [options.vehicleWeight] The vehicle weight in kg.
 * @param {Number} [options.vehicleWidth] The vehicle width in m.
 * @param {String} [options.windingness] Level of turns for thrilling route.
 *
 * @example
 * ```js
 * tomtom.routing()
 *   .locations('52.3,4.8:52.37,4.87')
 *   .go()
 *   .then(function(routeGeoJson) {
 *     console.log(routeGeoJson);
 *   });
 * ```
 */
/* eslint-enable max-len */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41), __webpack_require__(75), __webpack_require__(144), __webpack_require__(8), __webpack_require__(2), __webpack_require__(4), __webpack_require__(73)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restRouting, routingModel, batchRoutingModel, chain, validators, converters, getRoutingParameters) {
    'use strict';

    var LANGUAGE = {
        AfrikaansSouthAfrica: 'ar-ZA',
        Arabic: 'ar',
        Bulgarian: 'bg-BG',
        ChineseTaiwan: 'zh-TW',
        Czech: 'cs-CZ',
        Danish: 'da-DK',
        Dutch: 'nl-NL',
        EnglishGB: 'en-GB',
        EnglishUS: 'en-US',
        Finnish: 'fi-FI',
        French: 'fr-FR',
        German: 'de-DE',
        Greek: 'el-GR',
        Hungarian: 'hu-HU',
        Indonesian: 'id-ID',
        Italian: 'it-IT',
        Korean: 'ko-KR',
        Lithuanian: 'lt-LT',
        Malay: 'ms-MY',
        Norwegian: 'nb-NO',
        Polish: 'pl-PL',
        PortugueseBrazil: 'pt-BR',
        PortuguesePortugal: 'pt-PT',
        Russian: 'ru-RU',
        Slovak: 'sk-SK',
        Slovenian: 'sl-SI',
        Spanish: 'es-ES',
        SpanishMexico: 'es-MX',
        Swedish: 'sv-SE',
        Thai: 'th-TH',
        Turkish: 'tr-TR'
    };

    var fields = getRoutingParameters();

    var batchFields = {
        batchItems: {
            validator: validators.arrayOf(fields),
            converter: converters.arrayOf(fields)
        }
    };

    var routing = restRouting();

    function handleRouteChain(data, callback) {
        routing.calculateRoute(fields, data, function (response) {
            callback.call(this, routingModel(response));
        });
    }

    function handleBatchChain(data, callback) {
        routing.batch(fields, data, function (response) {
            callback.call(this, batchRoutingModel(response));
        });
    }

    return function (options) {
        var serviceFunction;
        options = options || {};
        options.__serviceType = 'routing';

        if (options instanceof Array) {
            serviceFunction = chain(batchFields, handleBatchChain, {
                batchItems: options
            });
        } else {
            serviceFunction = chain(fields, handleRouteChain, options);
        }
        serviceFunction.LANGUAGE = LANGUAGE;
        return serviceFunction;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(142), __webpack_require__(10), __webpack_require__(6), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (matrixFactory, requestFactory, endpoints, ApiKeyNames) {
    'use strict';

    var maxNoOfElementsInBatchRequest = 100,
        routingKeyName = ApiKeyNames.routing;

    return function () {
        return {
            calculateRoute: requestFactory.single(endpoints.routing, routingKeyName),

            calculateReachableRange: requestFactory.single(endpoints.reachableRange, routingKeyName),

            batch: requestFactory.batch(maxNoOfElementsInBatchRequest, {
                batchSync: endpoints.batchSyncRouting,
                batch: endpoints.batchRouting,
                single: endpoints.batchRoutingQuery
            }, routingKeyName),

            batchReachableRange: requestFactory.batch(maxNoOfElementsInBatchRequest, {
                batchSync: endpoints.batchSyncRouting,
                batch: endpoints.batchRouting,
                single: endpoints.batchReachableRangeQuery
            }, routingKeyName),

            matrix: matrixFactory(maxNoOfElementsInBatchRequest)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
    var engineType = {
        combustion: 'combustion',
        electric: 'electric',
        any: 'any'
    };

    function validateIfPointsGreaterOrEqual(speedsAndConsumptions) {
        var sortedKeys = Object.keys(speedsAndConsumptions).sort(function (x, y) {
            return parseFloat(x) > parseFloat(y);
        });
        var keysLength = sortedKeys.length;
        if (speedsAndConsumptions[sortedKeys[0]] > speedsAndConsumptions[sortedKeys[1]]) {
            throw new Error('Consumption for two lowest speeds should be increasing');
        }
        if (speedsAndConsumptions[sortedKeys[keysLength - 2]] > speedsAndConsumptions[sortedKeys[keysLength - 1]]) {
            throw new Error('Consumption for two highest speeds should be increasing');
        }
    }

    function validateFloat(val) {
        if (isNaN(parseFloat(val)) || !isFinite(val)) {
            throw new Error('Expecting float, got: ' + val);
        }
    }

    /**
     * @param {String[]} arr
     */
    function consumptionPairsValidator(arr) {
        var speedsAndConsumptions = {};
        arr.forEach(function (element) {
            var pair = element.split(',');
            if (pair.length !== 2) {
                throw new Error('Invalid number of parameters in the pair around ' + element);
            }
            validateFloat(pair[0]);
            validateFloat(pair[1]);
            if (speedsAndConsumptions.hasOwnProperty(parseFloat(pair[0]))) {
                throw new Error('Duplicate speed: ' + pair[0]);
            } else {
                speedsAndConsumptions[parseFloat(pair[0])] = parseFloat(pair[1]);
            }
        });
        if (Object.keys(speedsAndConsumptions).length > 1) {
            validateIfPointsGreaterOrEqual(speedsAndConsumptions);
        }
    }

    function checkIfCorrectEngineType(obj, type) {
        if (obj.vehicleEngineType && obj.vehicleEngineType !== type && type !== engineType.any) {
            throw new Error('Expecting vehicleEngineType set to ' + type);
        }
    }

    function efficiencyParameterRequired(obj, paramName) {
        if (!(utils.isValidValue(obj.accelerationEfficiency) && utils.isValidValue(obj.decelerationEfficiency) && utils.isValidValue(obj.uphillEfficiency) && utils.isValidValue(obj.downhillEfficiency))) {
            throw new Error('Efficiency parameters are required when using ' + paramName);
        }
    }

    function hasEfficiencyParameterSet(obj) {
        return obj.accelerationEfficiency || obj.decelerationEfficiency || obj.uphillEfficiency || obj.downhillEfficiency;
    }

    function validateDependantParameters(obj, paramName1, paramName2) {
        if (!(obj[paramName1] && obj[paramName2])) {
            throw new Error('Missing dependant parameter. Expecting both defined: ' + paramName1 + ', ' + paramName2);
        }
    }

    function validateEfficiencyParameters(obj, paramName1, paramName2) {
        if (obj[paramName1] * obj[paramName2] > 1) {
            throw new Error('Product of ' + paramName1 + ' and ' + paramName2 + ' cannot exceed 1');
        }
    }

    /**
     * @ignore
     * Consumption Model cannot be used with travelMode values bicycle and pedestrian.
     * @param {Object} obj
     */
    function validateTravelMode(obj) {
        if (obj.travelMode === 'bicycle' || obj.travelMode === 'pedestrian') {
            throw new Error('Consumption model parameters cannot be set if travelMode is set to bicycle or pedestrian');
        }
    }

    /**
     * @ignore
     * All parameters require constantSpeedConsumption* to be specified by the user. It is an
     * error to specify any other consumption model parameter (with the exception of vehicleWeight)
     * if constantSpeedConsumption* is not specified.
     * @param {Object} obj
     */
    function hasConstantSpeedConsumption(obj) {
        if (!obj.constantSpeedConsumptionInLitersPerHundredkm && !obj.constantSpeedConsumptionInkWhPerHundredkm) {
            throw new Error('Consumption model cannot be used without setting constant speed consumption parameter');
        }
    }

    return {
        /**
         * @ignore
         * The list must contain between 1 and 25 points (inclusive), and may not contain
         * duplicate points for the same speed. If it only contains a single point, then the
         * consumption rate of that point is used without further processing.
         * Consumption specified for the largest speed must be greater than or equal to
         * that of the penultimate largest speed. This ensures that extrapolation does not
         * lead to negative consumption rates. Similarly, consumption values specified for the
         * two smallest speeds in the list cannot lead to a negative consumption rate for any smaller speed.
         * The minimum and maximum values described here refer to the valid range for the consumption
         * values (expressed in l/100km.
         * @param {Number} engineType
         * @param {Object} obj
         * @return {Function} function
         */
        constantSpeedConsumption: function constantSpeedConsumption(engineType) {
            return function (value, obj) {
                var speedPairs;
                if (value === undefined || value === null) {
                    return;
                }
                validateTravelMode(obj);
                checkIfCorrectEngineType(obj, engineType);
                if (typeof value !== 'string') {
                    throw new TypeError('Expecting a String like "15.2,12.2:8.0,9.0"');
                }
                speedPairs = value.split(':');
                if (speedPairs.length < 1 || speedPairs.length > 25) {
                    throw new Error('Incorrect amount of speed-consumption pairs provided. Expecting 1-25, but got ' + value.length);
                }
                consumptionPairsValidator(speedPairs);
            };
        },
        vehicleWeight: function vehicleWeight(value, obj) {
            if (hasEfficiencyParameterSet(obj) && value === undefined) {
                throw new Error('vehicleWeight parameter must be set if any efficiency parameters is present');
            }
        },
        floatAndEngineType: function floatAndEngineType(engineType, paramName) {
            return function (value, obj) {
                if (!value) {
                    return;
                }
                validateTravelMode(obj);
                hasConstantSpeedConsumption(obj);
                checkIfCorrectEngineType(obj, engineType);
                validateFloat(value);
                if (value < 0) {
                    throw new Error(paramName + ': Expecting positive value');
                }
            };
        },
        fuelEnergyDensityInMJoulesPerLiter: function fuelEnergyDensityInMJoulesPerLiter(value, obj) {
            if (!value) {
                return;
            }
            validateTravelMode(obj);
            validateFloat(value);
            hasConstantSpeedConsumption(obj);
            checkIfCorrectEngineType(obj, 'combustion');
            efficiencyParameterRequired(obj, 'fuelEnergyDensityInMJoulesPerLiter');
        },
        /**
         * @ignore
         * accelerationEfficiency and decelerationEfficiency must always be specified as a pair (i.e. both or none).
         * uphillEfficiency and downhillEfficiency must always be specified as a pair (i.e. both or none).
         * If accelerationEfficiency and decelerationEfficiency are specified,
         * product of their values must not be greater than 1 (to prevent perpetual motion).
         * If uphillEfficiency and downhillEfficiency are specified, product of their
         * values must not be greater than 1 (to prevent perpetual motion).
         * @param {Number} paramName1
         * @param {Number} paramName2
         * @return {undefined} undefined
         */
        efficiencyParameter: function efficiencyParameter(paramName1, paramName2) {
            return function (value, obj) {
                if (!value) {
                    return;
                }
                validateTravelMode(obj);
                hasConstantSpeedConsumption(obj);
                checkIfCorrectEngineType(obj, engineType.any);
                validateDependantParameters(obj, paramName1, paramName2);
                /**
                 * @ignore
                 * If *Efficiency parameters are specified by the user, then vehicleWeight must also be specified.
                 */
                validateDependantParameters(obj, paramName1, 'vehicleWeight');
                /**
                 * @ignore
                 * When vehicleEngineType is combustion, fuelEnergyDensityInMJoulesPerLiter must be specified as well.
                 */
                if (obj.vehicleEngineType === engineType.combustion) {
                    validateDependantParameters(obj, paramName1, 'fuelEnergyDensityInMJoulesPerLiter');
                }
                validateEfficiencyParameters(obj, paramName1, paramName2);
                validateFloat(value);
            };
        },
        chargeParameter: function chargeParameter(paramName1, paramName2) {
            return function (value, obj) {
                if (!value) {
                    return;
                }
                validateTravelMode(obj);
                hasConstantSpeedConsumption(obj);
                checkIfCorrectEngineType(obj, engineType.electric);
                validateDependantParameters(obj, paramName1, paramName2);
                validateFloat(value);
            };
        },
        budgetInRange: function budgetInRange(value, data) {
            // eslint-disable-line no-unused-vars
            var maxBudget;
            var currentBudgetProvided;
            var electricEngine = data.vehicleEngineType === 'electric';
            if (electricEngine) {
                maxBudget = data.currentChargeInkWh;
                currentBudgetProvided = data.energyBudgetInkWh;
                if (currentBudgetProvided > maxBudget) {
                    throw new Error('Energy budget may not be greater than current energy.');
                }
            } else {
                maxBudget = data.currentFuelInLiters;
                currentBudgetProvided = data.fuelBudgetInLiters;
                if (currentBudgetProvided > maxBudget) {
                    throw new Error('Fuel budget may not be greater than current fuel.');
                }
            }
            if (currentBudgetProvided < 0) {
                throw new Error('Budget may not be negative.');
            }
        },
        requiredBudget: function requiredBudget(value, data) {
            // eslint-disable-line no-unused-vars
            var liters = data.fuelBudgetInLiters;
            var watts = data.energyBudgetInkWh;
            var time = data.timeBudgetInSec;
            if ([liters, watts, time].filter(function (n) {
                return n !== undefined;
            }).length > 1) {
                // both true or false -> logical xor
                throw new Error('Exactly one of fuelBudgetInLiters and energyBudgetInkWh and timeBudgetInSec must be set.'); // eslint-disable-line
            }
        },
        requiredWithSpecificEngineType: function requiredWithSpecificEngineType(value, data, key) {
            var consumptionInLiters = 'constantSpeedConsumptionInLitersPerHundredkm' in data;
            var consumptionInWatts = 'constantSpeedConsumptionInkWhPerHundredkm' in data;
            var electricEngine = data.vehicleEngineType === 'electric';

            if (key === 'energyBudgetInkWh' && value) {
                if (!electricEngine) {
                    throw new Error('Engine type should be "electric" when energyBudgetInkWh is set');
                }
                if (!consumptionInWatts) {
                    throw new Error('Missing constant speed consumption for electric engine.');
                }
            } else if (key === 'fuelBudgetInLiters' && value) {
                if (electricEngine) {
                    throw new Error('Engine type should be "combustion" or undefined when fuelBudgetInLiters is set');
                }
                if (!consumptionInLiters) {
                    throw new Error('Missing constant speed consumption for combustion engine.');
                }
            }
        },
        notCommon: function notCommon(value, data, key) {
            // eslint-disable-line no-unused-vars
            var forbiddenAvoids = ['alreadyUsedRoads'];
            var forbiddenModes = ['bicycle', 'pedestrian'];
            if ('arriveAt' in data || 'avoid' in data && forbiddenAvoids.indexOf(data.avoid) >= 0 || 'travelMode' in data && forbiddenModes.indexOf(data.travelMode) >= 0) {
                throw new Error(key + ' parameter is not allowed in Calculate Reachable Route request');
            }
        },
        firstParamCannotBeUsedWithSecond: function firstParamCannotBeUsedWithSecond(paramNameUsed, paramNameToAvoid) {
            return function (value, obj) {
                if (!value) {
                    return;
                }
                if (obj.hasOwnProperty(paramNameToAvoid) && utils.isValidValue(obj[paramNameToAvoid])) {
                    throw new Error(paramNameUsed + ' parameter cannot be used in conjunction with ' + paramNameToAvoid);
                }
            };
        },
        requiresDependantParameter: function requiresDependantParameter(parameterName, dependantParameter) {
            return function (value, obj) {
                if (!value) {
                    return;
                }
                if (!obj.hasOwnProperty(dependantParameter)) {
                    throw new Error(dependantParameter + ' must be specified when using with ' + parameterName);
                }
            };
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return {
        reverseGeocode: 'reverseGeocode',
        crossStreetLookup: 'reverseGeocode/crossStreet'
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return {
        search: 'search',
        poi: 'poiSearch',
        category: 'categorySearch',
        geometry: 'geometrySearch',
        nearby: 'nearbySearch',
        lowBandwidth: 's',
        searchAlongRoute: 'searchAlongRoute'
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (selector) {
    'use strict';

    return function (json) {
        return selector(json, 'results', 'address, dist, position, score, entryPoints,' + ' type, addressRanges, boundingBox, viewport, id, info, dataSources, entityType') || {};
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This widget allows to create a foldable widget over the map.
 *
 * @class Foldable
 * @namespace L
 * @extends L.Control
 * @module Widgets
 * @constructor
 * @method foldable
 * @param {Object} [options] Options to be passed to the foldable control
 * @param {String} [options.className=""] Class prefix that will be added to container
 * @param {String} [options.title=""] Title of the container. If it's null the title will be hidden.
 * @param {Object} [options.close=null] If is an object the Close button will be appear
 * @param {String} [options.close.text] Text displayed in the Close button
 * @param {String} [options.close.image] Image of the Close button
 * @param {Object} [options.show=null] If is an object the Show button will be appear
 * @param {String} [options.show.text] Text displayed in the Show button
 * @param {String} [options.show.image] Image of the Show button
 * @param {Boolean} [options.closeOnClick=false] Should component collapse when clicked
 * @param {Boolean} [options.closeOnMapClick=true] Should component collapse when map is clicked
 * @param {"topright"|"topleft"|"bottomright"|"bottomleft"} [options.position="topright"] Position on a map
 * @param {String} [options.content=null] Initial content of the widget. Should be a string with valid HTML syntax.
 * @param {Boolean} [options.collapsed=false] Initial state of the foldable widget
 * @param {Boolean} [options.responsive=false] Listens to window resize events and adjusts the content height to 
 * fit the map, when the map size changes.
 *
 * @example
 * ```javascript
 * var widget = new L.Foldable({
 *   title: 'Foldable widget',
 *   closeOnClick: true,
 *   show: {
 *     text: 'show'
 *   }
 * });
 * widget.addTo(map);
 * ```
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, Utils) {
    'use strict';

    var zIndex = 1001;

    var classes = {
        contentContainer: 'tomtom-foldable__content',
        contentHeader: 'tomtom-foldable__content-header',
        contentBody: 'tomtom-foldable__content-body',
        collapsed: 'tomtom-foldable--collapsed',
        footerContainer: 'tomtom-foldable__footer',
        footerBody: 'tomtom-foldable__footer-body'
    };

    function createContainer(options) {
        var prefix = Utils.isString(options.className) ? options.className : '';
        var className = (prefix + ' tomtom-foldable leaflet-popup-content-wrapper').trim();
        return L.DomUtil.create('div', className);
    }

    function createCloseButton(container, options) {
        var button;
        if (!options.close) {
            return null;
        }
        button = L.DomUtil.create('button', 'tomtom-foldable__close tomtom-foldable--clickable', container);
        if (options.close.text) {
            button.innerHTML = options.close.text;
        } else if (options.close.image) {
            button.style.cssText = 'background-image: url(' + options.close.image + '); ';
        }
        return button;
    }

    function createShowButton(container, options) {
        var button;
        if (!options.show) {
            return null;
        }
        button = L.DomUtil.create('button', 'tomtom-foldable__show tomtom-foldable--clickable', container);
        if (options.show.text) {
            button.innerHTML = options.show.text;
        } else if (options.show.image) {
            button.style.cssText = 'background-image: url(' + options.show.image + '); ';
        }
        return button;
    }

    function createTitle(container, options) {
        var title = null;
        title = L.DomUtil.create('h4', 'tomtom-foldable__title', container);
        if (Utils.isString(options.title)) {
            title.innerHTML = options.title;
        }
        return title;
    }

    function createFooter(container, options) {
        var footer = L.DomUtil.create('div', classes.footerBody, container);
        if (options.footer instanceof HTMLElement) {
            footer.appendChild(options.footer);
        }
        return footer;
    }

    function createContentContainer(container, options) {
        var content = L.DomUtil.create('div', classes.contentBody, container);
        if (options.content) {
            content.innerHTML = options.content;
        }
        return content;
    }

    function createDomElements() {
        this.container = createContainer(this.options);

        this._header = L.DomUtil.create('div', 'tomtom-foldable__header', this.container);
        createTitle(this._header, this.options);
        this._close = createCloseButton(this._header, this.options);
        this._show = createShowButton(this._header, this.options);
        this._content = L.DomUtil.create('div', classes.contentContainer, this.container);
        this._contentHeader = L.DomUtil.create('div', classes.contentHeader, this._content);
        this._contentBody = createContentContainer(this._content, this.options);
        if (this.options.footer) {
            this._footer = L.DomUtil.create('div', classes.footerContainer, this.container);
            createFooter(this._footer, this.options);
        }
        return this.container;
    }

    function clearElementContent(element) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    }

    function _addContent(content, parent) {
        var element;

        if (typeof content === 'undefined') {
            return;
        }

        if (content instanceof HTMLElement) {
            element = content;
        } else {
            element = document.createTextNode(content);
        }

        parent.appendChild(element);
    }

    L.Foldable = L.Control.extend({

        options: {
            title: '',
            close: null,
            closeOnClick: false,
            closeOnMapClick: true,
            show: null,
            position: 'topright',
            collapsed: false,
            content: null,
            responsive: false
        },

        initialize: function initialize(options) {
            L.setOptions(this, options);
        },

        /**
         * Binds handlers to events and creates HTML elements used by the
         * component. Called when added control to a map.
         *
         * @ignore
         * @method onAdd
         * @param {Object} map Leaflet map to add control to.
         * @example
         * ```javascript
         * var widget = new L.Foldable();
         * widget.addTo(map);
         * ```
         * @return {HTMLElement}
         */
        onAdd: function onAdd(map) {
            this._map = map;

            if (this.options.closeOnMapClick) {
                this._map.on('preclick', this.fold, this);
            }

            createDomElements.call(this);

            L.DomEvent.disableScrollPropagation(this.container);
            L.DomEvent.disableClickPropagation(this.container);

            L.DomEvent.on(this.container, 'click', this._bringToFront, this);

            if (this.options.closeOnClick) {
                L.DomEvent.on(this._content, 'click', this.fold, this);
            }

            if (this._close) {
                L.DomEvent.on(this._close, 'click', this.fold, this);
            }

            if (this._show) {
                L.DomEvent.on(this._show, 'click', this.unfold, this);
            }

            if (this.options.collapsed) {
                this.fold();
            } else {
                this.unfold();
            }

            if (this.options.responsive) {
                this._setContentBodyMaxHeightRef = Utils.debounce(this, this._setContentBodyMaxHeight, 250);
                window.addEventListener('resize', this._setContentBodyMaxHeightRef);
            }

            return this.container;
        },

        /**
         * Removes event listeners added by onAdd method.
         * Called on foldable.remove()
         *
         * @ignore
         * @method onRemove
         * @param {Object} map Leaflet map to remove control from.
         * @example
         * ```javascript
         * var widget = new L.Foldable();
         * widget.addTo(map);
         * // some code here...
         * widget.remove();
         * ```
         */
        onRemove: function onRemove(map) {
            map.off('preclick', this.fold, this);
            if (this.options.closeOnClick) {
                L.DomEvent.off(this._content, 'click', this.fold, this);
            }
            if (this._close) {
                L.DomEvent.off(this._close, 'click', this.fold, this);
            }
            if (this._show) {
                L.DomEvent.off(this._show, 'click', this.unfold, this);
            }
            L.DomEvent.off(this.container, 'click', this._bringToFront, this);
            if (this._timeout) {
                clearTimeout(this._timeout);
            }
            if (this.options.responsive) {
                window.removeEventListener('resize', this._setContentBodyMaxHeightRef);
            }
        },

        /**
         * Folds the content and shows the <b>show</b> button (to unfold it again later).
         *
         * This method is executed automatically when the widget loose focus (e.g. the user starts interacting
         * with another widget or the map).
         *
         * @method fold
         * @chainable
         * @example
         * ```javascript
         * var widget = new L.Foldable({collapsed: false});
         * widget.addTo(map);
         * widget.setContent('No data');
         * widget.fold();
         * ```
         * @return {L.Foldable}
         */
        fold: function fold() {
            this.container.classList.add(classes.collapsed);
            this._content.style.maxHeight = 0;
            return this;
        },

        _isCollapsed: function _isCollapsed() {
            return this.container.classList.contains(classes.collapsed);
        },

        _setContentBodyMaxHeight: function _setContentBodyMaxHeight() {
            //This hardcoded offset is used to not cover copyrights
            var additionalOffset = 60;
            var mapRect = this._map.getContainer().getBoundingClientRect();
            var mapHeight = mapRect.height;
            var offset = this.container.offsetTop;

            if (this._footer) {
                offset = Math.abs(offset + this._footer.getBoundingClientRect().height);
            }
            if (this._header) {
                offset = Math.abs(offset + this._header.getBoundingClientRect().height);
            }

            this._content.style.maxHeight = Math.floor(mapHeight - offset - additionalOffset) + 'px';
        },

        /**
         * Unfolds component's content.
         *
         * This method is executed when the user presses the <b>show</b> button.
         *
         * @method unfold
         * @chainable
         * @example
         * ```javascript
         * var widget = new L.Foldable();
         * widget.addTo(map);
         * widget.unfold();
         * ```
         * @return {L.Foldable}
         */
        unfold: function unfold() {
            this.container.classList.remove(classes.collapsed);
            this._setContentBodyMaxHeight();
            return this;
        },

        /**
         * Clears all the widget's content.
         *
         * @method clear
         * @chainable
         * @example
         * ```javascript
         * var widget = new L.Foldable();
         * widget.addTo(map);
         * // some time later
         * widget.clear();
         * ```
         * @return {L.Foldable}
         */
        clear: function clear() {
            clearElementContent(this._contentBody);
            clearElementContent(this._contentHeader);
            return this;
        },

        /**
         * It appends content into the results list.
         *
         * @method addContent
         * @chainable
         * @param {String|HTMLElement} content content to append
         * @example
         * ```javascript
         * var results = [1, 2, 3];
         * var widget = new L.Foldable();
         * widget.addTo(map);
         * widget.setContent('Length: ');
         * widget.addContent(results.length);
         * ```
         * @return {L.Foldable}
         */
        addContent: function addContent(content) {
            _addContent(content, this._contentBody);
            if (!this._isCollapsed()) {
                this._setContentBodyMaxHeight();
            }

            return this;
        },

        /**
         * It appends content into the results list header.
         *
         * @method addContentHeader
         * @chainable
         * @param {String|HTMLElement} content content to append
         * @example
         * ```javascript
         * var widget = new L.Foldable();
         * widget.addTo(map);
         * widget.addContentHeader('This is a header');
         * ```
         * @return {L.Foldable}
         */
        addContentHeader: function addContentHeader(content) {
            _addContent(content, this._contentHeader);
            if (!this._isCollapsed()) {
                this._setContentBodyMaxHeight();
            }

            return this;
        },

        /**
         * Sets (and replaces) all the content of the results list.
         *
         * @method setContent
         * @param {String|HTMLElement} content new content
         * @chainable
         * @example
         * ```javascript
         * var widget = new L.Foldable();
         * widget.addTo(map);
         * widget.setContent('Initial content');
         * widget.setContent('New content');
         * ```
         * @return {L.Foldable}
         */
        setContent: function setContent(content) {
            return this.clear().addContent(content);
        },

        _bringToFront: function _bringToFront() {
            zIndex += 1;
            this.container.parentElement.style.zIndex = zIndex;
        }

    });

    return function (options) {
        return new L.Foldable(options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 47 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Helper module to create {{#crossLink "StaticMapImage"}}{{/crossLink}} instances from
 * already existing {{#crossLink "L.Map"}}{{/crossLink}} instances.
 *
 * @private
 * @class StaticMapImageFactory
 * @module Services
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(49), __webpack_require__(5), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (StaticMapImage, Security, L) {
    'use strict';

    /**
     * @ignore
     * Given a L.Map instance it returns a generic object with the necessary configuration to create a valid
     * {{#crossLink "StaticMapImage"}}{{/crossLink}} instance.
     *
     * @param {L.Map} mapInstance
     * @return {Object} StaticMapImage configuration
     */

    function getConfigFromMapInstance(mapInstance) {
        var config = {};
        if (mapInstance.options.layer) {
            config.layer = mapInstance.options.layer;
        }
        if (mapInstance.options.style) {
            config.style = mapInstance.options.style;
        }
        config.key = Security.getKey('services/display');
        config.center = mapInstance.getCenter().wrap();
        config.zoom = mapInstance.getZoom();
        config.width = mapInstance.getSize().x;
        config.height = mapInstance.getSize().y;
        config.language = mapInstance.getLocaleService().getCurrentLocale().getLanguageCode();
        return config;
    }

    /**
     * Returns a configured {{#crossLink "StaticMapImage"}}{{/crossLink}} instance based in the current state of the
     * given {{#crossLink "L.Map"}}{{/crossLink}} instance.
     * @method createFromMapInstance
     * @param {L.Map} mapInstance
     * @return {StaticMapImage}
     */
    function createFromMapInstance(mapInstance) {
        var config = getConfigFromMapInstance(mapInstance);
        return new StaticMapImage(config);
    }

    L.Map.include({
        /* This method is documented directly in map.js due to a yuidoc's bug in the @for tag */
        getStaticMapUrl: function getStaticMapUrl() {
            var result = null;
            createFromMapInstance(this).go(function (url) {
                result = url;
            });
            return result;
        }
    });

    return {
        createFromMapInstance: createFromMapInstance,
        getConfigFromMapInstance: getConfigFromMapInstance
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This class makes it easy to generate URL string to request a static map image using the TomTom's
 * [Maps API - Static Image](https://developer.tomtom.com/maps-api/maps-api-documentation-raster/static-image).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "StaticMapImage/go:method"}}{{/crossLink}} generates the URL string.
 *
 * @example
 * ```js
 * // Using chainable methods
 * function callbackFn(urlString) {
 *   console.log(urlString);
 * }
 * var sMap = tomtom.staticMapImage();
 * sMap.key('abdcef123456')
 *   .zoom(15)
 *   .center(L.latLng(50.5, 30.5))
 *   .width(600)
 *   .height(400)
 *   .format('jpg')
 *   .go()
 *   .then(callbackFn);
 * ```
 *
 * @example
 * ```js
 * // Passing a object with all the configuration
 * function callbackFn(urlString) {
 *   console.log(urlString);
 * }
 * tomtom.staticMapImage({
 *   key: 'abdcef123456',
 *   zoom: 15,
 *   bbox: L.latLngBounds([
 *     [40.712, -74.227],
 *     [40.774, -74.125]
 *   ]),
 * }).go(callbackFn);
 * ```
 *
 * @class StaticMapImage
 * @uses Chain
 * @uses ViewMixin
 * @module Services
 * @constructor
 * @param {Object} [options]
 * @param {"basic"|"hybrid"|"labels"} [options.layer="basic"] The base map's layer to be used
 * @param {"main"|"night"} [options.style="main"] The base map style to be used.
 * @param {"png"|"jpg"|"jpeg"} [options.format="png"] The format of the image to be requested
 * @param {String} [options.key] API key that can be obtained from
 *     <a href="https://developer.tomtom.com">TomTom's developer portal</a>.
 * @param {Number} [options.zoom=12] Positive integer between 0 and 20
 * @param {L.LatLng} [options.center] Coordinates to the center of the view
 * @param {Number} [options.width] Width of the image in pixels
 * @param {Number} [options.height] Height of the image in pixels
 * @param {L.LatLngBounds} [options.bbox] Bounding box
 * @param {String} [options.view="Unified"] Geopolitical view
 * @param {String} [options.language="NGT"] Language to use for the labels.
 *  You can found the list of supported languages
 *  <a href="https://developer.tomtom.com/maps-api/maps-api-documentation-vector/tile#listOfSupportedLanguages">
 *  here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0), __webpack_require__(8), __webpack_require__(2), __webpack_require__(4), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, Utils, chain, validators, converters, mainConfig) {
    'use strict';

    /**
     * @ignore
     * Static Map API endpoint.
     */

    var baseUrl = mainConfig['endpoints.staticMapImage'];
    var MAX_WIDTH = 8192;
    var MAX_HEIGHT = 8192;
    var SUPPORTED_IMAGE_FORMATS_PER_LAYER = {
        'basic': ['jpg', 'jpeg', 'png'],
        'hybrid': ['png'],
        'labels': ['png']
    };

    /**
     * Getter and setter for the option `layer`.
     * @method layer
     * @chainable
     * @param {"basic"|"hybrid"|"labels"} [newValue] New value to be set
     * @return {String} When is used as setter this method is chainable
     */

    /**
     * Getter and setter for the option `style`.
     * @method style
     * @chainable
     * @param {"main"|"night"} [newValue] New value to be set
     * @return {String} When is used as setter this method is chainable
     */

    /**
     * Getter and setter for the option `format`.
     * @method format
     * @chainable
     * @param {"png"|"jpg"|"jpeg"} [newValue] New value to be set
     * @return {String} When is used as setter this method is chainable
     */

    /**
     * Getter and setter for the option `key`.
     * @method key
     * @chainable
     * @param {String} [newValue] New value to be set
     * @return {String} When is used as setter this method is chainable
     */

    /**
     * Getter and setter for the option `zoom`.
     * @method zoom
     * @chainable
     * @param {Number} [newValue] New integer value to be set
     * @return {String} When is used as setter this method is chainable
     */

    /**
     * Getter and setter for the option `center`.
     * @method center
     * @chainable
     * @param {L.LatLng} [newValue] New value to be set
     * @return {String} When is used as setter this method is chainable
     */

    /**
     * Getter and setter for the option `width`.
     * @method width
     * @chainable
     * @param {Number} [newValue] New integer value to be set
     * @return {String} When is used as setter this method is chainable
     */

    /**
     * Getter and setter for the option `height`.
     * @method height
     * @chainable
     * @param {Number} [newValue] New integer value to be set
     * @return {String} When is used as setter this method is chainable
     */

    /**
     * Getter and setter for the option `bbox`.
     * @method bbox
     * @chainable
     * @param {L.LatLngBounds} [newValue] New value to be set
     * @return {Object} When is used as setter this method is chainable
     */

    /**
     * Getter and setter for the option `language`.
     * @method language
     * @chainable
     * @param {String} [newValue] New value to be set
     * @return {String} When is used as setter this method is chainable
     */

    var fields = {
        layer: { validator: validators.oneOfValue(['basic', 'hybrid', 'labels'], 'layers'), defaultValue: 'basic' },
        style: { validator: validators.oneOfValue(['main', 'night'], 'styles'), defaultValue: 'main' },
        format: { validator: validators.oneOfValue(['png', 'jpg', 'jpeg'], 'formats'), defaultValue: 'png' },
        key: { validator: validators.string, required: true },
        zoom: { validator: validators.integerInInterval(-1, 20), converter: converters.integer },
        center: { converter: converters.point, validator: validators.point },
        width: { validator: validators.integerInInterval(0, MAX_WIDTH) },
        height: { validator: validators.integerInInterval(0, MAX_HEIGHT) },
        bbox: { validator: validators.boundingBox, converter: converters.boundingBox },
        view: { validator: validators.geopolView('maps', 'view') },
        language: { validator: validators.locale('maps') }
    };

    function checkIfLayerSupported(data) {
        if (!SUPPORTED_IMAGE_FORMATS_PER_LAYER[data.layer] || SUPPORTED_IMAGE_FORMATS_PER_LAYER[data.layer].indexOf(data.format) === -1) {
            throw new Error('Unsupported layer. Please change to PNG or use basic layer.');
        }
    }

    function checkIfBBoxAndCenterSet(data) {
        if (data.bbox && data.center) {
            // If both are used - service will return a HTTP 400 response.
            throw new Error('The bbox and center properties cannot be used together');
        }
    }

    function checkIfBBoxAndCenterNotSet(data) {
        if (!data.bbox && !data.center) {
            throw new Error('Either bbox or center property must be provided');
        }
    }

    function checkIfBBoxUsedWithHeightOrWidth(data) {
        if (data.bbox && (Utils.isValidNumber(data.width) || Utils.isValidNumber(data.height))) {
            // If both are used - service will return a HTTP 400 response.
            throw new Error('The bbox, width and height properties cannot be used together');
        }
    }

    /**
     * @ignore
     * Validate combination of properties. Done here because chain.js does not support such behaviour
     * @throws Error
     * @param {Object} data
     */
    function validateCombineProperties(data) {

        // Executing additional more complex validations
        checkIfLayerSupported(data);
        checkIfBBoxAndCenterSet(data);
        checkIfBBoxAndCenterNotSet(data);
        checkIfBBoxUsedWithHeightOrWidth(data);
    }

    function convertBBoxToString(bbox) {
        return bbox.minLon + ',' + bbox.minLat + ',' + bbox.maxLon + ',' + bbox.maxLat;
    }

    function serializeToStringIfNecessary(propertyName, propertyValue) {
        var splitCenter, latLngCenter;
        if (propertyName === 'bbox') {
            propertyValue = convertBBoxToString(propertyValue);
        } else if (propertyName === 'zoom') {
            return String(parseInt(propertyValue, 10) - 1);
        } else if (propertyName === 'center') {
            splitCenter = propertyValue.split(',');
            latLngCenter = L.latLng(parseFloat(splitCenter[0]), splitCenter[1]);
            return latLngCenter.lng + ',' + latLngCenter.lat;
        }
        return propertyValue;
    }

    /**
     * @ignore
     * Build the Url string using the configuration available.
     * @param {Object} data
     * @return {String}
     */
    function toUrl(data) {
        var querySegments = Object.keys(fields).reduce(function (segments, propertyName) {
            var propertyValue = data[propertyName];
            if (propertyValue !== undefined) {
                propertyValue = serializeToStringIfNecessary(propertyName, propertyValue);
                segments.push(propertyName + '=' + encodeURI(propertyValue));
            }
            return segments;
        }, []);
        return baseUrl + '?' + querySegments.join('&');
    }

    function handleChain(data, callback) {
        validateCombineProperties(data);
        if (callback) {
            callback(toUrl(data));
        }
    }

    function StaticMapImage(initConfig) {
        return chain.call(this, Utils.clone(fields), handleChain, initConfig);
    }

    return StaticMapImage;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(51)], __WEBPACK_AMD_DEFINE_RESULT__ = function (template) {

    function createKeyValueString(key, value) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }

    function mapQueryParamToKeyValueString(key, queryParams) {
        var queryParamValue = queryParams[key];
        var result = '';
        if (Array.isArray(queryParamValue)) {
            result = queryParamValue.map(function (value) {
                return createKeyValueString(key, value);
            }).join('&');
        } else {
            result = createKeyValueString(key, queryParams[key]);
        }
        return result;
    }

    function withQueryParams(url, queryParams) {
        var queryString;
        if (!queryParams) {
            return url;
        }

        queryString = Object.keys(queryParams).map(function (key) {
            return mapQueryParamToKeyValueString(key, queryParams);
        }).join('&');
        return url + '?' + queryString;
    }

    return function (urlTemplate, pathParams, queryParams) {
        var url = template(urlTemplate, pathParams);
        return withQueryParams(url, queryParams);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    function isUndefined(value) {
        return value === undefined;
    }

    function isFunction(value) {
        return typeof value === 'function';
    }

    return function (template, values) {
        return template.replace(/\{ *([\w_]+) *\}/g, function (match, key) {
            //eslint-disable-line
            var value = values[key];
            if (isUndefined(value)) {
                return '{' + key + '}';
            } else if (isFunction(value)) {
                return value(key);
            }
            return value;
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * The copyright caption service implementation. Provides a caption that is supposed to be display on link providing to
 * full copyright notice. The response is not changed often.
 *
 * This service is supposed to be called once when user have the map displayed for the first time.
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "CopyrightCaption/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "CopyrightCaption/go:method"}}{{/crossLink}} method to handle the response.
 *
 * @example
 * ```js
 * tomtom.copyrightCaption()
 *   .go()
 *   .then(function(response) {
 *     console.log(response);
 *   });
 * ```
 *
 * @class CopyrightCaption
 * @module Services
 * @uses Chain
 * @constructor
 * @uses KeyMixin
 * @uses ProtocolMixin
 *
 * @param {Object} [options]
 * @param {String} [options.key] This is optional if a key was already defined globally
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(122), __webpack_require__(8), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restCopyright, model, chain, validators) {
    'use strict';

    var fields = {
        key: { validator: validators.string },
        protocol: { validator: validators.oneOfValue(['http', 'https'], 'protocol') }
    };

    var copyright = restCopyright();

    /**
     * Perform the actual call to the web service.
     *
     * It receives two optional arguments. The first one is a callback function that will be used when a
     * successful response if received by the web service. The second one is another callback function
     * that will be used only in case of failure.
     *
     * Both arguments are shortcuts for the <b>callback</b> and <b>fail</b> methods respectively.
     *
     * The final response from service is a string containing the caption i.e.:
     *     © 1992 - 2016 TomTom.
     *
     * This text have to be displayed as a copyright prompt when using TomTom services. The caption should be
     * clickable. User should be presented with full copyright notice when caption is clicked. For further
     * documentation please check the caption class.
     *
     * The SDK provides a Promise polyfill for browsers (IE<9) without native ECMAScript 6 support.
     *
     * @method go
     * @param {Function} [success] The callback function to be called on case of success.
     * @param {Function} [fail] The callback function to be called on case of failure.
     *     If a success callback is not given this argument will be ignored. In that case the returned Promise
     *     should be used to handle the failures.
     * @return {Promise|null} If the success callback is omitted (and wasn't defined one yet) this function
     *     will return a Promise
     */

    function handleChain(data, callback) {
        copyright.caption(fields, data, function (response) {
            callback.call(this, model(response));
        });
    }

    return function (options) {
        return chain(fields, handleChain, options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(10), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    var displayKeyname = ApiKeyNames.display;

    return function () {
        return {
            copyrightsWorld: requestFactory.single(endpoints.copyrightsWorld, displayKeyname),
            copyrightsBounds: requestFactory.single(endpoints.copyrightsBounds, displayKeyname),

            caption: requestFactory.single(endpoints.caption, displayKeyname)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (parameterApplications) {
    var fieldName = 'contentType';

    return {
        setField: function setField(fields) {
            var copiedFields = Object.assign({}, fields);
            copiedFields[fieldName] = {
                application: parameterApplications.PATH
            };
            return copiedFields;
        },

        setValue: function setValue(requestOptions) {
            requestOptions[fieldName] = 'json';
            return requestOptions;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (http, endpoints) {
    return function (originalCallback, options) {
        return function (result) {
            http.get({
                url: '{protocol}://' + endpoints.origin + result,
                callbackParam: 'callback',
                fail: options.fail,
                callback: originalCallback
            });
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    /**
     * @ignore
     * This map contains:
     * * Identifier: 'pl-PL' - by this identifier we search in the map for locale
     * * Label: 'Polish' - label, which will be returned by getLabel function in Locale prototype
     * * Service specific options (routing, search, traffic):
     * * - fallback - identifies to which language code should be used, because for different services
     * *              different language codes are used. For example pl-PL is correct one for search, but pl is used by
     * *              routing. This field is also used by the method getLocaleFor in locale prototype
     * * - isNative - describes if this language is supported by service. For example 'en-AU' is supported by search
     * *            but it is not supported by routing, so it will be defaulted to 'en-GB' for it. Also language list
     *              for service is determined by this field. If you call localeService.getLocalesFor('routing')
     *              only languages with routing.isNative === true will be returned.
     */

    var map = {
        'af-ZA': {
            label: 'Afrikaans',
            routing: {
                fallback: 'af-ZA',
                isNative: true
            },
            search: {
                fallback: 'af-ZA',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'en-GB', //fallback
                isNative: false
            }
        },
        'ar': {
            label: 'Arabic',
            routing: {
                fallback: 'ar',
                isNative: true
            },
            search: {
                fallback: 'ar',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'ar',
                isNative: true
            }
        },
        'bg-BG': {
            label: 'Bulgarian',
            routing: {
                fallback: 'bg-BG',
                isNative: true
            },
            search: {
                fallback: 'bg-BG',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'bg-BG',
                isNative: true
            }
        },
        'ca-ES': {
            label: 'Spanish (Catalan)',
            routing: {
                fallback: 'es-ES', //fallback to spanish
                isNative: false
            },
            search: {
                fallback: 'ca-ES',
                isNative: true
            },
            traffic: {
                fallback: 'ca',
                isNative: true
            },
            maps: {
                fallback: 'es-ES', //fallback
                isNative: false
            }
        },
        'cs-CZ': {
            label: 'Czech',
            routing: {
                fallback: 'cs-CZ',
                isNative: true
            },
            search: {
                fallback: 'cs-CZ',
                isNative: true
            },
            traffic: {
                fallback: 'cs',
                isNative: true
            },
            maps: {
                fallback: 'cs-CZ',
                isNative: true
            }
        },
        'da-DK': {
            label: 'Danish',
            routing: {
                fallback: 'da-DK',
                isNative: true
            },
            search: {
                fallback: 'da-DK',
                isNative: true
            },
            traffic: {
                fallback: 'da',
                isNative: true
            },
            maps: {
                fallback: 'da-DK',
                isNative: true
            }
        },
        'nl-BE': {
            label: 'Dutch (Belgium)',
            routing: {
                fallback: 'nl-NL', //fallback to nl-NL
                isNative: false
            },
            search: {
                fallback: 'nl-BE',
                isNative: true
            },
            traffic: {
                fallback: 'nl',
                isNative: false
            },
            maps: {
                fallback: 'nl-NL', //fallback
                isNative: false
            }
        },
        'nl-NL': {
            label: 'Dutch',
            routing: {
                fallback: 'nl-NL',
                isNative: true
            },
            search: {
                fallback: 'nl-NL',
                isNative: true
            },
            traffic: {
                fallback: 'nl',
                isNative: true
            },
            maps: {
                fallback: 'nl-NL',
                isNative: true
            }
        },
        'en-AU': {
            label: 'English (Australia)',
            routing: {
                fallback: 'en-GB', //falback to en-gb
                isNative: false
            },
            search: {
                fallback: 'en-AU',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'en-AU',
                isNative: true
            }
        },
        'en-NZ': {
            label: 'English (New Zealand)',
            routing: {
                fallback: 'en-GB', //falback to en-gb
                isNative: false
            },
            search: {
                fallback: 'en-NZ',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'en-NZ',
                isNative: true
            }
        },
        'en-GB': {
            label: 'English (Great Britain)',
            routing: {
                fallback: 'en-GB',
                isNative: true
            },
            search: {
                fallback: 'en-GB',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: true
            },
            maps: {
                fallback: 'en-GB',
                isNative: true
            }
        },
        'en-US': {
            label: 'English (USA)',
            routing: {
                fallback: 'en-US',
                isNative: true
            },
            search: {
                fallback: 'en-US',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-US',
                isNative: true
            }
        },
        'en-CA': {
            label: 'English (Canada)',
            routing: {
                fallback: 'en-US', //fallback
                isNative: false
            },
            search: {
                fallback: 'en-US', //fallback
                isNative: false
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-CA',
                isNative: true
            }
        },
        'et-EE': {
            label: 'Estonian',
            routing: {
                fallback: 'en-GB', //falback to en-gb
                isNative: false
            },
            search: {
                fallback: 'et-EE',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-GB', //fallback
                isNative: false
            }
        },
        'eu-ES': {
            label: 'Basque (Spain)',
            routing: {
                fallback: 'es-ES',
                isNative: false
            },
            search: {
                fallback: 'eu-ES',
                isNative: true
            },
            traffic: {
                fallback: 'es',
                isNative: false
            },
            maps: {
                fallback: 'es-ES',
                isNative: false
            }
        },
        'fi-FI': {
            label: 'Finnish',
            routing: {
                fallback: 'fi-FI',
                isNative: true
            },
            search: {
                fallback: 'fi-FI',
                isNative: true
            },
            traffic: {
                fallback: 'fi',
                isNative: true
            },
            maps: {
                fallback: 'fi-FI',
                isNative: true
            }
        },
        'fr-CA': {
            label: 'French (Canada)',
            routing: {
                fallback: 'fr-FR',
                isNative: false //fallback to fr-FR
            },
            search: {
                fallback: 'fr-CA',
                isNative: true
            },
            traffic: {
                fallback: 'fr',
                isNative: false //fallback to fr
            },
            maps: {
                fallback: 'fr-FR', //fallback
                isNative: false
            }
        },
        'fr-FR': {
            label: 'French',
            routing: {
                fallback: 'fr-FR',
                isNative: true
            },
            search: {
                fallback: 'fr-FR',
                isNative: true
            },
            traffic: {
                fallback: 'fr',
                isNative: true
            },
            maps: {
                fallback: 'fr-FR',
                isNative: true
            }
        },
        'de-DE': {
            label: 'German',
            routing: {
                fallback: 'de-DE',
                isNative: true
            },
            search: {
                fallback: 'de-DE',
                isNative: true
            },
            traffic: {
                fallback: 'de',
                isNative: true
            },
            maps: {
                fallback: 'de-DE',
                isNative: true
            }
        },
        'el-GR': {
            label: 'Greek',
            routing: {
                fallback: 'el-GR',
                isNative: true
            },
            search: {
                fallback: 'el-GR',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'el-GR',
                isNative: true
            }
        },
        'gl-ES': {
            label: 'Galician (Spain)',
            routing: {
                fallback: 'es-ES',
                isNative: false
            },
            search: {
                fallback: 'gl-ES',
                isNative: true
            },
            traffic: {
                fallback: 'es',
                isNative: false
            },
            maps: {
                fallback: 'es-ES',
                isNative: false
            }
        },
        'he-IL': {
            label: 'Hebrew (Israel)',
            routing: {
                fallback: 'en-GB',
                isNative: false
            },
            search: {
                fallback: 'he-IL',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false
            },
            maps: {
                fallback: 'en-GB',
                isNative: false
            }
        },
        'hr-HR': {
            label: 'Croatian',
            routing: {
                fallback: 'en-GB',
                isNative: false //fallback to en-GB
            },
            search: {
                fallback: 'hr-HR',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-GB', //fallback
                isNative: false
            }
        },
        'hu-HU': {
            label: 'Hungarian',
            routing: {
                fallback: 'hu-HU',
                isNative: true
            },
            search: {
                fallback: 'hu-HU',
                isNative: true
            },
            traffic: {
                fallback: 'hu',
                isNative: true
            },
            maps: {
                fallback: 'hu-HU',
                isNative: true
            }
        },
        'id-ID': {
            label: 'Indonesian',
            routing: {
                fallback: 'id-ID',
                isNative: true
            },
            search: {
                fallback: 'id-ID',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'id-ID',
                isNative: true
            }
        },
        'it-IT': {
            label: 'Italian',
            routing: {
                fallback: 'it-IT',
                isNative: true
            },
            search: {
                fallback: 'it-IT',
                isNative: true
            },
            traffic: {
                fallback: 'it',
                isNative: true
            },
            maps: {
                fallback: 'it-IT',
                isNative: true
            }
        },
        'kk-KZ': {
            label: 'Kazakh (Kazakhstan)',
            routing: {
                fallback: 'en-GB',
                isNative: false
            },
            search: {
                fallback: 'kk-KZ',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false
            },
            maps: {
                fallback: 'en-GB',
                isNative: false
            }
        },
        'ko-KR': {
            label: 'Korean',
            routing: {
                fallback: 'ko-KR',
                isNative: true
            },
            search: {
                fallback: 'en-GB',
                isNative: false //fallback to en-GB
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ko-KR',
                isNative: true
            }
        },
        'lv-LV': {
            label: 'Latvian',
            routing: {
                fallback: 'en-GB', //fallback to en-GB
                isNative: false
            },
            search: {
                fallback: 'lv-LV',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-GB', //fallback
                isNative: false
            }
        },
        'lt-LT': {
            label: 'Lithuanian',
            routing: {
                fallback: 'lt-LT',
                isNative: true
            },
            search: {
                fallback: 'lt-LT',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'lt-LT',
                isNative: true
            }
        },
        'ms-MY': {
            label: 'Malay',
            routing: {
                fallback: 'ms-MY',
                isNative: true
            },
            search: {
                fallback: 'ms-MY',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ms-MY',
                isNative: true
            }
        },
        'NGT': {
            label: 'Neutral Ground Truth',
            routing: {
                fallback: 'en-GB', //fallback to en-gb
                isNative: false
            },
            search: {
                fallback: 'en-GB', //fallback to en-gb
                isNative: false
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'NGT',
                isNative: true
            }
        },
        'NGT-Latn': {
            label: 'Neutral Ground Truth (Latin)',
            routing: {
                fallback: 'en-GB', //fallback to en-gb
                isNative: false
            },
            search: {
                fallback: 'en-GB', //fallback to en-gb
                isNative: false
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'NGT-Latn',
                isNative: true
            }
        },
        'no-NO': {
            label: 'Norwegian',
            routing: {
                fallback: 'nb-NO',
                isNative: false
            },
            search: {
                fallback: 'no-NO',
                isNative: true
            },
            traffic: {
                fallback: 'no',
                isNative: true
            },
            maps: {
                fallback: 'nb-NO',
                isNative: false
            }
        },
        'nb-NO': {
            label: 'Norwegian',
            routing: {
                fallback: 'nb-NO',
                isNative: true
            },
            search: {
                fallback: 'no-NO',
                isNative: false
            },
            traffic: {
                fallback: 'no',
                isNative: false
            },
            maps: {
                fallback: 'nb-NO',
                isNative: true
            }
        },
        'pl-PL': {
            label: 'Polish',
            routing: {
                fallback: 'pl-PL',
                isNative: true
            },
            search: {
                fallback: 'pl-PL',
                isNative: true
            },
            traffic: {
                fallback: 'pl',
                isNative: true
            },
            maps: {
                fallback: 'pl-PL',
                isNative: true
            }
        },
        'pt-BR': {
            label: 'Portuguese (Brazil)',
            routing: {
                fallback: 'pt-BR',
                isNative: true
            },
            search: {
                fallback: 'pt-BR',
                isNative: true
            },
            traffic: {
                fallback: 'pt',
                isNative: false //fallback to pt
            },
            maps: {
                fallback: 'pt-BR',
                isNative: true
            }
        },
        'pt-PT': {
            label: 'Portuguese (Portugal)',
            routing: {
                fallback: 'pt-PT',
                isNative: true
            },
            search: {
                fallback: 'pt-PT',
                isNative: true
            },
            traffic: {
                fallback: 'pt',
                isNative: true
            },
            maps: {
                fallback: 'pt-PT',
                isNative: true
            }
        },
        'ro-RO': {
            label: 'Romanian (Romania)',
            routing: {
                fallback: 'en-GB',
                isNative: false
            },
            search: {
                fallback: 'ro-RO',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false
            },
            maps: {
                fallback: 'en-GB',
                isNative: false
            }
        },
        'ru-Cyrl-RU': {
            label: 'Russian (Cyrillic)',
            routing: {
                fallback: 'ru-RU',
                isNative: false
            },
            search: {
                fallback: 'ru-RU',
                isNative: false
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ru-Cyrl-RU',
                isNative: true
            }
        },
        'ru-Latn-RU': {
            label: 'Russian (Latin)',
            routing: {
                fallback: 'ru-RU',
                isNative: false
            },
            search: {
                fallback: 'ru-RU',
                isNative: false
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ru-Latn-RU',
                isNative: true
            }
        },
        'ru-RU': {
            label: 'Russian',
            routing: {
                fallback: 'ru-RU',
                isNative: true
            },
            search: {
                fallback: 'ru-RU',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ru-RU',
                isNative: true
            }
        },
        'sk-SK': {
            label: 'Slovak',
            routing: {
                fallback: 'sk-SK',
                isNative: true
            },
            search: {
                fallback: 'sk-SK',
                isNative: true
            },
            traffic: {
                fallback: 'sk',
                isNative: true
            },
            maps: {
                fallback: 'sk-SK',
                isNative: true
            }
        },
        'sl-SI': {
            label: 'Slovenian',
            routing: {
                fallback: 'sl-SI',
                isNative: true
            },
            search: {
                fallback: 'sl-SI',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'sl-SI',
                isNative: true
            }
        },
        'sr-RS': {
            label: 'Serbian',
            routing: {
                fallback: 'en-GB',
                isNative: false
            },
            search: {
                fallback: 'sr-RS',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false
            },
            maps: {
                fallback: 'en-GB',
                isNative: false
            }
        },
        'es-ES': {
            label: 'Spanish (Castilian)',
            routing: {
                fallback: 'es-ES',
                isNative: true
            },
            search: {
                fallback: 'es-ES',
                isNative: true
            },
            traffic: {
                fallback: 'es',
                isNative: true
            },
            maps: {
                fallback: 'es-ES',
                isNative: true
            }
        },
        'es-419': {
            label: 'Spanish (Latin American)',
            routing: {
                fallback: 'es-ES',
                isNative: false //fallback to es-ES
            },
            search: {
                fallback: 'es-419',
                isNative: true
            },
            traffic: {
                fallback: 'es',
                isNative: false //fallback to es
            },
            maps: {
                fallback: 'es-ES', //fallback
                isNative: false
            }
        },
        'es-MX': {
            label: 'Spanish (Mexico)',
            routing: {
                fallback: 'es-MX',
                isNative: true
            },
            search: {
                fallback: 'es-ES', //fallback to es-ES
                isNative: false
            },
            traffic: {
                fallback: 'es',
                isNative: false //falback to es
            },
            maps: {
                fallback: 'es-MX',
                isNative: true
            }
        },
        'sv-SE': {
            label: 'Swedish',
            routing: {
                fallback: 'sv-SE',
                isNative: true
            },
            search: {
                fallback: 'sv-SE',
                isNative: true
            },
            traffic: {
                fallback: 'sv',
                isNative: true
            },
            maps: {
                fallback: 'sv-SE',
                isNative: true
            }
        },
        'th-TH': {
            label: 'Thai',
            routing: {
                fallback: 'th-TH',
                isNative: true
            },
            search: {
                fallback: 'th-TH',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'th-TH',
                isNative: true
            }
        },
        'tr-TR': {
            label: 'Turkish',
            routing: {
                fallback: 'tr-TR',
                isNative: true
            },
            search: {
                fallback: 'tr-TR',
                isNative: true
            },
            traffic: {
                fallback: 'tr',
                isNative: true
            },
            maps: {
                fallback: 'tr-TR',
                isNative: true
            }
        },
        'uk-UA': {
            label: 'Ukrainian',
            routing: {
                fallback: 'en-GB',
                isNative: false
            },
            search: {
                fallback: 'uk-UA',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false
            },
            maps: {
                fallback: 'en-GB',
                isNative: false
            }
        },
        'vi-VN': {
            label: 'Vietnamese (Viet Nam)',
            routing: {
                fallback: 'en-GB',
                isNative: false
            },
            search: {
                fallback: 'vi-VN',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false
            },
            maps: {
                fallback: 'en-GB',
                isNative: false
            }
        },
        'zh-CN': {
            label: 'Chinese (PRC)',
            routing: {
                fallback: 'zh-TW', //fallback to taiwan
                isNative: false
            },
            search: {
                fallback: 'zh-CN',
                isNative: true
            },
            traffic: {
                fallback: 'en', //falback to english
                isNative: false
            },
            maps: {
                fallback: 'zh-TW', //fallback
                isNative: false
            }
        },
        'zh-TW': {
            label: 'Chinese (Taiwan)',
            routing: {
                fallback: 'zh-TW',
                isNative: true
            },
            search: {
                fallback: 'zh-TW',
                isNative: true
            },
            traffic: {
                fallback: 'en', //falback to english
                isNative: false
            },
            maps: {
                fallback: 'zh-TW',
                isNative: true
            }
        }
    };

    return map;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Locale) {
    'use strict';

    return function (languageCode, serviceType) {
        var locale = new Locale(languageCode);
        return locale.getValueFor(serviceType) === languageCode;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * Store the list of geopolitical views available as key-value pairs.
 *
 * By default, all the entries listed here are supported by the supported services defined in the geopolView class.
 * If a view is NOT supported by a service it needs to be added as a fallback here.
 *
 * Note: maps service have subTypes. If a view is not supported by a service + subType (ex: maps - raster), we need to
 * add its fallback here.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    return {
        Unified: {
            label: 'Unified'
        },
        IN: {
            label: 'India'
        },
        IL: {
            label: 'Israel'
        },
        MA: {
            label: 'Morocco'
        },
        PK: {
            label: 'Pakistan'
        },
        AR: {
            label: 'Argentina',
            search: {
                fallback: 'Unified'
            }
        },
        Arabic: {
            label: 'Arabic',
            search: {
                fallback: 'Unified'
            },
            reverseGeocoder: {
                fallback: 'Unified'
            }
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * The copyright service implementation provides a full copyrights notice in an HTML format that can be displayed to
 * the user when the copyrights link is clicked.
 *
 * The copyrights API can take as argument area which the copyrights concerns. If this argument is omitted the whole
 * world is considered.
 *
 * The API handles the "edge of the world" issue. Allowing to properly handle bounding box that is outside of world
 * extends (-180, -90, 180, 90).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "Copyright/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the {{#crossLink "Copyright/go:method"}}{{/crossLink}}
 *    method to handle the response.
 *
 * @class Copyright
 * @module Services
 * @uses Chain
 * @constructor
 * @uses KeyMixin
 * @uses BoundingBoxMixin
 * @uses ProtocolMixin
 *
 * @param {Object} [options]
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String} [options.key] This is optional if a key was already defined globally
 * @param {Object|Array|String} [options.boundingBox] An area to extract the copyrights information for.
 *     If omitted, the whole world will be taken into consideration.
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @example
 * ```js
 * tomtom.copyright()
 *   .go()
 *   .then(function(response) {
 *     console.log(response);
 *   });
 * ```
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(125), __webpack_require__(8), __webpack_require__(22), __webpack_require__(126)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restCopyright, model, chain, worldEdge, copyrightsParameters) {
    'use strict';

    var fields = copyrightsParameters.create();
    var copyright = restCopyright();

    /**
         * Perform the actual call to the web service.
         *
         * It receives two optional arguments. The first one is a callback function that will be used when a
         * successful response if received by the web service. The second one is another callback function
         * that will be used only in case of failure.
         *
         * Both arguments are shortcuts for the <b>callback</b> and <b>fail</b> methods respectively.
         *
         * The final response from the service is an HTML string with the copyright information that have to
         * be displayed.
         * The whole respose is wrapped into a `div` element with the id `copyrightMessage`. Country names are
         * enclosed within `h4` elements and the copyrights information per each supplier is enclose in `p`
         * elements. This makes styling with CSS fairly easy. An example response may look like this:
         *```html
         * <div id="copyrightMessage"><h4>General Copyrights:</h4>
         *   <p>© 1992 – 2016 TomTom. All rights reserved. This
         *   material is proprietary and the subject of
         *   copyright protection, database right protection
         *   and other intellectual property rights owned
         *   by TomTom or its suppliers. The use of
         *   this material is subject to the terms of a license
         *   agreement. Any unauthorized copying or disclosure
         *   of this material will lead to criminal and civil
         *   liabilities.</p>
         *   <p>Data Source © 2016 TomTom</p>
         * </div>
         * ```
         *
         * The SDK provides a Promise polyfill for browsers (IE<9) without native ECMAScript 6 support.
         *
         * @method go
         * @param {Function} [success] The callback function to be called on case of success.
         * @param {Function} [fail] The callback function to be called on case of failure.
         *     If a success callback is not given this argument will be ignored. In that case the returned Promise
         *     should be used to handle the failures.
         * @return {Promise|null} If the success callback is omitted (and wasn't defined one yet) this function
         *     will return a Promise
         */

    function addBoundingBoxParameters(data, boundingBox) {
        data.minLon = boundingBox.minLon;
        data.maxLon = boundingBox.maxLon;
        data.minLat = boundingBox.minLat;
        data.maxLat = boundingBox.maxLat;
        return data;
    }

    function copyrightsQuery(fields) {
        var modifiedFields = copyrightsParameters.modifyFields(fields);
        return function (options, callback) {
            if (options.minLon !== undefined && options.minLat !== undefined && options.maxLon !== undefined && options.maxLat !== undefined) {
                return copyright.copyrightsBounds(modifiedFields, options, callback);
            } else {
                return copyright.copyrightsWorld(modifiedFields, options, callback);
            }
        };
    }

    function handleChain(data, callback) {
        copyrightsParameters.modifyRequestOptions(data);
        worldEdge(copyrightsQuery(fields), model, data, callback, addBoundingBoxParameters);
    }

    return function (options) {
        return chain(fields, handleChain, options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    function defaultComparator(first, second) {
        return first === second;
    }

    return function (firstArray, secondArray, comparator) {
        var result, i, j;
        if (!comparator) {
            comparator = defaultComparator;
        }

        result = firstArray.concat(secondArray);
        for (i = 0; i < firstArray.length; i += 1) {
            for (j = firstArray.length; j < result.length; j += 1) {
                if (comparator(result[i], result[j])) {
                    result.splice(j, 1);
                    j -= 1;
                }
            }
        }
        return result;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Makes it easy to display a message notification over a map.
 *
 * @example
 * ```javascript
 * var mBox = new L.MessageBox({
 *   content:'Hello world',
 *   closeAfter: 1000
 * });
 * mBox.addTo(map);
 * ```
 *
 * @class MessageBox
 * @namespace L
 * @extends L.Layer
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {Boolean} [options.closeable=true] Show the close button
 * @param {Number} [options.closeAfter=0] Number of milliseconds after which the control will be automatically
 *     closed. If value is `0` it will not be closed automatically, which is the default behaviour.
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, Utils) {
    'use strict';

    L.MessageBox = L.Layer.extend({
        options: {
            closeable: true,
            closeAfter: 0
        },

        initialize: function initialize(options) {
            L.Util.setOptions(this, options);
        },

        onAdd: function onAdd(map) {
            var that;
            this._map = map;
            this._container = this.container = L.DomUtil.create('div', 'leaflet-messageBox tomtom-copyrights');
            this.contentContainer = L.DomUtil.create('div', 'leaflet-messageBox-content', this.container);
            if (this.options.closeable) {
                this.closeButton = L.DomUtil.create('div', 'leaflet-messageBox-close-button', this.container);
                this.closeButton.innerHTML = '&#215;';
                L.DomEvent.on(this.closeButton, 'click', this.onRemove, this);
            }
            that = this;
            if (this.options.closeAfter && parseInt(this.options.closeAfter, 10) === this.options.closeAfter) {
                setTimeout(function () {
                    that.close();
                }, this.options.closeAfter);
            }
            L.DomEvent.disableClickPropagation(this.container);
            L.DomEvent.disableScrollPropagation(this.container);

            if (this.options.content) {
                this.setContent(this.options.content);
            }

            map._container.appendChild(this.container);
            return this.container;
        },
        addTo: function addTo(map) {
            map.addLayer(this);
            return this;
        },
        onRemove: function onRemove() {
            if (this._map._container.contains(this.container)) {
                this._map._container.removeChild(this.container);
            }
            return this;
        },
        /**
         * Sets the HTML content of the message box.
         *
         * @chainable
         * @method setContent
         * @param {String|HTMLElement} content The text or {{#crossLink "HTMLElement"}}{{/crossLink}} to be a content
         * of the message box
         * @return {L.MessageBox}
         */
        setContent: function setContent(content) {
            if (!this.contentContainer) {
                this.options.content = content;
                return this;
            }
            if (Utils.isString(content)) {
                this.contentContainer.innerHTML = content || '';
                return this;
            }
            while (this.contentContainer.firstChild) {
                this.contentContainer.lastChild.remove();
            }
            this.contentContainer.appendChild(content);
            return this;
        },
        close: function close() {
            return this.onRemove();
        },
        openOn: function openOn(map) {
            return this.addTo(map);
        }
    });

    L.messageBox = function (options) {
        return new L.MessageBox(options);
    };

    return L.messageBox;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    return {
        hasProperty: function hasProperty(obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
        },
        isNotNull: function isNotNull(val) {
            if (val === null) {
                return false;
            }
            return typeof val === 'function' || (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This is an extension to Leaflet allowing to display the TomTom traffic incidents layer.
 *
 * It uses the tomtom.trafficIncidents service in order to retrieve incidents details.
 *
 * A look and feel, together with a clustering behaviour, can be modified by passing the pointToLayer function.
 *
 * @class TomTomTrafficIncidentsLayer
 * @extends L.GeoJSON
 * @namespace L
 * @module Map
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#geojson-options">Leaflet's GeoJSON</a>
 *     class allows.
 *     The additional options, which are TomTom specific, are described below.
 * @param {String} [options.key] API key that can be obtained from
 *     [TomTom's developer portal](https://developer.tomtom.com).
 *     This is a key for the traffic services.
 * @param {Function} [options.pointToLayer=default] This function is used to convert vector traffic
 *     incidents into a layer of markers on the map. It takes the GeoJSON feature as the first parameter and the latlng
 *     object as the second one. It returns a layer that will be added to the map. If this is omitted, the default
 *     implementation is used.
 * @param {Boolean} [options.imperialDistance=null] Set this option if you want to use a specific unit measurement
 *     system for the new instance of the layer instead of use the default unit
 * @param {Boolean} [options.createPopupForCluster=false] Set this to true if you want popup for clusters to be
 *     generated
 * @param {Boolean} [options.diff=false] If false, force a 'full' update on traffic markers.
 * @param {Boolean} [options.noRefresh] Disables periodic updates of traffic layers.
 * @param {Number} [options.refresh=30000] The traffic incidents information changes and needs to be updated
 *     periodically. By default, it is refreshed every 30 seconds. This parameter's value represents the time
 *     in milliseconds between each update interval. The value must be 0 or greater.
 */
/* jshint nomen:false */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(5), __webpack_require__(64), __webpack_require__(134), __webpack_require__(65), __webpack_require__(16), __webpack_require__(14), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, security, trafficIncidents, clusterIncidentMarker, incidentMarker, unitTypes, trafficRefresher, Utils) {

    var trafficStyles = ['s1', 's2', 's3', 'night'];

    //mix and max zoom of the incidents layer have been defined as constants because they should not be overwritten;
    //also the service does not allow values greater than 18
    var INCIDENTS_LAYER_MIN_ZOOM = 7;
    var INCIDENTS_LAYER_MAX_ZOOM = 18;

    var EVENTS = {
        /**
         * Fired when new incidents data is received.
         *
         * @event TRAFFIC_INCIDENTS_RECEIVED
         * @param {Object} data GeoJson data
         * @param {L.Marker[]} layers Array of markers created to display the incidents
         */
        TRAFFIC_INCIDENTS_RECEIVED: 'tomtom.trafficincidentsreceived'
    };

    function getTrafficStyle(trafficLayer) {
        var style = 'night',
            i;
        if (Utils.isString(trafficLayer)) {
            for (i = 0; i < trafficStyles.length; i += 1) {
                if (trafficStyles[i] === trafficLayer.toLowerCase()) {
                    return trafficStyles[i];
                }
            }
        }
        return style;
    }

    L.TomTomTrafficIncidentsLayer = L.GeoJSON.extend({
        options: {
            imperialDistance: null,
            trafficModelId: '-1',
            minZoom: INCIDENTS_LAYER_MIN_ZOOM
        },
        /**
         * Name of traffic incidents layer. It can be used to differentiate layers.
         * @property name
         * @default "TomTomTrafficIncidentsLayer"
         * @type String
         */
        name: 'trafficIncidents',
        Events: EVENTS,
        statics: {
            Events: EVENTS
        },
        _defaultPointToLayer: function _defaultPointToLayer(feature, latlng) {
            var marker;

            if (feature.properties.clusterSize) {
                marker = clusterIncidentMarker;
            } else {
                marker = incidentMarker;
            }

            return marker(feature, latlng, {
                createPopupForCluster: this.options.createPopupForCluster,
                imperialUnits: this._shouldUseImperialDistance()
            });
        },
        /**
         * @ignore
         * First check the configuration for this instance and then the global configuration.
         * The instance configuration has priority.
         *
         * @return {Boolean}
         */
        _shouldUseImperialDistance: function _shouldUseImperialDistance() {
            if (typeof this.options.imperialDistance === 'boolean') {
                return this.options.imperialDistance;
            }
            return this.unitService.getCurrentUnit().getLabel() === unitTypes.imperial;
        },
        initialize: function initialize(options) {
            this.options.pointToLayer = this._defaultPointToLayer.bind(this);
            L.Util.setOptions(this, options);
            this._layers = {};
            security.setKey('services/traffic', options.key);
            this.incidentsService = trafficIncidents(options.trafficService).key(security.getKey('services/traffic')).style(getTrafficStyle(options.style));
        },
        onAdd: function onAdd(map) {
            this._map = map;
            this.unitService = map.getUnitService();
            this.localeService = map.getLocaleService();
            map.on({ 'viewreset': this.redraw, 'moveend': this.update }, this);
            this.unitService.on(L.UnitService.Events.UNIT_CHANGED, this.redraw, this);
            this.localeService.on(L.LocaleService.Events.LOCALE_CHANGED, this.redraw, this);
            this.trafficRefresherIntervalId = trafficRefresher.addRefresherWithModelId(undefined, this.setTrafficModelId, this);
        },
        onRemove: function onRemove(map) {
            this.unitService.off(L.UnitService.Events.UNIT_CHANGED, this.redraw, this);
            map.off({ 'viewreset': this.redraw, 'moveend': this.update }, this);
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.clearLayers();
        },
        _getIncidentsService: function _getIncidentsService(trafficModelId) {
            var map = this._map,
                zoom,
                serviceCall;
            if (!map) {
                return null;
            }
            // although the vector map zoom in levels can go into great detail, the incidents layer
            // only supports up to zoom level 18
            zoom = map.getZoom() <= INCIDENTS_LAYER_MAX_ZOOM ? map.getZoom() : INCIDENTS_LAYER_MAX_ZOOM;

            if (zoom < INCIDENTS_LAYER_MIN_ZOOM) {
                this.clearLayers();
                return null;
            }
            serviceCall = this.incidentsService.boundingBox(map.getBounds()).zoomLevel(zoom).language(this.localeService.getCurrentLocale().getValueFor('traffic'));
            if (typeof trafficModelId !== 'undefined') {
                serviceCall = serviceCall.trafficModelID(trafficModelId);
            }
            return serviceCall;
        },
        // In this method we have to do few things:
        // 1. find layers (markers) that should be removed, because they are not present in the new response
        // 2. find layers that can stay and update them (IF NECESSARY)
        _updateMarkers: function _updateMarkers(geoJSON) {
            // In this object we are storing ids as keys (to speed up the searching process), that are pointing
            // to corresponding object in the geoJSON response from the API.
            var newFeaturesDictionary = geoJSON.features.reduce(function (result, feature) {
                var current = {};
                current[feature.properties.id] = feature;
                return Object.assign(result, current);
            }, Object.create(null));

            // eachLayer is iterating over old, already existing markers from the prev response
            this.eachLayer(function (layer) {
                // layer.feature.properites has the same structure as new markers in geoJSON, we are are using this
                // object as a reference to the original feature from the previous response.
                var properties = layer.feature.properties;

                // if we can find current marker in the new response it stays
                if (!(properties.id in newFeaturesDictionary)) {
                    this.removeLayer(layer);
                    return;
                }

                // From time to time markers with the same id have some useless props (like `time: undefined`) and we
                // could ignore them, BUT what if something else will change? We're doing deep equal and update
                // icon and popup data.
                if (layer instanceof L.Marker.IncidentMarker) {
                    layer.setFeature(newFeaturesDictionary[properties.id]);
                }

                // We already have a layer for this feature, let's keep it on the map
                delete newFeaturesDictionary[properties.id];
            }, this);

            // Here we use Object.assign because we don't want to assume that we know geoJSON structure, it's safer
            // to just update features property and keep the rest as it was. And we are doing that because outside
            // of this method we need to have original geoJSON with every feature we've got from the API.
            return Object.assign({}, geoJSON, {
                features: Object.keys(newFeaturesDictionary).map(function (key) {
                    return newFeaturesDictionary[key];
                })
            });
        },
        _handleResponse: function _handleResponse(geoJSON) {
            var data = geoJSON;
            if (this.options.diff) {
                data = this._updateMarkers(geoJSON);
            } else {
                this.clearLayers();
            }
            this.addData(data).fire(L.TomTomTrafficIncidentsLayer.Events.TRAFFIC_INCIDENTS_RECEIVED, {
                data: geoJSON,
                layers: this.getLayers()
            });
        },
        _request: function _request(trafficModelId) {
            var preconfiguredIncidentsService = this._getIncidentsService(trafficModelId);
            if (!preconfiguredIncidentsService) {
                return null;
            }
            return preconfiguredIncidentsService.go().then(this._handleResponse.bind(this));
        },
        redraw: function redraw() {
            return this._request(this.options.trafficModelId);
        },
        update: function update() {
            return this._request(this.options.trafficModelId);
        },
        setTrafficModelId: function setTrafficModelId(trafficModelId) {
            if (this.options.trafficModelId !== trafficModelId) {
                this.options.trafficModelId = trafficModelId;
                this.redraw();
            }
        },
        updateOptions: function updateOptions(options) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficRefresherIntervalId = trafficRefresher.addRefresherWithModelId(options, this.setTrafficModelId, this);
            L.setOptions(this, options);
        }
    });

    L.tomTomTrafficIncidentsLayer = function (options) {
        return new L.TomTomTrafficIncidentsLayer(options);
    };

    return L.tomTomTrafficIncidentsLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Provides current traffic incidents in given region, on given zoom level with given style using the TomTom's
 * [Traffic API - Traffic Incidents Details](https://developer.tomtom.com/traffic-api/traffic-api-documentation-traffic-incidents/traffic-incident-details)
 *
 * The current road situation is updated every minute. Please use the
 * {{#crossLink "TrafficModelId"}}{{/crossLink}} service in conjunction with your request to get traffic
 * incidents aligned with other services.
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "TrafficIncidents/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "TrafficIncidents/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * The final response from this  service is a GeoJSON object.
 *
 * @class TrafficIncidents
 * @uses Chain
 * @module Services
 * @uses KeyMixin
 * @uses BoundingBoxMixin
 * @uses ProtocolMixin
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {Number} [options.zoomLevel] A zoom level of the current map view `<0, 18>`. This option **is required**.
 * @param {Object|Array|String} [options.boundingBox] The area to extract incidents from. Conversion objects
 *     are described in the {{#crossLink "TrafficIncidents/boundingBox:method"}}{{/crossLink}} function.
 * @param {String} [options.style] Style name, **needs to be** one of `"s1"`, `"s2"`, `"s3"`, `"night"`.
 *     This needs to match the style of your raster traffic tiles to match traffic tubes with traffic icons.
 * @param {String} [options.language="en"] ISO 639-1 language code of the incidentCause and description
 * @param {Number} [options.trafficModelID=-1] Valid, not older than two minutes, traffic model ID.
 * @param {Boolean} [options.expandCluster=false] Should service include details of incidents that are
 *     clustered
 * @param {Boolean} [options.originalPosition=false] Should service include original incidents' position
 * @param {"http"|"https"} [options.protocol] Protocol's type
 * @param {Boolean} [options.preserveCluster=false] Determines if clusters should be preserved
 *     when requesting for details of all the incidents
 *
 * @example
 * ```javascript
 * function callbackFn(response) {
 *   console.log(response);
 * }
 * tomtom.trafficIncidents()
 *   .key("<Your API key>")
 *   .boundingBox("0,0,1,1")
 *   .style("s1")
 *   .zoomLevel(12)
 *   .go(callbackFn);
 * ```
 */
/* eslint-enable max-len */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(132), __webpack_require__(133), __webpack_require__(8), __webpack_require__(2), __webpack_require__(4), __webpack_require__(22), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restTrafficIncidents, model, chain, validators, converters, worldEdge, parameterApplications) {
    'use strict';

    var fields = {
        key: { validator: validators.string },

        /**
         * Sets or returns the value of the `zoomLevel` option.
         *
         * The zoom level of currently displayed map.
         * It is needed as the style (visibility, clustering, etc...) depends on current zoom level.
         * @method zoomLevel
         * @chainable
         * @param {Number} [newValue] Zoom level from `0` to `18`
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {Number} The same service instance or the current option value if no argument was given
         */
        zoomLevel: { validator: validators.zoomLevel, required: true, application: parameterApplications.PATH,
            name: 'zoom' },
        boundingBox: { converter: converters.boundingBox, validator: validators.boundingBox, required: true },

        /**
         * Sets or returns the value of the `style` option.
         *
         * The style that will be used to render the
         * traffic tile in the Maps API. This will have an effect on the coordinates of traffic incidents in the
         * reply.
         *
         * @method style
         * @chainable
         * @param {String} [newValue] Style name, needs to be on of _'s1', 's2', 's3', 'night'_. This needs to match
         *     style of your raster traffic tiles to match traffic tubes with traffic icons.
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {String} The same service instance or the current option value if no argument was given
         */
        style: { validator: validators.oneOfValue(['s1', 's2', 's3', 'night'], 'traffic style'), required: true,
            application: parameterApplications.PATH },

        /**
         * Sets or returns the value of the `language` option.
         *
         * Expects an ISO 639-1 language code for the `incidentCause` and `description` fields in the response.
         * English is the default language.
         *
         * The supported languages are: `ca`, `cs`, `da`, `de`, `en`, `es`, `fi`, `fr`, `hu`,
         * `it`, `nl`, `no`, `pl`, `pt`, `sk`, `sv`, `tr`.
         *
         * There is a conversion mechanism in place that will (ignoring the case) try to match the user input
         * with a valid language.
         *
         * For example: for the French language the following options are possible: "fr", "fre", "fr-fr", "fr_fr",
         * "french".
         *
         * @method language
         * @chainable
         * @param {String} [newValue] Language code, a conversion mechanism will be applied.
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {String} The same service instance or the current option value if no argument was given
         */
        language: { converter: converters.trafficIncidentsLanguage, validator: validators.trafficIncidentsLanguage },

        /**
         * Sets or returns the value of the `trafficModelID` option.
         *
         * Number referencing the traffic model to use.
         * This can be obtained from the the {{#crossLink "TrafficModelId"}}{{/crossLink}} service.
         *
         * It is updated every minute, and is valid for two minutes before it times out.
         *
         * If a wrong Traffic Model ID is specified, the correct one will be returned by the interface.
         *
         * The default value of `-1` will always invoke the most recent traffic model. Nevertheless it is
         * a good practice to use the value obtained from the service as this will guarantee an alignment
         * with the raster traffic layer.
         *
         * @method trafficModelID
         * @chainable
         * @param {Number} [newValue] Valid, not older than two minutes, traffic model ID.
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {Number} The same service instance or the current option value if no argument was given
         */
        trafficModelID: { validator: validators.string, defaultValue: '-1', application: parameterApplications.PATH },

        geometries: { validator: validators.oneOfValue(['shifted', 'original'], 'traffic geometries') },

        /**
         * Sets or returns the value of the `expandCluster` option.
         *
         * Tells the service to list all traffic incidents in a cluster separately.
         *
         * When is enabled the clusters in the response will be represented as geometry collections
         * and the cluster coordinates will appear as clusterCoordinates parameters.
         *
         * Enabling this feature is useful when the user wants to obtain details of the incidents
         * that are being clustered or wants to perform a client-side clustering.
         *
         * @method expandCluster
         * @chainable
         * @param {Boolean} [newValue] Should service include details of incidents that are clustered
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {Boolean} The same service instance or the current option value if no argument was given
         */
        expandCluster: { validator: validators.bool, defaultValue: false },

        /**
         * Sets or returns the value of the `preserveCluster` option.
         *
         * Tells the service to keep all traffic incidents clustered when receiving a list of all traffic
         * incidents in a cluster separately.
         *
         * This allows to get all the incidents details while remaining in clusters.
         *
         * @method preserveCluster
         * @chainable
         * @param {Boolean} [newValue] Should service keep clusters data
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {Boolean} The same service instance or the current option value if no argument was given
         */
        preserveCluster: { validator: validators.bool, defaultValue: false },

        /**
         * Sets or returns the value of the `originalPosition` option.
         *
         * Return the original position of the incident (`originalPosition` attribute) as well as the one
         * shifted to the beginning of the traffic tube.
         *
         * @method originalPosition
         * @chainable
         * @param {Boolean} [newValue] Should service include original incidents' position
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {Boolean} The same service instance or the current option value if no argument was given
         */
        originalPosition: { validator: validators.bool, defaultValue: false },

        protocol: { validator: validators.oneOfValue(['http', 'https'], 'protocol') },

        projection: {
            defaultValue: 'EPSG4326'
        }
    };

    var trafficIncidents = restTrafficIncidents();

    function addBoundingBoxParameters(data, boundingBox) {
        data.minLon = boundingBox.minLon;
        data.maxLon = boundingBox.maxLon;
        data.minLat = boundingBox.minLat;
        data.maxLat = boundingBox.maxLat;
        return data;
    }

    /*
     * At this moment it's impossible to map one field to two and more output fields but we need to do this, e.g.
     * bounding box needs to be mapped to topLeft and btmRight. That's why this method tries to fix this
     */
    function modifyFields(fields) {
        var pathField = {
            application: parameterApplications.PATH
        };
        var resultFields = Object.assign({}, fields);

        if (resultFields.boundingBox) {
            resultFields.minLon = pathField;
            resultFields.maxLon = pathField;
            resultFields.minLat = pathField;
            resultFields.maxLat = pathField;
            delete resultFields.boundingBox;
        }

        return resultFields;
    }

    function incidentsDetailsQuery(options, callback) {
        return trafficIncidents.incidentsDetails(modifyFields(fields), options, callback);
    }

    function buildHandleChain(preserveCluster) {
        return function (data, callback) {
            worldEdge(incidentsDetailsQuery, model(preserveCluster), data, callback, addBoundingBoxParameters);
        };
    }

    return function (options) {
        options = options || {};
        options.__serviceType = 'traffic';
        return chain(fields, buildHandleChain(options && options.preserveCluster), options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(36), __webpack_require__(15), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, T, units, Utils) {
    'use strict';

    var iconsMapping = {
        'Unknown': 'danger',
        'Accident': 'accident',
        'Fog': 'danger',
        'Dangerous Conditions': 'danger',
        'Rain': 'danger',
        'Ice': 'ice',
        'Jam': 'incident',
        'Lane Closed': 'laneclosed',
        'Road Closed': 'roadclosed',
        'Road Works': 'roadwork',
        'Wind': 'danger',
        'Flooding': 'danger',
        'Detour': 'danger',
        'Cluster': ''
    };
    var messageTemplate = new T('    <div class="traffic-details">' + '    <div class="traffic-icon">' + '        <div class="icon-circle-{{=incidentSeverity}}">' + '            <div class="icon-{{=icon}}-white"></div>' + '        </div>' + '    </div>' + '    {{roadNumber}}' + '        <div class="road-shield">{{=roadNumber}}</div>' + '    {{/roadNumber}}' + '    <div class="traffic-description">' + '        <div class="incident-category">{{=incidentCategory}}</div>' + '        <div' + '            class="incident-delay-length"' + '            {{!delaySeconds}}' + '                {{!lengthMeters}}' + '                    style="display:none;"' + '                {{/!lengthMeters}}' + '            {{/!delaySeconds}}' + '        >' + '            {{delaySeconds}}' + '                <div class="incident-delay">{{=time}}</div>' + '            {{/delaySeconds}}' + '            {{lengthMeters}}' + '                <div class="incident-length">{{=distance}}</div>' + '            {{/lengthMeters}}' + '        </div>' + '    </div>' + '</div>');

    function trafficIncidentMessage(info, isUsingImperialUnits) {
        info.distance = units.formatDistance(info.lengthMeters, isUsingImperialUnits);
        info.time = units.formatTime(info.delaySeconds);
        info.incidentSeverity = info.incidentSeverity || 'unknown';
        info.icon = iconsMapping[info.incidentCategory];
        return messageTemplate.render(info);
    }

    function getIconOptions(feature) {
        var severity = feature.properties.incidentSeverity || 'unknown';

        return {
            popupAnchor: [0, -5],
            background: { iconSize: [20, 20], iconAnchor: [10, 10], icon: 'icon-circle-' + severity },
            icon: {
                iconSize: [20, 20],
                iconAnchor: [0, 0],
                icon: 'icon-' + iconsMapping[feature.properties.incidentCategory] + '-white'
            },
            content: {
                content: null,
                iconSize: [20, 20],
                iconAnchor: [0, 0],
                style: { 'color': '#fff', 'font-weight': 'bold', 'font-size': '11px' }
            }
        };
    }

    L.Marker.IncidentMarker = L.Marker.extend({
        options: {
            imperialUnits: false
        },
        iconsMapping: iconsMapping,
        initialize: function initialize(feature, latlng, options) {
            L.Util.setOptions(this, options);
            L.Marker.prototype.initialize.call(this, latlng, options);
            this.setFeature(feature);
        },
        setFeature: function setFeature(feature) {
            var previousFeature = this.feature || {};
            this.feature = feature;
            this.setLatLng(this.feature.geometry.coordinates.reverse());
            if (!Utils.isEqual(this.feature.properties, previousFeature.properties)) {
                this._updateIcon();
                this._updatePopup();
            }
        },

        _updateIcon: function _updateIcon() {
            this.setIcon(L.svgIcon(getIconOptions(this.feature)));
        },
        _updatePopup: function _updatePopup() {
            var popupContent = trafficIncidentMessage(this.feature.properties, this.options.imperialUnits);
            if (this.getPopup()) {
                this.setPopupContent(popupContent);
            } else {
                this.bindPopup(popupContent, { className: 'incidents-popup' });
            }
        }
    });

    return function (feature, latlng, options) {
        if (!feature || !feature.properties) {
            return null;
        }

        return new L.Marker.IncidentMarker(feature, latlng, {
            imperialUnits: (options || {}).imperialUnits
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {
    'use strict';

    return {
        loadAnimationFactory: function loadAnimationFactory(layer) {
            return function () {
                var opacity = 'opacity',
                    back = layer._bgBuffer;
                back.style[L.DomUtil.TRANSITION] = opacity + ' 10';
                back.style[opacity] = 0.1;
                layer._tileContainer.style[opacity] = layer.options.opacity;
            };
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
    'use strict';

    return {
        fillInTiles512Options: function fillInTiles512Options(options) {
            if (options.tileSize === 512) {
                options.zoomOffset -= 1;
                options.minZoom = options.minZoom > 0 ? options.minZoom - 1 : 0;
            }
        },
        fillInSubdomainsOptions: function fillInSubdomainsOptions(options) {
            if (Utils.isString(options.subdomains)) {
                options.subdomains = options.subdomains.split('');
            }
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    var defaultStylesIndex = 0,
        defaultLayersIndex = 0;

    function getMap(type) {
        switch (type) {
            case 'vectorTrafficFlow':
                return {
                    style: ['vectorTrafficFlow'],
                    layer: ['absolute', 'relative', 'relative-delay']
                };
            case 'vectorTrafficIncidents':
                return {
                    style: ['vectorTrafficIncidents'],
                    layer: ['s1', 's2', 's3', 'night']
                };
            case 'vector':
            default:
                {
                    return {
                        style: ['main', 'night'],
                        layer: ['basic', 'hybrid', 'labels']
                    };
                }
        }
    }

    function validateStyleOrLayer(map, options, key) {
        if (!options || !options[key]) {
            return false;
        }
        return map[key].indexOf(options[key]) !== -1;
    }

    function copyFromOptionsToTheme(map, options, theme, key) {
        if (validateStyleOrLayer(map, options, key)) {
            theme[key] = options[key];
        }
    }

    return {
        getTheme: function getTheme(optionsHierarchyArray, type) {
            var i,
                map = getMap(type),
                options,
                theme = {
                style: map.style[defaultStylesIndex],
                layer: map.layer[defaultLayersIndex]
            },
                length = optionsHierarchyArray ? optionsHierarchyArray.length : 0;
            for (i = 0; i < length; ++i) {
                options = optionsHierarchyArray[i];
                copyFromOptionsToTheme(map, options, theme, 'style');
                copyFromOptionsToTheme(map, options, theme, 'layer');
            }
            return theme;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    var MAX_VECTOR_ZOOM = 22;
    var MAX_RASTER_ZOOM = 20;

    return {
        /**
         * Updates the max zoom property based on given source name.
         * This method takes into account max zoom given in map.options property.
         * @method updateMaxZoom
         * @param {Map} map Map instance
         * @param {String} source one of 'vector' or 'raster'
         */
        updateMaxZoom: function updateMaxZoom(map, source) {
            var max;

            switch (source) {
                case 'raster':
                    {
                        max = MAX_RASTER_ZOOM;
                        break;
                    }
                case 'vector':
                    {
                        max = MAX_VECTOR_ZOOM;
                        break;
                    }
                default:
                    return;
            }

            if (typeof map.options.maxZoom === 'undefined') {
                map._originalMaxZoom = Infinity;
            } else if (map._originalMaxZoom !== Infinity) {
                map._originalMaxZoom = map.options.maxZoom;
            }

            if (typeof map.options.maxZoom === 'number') {
                max = Math.min(max, map._originalMaxZoom);
            }

            map.setMaxZoom(max);
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Tile layer for Leaflet that use the
 * [Maps API - Raster](https://developer.tomtom.com/maps-api/maps-api-documentation/raster)
 * from TomTom.
 *
 * @example
 * ```js
 * var tomtomLayer = new L.TomTomLayer({key: "<Your API key>"});
 * ```
 *
 * @class TomTomLayer
 * @module Map
 * @namespace L
 * @extends L.TileLayer
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#tilelayer-options">Leaflet's TileLayer</a>
 *     allows.
 *     The additional options, which are TomTom specific, are described below.
 * @param {String} [options.key] API key that can be obtained from
 *     [TomTom's developer portal](https://developer.tomtom.com).
 *     When the key is passed on the map's initialization, it is set globally for all the services. It can be
 *     overwritten with the `tomtom.key()` method globally or per service with `tomtom.<service_name>.key()`
 *     functions. It is also possible to pass a specific key while working with instances of the services.
 * @param {"main"|"night"} [options.style="main"] The base map style to use
 * @param {"basic"|"hybrid"|"labels"} [options.layer="basic"] The base map's layer to use
 * @param {String} [options.language] Language to be used for map labels. Should be one of supported
 *      IETF language tags described
 *      [here](https://developer.tomtom.com/maps-api/maps-api-documentation-raster/raster-tile#listOfSupportedLanguages).
 *      When data in specified language is not available for a specific label,
 *      [default language](https://developer.tomtom.com/maps-api/maps-api-documentation-raster/raster-tile#defaultLanguageAlgorithm)
 *      is used.
 */
/* eslint-enable max-len */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(5), __webpack_require__(11), __webpack_require__(6), __webpack_require__(68), __webpack_require__(66), __webpack_require__(67), __webpack_require__(69), __webpack_require__(12), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, security, http, endpoints, mapTheme, animator, optionsComplementor, Utils, analytics, tileSetTransform) {
    'use strict';

    function tileSizeEstimator(options) {
        return options.detectRetina && L.Browser.retina ? 512 : 256;
    }

    L.TomTomLayer = L.TileLayer.extend({
        options: {
            attribution: '',
            minZoom: 2,
            maxZoom: 20,
            subdomains: 'abcd',
            reuseTiles: true,
            detectRetina: true
        },
        /**
         * Name of raster layer. It can be used to differentiate layers.
         * @property name
         * @default "raster"
         * @type String
         */
        name: 'raster',
        initialize: function initialize(options) {
            var key, theme, urlParams;
            options = L.setOptions(this, options);
            if (options.bounds) {
                options.bounds = L.latLngBounds(options.bounds);
            }
            security.setKey(options.key);
            key = security.getKey('services/display');
            options.accessToken = key;
            urlParams = (key ? 'key={accessToken}' : '') + (options.geopolView ? '&view={geopolView}' : '') + (options.language ? '&language={language}' : '') + '&tileSize=' + tileSizeEstimator(options);
            this._url = http.protocol() + '://' + endpoints.tileLayer + (urlParams ? '?' + urlParams : '');
            theme = mapTheme.getTheme([options]);
            options.style = theme.style;
            options.layer = theme.layer;
            optionsComplementor.fillInSubdomainsOptions(options);

            tileSetTransform.fixTileScale.call(this);
        },
        onAdd: function onAdd(map) {
            this._map = map;
            L.TileLayer.prototype.onAdd.call(this, map);
            if (this._animated) {
                this.on('load', animator.loadAnimationFactory(this));
            }
            this._updateOpacity();
            this.bringToBack();
            Utils.updateMaxZoom(map, this.name);
        },
        updateOptions: function updateOptions(options) {
            var theme = mapTheme.getTheme([this.options, options]);
            this.options.style = theme.style;
            this.options.layer = theme.layer;
            this.redraw();
        },
        createTile: function createTile(coords, done) {
            return analytics.customCreateTile(coords, done, this);
        }
    });

    L.tomTomLayer = function (options) {
        return new L.TomTomLayer(options);
    };

    return L.tomTomLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * Objects of this class should contain shared routing information. Currently this information consists of start and
 * end points but it might be extended in the future by waypoints. Instances of this class should be created for each
 * map.
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0), __webpack_require__(40)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, utils, routing) {
    'use strict';

    var pointProperties = ['startPoint', 'endPoint'];
    var otherProperties = ['jsonRoute'];
    var properties = pointProperties.concat(otherProperties);
    var EVENTS = {
        PROPERTY_VALUE_CHANGED: 'tomtom.propertyvaluechange'
    };
    var RoutingContext;

    function isPointProperty(property) {
        return pointProperties.indexOf(property) !== -1;
    }

    function propertyHandlerInitializer(property) {
        this[property] = function (propValue) {
            var previousValue, currentValue;
            if (propValue !== undefined) {
                previousValue = this['_' + property];
                currentValue = isPointProperty(property) ? utils.convertToLatLng(propValue) : propValue;
                this['_' + property] = currentValue;
                if (isPointProperty(property)) {
                    this._calculateRouteIfPossible();
                }

                this.fire(EVENTS.PROPERTY_VALUE_CHANGED, { name: property, currentValue: currentValue, previousValue: previousValue });
                return previousValue;
            } else {
                return this['_' + property];
            }
        };
    }

    RoutingContext = L.Evented.extend({
        initialize: function initialize() {
            properties.forEach(propertyHandlerInitializer, this);
        },
        _calculateRouteIfPossible: function _calculateRouteIfPossible() {
            var start, end, startLocation, endLocation, locations;

            start = this.startPoint();
            end = this.endPoint();
            if (!start || !end) {
                return;
            }

            startLocation = start.lat + ',' + start.lng;
            endLocation = end.lat + ',' + end.lng;
            locations = startLocation + ':' + endLocation;

            routing().locations(locations).go().then(this.jsonRoute.bind(this));
        }
    });

    RoutingContext.Events = EVENTS;

    return RoutingContext;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(2), __webpack_require__(73), __webpack_require__(0), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (converters, validators, getRoutingParameters, utils, parameterApplications) {
  /**
   * A setter and getter for `routeType` attribute.
   *
   * Represent the type of route requested.
   *
   * Notes on specific values:
   *  - `fastest` returns the fastest route.
   *  - `shortest` returns the shortest route by distance.
   *  - `eco` routes balance economy and speed.
   *  - thrilling routes include interesting or challenging roads and use as few motorways as possible. You can
   * choose the level of turns included and also the degree of hilliness. See the hilliness and windingness
   * parameters for how to set this. There is a limit of 900 km on routes planned with routeType=thrilling
   * Default value is fastest
   *
   * @method routeType
   * @chainable
   * @param {String} [routeType] Route type to be used during route calculation.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {String} Method returns the service instance allowing chaining or route type value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'traffic' attribute.
   * Possible values:
   * true (do consider all available traffic information during routing)
   * false (ignore current traffic data during routing). Note that although the current traffic data is
   * ignored during routing, the effect of historic traffic on effective road speeds is still incorporated.
   * Default is true
   *
   * @method traffic
   * @chainable
   * @param {String|Boolean} [traffic] Boolean flag determine if traffic data should be used to calculate the
   *     route.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {Boolean} Method returns the service instance allowing chaining or traffic value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for `avoid` attribute.
   *
   * Specifies something that the route calculation should try to avoid when determining the route.
   * Can be specified multiple times. Possible values:
   *  - `tollRoads` avoids toll roads.
   *  - `motorways` avoids motorways.
   *  - `ferries` avoids ferries.
   *  - `unpavedRoads` avoids unpaved roads.
   *  - `carpools` avoids routes that require use of carpool (HOV/ High Occupancy Vehicle) lanes.
   *  - `alreadyUsedRoads` avoids using the same road multiple times.
   *
   * Most useful in conjunction with `routeType=thrilling`.
   *
   * @method avoid
   * @chainable
   * @param {Array|String} [avoid] Specifies something that the route calculation should try to avoid when
   *     determining the route
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {Array} Method returns the service instance allowing chaining or street number value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'departAt' attribute.
   * The date and time of departure from the origin point.
   * Departure times apart from now must be specified as a dateTime.
   * When a time zone offset is not specified, it will be assumed to be that of the origin point.
   * The departAt value must be in the future. The departAt parameter cannot be used in conjunction with
   * arriveAt.
   *
   * @method departAt
   * @chainable
   * @param {String} [departAt] The properly formatted date with time or 'now' value. Date cannot be in the
   *     past.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {String} Method returns the service instance allowing chaining or language if argument
   *     is omitted.
   */

  /**
   * A setter and getter for 'arriveAt' attribute.
   * The date and time of arrival at the destination point.
   * It must be specified as a dateTime.
   * When a time zone offset is not specified it will be assumed to be that of the destination point.
   * The arriveAt value must be in the future. The arriveAt parameter cannot be used in conjunction with
   * departAt.
   *
   * @method arriveAt
   * @chainable
   * @param {String} [arriveAt] The properly formatted date with time value. Date cannot be in the past.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {String} Method returns the service instance allowing chaining or language if argument
   *     is omitted.
   */

  /**
   * A setter and getter for 'travelMode' attribute.
   * The mode of travel for the requested route. Possible values: _car, truck, taxi, bus, van, motorcycle,
   * bicycle, pedestrian_ Note that the requested travelMode may not be available for the entire route. Where
   * the requested travelMode is not available for a particular section, the <travelMode> element of the
   * response for that section will be other.
   *
   * @method travelMode
   * @chainable
   * @param {String} [travelMode] The primary mean of transportation to be used while routing.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {String} Method returns the service instance allowing chaining or language if argument
   *     is omitted.
   */

  /**
   * A setter and getter for 'hilliness' attribute.
   * Degree of hilliness for thrilling route. Possible values: low, normal, high
   * This parameter can only be used in conjunction with routeType thrilling.
   *
   * @method hilliness
   * @chainable
   * @param {String} [hilliness] The level of hilliness on a thrilling route.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {String} Method returns the service instance allowing chaining or language if argument
   *     is omitted.
   */

  /**
   * A setter and getter for 'windingness' attribute.
   * Level of turns for thrilling route. Possible values: low, normal, high
   * This parameter can only be used in conjunction with routeType thrilling.
   *
   * @method windingness
   * @chainable
   * @param {String} [windingness] The level of windingness on a thrilling route.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {String} Method returns the service instance allowing chaining or language if argument
   *     is omitted.
   */

  /**
   * A setter and getter for 'computeTravelTimeFor' attribute.
   * Specifies whether to return additional travel times using different types of traffic information (none,
   * historic, live) as well as the default best-estimate travel time. Possible values:
   * * none - do not compute additional travel times,
   * * all - compute travel times for all types of traffic information. Specifying all results in the fields
   * noTrafficTravelTimeInSeconds, historicTrafficTravelTimeInSeconds and
   * liveTrafficIncidentsTravelTimeInSeconds being included in the summaries in the route response.
   *
   * @method computeTravelTimeFor
   * @chainable
   * @param {String} [computeTravelTimeFor] Setting _all_ provides additional information regards travel
   *     times.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {String} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'vehicleEngineType' attribute.
   * Engine type of the vehicle. This parameter is currently only considered for travelMode truck. Valid
   * options are: _combustion, electric_
   *
   * @method vehicleEngineType
   * @chainable
   * @param {String} [vehicleEngineType] The vehicle engine type.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {String} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'vehicleMaxSpeed' attribute.
   * Maximum speed of the vehicle in km/hour. A value of 0 means that an appropriate value for the vehicle
   * will be determined and applied during route planning. A non-zero value may be overridden during route
   * planning. This parameter is currently only considered for travelMode truck.
   *
   * @method vehicleMaxSpeed
   * @chainable
   * @param {Number} [vehicleMaxSpeed] The maximal allowed vehicle speed in km/h.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {Number} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'vehicleWeight' attribute.
   * Weight of the vehicle in kg. A value of 0 means that weight restrictions are not considered during route
   * planning. This parameter is currently only considered for travelMode truck.
   *
   * @method vehicleWeight
   * @chainable
   * @param {Number} [vehicleWeight] The vehicle weight in kg.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {Number} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'vehicleAxleWeight' attribute.
   * Weight per axle of the vehicle in kg. A value of 0 means that weight restrictions per axle are not
   * considered during route planning. This parameter is currently only considered for travelMode truck.
   *
   * @method vehicleAxleWeight
   * @chainable
   * @param {Number} [vehicleAxleWeight] The vehicle axle wight in kg.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {Number} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'vehicleLength' attribute.
   * Length of the vehicle in meters. A value of 0 means that length restrictions are not considered during
   * route planning. This parameter is currently only considered for travelMode truck.
   *
   * @method vehicleLength
   * @chainable
   * @param {Number} [vehicleLength] The vehicle length in m.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {Number} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'vehicleWidth' attribute.
   * Width of the vehicle in meters. A value of 0 means that width restrictions are not considered during
   * route planning. This parameter is currently only considered for travelMode truck.
   *
   * @method vehicleWidth
   * @chainable
   * @param {Number} [vehicleWidth] The vehicle width in m.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {Number} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'vehicleHeight' attribute.
   * Height of the vehicle in meters. A value of 0 means that height restrictions are not considered
   * during route planning. This parameter is currently only considered for travelMode truck.
   *
   * @method vehicleHeight
   * @chainable
   * @param {Number} [vehicleHeight] The vehicle height in m.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {Number} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'vehicleCommercial' attribute.
   * Vehicle is used for commercial purposes and thus may not be allowed to drive on some roads. This
   * parameter is currently only considered for travelMode truck.
   *
   * @method vehicleCommercial
   * @chainable
   * @param {Boolean} [vehicleCommercial] True if vehicle is used for commercial purposes.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {String} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  /**
   * A setter and getter for 'vehicleLoadType' attribute.
   * Types of cargo that may be classified as hazardous materials and restricted from some roads. Available
   * vehicleLoadType values are US Hazmat classes 1 through 9, plus generic classifications for use in other
   * countries.
   *
   * __Use these for routing in US__
   * * USHazmatClass1 Explosives
   * * USHazmatClass2 Compressed gas
   * * USHazmatClass3 Flammable liquids
   * * USHazmatClass4 Flammable solids
   * * USHazmatClass5 Oxidizers
   * * USHazmatClass6 Poisons
   * * USHazmatClass7 Radioactive
   * * USHazmatclass8 Corrosives
   * * USHazmatClass9 Miscellaneous
   *
   * __Use these for routing in all other countries__
   * * otherHazmatExplosive Explosives
   * * otherHazmatGeneral Miscellaneous
   * * otherHazmatHarmfulToWater Harmful to water
   *
   * This parameter is currently only considered for travelMode truck.
   *
   * @method vehicleLoadType
   * @chainable
   * @param {Array|String} [vehicleLoadType] The array of truck cargo classification.
   * @throws {TypeError} if the given argument cannot be converted to a valid value
   * @return {Array} Method returns the service instance allowing chaining or current value if
   *     argument is omitted.
   */

  var fields = getRoutingParameters(['locations', 'maxAlternatives', 'instructionsType', 'language', 'computeBestOrder', 'routeRepresentation', 'vehicleHeading', 'report', 'callback', 'minDeviationTime', 'minDeviationDistance', 'alternativeType']);

  var latLonFieldDescription = {
    validator: validators.arrayOf({
      point: {
        validator: validators.objectOf({
          latitude: {
            validator: validators.latitude,
            required: true
          },
          longitude: {
            validator: validators.longitude,
            required: true
          }
        })
      }
    }),
    converter: converters.arrayOf({
      point: {
        converter: converters.objectOf({
          latitude: {
            converter: converters.latitude,
            required: true
          },
          longitude: {
            converter: converters.longitude,
            required: true
          }
        })
      }
    }),
    required: true,
    application: parameterApplications.POST
  };

  /**
  * A setter and getter for 'origins' attribute.
  * A set of origin locations represented by points (lat,lon). At least one origin is required.
  *
  * @method origins
  * @chainable
  * @param {Array} [origins] A set of origin locations represented by points (lat,lon).
  * @throws {TypeError} if the given argument cannot be converted to a valid value
  * @return {String} Method returns the service instance allowing chaining or current value if
  *     argument is omitted.
  */
  fields.origins = latLonFieldDescription;

  /**
  * A setter and getter for 'destinations' attribute.
  * A set of destination locations represented by points (lat,lon). At least one destination is required.
  *
  * @method destinations
  * @chainable
  * @param {Array} [destinations] A set of origin locations represented by points (lat,lon).
  * @throws {TypeError} if the given argument cannot be converted to a valid value
  * @return {String} Method returns the service instance allowing chaining or current value if
  *     argument is omitted.
  */
  fields.destinations = latLonFieldDescription;

  return function (fieldsToSkip) {
    var result = utils.clone(fields);
    if (fieldsToSkip instanceof Array) {
      fieldsToSkip.forEach(function (field) {
        delete result[field];
      });
    }

    return result;
  };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(74), __webpack_require__(0), __webpack_require__(2), __webpack_require__(42), __webpack_require__(4), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (commonRoutingParameters, utils, validators, postValidators, converters, parameterApplications) {
    /**
     * @class Routing
     * @module Services
     */

    var routingParameters = {

        /**
             * A setter and getter for 'locations' attribute.
             *
             * Locations through which the route is calculated. The
             * following constraints apply:
             * *    At least two locations must be provided.
             * *    The first location in the sequence defines the origin and must be of type point.
             * *    The last location in the sequence defines the destination and must be of type point.
             * *    One or more optional intermediate locations (known as waypoints) may be provided:
             *      *   The maximum allowed number of waypoints is 50, reduced to 20 when computeBestOrder is true.
             *      *   A point waypoint results in an extra leg in the response, a circle waypoint does not.
             *      *   Circle waypoints cannot be used when computeBestOrder is true.
             *
             * The points or circles that will be used to calculate the route. Following input types are allowed:
             *  1. string with Colon-delimited locations. For example: '52.50931,13.42936:52.50274,13.43872'.
             *  2. array containing locations
             *     location can be defined as string,object or array
             *
             * @method locations
             * @chainable
             * @param {String|Array} [locations] This is the specified locations for route calculation.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or converted locations
             *     value if argument is omitted.
             */
        locations: {
            validator: validators.routingLocations,
            converter: converters.routingLocations,
            required: true,
            application: parameterApplications.PATH
        },
        /**
             * A setter and getter for 'maxAlternatives' attribute.
             *
             * Number of desired alternative routes to be calculated. The value provided:
             * must be an integer in the range 0-5
             * using a value greater than 0 in conjunction with computeBestOrder set to true is not allowed
             * fewer alternative routes may be returned if either fewer alternatives exist or the requested number of
             * alternatives is larger than the service can calculate Default value is 0, Maximum value is 5
             *
             * @method maxAlternatives
             * @chainable
             * @param {Number} [maxAlternatives] To restrict maximum alternative routes to be calculated.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or maxAlternatives value
             *     if argument is omitted.
             */
        maxAlternatives: {
            validator: validators.numberInInterval(0, 5)
        },

        /**
             * A setter and getter for 'instructionsType' attribute.
             *
             * If specified, guidance instructions will be returned (if available).
             *
             * Possible values:
             * * _coded_ : returns raw instruction data without human-readable messages.
             * * _text_ : returns raw instructions data with human-readable messages in plain text.
             * * _tagged_ : returns raw instruction data with tagged human-readable messages to permit formatting.
             *
             * Note that the instructionsType parameter cannot be used in conjunction with routeRepresentation=none.
             * If alternative routes are requested, instructions will be generated for each route returned.
             *
             * @method instructionsType
             * @chainable
             * @param {String} [instructionsType] If a street number is sent in along with the request, the response
             *     may include the side of the street (Left/Right) and also an offset position for that street number.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or street number value if
             *     argument is omitted.
             */
        instructionsType: {
            validator: validators.oneOfValue(['coded', 'text', 'tagged'], 'instructions type')
        },
        /* eslint-disable max-len */
        /**
             * A setter and getter for 'language' attribute.
             *
             * The language parameter determines the language of the guidance messages. It does not affect proper nouns
             * (the names of streets, plazas, etc.) It has no effect when instructionsType=coded. Allowed values are (a
             * subset of) the IETF language tags described here. The currently supported languages are listed in the
             * supported languages section:
             *
             * https://developer.tomtom.com/routing-api/routing-api-documentation-routing/calculate-route#supportedlanguages
             *
             * @method language
             * @chainable
             * @param {String} [language] The language value
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
        /* eslint-enable max-len*/
        language: {
            validator: validators.routingGuidanceLanguage,
            converter: converters.routingGuidanceLanguage
        },
        /**
             * A setter and getter for 'computeBestOrder' attribute.
             *
             * Allows to reorder the route waypoints to reduce
             * the route length. Yields best results when used in conjunction with routeType shortest. Possible values:
             * *    true (compute a better order, if possible; not allowed to be used in conjunction with
             * maxAlternatives value greater than 0; not allowed to be used in conjunction with circle waypoints).
             * The response will include the optimized waypoint indices. This feature can be used with a maximum of
             * 20 route waypoints.
             * *    false (use the locations in the given order). Not allowed to be used in conjunction with
             * routeRepresentation none.
             *
             * @method computeBestOrder
             * @chainable
             * @param {Boolean} [computeBestOrder] Flag to reorder the route waypoints to reduce the route length
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Boolean} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
        computeBestOrder: {
            validator: validators.bool
        },

        /**
             * A setter and getter for 'routeRepresentation' attribute.
             *
             * Specifies the representation of the set of routes provided as response. Possible values:
             * * _polyline_ includes routes in the response.
             * * _none_ includes only the optimized waypoint indices but does not include the routes in the response.
             * * _summaryOnly_ includes only route summary in the response
             *
             * This parameter value _none_ can only be used in conjunction with computeBestOrder true.
             *
             * @method routeRepresentation
             * @chainable
             * @param {String} [routeRepresentation] Allows the routing response to omit the actual route and give only
             *     the best ordered waypoints.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
        routeRepresentation: {
            validator: validators.oneOfValue(['polyline', 'none', 'summaryOnly'], 'route representation')
        },

        /**
             * A setter and getter for 'computeTravelTimeFor' attribute.
             *
             * Specifies whether to return additional travel times using different types of traffic information (none,
             * historic, live) as well as the default best-estimate travel time. Possible values:
             * * none - do not compute additional travel times,
             * * all - compute travel times for all types of traffic information. Specifying all results in the fields
             * noTrafficTravelTimeInSeconds, historicTrafficTravelTimeInSeconds and
             * liveTrafficIncidentsTravelTimeInSeconds being included in the summaries in the route response.
             *
             * @method computeTravelTimeFor
             * @chainable
             * @param {String} [computeTravelTimeFor] Setting to _all_ provides additional information regards
             * travel times.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
        computeTravelTimeFor: {
            validator: validators.oneOfValue(['none', 'all'], 'compute travel time for')
        },

        /**
             * A setter and getter for 'vehicleHeading' attribute.
             *
             * The directional heading of the vehicle in degrees starting at true North and continuing in clockwise
             * direction. North is 0 degrees, east is 90 degrees, south is 180 degrees, west is 270 degrees. Possible
             * values 0-359.
             *
             * @method vehicleHeading
             * @chainable
             * @param {Number} [vehicleHeading] The angle in which the vehicle is heading.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
        vehicleHeading: {
            validator: validators.integerInInterval(-1, 359)
        },

        /**
             * Sets or gets the value of the minDeviationDistance option.
             *
             * Defines at least how far **in meters** the alternative routes have to follow the reference route.
             *
             * This option cannot be used in conjunction with {{#crossLink "Routing/arriveAt:method"}}{{/crossLink}}.
             *
             * @method minDeviationDistance
             * @chainable
             * @param {Number} [newValue] Meters represented as a positive integer number
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {Number} The same service instance or the current option value if no argument was given
             */
        minDeviationDistance: {
            validator: validators.naturalInteger,
            postValidator: [postValidators.firstParamCannotBeUsedWithSecond('minDeviationDistance', 'arriveAt'), postValidators.requiresDependantParameter('minDeviationDistance', 'supportingPoints')]
        },

        /**
             * Sets or gets the value of the minDeviationTime option.
             *
             * Defines at least how far **in time (seconds)** the alternative routes have to follow reference route.
             *
             * This option cannot be used in conjunction with {{#crossLink "Routing/arriveAt:method"}}{{/crossLink}}.
             *
             * @method minDeviationTime
             * @chainable
             * @param {Number} [newValue] Seconds represented as a positive integer number
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {Number} The same service instance or the current option value if no argument was given
             */
        minDeviationTime: {
            validator: validators.naturalInteger,
            postValidator: [postValidators.firstParamCannotBeUsedWithSecond('minDeviationTime', 'arriveAt'), postValidators.requiresDependantParameter('minDeviationTime', 'supportingPoints')]

        },

        /* eslint-disable max-len */
        /**
             * A getter and setter for the 'supportingPoints' attribute.
             *
             * Can be used to set supporting points for constructing (or reconstructing) a route and for
             * calculating alternative routes to a base route. The provided sequence of supporting points
             * is used as input for route reconstruction.
             *
             * Pseudo examples:
             * * If the base route is A > B and we include a supporting point C, the result will be A > C > B;
             * * Supporting points can be used to reconstruct entirely a route you previously had:
             * Let's illustrate the problem. To go from A > B you received A > C > D > E > B. If later, you try to generate
             * the same route (A > B) you might get different middle points, so if you need to generate the exact same route
             * you previously had you can do something like routing().locations(A, B).supportingPoints(C, D, E)
             *
             * You can use one of the following input formats to define the supporting points:
             * * String: '52.3,4.8' or '52.3,4.8:52.37,4.87'
             * * String[]: ['52.3,4.8:52.37,4.87', '52.3,4.8:52.37,4.87']
             * * Object: {lat: 52.3, lon: 4.8} or {lat: 53.3, lng: 5.8} or {x: 53.3, y: 5.8} or {latitude: 53.3, longitude: 5.8}
             * * Object[]: [{lat: 52.3, lon: 4.8}] or [{lat: 53.3, lng: 5.8}]
             *
             * How 'Supporting Points' differ from 'Waypoints?' - Waypoints are points where the calculated route will go through, but
             * the resulting route might be different from search to search, the waypoints order might not be necessarilly respected
             * when calculating the best route, and finally, there is a limit to the number of waypoints you can use in a route calculation.
             * Supporting points can be used to contruct a previous route entirely, or parts of it, using the previous generated points,
             * meaning that there is no limit to the number of points, and the order of these points will be respected.
             *
             * For more information please refer to the [Routing API Docs](https://developer.tomtom.com/routing-api/routing-api-documentation-routing/calculate-route)
             *
             * @method supportingPoints
             * @chainable
             * @param {String|String[]|Object|Object[]} [locations] Supporting points for route calculation.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or converted locations
             *     value if argument is omitted.
             *
             * @example
             * ```js
             * tomtom.routing()
             *   .locations('52.3,4.8:52.37,4.87')
             *   .supportingPoints('52.33357,4.852')
             *   .go()
             *   .then(function(routeGeoJson) {
             *     console.log(routeGeoJson);
             *   });
             * ```
             */
        /* eslint-enable max-len */
        supportingPoints: {
            converter: converters.supportingPoints,
            application: parameterApplications.POST
        },

        /**
             * A getter and setter for the 'sectionType' attribute.
             *
             * Specifies which of the section types is reported in the route response.
             *
             * Possible values:
             * - carTrain: car or train sections in the route
             * - ferry: ferry sections
             * - tunnel: tunnel sections
             * - motorway: motorway sections
             * - tollRoad: payed toll sections
             * - pedestrian: sections which are suited for pedestrians only
             * - tollVignette: sections which require a toll vignette to be present
             * - country: returns country sub sections in the route
             * - travelMode: sections in relation to the request parameter travelMode
             * - traffic: returns traffic sub sections in the route, values include: JAM, ROAD_WORK,
             * ROAD_CLOSURE and OTHER
             *
             * Default value is travelMode.
             * @method sectionType
             * @chainable
             * @param {String[]} [sectionType] Array of section types
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String[]} The same service instance or the current option value if no argument was given
             */
        sectionType: {
            validator: validators.arrayOfValues(['carTrain', 'country', 'ferry', 'motorway', 'pedestrian', 'tollRoad', 'tollVignette', 'travelMode', 'tunnel', 'traffic'], 'sectionType'),
            converter: converters.arrayOfStrings
        },

        /**
             * A setter and getter for 'alternativeType' attribute.
             *
             * Specifies the alternative type of the calculated alternatives compared to the reference route.
             * Possible values are:
             *
             * * anyRoute: allow any alternative route to be returned regardless of how it compares to the reference
             * route in terms of optimality.
             * * betterRoute: returns an alternative route only if it is better than the reference route according
             * to the given planning criteria.
             *
             * Can only be used when reconstructing a route.
             *
             * @method alternativeType
             * @chainable
             * @param {String} [alternativeType] anyRoute or betterRoute value.
             * @throws {TypeError} if the given argument is not one of the accepted values described above
             * @return {String} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
        alternativeType: {
            validator: validators.oneOfValue(['anyRoute', 'betterRoute'], 'alternativeType'),
            postValidator: postValidators.requiresDependantParameter('alternativeType', 'supportingPoints')
        }
    };

    routingParameters = utils.extend(routingParameters, commonRoutingParameters);

    return function (fieldsToSkip) {
        var result = utils.clone(routingParameters);
        if (fieldsToSkip instanceof Array) {
            fieldsToSkip.forEach(function (field) {
                delete result[field];
            });
        }

        return result;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(4), __webpack_require__(42), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (validators, converters, postValidators, parameterApplications) {

    var fields = {
        key: {
            validator: validators.string
        },

        /**
         * A setter and getter for 'routeType' attribute.
         * The type of route requested. Notes on specific values:
         * *    fastest returns the fastest route.
         * *    shortest returns the shortest route by distance.
         * *    eco routes balance economy and speed.
         * *    thrilling routes include interesting or challenging roads and use as few motorways as possible.
         * You can choose the level of turns included and also the degree of hilliness. See the hilliness and
         * windingness parameters for how to set this. There is a limit of 900 km on routes planned with
         * routeType=thrilling
         *
         * Default value is fastest
         *
         * @method routeType
         * @chainable
         * @param {String} [routeType] Route type to be used during route calculation.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or route type value if
         *     argument is omitted.
         */
        routeType: {
            validator: validators.oneOfValue(['fastest', 'shortest', 'eco', 'thrilling'], 'route type')
        },

        /**
         * A setter and getter for 'traffic' attribute.
         * 
         * Possible values:
         * - true (just considers all available traffic information during routing)
         * - false (ignores current traffic data during routing). Note that although the current traffic data is
         *   ignored during routing, the effect of historic traffic on effective road speeds is still incorporated.
         * 
         * Default is true
         *
         * @method traffic
         * @chainable
         * @param {Boolean} [traffic] Boolean flag determines if traffic data should be used to calculate the
         *     route.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Boolean} Method returns the service instance allowing chaining or traffic value if
         *     argument is omitted.
         */
        traffic: {
            validator: validators.bool
        },

        /**
         * A setter and getter for 'avoid' attribute.
         * 
         * Specifies something that the route calculation should try to avoid when determining the route. Can be
         * specified multiple times. Possible values:
         * *    tollRoads: avoids toll roads.
         * *    motorways: avoids motorways.
         * *    ferries: avoids ferries.
         * *    unpavedRoads: avoids unpaved roads.
         * *    carpools: avoids routes that require use of carpool (HOV/ High Occupancy Vehicle) lanes.
         * *    alreadyUsedRoads: avoids using the same road multiple times.
         *
         * Most useful in conjunction with routeType=thrilling.
         *
         * @method avoid
         * @chainable
         * @param {Array|String} [avoid] Specifies something that the route calculation should try to avoid when
         *     determining the route
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Array} Method returns the service instance allowing chaining or street number value if
         *     argument is omitted.
         */
        avoid: {
            validator: validators.arrayOfValues(['tollRoads', 'motorways', 'ferries', 'unpavedRoads', 'carpools', 'alreadyUsedRoads'], 'avoid'),
            converter: converters.arrayOfStrings
        },

        /**
         * A setter and getter for 'departAt' attribute.
         * 
         * The date and time of departure from the origin point.
         * Departure times apart from now must be specified as a dateTime.
         * When a time zone offset is not specified, it will be assumed to be that of the origin point.
         * The departAt value must be in the future. The departAt parameter cannot be used in conjunction with
         * arriveAt.
         *
         * @method departAt
         * @chainable
         * @param {String} [departAt] The properly formatted date with time or 'now' value. Date cannot be in the
         *     past.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or language if argument
         *     is omitted.
         */
        departAt: {
            validator: validators.departAt,
            converter: converters.dateTime
        },

        /**
         * A setter and getter for 'arriveAt' attribute.
         * 
         * The date and time of arrival at the destination point.
         * It must be specified as a dateTime.
         * When a time zone offset is not specified it will be assumed to be that of the destination point.
         * The arriveAt value must be in the future. The arriveAt parameter cannot be used in conjunction with
         * departAt.
         *
         * @method arriveAt
         * @chainable
         * @param {String} [arriveAt] The properly formatted date with time value. Date cannot be in the past.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or language if argument
         *     is omitted.
         */
        arriveAt: {
            validator: validators.arriveAt,
            converter: converters.dateTime
        },

        /**
         * A setter and getter for 'travelMode' attribute.
         * 
         * The travel mode for the requested route. 
         * 
         * Possible values: _car, truck, taxi, bus, van, motorcycle, bicycle, pedestrian_ 
         * 
         * Note that the requested travelMode may not be available for the entire route. Where
         * the requested travelMode is not available for a particular section, the <travelMode> element of the
         * response for that section will be other.
         *
         * @method travelMode
         * @chainable
         * @param {String} [travelMode] The primary mean of transportation to be used while routing.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or language if argument
         *     is omitted.
         */
        travelMode: {
            validator: validators.oneOfValue(['car', 'truck', 'taxi', 'bus', 'van', 'motorcycle', 'bicycle', 'pedestrian'], 'travel mode')
        },

        /**
         * A setter and getter for 'hilliness' attribute.
         * 
         * Degree of hilliness for thrilling route. Possible values: low, normal, high
         * This parameter can only be used in conjunction with routeType thrilling.
         *
         * @method hilliness
         * @chainable
         * @param {String} [hilliness] The level of hilliness on a thrilling route.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or language if argument
         *     is omitted.
         */
        hilliness: {
            validator: validators.oneOfValue(['low', 'normal', 'high'], 'hilliness')
        },

        /**
         * A setter and getter for 'windingness' attribute.
         * 
         * Level of turns for thrilling route. Possible values: low, normal, high
         * This parameter can only be used in conjunction with routeType thrilling.
         *
         * @method windingness
         * @chainable
         * @param {String} [windingness] The level of windingness on a thrilling route.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or language if argument
         *     is omitted.
         */
        windingness: {
            validator: validators.oneOfValue(['low', 'normal', 'high'], 'windingness')
        },

        /**
         * A setter and getter for 'report' attribute.
         * 
         * Specifies which data should be reported for diagnosis purposes. 
         * 
         * Possible values: _effectiveSettings_ 
         * Reports the effective parameters or data used when calling the API.
         * 
         * In the case of defaulted parameters the default will be reflected where the parameter was not specified
         * by the caller.
         *
         * @method report
         * @chainable
         * @param {String} [report] Level of verbose answer from service, useful for debugging purposes.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or language if argument
         *     is omitted.
         */
        report: {
            validator: validators.oneOfValue(['effectiveSettings'], 'report')
        },

        /**
         * A setter and getter for 'vehicleEngineType' attribute.
         * 
         * Engine type of the vehicle. This parameter is currently only considered for travelMode truck. Valid
         * options are: _combustion, electric_
         *
         * @method vehicleEngineType
         * @chainable
         * @param {String} [vehicleEngineType] The vehicle engine type.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        vehicleEngineType: {
            validator: validators.oneOfValue(['combustion', 'electric'], 'vehicle engine type')
        },

        /**
         * A setter and getter for 'vehicleMaxSpeed' attribute.
         * 
         * Maximum speed of the vehicle in km/hour. A value of 0 means that an appropriate value for the vehicle
         * will be determined and applied during route planning. A non-zero value may be overridden during route
         * planning. This parameter is currently only considered for travelMode truck.
         *
         * @method vehicleMaxSpeed
         * @chainable
         * @param {Number} [vehicleMaxSpeed] The maximal allowed vehicle speed in km/h.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        vehicleMaxSpeed: {
            validator: validators.naturalInteger
        },

        /**
         * A setter and getter for 'vehicleWeight' attribute.
         * 
         * Weight of the vehicle in kg. A value of 0 means that weight restrictions are not considered during route
         * planning. This parameter is currently only considered for travelMode truck.
         *
         * @method vehicleWeight
         * @chainable
         * @param {Number} [vehicleWeight] The vehicle weight in kg.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        vehicleWeight: {
            validator: validators.naturalInteger,
            postValidator: postValidators.vehicleWeight
        },

        /**
         * A setter and getter for 'vehicleAxleWeight' attribute.
         * 
         * Weight per axle of the vehicle in kg. A value of 0 means that weight restrictions per axle are not
         * considered during route planning. This parameter is currently only considered for travelMode truck.
         *
         * @method vehicleAxleWeight
         * @chainable
         * @param {Number} [vehicleAxleWeight] The vehicle axle weight in kg.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        vehicleAxleWeight: {
            validator: validators.naturalInteger
        },

        /**
         * A setter and getter for 'vehicleLength' attribute.
         * 
         * Length of the vehicle in meters. A value of 0 means that length restrictions are not considered during
         * route planning. This parameter is currently only considered for travelMode truck.
         *
         * @method vehicleLength
         * @chainable
         * @param {Number} [vehicleLength] The vehicle length in m.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        vehicleLength: {
            validator: validators.numberInInterval(0, Number.MAX_VALUE)
        },

        /**
         * A setter and getter for 'vehicleWidth' attribute.
         * 
         * Width of the vehicle in meters. A value of 0 means that width restrictions are not considered during
         * route planning. This parameter is currently only considered for travelMode truck.
         *
         * @method vehicleWidth
         * @chainable
         * @param {Number} [vehicleWidth] The vehicle width in m.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        vehicleWidth: {
            validator: validators.numberInInterval(0, Number.MAX_VALUE)
        },

        /**
         * A setter and getter for 'vehicleHeight' attribute.
         * 
         * Height of the vehicle in meters. A value of 0 means that height restrictions are not considered
         * during route planning. This parameter is currently only considered for travelMode truck.
         *
         * @method vehicleHeight
         * @chainable
         * @param {Number} [vehicleHeight] The vehicle height in m.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        vehicleHeight: {
            validator: validators.numberInInterval(0, Number.MAX_VALUE)
        },

        /**
         * A setter and getter for 'vehicleCommercial' attribute.
         * 
         * Vehicle is used for commercial purposes and thus may not be allowed to drive on some roads. This
         * parameter is currently only considered for travelMode truck.
         *
         * @method vehicleCommercial
         * @chainable
         * @param {Boolean} [vehicleCommercial] True if vehicle is used for commercial purposes.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        vehicleCommercial: {
            validator: validators.bool
        },

        /**
         * A setter and getter for 'vehicleLoadType' attribute.
         * 
         * Types of cargo that may be classified as hazardous materials and restricted from some roads. Available
         * vehicleLoadType values are US Hazmat classes 1 through 9, plus generic classifications for use in other
         * countries.
         *
         * __Use these for routing in US__
         * * USHazmatClass1 Explosives
         * * USHazmatClass2 Compressed gas
         * * USHazmatClass3 Flammable liquids
         * * USHazmatClass4 Flammable solids
         * * USHazmatClass5 Oxidizers
         * * USHazmatClass6 Poisons
         * * USHazmatClass7 Radioactive
         * * USHazmatclass8 Corrosives
         * * USHazmatClass9 Miscellaneous
         *
         * __Use these for routing in all other countries__
         * * otherHazmatExplosive Explosives
         * * otherHazmatGeneral Miscellaneous
         * * otherHazmatHarmfulToWater Harmful to water
         *
         * This parameter is currently only considered for travelMode truck.
         *
         * @method vehicleLoadType
         * @chainable
         * @param {Array|String} [vehicleLoadType] The array of truck cargo classification.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Array} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        vehicleLoadType: {
            validator: validators.arrayOfValues(['USHazmatClass1', 'USHazmatClass2', 'USHazmatClass3', 'USHazmatClass4', 'USHazmatClass5', 'USHazmatClass6', 'USHazmatClass7', 'USHazmatClass8', 'USHazmatClass9', 'otherHazmatExplosive', 'otherHazmatGeneral', 'otherHazmatHarmfulToWater'], 'vehicle load type'),
            converter: converters.arrayOfStrings
        },
        /**
         * A setter and getter for 'constantSpeedConsumptionInLitersPerHundredkm' attribute.
         * 
         * Specifies the speed-dependent component of consumption.
         * Provided as an unordered list of speed/consumption-rate pairs. The list defines points on a
         * consumption curve.
         * Consumption rates for speeds not in the list are found as follows:
         *   *  by linear interpolation, if the given speed lies in between two speeds in the list
         *   *  by linear extrapolation otherwise, assuming a constant (ΔConsumption/ΔSpeed) determined by
         * the nearest two points in the list.
         *
         * The list must contain between 1 and 25 points (inclusive), and may not
         * contain duplicate points for the same speed. If it only contains a single point,
         * then the consumption rate of that point is used without further processing.
         * Consumption specified for the largest speed must be greater than or equal to that of the
         * penultimate largest speed. This ensures that extrapolation does not lead to negative consumption rates.
         * Similarly, consumption values specified for the two smallest speeds in the list cannot lead to a
         * negative consumption rate for any smaller speed.
         * The minimum and maximum values described here refer to the valid range for the consumption values
         * (expressed in l/100km).
         * @method constantSpeedConsumptionInLitersPerHundredkm
         * @chainable
         * @param {Array} [constantSpeedConsumptionInLitersPerHundredkm] Colon-delimited list of
         * CombustionConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Array} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        constantSpeedConsumptionInLitersPerHundredkm: {
            postValidator: postValidators.constantSpeedConsumption('combustion'),
            converter: converters.constantSpeedConsumption
        },
        /**
         * A setter and getter for 'currentFuelInLiters' attribute.
         * 
         * Specifies the current supply of fuel in liters.
         * @method currentFuelInLiters
         * @chainable
         * @param {Number} [currentFuelInLiters]
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        currentFuelInLiters: {
            postValidators: postValidators.floatAndEngineType('combustion', 'currentFuelInLiters')
        },
        /**
         * A setter and getter for 'auxiliaryPowerInLitersPerHour' attribute.
         * 
         * Specifies the amount of fuel consumed for sustaining auxiliary systems of the vehicle, in liters
         *  per hour. It can be used to specify consumption due to devices and systems such as AC systems, radio,
         * heating, etc.
         * @method auxiliaryPowerInLitersPerHour
         * @chainable
         * @param {Number} [auxiliaryPowerInLitersPerHour]
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        auxiliaryPowerInLitersPerHour: {
            postValidators: postValidators.floatAndEngineType('combustion', 'auxiliaryPowerInLitersPerHour')
        },
        /**
         * A setter and getter for 'fuelEnergyDensityInMJoulesPerLiter' attribute.
         * 
         * Specifies the amount of chemical energy stored in one liter of fuel in megajoules (MJ).
         * It is used in conjunction with the *Efficiency parameters for conversions between saved
         * or consumed energy and fuel.
         * For example, energy density is 34.2 MJ/l for gasoline, and 35.8 MJ/l for Diesel fuel.
         * @method fuelEnergyDensityInMJoulesPerLiter
         * @chainable
         * @param {Number} [fuelEnergyDensityInMJoulesPerLiter]
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        fuelEnergyDensityInMJoulesPerLiter: {
            postValidator: postValidators.fuelEnergyDensityInMJoulesPerLiter
        },
        /**
         * A setter and getter for 'accelerationEfficiency' attribute.
         * 
         * Specifies the efficiency of converting chemical energy stored in fuel to kinetic energy when the
         * vehicle accelerates (i.e. KineticEnergyGained/ChemicalEnergyConsumed).
         * ChemicalEnergyConsumed is obtained by converting consumed fuel to chemical energy using
         * fuelEnergyDensityInMJoulesPerLiter.
         * @method accelerationEfficiency
         * @chainable
         * @param {Number} [accelerationEfficiency]
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        accelerationEfficiency: {
            postValidator: postValidators.efficiencyParameter('accelerationEfficiency', 'decelerationEfficiency')
        },
        /**
         * A setter and getter for 'decelerationEfficiency' attribute.
         * 
         * Specifies the efficiency of converting kinetic energy to saved (not consumed) fuel when the
         * vehicle decelerates (i.e. ChemicalEnergySaved/KineticEnergyLost).
         * ChemicalEnergySaved is obtained by converting saved (not consumed) fuel to energy using
         * fuelEnergyDensityInMJoulesPerLiter.
         * @method decelerationEfficiency
         * @chainable
         * @param {Number} [decelerationEfficiency]
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        decelerationEfficiency: {
            postValidator: postValidators.efficiencyParameter('decelerationEfficiency', 'accelerationEfficiency')
        },
        /**
         * A setter and getter for 'uphillEfficiency' attribute.
         * 
         * Specifies the efficiency of converting chemical energy stored in fuel to potential energy
         * when the vehicle gains elevation (i.e. PotentialEnergyGained/ChemicalEnergyConsumed).
         * ChemicalEnergyConsumed is obtained by converting consumed fuel to chemical energy using
         * fuelEnergyDensityInMJoulesPerLiter.
         * @method uphillEfficiency
         * @chainable
         * @param {Number} [uphillEfficiency]
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        uphillEfficiency: {
            postValidator: postValidators.efficiencyParameter('uphillEfficiency', 'downhillEfficiency')
        },
        /**
         * A setter and getter for 'downhillEfficiency' attribute.
         * 
         * Specifies the efficiency of converting potential energy to saved (not consumed) fuel when the
         * vehicle loses elevation (i.e. ChemicalEnergySaved/PotentialEnergyLost).
         * ChemicalEnergySaved is obtained by converting saved (not consumed) fuel to energy using
         * fuelEnergyDensityInMJoulesPerLiter.
         * @method downhillEfficiency
         * @chainable
         * @param {Number} [downhillEfficiency]
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        downhillEfficiency: {
            postValidator: postValidators.efficiencyParameter('downhillEfficiency', 'uphillEfficiency')
        },
        /**
         * A setter and getter for 'constantSpeedConsumptionInkWhPerHundredkm' attribute.
         * 
         * Specifies the speed-dependent component of consumption.
         * Provided as an unordered list of speed/consumption-rate pairs. The list defines points
         * on a consumption curve.
         * Consumption rates for speeds not in the list are found as follows:
         * *    by linear interpolation, if the given speed lies in between two speeds in the list
         * *    by linear extrapolation otherwise, assuming a constant (ΔConsumption/ΔSpeed) determined by
         * the nearest two points in the list
         *
         * The list must contain between 1 and 25 points (inclusive), and may not contain duplicate points
         * for the same speed. If it only contains a single point, then the consumption rate of that point
         * is used without further processing. Consumption specified for the largest speed must be greater
         * than or equal to that of the penultimate largest speed.
         * This ensures that extrapolation does not lead to negative consumption rates.
         * Similarly, consumption values specified for the two smallest speeds in the list cannot lead to a
         * negative consumption rate for any smaller speed.
         * The minimum and maximum values described here refer to the valid range for the consumption values
         * (expressed in kWh/100km).
         * @method constantSpeedConsumptionInkWhPerHundredkm
         * @chainable
         * @param {Array} [constantSpeedConsumptionInkWhPerHundredkm] Colon-delimited list of
         * ElectricConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Array} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        constantSpeedConsumptionInkWhPerHundredkm: {
            postValidator: postValidators.constantSpeedConsumption('electric'),
            converter: converters.constantSpeedConsumption
        },
        /**
         * A setter and getter for 'currentChargeInkWh' attribute.
         * 
         * Specifies the current electric energy supply in kilowatt hours (kWh).
         * @method currentChargeInkWh
         * @chainable
         * @param {Number} [currentChargeInkWh]
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        currentChargeInkWh: {
            postValidator: postValidators.chargeParameter('currentChargeInkWh', 'maxChargeInkWh')
        },
        /**
         * A setter and getter for 'maxChargeInkWh' attribute.
         * 
         * Specifies the maximum electric energy supply in kilowatt hours (kWh) that may be stored in t
         * he vehicle's battery.
         * @method maxChargeInkWh
         * @chainable
         * @param {Number} [maxChargeInkWh]
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        maxChargeInkWh: {
            postValidator: postValidators.chargeParameter('maxChargeInkWh', 'currentChargeInkWh')
        },
        /**
         * A setter and getter for 'auxiliaryPowerInkW' attribute.
         * 
         * Specifies the amount of power consumed for sustaining auxiliary systems, in kilowatts (kW).
         * It can be used to specify consumption due to devices and systems such as AC systems, radio, heating, etc.
         * @method auxiliaryPowerInkW
         * @chainable
         * @param {Number} [auxiliaryPowerInkW]
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {Number} Method returns the service instance allowing chaining or current value if
         * argument is omitted.
         */
        auxiliaryPowerInkW: {
            postValidator: postValidators.floatAndEngineType('electric', 'auxiliaryPowerInkW')
        },

        /**
         * A setter and getter for _'protocol'_ attribute. 
         * 
         * Represents type of protocol used to perform service call.
         *
         * @method protocol
         * @chainable
         * @param {String} [protocol] Protocol type, one of _http_ or _https_.
         * @throws {TypeError} If the given argument cannot be converted to a valid value.
         * @return {String} Method returns the service instance allowing chaining or _protocol_
         * value if argument is omitted.
         */
        protocol: {
            validator: validators.oneOfValue(['http', 'https'], 'protocol')
        },

        /**
         * A getter and setter for the 'avoidAreas' attribute.
         *
         * A list of shapes to avoid for planning routes. Supported shapes include rectangles.
         * Can contain one of each supported shapes element.
          * @example
         * ```js
         * tomtom.routing().locations('52.37173,4.91015:52.36357,4.898046255')
         * .avoidAreas([{
         *      southWestCorner: {latitude: 52.36391, longitude:4.90106},
         *      northEastCorner: {latitude: 52.36554, longitude:4.90767}
         * }]);
         * ```
         * Supported point formats:
         * - 'lat,lon'
         * - {lat:111, lon:111}
         * - {lat:111, lng:111}
         * - {latitude:111, longitude:111}
         * - {x:111, y:111}
         * - {lat: function(), lng:function()}
         *
         * @method avoidAreas
         * @chainable
         * @param {Object[]} [areas] A list of shapes to avoid for planning routes.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {String} Method returns the service instance allowing chaining or converted locations
         *     value if argument is omitted.
         */
        avoidAreas: {
            converter: converters.avoidAreas,
            application: parameterApplications.POST
        },

        /**
         * A getter and setter for the 'avoidVignette' attribute.
         *
         * List of 3-character ISO 3166-1 alpha-3 country codes of countries in which
         * all toll roads with vignettes are to be avoided.
         * Toll roads with vignettes in countries not in the list are unaffected.
         * It is an error to specify both avoidVignette and allowVignette.
         * @method avoidVignette
         * @chainable
         * @param {String|String[]} [newValue] Array of country codes
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {String|String[]} The same service instance or the current option value if no argument was given
         */
        avoidVignette: {
            validator: validators.countrySetAlpha3.bind(this, false),
            postValidator: postValidators.firstParamCannotBeUsedWithSecond('avoidVignette', 'allowVignette'),
            converter: converters.arrayOfStrings,
            application: parameterApplications.POST
        },

        /**
         * A getter and setter for the 'allowVignette' attribute.
         *
         * List of 3-character ISO 3166-1 alpha-3 country codes of countries in which
         * toll roads with vignettes are allowed.
         * Specifying allowVignette with some countries X is equivalent to specifying
         * avoidVignette with all countries but X.
         * Specifying allowVignette with an empty list is the same as avoiding all toll roads with vignettes.
         * It is an error to specify both avoidVignette and allowVignette.
         * @method allowVignette
         * @chainable
         * @param {String|String[]} [newValue] Array of country codes
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {String|String[]} The same service instance or the current option value if no argument was given
         */
        allowVignette: {
            validator: validators.countrySetAlpha3.bind(this, true),
            postValidator: postValidators.firstParamCannotBeUsedWithSecond('allowVignette', 'avoidVignette'),
            converter: converters.arrayOfStrings,
            application: parameterApplications.POST
        }
    };
    return fields;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(143)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, getRouteFeature) {
    'use strict';

    function newFeatureCollection() {
        return {
            type: 'FeatureCollection',
            features: []
        };
    }

    return function (data) {
        var result, i;
        if (Utils.isString(data)) {
            try {
                data = JSON.parse(data); // aja js has problems and response is not always parsed as it should
            } catch (e) {
                return null;
            }
        }
        if (data.error) {
            return { error: data.error };
        } else {
            result = newFeatureCollection();
            result.optimizedWaypoints = data.optimizedWaypoints;
            if (!data || !data.routes) {
                return result;
            }
            for (i = 0; i < data.routes.length; i += 1) {
                result.features.push(getRouteFeature(data.routes[i]));
            }
            return result;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {

    /**
     * @ignore
     * @param {String | HTMLElement} element Get rect from this element or query for it and then get its rects.
     * @returns {DOMRect | null} Rectangle of given element or null if something bad happens
     */
    function getRect(element) {
        try {
            if (typeof element === 'string') {
                return document.querySelector(element).getBoundingClientRect();
            }
            return element.getBoundingClientRect();
        } catch (err) {
            return null;
        }
    }

    /**
     * Helper method used to update bounding options. Used once for every control container.
     *
     * @ignore
     * @param {Object} bounds Object containing options for padding points. This object will be modified.
     * @param {Object} bounds.paddingTopLeft Object that will be passed as a top-left point of the fitBounds padding
     * @param {Number} bounds.paddingTopLeft.x Horizontal value of the top-left padding
     * @param {Number} bounds.paddingTopLeft.y Vertical value of the top-left padding
     * @param {Object} bounds.paddingBottomRight Object that will be passed as a bottom-right point of the fitBounds
     *     padding
     * @param {Number} bounds.paddingBottomRight.x Horizontal value of the bottom-right padding
     * @param {Number} bounds.paddingBottomRight.y Vertical value of the bottom-right padding
     * @param {'left' | 'right'} horizontal Parameter describing which controls are measured
     * @param {'top' | 'bottom'} vertical Parameter describing which controls are measured
     * @param {'width' | 'height' | 'both'} axis Which axis is taken into account when measuing controls
     * @param {DOMRect} rect Object containing dimensions of measured controls
     */
    function modifyBoundsForRect(bounds, horizontal, vertical, axis, rect) {
        /*__*/if (vertical === 'top' && horizontal === 'left' && axis === 'width') {
            bounds.paddingTopLeft.x += rect[axis];
        } else if (vertical === 'top' && horizontal === 'left' && axis === 'height') {
            bounds.paddingTopLeft.y += rect[axis];
        } else if (vertical === 'top' && horizontal === 'left' && axis === 'both') {
            bounds.paddingTopLeft.x += rect.width;
            bounds.paddingTopLeft.y += rect.height;
        } else if (vertical === 'top' && horizontal === 'right' && axis === 'width') {
            bounds.paddingBottomRight.x += rect[axis];
        } else if (vertical === 'top' && horizontal === 'right' && axis === 'height') {
            bounds.paddingTopLeft.y += rect[axis];
        } else if (vertical === 'top' && horizontal === 'right' && axis === 'both') {
            bounds.paddingBottomRight.x += rect.width;
            bounds.paddingTopLeft.y += rect.height;
        } else if (vertical === 'bottom' && horizontal === 'left' && axis === 'width') {
            bounds.paddingTopLeft.x += rect[axis];
        } else if (vertical === 'bottom' && horizontal === 'left' && axis === 'height') {
            bounds.paddingBottomRight.y += rect[axis];
        } else if (vertical === 'bottom' && horizontal === 'left' && axis === 'both') {
            bounds.paddingTopLeft.x += rect.width;
            bounds.paddingBottomRight.y += rect.height;
        } else if (vertical === 'bottom' && horizontal === 'right' && axis === 'width') {
            bounds.paddingBottomRight.x += rect[axis];
        } else if (vertical === 'bottom' && horizontal === 'right' && axis === 'height') {
            bounds.paddingBottomRight.y += rect[axis];
        } else if (vertical === 'bottom' && horizontal === 'right' && axis === 'both') {
            bounds.paddingBottomRight.x += rect.width;
            bounds.paddingBottomRight.y += rect.height;
        }
    }

    // eslint-disable-next-line
    /**
     * Helper method used to modify bounding options. This function measures every control container and sums their
     *     dimensions.
     *
     * @ignore
     * @param {Object} fitBoundsOptions Object containing options for padding points. This object will be modified.
     * @param {Object} fitBoundsOptions.paddingTopLeft Object that will be passed as a top-left point of the fitBounds
     *     padding
     * @param {Number} fitBoundsOptions.paddingTopLeft.x Horizontal value of the top-left padding
     * @param {Number} fitBoundsOptions.paddingTopLeft.y Vertical value of the top-left padding
     * @param {Object} fitBoundsOptions.paddingBottomRight Object that will be passed as a bottom-right point of the
     *     fitBounds padding
     * @param {Number} fitBoundsOptions.paddingBottomRight.x Horizontal value of the bottom-right padding
     * @param {Number} fitBoundsOptions.paddingBottomRight.y Vertical value of the bottom-right padding
     * @param {Object} controls Object describing how control container is measured
     * @param {'width' | 'height' | 'both'} [controls['top-left']] Object describing how control container is measured
     * @param {'width' | 'height' | 'both'} [controls['top-right']] Object describing how control container is measured
     * @param {'width' | 'height' | 'both'} [controls['bottom-left']] Object describing how control container is
     *      measured
     * @param {'width' | 'height' | 'both'} [controls['bottom-right']] Object describing how control container is
     *      measured
     * @param {'top-left' | 'top-right' | 'bottom-right' | 'bottom-left' } position Position of the measured container
     */
    function modifyBoundsOptions(fitBoundsOptions, controls, position) {
        var topOrBottom, leftOrRight, direction, selector, rect;
        var split = position.split('-');
        if (!(split && split.length === 2)) {
            return;
        }
        topOrBottom = split[0];
        leftOrRight = split[1];
        direction = controls[position]; // width or height or both

        selector = '.leaflet-' + topOrBottom + '.leaflet-' + leftOrRight;
        rect = getRect(selector);
        if (!rect) {
            return;
        }

        modifyBoundsForRect(fitBoundsOptions, leftOrRight, topOrBottom, direction, rect);
    }

    /**
     * @class MapUtils
     * @extends L
     * @module Map
     * @namespace L
     */
    L.MapUtils = {
        /**
         * This method looks over all layers in the map instance and returns an array
         * of matching layers. If layers are not found, returns empty array.
         * @method findLayersByName
         * @param {String} layerName Name of the layers you are looking for
         * @param {Map} map Map instance
         * @returns {Array} Returns an array of matching layers, if no element was found,
         * returns empty array.
         */
        findLayersByName: function findLayersByName(layerName, map) {
            var matchingLayers = [];
            map.eachLayer(function (layer) {
                if (layer.name === layerName) {
                    matchingLayers.push(layer);
                }
            });
            return matchingLayers;
        },

        /**
         * @method getPaddingOptions
         * @example
         * ```javascript
         * var popup = marker.openPopup().getPopup();
         * var popupElement = popup.getElement();
         * var bounds = L.MapUtils.getPaddingOptions({
         *      popup: popupElement,
         *      controls: {
         *          'top-left': 'width', // only width will be taken into account
         *          'bottom-right': 'both'
         *      }
         * });
         * ```
         * @param {Object} components Object describing how paddings should be calculated
         * @param {HTMLElement} [components.popup] Popup element which dimensions will be calculated
         * @param {Object} [components.controls] Object which values describes which control panel is measured and how.
         *      possible keys are `'top-left'`, `'top-right'`, `'bottom-left'`, `'bottom-right'` and values:
         *      `'width'`, `'height'`, `'both'`.
         * @returns {Object} Returns an object reflecting measurements on control containers
         */
        getPaddingOptions: function getPaddingOptions(components) {
            var popupRect;
            var controls = components.controls;
            var popup = components.popup;
            var fitBoundsOptions = {
                paddingTopLeft: { x: 0, y: 0 },
                paddingBottomRight: { x: 0, y: 0 }
            };
            if (controls) {
                try {
                    Object.getOwnPropertyNames(controls).forEach(modifyBoundsOptions.bind(null, fitBoundsOptions, controls));
                } catch (err) {
                    //
                }
            }
            if (popup) {
                try {
                    popupRect = getRect(popup);
                    fitBoundsOptions.paddingTopLeft.x += popupRect.width / 2;
                    fitBoundsOptions.paddingBottomRight.x += popupRect.width / 2;
                    fitBoundsOptions.paddingTopLeft.y += popupRect.height;
                } catch (err) {
                    //
                }
            }
            return fitBoundsOptions;
        },

        /**
         * @method setViewWithOffset
         * @param {Map} map Map object that is associated with setView method
         * @param {LatLng} targetLatLng Point that is the original center of the transformation
         * @param {number} targetZoom Zoom level that is going to be applied to setView
         * @param {Object} options Pan and zoom options
         * @param {Point} offsetPoint Point that represents the shift of the original center point
         */
        setViewWithOffset: function setViewWithOffset(map, targetLatLng, targetZoom, options, offsetPoint) {
            var targetPoint = map.project(targetLatLng, targetZoom).subtract(offsetPoint);
            var offsetLatLng = map.unproject(targetPoint, targetZoom);
            map.setView(offsetLatLng, targetZoom, options);
        }

    };

    return L.MapUtils;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';
    /*this mapping is used to map category_codes => filename
        https://developer.tomtom.com/search-api/search-api-documentation/supported-category-codes
        keep in mind that files in the filesystem are named like that: RESTAURANT.colors-black-white.svg
        colors-black-white is used during compilation to generate white and black icons
        icons are converted to css and included in map.css
    */

    var availableIcons = {
        fallback: 'flag',
        ACCESS_GATEWAY: 'ic_map_poi_110',
        ADMINISTRATIVE_DIVISION: 'ic_map_poi_133',
        ADVENTURE_SPORTS_VENUE: 'ic_map_poi_122',
        AGRICULTURE: 'ic_map_poi_107',
        AIRPORT: 'ic_map_poi_007',
        AMUSEMENT_PARK: 'ic_map_poi_051',
        AUTOMOTIVE_DEALER: 'ic_map_poi_008',
        BANK: 'ic_map_poi_077',
        BEACH: 'ic_map_poi_043',
        BUILDING_POINT: 'ic_map_poi_132',
        BUSINESS_PARK: 'ic_map_poi_102',
        CAFE_PUB: 'ic_map_poi_120',
        CAMPING_GROUND: 'ic_map_poi_058',
        CAR_WASH: 'ic_map_poi_067',
        CASH_DISPENSER: 'ic_map_poi_042',
        CASINO: 'ic_map_poi_009',
        CINEMA: 'ic_map_poi_011',
        CITY_CENTER: 'ic_map_poi_012',
        CLUB_ASSOCIATION: 'ic_map_poi_131',
        COLLEGE_UNIVERSITY: 'ic_map_poi_041',
        COMMERCIAL_BUILDING: 'ic_map_poi_098',
        COMMUNITY_CENTER: 'ic_map_poi_081',
        COMPANY: 'ic_map_poi_013',
        COURTHOUSE: 'ic_map_poi_015',
        CULTURAL_CENTER: 'ic_map_poi_016',
        DENTIST: 'ic_map_poi_048',
        DEPARTMENT_STORE: 'ic_map_poi_104',
        DOCTOR: 'ic_map_poi_047',
        ELECTRIC_VEHICLE_STATION: 'ic_map_poi_073',
        EMBASSY: 'ic_map_poi_040',
        EMERGENCY_MEDICAL_SERVICE: 'ic_map_poi_115',
        ENTERTAINMENT: 'ic_map_poi_035',
        EXCHANGE: 'ic_map_poi_096',
        EXHIBITION_CONVENTION_CENTER: 'ic_map_poi_017',
        FERRY_TERMINAL: 'ic_map_poi_018',
        FIRE_STATION_BRIGADE: 'ic_map_poi_068',
        FRONTIER_CROSSING: 'ic_map_poi_019',
        FUEL_FACILITIES: 'ic_map_poi_004',
        GEOGRAPHIC_FEATURE: 'ic_map_poi_127',
        GOLF_COURSE: 'ic_map_poi_020',
        GOVERNMENT_OFFICE: 'ic_map_poi_000',
        HEALTH_CARE_SERVICE: 'ic_map_poi_116',
        HELIPAD_HELICOPTER_LANDING: 'ic_map_poi_123',
        HOLIDAY_RENTAL: 'ic_map_poi_130',
        HOSPITAL_POLYCLINIC: 'ic_map_poi_021',
        HOTEL_MOTEL: 'ic_map_poi_022',
        ICE_SKATING_RINK: 'ic_map_poi_044',
        IMPORTANT_TOURIST_ATTRACTION: 'ic_map_poi_023',
        INDUSTRIAL_BUILDING: 'ic_map_poi_095',
        LEISURE_CENTER: 'ic_map_poi_061',
        LIBRARY: 'ic_map_poi_052',
        MANUFACTURING_FACILITY: 'ic_map_poi_099',
        MARINA: 'ic_map_poi_062',
        MARKET: 'ic_map_poi_118',
        MEDIA_FACILITY: 'ic_map_poi_101',
        MILITARY_INSTALLATION: 'ic_map_poi_106',
        MOTORING_ORGANIZATION_OFFICE: 'ic_map_poi_076',
        MOUNTAIN_PASS: 'ic_map_poi_024',
        MUSEUM: 'ic_map_poi_025',
        NATIVE_RESERVATION: 'ic_map_poi_125',
        NIGHTLIFE: 'ic_map_poi_050',
        NON_GOVERNMENTAL_ORGANIZATION: 'ic_map_poi_134',
        OPEN_PARKING_AREA: 'ic_map_poi_002',
        OTHER: 'flag',
        PARKING_GARAGE: 'ic_map_poi_003',
        PARK_RECREATION_AREA: 'ic_map_poi_059',
        PETROL_STATION: 'ic_map_poi_004',
        PHARMACY: 'ic_map_poi_054',
        PLACE_OF_WORSHIP: 'ic_map_poi_027',
        POLICE_STATION: 'ic_map_poi_039',
        PORT_WAREHOUSE_FACILITY: 'ic_map_poi_105',
        POST_OFFICE: 'ic_map_poi_028',
        PRIMARY_RESOURCE_UTILITY: 'ic_map_poi_108',
        PRISON_CORRECTIONAL_FACILITY: 'ic_map_poi_094',
        PUBLIC_AMENITY: 'ic_map_poi_097',
        PUBLIC_TRANSPORT_STOP: 'ic_map_poi_069',
        RAILWAY_STATION: 'ic_map_poi_005',
        RENT_A_CAR_FACILITY: 'ic_map_poi_029',
        RENT_A_CAR_PARKING: 'ic_map_poi_030',
        REPAIR_FACILITY: 'ic_map_poi_053',
        RESEARCH_FACILITY: 'ic_map_poi_100',
        RESIDENTIAL_ACCOMMODATION: 'ic_map_poi_075',
        RESTAURANT: 'ic_map_poi_031',
        RESTAURANT_AREA: 'ic_map_poi_031',
        REST_AREA: 'ic_map_poi_006',
        SCENIC_PANORAMIC_VIEW: 'ic_map_poi_055',
        SCHOOL: 'ic_map_poi_070',
        SHOP: 'ic_map_poi_032',
        SHOPPING_CENTER: 'ic_map_poi_033',
        SPORTS_CENTER: 'ic_map_poi_038',
        STADIUM: 'ic_map_poi_034',
        SWIMMING_POOL: 'ic_map_poi_046',
        TENNIS_COURT: 'ic_map_poi_045',
        THEATER: 'ic_map_poi_035',
        TOURIST_INFORMATION_OFFICE: 'ic_map_poi_023',
        TRAFFIC_LIGHT: 'ic_map_poi_129',
        TRAFFIC_SERVICE_CENTER: 'ic_map_poi_126',
        TRAFFIC_SIGN: 'ic_map_poi_128',
        TRAIL_SYSTEM: 'ic_map_poi_124',
        TRANSPORT_AUTHORITY_VEHICLE_REGISTRATION: 'ic_map_poi_113',
        TRUCK_STOP: 'ic_map_poi_071',
        VETERINARIAN: 'ic_map_poi_049',
        WATER_SPORT: 'ic_map_poi_046',
        WEIGH_STATION: 'ic_map_poi_111',
        WELFARE_ORGANIZATION: 'ic_map_poi_117',
        WINERY: 'ic_map_poi_057',
        ZOOS_ARBORETA_BOTANICAL_GARDEN: 'ic_map_poi_037'
    };

    /*
        This map contains icons which are single color - means they are not in black and white version
     */
    var singleColorIcons = {
        OPEN_PARKING_AREA: '',
        PARKING_GARAGE: '',
        RENT_A_CAR_PARKING: '',
        TRUCK_STOP: ''
    };

    return {
        defaultIcons: availableIcons,
        singleColorIcons: singleColorIcons
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * This component generates HTML content based on provided options and data. Currently supported data type is search
 * result (either main result or entry point associated with POI result).
 * Content generated is split into following sections which visibility is configurable:
 * * 'name' - prints POI name with associated icon
 * * 'address' - prints address information
 * * 'coordinates' - prints coordinates (lat,lng) information
 * * 'entryPoint' - prints parent POI name and entry point type
 *
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(149), __webpack_require__(154), __webpack_require__(155), __webpack_require__(156), __webpack_require__(157), __webpack_require__(158), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, modelFactory, entryPointContent, nameContent, addressContent, coordinatesContent, actionsGenerator, Wrapable) {
    'use strict';

    var AREAS = {
        ENTRYPOINT: 'entryPoint',
        NAME: 'name',
        ADDRESS: 'address',
        COORDINATES: 'coordinates'
    };
    var ordering = Object.keys(AREAS).map(function (item) {
        return AREAS[item];
    });

    var defaultOptions = {
        name: true,
        address: true,
        coordinates: true,
        entryPoint: false
    };

    var classes = {
        content: 'tomtom-point-content',
        details: 'tomtom-point-content__details'
    };
    var ContentGenerator;

    function areaContentGenerator(area, data) {
        switch (area) {
            case AREAS.ENTRYPOINT:
                return entryPointContent(data.parent.poi, data.type);
            case AREAS.NAME:
                return data.poi ? nameContent(data.poi) : L.DomUtil.create('span');
            case AREAS.ADDRESS:
                return addressContent(data);
            case AREAS.COORDINATES:
                return coordinatesContent(data.position);
            default:
                return L.DomUtil.create('span');
        }
    }

    ContentGenerator = function ContentGenerator(options) {
        this.options = options || defaultOptions;
    };

    /**
     * @ignore
     * @param {Object} data Either search result or entry point
     * @param {Object }additionalData Parent POI if 'data' param is entry point. If not, it's ignored.
     * @return {Wrapable}
     */
    ContentGenerator.prototype.generate = function (data, additionalData) {
        var result = L.DomUtil.create('div', classes.content),
            details = L.DomUtil.create('div', classes.details),
            modeledData = modelFactory(data, additionalData),
            actions;

        ordering.reduce(function (accumulator, area) {
            if (this.options[area]) {
                accumulator.appendChild(areaContentGenerator(area, modeledData));
            }
            return accumulator;
        }.bind(this), details);

        if (details.children.length) {
            result.appendChild(details);
        }

        if (this.options.actions) {
            actions = actionsGenerator(modeledData, this.options.actions);
            result.appendChild(actions.getHtmlElement());
        }

        return new Wrapable(result, function () {
            if (actions) {
                actions.wrap();
            }
        });
    };

    /**
     * @ignore
     * @param {Object} options
     * @param {Boolean} [options.name=true] A flag specifying if name area is printed
     * @param {Boolean} [options.coordinates=true] A flag specifying if coordinates area is printed
     * @param {Boolean} [options.address=true] A flag specifying if address area is printed
     * @param {Boolean} [options.entryPoint=false] A flag specifying if entry point area is printed
     * @param {Object} [options.actions] An object describing what type of actions should be created
     * @param {Object} [options.actions.routing] An object grouping routing actions configuration
     * @param {Boolean} [options.actions.routing.routeTo] A flag specifying if 'Route to' action should be generated.
     *     Coordinates for this action are taken from 'position' field associated with provided data object.
     * @param {Boolean} [options.actions.routing.routeFrom] A flag specifying if 'Route from' action should be
     *     generated. Coordinates for this action are taken from 'position' field associated with provided data object.
     * @param {Boolean} [options.actions.routing.routeToEntryPoint] A flag specifying if 'Route to' action for entry
     *     points should be generated. Coordinates for this action are taken from 'position' field associated with given
     *     entry point. If no entry point is available this action will not be generated.
     * @param {Boolean} [options.actions.routing.routeFromEntryPoint] A flag specifying if 'Route from' action entry
     *     points should be generated. Coordinates for this action are taken from 'position' field associated with given
     *     entry point. If no entry point is available this action will not be generated.
     * @param {Function} [options.actions.routing.onActionClick] 'click' event handler for all route actions. Most
     *     probably used for generating a route.
     * @param {Object} [options.actions.search] An object grouping search actions configuration
     * @param {Boolean} [options.actions.search.searchNearby] A flag specifying if 'NearBy' search action should be
     *     generated.
     * @param {Function} [options.actions.search.onActionClick] 'click' event handler for all search actions.
     * @param {Object} [options.actions.remove] An object specifying if 'Remove' action is generated.
     * @param {Function} [options.actions.remove.onActionClick] 'click' event handler for all 'Remove' action.
     *
     * @return {Wrapable}
     */

    return function (options) {
        var result = new ContentGenerator(options);
        return result.generate.bind(result);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(80), __webpack_require__(81), __webpack_require__(150), __webpack_require__(82), __webpack_require__(19), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, AddressModel, PoiModel, AddressRangesModel, EntryPointModel, ObjectModel, utils) {
    'use strict';

    var SIMPLE_PROPERTIES = ['dist', 'score', 'type', 'entityType'];
    var SearchModel;

    /**
     * For future readers: these functions were added to satisfy tics cyclomatic complexity score
     */

    function addSimpleProperties(json) {
        SIMPLE_PROPERTIES.forEach(function (property) {
            if (typeof json[property] !== 'undefined') {
                this[property] = json[property];
            }
        }, this);
    }

    function addAddress(json) {
        if (typeof json.address !== 'undefined') {
            this.address = new AddressModel(json.address);
        }
    }

    function addPosition(json) {
        if (typeof json.position !== 'undefined') {
            this.position = utils.convertToLatLng(json.position);
        }
    }

    function addPoi(json) {
        if (typeof json.poi !== 'undefined') {
            this.poi = new PoiModel(json.poi);
        }
    }

    function addAdressRanges(json) {
        if (typeof json.addressRanges !== 'undefined') {
            this.addressRanges = new AddressRangesModel(json.addressRanges);
        }
    }

    function setBoundingBox(json) {
        if (typeof json.boundingBox !== 'undefined') {
            this.boundingBox = L.latLngBounds(utils.convertToLatLng(json.boundingBox.btmRightPoint), utils.convertToLatLng(json.boundingBox.topLeftPoint));
        }
    }

    function setViewport(json) {
        if (typeof json.viewport !== 'undefined') {
            this.viewport = L.latLngBounds(utils.convertToLatLng(json.viewport.btmRightPoint), utils.convertToLatLng(json.viewport.topLeftPoint));
        }
    }

    function addEntryPoints(json) {
        if (typeof json.entryPoints !== 'undefined') {
            this.entryPoints = json.entryPoints.map(function (entry) {
                return new EntryPointModel(entry);
            });
        }
    }

    SearchModel = function SearchModel(json) {
        addSimpleProperties.call(this, json);
        addAddress.call(this, json);
        addPosition.call(this, json);
        addPoi.call(this, json);
        addAdressRanges.call(this, json);
        setBoundingBox.call(this, json);
        setViewport.call(this, json);
        addEntryPoints.call(this, json);
        return this;
    };
    SearchModel.prototype = Object.create(ObjectModel.prototype);
    SearchModel.prototype.constructor = SearchModel;

    SearchModel.prototype.simplify = function () {
        var result = {},
            key;
        var simplifier = function simplifier(item) {
            return item.simplify();
        };

        for (key in this) {
            if (this.hasOwnProperty(key)) {
                if (this[key] instanceof Array && this[key].length > 0 && this[key][0].simplify) {
                    result[key] = this[key].map(simplifier);
                } else if (_typeof(this[key]) === 'object' && this[key].simplify) {
                    result[key] = this[key].simplify();
                } else if (this[key] instanceof L.LatLng) {
                    result[key] = { lat: this[key].lat, lon: this[key].lng };
                } else if (this[key] instanceof L.LatLngBounds) {
                    result[key] = {
                        topLeftPoint: { lat: this[key].getSouthWest().lat, lon: this[key].getSouthWest().lng },
                        btmRightPoint: { lat: this[key].getNorthEast().lat, lon: this[key].getNorthEast().lng }
                    };
                } else {
                    result[key] = this[key];
                }
            }
        }
        return result;
    };

    return SearchModel;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ObjectModel) {
    'use strict';

    var SIMPLE_PROPERTIES = ['country', 'countryCode', 'countryCodeISO3', 'countrySecondarySubdivision', 'countryTertiarySubdivision', 'countrySubdivision', 'countrySubdivisionName', 'freeformAddress', 'municipality', 'municipalitySubdivision', 'postalCode', 'extendedPostalCode', 'streetName', 'streetNumber'];

    var AddressModel = function AddressModel(json) {
        SIMPLE_PROPERTIES.forEach(function (property) {
            if (typeof json[property] !== 'undefined') {
                this[property] = json[property];
            }
        }, this);
        return this;
    };
    AddressModel.prototype = Object.create(ObjectModel.prototype);
    AddressModel.prototype.constructor = AddressModel;

    return AddressModel;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ObjectModel) {
    'use strict';

    var SIMPLE_PROPERTIES = ['categories', 'classifications', 'name', 'phone', 'url'];

    var PoiModel = function PoiModel(json) {
        SIMPLE_PROPERTIES.forEach(function (property) {
            if (typeof json[property] !== 'undefined') {
                this[property] = json[property];
            }
        }, this);

        return this;
    };
    PoiModel.prototype = Object.create(ObjectModel.prototype);
    PoiModel.prototype.constructor = PoiModel;

    return PoiModel;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(25), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ObjectModel, reverseGeocode, utils) {
    'use strict';

    var EntryPointModel = function EntryPointModel(json, parent) {
        this.position = utils.convertToLatLng(json.position);
        this.type = json.type;
        this.parent = parent;

        return this;
    };

    EntryPointModel.prototype = Object.create(ObjectModel.prototype);
    EntryPointModel.prototype.constructor = EntryPointModel;

    EntryPointModel.prototype.simplify = function () {
        return {
            position: { lat: this.position.lat, lon: this.position.lng },
            type: this.type
        };
    };

    EntryPointModel.prototype.getAddress = function () {
        return reverseGeocode().position({ lat: this.position.lat, lon: this.position.lng }).go();
    };
    return EntryPointModel;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(151), __webpack_require__(84), __webpack_require__(8), __webpack_require__(2), __webpack_require__(4), __webpack_require__(0), __webpack_require__(152)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restReverseGeocode, model, chain, validators, converters, utils, batchModel) {
    'use strict';

    var TYPES = {
        reverseGeocode: 'reverseGeocode',
        crossStreetLookup: 'reverseGeocode/crossStreet'
    };

    var reverseGeocode = restReverseGeocode();

    function ReverseGeocodeBase(options) {
        this.options = options || {};
        this.options.__serviceType = 'reverseGeocoder';
        this.fields = {};
    }

    ReverseGeocodeBase.prototype.TYPE = TYPES;
    ReverseGeocodeBase.prototype.construct = function () {
        var batchFields;
        this.fields = utils.addFields.call(this, this.fields);
        batchFields = {
            batchItems: {
                validator: validators.arrayOf(this.fields),
                converter: converters.arrayOf(this.fields)
            },
            type: {
                validator: validators.string
            }
        };

        if (Array.isArray(this.options)) {
            return chain.call(this, batchFields, this.handleBatchChain, {
                batchItems: this.options,
                type: this.fields.type.defaultValue
            });
        } else {
            return chain.call(this, this.fields, this.handleChain, this.options);
        }
    };

    ReverseGeocodeBase.prototype.handleBatchChain = function (data, callback) {
        reverseGeocode.batch(this.fields, data, function (response) {
            callback.call(this, batchModel(response));
        });
    };

    ReverseGeocodeBase.prototype.handleChain = function (data, callback) {
        reverseGeocode.reverseGeocode(this.fields, data, function (response) {
            callback.call(this, model(response)[0]);
        });
    };

    function reverseGeocodeConstructor(options) {
        return new ReverseGeocodeBase(options).construct();
    }

    reverseGeocodeConstructor.prototype.constructor = ReverseGeocodeBase;

    return reverseGeocodeConstructor;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (selector) {
    'use strict';

    return function (json) {
        return selector(json, 'addresses');
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(4), __webpack_require__(43), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (validators, converters, types, parameterApplications) {
    var geocodeBaseFields = {
        key: {
            validator: validators.string
        },
        position: {
            converter: converters.point,
            validator: validators.point,
            required: true,
            application: parameterApplications.PATH
        },
        spatialKeys: {
            validator: validators.bool
        },
        heading: {
            validator: validators.number
        },
        radius: { validator: validators.naturalInteger },
        protocol: { validator: validators.oneOfValue(['http', 'https'], 'protocol') }
    };

    var additionalGeocodeFields = {
        type: {
            defaultValue: types.reverseGeocode,
            visible: false,
            application: parameterApplications.PATH
        },

        allowFreeformNewline: {
            validator: validators.bool
        },

        /**
         * @class ReverseGeocode
         * @module Services
         */

        /**
         * Sets or gets the value of the option `returnSpeedLimit`.
         *
         * Allows, if possible, to receive the speed limit information at the given location.
         *
         * @method returnSpeedLimit
         * @chainable
         * @param {Boolean} [newValue] Enable or disable the feature
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {Boolean} The same service instance or the current option value if no argument was given
         */
        returnSpeedLimit: {
            validator: validators.bool
        },

        /**
         * Sets or gets the value of the option `number`.
         *
         * If a street number is sent in along with the request, the response may
         * include the side of the street (Left/Right) and also an offset position for that street number.
         *
         * @method number
         * @chainable
         * @param {String} [newValue] Street number as a string
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {String} The same service instance or the current option value if no argument was given
         */
        number: {
            validator: validators.string
        },

        /**
         * Sets or gets the value of the option `returnRoadUse`.
         *
         * Requires to include a road use array for reversegeocodes at street level.
         *
         * @method returnRoadUse
         * @chainable
         * @param {Boolean} [newValue] Enable or disable the feature
         * @throws {TypeError} if the given argument cannot be converted into a valid value
         * @return {Boolean} The same service instance or the current option value if no argument was given
         */
        returnRoadUse: {
            validator: validators.bool
        },

        /**
         * Sets or gets the value of the option `returnMatchType`.
         *
         * If set, response will contain additional field with one of the values:
         *  * AddressPoint (exact house number location)
         *  * HouseNumberRange (interpolated house number location)
         *  * Street (street location without house number)
         *
         * @method returnMatchType
         * @chainable
         * @param {Boolean} [newValue] Enable or disable the feature
         * @throws {TypeError} If the given argument cannot be converted into a valid value
         * @return {Boolean} The same service instance or the current option value if no argument was given
        */
        returnMatchType: {
            validator: validators.bool
        },

        /**
         * Sets or gets the value of the option `roadUse`.
         *
         * Use this option if you want to restrict the result to one or a group of the following road uses:
         * - `"LimitedAccess"`
         * - `"Arterial"`
         * - `"Terminal"`
         * - `"Ramp"`
         * - `"Rotary"`
         * - `"LocalStreet"`
         *
         * @method roadUse
         * @chainable
         * @param {String[]|String} [newValue] An array of strings or just one string with comma separated values
         * @throws {TypeError} if the given argument cannot be converted into a valid value
         * @return {String[]|String} The same service instance or the current option value if no argument was given
         */
        roadUse: {
            converter: converters.roadUse,
            validator: validators.roadUse
        },

        language: {
            validator: validators.languageCode, converter: converters.language
        },

        view: { validator: validators.geopolView('reverseGeocoder', 'view') }
    };

    var crossStreetLookupFields = {
        type: {
            defaultValue: types.crossStreetLookup,
            visible: false,
            application: parameterApplications.PATH
        },

        limit: {
            validator: validators.limit
        },

        language: {
            validator: validators.languageCode
        }
    };

    return function (type) {
        if (type === types.reverseGeocode) {
            return Object.assign({}, geocodeBaseFields, additionalGeocodeFields);
        } else if (type === types.crossStreetLookup) {
            return Object.assign({}, geocodeBaseFields, crossStreetLookupFields);
        }
        throw new Error('Unsupported geocode type: ' + type);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(87), __webpack_require__(77)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, simpleSVGIcon, defaultIconsMappingProvider) {
    'use strict';

    var ICONS = defaultIconsMappingProvider.defaultIcons;

    function isSingleColorIcon(poiClassification) {
        return poiClassification && poiClassification[0] && defaultIconsMappingProvider.singleColorIcons[poiClassification[0].code] !== undefined;
    }

    return function (poiData) {
        var div,
            classificationsExist = poiData.classifications && poiData.classifications.length > 0,
            iconName = classificationsExist ? ICONS[poiData.classifications[0].code] : 'flag',
            isSingleColor = isSingleColorIcon(poiData.classifications),
            icon = simpleSVGIcon('icon-' + iconName + (isSingleColor ? '' : '-black'));

        div = L.DomUtil.create('div', 'tomtom-point-content__icon');
        div.appendChild(icon);
        return div;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * Preconfigured svg icon
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (SVGIcon) {
    'use strict';

    return function buildSimpleSVGIcon(iconName) {
        var options = {
            background: undefined,
            icon: {
                iconSize: [30, 30],
                iconAnchor: [0, 0],
                icon: iconName,
                noPlainSVG: false
            }
        };
        return new SVGIcon(options).createIcon();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {
    'use strict';

    function getValueOrEmptyString(value) {
        return value || '';
    }

    return function (address) {
        var addressElement = L.DomUtil.create('div'),
            streetElement = L.DomUtil.create('div', null, addressElement),
            municipalityElement = L.DomUtil.create('div', null, addressElement);

        streetElement.innerHTML = getValueOrEmptyString(address.streetName) + ' ' + getValueOrEmptyString(address.streetNumber);
        municipalityElement.innerHTML = getValueOrEmptyString(address.postalCode) + ' ' + getValueOrEmptyString(address.municipality);

        return addressElement;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * A clickable button with associated text, icon and click event handler.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(87)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, simpleSVGIcon) {
    'use strict';

    var classes = {
        action: 'tomtom-point-content__action',
        icon: 'tomtom-point-content__icon',
        text: 'tomtom-point-content__text'
    };

    return function (icon, text, clickHandler) {
        var buttonContainer = L.DomUtil.create('div', classes.action),
            iconContainer = L.DomUtil.create('div', classes.icon, buttonContainer),
            textContainer = L.DomUtil.create('span', classes.text, buttonContainer);

        if (icon) {
            iconContainer.appendChild(simpleSVGIcon(icon));
        }

        textContainer.innerHTML = text;

        if (clickHandler) {
            buttonContainer.addEventListener('click', clickHandler);
        }

        return buttonContainer;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */

/**
 * Sets or returns the value of the `boundingBox` option.
 *
 * The bounding box is an area within the search results needs to limit to. If it is omitted then the
 * whole world will be taken into consideration.
 *
 * In case the area specified exceeds the world boundaries the following actions will be taken
 * depending of which side was exceeded:
 *  - Latitudes: the exceeded values will be replaced with their maximun.
 *  - Longitudes: The service will split the area into two (or more) valid bounding boxes and will
 *    execute a search request for each one and them merge the responses into a single result.
 *
 * This method is able to convert a number of popular formats into the bounding box.
 *
 * The supported formats are listed below:
 *  - `{minLon: 0, minLat: 0, maxLon: 1, maxLat: 1}` Plain object with the keys minLon, minLat, maxLon, maxLat.
 *  - `L.LatLngBounds` Leaflet's L.LatLngBounds object.
 *  - `[0, 0, 1, 1]` An array of numbers describing the bounding box following the order: minLon, minLat,
 *     maxLon, maxLat.
 *  - `ol.Extent` Open Layers extent object.
 *  - `[ol.Coordinate, ol.Coordinate]` An array of two open layers coordinate objects with the order:
 *     southWest, northEast.
 *  - `[[0, 0], [1, 1]]` A two-dimensional array with two indexes [southWest, northEast], each one with
 *     latitude and longitude values.
 *  - `"0,0,1,1"` Comma separated string with numbers in the order: minLon, minLat, maxLon, maxLat.
 *  - `[{lon: 0, lat: 0},{lon: 1, lat: 1}]` A one-dimensional array with two objects in the order: southWest,
 *     northEast and each object with a `lat` and `lon` keys.
 *  - `[{lng: 0, lat: 0},{lng: 1, lat: 1}]` A one-dimensional array with two objects in the order: southWest,
 *     northEast and each object with a `lat` and `lon` keys.
 *  - `[L.LatLng, L.LatLng]` A one-dimensional array with two L.LatLng instances in the order: southWest
 *     and northEast.
 *  - `google.maps.LatLngBounds` Google Maps bounds object.
 *  - `google.maps.LatLngBoundsLiteral` Google Maps bounds object.
 *  - `[LatLng, LatLng]` array of two google.maps.LatLng.
 *  - `[LatLngLiteral, LatLngLiteral]` array of two google.maps.LatLngLiteral.
 *
 * @method boundingBox
 * @deprecated
 * @chainable
 * @param {Object|Number[]|Object[]|String} [newValue] Bounding box area in one of the supported formats
 * @throws {TypeError} If the given argument cannot be converted into a valid value
 * @return {Object|Number[]|Object[]|String} The same service instance or the current option value if no
 *     argument was given
 */

/**
 * Allows to make search request using the TomTom's
 * [Search API - Nearby Search API](https://developer.tomtom.com/search-api/search-api-documentation-search/nearby-search).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "NearbySearch/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "NearbySearch/go:method"}}{{/crossLink}} method to handle the response.
 *
 * @example
 * ```js
 * function callbackFn(result) {
 *   console.log(result);
 * };
 *
 * // Using a callback function
 * tomtom.nearbySearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .center([0,0])
 *   .radius(1000)
 *   .callback(callbackFn)
 *   .go();
 *
 * // Or using a Promise
 * tomtom.nearbySearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .center([0,0])
 *   .radius(1000)
 *   .go()
 *   .then(callbackFn);
 * ```
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class NearbySearch
 * @extends Search
 * @uses ExtendedPostalCodesForMixin
 * @uses CenterMixin
 * @uses RadiusMixin
 * @uses CountrySetMixin
 * @uses OffsetMixin
 * @uses ViewMixin
 * @uses BestResultMixin
 * @uses TypeaheadMixin
 * @constructor
 * @module Services
 *
 * @param {Object}   [options] Options to be passed to the nearby search call,
 *     or Array of such options objects to perform batch request.
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String} [options.view="Unified"] Geopolitical view
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {Boolean}  [options.bestResult=false] Return only one result, the best match result.
 * @param {Number[]|String|L.LatLng|Object} options.center Location where results should be biased.
 *  This parameter is required to be defined either in the options passed to the constructor or using the
 *  **center()** method.
 * @param {Number}   [options.radius=10000] The search radius in meters using the coordinates given to the **center**
 *  option as origin.
 *  It expects a value between 1 and 50000, if none is set defaults to 10000.
 * @param {Number}   [options.offset=0] Starting offset of the returned results within the full result set
 * @param {String}   [options.countrySet] List of country codes for limit the search request to those specific
 *  political limits
 * @param {Object|Number[]|Object[]|String} [options.boundingBox] DEPRECATED! The bounding box is an area within the
 * search results needs to limit to. If it is omitted then the whole world will be taken into consideration.
 * @param {String}   [options.extendedPostalCodesFor] Represent the indexes for which extended postal codes should
 *  be included in the results
 * @param {Boolean}   [options.typeahead=false] Enables of disables the option.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (search, validators) {
    'use strict';

    var SearchPrototype = search.prototype.constructor;

    function NearbySearch(options) {
        SearchPrototype.call(this, options);

        this.fields.type = {
            defaultValue: this.TYPE.nearby,
            visible: false
        };
        this.fields.query = {
            required: false,
            visible: false,
            defaultValue: ''
        };
        this.fields.center = {
            required: true
        };
        this.fields.radius = {
            required: true,
            validator: validators.integerInInterval(0, 50000),
            defaultValue: 10000
        };
        this.fields.typeahead = {
            visible: false
        };
    }

    NearbySearch.prototype = new SearchPrototype();
    NearbySearch.prototype.constructor = NearbySearch;

    return function (options) {
        return new NearbySearch(options).construct();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (selector) {
    'use strict';

    var properties = ['address', 'dist', 'entryPoints', 'position', 'score', 'poi', 'type', 'addressRanges', 'boundingBox', 'entityType', 'viewport', 'dataSources'].join(', ');
    return function (json) {
        return selector(json, 'results', properties);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(10), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    var searchKeyName = ApiKeyNames.search;

    return function () {
        return {
            search: requestFactory.single(endpoints.search, searchKeyName),
            batch: requestFactory.batch(100, {
                single: endpoints.batchSearchQuery,
                batchSync: endpoints.batchSyncSearch,
                batch: endpoints.batchSearch
            }, searchKeyName)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e.Leaflet=e.Leaflet||{},e.Leaflet.markercluster=e.Leaflet.markercluster||{}))}(this,function(e){"use strict";var t=L.MarkerClusterGroup=L.FeatureGroup.extend({options:{maxClusterRadius:80,iconCreateFunction:null,clusterPane:L.Marker.prototype.options.pane,spiderfyOnMaxZoom:!0,showCoverageOnHover:!0,zoomToBoundsOnClick:!0,singleMarkerMode:!1,disableClusteringAtZoom:null,removeOutsideVisibleBounds:!0,animate:!0,animateAddingMarkers:!1,spiderfyDistanceMultiplier:1,spiderLegPolylineOptions:{weight:1.5,color:"#222",opacity:.5},chunkedLoading:!1,chunkInterval:200,chunkDelay:50,chunkProgress:null,polygonOptions:{}},initialize:function(e){L.Util.setOptions(this,e),this.options.iconCreateFunction||(this.options.iconCreateFunction=this._defaultIconCreateFunction),this._featureGroup=L.featureGroup(),this._featureGroup.addEventParent(this),this._nonPointGroup=L.featureGroup(),this._nonPointGroup.addEventParent(this),this._inZoomAnimation=0,this._needsClustering=[],this._needsRemoving=[],this._currentShownBounds=null,this._queue=[],this._childMarkerEventHandlers={dragstart:this._childMarkerDragStart,move:this._childMarkerMoved,dragend:this._childMarkerDragEnd};var t=L.DomUtil.TRANSITION&&this.options.animate;L.extend(this,t?this._withAnimation:this._noAnimation),this._markerCluster=t?L.MarkerCluster:L.MarkerClusterNonAnimated},addLayer:function(e){if(e instanceof L.LayerGroup)return this.addLayers([e]);if(!e.getLatLng)return this._nonPointGroup.addLayer(e),this.fire("layeradd",{layer:e}),this;if(!this._map)return this._needsClustering.push(e),this.fire("layeradd",{layer:e}),this;if(this.hasLayer(e))return this;this._unspiderfy&&this._unspiderfy(),this._addLayer(e,this._maxZoom),this.fire("layeradd",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons();var t=e,i=this._zoom;if(e.__parent)for(;t.__parent._zoom>=i;)t=t.__parent;return this._currentShownBounds.contains(t.getLatLng())&&(this.options.animateAddingMarkers?this._animationAddLayer(e,t):this._animationAddLayerNonAnimated(e,t)),this},removeLayer:function(e){return e instanceof L.LayerGroup?this.removeLayers([e]):e.getLatLng?this._map?e.__parent?(this._unspiderfy&&(this._unspiderfy(),this._unspiderfyLayer(e)),this._removeLayer(e,!0),this.fire("layerremove",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),e.off(this._childMarkerEventHandlers,this),this._featureGroup.hasLayer(e)&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow()),this):this:(!this._arraySplice(this._needsClustering,e)&&this.hasLayer(e)&&this._needsRemoving.push({layer:e,latlng:e._latlng}),this.fire("layerremove",{layer:e}),this):(this._nonPointGroup.removeLayer(e),this.fire("layerremove",{layer:e}),this)},addLayers:function(e,t){if(!L.Util.isArray(e))return this.addLayer(e);var i,n=this._featureGroup,r=this._nonPointGroup,s=this.options.chunkedLoading,o=this.options.chunkInterval,a=this.options.chunkProgress,h=e.length,l=0,u=!0;if(this._map){var _=(new Date).getTime(),d=L.bind(function(){for(var c=(new Date).getTime();h>l;l++){if(s&&0===l%200){var p=(new Date).getTime()-c;if(p>o)break}if(i=e[l],i instanceof L.LayerGroup)u&&(e=e.slice(),u=!1),this._extractNonGroupLayers(i,e),h=e.length;else if(i.getLatLng){if(!this.hasLayer(i)&&(this._addLayer(i,this._maxZoom),t||this.fire("layeradd",{layer:i}),i.__parent&&2===i.__parent.getChildCount())){var f=i.__parent.getAllChildMarkers(),m=f[0]===i?f[1]:f[0];n.removeLayer(m)}}else r.addLayer(i),t||this.fire("layeradd",{layer:i})}a&&a(l,h,(new Date).getTime()-_),l===h?(this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds)):setTimeout(d,this.options.chunkDelay)},this);d()}else for(var c=this._needsClustering;h>l;l++)i=e[l],i instanceof L.LayerGroup?(u&&(e=e.slice(),u=!1),this._extractNonGroupLayers(i,e),h=e.length):i.getLatLng?this.hasLayer(i)||c.push(i):r.addLayer(i);return this},removeLayers:function(e){var t,i,n=e.length,r=this._featureGroup,s=this._nonPointGroup,o=!0;if(!this._map){for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):(this._arraySplice(this._needsClustering,i),s.removeLayer(i),this.hasLayer(i)&&this._needsRemoving.push({layer:i,latlng:i._latlng}),this.fire("layerremove",{layer:i}));return this}if(this._unspiderfy){this._unspiderfy();var a=e.slice(),h=n;for(t=0;h>t;t++)i=a[t],i instanceof L.LayerGroup?(this._extractNonGroupLayers(i,a),h=a.length):this._unspiderfyLayer(i)}for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):i.__parent?(this._removeLayer(i,!0,!0),this.fire("layerremove",{layer:i}),r.hasLayer(i)&&(r.removeLayer(i),i.clusterShow&&i.clusterShow())):(s.removeLayer(i),this.fire("layerremove",{layer:i}));return this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds),this},clearLayers:function(){return this._map||(this._needsClustering=[],this._needsRemoving=[],delete this._gridClusters,delete this._gridUnclustered),this._noanimationUnspiderfy&&this._noanimationUnspiderfy(),this._featureGroup.clearLayers(),this._nonPointGroup.clearLayers(),this.eachLayer(function(e){e.off(this._childMarkerEventHandlers,this),delete e.__parent},this),this._map&&this._generateInitialClusters(),this},getBounds:function(){var e=new L.LatLngBounds;this._topClusterLevel&&e.extend(this._topClusterLevel._bounds);for(var t=this._needsClustering.length-1;t>=0;t--)e.extend(this._needsClustering[t].getLatLng());return e.extend(this._nonPointGroup.getBounds()),e},eachLayer:function(e,t){var i,n,r,s=this._needsClustering.slice(),o=this._needsRemoving;for(this._topClusterLevel&&this._topClusterLevel.getAllChildMarkers(s),n=s.length-1;n>=0;n--){for(i=!0,r=o.length-1;r>=0;r--)if(o[r].layer===s[n]){i=!1;break}i&&e.call(t,s[n])}this._nonPointGroup.eachLayer(e,t)},getLayers:function(){var e=[];return this.eachLayer(function(t){e.push(t)}),e},getLayer:function(e){var t=null;return e=parseInt(e,10),this.eachLayer(function(i){L.stamp(i)===e&&(t=i)}),t},hasLayer:function(e){if(!e)return!1;var t,i=this._needsClustering;for(t=i.length-1;t>=0;t--)if(i[t]===e)return!0;for(i=this._needsRemoving,t=i.length-1;t>=0;t--)if(i[t].layer===e)return!1;return!(!e.__parent||e.__parent._group!==this)||this._nonPointGroup.hasLayer(e)},zoomToShowLayer:function(e,t){"function"!=typeof t&&(t=function(){});var i=function(){!e._icon&&!e.__parent._icon||this._inZoomAnimation||(this._map.off("moveend",i,this),this.off("animationend",i,this),e._icon?t():e.__parent._icon&&(this.once("spiderfied",t,this),e.__parent.spiderfy()))};e._icon&&this._map.getBounds().contains(e.getLatLng())?t():e.__parent._zoom<Math.round(this._map._zoom)?(this._map.on("moveend",i,this),this._map.panTo(e.getLatLng())):(this._map.on("moveend",i,this),this.on("animationend",i,this),e.__parent.zoomToBounds())},onAdd:function(e){this._map=e;var t,i,n;if(!isFinite(this._map.getMaxZoom()))throw"Map has no maxZoom specified";for(this._featureGroup.addTo(e),this._nonPointGroup.addTo(e),this._gridClusters||this._generateInitialClusters(),this._maxLat=e.options.crs.projection.MAX_LATITUDE,t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],n.newlatlng=n.layer._latlng,n.layer._latlng=n.latlng;for(t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],this._removeLayer(n.layer,!0),n.layer._latlng=n.newlatlng;this._needsRemoving=[],this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds(),this._map.on("zoomend",this._zoomEnd,this),this._map.on("moveend",this._moveEnd,this),this._spiderfierOnAdd&&this._spiderfierOnAdd(),this._bindEvents(),i=this._needsClustering,this._needsClustering=[],this.addLayers(i,!0)},onRemove:function(e){e.off("zoomend",this._zoomEnd,this),e.off("moveend",this._moveEnd,this),this._unbindEvents(),this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim",""),this._spiderfierOnRemove&&this._spiderfierOnRemove(),delete this._maxLat,this._hideCoverage(),this._featureGroup.remove(),this._nonPointGroup.remove(),this._featureGroup.clearLayers(),this._map=null},getVisibleParent:function(e){for(var t=e;t&&!t._icon;)t=t.__parent;return t||null},_arraySplice:function(e,t){for(var i=e.length-1;i>=0;i--)if(e[i]===t)return e.splice(i,1),!0},_removeFromGridUnclustered:function(e,t){for(var i=this._map,n=this._gridUnclustered,r=Math.floor(this._map.getMinZoom());t>=r&&n[t].removeObject(e,i.project(e.getLatLng(),t));t--);},_childMarkerDragStart:function(e){e.target.__dragStart=e.target._latlng},_childMarkerMoved:function(e){if(!this._ignoreMove&&!e.target.__dragStart){var t=e.target._popup&&e.target._popup.isOpen();this._moveChild(e.target,e.oldLatLng,e.latlng),t&&e.target.openPopup()}},_moveChild:function(e,t,i){e._latlng=t,this.removeLayer(e),e._latlng=i,this.addLayer(e)},_childMarkerDragEnd:function(e){var t=e.target.__dragStart;delete e.target.__dragStart,t&&this._moveChild(e.target,t,e.target._latlng)},_removeLayer:function(e,t,i){var n=this._gridClusters,r=this._gridUnclustered,s=this._featureGroup,o=this._map,a=Math.floor(this._map.getMinZoom());t&&this._removeFromGridUnclustered(e,this._maxZoom);var h,l=e.__parent,u=l._markers;for(this._arraySplice(u,e);l&&(l._childCount--,l._boundsNeedUpdate=!0,!(l._zoom<a));)t&&l._childCount<=1?(h=l._markers[0]===e?l._markers[1]:l._markers[0],n[l._zoom].removeObject(l,o.project(l._cLatLng,l._zoom)),r[l._zoom].addObject(h,o.project(h.getLatLng(),l._zoom)),this._arraySplice(l.__parent._childClusters,l),l.__parent._markers.push(h),h.__parent=l.__parent,l._icon&&(s.removeLayer(l),i||s.addLayer(h))):l._iconNeedsUpdate=!0,l=l.__parent;delete e.__parent},_isOrIsParent:function(e,t){for(;t;){if(e===t)return!0;t=t.parentNode}return!1},fire:function(e,t,i){if(t&&t.layer instanceof L.MarkerCluster){if(t.originalEvent&&this._isOrIsParent(t.layer._icon,t.originalEvent.relatedTarget))return;e="cluster"+e}L.FeatureGroup.prototype.fire.call(this,e,t,i)},listens:function(e,t){return L.FeatureGroup.prototype.listens.call(this,e,t)||L.FeatureGroup.prototype.listens.call(this,"cluster"+e,t)},_defaultIconCreateFunction:function(e){var t=e.getChildCount(),i=" marker-cluster-";return i+=10>t?"small":100>t?"medium":"large",new L.DivIcon({html:"<div><span>"+t+"</span></div>",className:"marker-cluster"+i,iconSize:new L.Point(40,40)})},_bindEvents:function(){var e=this._map,t=this.options.spiderfyOnMaxZoom,i=this.options.showCoverageOnHover,n=this.options.zoomToBoundsOnClick;(t||n)&&this.on("clusterclick",this._zoomOrSpiderfy,this),i&&(this.on("clustermouseover",this._showCoverage,this),this.on("clustermouseout",this._hideCoverage,this),e.on("zoomend",this._hideCoverage,this))},_zoomOrSpiderfy:function(e){for(var t=e.layer,i=t;1===i._childClusters.length;)i=i._childClusters[0];i._zoom===this._maxZoom&&i._childCount===t._childCount&&this.options.spiderfyOnMaxZoom?t.spiderfy():this.options.zoomToBoundsOnClick&&t.zoomToBounds(),e.originalEvent&&13===e.originalEvent.keyCode&&this._map._container.focus()},_showCoverage:function(e){var t=this._map;this._inZoomAnimation||(this._shownPolygon&&t.removeLayer(this._shownPolygon),e.layer.getChildCount()>2&&e.layer!==this._spiderfied&&(this._shownPolygon=new L.Polygon(e.layer.getConvexHull(),this.options.polygonOptions),t.addLayer(this._shownPolygon)))},_hideCoverage:function(){this._shownPolygon&&(this._map.removeLayer(this._shownPolygon),this._shownPolygon=null)},_unbindEvents:function(){var e=this.options.spiderfyOnMaxZoom,t=this.options.showCoverageOnHover,i=this.options.zoomToBoundsOnClick,n=this._map;(e||i)&&this.off("clusterclick",this._zoomOrSpiderfy,this),t&&(this.off("clustermouseover",this._showCoverage,this),this.off("clustermouseout",this._hideCoverage,this),n.off("zoomend",this._hideCoverage,this))},_zoomEnd:function(){this._map&&(this._mergeSplitClusters(),this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds())},_moveEnd:function(){if(!this._inZoomAnimation){var e=this._getExpandedVisibleBounds();this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,e),this._topClusterLevel._recursivelyAddChildrenToMap(null,Math.round(this._map._zoom),e),this._currentShownBounds=e}},_generateInitialClusters:function(){var e=Math.ceil(this._map.getMaxZoom()),t=Math.floor(this._map.getMinZoom()),i=this.options.maxClusterRadius,n=i;"function"!=typeof i&&(n=function(){return i}),null!==this.options.disableClusteringAtZoom&&(e=this.options.disableClusteringAtZoom-1),this._maxZoom=e,this._gridClusters={},this._gridUnclustered={};for(var r=e;r>=t;r--)this._gridClusters[r]=new L.DistanceGrid(n(r)),this._gridUnclustered[r]=new L.DistanceGrid(n(r));this._topClusterLevel=new this._markerCluster(this,t-1)},_addLayer:function(e,t){var i,n,r=this._gridClusters,s=this._gridUnclustered,o=Math.floor(this._map.getMinZoom());for(this.options.singleMarkerMode&&this._overrideMarkerIcon(e),e.on(this._childMarkerEventHandlers,this);t>=o;t--){i=this._map.project(e.getLatLng(),t);var a=r[t].getNearObject(i);if(a)return a._addChild(e),e.__parent=a,void 0;if(a=s[t].getNearObject(i)){var h=a.__parent;h&&this._removeLayer(a,!1);var l=new this._markerCluster(this,t,a,e);r[t].addObject(l,this._map.project(l._cLatLng,t)),a.__parent=l,e.__parent=l;var u=l;for(n=t-1;n>h._zoom;n--)u=new this._markerCluster(this,n,u),r[n].addObject(u,this._map.project(a.getLatLng(),n));return h._addChild(u),this._removeFromGridUnclustered(a,t),void 0}s[t].addObject(e,i)}this._topClusterLevel._addChild(e),e.__parent=this._topClusterLevel},_refreshClustersIcons:function(){this._featureGroup.eachLayer(function(e){e instanceof L.MarkerCluster&&e._iconNeedsUpdate&&e._updateIcon()})},_enqueue:function(e){this._queue.push(e),this._queueTimeout||(this._queueTimeout=setTimeout(L.bind(this._processQueue,this),300))},_processQueue:function(){for(var e=0;e<this._queue.length;e++)this._queue[e].call(this);this._queue.length=0,clearTimeout(this._queueTimeout),this._queueTimeout=null},_mergeSplitClusters:function(){var e=Math.round(this._map._zoom);this._processQueue(),this._zoom<e&&this._currentShownBounds.intersects(this._getExpandedVisibleBounds())?(this._animationStart(),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,this._getExpandedVisibleBounds()),this._animationZoomIn(this._zoom,e)):this._zoom>e?(this._animationStart(),this._animationZoomOut(this._zoom,e)):this._moveEnd()},_getExpandedVisibleBounds:function(){return this.options.removeOutsideVisibleBounds?L.Browser.mobile?this._checkBoundsMaxLat(this._map.getBounds()):this._checkBoundsMaxLat(this._map.getBounds().pad(1)):this._mapBoundsInfinite},_checkBoundsMaxLat:function(e){var t=this._maxLat;return void 0!==t&&(e.getNorth()>=t&&(e._northEast.lat=1/0),e.getSouth()<=-t&&(e._southWest.lat=-1/0)),e},_animationAddLayerNonAnimated:function(e,t){if(t===e)this._featureGroup.addLayer(e);else if(2===t._childCount){t._addToMap();var i=t.getAllChildMarkers();this._featureGroup.removeLayer(i[0]),this._featureGroup.removeLayer(i[1])}else t._updateIcon()},_extractNonGroupLayers:function(e,t){var i,n=e.getLayers(),r=0;for(t=t||[];r<n.length;r++)i=n[r],i instanceof L.LayerGroup?this._extractNonGroupLayers(i,t):t.push(i);return t},_overrideMarkerIcon:function(e){var t=e.options.icon=this.options.iconCreateFunction({getChildCount:function(){return 1},getAllChildMarkers:function(){return[e]}});return t}});L.MarkerClusterGroup.include({_mapBoundsInfinite:new L.LatLngBounds(new L.LatLng(-1/0,-1/0),new L.LatLng(1/0,1/0))}),L.MarkerClusterGroup.include({_noAnimation:{_animationStart:function(){},_animationZoomIn:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationZoomOut:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationAddLayer:function(e,t){this._animationAddLayerNonAnimated(e,t)}},_withAnimation:{_animationStart:function(){this._map._mapPane.className+=" leaflet-cluster-anim",this._inZoomAnimation++},_animationZoomIn:function(e,t){var i,n=this._getExpandedVisibleBounds(),r=this._featureGroup,s=Math.floor(this._map.getMinZoom());this._ignoreMove=!0,this._topClusterLevel._recursively(n,e,s,function(s){var o,a=s._latlng,h=s._markers;for(n.contains(a)||(a=null),s._isSingleParent()&&e+1===t?(r.removeLayer(s),s._recursivelyAddChildrenToMap(null,t,n)):(s.clusterHide(),s._recursivelyAddChildrenToMap(a,t,n)),i=h.length-1;i>=0;i--)o=h[i],n.contains(o._latlng)||r.removeLayer(o)}),this._forceLayout(),this._topClusterLevel._recursivelyBecomeVisible(n,t),r.eachLayer(function(e){e instanceof L.MarkerCluster||!e._icon||e.clusterShow()}),this._topClusterLevel._recursively(n,e,t,function(e){e._recursivelyRestoreChildPositions(t)}),this._ignoreMove=!1,this._enqueue(function(){this._topClusterLevel._recursively(n,e,s,function(e){r.removeLayer(e),e.clusterShow()}),this._animationEnd()})},_animationZoomOut:function(e,t){this._animationZoomOutSingle(this._topClusterLevel,e-1,t),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e,this._getExpandedVisibleBounds())},_animationAddLayer:function(e,t){var i=this,n=this._featureGroup;n.addLayer(e),t!==e&&(t._childCount>2?(t._updateIcon(),this._forceLayout(),this._animationStart(),e._setPos(this._map.latLngToLayerPoint(t.getLatLng())),e.clusterHide(),this._enqueue(function(){n.removeLayer(e),e.clusterShow(),i._animationEnd()})):(this._forceLayout(),i._animationStart(),i._animationZoomOutSingle(t,this._map.getMaxZoom(),this._zoom)))}},_animationZoomOutSingle:function(e,t,i){var n=this._getExpandedVisibleBounds(),r=Math.floor(this._map.getMinZoom());e._recursivelyAnimateChildrenInAndAddSelfToMap(n,r,t+1,i);var s=this;this._forceLayout(),e._recursivelyBecomeVisible(n,i),this._enqueue(function(){if(1===e._childCount){var o=e._markers[0];this._ignoreMove=!0,o.setLatLng(o.getLatLng()),this._ignoreMove=!1,o.clusterShow&&o.clusterShow()}else e._recursively(n,i,r,function(e){e._recursivelyRemoveChildrenFromMap(n,r,t+1)});s._animationEnd()})},_animationEnd:function(){this._map&&(this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim","")),this._inZoomAnimation--,this.fire("animationend")},_forceLayout:function(){L.Util.falseFn(document.body.offsetWidth)}}),L.markerClusterGroup=function(e){return new L.MarkerClusterGroup(e)};var i=L.MarkerCluster=L.Marker.extend({options:L.Icon.prototype.options,initialize:function(e,t,i,n){L.Marker.prototype.initialize.call(this,i?i._cLatLng||i.getLatLng():new L.LatLng(0,0),{icon:this,pane:e.options.clusterPane}),this._group=e,this._zoom=t,this._markers=[],this._childClusters=[],this._childCount=0,this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._bounds=new L.LatLngBounds,i&&this._addChild(i),n&&this._addChild(n)},getAllChildMarkers:function(e,t){e=e||[];for(var i=this._childClusters.length-1;i>=0;i--)this._childClusters[i].getAllChildMarkers(e);for(var n=this._markers.length-1;n>=0;n--)t&&this._markers[n].__dragStart||e.push(this._markers[n]);return e},getChildCount:function(){return this._childCount},zoomToBounds:function(e){for(var t,i=this._childClusters.slice(),n=this._group._map,r=n.getBoundsZoom(this._bounds),s=this._zoom+1,o=n.getZoom();i.length>0&&r>s;){s++;var a=[];for(t=0;t<i.length;t++)a=a.concat(i[t]._childClusters);i=a}r>s?this._group._map.setView(this._latlng,s):o>=r?this._group._map.setView(this._latlng,o+1):this._group._map.fitBounds(this._bounds,e)},getBounds:function(){var e=new L.LatLngBounds;return e.extend(this._bounds),e},_updateIcon:function(){this._iconNeedsUpdate=!0,this._icon&&this.setIcon(this)},createIcon:function(){return this._iconNeedsUpdate&&(this._iconObj=this._group.options.iconCreateFunction(this),this._iconNeedsUpdate=!1),this._iconObj.createIcon()},createShadow:function(){return this._iconObj.createShadow()},_addChild:function(e,t){this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._setClusterCenter(e),e instanceof L.MarkerCluster?(t||(this._childClusters.push(e),e.__parent=this),this._childCount+=e._childCount):(t||this._markers.push(e),this._childCount++),this.__parent&&this.__parent._addChild(e,!0)},_setClusterCenter:function(e){this._cLatLng||(this._cLatLng=e._cLatLng||e._latlng)},_resetBounds:function(){var e=this._bounds;e._southWest&&(e._southWest.lat=1/0,e._southWest.lng=1/0),e._northEast&&(e._northEast.lat=-1/0,e._northEast.lng=-1/0)},_recalculateBounds:function(){var e,t,i,n,r=this._markers,s=this._childClusters,o=0,a=0,h=this._childCount;if(0!==h){for(this._resetBounds(),e=0;e<r.length;e++)i=r[e]._latlng,this._bounds.extend(i),o+=i.lat,a+=i.lng;for(e=0;e<s.length;e++)t=s[e],t._boundsNeedUpdate&&t._recalculateBounds(),this._bounds.extend(t._bounds),i=t._wLatLng,n=t._childCount,o+=i.lat*n,a+=i.lng*n;this._latlng=this._wLatLng=new L.LatLng(o/h,a/h),this._boundsNeedUpdate=!1}},_addToMap:function(e){e&&(this._backupLatlng=this._latlng,this.setLatLng(e)),this._group._featureGroup.addLayer(this)},_recursivelyAnimateChildrenIn:function(e,t,i){this._recursively(e,this._group._map.getMinZoom(),i-1,function(e){var i,n,r=e._markers;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())},function(e){var i,n,r=e._childClusters;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())})},_recursivelyAnimateChildrenInAndAddSelfToMap:function(e,t,i,n){this._recursively(e,n,t,function(r){r._recursivelyAnimateChildrenIn(e,r._group._map.latLngToLayerPoint(r.getLatLng()).round(),i),r._isSingleParent()&&i-1===n?(r.clusterShow(),r._recursivelyRemoveChildrenFromMap(e,t,i)):r.clusterHide(),r._addToMap()})},_recursivelyBecomeVisible:function(e,t){this._recursively(e,this._group._map.getMinZoom(),t,null,function(e){e.clusterShow()})},_recursivelyAddChildrenToMap:function(e,t,i){this._recursively(i,this._group._map.getMinZoom()-1,t,function(n){if(t!==n._zoom)for(var r=n._markers.length-1;r>=0;r--){var s=n._markers[r];i.contains(s._latlng)&&(e&&(s._backupLatlng=s.getLatLng(),s.setLatLng(e),s.clusterHide&&s.clusterHide()),n._group._featureGroup.addLayer(s))}},function(t){t._addToMap(e)})},_recursivelyRestoreChildPositions:function(e){for(var t=this._markers.length-1;t>=0;t--){var i=this._markers[t];i._backupLatlng&&(i.setLatLng(i._backupLatlng),delete i._backupLatlng)}if(e-1===this._zoom)for(var n=this._childClusters.length-1;n>=0;n--)this._childClusters[n]._restorePosition();else for(var r=this._childClusters.length-1;r>=0;r--)this._childClusters[r]._recursivelyRestoreChildPositions(e)},_restorePosition:function(){this._backupLatlng&&(this.setLatLng(this._backupLatlng),delete this._backupLatlng)},_recursivelyRemoveChildrenFromMap:function(e,t,i,n){var r,s;this._recursively(e,t-1,i-1,function(e){for(s=e._markers.length-1;s>=0;s--)r=e._markers[s],n&&n.contains(r._latlng)||(e._group._featureGroup.removeLayer(r),r.clusterShow&&r.clusterShow())},function(e){for(s=e._childClusters.length-1;s>=0;s--)r=e._childClusters[s],n&&n.contains(r._latlng)||(e._group._featureGroup.removeLayer(r),r.clusterShow&&r.clusterShow())})},_recursively:function(e,t,i,n,r){var s,o,a=this._childClusters,h=this._zoom;if(h>=t&&(n&&n(this),r&&h===i&&r(this)),t>h||i>h)for(s=a.length-1;s>=0;s--)o=a[s],o._boundsNeedUpdate&&o._recalculateBounds(),e.intersects(o._bounds)&&o._recursively(e,t,i,n,r)},_isSingleParent:function(){return this._childClusters.length>0&&this._childClusters[0]._childCount===this._childCount}});L.Marker.include({clusterHide:function(){var e=this.options.opacity;return this.setOpacity(0),this.options.opacity=e,this},clusterShow:function(){return this.setOpacity(this.options.opacity)}}),L.DistanceGrid=function(e){this._cellSize=e,this._sqCellSize=e*e,this._grid={},this._objectPoint={}},L.DistanceGrid.prototype={addObject:function(e,t){var i=this._getCoord(t.x),n=this._getCoord(t.y),r=this._grid,s=r[n]=r[n]||{},o=s[i]=s[i]||[],a=L.Util.stamp(e);this._objectPoint[a]=t,o.push(e)},updateObject:function(e,t){this.removeObject(e),this.addObject(e,t)},removeObject:function(e,t){var i,n,r=this._getCoord(t.x),s=this._getCoord(t.y),o=this._grid,a=o[s]=o[s]||{},h=a[r]=a[r]||[];for(delete this._objectPoint[L.Util.stamp(e)],i=0,n=h.length;n>i;i++)if(h[i]===e)return h.splice(i,1),1===n&&delete a[r],!0},eachObject:function(e,t){var i,n,r,s,o,a,h,l=this._grid;for(i in l){o=l[i];for(n in o)for(a=o[n],r=0,s=a.length;s>r;r++)h=e.call(t,a[r]),h&&(r--,s--)}},getNearObject:function(e){var t,i,n,r,s,o,a,h,l=this._getCoord(e.x),u=this._getCoord(e.y),_=this._objectPoint,d=this._sqCellSize,c=null;for(t=u-1;u+1>=t;t++)if(r=this._grid[t])for(i=l-1;l+1>=i;i++)if(s=r[i])for(n=0,o=s.length;o>n;n++)a=s[n],h=this._sqDist(_[L.Util.stamp(a)],e),(d>h||d>=h&&null===c)&&(d=h,c=a);return c},_getCoord:function(e){var t=Math.floor(e/this._cellSize);return isFinite(t)?t:e},_sqDist:function(e,t){var i=t.x-e.x,n=t.y-e.y;return i*i+n*n}},function(){L.QuickHull={getDistant:function(e,t){var i=t[1].lat-t[0].lat,n=t[0].lng-t[1].lng;return n*(e.lat-t[0].lat)+i*(e.lng-t[0].lng)},findMostDistantPointFromBaseLine:function(e,t){var i,n,r,s=0,o=null,a=[];for(i=t.length-1;i>=0;i--)n=t[i],r=this.getDistant(n,e),r>0&&(a.push(n),r>s&&(s=r,o=n));return{maxPoint:o,newPoints:a}},buildConvexHull:function(e,t){var i=[],n=this.findMostDistantPointFromBaseLine(e,t);return n.maxPoint?(i=i.concat(this.buildConvexHull([e[0],n.maxPoint],n.newPoints)),i=i.concat(this.buildConvexHull([n.maxPoint,e[1]],n.newPoints))):[e[0]]},getConvexHull:function(e){var t,i=!1,n=!1,r=!1,s=!1,o=null,a=null,h=null,l=null,u=null,_=null;for(t=e.length-1;t>=0;t--){var d=e[t];(i===!1||d.lat>i)&&(o=d,i=d.lat),(n===!1||d.lat<n)&&(a=d,n=d.lat),(r===!1||d.lng>r)&&(h=d,r=d.lng),(s===!1||d.lng<s)&&(l=d,s=d.lng)}n!==i?(_=a,u=o):(_=l,u=h);var c=[].concat(this.buildConvexHull([_,u],e),this.buildConvexHull([u,_],e));return c}}}(),L.MarkerCluster.include({getConvexHull:function(){var e,t,i=this.getAllChildMarkers(),n=[];for(t=i.length-1;t>=0;t--)e=i[t].getLatLng(),n.push(e);return L.QuickHull.getConvexHull(n)}}),L.MarkerCluster.include({_2PI:2*Math.PI,_circleFootSeparation:25,_circleStartAngle:0,_spiralFootSeparation:28,_spiralLengthStart:11,_spiralLengthFactor:5,_circleSpiralSwitchover:9,spiderfy:function(){if(this._group._spiderfied!==this&&!this._group._inZoomAnimation){var e,t=this.getAllChildMarkers(null,!0),i=this._group,n=i._map,r=n.latLngToLayerPoint(this._latlng);this._group._unspiderfy(),this._group._spiderfied=this,t.length>=this._circleSpiralSwitchover?e=this._generatePointsSpiral(t.length,r):(r.y+=10,e=this._generatePointsCircle(t.length,r)),this._animationSpiderfy(t,e)}},unspiderfy:function(e){this._group._inZoomAnimation||(this._animationUnspiderfy(e),this._group._spiderfied=null)},_generatePointsCircle:function(e,t){var i,n,r=this._group.options.spiderfyDistanceMultiplier*this._circleFootSeparation*(2+e),s=r/this._2PI,o=this._2PI/e,a=[];for(s=Math.max(s,35),a.length=e,i=0;e>i;i++)n=this._circleStartAngle+i*o,a[i]=new L.Point(t.x+s*Math.cos(n),t.y+s*Math.sin(n))._round();return a},_generatePointsSpiral:function(e,t){var i,n=this._group.options.spiderfyDistanceMultiplier,r=n*this._spiralLengthStart,s=n*this._spiralFootSeparation,o=n*this._spiralLengthFactor*this._2PI,a=0,h=[];for(h.length=e,i=e;i>=0;i--)e>i&&(h[i]=new L.Point(t.x+r*Math.cos(a),t.y+r*Math.sin(a))._round()),a+=s/r+5e-4*i,r+=o/a;return h},_noanimationUnspiderfy:function(){var e,t,i=this._group,n=i._map,r=i._featureGroup,s=this.getAllChildMarkers(null,!0);for(i._ignoreMove=!0,this.setOpacity(1),t=s.length-1;t>=0;t--)e=s[t],r.removeLayer(e),e._preSpiderfyLatlng&&(e.setLatLng(e._preSpiderfyLatlng),delete e._preSpiderfyLatlng),e.setZIndexOffset&&e.setZIndexOffset(0),e._spiderLeg&&(n.removeLayer(e._spiderLeg),delete e._spiderLeg);i.fire("unspiderfied",{cluster:this,markers:s}),i._ignoreMove=!1,i._spiderfied=null}}),L.MarkerClusterNonAnimated=L.MarkerCluster.extend({_animationSpiderfy:function(e,t){var i,n,r,s,o=this._group,a=o._map,h=o._featureGroup,l=this._group.options.spiderLegPolylineOptions;for(o._ignoreMove=!0,i=0;i<e.length;i++)s=a.layerPointToLatLng(t[i]),n=e[i],r=new L.Polyline([this._latlng,s],l),a.addLayer(r),n._spiderLeg=r,n._preSpiderfyLatlng=n._latlng,n.setLatLng(s),n.setZIndexOffset&&n.setZIndexOffset(1e6),h.addLayer(n);this.setOpacity(.3),o._ignoreMove=!1,o.fire("spiderfied",{cluster:this,markers:e})},_animationUnspiderfy:function(){this._noanimationUnspiderfy()}}),L.MarkerCluster.include({_animationSpiderfy:function(e,t){var i,n,r,s,o,a,h=this,l=this._group,u=l._map,_=l._featureGroup,d=this._latlng,c=u.latLngToLayerPoint(d),p=L.Path.SVG,f=L.extend({},this._group.options.spiderLegPolylineOptions),m=f.opacity;for(void 0===m&&(m=L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity),p?(f.opacity=0,f.className=(f.className||"")+" leaflet-cluster-spider-leg"):f.opacity=m,l._ignoreMove=!0,i=0;i<e.length;i++)n=e[i],a=u.layerPointToLatLng(t[i]),r=new L.Polyline([d,a],f),u.addLayer(r),n._spiderLeg=r,p&&(s=r._path,o=s.getTotalLength()+.1,s.style.strokeDasharray=o,s.style.strokeDashoffset=o),n.setZIndexOffset&&n.setZIndexOffset(1e6),n.clusterHide&&n.clusterHide(),_.addLayer(n),n._setPos&&n._setPos(c);for(l._forceLayout(),l._animationStart(),i=e.length-1;i>=0;i--)a=u.layerPointToLatLng(t[i]),n=e[i],n._preSpiderfyLatlng=n._latlng,n.setLatLng(a),n.clusterShow&&n.clusterShow(),p&&(r=n._spiderLeg,s=r._path,s.style.strokeDashoffset=0,r.setStyle({opacity:m}));this.setOpacity(.3),l._ignoreMove=!1,setTimeout(function(){l._animationEnd(),l.fire("spiderfied",{cluster:h,markers:e})},200)},_animationUnspiderfy:function(e){var t,i,n,r,s,o,a=this,h=this._group,l=h._map,u=h._featureGroup,_=e?l._latLngToNewLayerPoint(this._latlng,e.zoom,e.center):l.latLngToLayerPoint(this._latlng),d=this.getAllChildMarkers(null,!0),c=L.Path.SVG;for(h._ignoreMove=!0,h._animationStart(),this.setOpacity(1),i=d.length-1;i>=0;i--)t=d[i],t._preSpiderfyLatlng&&(t.closePopup(),t.setLatLng(t._preSpiderfyLatlng),delete t._preSpiderfyLatlng,o=!0,t._setPos&&(t._setPos(_),o=!1),t.clusterHide&&(t.clusterHide(),o=!1),o&&u.removeLayer(t),c&&(n=t._spiderLeg,r=n._path,s=r.getTotalLength()+.1,r.style.strokeDashoffset=s,n.setStyle({opacity:0})));h._ignoreMove=!1,setTimeout(function(){var e=0;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&e++;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&(t.clusterShow&&t.clusterShow(),t.setZIndexOffset&&t.setZIndexOffset(0),e>1&&u.removeLayer(t),l.removeLayer(t._spiderLeg),delete t._spiderLeg);h._animationEnd(),h.fire("unspiderfied",{cluster:a,markers:d})},200)}}),L.MarkerClusterGroup.include({_spiderfied:null,unspiderfy:function(){this._unspiderfy.apply(this,arguments)},_spiderfierOnAdd:function(){this._map.on("click",this._unspiderfyWrapper,this),this._map.options.zoomAnimation&&this._map.on("zoomstart",this._unspiderfyZoomStart,this),this._map.on("zoomend",this._noanimationUnspiderfy,this),L.Browser.touch||this._map.getRenderer(this)},_spiderfierOnRemove:function(){this._map.off("click",this._unspiderfyWrapper,this),this._map.off("zoomstart",this._unspiderfyZoomStart,this),this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._map.off("zoomend",this._noanimationUnspiderfy,this),this._noanimationUnspiderfy()
},_unspiderfyZoomStart:function(){this._map&&this._map.on("zoomanim",this._unspiderfyZoomAnim,this)},_unspiderfyZoomAnim:function(e){L.DomUtil.hasClass(this._map._mapPane,"leaflet-touching")||(this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._unspiderfy(e))},_unspiderfyWrapper:function(){this._unspiderfy()},_unspiderfy:function(e){this._spiderfied&&this._spiderfied.unspiderfy(e)},_noanimationUnspiderfy:function(){this._spiderfied&&this._spiderfied._noanimationUnspiderfy()},_unspiderfyLayer:function(e){e._spiderLeg&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow(),e.setZIndexOffset&&e.setZIndexOffset(0),this._map.removeLayer(e._spiderLeg),delete e._spiderLeg)}}),L.MarkerClusterGroup.include({refreshClusters:function(e){return e?e instanceof L.MarkerClusterGroup?e=e._topClusterLevel.getAllChildMarkers():e instanceof L.LayerGroup?e=e._layers:e instanceof L.MarkerCluster?e=e.getAllChildMarkers():e instanceof L.Marker&&(e=[e]):e=this._topClusterLevel.getAllChildMarkers(),this._flagParentsIconsNeedUpdate(e),this._refreshClustersIcons(),this.options.singleMarkerMode&&this._refreshSingleMarkerModeMarkers(e),this},_flagParentsIconsNeedUpdate:function(e){var t,i;for(t in e)for(i=e[t].__parent;i;)i._iconNeedsUpdate=!0,i=i.__parent},_refreshSingleMarkerModeMarkers:function(e){var t,i;for(t in e)i=e[t],this.hasLayer(i)&&i.setIcon(this._overrideMarkerIcon(i))}}),L.Marker.include({refreshIconOptions:function(e,t){var i=this.options.icon;return L.setOptions(i,e),this.setIcon(i),t&&this.__parent&&this.__parent._group.refreshClusters(this),this}}),e.MarkerClusterGroup=t,e.MarkerCluster=i});
//# sourceMappingURL=leaflet.markercluster.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(45)], __WEBPACK_AMD_DEFINE_RESULT__ = function (geocodeModel) {
    'use strict';

    return function (data) {
        if (!(data.batchItems instanceof Array)) {
            return null;
        }
        return data.batchItems.map(function (batchItem) {
            if (batchItem.response.error) {
                return { error: batchItem.response.error };
            } else {
                return geocodeModel(batchItem.response);
            }
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Allows to make search request using the TomTom's
 * [Search API - Fuzzy Search](https://developer.tomtom.com/search-api/search-api-documentation-search/fuzzy-search).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "FuzzySearch/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "FuzzySearch/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The list of all supported category codes are available
 * [here](https://developer.tomtom.com/search-api/search-api-documentation/supported-category-codes).
 *
 * @example
 * ```js
 * function callbackFn(result) {
 *   console.log(result);
 * };
 *
 * // Using a callback function
 * tomtom.fuzzySearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("Amsterdam")
 *   .callback(callbackFn)
 *   .go();
 *
 * // Or using a Promise
 * tomtom.fuzzySearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("Amsterdam")
 *   .go()
 *   .then(callbackFn);
 * ```
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class FuzzySearch
 * @extends Search
 * @uses ExtendedPostalCodesForMixin
 * @uses CenterMixin
 * @uses RadiusMixin
 * @uses BoundingBoxMixin
 * @uses CountrySetMixin
 * @uses OffsetMixin
 * @uses BestResultMixin
 * @uses ViewMixin
 * @uses QueryMixin
 * @uses TypeaheadMixin
 * @constructor
 * @module Services
 *
 * @param {Object}   [options] Options to be passed to the fuzzy search call,
 *     or Array of such options objects to perform batch request.
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String} [options.view="Unified"] Geopolitical view
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String}   [options.query] Text that will be searched
 *  This parameter is required to be defined either in the options passed to the constructor or using the
 *  **query()** method.
 * @param {Boolean}  [options.typeahead=false] If is enabled the query will be interpreted as a
 *  partial input and the **predictive** mode will be used
 * @param {Boolean}  [options.bestResult=false] Return only one result, the best match result.
 * @param {Number[]|String|L.LatLng|Object} [options.center] Location where results should be biased
 * @param {Number}   [options.radius=0] The search radius in meters using the coordinates given to the **center**
 *  option as origin.
 *  If the radius is zero the results will not be constrained.
 * @param {Number}   [options.offset=0] Starting offset of the returned results within the full result set
 * @param {String}   [options.countrySet] List of country codes for limit the search request to those specific
 *  political limits
 * @param {Object|Number[]|Object[]|String} [options.boundingBox] The bounding box is an area within the search
 *  results needs to limit to. If it is omitted then the whole world will be taken into consideration.
 * @param {String}   [options.extendedPostalCodesFor] Represent the indexes for which extended postal codes should
 *  be included in the results
 * @param {String}   [options.idxSet] Specify which indexes to utilize for the search
 * @param {Number}   [options.maxFuzzyLevel=2] Maximum fuzzyness level to be used
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (search, validators) {
    'use strict';

    var SearchPrototype = search.prototype.constructor;

    function FuzzySearch(options) {
        SearchPrototype.call(this, options);

        this.fields.type = {
            defaultValue: this.TYPE.search,
            visible: false
        };

        /**
         * Sets or gets the current value of the option "minFuzzyLevel".
         *
         * The maximum allowed value is 4.
         *
         * @method minFuzzyLevel
         * @chainable
         * @param {Number} [newValue] The possible values are the integers 1, 2, 3 and 4
         * @throws {TypeError} If the given argument cannot be converted to a valid value
         * @return {Number} The same service instance or the current option value if no argument was given
         */
        this.fields.minFuzzyLevel = {
            validator: validators.fuzzinessLevel,
            defaultValue: 1
        };

        /**
         * Sets or gets the current value of the option "maxFuzzyLevel".
         *
         * The maximum allowed value is 4.
         *
         * @method maxFuzzyLevel
         * @chainable
         * @param {Number} [newValue] The possible values are the integers 1, 2, 3 and 4
         * @throws {TypeError} If the given argument cannot be converted to a valid value
         * @return {Number} The same service instance or the current option value if no argument was given
         */
        this.fields.maxFuzzyLevel = {
            validator: validators.fuzzinessLevel,
            defaultValue: 2
        };

        this.fields.idxSet = {
            validator: validators.string
        };
    }

    FuzzySearch.prototype = new SearchPrototype();
    FuzzySearch.prototype.constructor = FuzzySearch;

    return function (options) {
        return new FuzzySearch(options).construct();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    return function (data) {
        var coordinates = [];
        if (data.error) {
            throw new Error(data.error);
        }
        if (data.reachableRange && data.reachableRange.boundary && Array.isArray(data.reachableRange.boundary)) {
            coordinates = data.reachableRange.boundary.map(function (coordinates) {
                return [coordinates.longitude, coordinates.latitude];
            });
        }
        return {
            type: 'Feature',
            geometry: {
                type: 'Polygon',
                coordinates: [coordinates]
            }
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This widget displays a search input control over the map capable of executing
 * search requests and displaying the results in a dropdown under the input.
 *
 * By default the widget collapses when is empty and loses focus.
 *
 * This widget uses the fuzzy search implementation to execute search requests.
 *
 * @example
 * ```javascript
 *  // SearchBox with location button and Polish language
 * var widget = new L.SearchBox({
 *      location: true,
 *      language: 'pl-PL',
 *      view: 'IN'
 *  });
 * widget.addTo(map);
 *
 * // some time later...
 * widget.language('de-DE');
 * widget.view('IN');
 * ```
 *
 * @class SearchBox
 * @namespace L
 * @extends L.Control
 * @uses L.Evented
 * @module Widgets
 * @constructor
 * @param {Object} [options] Options to be passed to the searchBox control
 * @param {String} [options.placeholder="Search for place..."] The placeholder text to be displayed inside
 *     searchBox
 * @param {String} [options.id] Id of a searchBox's DOM element
 * @param {Boolean} [options.collapsed=false] Flag if checkbox is collapsed on initialization
 * @param {Boolean} [options.collapsible=true] Flag if searchBox can be collapsed
 * @param {Boolean} [options.location=false] Display location button to search for current location
 * @param {String} [options.icon="icon-search"] Determines icon of the searchBox
 * @param {Boolean} [options.disablePOIs=false] Determines whether search results should not contain POIs
 * @param {Boolean} [options.viewportBoundingBox=false] Enables or disables searching on a currently visible
 *     map area. If unset, search service will use current map center.
 * @param {Boolean} [options.withPrompt=true] Should widget show user prompts while typing, the call will be
 *     throttled according to the following settings: `minNumberCharsPrompt`, `throttleTimePrompt`, `idleTimeKeyPress`
 * @param {String|Boolean} [options.searchOnDragEnd="always"] This option defines what the widget should do after
 * the user finish dragging the map (and therefore changing the maps's viewport).
 * There are five possible values:
 *  - `"always"`: The widget will repeat the last search everytime the map's viewport changes.
 *  - `"open"`: The last search will be repeated only if the list of results was being displayed
 *            when the map's dragging occurs.
 *  - `"never"`: No action will be taken when the user change the map's viewport.
 *  - `true`: Alias of `"always"`.
 *  - `false`: Alias of `"never"`.
 * @param {Number} [options.minNumberCharsPrompt=3] Sets the minimal required number of characters that are
 *     required to perform search
 * @param {Number} [options.throttleTimePrompt=1000] Sets the minimal time between the following search
 *     service calls when user types text into the input
 * @param {Number} [options.idleTimeKeyPress=200] Sets the time between following key press events to assume
 *     the user finished typing the query
 * @param {String} [options.language] Language code, for example 'en-GB', 'en-US', 'de-DE'. Full list is available
 *     <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {String} [options.view] Sets the geopolitical view used in the search service. Accepted values:
 * 'AR', 'IL', 'MA', 'IN', 'PK' and 'Unified'. Full list is available
 * <a href="https://developer.tomtom.com/search-api/search-api-documentation">here</a>.
 * @param {Object} [options.serviceOptions] Options to be passed to service. See search service options
 * @param {Boolean} [options.imperialDistance=null] Set this option if you want to use a specific unit measurement
 *     system for the new instance of the widget instead of use the default unit
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(95), __webpack_require__(25), __webpack_require__(98), __webpack_require__(0), __webpack_require__(15), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, searchService, reverseGeocodeService, location, utils, unitFormatConverter, unitTypes) {
    'use strict';

    var ENTER = 13,
        ARROWUP = 38,
        ARROWDOWN = 40,
        EVENTS = {
        ResultCreated: 'resultCreated',
        ResultClicked: 'resultClicked',
        ClearButtonClicked: 'clearButtonClicked',
        ResultsCleared: 'resultsCleared',
        ResultsFound: 'resultsFound',
        ResultsDrawn: 'resultsDrawn',
        SearchInputChanged: 'searchInputChanged',
        LocationError: 'locationError'
    };

    /**
     * @param {HTMLElement} element
     * @param {Object} [data]
     * @param {String} [text]
     * @return {Object}
     */
    function searchBoxEvent(element, data, text) {
        return {
            element: element,
            data: data,
            text: text
        };
    }

    function createNoResults(control) {
        var result = L.DomUtil.create('div', 'leaflet-control-search-result', control.resultsContainer);
        result.innerHTML = 'No results found.';
        control.resultsContainer.style.height = 'auto';

        control.fire(control.Events.ResultCreated);
    }

    function locationError(control) {
        return function (error) {
            control.input.value = '';
            control.input.focus();
            control.clearResults();
            createNoResults(control);
            control.fire(control.Events.LocationError, searchBoxEvent(control.input, error, error.message));
            console.error(error);
        };
    }

    function resolveResultText(resultData) {
        if (!resultData || !resultData.address) {
            return resultData;
        }

        return resultData.poi ? resultData.poi.name + ', ' + resultData.address.freeformAddress : resultData.address.freeformAddress;
    }

    function locationSuccess(control) {
        return function (location) {
            var options = utils.clone(control.options.serviceOptions);
            reverseGeocodeService(options).position(location.latlng).go(function (result) {
                result.position = location.latlng.lng ? {
                    lat: location.latlng.lat,
                    lon: location.latlng.lng
                } : location.latlng;

                control.clearResults();
                control.input.value = resolveResultText(result);
                control.input.focus();
                control.fire(control.Events.ResultClicked, searchBoxEvent(control.locationIcon, result, control.input.value));
            });
        };
    }

    function createCurrentLocationButton(control) {
        control.location = location({
            size: null
        });
        control.locationIcon = control.location.onAdd(control._map);
        control.inputContainer.appendChild(control.locationIcon);
        control.location.on(control.location.Events.LocationFound, locationSuccess(control));
        control.location.on(control.location.Events.LocationError, locationError(control));
    }

    function isResultsListOpen(control) {
        return control.resultsContainer.hasChildNodes();
    }

    function onMapEndDrag() {
        var control = this,
            options = control.options,
            reRun = false;
        if (control.lastSearchText.trim().length === 0) {
            return;
        }
        if (options.searchOnDragEnd === 'open' && isResultsListOpen(control)) {
            reRun = true;
        } else if (['always', true].indexOf(options.searchOnDragEnd) !== -1) {
            reRun = true;
        }
        if (reRun) {
            control.search(control.input.value);
        }
    }

    function highlightNextResult(keyCode, selectedElement, resultsContainerElement) {
        var highlightClass = 'highlight',
            rules = {
            38: {
                edgeCase: 'firstChild',
                nextSibling: 'previousElementSibling',
                nextAfterEdgeCase: 'lastChild'
            },
            40: {
                edgeCase: 'lastChild',
                nextSibling: 'nextElementSibling',
                nextAfterEdgeCase: 'firstChild'
            }
        },
            newlySelectedElement;
        if (selectedElement) {
            selectedElement.className = selectedElement.className.replace(highlightClass, '');
        }

        if (!selectedElement || selectedElement === resultsContainerElement[rules[keyCode].edgeCase]) {
            newlySelectedElement = resultsContainerElement[rules[keyCode].nextAfterEdgeCase];
        } else {
            newlySelectedElement = selectedElement[rules[keyCode].nextSibling];
        }

        newlySelectedElement.className += ' ' + highlightClass;
    }

    function onResultSelect(resultData) {
        if (!resultData) {
            return;
        }
        this.stopSearch = true;
        this.input.value = resolveResultText(resultData);
        this.clearResultsContainer();
        this.input.blur();
        this.fire(this.Events.ResultClicked, searchBoxEvent(this.input, resultData, this.input.value));
    }

    function createOnKeyDownHandler(searchBoxControl) {
        var searchOnEnterLastTime = 0,
            searchOnEnterLastValue = '',
            timerId;

        return function (event) {
            var code = event.keyCode || event.which,
                selectedResult = this.resultsContainer.getElementsByClassName('highlight')[0],
                selectedResultIndex,
                currentTime,
                currentInputValue,
                throttleTimePrompt,
                deltaTimeToNextSearch;

            if (code === ENTER && searchBoxControl.input.value) {
                if (selectedResult) {
                    selectedResultIndex = [].indexOf.call(this.resultsContainer.children, selectedResult);
                    onResultSelect.call(this, this._searchResponses[selectedResultIndex]);
                } else {
                    if (timerId) {
                        clearTimeout(timerId);
                    }

                    currentTime = new Date().getTime();
                    currentInputValue = searchBoxControl.input.value;
                    throttleTimePrompt = searchBoxControl.options.throttleTimePrompt || 1000;
                    deltaTimeToNextSearch = throttleTimePrompt - (currentTime - searchOnEnterLastTime);

                    if (deltaTimeToNextSearch <= 0 || searchOnEnterLastValue !== currentInputValue) {
                        searchOnEnterLastTime = currentTime;
                        searchOnEnterLastValue = currentInputValue;
                        searchBoxControl.search(currentInputValue);
                    } else {
                        timerId = setTimeout(function () {
                            searchOnEnterLastTime = new Date().getTime();
                            searchOnEnterLastValue = searchBoxControl.input.value;
                            searchBoxControl.search(searchBoxControl.input.value);
                        }, deltaTimeToNextSearch);
                    }
                }
            }

            if (this.resultsContainer.hasChildNodes()) {
                if (code === ARROWUP || code === ARROWDOWN) {
                    this.stopSearch = true;
                    highlightNextResult.call(this, code, selectedResult, this.resultsContainer);
                }
            }
        };
    }

    function getOptionsForSearch(control) {
        var options = utils.clone(control.options.serviceOptions);
        options.query = control.input.value;
        if (control.options.viewportBoundingBox) {
            options.boundingBox = control._map.getBounds();
        } else {
            options.center = control._map.getCenter();
        }
        if (control.options.disablePOIs) {
            options.idxSet = 'PAD,Str,Xstr,Geo,Addr';
        }
        if (typeof options.typeahead !== 'boolean') {
            options.typeahead = true;
        }
        if (control.options.view) {
            options.view = control.options.view;
        }
        if (!utils.isString(options.language)) {
            options.language = control.options.language;
        }
        return options;
    }
    function handleResults(results) {
        this.expand();
        this._searchResponses = results;
        this._redrawResults(true);
        this.fire(this.Events.ResultsFound, searchBoxEvent(this.resultsContainer, results));
    }

    function createOnInputChangeHandler(control) {
        var timerId;

        function promptSearch() {
            if (control.input.value.length === 0 || control.lastSearchText === control.input.value || control.stopSearch) {
                return;
            }

            control.lastSearchText = control.input.value;

            searchService(getOptionsForSearch(control)).go(function (result) {
                if (!control.stopSearch) {
                    handleResults.call(control, result);
                }
            });
        }

        return function () {
            this.fire(this.Events.SearchInputChanged, searchBoxEvent(this.input, this.input.value, this.input.value));
            control.stopSearch = false;

            if (timerId) {
                clearTimeout(timerId);
            }

            if (this.options.withPrompt && this.input.value.length >= this.options.minNumberCharsPrompt) {
                if (control.options.idleTimeKeyPress === 0) {
                    promptSearch();
                } else {
                    timerId = setTimeout(promptSearch, control.options.idleTimeKeyPress);
                }
            }
        };
    }

    function shouldListenForDragEnd(control) {
        return ['always', 'open', true].indexOf(control.options.searchOnDragEnd) !== -1;
    }

    function clearSearchBox() {
        this.input.focus();
        this.input.value = '';
        this.lastSearchText = '';
        this.clearResults();
        this.fire(this.Events.ClearButtonClicked, searchBoxEvent(this.clearButton));
    }

    function setHandlers(control, container) {
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);
        L.DomEvent.on(container, 'drag', L.DomEvent.stopPropagation);
        L.DomEvent.on(container, 'keydown', createOnKeyDownHandler(control), control);
        L.DomEvent.on(container, 'input', createOnInputChangeHandler(control), control);

        if (shouldListenForDragEnd(control)) {
            L.DomEvent.on(control._map, 'dragend', onMapEndDrag, control);
        }

        L.DomEvent.on(control.clearButton, 'click', clearSearchBox, control);
        if (control.options.collapsible) {
            L.DomEvent.on(control.input, 'focus', control.expand, control);
            L.DomEvent.on(control.input, 'blur', control.collapse, control);
        }
    }

    function createDOMElements(control) {
        var container,
            containerClassname = 'leaflet-control-search';
        if (control.options.collapsible && control.options.collapsed) {
            containerClassname += ' collapsed';
        }
        container = L.DomUtil.create('div', containerClassname);
        control.inputContainer = L.DomUtil.create('div', 'leaflet-control-search-input-container', container);
        control.input = L.DomUtil.create('input', control.options.icon + ' leaflet-control-search-input', control.inputContainer);
        control.input.required = true;
        control.clearButton = L.DomUtil.create('div', 'leaflet-control-search-input-close-icon icon-close-gray', control.inputContainer);
        control.resultsContainer = L.DomUtil.create('div', 'leaflet-control-search-results-container', container);
        if (control.options.location) {
            createCurrentLocationButton(control);
        }
        if (control.options.id) {
            control.input.id = control.options.id;
        }
        setHandlers(control, container);
        control.input.setAttribute('placeholder', control.options.placeholder);
        return container;
    }

    function getWordsToHighlight(words) {
        var i;
        words = words.split(/[- ,]+/) || [];

        for (i = 0; i < words.length; i += 1) {
            words[i] = utils.encodeStringForRegex(words[i]);
        }

        return words;
    }

    function highlightWords(control, text) {
        var words = getWordsToHighlight(control.input.value);
        var regex = new RegExp('(' + words.join('|') + ')', 'ig');

        return text.replace(regex, '<span class="leaflet-control-search-result-highlight">$1</span>');
    }

    function createResultElement(control, result) {
        var useImperial = control._shouldUseImperialDistance();
        var nameWrapper, addressWrapper, address, distanceElement;
        var resultElement = L.DomUtil.create('div', 'geoResponse-result');

        if (typeof result.poi !== 'undefined' && typeof result.poi.name !== 'undefined') {
            nameWrapper = L.DomUtil.create('div', 'geoResponse-result-name');
            nameWrapper.innerHTML = highlightWords(control, result.poi.name);
            resultElement.appendChild(nameWrapper);
        }

        if (typeof result.address !== 'undefined') {
            addressWrapper = L.DomUtil.create('div', 'geoResponse-result-address');
            address = [];

            if (typeof result.address.freeformAddress !== 'undefined') {
                address.push(result.address.freeformAddress);
            }

            if (typeof result.address.countryCodeISO3 !== 'undefined') {
                address.push(result.address.countryCodeISO3);
            }

            addressWrapper.innerHTML = highlightWords(control, address.join(', '));
            resultElement.appendChild(addressWrapper);
        }

        if (typeof result.dist !== 'undefined') {
            distanceElement = L.DomUtil.create('div', 'geoResponse-result-distance');
            distanceElement.innerHTML = unitFormatConverter.formatDistance(result.dist, useImperial);
            resultElement.appendChild(distanceElement);
        }

        return resultElement;
    }

    function createResult(control, resultData) {
        var result = L.DomUtil.create('div', 'leaflet-control-search-result', control.resultsContainer);
        result.appendChild(createResultElement(control, resultData));
        control.resultsContainer.style.height = 'auto';
        control.fire(control.Events.ResultCreated, searchBoxEvent(result, resultData));

        L.DomEvent.on(result, 'click', function () {
            onResultSelect.call(control, resultData);
        }, control);

        L.DomEvent.on(result, 'mouseover', function () {
            this.stopSearch = true;
        }, control);
    }

    function handleUnitChange(event) {
        this.options.imperialDistance = event.unit === 'imperial';
        if (isResultsListOpen(this)) {
            this._redrawResults(true);
        }
    }

    function handleLocaleChange(event) {
        if (this.definedLanguage) {
            return;
        }
        this.language(event.getValueFor('search'));
        if (this.lastSearchText && isResultsListOpen(this)) {
            this.search(this.lastSearchText);
        }
    }

    function updateSearch() {
        if (this.lastSearchText && isResultsListOpen(this)) {
            this.search(this.lastSearchText);
        }
    }

    function handleGeopolViewChange(event) {
        if (this.definedGeopolView) {
            return;
        }
        this.options.view = event.code;
        updateSearch.call(this);
    }

    L.SearchBox = L.Control.extend({
        includes: L.Evented.prototype,

        options: {
            placeholder: 'Search for a place...',
            id: false,
            collapsible: true,
            collapsed: false,
            location: false,
            icon: 'icon-search',
            disablePOIs: false,
            viewportBoundingBox: false,
            minNumberCharsPrompt: 3,
            throttleTimePrompt: 1000,
            idleTimeKeyPress: 200,
            serviceOptions: {},
            position: 'topleft',
            withPrompt: true,
            imperialDistance: null,
            searchOnDragEnd: 'always'
        },

        statics: {
            Events: EVENTS
        },

        /**
         * @ignore
         * @type {HtmlElement}
         */
        resultsContainer: null,

        /**
         * @ignore
         * @type {HtmlElement}
         */
        input: null,

        /**
         * @ignore
         * @type {HtmlElement}
         */
        location: undefined,

        /**
         * @ignore
         * @type {HtmlElement}
         */
        locationIcon: null,

        /**
         * @ignore
         * Store the last search results received.
         * @type {Object[]}
         */
        _searchResponses: [],

        /**
         * @ignore
         * @type {String}
         */
        lastSearchText: '',

        initialize: function initialize(options) {
            L.Util.setOptions(this, options);
            if (options) {
                this.definedGeopolView = options.view;
                this.definedLanguage = options.language;
            }
        },

        onAdd: function onAdd(map) {
            this.unitService = map.getUnitService();
            this.unitService.on(L.UnitService.Events.UNIT_CHANGED, handleUnitChange, this);
            this.localeService = map.getLocaleService();
            this.localeService.on(L.LocaleService.Events.LOCALE_CHANGED, handleLocaleChange, this);
            this.geopolService = map.getGeopolViewService();
            this.geopolService.on(L.GeopolViewService.Events.GEOPOL_VIEW_CHANGED, handleGeopolViewChange, this);
            return createDOMElements(this);
        },

        onRemove: function onRemove() {
            this.unitService.off(L.UnitService.Events.UNIT_CHANGED, handleUnitChange, this);
            this.localeService.off(L.LocaleService.Events.LOCALE_CHANGED, handleLocaleChange, this);
            this.geopolService.off(L.GeopolViewService.Events.GEOPOL_VIEW_CHANGED, handleGeopolViewChange, this);
            if (shouldListenForDragEnd(this)) {
                L.DomEvent.off(this._map, 'dragend', onMapEndDrag, this);
            }
        },

        /**
         * @ignore
         * First check the configuration for this instance and then the global configuration.
         * The instance configuration has priority.
         *
         * @return {Boolean}
         */
        _shouldUseImperialDistance: function _shouldUseImperialDistance() {
            if (typeof this.options.imperialDistance === 'boolean') {
                return this.options.imperialDistance;
            }
            return this.unitService.getCurrentUnit().getLabel() === unitTypes.imperial;
        },

        /**
         * @ignore
         * Show the list of results under the widget.
         * @param {Boolean} [informNoResults=false] If is TRUE shows a notification saying
         *     there's no results no show
         */
        _redrawResults: function _redrawResults(informNoResults) {
            var i,
                results = this._searchResponses;

            this.clearResultsContainer();

            if (!results || results.length === 0) {
                if (informNoResults === true) {
                    createNoResults(this);
                }
                return;
            }

            for (i = 0; i < results.length; i += 1) {
                createResult(this, results[i]);
            }

            this.resultsContainer.style.height = 'auto';
            this.fire(this.Events.ResultsDrawn, searchBoxEvent(this.resultsContainer, results));
        },

        /**
         * Method used to clear the DOM elements from the search results container.
         *
         * This method just remove the DOM elements but leave the cache with the previous results inside the widget.
         *
         * @method clearResultsContainer
         */
        clearResultsContainer: function clearResultsContainer() {
            if (this.resultsContainer.hasChildNodes()) {
                this.resultsContainer.style.height = '0px';
                this.resultsContainer.innerHTML = '';
                this.fire(this.Events.ResultsCleared, searchBoxEvent(this.resultsContainer));
            }
        },

        /**
         * Method used to clear all the previous search results from the widget.
         *
         * @method clearResults
         */
        clearResults: function clearResults() {
            this.clearResultsContainer();
            this._searchResponses = [];
        },

        /**
         * Method used to feed the searchBox instance with one search result element.
         *
         * @method setResultData
         * @param {Object} resultData Result data given from search service. Must contain address and/or POI
         *     information.
         *
         *  @example
         * ```javascript
         * var widget = (new L.SearchBox()).addTo(map);
         * var resultData = {
         *   address: {freeformAddress: "Amsterdam"},
         *   poi: { name: "TomTom, Oosterdoksstraat, Amsterdam, The Netherlands" }
         * }
         * widget.setResultData(resultData);
         * ```
         */
        setResultData: function setResultData(resultData) {
            if (resultData) {
                this.input.value = resolveResultText(resultData);
                this.clearResults();
                this.input.blur();
            }
        },

        /**
         * Start a search using a query string.
         * This method update the content of the input control and also handle the search request.
         *
         * @method search
         * @param {Object|String} text String, Object or reverse geocoding object (with the `query` key) as a search
         *     query
         *
         *  @example
         * ```javascript
         * var widget = new L.SearchBox();
         * widget.addTo(map);
         * widget.search("Amsterdam");
         *
         * var reversedGeocodeResponse = {query: "Amsterdam"}
         * widget.search(reversedGeocodeResponse);
         * ```
        */
        search: function search(text) {
            var searchBox = this;
            if ((typeof text === 'undefined' ? 'undefined' : _typeof(text)) === 'object' && text.hasOwnProperty('query')) {
                text = text.query;
            }
            if (!utils.isString(text) || text.length === 0) {
                return;
            }
            this.input.focus();
            this.input.value = text;
            this.lastSearchText = text;

            searchService(getOptionsForSearch(searchBox)).go(function (results) {
                handleResults.call(searchBox, results);
            });
        },
        /**
         * Method used to collapse search. Collapsing is possible only if search is empty.
         *
         * @method collapse
         */
        collapse: function collapse() {
            if (!this.input.value) {
                this._container.className += ' collapsed';
                this.clearResultsContainer();
            } else {
                this.expand();
            }
        },
        /**
         * Method used to expand collapsed search.
         *
         * @method expand
         */
        expand: function expand() {
            this._container.className = this._container.className.replace(/\b collapsed\b/, '');
        },

        /**
         * Method used to get embedded location widget (if set and added).
         *
         * @method getLocation
         * @return {L.Location}
         */
        getLocation: function getLocation() {
            return this.location;
        },

        /**
         * Sets the icon by styling search box input.
         *
         * @method setIcon
         * @param {String|undefined} className Name of the CSS class that sets
         *     `background-image` property for search box input
         */
        setIcon: function setIcon(className) {
            if (utils.isString(className)) {
                this.input.className = this.input.className.replace(/(icon)((-)(\w+))*/, className);
            }
        },

        /**
         * Adds the location icon.
         *
         * @method addLocationIcon
         */
        addLocationIcon: function addLocationIcon() {
            if (this.location === undefined) {
                this.options.location = true;
                createCurrentLocationButton(this);
            }
        },

        /**
         * Removes the location icon.
         *
         * @method removeLocationIcon
         */
        removeLocationIcon: function removeLocationIcon() {
            if (this.location !== undefined) {
                this.options.location = false;
                this.locationIcon.parentNode.removeChild(this.locationIcon);
                this.location.clearAllEventListeners();
                this.location = undefined;
            }
        },

        /**
         * A setter for the _'language'_ option.
         *
         * The whitelist can be found
         * [here](https://developer.tomtom.com/search-api/search-api-documentation/supported-languages).
         *
         * @method language
         * @param {String} [languageCode] Language code, for example 'en-GB', 'en-US', 'de-DE'. Full list is available
         * <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>
         * .
         */
        language: function language(languageCode) {
            if (null === languageCode || '' === languageCode) {
                delete this.options.language;
                delete this.definedLanguage;
            } else {
                this.options.language = languageCode;
                this.definedLanguage = languageCode;
            }
        },

        /**
         * A setter for the 'view' option.
         *
         * Use this setter to set a geopolitical view.
         * When this parameter is used the search service will return values
         * taking in consideration the Geopolitical view used.
         *
         * Accepted values: 'AR', 'IL', 'MA', 'IN', 'PK' and 'Unified'
         *
         * @method view
         * @param {String} [geopolViewCode] Geopotical view code. Full list is available at
         * <a href="https://developer.tomtom.com/search-api/search-api-documentation">here</a>
         * .
         */
        view: function view(geopolViewCode) {
            if (geopolViewCode === null || geopolViewCode === '') {
                delete this.options.view;
                delete this.definedGeopolView;
            } else {
                this.options.view = geopolViewCode;
                this.definedGeopolView = geopolViewCode;
            }
            updateSearch.call(this);
        },

        /**
         * Whenever the input within the search box is changed by the user this event is triggered.
         *
         * @event SearchInputChanged
         * @param {Object} data The current text entered by the user
         * @param {String} text Same as data
         * @param {String} [type="searchInputChanged"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = new L.SearchBox();
         * widget.addTo(map);
         * widget.on(L.SearchBox.Events.SearchInputChanged, function(eventObject) {
         *   console.log(eventObject.text);
         * });
         * ```
         */
        /**
         * This event appears when response from search service is being processed. For each result which is being
         * rendered on the prompt list such event is fired.
         *
         * @event ResultCreated
         * @param {Object} data The result from search service response that is being processed
         * @param {String} [type="resultCreated"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = new L.SearchBox();
         * widget.addTo(map);
         * widget.on(L.SearchBox.Events.ResultCreated, function(eventObject) {
         *   console.log(eventObject.data);
         * });
         * ```
         */
        /**
         * Event that is fired when user selects the result from list or when current location is identified.
         *
         * @event ResultClicked
         * @param {Object} data Selected result object from search service response
         * @param {String} text The human readable string representation of selected result
         * @param {String} [type="resultClicked"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = new L.SearchBox();
         * widget.addTo(map);
         * widget.on(L.SearchBox.Events.ResultClicked, function(eventObject) {
         *   console.log(eventObject.text);
         *   console.log(eventObject.data);
         * });
         * ```
         */
        /**
         * Event that is fired when the response from search service is already processed and rendered in a form
         * of list of possible results.
         *
         * @event ResultsDrawn
         * @param {Array} data Array of search service results. Each result has, among other parameters, its
         *     `type`, `address` and `position`.
         * @param {String} [type="resultsDrawn"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = new L.SearchBox();
         * widget.addTo(map);
         * widget.on(L.SearchBox.Events.ResultsDrawn, function(eventObject) {
         *   console.log(eventObject.data);
         * });
         * ```
         */
        /**
         * Event that is fired when the response from search service appears for both normal and prompt query.
         *
         * @event ResultsFound
         * @param {Array} data Array of search service results. Each result has, among other parameters, its
         *     `type`, `address` and `position`.
         * @param {String} [type="resultsFound"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = new L.SearchBox();
         * widget.addTo(map);
         * widget.on(L.SearchBox.Events.ResultsFound, function(eventObject) {
         *   console.log(eventObject.data);
         * });
         * ```
         */
        /**
         * Event that is fired when user clicks the clear search box input button.
         *
         * @event ClearButtonClicked
         * @param {String} [type="clearButtonClicked"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = new L.SearchBox();
         * widget.addTo(map);
         * widget.on(L.SearchBox.Events.ClearButtonClicked, function() {
         *   console.log("User clicked the clear button");
         * });
         * ```
         */
        /**
         * Event that is fired when prompt results list is being cleared.
         *
         * @event ResultsCleared
         * @param {String} [type="resultsCleared"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = new L.SearchBox();
         * widget.addTo(map);
         * widget.on(L.SearchBox.Events.LocationsCleared, function() {
         *   console.log("Results were cleared");
         * });
         * ```
         */
        /**
         * Event that is fired when obtaining user's current location fails.
         *
         * @event LocationError
         * @param {Object} eventObject All failure information
         * @param {String} [type="locationError"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = new L.SearchBox();
         * widget.addTo(map);
         * widget.on(L.SearchBox.Events.LocationError, function(eventObject) {
         *   console.log(eventObject);
         * });
         * ```
         */
        Events: EVENTS
    });

    return function (options) {
        var searchBox = new L.SearchBox(options);
        utils.addDeprecatedProperty(searchBox, 'Event', 'Events');
        return searchBox;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Shows a button that provides location capabilities.
 *
 * @example
 * ```javascript
 * var widget = (new L.Location()).addTo(map);
 *
 * widget.on(L.Location.Events.LocationFound, function (event) {
 *   console.log('LocationFound');
 *   console.log(event);
 * });
 *
 * widget.on(L.Location.Events.LocationError, function (event) {
 *   console.log('LocationError');
 *   console.log(event);
 * });
 *
 * @class Location
 * @namespace L
 * @extends L.Control
 * @uses L.Evented
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.imageSrc=null] The image path for locate button. If this option is passed the button would
 *     be created as an `<img>` tag.
 * @param {Number[]} [options.size=[34,34]] Its an array of two integers (width, height).
 *     The default size of the icon will be double if the user's device has a screen with Retina display capability.
 *     Allows to change size of the image, a useful option for SVG images.
 * @param {String} [options.className=""] The class name of the container element.
 *     With this option an external icon library (i.e. Font Awesome) could be used for widget's button.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, Utils) {
    'use strict';

    var EVENTS = {
        LocationFound: 'locationFound',
        LocationError: 'locationError'
    };

    function getClassName(options) {
        return options.className || options.imageSrc ? options.className : 'icon-locate_me_btn';
    }

    function setSizeStyle(style, size) {
        if (size) {
            style.width = size[0] + 'px';
            style.height = size[1] + 'px';
            style.backgroundSize = size[0] + 'px ' + size[1] + 'px';
        }
    }

    L.Location = L.Control.extend({

        includes: L.Evented.prototype,

        options: {
            imageSrc: null,
            size: L.Browser.retina ? [57, 57] : [34, 34],
            className: ''
        },

        createContainer: function createContainer() {
            var className = getClassName(this.options),
                container = L.DomUtil.create('div', 'leaflet-control-location ' + className),
                img;
            setSizeStyle(container.style, this.options.size);
            container.style.cursor = 'pointer';
            if (!L.Browser.svg || this.options.imageSrc) {
                img = L.DomUtil.create('img', '', container);
                img.src = this.options.imageSrc || L.Icon.Default.imagePath + '/locate_me_btn.png';
                img.style.cursor = 'pointer';
            }
            return container;
        },

        /**
         * The method to instantiates the location control.
         * Executed when adding to map.
         *
         * @ignore
         * @method onAdd
         * @param {Object} map Leaflet map to add control to.
         * @return {HTMLElement}
         */
        onAdd: function onAdd(map) {
            var container = this.createContainer();
            var control = this;

            L.DomEvent.addListener(container, 'mousedown', map.locate, map);
            map.on('locationfound', function (location) {
                control.fire(EVENTS.LocationFound, location);
            });
            map.on('locationerror', function (error) {
                control.fire(EVENTS.LocationError, error);
            });
            return container;
        },
        /**
         * Event that is fired when obtaining user's current location succeed.
         *
         * @event LocationFound
         * @param {Object} eventObject The found
         *     <a href="http://leafletjs.com/reference-1.0.3.html#locationevent-property"
         *     target="_blank">location details</a>
         * @param {String} [type="locationFound"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.Location()).addTo(map);
         * widget.on(L.Location.Events.LocationFound, function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when obtaining user's current location fails.
         *
         * @event LocationError
         * @param {Object} eventObject All failure information
         * @param {String} [type="locationError"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         *
         * var widget = (new L.Location()).addTo(map);
         * widget.on(L.Location.Events.LocationError, function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        Events: EVENTS,
        statics: {
            Events: EVENTS
        }
    });

    return function (options) {
        var location = new L.Location(options);
        Utils.addDeprecatedProperty(location, 'Event', 'Events');
        return location;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Layer that show a ruler with distance labels over the map.
 *
 * @class MeasurementRuler
 * @namespace L
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.markerColor="#000"] Color to use for the ruler's stops
 * @param {String} [options.lineColor="#000"] Color of the rule's line
 * @param {String} [options.rulerClassname="leaflet-distance-measurement__ruler"] Class name that should be apply to
 *     the ruler
 * @param {String} [options.labelClassname="leaflet-distance-measurement__ruler__label"] Class name that should be
 *     apply to the distance label container
 * @param {String} [options.dashArray="5 5"] A string that defines the stroke dash pattern of the leaflet polyline
 *     used to draw the ruler. For more details read
 *
 * @param {Number} [options.distanceOffset=0] Distance (in meters) that needs to be added to the distance calculation
 *     of the ruler
 * @param {"metric"|"imperial"} [options.unitScheme="metric"] Unit scheme to use for the distance calculations
 * @param {Boolean} [options.useArc=false] Uses a <a href="https://en.wikipedia.org/wiki/Great-circle_distance"
 *     rel="nofollow">great arc</a> instead of a rect line
 *
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, unitFormatConverter) {
    'use strict';

    L.MeasurementRuler = L.LayerGroup.extend({

        options: {
            markerColor: '#000',
            lineColor: '#000',
            /**
             * @ignore
             * Class name that should be apply to the ruler.
             */
            rulerClassname: 'leaflet-distance-measurement__ruler',
            /**
             * @ignore
             * Class name that should be apply to the distance label container.
             */
            labelClassname: 'leaflet-distance-measurement__ruler__label',
            /**
             * @ignore
             * A string that defines the stroke dash pattern of the leaflet polyline used to draw the ruler.
             * https://leafletjs.com/reference-1.0.3.html#path-dasharray
             */
            dashArray: '5 5',
            /**
             * @ignore
             * Distance (in meters) that needs to be added to the distance calculation of the ruler.
             * @type {Number}
             */
            distanceOffset: 0,
            /**
             * @ignore
             * Unit scheme to use for the distance calculations.
             * @type {"metric"|"imperial"}
             */
            unitScheme: 'metric',
            /**
             * @ignore
             * Draw an arc instead of a rect line.
             * @type {Boolean}
             */
            useArc: false
        },

        /**
         * All the coordinates that conform the ruler path.
         *
         * @property latLngs
         * @type {L.LatLng[]}
         */
        latLngs: [],

        /**
         * Total distance (in meters) of the ruler.
         *
         * This property will be updated each time a coordinate is added to the ruler.
         *
         * @property distance
         * @type {Number}
         */
        distance: 0,

        initialize: function initialize(options) {
            this._layers = {};
            this._markers = [];
            this._labels = [];
            this.latLngs = [];
            this.distance = 0;
            L.Util.setOptions(this, options);
        },

        /**
         * Add new coordinates to the ruler path and redraw the ruler.
         *
         * This method extends the size of the ruler.
         *
         * @method addLatLng
         * @param {L.LatLng} latLng
         */
        addLatLng: function addLatLng(latLng) {
            var prevLatLng = this.getLast(),
                segmentDistance = prevLatLng ? prevLatLng.distanceTo(latLng) : 0;
            if (prevLatLng && prevLatLng.equals(latLng)) {
                return;
            }
            this.distance += segmentDistance;
            this.latLngs.push(latLng);
            this._redrawPolyline();
            this._drawMarkerWithLabel(latLng, this.options.distanceOffset + this.distance);
        },

        /**
         * Set all the ruler's path at once.
         *
         * @method setLatLngs
         * @param {L.LatLng[]} latLngs
         */
        setLatLngs: function setLatLngs(latLngs) {
            this.latLngs = latLngs;
            this.distance = 0;
            this._redrawRuler();
        },

        /**
         * Returns the last coordinates added to the ruler.
         *
         * @method getLast
         * @return {L.LatLng} If the ruler doesn't have coordinates it will return NULL
         */
        getLast: function getLast() {
            if (this.latLngs.length > 0) {
                return this.latLngs[this.latLngs.length - 1];
            }
            return null;
        },

        /**
         * @private
         * @method _buildMarker
         * @param {L.LatLng} latLng
         * @param {Number} radius
         * @return {L.CircleMarker}
         */
        _buildMarker: function _buildMarker(latLng) {
            return L.circleMarker(latLng, {
                color: this.options.markerColor,
                fillOpacity: 1,
                opacity: 1,
                fill: true,
                radius: 3,
                interactive: false,
                renderer: this._getRenderer()
            });
        },

        /**
         * @private
         * @method _buildLabelText
         * @param {String} label
         * @return {L.DivIcon}
         */
        _buildLabelText: function _buildLabelText(label) {
            return L.divIcon({
                className: this.options.labelClassname,
                html: '<span>' + label + '</span>'
            });
        },

        /**
         * @private
         * @method _buildLabel
         * @param {L.LatLng} latLng
         * @param {String} label
         * @return {L.Marker}
         */
        _buildLabel: function _buildLabel(latLng, label) {
            return L.marker(latLng, {
                icon: this._buildLabelText(label),
                interactive: false,
                title: label,
                alt: label
            });
        },

        /**
         * Creates and draw a marker with its distance label over the map.
         *
         * A distance label will be displayed next to the marker only when the distance is greater than zero.
         *
         * @private
         * @method _drawMarkerWithLabel
         * @param {L.LatLng} latLng
         * @param {Number} distance
         */
        _drawMarkerWithLabel: function _drawMarkerWithLabel(latLng, distance) {
            var distanceText = unitFormatConverter.formatDistance(distance, this.options.unitScheme === 'imperial'),
                marker = this._buildMarker(latLng),
                label = this._buildLabel(latLng, distanceText);
            this._markers.push(marker.addTo(this));
            if (distance > 0) {
                this._labels.push(label.addTo(this));
            }
        },

        /**
         * @private
         * @method _clearAllMarkersAndLabels
         */
        _clearAllMarkersAndLabels: function _clearAllMarkersAndLabels() {
            this._markers.forEach(function (layer) {
                layer.remove();
            });
            this._labels.forEach(function (layer) {
                layer.remove();
            });
            this._markers = [];
            this._labels = [];
        },

        /**
         * @private
         * @method _getRenderer
         * @return {L.SVG}
         */
        _getRenderer: function _getRenderer() {
            return L.svg({ padding: 0.8 });
        },

        /**
         * @private
         * @method _buildPolyline
         * @param {L.LatLng[]} latLngs
         * @param {String} [dashArray=null] https://leafletjs.com/reference-1.0.3.html#polyline-dasharray
         * @return {L.Polyline}
         */
        _buildPolyline: function _buildPolyline(latLngs, dashArray) {
            return L.polyline(latLngs, {
                color: this.options.lineColor,
                weight: 2,
                opacity: 1,
                dashArray: dashArray,
                className: this.options.rulerClassname,
                interactive: false,
                renderer: this._getRenderer()
            });
        },

        /**
         * Create or update the ruler path.
         * @private
         * @method _redrawPolyline
         * @return {L.Polyline}
         */
        _redrawPolyline: function _redrawPolyline() {
            var latLngs = this.latLngs;

            if (this.options.useArc) {
                latLngs = this._calculateGreatCircleArc(latLngs);
            }

            if (this.rulerPolyline) {
                this.rulerPolyline.setLatLngs(latLngs);
            } else {
                this.rulerPolyline = this._buildPolyline(latLngs, this.options.dashArray).addTo(this);
            }

            return this.rulerPolyline;
        },

        /**
         * Given a sorted list of coordinates, it fills the spaces between the coordinates to create an Arc.
         * @private
         * @method _calculateGreatCircleArc
         * @param {L.LatLng[]} latLngs
         * @return {L.LatLng[]} New array of coordinates
         */
        _calculateGreatCircleArc: function _calculateGreatCircleArc(latLngs) {
            var that = this;
            return latLngs.reduce(function (output, currentLatLng) {
                var curveSegmentPath;
                if (output.length === 0) {
                    return [currentLatLng];
                } else {
                    curveSegmentPath = that._polylineArc(output.pop(), currentLatLng);
                    return output.concat(curveSegmentPath);
                }
            }, []);
        },

        /**
         * Redraw the labels and markers.
         * @private
         * @method _redrawAllMarkersAndLabels
         */
        _redrawAllMarkersAndLabels: function _redrawAllMarkersAndLabels() {
            this._clearAllMarkersAndLabels();
            this.latLngs.forEach(function (latLng, index) {
                var prevLatLng = index > 0 ? this.latLngs[index - 1] : null,
                    segmentDistance = prevLatLng ? prevLatLng.distanceTo(latLng) : 0;
                this.distance += segmentDistance;
                this._drawMarkerWithLabel(latLng, this.options.distanceOffset + this.distance);
            }, this);
        },

        /**
         * Redraw the polyline, labels and markers.
         * @private
         * @method _redrawRuler
         */
        _redrawRuler: function _redrawRuler() {
            this._redrawPolyline();
            this._redrawAllMarkersAndLabels();
        },

        /**
         * Calculate Great-circle Arc (= shortest distance on a sphere like the Earth) between two coordinates
         * formulas: http://www.edwilliams.org/avform.htm
         * The content of this method was copied (and slightly modified) from
         * https://github.com/ppete2/Leaflet.PolylineMeasure .
         * @private
         * @method _polylineArc
         * @param {LatLng} from
         * @param {LatLng} to
         * @return {Array}
         */
        _polylineArc: function _polylineArc(from, to) {
            var d, arcpoints, arrLatLngs;
            /**
             * work with with copies of object's elements from.lat and from.lng,
             * otherwise they would get modified due to call-by-reference on Objects in Javascript
             */
            var fromLat = from.lat;
            var fromLng = from.lng;
            var toLat = to.lat;
            var toLng = to.lng;

            function gCinterpolate(f) {
                var A = Math.sin((1 - f) * d) / Math.sin(d);
                var B = Math.sin(f * d) / Math.sin(d);
                var x = A * Math.cos(fromLat) * Math.cos(fromLng) + B * Math.cos(toLat) * Math.cos(toLng);
                var y = A * Math.cos(fromLat) * Math.sin(fromLng) + B * Math.cos(toLat) * Math.sin(toLng);
                var z = A * Math.sin(fromLat) + B * Math.sin(toLat);
                // atan2 better than atan-function cause results are from -pi to +pi
                // => results of latInterpol, lngInterpol always within range -180° ... +180°
                // => conversion into values < -180° or > + 180° has to be done afterwards
                var latInterpol = 180 / Math.PI * Math.atan2(z, Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)));
                var lngInterpol = 180 / Math.PI * Math.atan2(y, x);
                // don't split polyline if it crosses dateline ( -180° or +180°).
                // Without the polyline would look like: +179° ==> +180° ==> -180° ==> -179°...
                // algo: if difference lngInterpol-from.lng is > 180°
                // there's been an unwanted split from +180 to -180 cause an arc can never span >180°
                var diff = lngInterpol - fromLng * 180 / Math.PI;
                function trunc(n) {
                    return Math[n > 0 ? 'floor' : 'ceil'](n);
                } // alternatively we could use the new Math.trunc method, but Internet Explorer doesn't know it
                if (diff < 0) {
                    lngInterpol = lngInterpol - trunc((diff - 180) / 360) * 360;
                } else {
                    lngInterpol = lngInterpol - trunc((diff + 180) / 360) * 360;
                }
                return L.latLng(latInterpol, lngInterpol);
            }

            function gCarc(npoints) {
                var i, step, coordPair;
                var arrArcCoords = [];
                var delta = 1.0 / (npoints - 1);
                // first point of Arc should NOT be returned
                for (i = 0; i < npoints; i++) {
                    step = delta * i;
                    coordPair = gCinterpolate(step);
                    arrArcCoords.push(coordPair);
                }
                return arrArcCoords;
            }

            fromLat = fromLat * Math.PI / 180;
            fromLng = fromLng * Math.PI / 180;
            toLat = toLat * Math.PI / 180;
            toLng = toLng * Math.PI / 180;
            d = 2.0 * Math.asin(Math.sqrt(Math.pow(Math.sin((fromLat - toLat) / 2.0), 2) + Math.cos(fromLat) * Math.cos(toLat) * Math.pow(Math.sin((fromLng - toLng) / 2.0), 2)));
            arcpoints = 100; // 100 points = 99 line segments.
            // lower value to make arc less accurate or increase value to make it more accurate.
            arrLatLngs = gCarc(arcpoints);
            return arrLatLngs;
        }
    });

    return L.MeasurementRuler;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(101);
module.exports = __webpack_require__(102);


/***/ }),
/* 101 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * The main namespace of the TomTom Maps SDK for Web. This is a place where you get access to all the services,
 * Leaflet's main object `L` and configuration.
 *
 * @class tomtom
 * @module The tomtom namespace
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  'use strict';

  var tomtom, requester, L, security, mapboxProvider, analytics;

  __webpack_require__(103);
  __webpack_require__(104);
  __webpack_require__(48);

  tomtom = {};

  requester = __webpack_require__(11);

  analytics = __webpack_require__(12);
  /**
   * This method sets the content of TomTom-User-Agent header. We are collecting anonymous data for
   * statistics of usage of our services in order to increase quality of our products.
   * @method setProductInfo
   * @param {String} productId Identifier (e.g. a name) of your application e.g.&nbsp;MyApplication
   * @param {String} productVersion Version of your application e.g.&nbsp;1.0.2
   */
  tomtom.setProductInfo = analytics.setProductInfo;

  /**
   * Factory function to create instances of the {{#crossLink "L.TomTomMarkersLayer"}}{{/crossLink}} class.
   *
   * @method tomTomMarkersLayer
   * @param {Object} [options] All the available options are described in the class page
   * @return {L.TomTomMarkersLayer}
   */
  tomtom.tomTomMarkersLayer = __webpack_require__(147);

  /**
   * Tells the SDK to use JSONP instead of JSON (default) for the requests to TomTom Maps APIs.
   *
   * @example
   * ```javascript
   * tomtom.useJsonp(true); // all requests will be JSONP from now on
   * ```
   *
   * @method useJsonp
   * @param {Boolean} [useJsonp] `true`: JSONP will be used, `false` JSON will be used
   * @deprecated The support for JSONP will be removed soon. Please consider using the JSON implementation.
   */
  tomtom.useJsonp = requester.useJsonp;

  /**
   * Tells the SDK to use HTTP instead of HTTPS (default) for the requests to TomTom Maps APIs.
   *
   * This configuration can be decided per service call basis with the `protocol` option.
   *
   * @example
   * ```javascript
   * tomtom.useHttp(true); // all requests will be HTTP now
   * ````
   *
   * @method useHttp
   * @param {Boolean} [useHttp] `true`: HTTP will be used, `false` HTTPS will be used
   */
  tomtom.useHttp = requester.useHttp;

  L = __webpack_require__(3);

  /**
   * Gives you access to the <a href="https://leafletjs.com/reference-${leaflet.version}.html">Leaflet's library</a>
   * used by the SDK.
   *
   * @property L
   * @type {Object}
   */
  tomtom.L = L;

  /**
   * Alias of the L property.
   *
   * @property display
   * @type {Object}
   */
  tomtom.display = L;

  //just to be backward compatible (we build car with thill)
  tomtom.Map = L.Map;

  /**
   * Factory function to create instances of the L.Map class.
   *
   * @method map
   * @return {L.Map}
   */
  tomtom.map = L.map;

  /**
   * Factory function to create instances of the TrafficIncidents class.
   *
   * @method traffic
   * @param {Object} [options] All the available options are described in the class page
   * @return {TrafficIncidents}
   */
  tomtom.traffic = __webpack_require__(64);

  /**
   * Factory function to create instances of the Copyright class.
   *
   * @method copyright
   * @param {Object} [options] All the available options are described in the class page
   * @return {Copyright}
   */
  tomtom.copyright = __webpack_require__(59);

  /**
   * Factory function to create instances of the CopyrightCaption class.
   *
   * @method copyrightCaption
   * @param {Object} [options] All the available options are described in the class page
   * @return {CopyrightCaption}
   */
  tomtom.copyrightCaption = __webpack_require__(52);

  /**
   * Factory function to create instances of the Geocode class.
   *
   * @method geocode
   * @param {Object} [options] All the available options are described in the class page
   * @return {Geocode}
   */
  tomtom.geocode = __webpack_require__(163);

  /**
   * Factory function to create instances of the class.
   *
   * @method structuredGeocode
   * @param {Object} [options] All the available options are described in the class page
   * @return {StructuredGeocode}
   */
  tomtom.structuredGeocode = __webpack_require__(166);

  /**
   * Factory function to create instances of the ReverseGeocode class.
   *
   * @method reverseGeocode
   * @param {Object} [options] All the available options are described in the class page
   * @return {ReverseGeocode}
   */
  tomtom.reverseGeocode = __webpack_require__(25);
  /**
   * Factory function to create instances of the CrossStreetLookupclass.
   *
   * @method crossStreetLookup
   * @param {Object} [options] All the available options are described in the class page
   * @return {CrossStreetLookup}
   */
  tomtom.crossStreetLookup = __webpack_require__(169);

  /**
   * Factory function to create instances of the FuzzySearch class.
   *
   * @method fuzzySearch
   * @param {Object} [options] All the available options are described in the class page
   * @return {FuzzySearch}
   */
  tomtom.fuzzySearch = __webpack_require__(95);

  /**
   * Factory function to create instances of the PoiSearch class.
   *
   * @method poiSearch
   * @param {Object} [options] All the available options are described in the class page
   * @return {PoiSearch}
   */
  tomtom.poiSearch = __webpack_require__(170);

  /**
   * Factory function to create instances of the CategorySearch class.
   *
   * @method categorySearch
   * @param {Object} [options] All the available options are described in the class page
   * @return {CategorySearch}
   */
  tomtom.categorySearch = __webpack_require__(171);

  /**
   * Factory function to create instances of the GeometrySearch class.
   *
   * @method geometrySearch
   * @param {Object} [options] All the available options are described in the class page
   * @return {GeometrySearch}
   */
  tomtom.geometrySearch = __webpack_require__(172);

  /**
   * Factory function to create instances of the NearbySearch class.
   *
   * @method nearbySearch
   * @param {Object} [options] All the available options are described in the class page
   * @return {NearbySearch}
   */
  tomtom.nearbySearch = __webpack_require__(90);

  /**
   * Factory function to create instances of the LowBandwidthSearch class.
   *
   * @method lowBandwidthSearch
   * @param {Object} [options] All the available options are described in the class page
   * @return {LowBandwidthSearch}
   */
  tomtom.lowBandwidthSearch = __webpack_require__(173);

  /**
   * Factory function to create instances of the AlongRouteSearch class.
   *
   * @method alongRouteSearch
   * @param {Object} [options] All the available options are described in the class page
   * @return {AlongRouteSearch}
   */
  tomtom.alongRouteSearch = __webpack_require__(175);

  /**
   * Factory function to create instances of the TrafficFlowSegmentData class.
   *
   * @method trafficFlowSegmentData
   * @param {Object} [options] All the available options are described in the class page
   * @return {trafficFlowSegmentData}
   */
  tomtom.trafficFlowSegmentData = __webpack_require__(176);

  /**
   * Factory function to create instances of the AdditionalData class.
   *
   * @method additionalData
   * @param {Object} [options] All the available options are described in the class page
   * @return {AdditionalData}
   */
  tomtom.additionalData = __webpack_require__(178);

  // this was kept for backwards compatibility but it will be removed in the future
  tomtom.additionalDataProvider = tomtom.additionalData;

  /**
   * Factory function to create instances of the Routing class.
   *
   * @method routing
   * @param {Object} [options] All the available options are described in the class page
   * @return {Routing}
   */
  tomtom.routing = __webpack_require__(40);

  /**
   * Factory function to create instances of the Reachable Range Routing class.
   *
   * @method reachableRange
   * @param {Object} [options] All the available options are described in the class page
   * @return {ReachableRange}
   */
  tomtom.reachableRange = __webpack_require__(180);

  /**
   * Factory function to create instances of the MatrixRouting class.
   *
   * @method matrixRouting
   * @param {Object} [options] All the available options are described in the class page
   * @return {MatrixRouting}
   */
  tomtom.matrixRouting = __webpack_require__(183);

  /**
   * Factory function that creates a new instance of the L.ControlPanel widget.
   *
   * @method controlPanel
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.ControlPanel}
   */
  tomtom.controlPanel = __webpack_require__(185);

  /**
   * Factory function that creates a new instance of the L.Foldable widget.
   *
   * @method foldable
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.Foldable}
   */
  tomtom.foldable = __webpack_require__(46);

  /**
   * Gives you access to the L.LanguageSelector module.
   * @property languageSelector
   * @type L.LanguageSelector
   */
  tomtom.languageSelector = __webpack_require__(186);

  /**
   * Returns the global locale service instance used by all the leaflet maps.
   *
   * It lets you get and change the locale configuration used by the entire SDK.
   *
   * Whenever the {{#crossLink "LocaleService/setCurrentLocale:method"}}{{/crossLink}} method of
   * this instance is called, all the {{#crossLink "LocaleService"}}{{/crossLink}} instances used by
   * maps will be updated too.
   *
   * But if you use the {{#crossLink "LocaleService/setCurrentLocale:method"}}{{/crossLink}}
   * method in a {{#crossLink "LocaleService"}}{{/crossLink}} of a map instance only that
   * instance will be updated.
   *
   * @method globalLocaleService
   * @return {LocaleService}
   */
  tomtom.globalLocaleService = __webpack_require__(30);

  /**
   * Factory function that creates a new instance of the L.ResultsList widget.
   *
   * @method resultsList
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.ResultsList}
   */
  tomtom.resultsList = __webpack_require__(187);

  /**
   * Factory function that creates a new instance of the L.SearchBox widget.
   *
   * @method searchBox
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.SearchBox}
   */
  tomtom.searchBox = __webpack_require__(97);

  /**
   * Factory function that creates a new instance of the L.DistanceMeasurement widget.
   *
   * @method distanceMeasurement
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.DistanceMeasurement}
   */
  tomtom.distanceMeasurement = __webpack_require__(188);

  /**
   * Factory function that creates a new instance of the L.Location widget.
   *
   * @method location
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.Location}
   */
  tomtom.location = __webpack_require__(98);

  /**
   * Factory function that creates a new instance of the L.RouteInputs widget.
   *
   * @method routeInputs
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.RouteInputs}
   */
  tomtom.routeInputs = __webpack_require__(190);

  /**
   * Factory function that creates a new instance of the L.RouteInstructions widget.
   *
   * @method routeInstructions
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.RouteInstructions}
   */
  tomtom.routeInstructions = __webpack_require__(191);

  /**
   * Factory function that creates a new instance of the L.MessageBox class.
   *
   * @method messageBox
   * @param {Object} [options] All the options are available in the class's page
   * @return {L.MessageBox}
   */
  tomtom.messageBox = __webpack_require__(61);

  /**
   * Gives you access to the UnitFormatConverter module.
   *
   * @property unitFormatConverter
   * @type UnitFormatConverter
   */
  tomtom.unitFormatConverter = __webpack_require__(15);

  /**
   * Gives you access to the L.UnitSelector module.
   * @property unitSelector
   * @type L.UnitSelector
   */
  tomtom.unitSelector = __webpack_require__(192);

  /**
   * Factory function that creates a new instance of the UnitService class.
   *
   * @method unitService
   * @param {UnitService} [parent] If is defined makes the new instance a "slave" of the given instance
   * @return {UnitService}
   */
  tomtom.unitService = __webpack_require__(39);

  /**
   * Returns the global unit view service instance used by all the leaflet maps.
   *
   * It lets you get and change the unit view used by the entire SDK.
   *
   * Whenever the {{#crossLink "UnitService/setCurrentUnit:method"}}{{/crossLink}} method of
   * this instance is called, all the {{#crossLink "UnitService"}}{{/crossLink}} instances used by
   * maps will be updated too.
   *
   * But if you use the {{#crossLink "UnitService/setCurrentUnit:method"}}{{/crossLink}}
   * method in a {{#crossLink "UnitService"}}{{/crossLink}} of a map instance only that
   * instance will be updated.
   *
   * @method globalUnitService
   * @return {UnitService}
   */
  tomtom.globalUnitService = __webpack_require__(38);

  /**
   * Returns the global geopolitical view service instance used by all the leaflet maps.
   *
   * It lets you get and change the geopolitical view used by the entire SDK.
   *
   * Whenever the {{#crossLink "GeopolViewService/setCurrentGeopolView:method"}}{{/crossLink}} method of
   * this instance is called, all the {{#crossLink "GeopolViewService"}}{{/crossLink}} instances used by
   * maps will be updated too.
   *
   * But if you use the {{#crossLink "GeopolViewService/setCurrentGeopolView:method"}}{{/crossLink}}
   * method in a {{#crossLink "GeopolViewService"}}{{/crossLink}} of a map instance only that
   * instance will be updated.
   *
   * @method globalGeopolViewService
   * @return {GeopolViewService}
   */
  tomtom.globalGeopolViewService = __webpack_require__(33);

  /**
   * Gives you access to the L.UnitSelector module.
   * @property unitSelector
   * @type L.UnitSelector
   */
  tomtom.geopolViewSelector = __webpack_require__(193);

  /**
   * Factory function that creates a new instance of the L.MarkersLayer class.
   *
   * @deprecated
   * @method markersView
   * @param {Object} [options] All the options are available in the class's page
   * @return {L.MarkersLayer}
   */
  tomtom.markersView = __webpack_require__(194);

  /**
   * Factory function that creates a new instance of the L.RouteOnMap widget.
   *
   * @method routeOnMap
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.RouteOnMap}
   */
  tomtom.routeOnMap = __webpack_require__(195);

  /**
   * Factory function that creates a new instance of the L.RouteSummary widget.
   *
   * @method routeSummary
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.RouteSummary}
   */
  tomtom.routeSummary = __webpack_require__(196);

  /**
   * Factory function that creates a new instance of the L.TomTomMinimap widget.
   *
   * @method miniMap
   * @param {Object} [options] All the options are available in the widget's page
   * @return {L.TomTomMinimap}
   */
  tomtom.miniMap = __webpack_require__(197);

  security = __webpack_require__(5);

  /**
   * Sets a key 'config' object in the security configuration file. When the key's name is omitted,
   *  then the default key is set.
   *
   * @example
   * ```javascript
   * tomtom.key('keyValue');  // sets global key
   * tomtom.key('service/traffic', 'keyValue'); // sets key for traffic service
   * ```
   *
   * @method key
   * @param {String} name Name of the key to be set
   * @param {String} [value] Value of the key
   */
  tomtom.key = security.setKey;

  /**
   * Sets a key for the services: map tiles and copyrights. Can also be passed on the map object's initialization with
   * _key_ parameter.
   *
   * @example
   * ```javascript
   * tomtom.mapsKey('keyValue');  // sets maps key
   * ```
   *
   * @method mapsKey
   * @param {String} value Value of the maps key
   */
  tomtom.mapsKey = security.setKeyForName('services/display');

  /**
   * Sets a key for the vector tiles service. Can also be passed on the map object's initialization
   * with the _key_ parameter or using _key_ method. In cases where default key covers vectors tile service as well
   * setting specific key here is not required.
   *
   * @example
   * ```javascript
   * tomtom.vectorMapsKey('keyValue');  // sets the vector maps key
   * ```
   *
   * @method vectorMapsKey
   * @param {String} value Value of the vector maps key
   */
  tomtom.vectorMapsKey = security.setKeyForName('services/display/vector');

  /**
   * Sets a key for the traffic incidents tiles and services. Can also be passed on the map object's
   * initialization as an option of the traffic incidents layer.
   *
   * @example
   * ```javascript
   * tomtom.trafficKey('keyValue');  // sets traffic key
   * ```
   *
   * @method trafficKey
   * @param {String} value Value of the traffic key
   */
  tomtom.trafficKey = security.setKeyForName('services/traffic');

  /**
   * Sets a key for traffic flow tiles service. Can also be passed on the map object's initialization
   * as an option of the traffic flow layer.
   *
   * @example
   * ```javascript
   * tomtom.trafficFlowKey('keyValue');  // sets traffic flow key
   * ```
   *
   * @method trafficFlowKey
   * @param {String} value Value of the traffic flow key
   */
  tomtom.trafficFlowKey = security.setKeyForName('services/trafficFlow');

  /**
   * Sets a key for search, geocode and reverse geocode services.
   *
   * @example
   * ```javascript
   * tomtom.searchKey('keyValue');  // sets search key
   * ```
   *
   * @method searchKey
   * @param {String} value Value of the search key
   */
  tomtom.searchKey = security.setKeyForName('services/search');

  /**
   * Sets a key for the routing service.
   *
   * @example
   * ```javascript
   * tomtom.routingKey('keyValue');  // sets routing key
   * ```
   *
   * @method routingKey
   * @param {String} value Value of the routing key
   */
  tomtom.routingKey = security.setKeyForName('services/routing');

  /**
   * Factory function to create instances of the LocaleService class.
   *
   * @method localeService
   * @return {LocaleService}
   */
  tomtom.localeService = __webpack_require__(31);

  mapboxProvider = __webpack_require__(27);

  /**
   * It takes a mapbox global object that have to be used for render the vector maps.
   *
   * The use of this method is required if you use the version of this SDK version without Mapbox GL JS
   * embedded in it.
   *
   * The currently supported version of Mapbox GL JS is v${mapboxgl.version}.
   *
   * @example
   * ```js
   * tomtom.setMapbox(mapboxgl); //sets mapboxgl reference
   * ```
   *
   * @method setMapbox
   * @param {Object} mapboxgl Reference to mapboxgl object (global object provided by Mapbox GL JS library)
   */
  tomtom.setMapbox = mapboxProvider.setMapbox;

  /**
   * Factory function to create instances of the StaticMapImage class.
   *
   * @method staticMapImage
   * @param {Object} [options] All the available options are described in the class page
   * @return {StaticMapImage}
   */
  tomtom.staticMapImage = __webpack_require__(49);

  /*
   * It includes a method in L.Map to easily generate an URL to obtain an static image of the current viewport.
   */
  __webpack_require__(48);

  return tomtom;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
  /**
   * @ignore
   * Overrides default Leaflet touch device recognition.
   * Leaflet uses Object.freeze on L.Browser, so we are unable to override L.Browser.touch.
   * Luckly Leaflet provides global flag that let's us change the default detection
   * by setting global variable: https://github.com/Leaflet/Leaflet/blob/master/build/docs-misc.leafdoc.
   */
  window.L_NO_TOUCH = !('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */


!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(105)], __WEBPACK_AMD_DEFINE_RESULT__ = function (promise) {

    //This is pollyfill for old IE trim method
    if (typeof String.prototype.trim !== 'function') {
        String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g, '');
        };
    }

    /**
     * @ignore
     * DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
     * Version 2, December 2004
     *
     * Copyright (C) 2011 Alex Kloss <alexthkloss@web.de>
     *
     * Everyone is permitted to copy and distribute verbatim or modified
     * copies of this license document, and changing it is allowed as long
     * as the name is changed.
     *
     * DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
     * TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION
     *
     * 0. You just DO WHAT THE FUCK YOU WANT TO.
     */

    if (![].indexOf) {
        Array.prototype.indexOf = function (a, b, c) {
            for (c = this.length, b = (c + ~~b) % c; b < c && (!(b in this) || this[b] !== a); ++b) {
                //do nothing
            }
            return b ^ c ? b : -1;
        };
    }

    if (![].forEach) {
        Array.prototype.forEach = function (a, b, c, d) {
            for (d = this.length, c = 0; c < d; ++c) {
                if (c in this) {
                    a.call(b, this[c], c, this);
                }
            }
        };
    }

    if (window.Promise === undefined) {
        window.Promise = promise;
    }

    Number.isInteger = Number.isInteger || function (value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };

    //Object.assign - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
    //eslint-disable-next-line eqeqeq
    if (typeof Object.assign != 'function') {
        //eslint-disable-next-line no-unused-vars
        Object.assign = function (target, varArgs) {
            // .length of function is 2
            var to, index, nextSource, nextKey;
            //eslint-disable-next-line eqeqeq
            if (target == null) {
                // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            to = Object(target);

            for (index = 1; index < arguments.length; index++) {
                nextSource = arguments[index];
                //eslint-disable-next-line eqeqeq
                if (nextSource != null) {
                    // Skip over if undefined or null
                    for (nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        };
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.ES6Promise=e()}(this,function(){"use strict";function t(t){var e=typeof t;return null!==t&&("object"===e||"function"===e)}function e(t){return"function"==typeof t}function n(t){I=t}function r(t){J=t}function o(){return function(){return process.nextTick(a)}}function i(){return"undefined"!=typeof H?function(){H(a)}:c()}function s(){var t=0,e=new V(a),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=a,function(){return t.port2.postMessage(0)}}function c(){var t=setTimeout;return function(){return t(a,1)}}function a(){for(var t=0;t<G;t+=2){var e=$[t],n=$[t+1];e(n),$[t]=void 0,$[t+1]=void 0}G=0}function f(){try{var t=require,e=__webpack_require__(107);return H=e.runOnLoop||e.runOnContext,i()}catch(n){return c()}}function l(t,e){var n=arguments,r=this,o=new this.constructor(p);void 0===o[et]&&k(o);var i=r._state;return i?!function(){var t=n[i-1];J(function(){return x(i,o,t,r._result)})}():E(r,o,t,e),o}function h(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(p);return g(n,t),n}function p(){}function v(){return new TypeError("You cannot resolve a promise with itself")}function d(){return new TypeError("A promises callback cannot return that same promise.")}function _(t){try{return t.then}catch(e){return it.error=e,it}}function y(t,e,n,r){try{t.call(e,n,r)}catch(o){return o}}function m(t,e,n){J(function(t){var r=!1,o=y(n,e,function(n){r||(r=!0,e!==n?g(t,n):S(t,n))},function(e){r||(r=!0,j(t,e))},"Settle: "+(t._label||" unknown promise"));!r&&o&&(r=!0,j(t,o))},t)}function b(t,e){e._state===rt?S(t,e._result):e._state===ot?j(t,e._result):E(e,void 0,function(e){return g(t,e)},function(e){return j(t,e)})}function w(t,n,r){n.constructor===t.constructor&&r===l&&n.constructor.resolve===h?b(t,n):r===it?(j(t,it.error),it.error=null):void 0===r?S(t,n):e(r)?m(t,n,r):S(t,n)}function g(e,n){e===n?j(e,v()):t(n)?w(e,n,_(n)):S(e,n)}function A(t){t._onerror&&t._onerror(t._result),T(t)}function S(t,e){t._state===nt&&(t._result=e,t._state=rt,0!==t._subscribers.length&&J(T,t))}function j(t,e){t._state===nt&&(t._state=ot,t._result=e,J(A,t))}function E(t,e,n,r){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+rt]=n,o[i+ot]=r,0===i&&t._state&&J(T,t)}function T(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,o=void 0,i=t._result,s=0;s<e.length;s+=3)r=e[s],o=e[s+n],r?x(n,r,o,i):o(i);t._subscribers.length=0}}function M(){this.error=null}function P(t,e){try{return t(e)}catch(n){return st.error=n,st}}function x(t,n,r,o){var i=e(r),s=void 0,u=void 0,c=void 0,a=void 0;if(i){if(s=P(r,o),s===st?(a=!0,u=s.error,s.error=null):c=!0,n===s)return void j(n,d())}else s=o,c=!0;n._state!==nt||(i&&c?g(n,s):a?j(n,u):t===rt?S(n,s):t===ot&&j(n,s))}function C(t,e){try{e(function(e){g(t,e)},function(e){j(t,e)})}catch(n){j(t,n)}}function O(){return ut++}function k(t){t[et]=ut++,t._state=void 0,t._result=void 0,t._subscribers=[]}function Y(t,e){this._instanceConstructor=t,this.promise=new t(p),this.promise[et]||k(this.promise),B(e)?(this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?S(this.promise,this._result):(this.length=this.length||0,this._enumerate(e),0===this._remaining&&S(this.promise,this._result))):j(this.promise,q())}function q(){return new Error("Array Methods must be provided an Array")}function F(t){return new Y(this,t).promise}function D(t){var e=this;return new e(B(t)?function(n,r){for(var o=t.length,i=0;i<o;i++)e.resolve(t[i]).then(n,r)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function K(t){var e=this,n=new e(p);return j(n,t),n}function L(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function N(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function U(t){this[et]=O(),this._result=this._state=void 0,this._subscribers=[],p!==t&&("function"!=typeof t&&L(),this instanceof U?C(this,t):N())}function W(){var t=void 0;if("undefined"!=typeof global)t=global;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var n=t.Promise;if(n){var r=null;try{r=Object.prototype.toString.call(n.resolve())}catch(e){}if("[object Promise]"===r&&!n.cast)return}t.Promise=U}var z=void 0;z=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var B=z,G=0,H=void 0,I=void 0,J=function(t,e){$[G]=t,$[G+1]=e,G+=2,2===G&&(I?I(a):tt())},Q="undefined"!=typeof window?window:void 0,R=Q||{},V=R.MutationObserver||R.WebKitMutationObserver,X="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),Z="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,$=new Array(1e3),tt=void 0;tt=X?o():V?s():Z?u():void 0===Q&&"function"=="function"?f():c();var et=Math.random().toString(36).substring(16),nt=void 0,rt=1,ot=2,it=new M,st=new M,ut=0;return Y.prototype._enumerate=function(t){for(var e=0;this._state===nt&&e<t.length;e++)this._eachEntry(t[e],e)},Y.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===h){var o=_(t);if(o===l&&t._state!==nt)this._settledAt(t._state,e,t._result);else if("function"!=typeof o)this._remaining--,this._result[e]=t;else if(n===U){var i=new n(p);w(i,t,o),this._willSettleAt(i,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},Y.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===nt&&(this._remaining--,t===ot?j(r,n):this._result[e]=n),0===this._remaining&&S(r,this._result)},Y.prototype._willSettleAt=function(t,e){var n=this;E(t,void 0,function(t){return n._settledAt(rt,e,t)},function(t){return n._settledAt(ot,e,t)})},U.all=F,U.race=D,U.resolve=h,U.reject=K,U._setScheduler=n,U._setAsap=r,U._asap=J,U.prototype={constructor:U,then:l,"catch":function(t){return this.then(null,t)}},U.polyfill=W,U.Promise=U,U});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(106), __webpack_require__(47)))

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    function getBasePath() {
        var scripts = document.getElementsByTagName('script'),
            pattern = /(.*)tomtom.min.js/,
            i,
            path;
        for (i = 0; i < scripts.length; i++) {
            if (scripts[i].src) {
                path = pattern.exec(scripts[i].src);
                if (path) {
                    return path[1];
                }
            }
        }
        return '';
    }

    return {
        get: function get(map) {
            var basePath = map && map.options && map.options.basePath ? map.options.basePath + '/' : getBasePath();
            return basePath + 'images';
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(116), __webpack_require__(117), __webpack_require__(5), __webpack_require__(18), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (http, stylesParser, relativeToAbsolutePathConverter, security, mainConfig, Utils) {
    'use strict';

    var originalSetStyle;

    /**
     * @ignore
     * @param {String} url
     * @param {Function} callback
     */
    function requestStyle(url, callback) {
        http.get({
            url: url,
            callback: callback
        });
    }

    function validateAndSetStyle(styleDefinition, options) {
        var apiKey, styleParserOptions, fallbackResourceUrlReqex, setStyle;
        options = options || {};
        apiKey = security.getKey(options.securityKeyName);
        styleParserOptions = {
            apiKey: apiKey,
            language: options ? options.language : undefined,
            geopolView: options ? options.geopolView : undefined,
            resourceUrls: options && options.resourceUrls ? {
                glyphs: relativeToAbsolutePathConverter.convert(options.resourceUrls.glyphs),
                sprite: relativeToAbsolutePathConverter.convert(options.resourceUrls.sprite)
            } : undefined
        };
        fallbackResourceUrlReqex = /https:\/\/api.tomtom.com\/maps-sdk-js\/\d*\.\d*\.\d*\/glyphs/g;
        setStyle = function setStyle() {
            if (styleParserOptions.resourceUrls && fallbackResourceUrlReqex.test(styleParserOptions.resourceUrls.glyphs)) {
                console.warn('You should host glyphs and sprites on your own.', '\n', 'During map initialization pass glyphs and sprites urls', '\n', 'var map = tomtom.map("map", {', '\n', 'key: "<your-tomtom-API-key>",', '\n', 'source: "vector",', '\n', 'basePath: <your-tomtom-sdk-base-path>,', '\n', 'glyphsUrl: <your-glyphs-URL>,', '\n', 'spriteUrl: <your-sprite-URL>', '\n', '});', '\n', 'If you set basePath correctly the SDK will try to load glyphs and sprites', 'from there and you will not need to set the URL explicitly.');
            }

            originalSetStyle.call(this, stylesParser(styleDefinition, styleParserOptions), options);
        };

        setStyle = setStyle.bind(this);

        /**
         * @ignore
         * Try to load sprite from the provided resource url. If it fails switch to hosted glyphs and sprites.
         * If url is not provided set provided style as it is.
         */
        if (styleParserOptions.resourceUrls && styleParserOptions.resourceUrls.sprite) {
            http.get({
                url: styleParserOptions.resourceUrls.sprite + '.json',
                callback: setStyle,
                fail: function fail() {
                    styleParserOptions.resourceUrls = {
                        glyphs: mainConfig['vector.glyphs'],
                        sprite: mainConfig['vector.sprites']
                    };
                    setStyle();
                }
            });
        } else {
            setStyle();
        }
    }

    /**
     * @ignore
     * @param {Object} styleDefinition
     * @param {Object} options
     */
    function setStyleDefinition(styleDefinition, options) {
        var that = this;
        if (options && options.preSetStyleCallback) {
            options.preSetStyleCallback(styleDefinition).then(function (styleDefinition) {
                validateAndSetStyle.call(that, styleDefinition, options);
            });
        } else {
            validateAndSetStyle.call(that, styleDefinition, options);
        }
    }

    /**
     * @ignore
     * @param {String} styleUrl
     * @param {Object} options
     */
    function setStyleDefinitionFromUrl(styleUrl, options) {
        var that = this;
        requestStyle(styleUrl, function (retrievedStyle) {
            setStyleDefinition.call(that, retrievedStyle, options);
        });
    }

    /**
     * @ignore
     * @param {Object} styleDefinition
     * @return {Boolean}
     */
    function isTomtomStyleObjectConfig(styleDefinition) {
        return (typeof styleDefinition === 'undefined' ? 'undefined' : _typeof(styleDefinition)) === 'object' && styleDefinition !== null && styleDefinition.styleUrlMapping;
    }

    /**
     * @ignore
     * @param {Object} styleDefinition
     * @return {String}
     */
    function resolveTomtomStyleUrl(styleDefinition) {
        var url = styleDefinition.styleUrlMapping[styleDefinition.theme.style][styleDefinition.theme.layer];
        return relativeToAbsolutePathConverter.convert(url);
    }

    /**
     * @ignore
     * @param {Object|String} styleDefinitionOrUrl
     * @param {Object} style.styleUrlMapping
     * @param {Object} [options]
     */
    function setStyle(styleDefinitionOrUrl, options) {
        if (isTomtomStyleObjectConfig(styleDefinitionOrUrl)) {
            options = options || {};
            options.resourceUrls = styleDefinitionOrUrl.resourceUrls;
            options.language = styleDefinitionOrUrl.language;
            options.geopolView = styleDefinitionOrUrl.geopolView;
            options.securityKeyName = styleDefinitionOrUrl.securityKeyName;
            options.preSetStyleCallback = styleDefinitionOrUrl.preSetStyleCallback;
            styleDefinitionOrUrl = resolveTomtomStyleUrl(styleDefinitionOrUrl);
        }

        // If a Style definition object is given
        if ((typeof styleDefinitionOrUrl === 'undefined' ? 'undefined' : _typeof(styleDefinitionOrUrl)) === 'object' && styleDefinitionOrUrl !== null) {
            setStyleDefinition.call(this, styleDefinitionOrUrl, options);

            // If an URL is given
        } else if (Utils.isString(styleDefinitionOrUrl)) {
            setStyleDefinitionFromUrl.call(this, styleDefinitionOrUrl, options);
        } else {
            originalSetStyle.call(this, styleDefinitionOrUrl, options);
        }
    }

    return {
        /**
         * @ignore
         * This method is used to enforce our styles to be loaded asynchronously and be passed to original mapboxgl
         * setStyle method LNS-10975
         * @param {Object} mapboxgl
         * @return {Function} Previously remembered setStyle function
         */
        modifySetStyle: function modifySetStyle(mapboxgl) {
            var previousOriginalSetStyleFunction;
            if (!mapboxgl || mapboxgl.Map.prototype.setStyle === setStyle) {
                return null;
            }
            previousOriginalSetStyleFunction = originalSetStyle;
            originalSetStyle = mapboxgl.Map.prototype.setStyle;
            mapboxgl.Map.prototype.setStyle = setStyle;
            return previousOriginalSetStyleFunction;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(50), __webpack_require__(112), __webpack_require__(12), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (urlBuilder, errorHandler, analytics, Utils) {
    'use strict';

    function stringify(obj) {
        try {
            return JSON.stringify(obj);
        } catch (ex) {
            return null;
        }
    }

    function setHeader(requestOptions, headerName, headerValue) {
        var header;
        if (!requestOptions.headers) {
            requestOptions.headers = {};
        }

        header = requestOptions.headers[headerName] || requestOptions.headers[headerName.toLowerCase()];
        if (!header) {
            requestOptions.headers[headerName] = headerValue;
        }
    }

    function addObjectBodyParams(bodyParams, requestOptions) {
        var body;
        if (!(bodyParams instanceof FormData) && !(bodyParams instanceof Blob)) {
            body = stringify(bodyParams);
            if (!body) {
                throw new Error('Unsupported request body type: ' + bodyParams);
            }
            setHeader(requestOptions, 'Content-Type', 'application/json');
        } else {
            body = bodyParams;
        }
        return body;
    }

    function addBodyParams(options, requestOptions) {
        var bodyParams = options.bodyParameters,
            body;
        if (!bodyParams) {
            return;
        }

        if (Utils.isObject(bodyParams)) {
            body = addObjectBodyParams(bodyParams, requestOptions);
        } else if (Utils.isString(bodyParams)) {
            body = bodyParams;
        }

        requestOptions.body = body;
    }

    function performFetchRequest(options, url, requestOptions) {
        fetch(url, requestOptions).then(function (response) {
            if (response.ok) {
                if (options.requestType === 'batch' && response.status === 202) {
                    return options.callback(response.headers.get('Location'));
                }
                return response.json().then(options.callback);
            } else {
                return Promise.reject(response);
            }
        }).catch(function (reason) {
            errorHandler(options, reason);
        });
    }

    return {
        /**
         * Executes a request and processes the response as JSON.
         * @method get
         * @param {Object} options Specifies the details of the request.
         * @param {String} options.url The URL to request.
         * @param {Object} [options.queryParameters] The data to pass as GET parameters with the request.
         * @param {Object} [options.pathParameters] The data to use as {placeholders} in url.
         * @param {Function} [options.fail] The callback to execute when the request fails.
         * @param {Function} options.callback The callback to execute when the request completes.
         */
        get: function get(options) {
            var url,
                requestOptions,
                headers = {};
            options.pathParameters = options.pathParameters || {};
            options.pathParameters.contentType = 'json';
            options.pathParameters.protocol = options.pathParameters.protocol || 'https';

            url = urlBuilder(options.url, options.pathParameters, options.queryParameters);
            if (analytics.isTomtomOrigin(url)) {
                headers = analytics.getAnalyticsHeader();
            }
            headers['Accept'] = 'application/json'; //eslint-disable-line dot-notation

            requestOptions = {
                method: 'GET',
                headers: headers,
                mode: 'cors'
            };

            performFetchRequest(options, url, requestOptions);
        },

        /**
         * Executes a request and processes the response as JSON.
         * @method post
         * @param {Object} options Specifies the details of the request.
         * @param {String} options.url The URL to request.
         * @param {Object} [options.queryParameters] The data to pass as Url parameters with the request.
         * @param {Object} [options.pathParameters] The data to use as {placeholders} in url.
         * @param {Object} [options.bodyParameters] The data to pass to request body.
         * @param {Function} [options.fail] The callback to execute when the request fails.
         * @param {Function} options.callback The callback to execute when the request completes.
         */
        post: function post(options) {
            var url,
                requestOptions,
                headers = {};
            options.pathParameters = options.pathParameters || {};
            options.pathParameters.contentType = 'json';
            options.pathParameters.protocol = options.pathParameters.protocol || 'https';

            url = urlBuilder(options.url, options.pathParameters, options.queryParameters);
            if (analytics.isTomtomOrigin(url)) {
                headers = analytics.getAnalyticsHeader();
            }
            headers['Accept'] = 'application/json'; //eslint-disable-line dot-notation

            requestOptions = {
                method: 'POST',
                headers: headers,
                mode: 'cors',
                redirect: 'follow'
            };

            addBodyParams(options, requestOptions);
            performFetchRequest(options, url, requestOptions);
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {

    function errorHandler(reason) {
        var contentType = reason.headers && reason.headers.get('content-type');
        if (reason.json) {
            if (/application\/json.*/.test(contentType)) {
                reason.json().then(this.fail).catch(this.fail);
            } else {
                reason.text().then(this.fail).catch(this.fail);
            }
        } else {
            this.fail(reason);
        }
    }

    return function (options, reason) {
        var errHandler = errorHandler.bind(options);
        if (options.fail) {
            errHandler(reason);
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(114), __webpack_require__(51), __webpack_require__(115), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (aja, template, errorHandler, analytics) {
    'use strict';

    function callbackFunction(callback, fail) {
        return function (response) {
            if (!response.errorResponse) {
                callback(response);
                return;
            }
            if (fail) {
                fail(response.errorResponse['@description']);
            }
        };
    }

    function prepareOptions(options) {
        options.pathParameters = options.pathParameters || {};
        options.pathParameters.contentType = 'jsonp';
        options.pathParameters.protocol = options.pathParameters.protocol || 'https';
        options.callbackParam = options.callbackParam || 'jsonp';
    }

    function addQueryParams(options, req) {
        return options.queryParameters ? req.data(options.queryParameters) : req;
    }

    return {
        /**
         * Executes a request and processes the response as JSON.
         * @method get
         * @param {Object} options Specifies the details of the request.
         * @param {String} options.url The URL to request with {placeholders} for path parameters. {contentType}
         *     will be replaced accordingly.
         * @param {Object} [options.queryParameters] The data to pass as GET parameters with the request.
         * @param {Object} [options.pathParameters] The data to use as {placeholders} in url.
         * @param {Function} options.callback The callback to execute when the request completes.
         * @param {String} [options.callbackParam=jsonp] The parameter name that the endpoint expects to qualify
         *     the JSONP callback function.
         */
        get: function get(options) {
            var url, req;
            console.warn('The support for JSONP will be removed soon. Please consider using the JSON implementation.');
            prepareOptions(options);
            url = template(options.url, options.pathParameters);
            req = aja().url(url).type('jsonp').jsonPaddingName(options.callbackParam);

            if (analytics.isTomtomOrigin(url)) {
                req = analytics.addAnalyticsHeader(req);
            }

            req = addQueryParams(options, req);
            req = errorHandler(options, req);
            req.on('success', callbackFunction(options.callback, options.fail)).go();
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(){"use strict";var a=["html","json","jsonp","script"],b=["connect","delete","get","head","options","patch","post","put","trace"],c=function f(){var a={},b={},c={url:function(a){return h.call(this,"url",a,d.string)},sync:function(a){return h.call(this,"sync",a,d.bool)},cache:function(a){return h.call(this,"cache",a,d.bool)},type:function(a){return h.call(this,"type",a,d.type)},header:function(b,c){return a.headers=a.headers||{},d.string(b),"undefined"!=typeof c?(d.string(c),a.headers[b]=c,this):a.headers[b]},auth:function(b,c){return d.string(b),d.string(c),a.auth={user:b,passwd:c},this},timeout:function(a){return h.call(this,"timeout",a,d.positiveInteger)},method:function(a){return h.call(this,"method",a,d.method)},queryString:function(a){return h.call(this,"queryString",a,d.queryString)},data:function(a){return h.call(this,"data",a,d.plainObject)},body:function(a){return h.call(this,"body",a,null,function(a){if("object"==typeof a){if(!(a instanceof FormData)){try{a=JSON.stringify(a)}catch(b){throw new TypeError("Unable to stringify body's content : "+b.name)}this.header("Content-Type","application/json")}}else a+="";return a})},into:function(a){return h.call(this,"into",a,d.selector,function(a){return"string"==typeof a?document.querySelectorAll(a):a instanceof HTMLElement?[a]:void 0})},jsonPaddingName:function(a){return h.call(this,"jsonPaddingName",a,d.string)},jsonPadding:function(a){return h.call(this,"jsonPadding",a,d.func)},on:function(a,c){return"function"==typeof c&&(b[a]=b[a]||[],b[a].push(c)),this},off:function(a){return b[a]=[],this},trigger:function(a,c){var d=this,e=function(a,c){b[a]instanceof Array&&b[a].forEach(function(a){a.call(d,c)})};if("undefined"!=typeof a){a+="";var f=/^([0-9])([0-9x])([0-9x])$/i,g=a.match(f);g&&g.length>3?Object.keys(b).forEach(function(a){var b=a.match(f);!(b&&b.length>3&&g[1]===b[1])||"x"!==b[2]&&g[2]!==b[2]||"x"!==b[3]&&g[3]!==b[3]||e(a,c)}):b[a]&&e(a,c)}return this},go:function(){var b=a.type||(a.into?"html":"json"),c=j();return"function"==typeof g[b]?g[b].call(this,c):void 0}},g={json:function(a){var b=this;g._xhr.call(this,a,function(a){if(a)try{a=JSON.parse(a)}catch(c){return b.trigger("error",c),null}return a})},html:function(b){g._xhr.call(this,b,function(b){return a.into&&a.into.length&&[].forEach.call(a.into,function(a){a.innerHTML=b}),b})},_xhr:function(b,c){var d,e,f,g,h,j=this,k=a.method||"get",l=a.sync!==!0,m=new XMLHttpRequest,n=a.data,o=a.body,p=(a.headers||{},this.header("Content-Type")),q=a.timeout;if(!p&&n&&i()&&(this.header("Content-Type","application/x-www-form-urlencoded;charset=utf-8"),p=this.header("Content-Type")),n&&i())if("string"!=typeof o&&(o=""),p.indexOf("json")>-1)try{o=JSON.stringify(n)}catch(r){throw new TypeError("Unable to stringify body's content : "+r.name)}else{g=p&&p.indexOf("x-www-form-urlencoded")>1;for(d in n)o+=g?encodeURIComponent(d)+"="+encodeURIComponent(n[d])+"&":d+"="+n[d]+"\n\r"}h=[k,b,l],a.auth&&(h.push(a.auth.user),h.push(a.auth.passwd)),m.open.apply(m,h);for(e in a.headers)m.setRequestHeader(e,a.headers[e]);m.onprogress=function(a){a.lengthComputable&&j.trigger("progress",a.loaded/a.total)},m.onload=function(){var a=m.responseText;f&&clearTimeout(f),this.status>=200&&this.status<300&&("function"==typeof c&&(a=c(a)),j.trigger("success",a)),j.trigger(this.status,a),j.trigger("end",a)},m.onerror=function(a){f&&clearTimeout(f),j.trigger("error",a,arguments)},q&&(f=setTimeout(function(){j.trigger("timeout",{type:"timeout",expiredAfter:q},m,arguments),m.abort()},q)),m.send(o)},jsonp:function(b){var c,d=this,g=document.querySelector("head"),h=a.sync!==!0,i=a.jsonPaddingName||"callback",j=a.jsonPadding||"_padd"+(new Date).getTime()+Math.floor(1e4*Math.random()),k={};if(f[j])throw new Error("Padding "+j+"  already exists. It must be unique.");/^ajajsonp_/.test(j)||(j="ajajsonp_"+j),window[j]=function(a){d.trigger("success",a),g.removeChild(c),window[j]=void 0},k[i]=j,b=e(b,k),c=document.createElement("script"),c.async=h,c.src=b,c.onerror=function(){d.trigger("error",arguments),g.removeChild(c),window[j]=void 0},g.appendChild(c)},script:function(b){var c,d=this,e=document.querySelector("head")||document.querySelector("body"),f=a.sync!==!0;if(!e)throw new Error("Ok, wait a second, you want to load a script, but you don't have at least a head or body tag...");c=document.createElement("script"),c.async=f,c.src=b,c.onerror=function(){d.trigger("error",arguments),e.removeChild(c)},c.onload=function(){d.trigger("success",arguments)},e.appendChild(c)}},h=function(b,c,e,f){if("undefined"!=typeof c){if("function"==typeof e)try{c=e.call(d,c)}catch(g){throw new TypeError("Failed to set "+b+" : "+g.message)}return"function"==typeof f?a[b]=f.call(this,c):a[b]=c,this}return"undefined"===a[b]?null:a[b]},i=function(){return["delete","patch","post","put"].indexOf(a.method)>-1},j=function(){var b=a.url,c="undefined"!=typeof a.cache?!!a.cache:!0,d=a.queryString||"",f=a.data;return c===!1&&(d+="&ajabuster="+(new Date).getTime()),b=e(b,d),f&&!i()&&(b=e(b,f)),b};return c},d={bool:function(a){return!!a},string:function(a){if("string"!=typeof a)throw new TypeError("a string is expected, but "+a+" ["+typeof a+"] given");return a},positiveInteger:function(a){if(parseInt(a)!==a||0>=a)throw new TypeError("an integer is expected, but "+a+" ["+typeof a+"] given");return a},plainObject:function(a){if("object"!=typeof a||a.constructor!==Object)throw new TypeError("an object is expected, but "+a+"  ["+typeof a+"] given");return a},type:function(b){if(b=this.string(b),a.indexOf(b.toLowerCase())<0)throw new TypeError("a type in ["+a.join(", ")+"] is expected, but "+b+" given");return b.toLowerCase()},method:function(a){if(a=this.string(a),b.indexOf(a.toLowerCase())<0)throw new TypeError("a method in ["+b.join(", ")+"] is expected, but "+a+" given");return a.toLowerCase()},queryString:function(a){var b={};return"string"==typeof a?a.replace("?","").split("&").forEach(function(a){var c=a.split("=");2===c.length&&(b[decodeURIComponent(c[0])]=decodeURIComponent(c[1]))}):b=a,this.plainObject(b)},selector:function(a){if("string"!=typeof a&&!(a instanceof HTMLElement))throw new TypeError("a selector or an HTMLElement is expected, "+a+" ["+typeof a+"] given");return a},func:function(a){if(a=this.string(a),!/^([a-zA-Z_])([a-zA-Z0-9_\-])+$/.test(a))throw new TypeError("a valid function name is expected, "+a+" ["+typeof a+"] given");return a}},e=function(a,b){var c;if(a=a||"",b)if(-1===a.indexOf("?")&&(a+="?"),"string"==typeof b)a+=b;else if("object"==typeof b)for(c in b)a+="&"+encodeURIComponent(c)+"="+encodeURIComponent(b[c]);return a}; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return c}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=c:window.aja=window.aja||c}();

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {

    function errorHandler(err) {
        if (Object.prototype.toString.call(err) === '[object String]') {
            try {
                err = JSON.parse(err);
                this.fail(err);
            } catch (e) {
                this.fail(err);
            }
        }
        this.fail(err);
    }

    return function (options, req) {
        var errHandler = errorHandler.bind(options);
        if (options.fail) {
            req.on('error', errHandler).on('4xx', errHandler).on('5xx', errHandler);
        }
        return req;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
    'use strict';

    /**
     * @ignore
     * @param {String} sourceUrl
     * @param {String} paramName
     * @param {String} paramValue
     * @return {String}
     */

    function setQueryParamInUrl(sourceUrl, paramName, paramValue) {
        var qPrefix,
            pattern = new RegExp('(' + paramName + '=)[^&]*');
        if (pattern.test(sourceUrl)) {
            sourceUrl = sourceUrl.replace(pattern, '$1' + paramValue);
        } else {
            qPrefix = /\?/.test(sourceUrl) ? '&' : '?';
            sourceUrl += qPrefix + paramName + '=' + paramValue;
        }
        return sourceUrl;
    }

    /**
     * @ignore
     * Sets the value of a parameter in the given Url string.
     *
     * It does that in two form:
     *  1. Find and replace a token for this param in the Url
     *  2. If no token is found, appends the value as a query paremeter
     *
     * @param {String} sourceUrl
     * @param {String} paramName
     * @param {String} paramValue
     * @return {String} New Url string
     */
    function setParamInUrl(sourceUrl, paramName, paramValue) {
        var token;
        if (!Utils.isString(paramName) || !Utils.isString(paramValue) || paramValue.trim().length === 0) {
            return sourceUrl;
        }
        token = new RegExp('{' + paramName + '}', 'g');
        if (token.test(sourceUrl)) {
            return sourceUrl.replace(token, paramValue);
        }
        return setQueryParamInUrl(sourceUrl, paramName, paramValue);
    }

    /**
     * @ignore
     * @param {String} sourceUrl
     * @param {Object} options
     * @param {String} [options.apiKey]
     * @param {String} [options.language]
     * @param {String} [options.geopolView]
     * @return {String} Parsed URL
     */
    function parseSourceUrl(sourceUrl, options) {
        // Replacing "key" token with API key
        sourceUrl = setParamInUrl(sourceUrl, 'key', options.apiKey);
        // Adding language query parameter
        if (options.language) {
            sourceUrl = setParamInUrl(sourceUrl, 'language', options.language);
        }
        // Adding geo-political view query parameter
        if (options.geopolView) {
            sourceUrl = setParamInUrl(sourceUrl, 'view', options.geopolView);
        }
        return sourceUrl;
    }

    /**
     * @ignore
     * @param {Object} source
     * @param {Object} [source.url]
     * @param {Object} [source.tiles]
     * @param {Object} options
     * @param {String} [options.apiKey]
     * @param {String} [options.language]
     * @param {String} [options.geopolView]
     * @return {Object}
     */
    function parseSourceUrls(source, options) {
        if (!Utils.isObject(source)) {
            return source;
        }
        if (source.hasOwnProperty('url') && Utils.isString(source.url)) {
            source.url = parseSourceUrl(source.url, options);
        }
        if (source.hasOwnProperty('tiles') && Utils.isArray(source.tiles)) {
            source.tiles = source.tiles.map(function (urlStr) {
                return parseSourceUrl(urlStr, options);
            });
        }
        return source;
    }

    /**
     * @ignore
     * Returns a new source's object with all the necessary changes to be compatible with the TomTom's Online Maps API.
     * @param {Object} sources
     * @param {Object} options
     * @param {String} [options.apiKey]
     * @param {String} [options.language]
     * @param {String} [options.geopolView]
     * @return {Object} New sources object
     */
    function parseSources(sources, options) {
        var sourceName,
            newSourcesObj = {};
        for (sourceName in sources) {
            if (sources.hasOwnProperty(sourceName)) {
                newSourcesObj[sourceName] = parseSourceUrls(sources[sourceName], options);
            }
        }
        return newSourcesObj;
    }

    /**
     * @ignore
     * Replace the {key} token with the real API key in the given style definition.
     *
     * @param {Object} styleDefinition Style definition object
     * @param {Object} [styleDefinition.sources]
     * @param {Object} options
     * @param {String} [options.apiKey]
     * @param {String} [options.language]
     * @param {String} [options.geopolView]
     * @param {Object} [options.resourcesUrls] Glyphs and sprite URLs to be used instead of
     *      those defined in the style definition
     * @param {String} [options.resourcesUrls.glyphs]
     * @param {String} [options.resourcesUrls.sprite]
     * @return {Object} New style definition object
     */
    function stylesParser(styleDefinition, options) {
        if (!Utils.isObject(styleDefinition)) {
            return styleDefinition;
        }

        // Parsing the style's sources
        if (Utils.isObject(styleDefinition.sources)) {
            styleDefinition.sources = parseSources(styleDefinition.sources, options);
        }

        // Replacing glyphs and sprite URLs if custom ones were passed to the L.Map constructor
        if (Utils.isObject(options.resourceUrls)) {
            if (options.resourceUrls.glyphs) {
                styleDefinition.glyphs = options.resourceUrls.glyphs;
            }
            if (options.resourceUrls.sprite) {
                styleDefinition.sprite = options.resourceUrls.sprite;
            }
        }

        return styleDefinition;
    }

    return stylesParser;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    function convertRelativePathToAbsolute(styleUrl) {
        return window.location.protocol + '//' + window.location.host + styleUrl;
    }

    function toAbsoluteUrl(url) {

        if (url.indexOf('://') === -1) {
            url = convertRelativePathToAbsolute(url);
        }

        return url;
    }
    return {
        convert: toAbsoluteUrl
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

/* Mapbox GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/mapbox/mapbox-gl-js/blob/v0.53.0/LICENSE.txt */
(function (global, factory) {
 true ? module.exports = factory() :
typeof define === 'function' && define.amd ? define(factory) :
(global = global || self, global.mapboxgl = factory());
}(this, function () { 'use strict';

/* eslint-disable */

var shared, worker, mapboxgl;
// define gets called three times: one for each chunk. we rely on the order
// they're imported to know which is which
function define(_, chunk) {
if (!shared) {
    shared = chunk;
} else if (!worker) {
    worker = chunk;
} else {
    var workerBundleString = 'var sharedChunk = {}; (' + shared + ')(sharedChunk); (' + worker + ')(sharedChunk);'

    var sharedChunk = {};
    shared(sharedChunk);
    mapboxgl = chunk(sharedChunk);
    mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: 'text/javascript' }));
}
}


define(["exports"],function(t){"use strict";function e(t,e){return t(e={exports:{}},e.exports),e.exports}var r=n;function n(t,e,r,n){this.cx=3*t,this.bx=3*(r-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(n-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=n,this.p2x=r,this.p2y=n;}n.prototype.sampleCurveX=function(t){return ((this.ax*t+this.bx)*t+this.cx)*t},n.prototype.sampleCurveY=function(t){return ((this.ay*t+this.by)*t+this.cy)*t},n.prototype.sampleCurveDerivativeX=function(t){return (3*this.ax*t+2*this.bx)*t+this.cx},n.prototype.solveCurveX=function(t,e){var r,n,i,a,o;for(void 0===e&&(e=1e-6),i=t,o=0;o<8;o++){if(a=this.sampleCurveX(i)-t,Math.abs(a)<e)return i;var s=this.sampleCurveDerivativeX(i);if(Math.abs(s)<1e-6)break;i-=a/s;}if((i=t)<(r=0))return r;if(i>(n=1))return n;for(;r<n;){if(a=this.sampleCurveX(i),Math.abs(a-t)<e)return i;t>a?r=i:n=i,i=.5*(n-r)+r;}return i},n.prototype.solve=function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))};var i=a;function a(t,e){this.x=t,this.y=e;}function o(t,e){if(Array.isArray(t)){if(!Array.isArray(e)||t.length!==e.length)return !1;for(var r=0;r<t.length;r++)if(!o(t[r],e[r]))return !1;return !0}if("object"==typeof t&&null!==t&&null!==e){if("object"!=typeof e)return !1;if(Object.keys(t).length!==Object.keys(e).length)return !1;for(var n in t)if(!o(t[n],e[n]))return !1;return !0}return t===e}function s(t,e,n,i){var a=new r(t,e,n,i);return function(t){return a.solve(t)}}a.prototype={clone:function(){return new a(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,r=t.y-this.y;return e*e+r*r},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[0]*this.x+t[1]*this.y,r=t[2]*this.x+t[3]*this.y;return this.x=e,this.y=r,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),r=Math.sin(t),n=e*this.x-r*this.y,i=r*this.x+e*this.y;return this.x=n,this.y=i,this},_rotateAround:function(t,e){var r=Math.cos(t),n=Math.sin(t),i=e.x+r*(this.x-e.x)-n*(this.y-e.y),a=e.y+n*(this.x-e.x)+r*(this.y-e.y);return this.x=i,this.y=a,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},a.convert=function(t){return t instanceof a?t:Array.isArray(t)?new a(t[0],t[1]):t};var u=s(.25,.1,.25,1);function l(t,e,r){return Math.min(r,Math.max(e,t))}function p(t,e,r){var n=r-e,i=((t-e)%n+n)%n+e;return i===e?r:i}function c(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}var h=1;function f(){return h++}function y(){return function t(e){return e?(e^16*Math.random()>>e/4).toString(16):([1e7]+-[1e3]+-4e3+-8e3+-1e11).replace(/[018]/g,t)}()}function d(t){return !!t&&/^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)}function m(t,e){t.forEach(function(t){e[t]&&(e[t]=e[t].bind(e));});}function v(t,e){return -1!==t.indexOf(e,t.length-e.length)}function g(t,e,r){var n={};for(var i in t)n[i]=e.call(r||this,t[i],i,t);return n}function x(t,e,r){var n={};for(var i in t)e.call(r||this,t[i],i,t)&&(n[i]=t[i]);return n}function b(t){return Array.isArray(t)?t.map(b):"object"==typeof t&&t?g(t,b):t}var _={};function w(t){_[t]||("undefined"!=typeof console&&console.warn(t),_[t]=!0);}function A(t,e,r){return (r.y-t.y)*(e.x-t.x)>(e.y-t.y)*(r.x-t.x)}function S(t){for(var e=0,r=0,n=t.length,i=n-1,a=void 0,o=void 0;r<n;i=r++)a=t[r],e+=((o=t[i]).x-a.x)*(a.y+o.y);return e}function k(t){try{var e=self[t];return e.setItem("_mapbox_test_",1),e.removeItem("_mapbox_test_"),!0}catch(t){return !1}}var z,I,B=self.performance&&self.performance.now?self.performance.now.bind(self.performance):Date.now.bind(Date),E=self.requestAnimationFrame||self.mozRequestAnimationFrame||self.webkitRequestAnimationFrame||self.msRequestAnimationFrame,P=self.cancelAnimationFrame||self.mozCancelAnimationFrame||self.webkitCancelAnimationFrame||self.msCancelAnimationFrame,V={now:B,frame:function(t){var e=E(t);return {cancel:function(){return P(e)}}},getImageData:function(t){var e=self.document.createElement("canvas"),r=e.getContext("2d");if(!r)throw new Error("failed to create canvas 2d context");return e.width=t.width,e.height=t.height,r.drawImage(t,0,0,t.width,t.height),r.getImageData(0,0,t.width,t.height)},resolveURL:function(t){var e=self.document.createElement("a");return e.href=t,e.href},hardwareConcurrency:self.navigator.hardwareConcurrency||4,get devicePixelRatio(){return self.devicePixelRatio}},C={API_URL:"https://api.mapbox.com",get EVENTS_URL(){return 0===this.API_URL.indexOf("https://api.mapbox.cn")?"https://events.mapbox.cn/events/v2":"https://events.mapbox.com/events/v2"},FEEDBACK_URL:"https://apps.mapbox.com/feedback",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null,MAX_PARALLEL_IMAGE_REQUESTS:16},M={supported:!1,testSupport:function(t){if(T||!I)return;F?L(t):z=t;}},T=!1,F=!1;function L(t){var e=t.createTexture();t.bindTexture(t.TEXTURE_2D,e);try{if(t.texImage2D(t.TEXTURE_2D,0,t.RGBA,t.RGBA,t.UNSIGNED_BYTE,I),t.isContextLost())return;M.supported=!0;}catch(t){}t.deleteTexture(e),T=!0;}self.document&&((I=self.document.createElement("img")).onload=function(){z&&L(z),z=null,F=!0;},I.onerror=function(){T=!0,z=null;},I.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");var O="See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes";function D(t,e){var r=X(C.API_URL);if(t.protocol=r.protocol,t.authority=r.authority,"/"!==r.path&&(t.path=""+r.path+t.path),!C.REQUIRE_ACCESS_TOKEN)return Z(t);if(!(e=e||C.ACCESS_TOKEN))throw new Error("An API access token is required to use Mapbox GL. "+O);if("s"===e[0])throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). "+O);return t.params.push("access_token="+e),Z(t)}function U(t){return 0===t.indexOf("mapbox:")}var j=/^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;function q(t){return j.test(t)}var R=/(\.(png|jpg)\d*)(?=$)/,N=/\.[\w]+$/,K=function(t){var e=X(t);if(!e.path.match(/(^\/v4\/)/)||!e.path.match(N))return t;var r="mapbox://tiles/";r+=e.path.replace("/v4/","");var n=e.params.filter(function(t){return !t.match(/^access_token=/)});return n.length&&(r+="?"+n.join("&")),r},G=/^(\w+):\/\/([^\/?]*)(\/[^?]+)?\??(.+)?/;function X(t){var e=t.match(G);if(!e)throw new Error("Unable to parse URL object");return {protocol:e[1],authority:e[2],path:e[3]||"/",params:e[4]?e[4].split("&"):[]}}function Z(t){var e=t.params.length?"?"+t.params.join("&"):"";return t.protocol+"://"+t.authority+t.path+e}function H(t){if(!t)return null;var e,r=t.split(".");if(!r||3!==r.length)return null;try{return JSON.parse((e=r[1],decodeURIComponent(self.atob(e).split("").map(function(t){return "%"+("00"+t.charCodeAt(0).toString(16)).slice(-2)}).join(""))))}catch(t){return null}}var Y=function(t){this.type=t,this.anonId=null,this.eventData={},this.queue=[],this.pendingRequest=null;};Y.prototype.getStorageKey=function(t){var e,r=H(C.ACCESS_TOKEN),n="";return r&&r.u?(e=r.u,n=self.btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g,function(t,e){return String.fromCharCode(Number("0x"+e))}))):n=C.ACCESS_TOKEN||"",t?"mapbox.eventData."+t+":"+n:"mapbox.eventData:"+n},Y.prototype.fetchEventData=function(){var t=k("localStorage"),e=this.getStorageKey(),r=this.getStorageKey("uuid");if(t)try{var n=self.localStorage.getItem(e);n&&(this.eventData=JSON.parse(n));var i=self.localStorage.getItem(r);i&&(this.anonId=i);}catch(t){w("Unable to read from LocalStorage");}},Y.prototype.saveEventData=function(){var t=k("localStorage"),e=this.getStorageKey(),r=this.getStorageKey("uuid");if(t)try{self.localStorage.setItem(r,this.anonId),Object.keys(this.eventData).length>=1&&self.localStorage.setItem(e,JSON.stringify(this.eventData));}catch(t){w("Unable to write to LocalStorage");}},Y.prototype.processRequests=function(){},Y.prototype.postEvent=function(t,e,r){var n=this,i=X(C.EVENTS_URL);i.params.push("access_token="+(C.ACCESS_TOKEN||""));var a={event:this.type,created:new Date(t).toISOString(),sdkIdentifier:"mapbox-gl-js",sdkVersion:"0.53.0",userId:this.anonId},o=e?c(a,e):a,s={url:Z(i),headers:{"Content-Type":"text/plain"},body:JSON.stringify([o])};this.pendingRequest=st(s,function(t){n.pendingRequest=null,r(t),n.saveEventData(),n.processRequests();});},Y.prototype.queueRequest=function(t){this.queue.push(t),this.processRequests();};var J=function(t){function e(){t.call(this,"map.load"),this.success={};}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.postMapLoadEvent=function(t,e){C.ACCESS_TOKEN&&Array.isArray(t)&&t.some(function(t){return U(t)||q(t)})&&this.queueRequest({id:e,timestamp:Date.now()});},e.prototype.processRequests=function(){var t=this;if(!this.pendingRequest&&0!==this.queue.length){var e=this.queue.shift(),r=e.id,n=e.timestamp;r&&this.success[r]||(this.anonId||this.fetchEventData(),d(this.anonId)||(this.anonId=y()),this.postEvent(n,{},function(e){e||r&&(t.success[r]=!0);}));}},e}(Y),$=new(function(t){function e(){t.call(this,"appUserTurnstile");}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.postTurnstileEvent=function(t){C.ACCESS_TOKEN&&Array.isArray(t)&&t.some(function(t){return U(t)||q(t)})&&this.queueRequest(Date.now());},e.prototype.processRequests=function(){var t=this;if(!this.pendingRequest&&0!==this.queue.length){this.anonId&&this.eventData.lastSuccess&&this.eventData.tokenU||this.fetchEventData();var e=H(C.ACCESS_TOKEN),r=e?e.u:C.ACCESS_TOKEN,n=r!==this.eventData.tokenU;d(this.anonId)||(this.anonId=y(),n=!0);var i=this.queue.shift();if(this.eventData.lastSuccess){var a=new Date(this.eventData.lastSuccess),o=new Date(i),s=(i-this.eventData.lastSuccess)/864e5;n=n||s>=1||s<-1||a.getDate()!==o.getDate();}else n=!0;if(!n)return this.processRequests();this.postEvent(i,{"enabled.telemetry":!1},function(e){e||(t.eventData.lastSuccess=i,t.eventData.tokenU=r);});}},e}(Y)),W=$.postTurnstileEvent.bind($),Q=new J,tt=Q.postMapLoadEvent.bind(Q),et={Unknown:"Unknown",Style:"Style",Source:"Source",Tile:"Tile",Glyphs:"Glyphs",SpriteImage:"SpriteImage",SpriteJSON:"SpriteJSON",Image:"Image"};"function"==typeof Object.freeze&&Object.freeze(et);var rt=function(t){function e(e,r,n){401===r&&q(n)&&(e+=": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"),t.call(this,e),this.status=r,this.url=n,this.name=this.constructor.name,this.message=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.toString=function(){return this.name+": "+this.message+" ("+this.status+"): "+this.url},e}(Error);function nt(){return "undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope}var it=nt()?function(){return self.worker&&self.worker.referrer}:function(){var t=self.location.origin;if(t&&"null"!==t&&"file://"!==t)return t+self.location.pathname};var at=function(t,e){if(!/^file:/.test(t.url)){if(self.fetch&&self.Request&&self.AbortController)return function(t,e){var r=new self.AbortController,n=new self.Request(t.url,{method:t.method||"GET",body:t.body,credentials:t.credentials,headers:t.headers,referrer:it(),signal:r.signal});return "json"===t.type&&n.headers.set("Accept","application/json"),self.fetch(n).then(function(r){r.ok?r[t.type||"text"]().then(function(t){e(null,t,r.headers.get("Cache-Control"),r.headers.get("Expires"));}).catch(function(t){return e(new Error(t.message))}):e(new rt(r.statusText,r.status,t.url));}).catch(function(t){20!==t.code&&e(new Error(t.message));}),{cancel:function(){return r.abort()}}}(t,e);if(nt()&&self.worker&&self.worker.actor)return self.worker.actor.send("getResource",t,e)}return function(t,e){var r=new self.XMLHttpRequest;for(var n in r.open(t.method||"GET",t.url,!0),"arrayBuffer"===t.type&&(r.responseType="arraybuffer"),t.headers)r.setRequestHeader(n,t.headers[n]);return "json"===t.type&&r.setRequestHeader("Accept","application/json"),r.withCredentials="include"===t.credentials,r.onerror=function(){e(new Error(r.statusText));},r.onload=function(){if((r.status>=200&&r.status<300||0===r.status)&&null!==r.response){var n=r.response;if("json"===t.type)try{n=JSON.parse(r.response);}catch(t){return e(t)}e(null,n,r.getResponseHeader("Cache-Control"),r.getResponseHeader("Expires"));}else e(new rt(r.statusText,r.status,t.url));},r.send(t.body),{cancel:function(){return r.abort()}}}(t,e)},ot=function(t,e){return at(c(t,{type:"arrayBuffer"}),e)},st=function(t,e){return at(c(t,{method:"POST"}),e)};var ut,lt;ut=[],lt=0;var pt=function(t,e){if(lt>=C.MAX_PARALLEL_IMAGE_REQUESTS){var r={requestParameters:t,callback:e,cancelled:!1,cancel:function(){this.cancelled=!0;}};return ut.push(r),r}lt++;var n=!1,i=function(){if(!n)for(n=!0,lt--;ut.length&&lt<C.MAX_PARALLEL_IMAGE_REQUESTS;){var t=ut.shift(),e=t.requestParameters,r=t.callback;t.cancelled||(t.cancel=pt(e,r).cancel);}},a=ot(t,function(t,r,n,a){if(i(),t)e(t);else if(r){var o=new self.Image,s=self.URL||self.webkitURL;o.onload=function(){e(null,o),s.revokeObjectURL(o.src);},o.onerror=function(){return e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."))};var u=new self.Blob([new Uint8Array(r)],{type:"image/png"});o.cacheControl=n,o.expires=a,o.src=r.byteLength?s.createObjectURL(u):"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";}});return {cancel:function(){a.cancel(),i();}}};function ct(t,e,r){r[t]&&-1!==r[t].indexOf(e)||(r[t]=r[t]||[],r[t].push(e));}function ht(t,e,r){if(r&&r[t]){var n=r[t].indexOf(e);-1!==n&&r[t].splice(n,1);}}var ft=function(t,e){void 0===e&&(e={}),c(this,e),this.type=t;},yt=function(t){function e(e,r){void 0===r&&(r={}),t.call(this,"error",c({error:e},r));}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(ft),dt=function(){};dt.prototype.on=function(t,e){return this._listeners=this._listeners||{},ct(t,e,this._listeners),this},dt.prototype.off=function(t,e){return ht(t,e,this._listeners),ht(t,e,this._oneTimeListeners),this},dt.prototype.once=function(t,e){return this._oneTimeListeners=this._oneTimeListeners||{},ct(t,e,this._oneTimeListeners),this},dt.prototype.fire=function(t,e){"string"==typeof t&&(t=new ft(t,e||{}));var r=t.type;if(this.listens(r)){t.target=this;for(var n=0,i=this._listeners&&this._listeners[r]?this._listeners[r].slice():[];n<i.length;n+=1){i[n].call(this,t);}for(var a=0,o=this._oneTimeListeners&&this._oneTimeListeners[r]?this._oneTimeListeners[r].slice():[];a<o.length;a+=1){var s=o[a];ht(r,s,this._oneTimeListeners),s.call(this,t);}var u=this._eventedParent;u&&(c(t,"function"==typeof this._eventedParentData?this._eventedParentData():this._eventedParentData),u.fire(t));}else t instanceof yt&&console.error(t.error);return this},dt.prototype.listens=function(t){return this._listeners&&this._listeners[t]&&this._listeners[t].length>0||this._oneTimeListeners&&this._oneTimeListeners[t]&&this._oneTimeListeners[t].length>0||this._eventedParent&&this._eventedParent.listens(t)},dt.prototype.setEventedParent=function(t,e){return this._eventedParent=t,this._eventedParentData=e,this};var mt={$version:8,$root:{version:{required:!0,type:"enum",values:[8]},name:{type:"string"},metadata:{type:"*"},center:{type:"array",value:"number"},zoom:{type:"number"},bearing:{type:"number",default:0,period:360,units:"degrees"},pitch:{type:"number",default:0,units:"degrees"},light:{type:"light"},sources:{required:!0,type:"sources"},sprite:{type:"string"},glyphs:{type:"string"},transition:{type:"transition"},layers:{required:!0,type:"array",value:"layer"}},sources:{"*":{type:"source"}},source:["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],source_vector:{type:{required:!0,type:"enum",values:{vector:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},attribution:{type:"string"},"*":{type:"*"}},source_raster:{type:{required:!0,type:"enum",values:{raster:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},attribution:{type:"string"},"*":{type:"*"}},source_raster_dem:{type:{required:!0,type:"enum",values:{"raster-dem":{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},attribution:{type:"string"},encoding:{type:"enum",values:{terrarium:{},mapbox:{}},default:"mapbox"},"*":{type:"*"}},source_geojson:{type:{required:!0,type:"enum",values:{geojson:{}}},data:{type:"*"},maxzoom:{type:"number",default:18},attribution:{type:"string"},buffer:{type:"number",default:128,maximum:512,minimum:0},tolerance:{type:"number",default:.375},cluster:{type:"boolean",default:!1},clusterRadius:{type:"number",default:50,minimum:0},clusterMaxZoom:{type:"number"},clusterProperties:{type:"*"},lineMetrics:{type:"boolean",default:!1},generateId:{type:"boolean",default:!1}},source_video:{type:{required:!0,type:"enum",values:{video:{}}},urls:{required:!0,type:"array",value:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},source_image:{type:{required:!0,type:"enum",values:{image:{}}},url:{required:!0,type:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},layer:{id:{type:"string",required:!0},type:{type:"enum",values:{fill:{},line:{},symbol:{},circle:{},heatmap:{},"fill-extrusion":{},raster:{},hillshade:{},background:{}},required:!0},metadata:{type:"*"},source:{type:"string"},"source-layer":{type:"string"},minzoom:{type:"number",minimum:0,maximum:24},maxzoom:{type:"number",minimum:0,maximum:24},filter:{type:"filter"},layout:{type:"layout"},paint:{type:"paint"}},layout:["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background"],layout_background:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_fill:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_circle:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_heatmap:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},"layout_fill-extrusion":{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_line:{"line-cap":{type:"enum",values:{butt:{},round:{},square:{}},default:"butt",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-join":{type:"enum",values:{bevel:{},round:{},miter:{}},default:"miter",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{type:"number",default:2,requires:[{"line-join":"miter"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-round-limit":{type:"number",default:1.05,requires:[{"line-join":"round"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_symbol:{"symbol-placement":{type:"enum",values:{point:{},line:{},"line-center":{}},default:"point",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-spacing":{type:"number",default:250,minimum:1,units:"pixels",requires:[{"symbol-placement":"line"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{type:"boolean",default:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{type:"enum",values:{auto:{},"viewport-y":{},source:{}},default:"auto",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-optional":{type:"boolean",default:!1,requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-size":{type:"number",default:1,minimum:0,units:"factor of the original icon size",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{type:"enum",values:{none:{},width:{},height:{},both:{}},default:"none",requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{type:"array",value:"number",length:4,default:[0,0,0,0],units:"pixels",requires:["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-image":{type:"string",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{type:"boolean",default:!1,requires:["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-offset":{type:"array",value:"number",length:2,default:[0,0],requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-field":{type:"formatted",default:"",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-font":{type:"array",value:"string",default:["Open Sans Regular","Arial Unicode MS Regular"],requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-size":{type:"number",default:16,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{type:"number",default:10,minimum:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{type:"number",default:1.2,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-letter-spacing":{type:"number",default:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-justify":{type:"enum",values:{left:{},center:{},right:{}},default:"center",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{type:"number",default:45,units:"degrees",requires:["text-field",{"symbol-placement":["line","line-center"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-keep-upright":{type:"boolean",default:!0,requires:["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-transform":{type:"enum",values:{none:{},uppercase:{},lowercase:{}},default:"none",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-offset":{type:"array",value:"number",units:"ems",length:2,default:[0,0],requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-optional":{type:"boolean",default:!1,requires:["text-field","icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_raster:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_hillshade:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},filter:{type:"array",value:"*"},filter_operator:{type:"enum",values:{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},in:{},"!in":{},all:{},any:{},none:{},has:{},"!has":{}}},geometry_type:{type:"enum",values:{Point:{},LineString:{},Polygon:{}}},function:{expression:{type:"expression"},stops:{type:"array",value:"function_stop"},base:{type:"number",default:1,minimum:0},property:{type:"string",default:"$zoom"},type:{type:"enum",values:{identity:{},exponential:{},interval:{},categorical:{}},default:"exponential"},colorSpace:{type:"enum",values:{rgb:{},lab:{},hcl:{}},default:"rgb"},default:{type:"*",required:!1}},function_stop:{type:"array",minimum:0,maximum:22,value:["number","color"],length:2},expression:{type:"array",value:"*",minimum:1},expression_name:{type:"enum",values:{let:{group:"Variable binding"},var:{group:"Variable binding"},literal:{group:"Types"},array:{group:"Types"},at:{group:"Lookup"},case:{group:"Decision"},match:{group:"Decision"},coalesce:{group:"Decision"},step:{group:"Ramps, scales, curves"},interpolate:{group:"Ramps, scales, curves"},"interpolate-hcl":{group:"Ramps, scales, curves"},"interpolate-lab":{group:"Ramps, scales, curves"},ln2:{group:"Math"},pi:{group:"Math"},e:{group:"Math"},typeof:{group:"Types"},string:{group:"Types"},number:{group:"Types"},boolean:{group:"Types"},object:{group:"Types"},collator:{group:"Types"},format:{group:"Types"},"number-format":{group:"Types"},"to-string":{group:"Types"},"to-number":{group:"Types"},"to-boolean":{group:"Types"},"to-rgba":{group:"Color"},"to-color":{group:"Types"},rgb:{group:"Color"},rgba:{group:"Color"},get:{group:"Lookup"},has:{group:"Lookup"},length:{group:"Lookup"},properties:{group:"Feature data"},"feature-state":{group:"Feature data"},"geometry-type":{group:"Feature data"},id:{group:"Feature data"},zoom:{group:"Zoom"},"heatmap-density":{group:"Heatmap"},"line-progress":{group:"Feature data"},accumulated:{group:"Feature data"},"+":{group:"Math"},"*":{group:"Math"},"-":{group:"Math"},"/":{group:"Math"},"%":{group:"Math"},"^":{group:"Math"},sqrt:{group:"Math"},log10:{group:"Math"},ln:{group:"Math"},log2:{group:"Math"},sin:{group:"Math"},cos:{group:"Math"},tan:{group:"Math"},asin:{group:"Math"},acos:{group:"Math"},atan:{group:"Math"},min:{group:"Math"},max:{group:"Math"},round:{group:"Math"},abs:{group:"Math"},ceil:{group:"Math"},floor:{group:"Math"},"==":{group:"Decision"},"!=":{group:"Decision"},">":{group:"Decision"},"<":{group:"Decision"},">=":{group:"Decision"},"<=":{group:"Decision"},all:{group:"Decision"},any:{group:"Decision"},"!":{group:"Decision"},"is-supported-script":{group:"String"},upcase:{group:"String"},downcase:{group:"String"},concat:{group:"String"},"resolved-locale":{group:"String"}}},light:{anchor:{type:"enum",default:"viewport",values:{map:{},viewport:{}},"property-type":"data-constant",transition:!1,expression:{interpolated:!1,parameters:["zoom"]}},position:{type:"array",default:[1.15,210,30],length:3,value:"number","property-type":"data-constant",transition:!0,expression:{interpolated:!0,parameters:["zoom"]}},color:{type:"color","property-type":"data-constant",default:"#ffffff",expression:{interpolated:!0,parameters:["zoom"]},transition:!0},intensity:{type:"number","property-type":"data-constant",default:.5,minimum:0,maximum:1,expression:{interpolated:!0,parameters:["zoom"]},transition:!0}},paint:["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background"],paint_fill:{"fill-antialias":{type:"boolean",default:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{type:"color",transition:!0,requires:[{"!":"fill-pattern"},{"fill-antialias":!0}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-extrusion-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-extrusion-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"fill-extrusion-height":{type:"number",default:0,minimum:0,units:"meters",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{type:"number",default:0,minimum:0,units:"meters",transition:!0,requires:["fill-extrusion-height"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{type:"boolean",default:!0,transition:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_line:{"line-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"line-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["line-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-width":{type:"number",default:1,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{type:"number",default:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{type:"array",value:"number",minimum:0,transition:!0,units:"line widths",requires:[{"!":"line-pattern"}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"line-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-gradient":{type:"color",transition:!1,requires:[{"!":"line-dasharray"},{"!":"line-pattern"},{source:"geojson",has:{lineMetrics:!0}}],expression:{interpolated:!0,parameters:["line-progress"]},"property-type":"color-ramp"}},paint_circle:{"circle-radius":{type:"number",default:5,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{type:"number",default:0,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["circle-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{type:"enum",values:{map:{},viewport:{}},default:"map",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"}},paint_heatmap:{"heatmap-radius":{type:"number",default:30,minimum:1,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{type:"number",default:1,minimum:0,transition:!1,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{type:"number",default:1,minimum:0,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"heatmap-color":{type:"color",default:["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",.1,"royalblue",.3,"cyan",.5,"lime",.7,"yellow",1,"red"],transition:!1,expression:{interpolated:!0,parameters:["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_symbol:{"icon-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{type:"color",default:"#000000",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["icon-image","icon-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{type:"color",default:"#000000",transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["text-field","text-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_raster:{"raster-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{type:"number",default:0,period:360,transition:!0,units:"degrees",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{type:"number",default:0,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-saturation":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-contrast":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-resampling":{type:"enum",values:{linear:{},nearest:{}},default:"linear",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{type:"number",default:300,minimum:0,transition:!1,units:"milliseconds",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_hillshade:{"hillshade-illumination-direction":{type:"number",default:335,minimum:0,maximum:359,transition:!1,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{type:"number",default:.5,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{type:"color",default:"#FFFFFF",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_background:{"background-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"background-pattern"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"background-pattern":{type:"string",transition:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"background-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},transition:{duration:{type:"number",default:300,minimum:0,units:"milliseconds"},delay:{type:"number",default:0,minimum:0,units:"milliseconds"}},"property-type":{"data-driven":{type:"property-type"},"cross-faded":{type:"property-type"},"cross-faded-data-driven":{type:"property-type"},"color-ramp":{type:"property-type"},"data-constant":{type:"property-type"},constant:{type:"property-type"}}},vt=function(t,e,r,n){this.message=(t?t+": ":"")+r,n&&(this.identifier=n),null!=e&&e.__line__&&(this.line=e.__line__);};function gt(t){var e=t.key,r=t.value;return r?[new vt(e,r,"constants have been deprecated as of v8")]:[]}function xt(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}function bt(t){return t instanceof Number||t instanceof String||t instanceof Boolean?t.valueOf():t}function _t(t){return Array.isArray(t)?t.map(_t):bt(t)}var wt=function(t){function e(e,r){t.call(this,r),this.message=r,this.key=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Error),At=function(t,e){void 0===e&&(e=[]),this.parent=t,this.bindings={};for(var r=0,n=e;r<n.length;r+=1){var i=n[r],a=i[0],o=i[1];this.bindings[a]=o;}};At.prototype.concat=function(t){return new At(this,t)},At.prototype.get=function(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(t+" not found in scope.")},At.prototype.has=function(t){return !!this.bindings[t]||!!this.parent&&this.parent.has(t)};var St={kind:"null"},kt={kind:"number"},zt={kind:"string"},It={kind:"boolean"},Bt={kind:"color"},Et={kind:"object"},Pt={kind:"value"},Vt={kind:"collator"},Ct={kind:"formatted"};function Mt(t,e){return {kind:"array",itemType:t,N:e}}function Tt(t){if("array"===t.kind){var e=Tt(t.itemType);return "number"==typeof t.N?"array<"+e+", "+t.N+">":"value"===t.itemType.kind?"array":"array<"+e+">"}return t.kind}var Ft=[St,kt,zt,It,Bt,Ct,Et,Mt(Pt)];function Lt(t,e){if("error"===e.kind)return null;if("array"===t.kind){if("array"===e.kind&&(0===e.N&&"value"===e.itemType.kind||!Lt(t.itemType,e.itemType))&&("number"!=typeof t.N||t.N===e.N))return null}else{if(t.kind===e.kind)return null;if("value"===t.kind)for(var r=0,n=Ft;r<n.length;r+=1){if(!Lt(n[r],e))return null}}return "Expected "+Tt(t)+" but found "+Tt(e)+" instead."}var Ot=e(function(t,e){var r={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};function n(t){return (t=Math.round(t))<0?0:t>255?255:t}function i(t){return t<0?0:t>1?1:t}function a(t){return "%"===t[t.length-1]?n(parseFloat(t)/100*255):n(parseInt(t))}function o(t){return "%"===t[t.length-1]?i(parseFloat(t)/100):i(parseFloat(t))}function s(t,e,r){return r<0?r+=1:r>1&&(r-=1),6*r<1?t+(e-t)*r*6:2*r<1?e:3*r<2?t+(e-t)*(2/3-r)*6:t}try{e.parseCSSColor=function(t){var e,i=t.replace(/ /g,"").toLowerCase();if(i in r)return r[i].slice();if("#"===i[0])return 4===i.length?(e=parseInt(i.substr(1),16))>=0&&e<=4095?[(3840&e)>>4|(3840&e)>>8,240&e|(240&e)>>4,15&e|(15&e)<<4,1]:null:7===i.length&&(e=parseInt(i.substr(1),16))>=0&&e<=16777215?[(16711680&e)>>16,(65280&e)>>8,255&e,1]:null;var u=i.indexOf("("),l=i.indexOf(")");if(-1!==u&&l+1===i.length){var p=i.substr(0,u),c=i.substr(u+1,l-(u+1)).split(","),h=1;switch(p){case"rgba":if(4!==c.length)return null;h=o(c.pop());case"rgb":return 3!==c.length?null:[a(c[0]),a(c[1]),a(c[2]),h];case"hsla":if(4!==c.length)return null;h=o(c.pop());case"hsl":if(3!==c.length)return null;var f=(parseFloat(c[0])%360+360)%360/360,y=o(c[1]),d=o(c[2]),m=d<=.5?d*(y+1):d+y-d*y,v=2*d-m;return [n(255*s(v,m,f+1/3)),n(255*s(v,m,f)),n(255*s(v,m,f-1/3)),h];default:return null}}return null};}catch(t){}}).parseCSSColor,Dt=function(t,e,r,n){void 0===n&&(n=1),this.r=t,this.g=e,this.b=r,this.a=n;};Dt.parse=function(t){if(t){if(t instanceof Dt)return t;if("string"==typeof t){var e=Ot(t);if(e)return new Dt(e[0]/255*e[3],e[1]/255*e[3],e[2]/255*e[3],e[3])}}},Dt.prototype.toString=function(){var t=this.toArray(),e=t[0],r=t[1],n=t[2],i=t[3];return "rgba("+Math.round(e)+","+Math.round(r)+","+Math.round(n)+","+i+")"},Dt.prototype.toArray=function(){var t=this.r,e=this.g,r=this.b,n=this.a;return 0===n?[0,0,0,0]:[255*t/n,255*e/n,255*r/n,n]},Dt.black=new Dt(0,0,0,1),Dt.white=new Dt(1,1,1,1),Dt.transparent=new Dt(0,0,0,0),Dt.red=new Dt(1,0,0,1);var Ut=function(t,e,r){this.sensitivity=t?e?"variant":"case":e?"accent":"base",this.locale=r,this.collator=new Intl.Collator(this.locale?this.locale:[],{sensitivity:this.sensitivity,usage:"search"});};Ut.prototype.compare=function(t,e){return this.collator.compare(t,e)},Ut.prototype.resolvedLocale=function(){return new Intl.Collator(this.locale?this.locale:[]).resolvedOptions().locale};var jt=function(t,e,r){this.text=t,this.scale=e,this.fontStack=r;},qt=function(t){this.sections=t;};function Rt(t,e,r,n){return "number"==typeof t&&t>=0&&t<=255&&"number"==typeof e&&e>=0&&e<=255&&"number"==typeof r&&r>=0&&r<=255?void 0===n||"number"==typeof n&&n>=0&&n<=1?null:"Invalid rgba value ["+[t,e,r,n].join(", ")+"]: 'a' must be between 0 and 1.":"Invalid rgba value ["+("number"==typeof n?[t,e,r,n]:[t,e,r]).join(", ")+"]: 'r', 'g', and 'b' must be between 0 and 255."}function Nt(t){if(null===t)return St;if("string"==typeof t)return zt;if("boolean"==typeof t)return It;if("number"==typeof t)return kt;if(t instanceof Dt)return Bt;if(t instanceof Ut)return Vt;if(t instanceof qt)return Ct;if(Array.isArray(t)){for(var e,r=t.length,n=0,i=t;n<i.length;n+=1){var a=Nt(i[n]);if(e){if(e===a)continue;e=Pt;break}e=a;}return Mt(e||Pt,r)}return Et}function Kt(t){var e=typeof t;return null===t?"":"string"===e||"number"===e||"boolean"===e?String(t):t instanceof Dt||t instanceof qt?t.toString():JSON.stringify(t)}qt.fromString=function(t){return new qt([new jt(t,null,null)])},qt.prototype.toString=function(){return this.sections.map(function(t){return t.text}).join("")},qt.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t.push(n.text);var i={};n.fontStack&&(i["text-font"]=["literal",n.fontStack.split(",")]),n.scale&&(i["font-scale"]=n.scale),t.push(i);}return t};var Gt=function(t,e){this.type=t,this.value=e;};Gt.parse=function(t,e){if(2!==t.length)return e.error("'literal' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(!function t(e){if(null===e)return !0;if("string"==typeof e)return !0;if("boolean"==typeof e)return !0;if("number"==typeof e)return !0;if(e instanceof Dt)return !0;if(e instanceof Ut)return !0;if(e instanceof qt)return !0;if(Array.isArray(e)){for(var r=0,n=e;r<n.length;r+=1)if(!t(n[r]))return !1;return !0}if("object"==typeof e){for(var i in e)if(!t(e[i]))return !1;return !0}return !1}(t[1]))return e.error("invalid value");var r=t[1],n=Nt(r),i=e.expectedType;return "array"!==n.kind||0!==n.N||!i||"array"!==i.kind||"number"==typeof i.N&&0!==i.N||(n=i),new Gt(n,r)},Gt.prototype.evaluate=function(){return this.value},Gt.prototype.eachChild=function(){},Gt.prototype.possibleOutputs=function(){return [this.value]},Gt.prototype.serialize=function(){return "array"===this.type.kind||"object"===this.type.kind?["literal",this.value]:this.value instanceof Dt?["rgba"].concat(this.value.toArray()):this.value instanceof qt?this.value.serialize():this.value};var Xt=function(t){this.name="ExpressionEvaluationError",this.message=t;};Xt.prototype.toJSON=function(){return this.message};var Zt={string:zt,number:kt,boolean:It,object:Et},Ht=function(t,e){this.type=t,this.args=e;};Ht.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r,n=1,i=t[0];if("array"===i){var a,o;if(t.length>2){var s=t[1];if("string"!=typeof s||!(s in Zt)||"object"===s)return e.error('The item type argument of "array" must be one of string, number, boolean',1);a=Zt[s],n++;}else a=Pt;if(t.length>3){if(null!==t[2]&&("number"!=typeof t[2]||t[2]<0||t[2]!==Math.floor(t[2])))return e.error('The length argument to "array" must be a positive integer literal',2);o=t[2],n++;}r=Mt(a,o);}else r=Zt[i];for(var u=[];n<t.length;n++){var l=e.parse(t[n],n,Pt);if(!l)return null;u.push(l);}return new Ht(r,u)},Ht.prototype.evaluate=function(t){for(var e=0;e<this.args.length;e++){var r=this.args[e].evaluate(t);if(!Lt(this.type,Nt(r)))return r;if(e===this.args.length-1)throw new Xt("Expected value to be of type "+Tt(this.type)+", but found "+Tt(Nt(r))+" instead.")}return null},Ht.prototype.eachChild=function(t){this.args.forEach(t);},Ht.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.args.map(function(t){return t.possibleOutputs()}))},Ht.prototype.serialize=function(){var t=this.type,e=[t.kind];if("array"===t.kind){var r=t.itemType;if("string"===r.kind||"number"===r.kind||"boolean"===r.kind){e.push(r.kind);var n=t.N;("number"==typeof n||this.args.length>1)&&e.push(n);}}return e.concat(this.args.map(function(t){return t.serialize()}))};var Yt=function(t){this.type=Ct,this.sections=t;};Yt.parse=function(t,e){if(t.length<3)return e.error("Expected at least two arguments.");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");for(var r=[],n=1;n<t.length-1;n+=2){var i=e.parse(t[n],1,Pt);if(!i)return null;var a=i.type.kind;if("string"!==a&&"value"!==a&&"null"!==a)return e.error("Formatted text type must be 'string', 'value', or 'null'.");var o=t[n+1];if("object"!=typeof o||Array.isArray(o))return e.error("Format options argument must be an object.");var s=null;if(o["font-scale"]&&!(s=e.parse(o["font-scale"],1,kt)))return null;var u=null;if(o["text-font"]&&!(u=e.parse(o["text-font"],1,Mt(zt))))return null;r.push({text:i,scale:s,font:u});}return new Yt(r)},Yt.prototype.evaluate=function(t){return new qt(this.sections.map(function(e){return new jt(Kt(e.text.evaluate(t)),e.scale?e.scale.evaluate(t):null,e.font?e.font.evaluate(t).join(","):null)}))},Yt.prototype.eachChild=function(t){for(var e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t(n.text),n.scale&&t(n.scale),n.font&&t(n.font);}},Yt.prototype.possibleOutputs=function(){return [void 0]},Yt.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t.push(n.text.serialize());var i={};n.scale&&(i["font-scale"]=n.scale.serialize()),n.font&&(i["text-font"]=n.font.serialize()),t.push(i);}return t};var Jt={"to-boolean":It,"to-color":Bt,"to-number":kt,"to-string":zt},$t=function(t,e){this.type=t,this.args=e;};$t.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r=t[0];if(("to-boolean"===r||"to-string"===r)&&2!==t.length)return e.error("Expected one argument.");for(var n=Jt[r],i=[],a=1;a<t.length;a++){var o=e.parse(t[a],a,Pt);if(!o)return null;i.push(o);}return new $t(n,i)},$t.prototype.evaluate=function(t){if("boolean"===this.type.kind)return Boolean(this.args[0].evaluate(t));if("color"===this.type.kind){for(var e,r,n=0,i=this.args;n<i.length;n+=1){if(r=null,(e=i[n].evaluate(t))instanceof Dt)return e;if("string"==typeof e){var a=t.parseColor(e);if(a)return a}else if(Array.isArray(e)&&!(r=e.length<3||e.length>4?"Invalid rbga value "+JSON.stringify(e)+": expected an array containing either three or four numeric values.":Rt(e[0],e[1],e[2],e[3])))return new Dt(e[0]/255,e[1]/255,e[2]/255,e[3])}throw new Xt(r||"Could not parse color from value '"+("string"==typeof e?e:JSON.stringify(e))+"'")}if("number"===this.type.kind){for(var o=null,s=0,u=this.args;s<u.length;s+=1){if(null===(o=u[s].evaluate(t)))return 0;var l=Number(o);if(!isNaN(l))return l}throw new Xt("Could not convert "+JSON.stringify(o)+" to number.")}return "formatted"===this.type.kind?qt.fromString(Kt(this.args[0].evaluate(t))):Kt(this.args[0].evaluate(t))},$t.prototype.eachChild=function(t){this.args.forEach(t);},$t.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.args.map(function(t){return t.possibleOutputs()}))},$t.prototype.serialize=function(){if("formatted"===this.type.kind)return new Yt([{text:this.args[0],scale:null,font:null}]).serialize();var t=["to-"+this.type.kind];return this.eachChild(function(e){t.push(e.serialize());}),t};var Wt=["Unknown","Point","LineString","Polygon"],Qt=function(){this.globals=null,this.feature=null,this.featureState=null,this._parseColorCache={};};Qt.prototype.id=function(){return this.feature&&"id"in this.feature?this.feature.id:null},Qt.prototype.geometryType=function(){return this.feature?"number"==typeof this.feature.type?Wt[this.feature.type]:this.feature.type:null},Qt.prototype.properties=function(){return this.feature&&this.feature.properties||{}},Qt.prototype.parseColor=function(t){var e=this._parseColorCache[t];return e||(e=this._parseColorCache[t]=Dt.parse(t)),e};var te=function(t,e,r,n){this.name=t,this.type=e,this._evaluate=r,this.args=n;};te.prototype.evaluate=function(t){return this._evaluate(t,this.args)},te.prototype.eachChild=function(t){this.args.forEach(t);},te.prototype.possibleOutputs=function(){return [void 0]},te.prototype.serialize=function(){return [this.name].concat(this.args.map(function(t){return t.serialize()}))},te.parse=function(t,e){var r,n=t[0],i=te.definitions[n];if(!i)return e.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0);for(var a=Array.isArray(i)?i[0]:i.type,o=Array.isArray(i)?[[i[1],i[2]]]:i.overloads,s=o.filter(function(e){var r=e[0];return !Array.isArray(r)||r.length===t.length-1}),u=null,l=0,p=s;l<p.length;l+=1){var c=p[l],h=c[0],f=c[1];u=new oe(e.registry,e.path,null,e.scope);for(var y=[],d=!1,m=1;m<t.length;m++){var v=t[m],g=Array.isArray(h)?h[m-1]:h.type,x=u.parse(v,1+y.length,g);if(!x){d=!0;break}y.push(x);}if(!d)if(Array.isArray(h)&&h.length!==y.length)u.error("Expected "+h.length+" arguments, but found "+y.length+" instead.");else{for(var b=0;b<y.length;b++){var _=Array.isArray(h)?h[b]:h.type,w=y[b];u.concat(b+1).checkSubtype(_,w.type);}if(0===u.errors.length)return new te(n,a,f,y)}}if(1===s.length)(r=e.errors).push.apply(r,u.errors);else{for(var A=(s.length?s:o).map(function(t){var e,r=t[0];return e=r,Array.isArray(e)?"("+e.map(Tt).join(", ")+")":"("+Tt(e.type)+"...)"}).join(" | "),S=[],k=1;k<t.length;k++){var z=e.parse(t[k],1+S.length);if(!z)return null;S.push(Tt(z.type));}e.error("Expected arguments of type "+A+", but found ("+S.join(", ")+") instead.");}return null},te.register=function(t,e){for(var r in te.definitions=e,e)t[r]=te;};var ee=function(t,e,r){this.type=Vt,this.locale=r,this.caseSensitive=t,this.diacriticSensitive=e;};function re(t){if(t instanceof te){if("get"===t.name&&1===t.args.length)return !1;if("feature-state"===t.name)return !1;if("has"===t.name&&1===t.args.length)return !1;if("properties"===t.name||"geometry-type"===t.name||"id"===t.name)return !1;if(/^filter-/.test(t.name))return !1}var e=!0;return t.eachChild(function(t){e&&!re(t)&&(e=!1);}),e}function ne(t){if(t instanceof te&&"feature-state"===t.name)return !1;var e=!0;return t.eachChild(function(t){e&&!ne(t)&&(e=!1);}),e}function ie(t,e){if(t instanceof te&&e.indexOf(t.name)>=0)return !1;var r=!0;return t.eachChild(function(t){r&&!ie(t,e)&&(r=!1);}),r}ee.parse=function(t,e){if(2!==t.length)return e.error("Expected one argument.");var r=t[1];if("object"!=typeof r||Array.isArray(r))return e.error("Collator options argument must be an object.");var n=e.parse(void 0!==r["case-sensitive"]&&r["case-sensitive"],1,It);if(!n)return null;var i=e.parse(void 0!==r["diacritic-sensitive"]&&r["diacritic-sensitive"],1,It);if(!i)return null;var a=null;return r.locale&&!(a=e.parse(r.locale,1,zt))?null:new ee(n,i,a)},ee.prototype.evaluate=function(t){return new Ut(this.caseSensitive.evaluate(t),this.diacriticSensitive.evaluate(t),this.locale?this.locale.evaluate(t):null)},ee.prototype.eachChild=function(t){t(this.caseSensitive),t(this.diacriticSensitive),this.locale&&t(this.locale);},ee.prototype.possibleOutputs=function(){return [void 0]},ee.prototype.serialize=function(){var t={};return t["case-sensitive"]=this.caseSensitive.serialize(),t["diacritic-sensitive"]=this.diacriticSensitive.serialize(),this.locale&&(t.locale=this.locale.serialize()),["collator",t]};var ae=function(t,e){this.type=e.type,this.name=t,this.boundExpression=e;};ae.parse=function(t,e){if(2!==t.length||"string"!=typeof t[1])return e.error("'var' expression requires exactly one string literal argument.");var r=t[1];return e.scope.has(r)?new ae(r,e.scope.get(r)):e.error('Unknown variable "'+r+'". Make sure "'+r+'" has been bound in an enclosing "let" expression before using it.',1)},ae.prototype.evaluate=function(t){return this.boundExpression.evaluate(t)},ae.prototype.eachChild=function(){},ae.prototype.possibleOutputs=function(){return [void 0]},ae.prototype.serialize=function(){return ["var",this.name]};var oe=function(t,e,r,n,i){void 0===e&&(e=[]),void 0===n&&(n=new At),void 0===i&&(i=[]),this.registry=t,this.path=e,this.key=e.map(function(t){return "["+t+"]"}).join(""),this.scope=n,this.errors=i,this.expectedType=r;};function se(t,e){for(var r,n,i=0,a=t.length-1,o=0;i<=a;){if(r=t[o=Math.floor((i+a)/2)],n=t[o+1],e===r||e>r&&e<n)return o;if(r<e)i=o+1;else{if(!(r>e))throw new Xt("Input is not a number.");a=o-1;}}return Math.max(o-1,0)}oe.prototype.parse=function(t,e,r,n,i){return void 0===i&&(i={}),e?this.concat(e,r,n)._parse(t,i):this._parse(t,i)},oe.prototype._parse=function(t,e){function r(t,e,r){return "assert"===r?new Ht(e,[t]):"coerce"===r?new $t(e,[t]):t}if(null!==t&&"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t||(t=["literal",t]),Array.isArray(t)){if(0===t.length)return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');var n=t[0];if("string"!=typeof n)return this.error("Expression name must be a string, but found "+typeof n+' instead. If you wanted a literal array, use ["literal", [...]].',0),null;var i=this.registry[n];if(i){var a=i.parse(t,this);if(!a)return null;if(this.expectedType){var o=this.expectedType,s=a.type;if("string"!==o.kind&&"number"!==o.kind&&"boolean"!==o.kind&&"object"!==o.kind&&"array"!==o.kind||"value"!==s.kind)if("color"!==o.kind&&"formatted"!==o.kind||"value"!==s.kind&&"string"!==s.kind){if(this.checkSubtype(o,s))return null}else a=r(a,o,e.typeAnnotation||"coerce");else a=r(a,o,e.typeAnnotation||"assert");}if(!(a instanceof Gt)&&function t(e){if(e instanceof ae)return t(e.boundExpression);if(e instanceof te&&"error"===e.name)return !1;if(e instanceof ee)return !1;var r=e instanceof $t||e instanceof Ht;var n=!0;e.eachChild(function(e){n=r?n&&t(e):n&&e instanceof Gt;});if(!n)return !1;return re(e)&&ie(e,["zoom","heatmap-density","line-progress","accumulated","is-supported-script"])}(a)){var u=new Qt;try{a=new Gt(a.type,a.evaluate(u));}catch(t){return this.error(t.message),null}}return a}return this.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0)}return void 0===t?this.error("'undefined' value invalid. Use null instead."):"object"==typeof t?this.error('Bare objects invalid. Use ["literal", {...}] instead.'):this.error("Expected an array, but found "+typeof t+" instead.")},oe.prototype.concat=function(t,e,r){var n="number"==typeof t?this.path.concat(t):this.path,i=r?this.scope.concat(r):this.scope;return new oe(this.registry,n,e||null,i,this.errors)},oe.prototype.error=function(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];var n=""+this.key+e.map(function(t){return "["+t+"]"}).join("");this.errors.push(new wt(n,t));},oe.prototype.checkSubtype=function(t,e){var r=Lt(t,e);return r&&this.error(r),r};var ue=function(t,e,r){this.type=t,this.input=e,this.labels=[],this.outputs=[];for(var n=0,i=r;n<i.length;n+=1){var a=i[n],o=a[0],s=a[1];this.labels.push(o),this.outputs.push(s);}};function le(t,e,r){return t*(1-r)+e*r}ue.parse=function(t,e){var r=t[1],n=t.slice(2);if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(!(r=e.parse(r,1,kt)))return null;var i=[],a=null;e.expectedType&&"value"!==e.expectedType.kind&&(a=e.expectedType),n.unshift(-1/0);for(var o=0;o<n.length;o+=2){var s=n[o],u=n[o+1],l=o+1,p=o+2;if("number"!=typeof s)return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',l);if(i.length&&i[i.length-1][0]>=s)return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',l);var c=e.parse(u,p,a);if(!c)return null;a=a||c.type,i.push([s,c]);}return new ue(a,r,i)},ue.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;return n>=e[i-1]?r[i-1].evaluate(t):r[se(e,n)].evaluate(t)},ue.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e]);}},ue.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.outputs.map(function(t){return t.possibleOutputs()}))},ue.prototype.serialize=function(){for(var t=["step",this.input.serialize()],e=0;e<this.labels.length;e++)e>0&&t.push(this.labels[e]),t.push(this.outputs[e].serialize());return t};var pe=Object.freeze({number:le,color:function(t,e,r){return new Dt(le(t.r,e.r,r),le(t.g,e.g,r),le(t.b,e.b,r),le(t.a,e.a,r))},array:function(t,e,r){return t.map(function(t,n){return le(t,e[n],r)})}}),ce=.95047,he=1,fe=1.08883,ye=4/29,de=6/29,me=3*de*de,ve=de*de*de,ge=Math.PI/180,xe=180/Math.PI;function be(t){return t>ve?Math.pow(t,1/3):t/me+ye}function _e(t){return t>de?t*t*t:me*(t-ye)}function we(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function Ae(t){return (t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function Se(t){var e=Ae(t.r),r=Ae(t.g),n=Ae(t.b),i=be((.4124564*e+.3575761*r+.1804375*n)/ce),a=be((.2126729*e+.7151522*r+.072175*n)/he);return {l:116*a-16,a:500*(i-a),b:200*(a-be((.0193339*e+.119192*r+.9503041*n)/fe)),alpha:t.a}}function ke(t){var e=(t.l+16)/116,r=isNaN(t.a)?e:e+t.a/500,n=isNaN(t.b)?e:e-t.b/200;return e=he*_e(e),r=ce*_e(r),n=fe*_e(n),new Dt(we(3.2404542*r-1.5371385*e-.4985314*n),we(-.969266*r+1.8760108*e+.041556*n),we(.0556434*r-.2040259*e+1.0572252*n),t.alpha)}function ze(t,e,r){var n=e-t;return t+r*(n>180||n<-180?n-360*Math.round(n/360):n)}var Ie={forward:Se,reverse:ke,interpolate:function(t,e,r){return {l:le(t.l,e.l,r),a:le(t.a,e.a,r),b:le(t.b,e.b,r),alpha:le(t.alpha,e.alpha,r)}}},Be={forward:function(t){var e=Se(t),r=e.l,n=e.a,i=e.b,a=Math.atan2(i,n)*xe;return {h:a<0?a+360:a,c:Math.sqrt(n*n+i*i),l:r,alpha:t.a}},reverse:function(t){var e=t.h*ge,r=t.c;return ke({l:t.l,a:Math.cos(e)*r,b:Math.sin(e)*r,alpha:t.alpha})},interpolate:function(t,e,r){return {h:ze(t.h,e.h,r),c:le(t.c,e.c,r),l:le(t.l,e.l,r),alpha:le(t.alpha,e.alpha,r)}}},Ee=Object.freeze({lab:Ie,hcl:Be}),Pe=function(t,e,r,n,i){this.type=t,this.operator=e,this.interpolation=r,this.input=n,this.labels=[],this.outputs=[];for(var a=0,o=i;a<o.length;a+=1){var s=o[a],u=s[0],l=s[1];this.labels.push(u),this.outputs.push(l);}};function Ve(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}Pe.interpolationFactor=function(t,e,n,i){var a=0;if("exponential"===t.name)a=Ve(e,t.base,n,i);else if("linear"===t.name)a=Ve(e,1,n,i);else if("cubic-bezier"===t.name){var o=t.controlPoints;a=new r(o[0],o[1],o[2],o[3]).solve(Ve(e,1,n,i));}return a},Pe.parse=function(t,e){var r=t[0],n=t[1],i=t[2],a=t.slice(3);if(!Array.isArray(n)||0===n.length)return e.error("Expected an interpolation type expression.",1);if("linear"===n[0])n={name:"linear"};else if("exponential"===n[0]){var o=n[1];if("number"!=typeof o)return e.error("Exponential interpolation requires a numeric base.",1,1);n={name:"exponential",base:o};}else{if("cubic-bezier"!==n[0])return e.error("Unknown interpolation type "+String(n[0]),1,0);var s=n.slice(1);if(4!==s.length||s.some(function(t){return "number"!=typeof t||t<0||t>1}))return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);n={name:"cubic-bezier",controlPoints:s};}if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(!(i=e.parse(i,2,kt)))return null;var u=[],l=null;"interpolate-hcl"===r||"interpolate-lab"===r?l=Bt:e.expectedType&&"value"!==e.expectedType.kind&&(l=e.expectedType);for(var p=0;p<a.length;p+=2){var c=a[p],h=a[p+1],f=p+3,y=p+4;if("number"!=typeof c)return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',f);if(u.length&&u[u.length-1][0]>=c)return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',f);var d=e.parse(h,y,l);if(!d)return null;l=l||d.type,u.push([c,d]);}return "number"===l.kind||"color"===l.kind||"array"===l.kind&&"number"===l.itemType.kind&&"number"==typeof l.N?new Pe(l,r,n,i,u):e.error("Type "+Tt(l)+" is not interpolatable.")},Pe.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;if(n>=e[i-1])return r[i-1].evaluate(t);var a=se(e,n),o=e[a],s=e[a+1],u=Pe.interpolationFactor(this.interpolation,n,o,s),l=r[a].evaluate(t),p=r[a+1].evaluate(t);return "interpolate"===this.operator?pe[this.type.kind.toLowerCase()](l,p,u):"interpolate-hcl"===this.operator?Be.reverse(Be.interpolate(Be.forward(l),Be.forward(p),u)):Ie.reverse(Ie.interpolate(Ie.forward(l),Ie.forward(p),u))},Pe.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e]);}},Pe.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.outputs.map(function(t){return t.possibleOutputs()}))},Pe.prototype.serialize=function(){var t;t="linear"===this.interpolation.name?["linear"]:"exponential"===this.interpolation.name?1===this.interpolation.base?["linear"]:["exponential",this.interpolation.base]:["cubic-bezier"].concat(this.interpolation.controlPoints);for(var e=[this.operator,t,this.input.serialize()],r=0;r<this.labels.length;r++)e.push(this.labels[r],this.outputs[r].serialize());return e};var Ce=function(t,e){this.type=t,this.args=e;};Ce.parse=function(t,e){if(t.length<2)return e.error("Expectected at least one argument.");var r=null,n=e.expectedType;n&&"value"!==n.kind&&(r=n);for(var i=[],a=0,o=t.slice(1);a<o.length;a+=1){var s=o[a],u=e.parse(s,1+i.length,r,void 0,{typeAnnotation:"omit"});if(!u)return null;r=r||u.type,i.push(u);}var l=n&&i.some(function(t){return Lt(n,t.type)});return new Ce(l?Pt:r,i)},Ce.prototype.evaluate=function(t){for(var e=null,r=0,n=this.args;r<n.length;r+=1){if(null!==(e=n[r].evaluate(t)))break}return e},Ce.prototype.eachChild=function(t){this.args.forEach(t);},Ce.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.args.map(function(t){return t.possibleOutputs()}))},Ce.prototype.serialize=function(){var t=["coalesce"];return this.eachChild(function(e){t.push(e.serialize());}),t};var Me=function(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e;};Me.prototype.evaluate=function(t){return this.result.evaluate(t)},Me.prototype.eachChild=function(t){for(var e=0,r=this.bindings;e<r.length;e+=1){t(r[e][1]);}t(this.result);},Me.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found "+(t.length-1)+" instead.");for(var r=[],n=1;n<t.length-1;n+=2){var i=t[n];if("string"!=typeof i)return e.error("Expected string, but found "+typeof i+" instead.",n);if(/[^a-zA-Z0-9_]/.test(i))return e.error("Variable names must contain only alphanumeric characters or '_'.",n);var a=e.parse(t[n+1],n+1);if(!a)return null;r.push([i,a]);}var o=e.parse(t[t.length-1],t.length-1,e.expectedType,r);return o?new Me(r,o):null},Me.prototype.possibleOutputs=function(){return this.result.possibleOutputs()},Me.prototype.serialize=function(){for(var t=["let"],e=0,r=this.bindings;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];t.push(i,a.serialize());}return t.push(this.result.serialize()),t};var Te=function(t,e,r){this.type=t,this.index=e,this.input=r;};Te.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,kt),n=e.parse(t[2],2,Mt(e.expectedType||Pt));if(!r||!n)return null;var i=n.type;return new Te(i.itemType,r,n)},Te.prototype.evaluate=function(t){var e=this.index.evaluate(t),r=this.input.evaluate(t);if(e<0)throw new Xt("Array index out of bounds: "+e+" < 0.");if(e>=r.length)throw new Xt("Array index out of bounds: "+e+" > "+(r.length-1)+".");if(e!==Math.floor(e))throw new Xt("Array index must be an integer, but found "+e+" instead.");return r[e]},Te.prototype.eachChild=function(t){t(this.index),t(this.input);},Te.prototype.possibleOutputs=function(){return [void 0]},Te.prototype.serialize=function(){return ["at",this.index.serialize(),this.input.serialize()]};var Fe=function(t,e,r,n,i,a){this.inputType=t,this.type=e,this.input=r,this.cases=n,this.outputs=i,this.otherwise=a;};Fe.parse=function(t,e){if(t.length<5)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if(t.length%2!=1)return e.error("Expected an even number of arguments.");var r,n;e.expectedType&&"value"!==e.expectedType.kind&&(n=e.expectedType);for(var i={},a=[],o=2;o<t.length-1;o+=2){var s=t[o],u=t[o+1];Array.isArray(s)||(s=[s]);var l=e.concat(o);if(0===s.length)return l.error("Expected at least one branch label.");for(var p=0,c=s;p<c.length;p+=1){var h=c[p];if("number"!=typeof h&&"string"!=typeof h)return l.error("Branch labels must be numbers or strings.");if("number"==typeof h&&Math.abs(h)>Number.MAX_SAFE_INTEGER)return l.error("Branch labels must be integers no larger than "+Number.MAX_SAFE_INTEGER+".");if("number"==typeof h&&Math.floor(h)!==h)return l.error("Numeric branch labels must be integer values.");if(r){if(l.checkSubtype(r,Nt(h)))return null}else r=Nt(h);if(void 0!==i[String(h)])return l.error("Branch labels must be unique.");i[String(h)]=a.length;}var f=e.parse(u,o,n);if(!f)return null;n=n||f.type,a.push(f);}var y=e.parse(t[1],1,Pt);if(!y)return null;var d=e.parse(t[t.length-1],t.length-1,n);return d?"value"!==y.type.kind&&e.concat(1).checkSubtype(r,y.type)?null:new Fe(r,n,y,i,a,d):null},Fe.prototype.evaluate=function(t){var e=this.input.evaluate(t);return (Nt(e)===this.inputType&&this.outputs[this.cases[e]]||this.otherwise).evaluate(t)},Fe.prototype.eachChild=function(t){t(this.input),this.outputs.forEach(t),t(this.otherwise);},Fe.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.outputs.map(function(t){return t.possibleOutputs()})).concat(this.otherwise.possibleOutputs())},Fe.prototype.serialize=function(){for(var t=this,e=["match",this.input.serialize()],r=[],n={},i=0,a=Object.keys(this.cases).sort();i<a.length;i+=1){var o=a[i];void 0===(c=n[this.cases[o]])?(n[this.cases[o]]=r.length,r.push([this.cases[o],[o]])):r[c][1].push(o);}for(var s=function(e){return "number"===t.inputType.kind?Number(e):e},u=0,l=r;u<l.length;u+=1){var p=l[u],c=p[0],h=p[1];1===h.length?e.push(s(h[0])):e.push(h.map(s)),e.push(this.outputs[outputIndex$1].serialize());}return e.push(this.otherwise.serialize()),e};var Le=function(t,e,r){this.type=t,this.branches=e,this.otherwise=r;};function Oe(t,e){return "=="===t||"!="===t?"boolean"===e.kind||"string"===e.kind||"number"===e.kind||"null"===e.kind||"value"===e.kind:"string"===e.kind||"number"===e.kind||"value"===e.kind}function De(t,e,r,n){return 0===n.compare(e,r)}function Ue(t,e,r){var n="=="!==t&&"!="!==t;return function(){function i(t,e,r){this.type=It,this.lhs=t,this.rhs=e,this.collator=r,this.hasUntypedArgument="value"===t.type.kind||"value"===e.type.kind;}return i.parse=function(t,e){if(3!==t.length&&4!==t.length)return e.error("Expected two or three arguments.");var r=t[0],a=e.parse(t[1],1,Pt);if(!a)return null;if(!Oe(r,a.type))return e.concat(1).error('"'+r+"\" comparisons are not supported for type '"+Tt(a.type)+"'.");var o=e.parse(t[2],2,Pt);if(!o)return null;if(!Oe(r,o.type))return e.concat(2).error('"'+r+"\" comparisons are not supported for type '"+Tt(o.type)+"'.");if(a.type.kind!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot compare types '"+Tt(a.type)+"' and '"+Tt(o.type)+"'.");n&&("value"===a.type.kind&&"value"!==o.type.kind?a=new Ht(o.type,[a]):"value"!==a.type.kind&&"value"===o.type.kind&&(o=new Ht(a.type,[o])));var s=null;if(4===t.length){if("string"!==a.type.kind&&"string"!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot use collator to compare non-string types.");if(!(s=e.parse(t[3],3,Vt)))return null}return new i(a,o,s)},i.prototype.evaluate=function(i){var a=this.lhs.evaluate(i),o=this.rhs.evaluate(i);if(n&&this.hasUntypedArgument){var s=Nt(a),u=Nt(o);if(s.kind!==u.kind||"string"!==s.kind&&"number"!==s.kind)throw new Xt('Expected arguments for "'+t+'" to be (string, string) or (number, number), but found ('+s.kind+", "+u.kind+") instead.")}if(this.collator&&!n&&this.hasUntypedArgument){var l=Nt(a),p=Nt(o);if("string"!==l.kind||"string"!==p.kind)return e(i,a,o)}return this.collator?r(i,a,o,this.collator.evaluate(i)):e(i,a,o)},i.prototype.eachChild=function(t){t(this.lhs),t(this.rhs),this.collator&&t(this.collator);},i.prototype.possibleOutputs=function(){return [!0,!1]},i.prototype.serialize=function(){var e=[t];return this.eachChild(function(t){e.push(t.serialize());}),e},i}()}Le.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found only "+(t.length-1)+".");if(t.length%2!=0)return e.error("Expected an odd number of arguments.");var r;e.expectedType&&"value"!==e.expectedType.kind&&(r=e.expectedType);for(var n=[],i=1;i<t.length-1;i+=2){var a=e.parse(t[i],i,It);if(!a)return null;var o=e.parse(t[i+1],i+1,r);if(!o)return null;n.push([a,o]),r=r||o.type;}var s=e.parse(t[t.length-1],t.length-1,r);return s?new Le(r,n,s):null},Le.prototype.evaluate=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];if(i.evaluate(t))return a.evaluate(t)}return this.otherwise.evaluate(t)},Le.prototype.eachChild=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];t(i),t(a);}t(this.otherwise);},Le.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.branches.map(function(t){t[0];return t[1].possibleOutputs()})).concat(this.otherwise.possibleOutputs())},Le.prototype.serialize=function(){var t=["case"];return this.eachChild(function(e){t.push(e.serialize());}),t};var je=Ue("==",function(t,e,r){return e===r},De),qe=Ue("!=",function(t,e,r){return e!==r},function(t,e,r,n){return !De(0,e,r,n)}),Re=Ue("<",function(t,e,r){return e<r},function(t,e,r,n){return n.compare(e,r)<0}),Ne=Ue(">",function(t,e,r){return e>r},function(t,e,r,n){return n.compare(e,r)>0}),Ke=Ue("<=",function(t,e,r){return e<=r},function(t,e,r,n){return n.compare(e,r)<=0}),Ge=Ue(">=",function(t,e,r){return e>=r},function(t,e,r,n){return n.compare(e,r)>=0}),Xe=function(t,e,r,n,i){this.type=zt,this.number=t,this.locale=e,this.currency=r,this.minFractionDigits=n,this.maxFractionDigits=i;};Xe.parse=function(t,e){if(3!==t.length)return e.error("Expected two arguments.");var r=e.parse(t[1],1,kt);if(!r)return null;var n=t[2];if("object"!=typeof n||Array.isArray(n))return e.error("NumberFormat options argument must be an object.");var i=null;if(n.locale&&!(i=e.parse(n.locale,1,zt)))return null;var a=null;if(n.currency&&!(a=e.parse(n.currency,1,zt)))return null;var o=null;if(n["min-fraction-digits"]&&!(o=e.parse(n["min-fraction-digits"],1,kt)))return null;var s=null;return n["max-fraction-digits"]&&!(s=e.parse(n["max-fraction-digits"],1,kt))?null:new Xe(r,i,a,o,s)},Xe.prototype.evaluate=function(t){return new Intl.NumberFormat(this.locale?this.locale.evaluate(t):[],{style:this.currency?"currency":"decimal",currency:this.currency?this.currency.evaluate(t):void 0,minimumFractionDigits:this.minFractionDigits?this.minFractionDigits.evaluate(t):void 0,maximumFractionDigits:this.maxFractionDigits?this.maxFractionDigits.evaluate(t):void 0}).format(this.number.evaluate(t))},Xe.prototype.eachChild=function(t){t(this.number),this.locale&&t(this.locale),this.currency&&t(this.currency),this.minFractionDigits&&t(this.minFractionDigits),this.maxFractionDigits&&t(this.maxFractionDigits);},Xe.prototype.possibleOutputs=function(){return [void 0]},Xe.prototype.serialize=function(){var t={};return this.locale&&(t.locale=this.locale.serialize()),this.currency&&(t.currency=this.currency.serialize()),this.minFractionDigits&&(t["min-fraction-digits"]=this.minFractionDigits.serialize()),this.maxFractionDigits&&(t["max-fraction-digits"]=this.maxFractionDigits.serialize()),["number-format",this.number.serialize(),t]};var Ze=function(t){this.type=kt,this.input=t;};Ze.parse=function(t,e){if(2!==t.length)return e.error("Expected 1 argument, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1);return r?"array"!==r.type.kind&&"string"!==r.type.kind&&"value"!==r.type.kind?e.error("Expected argument of type string or array, but found "+Tt(r.type)+" instead."):new Ze(r):null},Ze.prototype.evaluate=function(t){var e=this.input.evaluate(t);if("string"==typeof e)return e.length;if(Array.isArray(e))return e.length;throw new Xt("Expected value to be of type string or array, but found "+Tt(Nt(e))+" instead.")},Ze.prototype.eachChild=function(t){t(this.input);},Ze.prototype.possibleOutputs=function(){return [void 0]},Ze.prototype.serialize=function(){var t=["length"];return this.eachChild(function(e){t.push(e.serialize());}),t};var He={"==":je,"!=":qe,">":Ne,"<":Re,">=":Ge,"<=":Ke,array:Ht,at:Te,boolean:Ht,case:Le,coalesce:Ce,collator:ee,format:Yt,interpolate:Pe,"interpolate-hcl":Pe,"interpolate-lab":Pe,length:Ze,let:Me,literal:Gt,match:Fe,number:Ht,"number-format":Xe,object:Ht,step:ue,string:Ht,"to-boolean":$t,"to-color":$t,"to-number":$t,"to-string":$t,var:ae};function Ye(t,e){var r=e[0],n=e[1],i=e[2],a=e[3];r=r.evaluate(t),n=n.evaluate(t),i=i.evaluate(t);var o=a?a.evaluate(t):1,s=Rt(r,n,i,o);if(s)throw new Xt(s);return new Dt(r/255*o,n/255*o,i/255*o,o)}function Je(t,e){return t in e}function $e(t,e){var r=e[t];return void 0===r?null:r}function We(t){return {type:t}}function Qe(t){return {result:"success",value:t}}function tr(t){return {result:"error",value:t}}function er(t){return "data-driven"===t["property-type"]||"cross-faded-data-driven"===t["property-type"]}function rr(t){return !!t.expression&&t.expression.parameters.indexOf("zoom")>-1}function nr(t){return !!t.expression&&t.expression.interpolated}function ir(t){return t instanceof Number?"number":t instanceof String?"string":t instanceof Boolean?"boolean":Array.isArray(t)?"array":null===t?"null":typeof t}function ar(t){return "object"==typeof t&&null!==t&&!Array.isArray(t)}function or(t){return t}function sr(t,e,r){return void 0!==t?t:void 0!==e?e:void 0!==r?r:void 0}function ur(t,e,r,n,i){return sr(typeof r===i?n[r]:void 0,t.default,e.default)}function lr(t,e,r){if("number"!==ir(r))return sr(t.default,e.default);var n=t.stops.length;if(1===n)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[n-1][0])return t.stops[n-1][1];var i=hr(t.stops,r);return t.stops[i][1]}function pr(t,e,r){var n=void 0!==t.base?t.base:1;if("number"!==ir(r))return sr(t.default,e.default);var i=t.stops.length;if(1===i)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[i-1][0])return t.stops[i-1][1];var a=hr(t.stops,r),o=function(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}(r,n,t.stops[a][0],t.stops[a+1][0]),s=t.stops[a][1],u=t.stops[a+1][1],l=pe[e.type]||or;if(t.colorSpace&&"rgb"!==t.colorSpace){var p=Ee[t.colorSpace];l=function(t,e){return p.reverse(p.interpolate(p.forward(t),p.forward(e),o))};}return "function"==typeof s.evaluate?{evaluate:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];var r=s.evaluate.apply(void 0,t),n=u.evaluate.apply(void 0,t);if(void 0!==r&&void 0!==n)return l(r,n,o)}}:l(s,u,o)}function cr(t,e,r){return "color"===e.type?r=Dt.parse(r):"formatted"===e.type?r=qt.fromString(r.toString()):ir(r)===e.type||"enum"===e.type&&e.values[r]||(r=void 0),sr(r,t.default,e.default)}function hr(t,e){for(var r,n,i=0,a=t.length-1,o=0;i<=a;){if(r=t[o=Math.floor((i+a)/2)][0],n=t[o+1][0],e===r||e>r&&e<n)return o;r<e?i=o+1:r>e&&(a=o-1);}return Math.max(o-1,0)}te.register(He,{error:[{kind:"error"},[zt],function(t,e){var r=e[0];throw new Xt(r.evaluate(t))}],typeof:[zt,[Pt],function(t,e){return Tt(Nt(e[0].evaluate(t)))}],"to-rgba":[Mt(kt,4),[Bt],function(t,e){return e[0].evaluate(t).toArray()}],rgb:[Bt,[kt,kt,kt],Ye],rgba:[Bt,[kt,kt,kt,kt],Ye],has:{type:It,overloads:[[[zt],function(t,e){return Je(e[0].evaluate(t),t.properties())}],[[zt,Et],function(t,e){var r=e[0],n=e[1];return Je(r.evaluate(t),n.evaluate(t))}]]},get:{type:Pt,overloads:[[[zt],function(t,e){return $e(e[0].evaluate(t),t.properties())}],[[zt,Et],function(t,e){var r=e[0],n=e[1];return $e(r.evaluate(t),n.evaluate(t))}]]},"feature-state":[Pt,[zt],function(t,e){return $e(e[0].evaluate(t),t.featureState||{})}],properties:[Et,[],function(t){return t.properties()}],"geometry-type":[zt,[],function(t){return t.geometryType()}],id:[Pt,[],function(t){return t.id()}],zoom:[kt,[],function(t){return t.globals.zoom}],"heatmap-density":[kt,[],function(t){return t.globals.heatmapDensity||0}],"line-progress":[kt,[],function(t){return t.globals.lineProgress||0}],accumulated:[Pt,[],function(t){return void 0===t.globals.accumulated?null:t.globals.accumulated}],"+":[kt,We(kt),function(t,e){for(var r=0,n=0,i=e;n<i.length;n+=1){r+=i[n].evaluate(t);}return r}],"*":[kt,We(kt),function(t,e){for(var r=1,n=0,i=e;n<i.length;n+=1){r*=i[n].evaluate(t);}return r}],"-":{type:kt,overloads:[[[kt,kt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)-n.evaluate(t)}],[[kt],function(t,e){return -e[0].evaluate(t)}]]},"/":[kt,[kt,kt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)/n.evaluate(t)}],"%":[kt,[kt,kt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)%n.evaluate(t)}],ln2:[kt,[],function(){return Math.LN2}],pi:[kt,[],function(){return Math.PI}],e:[kt,[],function(){return Math.E}],"^":[kt,[kt,kt],function(t,e){var r=e[0],n=e[1];return Math.pow(r.evaluate(t),n.evaluate(t))}],sqrt:[kt,[kt],function(t,e){var r=e[0];return Math.sqrt(r.evaluate(t))}],log10:[kt,[kt],function(t,e){var r=e[0];return Math.log(r.evaluate(t))/Math.LN10}],ln:[kt,[kt],function(t,e){var r=e[0];return Math.log(r.evaluate(t))}],log2:[kt,[kt],function(t,e){var r=e[0];return Math.log(r.evaluate(t))/Math.LN2}],sin:[kt,[kt],function(t,e){var r=e[0];return Math.sin(r.evaluate(t))}],cos:[kt,[kt],function(t,e){var r=e[0];return Math.cos(r.evaluate(t))}],tan:[kt,[kt],function(t,e){var r=e[0];return Math.tan(r.evaluate(t))}],asin:[kt,[kt],function(t,e){var r=e[0];return Math.asin(r.evaluate(t))}],acos:[kt,[kt],function(t,e){var r=e[0];return Math.acos(r.evaluate(t))}],atan:[kt,[kt],function(t,e){var r=e[0];return Math.atan(r.evaluate(t))}],min:[kt,We(kt),function(t,e){return Math.min.apply(Math,e.map(function(e){return e.evaluate(t)}))}],max:[kt,We(kt),function(t,e){return Math.max.apply(Math,e.map(function(e){return e.evaluate(t)}))}],abs:[kt,[kt],function(t,e){var r=e[0];return Math.abs(r.evaluate(t))}],round:[kt,[kt],function(t,e){var r=e[0].evaluate(t);return r<0?-Math.round(-r):Math.round(r)}],floor:[kt,[kt],function(t,e){var r=e[0];return Math.floor(r.evaluate(t))}],ceil:[kt,[kt],function(t,e){var r=e[0];return Math.ceil(r.evaluate(t))}],"filter-==":[It,[zt,Pt],function(t,e){var r=e[0],n=e[1];return t.properties()[r.value]===n.value}],"filter-id-==":[It,[Pt],function(t,e){var r=e[0];return t.id()===r.value}],"filter-type-==":[It,[zt],function(t,e){var r=e[0];return t.geometryType()===r.value}],"filter-<":[It,[zt,Pt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<a}],"filter-id-<":[It,[Pt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<i}],"filter->":[It,[zt,Pt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>a}],"filter-id->":[It,[Pt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>i}],"filter-<=":[It,[zt,Pt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<=a}],"filter-id-<=":[It,[Pt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<=i}],"filter->=":[It,[zt,Pt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>=a}],"filter-id->=":[It,[Pt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>=i}],"filter-has":[It,[Pt],function(t,e){return e[0].value in t.properties()}],"filter-has-id":[It,[],function(t){return null!==t.id()}],"filter-type-in":[It,[Mt(zt)],function(t,e){return e[0].value.indexOf(t.geometryType())>=0}],"filter-id-in":[It,[Mt(Pt)],function(t,e){return e[0].value.indexOf(t.id())>=0}],"filter-in-small":[It,[zt,Mt(Pt)],function(t,e){var r=e[0];return e[1].value.indexOf(t.properties()[r.value])>=0}],"filter-in-large":[It,[zt,Mt(Pt)],function(t,e){var r=e[0],n=e[1];return function(t,e,r,n){for(;r<=n;){var i=r+n>>1;if(e[i]===t)return !0;e[i]>t?n=i-1:r=i+1;}return !1}(t.properties()[r.value],n.value,0,n.value.length-1)}],all:{type:It,overloads:[[[It,It],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)&&n.evaluate(t)}],[We(It),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(!n[r].evaluate(t))return !1}return !0}]]},any:{type:It,overloads:[[[It,It],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)||n.evaluate(t)}],[We(It),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(n[r].evaluate(t))return !0}return !1}]]},"!":[It,[It],function(t,e){return !e[0].evaluate(t)}],"is-supported-script":[It,[zt],function(t,e){var r=e[0],n=t.globals&&t.globals.isSupportedScript;return !n||n(r.evaluate(t))}],upcase:[zt,[zt],function(t,e){return e[0].evaluate(t).toUpperCase()}],downcase:[zt,[zt],function(t,e){return e[0].evaluate(t).toLowerCase()}],concat:[zt,We(Pt),function(t,e){return e.map(function(e){return Kt(e.evaluate(t))}).join("")}],"resolved-locale":[zt,[Vt],function(t,e){return e[0].evaluate(t).resolvedLocale()}]});var fr=function(t,e){var r;this.expression=t,this._warningHistory={},this._evaluator=new Qt,this._defaultValue=e?"color"===(r=e).type&&ar(r.default)?new Dt(0,0,0,0):"color"===r.type?Dt.parse(r.default)||null:void 0===r.default?null:r.default:null,this._enumValues=e&&"enum"===e.type?e.values:null;};function yr(t){return Array.isArray(t)&&t.length>0&&"string"==typeof t[0]&&t[0]in He}function dr(t,e){var r=new oe(He,[],e?function(t){var e={color:Bt,string:zt,number:kt,enum:zt,boolean:It,formatted:Ct};if("array"===t.type)return Mt(e[t.value]||Pt,t.length);return e[t.type]}(e):void 0),n=r.parse(t,void 0,void 0,void 0,e&&"string"===e.type?{typeAnnotation:"coerce"}:void 0);return n?Qe(new fr(n,e)):tr(r.errors)}fr.prototype.evaluateWithoutErrorHandling=function(t,e,r){return this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=r,this.expression.evaluate(this._evaluator)},fr.prototype.evaluate=function(t,e,r){this._evaluator.globals=t,this._evaluator.feature=e||null,this._evaluator.featureState=r||null;try{var n=this.expression.evaluate(this._evaluator);if(null==n)return this._defaultValue;if(this._enumValues&&!(n in this._enumValues))throw new Xt("Expected value to be one of "+Object.keys(this._enumValues).map(function(t){return JSON.stringify(t)}).join(", ")+", but found "+JSON.stringify(n)+" instead.");return n}catch(t){return this._warningHistory[t.message]||(this._warningHistory[t.message]=!0,"undefined"!=typeof console&&console.warn(t.message)),this._defaultValue}};var mr=function(t,e){this.kind=t,this._styleExpression=e,this.isStateDependent="constant"!==t&&!ne(e.expression);};mr.prototype.evaluateWithoutErrorHandling=function(t,e,r){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r)},mr.prototype.evaluate=function(t,e,r){return this._styleExpression.evaluate(t,e,r)};var vr=function(t,e,r){this.kind=t,this.zoomStops=r.labels,this._styleExpression=e,this.isStateDependent="camera"!==t&&!ne(e.expression),r instanceof Pe&&(this._interpolationType=r.interpolation);};function gr(t,e){if("error"===(t=dr(t,e)).result)return t;var r=t.value.expression,n=re(r);if(!n&&!er(e))return tr([new wt("","data expressions not supported")]);var i=ie(r,["zoom"]);if(!i&&!rr(e))return tr([new wt("","zoom expressions not supported")]);var a=function t(e){var r=null;if(e instanceof Me)r=t(e.result);else if(e instanceof Ce)for(var n=0,i=e.args;n<i.length;n+=1){var a=i[n];if(r=t(a))break}else(e instanceof ue||e instanceof Pe)&&e.input instanceof te&&"zoom"===e.input.name&&(r=e);if(r instanceof wt)return r;e.eachChild(function(e){var n=t(e);n instanceof wt?r=n:!r&&n?r=new wt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):r&&n&&r!==n&&(r=new wt("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));});return r}(r);return a||i?a instanceof wt?tr([a]):a instanceof Pe&&!nr(e)?tr([new wt("",'"interpolate" expressions cannot be used with this property')]):Qe(a?new vr(n?"camera":"composite",t.value,a):new mr(n?"constant":"source",t.value)):tr([new wt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')])}vr.prototype.evaluateWithoutErrorHandling=function(t,e,r){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r)},vr.prototype.evaluate=function(t,e,r){return this._styleExpression.evaluate(t,e,r)},vr.prototype.interpolationFactor=function(t,e,r){return this._interpolationType?Pe.interpolationFactor(this._interpolationType,t,e,r):0};var xr=function(t,e){this._parameters=t,this._specification=e,xt(this,function t(e,r){var n,i,a,o="color"===r.type,s=e.stops&&"object"==typeof e.stops[0][0],u=s||void 0!==e.property,l=s||!u,p=e.type||(nr(r)?"exponential":"interval");if(o&&((e=xt({},e)).stops&&(e.stops=e.stops.map(function(t){return [t[0],Dt.parse(t[1])]})),e.default?e.default=Dt.parse(e.default):e.default=Dt.parse(r.default)),e.colorSpace&&"rgb"!==e.colorSpace&&!Ee[e.colorSpace])throw new Error("Unknown color space: "+e.colorSpace);if("exponential"===p)n=pr;else if("interval"===p)n=lr;else if("categorical"===p){n=ur,i=Object.create(null);for(var c=0,h=e.stops;c<h.length;c+=1){var f=h[c];i[f[0]]=f[1];}a=typeof e.stops[0][0];}else{if("identity"!==p)throw new Error('Unknown function type "'+p+'"');n=cr;}if(s){for(var y={},d=[],m=0;m<e.stops.length;m++){var v=e.stops[m],g=v[0].zoom;void 0===y[g]&&(y[g]={zoom:g,type:e.type,property:e.property,default:e.default,stops:[]},d.push(g)),y[g].stops.push([v[0].value,v[1]]);}for(var x=[],b=0,_=d;b<_.length;b+=1){var w=_[b];x.push([y[w].zoom,t(y[w],r)]);}return {kind:"composite",interpolationFactor:Pe.interpolationFactor.bind(void 0,{name:"linear"}),zoomStops:x.map(function(t){return t[0]}),evaluate:function(t,n){var i=t.zoom;return pr({stops:x,base:e.base},r,i).evaluate(i,n)}}}return l?{kind:"camera",interpolationFactor:"exponential"===p?Pe.interpolationFactor.bind(void 0,{name:"exponential",base:void 0!==e.base?e.base:1}):function(){return 0},zoomStops:e.stops.map(function(t){return t[0]}),evaluate:function(t){var o=t.zoom;return n(e,r,o,i,a)}}:{kind:"source",evaluate:function(t,o){var s=o&&o.properties?o.properties[e.property]:void 0;return void 0===s?sr(e.default,r.default):n(e,r,s,i,a)}}}(this._parameters,this._specification));};function br(t,e){if(ar(t))return new xr(t,e);if(yr(t)){var r=gr(t,e);if("error"===r.result)throw new Error(r.value.map(function(t){return t.key+": "+t.message}).join(", "));return r.value}var n=t;return "string"==typeof t&&"color"===e.type&&(n=Dt.parse(t)),{kind:"constant",evaluate:function(){return n}}}function _r(t){var e=t.key,r=t.value,n=t.valueSpec||{},i=t.objectElementValidators||{},a=t.style,o=t.styleSpec,s=[],u=ir(r);if("object"!==u)return [new vt(e,r,"object expected, "+u+" found")];for(var l in r){var p=l.split(".")[0],c=n[p]||n["*"],h=void 0;if(i[p])h=i[p];else if(n[p])h=Gr;else if(i["*"])h=i["*"];else{if(!n["*"]){s.push(new vt(e,r[l],'unknown property "'+l+'"'));continue}h=Gr;}s=s.concat(h({key:(e?e+".":e)+l,value:r[l],valueSpec:c,style:a,styleSpec:o,object:r,objectKey:l},r));}for(var f in n)i[f]||n[f].required&&void 0===n[f].default&&void 0===r[f]&&s.push(new vt(e,r,'missing required property "'+f+'"'));return s}function wr(t){var e=t.value,r=t.valueSpec,n=t.style,i=t.styleSpec,a=t.key,o=t.arrayElementValidator||Gr;if("array"!==ir(e))return [new vt(a,e,"array expected, "+ir(e)+" found")];if(r.length&&e.length!==r.length)return [new vt(a,e,"array length "+r.length+" expected, length "+e.length+" found")];if(r["min-length"]&&e.length<r["min-length"])return [new vt(a,e,"array length at least "+r["min-length"]+" expected, length "+e.length+" found")];var s={type:r.value};i.$version<7&&(s.function=r.function),"object"===ir(r.value)&&(s=r.value);for(var u=[],l=0;l<e.length;l++)u=u.concat(o({array:e,arrayIndex:l,value:e[l],valueSpec:s,style:n,styleSpec:i,key:a+"["+l+"]"}));return u}function Ar(t){var e=t.key,r=t.value,n=t.valueSpec,i=ir(r);return "number"!==i?[new vt(e,r,"number expected, "+i+" found")]:"minimum"in n&&r<n.minimum?[new vt(e,r,r+" is less than the minimum value "+n.minimum)]:"maximum"in n&&r>n.maximum?[new vt(e,r,r+" is greater than the maximum value "+n.maximum)]:[]}function Sr(t){var e,r,n,i=t.valueSpec,a=bt(t.value.type),o={},s="categorical"!==a&&void 0===t.value.property,u=!s,l="array"===ir(t.value.stops)&&"array"===ir(t.value.stops[0])&&"object"===ir(t.value.stops[0][0]),p=_r({key:t.key,value:t.value,valueSpec:t.styleSpec.function,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{stops:function(t){if("identity"===a)return [new vt(t.key,t.value,'identity function may not have a "stops" property')];var e=[],r=t.value;e=e.concat(wr({key:t.key,value:r,valueSpec:t.valueSpec,style:t.style,styleSpec:t.styleSpec,arrayElementValidator:c})),"array"===ir(r)&&0===r.length&&e.push(new vt(t.key,r,"array must have at least one stop"));return e},default:function(t){return Gr({key:t.key,value:t.value,valueSpec:i,style:t.style,styleSpec:t.styleSpec})}}});return "identity"===a&&s&&p.push(new vt(t.key,t.value,'missing required property "property"')),"identity"===a||t.value.stops||p.push(new vt(t.key,t.value,'missing required property "stops"')),"exponential"===a&&t.valueSpec.expression&&!nr(t.valueSpec)&&p.push(new vt(t.key,t.value,"exponential functions not supported")),t.styleSpec.$version>=8&&(u&&!er(t.valueSpec)?p.push(new vt(t.key,t.value,"property functions not supported")):s&&!rr(t.valueSpec)&&p.push(new vt(t.key,t.value,"zoom functions not supported"))),"categorical"!==a&&!l||void 0!==t.value.property||p.push(new vt(t.key,t.value,'"property" property is required')),p;function c(t){var e=[],a=t.value,s=t.key;if("array"!==ir(a))return [new vt(s,a,"array expected, "+ir(a)+" found")];if(2!==a.length)return [new vt(s,a,"array length 2 expected, length "+a.length+" found")];if(l){if("object"!==ir(a[0]))return [new vt(s,a,"object expected, "+ir(a[0])+" found")];if(void 0===a[0].zoom)return [new vt(s,a,"object stop key must have zoom")];if(void 0===a[0].value)return [new vt(s,a,"object stop key must have value")];if(n&&n>bt(a[0].zoom))return [new vt(s,a[0].zoom,"stop zoom values must appear in ascending order")];bt(a[0].zoom)!==n&&(n=bt(a[0].zoom),r=void 0,o={}),e=e.concat(_r({key:s+"[0]",value:a[0],valueSpec:{zoom:{}},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{zoom:Ar,value:h}}));}else e=e.concat(h({key:s+"[0]",value:a[0],valueSpec:{},style:t.style,styleSpec:t.styleSpec},a));return yr(_t(a[1]))?e.concat([new vt(s+"[1]",a[1],"expressions are not allowed in function stops.")]):e.concat(Gr({key:s+"[1]",value:a[1],valueSpec:i,style:t.style,styleSpec:t.styleSpec}))}function h(t,n){var s=ir(t.value),u=bt(t.value),l=null!==t.value?t.value:n;if(e){if(s!==e)return [new vt(t.key,l,s+" stop domain type must match previous stop domain type "+e)]}else e=s;if("number"!==s&&"string"!==s&&"boolean"!==s)return [new vt(t.key,l,"stop domain value must be a number, string, or boolean")];if("number"!==s&&"categorical"!==a){var p="number expected, "+s+" found";return er(i)&&void 0===a&&(p+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new vt(t.key,l,p)]}return "categorical"!==a||"number"!==s||isFinite(u)&&Math.floor(u)===u?"categorical"!==a&&"number"===s&&void 0!==r&&u<r?[new vt(t.key,l,"stop domain values must appear in ascending order")]:(r=u,"categorical"===a&&u in o?[new vt(t.key,l,"stop domain values must be unique")]:(o[u]=!0,[])):[new vt(t.key,l,"integer expected, found "+u)]}}function kr(t){var e=("property"===t.expressionContext?gr:dr)(_t(t.value),t.valueSpec);if("error"===e.result)return e.value.map(function(e){return new vt(""+t.key+e.key,t.value,e.message)});var r=e.value.expression||e.value._styleExpression.expression;if("property"===t.expressionContext&&"text-font"===t.propertyKey&&-1!==r.possibleOutputs().indexOf(void 0))return [new vt(t.key,t.value,'Invalid data expression for "'+t.propertyKey+'". Output values must be contained as literals within the expression.')];if("property"===t.expressionContext&&"layout"===t.propertyType&&!ne(r))return [new vt(t.key,t.value,'"feature-state" data expressions are not supported with layout properties.')];if("filter"===t.expressionContext&&!ne(r))return [new vt(t.key,t.value,'"feature-state" data expressions are not supported with filters.')];if(t.expressionContext&&0===t.expressionContext.indexOf("cluster")){if(!ie(r,["zoom","feature-state"]))return [new vt(t.key,t.value,'"zoom" and "feature-state" expressions are not supported with cluster properties.')];if("cluster-initial"===t.expressionContext&&!re(r))return [new vt(t.key,t.value,"Feature data expressions are not supported with initial expression part of cluster properties.")]}return []}function zr(t){var e=t.key,r=t.value,n=t.valueSpec,i=[];return Array.isArray(n.values)?-1===n.values.indexOf(bt(r))&&i.push(new vt(e,r,"expected one of ["+n.values.join(", ")+"], "+JSON.stringify(r)+" found")):-1===Object.keys(n.values).indexOf(bt(r))&&i.push(new vt(e,r,"expected one of ["+Object.keys(n.values).join(", ")+"], "+JSON.stringify(r)+" found")),i}function Ir(t){if(!0===t||!1===t)return !0;if(!Array.isArray(t)||0===t.length)return !1;switch(t[0]){case"has":return t.length>=2&&"$id"!==t[1]&&"$type"!==t[1];case"in":case"!in":case"!has":case"none":return !1;case"==":case"!=":case">":case">=":case"<":case"<=":return 3!==t.length||Array.isArray(t[1])||Array.isArray(t[2]);case"any":case"all":for(var e=0,r=t.slice(1);e<r.length;e+=1){var n=r[e];if(!Ir(n)&&"boolean"!=typeof n)return !1}return !0;default:return !0}}xr.deserialize=function(t){return new xr(t._parameters,t._specification)},xr.serialize=function(t){return {_parameters:t._parameters,_specification:t._specification}};var Br={type:"boolean",default:!1,transition:!1,"property-type":"data-driven",expression:{interpolated:!1,parameters:["zoom","feature"]}};function Er(t){if(null==t)return function(){return !0};Ir(t)||(t=Vr(t));var e=dr(t,Br);if("error"===e.result)throw new Error(e.value.map(function(t){return t.key+": "+t.message}).join(", "));return function(t,r){return e.value.evaluate(t,r)}}function Pr(t,e){return t<e?-1:t>e?1:0}function Vr(t){if(!t)return !0;var e,r=t[0];return t.length<=1?"any"!==r:"=="===r?Cr(t[1],t[2],"=="):"!="===r?Fr(Cr(t[1],t[2],"==")):"<"===r||">"===r||"<="===r||">="===r?Cr(t[1],t[2],r):"any"===r?(e=t.slice(1),["any"].concat(e.map(Vr))):"all"===r?["all"].concat(t.slice(1).map(Vr)):"none"===r?["all"].concat(t.slice(1).map(Vr).map(Fr)):"in"===r?Mr(t[1],t.slice(2)):"!in"===r?Fr(Mr(t[1],t.slice(2))):"has"===r?Tr(t[1]):"!has"!==r||Fr(Tr(t[1]))}function Cr(t,e,r){switch(t){case"$type":return ["filter-type-"+r,e];case"$id":return ["filter-id-"+r,e];default:return ["filter-"+r,t,e]}}function Mr(t,e){if(0===e.length)return !1;switch(t){case"$type":return ["filter-type-in",["literal",e]];case"$id":return ["filter-id-in",["literal",e]];default:return e.length>200&&!e.some(function(t){return typeof t!=typeof e[0]})?["filter-in-large",t,["literal",e.sort(Pr)]]:["filter-in-small",t,["literal",e]]}}function Tr(t){switch(t){case"$type":return !0;case"$id":return ["filter-has-id"];default:return ["filter-has",t]}}function Fr(t){return ["!",t]}function Lr(t){return Ir(_t(t.value))?kr(xt({},t,{expressionContext:"filter",valueSpec:{value:"boolean"}})):function t(e){var r=e.value;var n=e.key;if("array"!==ir(r))return [new vt(n,r,"array expected, "+ir(r)+" found")];var i=e.styleSpec;var a;var o=[];if(r.length<1)return [new vt(n,r,"filter array must have at least 1 element")];o=o.concat(zr({key:n+"[0]",value:r[0],valueSpec:i.filter_operator,style:e.style,styleSpec:e.styleSpec}));switch(bt(r[0])){case"<":case"<=":case">":case">=":r.length>=2&&"$type"===bt(r[1])&&o.push(new vt(n,r,'"$type" cannot be use with operator "'+r[0]+'"'));case"==":case"!=":3!==r.length&&o.push(new vt(n,r,'filter array for operator "'+r[0]+'" must have 3 elements'));case"in":case"!in":r.length>=2&&"string"!==(a=ir(r[1]))&&o.push(new vt(n+"[1]",r[1],"string expected, "+a+" found"));for(var s=2;s<r.length;s++)a=ir(r[s]),"$type"===bt(r[1])?o=o.concat(zr({key:n+"["+s+"]",value:r[s],valueSpec:i.geometry_type,style:e.style,styleSpec:e.styleSpec})):"string"!==a&&"number"!==a&&"boolean"!==a&&o.push(new vt(n+"["+s+"]",r[s],"string, number, or boolean expected, "+a+" found"));break;case"any":case"all":case"none":for(var u=1;u<r.length;u++)o=o.concat(t({key:n+"["+u+"]",value:r[u],style:e.style,styleSpec:e.styleSpec}));break;case"has":case"!has":a=ir(r[1]),2!==r.length?o.push(new vt(n,r,'filter array for "'+r[0]+'" operator must have 2 elements')):"string"!==a&&o.push(new vt(n+"[1]",r[1],"string expected, "+a+" found"));}return o}(t)}function Or(t,e){var r=t.key,n=t.style,i=t.styleSpec,a=t.value,o=t.objectKey,s=i[e+"_"+t.layerType];if(!s)return [];var u=o.match(/^(.*)-transition$/);if("paint"===e&&u&&s[u[1]]&&s[u[1]].transition)return Gr({key:r,value:a,valueSpec:i.transition,style:n,styleSpec:i});var l,p=t.valueSpec||s[o];if(!p)return [new vt(r,a,'unknown property "'+o+'"')];if("string"===ir(a)&&er(p)&&!p.tokens&&(l=/^{([^}]+)}$/.exec(a)))return [new vt(r,a,'"'+o+'" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": '+JSON.stringify(l[1])+" }`.")];var c=[];return "symbol"===t.layerType&&("text-field"===o&&n&&!n.glyphs&&c.push(new vt(r,a,'use of "text-field" requires a style "glyphs" property')),"text-font"===o&&ar(_t(a))&&"identity"===bt(a.type)&&c.push(new vt(r,a,'"text-font" does not support identity functions'))),c.concat(Gr({key:t.key,value:a,valueSpec:p,style:n,styleSpec:i,expressionContext:"property",propertyType:e,propertyKey:o}))}function Dr(t){return Or(t,"paint")}function Ur(t){return Or(t,"layout")}function jr(t){var e=[],r=t.value,n=t.key,i=t.style,a=t.styleSpec;r.type||r.ref||e.push(new vt(n,r,'either "type" or "ref" is required'));var o,s=bt(r.type),u=bt(r.ref);if(r.id)for(var l=bt(r.id),p=0;p<t.arrayIndex;p++){var c=i.layers[p];bt(c.id)===l&&e.push(new vt(n,r.id,'duplicate layer id "'+r.id+'", previously used at line '+c.id.__line__));}if("ref"in r)["type","source","source-layer","filter","layout"].forEach(function(t){t in r&&e.push(new vt(n,r[t],'"'+t+'" is prohibited for ref layers'));}),i.layers.forEach(function(t){bt(t.id)===u&&(o=t);}),o?o.ref?e.push(new vt(n,r.ref,"ref cannot reference another ref layer")):s=bt(o.type):e.push(new vt(n,r.ref,'ref layer "'+u+'" not found'));else if("background"!==s)if(r.source){var h=i.sources&&i.sources[r.source],f=h&&bt(h.type);h?"vector"===f&&"raster"===s?e.push(new vt(n,r.source,'layer "'+r.id+'" requires a raster source')):"raster"===f&&"raster"!==s?e.push(new vt(n,r.source,'layer "'+r.id+'" requires a vector source')):"vector"!==f||r["source-layer"]?"raster-dem"===f&&"hillshade"!==s?e.push(new vt(n,r.source,"raster-dem source can only be used with layer type 'hillshade'.")):"line"!==s||!r.paint||!r.paint["line-gradient"]||"geojson"===f&&h.lineMetrics||e.push(new vt(n,r,'layer "'+r.id+'" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')):e.push(new vt(n,r,'layer "'+r.id+'" must specify a "source-layer"')):e.push(new vt(n,r.source,'source "'+r.source+'" not found'));}else e.push(new vt(n,r,'missing required property "source"'));return e=e.concat(_r({key:n,value:r,valueSpec:a.layer,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(){return []},type:function(){return Gr({key:n+".type",value:r.type,valueSpec:a.layer.type,style:t.style,styleSpec:t.styleSpec,object:r,objectKey:"type"})},filter:Lr,layout:function(t){return _r({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return Ur(xt({layerType:s},t))}}})},paint:function(t){return _r({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return Dr(xt({layerType:s},t))}}})}}}))}function qr(t){var e=t.value,r=t.key,n=t.styleSpec,i=t.style;if(!e.type)return [new vt(r,e,'"type" is required')];var a,o=bt(e.type);switch(o){case"vector":case"raster":case"raster-dem":if(a=_r({key:r,value:e,valueSpec:n["source_"+o.replace("-","_")],style:t.style,styleSpec:n}),"url"in e)for(var s in e)["type","url","tileSize"].indexOf(s)<0&&a.push(new vt(r+"."+s,e[s],'a source with a "url" property may not include a "'+s+'" property'));return a;case"geojson":if(a=_r({key:r,value:e,valueSpec:n.source_geojson,style:i,styleSpec:n}),e.cluster)for(var u in e.clusterProperties){var l=e.clusterProperties[u],p=l[0],c=l[1],h="string"==typeof p?[p,["accumulated"],["get",u]]:p;a.push.apply(a,kr({key:r+"."+u+".map",value:c,expressionContext:"cluster-map"})),a.push.apply(a,kr({key:r+"."+u+".reduce",value:h,expressionContext:"cluster-reduce"}));}return a;case"video":return _r({key:r,value:e,valueSpec:n.source_video,style:i,styleSpec:n});case"image":return _r({key:r,value:e,valueSpec:n.source_image,style:i,styleSpec:n});case"canvas":return [new vt(r,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")];default:return zr({key:r+".type",value:e.type,valueSpec:{values:["vector","raster","raster-dem","geojson","video","image"]},style:i,styleSpec:n})}}function Rr(t){var e=t.value,r=t.styleSpec,n=r.light,i=t.style,a=[],o=ir(e);if(void 0===e)return a;if("object"!==o)return a=a.concat([new vt("light",e,"object expected, "+o+" found")]);for(var s in e){var u=s.match(/^(.*)-transition$/);a=u&&n[u[1]]&&n[u[1]].transition?a.concat(Gr({key:s,value:e[s],valueSpec:r.transition,style:i,styleSpec:r})):n[s]?a.concat(Gr({key:s,value:e[s],valueSpec:n[s],style:i,styleSpec:r})):a.concat([new vt(s,e[s],'unknown property "'+s+'"')]);}return a}function Nr(t){var e=t.value,r=t.key,n=ir(e);return "string"!==n?[new vt(r,e,"string expected, "+n+" found")]:[]}var Kr={"*":function(){return []},array:wr,boolean:function(t){var e=t.value,r=t.key,n=ir(e);return "boolean"!==n?[new vt(r,e,"boolean expected, "+n+" found")]:[]},number:Ar,color:function(t){var e=t.key,r=t.value,n=ir(r);return "string"!==n?[new vt(e,r,"color expected, "+n+" found")]:null===Ot(r)?[new vt(e,r,'color expected, "'+r+'" found')]:[]},constants:gt,enum:zr,filter:Lr,function:Sr,layer:jr,object:_r,source:qr,light:Rr,string:Nr,formatted:function(t){return 0===Nr(t).length?[]:kr(t)}};function Gr(t){var e=t.value,r=t.valueSpec,n=t.styleSpec;return r.expression&&ar(bt(e))?Sr(t):r.expression&&yr(_t(e))?kr(t):r.type&&Kr[r.type]?Kr[r.type](t):_r(xt({},t,{valueSpec:r.type?n[r.type]:r}))}function Xr(t){var e=t.value,r=t.key,n=Nr(t);return n.length?n:(-1===e.indexOf("{fontstack}")&&n.push(new vt(r,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&n.push(new vt(r,e,'"glyphs" url must include a "{range}" token')),n)}function Zr(t,e){e=e||mt;var r=[];return r=r.concat(Gr({key:"",value:t,valueSpec:e.$root,styleSpec:e,style:t,objectElementValidators:{glyphs:Xr,"*":function(){return []}}})),t.constants&&(r=r.concat(gt({key:"constants",value:t.constants,style:t,styleSpec:e}))),Hr(r)}function Hr(t){return [].concat(t).sort(function(t,e){return t.line-e.line})}function Yr(t){return function(){for(var e=[],r=arguments.length;r--;)e[r]=arguments[r];return Hr(t.apply(this,e))}}Zr.source=Yr(qr),Zr.light=Yr(Rr),Zr.layer=Yr(jr),Zr.filter=Yr(Lr),Zr.paintProperty=Yr(Dr),Zr.layoutProperty=Yr(Ur);var Jr=Zr,$r=Zr.light,Wr=Zr.paintProperty,Qr=Zr.layoutProperty;function tn(t,e){var r=!1;if(e&&e.length)for(var n=0,i=e;n<i.length;n+=1){var a=i[n];t.fire(new yt(new Error(a.message))),r=!0;}return r}var en=nn,rn=3;function nn(t,e,r){var n=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var i=new Int32Array(this.arrayBuffer);t=i[0],e=i[1],r=i[2],this.d=e+2*r;for(var a=0;a<this.d*this.d;a++){var o=i[rn+a],s=i[rn+a+1];n.push(o===s?null:i.subarray(o,s));}var u=i[rn+n.length],l=i[rn+n.length+1];this.keys=i.subarray(u,l),this.bboxes=i.subarray(l),this.insert=this._insertReadonly;}else{this.d=e+2*r;for(var p=0;p<this.d*this.d;p++)n.push([]);this.keys=[],this.bboxes=[];}this.n=e,this.extent=t,this.padding=r,this.scale=e/t,this.uid=0;var c=r/e*t;this.min=-c,this.max=t+c;}nn.prototype.insert=function(t,e,r,n,i){this._forEachCell(e,r,n,i,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(e),this.bboxes.push(r),this.bboxes.push(n),this.bboxes.push(i);},nn.prototype._insertReadonly=function(){throw"Cannot insert into a GridIndex created from an ArrayBuffer."},nn.prototype._insertCell=function(t,e,r,n,i,a){this.cells[i].push(a);},nn.prototype.query=function(t,e,r,n,i){var a=this.min,o=this.max;if(t<=a&&e<=a&&o<=r&&o<=n&&!i)return Array.prototype.slice.call(this.keys);var s=[];return this._forEachCell(t,e,r,n,this._queryCell,s,{},i),s},nn.prototype._queryCell=function(t,e,r,n,i,a,o,s){var u=this.cells[i];if(null!==u)for(var l=this.keys,p=this.bboxes,c=0;c<u.length;c++){var h=u[c];if(void 0===o[h]){var f=4*h;(s?s(p[f+0],p[f+1],p[f+2],p[f+3]):t<=p[f+2]&&e<=p[f+3]&&r>=p[f+0]&&n>=p[f+1])?(o[h]=!0,a.push(l[h])):o[h]=!1;}}},nn.prototype._forEachCell=function(t,e,r,n,i,a,o,s){for(var u=this._convertToCellCoord(t),l=this._convertToCellCoord(e),p=this._convertToCellCoord(r),c=this._convertToCellCoord(n),h=u;h<=p;h++)for(var f=l;f<=c;f++){var y=this.d*f+h;if((!s||s(this._convertFromCellCoord(h),this._convertFromCellCoord(f),this._convertFromCellCoord(h+1),this._convertFromCellCoord(f+1)))&&i.call(this,t,e,r,n,y,a,o,s))return}},nn.prototype._convertFromCellCoord=function(t){return (t-this.padding)/this.scale},nn.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},nn.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,e=rn+this.cells.length+1+1,r=0,n=0;n<this.cells.length;n++)r+=this.cells[n].length;var i=new Int32Array(e+r+this.keys.length+this.bboxes.length);i[0]=this.extent,i[1]=this.n,i[2]=this.padding;for(var a=e,o=0;o<t.length;o++){var s=t[o];i[rn+o]=a,i.set(s,a),a+=s.length;}return i[rn+t.length]=a,i.set(this.keys,a),a+=this.keys.length,i[rn+t.length+1]=a,i.set(this.bboxes,a),a+=this.bboxes.length,i.buffer};var an=self.ImageData,on={};function sn(t,e,r){void 0===r&&(r={}),Object.defineProperty(e,"_classRegistryKey",{value:t,writeable:!1}),on[t]={klass:e,omit:r.omit||[],shallow:r.shallow||[]};}for(var un in sn("Object",Object),en.serialize=function(t,e){var r=t.toArrayBuffer();return e&&e.push(r),{buffer:r}},en.deserialize=function(t){return new en(t.buffer)},sn("Grid",en),sn("Color",Dt),sn("Error",Error),sn("StylePropertyFunction",xr),sn("StyleExpression",fr,{omit:["_evaluator"]}),sn("ZoomDependentExpression",vr),sn("ZoomConstantExpression",mr),sn("CompoundExpression",te,{omit:["_evaluate"]}),He)He[un]._classRegistryKey||sn("Expression_"+un,He[un]);function ln(t,e){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp)return t;if(t instanceof ArrayBuffer)return e&&e.push(t),t;if(ArrayBuffer.isView(t)){var r=t;return e&&e.push(r.buffer),r}if(t instanceof an)return e&&e.push(t.data.buffer),t;if(Array.isArray(t)){for(var n=[],i=0,a=t;i<a.length;i+=1){var o=a[i];n.push(ln(o,e));}return n}if("object"==typeof t){var s=t.constructor,u=s._classRegistryKey;if(!u)throw new Error("can't serialize object of unregistered class");var l=s.serialize?s.serialize(t,e):{};if(!s.serialize){for(var p in t)if(t.hasOwnProperty(p)&&!(on[u].omit.indexOf(p)>=0)){var c=t[p];l[p]=on[u].shallow.indexOf(p)>=0?c:ln(c,e);}t instanceof Error&&(l.message=t.message);}if(l.$name)throw new Error("$name property is reserved for worker serialization logic.");return "Object"!==u&&(l.$name=u),l}throw new Error("can't serialize object of type "+typeof t)}function pn(t){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp||t instanceof ArrayBuffer||ArrayBuffer.isView(t)||t instanceof an)return t;if(Array.isArray(t))return t.map(pn);if("object"==typeof t){var e=t.$name||"Object",r=on[e].klass;if(!r)throw new Error("can't deserialize unregistered class "+e);if(r.deserialize)return r.deserialize(t);for(var n=Object.create(r.prototype),i=0,a=Object.keys(t);i<a.length;i+=1){var o=a[i];if("$name"!==o){var s=t[o];n[o]=on[e].shallow.indexOf(o)>=0?s:pn(s);}}return n}throw new Error("can't deserialize object of type "+typeof t)}var cn=function(){this.first=!0;};cn.prototype.update=function(t,e){var r=Math.floor(t);return this.first?(this.first=!1,this.lastIntegerZoom=r,this.lastIntegerZoomTime=0,this.lastZoom=t,this.lastFloorZoom=r,!0):(this.lastFloorZoom>r?(this.lastIntegerZoom=r+1,this.lastIntegerZoomTime=e):this.lastFloorZoom<r&&(this.lastIntegerZoom=r,this.lastIntegerZoomTime=e),t!==this.lastZoom&&(this.lastZoom=t,this.lastFloorZoom=r,!0))};var hn={"Latin-1 Supplement":function(t){return t>=128&&t<=255},Arabic:function(t){return t>=1536&&t<=1791},"Arabic Supplement":function(t){return t>=1872&&t<=1919},"Arabic Extended-A":function(t){return t>=2208&&t<=2303},"Hangul Jamo":function(t){return t>=4352&&t<=4607},"Unified Canadian Aboriginal Syllabics":function(t){return t>=5120&&t<=5759},Khmer:function(t){return t>=6016&&t<=6143},"Unified Canadian Aboriginal Syllabics Extended":function(t){return t>=6320&&t<=6399},"General Punctuation":function(t){return t>=8192&&t<=8303},"Letterlike Symbols":function(t){return t>=8448&&t<=8527},"Number Forms":function(t){return t>=8528&&t<=8591},"Miscellaneous Technical":function(t){return t>=8960&&t<=9215},"Control Pictures":function(t){return t>=9216&&t<=9279},"Optical Character Recognition":function(t){return t>=9280&&t<=9311},"Enclosed Alphanumerics":function(t){return t>=9312&&t<=9471},"Geometric Shapes":function(t){return t>=9632&&t<=9727},"Miscellaneous Symbols":function(t){return t>=9728&&t<=9983},"Miscellaneous Symbols and Arrows":function(t){return t>=11008&&t<=11263},"CJK Radicals Supplement":function(t){return t>=11904&&t<=12031},"Kangxi Radicals":function(t){return t>=12032&&t<=12255},"Ideographic Description Characters":function(t){return t>=12272&&t<=12287},"CJK Symbols and Punctuation":function(t){return t>=12288&&t<=12351},Hiragana:function(t){return t>=12352&&t<=12447},Katakana:function(t){return t>=12448&&t<=12543},Bopomofo:function(t){return t>=12544&&t<=12591},"Hangul Compatibility Jamo":function(t){return t>=12592&&t<=12687},Kanbun:function(t){return t>=12688&&t<=12703},"Bopomofo Extended":function(t){return t>=12704&&t<=12735},"CJK Strokes":function(t){return t>=12736&&t<=12783},"Katakana Phonetic Extensions":function(t){return t>=12784&&t<=12799},"Enclosed CJK Letters and Months":function(t){return t>=12800&&t<=13055},"CJK Compatibility":function(t){return t>=13056&&t<=13311},"CJK Unified Ideographs Extension A":function(t){return t>=13312&&t<=19903},"Yijing Hexagram Symbols":function(t){return t>=19904&&t<=19967},"CJK Unified Ideographs":function(t){return t>=19968&&t<=40959},"Yi Syllables":function(t){return t>=40960&&t<=42127},"Yi Radicals":function(t){return t>=42128&&t<=42191},"Hangul Jamo Extended-A":function(t){return t>=43360&&t<=43391},"Hangul Syllables":function(t){return t>=44032&&t<=55215},"Hangul Jamo Extended-B":function(t){return t>=55216&&t<=55295},"Private Use Area":function(t){return t>=57344&&t<=63743},"CJK Compatibility Ideographs":function(t){return t>=63744&&t<=64255},"Arabic Presentation Forms-A":function(t){return t>=64336&&t<=65023},"Vertical Forms":function(t){return t>=65040&&t<=65055},"CJK Compatibility Forms":function(t){return t>=65072&&t<=65103},"Small Form Variants":function(t){return t>=65104&&t<=65135},"Arabic Presentation Forms-B":function(t){return t>=65136&&t<=65279},"Halfwidth and Fullwidth Forms":function(t){return t>=65280&&t<=65519}};function fn(t){for(var e=0,r=t;e<r.length;e+=1){if(dn(r[e].charCodeAt(0)))return !0}return !1}function yn(t){return !hn.Arabic(t)&&(!hn["Arabic Supplement"](t)&&(!hn["Arabic Extended-A"](t)&&(!hn["Arabic Presentation Forms-A"](t)&&!hn["Arabic Presentation Forms-B"](t))))}function dn(t){return 746===t||747===t||!(t<4352)&&(!!hn["Bopomofo Extended"](t)||(!!hn.Bopomofo(t)||(!(!hn["CJK Compatibility Forms"](t)||t>=65097&&t<=65103)||(!!hn["CJK Compatibility Ideographs"](t)||(!!hn["CJK Compatibility"](t)||(!!hn["CJK Radicals Supplement"](t)||(!!hn["CJK Strokes"](t)||(!(!hn["CJK Symbols and Punctuation"](t)||t>=12296&&t<=12305||t>=12308&&t<=12319||12336===t)||(!!hn["CJK Unified Ideographs Extension A"](t)||(!!hn["CJK Unified Ideographs"](t)||(!!hn["Enclosed CJK Letters and Months"](t)||(!!hn["Hangul Compatibility Jamo"](t)||(!!hn["Hangul Jamo Extended-A"](t)||(!!hn["Hangul Jamo Extended-B"](t)||(!!hn["Hangul Jamo"](t)||(!!hn["Hangul Syllables"](t)||(!!hn.Hiragana(t)||(!!hn["Ideographic Description Characters"](t)||(!!hn.Kanbun(t)||(!!hn["Kangxi Radicals"](t)||(!!hn["Katakana Phonetic Extensions"](t)||(!(!hn.Katakana(t)||12540===t)||(!(!hn["Halfwidth and Fullwidth Forms"](t)||65288===t||65289===t||65293===t||t>=65306&&t<=65310||65339===t||65341===t||65343===t||t>=65371&&t<=65503||65507===t||t>=65512&&t<=65519)||(!(!hn["Small Form Variants"](t)||t>=65112&&t<=65118||t>=65123&&t<=65126)||(!!hn["Unified Canadian Aboriginal Syllabics"](t)||(!!hn["Unified Canadian Aboriginal Syllabics Extended"](t)||(!!hn["Vertical Forms"](t)||(!!hn["Yijing Hexagram Symbols"](t)||(!!hn["Yi Syllables"](t)||!!hn["Yi Radicals"](t))))))))))))))))))))))))))))))}function mn(t){return !(dn(t)||function(t){return !!(hn["Latin-1 Supplement"](t)&&(167===t||169===t||174===t||177===t||188===t||189===t||190===t||215===t||247===t)||hn["General Punctuation"](t)&&(8214===t||8224===t||8225===t||8240===t||8241===t||8251===t||8252===t||8258===t||8263===t||8264===t||8265===t||8273===t)||hn["Letterlike Symbols"](t)||hn["Number Forms"](t)||hn["Miscellaneous Technical"](t)&&(t>=8960&&t<=8967||t>=8972&&t<=8991||t>=8996&&t<=9e3||9003===t||t>=9085&&t<=9114||t>=9150&&t<=9165||9167===t||t>=9169&&t<=9179||t>=9186&&t<=9215)||hn["Control Pictures"](t)&&9251!==t||hn["Optical Character Recognition"](t)||hn["Enclosed Alphanumerics"](t)||hn["Geometric Shapes"](t)||hn["Miscellaneous Symbols"](t)&&!(t>=9754&&t<=9759)||hn["Miscellaneous Symbols and Arrows"](t)&&(t>=11026&&t<=11055||t>=11088&&t<=11097||t>=11192&&t<=11243)||hn["CJK Symbols and Punctuation"](t)||hn.Katakana(t)||hn["Private Use Area"](t)||hn["CJK Compatibility Forms"](t)||hn["Small Form Variants"](t)||hn["Halfwidth and Fullwidth Forms"](t)||8734===t||8756===t||8757===t||t>=9984&&t<=10087||t>=10102&&t<=10131||65532===t||65533===t)}(t))}function vn(t,e){return !(!e&&(t>=1424&&t<=2303||hn["Arabic Presentation Forms-A"](t)||hn["Arabic Presentation Forms-B"](t)))&&!(t>=2304&&t<=3583||t>=3840&&t<=4255||hn.Khmer(t))}var gn,xn=!1,bn=null,_n=!1,wn=new dt,An={applyArabicShaping:null,processBidirectionalText:null,processStyledBidirectionalText:null,isLoaded:function(){return _n||null!=An.applyArabicShaping}},Sn=function(t,e){this.zoom=t,e?(this.now=e.now,this.fadeDuration=e.fadeDuration,this.zoomHistory=e.zoomHistory,this.transition=e.transition):(this.now=0,this.fadeDuration=0,this.zoomHistory=new cn,this.transition={});};Sn.prototype.isSupportedScript=function(t){return function(t,e){for(var r=0,n=t;r<n.length;r+=1)if(!vn(n[r].charCodeAt(0),e))return !1;return !0}(t,An.isLoaded())},Sn.prototype.crossFadingFactor=function(){return 0===this.fadeDuration?1:Math.min((this.now-this.zoomHistory.lastIntegerZoomTime)/this.fadeDuration,1)},Sn.prototype.getCrossfadeParameters=function(){var t=this.zoom,e=t-Math.floor(t),r=this.crossFadingFactor();return t>this.zoomHistory.lastIntegerZoom?{fromScale:2,toScale:1,t:e+(1-e)*r}:{fromScale:.5,toScale:1,t:1-(1-r)*e}};var kn=function(t,e){this.property=t,this.value=e,this.expression=br(void 0===e?t.specification.default:e,t.specification);};kn.prototype.isDataDriven=function(){return "source"===this.expression.kind||"composite"===this.expression.kind},kn.prototype.possiblyEvaluate=function(t){return this.property.possiblyEvaluate(this,t)};var zn=function(t){this.property=t,this.value=new kn(t,void 0);};zn.prototype.transitioned=function(t,e){return new Bn(this.property,this.value,e,c({},t.transition,this.transition),t.now)},zn.prototype.untransitioned=function(){return new Bn(this.property,this.value,null,{},0)};var In=function(t){this._properties=t,this._values=Object.create(t.defaultTransitionablePropertyValues);};In.prototype.getValue=function(t){return b(this._values[t].value.value)},In.prototype.setValue=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new zn(this._values[t].property)),this._values[t].value=new kn(this._values[t].property,null===e?void 0:b(e));},In.prototype.getTransition=function(t){return b(this._values[t].transition)},In.prototype.setTransition=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new zn(this._values[t].property)),this._values[t].transition=b(e)||void 0;},In.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);var a=this.getTransition(n);void 0!==a&&(t[n+"-transition"]=a);}return t},In.prototype.transitioned=function(t,e){for(var r=new En(this._properties),n=0,i=Object.keys(this._values);n<i.length;n+=1){var a=i[n];r._values[a]=this._values[a].transitioned(t,e._values[a]);}return r},In.prototype.untransitioned=function(){for(var t=new En(this._properties),e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e];t._values[n]=this._values[n].untransitioned();}return t};var Bn=function(t,e,r,n,i){this.property=t,this.value=e,this.begin=i+n.delay||0,this.end=this.begin+n.duration||0,t.specification.transition&&(n.delay||n.duration)&&(this.prior=r);};Bn.prototype.possiblyEvaluate=function(t){var e=t.now||0,r=this.value.possiblyEvaluate(t),n=this.prior;if(n){if(e>this.end)return this.prior=null,r;if(this.value.isDataDriven())return this.prior=null,r;if(e<this.begin)return n.possiblyEvaluate(t);var i=(e-this.begin)/(this.end-this.begin);return this.property.interpolate(n.possiblyEvaluate(t),r,function(t){if(t<=0)return 0;if(t>=1)return 1;var e=t*t,r=e*t;return 4*(t<.5?r:3*(t-e)+r-.75)}(i))}return r};var En=function(t){this._properties=t,this._values=Object.create(t.defaultTransitioningPropertyValues);};En.prototype.possiblyEvaluate=function(t){for(var e=new Cn(this._properties),r=0,n=Object.keys(this._values);r<n.length;r+=1){var i=n[r];e._values[i]=this._values[i].possiblyEvaluate(t);}return e},En.prototype.hasTransition=function(){for(var t=0,e=Object.keys(this._values);t<e.length;t+=1){var r=e[t];if(this._values[r].prior)return !0}return !1};var Pn=function(t){this._properties=t,this._values=Object.create(t.defaultPropertyValues);};Pn.prototype.getValue=function(t){return b(this._values[t].value)},Pn.prototype.setValue=function(t,e){this._values[t]=new kn(this._values[t].property,null===e?void 0:b(e));},Pn.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);}return t},Pn.prototype.possiblyEvaluate=function(t){for(var e=new Cn(this._properties),r=0,n=Object.keys(this._values);r<n.length;r+=1){var i=n[r];e._values[i]=this._values[i].possiblyEvaluate(t);}return e};var Vn=function(t,e,r){this.property=t,this.value=e,this.parameters=r;};Vn.prototype.isConstant=function(){return "constant"===this.value.kind},Vn.prototype.constantOr=function(t){return "constant"===this.value.kind?this.value.value:t},Vn.prototype.evaluate=function(t,e){return this.property.evaluate(this.value,this.parameters,t,e)};var Cn=function(t){this._properties=t,this._values=Object.create(t.defaultPossiblyEvaluatedValues);};Cn.prototype.get=function(t){return this._values[t]};var Mn=function(t){this.specification=t;};Mn.prototype.possiblyEvaluate=function(t,e){return t.expression.evaluate(e)},Mn.prototype.interpolate=function(t,e,r){var n=pe[this.specification.type];return n?n(t,e,r):t};var Tn=function(t){this.specification=t;};Tn.prototype.possiblyEvaluate=function(t,e){return "constant"===t.expression.kind||"camera"===t.expression.kind?new Vn(this,{kind:"constant",value:t.expression.evaluate(e)},e):new Vn(this,t.expression,e)},Tn.prototype.interpolate=function(t,e,r){if("constant"!==t.value.kind||"constant"!==e.value.kind)return t;if(void 0===t.value.value||void 0===e.value.value)return new Vn(this,{kind:"constant",value:void 0},t.parameters);var n=pe[this.specification.type];return n?new Vn(this,{kind:"constant",value:n(t.value.value,e.value.value,r)},t.parameters):t},Tn.prototype.evaluate=function(t,e,r,n){return "constant"===t.kind?t.value:t.evaluate(e,r,n)};var Fn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.possiblyEvaluate=function(t,e){if(void 0===t.value)return new Vn(this,{kind:"constant",value:void 0},e);if("constant"===t.expression.kind){var r=t.expression.evaluate(e),n=this._calculate(r,r,r,e);return new Vn(this,{kind:"constant",value:n},e)}if("camera"===t.expression.kind){var i=this._calculate(t.expression.evaluate({zoom:e.zoom-1}),t.expression.evaluate({zoom:e.zoom}),t.expression.evaluate({zoom:e.zoom+1}),e);return new Vn(this,{kind:"constant",value:i},e)}return new Vn(this,t.expression,e)},e.prototype.evaluate=function(t,e,r,n){if("source"===t.kind){var i=t.evaluate(e,r,n);return this._calculate(i,i,i,e)}return "composite"===t.kind?this._calculate(t.evaluate({zoom:Math.floor(e.zoom)-1},r,n),t.evaluate({zoom:Math.floor(e.zoom)},r,n),t.evaluate({zoom:Math.floor(e.zoom)+1},r,n),e):t.value},e.prototype._calculate=function(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:r,to:e}},e.prototype.interpolate=function(t){return t},e}(Tn),Ln=function(t){this.specification=t;};Ln.prototype.possiblyEvaluate=function(t,e){if(void 0!==t.value){if("constant"===t.expression.kind){var r=t.expression.evaluate(e);return this._calculate(r,r,r,e)}return this._calculate(t.expression.evaluate(new Sn(Math.floor(e.zoom-1),e)),t.expression.evaluate(new Sn(Math.floor(e.zoom),e)),t.expression.evaluate(new Sn(Math.floor(e.zoom+1),e)),e)}},Ln.prototype._calculate=function(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:r,to:e}},Ln.prototype.interpolate=function(t){return t};var On=function(t){this.specification=t;};On.prototype.possiblyEvaluate=function(t,e){return !!t.expression.evaluate(e)},On.prototype.interpolate=function(){return !1};var Dn=function(t){for(var e in this.properties=t,this.defaultPropertyValues={},this.defaultTransitionablePropertyValues={},this.defaultTransitioningPropertyValues={},this.defaultPossiblyEvaluatedValues={},t){var r=t[e],n=this.defaultPropertyValues[e]=new kn(r,void 0),i=this.defaultTransitionablePropertyValues[e]=new zn(r);this.defaultTransitioningPropertyValues[e]=i.untransitioned(),this.defaultPossiblyEvaluatedValues[e]=n.possiblyEvaluate({});}};sn("DataDrivenProperty",Tn),sn("DataConstantProperty",Mn),sn("CrossFadedDataDrivenProperty",Fn),sn("CrossFadedProperty",Ln),sn("ColorRampProperty",On);var Un=function(t){function e(e,r){if(t.call(this),this.id=e.id,this.type=e.type,this.visibility="visible",this._featureFilter=function(){return !0},"custom"!==e.type&&(e=e,this.metadata=e.metadata,this.minzoom=e.minzoom,this.maxzoom=e.maxzoom,"background"!==e.type&&(this.source=e.source,this.sourceLayer=e["source-layer"],this.filter=e.filter),r.layout&&(this._unevaluatedLayout=new Pn(r.layout)),r.paint)){for(var n in this._transitionablePaint=new In(r.paint),e.paint)this.setPaintProperty(n,e.paint[n],{validate:!1});for(var i in e.layout)this.setLayoutProperty(i,e.layout[i],{validate:!1});this._transitioningPaint=this._transitionablePaint.untransitioned();}}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getCrossfadeParameters=function(){return this._crossfadeParameters},e.prototype.getLayoutProperty=function(t){return "visibility"===t?this.visibility:this._unevaluatedLayout.getValue(t)},e.prototype.setLayoutProperty=function(t,e,r){if(void 0===r&&(r={}),null!=e){var n="layers."+this.id+".layout."+t;if(this._validate(Qr,n,t,e,r))return}"visibility"!==t?this._unevaluatedLayout.setValue(t,e):this.visibility="none"===e?e:"visible";},e.prototype.getPaintProperty=function(t){return v(t,"-transition")?this._transitionablePaint.getTransition(t.slice(0,-"-transition".length)):this._transitionablePaint.getValue(t)},e.prototype.setPaintProperty=function(t,e,r){if(void 0===r&&(r={}),null!=e){var n="layers."+this.id+".paint."+t;if(this._validate(Wr,n,t,e,r))return !1}if(v(t,"-transition"))return this._transitionablePaint.setTransition(t.slice(0,-"-transition".length),e||void 0),!1;var i=this._transitionablePaint._values[t],a="cross-faded-data-driven"===i.property.specification["property-type"]&&!i.value.value&&e,o=this._transitionablePaint._values[t].value.isDataDriven();this._transitionablePaint.setValue(t,e);var s=this._transitionablePaint._values[t].value.isDataDriven();return this._handleSpecialPaintPropertyUpdate(t),s||o||a},e.prototype._handleSpecialPaintPropertyUpdate=function(t){},e.prototype.isHidden=function(t){return !!(this.minzoom&&t<this.minzoom)||(!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.visibility)},e.prototype.updateTransitions=function(t){this._transitioningPaint=this._transitionablePaint.transitioned(t,this._transitioningPaint);},e.prototype.hasTransition=function(){return this._transitioningPaint.hasTransition()},e.prototype.recalculate=function(t){t.getCrossfadeParameters&&(this._crossfadeParameters=t.getCrossfadeParameters()),this._unevaluatedLayout&&(this.layout=this._unevaluatedLayout.possiblyEvaluate(t)),this.paint=this._transitioningPaint.possiblyEvaluate(t);},e.prototype.serialize=function(){var t={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:this._unevaluatedLayout&&this._unevaluatedLayout.serialize(),paint:this._transitionablePaint&&this._transitionablePaint.serialize()};return "none"===this.visibility&&(t.layout=t.layout||{},t.layout.visibility="none"),x(t,function(t,e){return !(void 0===t||"layout"===e&&!Object.keys(t).length||"paint"===e&&!Object.keys(t).length)})},e.prototype._validate=function(t,e,r,n,i){return void 0===i&&(i={}),(!i||!1!==i.validate)&&tn(this,t.call(Jr,{key:e,layerType:this.type,objectKey:r,value:n,styleSpec:mt,style:{glyphs:!0,sprite:!0}}))},e.prototype.hasOffscreenPass=function(){return !1},e.prototype.resize=function(){},e.prototype.isStateDependent=function(){for(var t in this.paint._values){var e=this.paint.get(t);if(e instanceof Vn&&er(e.property.specification)&&(("source"===e.value.kind||"composite"===e.value.kind)&&e.value.isStateDependent))return !0}return !1},e}(dt),jn={Int8:Int8Array,Uint8:Uint8Array,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array},qn=function(t,e){this._structArray=t,this._pos1=e*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8;},Rn=function(){this.isTransferred=!1,this.capacity=-1,this.resize(0);};function Nn(t,e){void 0===e&&(e=1);var r=0,n=0;return {members:t.map(function(t){var i,a=(i=t.type,jn[i].BYTES_PER_ELEMENT),o=r=Kn(r,Math.max(e,a)),s=t.components||1;return n=Math.max(n,a),r+=a*s,{name:t.name,type:t.type,components:s,offset:o}}),size:Kn(r,Math.max(n,e)),alignment:e}}function Kn(t,e){return Math.ceil(t/e)*e}Rn.serialize=function(t,e){return t._trim(),e&&(t.isTransferred=!0,e.push(t.arrayBuffer)),{length:t.length,arrayBuffer:t.arrayBuffer}},Rn.deserialize=function(t){var e=Object.create(this.prototype);return e.arrayBuffer=t.arrayBuffer,e.length=t.length,e.capacity=t.arrayBuffer.byteLength/e.bytesPerElement,e._refreshViews(),e},Rn.prototype._trim=function(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews());},Rn.prototype.clear=function(){this.length=0;},Rn.prototype.resize=function(t){this.reserve(t),this.length=t;},Rn.prototype.reserve=function(t){if(t>this.capacity){this.capacity=Math.max(t,Math.floor(5*this.capacity),128),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement);var e=this.uint8;this._refreshViews(),e&&this.uint8.set(e);}},Rn.prototype._refreshViews=function(){throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")};var Gn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.int16[n+0]=e,this.int16[n+1]=r,t},e}(Rn);Gn.prototype.bytesPerElement=4,sn("StructArrayLayout2i4",Gn);var Xn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.int16[a+0]=e,this.int16[a+1]=r,this.int16[a+2]=n,this.int16[a+3]=i,t},e}(Rn);Xn.prototype.bytesPerElement=8,sn("StructArrayLayout4i8",Xn);var Zn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}(Rn);Zn.prototype.bytesPerElement=12,sn("StructArrayLayout2i4i12",Zn);var Hn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s){var u=this.length;return this.resize(u+1),this.emplace(u,t,e,r,n,i,a,o,s)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u){var l=6*t,p=12*t;return this.int16[l+0]=e,this.int16[l+1]=r,this.int16[l+2]=n,this.int16[l+3]=i,this.uint8[p+8]=a,this.uint8[p+9]=o,this.uint8[p+10]=s,this.uint8[p+11]=u,t},e}(Rn);Hn.prototype.bytesPerElement=12,sn("StructArrayLayout4i4ub12",Hn);var Yn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s){var u=this.length;return this.resize(u+1),this.emplace(u,t,e,r,n,i,a,o,s)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u){var l=8*t;return this.uint16[l+0]=e,this.uint16[l+1]=r,this.uint16[l+2]=n,this.uint16[l+3]=i,this.uint16[l+4]=a,this.uint16[l+5]=o,this.uint16[l+6]=s,this.uint16[l+7]=u,t},e}(Rn);Yn.prototype.bytesPerElement=16,sn("StructArrayLayout8ui16",Yn);var Jn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s){var u=this.length;return this.resize(u+1),this.emplace(u,t,e,r,n,i,a,o,s)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u){var l=8*t;return this.int16[l+0]=e,this.int16[l+1]=r,this.int16[l+2]=n,this.int16[l+3]=i,this.uint16[l+4]=a,this.uint16[l+5]=o,this.uint16[l+6]=s,this.uint16[l+7]=u,t},e}(Rn);Jn.prototype.bytesPerElement=16,sn("StructArrayLayout4i4ui16",Jn);var $n=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.float32[i+0]=e,this.float32[i+1]=r,this.float32[i+2]=n,t},e}(Rn);$n.prototype.bytesPerElement=12,sn("StructArrayLayout3f12",$n);var Wn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){var r=1*t;return this.uint32[r+0]=e,t},e}(Rn);Wn.prototype.bytesPerElement=4,sn("StructArrayLayout1ul4",Wn);var Qn=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p){var c=this.length;return this.resize(c+1),this.emplace(c,t,e,r,n,i,a,o,s,u,l,p)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c){var h=12*t,f=6*t;return this.int16[h+0]=e,this.int16[h+1]=r,this.int16[h+2]=n,this.int16[h+3]=i,this.int16[h+4]=a,this.int16[h+5]=o,this.uint32[f+3]=s,this.uint16[h+8]=u,this.uint16[h+9]=l,this.int16[h+10]=p,this.int16[h+11]=c,t},e}(Rn);Qn.prototype.bytesPerElement=24,sn("StructArrayLayout6i1ul2ui2i24",Qn);var ti=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}(Rn);ti.prototype.bytesPerElement=12,sn("StructArrayLayout2i2i2i12",ti);var ei=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=4*t;return this.uint8[n+0]=e,this.uint8[n+1]=r,t},e}(Rn);ei.prototype.bytesPerElement=4,sn("StructArrayLayout2ub4",ei);var ri=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f){var y=this.length;return this.resize(y+1),this.emplace(y,t,e,r,n,i,a,o,s,u,l,p,c,h,f)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y){var d=20*t,m=10*t,v=40*t;return this.int16[d+0]=e,this.int16[d+1]=r,this.uint16[d+2]=n,this.uint16[d+3]=i,this.uint32[m+2]=a,this.uint32[m+3]=o,this.uint32[m+4]=s,this.uint16[d+10]=u,this.uint16[d+11]=l,this.uint16[d+12]=p,this.float32[m+7]=c,this.float32[m+8]=h,this.uint8[v+36]=f,this.uint8[v+37]=y,t},e}(Rn);ri.prototype.bytesPerElement=40,sn("StructArrayLayout2i2ui3ul3ui2f2ub40",ri);var ni=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f){var y=this.length;return this.resize(y+1),this.emplace(y,t,e,r,n,i,a,o,s,u,l,p,c,h,f)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y){var d=16*t,m=8*t;return this.int16[d+0]=e,this.int16[d+1]=r,this.int16[d+2]=n,this.int16[d+3]=i,this.uint16[d+4]=a,this.uint16[d+5]=o,this.uint16[d+6]=s,this.uint16[d+7]=u,this.uint16[d+8]=l,this.uint16[d+9]=p,this.uint16[d+10]=c,this.uint16[d+11]=h,this.uint16[d+12]=f,this.uint32[m+7]=y,t},e}(Rn);ni.prototype.bytesPerElement=32,sn("StructArrayLayout4i9ui1ul32",ni);var ii=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){var r=1*t;return this.float32[r+0]=e,t},e}(Rn);ii.prototype.bytesPerElement=4,sn("StructArrayLayout1f4",ii);var ai=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.int16[i+0]=e,this.int16[i+1]=r,this.int16[i+2]=n,t},e}(Rn);ai.prototype.bytesPerElement=6,sn("StructArrayLayout3i6",ai);var oi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=2*t,a=4*t;return this.uint32[i+0]=e,this.uint16[a+2]=r,this.uint16[a+3]=n,t},e}(Rn);oi.prototype.bytesPerElement=8,sn("StructArrayLayout1ul2ui8",oi);var si=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.uint16[i+0]=e,this.uint16[i+1]=r,this.uint16[i+2]=n,t},e}(Rn);si.prototype.bytesPerElement=6,sn("StructArrayLayout3ui6",si);var ui=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.uint16[n+0]=e,this.uint16[n+1]=r,t},e}(Rn);ui.prototype.bytesPerElement=4,sn("StructArrayLayout2ui4",ui);var li=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){var r=1*t;return this.uint16[r+0]=e,t},e}(Rn);li.prototype.bytesPerElement=2,sn("StructArrayLayout1ui2",li);var pi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.float32[n+0]=e,this.float32[n+1]=r,t},e}(Rn);pi.prototype.bytesPerElement=8,sn("StructArrayLayout2f8",pi);var ci=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.float32[a+0]=e,this.float32[a+1]=r,this.float32[a+2]=n,this.float32[a+3]=i,t},e}(Rn);ci.prototype.bytesPerElement=16,sn("StructArrayLayout4f16",ci);var hi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorPointX:{configurable:!0},anchorPointY:{configurable:!0},x1:{configurable:!0},y1:{configurable:!0},x2:{configurable:!0},y2:{configurable:!0},featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0},radius:{configurable:!0},signedDistanceFromAnchor:{configurable:!0},anchorPoint:{configurable:!0}};return r.anchorPointX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorPointX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorPointY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorPointY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.x1.get=function(){return this._structArray.int16[this._pos2+2]},r.x1.set=function(t){this._structArray.int16[this._pos2+2]=t;},r.y1.get=function(){return this._structArray.int16[this._pos2+3]},r.y1.set=function(t){this._structArray.int16[this._pos2+3]=t;},r.x2.get=function(){return this._structArray.int16[this._pos2+4]},r.x2.set=function(t){this._structArray.int16[this._pos2+4]=t;},r.y2.get=function(){return this._structArray.int16[this._pos2+5]},r.y2.set=function(t){this._structArray.int16[this._pos2+5]=t;},r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.featureIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t;},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+8]},r.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+8]=t;},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+9]},r.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+9]=t;},r.radius.get=function(){return this._structArray.int16[this._pos2+10]},r.radius.set=function(t){this._structArray.int16[this._pos2+10]=t;},r.signedDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+11]},r.signedDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+11]=t;},r.anchorPoint.get=function(){return new i(this.anchorPointX,this.anchorPointY)},Object.defineProperties(e.prototype,r),e}(qn);hi.prototype.size=24;var fi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new hi(this,t)},e}(Qn);sn("CollisionBoxArray",fi);var yi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorX:{configurable:!0},anchorY:{configurable:!0},glyphStartIndex:{configurable:!0},numGlyphs:{configurable:!0},vertexStartIndex:{configurable:!0},lineStartIndex:{configurable:!0},lineLength:{configurable:!0},segment:{configurable:!0},lowerSize:{configurable:!0},upperSize:{configurable:!0},lineOffsetX:{configurable:!0},lineOffsetY:{configurable:!0},writingMode:{configurable:!0},hidden:{configurable:!0}};return r.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.glyphStartIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.glyphStartIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t;},r.numGlyphs.get=function(){return this._structArray.uint16[this._pos2+3]},r.numGlyphs.set=function(t){this._structArray.uint16[this._pos2+3]=t;},r.vertexStartIndex.get=function(){return this._structArray.uint32[this._pos4+2]},r.vertexStartIndex.set=function(t){this._structArray.uint32[this._pos4+2]=t;},r.lineStartIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.lineStartIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t;},r.lineLength.get=function(){return this._structArray.uint32[this._pos4+4]},r.lineLength.set=function(t){this._structArray.uint32[this._pos4+4]=t;},r.segment.get=function(){return this._structArray.uint16[this._pos2+10]},r.segment.set=function(t){this._structArray.uint16[this._pos2+10]=t;},r.lowerSize.get=function(){return this._structArray.uint16[this._pos2+11]},r.lowerSize.set=function(t){this._structArray.uint16[this._pos2+11]=t;},r.upperSize.get=function(){return this._structArray.uint16[this._pos2+12]},r.upperSize.set=function(t){this._structArray.uint16[this._pos2+12]=t;},r.lineOffsetX.get=function(){return this._structArray.float32[this._pos4+7]},r.lineOffsetX.set=function(t){this._structArray.float32[this._pos4+7]=t;},r.lineOffsetY.get=function(){return this._structArray.float32[this._pos4+8]},r.lineOffsetY.set=function(t){this._structArray.float32[this._pos4+8]=t;},r.writingMode.get=function(){return this._structArray.uint8[this._pos1+36]},r.writingMode.set=function(t){this._structArray.uint8[this._pos1+36]=t;},r.hidden.get=function(){return this._structArray.uint8[this._pos1+37]},r.hidden.set=function(t){this._structArray.uint8[this._pos1+37]=t;},Object.defineProperties(e.prototype,r),e}(qn);yi.prototype.size=40;var di=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new yi(this,t)},e}(ri);sn("PlacedSymbolArray",di);var mi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorX:{configurable:!0},anchorY:{configurable:!0},horizontalPlacedTextSymbolIndex:{configurable:!0},verticalPlacedTextSymbolIndex:{configurable:!0},key:{configurable:!0},textBoxStartIndex:{configurable:!0},textBoxEndIndex:{configurable:!0},iconBoxStartIndex:{configurable:!0},iconBoxEndIndex:{configurable:!0},featureIndex:{configurable:!0},numGlyphVertices:{configurable:!0},numVerticalGlyphVertices:{configurable:!0},numIconVertices:{configurable:!0},crossTileID:{configurable:!0}};return r.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.horizontalPlacedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+2]},r.horizontalPlacedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+2]=t;},r.verticalPlacedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+3]},r.verticalPlacedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+3]=t;},r.key.get=function(){return this._structArray.uint16[this._pos2+4]},r.key.set=function(t){this._structArray.uint16[this._pos2+4]=t;},r.textBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+5]},r.textBoxStartIndex.set=function(t){this._structArray.uint16[this._pos2+5]=t;},r.textBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+6]},r.textBoxEndIndex.set=function(t){this._structArray.uint16[this._pos2+6]=t;},r.iconBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+7]},r.iconBoxStartIndex.set=function(t){this._structArray.uint16[this._pos2+7]=t;},r.iconBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+8]},r.iconBoxEndIndex.set=function(t){this._structArray.uint16[this._pos2+8]=t;},r.featureIndex.get=function(){return this._structArray.uint16[this._pos2+9]},r.featureIndex.set=function(t){this._structArray.uint16[this._pos2+9]=t;},r.numGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+10]},r.numGlyphVertices.set=function(t){this._structArray.uint16[this._pos2+10]=t;},r.numVerticalGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+11]},r.numVerticalGlyphVertices.set=function(t){this._structArray.uint16[this._pos2+11]=t;},r.numIconVertices.get=function(){return this._structArray.uint16[this._pos2+12]},r.numIconVertices.set=function(t){this._structArray.uint16[this._pos2+12]=t;},r.crossTileID.get=function(){return this._structArray.uint32[this._pos4+7]},r.crossTileID.set=function(t){this._structArray.uint32[this._pos4+7]=t;},Object.defineProperties(e.prototype,r),e}(qn);mi.prototype.size=32;var vi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new mi(this,t)},e}(ni);sn("SymbolInstanceArray",vi);var gi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={offsetX:{configurable:!0}};return r.offsetX.get=function(){return this._structArray.float32[this._pos4+0]},r.offsetX.set=function(t){this._structArray.float32[this._pos4+0]=t;},Object.defineProperties(e.prototype,r),e}(qn);gi.prototype.size=4;var xi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getoffsetX=function(t){return this.float32[1*t+0]},e.prototype.get=function(t){return new gi(this,t)},e}(ii);sn("GlyphOffsetArray",xi);var bi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={x:{configurable:!0},y:{configurable:!0},tileUnitDistanceFromAnchor:{configurable:!0}};return r.x.get=function(){return this._structArray.int16[this._pos2+0]},r.x.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.y.get=function(){return this._structArray.int16[this._pos2+1]},r.y.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.tileUnitDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+2]},r.tileUnitDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+2]=t;},Object.defineProperties(e.prototype,r),e}(qn);bi.prototype.size=6;var _i=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getx=function(t){return this.int16[3*t+0]},e.prototype.gety=function(t){return this.int16[3*t+1]},e.prototype.gettileUnitDistanceFromAnchor=function(t){return this.int16[3*t+2]},e.prototype.get=function(t){return new bi(this,t)},e}(ai);sn("SymbolLineVertexArray",_i);var wi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0}};return r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+0]},r.featureIndex.set=function(t){this._structArray.uint32[this._pos4+0]=t;},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t;},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+3]},r.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+3]=t;},Object.defineProperties(e.prototype,r),e}(qn);wi.prototype.size=8;var Ai=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new wi(this,t)},e}(oi);sn("FeatureIndexArray",Ai);var Si=Nn([{name:"a_pos",components:2,type:"Int16"}],4),ki=Si.members,zi=(Si.size,Si.alignment,function(t){void 0===t&&(t=[]),this.segments=t;});function Ii(t,e){return 256*(t=l(Math.floor(t),0,255))+(e=l(Math.floor(e),0,255))}zi.prototype.prepareSegment=function(t,e,r,n){var i=this.segments[this.segments.length-1];return t>zi.MAX_VERTEX_ARRAY_LENGTH&&w("Max vertices per segment is "+zi.MAX_VERTEX_ARRAY_LENGTH+": bucket requested "+t),(!i||i.vertexLength+t>zi.MAX_VERTEX_ARRAY_LENGTH||i.sortKey!==n)&&(i={vertexOffset:e.length,primitiveOffset:r.length,vertexLength:0,primitiveLength:0},void 0!==n&&(i.sortKey=n),this.segments.push(i)),i},zi.prototype.get=function(){return this.segments},zi.prototype.destroy=function(){for(var t=0,e=this.segments;t<e.length;t+=1){var r=e[t];for(var n in r.vaos)r.vaos[n].destroy();}},zi.simpleSegment=function(t,e,r,n){return new zi([{vertexOffset:t,primitiveOffset:e,vertexLength:r,primitiveLength:n,vaos:{},sortKey:0}])},zi.MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,sn("SegmentVector",zi);var Bi=function(){this.ids=[],this.positions=[],this.indexed=!1;};function Ei(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}Bi.prototype.add=function(t,e,r,n){this.ids.push(t),this.positions.push(e,r,n);},Bi.prototype.getPositions=function(t){for(var e=0,r=this.ids.length-1;e<r;){var n=e+r>>1;this.ids[n]>=t?r=n:e=n+1;}for(var i=[];this.ids[e]===t;){var a=this.positions[3*e],o=this.positions[3*e+1],s=this.positions[3*e+2];i.push({index:a,start:o,end:s}),e++;}return i},Bi.serialize=function(t,e){var r=new Float64Array(t.ids),n=new Uint32Array(t.positions);return function t(e,r,n,i){if(n>=i)return;var a=e[n+i>>1];var o=n-1;var s=i+1;for(;;){do{o++;}while(e[o]<a);do{s--;}while(e[s]>a);if(o>=s)break;Ei(e,o,s),Ei(r,3*o,3*s),Ei(r,3*o+1,3*s+1),Ei(r,3*o+2,3*s+2);}t(e,r,n,s);t(e,r,s+1,i);}(r,n,0,r.length-1),e.push(r.buffer,n.buffer),{ids:r,positions:n}},Bi.deserialize=function(t){var e=new Bi;return e.ids=t.ids,e.positions=t.positions,e.indexed=!0,e},sn("FeaturePositionMap",Bi);var Pi=function(t,e){this.gl=t.gl,this.location=e;},Vi=function(t){function e(e,r){t.call(this,e,r),this.current=0;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1i(this.location,t));},e}(Pi),Ci=function(t){function e(e,r){t.call(this,e,r),this.current=0;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1f(this.location,t));},e}(Pi),Mi=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0];}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]||(this.current=t,this.gl.uniform2f(this.location,t[0],t[1]));},e}(Pi),Ti=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0,0];}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]||(this.current=t,this.gl.uniform3f(this.location,t[0],t[1],t[2]));},e}(Pi),Fi=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0,0,0];}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]&&t[3]===this.current[3]||(this.current=t,this.gl.uniform4f(this.location,t[0],t[1],t[2],t[3]));},e}(Pi),Li=function(t){function e(e,r){t.call(this,e,r),this.current=Dt.transparent;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t.r===this.current.r&&t.g===this.current.g&&t.b===this.current.b&&t.a===this.current.a||(this.current=t,this.gl.uniform4f(this.location,t.r,t.g,t.b,t.a));},e}(Pi),Oi=new Float32Array(16),Di=function(t){function e(e,r){t.call(this,e,r),this.current=Oi;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(t[12]!==this.current[12]||t[0]!==this.current[0])return this.current=t,void this.gl.uniformMatrix4fv(this.location,!1,t);for(var e=1;e<16;e++)if(t[e]!==this.current[e]){this.current=t,this.gl.uniformMatrix4fv(this.location,!1,t);break}},e}(Pi);function Ui(t){return [Ii(255*t.r,255*t.g),Ii(255*t.b,255*t.a)]}var ji=function(t,e,r){this.value=t,this.names=e,this.uniformNames=this.names.map(function(t){return "u_"+t}),this.type=r,this.maxValue=-1/0;};ji.prototype.defines=function(){return this.names.map(function(t){return "#define HAS_UNIFORM_u_"+t})},ji.prototype.setConstantPatternPositions=function(){},ji.prototype.populatePaintArray=function(){},ji.prototype.updatePaintArray=function(){},ji.prototype.upload=function(){},ji.prototype.destroy=function(){},ji.prototype.setUniforms=function(t,e,r,n){e.set(n.constantOr(this.value));},ji.prototype.getBinding=function(t,e){return "color"===this.type?new Li(t,e):new Ci(t,e)},ji.serialize=function(t){var e=t.value,r=t.names,n=t.type;return {value:ln(e),names:r,type:n}},ji.deserialize=function(t){var e=t.value,r=t.names,n=t.type;return new ji(pn(e),r,n)};var qi=function(t,e,r){this.value=t,this.names=e,this.uniformNames=this.names.map(function(t){return "u_"+t}),this.type=r,this.maxValue=-1/0,this.patternPositions={patternTo:null,patternFrom:null};};qi.prototype.defines=function(){return this.names.map(function(t){return "#define HAS_UNIFORM_u_"+t})},qi.prototype.populatePaintArray=function(){},qi.prototype.updatePaintArray=function(){},qi.prototype.upload=function(){},qi.prototype.destroy=function(){},qi.prototype.setConstantPatternPositions=function(t,e){this.patternPositions.patternTo=t.tlbr,this.patternPositions.patternFrom=e.tlbr;},qi.prototype.setUniforms=function(t,e,r,n,i){var a=this.patternPositions;"u_pattern_to"===i&&a.patternTo&&e.set(a.patternTo),"u_pattern_from"===i&&a.patternFrom&&e.set(a.patternFrom);},qi.prototype.getBinding=function(t,e){return new Fi(t,e)};var Ri=function(t,e,r,n){this.expression=t,this.names=e,this.type=r,this.uniformNames=this.names.map(function(t){return "a_"+t}),this.maxValue=-1/0,this.paintVertexAttributes=e.map(function(t){return {name:"a_"+t,type:"Float32",components:"color"===r?2:1,offset:0}}),this.paintVertexArray=new n;};Ri.prototype.defines=function(){return []},Ri.prototype.setConstantPatternPositions=function(){},Ri.prototype.populatePaintArray=function(t,e){var r=this.paintVertexArray,n=r.length;r.reserve(t);var i=this.expression.evaluate(new Sn(0),e,{});if("color"===this.type)for(var a=Ui(i),o=n;o<t;o++)r.emplaceBack(a[0],a[1]);else{for(var s=n;s<t;s++)r.emplaceBack(i);this.maxValue=Math.max(this.maxValue,i);}},Ri.prototype.updatePaintArray=function(t,e,r,n){var i=this.paintVertexArray,a=this.expression.evaluate({zoom:0},r,n);if("color"===this.type)for(var o=Ui(a),s=t;s<e;s++)i.emplace(s,o[0],o[1]);else{for(var u=t;u<e;u++)i.emplace(u,a);this.maxValue=Math.max(this.maxValue,a);}},Ri.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Ri.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();},Ri.prototype.setUniforms=function(t,e){e.set(0);},Ri.prototype.getBinding=function(t,e){return new Ci(t,e)};var Ni=function(t,e,r,n,i,a){this.expression=t,this.names=e,this.uniformNames=this.names.map(function(t){return "a_"+t+"_t"}),this.type=r,this.useIntegerZoom=n,this.zoom=i,this.maxValue=-1/0;var o=a;this.paintVertexAttributes=e.map(function(t){return {name:"a_"+t,type:"Float32",components:"color"===r?4:2,offset:0}}),this.paintVertexArray=new o;};Ni.prototype.defines=function(){return []},Ni.prototype.setConstantPatternPositions=function(){},Ni.prototype.populatePaintArray=function(t,e){var r=this.paintVertexArray,n=r.length;r.reserve(t);var i=this.expression.evaluate(new Sn(this.zoom),e,{}),a=this.expression.evaluate(new Sn(this.zoom+1),e,{});if("color"===this.type)for(var o=Ui(i),s=Ui(a),u=n;u<t;u++)r.emplaceBack(o[0],o[1],s[0],s[1]);else{for(var l=n;l<t;l++)r.emplaceBack(i,a);this.maxValue=Math.max(this.maxValue,i,a);}},Ni.prototype.updatePaintArray=function(t,e,r,n){var i=this.paintVertexArray,a=this.expression.evaluate({zoom:this.zoom},r,n),o=this.expression.evaluate({zoom:this.zoom+1},r,n);if("color"===this.type)for(var s=Ui(a),u=Ui(o),l=t;l<e;l++)i.emplace(l,s[0],s[1],u[0],u[1]);else{for(var p=t;p<e;p++)i.emplace(p,a,o);this.maxValue=Math.max(this.maxValue,a,o);}},Ni.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Ni.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();},Ni.prototype.interpolationFactor=function(t){return this.useIntegerZoom?this.expression.interpolationFactor(Math.floor(t),this.zoom,this.zoom+1):this.expression.interpolationFactor(t,this.zoom,this.zoom+1)},Ni.prototype.setUniforms=function(t,e,r){e.set(this.interpolationFactor(r.zoom));},Ni.prototype.getBinding=function(t,e){return new Ci(t,e)};var Ki=function(t,e,r,n,i,a,o){this.expression=t,this.names=e,this.type=r,this.uniformNames=this.names.map(function(t){return "a_"+t+"_t"}),this.useIntegerZoom=n,this.zoom=i,this.maxValue=-1/0,this.layerId=o,this.paintVertexAttributes=e.map(function(t){return {name:"a_"+t,type:"Uint16",components:4,offset:0}}),this.zoomInPaintVertexArray=new a,this.zoomOutPaintVertexArray=new a;};Ki.prototype.defines=function(){return []},Ki.prototype.setConstantPatternPositions=function(){},Ki.prototype.populatePaintArray=function(t,e,r){var n=this.zoomInPaintVertexArray,i=this.zoomOutPaintVertexArray,a=this.layerId,o=n.length;if(n.reserve(t),i.reserve(t),r&&e.patterns&&e.patterns[a]){var s=e.patterns[a],u=s.min,l=s.mid,p=s.max,c=r[u],h=r[l],f=r[p];if(!c||!h||!f)return;for(var y=o;y<t;y++)n.emplaceBack(h.tl[0],h.tl[1],h.br[0],h.br[1],c.tl[0],c.tl[1],c.br[0],c.br[1]),i.emplaceBack(h.tl[0],h.tl[1],h.br[0],h.br[1],f.tl[0],f.tl[1],f.br[0],f.br[1]);}},Ki.prototype.updatePaintArray=function(t,e,r,n,i){var a=this.zoomInPaintVertexArray,o=this.zoomOutPaintVertexArray,s=this.layerId;if(i&&r.patterns&&r.patterns[s]){var u=r.patterns[s],l=u.min,p=u.mid,c=u.max,h=i[l],f=i[p],y=i[c];if(!h||!f||!y)return;for(var d=t;d<e;d++)a.emplace(d,f.tl[0],f.tl[1],f.br[0],f.br[1],h.tl[0],h.tl[1],h.br[0],h.br[1]),o.emplace(d,f.tl[0],f.tl[1],f.br[0],f.br[1],y.tl[0],y.tl[1],y.br[0],y.br[1]);}},Ki.prototype.upload=function(t){this.zoomInPaintVertexArray&&this.zoomInPaintVertexArray.arrayBuffer&&this.zoomOutPaintVertexArray&&this.zoomOutPaintVertexArray.arrayBuffer&&(this.zoomInPaintVertexBuffer=t.createVertexBuffer(this.zoomInPaintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent),this.zoomOutPaintVertexBuffer=t.createVertexBuffer(this.zoomOutPaintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Ki.prototype.destroy=function(){this.zoomOutPaintVertexBuffer&&this.zoomOutPaintVertexBuffer.destroy(),this.zoomInPaintVertexBuffer&&this.zoomInPaintVertexBuffer.destroy();},Ki.prototype.setUniforms=function(t,e){e.set(0);},Ki.prototype.getBinding=function(t,e){return new Ci(t,e)};var Gi=function(){this.binders={},this.cacheKey="",this._buffers=[],this._featureMap=new Bi,this._bufferOffset=0;};Gi.createDynamic=function(t,e,r){var n=new Gi,i=[];for(var a in t.paint._values)if(r(a)){var o=t.paint.get(a);if(o instanceof Vn&&er(o.property.specification)){var s=Zi(a,t.type),u=o.property.specification.type,l=o.property.useIntegerZoom;if("cross-faded"===o.property.specification["property-type"]||"cross-faded-data-driven"===o.property.specification["property-type"])if("constant"===o.value.kind)n.binders[a]=new qi(o.value.value,s,u),i.push("/u_"+a);else{var p=Hi(a,u,"source");n.binders[a]=new Ki(o.value,s,u,l,e,p,t.id),i.push("/a_"+a);}else if("constant"===o.value.kind)n.binders[a]=new ji(o.value.value,s,u),i.push("/u_"+a);else if("source"===o.value.kind){var c=Hi(a,u,"source");n.binders[a]=new Ri(o.value,s,u,c),i.push("/a_"+a);}else{var h=Hi(a,u,"composite");n.binders[a]=new Ni(o.value,s,u,l,e,h),i.push("/z_"+a);}}}return n.cacheKey=i.sort().join(""),n},Gi.prototype.populatePaintArrays=function(t,e,r,n){for(var i in this.binders){this.binders[i].populatePaintArray(t,e,n);}void 0!==e.id&&this._featureMap.add(+e.id,r,this._bufferOffset,t),this._bufferOffset=t;},Gi.prototype.setConstantPatternPositions=function(t,e){for(var r in this.binders){this.binders[r].setConstantPatternPositions(t,e);}},Gi.prototype.updatePaintArrays=function(t,e,r,n){var i=!1;for(var a in t)for(var o=0,s=this._featureMap.getPositions(+a);o<s.length;o+=1){var u=s[o],l=e.feature(u.index);for(var p in this.binders){var c=this.binders[p];if(!(c instanceof ji||c instanceof qi)&&!0===c.expression.isStateDependent){var h=r.paint.get(p);c.expression=h.value,c.updatePaintArray(u.start,u.end,l,t[a],n),i=!0;}}}return i},Gi.prototype.defines=function(){var t=[];for(var e in this.binders)t.push.apply(t,this.binders[e].defines());return t},Gi.prototype.getPaintVertexBuffers=function(){return this._buffers},Gi.prototype.getUniforms=function(t,e){var r={};for(var n in this.binders)for(var i=this.binders[n],a=0,o=i.uniformNames;a<o.length;a+=1){var s=o[a];r[s]=i.getBinding(t,e[s]);}return r},Gi.prototype.setUniforms=function(t,e,r,n){for(var i in this.binders)for(var a=this.binders[i],o=0,s=a.uniformNames;o<s.length;o+=1){var u=s[o];a.setUniforms(t,e[u],n,r.get(i),u);}},Gi.prototype.updatePatternPaintBuffers=function(t){var e=[];for(var r in this.binders){var n=this.binders[r];if(n instanceof Ki){var i=2===t.fromScale?n.zoomInPaintVertexBuffer:n.zoomOutPaintVertexBuffer;i&&e.push(i);}else(n instanceof Ri||n instanceof Ni)&&n.paintVertexBuffer&&e.push(n.paintVertexBuffer);}this._buffers=e;},Gi.prototype.upload=function(t){for(var e in this.binders)this.binders[e].upload(t);var r=[];for(var n in this.binders){var i=this.binders[n];(i instanceof Ri||i instanceof Ni)&&i.paintVertexBuffer&&r.push(i.paintVertexBuffer);}this._buffers=r;},Gi.prototype.destroy=function(){for(var t in this.binders)this.binders[t].destroy();};var Xi=function(t,e,r,n){void 0===n&&(n=function(){return !0}),this.programConfigurations={};for(var i=0,a=e;i<a.length;i+=1){var o=a[i];this.programConfigurations[o.id]=Gi.createDynamic(o,r,n),this.programConfigurations[o.id].layoutAttributes=t;}this.needsUpload=!1;};function Zi(t,e){return {"text-opacity":["opacity"],"icon-opacity":["opacity"],"text-color":["fill_color"],"icon-color":["fill_color"],"text-halo-color":["halo_color"],"icon-halo-color":["halo_color"],"text-halo-blur":["halo_blur"],"icon-halo-blur":["halo_blur"],"text-halo-width":["halo_width"],"icon-halo-width":["halo_width"],"line-gap-width":["gapwidth"],"line-pattern":["pattern_to","pattern_from"],"fill-pattern":["pattern_to","pattern_from"],"fill-extrusion-pattern":["pattern_to","pattern_from"]}[t]||[t.replace(e+"-","").replace(/-/g,"_")]}function Hi(t,e,r){var n={color:{source:pi,composite:ci},number:{source:ii,composite:pi}},i=function(t){return {"line-pattern":{source:Yn,composite:Yn},"fill-pattern":{source:Yn,composite:Yn},"fill-extrusion-pattern":{source:Yn,composite:Yn}}[t]}(t);return i&&i[r]||n[e][r]}Xi.prototype.populatePaintArrays=function(t,e,r,n){for(var i in this.programConfigurations)this.programConfigurations[i].populatePaintArrays(t,e,r,n);this.needsUpload=!0;},Xi.prototype.updatePaintArrays=function(t,e,r,n){for(var i=0,a=r;i<a.length;i+=1){var o=a[i];this.needsUpload=this.programConfigurations[o.id].updatePaintArrays(t,e,o,n)||this.needsUpload;}},Xi.prototype.get=function(t){return this.programConfigurations[t]},Xi.prototype.upload=function(t){if(this.needsUpload){for(var e in this.programConfigurations)this.programConfigurations[e].upload(t);this.needsUpload=!1;}},Xi.prototype.destroy=function(){for(var t in this.programConfigurations)this.programConfigurations[t].destroy();},sn("ConstantBinder",ji),sn("CrossFadedConstantBinder",qi),sn("SourceExpressionBinder",Ri),sn("CrossFadedCompositeBinder",Ki),sn("CompositeExpressionBinder",Ni),sn("ProgramConfiguration",Gi,{omit:["_buffers"]}),sn("ProgramConfigurationSet",Xi);var Yi=8192;var Ji,$i=(Ji=16,{min:-1*Math.pow(2,Ji-1),max:Math.pow(2,Ji-1)-1});function Wi(t){for(var e=Yi/t.extent,r=t.loadGeometry(),n=0;n<r.length;n++)for(var i=r[n],a=0;a<i.length;a++){var o=i[a];o.x=Math.round(o.x*e),o.y=Math.round(o.y*e),(o.x<$i.min||o.x>$i.max||o.y<$i.min||o.y>$i.max)&&w("Geometry exceeds allowed extent, reduce your vector tile buffer size");}return r}function Qi(t,e,r,n,i){t.emplaceBack(2*e+(n+1)/2,2*r+(i+1)/2);}var ta=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new Gn,this.indexArray=new si,this.segments=new zi,this.programConfigurations=new Xi(ki,t.layers,t.zoom),this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id});};function ea(t,e){for(var r=0;r<t.length;r++)if(pa(e,t[r]))return !0;for(var n=0;n<e.length;n++)if(pa(t,e[n]))return !0;return !!aa(t,e)}function ra(t,e,r){return !!pa(t,e)||!!sa(e,t,r)}function na(t,e){if(1===t.length)return la(e,t[0]);for(var r=0;r<e.length;r++)for(var n=e[r],i=0;i<n.length;i++)if(pa(t,n[i]))return !0;for(var a=0;a<t.length;a++)if(la(e,t[a]))return !0;for(var o=0;o<e.length;o++)if(aa(t,e[o]))return !0;return !1}function ia(t,e,r){if(t.length>1){if(aa(t,e))return !0;for(var n=0;n<e.length;n++)if(sa(e[n],t,r))return !0}for(var i=0;i<t.length;i++)if(sa(t[i],e,r))return !0;return !1}function aa(t,e){if(0===t.length||0===e.length)return !1;for(var r=0;r<t.length-1;r++)for(var n=t[r],i=t[r+1],a=0;a<e.length-1;a++){if(oa(n,i,e[a],e[a+1]))return !0}return !1}function oa(t,e,r,n){return A(t,r,n)!==A(e,r,n)&&A(t,e,r)!==A(t,e,n)}function sa(t,e,r){var n=r*r;if(1===e.length)return t.distSqr(e[0])<n;for(var i=1;i<e.length;i++){if(ua(t,e[i-1],e[i])<n)return !0}return !1}function ua(t,e,r){var n=e.distSqr(r);if(0===n)return t.distSqr(e);var i=((t.x-e.x)*(r.x-e.x)+(t.y-e.y)*(r.y-e.y))/n;return i<0?t.distSqr(e):i>1?t.distSqr(r):t.distSqr(r.sub(e)._mult(i)._add(e))}function la(t,e){for(var r,n,i,a=!1,o=0;o<t.length;o++)for(var s=0,u=(r=t[o]).length-1;s<r.length;u=s++)n=r[s],i=r[u],n.y>e.y!=i.y>e.y&&e.x<(i.x-n.x)*(e.y-n.y)/(i.y-n.y)+n.x&&(a=!a);return a}function pa(t,e){for(var r=!1,n=0,i=t.length-1;n<t.length;i=n++){var a=t[n],o=t[i];a.y>e.y!=o.y>e.y&&e.x<(o.x-a.x)*(e.y-a.y)/(o.y-a.y)+a.x&&(r=!r);}return r}function ca(t,e,r){var n=r[0],i=r[2];if(t.x<n.x&&e.x<n.x||t.x>i.x&&e.x>i.x||t.y<n.y&&e.y<n.y||t.y>i.y&&e.y>i.y)return !1;var a=A(t,e,r[0]);return a!==A(t,e,r[1])||a!==A(t,e,r[2])||a!==A(t,e,r[3])}function ha(t,e,r){var n=e.paint.get(t).value;return "constant"===n.kind?n.value:r.programConfigurations.get(e.id).binders[t].maxValue}function fa(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])}function ya(t,e,r,n,a){if(!e[0]&&!e[1])return t;var o=i.convert(e)._mult(a);"viewport"===r&&o._rotate(-n);for(var s=[],u=0;u<t.length;u++){var l=t[u];s.push(l.sub(o));}return s}ta.prototype.populate=function(t,e){for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.index,s=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new Sn(this.zoom),a)){var u=Wi(a);this.addFeature(a,u,o),e.featureIndex.insert(a,u,o,s,this.index);}}},ta.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},ta.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},ta.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},ta.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,ki),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},ta.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},ta.prototype.addFeature=function(t,e,r){for(var n=0,i=e;n<i.length;n+=1)for(var a=0,o=i[n];a<o.length;a+=1){var s=o[a],u=s.x,l=s.y;if(!(u<0||u>=Yi||l<0||l>=Yi)){var p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray),c=p.vertexLength;Qi(this.layoutVertexArray,u,l,-1,-1),Qi(this.layoutVertexArray,u,l,1,-1),Qi(this.layoutVertexArray,u,l,1,1),Qi(this.layoutVertexArray,u,l,-1,1),this.indexArray.emplaceBack(c,c+1,c+2),this.indexArray.emplaceBack(c,c+3,c+2),p.vertexLength+=4,p.primitiveLength+=2;}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,{});},sn("CircleBucket",ta,{omit:["layers"]});var da={paint:new Dn({"circle-radius":new Tn(mt.paint_circle["circle-radius"]),"circle-color":new Tn(mt.paint_circle["circle-color"]),"circle-blur":new Tn(mt.paint_circle["circle-blur"]),"circle-opacity":new Tn(mt.paint_circle["circle-opacity"]),"circle-translate":new Mn(mt.paint_circle["circle-translate"]),"circle-translate-anchor":new Mn(mt.paint_circle["circle-translate-anchor"]),"circle-pitch-scale":new Mn(mt.paint_circle["circle-pitch-scale"]),"circle-pitch-alignment":new Mn(mt.paint_circle["circle-pitch-alignment"]),"circle-stroke-width":new Tn(mt.paint_circle["circle-stroke-width"]),"circle-stroke-color":new Tn(mt.paint_circle["circle-stroke-color"]),"circle-stroke-opacity":new Tn(mt.paint_circle["circle-stroke-opacity"])})},ma=1e-6,va="undefined"!=typeof Float32Array?Float32Array:Array;Math.PI;function ga(){var t=new va(9);return va!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[5]=0,t[6]=0,t[7]=0),t[0]=1,t[4]=1,t[8]=1,t}function xa(){var t=new va(3);return va!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t}function ba(t,e,r){var n=new va(3);return n[0]=t,n[1]=e,n[2]=r,n}function _a(t,e,r){var n=e[0],i=e[1],a=e[2],o=r[0],s=r[1],u=r[2];return t[0]=i*u-a*s,t[1]=a*o-n*u,t[2]=n*s-i*o,t}var wa,Aa=function(t){var e=t[0],r=t[1],n=t[2];return Math.sqrt(e*e+r*r+n*n)};wa=xa();function Sa(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3];return t[0]=r[0]*n+r[4]*i+r[8]*a+r[12]*o,t[1]=r[1]*n+r[5]*i+r[9]*a+r[13]*o,t[2]=r[2]*n+r[6]*i+r[10]*a+r[14]*o,t[3]=r[3]*n+r[7]*i+r[11]*a+r[15]*o,t}!function(){var t,e=(t=new va(4),va!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0,t[3]=0),t);}();function ka(){var t=new va(4);return va!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t[3]=1,t}function za(t,e,r,n){var i,a,o,s,u,l=e[0],p=e[1],c=e[2],h=e[3],f=r[0],y=r[1],d=r[2],m=r[3];return (a=l*f+p*y+c*d+h*m)<0&&(a=-a,f=-f,y=-y,d=-d,m=-m),1-a>ma?(i=Math.acos(a),o=Math.sin(i),s=Math.sin((1-n)*i)/o,u=Math.sin(n*i)/o):(s=1-n,u=n),t[0]=s*l+u*f,t[1]=s*p+u*y,t[2]=s*c+u*d,t[3]=s*h+u*m,t}var Ia,Ba,Ea,Pa,Va,Ca,Ma=function(t,e){var r=e[0],n=e[1],i=e[2],a=e[3],o=r*r+n*n+i*i+a*a;return o>0&&(o=1/Math.sqrt(o)),t[0]=r*o,t[1]=n*o,t[2]=i*o,t[3]=a*o,t};Ia=xa(),Ba=ba(1,0,0),Ea=ba(0,1,0),Pa=ka(),Va=ka(),Ca=ga();!function(){var t,e=(t=new va(2),va!=Float32Array&&(t[0]=0,t[1]=0),t);}();var Ta=function(t){function e(e){t.call(this,e,da);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new ta(t)},e.prototype.queryRadius=function(t){var e=t;return ha("circle-radius",this,e)+ha("circle-stroke-width",this,e)+fa(this.paint.get("circle-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o,s){for(var u=ya(t,this.paint.get("circle-translate"),this.paint.get("circle-translate-anchor"),a.angle,o),l=this.paint.get("circle-radius").evaluate(e,r)+this.paint.get("circle-stroke-width").evaluate(e,r),p="map"===this.paint.get("circle-pitch-alignment"),c=p?u:function(t,e){return t.map(function(t){return Fa(t,e)})}(u,s),h=p?l*o:l,f=0,y=n;f<y.length;f+=1)for(var d=0,m=y[f];d<m.length;d+=1){var v=m[d],g=p?v:Fa(v,s),x=h,b=Sa([],[v.x,v.y,0,1],s);if("viewport"===this.paint.get("circle-pitch-scale")&&"map"===this.paint.get("circle-pitch-alignment")?x*=b[3]/a.cameraToCenterDistance:"map"===this.paint.get("circle-pitch-scale")&&"viewport"===this.paint.get("circle-pitch-alignment")&&(x*=a.cameraToCenterDistance/b[3]),ra(c,g,x))return !0}return !1},e}(Un);function Fa(t,e){var r=Sa([],[t.x,t.y,0,1],e);return new i(r[0]/r[3],r[1]/r[3])}var La=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(ta);function Oa(t,e,r,n){var i=e.width,a=e.height;if(n){if(n.length!==i*a*r)throw new RangeError("mismatched image size")}else n=new Uint8Array(i*a*r);return t.width=i,t.height=a,t.data=n,t}function Da(t,e,r){var n=e.width,i=e.height;if(n!==t.width||i!==t.height){var a=Oa({},{width:n,height:i},r);Ua(t,a,{x:0,y:0},{x:0,y:0},{width:Math.min(t.width,n),height:Math.min(t.height,i)},r),t.width=n,t.height=i,t.data=a.data;}}function Ua(t,e,r,n,i,a){if(0===i.width||0===i.height)return e;if(i.width>t.width||i.height>t.height||r.x>t.width-i.width||r.y>t.height-i.height)throw new RangeError("out of range source coordinates for image copy");if(i.width>e.width||i.height>e.height||n.x>e.width-i.width||n.y>e.height-i.height)throw new RangeError("out of range destination coordinates for image copy");for(var o=t.data,s=e.data,u=0;u<i.height;u++)for(var l=((r.y+u)*t.width+r.x)*a,p=((n.y+u)*e.width+n.x)*a,c=0;c<i.width*a;c++)s[p+c]=o[l+c];return e}sn("HeatmapBucket",La,{omit:["layers"]});var ja=function(t,e){Oa(this,t,1,e);};ja.prototype.resize=function(t){Da(this,t,1);},ja.prototype.clone=function(){return new ja({width:this.width,height:this.height},new Uint8Array(this.data))},ja.copy=function(t,e,r,n,i){Ua(t,e,r,n,i,1);};var qa=function(t,e){Oa(this,t,4,e);};qa.prototype.resize=function(t){Da(this,t,4);},qa.prototype.clone=function(){return new qa({width:this.width,height:this.height},new Uint8Array(this.data))},qa.copy=function(t,e,r,n,i){Ua(t,e,r,n,i,4);},sn("AlphaImage",ja),sn("RGBAImage",qa);var Ra={paint:new Dn({"heatmap-radius":new Tn(mt.paint_heatmap["heatmap-radius"]),"heatmap-weight":new Tn(mt.paint_heatmap["heatmap-weight"]),"heatmap-intensity":new Mn(mt.paint_heatmap["heatmap-intensity"]),"heatmap-color":new On(mt.paint_heatmap["heatmap-color"]),"heatmap-opacity":new Mn(mt.paint_heatmap["heatmap-opacity"])})};function Na(t,e){for(var r=new Uint8Array(1024),n={},i=0,a=0;i<256;i++,a+=4){n[e]=i/255;var o=t.evaluate(n);r[a+0]=Math.floor(255*o.r/o.a),r[a+1]=Math.floor(255*o.g/o.a),r[a+2]=Math.floor(255*o.b/o.a),r[a+3]=Math.floor(255*o.a);}return new qa({width:256,height:1},r)}var Ka=function(t){function e(e){t.call(this,e,Ra),this._updateColorRamp();}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new La(t)},e.prototype._handleSpecialPaintPropertyUpdate=function(t){"heatmap-color"===t&&this._updateColorRamp();},e.prototype._updateColorRamp=function(){var t=this._transitionablePaint._values["heatmap-color"].value.expression;this.colorRamp=Na(t,"heatmapDensity"),this.colorRampTexture=null;},e.prototype.resize=function(){this.heatmapFbo&&(this.heatmapFbo.destroy(),this.heatmapFbo=null);},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("heatmap-opacity")&&"none"!==this.visibility},e}(Un),Ga={paint:new Dn({"hillshade-illumination-direction":new Mn(mt.paint_hillshade["hillshade-illumination-direction"]),"hillshade-illumination-anchor":new Mn(mt.paint_hillshade["hillshade-illumination-anchor"]),"hillshade-exaggeration":new Mn(mt.paint_hillshade["hillshade-exaggeration"]),"hillshade-shadow-color":new Mn(mt.paint_hillshade["hillshade-shadow-color"]),"hillshade-highlight-color":new Mn(mt.paint_hillshade["hillshade-highlight-color"]),"hillshade-accent-color":new Mn(mt.paint_hillshade["hillshade-accent-color"])})},Xa=function(t){function e(e){t.call(this,e,Ga);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("hillshade-exaggeration")&&"none"!==this.visibility},e}(Un),Za=Nn([{name:"a_pos",components:2,type:"Int16"}],4),Ha=Za.members,Ya=(Za.size,Za.alignment,$a),Ja=$a;function $a(t,e,r){r=r||2;var n,i,a,o,s,u,l,p=e&&e.length,c=p?e[0]*r:t.length,h=Wa(t,0,c,r,!0),f=[];if(!h||h.next===h.prev)return f;if(p&&(h=function(t,e,r,n){var i,a,o,s,u,l=[];for(i=0,a=e.length;i<a;i++)o=e[i]*n,s=i<a-1?e[i+1]*n:t.length,(u=Wa(t,o,s,n,!1))===u.next&&(u.steiner=!0),l.push(uo(u));for(l.sort(ao),i=0;i<l.length;i++)oo(l[i],r),r=Qa(r,r.next);return r}(t,e,h,r)),t.length>80*r){n=a=t[0],i=o=t[1];for(var y=r;y<c;y+=r)(s=t[y])<n&&(n=s),(u=t[y+1])<i&&(i=u),s>a&&(a=s),u>o&&(o=u);l=0!==(l=Math.max(a-n,o-i))?1/l:0;}return to(h,f,r,n,i,l),f}function Wa(t,e,r,n,i){var a,o;if(i===bo(t,e,r,n)>0)for(a=e;a<r;a+=n)o=vo(a,t[a],t[a+1],o);else for(a=r-n;a>=e;a-=n)o=vo(a,t[a],t[a+1],o);return o&&ho(o,o.next)&&(go(o),o=o.next),o}function Qa(t,e){if(!t)return t;e||(e=t);var r,n=t;do{if(r=!1,n.steiner||!ho(n,n.next)&&0!==co(n.prev,n,n.next))n=n.next;else{if(go(n),(n=e=n.prev)===n.next)break;r=!0;}}while(r||n!==e);return e}function to(t,e,r,n,i,a,o){if(t){!o&&a&&function(t,e,r,n){var i=t;do{null===i.z&&(i.z=so(i.x,i.y,e,r,n)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next;}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){var e,r,n,i,a,o,s,u,l=1;do{for(r=t,t=null,a=null,o=0;r;){for(o++,n=r,s=0,e=0;e<l&&(s++,n=n.nextZ);e++);for(u=l;s>0||u>0&&n;)0!==s&&(0===u||!n||r.z<=n.z)?(i=r,r=r.nextZ,s--):(i=n,n=n.nextZ,u--),a?a.nextZ=i:t=i,i.prevZ=a,a=i;r=n;}a.nextZ=null,l*=2;}while(o>1)}(i);}(t,n,i,a);for(var s,u,l=t;t.prev!==t.next;)if(s=t.prev,u=t.next,a?ro(t,n,i,a):eo(t))e.push(s.i/r),e.push(t.i/r),e.push(u.i/r),go(t),t=u.next,l=u.next;else if((t=u)===l){o?1===o?to(t=no(t,e,r),e,r,n,i,a,2):2===o&&io(t,e,r,n,i,a):to(Qa(t),e,r,n,i,a,1);break}}}function eo(t){var e=t.prev,r=t,n=t.next;if(co(e,r,n)>=0)return !1;for(var i=t.next.next;i!==t.prev;){if(lo(e.x,e.y,r.x,r.y,n.x,n.y,i.x,i.y)&&co(i.prev,i,i.next)>=0)return !1;i=i.next;}return !0}function ro(t,e,r,n){var i=t.prev,a=t,o=t.next;if(co(i,a,o)>=0)return !1;for(var s=i.x<a.x?i.x<o.x?i.x:o.x:a.x<o.x?a.x:o.x,u=i.y<a.y?i.y<o.y?i.y:o.y:a.y<o.y?a.y:o.y,l=i.x>a.x?i.x>o.x?i.x:o.x:a.x>o.x?a.x:o.x,p=i.y>a.y?i.y>o.y?i.y:o.y:a.y>o.y?a.y:o.y,c=so(s,u,e,r,n),h=so(l,p,e,r,n),f=t.prevZ,y=t.nextZ;f&&f.z>=c&&y&&y.z<=h;){if(f!==t.prev&&f!==t.next&&lo(i.x,i.y,a.x,a.y,o.x,o.y,f.x,f.y)&&co(f.prev,f,f.next)>=0)return !1;if(f=f.prevZ,y!==t.prev&&y!==t.next&&lo(i.x,i.y,a.x,a.y,o.x,o.y,y.x,y.y)&&co(y.prev,y,y.next)>=0)return !1;y=y.nextZ;}for(;f&&f.z>=c;){if(f!==t.prev&&f!==t.next&&lo(i.x,i.y,a.x,a.y,o.x,o.y,f.x,f.y)&&co(f.prev,f,f.next)>=0)return !1;f=f.prevZ;}for(;y&&y.z<=h;){if(y!==t.prev&&y!==t.next&&lo(i.x,i.y,a.x,a.y,o.x,o.y,y.x,y.y)&&co(y.prev,y,y.next)>=0)return !1;y=y.nextZ;}return !0}function no(t,e,r){var n=t;do{var i=n.prev,a=n.next.next;!ho(i,a)&&fo(i,n,n.next,a)&&yo(i,a)&&yo(a,i)&&(e.push(i.i/r),e.push(n.i/r),e.push(a.i/r),go(n),go(n.next),n=t=a),n=n.next;}while(n!==t);return n}function io(t,e,r,n,i,a){var o=t;do{for(var s=o.next.next;s!==o.prev;){if(o.i!==s.i&&po(o,s)){var u=mo(o,s);return o=Qa(o,o.next),u=Qa(u,u.next),to(o,e,r,n,i,a),void to(u,e,r,n,i,a)}s=s.next;}o=o.next;}while(o!==t)}function ao(t,e){return t.x-e.x}function oo(t,e){if(e=function(t,e){var r,n=e,i=t.x,a=t.y,o=-1/0;do{if(a<=n.y&&a>=n.next.y&&n.next.y!==n.y){var s=n.x+(a-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(s<=i&&s>o){if(o=s,s===i){if(a===n.y)return n;if(a===n.next.y)return n.next}r=n.x<n.next.x?n:n.next;}}n=n.next;}while(n!==e);if(!r)return null;if(i===o)return r.prev;var u,l=r,p=r.x,c=r.y,h=1/0;n=r.next;for(;n!==l;)i>=n.x&&n.x>=p&&i!==n.x&&lo(a<c?i:o,a,p,c,a<c?o:i,a,n.x,n.y)&&((u=Math.abs(a-n.y)/(i-n.x))<h||u===h&&n.x>r.x)&&yo(n,t)&&(r=n,h=u),n=n.next;return r}(t,e)){var r=mo(e,t);Qa(r,r.next);}}function so(t,e,r,n,i){return (t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=32767*(t-r)*i)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=32767*(e-n)*i)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function uo(t){var e=t,r=t;do{(e.x<r.x||e.x===r.x&&e.y<r.y)&&(r=e),e=e.next;}while(e!==t);return r}function lo(t,e,r,n,i,a,o,s){return (i-o)*(e-s)-(t-o)*(a-s)>=0&&(t-o)*(n-s)-(r-o)*(e-s)>=0&&(r-o)*(a-s)-(i-o)*(n-s)>=0}function po(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){var r=t;do{if(r.i!==t.i&&r.next.i!==t.i&&r.i!==e.i&&r.next.i!==e.i&&fo(r,r.next,t,e))return !0;r=r.next;}while(r!==t);return !1}(t,e)&&yo(t,e)&&yo(e,t)&&function(t,e){var r=t,n=!1,i=(t.x+e.x)/2,a=(t.y+e.y)/2;do{r.y>a!=r.next.y>a&&r.next.y!==r.y&&i<(r.next.x-r.x)*(a-r.y)/(r.next.y-r.y)+r.x&&(n=!n),r=r.next;}while(r!==t);return n}(t,e)}function co(t,e,r){return (e.y-t.y)*(r.x-e.x)-(e.x-t.x)*(r.y-e.y)}function ho(t,e){return t.x===e.x&&t.y===e.y}function fo(t,e,r,n){return !!(ho(t,e)&&ho(r,n)||ho(t,n)&&ho(r,e))||co(t,e,r)>0!=co(t,e,n)>0&&co(r,n,t)>0!=co(r,n,e)>0}function yo(t,e){return co(t.prev,t,t.next)<0?co(t,e,t.next)>=0&&co(t,t.prev,e)>=0:co(t,e,t.prev)<0||co(t,t.next,e)<0}function mo(t,e){var r=new xo(t.i,t.x,t.y),n=new xo(e.i,e.x,e.y),i=t.next,a=e.prev;return t.next=e,e.prev=t,r.next=i,i.prev=r,n.next=r,r.prev=n,a.next=n,n.prev=a,n}function vo(t,e,r,n){var i=new xo(t,e,r);return n?(i.next=n.next,i.prev=n,n.next.prev=i,n.next=i):(i.prev=i,i.next=i),i}function go(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ);}function xo(t,e,r){this.i=t,this.x=e,this.y=r,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1;}function bo(t,e,r,n){for(var i=0,a=e,o=r-n;a<r;a+=n)i+=(t[o]-t[a])*(t[a+1]+t[o+1]),o=a;return i}function _o(t,e,r,n,i){!function t(e,r,n,i,a){for(;i>n;){if(i-n>600){var o=i-n+1,s=r-n+1,u=Math.log(o),l=.5*Math.exp(2*u/3),p=.5*Math.sqrt(u*l*(o-l)/o)*(s-o/2<0?-1:1),c=Math.max(n,Math.floor(r-s*l/o+p)),h=Math.min(i,Math.floor(r+(o-s)*l/o+p));t(e,r,c,h,a);}var f=e[r],y=n,d=i;for(wo(e,n,r),a(e[i],f)>0&&wo(e,n,i);y<d;){for(wo(e,y,d),y++,d--;a(e[y],f)<0;)y++;for(;a(e[d],f)>0;)d--;}0===a(e[n],f)?wo(e,n,d):wo(e,++d,i),d<=r&&(n=d+1),r<=d&&(i=d-1);}}(t,e,r||0,n||t.length-1,i||Ao);}function wo(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}function Ao(t,e){return t<e?-1:t>e?1:0}function So(t,e){var r=t.length;if(r<=1)return [t];for(var n,i,a=[],o=0;o<r;o++){var s=S(t[o]);0!==s&&(t[o].area=Math.abs(s),void 0===i&&(i=s<0),i===s<0?(n&&a.push(n),n=[t[o]]):n.push(t[o]));}if(n&&a.push(n),e>1)for(var u=0;u<a.length;u++)a[u].length<=e||(_o(a[u],e,1,a[u].length-1,ko),a[u]=a[u].slice(0,e));return a}function ko(t,e){return e.area-t.area}function zo(t,e,r){for(var n=r.patternDependencies,i=!1,a=0,o=e;a<o.length;a+=1){var s=o[a].paint.get(t+"-pattern");s.isConstant()||(i=!0);var u=s.constantOr(null);u&&(i=!0,n[u.to]=!0,n[u.from]=!0);}return i}function Io(t,e,r,n,i){for(var a=i.patternDependencies,o=0,s=e;o<s.length;o+=1){var u=s[o],l=u.paint.get(t+"-pattern").value;if("constant"!==l.kind){var p=l.evaluate({zoom:n-1},r,{}),c=l.evaluate({zoom:n},r,{}),h=l.evaluate({zoom:n+1},r,{});a[p]=!0,a[c]=!0,a[h]=!0,r.patterns[u.id]={min:p,mid:c,max:h};}}return r}$a.deviation=function(t,e,r,n){var i=e&&e.length,a=i?e[0]*r:t.length,o=Math.abs(bo(t,0,a,r));if(i)for(var s=0,u=e.length;s<u;s++){var l=e[s]*r,p=s<u-1?e[s+1]*r:t.length;o-=Math.abs(bo(t,l,p,r));}var c=0;for(s=0;s<n.length;s+=3){var h=n[s]*r,f=n[s+1]*r,y=n[s+2]*r;c+=Math.abs((t[h]-t[y])*(t[f+1]-t[h+1])-(t[h]-t[f])*(t[y+1]-t[h+1]));}return 0===o&&0===c?0:Math.abs((c-o)/o)},$a.flatten=function(t){for(var e=t[0][0].length,r={vertices:[],holes:[],dimensions:e},n=0,i=0;i<t.length;i++){for(var a=0;a<t[i].length;a++)for(var o=0;o<e;o++)r.vertices.push(t[i][a][o]);i>0&&(n+=t[i-1].length,r.holes.push(n));}return r},Ya.default=Ja;var Bo=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new Gn,this.indexArray=new si,this.indexArray2=new ui,this.programConfigurations=new Xi(Ha,t.layers,t.zoom),this.segments=new zi,this.segments2=new zi,this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id});};Bo.prototype.populate=function(t,e){this.features=[],this.hasPattern=zo("fill",this.layers,e);for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.index,s=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new Sn(this.zoom),a)){var u=Wi(a),l={sourceLayerIndex:s,index:o,geometry:u,properties:a.properties,type:a.type,patterns:{}};void 0!==a.id&&(l.id=a.id),this.hasPattern?this.features.push(Io("fill",this.layers,l,this.zoom,e)):this.addFeature(l,u,o,{}),e.featureIndex.insert(a,u,o,s,this.index);}}},Bo.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},Bo.prototype.addFeatures=function(t,e){for(var r=0,n=this.features;r<n.length;r+=1){var i=n[r],a=i.geometry;this.addFeature(i,a,i.index,e);}},Bo.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},Bo.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},Bo.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Ha),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.indexBuffer2=t.createIndexBuffer(this.indexArray2)),this.programConfigurations.upload(t),this.uploaded=!0;},Bo.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.indexBuffer2.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.segments2.destroy());},Bo.prototype.addFeature=function(t,e,r,n){for(var i=0,a=So(e,500);i<a.length;i+=1){for(var o=a[i],s=0,u=0,l=o;u<l.length;u+=1){s+=l[u].length;}for(var p=this.segments.prepareSegment(s,this.layoutVertexArray,this.indexArray),c=p.vertexLength,h=[],f=[],y=0,d=o;y<d.length;y+=1){var m=d[y];if(0!==m.length){m!==o[0]&&f.push(h.length/2);var v=this.segments2.prepareSegment(m.length,this.layoutVertexArray,this.indexArray2),g=v.vertexLength;this.layoutVertexArray.emplaceBack(m[0].x,m[0].y),this.indexArray2.emplaceBack(g+m.length-1,g),h.push(m[0].x),h.push(m[0].y);for(var x=1;x<m.length;x++)this.layoutVertexArray.emplaceBack(m[x].x,m[x].y),this.indexArray2.emplaceBack(g+x-1,g+x),h.push(m[x].x),h.push(m[x].y);v.vertexLength+=m.length,v.primitiveLength+=m.length;}}for(var b=Ya(h,f),_=0;_<b.length;_+=3)this.indexArray.emplaceBack(c+b[_],c+b[_+1],c+b[_+2]);p.vertexLength+=s,p.primitiveLength+=b.length/3;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,n);},sn("FillBucket",Bo,{omit:["layers","features"]});var Eo={paint:new Dn({"fill-antialias":new Mn(mt.paint_fill["fill-antialias"]),"fill-opacity":new Tn(mt.paint_fill["fill-opacity"]),"fill-color":new Tn(mt.paint_fill["fill-color"]),"fill-outline-color":new Tn(mt.paint_fill["fill-outline-color"]),"fill-translate":new Mn(mt.paint_fill["fill-translate"]),"fill-translate-anchor":new Mn(mt.paint_fill["fill-translate-anchor"]),"fill-pattern":new Fn(mt.paint_fill["fill-pattern"])})},Po=function(t){function e(e){t.call(this,e,Eo);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(e){t.prototype.recalculate.call(this,e);var r=this.paint._values["fill-outline-color"];"constant"===r.value.kind&&void 0===r.value.value&&(this.paint._values["fill-outline-color"]=this.paint._values["fill-color"]);},e.prototype.createBucket=function(t){return new Bo(t)},e.prototype.queryRadius=function(){return fa(this.paint.get("fill-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o){return na(ya(t,this.paint.get("fill-translate"),this.paint.get("fill-translate-anchor"),a.angle,o),n)},e}(Un),Vo=Nn([{name:"a_pos",components:2,type:"Int16"},{name:"a_normal_ed",components:4,type:"Int16"}],4),Co=Vo.members,Mo=(Vo.size,Vo.alignment,Math.pow(2,13));function To(t,e,r,n,i,a,o,s){t.emplaceBack(e,r,2*Math.floor(n*Mo)+o,i*Mo*2,a*Mo*2,Math.round(s));}var Fo=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new Zn,this.indexArray=new si,this.programConfigurations=new Xi(Co,t.layers,t.zoom),this.segments=new zi,this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id});};function Lo(t,e){return t.x===e.x&&(t.x<0||t.x>Yi)||t.y===e.y&&(t.y<0||t.y>Yi)}function Oo(t){return t.every(function(t){return t.x<0})||t.every(function(t){return t.x>Yi})||t.every(function(t){return t.y<0})||t.every(function(t){return t.y>Yi})}Fo.prototype.populate=function(t,e){this.features=[],this.hasPattern=zo("fill-extrusion",this.layers,e);for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.index,s=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new Sn(this.zoom),a)){var u=Wi(a),l={sourceLayerIndex:s,index:o,geometry:u,properties:a.properties,type:a.type,patterns:{}};void 0!==a.id&&(l.id=a.id),this.hasPattern?this.features.push(Io("fill-extrusion",this.layers,l,this.zoom,e)):this.addFeature(l,u,o,{}),e.featureIndex.insert(a,u,o,s,this.index,!0);}}},Fo.prototype.addFeatures=function(t,e){for(var r=0,n=this.features;r<n.length;r+=1){var i=n[r],a=i.geometry;this.addFeature(i,a,i.index,e);}},Fo.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},Fo.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},Fo.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},Fo.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Co),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},Fo.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},Fo.prototype.addFeature=function(t,e,r,n){for(var i=0,a=So(e,500);i<a.length;i+=1){for(var o=a[i],s=0,u=0,l=o;u<l.length;u+=1){s+=l[u].length;}for(var p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray),c=0,h=o;c<h.length;c+=1){var f=h[c];if(0!==f.length&&!Oo(f))for(var y=0,d=0;d<f.length;d++){var m=f[d];if(d>=1){var v=f[d-1];if(!Lo(m,v)){p.vertexLength+4>zi.MAX_VERTEX_ARRAY_LENGTH&&(p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray));var g=m.sub(v)._perp()._unit(),x=v.dist(m);y+x>32768&&(y=0),To(this.layoutVertexArray,m.x,m.y,g.x,g.y,0,0,y),To(this.layoutVertexArray,m.x,m.y,g.x,g.y,0,1,y),y+=x,To(this.layoutVertexArray,v.x,v.y,g.x,g.y,0,0,y),To(this.layoutVertexArray,v.x,v.y,g.x,g.y,0,1,y);var b=p.vertexLength;this.indexArray.emplaceBack(b,b+2,b+1),this.indexArray.emplaceBack(b+1,b+2,b+3),p.vertexLength+=4,p.primitiveLength+=2;}}}}p.vertexLength+s>zi.MAX_VERTEX_ARRAY_LENGTH&&(p=this.segments.prepareSegment(s,this.layoutVertexArray,this.indexArray));for(var _=[],w=[],A=p.vertexLength,S=0,k=o;S<k.length;S+=1){var z=k[S];if(0!==z.length){z!==o[0]&&w.push(_.length/2);for(var I=0;I<z.length;I++){var B=z[I];To(this.layoutVertexArray,B.x,B.y,0,0,1,1,0),_.push(B.x),_.push(B.y);}}}for(var E=Ya(_,w),P=0;P<E.length;P+=3)this.indexArray.emplaceBack(A+E[P],A+E[P+2],A+E[P+1]);p.primitiveLength+=E.length/3,p.vertexLength+=s;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,n);},sn("FillExtrusionBucket",Fo,{omit:["layers","features"]});var Do={paint:new Dn({"fill-extrusion-opacity":new Mn(mt["paint_fill-extrusion"]["fill-extrusion-opacity"]),"fill-extrusion-color":new Tn(mt["paint_fill-extrusion"]["fill-extrusion-color"]),"fill-extrusion-translate":new Mn(mt["paint_fill-extrusion"]["fill-extrusion-translate"]),"fill-extrusion-translate-anchor":new Mn(mt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),"fill-extrusion-pattern":new Fn(mt["paint_fill-extrusion"]["fill-extrusion-pattern"]),"fill-extrusion-height":new Tn(mt["paint_fill-extrusion"]["fill-extrusion-height"]),"fill-extrusion-base":new Tn(mt["paint_fill-extrusion"]["fill-extrusion-base"]),"fill-extrusion-vertical-gradient":new Mn(mt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])})},Uo=function(t){function e(e){t.call(this,e,Do);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new Fo(t)},e.prototype.queryRadius=function(){return fa(this.paint.get("fill-extrusion-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,a,o,s,u){var l=ya(t,this.paint.get("fill-extrusion-translate"),this.paint.get("fill-extrusion-translate-anchor"),o.angle,s),p=this.paint.get("fill-extrusion-height").evaluate(e,r),c=this.paint.get("fill-extrusion-base").evaluate(e,r),h=function(t,e,r,n){for(var a=[],o=0,s=t;o<s.length;o+=1){var u=s[o],l=[u.x,u.y,n,1];Sa(l,l,e),a.push(new i(l[0]/l[3],l[1]/l[3]));}return a}(l,u,0,0),f=function(t,e,r,n){for(var a=[],o=[],s=n[8]*e,u=n[9]*e,l=n[10]*e,p=n[11]*e,c=n[8]*r,h=n[9]*r,f=n[10]*r,y=n[11]*r,d=0,m=t;d<m.length;d+=1){for(var v=m[d],g=[],x=[],b=0,_=v;b<_.length;b+=1){var w=_[b],A=w.x,S=w.y,k=n[0]*A+n[4]*S+n[12],z=n[1]*A+n[5]*S+n[13],I=n[2]*A+n[6]*S+n[14],B=n[3]*A+n[7]*S+n[15],E=k+s,P=z+u,V=I+l,C=B+p,M=k+c,T=z+h,F=I+f,L=B+y,O=new i(E/C,P/C);O.z=V/C,g.push(O);var D=new i(M/L,T/L);D.z=F/L,x.push(D);}a.push(g),o.push(x);}return [a,o]}(n,c,p,u);return function(t,e,r){var n=1/0;na(r,e)&&(n=qo(r,e[0]));for(var i=0;i<e.length;i++)for(var a=e[i],o=t[i],s=0;s<a.length-1;s++){var u=a[s],l=a[s+1],p=o[s],c=o[s+1],h=[u,l,c,p,u];ea(r,h)&&(n=Math.min(n,qo(r,h)));}return n!==1/0&&n}(f[0],f[1],h)},e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("fill-extrusion-opacity")&&"none"!==this.visibility},e.prototype.resize=function(){this.viewportFrame&&(this.viewportFrame.destroy(),this.viewportFrame=null);},e}(Un);function jo(t,e){return t.x*e.x+t.y*e.y}function qo(t,e){if(1===t.length){var r=e[0],n=e[1],i=e[3],a=t[0],o=n.sub(r),s=i.sub(r),u=a.sub(r),l=jo(o,o),p=jo(o,s),c=jo(s,s),h=jo(u,o),f=jo(u,s),y=l*c-p*p,d=(c*h-p*f)/y,m=(l*f-p*h)/y,v=1-d-m;return r.z*v+n.z*d+i.z*m}for(var g=1/0,x=0,b=e;x<b.length;x+=1){var _=b[x];g=Math.min(g,_.z);}return g}var Ro=Nn([{name:"a_pos_normal",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint8"}],4),No=Ro.members,Ko=(Ro.size,Ro.alignment,Go);function Go(t,e,r,n,i){this.properties={},this.extent=r,this.type=0,this._pbf=t,this._geometry=-1,this._keys=n,this._values=i,t.readFields(Xo,this,e);}function Xo(t,e,r){1==t?e.id=r.readVarint():2==t?function(t,e){var r=t.readVarint()+t.pos;for(;t.pos<r;){var n=e._keys[t.readVarint()],i=e._values[t.readVarint()];e.properties[n]=i;}}(r,e):3==t?e.type=r.readVarint():4==t&&(e._geometry=r.pos);}function Zo(t){for(var e,r,n=0,i=0,a=t.length,o=a-1;i<a;o=i++)e=t[i],n+=((r=t[o]).x-e.x)*(e.y+r.y);return n}Go.types=["Unknown","Point","LineString","Polygon"],Go.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,r=t.readVarint()+t.pos,n=1,a=0,o=0,s=0,u=[];t.pos<r;){if(a<=0){var l=t.readVarint();n=7&l,a=l>>3;}if(a--,1===n||2===n)o+=t.readSVarint(),s+=t.readSVarint(),1===n&&(e&&u.push(e),e=[]),e.push(new i(o,s));else{if(7!==n)throw new Error("unknown command "+n);e&&e.push(e[0].clone());}}return e&&u.push(e),u},Go.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e=t.readVarint()+t.pos,r=1,n=0,i=0,a=0,o=1/0,s=-1/0,u=1/0,l=-1/0;t.pos<e;){if(n<=0){var p=t.readVarint();r=7&p,n=p>>3;}if(n--,1===r||2===r)(i+=t.readSVarint())<o&&(o=i),i>s&&(s=i),(a+=t.readSVarint())<u&&(u=a),a>l&&(l=a);else if(7!==r)throw new Error("unknown command "+r)}return [o,u,s,l]},Go.prototype.toGeoJSON=function(t,e,r){var n,i,a=this.extent*Math.pow(2,r),o=this.extent*t,s=this.extent*e,u=this.loadGeometry(),l=Go.types[this.type];function p(t){for(var e=0;e<t.length;e++){var r=t[e],n=180-360*(r.y+s)/a;t[e]=[360*(r.x+o)/a-180,360/Math.PI*Math.atan(Math.exp(n*Math.PI/180))-90];}}switch(this.type){case 1:var c=[];for(n=0;n<u.length;n++)c[n]=u[n][0];p(u=c);break;case 2:for(n=0;n<u.length;n++)p(u[n]);break;case 3:for(u=function(t){var e=t.length;if(e<=1)return [t];for(var r,n,i=[],a=0;a<e;a++){var o=Zo(t[a]);0!==o&&(void 0===n&&(n=o<0),n===o<0?(r&&i.push(r),r=[t[a]]):r.push(t[a]));}r&&i.push(r);return i}(u),n=0;n<u.length;n++)for(i=0;i<u[n].length;i++)p(u[n][i]);}1===u.length?u=u[0]:l="Multi"+l;var h={type:"Feature",geometry:{type:l,coordinates:u},properties:this.properties};return "id"in this&&(h.id=this.id),h};var Ho=Yo;function Yo(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(Jo,this,e),this.length=this._features.length;}function Jo(t,e,r){15===t?e.version=r.readVarint():1===t?e.name=r.readString():5===t?e.extent=r.readVarint():2===t?e._features.push(r.pos):3===t?e._keys.push(r.readString()):4===t&&e._values.push(function(t){var e=null,r=t.readVarint()+t.pos;for(;t.pos<r;){var n=t.readVarint()>>3;e=1===n?t.readString():2===n?t.readFloat():3===n?t.readDouble():4===n?t.readVarint64():5===n?t.readVarint():6===n?t.readSVarint():7===n?t.readBoolean():null;}return e}(r));}function $o(t,e,r){if(3===t){var n=new Ho(r,r.readVarint()+r.pos);n.length&&(e[n.name]=n);}}Yo.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[t];var e=this._pbf.readVarint()+this._pbf.pos;return new Ko(this._pbf,e,this.extent,this._keys,this._values)};var Wo={VectorTile:function(t,e){this.layers=t.readFields($o,{},e);},VectorTileFeature:Ko,VectorTileLayer:Ho},Qo=Wo.VectorTileFeature.types,ts=63,es=Math.cos(Math.PI/180*37.5),rs=.5,ns=Math.pow(2,14)/rs;function is(t,e,r,n,i,a,o){t.emplaceBack(e.x,e.y,n?1:0,i?1:-1,Math.round(ts*r.x)+128,Math.round(ts*r.y)+128,1+(0===a?0:a<0?-1:1)|(o*rs&63)<<2,o*rs>>6);}var as=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.features=[],this.hasPattern=!1,this.layoutVertexArray=new Hn,this.indexArray=new si,this.programConfigurations=new Xi(No,t.layers,t.zoom),this.segments=new zi,this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id});};function os(t,e){return (t/e.tileTotal*(e.end-e.start)+e.start)*(ns-1)}as.prototype.populate=function(t,e){this.features=[],this.hasPattern=zo("line",this.layers,e);for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.index,s=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new Sn(this.zoom),a)){var u=Wi(a),l={sourceLayerIndex:s,index:o,geometry:u,properties:a.properties,type:a.type,patterns:{}};void 0!==a.id&&(l.id=a.id),this.hasPattern?this.features.push(Io("line",this.layers,l,this.zoom,e)):this.addFeature(l,u,o,{}),e.featureIndex.insert(a,u,o,s,this.index);}}},as.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},as.prototype.addFeatures=function(t,e){for(var r=0,n=this.features;r<n.length;r+=1){var i=n[r],a=i.geometry;this.addFeature(i,a,i.index,e);}},as.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},as.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},as.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,No),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},as.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},as.prototype.addFeature=function(t,e,r,n){for(var i=this.layers[0].layout,a=i.get("line-join").evaluate(t,{}),o=i.get("line-cap"),s=i.get("line-miter-limit"),u=i.get("line-round-limit"),l=0,p=e;l<p.length;l+=1){var c=p[l];this.addLine(c,t,a,o,s,u,r,n);}},as.prototype.addLine=function(t,e,r,n,i,a,o,s){var u=null;e.properties&&e.properties.hasOwnProperty("mapbox_clip_start")&&e.properties.hasOwnProperty("mapbox_clip_end")&&(u={start:e.properties.mapbox_clip_start,end:e.properties.mapbox_clip_end,tileTotal:void 0});for(var l="Polygon"===Qo[e.type],p=t.length;p>=2&&t[p-1].equals(t[p-2]);)p--;for(var c=0;c<p-1&&t[c].equals(t[c+1]);)c++;if(!(p<(l?3:2))){u&&(u.tileTotal=function(t,e,r){for(var n,i,a=0,o=e;o<r-1;o++)n=t[o],i=t[o+1],a+=n.dist(i);return a}(t,c,p)),"bevel"===r&&(i=1.05);var h=Yi/(512*this.overscaling)*15,f=t[c],y=this.segments.prepareSegment(10*p,this.layoutVertexArray,this.indexArray);this.distance=0;var d,m,v,g=n,x=l?"butt":n,b=!0,_=void 0,w=void 0,A=void 0,S=void 0;this.e1=this.e2=this.e3=-1,l&&(d=t[p-2],S=f.sub(d)._unit()._perp());for(var k=c;k<p;k++)if(!(w=l&&k===p-1?t[c+1]:t[k+1])||!t[k].equals(w)){S&&(A=S),d&&(_=d),d=t[k],S=w?w.sub(d)._unit()._perp():A;var z=(A=A||S).add(S);0===z.x&&0===z.y||z._unit();var I=z.x*S.x+z.y*S.y,B=0!==I?1/I:1/0,E=I<es&&_&&w;if(E&&k>c){var P=d.dist(_);if(P>2*h){var V=d.sub(d.sub(_)._mult(h/P)._round());this.distance+=V.dist(_),this.addCurrentVertex(V,this.distance,A.mult(1),0,0,!1,y,u),_=V;}}var C=_&&w,M=C?r:w?g:x;if(C&&"round"===M&&(B<a?M="miter":B<=2&&(M="fakeround")),"miter"===M&&B>i&&(M="bevel"),"bevel"===M&&(B>2&&(M="flipbevel"),B<i&&(M="miter")),_&&(this.distance+=d.dist(_)),"miter"===M)z._mult(B),this.addCurrentVertex(d,this.distance,z,0,0,!1,y,u);else if("flipbevel"===M){if(B>100)z=S.clone().mult(-1);else{var T=A.x*S.y-A.y*S.x>0?-1:1,F=B*A.add(S).mag()/A.sub(S).mag();z._perp()._mult(F*T);}this.addCurrentVertex(d,this.distance,z,0,0,!1,y,u),this.addCurrentVertex(d,this.distance,z.mult(-1),0,0,!1,y,u);}else if("bevel"===M||"fakeround"===M){var L=A.x*S.y-A.y*S.x>0,O=-Math.sqrt(B*B-1);if(L?(v=0,m=O):(m=0,v=O),b||this.addCurrentVertex(d,this.distance,A,m,v,!1,y,u),"fakeround"===M){for(var D=Math.floor(8*(.5-(I-.5))),U=void 0,j=0;j<D;j++)U=S.mult((j+1)/(D+1))._add(A)._unit(),this.addPieSliceVertex(d,this.distance,U,L,y,u);this.addPieSliceVertex(d,this.distance,z,L,y,u);for(var q=D-1;q>=0;q--)U=A.mult((q+1)/(D+1))._add(S)._unit(),this.addPieSliceVertex(d,this.distance,U,L,y,u);}w&&this.addCurrentVertex(d,this.distance,S,-m,-v,!1,y,u);}else"butt"===M?(b||this.addCurrentVertex(d,this.distance,A,0,0,!1,y,u),w&&this.addCurrentVertex(d,this.distance,S,0,0,!1,y,u)):"square"===M?(b||(this.addCurrentVertex(d,this.distance,A,1,1,!1,y,u),this.e1=this.e2=-1),w&&this.addCurrentVertex(d,this.distance,S,-1,-1,!1,y,u)):"round"===M&&(b||(this.addCurrentVertex(d,this.distance,A,0,0,!1,y,u),this.addCurrentVertex(d,this.distance,A,1,1,!0,y,u),this.e1=this.e2=-1),w&&(this.addCurrentVertex(d,this.distance,S,-1,-1,!0,y,u),this.addCurrentVertex(d,this.distance,S,0,0,!1,y,u)));if(E&&k<p-1){var R=d.dist(w);if(R>2*h){var N=d.add(w.sub(d)._mult(h/R)._round());this.distance+=N.dist(d),this.addCurrentVertex(N,this.distance,S.mult(1),0,0,!1,y,u),d=N;}}b=!1;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,e,o,s);}},as.prototype.addCurrentVertex=function(t,e,r,n,i,a,o,s){var u,l=this.layoutVertexArray,p=this.indexArray;s&&(e=os(e,s)),u=r.clone(),n&&u._sub(r.perp()._mult(n)),is(l,t,u,a,!1,n,e),this.e3=o.vertexLength++,this.e1>=0&&this.e2>=0&&(p.emplaceBack(this.e1,this.e2,this.e3),o.primitiveLength++),this.e1=this.e2,this.e2=this.e3,u=r.mult(-1),i&&u._sub(r.perp()._mult(i)),is(l,t,u,a,!0,-i,e),this.e3=o.vertexLength++,this.e1>=0&&this.e2>=0&&(p.emplaceBack(this.e1,this.e2,this.e3),o.primitiveLength++),this.e1=this.e2,this.e2=this.e3,e>ns/2&&!s&&(this.distance=0,this.addCurrentVertex(t,this.distance,r,n,i,a,o));},as.prototype.addPieSliceVertex=function(t,e,r,n,i,a){r=r.mult(n?-1:1);var o=this.layoutVertexArray,s=this.indexArray;a&&(e=os(e,a)),is(o,t,r,!1,n,0,e),this.e3=i.vertexLength++,this.e1>=0&&this.e2>=0&&(s.emplaceBack(this.e1,this.e2,this.e3),i.primitiveLength++),n?this.e2=this.e3:this.e1=this.e3;},sn("LineBucket",as,{omit:["layers","features"]});var ss=new Dn({"line-cap":new Mn(mt.layout_line["line-cap"]),"line-join":new Tn(mt.layout_line["line-join"]),"line-miter-limit":new Mn(mt.layout_line["line-miter-limit"]),"line-round-limit":new Mn(mt.layout_line["line-round-limit"])}),us={paint:new Dn({"line-opacity":new Tn(mt.paint_line["line-opacity"]),"line-color":new Tn(mt.paint_line["line-color"]),"line-translate":new Mn(mt.paint_line["line-translate"]),"line-translate-anchor":new Mn(mt.paint_line["line-translate-anchor"]),"line-width":new Tn(mt.paint_line["line-width"]),"line-gap-width":new Tn(mt.paint_line["line-gap-width"]),"line-offset":new Tn(mt.paint_line["line-offset"]),"line-blur":new Tn(mt.paint_line["line-blur"]),"line-dasharray":new Ln(mt.paint_line["line-dasharray"]),"line-pattern":new Fn(mt.paint_line["line-pattern"]),"line-gradient":new On(mt.paint_line["line-gradient"])}),layout:ss},ls=new(function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.possiblyEvaluate=function(e,r){return r=new Sn(Math.floor(r.zoom),{now:r.now,fadeDuration:r.fadeDuration,zoomHistory:r.zoomHistory,transition:r.transition}),t.prototype.possiblyEvaluate.call(this,e,r)},e.prototype.evaluate=function(e,r,n,i){return r=c({},r,{zoom:Math.floor(r.zoom)}),t.prototype.evaluate.call(this,e,r,n,i)},e}(Tn))(us.paint.properties["line-width"].specification);ls.useIntegerZoom=!0;var ps=function(t){function e(e){t.call(this,e,us);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._handleSpecialPaintPropertyUpdate=function(t){"line-gradient"===t&&this._updateGradient();},e.prototype._updateGradient=function(){var t=this._transitionablePaint._values["line-gradient"].value.expression;this.gradient=Na(t,"lineProgress"),this.gradientTexture=null;},e.prototype.recalculate=function(e){t.prototype.recalculate.call(this,e),this.paint._values["line-floorwidth"]=ls.possiblyEvaluate(this._transitioningPaint._values["line-width"].value,e);},e.prototype.createBucket=function(t){return new as(t)},e.prototype.queryRadius=function(t){var e=t,r=cs(ha("line-width",this,e),ha("line-gap-width",this,e)),n=ha("line-offset",this,e);return r/2+Math.abs(n)+fa(this.paint.get("line-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,a,o,s){var u=ya(t,this.paint.get("line-translate"),this.paint.get("line-translate-anchor"),o.angle,s),l=s/2*cs(this.paint.get("line-width").evaluate(e,r),this.paint.get("line-gap-width").evaluate(e,r)),p=this.paint.get("line-offset").evaluate(e,r);return p&&(n=function(t,e){for(var r=[],n=new i(0,0),a=0;a<t.length;a++){for(var o=t[a],s=[],u=0;u<o.length;u++){var l=o[u-1],p=o[u],c=o[u+1],h=0===u?n:p.sub(l)._unit()._perp(),f=u===o.length-1?n:c.sub(p)._unit()._perp(),y=h._add(f)._unit(),d=y.x*f.x+y.y*f.y;y._mult(1/d),s.push(y._mult(e)._add(p));}r.push(s);}return r}(n,p*s)),function(t,e,r){for(var n=0;n<e.length;n++){var i=e[n];if(t.length>=3)for(var a=0;a<i.length;a++)if(pa(t,i[a]))return !0;if(ia(t,i,r))return !0}return !1}(u,n,l)},e}(Un);function cs(t,e){return e>0?e+2*t:t}var hs=Nn([{name:"a_pos_offset",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint16"}]),fs=Nn([{name:"a_projected_pos",components:3,type:"Float32"}],4),ys=(Nn([{name:"a_fade_opacity",components:1,type:"Uint32"}],4),Nn([{name:"a_placed",components:2,type:"Uint8"}],4)),ds=(Nn([{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Int16",name:"x1"},{type:"Int16",name:"y1"},{type:"Int16",name:"x2"},{type:"Int16",name:"y2"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"},{type:"Int16",name:"radius"},{type:"Int16",name:"signedDistanceFromAnchor"}]),Nn([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4)),ms=Nn([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4);Nn([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Uint16",name:"glyphStartIndex"},{type:"Uint16",name:"numGlyphs"},{type:"Uint32",name:"vertexStartIndex"},{type:"Uint32",name:"lineStartIndex"},{type:"Uint32",name:"lineLength"},{type:"Uint16",name:"segment"},{type:"Uint16",name:"lowerSize"},{type:"Uint16",name:"upperSize"},{type:"Float32",name:"lineOffsetX"},{type:"Float32",name:"lineOffsetY"},{type:"Uint8",name:"writingMode"},{type:"Uint8",name:"hidden"}]),Nn([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Int16",name:"horizontalPlacedTextSymbolIndex"},{type:"Int16",name:"verticalPlacedTextSymbolIndex"},{type:"Uint16",name:"key"},{type:"Uint16",name:"textBoxStartIndex"},{type:"Uint16",name:"textBoxEndIndex"},{type:"Uint16",name:"iconBoxStartIndex"},{type:"Uint16",name:"iconBoxEndIndex"},{type:"Uint16",name:"featureIndex"},{type:"Uint16",name:"numGlyphVertices"},{type:"Uint16",name:"numVerticalGlyphVertices"},{type:"Uint16",name:"numIconVertices"},{type:"Uint32",name:"crossTileID"}]),Nn([{type:"Float32",name:"offsetX"}]),Nn([{type:"Int16",name:"x"},{type:"Int16",name:"y"},{type:"Int16",name:"tileUnitDistanceFromAnchor"}]);function vs(t,e,r){return t.sections.forEach(function(t){t.text=function(t,e,r){var n=e.layout.get("text-transform").evaluate(r,{});return "uppercase"===n?t=t.toLocaleUpperCase():"lowercase"===n&&(t=t.toLocaleLowerCase()),An.applyArabicShaping&&(t=An.applyArabicShaping(t)),t}(t.text,e,r);}),t}var gs={"!":"︕","#":"＃",$:"＄","%":"％","&":"＆","(":"︵",")":"︶","*":"＊","+":"＋",",":"︐","-":"︲",".":"・","/":"／",":":"︓",";":"︔","<":"︿","=":"＝",">":"﹀","?":"︖","@":"＠","[":"﹇","\\":"＼","]":"﹈","^":"＾",_:"︳","`":"｀","{":"︷","|":"―","}":"︸","~":"～","¢":"￠","£":"￡","¥":"￥","¦":"￤","¬":"￢","¯":"￣","–":"︲","—":"︱","‘":"﹃","’":"﹄","“":"﹁","”":"﹂","…":"︙","‧":"・","₩":"￦","、":"︑","。":"︒","〈":"︿","〉":"﹀","《":"︽","》":"︾","「":"﹁","」":"﹂","『":"﹃","』":"﹄","【":"︻","】":"︼","〔":"︹","〕":"︺","〖":"︗","〗":"︘","！":"︕","（":"︵","）":"︶","，":"︐","－":"︲","．":"・","：":"︓","；":"︔","＜":"︿","＞":"﹀","？":"︖","［":"﹇","］":"﹈","＿":"︳","｛":"︷","｜":"―","｝":"︸","｟":"︵","｠":"︶","｡":"︒","｢":"﹁","｣":"﹂"};var xs=function(t){function e(e,r,n,i){t.call(this,e,r),this.angle=n,void 0!==i&&(this.segment=i);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.clone=function(){return new e(this.x,this.y,this.angle,this.segment)},e}(i);sn("Anchor",xs);var bs=256;function _s(t,e){var r=e.expression;if("constant"===r.kind)return {functionType:"constant",layoutSize:r.evaluate(new Sn(t+1))};if("source"===r.kind)return {functionType:"source"};for(var n=r.zoomStops,i=0;i<n.length&&n[i]<=t;)i++;for(var a=i=Math.max(0,i-1);a<n.length&&n[a]<t+1;)a++;a=Math.min(n.length-1,a);var o={min:n[i],max:n[a]};return "composite"===r.kind?{functionType:"composite",zoomRange:o,propertyValue:e.value}:{functionType:"camera",layoutSize:r.evaluate(new Sn(t+1)),zoomRange:o,sizeRange:{min:r.evaluate(new Sn(o.min)),max:r.evaluate(new Sn(o.max))},propertyValue:e.value}}var ws=Wo.VectorTileFeature.types,As=[{name:"a_fade_opacity",components:1,type:"Uint8",offset:0}];function Ss(t,e,r,n,i,a,o,s){t.emplaceBack(e,r,Math.round(32*n),Math.round(32*i),a,o,s?s[0]:0,s?s[1]:0);}function ks(t,e,r){t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r);}var zs=function(t){this.layoutVertexArray=new Jn,this.indexArray=new si,this.programConfigurations=t,this.segments=new zi,this.dynamicLayoutVertexArray=new $n,this.opacityVertexArray=new Wn,this.placedSymbolArray=new di;};zs.prototype.upload=function(t,e,r,n){r&&(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,hs.members),this.indexBuffer=t.createIndexBuffer(this.indexArray,e),this.dynamicLayoutVertexBuffer=t.createVertexBuffer(this.dynamicLayoutVertexArray,fs.members,!0),this.opacityVertexBuffer=t.createVertexBuffer(this.opacityVertexArray,As,!0),this.opacityVertexBuffer.itemSize=1),(r||n)&&this.programConfigurations.upload(t);},zs.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.dynamicLayoutVertexBuffer.destroy(),this.opacityVertexBuffer.destroy());},sn("SymbolBuffers",zs);var Is=function(t,e,r){this.layoutVertexArray=new t,this.layoutAttributes=e,this.indexArray=new r,this.segments=new zi,this.collisionVertexArray=new ei;};Is.prototype.upload=function(t){this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,this.layoutAttributes),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.collisionVertexBuffer=t.createVertexBuffer(this.collisionVertexArray,ys.members,!0);},Is.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy(),this.collisionVertexBuffer.destroy());},sn("CollisionBuffers",Is);var Bs=function(t){this.collisionBoxArray=t.collisionBoxArray,this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.pixelRatio=t.pixelRatio,this.sourceLayerIndex=t.sourceLayerIndex,this.hasPattern=!1;var e=this.layers[0]._unevaluatedLayout._values;this.textSizeData=_s(this.zoom,e["text-size"]),this.iconSizeData=_s(this.zoom,e["icon-size"]);var r=this.layers[0].layout,n=r.get("symbol-sort-key"),i=r.get("symbol-z-order");this.sortFeaturesByKey="viewport-y"!==i&&void 0!==n.constantOr(1);var a="viewport-y"===i||"auto"===i&&!this.sortFeaturesByKey;this.sortFeaturesByY=a&&(r.get("text-allow-overlap")||r.get("icon-allow-overlap")||r.get("text-ignore-placement")||r.get("icon-ignore-placement")),this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id}),this.sourceID=t.sourceID;};Bs.prototype.createArrays=function(){this.text=new zs(new Xi(hs.members,this.layers,this.zoom,function(t){return /^text/.test(t)})),this.icon=new zs(new Xi(hs.members,this.layers,this.zoom,function(t){return /^icon/.test(t)})),this.collisionBox=new Is(ti,ds.members,ui),this.collisionCircle=new Is(ti,ms.members,si),this.glyphOffsetArray=new xi,this.lineVertexArray=new _i,this.symbolInstances=new vi;},Bs.prototype.calculateGlyphDependencies=function(t,e,r,n){for(var i=0;i<t.length;i++)if(e[t.charCodeAt(i)]=!0,r&&n){var a=gs[t.charAt(i)];a&&(e[a.charCodeAt(0)]=!0);}},Bs.prototype.populate=function(t,e){var r=this.layers[0],n=r.layout,i=n.get("text-font"),a=n.get("text-field"),o=n.get("icon-image"),s=("constant"!==a.value.kind||a.value.value.toString().length>0)&&("constant"!==i.value.kind||i.value.value.length>0),u="constant"!==o.value.kind||o.value.value&&o.value.value.length>0,l=n.get("symbol-sort-key");if(this.features=[],s||u){for(var p=e.iconDependencies,c=e.glyphDependencies,h=new Sn(this.zoom),f=0,y=t;f<y.length;f+=1){var d=y[f],m=d.feature,v=d.index,g=d.sourceLayerIndex;if(r._featureFilter(h,m)){var x=void 0;if(s){var b=r.getValueAndResolveTokens("text-field",m);x=vs(b instanceof qt?b:qt.fromString(b),r,m);}var _=void 0;if(u&&(_=r.getValueAndResolveTokens("icon-image",m)),x||_){var w=this.sortFeaturesByKey?l.evaluate(m,{}):void 0,A={text:x,icon:_,index:v,sourceLayerIndex:g,geometry:Wi(m),properties:m.properties,type:ws[m.type],sortKey:w};if(void 0!==m.id&&(A.id=m.id),this.features.push(A),_&&(p[_]=!0),x)for(var S=i.evaluate(m,{}).join(","),k="map"===n.get("text-rotation-alignment")&&"point"!==n.get("symbol-placement"),z=0,I=x.sections;z<I.length;z+=1){var B=I[z],E=fn(x.toString()),P=B.fontStack||S,V=c[P]=c[P]||{};this.calculateGlyphDependencies(B.text,V,k,E);}}}}"line"===n.get("symbol-placement")&&(this.features=function(t){var e={},r={},n=[],i=0;function a(e){n.push(t[e]),i++;}function o(t,e,i){var a=r[t];return delete r[t],r[e]=a,n[a].geometry[0].pop(),n[a].geometry[0]=n[a].geometry[0].concat(i[0]),a}function s(t,r,i){var a=e[r];return delete e[r],e[t]=a,n[a].geometry[0].shift(),n[a].geometry[0]=i[0].concat(n[a].geometry[0]),a}function u(t,e,r){var n=r?e[0][e[0].length-1]:e[0][0];return t+":"+n.x+":"+n.y}for(var l=0;l<t.length;l++){var p=t[l],c=p.geometry,h=p.text?p.text.toString():null;if(h){var f=u(h,c),y=u(h,c,!0);if(f in r&&y in e&&r[f]!==e[y]){var d=s(f,y,c),m=o(f,y,n[d].geometry);delete e[f],delete r[y],r[u(h,n[m].geometry,!0)]=m,n[d].geometry=null;}else f in r?o(f,y,c):y in e?s(f,y,c):(a(l),e[f]=i-1,r[y]=i-1);}else a(l);}return n.filter(function(t){return t.geometry})}(this.features)),this.sortFeaturesByKey&&this.features.sort(function(t,e){return t.sortKey-e.sortKey});}},Bs.prototype.update=function(t,e,r){this.stateDependentLayers.length&&(this.text.programConfigurations.updatePaintArrays(t,e,this.layers,r),this.icon.programConfigurations.updatePaintArrays(t,e,this.layers,r));},Bs.prototype.isEmpty=function(){return 0===this.symbolInstances.length},Bs.prototype.uploadPending=function(){return !this.uploaded||this.text.programConfigurations.needsUpload||this.icon.programConfigurations.needsUpload},Bs.prototype.upload=function(t){this.uploaded||(this.collisionBox.upload(t),this.collisionCircle.upload(t)),this.text.upload(t,this.sortFeaturesByY,!this.uploaded,this.text.programConfigurations.needsUpload),this.icon.upload(t,this.sortFeaturesByY,!this.uploaded,this.icon.programConfigurations.needsUpload),this.uploaded=!0;},Bs.prototype.destroy=function(){this.text.destroy(),this.icon.destroy(),this.collisionBox.destroy(),this.collisionCircle.destroy();},Bs.prototype.addToLineVertexArray=function(t,e){var r=this.lineVertexArray.length;if(void 0!==t.segment){for(var n=t.dist(e[t.segment+1]),i=t.dist(e[t.segment]),a={},o=t.segment+1;o<e.length;o++)a[o]={x:e[o].x,y:e[o].y,tileUnitDistanceFromAnchor:n},o<e.length-1&&(n+=e[o+1].dist(e[o]));for(var s=t.segment||0;s>=0;s--)a[s]={x:e[s].x,y:e[s].y,tileUnitDistanceFromAnchor:i},s>0&&(i+=e[s-1].dist(e[s]));for(var u=0;u<e.length;u++){var l=a[u];this.lineVertexArray.emplaceBack(l.x,l.y,l.tileUnitDistanceFromAnchor);}}return {lineStartIndex:r,lineLength:this.lineVertexArray.length-r}},Bs.prototype.addSymbols=function(t,e,r,n,i,a,o,s,u,l){for(var p=t.indexArray,c=t.layoutVertexArray,h=t.dynamicLayoutVertexArray,f=t.segments.prepareSegment(4*e.length,t.layoutVertexArray,t.indexArray,a.sortKey),y=this.glyphOffsetArray.length,d=f.vertexLength,m=0,v=e;m<v.length;m+=1){var g=v[m],x=g.tl,b=g.tr,_=g.bl,w=g.br,A=g.tex,S=f.vertexLength,k=g.glyphOffset[1];Ss(c,s.x,s.y,x.x,k+x.y,A.x,A.y,r),Ss(c,s.x,s.y,b.x,k+b.y,A.x+A.w,A.y,r),Ss(c,s.x,s.y,_.x,k+_.y,A.x,A.y+A.h,r),Ss(c,s.x,s.y,w.x,k+w.y,A.x+A.w,A.y+A.h,r),ks(h,s,0),p.emplaceBack(S,S+1,S+2),p.emplaceBack(S+1,S+2,S+3),f.vertexLength+=4,f.primitiveLength+=2,this.glyphOffsetArray.emplaceBack(g.glyphOffset[0]);}t.placedSymbolArray.emplaceBack(s.x,s.y,y,this.glyphOffsetArray.length-y,d,u,l,s.segment,r?r[0]:0,r?r[1]:0,n[0],n[1],o,!1),t.programConfigurations.populatePaintArrays(t.layoutVertexArray.length,a,a.index,{});},Bs.prototype._addCollisionDebugVertex=function(t,e,r,n,i,a){return e.emplaceBack(0,0),t.emplaceBack(r.x,r.y,n,i,Math.round(a.x),Math.round(a.y))},Bs.prototype.addCollisionDebugVertices=function(t,e,r,n,a,o,s,u){var l=a.segments.prepareSegment(4,a.layoutVertexArray,a.indexArray),p=l.vertexLength,c=a.layoutVertexArray,h=a.collisionVertexArray,f=s.anchorX,y=s.anchorY;if(this._addCollisionDebugVertex(c,h,o,f,y,new i(t,e)),this._addCollisionDebugVertex(c,h,o,f,y,new i(r,e)),this._addCollisionDebugVertex(c,h,o,f,y,new i(r,n)),this._addCollisionDebugVertex(c,h,o,f,y,new i(t,n)),l.vertexLength+=4,u){var d=a.indexArray;d.emplaceBack(p,p+1,p+2),d.emplaceBack(p,p+2,p+3),l.primitiveLength+=2;}else{var m=a.indexArray;m.emplaceBack(p,p+1),m.emplaceBack(p+1,p+2),m.emplaceBack(p+2,p+3),m.emplaceBack(p+3,p),l.primitiveLength+=4;}},Bs.prototype.addDebugCollisionBoxes=function(t,e,r){for(var n=t;n<e;n++){var i=this.collisionBoxArray.get(n),a=i.x1,o=i.y1,s=i.x2,u=i.y2,l=i.radius>0;this.addCollisionDebugVertices(a,o,s,u,l?this.collisionCircle:this.collisionBox,i.anchorPoint,r,l);}},Bs.prototype.generateCollisionDebugBuffers=function(){for(var t=0;t<this.symbolInstances.length;t++){var e=this.symbolInstances.get(t);this.addDebugCollisionBoxes(e.textBoxStartIndex,e.textBoxEndIndex,e),this.addDebugCollisionBoxes(e.iconBoxStartIndex,e.iconBoxEndIndex,e);}},Bs.prototype._deserializeCollisionBoxesForSymbol=function(t,e,r,n,i){for(var a={},o=e;o<r;o++){var s=t.get(o);if(0===s.radius){a.textBox={x1:s.x1,y1:s.y1,x2:s.x2,y2:s.y2,anchorPointX:s.anchorPointX,anchorPointY:s.anchorPointY},a.textFeatureIndex=s.featureIndex;break}a.textCircles||(a.textCircles=[],a.textFeatureIndex=s.featureIndex);a.textCircles.push(s.anchorPointX,s.anchorPointY,s.radius,s.signedDistanceFromAnchor,1);}for(var u=n;u<i;u++){var l=t.get(u);if(0===l.radius){a.iconBox={x1:l.x1,y1:l.y1,x2:l.x2,y2:l.y2,anchorPointX:l.anchorPointX,anchorPointY:l.anchorPointY},a.iconFeatureIndex=l.featureIndex;break}}return a},Bs.prototype.deserializeCollisionBoxes=function(t){this.collisionArrays=[];for(var e=0;e<this.symbolInstances.length;e++){var r=this.symbolInstances.get(e);this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t,r.textBoxStartIndex,r.textBoxEndIndex,r.iconBoxStartIndex,r.iconBoxEndIndex));}},Bs.prototype.hasTextData=function(){return this.text.segments.get().length>0},Bs.prototype.hasIconData=function(){return this.icon.segments.get().length>0},Bs.prototype.hasCollisionBoxData=function(){return this.collisionBox.segments.get().length>0},Bs.prototype.hasCollisionCircleData=function(){return this.collisionCircle.segments.get().length>0},Bs.prototype.addIndicesForPlacedTextSymbol=function(t){for(var e=this.text.placedSymbolArray.get(t),r=e.vertexStartIndex+4*e.numGlyphs,n=e.vertexStartIndex;n<r;n+=4)this.text.indexArray.emplaceBack(n,n+1,n+2),this.text.indexArray.emplaceBack(n+1,n+2,n+3);},Bs.prototype.sortFeatures=function(t){if(this.sortFeaturesByY&&this.sortedAngle!==t&&(this.sortedAngle=t,!(this.text.segments.get().length>1||this.icon.segments.get().length>1))){for(var e=[],r=0;r<this.symbolInstances.length;r++)e.push(r);for(var n=Math.sin(t),i=Math.cos(t),a=[],o=[],s=0;s<this.symbolInstances.length;s++){var u=this.symbolInstances.get(s);a.push(0|Math.round(n*u.anchorX+i*u.anchorY)),o.push(u.featureIndex);}e.sort(function(t,e){return a[t]-a[e]||o[e]-o[t]}),this.text.indexArray.clear(),this.icon.indexArray.clear(),this.featureSortOrder=[];for(var l=0,p=e;l<p.length;l+=1){var c=p[l],h=this.symbolInstances.get(c);this.featureSortOrder.push(h.featureIndex),h.horizontalPlacedTextSymbolIndex>=0&&this.addIndicesForPlacedTextSymbol(h.horizontalPlacedTextSymbolIndex),h.verticalPlacedTextSymbolIndex>=0&&this.addIndicesForPlacedTextSymbol(h.verticalPlacedTextSymbolIndex);var f=this.icon.placedSymbolArray.get(c);if(f.numGlyphs){var y=f.vertexStartIndex;this.icon.indexArray.emplaceBack(y,y+1,y+2),this.icon.indexArray.emplaceBack(y+1,y+2,y+3);}}this.text.indexBuffer&&this.text.indexBuffer.updateData(this.text.indexArray),this.icon.indexBuffer&&this.icon.indexBuffer.updateData(this.icon.indexArray);}},sn("SymbolBucket",Bs,{omit:["layers","collisionBoxArray","features","compareText"]}),Bs.MAX_GLYPHS=65535,Bs.addDynamicAttributes=ks;var Es=new Dn({"symbol-placement":new Mn(mt.layout_symbol["symbol-placement"]),"symbol-spacing":new Mn(mt.layout_symbol["symbol-spacing"]),"symbol-avoid-edges":new Mn(mt.layout_symbol["symbol-avoid-edges"]),"symbol-sort-key":new Tn(mt.layout_symbol["symbol-sort-key"]),"symbol-z-order":new Mn(mt.layout_symbol["symbol-z-order"]),"icon-allow-overlap":new Mn(mt.layout_symbol["icon-allow-overlap"]),"icon-ignore-placement":new Mn(mt.layout_symbol["icon-ignore-placement"]),"icon-optional":new Mn(mt.layout_symbol["icon-optional"]),"icon-rotation-alignment":new Mn(mt.layout_symbol["icon-rotation-alignment"]),"icon-size":new Tn(mt.layout_symbol["icon-size"]),"icon-text-fit":new Mn(mt.layout_symbol["icon-text-fit"]),"icon-text-fit-padding":new Mn(mt.layout_symbol["icon-text-fit-padding"]),"icon-image":new Tn(mt.layout_symbol["icon-image"]),"icon-rotate":new Tn(mt.layout_symbol["icon-rotate"]),"icon-padding":new Mn(mt.layout_symbol["icon-padding"]),"icon-keep-upright":new Mn(mt.layout_symbol["icon-keep-upright"]),"icon-offset":new Tn(mt.layout_symbol["icon-offset"]),"icon-anchor":new Tn(mt.layout_symbol["icon-anchor"]),"icon-pitch-alignment":new Mn(mt.layout_symbol["icon-pitch-alignment"]),"text-pitch-alignment":new Mn(mt.layout_symbol["text-pitch-alignment"]),"text-rotation-alignment":new Mn(mt.layout_symbol["text-rotation-alignment"]),"text-field":new Tn(mt.layout_symbol["text-field"]),"text-font":new Tn(mt.layout_symbol["text-font"]),"text-size":new Tn(mt.layout_symbol["text-size"]),"text-max-width":new Tn(mt.layout_symbol["text-max-width"]),"text-line-height":new Mn(mt.layout_symbol["text-line-height"]),"text-letter-spacing":new Tn(mt.layout_symbol["text-letter-spacing"]),"text-justify":new Tn(mt.layout_symbol["text-justify"]),"text-anchor":new Tn(mt.layout_symbol["text-anchor"]),"text-max-angle":new Mn(mt.layout_symbol["text-max-angle"]),"text-rotate":new Tn(mt.layout_symbol["text-rotate"]),"text-padding":new Mn(mt.layout_symbol["text-padding"]),"text-keep-upright":new Mn(mt.layout_symbol["text-keep-upright"]),"text-transform":new Tn(mt.layout_symbol["text-transform"]),"text-offset":new Tn(mt.layout_symbol["text-offset"]),"text-allow-overlap":new Mn(mt.layout_symbol["text-allow-overlap"]),"text-ignore-placement":new Mn(mt.layout_symbol["text-ignore-placement"]),"text-optional":new Mn(mt.layout_symbol["text-optional"])}),Ps={paint:new Dn({"icon-opacity":new Tn(mt.paint_symbol["icon-opacity"]),"icon-color":new Tn(mt.paint_symbol["icon-color"]),"icon-halo-color":new Tn(mt.paint_symbol["icon-halo-color"]),"icon-halo-width":new Tn(mt.paint_symbol["icon-halo-width"]),"icon-halo-blur":new Tn(mt.paint_symbol["icon-halo-blur"]),"icon-translate":new Mn(mt.paint_symbol["icon-translate"]),"icon-translate-anchor":new Mn(mt.paint_symbol["icon-translate-anchor"]),"text-opacity":new Tn(mt.paint_symbol["text-opacity"]),"text-color":new Tn(mt.paint_symbol["text-color"]),"text-halo-color":new Tn(mt.paint_symbol["text-halo-color"]),"text-halo-width":new Tn(mt.paint_symbol["text-halo-width"]),"text-halo-blur":new Tn(mt.paint_symbol["text-halo-blur"]),"text-translate":new Mn(mt.paint_symbol["text-translate"]),"text-translate-anchor":new Mn(mt.paint_symbol["text-translate-anchor"])}),layout:Es},Vs=function(t){function e(e){t.call(this,e,Ps);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(e){t.prototype.recalculate.call(this,e),"auto"===this.layout.get("icon-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["icon-rotation-alignment"]="map":this.layout._values["icon-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["text-rotation-alignment"]="map":this.layout._values["text-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-pitch-alignment")&&(this.layout._values["text-pitch-alignment"]=this.layout.get("text-rotation-alignment")),"auto"===this.layout.get("icon-pitch-alignment")&&(this.layout._values["icon-pitch-alignment"]=this.layout.get("icon-rotation-alignment"));},e.prototype.getValueAndResolveTokens=function(t,e){var r,n=this.layout.get(t).evaluate(e,{}),i=this._unevaluatedLayout._values[t];return i.isDataDriven()||yr(i.value)?n:(r=e.properties,n.replace(/{([^{}]+)}/g,function(t,e){return e in r?String(r[e]):""}))},e.prototype.createBucket=function(t){return new Bs(t)},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e}(Un),Cs={paint:new Dn({"background-color":new Mn(mt.paint_background["background-color"]),"background-pattern":new Ln(mt.paint_background["background-pattern"]),"background-opacity":new Mn(mt.paint_background["background-opacity"])})},Ms=function(t){function e(e){t.call(this,e,Cs);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Un),Ts={paint:new Dn({"raster-opacity":new Mn(mt.paint_raster["raster-opacity"]),"raster-hue-rotate":new Mn(mt.paint_raster["raster-hue-rotate"]),"raster-brightness-min":new Mn(mt.paint_raster["raster-brightness-min"]),"raster-brightness-max":new Mn(mt.paint_raster["raster-brightness-max"]),"raster-saturation":new Mn(mt.paint_raster["raster-saturation"]),"raster-contrast":new Mn(mt.paint_raster["raster-contrast"]),"raster-resampling":new Mn(mt.paint_raster["raster-resampling"]),"raster-fade-duration":new Mn(mt.paint_raster["raster-fade-duration"])})},Fs=function(t){function e(e){t.call(this,e,Ts);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Un);var Ls=function(t){function e(e){t.call(this,e,{}),this.implementation=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.hasOffscreenPass=function(){return void 0!==this.implementation.prerender||"3d"===this.implementation.renderingMode},e.prototype.recalculate=function(){},e.prototype.updateTransitions=function(){},e.prototype.hasTransition=function(){},e.prototype.serialize=function(){},e.prototype.resize=function(){this.viewportFrame&&(this.viewportFrame.destroy(),this.viewportFrame=null);},e.prototype.onAdd=function(t){this.implementation.onAdd&&this.implementation.onAdd(t,t.painter.context.gl);},e.prototype.onRemove=function(t){this.implementation.onRemove&&this.implementation.onRemove(t);},e}(Un),Os={circle:Ta,heatmap:Ka,hillshade:Xa,fill:Po,"fill-extrusion":Uo,line:ps,symbol:Vs,background:Ms,raster:Fs};function Ds(t){for(var e=0,r=0,n=0,i=t;n<i.length;n+=1){var a=i[n];e+=a.w*a.h,r=Math.max(r,a.w);}t.sort(function(t,e){return e.h-t.h});for(var o=[{x:0,y:0,w:Math.max(Math.ceil(Math.sqrt(e/.95)),r),h:1/0}],s=0,u=0,l=0,p=t;l<p.length;l+=1)for(var c=p[l],h=o.length-1;h>=0;h--){var f=o[h];if(!(c.w>f.w||c.h>f.h)){if(c.x=f.x,c.y=f.y,u=Math.max(u,c.y+c.h),s=Math.max(s,c.x+c.w),c.w===f.w&&c.h===f.h){var y=o.pop();h<o.length&&(o[h]=y);}else c.h===f.h?(f.x+=c.w,f.w-=c.w):c.w===f.w?(f.y+=c.h,f.h-=c.h):(o.push({x:f.x+c.w,y:f.y,w:f.w-c.w,h:c.h}),f.y+=c.h,f.h-=c.h);break}}return {w:s,h:u,fill:e/(s*u)||0}}var Us=function(t,e){var r=e.pixelRatio;this.paddedRect=t,this.pixelRatio=r;},js={tl:{configurable:!0},br:{configurable:!0},tlbr:{configurable:!0},displaySize:{configurable:!0}};js.tl.get=function(){return [this.paddedRect.x+1,this.paddedRect.y+1]},js.br.get=function(){return [this.paddedRect.x+this.paddedRect.w-1,this.paddedRect.y+this.paddedRect.h-1]},js.tlbr.get=function(){return this.tl.concat(this.br)},js.displaySize.get=function(){return [(this.paddedRect.w-2)/this.pixelRatio,(this.paddedRect.h-2)/this.pixelRatio]},Object.defineProperties(Us.prototype,js);var qs=function(t,e){var r={},n={},i=[];for(var a in t){var o=t[a],s={x:0,y:0,w:o.data.width+2,h:o.data.height+2};i.push(s),r[a]=new Us(s,o);}for(var u in e){var l=e[u],p={x:0,y:0,w:l.data.width+2,h:l.data.height+2};i.push(p),n[u]=new Us(p,l);}var c=Ds(i),h=c.w,f=c.h,y=new qa({width:h||1,height:f||1});for(var d in t){var m=t[d],v=r[d].paddedRect;qa.copy(m.data,y,{x:0,y:0},{x:v.x+1,y:v.y+1},m.data);}for(var g in e){var x=e[g],b=n[g].paddedRect,_=b.x+1,w=b.y+1,A=x.data.width,S=x.data.height;qa.copy(x.data,y,{x:0,y:0},{x:_,y:w},x.data),qa.copy(x.data,y,{x:0,y:S-1},{x:_,y:w-1},{width:A,height:1}),qa.copy(x.data,y,{x:0,y:0},{x:_,y:w+S},{width:A,height:1}),qa.copy(x.data,y,{x:A-1,y:0},{x:_-1,y:w},{width:1,height:S}),qa.copy(x.data,y,{x:0,y:0},{x:_+A,y:w},{width:1,height:S});}this.image=y,this.iconPositions=r,this.patternPositions=n;};sn("ImagePosition",Us),sn("ImageAtlas",qs);var Rs=self.HTMLImageElement,Ns=self.HTMLCanvasElement,Ks=self.HTMLVideoElement,Gs=self.ImageData,Xs=function(t,e,r,n){this.context=t,this.format=r,this.texture=t.gl.createTexture(),this.update(e,n);};Xs.prototype.update=function(t,e){var r=t.width,n=t.height,i=!this.size||this.size[0]!==r||this.size[1]!==n,a=this.context,o=a.gl;this.useMipmap=Boolean(e&&e.useMipmap),o.bindTexture(o.TEXTURE_2D,this.texture),a.pixelStoreUnpackFlipY.set(!1),a.pixelStoreUnpack.set(1),a.pixelStoreUnpackPremultiplyAlpha.set(this.format===o.RGBA&&(!e||!1!==e.premultiply)),i?(this.size=[r,n],t instanceof Rs||t instanceof Ns||t instanceof Ks||t instanceof Gs?o.texImage2D(o.TEXTURE_2D,0,this.format,this.format,o.UNSIGNED_BYTE,t):o.texImage2D(o.TEXTURE_2D,0,this.format,r,n,0,this.format,o.UNSIGNED_BYTE,t.data)):t instanceof Rs||t instanceof Ns||t instanceof Ks||t instanceof Gs?o.texSubImage2D(o.TEXTURE_2D,0,0,0,o.RGBA,o.UNSIGNED_BYTE,t):o.texSubImage2D(o.TEXTURE_2D,0,0,0,r,n,o.RGBA,o.UNSIGNED_BYTE,t.data),this.useMipmap&&this.isSizePowerOfTwo()&&o.generateMipmap(o.TEXTURE_2D);},Xs.prototype.bind=function(t,e,r){var n=this.context.gl;n.bindTexture(n.TEXTURE_2D,this.texture),r!==n.LINEAR_MIPMAP_NEAREST||this.isSizePowerOfTwo()||(r=n.LINEAR),t!==this.filter&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,t),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,r||t),this.filter=t),e!==this.wrap&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,e),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,e),this.wrap=e);},Xs.prototype.isSizePowerOfTwo=function(){return this.size[0]===this.size[1]&&Math.log(this.size[0])/Math.LN2%1==0},Xs.prototype.destroy=function(){this.context.gl.deleteTexture(this.texture),this.texture=null;};var Zs=function(t,e,r,n,i){var a,o,s=8*i-n-1,u=(1<<s)-1,l=u>>1,p=-7,c=r?i-1:0,h=r?-1:1,f=t[e+c];for(c+=h,a=f&(1<<-p)-1,f>>=-p,p+=s;p>0;a=256*a+t[e+c],c+=h,p-=8);for(o=a&(1<<-p)-1,a>>=-p,p+=n;p>0;o=256*o+t[e+c],c+=h,p-=8);if(0===a)a=1-l;else{if(a===u)return o?NaN:1/0*(f?-1:1);o+=Math.pow(2,n),a-=l;}return (f?-1:1)*o*Math.pow(2,a-n)},Hs=function(t,e,r,n,i,a){var o,s,u,l=8*a-i-1,p=(1<<l)-1,c=p>>1,h=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,f=n?0:a-1,y=n?1:-1,d=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,o=p):(o=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-o))<1&&(o--,u*=2),(e+=o+c>=1?h/u:h*Math.pow(2,1-c))*u>=2&&(o++,u/=2),o+c>=p?(s=0,o=p):o+c>=1?(s=(e*u-1)*Math.pow(2,i),o+=c):(s=e*Math.pow(2,c-1)*Math.pow(2,i),o=0));i>=8;t[r+f]=255&s,f+=y,s/=256,i-=8);for(o=o<<i|s,l+=i;l>0;t[r+f]=255&o,f+=y,o/=256,l-=8);t[r+f-y]|=128*d;},Ys=Js;function Js(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length;}Js.Varint=0,Js.Fixed64=1,Js.Bytes=2,Js.Fixed32=5;function $s(t){return t.type===Js.Bytes?t.readVarint()+t.pos:t.pos+1}function Ws(t,e,r){return r?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function Qs(t,e,r){var n=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.ceil(Math.log(e)/(7*Math.LN2));r.realloc(n);for(var i=r.pos-1;i>=t;i--)r.buf[i+n]=r.buf[i];}function tu(t,e){for(var r=0;r<t.length;r++)e.writeVarint(t[r]);}function eu(t,e){for(var r=0;r<t.length;r++)e.writeSVarint(t[r]);}function ru(t,e){for(var r=0;r<t.length;r++)e.writeFloat(t[r]);}function nu(t,e){for(var r=0;r<t.length;r++)e.writeDouble(t[r]);}function iu(t,e){for(var r=0;r<t.length;r++)e.writeBoolean(t[r]);}function au(t,e){for(var r=0;r<t.length;r++)e.writeFixed32(t[r]);}function ou(t,e){for(var r=0;r<t.length;r++)e.writeSFixed32(t[r]);}function su(t,e){for(var r=0;r<t.length;r++)e.writeFixed64(t[r]);}function uu(t,e){for(var r=0;r<t.length;r++)e.writeSFixed64(t[r]);}function lu(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function pu(t,e,r){t[r]=e,t[r+1]=e>>>8,t[r+2]=e>>>16,t[r+3]=e>>>24;}function cu(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}Js.prototype={destroy:function(){this.buf=null;},readFields:function(t,e,r){for(r=r||this.length;this.pos<r;){var n=this.readVarint(),i=n>>3,a=this.pos;this.type=7&n,t(i,e,this),this.pos===a&&this.skip(n);}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=lu(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=cu(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=lu(this.buf,this.pos)+4294967296*lu(this.buf,this.pos+4);return this.pos+=8,t},readSFixed64:function(){var t=lu(this.buf,this.pos)+4294967296*cu(this.buf,this.pos+4);return this.pos+=8,t},readFloat:function(){var t=Zs(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=Zs(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,r,n=this.buf;return e=127&(r=n[this.pos++]),r<128?e:(e|=(127&(r=n[this.pos++]))<<7,r<128?e:(e|=(127&(r=n[this.pos++]))<<14,r<128?e:(e|=(127&(r=n[this.pos++]))<<21,r<128?e:function(t,e,r){var n,i,a=r.buf;if(i=a[r.pos++],n=(112&i)>>4,i<128)return Ws(t,n,e);if(i=a[r.pos++],n|=(127&i)<<3,i<128)return Ws(t,n,e);if(i=a[r.pos++],n|=(127&i)<<10,i<128)return Ws(t,n,e);if(i=a[r.pos++],n|=(127&i)<<17,i<128)return Ws(t,n,e);if(i=a[r.pos++],n|=(127&i)<<24,i<128)return Ws(t,n,e);if(i=a[r.pos++],n|=(1&i)<<31,i<128)return Ws(t,n,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(r=n[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=function(t,e,r){var n="",i=e;for(;i<r;){var a,o,s,u=t[i],l=null,p=u>239?4:u>223?3:u>191?2:1;if(i+p>r)break;1===p?u<128&&(l=u):2===p?128==(192&(a=t[i+1]))&&(l=(31&u)<<6|63&a)<=127&&(l=null):3===p?(a=t[i+1],o=t[i+2],128==(192&a)&&128==(192&o)&&((l=(15&u)<<12|(63&a)<<6|63&o)<=2047||l>=55296&&l<=57343)&&(l=null)):4===p&&(a=t[i+1],o=t[i+2],s=t[i+3],128==(192&a)&&128==(192&o)&&128==(192&s)&&((l=(15&u)<<18|(63&a)<<12|(63&o)<<6|63&s)<=65535||l>=1114112)&&(l=null)),null===l?(l=65533,p=1):l>65535&&(l-=65536,n+=String.fromCharCode(l>>>10&1023|55296),l=56320|1023&l),n+=String.fromCharCode(l),i+=p;}return n}(this.buf,this.pos,t);return this.pos=t,e},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){var r=$s(this);for(t=t||[];this.pos<r;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){var e=$s(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){var e=$s(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){var e=$s(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){var e=$s(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){var e=$s(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){var e=$s(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){var e=$s(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){var e=$s(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===Js.Varint)for(;this.buf[this.pos++]>127;);else if(e===Js.Bytes)this.pos=this.readVarint()+this.pos;else if(e===Js.Fixed32)this.pos+=4;else{if(e!==Js.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8;}},writeTag:function(t,e){this.writeVarint(t<<3|e);},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var r=new Uint8Array(e);r.set(this.buf),this.buf=r,this.length=e;}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),pu(this.buf,t,this.pos),this.pos+=4;},writeSFixed32:function(t){this.realloc(4),pu(this.buf,t,this.pos),this.pos+=4;},writeFixed64:function(t){this.realloc(8),pu(this.buf,-1&t,this.pos),pu(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeSFixed64:function(t){this.realloc(8),pu(this.buf,-1&t,this.pos),pu(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var r,n;t>=0?(r=t%4294967296|0,n=t/4294967296|0):(n=~(-t/4294967296),4294967295^(r=~(-t%4294967296))?r=r+1|0:(r=0,n=n+1|0));if(t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,r){r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos]=127&t;}(r,0,e),function(t,e){var r=(7&t)<<4;if(e.buf[e.pos++]|=r|((t>>>=3)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;e.buf[e.pos++]=127&t;}(n,e);}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))));},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t);},writeBoolean:function(t){this.writeVarint(Boolean(t));},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,r){for(var n,i,a=0;a<e.length;a++){if((n=e.charCodeAt(a))>55295&&n<57344){if(!i){n>56319||a+1===e.length?(t[r++]=239,t[r++]=191,t[r++]=189):i=n;continue}if(n<56320){t[r++]=239,t[r++]=191,t[r++]=189,i=n;continue}n=i-55296<<10|n-56320|65536,i=null;}else i&&(t[r++]=239,t[r++]=191,t[r++]=189,i=null);n<128?t[r++]=n:(n<2048?t[r++]=n>>6|192:(n<65536?t[r++]=n>>12|224:(t[r++]=n>>18|240,t[r++]=n>>12&63|128),t[r++]=n>>6&63|128),t[r++]=63&n|128);}return r}(this.buf,t,this.pos);var r=this.pos-e;r>=128&&Qs(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r;},writeFloat:function(t){this.realloc(4),Hs(this.buf,t,this.pos,!0,23,4),this.pos+=4;},writeDouble:function(t){this.realloc(8),Hs(this.buf,t,this.pos,!0,52,8),this.pos+=8;},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var r=0;r<e;r++)this.buf[this.pos++]=t[r];},writeRawMessage:function(t,e){this.pos++;var r=this.pos;t(e,this);var n=this.pos-r;n>=128&&Qs(r,n,this),this.pos=r-1,this.writeVarint(n),this.pos+=n;},writeMessage:function(t,e,r){this.writeTag(t,Js.Bytes),this.writeRawMessage(e,r);},writePackedVarint:function(t,e){this.writeMessage(t,tu,e);},writePackedSVarint:function(t,e){this.writeMessage(t,eu,e);},writePackedBoolean:function(t,e){this.writeMessage(t,iu,e);},writePackedFloat:function(t,e){this.writeMessage(t,ru,e);},writePackedDouble:function(t,e){this.writeMessage(t,nu,e);},writePackedFixed32:function(t,e){this.writeMessage(t,au,e);},writePackedSFixed32:function(t,e){this.writeMessage(t,ou,e);},writePackedFixed64:function(t,e){this.writeMessage(t,su,e);},writePackedSFixed64:function(t,e){this.writeMessage(t,uu,e);},writeBytesField:function(t,e){this.writeTag(t,Js.Bytes),this.writeBytes(e);},writeFixed32Field:function(t,e){this.writeTag(t,Js.Fixed32),this.writeFixed32(e);},writeSFixed32Field:function(t,e){this.writeTag(t,Js.Fixed32),this.writeSFixed32(e);},writeFixed64Field:function(t,e){this.writeTag(t,Js.Fixed64),this.writeFixed64(e);},writeSFixed64Field:function(t,e){this.writeTag(t,Js.Fixed64),this.writeSFixed64(e);},writeVarintField:function(t,e){this.writeTag(t,Js.Varint),this.writeVarint(e);},writeSVarintField:function(t,e){this.writeTag(t,Js.Varint),this.writeSVarint(e);},writeStringField:function(t,e){this.writeTag(t,Js.Bytes),this.writeString(e);},writeFloatField:function(t,e){this.writeTag(t,Js.Fixed32),this.writeFloat(e);},writeDoubleField:function(t,e){this.writeTag(t,Js.Fixed64),this.writeDouble(e);},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e));}};var hu=3;function fu(t,e,r){1===t&&r.readMessage(yu,e);}function yu(t,e,r){if(3===t){var n=r.readMessage(du,{}),i=n.id,a=n.bitmap,o=n.width,s=n.height,u=n.left,l=n.top,p=n.advance;e.push({id:i,bitmap:new ja({width:o+2*hu,height:s+2*hu},a),metrics:{width:o,height:s,left:u,top:l,advance:p}});}}function du(t,e,r){1===t?e.id=r.readVarint():2===t?e.bitmap=r.readBytes():3===t?e.width=r.readVarint():4===t?e.height=r.readVarint():5===t?e.left=r.readSVarint():6===t?e.top=r.readSVarint():7===t&&(e.advance=r.readVarint());}var mu=hu,vu=function(t,e,r){this.target=t,this.parent=e,this.mapId=r,this.callbacks={},this.callbackID=0,m(["receive"],this),this.target.addEventListener("message",this.receive,!1);};function gu(t,e,r){var n=2*Math.PI*6378137/256/Math.pow(2,r);return [t*n-2*Math.PI*6378137/2,e*n-2*Math.PI*6378137/2]}vu.prototype.send=function(t,e,r,n){var i=this,a=r?this.mapId+":"+this.callbackID++:null;r&&(this.callbacks[a]=r);var o=[];if(this.target.postMessage({targetMapId:n,sourceMapId:this.mapId,type:t,id:String(a),data:ln(e,o)},o),r)return {cancel:function(){return i.target.postMessage({targetMapId:n,sourceMapId:i.mapId,type:"<cancel>",id:String(a)})}}},vu.prototype.receive=function(t){var e,r=this,n=t.data,i=n.id;if(!n.targetMapId||this.mapId===n.targetMapId){var a=function(t,e){delete r.callbacks[i];var n=[];r.target.postMessage({sourceMapId:r.mapId,type:"<response>",id:String(i),error:t?ln(t):null,data:ln(e,n)},n);};if("<response>"===n.type||"<cancel>"===n.type)e=this.callbacks[n.id],delete this.callbacks[n.id],e&&n.error?e(pn(n.error)):e&&e(null,pn(n.data));else if(void 0!==n.id&&this.parent[n.type]){this.callbacks[n.id]=null;var o=this.parent[n.type](n.sourceMapId,pn(n.data),a);o&&null===this.callbacks[n.id]&&(this.callbacks[n.id]=o);}else if(void 0!==n.id&&this.parent.getWorkerSource){var s=n.type.split("."),u=pn(n.data);this.parent.getWorkerSource(n.sourceMapId,s[0],u.source)[s[1]](u,a);}else this.parent[n.type](pn(n.data));}},vu.prototype.remove=function(){this.target.removeEventListener("message",this.receive,!1);};var xu=function(t,e){t&&(e?this.setSouthWest(t).setNorthEast(e):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]));};xu.prototype.setNorthEast=function(t){return this._ne=t instanceof bu?new bu(t.lng,t.lat):bu.convert(t),this},xu.prototype.setSouthWest=function(t){return this._sw=t instanceof bu?new bu(t.lng,t.lat):bu.convert(t),this},xu.prototype.extend=function(t){var e,r,n=this._sw,i=this._ne;if(t instanceof bu)e=t,r=t;else{if(!(t instanceof xu))return Array.isArray(t)?t.every(Array.isArray)?this.extend(xu.convert(t)):this.extend(bu.convert(t)):this;if(e=t._sw,r=t._ne,!e||!r)return this}return n||i?(n.lng=Math.min(e.lng,n.lng),n.lat=Math.min(e.lat,n.lat),i.lng=Math.max(r.lng,i.lng),i.lat=Math.max(r.lat,i.lat)):(this._sw=new bu(e.lng,e.lat),this._ne=new bu(r.lng,r.lat)),this},xu.prototype.getCenter=function(){return new bu((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)},xu.prototype.getSouthWest=function(){return this._sw},xu.prototype.getNorthEast=function(){return this._ne},xu.prototype.getNorthWest=function(){return new bu(this.getWest(),this.getNorth())},xu.prototype.getSouthEast=function(){return new bu(this.getEast(),this.getSouth())},xu.prototype.getWest=function(){return this._sw.lng},xu.prototype.getSouth=function(){return this._sw.lat},xu.prototype.getEast=function(){return this._ne.lng},xu.prototype.getNorth=function(){return this._ne.lat},xu.prototype.toArray=function(){return [this._sw.toArray(),this._ne.toArray()]},xu.prototype.toString=function(){return "LngLatBounds("+this._sw.toString()+", "+this._ne.toString()+")"},xu.prototype.isEmpty=function(){return !(this._sw&&this._ne)},xu.convert=function(t){return !t||t instanceof xu?t:new xu(t)};var bu=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid LngLat object: ("+t+", "+e+")");if(this.lng=+t,this.lat=+e,this.lat>90||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")};function _u(t){return 2*Math.PI*6378137*Math.cos(t*Math.PI/180)}function wu(t){return (180+t)/360}function Au(t){return (180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360)))/360}function Su(t,e){return t/_u(e)}function ku(t){var e=180-360*t;return 360/Math.PI*Math.atan(Math.exp(e*Math.PI/180))-90}bu.prototype.wrap=function(){return new bu(p(this.lng,-180,180),this.lat)},bu.prototype.toArray=function(){return [this.lng,this.lat]},bu.prototype.toString=function(){return "LngLat("+this.lng+", "+this.lat+")"},bu.prototype.toBounds=function(t){void 0===t&&(t=0);var e=360*t/40075017,r=e/Math.cos(Math.PI/180*this.lat);return new xu(new bu(this.lng-r,this.lat-e),new bu(this.lng+r,this.lat+e))},bu.convert=function(t){if(t instanceof bu)return t;if(Array.isArray(t)&&(2===t.length||3===t.length))return new bu(Number(t[0]),Number(t[1]));if(!Array.isArray(t)&&"object"==typeof t&&null!==t)return new bu(Number("lng"in t?t.lng:t.lon),Number(t.lat));throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")};var zu=function(t,e,r){void 0===r&&(r=0),this.x=+t,this.y=+e,this.z=+r;};zu.fromLngLat=function(t,e){void 0===e&&(e=0);var r=bu.convert(t);return new zu(wu(r.lng),Au(r.lat),Su(e,r.lat))},zu.prototype.toLngLat=function(){return new bu(360*this.x-180,ku(this.y))},zu.prototype.toAltitude=function(){return t=this.z,e=this.y,t*_u(ku(e));var t,e;};var Iu=function(t,e,r){this.z=t,this.x=e,this.y=r,this.key=Pu(0,t,e,r);};Iu.prototype.equals=function(t){return this.z===t.z&&this.x===t.x&&this.y===t.y},Iu.prototype.url=function(t,e){var r,n,i,a,o,s=(r=this.x,n=this.y,i=this.z,a=gu(256*r,256*(n=Math.pow(2,i)-n-1),i),o=gu(256*(r+1),256*(n+1),i),a[0]+","+a[1]+","+o[0]+","+o[1]),u=function(t,e,r){for(var n,i="",a=t;a>0;a--)i+=(e&(n=1<<a-1)?1:0)+(r&n?2:0);return i}(this.z,this.x,this.y);return t[(this.x+this.y)%t.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace("{z}",String(this.z)).replace("{x}",String(this.x)).replace("{y}",String("tms"===e?Math.pow(2,this.z)-this.y-1:this.y)).replace("{quadkey}",u).replace("{bbox-epsg-3857}",s)},Iu.prototype.getTilePoint=function(t){var e=Math.pow(2,this.z);return new i((t.x*e-this.x)*Yi,(t.y*e-this.y)*Yi)};var Bu=function(t,e){this.wrap=t,this.canonical=e,this.key=Pu(t,e.z,e.x,e.y);},Eu=function(t,e,r,n,i){this.overscaledZ=t,this.wrap=e,this.canonical=new Iu(r,+n,+i),this.key=Pu(e,t,n,i);};function Pu(t,e,r,n){(t*=2)<0&&(t=-1*t-1);var i=1<<e;return 32*(i*i*t+i*n+r)+e}Eu.prototype.equals=function(t){return this.overscaledZ===t.overscaledZ&&this.wrap===t.wrap&&this.canonical.equals(t.canonical)},Eu.prototype.scaledTo=function(t){var e=this.canonical.z-t;return t>this.canonical.z?new Eu(t,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y):new Eu(t,this.wrap,t,this.canonical.x>>e,this.canonical.y>>e)},Eu.prototype.isChildOf=function(t){if(t.wrap!==this.wrap)return !1;var e=this.canonical.z-t.canonical.z;return 0===t.overscaledZ||t.overscaledZ<this.overscaledZ&&t.canonical.x===this.canonical.x>>e&&t.canonical.y===this.canonical.y>>e},Eu.prototype.children=function(t){if(this.overscaledZ>=t)return [new Eu(this.overscaledZ+1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];var e=this.canonical.z+1,r=2*this.canonical.x,n=2*this.canonical.y;return [new Eu(e,this.wrap,e,r,n),new Eu(e,this.wrap,e,r+1,n),new Eu(e,this.wrap,e,r,n+1),new Eu(e,this.wrap,e,r+1,n+1)]},Eu.prototype.isLessThan=function(t){return this.wrap<t.wrap||!(this.wrap>t.wrap)&&(this.overscaledZ<t.overscaledZ||!(this.overscaledZ>t.overscaledZ)&&(this.canonical.x<t.canonical.x||!(this.canonical.x>t.canonical.x)&&this.canonical.y<t.canonical.y))},Eu.prototype.wrapped=function(){return new Eu(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)},Eu.prototype.unwrapTo=function(t){return new Eu(this.overscaledZ,t,this.canonical.z,this.canonical.x,this.canonical.y)},Eu.prototype.overscaleFactor=function(){return Math.pow(2,this.overscaledZ-this.canonical.z)},Eu.prototype.toUnwrapped=function(){return new Bu(this.wrap,this.canonical)},Eu.prototype.toString=function(){return this.overscaledZ+"/"+this.canonical.x+"/"+this.canonical.y},Eu.prototype.getTilePoint=function(t){return this.canonical.getTilePoint(new zu(t.x-this.wrap,t.y))},sn("CanonicalTileID",Iu),sn("OverscaledTileID",Eu,{omit:["posMatrix"]});var Vu=function(t,e,r){if(this.uid=t,e.height!==e.width)throw new RangeError("DEM tiles must be square");if(r&&"mapbox"!==r&&"terrarium"!==r)return w('"'+r+'" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');var n=this.dim=e.height;this.stride=this.dim+2,this.data=new Int32Array(this.stride*this.stride);for(var i=e.data,a="terrarium"===r?this._unpackTerrarium:this._unpackMapbox,o=0;o<n;o++)for(var s=0;s<n;s++){var u=4*(o*n+s);this.set(s,o,a(i[u],i[u+1],i[u+2]));}for(var l=0;l<n;l++)this.set(-1,l,this.get(0,l)),this.set(n,l,this.get(n-1,l)),this.set(l,-1,this.get(l,0)),this.set(l,n,this.get(l,n-1));this.set(-1,-1,this.get(0,0)),this.set(n,-1,this.get(n-1,0)),this.set(-1,n,this.get(0,n-1)),this.set(n,n,this.get(n-1,n-1));};Vu.prototype.set=function(t,e,r){this.data[this._idx(t,e)]=r+65536;},Vu.prototype.get=function(t,e){return this.data[this._idx(t,e)]-65536},Vu.prototype._idx=function(t,e){if(t<-1||t>=this.dim+1||e<-1||e>=this.dim+1)throw new RangeError("out of range source coordinates for DEM data");return (e+1)*this.stride+(t+1)},Vu.prototype._unpackMapbox=function(t,e,r){return (256*t*256+256*e+r)/10-1e4},Vu.prototype._unpackTerrarium=function(t,e,r){return 256*t+e+r/256-32768},Vu.prototype.getPixels=function(){return new qa({width:this.stride,height:this.stride},new Uint8Array(this.data.buffer))},Vu.prototype.backfillBorder=function(t,e,r){if(this.dim!==t.dim)throw new Error("dem dimension mismatch");var n=e*this.dim,i=e*this.dim+this.dim,a=r*this.dim,o=r*this.dim+this.dim;switch(e){case-1:n=i-1;break;case 1:i=n+1;}switch(r){case-1:a=o-1;break;case 1:o=a+1;}for(var s=-e*this.dim,u=-r*this.dim,l=a;l<o;l++)for(var p=n;p<i;p++)this.set(p,l,t.get(p+s,l+u));},sn("DEMData",Vu);var Cu=Nn([{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]);var Mu=function(t){this._stringToNumber={},this._numberToString=[];for(var e=0;e<t.length;e++){var r=t[e];this._stringToNumber[r]=e,this._numberToString[e]=r;}};Mu.prototype.encode=function(t){return this._stringToNumber[t]},Mu.prototype.decode=function(t){return this._numberToString[t]};var Tu=function(t,e,r,n){this.type="Feature",this._vectorTileFeature=t,t._z=e,t._x=r,t._y=n,this.properties=t.properties,null!=t.id&&(this.id=t.id);},Fu={geometry:{configurable:!0}};Fu.geometry.get=function(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x,this._vectorTileFeature._y,this._vectorTileFeature._z).geometry),this._geometry},Fu.geometry.set=function(t){this._geometry=t;},Tu.prototype.toJSON=function(){var t={geometry:this.geometry};for(var e in this)"_geometry"!==e&&"_vectorTileFeature"!==e&&(t[e]=this[e]);return t},Object.defineProperties(Tu.prototype,Fu);var Lu=function(){this.state={},this.stateChanges={},this.deletedStates={};};Lu.prototype.updateState=function(t,e,r){var n=String(e);if(this.stateChanges[t]=this.stateChanges[t]||{},this.stateChanges[t][n]=this.stateChanges[t][n]||{},c(this.stateChanges[t][n],r),null===this.deletedStates[t])for(var i in this.deletedStates[t]={},this.state[t])i!==n&&(this.deletedStates[t][i]=null);else if(this.deletedStates[t]&&null===this.deletedStates[t][n])for(var a in this.deletedStates[t][n]={},this.state[t][n])r[a]||(this.deletedStates[t][n][a]=null);else for(var o in r){this.deletedStates[t]&&this.deletedStates[t][n]&&null===this.deletedStates[t][n][o]&&delete this.deletedStates[t][n][o];}},Lu.prototype.removeFeatureState=function(t,e,r){if(!(null===this.deletedStates[t])){var n=String(e);if(this.deletedStates[t]=this.deletedStates[t]||{},r&&e)null!==this.deletedStates[t][n]&&(this.deletedStates[t][n]=this.deletedStates[t][n]||{},this.deletedStates[t][n][r]=null);else if(e){if(this.stateChanges[t]&&this.stateChanges[t][n])for(r in this.deletedStates[t][n]={},this.stateChanges[t][n])this.deletedStates[t][n][r]=null;else this.deletedStates[t][n]=null;}else this.deletedStates[t]=null;}},Lu.prototype.getState=function(t,e){var r=String(e),n=this.state[t]||{},i=this.stateChanges[t]||{},a=c({},n[r],i[r]);if(null===this.deletedStates[t])return {};if(this.deletedStates[t]){var o=this.deletedStates[t][e];if(null===o)return {};for(var s in o)delete a[s];}return a},Lu.prototype.initializeTileState=function(t,e){t.setFeatureState(this.state,e);},Lu.prototype.coalesceChanges=function(t,e){var r={};for(var n in this.stateChanges){this.state[n]=this.state[n]||{};var i={};for(var a in this.stateChanges[n])this.state[n][a]||(this.state[n][a]={}),c(this.state[n][a],this.stateChanges[n][a]),i[a]=this.state[n][a];r[n]=i;}for(var o in this.deletedStates){this.state[o]=this.state[o]||{};var s={};if(null===this.deletedStates[o]){for(var u in this.state[o])s[u]={};this.state[o]={};}else for(var l in this.deletedStates[o]){if(null===this.deletedStates[o][l])this.state[o][l]={};else for(var p=0,h=Object.keys(this.deletedStates[o][l]);p<h.length;p+=1){var f=h[p];delete this.state[o][l][f];}s[l]=this.state[o][l];}r[o]=r[o]||{},c(r[o],s);}if(this.stateChanges={},this.deletedStates={},0!==Object.keys(r).length)for(var y in t){t[y].setFeatureState(r,e);}};var Ou=function(t,e,r){this.tileID=t,this.x=t.canonical.x,this.y=t.canonical.y,this.z=t.canonical.z,this.grid=e||new en(Yi,16,0),this.grid3D=new en(Yi,16,0),this.featureIndexArray=r||new Ai;};function Du(t){for(var e=1/0,r=1/0,n=-1/0,i=-1/0,a=0,o=t;a<o.length;a+=1){var s=o[a];e=Math.min(e,s.x),r=Math.min(r,s.y),n=Math.max(n,s.x),i=Math.max(i,s.y);}return {minX:e,minY:r,maxX:n,maxY:i}}function Uu(t,e){return e-t}Ou.prototype.insert=function(t,e,r,n,i,a){var o=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(r,n,i);for(var s=a?this.grid3D:this.grid,u=0;u<e.length;u++){for(var l=e[u],p=[1/0,1/0,-1/0,-1/0],c=0;c<l.length;c++){var h=l[c];p[0]=Math.min(p[0],h.x),p[1]=Math.min(p[1],h.y),p[2]=Math.max(p[2],h.x),p[3]=Math.max(p[3],h.y);}p[0]<Yi&&p[1]<Yi&&p[2]>=0&&p[3]>=0&&s.insert(o,p[0],p[1],p[2],p[3]);}},Ou.prototype.loadVTLayers=function(){return this.vtLayers||(this.vtLayers=new Wo.VectorTile(new Ys(this.rawTileData)).layers,this.sourceLayerCoder=new Mu(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"])),this.vtLayers},Ou.prototype.query=function(t,e,r){var n=this;this.loadVTLayers();for(var a=t.params||{},o=Yi/t.tileSize/t.scale,s=Er(a.filter),u=t.queryGeometry,l=t.queryPadding*o,p=Du(u),c=this.grid.query(p.minX-l,p.minY-l,p.maxX+l,p.maxY+l),h=Du(t.cameraQueryGeometry),f=this.grid3D.query(h.minX-l,h.minY-l,h.maxX+l,h.maxY+l,function(e,r,n,a){return function(t,e,r,n,a){for(var o=0,s=t;o<s.length;o+=1){var u=s[o];if(e<=u.x&&r<=u.y&&n>=u.x&&a>=u.y)return !0}var l=[new i(e,r),new i(e,a),new i(n,a),new i(n,r)];if(t.length>2)for(var p=0,c=l;p<c.length;p+=1)if(pa(t,c[p]))return !0;for(var h=0;h<t.length-1;h++)if(ca(t[h],t[h+1],l))return !0;return !1}(t.cameraQueryGeometry,e-l,r-l,n+l,a+l)}),y=0,d=f;y<d.length;y+=1){var m=d[y];c.push(m);}c.sort(Uu);for(var v,g={},x=function(i){var l=c[i];if(l!==v){v=l;var p=n.featureIndexArray.get(l),h=null;n.loadMatchingFeature(g,p.bucketIndex,p.sourceLayerIndex,p.featureIndex,s,a.layers,e,function(e,i){h||(h=Wi(e));var a={};return e.id&&(a=r.getState(i.sourceLayer||"_geojsonTileLayer",e.id)),i.queryIntersectsFeature(u,e,a,h,n.z,t.transform,o,t.pixelPosMatrix)});}},b=0;b<c.length;b++)x(b);return g},Ou.prototype.loadMatchingFeature=function(t,e,r,n,i,a,o,s){var u=this.bucketLayerIDs[e];if(!a||function(t,e){for(var r=0;r<t.length;r++)if(e.indexOf(t[r])>=0)return !0;return !1}(a,u)){var l=this.sourceLayerCoder.decode(r),p=this.vtLayers[l].feature(n);if(i(new Sn(this.tileID.overscaledZ),p))for(var c=0;c<u.length;c++){var h=u[c];if(!(a&&a.indexOf(h)<0)){var f=o[h];if(f){var y=!s||s(p,f);if(y){var d=new Tu(p,this.z,this.x,this.y);d.layer=f.serialize();var m=t[h];void 0===m&&(m=t[h]=[]),m.push({featureIndex:n,feature:d,intersectionZ:y});}}}}}},Ou.prototype.lookupSymbolFeatures=function(t,e,r,n,i,a){var o={};this.loadVTLayers();for(var s=Er(n),u=0,l=t;u<l.length;u+=1){var p=l[u];this.loadMatchingFeature(o,e,r,p,s,i,a);}return o},Ou.prototype.hasLayer=function(t){for(var e=0,r=this.bucketLayerIDs;e<r.length;e+=1)for(var n=0,i=r[e];n<i.length;n+=1){if(t===i[n])return !0}return !1},sn("FeatureIndex",Ou,{omit:["rawTileData","sourceLayerCoder"]});var ju=function(t,e){this.tileID=t,this.uid=f(),this.uses=0,this.tileSize=e,this.buckets={},this.expirationTime=null,this.queryPadding=0,this.hasSymbolBuckets=!1,this.expiredRequestCount=0,this.state="loading";};ju.prototype.registerFadeDuration=function(t){var e=t+this.timeAdded;e<V.now()||this.fadeEndTime&&e<this.fadeEndTime||(this.fadeEndTime=e);},ju.prototype.wasRequested=function(){return "errored"===this.state||"loaded"===this.state||"reloading"===this.state},ju.prototype.loadVectorData=function(t,e,r){if(this.hasData()&&this.unloadVectorData(),this.state="loaded",t){for(var n in t.featureIndex&&(this.latestFeatureIndex=t.featureIndex,t.rawTileData?(this.latestRawTileData=t.rawTileData,this.latestFeatureIndex.rawTileData=t.rawTileData):this.latestRawTileData&&(this.latestFeatureIndex.rawTileData=this.latestRawTileData)),this.collisionBoxArray=t.collisionBoxArray,this.buckets=function(t,e){var r={};if(!e)return r;for(var n=function(){var t=a[i],n=t.layerIds.map(function(t){return e.getLayer(t)}).filter(Boolean);if(0!==n.length){t.layers=n,t.stateDependentLayerIds&&(t.stateDependentLayers=t.stateDependentLayerIds.map(function(t){return n.filter(function(e){return e.id===t})[0]}));for(var o=0,s=n;o<s.length;o+=1){var u=s[o];r[u.id]=t;}}},i=0,a=t;i<a.length;i+=1)n();return r}(t.buckets,e.style),this.hasSymbolBuckets=!1,this.buckets){var i=this.buckets[n];if(i instanceof Bs){if(this.hasSymbolBuckets=!0,!r)break;i.justReloaded=!0;}}for(var a in this.queryPadding=0,this.buckets){var o=this.buckets[a];this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(a).queryRadius(o));}t.imageAtlas&&(this.imageAtlas=t.imageAtlas),t.glyphAtlasImage&&(this.glyphAtlasImage=t.glyphAtlasImage);}else this.collisionBoxArray=new fi;},ju.prototype.unloadVectorData=function(){for(var t in this.buckets)this.buckets[t].destroy();this.buckets={},this.imageAtlasTexture&&this.imageAtlasTexture.destroy(),this.imageAtlas&&(this.imageAtlas=null),this.glyphAtlasTexture&&this.glyphAtlasTexture.destroy(),this.latestFeatureIndex=null,this.state="unloaded";},ju.prototype.unloadDEMData=function(){this.dem=null,this.neighboringTiles=null,this.state="unloaded";},ju.prototype.getBucket=function(t){return this.buckets[t.id]},ju.prototype.upload=function(t){for(var e in this.buckets){var r=this.buckets[e];r.uploadPending()&&r.upload(t);}var n=t.gl;this.imageAtlas&&!this.imageAtlas.uploaded&&(this.imageAtlasTexture=new Xs(t,this.imageAtlas.image,n.RGBA),this.imageAtlas.uploaded=!0),this.glyphAtlasImage&&(this.glyphAtlasTexture=new Xs(t,this.glyphAtlasImage,n.ALPHA),this.glyphAtlasImage=null);},ju.prototype.queryRenderedFeatures=function(t,e,r,n,i,a,o,s,u){return this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData?this.latestFeatureIndex.query({queryGeometry:r,cameraQueryGeometry:n,scale:i,tileSize:this.tileSize,pixelPosMatrix:u,transform:o,params:a,queryPadding:this.queryPadding*s},t,e):{}},ju.prototype.querySourceFeatures=function(t,e){if(this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData){var r=this.latestFeatureIndex.loadVTLayers(),n=e?e.sourceLayer:"",i=r._geojsonTileLayer||r[n];if(i)for(var a=Er(e&&e.filter),o=this.tileID.canonical,s=o.z,u=o.x,l=o.y,p={z:s,x:u,y:l},c=0;c<i.length;c++){var h=i.feature(c);if(a(new Sn(this.tileID.overscaledZ),h)){var f=new Tu(h,s,u,l);f.tile=p,t.push(f);}}}},ju.prototype.clearMask=function(){this.segments&&(this.segments.destroy(),delete this.segments),this.maskedBoundsBuffer&&(this.maskedBoundsBuffer.destroy(),delete this.maskedBoundsBuffer),this.maskedIndexBuffer&&(this.maskedIndexBuffer.destroy(),delete this.maskedIndexBuffer);},ju.prototype.setMask=function(t,e){if(!o(this.mask,t)&&(this.mask=t,this.clearMask(),!o(t,{0:!0}))){var r=new Xn,n=new si;this.segments=new zi,this.segments.prepareSegment(0,r,n);for(var a=Object.keys(t),s=0;s<a.length;s++){var u=t[a[s]],l=Yi>>u.z,p=new i(u.x*l,u.y*l),c=new i(p.x+l,p.y+l),h=this.segments.prepareSegment(4,r,n);r.emplaceBack(p.x,p.y,p.x,p.y),r.emplaceBack(c.x,p.y,c.x,p.y),r.emplaceBack(p.x,c.y,p.x,c.y),r.emplaceBack(c.x,c.y,c.x,c.y);var f=h.vertexLength;n.emplaceBack(f,f+1,f+2),n.emplaceBack(f+1,f+2,f+3),h.vertexLength+=4,h.primitiveLength+=2;}this.maskedBoundsBuffer=e.createVertexBuffer(r,Cu.members),this.maskedIndexBuffer=e.createIndexBuffer(n);}},ju.prototype.hasData=function(){return "loaded"===this.state||"reloading"===this.state||"expired"===this.state},ju.prototype.patternsLoaded=function(){return this.imageAtlas&&!!Object.keys(this.imageAtlas.patternPositions).length},ju.prototype.setExpiryData=function(t){var e=this.expirationTime;if(t.cacheControl){var r=function(t){var e={};if(t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g,function(t,r,n,i){var a=n||i;return e[r]=!a||a.toLowerCase(),""}),e["max-age"]){var r=parseInt(e["max-age"],10);isNaN(r)?delete e["max-age"]:e["max-age"]=r;}return e}(t.cacheControl);r["max-age"]&&(this.expirationTime=Date.now()+1e3*r["max-age"]);}else t.expires&&(this.expirationTime=new Date(t.expires).getTime());if(this.expirationTime){var n=Date.now(),i=!1;if(this.expirationTime>n)i=!1;else if(e)if(this.expirationTime<e)i=!0;else{var a=this.expirationTime-e;a?this.expirationTime=n+Math.max(a,3e4):i=!0;}else i=!0;i?(this.expiredRequestCount++,this.state="expired"):this.expiredRequestCount=0;}},ju.prototype.getExpiryTimeout=function(){if(this.expirationTime)return this.expiredRequestCount?1e3*(1<<Math.min(this.expiredRequestCount-1,31)):Math.min(this.expirationTime-(new Date).getTime(),Math.pow(2,31)-1)},ju.prototype.setFeatureState=function(t,e){if(this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData&&0!==Object.keys(t).length){var r=this.latestFeatureIndex.loadVTLayers();for(var n in this.buckets){var i=this.buckets[n],a=i.layers[0].sourceLayer||"_geojsonTileLayer",o=r[a],s=t[a];o&&s&&0!==Object.keys(s).length&&(i.update(s,o,this.imageAtlas&&this.imageAtlas.patternPositions||{}),e&&e.style&&(this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(n).queryRadius(i))));}}},ju.prototype.holdingForFade=function(){return void 0!==this.symbolFadeHoldUntil},ju.prototype.symbolFadeFinished=function(){return !this.symbolFadeHoldUntil||this.symbolFadeHoldUntil<V.now()},ju.prototype.clearFadeHold=function(){this.symbolFadeHoldUntil=void 0;},ju.prototype.setHoldDuration=function(t){this.symbolFadeHoldUntil=V.now()+t;};var qu={horizontal:1,vertical:2,horizontalOnly:3},Ru=function(){this.text="",this.sectionIndex=[],this.sections=[];};Ru.fromFeature=function(t,e){for(var r=new Ru,n=0;n<t.sections.length;n++){var i=t.sections[n];r.sections.push({scale:i.scale||1,fontStack:i.fontStack||e}),r.text+=i.text;for(var a=0;a<i.text.length;a++)r.sectionIndex.push(n);}return r},Ru.prototype.length=function(){return this.text.length},Ru.prototype.getSection=function(t){return this.sections[this.sectionIndex[t]]},Ru.prototype.getCharCode=function(t){return this.text.charCodeAt(t)},Ru.prototype.verticalizePunctuation=function(){this.text=function(t){for(var e="",r=0;r<t.length;r++){var n=t.charCodeAt(r+1)||null,i=t.charCodeAt(r-1)||null;n&&mn(n)&&!gs[t[r+1]]||i&&mn(i)&&!gs[t[r-1]]||!gs[t[r]]?e+=t[r]:e+=gs[t[r]];}return e}(this.text);},Ru.prototype.trim=function(){for(var t=0,e=0;e<this.text.length&&Nu[this.text.charCodeAt(e)];e++)t++;for(var r=this.text.length,n=this.text.length-1;n>=0&&n>=t&&Nu[this.text.charCodeAt(n)];n--)r--;this.text=this.text.substring(t,r),this.sectionIndex=this.sectionIndex.slice(t,r);},Ru.prototype.substring=function(t,e){var r=new Ru;return r.text=this.text.substring(t,e),r.sectionIndex=this.sectionIndex.slice(t,e),r.sections=this.sections,r},Ru.prototype.toString=function(){return this.text},Ru.prototype.getMaxScale=function(){var t=this;return this.sectionIndex.reduce(function(e,r){return Math.max(e,t.sections[r].scale)},0)};var Nu={9:!0,10:!0,11:!0,12:!0,13:!0,32:!0},Ku={};function Gu(t,e,r,n){var i=Math.pow(t-e,2);return n?t<e?i/2:2*i:i+Math.abs(r)*r}function Xu(t,e){var r=0;return 10===t&&(r-=1e4),40!==t&&65288!==t||(r+=50),41!==e&&65289!==e||(r+=50),r}function Zu(t,e,r,n,i,a){for(var o=null,s=Gu(e,r,i,a),u=0,l=n;u<l.length;u+=1){var p=l[u],c=Gu(e-p.x,r,i,a)+p.badness;c<=s&&(o=p,s=c);}return {index:t,x:e,priorBreak:o,badness:s}}function Hu(t,e,r,n){if(!r)return [];if(!t)return [];for(var i,a=[],o=function(t,e,r,n){for(var i=0,a=0;a<t.length();a++){var o=t.getSection(a),s=n[o.fontStack],u=s&&s[t.getCharCode(a)];u&&(i+=u.metrics.advance*o.scale+e);}return i/Math.max(1,Math.ceil(i/r))}(t,e,r,n),s=0,u=0;u<t.length();u++){var l=t.getSection(u),p=t.getCharCode(u),c=n[l.fontStack],h=c&&c[p];h&&!Nu[p]&&(s+=h.metrics.advance*l.scale+e),u<t.length()-1&&(Ku[p]||!((i=p)<11904)&&(hn["Bopomofo Extended"](i)||hn.Bopomofo(i)||hn["CJK Compatibility Forms"](i)||hn["CJK Compatibility Ideographs"](i)||hn["CJK Compatibility"](i)||hn["CJK Radicals Supplement"](i)||hn["CJK Strokes"](i)||hn["CJK Symbols and Punctuation"](i)||hn["CJK Unified Ideographs Extension A"](i)||hn["CJK Unified Ideographs"](i)||hn["Enclosed CJK Letters and Months"](i)||hn["Halfwidth and Fullwidth Forms"](i)||hn.Hiragana(i)||hn["Ideographic Description Characters"](i)||hn["Kangxi Radicals"](i)||hn["Katakana Phonetic Extensions"](i)||hn.Katakana(i)||hn["Vertical Forms"](i)||hn["Yi Radicals"](i)||hn["Yi Syllables"](i)))&&a.push(Zu(u+1,s,o,a,Xu(p,t.getCharCode(u+1)),!1));}return function t(e){return e?t(e.priorBreak).concat(e.index):[]}(Zu(t.length(),s,o,a,0,!0))}function Yu(t){var e=.5,r=.5;switch(t){case"right":case"top-right":case"bottom-right":e=1;break;case"left":case"top-left":case"bottom-left":e=0;}switch(t){case"bottom":case"bottom-right":case"bottom-left":r=1;break;case"top":case"top-right":case"top-left":r=0;}return {horizontalAlign:e,verticalAlign:r}}function Ju(t,e,r,n,i){if(i){var a=t[n],o=e[a.fontStack],s=o&&o[a.glyph];if(s)for(var u=s.metrics.advance*a.scale,l=(t[n].x+u)*i,p=r;p<=n;p++)t[p].x-=l;}}Ku[10]=!0,Ku[32]=!0,Ku[38]=!0,Ku[40]=!0,Ku[41]=!0,Ku[43]=!0,Ku[45]=!0,Ku[47]=!0,Ku[173]=!0,Ku[183]=!0,Ku[8203]=!0,Ku[8208]=!0,Ku[8211]=!0,Ku[8231]=!0,t.createCommonjsModule=e,t.window=self,t.Point=i,t.browser=V,t.getJSON=function(t,e){return at(c(t,{type:"json"}),e)},t.normalizeSpriteURL=function(t,e,r,n){var i=X(t);return U(t)?(i.path="/styles/v1"+i.path+"/sprite"+e+r,D(i,n)):(i.path+=""+e+r,Z(i))},t.ResourceType=et,t.getImage=pt,t.RGBAImage=qa,t.ImagePosition=Us,t.Texture=Xs,t.potpack=Ds,t.normalizeGlyphsURL=function(t,e){if(!U(t))return t;var r=X(t);return r.path="/fonts/v1"+r.path,D(r,e)},t.getArrayBuffer=ot,t.parseGlyphPBF=function(t){return new Ys(t).readFields(fu,[])},t.asyncAll=function(t,e,r){if(!t.length)return r(null,[]);var n=t.length,i=new Array(t.length),a=null;t.forEach(function(t,o){e(t,function(t,e){t&&(a=t),i[o]=e,0==--n&&r(a,i);});});},t.isChar=hn,t.AlphaImage=ja,t.Properties=Dn,t.DataConstantProperty=Mn,t.styleSpec=mt,t.validateLight=$r,t.endsWith=v,t.emitValidationErrors=tn,t.validateStyle=Jr,t.extend=c,t.Evented=dt,t.sphericalToCartesian=function(t){var e=t[0],r=t[1],n=t[2];return r+=90,r*=Math.PI/180,n*=Math.PI/180,{x:e*Math.cos(r)*Math.sin(n),y:e*Math.sin(r)*Math.sin(n),z:e*Math.cos(n)}},t.number=le,t.Transitionable=In,t.warnOnce=w,t.uniqueId=f,t.Actor=vu,t.normalizeSourceURL=function(t,e){if(!U(t))return t;var r=X(t);return r.path="/v4/"+r.authority+".json",r.params.push("secure"),D(r,e)},t.pick=function(t,e){for(var r={},n=0;n<e.length;n++){var i=e[n];i in t&&(r[i]=t[i]);}return r},t.canonicalizeTileset=function(t,e){if(!U(e))return t.tiles||[];for(var r=[],n=0,i=t.tiles;n<i.length;n+=1){var a=i[n],o=K(a);r.push(o);}return r},t.LngLatBounds=xu,t.mercatorXfromLng=wu,t.mercatorYfromLat=Au,t.Event=ft,t.ErrorEvent=yt,t.postTurnstileEvent=W,t.postMapLoadEvent=tt,t.normalizeTileURL=function(t,e,r){if(!e||!U(e))return t;var n=X(t),i=V.devicePixelRatio>=2||512===r?"@2x":"",a=M.supported?".webp":"$1";return n.path=n.path.replace(R,""+i+a),n.path="/v4"+n.path,D(n)},t.OverscaledTileID=Eu,t.EXTENT=Yi,t.MercatorCoordinate=zu,t.CanonicalTileID=Iu,t.StructArrayLayout4i8=Xn,t.rasterBoundsAttributes=Cu,t.SegmentVector=zi,t.getVideo=function(t,e){var r,n,i=self.document.createElement("video");i.muted=!0,i.onloadstart=function(){e(null,i);};for(var a=0;a<t.length;a++){var o=self.document.createElement("source");r=t[a],n=void 0,(n=self.document.createElement("a")).href=r,(n.protocol!==self.document.location.protocol||n.host!==self.document.location.host)&&(i.crossOrigin="Anonymous"),o.src=t[a],i.appendChild(o);}return {cancel:function(){}}},t.ValidationError=vt,t.bindAll=m,t.multiply=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],c=e[8],h=e[9],f=e[10],y=e[11],d=e[12],m=e[13],v=e[14],g=e[15],x=r[0],b=r[1],_=r[2],w=r[3];return t[0]=x*n+b*s+_*c+w*d,t[1]=x*i+b*u+_*h+w*m,t[2]=x*a+b*l+_*f+w*v,t[3]=x*o+b*p+_*y+w*g,x=r[4],b=r[5],_=r[6],w=r[7],t[4]=x*n+b*s+_*c+w*d,t[5]=x*i+b*u+_*h+w*m,t[6]=x*a+b*l+_*f+w*v,t[7]=x*o+b*p+_*y+w*g,x=r[8],b=r[9],_=r[10],w=r[11],t[8]=x*n+b*s+_*c+w*d,t[9]=x*i+b*u+_*h+w*m,t[10]=x*a+b*l+_*f+w*v,t[11]=x*o+b*p+_*y+w*g,x=r[12],b=r[13],_=r[14],w=r[15],t[12]=x*n+b*s+_*c+w*d,t[13]=x*i+b*u+_*h+w*m,t[14]=x*a+b*l+_*f+w*v,t[15]=x*o+b*p+_*y+w*g,t},t.identity=function(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t},t.translate=function(t,e,r){var n,i,a,o,s,u,l,p,c,h,f,y,d=r[0],m=r[1],v=r[2];return e===t?(t[12]=e[0]*d+e[4]*m+e[8]*v+e[12],t[13]=e[1]*d+e[5]*m+e[9]*v+e[13],t[14]=e[2]*d+e[6]*m+e[10]*v+e[14],t[15]=e[3]*d+e[7]*m+e[11]*v+e[15]):(n=e[0],i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],c=e[8],h=e[9],f=e[10],y=e[11],t[0]=n,t[1]=i,t[2]=a,t[3]=o,t[4]=s,t[5]=u,t[6]=l,t[7]=p,t[8]=c,t[9]=h,t[10]=f,t[11]=y,t[12]=n*d+s*m+c*v+e[12],t[13]=i*d+u*m+h*v+e[13],t[14]=a*d+l*m+f*v+e[14],t[15]=o*d+p*m+y*v+e[15]),t},t.scale=function(t,e,r){var n=r[0],i=r[1],a=r[2];return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t[3]=e[3]*n,t[4]=e[4]*i,t[5]=e[5]*i,t[6]=e[6]*i,t[7]=e[7]*i,t[8]=e[8]*a,t[9]=e[9]*a,t[10]=e[10]*a,t[11]=e[11]*a,t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],t},t.Color=Dt,t.isEqual=o,t.keysDifference=function(t,e){var r=[];for(var n in t)n in e||r.push(n);return r},t.Tile=ju,t.SourceFeatureState=Lu,t.refProperties=["type","source","source-layer","minzoom","maxzoom","filter","layout"],t.rotateZ=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[0],o=e[1],s=e[2],u=e[3],l=e[4],p=e[5],c=e[6],h=e[7];return e!==t&&(t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=a*i+l*n,t[1]=o*i+p*n,t[2]=s*i+c*n,t[3]=u*i+h*n,t[4]=l*i-a*n,t[5]=p*i-o*n,t[6]=c*i-s*n,t[7]=h*i-u*n,t},t.evaluateSizeForZoom=function(t,e,r){if("constant"===t.functionType)return {uSizeT:0,uSize:t.layoutSize};if("source"===t.functionType)return {uSizeT:0,uSize:0};if("camera"===t.functionType){var n=t.propertyValue,i=t.zoomRange,a=t.sizeRange,o=l(br(n,r.specification).interpolationFactor(e,i.min,i.max),0,1);return {uSizeT:0,uSize:a.min+o*(a.max-a.min)}}var s=t.propertyValue,u=t.zoomRange;return {uSizeT:l(br(s,r.specification).interpolationFactor(e,u.min,u.max),0,1),uSize:0}},t.WritingMode=qu,t.transformMat4=Sa,t.evaluateSizeForFeature=function(t,e,r){var n=e;return "source"===t.functionType?r.lowerSize/bs:"composite"===t.functionType?le(r.lowerSize/bs,r.upperSize/bs,n.uSizeT):n.uSize},t.addDynamicAttributes=ks,t.properties=Ps,t.polygonIntersectsPolygon=ea,t.isMapboxURL=U,t.normalizeStyleURL=function(t,e){if(!U(t))return t;var r=X(t);return r.path="/styles/v1"+r.path,D(r,e)},t.createStyleLayer=function(t){return "custom"===t.type?new Ls(t):new Os[t.type](t)},t.clone=b,t.validateCustomStyleLayer=function(t){var e=[],r=t.id;return void 0===r&&e.push({message:"layers."+r+': missing required property "id"'}),void 0===t.render&&e.push({message:"layers."+r+': missing required method "render"'}),t.renderingMode&&"2d"!==t.renderingMode&&"3d"!==t.renderingMode&&e.push({message:"layers."+r+': property "renderingMode" must be either "2d" or "3d"'}),e},t.filterObject=x,t.mapObject=g,t.evented=wn,t.makeRequest=at,t.registerForPluginAvailability=function(t){return bn?t({pluginURL:bn,completionCallback:gn}):wn.once("pluginAvailable",t),t},t.ZoomHistory=cn,t.getReferrer=it,t.createLayout=Nn,t.UniformMatrix4f=Di,t.Uniform3f=Ti,t.Uniform1f=Ci,t.Uniform1i=Vi,t.Uniform2f=Mi,t.Uniform4f=Fi,t.create=ga,t.fromRotation=function(t,e){var r=Math.sin(e),n=Math.cos(e);return t[0]=n,t[1]=r,t[2]=0,t[3]=-r,t[4]=n,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t},t.transformMat3=function(t,e,r){var n=e[0],i=e[1],a=e[2];return t[0]=n*r[0]+i*r[3]+a*r[6],t[1]=n*r[1]+i*r[4]+a*r[7],t[2]=n*r[2]+i*r[5]+a*r[8],t},t.create$1=function(){var t=new va(16);return va!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0),t[0]=1,t[5]=1,t[10]=1,t[15]=1,t},t.ortho=function(t,e,r,n,i,a,o){var s=1/(e-r),u=1/(n-i),l=1/(a-o);return t[0]=-2*s,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*u,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*l,t[11]=0,t[12]=(e+r)*s,t[13]=(i+n)*u,t[14]=(o+a)*l,t[15]=1,t},t.UniformColor=Li,t.clamp=l,t.StructArrayLayout2i4=Gn,t.StructArrayLayout2ui4=ui,t.ProgramConfiguration=Gi,t.StructArrayLayout1ui2=li,t.StructArrayLayout3ui6=si,t.wrap=p,t.create$2=function(){var t=new va(4);return va!=Float32Array&&(t[1]=0,t[2]=0),t[0]=1,t[3]=1,t},t.rotate=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=Math.sin(r),u=Math.cos(r);return t[0]=n*u+a*s,t[1]=i*u+o*s,t[2]=n*-s+a*u,t[3]=i*-s+o*u,t},t.LngLat=bu,t.UnwrappedTileID=Bu,t.perspective=function(t,e,r,n,i){var a,o=1/Math.tan(e/2);return t[0]=o/r,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=o,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=-1,t[12]=0,t[13]=0,t[15]=0,null!=i&&i!==1/0?(a=1/(n-i),t[10]=(i+n)*a,t[14]=2*i*n*a):(t[10]=-1,t[14]=-2*n),t},t.rotateX=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[4],o=e[5],s=e[6],u=e[7],l=e[8],p=e[9],c=e[10],h=e[11];return e!==t&&(t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[4]=a*i+l*n,t[5]=o*i+p*n,t[6]=s*i+c*n,t[7]=u*i+h*n,t[8]=l*i-a*n,t[9]=p*i-o*n,t[10]=c*i-s*n,t[11]=h*i-u*n,t},t.mercatorZfromAltitude=Su,t.invert=function(t,e){var r=e[0],n=e[1],i=e[2],a=e[3],o=e[4],s=e[5],u=e[6],l=e[7],p=e[8],c=e[9],h=e[10],f=e[11],y=e[12],d=e[13],m=e[14],v=e[15],g=r*s-n*o,x=r*u-i*o,b=r*l-a*o,_=n*u-i*s,w=n*l-a*s,A=i*l-a*u,S=p*d-c*y,k=p*m-h*y,z=p*v-f*y,I=c*m-h*d,B=c*v-f*d,E=h*v-f*m,P=g*E-x*B+b*I+_*z-w*k+A*S;return P?(P=1/P,t[0]=(s*E-u*B+l*I)*P,t[1]=(i*B-n*E-a*I)*P,t[2]=(d*A-m*w+v*_)*P,t[3]=(h*w-c*A-f*_)*P,t[4]=(u*z-o*E-l*k)*P,t[5]=(r*E-i*z+a*k)*P,t[6]=(m*b-y*A-v*x)*P,t[7]=(p*A-h*b+f*x)*P,t[8]=(o*B-s*z+l*S)*P,t[9]=(n*z-r*B-a*S)*P,t[10]=(y*w-d*b+v*g)*P,t[11]=(c*b-p*w-f*g)*P,t[12]=(s*k-o*I-u*S)*P,t[13]=(r*I-n*k+i*S)*P,t[14]=(d*x-y*_-m*g)*P,t[15]=(p*_-c*x+h*g)*P,t):null},t.ease=u,t.bezier=s,t.config=C,t.webpSupported=M,t.EvaluationParameters=Sn,t.version="0.53.0",t.setRTLTextPlugin=function(t,e){if(xn)throw new Error("setRTLTextPlugin cannot be called multiple times.");xn=!0,bn=V.resolveURL(t),gn=function(t){t?(xn=!1,bn=null,e&&e(t)):_n=!0;},wn.fire(new ft("pluginAvailable",{pluginURL:bn,completionCallback:gn}));},t.featureFilter=Er,t.values=function(t){var e=[];for(var r in t)e.push(t[r]);return e},t.Anchor=xs,t.GLYPH_PBF_BORDER=mu,t.distToSegmentSquared=ua,t.allowsLetterSpacing=function(t){for(var e=0,r=t;e<r.length;e+=1)if(!yn(r[e].charCodeAt(0)))return !1;return !0},t.shapeText=function(t,e,r,n,i,a,o,s,u,l,p){var c=Ru.fromFeature(t,r);p===qu.vertical&&c.verticalizePunctuation();var h,f=[],y={positionedGlyphs:f,text:c,top:u[1],bottom:u[1],left:u[0],right:u[0],writingMode:p},d=An.processBidirectionalText,m=An.processStyledBidirectionalText;if(d&&1===c.sections.length){h=[];for(var v=0,g=d(c.toString(),Hu(c,s,n,e));v<g.length;v+=1){var x=g[v],b=new Ru;b.text=x,b.sections=c.sections;for(var _=0;_<x.length;_++)b.sectionIndex.push(0);h.push(b);}}else if(m){h=[];for(var w=0,A=m(c.text,c.sectionIndex,Hu(c,s,n,e));w<A.length;w+=1){var S=A[w],k=new Ru;k.text=S[0],k.sectionIndex=S[1],k.sections=c.sections,h.push(k);}}else h=function(t,e){for(var r=[],n=t.text,i=0,a=0,o=e;a<o.length;a+=1){var s=o[a];r.push(t.substring(i,s)),i=s;}return i<n.length&&r.push(t.substring(i,n.length)),r}(c,Hu(c,s,n,e));return function(t,e,r,n,i,a,o,s,u){for(var l=0,p=-17,c=0,h=t.positionedGlyphs,f="right"===a?1:"left"===a?0:.5,y=0,d=r;y<d.length;y+=1){var m=d[y];m.trim();var v=m.getMaxScale();if(m.length()){for(var g=h.length,x=0;x<m.length();x++){var b=m.getSection(x),_=m.getCharCode(x),w=24*(v-b.scale),A=e[b.fontStack],S=A&&A[_];S&&(dn(_)&&o!==qu.horizontal?(h.push({glyph:_,x:l,y:w,vertical:!0,scale:b.scale,fontStack:b.fontStack}),l+=u*b.scale+s):(h.push({glyph:_,x:l,y:p+w,vertical:!1,scale:b.scale,fontStack:b.fontStack}),l+=S.metrics.advance*b.scale+s));}if(h.length!==g){var k=l-s;c=Math.max(k,c),Ju(h,e,g,h.length-1,f);}l=0,p+=n*v;}else p+=n;}var z=Yu(i),I=z.horizontalAlign,B=z.verticalAlign;!function(t,e,r,n,i,a,o){for(var s=(e-r)*i,u=(-n*o+.5)*a,l=0;l<t.length;l++)t[l].x+=s,t[l].y+=u;}(h,f,I,B,c,n,r.length);var E=p- -17;t.top+=-B*E,t.bottom=t.top+E,t.left+=-I*c,t.right=t.left+c;}(y,e,h,i,a,o,p,s,l),!!f.length&&(y.text=y.text.toString(),y)},t.allowsVerticalWritingMode=fn,t.shapeIcon=function(t,e,r){var n=Yu(r),i=n.horizontalAlign,a=n.verticalAlign,o=e[0],s=e[1],u=o-t.displaySize[0]*i,l=u+t.displaySize[0],p=s-t.displaySize[1]*a;return {image:t,top:p,bottom:p+t.displaySize[1],left:u,right:l}},t.classifyRings=So,t.SIZE_PACK_FACTOR=bs,t.SymbolBucket=Bs,t.register=sn,t.CollisionBoxArray=fi,t.DictionaryCoder=Mu,t.FeatureIndex=Ou,t.ImageAtlas=qs,t.LineBucket=as,t.FillBucket=Bo,t.FillExtrusionBucket=Fo,t.mvt=Wo,t.Protobuf=Ys,t.DEMData=Vu,t.vectorTile=Wo,t.Point$1=i,t.pbf=Ys,t.createExpression=dr,t.plugin=An;});

define(["./shared.js"],function(e){"use strict";function t(e){var r=typeof e;if("number"===r||"boolean"===r||"string"===r||null==e)return JSON.stringify(e);if(Array.isArray(e)){for(var n="[",o=0,i=e;o<i.length;o+=1){n+=t(i[o])+",";}return n+"]"}for(var a=Object.keys(e).sort(),s="{",l=0;l<a.length;l++)s+=JSON.stringify(a[l])+":"+t(e[a[l]])+",";return s+"}"}function r(r){for(var n="",o=0,i=e.refProperties;o<i.length;o+=1){n+="/"+t(r[i[o]]);}return n}var n=function(e){e&&this.replace(e);};function o(e,t,r,n,o){if(void 0===t.segment)return !0;for(var i=t,a=t.segment+1,s=0;s>-r/2;){if(--a<0)return !1;s-=e[a].dist(i),i=e[a];}s+=e[a].dist(e[a+1]),a++;for(var l=[],u=0;s<r/2;){var h=e[a-1],c=e[a],p=e[a+1];if(!p)return !1;var f=h.angleTo(c)-c.angleTo(p);for(f=Math.abs((f+3*Math.PI)%(2*Math.PI)-Math.PI),l.push({distance:s,angleDelta:f}),u+=f;s-l[0].distance>n;)u-=l.shift().angleDelta;if(u>o)return !1;a++,s+=c.dist(p);}return !0}function i(e){for(var t=0,r=0;r<e.length-1;r++)t+=e[r].dist(e[r+1]);return t}function a(e,t,r){return e?.6*t*r:0}function s(e,t){return Math.max(e?e.right-e.left:0,t?t.right-t.left:0)}function l(t,r,n,l,u,h){for(var c=a(n,u,h),p=s(n,l)*h,f=0,d=i(t)/2,g=0;g<t.length-1;g++){var m=t[g],v=t[g+1],y=m.dist(v);if(f+y>d){var x=(d-f)/y,w=e.number(m.x,v.x,x),M=e.number(m.y,v.y,x),S=new e.Anchor(w,M,v.angleTo(m),g);return S._round(),!c||o(t,S,p,c,r)?S:void 0}f+=y;}}function u(t,r,n,l,u,h,c,p,f){var d=a(l,h,c),g=s(l,u),m=g*c,v=0===t[0].x||t[0].x===f||0===t[0].y||t[0].y===f;return r-m<r/4&&(r=m+r/4),function t(r,n,a,s,l,u,h,c,p){var f=u/2;var d=i(r);var g=0,m=n-a;var v=[];for(var y=0;y<r.length-1;y++){for(var x=r[y],w=r[y+1],M=x.dist(w),S=w.angleTo(x);m+a<g+M;){var _=((m+=a)-g)/M,P=e.number(x.x,w.x,_),b=e.number(x.y,w.y,_);if(P>=0&&P<p&&b>=0&&b<p&&m-f>=0&&m+f<=d){var T=new e.Anchor(P,b,S,y);T._round(),s&&!o(r,T,u,s,l)||v.push(T);}}g+=M;}c||v.length||h||(v=t(r,g/2,a,s,l,u,h,!0,p));return v}(t,v?r/2*p%r:(g/2+2*h)*c*p%r,r,d,n,m,v,!1,f)}n.prototype.replace=function(e){this._layerConfigs={},this._layers={},this.update(e,[]);},n.prototype.update=function(t,n){for(var o=this,i=0,a=t;i<a.length;i+=1){var s=a[i];this._layerConfigs[s.id]=s;var l=this._layers[s.id]=e.createStyleLayer(s);l._featureFilter=e.featureFilter(l.filter);}for(var u=0,h=n;u<h.length;u+=1){var c=h[u];delete this._layerConfigs[c],delete this._layers[c];}this.familiesBySource={};for(var p=0,f=function(e){for(var t={},n=0;n<e.length;n++){var o=r(e[n]),i=t[o];i||(i=t[o]=[]),i.push(e[n]);}var a=[];for(var s in t)a.push(t[s]);return a}(e.values(this._layerConfigs));p<f.length;p+=1){var d=f[p].map(function(e){return o._layers[e.id]}),g=d[0];if("none"!==g.visibility){var m=g.source||"",v=this.familiesBySource[m];v||(v=this.familiesBySource[m]={});var y=g.sourceLayer||"_geojsonTileLayer",x=v[y];x||(x=v[y]=[]),x.push(d);}}};var h=function(t,r,n,o,i,a,s,l,u,h,c,p){var f=s.top*l-u,d=s.bottom*l+u,g=s.left*l-u,m=s.right*l+u;if(this.boxStartIndex=t.length,h){var v=d-f,y=m-g;v>0&&(v=Math.max(10*l,v),this._addLineCollisionCircles(t,r,n,n.segment,y,v,o,i,a,c));}else{if(p){var x=new e.Point(g,f),w=new e.Point(m,f),M=new e.Point(g,d),S=new e.Point(m,d),_=p*Math.PI/180;x._rotate(_),w._rotate(_),M._rotate(_),S._rotate(_),g=Math.min(x.x,w.x,M.x,S.x),m=Math.max(x.x,w.x,M.x,S.x),f=Math.min(x.y,w.y,M.y,S.y),d=Math.max(x.y,w.y,M.y,S.y);}t.emplaceBack(n.x,n.y,g,f,m,d,o,i,a,0,0);}this.boxEndIndex=t.length;};h.prototype._addLineCollisionCircles=function(e,t,r,n,o,i,a,s,l,u){var h=i/2,c=Math.floor(o/h)||1,p=1+.4*Math.log(u)/Math.LN2,f=Math.floor(c*p/2),d=-i/2,g=r,m=n+1,v=d,y=-o/2,x=y-o/4;do{if(--m<0){if(v>y)return;m=0;break}v-=t[m].dist(g),g=t[m];}while(v>x);for(var w=t[m].dist(t[m+1]),M=-f;M<c+f;M++){var S=M*h,_=y+S;if(S<0&&(_+=S),S>o&&(_+=S-o),!(_<v)){for(;v+w<_;){if(v+=w,++m+1>=t.length)return;w=t[m].dist(t[m+1]);}var P=_-v,b=t[m],T=t[m+1].sub(b)._unit()._mult(P)._add(b)._round(),I=Math.abs(_-d)<h?0:.8*(_-d);e.emplaceBack(T.x,T.y,-i/2,-i/2,i/2,i/2,a,s,l,i/2,I);}}};var c=function(e,t){if(void 0===e&&(e=[]),void 0===t&&(t=p),this.data=e,this.length=this.data.length,this.compare=t,this.length>0)for(var r=(this.length>>1)-1;r>=0;r--)this._down(r);};function p(e,t){return e<t?-1:e>t?1:0}function f(t,r,n){void 0===r&&(r=1),void 0===n&&(n=!1);for(var o=1/0,i=1/0,a=-1/0,s=-1/0,l=t[0],u=0;u<l.length;u++){var h=l[u];(!u||h.x<o)&&(o=h.x),(!u||h.y<i)&&(i=h.y),(!u||h.x>a)&&(a=h.x),(!u||h.y>s)&&(s=h.y);}var p=a-o,f=s-i,m=Math.min(p,f),v=m/2,y=new c([],d);if(0===m)return new e.Point(o,i);for(var x=o;x<a;x+=m)for(var w=i;w<s;w+=m)y.push(new g(x+v,w+v,v,t));for(var M=function(e){for(var t=0,r=0,n=0,o=e[0],i=0,a=o.length,s=a-1;i<a;s=i++){var l=o[i],u=o[s],h=l.x*u.y-u.x*l.y;r+=(l.x+u.x)*h,n+=(l.y+u.y)*h,t+=3*h;}return new g(r/t,n/t,0,e)}(t),S=y.length;y.length;){var _=y.pop();(_.d>M.d||!M.d)&&(M=_,n&&console.log("found best %d after %d probes",Math.round(1e4*_.d)/1e4,S)),_.max-M.d<=r||(v=_.h/2,y.push(new g(_.p.x-v,_.p.y-v,v,t)),y.push(new g(_.p.x+v,_.p.y-v,v,t)),y.push(new g(_.p.x-v,_.p.y+v,v,t)),y.push(new g(_.p.x+v,_.p.y+v,v,t)),S+=4);}return n&&(console.log("num probes: "+S),console.log("best distance: "+M.d)),M.p}function d(e,t){return t.max-e.max}function g(t,r,n,o){this.p=new e.Point(t,r),this.h=n,this.d=function(t,r){for(var n=!1,o=1/0,i=0;i<r.length;i++)for(var a=r[i],s=0,l=a.length,u=l-1;s<l;u=s++){var h=a[s],c=a[u];h.y>t.y!=c.y>t.y&&t.x<(c.x-h.x)*(t.y-h.y)/(c.y-h.y)+h.x&&(n=!n),o=Math.min(o,e.distToSegmentSquared(t,h,c));}return (n?1:-1)*Math.sqrt(o)}(this.p,o),this.max=this.d+this.h*Math.SQRT2;}c.prototype.push=function(e){this.data.push(e),this.length++,this._up(this.length-1);},c.prototype.pop=function(){if(0!==this.length){var e=this.data[0];return this.length--,this.length>0&&(this.data[0]=this.data[this.length],this._down(0)),this.data.pop(),e}},c.prototype.peek=function(){return this.data[0]},c.prototype._up=function(e){for(var t=this.data,r=this.compare,n=t[e];e>0;){var o=e-1>>1,i=t[o];if(r(n,i)>=0)break;t[e]=i,e=o;}t[e]=n;},c.prototype._down=function(e){for(var t=this.data,r=this.compare,n=this.length>>1,o=t[e];e<n;){var i=1+(e<<1),a=t[i],s=i+1;if(s<this.length&&r(t[s],a)<0&&(i=s,a=t[s]),r(a,o)>=0)break;t[e]=a,e=i;}t[e]=o;};var m=e.createCommonjsModule(function(e){e.exports=function(e,t){var r,n,o,i,a,s,l,u;for(r=3&e.length,n=e.length-r,o=t,a=3432918353,s=461845907,u=0;u<n;)l=255&e.charCodeAt(u)|(255&e.charCodeAt(++u))<<8|(255&e.charCodeAt(++u))<<16|(255&e.charCodeAt(++u))<<24,++u,o=27492+(65535&(i=5*(65535&(o=(o^=l=(65535&(l=(l=(65535&l)*a+(((l>>>16)*a&65535)<<16)&4294967295)<<15|l>>>17))*s+(((l>>>16)*s&65535)<<16)&4294967295)<<13|o>>>19))+((5*(o>>>16)&65535)<<16)&4294967295))+((58964+(i>>>16)&65535)<<16);switch(l=0,r){case 3:l^=(255&e.charCodeAt(u+2))<<16;case 2:l^=(255&e.charCodeAt(u+1))<<8;case 1:o^=l=(65535&(l=(l=(65535&(l^=255&e.charCodeAt(u)))*a+(((l>>>16)*a&65535)<<16)&4294967295)<<15|l>>>17))*s+(((l>>>16)*s&65535)<<16)&4294967295;}return o^=e.length,o=2246822507*(65535&(o^=o>>>16))+((2246822507*(o>>>16)&65535)<<16)&4294967295,o=3266489909*(65535&(o^=o>>>13))+((3266489909*(o>>>16)&65535)<<16)&4294967295,(o^=o>>>16)>>>0};}),v=e.createCommonjsModule(function(e){e.exports=function(e,t){for(var r,n=e.length,o=t^n,i=0;n>=4;)r=1540483477*(65535&(r=255&e.charCodeAt(i)|(255&e.charCodeAt(++i))<<8|(255&e.charCodeAt(++i))<<16|(255&e.charCodeAt(++i))<<24))+((1540483477*(r>>>16)&65535)<<16),o=1540483477*(65535&o)+((1540483477*(o>>>16)&65535)<<16)^(r=1540483477*(65535&(r^=r>>>24))+((1540483477*(r>>>16)&65535)<<16)),n-=4,++i;switch(n){case 3:o^=(255&e.charCodeAt(i+2))<<16;case 2:o^=(255&e.charCodeAt(i+1))<<8;case 1:o=1540483477*(65535&(o^=255&e.charCodeAt(i)))+((1540483477*(o>>>16)&65535)<<16);}return o=1540483477*(65535&(o^=o>>>13))+((1540483477*(o>>>16)&65535)<<16),(o^=o>>>15)>>>0};}),y=m,x=m,w=v;function M(t,r,n,o,i,a){t.createArrays();var s=512*t.overscaling;t.tilePixelRatio=e.EXTENT/s,t.compareText={},t.iconsNeedLinear=!1;var l=t.layers[0].layout,u=t.layers[0]._unevaluatedLayout._values,h={};if("composite"===t.textSizeData.functionType){var c=t.textSizeData.zoomRange,p=c.min,f=c.max;h.compositeTextSizes=[u["text-size"].possiblyEvaluate(new e.EvaluationParameters(p)),u["text-size"].possiblyEvaluate(new e.EvaluationParameters(f))];}if("composite"===t.iconSizeData.functionType){var d=t.iconSizeData.zoomRange,g=d.min,m=d.max;h.compositeIconSizes=[u["icon-size"].possiblyEvaluate(new e.EvaluationParameters(g)),u["icon-size"].possiblyEvaluate(new e.EvaluationParameters(m))];}h.layoutTextSize=u["text-size"].possiblyEvaluate(new e.EvaluationParameters(t.zoom+1)),h.layoutIconSize=u["icon-size"].possiblyEvaluate(new e.EvaluationParameters(t.zoom+1)),h.textMaxSize=u["text-size"].possiblyEvaluate(new e.EvaluationParameters(18));for(var v=24*l.get("text-line-height"),y="map"===l.get("text-rotation-alignment")&&"point"!==l.get("symbol-placement"),x=l.get("text-keep-upright"),w=0,M=t.features;w<M.length;w+=1){var _=M[w],P=l.get("text-font").evaluate(_,{}).join(","),b=n,T={},I=_.text;if(I){var k=I.toString(),z=l.get("text-offset").evaluate(_,{}).map(function(e){return 24*e}),C=24*l.get("text-letter-spacing").evaluate(_,{}),E=e.allowsLetterSpacing(k)?C:0,A=l.get("text-anchor").evaluate(_,{}),L=l.get("text-justify").evaluate(_,{}),D="point"===l.get("symbol-placement")?24*l.get("text-max-width").evaluate(_,{}):0;T.horizontal=e.shapeText(I,r,P,D,v,A,L,E,z,24,e.WritingMode.horizontal),e.allowsVerticalWritingMode(k)&&y&&x&&(T.vertical=e.shapeText(I,r,P,D,v,A,L,E,z,24,e.WritingMode.vertical));}var O=void 0;if(_.icon){var N=o[_.icon];N&&(O=e.shapeIcon(i[_.icon],l.get("icon-offset").evaluate(_,{}),l.get("icon-anchor").evaluate(_,{})),void 0===t.sdfIcons?t.sdfIcons=N.sdf:t.sdfIcons!==N.sdf&&e.warnOnce("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),N.pixelRatio!==t.pixelRatio?t.iconsNeedLinear=!0:0!==l.get("icon-rotate").constantOr(1)&&(t.iconsNeedLinear=!0));}(T.horizontal||O)&&S(t,_,T,O,b,h);}a&&t.generateCollisionDebugBuffers();}function S(t,r,n,o,i,a){var s=a.layoutTextSize.evaluate(r,{}),c=a.layoutIconSize.evaluate(r,{}),p=a.textMaxSize.evaluate(r,{});void 0===p&&(p=s);var d=t.layers[0].layout,g=d.get("text-offset").evaluate(r,{}),m=d.get("icon-offset").evaluate(r,{}),v=s/24,x=t.tilePixelRatio*v,w=t.tilePixelRatio*p/24,M=t.tilePixelRatio*c,S=t.tilePixelRatio*d.get("symbol-spacing"),T=d.get("text-padding")*t.tilePixelRatio,I=d.get("icon-padding")*t.tilePixelRatio,k=d.get("text-max-angle")/180*Math.PI,z="map"===d.get("text-rotation-alignment")&&"point"!==d.get("symbol-placement"),C="map"===d.get("icon-rotation-alignment")&&"point"!==d.get("symbol-placement"),E=d.get("symbol-placement"),A=S/2,L=function(s,l){l.x<0||l.x>=e.EXTENT||l.y<0||l.y>=e.EXTENT||function(t,r,n,o,i,a,s,l,u,c,p,f,d,g,m,v,x,w,M,S,b){var T,I,k=t.addToLineVertexArray(r,n),z=0,C=0,E=0,A=y(o.horizontal?o.horizontal.text:""),L=[];if(o.horizontal){var D=a.layout.get("text-rotate").evaluate(M,{});T=new h(s,n,r,l,u,c,o.horizontal,p,f,d,t.overscaling,D),C+=P(t,r,o.horizontal,a,d,M,g,k,o.vertical?e.WritingMode.horizontal:e.WritingMode.horizontalOnly,L,S,b),o.vertical&&(E+=P(t,r,o.vertical,a,d,M,g,k,e.WritingMode.vertical,L,S,b));}var O=T?T.boxStartIndex:t.collisionBoxArray.length,N=T?T.boxEndIndex:t.collisionBoxArray.length;if(i){var R=function(t,r,n,o,i,a){var s,l,u,h,c=r.image,p=n.layout,f=r.top-1/c.pixelRatio,d=r.left-1/c.pixelRatio,g=r.bottom+1/c.pixelRatio,m=r.right+1/c.pixelRatio;if("none"!==p.get("icon-text-fit")&&i){var v=m-d,y=g-f,x=p.get("text-size").evaluate(a,{})/24,w=i.left*x,M=i.right*x,S=i.top*x,_=M-w,P=i.bottom*x-S,b=p.get("icon-text-fit-padding")[0],T=p.get("icon-text-fit-padding")[1],I=p.get("icon-text-fit-padding")[2],k=p.get("icon-text-fit-padding")[3],z="width"===p.get("icon-text-fit")?.5*(P-y):0,C="height"===p.get("icon-text-fit")?.5*(_-v):0,E="width"===p.get("icon-text-fit")||"both"===p.get("icon-text-fit")?_:v,A="height"===p.get("icon-text-fit")||"both"===p.get("icon-text-fit")?P:y;s=new e.Point(w+C-k,S+z-b),l=new e.Point(w+C+T+E,S+z-b),u=new e.Point(w+C+T+E,S+z+I+A),h=new e.Point(w+C-k,S+z+I+A);}else s=new e.Point(d,f),l=new e.Point(m,f),u=new e.Point(m,g),h=new e.Point(d,g);var L=n.layout.get("icon-rotate").evaluate(a,{})*Math.PI/180;if(L){var D=Math.sin(L),O=Math.cos(L),N=[O,-D,D,O];s._matMult(N),l._matMult(N),h._matMult(N),u._matMult(N);}return [{tl:s,tr:l,bl:h,br:u,tex:c.paddedRect,writingMode:void 0,glyphOffset:[0,0]}]}(0,i,a,0,o.horizontal,M),F=a.layout.get("icon-rotate").evaluate(M,{});I=new h(s,n,r,l,u,c,i,m,v,!1,t.overscaling,F),z=4*R.length;var B=t.iconSizeData,Z=null;"source"===B.functionType?(Z=[e.SIZE_PACK_FACTOR*a.layout.get("icon-size").evaluate(M,{})])[0]>_&&e.warnOnce(t.layerIds[0]+': Value for "icon-size" is >= 256. Reduce your "icon-size".'):"composite"===B.functionType&&((Z=[e.SIZE_PACK_FACTOR*b.compositeIconSizes[0].evaluate(M,{}),e.SIZE_PACK_FACTOR*b.compositeIconSizes[1].evaluate(M,{})])[0]>_||Z[1]>_)&&e.warnOnce(t.layerIds[0]+': Value for "icon-size" is >= 256. Reduce your "icon-size".'),t.addSymbols(t.icon,R,Z,w,x,M,!1,r,k.lineStartIndex,k.lineLength);}var j=I?I.boxStartIndex:t.collisionBoxArray.length,G=I?I.boxEndIndex:t.collisionBoxArray.length;t.glyphOffsetArray.length>=e.SymbolBucket.MAX_GLYPHS&&e.warnOnce("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907");t.symbolInstances.emplaceBack(r.x,r.y,L.length>0?L[0]:-1,L.length>1?L[1]:-1,A,O,N,j,G,l,C,E,z,0);}(t,l,s,n,o,t.layers[0],t.collisionBoxArray,r.index,r.sourceLayerIndex,t.index,x,T,z,g,M,I,C,m,r,i,a);};if("line"===E)for(var D=0,O=function(t,r,n,o,i){for(var a=[],s=0;s<t.length;s++)for(var l=t[s],u=void 0,h=0;h<l.length-1;h++){var c=l[h],p=l[h+1];c.x<r&&p.x<r||(c.x<r?c=new e.Point(r,c.y+(p.y-c.y)*((r-c.x)/(p.x-c.x)))._round():p.x<r&&(p=new e.Point(r,c.y+(p.y-c.y)*((r-c.x)/(p.x-c.x)))._round()),c.y<n&&p.y<n||(c.y<n?c=new e.Point(c.x+(p.x-c.x)*((n-c.y)/(p.y-c.y)),n)._round():p.y<n&&(p=new e.Point(c.x+(p.x-c.x)*((n-c.y)/(p.y-c.y)),n)._round()),c.x>=o&&p.x>=o||(c.x>=o?c=new e.Point(o,c.y+(p.y-c.y)*((o-c.x)/(p.x-c.x)))._round():p.x>=o&&(p=new e.Point(o,c.y+(p.y-c.y)*((o-c.x)/(p.x-c.x)))._round()),c.y>=i&&p.y>=i||(c.y>=i?c=new e.Point(c.x+(p.x-c.x)*((i-c.y)/(p.y-c.y)),i)._round():p.y>=i&&(p=new e.Point(c.x+(p.x-c.x)*((i-c.y)/(p.y-c.y)),i)._round()),u&&c.equals(u[u.length-1])||(u=[c],a.push(u)),u.push(p)))));}return a}(r.geometry,0,0,e.EXTENT,e.EXTENT);D<O.length;D+=1)for(var N=O[D],R=0,F=u(N,S,k,n.vertical||n.horizontal,o,24,w,t.overscaling,e.EXTENT);R<F.length;R+=1){var B=F[R],Z=n.horizontal;Z&&b(t,Z.text,A,B)||L(N,B);}else if("line-center"===E)for(var j=0,G=r.geometry;j<G.length;j+=1){var J=G[j];if(J.length>1){var X=l(J,k,n.vertical||n.horizontal,o,24,w);X&&L(J,X);}}else if("Polygon"===r.type)for(var V=0,W=e.classifyRings(r.geometry,0);V<W.length;V+=1){var Y=W[V],q=f(Y,16);L(Y[0],new e.Anchor(q.x,q.y,0));}else if("LineString"===r.type)for(var U=0,K=r.geometry;U<K.length;U+=1){var H=K[U];L(H,new e.Anchor(H[0].x,H[0].y,0));}else if("Point"===r.type)for(var Q=0,$=r.geometry;Q<$.length;Q+=1)for(var ee=0,te=$[Q];ee<te.length;ee+=1){var re=te[ee];L([re],new e.Anchor(re.x,re.y,0));}}y.murmur3=x,y.murmur2=w;var _=65535;function P(t,r,n,o,i,a,s,l,u,h,c,p){var f=function(t,r,n,o,i,a){for(var s=n.layout.get("text-rotate").evaluate(i,{})*Math.PI/180,l=n.layout.get("text-offset").evaluate(i,{}).map(function(e){return 24*e}),u=r.positionedGlyphs,h=[],c=0;c<u.length;c++){var p=u[c],f=a[p.fontStack],d=f&&f[p.glyph];if(d){var g=d.rect;if(g){var m=e.GLYPH_PBF_BORDER+1,v=d.metrics.advance*p.scale/2,y=o?[p.x+v,p.y]:[0,0],x=o?[0,0]:[p.x+v+l[0],p.y+l[1]],w=(d.metrics.left-m)*p.scale-v+x[0],M=(-d.metrics.top-m)*p.scale+x[1],S=w+g.w*p.scale,_=M+g.h*p.scale,P=new e.Point(w,M),b=new e.Point(S,M),T=new e.Point(w,_),I=new e.Point(S,_);if(o&&p.vertical){var k=new e.Point(-v,v),z=-Math.PI/2,C=new e.Point(5,0);P._rotateAround(z,k)._add(C),b._rotateAround(z,k)._add(C),T._rotateAround(z,k)._add(C),I._rotateAround(z,k)._add(C);}if(s){var E=Math.sin(s),A=Math.cos(s),L=[A,-E,E,A];P._matMult(L),b._matMult(L),T._matMult(L),I._matMult(L);}h.push({tl:P,tr:b,bl:T,br:I,tex:g,writingMode:r.writingMode,glyphOffset:y});}}}return h}(0,n,o,i,a,c),d=t.textSizeData,g=null;return "source"===d.functionType?(g=[e.SIZE_PACK_FACTOR*o.layout.get("text-size").evaluate(a,{})])[0]>_&&e.warnOnce(t.layerIds[0]+': Value for "text-size" is >= 256. Reduce your "text-size".'):"composite"===d.functionType&&((g=[e.SIZE_PACK_FACTOR*p.compositeTextSizes[0].evaluate(a,{}),e.SIZE_PACK_FACTOR*p.compositeTextSizes[1].evaluate(a,{})])[0]>_||g[1]>_)&&e.warnOnce(t.layerIds[0]+': Value for "text-size" is >= 256. Reduce your "text-size".'),t.addSymbols(t.text,f,g,s,i,a,u,r,l.lineStartIndex,l.lineLength),h.push(t.text.placedSymbolArray.length-1),4*f.length}function b(e,t,r,n){var o=e.compareText;if(t in o){for(var i=o[t],a=i.length-1;a>=0;a--)if(n.dist(i[a])<r)return !0}else o[t]=[];return o[t].push(n),!1}var T=function(t){var r={},n=[];for(var o in t){var i=t[o],a=r[o]={};for(var s in i){var l=i[+s];if(l&&0!==l.bitmap.width&&0!==l.bitmap.height){var u={x:0,y:0,w:l.bitmap.width+2,h:l.bitmap.height+2};n.push(u),a[s]={rect:u,metrics:l.metrics};}}}var h=e.potpack(n),c=h.w,p=h.h,f=new e.AlphaImage({width:c||1,height:p||1});for(var d in t){var g=t[d];for(var m in g){var v=g[+m];if(v&&0!==v.bitmap.width&&0!==v.bitmap.height){var y=r[d][m].rect;e.AlphaImage.copy(v.bitmap,f,{x:0,y:0},{x:y.x+1,y:y.y+1},v.bitmap);}}}this.image=f,this.positions=r;};e.register("GlyphAtlas",T);var I=function(t){this.tileID=new e.OverscaledTileID(t.tileID.overscaledZ,t.tileID.wrap,t.tileID.canonical.z,t.tileID.canonical.x,t.tileID.canonical.y),this.uid=t.uid,this.zoom=t.zoom,this.pixelRatio=t.pixelRatio,this.tileSize=t.tileSize,this.source=t.source,this.overscaling=this.tileID.overscaleFactor(),this.showCollisionBoxes=t.showCollisionBoxes,this.collectResourceTiming=!!t.collectResourceTiming,this.returnDependencies=!!t.returnDependencies;};function k(t,r){for(var n=new e.EvaluationParameters(r),o=0,i=t;o<i.length;o+=1){i[o].recalculate(n);}}I.prototype.parse=function(t,r,n,o){var i=this;this.status="parsing",this.data=t,this.collisionBoxArray=new e.CollisionBoxArray;var a=new e.DictionaryCoder(Object.keys(t.layers).sort()),s=new e.FeatureIndex(this.tileID);s.bucketLayerIDs=[];var l,u,h,c,p={},f={featureIndex:s,iconDependencies:{},patternDependencies:{},glyphDependencies:{}},d=r.familiesBySource[this.source];for(var g in d){var m=t.layers[g];if(m){1===m.version&&e.warnOnce('Vector tile source "'+this.source+'" layer "'+g+'" does not use vector tile spec v2 and therefore may have some rendering errors.');for(var v=a.encode(g),y=[],x=0;x<m.length;x++){var w=m.feature(x);y.push({feature:w,index:x,sourceLayerIndex:v});}for(var S=0,_=d[g];S<_.length;S+=1){var P=_[S],b=P[0];if(!(b.minzoom&&this.zoom<Math.floor(b.minzoom)))if(!(b.maxzoom&&this.zoom>=b.maxzoom))if("none"!==b.visibility)k(P,this.zoom),(p[b.id]=b.createBucket({index:s.bucketLayerIDs.length,layers:P,zoom:this.zoom,pixelRatio:this.pixelRatio,overscaling:this.overscaling,collisionBoxArray:this.collisionBoxArray,sourceLayerIndex:v,sourceID:this.source})).populate(y,f),s.bucketLayerIDs.push(P.map(function(e){return e.id}));}}}var I=e.mapObject(f.glyphDependencies,function(e){return Object.keys(e).map(Number)});Object.keys(I).length?n.send("getGlyphs",{uid:this.uid,stacks:I},function(e,t){l||(l=e,u=t,E.call(i));}):u={};var z=Object.keys(f.iconDependencies);z.length?n.send("getImages",{icons:z},function(e,t){l||(l=e,h=t,E.call(i));}):h={};var C=Object.keys(f.patternDependencies);function E(){if(l)return o(l);if(u&&h&&c){var t=new T(u),r=new e.ImageAtlas(h,c);for(var n in p){var i=p[n];i instanceof e.SymbolBucket?(k(i.layers,this.zoom),M(i,u,t.positions,h,r.iconPositions,this.showCollisionBoxes)):i.hasPattern&&(i instanceof e.LineBucket||i instanceof e.FillBucket||i instanceof e.FillExtrusionBucket)&&(k(i.layers,this.zoom),i.addFeatures(f,r.patternPositions));}this.status="done",o(null,{buckets:e.values(p).filter(function(e){return !e.isEmpty()}),featureIndex:s,collisionBoxArray:this.collisionBoxArray,glyphAtlasImage:t.image,imageAtlas:r,glyphMap:this.returnDependencies?u:null,iconMap:this.returnDependencies?h:null,glyphPositions:this.returnDependencies?t.positions:null});}}C.length?n.send("getImages",{icons:C},function(e,t){l||(l=e,c=t,E.call(i));}):c={},E.call(this);};var z="undefined"!=typeof performance,C={getEntriesByName:function(e){return !!(z&&performance&&performance.getEntriesByName)&&performance.getEntriesByName(e)},mark:function(e){return !!(z&&performance&&performance.mark)&&performance.mark(e)},measure:function(e,t,r){return !!(z&&performance&&performance.measure)&&performance.measure(e,t,r)},clearMarks:function(e){return !!(z&&performance&&performance.clearMarks)&&performance.clearMarks(e)},clearMeasures:function(e){return !!(z&&performance&&performance.clearMeasures)&&performance.clearMeasures(e)}},E=function(e){this._marks={start:[e.url,"start"].join("#"),end:[e.url,"end"].join("#"),measure:e.url.toString()},C.mark(this._marks.start);};function A(t,r){var n=e.getArrayBuffer(t.request,function(t,n,o,i){t?r(t):n&&r(null,{vectorTile:new e.mvt.VectorTile(new e.Protobuf(n)),rawData:n,cacheControl:o,expires:i});});return function(){n.cancel(),r();}}E.prototype.finish=function(){C.mark(this._marks.end);var e=C.getEntriesByName(this._marks.measure);return 0===e.length&&(C.measure(this._marks.measure,this._marks.start,this._marks.end),e=C.getEntriesByName(this._marks.measure),C.clearMarks(this._marks.start),C.clearMarks(this._marks.end),C.clearMeasures(this._marks.measure)),e},C.Performance=E;var L=function(e,t,r){this.actor=e,this.layerIndex=t,this.loadVectorData=r||A,this.loading={},this.loaded={};};L.prototype.loadTile=function(t,r){var n=this,o=t.uid;this.loading||(this.loading={});var i=!!(t&&t.request&&t.request.collectResourceTiming)&&new C.Performance(t.request),a=this.loading[o]=new I(t);a.abort=this.loadVectorData(t,function(t,s){if(delete n.loading[o],t||!s)return a.status="done",n.loaded[o]=a,r(t);var l=s.rawData,u={};s.expires&&(u.expires=s.expires),s.cacheControl&&(u.cacheControl=s.cacheControl);var h={};if(i){var c=i.finish();c&&(h.resourceTiming=JSON.parse(JSON.stringify(c)));}a.vectorTile=s.vectorTile,a.parse(s.vectorTile,n.layerIndex,n.actor,function(t,n){if(t||!n)return r(t);r(null,e.extend({rawTileData:l.slice(0)},n,u,h));}),n.loaded=n.loaded||{},n.loaded[o]=a;});},L.prototype.reloadTile=function(e,t){var r=this.loaded,n=e.uid,o=this;if(r&&r[n]){var i=r[n];i.showCollisionBoxes=e.showCollisionBoxes;var a=function(e,r){var n=i.reloadCallback;n&&(delete i.reloadCallback,i.parse(i.vectorTile,o.layerIndex,o.actor,n)),t(e,r);};"parsing"===i.status?i.reloadCallback=a:"done"===i.status&&(i.vectorTile?i.parse(i.vectorTile,this.layerIndex,this.actor,a):a());}},L.prototype.abortTile=function(e,t){var r=this.loading,n=e.uid;r&&r[n]&&r[n].abort&&(r[n].abort(),delete r[n]),t();},L.prototype.removeTile=function(e,t){var r=this.loaded,n=e.uid;r&&r[n]&&delete r[n],t();};var D=function(){this.loaded={};};D.prototype.loadTile=function(t,r){var n=t.uid,o=t.encoding,i=t.rawImageData,a=new e.DEMData(n,i,o);this.loaded=this.loaded||{},this.loaded[n]=a,r(null,a);},D.prototype.removeTile=function(e){var t=this.loaded,r=e.uid;t&&t[r]&&delete t[r];};var O={RADIUS:6378137,FLATTENING:1/298.257223563,POLAR_RADIUS:6356752.3142};function N(e){var t=0;if(e&&e.length>0){t+=Math.abs(R(e[0]));for(var r=1;r<e.length;r++)t-=Math.abs(R(e[r]));}return t}function R(e){var t,r,n,o,i,a,s=0,l=e.length;if(l>2){for(a=0;a<l;a++)a===l-2?(n=l-2,o=l-1,i=0):a===l-1?(n=l-1,o=0,i=1):(n=a,o=a+1,i=a+2),t=e[n],r=e[o],s+=(F(e[i][0])-F(t[0]))*Math.sin(F(r[1]));s=s*O.RADIUS*O.RADIUS/2;}return s}function F(e){return e*Math.PI/180}var B={geometry:function e(t){var r,n=0;switch(t.type){case"Polygon":return N(t.coordinates);case"MultiPolygon":for(r=0;r<t.coordinates.length;r++)n+=N(t.coordinates[r]);return n;case"Point":case"MultiPoint":case"LineString":case"MultiLineString":return 0;case"GeometryCollection":for(r=0;r<t.geometries.length;r++)n+=e(t.geometries[r]);return n}},ring:R},Z=function e(t,r){switch(t&&t.type||null){case"FeatureCollection":return t.features=t.features.map(j(e,r)),t;case"GeometryCollection":return t.geometries=t.geometries.map(j(e,r)),t;case"Feature":return t.geometry=e(t.geometry,r),t;case"Polygon":case"MultiPolygon":return function(e,t){"Polygon"===e.type?e.coordinates=G(e.coordinates,t):"MultiPolygon"===e.type&&(e.coordinates=e.coordinates.map(j(G,t)));return e}(t,r);default:return t}};function j(e,t){return function(r){return e(r,t)}}function G(e,t){t=!!t,e[0]=J(e[0],t);for(var r=1;r<e.length;r++)e[r]=J(e[r],!t);return e}function J(e,t){return function(e){return B.ring(e)>=0}(e)===t?e:e.reverse()}var X=e.mvt.VectorTileFeature.prototype.toGeoJSON,V=function(t){this._feature=t,this.extent=e.EXTENT,this.type=t.type,this.properties=t.tags,"id"in t&&!isNaN(t.id)&&(this.id=parseInt(t.id,10));};V.prototype.loadGeometry=function(){if(1===this._feature.type){for(var t=[],r=0,n=this._feature.geometry;r<n.length;r+=1){var o=n[r];t.push([new e.Point(o[0],o[1])]);}return t}for(var i=[],a=0,s=this._feature.geometry;a<s.length;a+=1){for(var l=[],u=0,h=s[a];u<h.length;u+=1){var c=h[u];l.push(new e.Point(c[0],c[1]));}i.push(l);}return i},V.prototype.toGeoJSON=function(e,t,r){return X.call(this,e,t,r)};var W=function(t){this.layers={_geojsonTileLayer:this},this.name="_geojsonTileLayer",this.extent=e.EXTENT,this.length=t.length,this._features=t;};W.prototype.feature=function(e){return new V(this._features[e])};var Y=e.vectorTile.VectorTileFeature,q=U;function U(e,t){this.options=t||{},this.features=e,this.length=e.length;}function K(e,t){this.id="number"==typeof e.id?e.id:void 0,this.type=e.type,this.rawGeometry=1===e.type?[e.geometry]:e.geometry,this.properties=e.tags,this.extent=t||4096;}U.prototype.feature=function(e){return new K(this.features[e],this.options.extent)},K.prototype.loadGeometry=function(){var t=this.rawGeometry;this.geometry=[];for(var r=0;r<t.length;r++){for(var n=t[r],o=[],i=0;i<n.length;i++)o.push(new e.Point$1(n[i][0],n[i][1]));this.geometry.push(o);}return this.geometry},K.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-1/0,n=1/0,o=-1/0,i=0;i<e.length;i++)for(var a=e[i],s=0;s<a.length;s++){var l=a[s];t=Math.min(t,l.x),r=Math.max(r,l.x),n=Math.min(n,l.y),o=Math.max(o,l.y);}return [t,n,r,o]},K.prototype.toGeoJSON=Y.prototype.toGeoJSON;var H=te,Q=te,$=function(e,t){t=t||{};var r={};for(var n in e)r[n]=new q(e[n].features,t),r[n].name=n,r[n].version=t.version,r[n].extent=t.extent;return te({layers:r})},ee=q;function te(t){var r=new e.pbf;return function(e,t){for(var r in e.layers)t.writeMessage(3,re,e.layers[r]);}(t,r),r.finish()}function re(e,t){var r;t.writeVarintField(15,e.version||1),t.writeStringField(1,e.name||""),t.writeVarintField(5,e.extent||4096);var n={keys:[],values:[],keycache:{},valuecache:{}};for(r=0;r<e.length;r++)n.feature=e.feature(r),t.writeMessage(2,ne,n);var o=n.keys;for(r=0;r<o.length;r++)t.writeStringField(3,o[r]);var i=n.values;for(r=0;r<i.length;r++)t.writeMessage(4,le,i[r]);}function ne(e,t){var r=e.feature;void 0!==r.id&&t.writeVarintField(1,r.id),t.writeMessage(2,oe,e),t.writeVarintField(3,r.type),t.writeMessage(4,se,r);}function oe(e,t){var r=e.feature,n=e.keys,o=e.values,i=e.keycache,a=e.valuecache;for(var s in r.properties){var l=i[s];void 0===l&&(n.push(s),l=n.length-1,i[s]=l),t.writeVarint(l);var u=r.properties[s],h=typeof u;"string"!==h&&"boolean"!==h&&"number"!==h&&(u=JSON.stringify(u));var c=h+":"+u,p=a[c];void 0===p&&(o.push(u),p=o.length-1,a[c]=p),t.writeVarint(p);}}function ie(e,t){return (t<<3)+(7&e)}function ae(e){return e<<1^e>>31}function se(e,t){for(var r=e.loadGeometry(),n=e.type,o=0,i=0,a=r.length,s=0;s<a;s++){var l=r[s],u=1;1===n&&(u=l.length),t.writeVarint(ie(1,u));for(var h=3===n?l.length-1:l.length,c=0;c<h;c++){1===c&&1!==n&&t.writeVarint(ie(2,h-1));var p=l[c].x-o,f=l[c].y-i;t.writeVarint(ae(p)),t.writeVarint(ae(f)),o+=p,i+=f;}3===n&&t.writeVarint(ie(7,1));}}function le(e,t){var r=typeof e;"string"===r?t.writeStringField(1,e):"boolean"===r?t.writeBooleanField(7,e):"number"===r&&(e%1!=0?t.writeDoubleField(3,e):e<0?t.writeSVarintField(6,e):t.writeVarintField(5,e));}function ue(e,t,r,n,o,i){if(!(o-n<=r)){var a=n+o>>1;!function e(t,r,n,o,i,a){for(;i>o;){if(i-o>600){var s=i-o+1,l=n-o+1,u=Math.log(s),h=.5*Math.exp(2*u/3),c=.5*Math.sqrt(u*h*(s-h)/s)*(l-s/2<0?-1:1),p=Math.max(o,Math.floor(n-l*h/s+c)),f=Math.min(i,Math.floor(n+(s-l)*h/s+c));e(t,r,n,p,f,a);}var d=r[2*n+a],g=o,m=i;for(he(t,r,o,n),r[2*i+a]>d&&he(t,r,o,i);g<m;){for(he(t,r,g,m),g++,m--;r[2*g+a]<d;)g++;for(;r[2*m+a]>d;)m--;}r[2*o+a]===d?he(t,r,o,m):he(t,r,++m,i),m<=n&&(o=m+1),n<=m&&(i=m-1);}}(e,t,a,n,o,i%2),ue(e,t,r,n,a-1,i+1),ue(e,t,r,a+1,o,i+1);}}function he(e,t,r,n){ce(e,r,n),ce(t,2*r,2*n),ce(t,2*r+1,2*n+1);}function ce(e,t,r){var n=e[t];e[t]=e[r],e[r]=n;}function pe(e,t,r,n){var o=e-r,i=t-n;return o*o+i*i}H.fromVectorTileJs=Q,H.fromGeojsonVt=$,H.GeoJSONWrapper=ee;var fe=function(e){return e[0]},de=function(e){return e[1]},ge=function(e,t,r,n,o){void 0===t&&(t=fe),void 0===r&&(r=de),void 0===n&&(n=64),void 0===o&&(o=Float64Array),this.nodeSize=n,this.points=e;for(var i=e.length<65536?Uint16Array:Uint32Array,a=this.ids=new i(e.length),s=this.coords=new o(2*e.length),l=0;l<e.length;l++)a[l]=l,s[2*l]=t(e[l]),s[2*l+1]=r(e[l]);ue(a,s,n,0,a.length-1,0);};ge.prototype.range=function(e,t,r,n){return function(e,t,r,n,o,i,a){for(var s,l,u=[0,e.length-1,0],h=[];u.length;){var c=u.pop(),p=u.pop(),f=u.pop();if(p-f<=a)for(var d=f;d<=p;d++)s=t[2*d],l=t[2*d+1],s>=r&&s<=o&&l>=n&&l<=i&&h.push(e[d]);else{var g=Math.floor((f+p)/2);s=t[2*g],l=t[2*g+1],s>=r&&s<=o&&l>=n&&l<=i&&h.push(e[g]);var m=(c+1)%2;(0===c?r<=s:n<=l)&&(u.push(f),u.push(g-1),u.push(m)),(0===c?o>=s:i>=l)&&(u.push(g+1),u.push(p),u.push(m));}}return h}(this.ids,this.coords,e,t,r,n,this.nodeSize)},ge.prototype.within=function(e,t,r){return function(e,t,r,n,o,i){for(var a=[0,e.length-1,0],s=[],l=o*o;a.length;){var u=a.pop(),h=a.pop(),c=a.pop();if(h-c<=i)for(var p=c;p<=h;p++)pe(t[2*p],t[2*p+1],r,n)<=l&&s.push(e[p]);else{var f=Math.floor((c+h)/2),d=t[2*f],g=t[2*f+1];pe(d,g,r,n)<=l&&s.push(e[f]);var m=(u+1)%2;(0===u?r-o<=d:n-o<=g)&&(a.push(c),a.push(f-1),a.push(m)),(0===u?r+o>=d:n+o>=g)&&(a.push(f+1),a.push(h),a.push(m));}}return s}(this.ids,this.coords,e,t,r,this.nodeSize)};var me={minZoom:0,maxZoom:16,radius:40,extent:512,nodeSize:64,log:!1,reduce:null,map:function(e){return e}},ve=function(e){this.options=Pe(Object.create(me),e),this.trees=new Array(this.options.maxZoom+1);};function ye(e,t,r,n,o){return {x:e,y:t,zoom:1/0,id:r,parentId:-1,numPoints:n,properties:o}}function xe(e,t){var r=e.geometry.coordinates,n=r[0],o=r[1];return {x:Se(n),y:_e(o),zoom:1/0,index:t,parentId:-1}}function we(e){return {type:"Feature",id:e.id,properties:Me(e),geometry:{type:"Point",coordinates:[(n=e.x,360*(n-.5)),(t=e.y,r=(180-360*t)*Math.PI/180,360*Math.atan(Math.exp(r))/Math.PI-90)]}};var t,r,n;}function Me(e){var t=e.numPoints,r=t>=1e4?Math.round(t/1e3)+"k":t>=1e3?Math.round(t/100)/10+"k":t;return Pe(Pe({},e.properties),{cluster:!0,cluster_id:e.id,point_count:t,point_count_abbreviated:r})}function Se(e){return e/360+.5}function _e(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function Pe(e,t){for(var r in t)e[r]=t[r];return e}function be(e){return e.x}function Te(e){return e.y}function Ie(e,t,r,n,o,i){var a=o-r,s=i-n;if(0!==a||0!==s){var l=((e-r)*a+(t-n)*s)/(a*a+s*s);l>1?(r=o,n=i):l>0&&(r+=a*l,n+=s*l);}return (a=e-r)*a+(s=t-n)*s}function ke(e,t,r,n){var o={id:void 0===e?null:e,type:t,geometry:r,tags:n,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};return function(e){var t=e.geometry,r=e.type;if("Point"===r||"MultiPoint"===r||"LineString"===r)ze(e,t);else if("Polygon"===r||"MultiLineString"===r)for(var n=0;n<t.length;n++)ze(e,t[n]);else if("MultiPolygon"===r)for(n=0;n<t.length;n++)for(var o=0;o<t[n].length;o++)ze(e,t[n][o]);}(o),o}function ze(e,t){for(var r=0;r<t.length;r+=3)e.minX=Math.min(e.minX,t[r]),e.minY=Math.min(e.minY,t[r+1]),e.maxX=Math.max(e.maxX,t[r]),e.maxY=Math.max(e.maxY,t[r+1]);}function Ce(e,t,r,n){if(t.geometry){var o=t.geometry.coordinates,i=t.geometry.type,a=Math.pow(r.tolerance/((1<<r.maxZoom)*r.extent),2),s=[],l=t.id;if(r.promoteId?l=t.properties[r.promoteId]:r.generateId&&(l=n||0),"Point"===i)Ee(o,s);else if("MultiPoint"===i)for(var u=0;u<o.length;u++)Ee(o[u],s);else if("LineString"===i)Ae(o,s,a,!1);else if("MultiLineString"===i){if(r.lineMetrics){for(u=0;u<o.length;u++)s=[],Ae(o[u],s,a,!1),e.push(ke(l,"LineString",s,t.properties));return}Le(o,s,a,!1);}else if("Polygon"===i)Le(o,s,a,!0);else{if("MultiPolygon"!==i){if("GeometryCollection"===i){for(u=0;u<t.geometry.geometries.length;u++)Ce(e,{id:l,geometry:t.geometry.geometries[u],properties:t.properties},r,n);return}throw new Error("Input data is not a valid GeoJSON object.")}for(u=0;u<o.length;u++){var h=[];Le(o[u],h,a,!0),s.push(h);}}e.push(ke(l,i,s,t.properties));}}function Ee(e,t){t.push(De(e[0])),t.push(Oe(e[1])),t.push(0);}function Ae(e,t,r,n){for(var o,i,a=0,s=0;s<e.length;s++){var l=De(e[s][0]),u=Oe(e[s][1]);t.push(l),t.push(u),t.push(0),s>0&&(a+=n?(o*u-l*i)/2:Math.sqrt(Math.pow(l-o,2)+Math.pow(u-i,2))),o=l,i=u;}var h=t.length-3;t[2]=1,function e(t,r,n,o){for(var i,a=o,s=n-r>>1,l=n-r,u=t[r],h=t[r+1],c=t[n],p=t[n+1],f=r+3;f<n;f+=3){var d=Ie(t[f],t[f+1],u,h,c,p);if(d>a)i=f,a=d;else if(d===a){var g=Math.abs(f-s);g<l&&(i=f,l=g);}}a>o&&(i-r>3&&e(t,r,i,o),t[i+2]=a,n-i>3&&e(t,i,n,o));}(t,0,h,r),t[h+2]=1,t.size=Math.abs(a),t.start=0,t.end=t.size;}function Le(e,t,r,n){for(var o=0;o<e.length;o++){var i=[];Ae(e[o],i,r,n),t.push(i);}}function De(e){return e/360+.5}function Oe(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function Ne(e,t,r,n,o,i,a,s){if(n/=t,i>=(r/=t)&&a<n)return e;if(a<r||i>=n)return null;for(var l=[],u=0;u<e.length;u++){var h=e[u],c=h.geometry,p=h.type,f=0===o?h.minX:h.minY,d=0===o?h.maxX:h.maxY;if(f>=r&&d<n)l.push(h);else if(!(d<r||f>=n)){var g=[];if("Point"===p||"MultiPoint"===p)Re(c,g,r,n,o);else if("LineString"===p)Fe(c,g,r,n,o,!1,s.lineMetrics);else if("MultiLineString"===p)Ze(c,g,r,n,o,!1);else if("Polygon"===p)Ze(c,g,r,n,o,!0);else if("MultiPolygon"===p)for(var m=0;m<c.length;m++){var v=[];Ze(c[m],v,r,n,o,!0),v.length&&g.push(v);}if(g.length){if(s.lineMetrics&&"LineString"===p){for(m=0;m<g.length;m++)l.push(ke(h.id,p,g[m],h.tags));continue}"LineString"!==p&&"MultiLineString"!==p||(1===g.length?(p="LineString",g=g[0]):p="MultiLineString"),"Point"!==p&&"MultiPoint"!==p||(p=3===g.length?"Point":"MultiPoint"),l.push(ke(h.id,p,g,h.tags));}}}return l.length?l:null}function Re(e,t,r,n,o){for(var i=0;i<e.length;i+=3){var a=e[i+o];a>=r&&a<=n&&(t.push(e[i]),t.push(e[i+1]),t.push(e[i+2]));}}function Fe(e,t,r,n,o,i,a){for(var s,l,u=Be(e),h=0===o?Ge:Je,c=e.start,p=0;p<e.length-3;p+=3){var f=e[p],d=e[p+1],g=e[p+2],m=e[p+3],v=e[p+4],y=0===o?f:d,x=0===o?m:v,w=!1;a&&(s=Math.sqrt(Math.pow(f-m,2)+Math.pow(d-v,2))),y<r?x>r&&(l=h(u,f,d,m,v,r),a&&(u.start=c+s*l)):y>n?x<n&&(l=h(u,f,d,m,v,n),a&&(u.start=c+s*l)):je(u,f,d,g),x<r&&y>=r&&(l=h(u,f,d,m,v,r),w=!0),x>n&&y<=n&&(l=h(u,f,d,m,v,n),w=!0),!i&&w&&(a&&(u.end=c+s*l),t.push(u),u=Be(e)),a&&(c+=s);}var M=e.length-3;f=e[M],d=e[M+1],g=e[M+2],(y=0===o?f:d)>=r&&y<=n&&je(u,f,d,g),M=u.length-3,i&&M>=3&&(u[M]!==u[0]||u[M+1]!==u[1])&&je(u,u[0],u[1],u[2]),u.length&&t.push(u);}function Be(e){var t=[];return t.size=e.size,t.start=e.start,t.end=e.end,t}function Ze(e,t,r,n,o,i){for(var a=0;a<e.length;a++)Fe(e[a],t,r,n,o,i,!1);}function je(e,t,r,n){e.push(t),e.push(r),e.push(n);}function Ge(e,t,r,n,o,i){var a=(i-t)/(n-t);return e.push(i),e.push(r+(o-r)*a),e.push(1),a}function Je(e,t,r,n,o,i){var a=(i-r)/(o-r);return e.push(t+(n-t)*a),e.push(i),e.push(1),a}function Xe(e,t){for(var r=[],n=0;n<e.length;n++){var o,i=e[n],a=i.type;if("Point"===a||"MultiPoint"===a||"LineString"===a)o=Ve(i.geometry,t);else if("MultiLineString"===a||"Polygon"===a){o=[];for(var s=0;s<i.geometry.length;s++)o.push(Ve(i.geometry[s],t));}else if("MultiPolygon"===a)for(o=[],s=0;s<i.geometry.length;s++){for(var l=[],u=0;u<i.geometry[s].length;u++)l.push(Ve(i.geometry[s][u],t));o.push(l);}r.push(ke(i.id,a,o,i.tags));}return r}function Ve(e,t){var r=[];r.size=e.size,void 0!==e.start&&(r.start=e.start,r.end=e.end);for(var n=0;n<e.length;n+=3)r.push(e[n]+t,e[n+1],e[n+2]);return r}function We(e,t){if(e.transformed)return e;var r,n,o,i=1<<e.z,a=e.x,s=e.y;for(r=0;r<e.features.length;r++){var l=e.features[r],u=l.geometry,h=l.type;if(l.geometry=[],1===h)for(n=0;n<u.length;n+=2)l.geometry.push(Ye(u[n],u[n+1],t,i,a,s));else for(n=0;n<u.length;n++){var c=[];for(o=0;o<u[n].length;o+=2)c.push(Ye(u[n][o],u[n][o+1],t,i,a,s));l.geometry.push(c);}}return e.transformed=!0,e}function Ye(e,t,r,n,o,i){return [Math.round(r*(e*n-o)),Math.round(r*(t*n-i))]}function qe(e,t,r,n,o){for(var i=t===o.maxZoom?0:o.tolerance/((1<<t)*o.extent),a={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:r,y:n,z:t,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0},s=0;s<e.length;s++){a.numFeatures++,Ue(a,e[s],i,o);var l=e[s].minX,u=e[s].minY,h=e[s].maxX,c=e[s].maxY;l<a.minX&&(a.minX=l),u<a.minY&&(a.minY=u),h>a.maxX&&(a.maxX=h),c>a.maxY&&(a.maxY=c);}return a}function Ue(e,t,r,n){var o=t.geometry,i=t.type,a=[];if("Point"===i||"MultiPoint"===i)for(var s=0;s<o.length;s+=3)a.push(o[s]),a.push(o[s+1]),e.numPoints++,e.numSimplified++;else if("LineString"===i)Ke(a,o,e,r,!1,!1);else if("MultiLineString"===i||"Polygon"===i)for(s=0;s<o.length;s++)Ke(a,o[s],e,r,"Polygon"===i,0===s);else if("MultiPolygon"===i)for(var l=0;l<o.length;l++){var u=o[l];for(s=0;s<u.length;s++)Ke(a,u[s],e,r,!0,0===s);}if(a.length){var h=t.tags||null;if("LineString"===i&&n.lineMetrics){for(var c in h={},t.tags)h[c]=t.tags[c];h.mapbox_clip_start=o.start/o.size,h.mapbox_clip_end=o.end/o.size;}var p={geometry:a,type:"Polygon"===i||"MultiPolygon"===i?3:"LineString"===i||"MultiLineString"===i?2:1,tags:h};null!==t.id&&(p.id=t.id),e.features.push(p);}}function Ke(e,t,r,n,o,i){var a=n*n;if(n>0&&t.size<(o?a:n))r.numPoints+=t.length/3;else{for(var s=[],l=0;l<t.length;l+=3)(0===n||t[l+2]>a)&&(r.numSimplified++,s.push(t[l]),s.push(t[l+1])),r.numPoints++;o&&function(e,t){for(var r=0,n=0,o=e.length,i=o-2;n<o;i=n,n+=2)r+=(e[n]-e[i])*(e[n+1]+e[i+1]);if(r>0===t)for(n=0,o=e.length;n<o/2;n+=2){var a=e[n],s=e[n+1];e[n]=e[o-2-n],e[n+1]=e[o-1-n],e[o-2-n]=a,e[o-1-n]=s;}}(s,i),e.push(s);}}function He(e,t){var r=(t=this.options=function(e,t){for(var r in t)e[r]=t[r];return e}(Object.create(this.options),t)).debug;if(r&&console.time("preprocess data"),t.maxZoom<0||t.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");if(t.promoteId&&t.generateId)throw new Error("promoteId and generateId cannot be used together.");var n=function(e,t){var r=[];if("FeatureCollection"===e.type)for(var n=0;n<e.features.length;n++)Ce(r,e.features[n],t,n);else"Feature"===e.type?Ce(r,e,t):Ce(r,{geometry:e},t);return r}(e,t);this.tiles={},this.tileCoords=[],r&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",t.indexMaxZoom,t.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),(n=function(e,t){var r=t.buffer/t.extent,n=e,o=Ne(e,1,-1-r,r,0,-1,2,t),i=Ne(e,1,1-r,2+r,0,-1,2,t);return (o||i)&&(n=Ne(e,1,-r,1+r,0,-1,2,t)||[],o&&(n=Xe(o,1).concat(n)),i&&(n=n.concat(Xe(i,-1)))),n}(n,t)).length&&this.splitTile(n,0,0,0),r&&(n.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)));}function Qe(e,t,r){return 32*((1<<e)*r+t)+e}function $e(e,t){var r=e.tileID.canonical;if(!this._geoJSONIndex)return t(null,null);var n=this._geoJSONIndex.getTile(r.z,r.x,r.y);if(!n)return t(null,null);var o=new W(n.features),i=H(o);0===i.byteOffset&&i.byteLength===i.buffer.byteLength||(i=new Uint8Array(i)),t(null,{vectorTile:o,rawData:i.buffer});}ve.prototype.load=function(e){var t=this.options,r=t.log,n=t.minZoom,o=t.maxZoom,i=t.nodeSize;r&&console.time("total time");var a="prepare "+e.length+" points";r&&console.time(a),this.points=e;for(var s=[],l=0;l<e.length;l++)e[l].geometry&&s.push(xe(e[l],l));this.trees[o+1]=new ge(s,be,Te,i,Float32Array),r&&console.timeEnd(a);for(var u=o;u>=n;u--){var h=+Date.now();s=this._cluster(s,u),this.trees[u]=new ge(s,be,Te,i,Float32Array),r&&console.log("z%d: %d clusters in %dms",u,s.length,+Date.now()-h);}return r&&console.timeEnd("total time"),this},ve.prototype.getClusters=function(e,t){var r=((e[0]+180)%360+360)%360-180,n=Math.max(-90,Math.min(90,e[1])),o=180===e[2]?180:((e[2]+180)%360+360)%360-180,i=Math.max(-90,Math.min(90,e[3]));if(e[2]-e[0]>=360)r=-180,o=180;else if(r>o){var a=this.getClusters([r,n,180,i],t),s=this.getClusters([-180,n,o,i],t);return a.concat(s)}for(var l=this.trees[this._limitZoom(t)],u=[],h=0,c=l.range(Se(r),_e(i),Se(o),_e(n));h<c.length;h+=1){var p=c[h],f=l.points[p];u.push(f.numPoints?we(f):this.points[f.index]);}return u},ve.prototype.getChildren=function(e){var t=e>>5,r=e%32,n="No cluster with the specified id.",o=this.trees[r];if(!o)throw new Error(n);var i=o.points[t];if(!i)throw new Error(n);for(var a=this.options.radius/(this.options.extent*Math.pow(2,r-1)),s=[],l=0,u=o.within(i.x,i.y,a);l<u.length;l+=1){var h=u[l],c=o.points[h];c.parentId===e&&s.push(c.numPoints?we(c):this.points[c.index]);}if(0===s.length)throw new Error(n);return s},ve.prototype.getLeaves=function(e,t,r){t=t||10,r=r||0;var n=[];return this._appendLeaves(n,e,t,r,0),n},ve.prototype.getTile=function(e,t,r){var n=this.trees[this._limitZoom(e)],o=Math.pow(2,e),i=this.options,a=i.extent,s=i.radius/a,l=(r-s)/o,u=(r+1+s)/o,h={features:[]};return this._addTileFeatures(n.range((t-s)/o,l,(t+1+s)/o,u),n.points,t,r,o,h),0===t&&this._addTileFeatures(n.range(1-s/o,l,1,u),n.points,o,r,o,h),t===o-1&&this._addTileFeatures(n.range(0,l,s/o,u),n.points,-1,r,o,h),h.features.length?h:null},ve.prototype.getClusterExpansionZoom=function(e){for(var t=e%32-1;t<=this.options.maxZoom;){var r=this.getChildren(e);if(t++,1!==r.length)break;e=r[0].properties.cluster_id;}return t},ve.prototype._appendLeaves=function(e,t,r,n,o){for(var i=0,a=this.getChildren(t);i<a.length;i+=1){var s=a[i],l=s.properties;if(l&&l.cluster?o+l.point_count<=n?o+=l.point_count:o=this._appendLeaves(e,l.cluster_id,r,n,o):o<n?o++:e.push(s),e.length===r)break}return o},ve.prototype._addTileFeatures=function(e,t,r,n,o,i){for(var a=0,s=e;a<s.length;a+=1){var l=t[s[a]],u={type:1,geometry:[[Math.round(this.options.extent*(l.x*o-r)),Math.round(this.options.extent*(l.y*o-n))]],tags:l.numPoints?Me(l):this.points[l.index].properties},h=l.numPoints?l.id:this.points[l.index].id;void 0!==h&&(u.id=h),i.features.push(u);}},ve.prototype._limitZoom=function(e){return Math.max(this.options.minZoom,Math.min(e,this.options.maxZoom+1))},ve.prototype._cluster=function(e,t){for(var r=[],n=this.options,o=n.radius,i=n.extent,a=n.reduce,s=o/(i*Math.pow(2,t)),l=0;l<e.length;l++){var u=e[l];if(!(u.zoom<=t)){u.zoom=t;for(var h=this.trees[t+1],c=h.within(u.x,u.y,s),p=u.numPoints||1,f=u.x*p,d=u.y*p,g=a?this._map(u,!0):null,m=(l<<5)+(t+1),v=0,y=c;v<y.length;v+=1){var x=y[v],w=h.points[x];if(!(w.zoom<=t)){w.zoom=t;var M=w.numPoints||1;f+=w.x*M,d+=w.y*M,p+=M,w.parentId=m,a&&a(g,this._map(w));}}1===p?r.push(u):(u.parentId=m,r.push(ye(f/p,d/p,m,p,g)));}}return r},ve.prototype._map=function(e,t){if(e.numPoints)return t?Pe({},e.properties):e.properties;var r=this.points[e.index].properties,n=this.options.map(r);return t&&n===r?Pe({},n):n},He.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!1,promoteId:null,generateId:!1,debug:0},He.prototype.splitTile=function(e,t,r,n,o,i,a){for(var s=[e,t,r,n],l=this.options,u=l.debug;s.length;){n=s.pop(),r=s.pop(),t=s.pop(),e=s.pop();var h=1<<t,c=Qe(t,r,n),p=this.tiles[c];if(!p&&(u>1&&console.time("creation"),p=this.tiles[c]=qe(e,t,r,n,l),this.tileCoords.push({z:t,x:r,y:n}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",t,r,n,p.numFeatures,p.numPoints,p.numSimplified),console.timeEnd("creation"));var f="z"+t;this.stats[f]=(this.stats[f]||0)+1,this.total++;}if(p.source=e,o){if(t===l.maxZoom||t===o)continue;var d=1<<o-t;if(r!==Math.floor(i/d)||n!==Math.floor(a/d))continue}else if(t===l.indexMaxZoom||p.numPoints<=l.indexMaxPoints)continue;if(p.source=null,0!==e.length){u>1&&console.time("clipping");var g,m,v,y,x,w,M=.5*l.buffer/l.extent,S=.5-M,_=.5+M,P=1+M;g=m=v=y=null,x=Ne(e,h,r-M,r+_,0,p.minX,p.maxX,l),w=Ne(e,h,r+S,r+P,0,p.minX,p.maxX,l),e=null,x&&(g=Ne(x,h,n-M,n+_,1,p.minY,p.maxY,l),m=Ne(x,h,n+S,n+P,1,p.minY,p.maxY,l),x=null),w&&(v=Ne(w,h,n-M,n+_,1,p.minY,p.maxY,l),y=Ne(w,h,n+S,n+P,1,p.minY,p.maxY,l),w=null),u>1&&console.timeEnd("clipping"),s.push(g||[],t+1,2*r,2*n),s.push(m||[],t+1,2*r,2*n+1),s.push(v||[],t+1,2*r+1,2*n),s.push(y||[],t+1,2*r+1,2*n+1);}}},He.prototype.getTile=function(e,t,r){var n=this.options,o=n.extent,i=n.debug;if(e<0||e>24)return null;var a=1<<e,s=Qe(e,t=(t%a+a)%a,r);if(this.tiles[s])return We(this.tiles[s],o);i>1&&console.log("drilling down to z%d-%d-%d",e,t,r);for(var l,u=e,h=t,c=r;!l&&u>0;)u--,h=Math.floor(h/2),c=Math.floor(c/2),l=this.tiles[Qe(u,h,c)];return l&&l.source?(i>1&&console.log("found parent tile z%d-%d-%d",u,h,c),i>1&&console.time("drilling down"),this.splitTile(l.source,u,h,c,e,t,r),i>1&&console.timeEnd("drilling down"),this.tiles[s]?We(this.tiles[s],o):null):null};var et=function(t){function r(e,r,n){t.call(this,e,r,$e),n&&(this.loadGeoJSON=n);}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype.loadData=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),this._pendingCallback=t,this._pendingLoadDataParams=e,this._state&&"Idle"!==this._state?this._state="NeedsLoadData":(this._state="Coalescing",this._loadData());},r.prototype._loadData=function(){var t=this;if(this._pendingCallback&&this._pendingLoadDataParams){var r=this._pendingCallback,n=this._pendingLoadDataParams;delete this._pendingCallback,delete this._pendingLoadDataParams;var o=!!(n&&n.request&&n.request.collectResourceTiming)&&new C.Performance(n.request);this.loadGeoJSON(n,function(i,a){if(i||!a)return r(i);if("object"!=typeof a)return r(new Error("Input data is not a valid GeoJSON object."));Z(a,!0);try{t._geoJSONIndex=n.cluster?new ve(function(t){var r=t.superclusterOptions,n=t.clusterProperties;if(!n||!r)return r;for(var o={},i={},a={accumulated:null,zoom:0},s={properties:null},l=Object.keys(n),u=0,h=l;u<h.length;u+=1){var c=h[u],p=n[c],f=p[0],d=p[1],g=e.createExpression(d),m=e.createExpression("string"==typeof f?[f,["accumulated"],["get",c]]:f);o[c]=g.value,i[c]=m.value;}return r.map=function(e){s.properties=e;for(var t={},r=0,n=l;r<n.length;r+=1){var i=n[r];t[i]=o[i].evaluate(a,s);}return t},r.reduce=function(e,t){s.properties=t;for(var r=0,n=l;r<n.length;r+=1){var o=n[r];a.accumulated=e[o],e[o]=i[o].evaluate(a,s);}},r}(n)).load(a.features):function(e,t){return new He(e,t)}(a,n.geojsonVtOptions);}catch(i){return r(i)}t.loaded={};var s={};if(o){var l=o.finish();l&&(s.resourceTiming={},s.resourceTiming[n.source]=JSON.parse(JSON.stringify(l)));}r(null,s);});}},r.prototype.coalesce=function(){"Coalescing"===this._state?this._state="Idle":"NeedsLoadData"===this._state&&(this._state="Coalescing",this._loadData());},r.prototype.reloadTile=function(e,r){var n=this.loaded,o=e.uid;return n&&n[o]?t.prototype.reloadTile.call(this,e,r):this.loadTile(e,r)},r.prototype.loadGeoJSON=function(t,r){if(t.request)e.getJSON(t.request,r);else{if("string"!=typeof t.data)return r(new Error("Input data is not a valid GeoJSON object."));try{return r(null,JSON.parse(t.data))}catch(e){return r(new Error("Input data is not a valid GeoJSON object."))}}},r.prototype.removeSource=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),t();},r.prototype.getClusterExpansionZoom=function(e,t){t(null,this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));},r.prototype.getClusterChildren=function(e,t){t(null,this._geoJSONIndex.getChildren(e.clusterId));},r.prototype.getClusterLeaves=function(e,t){t(null,this._geoJSONIndex.getLeaves(e.clusterId,e.limit,e.offset));},r}(L);var tt=function(t){var r=this;this.self=t,this.actor=new e.Actor(t,this),this.layerIndexes={},this.workerSourceTypes={vector:L,geojson:et},this.workerSources={},this.demWorkerSources={},this.self.registerWorkerSource=function(e,t){if(r.workerSourceTypes[e])throw new Error('Worker source with name "'+e+'" already registered.');r.workerSourceTypes[e]=t;},this.self.registerRTLTextPlugin=function(t){if(e.plugin.isLoaded())throw new Error("RTL text plugin already registered.");e.plugin.applyArabicShaping=t.applyArabicShaping,e.plugin.processBidirectionalText=t.processBidirectionalText,e.plugin.processStyledBidirectionalText=t.processStyledBidirectionalText;};};return tt.prototype.setReferrer=function(e,t){this.referrer=t;},tt.prototype.setLayers=function(e,t,r){this.getLayerIndex(e).replace(t),r();},tt.prototype.updateLayers=function(e,t,r){this.getLayerIndex(e).update(t.layers,t.removedIds),r();},tt.prototype.loadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).loadTile(t,r);},tt.prototype.loadDEMTile=function(e,t,r){this.getDEMWorkerSource(e,t.source).loadTile(t,r);},tt.prototype.reloadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).reloadTile(t,r);},tt.prototype.abortTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).abortTile(t,r);},tt.prototype.removeTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).removeTile(t,r);},tt.prototype.removeDEMTile=function(e,t){this.getDEMWorkerSource(e,t.source).removeTile(t);},tt.prototype.removeSource=function(e,t,r){if(this.workerSources[e]&&this.workerSources[e][t.type]&&this.workerSources[e][t.type][t.source]){var n=this.workerSources[e][t.type][t.source];delete this.workerSources[e][t.type][t.source],void 0!==n.removeSource?n.removeSource(t,r):r();}},tt.prototype.loadWorkerSource=function(e,t,r){try{this.self.importScripts(t.url),r();}catch(e){r(e.toString());}},tt.prototype.loadRTLTextPlugin=function(t,r,n){try{e.plugin.isLoaded()||(this.self.importScripts(r),n(e.plugin.isLoaded()?null:new Error("RTL Text Plugin failed to import scripts from "+r)));}catch(e){n(e.toString());}},tt.prototype.getLayerIndex=function(e){var t=this.layerIndexes[e];return t||(t=this.layerIndexes[e]=new n),t},tt.prototype.getWorkerSource=function(e,t,r){var n=this;if(this.workerSources[e]||(this.workerSources[e]={}),this.workerSources[e][t]||(this.workerSources[e][t]={}),!this.workerSources[e][t][r]){var o={send:function(t,r,o){n.actor.send(t,r,o,e);}};this.workerSources[e][t][r]=new this.workerSourceTypes[t](o,this.getLayerIndex(e));}return this.workerSources[e][t][r]},tt.prototype.getDEMWorkerSource=function(e,t){return this.demWorkerSources[e]||(this.demWorkerSources[e]={}),this.demWorkerSources[e][t]||(this.demWorkerSources[e][t]=new D),this.demWorkerSources[e][t]},"undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope&&(self.worker=new tt(self)),tt});

define(["./shared.js"],function(t){"use strict";var e=t.createCommonjsModule(function(t){function e(t){return !!("undefined"!=typeof window&&"undefined"!=typeof document&&Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray&&Function.prototype&&Function.prototype.bind&&Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions&&"JSON"in window&&"parse"in JSON&&"stringify"in JSON&&function(){if(!("Worker"in window&&"Blob"in window&&"URL"in window))return !1;var t,e,i=new Blob([""],{type:"text/javascript"}),o=URL.createObjectURL(i);try{e=new Worker(o),t=!0;}catch(e){t=!1;}e&&e.terminate();return URL.revokeObjectURL(o),t}()&&"Uint8ClampedArray"in window&&ArrayBuffer.isView&&function(t){void 0===i[t]&&(i[t]=function(t){var i=document.createElement("canvas"),o=Object.create(e.webGLContextAttributes);return o.failIfMajorPerformanceCaveat=t,i.probablySupportsContext?i.probablySupportsContext("webgl",o)||i.probablySupportsContext("experimental-webgl",o):i.supportsContext?i.supportsContext("webgl",o)||i.supportsContext("experimental-webgl",o):i.getContext("webgl",o)||i.getContext("experimental-webgl",o)}(t));return i[t]}(t&&t.failIfMajorPerformanceCaveat))}t.exports?t.exports=e:window&&(window.mapboxgl=window.mapboxgl||{},window.mapboxgl.supported=e);var i={};e.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0};}),i={create:function(e,i,o){var r=t.window.document.createElement(e);return i&&(r.className=i),o&&o.appendChild(r),r},createNS:function(e,i){return t.window.document.createElementNS(e,i)}},o=t.window.document?t.window.document.documentElement.style:null;function r(t){if(!o)return null;for(var e=0;e<t.length;e++)if(t[e]in o)return t[e];return t[0]}var a,n=r(["userSelect","MozUserSelect","WebkitUserSelect","msUserSelect"]);i.disableDrag=function(){o&&n&&(a=o[n],o[n]="none");},i.enableDrag=function(){o&&n&&(o[n]=a);};var s=r(["transform","WebkitTransform"]);i.setTransform=function(t,e){t.style[s]=e;};var l=!1;try{var c=Object.defineProperty({},"passive",{get:function(){l=!0;}});t.window.addEventListener("test",c,c),t.window.removeEventListener("test",c,c);}catch(t){l=!1;}i.addEventListener=function(t,e,i,o){void 0===o&&(o={}),"passive"in o&&l?t.addEventListener(e,i,o):t.addEventListener(e,i,o.capture);},i.removeEventListener=function(t,e,i,o){void 0===o&&(o={}),"passive"in o&&l?t.removeEventListener(e,i,o):t.removeEventListener(e,i,o.capture);};var u=function(e){e.preventDefault(),e.stopPropagation(),t.window.removeEventListener("click",u,!0);};i.suppressClick=function(){t.window.addEventListener("click",u,!0),t.window.setTimeout(function(){t.window.removeEventListener("click",u,!0);},0);},i.mousePos=function(e,i){var o=e.getBoundingClientRect();return i=i.touches?i.touches[0]:i,new t.Point(i.clientX-o.left-e.clientLeft,i.clientY-o.top-e.clientTop)},i.touchPos=function(e,i){for(var o=e.getBoundingClientRect(),r=[],a="touchend"===i.type?i.changedTouches:i.touches,n=0;n<a.length;n++)r.push(new t.Point(a[n].clientX-o.left-e.clientLeft,a[n].clientY-o.top-e.clientTop));return r},i.mouseButton=function(e){return void 0!==t.window.InstallTrigger&&2===e.button&&e.ctrlKey&&t.window.navigator.platform.toUpperCase().indexOf("MAC")>=0?0:e.button},i.remove=function(t){t.parentNode&&t.parentNode.removeChild(t);};var h=function(){this.images={},this.loaded=!1,this.requestors=[],this.patterns={},this.atlasImage=new t.RGBAImage({width:1,height:1}),this.dirty=!0;};h.prototype.isLoaded=function(){return this.loaded},h.prototype.setLoaded=function(t){if(this.loaded!==t&&(this.loaded=t,t)){for(var e=0,i=this.requestors;e<i.length;e+=1){var o=i[e],r=o.ids,a=o.callback;this._notify(r,a);}this.requestors=[];}},h.prototype.getImage=function(t){return this.images[t]},h.prototype.addImage=function(t,e){this.images[t]=e;},h.prototype.removeImage=function(t){delete this.images[t],delete this.patterns[t];},h.prototype.listImages=function(){return Object.keys(this.images)},h.prototype.getImages=function(t,e){var i=!0;if(!this.isLoaded())for(var o=0,r=t;o<r.length;o+=1){var a=r[o];this.images[a]||(i=!1);}this.isLoaded()||i?this._notify(t,e):this.requestors.push({ids:t,callback:e});},h.prototype._notify=function(t,e){for(var i={},o=0,r=t;o<r.length;o+=1){var a=r[o],n=this.images[a];n&&(i[a]={data:n.data.clone(),pixelRatio:n.pixelRatio,sdf:n.sdf});}e(null,i);},h.prototype.getPixelSize=function(){var t=this.atlasImage;return {width:t.width,height:t.height}},h.prototype.getPattern=function(e){var i=this.patterns[e];if(i)return i.position;var o=this.getImage(e);if(!o)return null;var r={w:o.data.width+2,h:o.data.height+2,x:0,y:0},a=new t.ImagePosition(r,o);return this.patterns[e]={bin:r,position:a},this._updatePatternAtlas(),a},h.prototype.bind=function(e){var i=e.gl;this.atlasTexture?this.dirty&&(this.atlasTexture.update(this.atlasImage),this.dirty=!1):this.atlasTexture=new t.Texture(e,this.atlasImage,i.RGBA),this.atlasTexture.bind(i.LINEAR,i.CLAMP_TO_EDGE);},h.prototype._updatePatternAtlas=function(){var e=[];for(var i in this.patterns)e.push(this.patterns[i].bin);var o=t.potpack(e),r=o.w,a=o.h,n=this.atlasImage;for(var s in n.resize({width:r||1,height:a||1}),this.patterns){var l=this.patterns[s].bin,c=l.x+1,u=l.y+1,h=this.images[s].data,p=h.width,d=h.height;t.RGBAImage.copy(h,n,{x:0,y:0},{x:c,y:u},{width:p,height:d}),t.RGBAImage.copy(h,n,{x:0,y:d-1},{x:c,y:u-1},{width:p,height:1}),t.RGBAImage.copy(h,n,{x:0,y:0},{x:c,y:u+d},{width:p,height:1}),t.RGBAImage.copy(h,n,{x:p-1,y:0},{x:c-1,y:u},{width:1,height:d}),t.RGBAImage.copy(h,n,{x:0,y:0},{x:c+p,y:u},{width:1,height:d});}this.dirty=!0;};var p=_,d=1e20;function _(t,e,i,o,r,a){this.fontSize=t||24,this.buffer=void 0===e?3:e,this.cutoff=o||.25,this.fontFamily=r||"sans-serif",this.fontWeight=a||"normal",this.radius=i||8;var n=this.size=this.fontSize+2*this.buffer;this.canvas=document.createElement("canvas"),this.canvas.width=this.canvas.height=n,this.ctx=this.canvas.getContext("2d"),this.ctx.font=this.fontWeight+" "+this.fontSize+"px "+this.fontFamily,this.ctx.textBaseline="middle",this.ctx.fillStyle="black",this.gridOuter=new Float64Array(n*n),this.gridInner=new Float64Array(n*n),this.f=new Float64Array(n),this.d=new Float64Array(n),this.z=new Float64Array(n+1),this.v=new Int16Array(n),this.middle=Math.round(n/2*(navigator.userAgent.indexOf("Gecko/")>=0?1.2:1));}function f(t,e,i,o,r,a,n){for(var s=0;s<e;s++){for(var l=0;l<i;l++)o[l]=t[l*e+s];for(m(o,r,a,n,i),l=0;l<i;l++)t[l*e+s]=r[l];}for(l=0;l<i;l++){for(s=0;s<e;s++)o[s]=t[l*e+s];for(m(o,r,a,n,e),s=0;s<e;s++)t[l*e+s]=Math.sqrt(r[s]);}}function m(t,e,i,o,r){i[0]=0,o[0]=-d,o[1]=+d;for(var a=1,n=0;a<r;a++){for(var s=(t[a]+a*a-(t[i[n]]+i[n]*i[n]))/(2*a-2*i[n]);s<=o[n];)n--,s=(t[a]+a*a-(t[i[n]]+i[n]*i[n]))/(2*a-2*i[n]);i[++n]=a,o[n]=s,o[n+1]=+d;}for(a=0,n=0;a<r;a++){for(;o[n+1]<a;)n++;e[a]=(a-i[n])*(a-i[n])+t[i[n]];}}_.prototype.draw=function(t){this.ctx.clearRect(0,0,this.size,this.size),this.ctx.fillText(t,this.buffer,this.middle);for(var e=this.ctx.getImageData(0,0,this.size,this.size),i=new Uint8ClampedArray(this.size*this.size),o=0;o<this.size*this.size;o++){var r=e.data[4*o+3]/255;this.gridOuter[o]=1===r?0:0===r?d:Math.pow(Math.max(0,.5-r),2),this.gridInner[o]=1===r?d:0===r?0:Math.pow(Math.max(0,r-.5),2);}for(f(this.gridOuter,this.size,this.size,this.f,this.d,this.v,this.z),f(this.gridInner,this.size,this.size,this.f,this.d,this.v,this.z),o=0;o<this.size*this.size;o++){var a=this.gridOuter[o]-this.gridInner[o];i[o]=Math.max(0,Math.min(255,Math.round(255-255*(a/this.radius+this.cutoff))));}return i};var g=function(t,e){this.requestTransform=t,this.localIdeographFontFamily=e,this.entries={};};g.prototype.setURL=function(t){this.url=t;},g.prototype.getGlyphs=function(e,i){var o=this,r=[];for(var a in e)for(var n=0,s=e[a];n<s.length;n+=1){var l=s[n];r.push({stack:a,id:l});}t.asyncAll(r,function(t,e){var i=t.stack,r=t.id,a=o.entries[i];a||(a=o.entries[i]={glyphs:{},requests:{}});var n=a.glyphs[r];if(void 0===n)if(n=o._tinySDF(a,i,r))e(null,{stack:i,id:r,glyph:n});else{var s=Math.floor(r/256);if(256*s>65535)e(new Error("glyphs > 65535 not supported"));else{var l=a.requests[s];l||(l=a.requests[s]=[],g.loadGlyphRange(i,s,o.url,o.requestTransform,function(t,e){if(e)for(var i in e)a.glyphs[+i]=e[+i];for(var o=0,r=l;o<r.length;o+=1){(0,r[o])(t,e);}delete a.requests[s];})),l.push(function(t,o){t?e(t):o&&e(null,{stack:i,id:r,glyph:o[r]||null});});}}else e(null,{stack:i,id:r,glyph:n});},function(t,e){if(t)i(t);else if(e){for(var o={},r=0,a=e;r<a.length;r+=1){var n=a[r],s=n.stack,l=n.id,c=n.glyph;(o[s]||(o[s]={}))[l]=c&&{id:c.id,bitmap:c.bitmap.clone(),metrics:c.metrics};}i(null,o);}});},g.prototype._tinySDF=function(e,i,o){var r=this.localIdeographFontFamily;if(r&&(t.isChar["CJK Unified Ideographs"](o)||t.isChar["Hangul Syllables"](o))){var a=e.tinySDF;if(!a){var n="400";/bold/i.test(i)?n="900":/medium/i.test(i)?n="500":/light/i.test(i)&&(n="200"),a=e.tinySDF=new g.TinySDF(24,3,8,.25,r,n);}return {id:o,bitmap:new t.AlphaImage({width:30,height:30},a.draw(String.fromCharCode(o))),metrics:{width:24,height:24,left:0,top:-8,advance:24}}}},g.loadGlyphRange=function(e,i,o,r,a){var n=256*i,s=n+255,l=r(t.normalizeGlyphsURL(o).replace("{fontstack}",e).replace("{range}",n+"-"+s),t.ResourceType.Glyphs);t.getArrayBuffer(l,function(e,i){if(e)a(e);else if(i){for(var o={},r=0,n=t.parseGlyphPBF(i);r<n.length;r+=1){var s=n[r];o[s.id]=s;}a(null,o);}});},g.TinySDF=p;var v=function(){this.specification=t.styleSpec.light.position;};v.prototype.possiblyEvaluate=function(e,i){return t.sphericalToCartesian(e.expression.evaluate(i))},v.prototype.interpolate=function(e,i,o){return {x:t.number(e.x,i.x,o),y:t.number(e.y,i.y,o),z:t.number(e.z,i.z,o)}};var y=new t.Properties({anchor:new t.DataConstantProperty(t.styleSpec.light.anchor),position:new v,color:new t.DataConstantProperty(t.styleSpec.light.color),intensity:new t.DataConstantProperty(t.styleSpec.light.intensity)}),x=function(e){function i(i){e.call(this),this._transitionable=new t.Transitionable(y),this.setLight(i),this._transitioning=this._transitionable.untransitioned();}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getLight=function(){return this._transitionable.serialize()},i.prototype.setLight=function(e,i){if(void 0===i&&(i={}),!this._validate(t.validateLight,e,i))for(var o in e){var r=e[o];t.endsWith(o,"-transition")?this._transitionable.setTransition(o.slice(0,-"-transition".length),r):this._transitionable.setValue(o,r);}},i.prototype.updateTransitions=function(t){this._transitioning=this._transitionable.transitioned(t,this._transitioning);},i.prototype.hasTransition=function(){return this._transitioning.hasTransition()},i.prototype.recalculate=function(t){this.properties=this._transitioning.possiblyEvaluate(t);},i.prototype._validate=function(e,i,o){return (!o||!1!==o.validate)&&t.emitValidationErrors(this,e.call(t.validateStyle,t.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:t.styleSpec})))},i}(t.Evented),b=function(t,e){this.width=t,this.height=e,this.nextRow=0,this.bytes=4,this.data=new Uint8Array(this.width*this.height*this.bytes),this.positions={};};b.prototype.getDash=function(t,e){var i=t.join(",")+String(e);return this.positions[i]||(this.positions[i]=this.addDash(t,e)),this.positions[i]},b.prototype.addDash=function(e,i){var o=i?7:0,r=2*o+1;if(this.nextRow+r>this.height)return t.warnOnce("LineAtlas out of space"),null;for(var a=0,n=0;n<e.length;n++)a+=e[n];for(var s=this.width/a,l=s/2,c=e.length%2==1,u=-o;u<=o;u++)for(var h=this.nextRow+o+u,p=this.width*h,d=c?-e[e.length-1]:0,_=e[0],f=1,m=0;m<this.width;m++){for(;_<m/s;)d=_,_+=e[f],c&&f===e.length-1&&(_+=e[0]),f++;var g=Math.abs(m-d*s),v=Math.abs(m-_*s),y=Math.min(g,v),x=f%2==1,b=void 0;if(i){var w=o?u/o*(l+1):0;if(x){var E=l-Math.abs(w);b=Math.sqrt(y*y+E*E);}else b=l-Math.sqrt(y*y+w*w);}else b=(x?1:-1)*y;this.data[3+4*(p+m)]=Math.max(0,Math.min(255,b+128));}var T={y:(this.nextRow+o+.5)/this.height,height:2*o/this.height,width:a};return this.nextRow+=r,this.dirty=!0,T},b.prototype.bind=function(t){var e=t.gl;this.texture?(e.bindTexture(e.TEXTURE_2D,this.texture),this.dirty&&(this.dirty=!1,e.texSubImage2D(e.TEXTURE_2D,0,0,0,this.width,this.height,e.RGBA,e.UNSIGNED_BYTE,this.data))):(this.texture=e.createTexture(),e.bindTexture(e.TEXTURE_2D,this.texture),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,e.LINEAR),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,e.LINEAR),e.texImage2D(e.TEXTURE_2D,0,e.RGBA,this.width,this.height,0,e.RGBA,e.UNSIGNED_BYTE,this.data));};var w=function e(i,o){this.workerPool=i,this.actors=[],this.currentActor=0,this.id=t.uniqueId();for(var r=this.workerPool.acquire(this.id),a=0;a<r.length;a++){var n=r[a],s=new e.Actor(n,o,this.id);s.name="Worker "+a,this.actors.push(s);}};function E(e,i,o){var r=function(i,r){if(i)return o(i);if(r){var a=t.pick(r,["tiles","minzoom","maxzoom","attribution","mapbox_logo","bounds"]);r.vector_layers&&(a.vectorLayers=r.vector_layers,a.vectorLayerIds=a.vectorLayers.map(function(t){return t.id})),e.url&&(a.tiles=t.canonicalizeTileset(a,e.url)),o(null,a);}};return e.url?t.getJSON(i(t.normalizeSourceURL(e.url),t.ResourceType.Source),r):t.browser.frame(function(){return r(null,e)})}w.prototype.broadcast=function(e,i,o){o=o||function(){},t.asyncAll(this.actors,function(t,o){t.send(e,i,o);},o);},w.prototype.send=function(t,e,i,o){return ("number"!=typeof o||isNaN(o))&&(o=this.currentActor=(this.currentActor+1)%this.actors.length),this.actors[o].send(t,e,i),o},w.prototype.remove=function(){this.actors.forEach(function(t){t.remove();}),this.actors=[],this.workerPool.release(this.id);},w.Actor=t.Actor;var T=function(e,i,o){this.bounds=t.LngLatBounds.convert(this.validateBounds(e)),this.minzoom=i||0,this.maxzoom=o||24;};T.prototype.validateBounds=function(t){return Array.isArray(t)&&4===t.length?[Math.max(-180,t[0]),Math.max(-90,t[1]),Math.min(180,t[2]),Math.min(90,t[3])]:[-180,-90,180,90]},T.prototype.contains=function(e){var i=Math.pow(2,e.z),o=Math.floor(t.mercatorXfromLng(this.bounds.getWest())*i),r=Math.floor(t.mercatorYfromLat(this.bounds.getNorth())*i),a=Math.ceil(t.mercatorXfromLng(this.bounds.getEast())*i),n=Math.ceil(t.mercatorYfromLat(this.bounds.getSouth())*i);return e.x>=o&&e.x<a&&e.y>=r&&e.y<n};var I=function(e){function i(i,o,r,a){if(e.call(this),this.id=i,this.dispatcher=r,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,t.extend(this,t.pick(o,["url","scheme","tileSize"])),this._options=t.extend({type:"vector"},o),this._collectResourceTiming=o.collectResourceTiming,512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(a);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=E(this._options,this.map._transformRequest,function(i,o){e._tileJSONRequest=null,i?e.fire(new t.ErrorEvent(i)):o&&(t.extend(e,o),o.bounds&&(e.tileBounds=new T(o.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(o.tiles),t.postMapLoadEvent(o.tiles,e.map._getMapId()),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));});},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.loadTile=function(e,i){var o=t.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.url),r={request:this.map._transformRequest(o,t.ResourceType.Tile),uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,tileSize:this.tileSize*e.tileID.overscaleFactor(),type:this.type,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes};function a(t,o){return e.aborted?i(null):t&&404!==t.status?i(t):(o&&o.resourceTiming&&(e.resourceTiming=o.resourceTiming),this.map._refreshExpiredTiles&&o&&e.setExpiryData(o),e.loadVectorData(o,this.map.painter),i(null),void(e.reloadCallback&&(this.loadTile(e,e.reloadCallback),e.reloadCallback=null)))}r.request.collectResourceTiming=this._collectResourceTiming,void 0===e.workerID||"expired"===e.state?e.workerID=this.dispatcher.send("loadTile",r,a.bind(this)):"loading"===e.state?e.reloadCallback=i:this.dispatcher.send("reloadTile",r,a.bind(this),e.workerID);},i.prototype.abortTile=function(t){this.dispatcher.send("abortTile",{uid:t.uid,type:this.type,source:this.id},void 0,t.workerID);},i.prototype.unloadTile=function(t){t.unloadVectorData(),this.dispatcher.send("removeTile",{uid:t.uid,type:this.type,source:this.id},void 0,t.workerID);},i.prototype.hasTransition=function(){return !1},i}(t.Evented),C=function(e){function i(i,o,r,a){e.call(this),this.id=i,this.dispatcher=r,this.setEventedParent(a),this.type="raster",this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,this._options=t.extend({},o),t.extend(this,t.pick(o,["url","scheme","tileSize"]));}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=E(this._options,this.map._transformRequest,function(i,o){e._tileJSONRequest=null,i?e.fire(new t.ErrorEvent(i)):o&&(t.extend(e,o),o.bounds&&(e.tileBounds=new T(o.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(o.tiles),t.postMapLoadEvent(o.tiles,e.map._getMapId()),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));});},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.loadTile=function(e,i){var o=this,r=t.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.url,this.tileSize);e.request=t.getImage(this.map._transformRequest(r,t.ResourceType.Tile),function(r,a){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(r)e.state="errored",i(r);else if(a){o.map._refreshExpiredTiles&&e.setExpiryData(a),delete a.cacheControl,delete a.expires;var n=o.map.painter.context,s=n.gl;e.texture=o.map.painter.getTileTexture(a.width),e.texture?e.texture.update(a,{useMipmap:!0}):(e.texture=new t.Texture(n,a,s.RGBA,{useMipmap:!0}),e.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE,s.LINEAR_MIPMAP_NEAREST),n.extTextureFilterAnisotropic&&s.texParameterf(s.TEXTURE_2D,n.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,n.extTextureFilterAnisotropicMax)),e.state="loaded",i(null);}});},i.prototype.abortTile=function(t,e){t.request&&(t.request.cancel(),delete t.request),e();},i.prototype.unloadTile=function(t,e){t.texture&&this.map.painter.saveTileTexture(t.texture),e();},i.prototype.hasTransition=function(){return !1},i}(t.Evented),S=function(e){function i(i,o,r,a){e.call(this,i,o,r,a),this.type="raster-dem",this.maxzoom=22,this._options=t.extend({},o),this.encoding=o.encoding||"mapbox";}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.serialize=function(){return {type:"raster-dem",url:this.url,tileSize:this.tileSize,tiles:this.tiles,bounds:this.bounds,encoding:this.encoding}},i.prototype.loadTile=function(e,i){var o=t.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.url,this.tileSize);e.request=t.getImage(this.map._transformRequest(o,t.ResourceType.Tile),function(o,r){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(o)e.state="errored",i(o);else if(r){this.map._refreshExpiredTiles&&e.setExpiryData(r),delete r.cacheControl,delete r.expires;var a=t.browser.getImageData(r),n={uid:e.uid,coord:e.tileID,source:this.id,rawImageData:a,encoding:this.encoding};e.workerID&&"expired"!==e.state||(e.workerID=this.dispatcher.send("loadDEMTile",n,function(t,o){t&&(e.state="errored",i(t));o&&(e.dem=o,e.needsHillshadePrepare=!0,e.state="loaded",i(null));}.bind(this)));}}.bind(this)),e.neighboringTiles=this._getNeighboringTiles(e.tileID);},i.prototype._getNeighboringTiles=function(e){var i=e.canonical,o=Math.pow(2,i.z),r=(i.x-1+o)%o,a=0===i.x?e.wrap-1:e.wrap,n=(i.x+1+o)%o,s=i.x+1===o?e.wrap+1:e.wrap,l={};return l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y).key]={backfilled:!1},i.y>0&&(l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y-1).key]={backfilled:!1}),i.y+1<o&&(l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y+1).key]={backfilled:!1}),l},i.prototype.unloadTile=function(t){t.demTexture&&this.map.painter.saveTileTexture(t.demTexture),t.fbo&&(t.fbo.destroy(),delete t.fbo),t.dem&&delete t.dem,delete t.neighboringTiles,t.state="unloaded",this.dispatcher.send("removeDEMTile",{uid:t.uid,source:this.id},void 0,t.workerID);},i}(C),z=function(e){function i(i,o,r,a){e.call(this),this.id=i,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this._removed=!1,this.dispatcher=r,this.setEventedParent(a),this._data=o.data,this._options=t.extend({},o),this._collectResourceTiming=o.collectResourceTiming,this._resourceTiming=[],void 0!==o.maxzoom&&(this.maxzoom=o.maxzoom),o.type&&(this.type=o.type),o.attribution&&(this.attribution=o.attribution);var n=t.EXTENT/this.tileSize;this.workerOptions=t.extend({source:this.id,cluster:o.cluster||!1,geojsonVtOptions:{buffer:(void 0!==o.buffer?o.buffer:128)*n,tolerance:(void 0!==o.tolerance?o.tolerance:.375)*n,extent:t.EXTENT,maxZoom:this.maxzoom,lineMetrics:o.lineMetrics||!1,generateId:o.generateId||!1},superclusterOptions:{maxZoom:void 0!==o.clusterMaxZoom?Math.min(o.clusterMaxZoom,this.maxzoom-1):this.maxzoom-1,extent:t.EXTENT,radius:(o.clusterRadius||50)*n,log:!1},clusterProperties:o.clusterProperties},o.workerOptions);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData(function(i){if(i)e.fire(new t.ErrorEvent(i));else{var o={dataType:"source",sourceDataType:"metadata"};e._collectResourceTiming&&e._resourceTiming&&e._resourceTiming.length>0&&(o.resourceTiming=e._resourceTiming,e._resourceTiming=[]),e.fire(new t.Event("data",o));}});},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setData=function(e){var i=this;return this._data=e,this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData(function(e){if(e)i.fire(new t.ErrorEvent(e));else{var o={dataType:"source",sourceDataType:"content"};i._collectResourceTiming&&i._resourceTiming&&i._resourceTiming.length>0&&(o.resourceTiming=i._resourceTiming,i._resourceTiming=[]),i.fire(new t.Event("data",o));}}),this},i.prototype.getClusterExpansionZoom=function(t,e){return this.dispatcher.send("geojson.getClusterExpansionZoom",{clusterId:t,source:this.id},e,this.workerID),this},i.prototype.getClusterChildren=function(t,e){return this.dispatcher.send("geojson.getClusterChildren",{clusterId:t,source:this.id},e,this.workerID),this},i.prototype.getClusterLeaves=function(t,e,i,o){return this.dispatcher.send("geojson.getClusterLeaves",{source:this.id,clusterId:t,limit:e,offset:i},o,this.workerID),this},i.prototype._updateWorkerData=function(e){var i=this,o=t.extend({},this.workerOptions),r=this._data;"string"==typeof r?(o.request=this.map._transformRequest(t.browser.resolveURL(r),t.ResourceType.Source),o.request.collectResourceTiming=this._collectResourceTiming):o.data=JSON.stringify(r),this.workerID=this.dispatcher.send(this.type+".loadData",o,function(t,r){i._removed||r&&r.abandoned||(i._loaded=!0,r&&r.resourceTiming&&r.resourceTiming[i.id]&&(i._resourceTiming=r.resourceTiming[i.id].slice(0)),i.dispatcher.send(i.type+".coalesce",{source:o.source},null,i.workerID),e(t));},this.workerID);},i.prototype.loadTile=function(e,i){var o=this,r=void 0===e.workerID?"loadTile":"reloadTile",a={type:this.type,uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes};e.workerID=this.dispatcher.send(r,a,function(t,a){return e.unloadVectorData(),e.aborted?i(null):t?i(t):(e.loadVectorData(a,o.map.painter,"reloadTile"===r),i(null))},this.workerID);},i.prototype.abortTile=function(t){t.aborted=!0;},i.prototype.unloadTile=function(t){t.unloadVectorData(),this.dispatcher.send("removeTile",{uid:t.uid,type:this.type,source:this.id},null,t.workerID);},i.prototype.onRemove=function(){this._removed=!0,this.dispatcher.send("removeSource",{type:this.type,source:this.id},null,this.workerID);},i.prototype.serialize=function(){return t.extend({},this._options,{type:this.type,data:this._data})},i.prototype.hasTransition=function(){return !1},i}(t.Evented),L=function(e){function i(t,i,o,r){e.call(this),this.id=t,this.dispatcher=o,this.coordinates=i.coordinates,this.type="image",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.tiles={},this.setEventedParent(r),this.options=i;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(e,i){var o=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this.url=this.options.url,t.getImage(this.map._transformRequest(this.url,t.ResourceType.Image),function(r,a){r?o.fire(new t.ErrorEvent(r)):a&&(o.image=a,e&&(o.coordinates=e),i&&i(),o._finishLoading());});},i.prototype.updateImage=function(t){var e=this;return this.image&&t.url?(this.options.url=t.url,this.load(t.coordinates,function(){e.texture=null;}),this):this},i.prototype._finishLoading=function(){this.map&&(this.setCoordinates(this.coordinates),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})));},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setCoordinates=function(e){var i=this;this.coordinates=e;var o=e.map(t.MercatorCoordinate.fromLngLat);this.tileID=function(e){for(var i=1/0,o=1/0,r=-1/0,a=-1/0,n=0,s=e;n<s.length;n+=1){var l=s[n];i=Math.min(i,l.x),o=Math.min(o,l.y),r=Math.max(r,l.x),a=Math.max(a,l.y);}var c=r-i,u=a-o,h=Math.max(c,u),p=Math.max(0,Math.floor(-Math.log(h)/Math.LN2)),d=Math.pow(2,p);return new t.CanonicalTileID(p,Math.floor((i+r)/2*d),Math.floor((o+a)/2*d))}(o),this.minzoom=this.maxzoom=this.tileID.z;var r=o.map(function(t){return i.tileID.getTilePoint(t)._round()});return this._boundsArray=new t.StructArrayLayout4i8,this._boundsArray.emplaceBack(r[0].x,r[0].y,0,0),this._boundsArray.emplaceBack(r[1].x,r[1].y,t.EXTENT,0),this._boundsArray.emplaceBack(r[3].x,r[3].y,0,t.EXTENT),this._boundsArray.emplaceBack(r[2].x,r[2].y,t.EXTENT,t.EXTENT),this.boundsBuffer&&(this.boundsBuffer.destroy(),delete this.boundsBuffer),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})),this},i.prototype.prepare=function(){if(0!==Object.keys(this.tiles).length&&this.image){var e=this.map.painter.context,i=e.gl;for(var o in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,t.rasterBoundsAttributes.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture||(this.texture=new t.Texture(e,this.image,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var r=this.tiles[o];"loaded"!==r.state&&(r.state="loaded",r.texture=this.texture);}}},i.prototype.loadTile=function(t,e){this.tileID&&this.tileID.equals(t.tileID.canonical)?(this.tiles[String(t.tileID.wrap)]=t,t.buckets={},e(null)):(t.state="errored",e(null));},i.prototype.serialize=function(){return {type:"image",url:this.options.url,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return !1},i}(t.Evented);var P={vector:I,raster:C,"raster-dem":S,geojson:z,video:function(e){function i(t,i,o,r){e.call(this,t,i,o,r),this.roundZoom=!0,this.type="video",this.options=i;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this,i=this.options;this.urls=[];for(var o=0,r=i.urls;o<r.length;o+=1){var a=r[o];this.urls.push(this.map._transformRequest(a,t.ResourceType.Source).url);}t.getVideo(this.urls,function(i,o){i?e.fire(new t.ErrorEvent(i)):o&&(e.video=o,e.video.loop=!0,e.video.addEventListener("playing",function(){e.map.triggerRepaint();}),e.map&&e.video.play(),e._finishLoading());});},i.prototype.getVideo=function(){return this.video},i.prototype.onAdd=function(t){this.map||(this.map=t,this.load(),this.video&&(this.video.play(),this.setCoordinates(this.coordinates)));},i.prototype.prepare=function(){if(!(0===Object.keys(this.tiles).length||this.video.readyState<2)){var e=this.map.painter.context,i=e.gl;for(var o in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,t.rasterBoundsAttributes.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?this.video.paused||(this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE),i.texSubImage2D(i.TEXTURE_2D,0,0,0,i.RGBA,i.UNSIGNED_BYTE,this.video)):(this.texture=new t.Texture(e,this.video,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var r=this.tiles[o];"loaded"!==r.state&&(r.state="loaded",r.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"video",urls:this.urls,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this.video&&!this.video.paused},i}(L),image:L,canvas:function(e){function i(i,o,r,a){e.call(this,i,o,r,a),o.coordinates?Array.isArray(o.coordinates)&&4===o.coordinates.length&&!o.coordinates.some(function(t){return !Array.isArray(t)||2!==t.length||t.some(function(t){return "number"!=typeof t})})||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"coordinates" property must be an array of 4 longitude/latitude array pairs'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "coordinates"'))),o.animate&&"boolean"!=typeof o.animate&&this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'optional "animate" property must be a boolean value'))),o.canvas?"string"==typeof o.canvas||o.canvas instanceof t.window.HTMLCanvasElement||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "canvas"'))),this.options=o,this.animate=void 0===o.animate||o.animate;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){this.canvas||(this.canvas=this.options.canvas instanceof t.window.HTMLCanvasElement?this.options.canvas:t.window.document.getElementById(this.options.canvas)),this.width=this.canvas.width,this.height=this.canvas.height,this._hasInvalidDimensions()?this.fire(new t.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))):(this.play=function(){this._playing=!0,this.map.triggerRepaint();},this.pause=function(){this._playing=!1;},this._finishLoading());},i.prototype.getCanvas=function(){return this.canvas},i.prototype.onAdd=function(t){this.map=t,this.load(),this.canvas&&this.animate&&this.play();},i.prototype.onRemove=function(){this.pause();},i.prototype.prepare=function(){var e=!1;if(this.canvas.width!==this.width&&(this.width=this.canvas.width,e=!0),this.canvas.height!==this.height&&(this.height=this.canvas.height,e=!0),!this._hasInvalidDimensions()&&0!==Object.keys(this.tiles).length){var i=this.map.painter.context,o=i.gl;for(var r in this.boundsBuffer||(this.boundsBuffer=i.createVertexBuffer(this._boundsArray,t.rasterBoundsAttributes.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?(e||this._playing)&&this.texture.update(this.canvas,{premultiply:!0}):this.texture=new t.Texture(i,this.canvas,o.RGBA,{premultiply:!0}),this.tiles){var a=this.tiles[r];"loaded"!==a.state&&(a.state="loaded",a.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"canvas",coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this._playing},i.prototype._hasInvalidDimensions=function(){for(var t=0,e=[this.canvas.width,this.canvas.height];t<e.length;t+=1){var i=e[t];if(isNaN(i)||i<=0)return !0}return !1},i}(L)},D=function(e,i,o,r){var a=new P[i.type](e,i,o,r);if(a.id!==e)throw new Error("Expected Source id to be "+e+" instead of "+a.id);return t.bindAll(["load","abort","unload","serialize","prepare"],a),a};function R(e,i){var o=t.identity([]);return t.translate(o,o,[1,1,0]),t.scale(o,o,[.5*e.width,.5*e.height,1]),t.multiply(o,o,e.calculatePosMatrix(i.toUnwrapped()))}function M(t,e,i,o,r){var a=function(t,e,i){if(t)for(var o=0,r=t;o<r.length;o+=1){var a=e[r[o]];if(a&&a.source===i&&"fill-extrusion"===a.type)return !0}else for(var n in e){var s=e[n];if(s.source===i&&"fill-extrusion"===s.type)return !0}return !1}(o&&o.layers,e,t.id),n=r.maxPitchScaleFactor(),s=t.tilesIn(i,n,a);s.sort(A);for(var l=[],c=0,u=s;c<u.length;c+=1){var h=u[c];l.push({wrappedTileID:h.tileID.wrapped().key,queryResults:h.tile.queryRenderedFeatures(e,t._state,h.queryGeometry,h.cameraQueryGeometry,h.scale,o,r,n,R(t.transform,h.tileID))});}var p=function(t){for(var e={},i={},o=0,r=t;o<r.length;o+=1){var a=r[o],n=a.queryResults,s=a.wrappedTileID,l=i[s]=i[s]||{};for(var c in n)for(var u=n[c],h=l[c]=l[c]||{},p=e[c]=e[c]||[],d=0,_=u;d<_.length;d+=1){var f=_[d];h[f.featureIndex]||(h[f.featureIndex]=!0,p.push(f));}}return e}(l);for(var d in p)p[d].forEach(function(e){var i=e.feature,o=t.getFeatureState(i.layer["source-layer"],i.id);i.source=i.layer.source,i.layer["source-layer"]&&(i.sourceLayer=i.layer["source-layer"]),i.state=o;});return p}function A(t,e){var i=t.tileID,o=e.tileID;return i.overscaledZ-o.overscaledZ||i.canonical.y-o.canonical.y||i.wrap-o.wrap||i.canonical.x-o.canonical.x}var k=function(t,e){this.max=t,this.onRemove=e,this.reset();};k.prototype.reset=function(){for(var t in this.data)for(var e=0,i=this.data[t];e<i.length;e+=1){var o=i[e];o.timeout&&clearTimeout(o.timeout),this.onRemove(o.value);}return this.data={},this.order=[],this},k.prototype.add=function(t,e,i){var o=this,r=t.wrapped().key;void 0===this.data[r]&&(this.data[r]=[]);var a={value:e,timeout:void 0};if(void 0!==i&&(a.timeout=setTimeout(function(){o.remove(t,a);},i)),this.data[r].push(a),this.order.push(r),this.order.length>this.max){var n=this._getAndRemoveByKey(this.order[0]);n&&this.onRemove(n);}return this},k.prototype.has=function(t){return t.wrapped().key in this.data},k.prototype.getAndRemove=function(t){return this.has(t)?this._getAndRemoveByKey(t.wrapped().key):null},k.prototype._getAndRemoveByKey=function(t){var e=this.data[t].shift();return e.timeout&&clearTimeout(e.timeout),0===this.data[t].length&&delete this.data[t],this.order.splice(this.order.indexOf(t),1),e.value},k.prototype.get=function(t){return this.has(t)?this.data[t.wrapped().key][0].value:null},k.prototype.remove=function(t,e){if(!this.has(t))return this;var i=t.wrapped().key,o=void 0===e?0:this.data[i].indexOf(e),r=this.data[i][o];return this.data[i].splice(o,1),r.timeout&&clearTimeout(r.timeout),0===this.data[i].length&&delete this.data[i],this.onRemove(r.value),this.order.splice(this.order.indexOf(i),1),this},k.prototype.setMaxSize=function(t){for(this.max=t;this.order.length>this.max;){var e=this._getAndRemoveByKey(this.order[0]);e&&this.onRemove(e);}return this};var B=function(t,e,i){this.context=t;var o=t.gl;this.buffer=o.createBuffer(),this.dynamicDraw=Boolean(i),this.context.unbindVAO(),t.bindElementBuffer.set(this.buffer),o.bufferData(o.ELEMENT_ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?o.DYNAMIC_DRAW:o.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};B.prototype.bind=function(){this.context.bindElementBuffer.set(this.buffer);},B.prototype.updateData=function(t){var e=this.context.gl;this.context.unbindVAO(),this.bind(),e.bufferSubData(e.ELEMENT_ARRAY_BUFFER,0,t.arrayBuffer);},B.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer);};var O={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT",Int32:"INT",Uint32:"UNSIGNED_INT",Float32:"FLOAT"},F=function(t,e,i,o){this.length=e.length,this.attributes=i,this.itemSize=e.bytesPerElement,this.dynamicDraw=o,this.context=t;var r=t.gl;this.buffer=r.createBuffer(),t.bindVertexBuffer.set(this.buffer),r.bufferData(r.ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?r.DYNAMIC_DRAW:r.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};F.prototype.bind=function(){this.context.bindVertexBuffer.set(this.buffer);},F.prototype.updateData=function(t){var e=this.context.gl;this.bind(),e.bufferSubData(e.ARRAY_BUFFER,0,t.arrayBuffer);},F.prototype.enableAttributes=function(t,e){for(var i=0;i<this.attributes.length;i++){var o=this.attributes[i],r=e.attributes[o.name];void 0!==r&&t.enableVertexAttribArray(r);}},F.prototype.setVertexAttribPointers=function(t,e,i){for(var o=0;o<this.attributes.length;o++){var r=this.attributes[o],a=e.attributes[r.name];void 0!==a&&t.vertexAttribPointer(a,r.components,t[O[r.type]],!1,this.itemSize,r.offset+this.itemSize*(i||0));}},F.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer);};var U=function(t){this.gl=t.gl,this.default=this.getDefault(),this.current=this.default,this.dirty=!1;};U.prototype.get=function(){return this.current},U.prototype.set=function(t){},U.prototype.getDefault=function(){return this.default},U.prototype.setDefault=function(){this.set(this.default);};var N=function(e){function i(){e.apply(this,arguments);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getDefault=function(){return t.Color.transparent},i.prototype.set=function(t){var e=this.current;(t.r!==e.r||t.g!==e.g||t.b!==e.b||t.a!==e.a||this.dirty)&&(this.gl.clearColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1);},i}(U),Z=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 1},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.clearDepth(t),this.current=t,this.dirty=!1);},e}(U),j=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.clearStencil(t),this.current=t,this.dirty=!1);},e}(U),V=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return [!0,!0,!0,!0]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||t[3]!==e[3]||this.dirty)&&(this.gl.colorMask(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1);},e}(U),q=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.depthMask(t),this.current=t,this.dirty=!1);},e}(U),G=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 255},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.stencilMask(t),this.current=t,this.dirty=!1);},e}(U),W=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return {func:this.gl.ALWAYS,ref:0,mask:255}},e.prototype.set=function(t){var e=this.current;(t.func!==e.func||t.ref!==e.ref||t.mask!==e.mask||this.dirty)&&(this.gl.stencilFunc(t.func,t.ref,t.mask),this.current=t,this.dirty=!1);},e}(U),X=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [t.KEEP,t.KEEP,t.KEEP]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||this.dirty)&&(this.gl.stencilOp(t[0],t[1],t[2]),this.current=t,this.dirty=!1);},e}(U),H=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.STENCIL_TEST):e.disable(e.STENCIL_TEST),this.current=t,this.dirty=!1;}},e}(U),K=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return [0,1]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||this.dirty)&&(this.gl.depthRange(t[0],t[1]),this.current=t,this.dirty=!1);},e}(U),Y=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.DEPTH_TEST):e.disable(e.DEPTH_TEST),this.current=t,this.dirty=!1;}},e}(U),J=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.LESS},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.depthFunc(t),this.current=t,this.dirty=!1);},e}(U),Q=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.BLEND):e.disable(e.BLEND),this.current=t,this.dirty=!1;}},e}(U),$=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [t.ONE,t.ZERO]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||this.dirty)&&(this.gl.blendFunc(t[0],t[1]),this.current=t,this.dirty=!1);},e}(U),tt=function(e){function i(){e.apply(this,arguments);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getDefault=function(){return t.Color.transparent},i.prototype.set=function(t){var e=this.current;(t.r!==e.r||t.g!==e.g||t.b!==e.b||t.a!==e.a||this.dirty)&&(this.gl.blendColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1);},i}(U),et=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.FUNC_ADD},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.blendEquation(t),this.current=t,this.dirty=!1);},e}(U),it=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.CULL_FACE):e.disable(e.CULL_FACE),this.current=t,this.dirty=!1;}},e}(U),ot=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.BACK},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.cullFace(t),this.current=t,this.dirty=!1);},e}(U),rt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.CCW},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.frontFace(t),this.current=t,this.dirty=!1);},e}(U),at=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.useProgram(t),this.current=t,this.dirty=!1);},e}(U),nt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.TEXTURE0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.activeTexture(t),this.current=t,this.dirty=!1);},e}(U),st=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [0,0,t.drawingBufferWidth,t.drawingBufferHeight]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||t[3]!==e[3]||this.dirty)&&(this.gl.viewport(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1);},e}(U),lt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindFramebuffer(e.FRAMEBUFFER,t),this.current=t,this.dirty=!1;}},e}(U),ct=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindRenderbuffer(e.RENDERBUFFER,t),this.current=t,this.dirty=!1;}},e}(U),ut=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindTexture(e.TEXTURE_2D,t),this.current=t,this.dirty=!1;}},e}(U),ht=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindBuffer(e.ARRAY_BUFFER,t),this.current=t,this.dirty=!1;}},e}(U),pt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){var e=this.gl;e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,t),this.current=t,this.dirty=!1;},e}(U),dt=function(t){function e(e){t.call(this,e),this.vao=e.extVertexArrayObject;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){this.vao&&(t!==this.current||this.dirty)&&(this.vao.bindVertexArrayOES(t),this.current=t,this.dirty=!1);},e}(U),_t=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 4},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_ALIGNMENT,t),this.current=t,this.dirty=!1;}},e}(U),ft=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,t),this.current=t,this.dirty=!1;}},e}(U),mt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,t),this.current=t,this.dirty=!1;}},e}(U),gt=function(t){function e(e,i){t.call(this,e),this.context=e,this.parent=i;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e}(U),vt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.setDirty=function(){this.dirty=!0;},e.prototype.set=function(t){if(t!==this.current||this.dirty){this.context.bindFramebuffer.set(this.parent);var e=this.gl;e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0),this.current=t,this.dirty=!1;}},e}(gt),yt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(t!==this.current||this.dirty){this.context.bindFramebuffer.set(this.parent);var e=this.gl;e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.RENDERBUFFER,t),this.current=t,this.dirty=!1;}},e}(gt),xt=function(t,e,i){this.context=t,this.width=e,this.height=i;var o=t.gl,r=this.framebuffer=o.createFramebuffer();this.colorAttachment=new vt(t,r),this.depthAttachment=new yt(t,r);};xt.prototype.destroy=function(){var t=this.context.gl,e=this.colorAttachment.get();e&&t.deleteTexture(e);var i=this.depthAttachment.get();i&&t.deleteRenderbuffer(i),t.deleteFramebuffer(this.framebuffer);};var bt=function(t,e,i){this.func=t,this.mask=e,this.range=i;};bt.ReadOnly=!1,bt.ReadWrite=!0,bt.disabled=new bt(519,bt.ReadOnly,[0,1]);var wt=function(t,e,i,o,r,a){this.test=t,this.ref=e,this.mask=i,this.fail=o,this.depthFail=r,this.pass=a;};wt.disabled=new wt({func:519,mask:0},0,0,7680,7680,7680);var Et=function(t,e,i){this.blendFunction=t,this.blendColor=e,this.mask=i;};Et.Replace=[1,0],Et.disabled=new Et(Et.Replace,t.Color.transparent,[!1,!1,!1,!1]),Et.unblended=new Et(Et.Replace,t.Color.transparent,[!0,!0,!0,!0]),Et.alphaBlended=new Et([1,771],t.Color.transparent,[!0,!0,!0,!0]);var Tt=function(t,e,i){this.enable=t,this.mode=e,this.frontFace=i;};Tt.disabled=new Tt(!1,1029,2305),Tt.backCCW=new Tt(!0,1029,2305);var It=function(t){this.gl=t,this.extVertexArrayObject=this.gl.getExtension("OES_vertex_array_object"),this.clearColor=new N(this),this.clearDepth=new Z(this),this.clearStencil=new j(this),this.colorMask=new V(this),this.depthMask=new q(this),this.stencilMask=new G(this),this.stencilFunc=new W(this),this.stencilOp=new X(this),this.stencilTest=new H(this),this.depthRange=new K(this),this.depthTest=new Y(this),this.depthFunc=new J(this),this.blend=new Q(this),this.blendFunc=new $(this),this.blendColor=new tt(this),this.blendEquation=new et(this),this.cullFace=new it(this),this.cullFaceSide=new ot(this),this.frontFace=new rt(this),this.program=new at(this),this.activeTexture=new nt(this),this.viewport=new st(this),this.bindFramebuffer=new lt(this),this.bindRenderbuffer=new ct(this),this.bindTexture=new ut(this),this.bindVertexBuffer=new ht(this),this.bindElementBuffer=new pt(this),this.bindVertexArrayOES=this.extVertexArrayObject&&new dt(this),this.pixelStoreUnpack=new _t(this),this.pixelStoreUnpackPremultiplyAlpha=new ft(this),this.pixelStoreUnpackFlipY=new mt(this),this.extTextureFilterAnisotropic=t.getExtension("EXT_texture_filter_anisotropic")||t.getExtension("MOZ_EXT_texture_filter_anisotropic")||t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.extTextureFilterAnisotropic&&(this.extTextureFilterAnisotropicMax=t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.extTextureHalfFloat=t.getExtension("OES_texture_half_float"),this.extTextureHalfFloat&&t.getExtension("OES_texture_half_float_linear");};It.prototype.setDirty=function(){this.clearColor.dirty=!0,this.clearDepth.dirty=!0,this.clearStencil.dirty=!0,this.colorMask.dirty=!0,this.depthMask.dirty=!0,this.stencilMask.dirty=!0,this.stencilFunc.dirty=!0,this.stencilOp.dirty=!0,this.stencilTest.dirty=!0,this.depthRange.dirty=!0,this.depthTest.dirty=!0,this.depthFunc.dirty=!0,this.blend.dirty=!0,this.blendFunc.dirty=!0,this.blendColor.dirty=!0,this.blendEquation.dirty=!0,this.cullFace.dirty=!0,this.cullFaceSide.dirty=!0,this.frontFace.dirty=!0,this.program.dirty=!0,this.activeTexture.dirty=!0,this.viewport.dirty=!0,this.bindFramebuffer.dirty=!0,this.bindRenderbuffer.dirty=!0,this.bindTexture.dirty=!0,this.bindVertexBuffer.dirty=!0,this.bindElementBuffer.dirty=!0,this.extVertexArrayObject&&(this.bindVertexArrayOES.dirty=!0),this.pixelStoreUnpack.dirty=!0,this.pixelStoreUnpackPremultiplyAlpha.dirty=!0,this.pixelStoreUnpackFlipY.dirty=!0;},It.prototype.createIndexBuffer=function(t,e){return new B(this,t,e)},It.prototype.createVertexBuffer=function(t,e,i){return new F(this,t,e,i)},It.prototype.createRenderbuffer=function(t,e,i){var o=this.gl,r=o.createRenderbuffer();return this.bindRenderbuffer.set(r),o.renderbufferStorage(o.RENDERBUFFER,t,e,i),this.bindRenderbuffer.set(null),r},It.prototype.createFramebuffer=function(t,e){return new xt(this,t,e)},It.prototype.clear=function(t){var e=t.color,i=t.depth,o=this.gl,r=0;e&&(r|=o.COLOR_BUFFER_BIT,this.clearColor.set(e),this.colorMask.set([!0,!0,!0,!0])),void 0!==i&&(r|=o.DEPTH_BUFFER_BIT,this.depthRange.set([0,1]),this.clearDepth.set(i),this.depthMask.set(!0)),o.clear(r);},It.prototype.setCullFace=function(t){!1===t.enable?this.cullFace.set(!1):(this.cullFace.set(!0),this.cullFaceSide.set(t.mode),this.frontFace.set(t.frontFace));},It.prototype.setDepthMode=function(t){t.func!==this.gl.ALWAYS||t.mask?(this.depthTest.set(!0),this.depthFunc.set(t.func),this.depthMask.set(t.mask),this.depthRange.set(t.range)):this.depthTest.set(!1);},It.prototype.setStencilMode=function(t){t.test.func!==this.gl.ALWAYS||t.mask?(this.stencilTest.set(!0),this.stencilMask.set(t.mask),this.stencilOp.set([t.fail,t.depthFail,t.pass]),this.stencilFunc.set({func:t.test.func,ref:t.ref,mask:t.test.mask})):this.stencilTest.set(!1);},It.prototype.setColorMode=function(e){t.isEqual(e.blendFunction,Et.Replace)?this.blend.set(!1):(this.blend.set(!0),this.blendFunc.set(e.blendFunction),this.blendColor.set(e.blendColor)),this.colorMask.set(e.mask);},It.prototype.unbindVAO=function(){this.extVertexArrayObject&&this.bindVertexArrayOES.set(null);};var Ct=function(e){function i(i,o,r){var a=this;e.call(this),this.id=i,this.dispatcher=r,this.on("data",function(t){"source"===t.dataType&&"metadata"===t.sourceDataType&&(a._sourceLoaded=!0),a._sourceLoaded&&!a._paused&&"source"===t.dataType&&"content"===t.sourceDataType&&(a.reload(),a.transform&&a.update(a.transform));}),this.on("error",function(){a._sourceErrored=!0;}),this._source=D(i,o,r,this),this._tiles={},this._cache=new k(0,this._unloadTile.bind(this)),this._timers={},this._cacheTimers={},this._maxTileCacheSize=null,this._coveredTiles={},this._state=new t.SourceFeatureState;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.onAdd=function(t){this.map=t,this._maxTileCacheSize=t?t._maxTileCacheSize:null,this._source&&this._source.onAdd&&this._source.onAdd(t);},i.prototype.onRemove=function(t){this._source&&this._source.onRemove&&this._source.onRemove(t);},i.prototype.loaded=function(){if(this._sourceErrored)return !0;if(!this._sourceLoaded)return !1;for(var t in this._tiles){var e=this._tiles[t];if("loaded"!==e.state&&"errored"!==e.state)return !1}return !0},i.prototype.getSource=function(){return this._source},i.prototype.pause=function(){this._paused=!0;},i.prototype.resume=function(){if(this._paused){var t=this._shouldReloadOnResume;this._paused=!1,this._shouldReloadOnResume=!1,t&&this.reload(),this.transform&&this.update(this.transform);}},i.prototype._loadTile=function(t,e){return this._source.loadTile(t,e)},i.prototype._unloadTile=function(t){if(this._source.unloadTile)return this._source.unloadTile(t,function(){})},i.prototype._abortTile=function(t){if(this._source.abortTile)return this._source.abortTile(t,function(){})},i.prototype.serialize=function(){return this._source.serialize()},i.prototype.prepare=function(t){for(var e in this._source.prepare&&this._source.prepare(),this._state.coalesceChanges(this._tiles,this.map?this.map.painter:null),this._tiles)this._tiles[e].upload(t);},i.prototype.getIds=function(){return Object.keys(this._tiles).map(Number).sort(St)},i.prototype.getRenderableIds=function(e){var i=this,o=[];for(var r in this._tiles)this._isIdRenderable(+r,e)&&o.push(+r);return e?o.sort(function(e,o){var r=i._tiles[e].tileID,a=i._tiles[o].tileID,n=new t.Point(r.canonical.x,r.canonical.y)._rotate(i.transform.angle),s=new t.Point(a.canonical.x,a.canonical.y)._rotate(i.transform.angle);return r.overscaledZ-a.overscaledZ||s.y-n.y||s.x-n.x}):o.sort(St)},i.prototype.hasRenderableParent=function(t){var e=this.findLoadedParent(t,0);return !!e&&this._isIdRenderable(e.tileID.key)},i.prototype._isIdRenderable=function(t,e){return this._tiles[t]&&this._tiles[t].hasData()&&!this._coveredTiles[t]&&(e||!this._tiles[t].holdingForFade())},i.prototype.reload=function(){if(this._paused)this._shouldReloadOnResume=!0;else for(var t in this._cache.reset(),this._tiles)"errored"!==this._tiles[t].state&&this._reloadTile(t,"reloading");},i.prototype._reloadTile=function(t,e){var i=this._tiles[t];i&&("loading"!==i.state&&(i.state=e),this._loadTile(i,this._tileLoaded.bind(this,i,t,e)));},i.prototype._tileLoaded=function(e,i,o,r){if(r)return e.state="errored",void(404!==r.status?this._source.fire(new t.ErrorEvent(r,{tile:e})):this.update(this.transform));e.timeAdded=t.browser.now(),"expired"===o&&(e.refreshedUponExpiration=!0),this._setTileReloadTimer(i,e),"raster-dem"===this.getSource().type&&e.dem&&this._backfillDEM(e),this._state.initializeTileState(e,this.map?this.map.painter:null),this._source.fire(new t.Event("data",{dataType:"source",tile:e,coord:e.tileID}));},i.prototype._backfillDEM=function(t){for(var e=this.getRenderableIds(),i=0;i<e.length;i++){var o=e[i];if(t.neighboringTiles&&t.neighboringTiles[o]){var r=this.getTileByID(o);a(t,r),a(r,t);}}function a(t,e){t.needsHillshadePrepare=!0;var i=e.tileID.canonical.x-t.tileID.canonical.x,o=e.tileID.canonical.y-t.tileID.canonical.y,r=Math.pow(2,t.tileID.canonical.z),a=e.tileID.key;0===i&&0===o||Math.abs(o)>1||(Math.abs(i)>1&&(1===Math.abs(i+r)?i+=r:1===Math.abs(i-r)&&(i-=r)),e.dem&&t.dem&&(t.dem.backfillBorder(e.dem,i,o),t.neighboringTiles&&t.neighboringTiles[a]&&(t.neighboringTiles[a].backfilled=!0)));}},i.prototype.getTile=function(t){return this.getTileByID(t.key)},i.prototype.getTileByID=function(t){return this._tiles[t]},i.prototype.getZoom=function(t){return t.zoom+t.scaleZoom(t.tileSize/this._source.tileSize)},i.prototype._retainLoadedChildren=function(t,e,i,o){for(var r in this._tiles){var a=this._tiles[r];if(!(o[r]||!a.hasData()||a.tileID.overscaledZ<=e||a.tileID.overscaledZ>i)){for(var n=a.tileID;a&&a.tileID.overscaledZ>e+1;){var s=a.tileID.scaledTo(a.tileID.overscaledZ-1);(a=this._tiles[s.key])&&a.hasData()&&(n=s);}for(var l=n;l.overscaledZ>e;)if(t[(l=l.scaledTo(l.overscaledZ-1)).key]){o[n.key]=n;break}}}},i.prototype.findLoadedParent=function(t,e){for(var i=t.overscaledZ-1;i>=e;i--){var o=t.scaledTo(i);if(!o)return;var r=String(o.key),a=this._tiles[r];if(a&&a.hasData())return a;if(this._cache.has(o))return this._cache.get(o)}},i.prototype.updateCacheSize=function(t){var e=(Math.ceil(t.width/this._source.tileSize)+1)*(Math.ceil(t.height/this._source.tileSize)+1),i=Math.floor(5*e),o="number"==typeof this._maxTileCacheSize?Math.min(this._maxTileCacheSize,i):i;this._cache.setMaxSize(o);},i.prototype.handleWrapJump=function(t){var e=(t-(void 0===this._prevLng?t:this._prevLng))/360,i=Math.round(e);if(this._prevLng=t,i){var o={};for(var r in this._tiles){var a=this._tiles[r];a.tileID=a.tileID.unwrapTo(a.tileID.wrap+i),o[a.tileID.key]=a;}for(var n in this._tiles=o,this._timers)clearTimeout(this._timers[n]),delete this._timers[n];for(var s in this._tiles){var l=this._tiles[s];this._setTileReloadTimer(s,l);}}},i.prototype.update=function(e){var o=this;if(this.transform=e,this._sourceLoaded&&!this._paused){var r;this.updateCacheSize(e),this.handleWrapJump(this.transform.center.lng),this._coveredTiles={},this.used?this._source.tileID?r=e.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(e){return new t.OverscaledTileID(e.canonical.z,e.wrap,e.canonical.z,e.canonical.x,e.canonical.y)}):(r=e.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}),this._source.hasTile&&(r=r.filter(function(t){return o._source.hasTile(t)}))):r=[];var a=(this._source.roundZoom?Math.round:Math.floor)(this.getZoom(e)),n=Math.max(a-i.maxOverzooming,this._source.minzoom),s=Math.max(a+i.maxUnderzooming,this._source.minzoom),l=this._updateRetainedTiles(r,a);if(zt(this._source.type)){for(var c={},u={},h=0,p=Object.keys(l);h<p.length;h+=1){var d=p[h],_=l[d],f=this._tiles[d];if(f&&!(f.fadeEndTime&&f.fadeEndTime<=t.browser.now())){var m=this.findLoadedParent(_,n);m&&(this._addTile(m.tileID),c[m.tileID.key]=m.tileID),u[d]=_;}}for(var g in this._retainLoadedChildren(u,a,s,l),c)l[g]||(this._coveredTiles[g]=!0,l[g]=c[g]);}for(var v in l)this._tiles[v].clearFadeHold();for(var y=0,x=t.keysDifference(this._tiles,l);y<x.length;y+=1){var b=x[y],w=this._tiles[b];w.hasSymbolBuckets&&!w.holdingForFade()?w.setHoldDuration(this.map._fadeDuration):w.hasSymbolBuckets&&!w.symbolFadeFinished()||this._removeTile(b);}}},i.prototype.releaseSymbolFadeTiles=function(){for(var t in this._tiles)this._tiles[t].holdingForFade()&&this._removeTile(t);},i.prototype._updateRetainedTiles=function(t,e){for(var o={},r={},a=Math.max(e-i.maxOverzooming,this._source.minzoom),n=Math.max(e+i.maxUnderzooming,this._source.minzoom),s={},l=0,c=t;l<c.length;l+=1){var u=c[l],h=this._addTile(u);o[u.key]=u,h.hasData()||e<this._source.maxzoom&&(s[u.key]=u);}this._retainLoadedChildren(s,e,n,o);for(var p=0,d=t;p<d.length;p+=1){var _=d[p],f=this._tiles[_.key];if(!f.hasData()){if(e+1>this._source.maxzoom){var m=_.children(this._source.maxzoom)[0],g=this.getTile(m);if(g&&g.hasData()){o[m.key]=m;continue}}else{var v=_.children(this._source.maxzoom);if(o[v[0].key]&&o[v[1].key]&&o[v[2].key]&&o[v[3].key])continue}for(var y=f.wasRequested(),x=_.overscaledZ-1;x>=a;--x){var b=_.scaledTo(x);if(r[b.key])break;if(r[b.key]=!0,!(f=this.getTile(b))&&y&&(f=this._addTile(b)),f&&(o[b.key]=b,y=f.wasRequested(),f.hasData()))break}}}return o},i.prototype._addTile=function(e){var i=this._tiles[e.key];if(i)return i;(i=this._cache.getAndRemove(e))&&(this._setTileReloadTimer(e.key,i),i.tileID=e,this._state.initializeTileState(i,this.map?this.map.painter:null),this._cacheTimers[e.key]&&(clearTimeout(this._cacheTimers[e.key]),delete this._cacheTimers[e.key],this._setTileReloadTimer(e.key,i)));var o=Boolean(i);return o||(i=new t.Tile(e,this._source.tileSize*e.overscaleFactor()),this._loadTile(i,this._tileLoaded.bind(this,i,e.key,i.state))),i?(i.uses++,this._tiles[e.key]=i,o||this._source.fire(new t.Event("dataloading",{tile:i,coord:i.tileID,dataType:"source"})),i):null},i.prototype._setTileReloadTimer=function(t,e){var i=this;t in this._timers&&(clearTimeout(this._timers[t]),delete this._timers[t]);var o=e.getExpiryTimeout();o&&(this._timers[t]=setTimeout(function(){i._reloadTile(t,"expired"),delete i._timers[t];},o));},i.prototype._removeTile=function(t){var e=this._tiles[t];e&&(e.uses--,delete this._tiles[t],this._timers[t]&&(clearTimeout(this._timers[t]),delete this._timers[t]),e.uses>0||(e.hasData()?this._cache.add(e.tileID,e,e.getExpiryTimeout()):(e.aborted=!0,this._abortTile(e),this._unloadTile(e))));},i.prototype.clearTiles=function(){for(var t in this._shouldReloadOnResume=!1,this._paused=!1,this._tiles)this._removeTile(t);this._cache.reset();},i.prototype.tilesIn=function(e,i,o){var r=this,a=[],n=this.transform;if(!n)return a;for(var s=o?n.getCameraQueryGeometry(e):e,l=e.map(function(t){return n.pointCoordinate(t)}),c=s.map(function(t){return n.pointCoordinate(t)}),u=this.getIds(),h=1/0,p=1/0,d=-1/0,_=-1/0,f=0,m=c;f<m.length;f+=1){var g=m[f];h=Math.min(h,g.x),p=Math.min(p,g.y),d=Math.max(d,g.x),_=Math.max(_,g.y);}for(var v=function(e){var o=r._tiles[u[e]];if(!o.holdingForFade()){var s=o.tileID,f=Math.pow(2,n.zoom-o.tileID.overscaledZ),m=i*o.queryPadding*t.EXTENT/o.tileSize/f,g=[s.getTilePoint(new t.MercatorCoordinate(h,p)),s.getTilePoint(new t.MercatorCoordinate(d,_))];if(g[0].x-m<t.EXTENT&&g[0].y-m<t.EXTENT&&g[1].x+m>=0&&g[1].y+m>=0){var v=l.map(function(t){return s.getTilePoint(t)}),y=c.map(function(t){return s.getTilePoint(t)});a.push({tile:o,tileID:s,queryGeometry:v,cameraQueryGeometry:y,scale:f});}}},y=0;y<u.length;y++)v(y);return a},i.prototype.getVisibleCoordinates=function(t){for(var e=this,i=this.getRenderableIds(t).map(function(t){return e._tiles[t].tileID}),o=0,r=i;o<r.length;o+=1){var a=r[o];a.posMatrix=this.transform.calculatePosMatrix(a.toUnwrapped());}return i},i.prototype.hasTransition=function(){if(this._source.hasTransition())return !0;if(zt(this._source.type))for(var e in this._tiles){var i=this._tiles[e];if(void 0!==i.fadeEndTime&&i.fadeEndTime>=t.browser.now())return !0}return !1},i.prototype.setFeatureState=function(t,e,i){t=t||"_geojsonTileLayer",this._state.updateState(t,e,i);},i.prototype.removeFeatureState=function(t,e,i){t=t||"_geojsonTileLayer",this._state.removeFeatureState(t,e,i);},i.prototype.getFeatureState=function(t,e){return t=t||"_geojsonTileLayer",this._state.getState(t,e)},i}(t.Evented);function St(t,e){return t%32-e%32||e-t}function zt(t){return "raster"===t||"image"===t||"video"===t}function Lt(){return new t.window.Worker(Qo.workerUrl)}Ct.maxOverzooming=10,Ct.maxUnderzooming=3;var Pt=function(){this.active={};};Pt.prototype.acquire=function(t){if(!this.workers)for(this.workers=[];this.workers.length<Pt.workerCount;)this.workers.push(new Lt);return this.active[t]=!0,this.workers.slice()},Pt.prototype.release=function(t){delete this.active[t],0===Object.keys(this.active).length&&(this.workers.forEach(function(t){t.terminate();}),this.workers=null);};var Dt,Rt=Math.floor(t.browser.hardwareConcurrency/2);function Mt(e,i){var o={};for(var r in e)"ref"!==r&&(o[r]=e[r]);return t.refProperties.forEach(function(t){t in i&&(o[t]=i[t]);}),o}function At(t){t=t.slice();for(var e=Object.create(null),i=0;i<t.length;i++)e[t[i].id]=t[i];for(var o=0;o<t.length;o++)"ref"in t[o]&&(t[o]=Mt(t[o],e[t[o].ref]));return t}Pt.workerCount=Math.max(Math.min(Rt,6),1);var kt={setStyle:"setStyle",addLayer:"addLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setGeoJSONSourceData:"setGeoJSONSourceData",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight"};function Bt(t,e,i){i.push({command:kt.addSource,args:[t,e[t]]});}function Ot(t,e,i){e.push({command:kt.removeSource,args:[t]}),i[t]=!0;}function Ft(t,e,i,o){Ot(t,i,o),Bt(t,e,i);}function Ut(e,i,o){var r;for(r in e[o])if(e[o].hasOwnProperty(r)&&"data"!==r&&!t.isEqual(e[o][r],i[o][r]))return !1;for(r in i[o])if(i[o].hasOwnProperty(r)&&"data"!==r&&!t.isEqual(e[o][r],i[o][r]))return !1;return !0}function Nt(e,i,o,r,a,n){var s;for(s in i=i||{},e=e||{})e.hasOwnProperty(s)&&(t.isEqual(e[s],i[s])||o.push({command:n,args:[r,s,i[s],a]}));for(s in i)i.hasOwnProperty(s)&&!e.hasOwnProperty(s)&&(t.isEqual(e[s],i[s])||o.push({command:n,args:[r,s,i[s],a]}));}function Zt(t){return t.id}function jt(t,e){return t[e.id]=e,t}function Vt(e,i){if(!e)return [{command:kt.setStyle,args:[i]}];var o=[];try{if(!t.isEqual(e.version,i.version))return [{command:kt.setStyle,args:[i]}];t.isEqual(e.center,i.center)||o.push({command:kt.setCenter,args:[i.center]}),t.isEqual(e.zoom,i.zoom)||o.push({command:kt.setZoom,args:[i.zoom]}),t.isEqual(e.bearing,i.bearing)||o.push({command:kt.setBearing,args:[i.bearing]}),t.isEqual(e.pitch,i.pitch)||o.push({command:kt.setPitch,args:[i.pitch]}),t.isEqual(e.sprite,i.sprite)||o.push({command:kt.setSprite,args:[i.sprite]}),t.isEqual(e.glyphs,i.glyphs)||o.push({command:kt.setGlyphs,args:[i.glyphs]}),t.isEqual(e.transition,i.transition)||o.push({command:kt.setTransition,args:[i.transition]}),t.isEqual(e.light,i.light)||o.push({command:kt.setLight,args:[i.light]});var r={},a=[];!function(e,i,o,r){var a;for(a in i=i||{},e=e||{})e.hasOwnProperty(a)&&(i.hasOwnProperty(a)||Ot(a,o,r));for(a in i)i.hasOwnProperty(a)&&(e.hasOwnProperty(a)?t.isEqual(e[a],i[a])||("geojson"===e[a].type&&"geojson"===i[a].type&&Ut(e,i,a)?o.push({command:kt.setGeoJSONSourceData,args:[a,i[a].data]}):Ft(a,i,o,r)):Bt(a,i,o));}(e.sources,i.sources,a,r);var n=[];e.layers&&e.layers.forEach(function(t){r[t.source]?o.push({command:kt.removeLayer,args:[t.id]}):n.push(t);}),o=o.concat(a),function(e,i,o){i=i||[];var r,a,n,s,l,c,u,h=(e=e||[]).map(Zt),p=i.map(Zt),d=e.reduce(jt,{}),_=i.reduce(jt,{}),f=h.slice(),m=Object.create(null);for(r=0,a=0;r<h.length;r++)n=h[r],_.hasOwnProperty(n)?a++:(o.push({command:kt.removeLayer,args:[n]}),f.splice(f.indexOf(n,a),1));for(r=0,a=0;r<p.length;r++)n=p[p.length-1-r],f[f.length-1-r]!==n&&(d.hasOwnProperty(n)?(o.push({command:kt.removeLayer,args:[n]}),f.splice(f.lastIndexOf(n,f.length-a),1)):a++,c=f[f.length-r],o.push({command:kt.addLayer,args:[_[n],c]}),f.splice(f.length-r,0,n),m[n]=!0);for(r=0;r<p.length;r++)if(s=d[n=p[r]],l=_[n],!m[n]&&!t.isEqual(s,l))if(t.isEqual(s.source,l.source)&&t.isEqual(s["source-layer"],l["source-layer"])&&t.isEqual(s.type,l.type)){for(u in Nt(s.layout,l.layout,o,n,null,kt.setLayoutProperty),Nt(s.paint,l.paint,o,n,null,kt.setPaintProperty),t.isEqual(s.filter,l.filter)||o.push({command:kt.setFilter,args:[n,l.filter]}),t.isEqual(s.minzoom,l.minzoom)&&t.isEqual(s.maxzoom,l.maxzoom)||o.push({command:kt.setLayerZoomRange,args:[n,l.minzoom,l.maxzoom]}),s)s.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?Nt(s[u],l[u],o,n,u.slice(6),kt.setPaintProperty):t.isEqual(s[u],l[u])||o.push({command:kt.setLayerProperty,args:[n,u,l[u]]}));for(u in l)l.hasOwnProperty(u)&&!s.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?Nt(s[u],l[u],o,n,u.slice(6),kt.setPaintProperty):t.isEqual(s[u],l[u])||o.push({command:kt.setLayerProperty,args:[n,u,l[u]]}));}else o.push({command:kt.removeLayer,args:[n]}),c=f[f.lastIndexOf(n)+1],o.push({command:kt.addLayer,args:[l,c]});}(n,i.layers,o);}catch(t){console.warn("Unable to compute style diff:",t),o=[{command:kt.setStyle,args:[i]}];}return o}var qt=function(t,e,i){var o=this.boxCells=[],r=this.circleCells=[];this.xCellCount=Math.ceil(t/i),this.yCellCount=Math.ceil(e/i);for(var a=0;a<this.xCellCount*this.yCellCount;a++)o.push([]),r.push([]);this.circleKeys=[],this.boxKeys=[],this.bboxes=[],this.circles=[],this.width=t,this.height=e,this.xScale=this.xCellCount/t,this.yScale=this.yCellCount/e,this.boxUid=0,this.circleUid=0;};qt.prototype.keysLength=function(){return this.boxKeys.length+this.circleKeys.length},qt.prototype.insert=function(t,e,i,o,r){this._forEachCell(e,i,o,r,this._insertBoxCell,this.boxUid++),this.boxKeys.push(t),this.bboxes.push(e),this.bboxes.push(i),this.bboxes.push(o),this.bboxes.push(r);},qt.prototype.insertCircle=function(t,e,i,o){this._forEachCell(e-o,i-o,e+o,i+o,this._insertCircleCell,this.circleUid++),this.circleKeys.push(t),this.circles.push(e),this.circles.push(i),this.circles.push(o);},qt.prototype._insertBoxCell=function(t,e,i,o,r,a){this.boxCells[r].push(a);},qt.prototype._insertCircleCell=function(t,e,i,o,r,a){this.circleCells[r].push(a);},qt.prototype._query=function(t,e,i,o,r,a){if(i<0||t>this.width||o<0||e>this.height)return !r&&[];var n=[];if(t<=0&&e<=0&&this.width<=i&&this.height<=o){if(r)return !0;for(var s=0;s<this.boxKeys.length;s++)n.push({key:this.boxKeys[s],x1:this.bboxes[4*s],y1:this.bboxes[4*s+1],x2:this.bboxes[4*s+2],y2:this.bboxes[4*s+3]});for(var l=0;l<this.circleKeys.length;l++){var c=this.circles[3*l],u=this.circles[3*l+1],h=this.circles[3*l+2];n.push({key:this.circleKeys[l],x1:c-h,y1:u-h,x2:c+h,y2:u+h});}return a?n.filter(a):n}var p={hitTest:r,seenUids:{box:{},circle:{}}};return this._forEachCell(t,e,i,o,this._queryCell,n,p,a),r?n.length>0:n},qt.prototype._queryCircle=function(t,e,i,o,r){var a=t-i,n=t+i,s=e-i,l=e+i;if(n<0||a>this.width||l<0||s>this.height)return !o&&[];var c=[],u={hitTest:o,circle:{x:t,y:e,radius:i},seenUids:{box:{},circle:{}}};return this._forEachCell(a,s,n,l,this._queryCellCircle,c,u,r),o?c.length>0:c},qt.prototype.query=function(t,e,i,o,r){return this._query(t,e,i,o,!1,r)},qt.prototype.hitTest=function(t,e,i,o,r){return this._query(t,e,i,o,!0,r)},qt.prototype.hitTestCircle=function(t,e,i,o){return this._queryCircle(t,e,i,!0,o)},qt.prototype._queryCell=function(t,e,i,o,r,a,n,s){var l=n.seenUids,c=this.boxCells[r];if(null!==c)for(var u=this.bboxes,h=0,p=c;h<p.length;h+=1){var d=p[h];if(!l.box[d]){l.box[d]=!0;var _=4*d;if(t<=u[_+2]&&e<=u[_+3]&&i>=u[_+0]&&o>=u[_+1]&&(!s||s(this.boxKeys[d]))){if(n.hitTest)return a.push(!0),!0;a.push({key:this.boxKeys[d],x1:u[_],y1:u[_+1],x2:u[_+2],y2:u[_+3]});}}}var f=this.circleCells[r];if(null!==f)for(var m=this.circles,g=0,v=f;g<v.length;g+=1){var y=v[g];if(!l.circle[y]){l.circle[y]=!0;var x=3*y;if(this._circleAndRectCollide(m[x],m[x+1],m[x+2],t,e,i,o)&&(!s||s(this.circleKeys[y]))){if(n.hitTest)return a.push(!0),!0;var b=m[x],w=m[x+1],E=m[x+2];a.push({key:this.circleKeys[y],x1:b-E,y1:w-E,x2:b+E,y2:w+E});}}}},qt.prototype._queryCellCircle=function(t,e,i,o,r,a,n,s){var l=n.circle,c=n.seenUids,u=this.boxCells[r];if(null!==u)for(var h=this.bboxes,p=0,d=u;p<d.length;p+=1){var _=d[p];if(!c.box[_]){c.box[_]=!0;var f=4*_;if(this._circleAndRectCollide(l.x,l.y,l.radius,h[f+0],h[f+1],h[f+2],h[f+3])&&(!s||s(this.boxKeys[_])))return a.push(!0),!0}}var m=this.circleCells[r];if(null!==m)for(var g=this.circles,v=0,y=m;v<y.length;v+=1){var x=y[v];if(!c.circle[x]){c.circle[x]=!0;var b=3*x;if(this._circlesCollide(g[b],g[b+1],g[b+2],l.x,l.y,l.radius)&&(!s||s(this.circleKeys[x])))return a.push(!0),!0}}},qt.prototype._forEachCell=function(t,e,i,o,r,a,n,s){for(var l=this._convertToXCellCoord(t),c=this._convertToYCellCoord(e),u=this._convertToXCellCoord(i),h=this._convertToYCellCoord(o),p=l;p<=u;p++)for(var d=c;d<=h;d++){var _=this.xCellCount*d+p;if(r.call(this,t,e,i,o,_,a,n,s))return}},qt.prototype._convertToXCellCoord=function(t){return Math.max(0,Math.min(this.xCellCount-1,Math.floor(t*this.xScale)))},qt.prototype._convertToYCellCoord=function(t){return Math.max(0,Math.min(this.yCellCount-1,Math.floor(t*this.yScale)))},qt.prototype._circlesCollide=function(t,e,i,o,r,a){var n=o-t,s=r-e,l=i+a;return l*l>n*n+s*s},qt.prototype._circleAndRectCollide=function(t,e,i,o,r,a,n){var s=(a-o)/2,l=Math.abs(t-(o+s));if(l>s+i)return !1;var c=(n-r)/2,u=Math.abs(e-(r+c));if(u>c+i)return !1;if(l<=s||u<=c)return !0;var h=l-s,p=u-c;return h*h+p*p<=i*i};var Gt=t.properties.layout;function Wt(e,i,o,r,a){var n=t.identity(new Float32Array(16));return i?(t.identity(n),t.scale(n,n,[1/a,1/a,1]),o||t.rotateZ(n,n,r.angle)):(t.scale(n,n,[r.width/2,-r.height/2,1]),t.translate(n,n,[1,-1,0]),t.multiply(n,n,e)),n}function Xt(e,i,o,r,a){var n=t.identity(new Float32Array(16));return i?(t.multiply(n,n,e),t.scale(n,n,[a,a,1]),o||t.rotateZ(n,n,-r.angle)):(t.scale(n,n,[1,-1,1]),t.translate(n,n,[-1,-1,0]),t.scale(n,n,[2/r.width,2/r.height,1])),n}function Ht(e,i){var o=[e.x,e.y,0,1];re(o,o,i);var r=o[3];return {point:new t.Point(o[0]/r,o[1]/r),signedDistanceFromCamera:r}}function Kt(t,e){var i=t[0]/t[3],o=t[1]/t[3];return i>=-e[0]&&i<=e[0]&&o>=-e[1]&&o<=e[1]}function Yt(e,i,o,r,a,n,s,l){var c=r?e.textSizeData:e.iconSizeData,u=t.evaluateSizeForZoom(c,o.transform.zoom,Gt.properties[r?"text-size":"icon-size"]),h=[256/o.width*2+1,256/o.height*2+1],p=r?e.text.dynamicLayoutVertexArray:e.icon.dynamicLayoutVertexArray;p.clear();for(var d=e.lineVertexArray,_=r?e.text.placedSymbolArray:e.icon.placedSymbolArray,f=o.transform.width/o.transform.height,m=!1,g=0;g<_.length;g++){var v=_.get(g);if(v.hidden||v.writingMode===t.WritingMode.vertical&&!m)oe(v.numGlyphs,p);else{m=!1;var y=[v.anchorX,v.anchorY,0,1];if(t.transformMat4(y,y,i),Kt(y,h)){var x=.5+y[3]/o.transform.cameraToCenterDistance*.5,b=t.evaluateSizeForFeature(c,u,v),w=s?b*x:b/x,E=new t.Point(v.anchorX,v.anchorY),T=Ht(E,a).point,I={},C=$t(v,w,!1,l,i,a,n,e.glyphOffsetArray,d,p,T,E,I,f);m=C.useVertical,(C.notEnoughRoom||m||C.needsFlipping&&$t(v,w,!0,l,i,a,n,e.glyphOffsetArray,d,p,T,E,I,f).notEnoughRoom)&&oe(v.numGlyphs,p);}else oe(v.numGlyphs,p);}}r?e.text.dynamicLayoutVertexBuffer.updateData(p):e.icon.dynamicLayoutVertexBuffer.updateData(p);}function Jt(t,e,i,o,r,a,n,s,l,c,u,h){var p=s.glyphStartIndex+s.numGlyphs,d=s.lineStartIndex,_=s.lineStartIndex+s.lineLength,f=e.getoffsetX(s.glyphStartIndex),m=e.getoffsetX(p-1),g=ee(t*f,i,o,r,a,n,s.segment,d,_,l,c,u,h);if(!g)return null;var v=ee(t*m,i,o,r,a,n,s.segment,d,_,l,c,u,h);return v?{first:g,last:v}:null}function Qt(e,i,o,r){if(e===t.WritingMode.horizontal&&Math.abs(o.y-i.y)>Math.abs(o.x-i.x)*r)return {useVertical:!0};return (e===t.WritingMode.vertical?i.y<o.y:i.x>o.x)?{needsFlipping:!0}:null}function $t(e,i,o,r,a,n,s,l,c,u,h,p,d,_){var f,m=i/24,g=e.lineOffsetX*i,v=e.lineOffsetY*i;if(e.numGlyphs>1){var y=e.glyphStartIndex+e.numGlyphs,x=e.lineStartIndex,b=e.lineStartIndex+e.lineLength,w=Jt(m,l,g,v,o,h,p,e,c,n,d,!1);if(!w)return {notEnoughRoom:!0};var E=Ht(w.first.point,s).point,T=Ht(w.last.point,s).point;if(r&&!o){var I=Qt(e.writingMode,E,T,_);if(I)return I}f=[w.first];for(var C=e.glyphStartIndex+1;C<y-1;C++)f.push(ee(m*l.getoffsetX(C),g,v,o,h,p,e.segment,x,b,c,n,d,!1));f.push(w.last);}else{if(r&&!o){var S=Ht(p,a).point,z=e.lineStartIndex+e.segment+1,L=new t.Point(c.getx(z),c.gety(z)),P=Ht(L,a),D=P.signedDistanceFromCamera>0?P.point:te(p,L,S,1,a),R=Qt(e.writingMode,S,D,_);if(R)return R}var M=ee(m*l.getoffsetX(e.glyphStartIndex),g,v,o,h,p,e.segment,e.lineStartIndex,e.lineStartIndex+e.lineLength,c,n,d,!1);if(!M)return {notEnoughRoom:!0};f=[M];}for(var A=0,k=f;A<k.length;A+=1){var B=k[A];t.addDynamicAttributes(u,B.point,B.angle);}return {}}function te(t,e,i,o,r){var a=Ht(t.add(t.sub(e)._unit()),r).point,n=i.sub(a);return i.add(n._mult(o/n.mag()))}function ee(e,i,o,r,a,n,s,l,c,u,h,p,d){var _=r?e-i:e+i,f=_>0?1:-1,m=0;r&&(f*=-1,m=Math.PI),f<0&&(m+=Math.PI);for(var g=f>0?l+s:l+s+1,v=g,y=a,x=a,b=0,w=0,E=Math.abs(_);b+w<=E;){if((g+=f)<l||g>=c)return null;if(x=y,void 0===(y=p[g])){var T=new t.Point(u.getx(g),u.gety(g)),I=Ht(T,h);if(I.signedDistanceFromCamera>0)y=p[g]=I.point;else{var C=g-f;y=te(0===b?n:new t.Point(u.getx(C),u.gety(C)),T,x,E-b+1,h);}}b+=w,w=x.dist(y);}var S=(E-b)/w,z=y.sub(x),L=z.mult(S)._add(x);return L._add(z._unit()._perp()._mult(o*f)),{point:L,angle:m+Math.atan2(y.y-x.y,y.x-x.x),tileDistance:d?{prevTileDistance:g-f===v?0:u.gettileUnitDistanceFromAnchor(g-f),lastSegmentViewportDistance:E-b}:null}}var ie=new Float32Array([-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0]);function oe(t,e){for(var i=0;i<t;i++){var o=e.length;e.resize(o+4),e.float32.set(ie,3*o);}}function re(t,e,i){var o=e[0],r=e[1];return t[0]=i[0]*o+i[4]*r+i[12],t[1]=i[1]*o+i[5]*r+i[13],t[3]=i[3]*o+i[7]*r+i[15],t}var ae=function(t,e,i){void 0===e&&(e=new qt(t.width+200,t.height+200,25)),void 0===i&&(i=new qt(t.width+200,t.height+200,25)),this.transform=t,this.grid=e,this.ignoredGrid=i,this.pitchfactor=Math.cos(t._pitch)*t.cameraToCenterDistance,this.screenRightBoundary=t.width+100,this.screenBottomBoundary=t.height+100,this.gridRightBoundary=t.width+200,this.gridBottomBoundary=t.height+200;};function ne(t,e,i){t[e+4]=i?1:0;}function se(e,i,o){return i*(t.EXTENT/(e.tileSize*Math.pow(2,o-e.tileID.overscaledZ)))}ae.prototype.placeCollisionBox=function(t,e,i,o,r){var a=this.projectAndGetPerspectiveRatio(o,t.anchorPointX,t.anchorPointY),n=i*a.perspectiveRatio,s=t.x1*n+a.point.x,l=t.y1*n+a.point.y,c=t.x2*n+a.point.x,u=t.y2*n+a.point.y;return !this.isInsideGrid(s,l,c,u)||!e&&this.grid.hitTest(s,l,c,u,r)?{box:[],offscreen:!1}:{box:[s,l,c,u],offscreen:this.isOffscreen(s,l,c,u)}},ae.prototype.approximateTileDistance=function(t,e,i,o,r){var a=r?1:o/this.pitchfactor,n=t.lastSegmentViewportDistance*i;return t.prevTileDistance+n+(a-1)*n*Math.abs(Math.sin(e))},ae.prototype.placeCollisionCircles=function(e,i,o,r,a,n,s,l,c,u,h,p,d){var _=[],f=this.projectAnchor(c,a.anchorX,a.anchorY),m=l/24,g=a.lineOffsetX*l,v=a.lineOffsetY*l,y=new t.Point(a.anchorX,a.anchorY),x=Jt(m,s,g,v,!1,Ht(y,u).point,y,a,n,u,{},!0),b=!1,w=!1,E=!0,T=f.perspectiveRatio*r,I=1/(r*o),C=0,S=0;x&&(C=this.approximateTileDistance(x.first.tileDistance,x.first.angle,I,f.cameraDistance,p),S=this.approximateTileDistance(x.last.tileDistance,x.last.angle,I,f.cameraDistance,p));for(var z=0;z<e.length;z+=5){var L=e[z],P=e[z+1],D=e[z+2],R=e[z+3];if(!x||R<-C||R>S)ne(e,z,!1);else{var M=this.projectPoint(c,L,P),A=D*T;if(_.length>0){var k=M.x-_[_.length-4],B=M.y-_[_.length-3];if(A*A*2>k*k+B*B)if(z+8<e.length){var O=e[z+8];if(O>-C&&O<S){ne(e,z,!1);continue}}}var F=z/5;_.push(M.x,M.y,A,F),ne(e,z,!0);var U=M.x-A,N=M.y-A,Z=M.x+A,j=M.y+A;if(E=E&&this.isOffscreen(U,N,Z,j),w=w||this.isInsideGrid(U,N,Z,j),!i&&this.grid.hitTestCircle(M.x,M.y,A,d)){if(!h)return {circles:[],offscreen:!1};b=!0;}}}return {circles:b||!w?[]:_,offscreen:E}},ae.prototype.queryRenderedSymbols=function(e){if(0===e.length||0===this.grid.keysLength()&&0===this.ignoredGrid.keysLength())return {};for(var i=[],o=1/0,r=1/0,a=-1/0,n=-1/0,s=0,l=e;s<l.length;s+=1){var c=l[s],u=new t.Point(c.x+100,c.y+100);o=Math.min(o,u.x),r=Math.min(r,u.y),a=Math.max(a,u.x),n=Math.max(n,u.y),i.push(u);}for(var h={},p={},d=0,_=this.grid.query(o,r,a,n).concat(this.ignoredGrid.query(o,r,a,n));d<_.length;d+=1){var f=_[d],m=f.key;if(void 0===h[m.bucketInstanceId]&&(h[m.bucketInstanceId]={}),!h[m.bucketInstanceId][m.featureIndex]){var g=[new t.Point(f.x1,f.y1),new t.Point(f.x2,f.y1),new t.Point(f.x2,f.y2),new t.Point(f.x1,f.y2)];t.polygonIntersectsPolygon(i,g)&&(h[m.bucketInstanceId][m.featureIndex]=!0,void 0===p[m.bucketInstanceId]&&(p[m.bucketInstanceId]=[]),p[m.bucketInstanceId].push(m.featureIndex));}}return p},ae.prototype.insertCollisionBox=function(t,e,i,o,r){var a={bucketInstanceId:i,featureIndex:o,collisionGroupID:r};(e?this.ignoredGrid:this.grid).insert(a,t[0],t[1],t[2],t[3]);},ae.prototype.insertCollisionCircles=function(t,e,i,o,r){for(var a=e?this.ignoredGrid:this.grid,n={bucketInstanceId:i,featureIndex:o,collisionGroupID:r},s=0;s<t.length;s+=4)a.insertCircle(n,t[s],t[s+1],t[s+2]);},ae.prototype.projectAnchor=function(t,e,i){var o=[e,i,0,1];return re(o,o,t),{perspectiveRatio:.5+this.transform.cameraToCenterDistance/o[3]*.5,cameraDistance:o[3]}},ae.prototype.projectPoint=function(e,i,o){var r=[i,o,0,1];return re(r,r,e),new t.Point((r[0]/r[3]+1)/2*this.transform.width+100,(-r[1]/r[3]+1)/2*this.transform.height+100)},ae.prototype.projectAndGetPerspectiveRatio=function(e,i,o){var r=[i,o,0,1];return re(r,r,e),{point:new t.Point((r[0]/r[3]+1)/2*this.transform.width+100,(-r[1]/r[3]+1)/2*this.transform.height+100),perspectiveRatio:.5+this.transform.cameraToCenterDistance/r[3]*.5}},ae.prototype.isOffscreen=function(t,e,i,o){return i<100||t>=this.screenRightBoundary||o<100||e>this.screenBottomBoundary},ae.prototype.isInsideGrid=function(t,e,i,o){return i>=0&&t<this.gridRightBoundary&&o>=0&&e<this.gridBottomBoundary};var le=function(t,e,i,o){this.opacity=t?Math.max(0,Math.min(1,t.opacity+(t.placed?e:-e))):o&&i?1:0,this.placed=i;};le.prototype.isHidden=function(){return 0===this.opacity&&!this.placed};var ce=function(t,e,i,o,r){this.text=new le(t?t.text:null,e,i,r),this.icon=new le(t?t.icon:null,e,o,r);};ce.prototype.isHidden=function(){return this.text.isHidden()&&this.icon.isHidden()};var ue=function(t,e,i){this.text=t,this.icon=e,this.skipFade=i;},he=function(t,e,i,o,r){this.bucketInstanceId=t,this.featureIndex=e,this.sourceLayerIndex=i,this.bucketIndex=o,this.tileID=r;},pe=function(t){this.crossSourceCollisions=t,this.maxGroupID=0,this.collisionGroups={};};pe.prototype.get=function(t){if(this.crossSourceCollisions)return {ID:0,predicate:null};if(!this.collisionGroups[t]){var e=++this.maxGroupID;this.collisionGroups[t]={ID:e,predicate:function(t){return t.collisionGroupID===e}};}return this.collisionGroups[t]};var de=function(t,e,i){this.transform=t.clone(),this.collisionIndex=new ae(this.transform),this.placements={},this.opacities={},this.stale=!1,this.commitTime=0,this.fadeDuration=e,this.retainedQueryData={},this.collisionGroups=new pe(i);};function _e(t,e,i){t.emplaceBack(e?1:0,i?1:0),t.emplaceBack(e?1:0,i?1:0),t.emplaceBack(e?1:0,i?1:0),t.emplaceBack(e?1:0,i?1:0);}de.prototype.placeLayerTile=function(e,i,o,r){var a=i.getBucket(e),n=i.latestFeatureIndex;if(a&&n&&e.id===a.layerIds[0]){var s=i.collisionBoxArray,l=a.layers[0].layout,c=Math.pow(2,this.transform.zoom-i.tileID.overscaledZ),u=i.tileSize/t.EXTENT,h=this.transform.calculatePosMatrix(i.tileID.toUnwrapped()),p=Wt(h,"map"===l.get("text-pitch-alignment"),"map"===l.get("text-rotation-alignment"),this.transform,se(i,1,this.transform.zoom)),d=Wt(h,"map"===l.get("icon-pitch-alignment"),"map"===l.get("icon-rotation-alignment"),this.transform,se(i,1,this.transform.zoom));this.retainedQueryData[a.bucketInstanceId]=new he(a.bucketInstanceId,n,a.sourceLayerIndex,a.index,i.tileID),this.placeLayerBucket(a,h,p,d,c,u,o,i.holdingForFade(),r,s);}},de.prototype.placeLayerBucket=function(e,i,o,r,a,n,s,l,c,u){var h=e.layers[0].layout,p=t.evaluateSizeForZoom(e.textSizeData,this.transform.zoom,t.properties.layout.properties["text-size"]),d=h.get("text-optional"),_=h.get("icon-optional"),f=h.get("text-allow-overlap"),m=h.get("icon-allow-overlap"),g=f&&(m||!e.hasIconData()||_),v=m&&(f||!e.hasTextData()||d),y=this.collisionGroups.get(e.sourceID);!e.collisionArrays&&u&&e.deserializeCollisionBoxes(u);for(var x=0;x<e.symbolInstances.length;x++){var b=e.symbolInstances.get(x);if(!c[b.crossTileID]){if(l){this.placements[b.crossTileID]=new ue(!1,!1,!1);continue}var w=!1,E=!1,T=!0,I=null,C=null,S=null,z=0,L=0,P=e.collisionArrays[x];P.textFeatureIndex&&(z=P.textFeatureIndex),P.textBox&&(w=(I=this.collisionIndex.placeCollisionBox(P.textBox,h.get("text-allow-overlap"),n,i,y.predicate)).box.length>0,T=T&&I.offscreen);var D=P.textCircles;if(D){var R=e.text.placedSymbolArray.get(b.horizontalPlacedTextSymbolIndex),M=t.evaluateSizeForFeature(e.textSizeData,p,R);C=this.collisionIndex.placeCollisionCircles(D,h.get("text-allow-overlap"),a,n,R,e.lineVertexArray,e.glyphOffsetArray,M,i,o,s,"map"===h.get("text-pitch-alignment"),y.predicate),w=h.get("text-allow-overlap")||C.circles.length>0,T=T&&C.offscreen;}P.iconFeatureIndex&&(L=P.iconFeatureIndex),P.iconBox&&(E=(S=this.collisionIndex.placeCollisionBox(P.iconBox,h.get("icon-allow-overlap"),n,i,y.predicate)).box.length>0,T=T&&S.offscreen);var A=d||0===b.numGlyphVertices&&0===b.numVerticalGlyphVertices,k=_||0===b.numIconVertices;A||k?k?A||(E=E&&w):w=E&&w:E=w=E&&w,w&&I&&this.collisionIndex.insertCollisionBox(I.box,h.get("text-ignore-placement"),e.bucketInstanceId,z,y.ID),E&&S&&this.collisionIndex.insertCollisionBox(S.box,h.get("icon-ignore-placement"),e.bucketInstanceId,L,y.ID),w&&C&&this.collisionIndex.insertCollisionCircles(C.circles,h.get("text-ignore-placement"),e.bucketInstanceId,z,y.ID),this.placements[b.crossTileID]=new ue(w||g,E||v,T||e.justReloaded),c[b.crossTileID]=!0;}}e.justReloaded=!1;},de.prototype.commit=function(t,e){this.commitTime=e;var i=!1,o=t&&0!==this.fadeDuration?(this.commitTime-t.commitTime)/this.fadeDuration:1,r=t?t.opacities:{};for(var a in this.placements){var n=this.placements[a],s=r[a];s?(this.opacities[a]=new ce(s,o,n.text,n.icon),i=i||n.text!==s.text.placed||n.icon!==s.icon.placed):(this.opacities[a]=new ce(null,o,n.text,n.icon,n.skipFade),i=i||n.text||n.icon);}for(var l in r){var c=r[l];if(!this.opacities[l]){var u=new ce(c,o,!1,!1);u.isHidden()||(this.opacities[l]=u,i=i||c.text.placed||c.icon.placed);}}i?this.lastPlacementChangeTime=e:"number"!=typeof this.lastPlacementChangeTime&&(this.lastPlacementChangeTime=t?t.lastPlacementChangeTime:e);},de.prototype.updateLayerOpacities=function(t,e){for(var i={},o=0,r=e;o<r.length;o+=1){var a=r[o],n=a.getBucket(t);n&&a.latestFeatureIndex&&t.id===n.layerIds[0]&&this.updateBucketOpacities(n,i,a.collisionBoxArray);}},de.prototype.updateBucketOpacities=function(t,e,i){t.hasTextData()&&t.text.opacityVertexArray.clear(),t.hasIconData()&&t.icon.opacityVertexArray.clear(),t.hasCollisionBoxData()&&t.collisionBox.collisionVertexArray.clear(),t.hasCollisionCircleData()&&t.collisionCircle.collisionVertexArray.clear();var o=t.layers[0].layout,r=new ce(null,0,!1,!1,!0),a=o.get("text-allow-overlap"),n=o.get("icon-allow-overlap"),s=new ce(null,0,a&&(n||!t.hasIconData()||o.get("icon-optional")),n&&(a||!t.hasTextData()||o.get("text-optional")),!0);!t.collisionArrays&&i&&(t.hasCollisionBoxData()||t.hasCollisionCircleData())&&t.deserializeCollisionBoxes(i);for(var l=0;l<t.symbolInstances.length;l++){var c=t.symbolInstances.get(l),u=e[c.crossTileID],h=this.opacities[c.crossTileID];u?h=r:h||(h=s,this.opacities[c.crossTileID]=h),e[c.crossTileID]=!0;var p=c.numGlyphVertices>0||c.numVerticalGlyphVertices>0,d=c.numIconVertices>0;if(p){for(var _=we(h.text),f=(c.numGlyphVertices+c.numVerticalGlyphVertices)/4,m=0;m<f;m++)t.text.opacityVertexArray.emplaceBack(_);t.text.placedSymbolArray.get(c.horizontalPlacedTextSymbolIndex).hidden=h.text.isHidden(),c.verticalPlacedTextSymbolIndex>=0&&(t.text.placedSymbolArray.get(c.verticalPlacedTextSymbolIndex).hidden=h.text.isHidden());}if(d){for(var g=we(h.icon),v=0;v<c.numIconVertices/4;v++)t.icon.opacityVertexArray.emplaceBack(g);t.icon.placedSymbolArray.get(l).hidden=h.icon.isHidden();}if(t.hasCollisionBoxData()||t.hasCollisionCircleData()){var y=t.collisionArrays[l];if(y){y.textBox&&_e(t.collisionBox.collisionVertexArray,h.text.placed,!1),y.iconBox&&_e(t.collisionBox.collisionVertexArray,h.icon.placed,!1);var x=y.textCircles;if(x&&t.hasCollisionCircleData())for(var b=0;b<x.length;b+=5){var w=u||0===x[b+4];_e(t.collisionCircle.collisionVertexArray,h.text.placed,w);}}}}t.sortFeatures(this.transform.angle),this.retainedQueryData[t.bucketInstanceId]&&(this.retainedQueryData[t.bucketInstanceId].featureSortOrder=t.featureSortOrder),t.hasTextData()&&t.text.opacityVertexBuffer&&t.text.opacityVertexBuffer.updateData(t.text.opacityVertexArray),t.hasIconData()&&t.icon.opacityVertexBuffer&&t.icon.opacityVertexBuffer.updateData(t.icon.opacityVertexArray),t.hasCollisionBoxData()&&t.collisionBox.collisionVertexBuffer&&t.collisionBox.collisionVertexBuffer.updateData(t.collisionBox.collisionVertexArray),t.hasCollisionCircleData()&&t.collisionCircle.collisionVertexBuffer&&t.collisionCircle.collisionVertexBuffer.updateData(t.collisionCircle.collisionVertexArray);},de.prototype.symbolFadeChange=function(t){return 0===this.fadeDuration?1:(t-this.commitTime)/this.fadeDuration},de.prototype.hasTransitions=function(t){return this.stale||t-this.lastPlacementChangeTime<this.fadeDuration},de.prototype.stillRecent=function(t){return this.commitTime+this.fadeDuration>t},de.prototype.setStale=function(){this.stale=!0;};var fe=Math.pow(2,25),me=Math.pow(2,24),ge=Math.pow(2,17),ve=Math.pow(2,16),ye=Math.pow(2,9),xe=Math.pow(2,8),be=Math.pow(2,1);function we(t){if(0===t.opacity&&!t.placed)return 0;if(1===t.opacity&&t.placed)return 4294967295;var e=t.placed?1:0,i=Math.floor(127*t.opacity);return i*fe+e*me+i*ge+e*ve+i*ye+e*xe+i*be+e}var Ee=function(){this._currentTileIndex=0,this._seenCrossTileIDs={};};Ee.prototype.continuePlacement=function(t,e,i,o,r){for(;this._currentTileIndex<t.length;){var a=t[this._currentTileIndex];if(e.placeLayerTile(o,a,i,this._seenCrossTileIDs),this._currentTileIndex++,r())return !0}};var Te=function(t,e,i,o,r,a){this.placement=new de(t,r,a),this._currentPlacementIndex=e.length-1,this._forceFullPlacement=i,this._showCollisionBoxes=o,this._done=!1;};Te.prototype.isDone=function(){return this._done},Te.prototype.continuePlacement=function(e,i,o){for(var r=this,a=t.browser.now(),n=function(){var e=t.browser.now()-a;return !r._forceFullPlacement&&e>2};this._currentPlacementIndex>=0;){var s=i[e[this._currentPlacementIndex]],l=this.placement.collisionIndex.transform.zoom;if("symbol"===s.type&&(!s.minzoom||s.minzoom<=l)&&(!s.maxzoom||s.maxzoom>l)){if(this._inProgressLayer||(this._inProgressLayer=new Ee),this._inProgressLayer.continuePlacement(o[s.source],this.placement,this._showCollisionBoxes,s,n))return;delete this._inProgressLayer;}this._currentPlacementIndex--;}this._done=!0;},Te.prototype.commit=function(t,e){return this.placement.commit(t,e),this.placement};var Ie=512/t.EXTENT/2,Ce=function(t,e,i){this.tileID=t,this.indexedSymbolInstances={},this.bucketInstanceId=i;for(var o=0;o<e.length;o++){var r=e.get(o),a=r.key;this.indexedSymbolInstances[a]||(this.indexedSymbolInstances[a]=[]),this.indexedSymbolInstances[a].push({crossTileID:r.crossTileID,coord:this.getScaledCoordinates(r,t)});}};Ce.prototype.getScaledCoordinates=function(e,i){var o=i.canonical.z-this.tileID.canonical.z,r=Ie/Math.pow(2,o);return {x:Math.floor((i.canonical.x*t.EXTENT+e.anchorX)*r),y:Math.floor((i.canonical.y*t.EXTENT+e.anchorY)*r)}},Ce.prototype.findMatches=function(t,e,i){for(var o=this.tileID.canonical.z<e.canonical.z?1:Math.pow(2,this.tileID.canonical.z-e.canonical.z),r=0;r<t.length;r++){var a=t.get(r);if(!a.crossTileID){var n=this.indexedSymbolInstances[a.key];if(n)for(var s=this.getScaledCoordinates(a,e),l=0,c=n;l<c.length;l+=1){var u=c[l];if(Math.abs(u.coord.x-s.x)<=o&&Math.abs(u.coord.y-s.y)<=o&&!i[u.crossTileID]){i[u.crossTileID]=!0,a.crossTileID=u.crossTileID;break}}}}};var Se=function(){this.maxCrossTileID=0;};Se.prototype.generate=function(){return ++this.maxCrossTileID};var ze=function(){this.indexes={},this.usedCrossTileIDs={},this.lng=0;};ze.prototype.handleWrapJump=function(t){var e=Math.round((t-this.lng)/360);if(0!==e)for(var i in this.indexes){var o=this.indexes[i],r={};for(var a in o){var n=o[a];n.tileID=n.tileID.unwrapTo(n.tileID.wrap+e),r[n.tileID.key]=n;}this.indexes[i]=r;}this.lng=t;},ze.prototype.addBucket=function(t,e,i){if(this.indexes[t.overscaledZ]&&this.indexes[t.overscaledZ][t.key]){if(this.indexes[t.overscaledZ][t.key].bucketInstanceId===e.bucketInstanceId)return !1;this.removeBucketCrossTileIDs(t.overscaledZ,this.indexes[t.overscaledZ][t.key]);}for(var o=0;o<e.symbolInstances.length;o++){e.symbolInstances.get(o).crossTileID=0;}this.usedCrossTileIDs[t.overscaledZ]||(this.usedCrossTileIDs[t.overscaledZ]={});var r=this.usedCrossTileIDs[t.overscaledZ];for(var a in this.indexes){var n=this.indexes[a];if(Number(a)>t.overscaledZ)for(var s in n){var l=n[s];l.tileID.isChildOf(t)&&l.findMatches(e.symbolInstances,t,r);}else{var c=n[t.scaledTo(Number(a)).key];c&&c.findMatches(e.symbolInstances,t,r);}}for(var u=0;u<e.symbolInstances.length;u++){var h=e.symbolInstances.get(u);h.crossTileID||(h.crossTileID=i.generate(),r[h.crossTileID]=!0);}return void 0===this.indexes[t.overscaledZ]&&(this.indexes[t.overscaledZ]={}),this.indexes[t.overscaledZ][t.key]=new Ce(t,e.symbolInstances,e.bucketInstanceId),!0},ze.prototype.removeBucketCrossTileIDs=function(t,e){for(var i in e.indexedSymbolInstances)for(var o=0,r=e.indexedSymbolInstances[i];o<r.length;o+=1){var a=r[o];delete this.usedCrossTileIDs[t][a.crossTileID];}},ze.prototype.removeStaleBuckets=function(t){var e=!1;for(var i in this.indexes){var o=this.indexes[i];for(var r in o)t[o[r].bucketInstanceId]||(this.removeBucketCrossTileIDs(i,o[r]),delete o[r],e=!0);}return e};var Le=function(){this.layerIndexes={},this.crossTileIDs=new Se,this.maxBucketInstanceId=0,this.bucketsInCurrentPlacement={};};Le.prototype.addLayer=function(t,e,i){var o=this.layerIndexes[t.id];void 0===o&&(o=this.layerIndexes[t.id]=new ze);var r=!1,a={};o.handleWrapJump(i);for(var n=0,s=e;n<s.length;n+=1){var l=s[n],c=l.getBucket(t);c&&t.id===c.layerIds[0]&&(c.bucketInstanceId||(c.bucketInstanceId=++this.maxBucketInstanceId),o.addBucket(l.tileID,c,this.crossTileIDs)&&(r=!0),a[c.bucketInstanceId]=!0);}return o.removeStaleBuckets(a)&&(r=!0),r},Le.prototype.pruneUnusedLayers=function(t){var e={};for(var i in t.forEach(function(t){e[t]=!0;}),this.layerIndexes)e[i]||delete this.layerIndexes[i];};var Pe=function(e,i){return t.emitValidationErrors(e,i&&i.filter(function(t){return "source.canvas"!==t.identifier}))},De=t.pick(kt,["addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition","setGeoJSONSourceData"]),Re=t.pick(kt,["setCenter","setZoom","setBearing","setPitch"]),Me=function(e){function i(o,r){var a=this;void 0===r&&(r={}),e.call(this),this.map=o,this.dispatcher=new w((Dt||(Dt=new Pt),Dt),this),this.imageManager=new h,this.glyphManager=new g(o._transformRequest,r.localIdeographFontFamily),this.lineAtlas=new b(256,512),this.crossTileSymbolIndex=new Le,this._layers={},this._order=[],this.sourceCaches={},this.zoomHistory=new t.ZoomHistory,this._loaded=!1,this._resetUpdates(),this.dispatcher.broadcast("setReferrer",t.getReferrer());var n=this;this._rtlTextPluginCallback=i.registerForPluginAvailability(function(t){for(var e in n.dispatcher.broadcast("loadRTLTextPlugin",t.pluginURL,t.completionCallback),n.sourceCaches)n.sourceCaches[e].reload();}),this.on("data",function(t){if("source"===t.dataType&&"metadata"===t.sourceDataType){var e=a.sourceCaches[t.sourceId];if(e){var i=e.getSource();if(i&&i.vectorLayerIds)for(var o in a._layers){var r=a._layers[o];r.source===i.id&&a._validateLayer(r);}}}});}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.loadURL=function(e,i){var o=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"}));var r="boolean"==typeof i.validate?i.validate:!t.isMapboxURL(e);e=t.normalizeStyleURL(e,i.accessToken);var a=this.map._transformRequest(e,t.ResourceType.Style);this._request=t.getJSON(a,function(e,i){o._request=null,e?o.fire(new t.ErrorEvent(e)):i&&o._load(i,r);});},i.prototype.loadJSON=function(e,i){var o=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"})),this._request=t.browser.frame(function(){o._request=null,o._load(e,!1!==i.validate);});},i.prototype._load=function(e,i){var o=this;if(!i||!Pe(this,t.validateStyle(e))){for(var r in this._loaded=!0,this.stylesheet=e,e.sources)this.addSource(r,e.sources[r],{validate:!1});e.sprite?this._spriteRequest=function(e,i,o){var r,a,n,s=t.browser.devicePixelRatio>1?"@2x":"",l=t.getJSON(i(t.normalizeSpriteURL(e,s,".json"),t.ResourceType.SpriteJSON),function(t,e){l=null,n||(n=t,r=e,u());}),c=t.getImage(i(t.normalizeSpriteURL(e,s,".png"),t.ResourceType.SpriteImage),function(t,e){c=null,n||(n=t,a=e,u());});function u(){if(n)o(n);else if(r&&a){var e=t.browser.getImageData(a),i={};for(var s in r){var l=r[s],c=l.width,u=l.height,h=l.x,p=l.y,d=l.sdf,_=l.pixelRatio,f=new t.RGBAImage({width:c,height:u});t.RGBAImage.copy(e,f,{x:h,y:p},{x:0,y:0},{width:c,height:u}),i[s]={data:f,pixelRatio:_,sdf:d};}o(null,i);}}return {cancel:function(){l&&(l.cancel(),l=null),c&&(c.cancel(),c=null);}}}(e.sprite,this.map._transformRequest,function(e,i){if(o._spriteRequest=null,e)o.fire(new t.ErrorEvent(e));else if(i)for(var r in i)o.imageManager.addImage(r,i[r]);o.imageManager.setLoaded(!0),o.fire(new t.Event("data",{dataType:"style"}));}):this.imageManager.setLoaded(!0),this.glyphManager.setURL(e.glyphs);var a=At(this.stylesheet.layers);this._order=a.map(function(t){return t.id}),this._layers={};for(var n=0,s=a;n<s.length;n+=1){var l=s[n];(l=t.createStyleLayer(l)).setEventedParent(this,{layer:{id:l.id}}),this._layers[l.id]=l;}this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new x(this.stylesheet.light),this.fire(new t.Event("data",{dataType:"style"})),this.fire(new t.Event("style.load"));}},i.prototype._validateLayer=function(e){var i=this.sourceCaches[e.source];if(i){var o=e.sourceLayer;if(o){var r=i.getSource();("geojson"===r.type||r.vectorLayerIds&&-1===r.vectorLayerIds.indexOf(o))&&this.fire(new t.ErrorEvent(new Error('Source layer "'+o+'" does not exist on source "'+r.id+'" as specified by style layer "'+e.id+'"')));}}},i.prototype.loaded=function(){if(!this._loaded)return !1;if(Object.keys(this._updatedSources).length)return !1;for(var t in this.sourceCaches)if(!this.sourceCaches[t].loaded())return !1;return !!this.imageManager.isLoaded()},i.prototype._serializeLayers=function(t){for(var e=[],i=0,o=t;i<o.length;i+=1){var r=o[i],a=this._layers[r];"custom"!==a.type&&e.push(a.serialize());}return e},i.prototype.hasTransitions=function(){if(this.light&&this.light.hasTransition())return !0;for(var t in this.sourceCaches)if(this.sourceCaches[t].hasTransition())return !0;for(var e in this._layers)if(this._layers[e].hasTransition())return !0;return !1},i.prototype._checkLoaded=function(){if(!this._loaded)throw new Error("Style is not done loading")},i.prototype.update=function(e){if(this._loaded){var i=this._changed;if(this._changed){var o=Object.keys(this._updatedLayers),r=Object.keys(this._removedLayers);for(var a in(o.length||r.length)&&this._updateWorkerLayers(o,r),this._updatedSources){var n=this._updatedSources[a];"reload"===n?this._reloadSource(a):"clear"===n&&this._clearSource(a);}for(var s in this._updatedPaintProps)this._layers[s].updateTransitions(e);this.light.updateTransitions(e),this._resetUpdates();}for(var l in this.sourceCaches)this.sourceCaches[l].used=!1;for(var c=0,u=this._order;c<u.length;c+=1){var h=u[c],p=this._layers[h];p.recalculate(e),!p.isHidden(e.zoom)&&p.source&&(this.sourceCaches[p.source].used=!0);}this.light.recalculate(e),this.z=e.zoom,i&&this.fire(new t.Event("data",{dataType:"style"}));}},i.prototype._updateWorkerLayers=function(t,e){this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(t),removedIds:e});},i.prototype._resetUpdates=function(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSources={},this._updatedPaintProps={};},i.prototype.setState=function(e){var i=this;if(this._checkLoaded(),Pe(this,t.validateStyle(e)))return !1;(e=t.clone(e)).layers=At(e.layers);var o=Vt(this.serialize(),e).filter(function(t){return !(t.command in Re)});if(0===o.length)return !1;var r=o.filter(function(t){return !(t.command in De)});if(r.length>0)throw new Error("Unimplemented: "+r.map(function(t){return t.command}).join(", ")+".");return o.forEach(function(t){"setTransition"!==t.command&&i[t.command].apply(i,t.args);}),this.stylesheet=e,!0},i.prototype.addImage=function(e,i){if(this.getImage(e))return this.fire(new t.ErrorEvent(new Error("An image with this name already exists.")));this.imageManager.addImage(e,i),this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.getImage=function(t){return this.imageManager.getImage(t)},i.prototype.removeImage=function(e){if(!this.getImage(e))return this.fire(new t.ErrorEvent(new Error("No image with this name exists.")));this.imageManager.removeImage(e),this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.listImages=function(){return this._checkLoaded(),this.imageManager.listImages()},i.prototype.addSource=function(e,i,o){var r=this;if(void 0===o&&(o={}),this._checkLoaded(),void 0!==this.sourceCaches[e])throw new Error("There is already a source with this ID");if(!i.type)throw new Error("The type property must be defined, but the only the following properties were given: "+Object.keys(i).join(", ")+".");if(!(["vector","raster","geojson","video","image"].indexOf(i.type)>=0)||!this._validate(t.validateStyle.source,"sources."+e,i,null,o)){this.map&&this.map._collectResourceTiming&&(i.collectResourceTiming=!0);var a=this.sourceCaches[e]=new Ct(e,i,this.dispatcher);a.style=this,a.setEventedParent(this,function(){return {isSourceLoaded:r.loaded(),source:a.serialize(),sourceId:e}}),a.onAdd(this.map),this._changed=!0;}},i.prototype.removeSource=function(e){if(this._checkLoaded(),void 0===this.sourceCaches[e])throw new Error("There is no source with this ID");for(var i in this._layers)if(this._layers[i].source===e)return this.fire(new t.ErrorEvent(new Error('Source "'+e+'" cannot be removed while layer "'+i+'" is using it.')));var o=this.sourceCaches[e];delete this.sourceCaches[e],delete this._updatedSources[e],o.fire(new t.Event("data",{sourceDataType:"metadata",dataType:"source",sourceId:e})),o.setEventedParent(null),o.clearTiles(),o.onRemove&&o.onRemove(this.map),this._changed=!0;},i.prototype.setGeoJSONSourceData=function(t,e){this._checkLoaded(),this.sourceCaches[t].getSource().setData(e),this._changed=!0;},i.prototype.getSource=function(t){return this.sourceCaches[t]&&this.sourceCaches[t].getSource()},i.prototype.addLayer=function(e,i,o){void 0===o&&(o={}),this._checkLoaded();var r=e.id;if(this.getLayer(r))this.fire(new t.ErrorEvent(new Error('Layer with id "'+r+'" already exists on this map')));else{var a;if("custom"===e.type){if(Pe(this,t.validateCustomStyleLayer(e)))return;a=t.createStyleLayer(e);}else{if("object"==typeof e.source&&(this.addSource(r,e.source),e=t.clone(e),e=t.extend(e,{source:r})),this._validate(t.validateStyle.layer,"layers."+r,e,{arrayIndex:-1},o))return;a=t.createStyleLayer(e),this._validateLayer(a),a.setEventedParent(this,{layer:{id:r}});}var n=i?this._order.indexOf(i):this._order.length;if(i&&-1===n)this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.')));else{if(this._order.splice(n,0,r),this._layerOrderChanged=!0,this._layers[r]=a,this._removedLayers[r]&&a.source&&"custom"!==a.type){var s=this._removedLayers[r];delete this._removedLayers[r],s.type!==a.type?this._updatedSources[a.source]="clear":(this._updatedSources[a.source]="reload",this.sourceCaches[a.source].pause());}this._updateLayer(a),a.onAdd&&a.onAdd(this.map);}}},i.prototype.moveLayer=function(e,i){if(this._checkLoaded(),this._changed=!0,this._layers[e]){if(e!==i){var o=this._order.indexOf(e);this._order.splice(o,1);var r=i?this._order.indexOf(i):this._order.length;i&&-1===r?this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.'))):(this._order.splice(r,0,e),this._layerOrderChanged=!0);}}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be moved.")));},i.prototype.removeLayer=function(e){this._checkLoaded();var i=this._layers[e];if(i){i.setEventedParent(null);var o=this._order.indexOf(e);this._order.splice(o,1),this._layerOrderChanged=!0,this._changed=!0,this._removedLayers[e]=i,delete this._layers[e],delete this._updatedLayers[e],delete this._updatedPaintProps[e],i.onRemove&&i.onRemove(this.map);}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be removed.")));},i.prototype.getLayer=function(t){return this._layers[t]},i.prototype.setLayerZoomRange=function(e,i,o){this._checkLoaded();var r=this.getLayer(e);r?r.minzoom===i&&r.maxzoom===o||(null!=i&&(r.minzoom=i),null!=o&&(r.maxzoom=o),this._updateLayer(r)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot have zoom extent.")));},i.prototype.setFilter=function(e,i,o){void 0===o&&(o={}),this._checkLoaded();var r=this.getLayer(e);if(r){if(!t.isEqual(r.filter,i))return null==i?(r.filter=void 0,void this._updateLayer(r)):void(this._validate(t.validateStyle.filter,"layers."+r.id+".filter",i,null,o)||(r.filter=t.clone(i),this._updateLayer(r)))}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be filtered.")));},i.prototype.getFilter=function(e){return t.clone(this.getLayer(e).filter)},i.prototype.setLayoutProperty=function(e,i,o,r){void 0===r&&(r={}),this._checkLoaded();var a=this.getLayer(e);a?t.isEqual(a.getLayoutProperty(i),o)||(a.setLayoutProperty(i,o,r),this._updateLayer(a)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getLayoutProperty=function(e,i){var o=this.getLayer(e);if(o)return o.getLayoutProperty(i);this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style.")));},i.prototype.setPaintProperty=function(e,i,o,r){void 0===r&&(r={}),this._checkLoaded();var a=this.getLayer(e);a?t.isEqual(a.getPaintProperty(i),o)||(a.setPaintProperty(i,o,r)&&this._updateLayer(a),this._changed=!0,this._updatedPaintProps[e]=!0):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getPaintProperty=function(t,e){return this.getLayer(t).getPaintProperty(e)},i.prototype.setFeatureState=function(e,i){this._checkLoaded();var o=e.source,r=e.sourceLayer,a=this.sourceCaches[o],n=parseInt(e.id,10);if(void 0!==a){var s=a.getSource().type;"geojson"===s&&r?this.fire(new t.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))):"vector"!==s||r?isNaN(n)||n<0?this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided and non-negative."))):a.setFeatureState(r,n,i):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+o+"' does not exist in the map's style.")));},i.prototype.removeFeatureState=function(e,i){this._checkLoaded();var o=e.source,r=this.sourceCaches[o];if(void 0!==r){var a=r.getSource().type,n="vector"===a?e.sourceLayer:void 0,s=parseInt(e.id,10);"vector"!==a||n?e.id&&isNaN(s)||s<0?this.fire(new t.ErrorEvent(new Error("The feature id parameter must be non-negative."))):!i||e.id?r.removeFeatureState(n,s,i):this.fire(new t.ErrorEvent(new Error("A feature id is requred to remove its specific state property."))):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+o+"' does not exist in the map's style.")));},i.prototype.getFeatureState=function(e){this._checkLoaded();var i=e.source,o=e.sourceLayer,r=this.sourceCaches[i],a=parseInt(e.id,10);if(void 0!==r)if("vector"!==r.getSource().type||o){if(!(isNaN(a)||a<0))return r.getFeatureState(o,a);this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided and non-negative.")));}else this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));else this.fire(new t.ErrorEvent(new Error("The source '"+i+"' does not exist in the map's style.")));},i.prototype.getTransition=function(){return t.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)},i.prototype.serialize=function(){return t.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,sources:t.mapObject(this.sourceCaches,function(t){return t.serialize()}),layers:this._serializeLayers(this._order)},function(t){return void 0!==t})},i.prototype._updateLayer=function(t){this._updatedLayers[t.id]=!0,t.source&&!this._updatedSources[t.source]&&(this._updatedSources[t.source]="reload",this.sourceCaches[t.source].pause()),this._changed=!0;},i.prototype._flattenAndSortRenderedFeatures=function(t){for(var e=[],i=[],o=this._order.length-1;o>=0;o--)for(var r=this._order[o],a=0,n=t;a<n.length;a+=1){var s=n[a][r];if(s)if("fill-extrusion"===this._layers[r].type)for(var l=0,c=s;l<c.length;l+=1){var u=c[l];i.push(u);}else for(var h=0,p=s;h<p.length;h+=1){var d=p[h];e.push(d.feature);}}i.sort(function(t,e){return t.intersectionZ-e.intersectionZ});for(var _=0,f=i;_<f.length;_+=1){var m=f[_];e.push(m.feature);}return e},i.prototype.queryRenderedFeatures=function(e,i,o){i&&i.filter&&this._validate(t.validateStyle.filter,"queryRenderedFeatures.filter",i.filter);var r={};if(i&&i.layers){if(!Array.isArray(i.layers))return this.fire(new t.ErrorEvent(new Error("parameters.layers must be an Array."))),[];for(var a=0,n=i.layers;a<n.length;a+=1){var s=n[a],l=this._layers[s];if(!l)return this.fire(new t.ErrorEvent(new Error("The layer '"+s+"' does not exist in the map's style and cannot be queried for features."))),[];r[l.source]=!0;}}var c=[];for(var u in this.sourceCaches)i.layers&&!r[u]||c.push(M(this.sourceCaches[u],this._layers,e,i,o));return this.placement&&c.push(function(t,e,i,o,r,a){for(var n={},s=r.queryRenderedSymbols(i),l=[],c=0,u=Object.keys(s).map(Number);c<u.length;c+=1){var h=u[c];l.push(a[h]);}l.sort(A);for(var p=function(){var e=_[d],i=e.featureIndex.lookupSymbolFeatures(s[e.bucketInstanceId],e.bucketIndex,e.sourceLayerIndex,o.filter,o.layers,t);for(var r in i){var a=n[r]=n[r]||[],l=i[r];l.sort(function(t,i){var o=e.featureSortOrder;if(o){var r=o.indexOf(t.featureIndex);return o.indexOf(i.featureIndex)-r}return i.featureIndex-t.featureIndex});for(var c=0,u=l;c<u.length;c+=1){var h=u[c];a.push(h);}}},d=0,_=l;d<_.length;d+=1)p();var f=function(i){n[i].forEach(function(o){var r=o.feature,a=t[i],n=e[a.source].getFeatureState(r.layer["source-layer"],r.id);r.source=r.layer.source,r.layer["source-layer"]&&(r.sourceLayer=r.layer["source-layer"]),r.state=n;});};for(var m in n)f(m);return n}(this._layers,this.sourceCaches,e,i,this.placement.collisionIndex,this.placement.retainedQueryData)),this._flattenAndSortRenderedFeatures(c)},i.prototype.querySourceFeatures=function(e,i){i&&i.filter&&this._validate(t.validateStyle.filter,"querySourceFeatures.filter",i.filter);var o=this.sourceCaches[e];return o?function(t,e){for(var i=t.getRenderableIds().map(function(e){return t.getTileByID(e)}),o=[],r={},a=0;a<i.length;a++){var n=i[a],s=n.tileID.canonical.key;r[s]||(r[s]=!0,n.querySourceFeatures(o,e));}return o}(o,i):[]},i.prototype.addSourceType=function(t,e,o){return i.getSourceType(t)?o(new Error('A source type called "'+t+'" already exists.')):(i.setSourceType(t,e),e.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:t,url:e.workerSourceURL},o):o(null,null))},i.prototype.getLight=function(){return this.light.getLight()},i.prototype.setLight=function(e,i){void 0===i&&(i={}),this._checkLoaded();var o=this.light.getLight(),r=!1;for(var a in e)if(!t.isEqual(e[a],o[a])){r=!0;break}if(r){var n={now:t.browser.now(),transition:t.extend({duration:300,delay:0},this.stylesheet.transition)};this.light.setLight(e,i),this.light.updateTransitions(n);}},i.prototype._validate=function(e,i,o,r,a){return void 0===a&&(a={}),(!a||!1!==a.validate)&&Pe(this,e.call(t.validateStyle,t.extend({key:i,style:this.serialize(),value:o,styleSpec:t.styleSpec},r)))},i.prototype._remove=function(){for(var e in this._request&&(this._request.cancel(),this._request=null),this._spriteRequest&&(this._spriteRequest.cancel(),this._spriteRequest=null),t.evented.off("pluginAvailable",this._rtlTextPluginCallback),this.sourceCaches)this.sourceCaches[e].clearTiles();this.dispatcher.remove();},i.prototype._clearSource=function(t){this.sourceCaches[t].clearTiles();},i.prototype._reloadSource=function(t){this.sourceCaches[t].resume(),this.sourceCaches[t].reload();},i.prototype._updateSources=function(t){for(var e in this.sourceCaches)this.sourceCaches[e].update(t);},i.prototype._generateCollisionBoxes=function(){for(var t in this.sourceCaches)this._reloadSource(t);},i.prototype._updatePlacement=function(e,i,o,r){for(var a=!1,n=!1,s={},l=0,c=this._order;l<c.length;l+=1){var u=c[l],h=this._layers[u];if("symbol"===h.type){if(!s[h.source]){var p=this.sourceCaches[h.source];s[h.source]=p.getRenderableIds(!0).map(function(t){return p.getTileByID(t)}).sort(function(t,e){return e.tileID.overscaledZ-t.tileID.overscaledZ||(t.tileID.isLessThan(e.tileID)?-1:1)});}var d=this.crossTileSymbolIndex.addLayer(h,s[h.source],e.center.lng);a=a||d;}}this.crossTileSymbolIndex.pruneUnusedLayers(this._order);var _=this._layerOrderChanged||0===o;if((_||!this.pauseablePlacement||this.pauseablePlacement.isDone()&&!this.placement.stillRecent(t.browser.now()))&&(this.pauseablePlacement=new Te(e,this._order,_,i,o,r),this._layerOrderChanged=!1),this.pauseablePlacement.isDone()?this.placement.setStale():(this.pauseablePlacement.continuePlacement(this._order,this._layers,s),this.pauseablePlacement.isDone()&&(this.placement=this.pauseablePlacement.commit(this.placement,t.browser.now()),n=!0),a&&this.pauseablePlacement.placement.setStale()),n||a)for(var f=0,m=this._order;f<m.length;f+=1){var g=m[f],v=this._layers[g];"symbol"===v.type&&this.placement.updateLayerOpacities(v,s[v.source]);}return !this.pauseablePlacement.isDone()||this.placement.hasTransitions(t.browser.now())},i.prototype._releaseSymbolFadeTiles=function(){for(var t in this.sourceCaches)this.sourceCaches[t].releaseSymbolFadeTiles();},i.prototype.getImages=function(t,e,i){this.imageManager.getImages(e.icons,i);},i.prototype.getGlyphs=function(t,e,i){this.glyphManager.getGlyphs(e.stacks,i);},i.prototype.getResource=function(e,i,o){return t.makeRequest(i,o)},i}(t.Evented);Me.getSourceType=function(t){return P[t]},Me.setSourceType=function(t,e){P[t]=e;},Me.registerForPluginAvailability=t.registerForPluginAvailability;var Ae=t.createLayout([{name:"a_pos",type:"Int16",components:2}]),ke=si("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif","#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"),Be=si("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Oe=si("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),Fe=si("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvarying vec3 v_data;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvarying vec3 v_data;void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/DEVICE_PIXEL_RATIO/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),Ue=si("void main() {gl_FragColor=vec4(1.0);}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Ne=si("#pragma mapbox: define highp float weight\nuniform highp float u_intensity;varying vec2 v_extrude;\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;const highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),Ze=si("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),je=si("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}","attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=a_extrude*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),Ve=si("uniform float u_overscale_factor;varying float v_placed;varying float v_notUsed;varying float v_radius;varying vec2 v_extrude;varying vec2 v_extrude_scale;void main() {float alpha=0.5;vec4 color=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {color=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {color*=.2;}float extrude_scale_length=length(v_extrude_scale);float extrude_length=length(v_extrude)*extrude_scale_length;float stroke_width=15.0*extrude_scale_length/u_overscale_factor;float radius=v_radius*extrude_scale_length;float distance_to_edge=abs(extrude_length-radius);float opacity_t=smoothstep(-stroke_width,0.0,-distance_to_edge);gl_FragColor=opacity_t*color;}","attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;varying float v_radius;varying vec2 v_extrude;varying vec2 v_extrude_scale;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);highp float padding_factor=1.2;gl_Position.xy+=a_extrude*u_extrude_scale*padding_factor*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;v_radius=abs(a_extrude.y);v_extrude=a_extrude*padding_factor;v_extrude_scale=u_extrude_scale*u_camera_to_center_distance*collision_perspective_ratio;}"),qe=si("uniform highp vec4 u_color;void main() {gl_FragColor=u_color;}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Ge=si("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),We=si("#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvarying vec2 v_pos;void main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),Xe=si("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec4 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),He=si("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec4 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileZoomRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),Ke=si("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);}"),Ye=si("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec4 u_scale;uniform float u_vertical_gradient;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));}"),Je=si("uniform sampler2D u_image;uniform float u_opacity;varying vec2 v_pos;void main() {gl_FragColor=texture2D(u_image,v_pos)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),Qe=si("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform float u_maxzoom;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;return (data.r+data.g*256.0+data.b*256.0*256.0)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggeration=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/ pow(2.0,(u_zoom-u_maxzoom)*exaggeration+19.2562-u_zoom);gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),$e=si("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),ti=si("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvarying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/DEVICE_PIXEL_RATIO)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define ANTIALIASING 1.0/DEVICE_PIXEL_RATIO/2.0\n#define scale 0.015873016\nattribute vec4 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_gl_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nvec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=a_pos_normal.xy;mediump vec2 normal=a_pos_normal.zw;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_gl_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),ei=si("#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nuniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp float v_lineprogress;void main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/DEVICE_PIXEL_RATIO)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,vec2(v_lineprogress,0.5));gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define MAX_LINE_DISTANCE 32767.0\n#define ANTIALIASING 1.0/DEVICE_PIXEL_RATIO/2.0\n#define scale 0.015873016\nattribute vec4 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_gl_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nvec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_lineprogress=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0/MAX_LINE_DISTANCE;vec2 pos=a_pos_normal.xy;mediump vec2 normal=a_pos_normal.zw;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_gl_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),ii=si("uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec4 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileZoomRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/DEVICE_PIXEL_RATIO)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x,1.0);float x_b=mod(v_linesofar/pattern_size_b.x,1.0);float y_a=0.5+(v_normal.y*clamp(v_width2.s,0.0,(pattern_size_a.y+2.0)/2.0)/pattern_size_a.y);float y_b=0.5+(v_normal.y*clamp(v_width2.s,0.0,(pattern_size_b.y+2.0)/2.0)/pattern_size_b.y);vec2 pos_a=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,vec2(x_a,y_a));vec2 pos_b=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,vec2(x_b,y_b));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\n#define ANTIALIASING 1.0/DEVICE_PIXEL_RATIO/2.0\nattribute vec4 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_gl_units_to_pixels;uniform mediump float u_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=a_pos_normal.xy;mediump vec2 normal=a_pos_normal.zw;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_gl_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);}"),oi=si("uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/DEVICE_PIXEL_RATIO)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\n#define ANTIALIASING 1.0/DEVICE_PIXEL_RATIO/2.0\nattribute vec4 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_gl_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nvec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=a_pos_normal.xy;mediump vec2 normal=a_pos_normal.zw;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_gl_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),ri=si("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),ai=si("uniform sampler2D u_texture;\n#pragma mapbox: define lowp float opacity\nvarying vec2 v_tex;varying float v_fade_opacity;void main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;\n#pragma mapbox: define lowp float opacity\nuniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_gl_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;void main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size[0],a_size[1],u_size_t)/256.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size[0]/256.0;} else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {size=u_size;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_gl_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"),ni=si("#define SDF_PX 8.0\n#define EDGE_GAMMA 0.105/DEVICE_PIXEL_RATIO\nuniform bool u_is_halo;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nuniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;void main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nuniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_gl_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;void main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size[0],a_size[1],u_size_t)/256.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size[0]/256.0;} else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {size=u_size;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_gl_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=vec2(tex.x,tex.y);v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}");function si(t,e){var i=/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,o={};return {fragmentSource:t=t.replace(i,function(t,e,i,r,a){return o[a]=!0,"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nvarying "+i+" "+r+" "+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"\n#ifdef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n"}),vertexSource:e=e.replace(i,function(t,e,i,r,a){var n="float"===r?"vec2":"vec4",s=a.match(/color/)?"color":n;return o[a]?"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nuniform lowp float a_"+a+"_t;\nattribute "+i+" "+n+" a_"+a+";\nvarying "+i+" "+r+" "+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"vec4"===s?"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+a+" = a_"+a+";\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+a+" = unpack_mix_"+s+"(a_"+a+", a_"+a+"_t);\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nuniform lowp float a_"+a+"_t;\nattribute "+i+" "+n+" a_"+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"vec4"===s?"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = a_"+a+";\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = unpack_mix_"+s+"(a_"+a+", a_"+a+"_t);\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n"})}}var li=Object.freeze({prelude:ke,background:Be,backgroundPattern:Oe,circle:Fe,clippingMask:Ue,heatmap:Ne,heatmapTexture:Ze,collisionBox:je,collisionCircle:Ve,debug:qe,fill:Ge,fillOutline:We,fillOutlinePattern:Xe,fillPattern:He,fillExtrusion:Ke,fillExtrusionPattern:Ye,extrusionTexture:Je,hillshadePrepare:Qe,hillshade:$e,line:ti,lineGradient:ei,linePattern:ii,lineSDF:oi,raster:ri,symbolIcon:ai,symbolSDF:ni}),ci=function(){this.boundProgram=null,this.boundLayoutVertexBuffer=null,this.boundPaintVertexBuffers=[],this.boundIndexBuffer=null,this.boundVertexOffset=null,this.boundDynamicVertexBuffer=null,this.vao=null;};ci.prototype.bind=function(t,e,i,o,r,a,n,s){this.context=t;for(var l=this.boundPaintVertexBuffers.length!==o.length,c=0;!l&&c<o.length;c++)this.boundPaintVertexBuffers[c]!==o[c]&&(l=!0);var u=!this.vao||this.boundProgram!==e||this.boundLayoutVertexBuffer!==i||l||this.boundIndexBuffer!==r||this.boundVertexOffset!==a||this.boundDynamicVertexBuffer!==n||this.boundDynamicVertexBuffer2!==s;!t.extVertexArrayObject||u?this.freshBind(e,i,o,r,a,n,s):(t.bindVertexArrayOES.set(this.vao),n&&n.bind(),r&&r.dynamicDraw&&r.bind(),s&&s.bind());},ci.prototype.freshBind=function(t,e,i,o,r,a,n){var s,l=t.numAttributes,c=this.context,u=c.gl;if(c.extVertexArrayObject)this.vao&&this.destroy(),this.vao=c.extVertexArrayObject.createVertexArrayOES(),c.bindVertexArrayOES.set(this.vao),s=0,this.boundProgram=t,this.boundLayoutVertexBuffer=e,this.boundPaintVertexBuffers=i,this.boundIndexBuffer=o,this.boundVertexOffset=r,this.boundDynamicVertexBuffer=a,this.boundDynamicVertexBuffer2=n;else{s=c.currentNumAttributes||0;for(var h=l;h<s;h++)u.disableVertexAttribArray(h);}e.enableAttributes(u,t);for(var p=0,d=i;p<d.length;p+=1){d[p].enableAttributes(u,t);}a&&a.enableAttributes(u,t),n&&n.enableAttributes(u,t),e.bind(),e.setVertexAttribPointers(u,t,r);for(var _=0,f=i;_<f.length;_+=1){var m=f[_];m.bind(),m.setVertexAttribPointers(u,t,r);}a&&(a.bind(),a.setVertexAttribPointers(u,t,r)),o&&o.bind(),n&&(n.bind(),n.setVertexAttribPointers(u,t,r)),c.currentNumAttributes=l;},ci.prototype.destroy=function(){this.vao&&(this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null);};var ui=function(e,i,o,r,a){var n=e.gl;this.program=n.createProgram();var s=o.defines().concat("#define DEVICE_PIXEL_RATIO "+t.browser.devicePixelRatio.toFixed(1));a&&s.push("#define OVERDRAW_INSPECTOR;");var l=s.concat(ke.fragmentSource,i.fragmentSource).join("\n"),c=s.concat(ke.vertexSource,i.vertexSource).join("\n"),u=n.createShader(n.FRAGMENT_SHADER);n.shaderSource(u,l),n.compileShader(u),n.attachShader(this.program,u);var h=n.createShader(n.VERTEX_SHADER);n.shaderSource(h,c),n.compileShader(h),n.attachShader(this.program,h);for(var p=o.layoutAttributes||[],d=0;d<p.length;d++)n.bindAttribLocation(this.program,d,p[d].name);n.linkProgram(this.program),this.numAttributes=n.getProgramParameter(this.program,n.ACTIVE_ATTRIBUTES),this.attributes={};for(var _={},f=0;f<this.numAttributes;f++){var m=n.getActiveAttrib(this.program,f);m&&(this.attributes[m.name]=n.getAttribLocation(this.program,m.name));}for(var g=n.getProgramParameter(this.program,n.ACTIVE_UNIFORMS),v=0;v<g;v++){var y=n.getActiveUniform(this.program,v);y&&(_[y.name]=n.getUniformLocation(this.program,y.name));}this.fixedUniforms=r(e,_),this.binderUniforms=o.getUniforms(e,_);};function hi(e,i,o){var r=1/se(o,1,i.transform.tileZoom),a=Math.pow(2,o.tileID.overscaledZ),n=o.tileSize*Math.pow(2,i.transform.tileZoom)/a,s=n*(o.tileID.canonical.x+o.tileID.wrap*a),l=n*o.tileID.canonical.y;return {u_image:0,u_texsize:o.imageAtlasTexture.size,u_scale:[t.browser.devicePixelRatio,r,e.fromScale,e.toScale],u_fade:e.t,u_pixel_coord_upper:[s>>16,l>>16],u_pixel_coord_lower:[65535&s,65535&l]}}ui.prototype.draw=function(t,e,i,o,r,a,n,s,l,c,u,h,p,d,_,f){var m,g=t.gl;for(var v in t.program.set(this.program),t.setDepthMode(i),t.setStencilMode(o),t.setColorMode(r),t.setCullFace(a),this.fixedUniforms)this.fixedUniforms[v].set(n[v]);d&&d.setUniforms(t,this.binderUniforms,h,{zoom:p});for(var y=(m={},m[g.LINES]=2,m[g.TRIANGLES]=3,m[g.LINE_STRIP]=1,m)[e],x=0,b=u.get();x<b.length;x+=1){var w=b[x],E=w.vaos||(w.vaos={});(E[s]||(E[s]=new ci)).bind(t,this,l,d?d.getPaintVertexBuffers():[],c,w.vertexOffset,_,f),g.drawElements(e,w.primitiveLength*y,g.UNSIGNED_SHORT,w.primitiveOffset*y*2);}};var pi=function(e,i,o){var r=i.style.light,a=r.properties.get("position"),n=[a.x,a.y,a.z],s=t.create();"viewport"===r.properties.get("anchor")&&t.fromRotation(s,-i.transform.angle),t.transformMat3(n,n,s);var l=r.properties.get("color");return {u_matrix:e,u_lightpos:n,u_lightintensity:r.properties.get("intensity"),u_lightcolor:[l.r,l.g,l.b],u_vertical_gradient:+o}},di=function(e,i,o,r,a,n){return t.extend(pi(e,i,o),hi(a,i,n),{u_height_factor:-Math.pow(2,r.overscaledZ)/n.tileSize/8})},_i=function(e,i,o){var r=t.create$1();t.ortho(r,0,e.width,e.height,0,0,1);var a=e.context.gl;return {u_matrix:r,u_world:[a.drawingBufferWidth,a.drawingBufferHeight],u_image:o,u_opacity:i}},fi=function(t){return {u_matrix:t}},mi=function(e,i,o,r){return t.extend(fi(e),hi(o,i,r))},gi=function(t,e){return {u_matrix:t,u_world:e}},vi=function(e,i,o,r,a){return t.extend(mi(e,i,o,r),{u_world:a})},yi=function(t,e,i,o){var r,a,n=t.transform;if("map"===o.paint.get("circle-pitch-alignment")){var s=se(i,1,n.zoom);r=!0,a=[s,s];}else r=!1,a=n.pixelsToGLUnits;return {u_camera_to_center_distance:n.cameraToCenterDistance,u_scale_with_map:+("map"===o.paint.get("circle-pitch-scale")),u_matrix:t.translatePosMatrix(e.posMatrix,i,o.paint.get("circle-translate"),o.paint.get("circle-translate-anchor")),u_pitch_with_map:+r,u_extrude_scale:a}},xi=function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pixels_to_tile_units:new t.Uniform1f(e,i.u_pixels_to_tile_units),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_overscale_factor:new t.Uniform1f(e,i.u_overscale_factor)}},bi=function(t,e,i){var o=se(i,1,e.zoom),r=Math.pow(2,e.zoom-i.tileID.overscaledZ),a=i.tileID.overscaleFactor();return {u_matrix:t,u_camera_to_center_distance:e.cameraToCenterDistance,u_pixels_to_tile_units:o,u_extrude_scale:[e.pixelsToGLUnits[0]/(o*r),e.pixelsToGLUnits[1]/(o*r)],u_overscale_factor:a}},wi=function(t,e){return {u_matrix:t,u_color:e}},Ei=function(t){return {u_matrix:t}},Ti=function(t,e,i,o){return {u_matrix:t,u_extrude_scale:se(e,1,i),u_intensity:o}},Ii=function(e,i,o,r){var a=t.create$1();t.ortho(a,0,e.width,e.height,0,0,1);var n=e.context.gl;return {u_matrix:a,u_world:[n.drawingBufferWidth,n.drawingBufferHeight],u_image:o,u_color_ramp:r,u_opacity:i.paint.get("heatmap-opacity")}},Ci=function(t,e,i){var o=i.paint.get("hillshade-shadow-color"),r=i.paint.get("hillshade-highlight-color"),a=i.paint.get("hillshade-accent-color"),n=i.paint.get("hillshade-illumination-direction")*(Math.PI/180);"viewport"===i.paint.get("hillshade-illumination-anchor")&&(n-=t.transform.angle);var s=!t.options.moving;return {u_matrix:t.transform.calculatePosMatrix(e.tileID.toUnwrapped(),s),u_image:0,u_latrange:zi(t,e.tileID),u_light:[i.paint.get("hillshade-exaggeration"),n],u_shadow:o,u_highlight:r,u_accent:a}},Si=function(e,i){var o=e.dem.stride,r=t.create$1();return t.ortho(r,0,t.EXTENT,-t.EXTENT,0,0,1),t.translate(r,r,[0,-t.EXTENT,0]),{u_matrix:r,u_image:1,u_dimension:[o,o],u_zoom:e.tileID.overscaledZ,u_maxzoom:i}};function zi(e,i){var o=Math.pow(2,i.canonical.z),r=i.canonical.y;return [new t.MercatorCoordinate(0,r/o).toLngLat().lat,new t.MercatorCoordinate(0,(r+1)/o).toLngLat().lat]}var Li=function(t,e,i){var o=t.transform;return {u_matrix:Ai(t,e,i),u_ratio:1/se(e,1,o.zoom),u_gl_units_to_pixels:[1/o.pixelsToGLUnits[0],1/o.pixelsToGLUnits[1]]}},Pi=function(e,i,o){return t.extend(Li(e,i,o),{u_image:0})},Di=function(e,i,o,r){var a=e.transform,n=Mi(i,a);return {u_matrix:Ai(e,i,o),u_texsize:i.imageAtlasTexture.size,u_ratio:1/se(i,1,a.zoom),u_image:0,u_scale:[t.browser.devicePixelRatio,n,r.fromScale,r.toScale],u_fade:r.t,u_gl_units_to_pixels:[1/a.pixelsToGLUnits[0],1/a.pixelsToGLUnits[1]]}},Ri=function(e,i,o,r,a){var n=e.transform,s=e.lineAtlas,l=Mi(i,n),c="round"===o.layout.get("line-cap"),u=s.getDash(r.from,c),h=s.getDash(r.to,c),p=u.width*a.fromScale,d=h.width*a.toScale;return t.extend(Li(e,i,o),{u_patternscale_a:[l/p,-u.height/2],u_patternscale_b:[l/d,-h.height/2],u_sdfgamma:s.width/(256*Math.min(p,d)*t.browser.devicePixelRatio)/2,u_image:0,u_tex_y_a:u.y,u_tex_y_b:h.y,u_mix:a.t})};function Mi(t,e){return 1/se(t,1,e.tileZoom)}function Ai(t,e,i){return t.translatePosMatrix(e.tileID.posMatrix,e,i.paint.get("line-translate"),i.paint.get("line-translate-anchor"))}var ki=function(t,e,i,o,r){return {u_matrix:t,u_tl_parent:e,u_scale_parent:i,u_buffer_scale:1,u_fade_t:o.mix,u_opacity:o.opacity*r.paint.get("raster-opacity"),u_image0:0,u_image1:1,u_brightness_low:r.paint.get("raster-brightness-min"),u_brightness_high:r.paint.get("raster-brightness-max"),u_saturation_factor:(n=r.paint.get("raster-saturation"),n>0?1-1/(1.001-n):-n),u_contrast_factor:(a=r.paint.get("raster-contrast"),a>0?1/(1-a):1+a),u_spin_weights:Bi(r.paint.get("raster-hue-rotate"))};var a,n;};function Bi(t){t*=Math.PI/180;var e=Math.sin(t),i=Math.cos(t);return [(2*i+1)/3,(-Math.sqrt(3)*e-i+1)/3,(Math.sqrt(3)*e-i+1)/3]}var Oi=function(t,e,i,o,r,a,n,s,l,c){var u=r.transform;return {u_is_size_zoom_constant:+("constant"===t||"source"===t),u_is_size_feature_constant:+("constant"===t||"camera"===t),u_size_t:e?e.uSizeT:0,u_size:e?e.uSize:0,u_camera_to_center_distance:u.cameraToCenterDistance,u_pitch:u.pitch/360*2*Math.PI,u_rotate_symbol:+i,u_aspect_ratio:u.width/u.height,u_fade_change:r.options.fadeDuration?r.symbolFadeChange:1,u_matrix:a,u_label_plane_matrix:n,u_gl_coord_matrix:s,u_is_text:+l,u_pitch_with_map:+o,u_texsize:c,u_texture:0}},Fi=function(e,i,o,r,a,n,s,l,c,u,h){var p=a.transform;return t.extend(Oi(e,i,o,r,a,n,s,l,c,u),{u_gamma_scale:r?Math.cos(p._pitch)*p.cameraToCenterDistance:1,u_is_halo:+h})},Ui=function(t,e,i){return {u_matrix:t,u_opacity:e,u_color:i}},Ni=function(e,i,o,r,a,n){return t.extend(function(t,e,i,o){var r=i.imageManager.getPattern(t.from),a=i.imageManager.getPattern(t.to),n=i.imageManager.getPixelSize(),s=n.width,l=n.height,c=Math.pow(2,o.tileID.overscaledZ),u=o.tileSize*Math.pow(2,i.transform.tileZoom)/c,h=u*(o.tileID.canonical.x+o.tileID.wrap*c),p=u*o.tileID.canonical.y;return {u_image:0,u_pattern_tl_a:r.tl,u_pattern_br_a:r.br,u_pattern_tl_b:a.tl,u_pattern_br_b:a.br,u_texsize:[s,l],u_mix:e.t,u_pattern_size_a:r.displaySize,u_pattern_size_b:a.displaySize,u_scale_a:e.fromScale,u_scale_b:e.toScale,u_tile_units_to_pixels:1/se(o,1,i.transform.tileZoom),u_pixel_coord_upper:[h>>16,p>>16],u_pixel_coord_lower:[65535&h,65535&p]}}(r,n,o,a),{u_matrix:e,u_opacity:i})},Zi={fillExtrusion:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient)}},fillExtrusionPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient),u_height_factor:new t.Uniform1f(e,i.u_height_factor),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},extrusionTexture:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_opacity:new t.Uniform1f(e,i.u_opacity)}},fill:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},fillPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},fillOutline:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world)}},fillOutlinePattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},circle:function(e,i){return {u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_scale_with_map:new t.Uniform1i(e,i.u_scale_with_map),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},collisionBox:xi,collisionCircle:xi,debug:function(e,i){return {u_color:new t.UniformColor(e,i.u_color),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},clippingMask:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmap:function(e,i){return {u_extrude_scale:new t.Uniform1f(e,i.u_extrude_scale),u_intensity:new t.Uniform1f(e,i.u_intensity),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmapTexture:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_color_ramp:new t.Uniform1i(e,i.u_color_ramp),u_opacity:new t.Uniform1f(e,i.u_opacity)}},hillshade:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_latrange:new t.Uniform2f(e,i.u_latrange),u_light:new t.Uniform2f(e,i.u_light),u_shadow:new t.UniformColor(e,i.u_shadow),u_highlight:new t.UniformColor(e,i.u_highlight),u_accent:new t.UniformColor(e,i.u_accent)}},hillshadePrepare:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_dimension:new t.Uniform2f(e,i.u_dimension),u_zoom:new t.Uniform1f(e,i.u_zoom),u_maxzoom:new t.Uniform1f(e,i.u_maxzoom)}},line:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_gl_units_to_pixels:new t.Uniform2f(e,i.u_gl_units_to_pixels)}},lineGradient:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_gl_units_to_pixels:new t.Uniform2f(e,i.u_gl_units_to_pixels),u_image:new t.Uniform1i(e,i.u_image)}},linePattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_texsize:new t.Uniform2f(e,i.u_texsize),u_ratio:new t.Uniform1f(e,i.u_ratio),u_image:new t.Uniform1i(e,i.u_image),u_gl_units_to_pixels:new t.Uniform2f(e,i.u_gl_units_to_pixels),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},lineSDF:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_gl_units_to_pixels:new t.Uniform2f(e,i.u_gl_units_to_pixels),u_patternscale_a:new t.Uniform2f(e,i.u_patternscale_a),u_patternscale_b:new t.Uniform2f(e,i.u_patternscale_b),u_sdfgamma:new t.Uniform1f(e,i.u_sdfgamma),u_image:new t.Uniform1i(e,i.u_image),u_tex_y_a:new t.Uniform1f(e,i.u_tex_y_a),u_tex_y_b:new t.Uniform1f(e,i.u_tex_y_b),u_mix:new t.Uniform1f(e,i.u_mix)}},raster:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_tl_parent:new t.Uniform2f(e,i.u_tl_parent),u_scale_parent:new t.Uniform1f(e,i.u_scale_parent),u_buffer_scale:new t.Uniform1f(e,i.u_buffer_scale),u_fade_t:new t.Uniform1f(e,i.u_fade_t),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image0:new t.Uniform1i(e,i.u_image0),u_image1:new t.Uniform1i(e,i.u_image1),u_brightness_low:new t.Uniform1f(e,i.u_brightness_low),u_brightness_high:new t.Uniform1f(e,i.u_brightness_high),u_saturation_factor:new t.Uniform1f(e,i.u_saturation_factor),u_contrast_factor:new t.Uniform1f(e,i.u_contrast_factor),u_spin_weights:new t.Uniform3f(e,i.u_spin_weights)}},symbolIcon:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_gl_coord_matrix:new t.UniformMatrix4f(e,i.u_gl_coord_matrix),u_is_text:new t.Uniform1f(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture)}},symbolSDF:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_gl_coord_matrix:new t.UniformMatrix4f(e,i.u_gl_coord_matrix),u_is_text:new t.Uniform1f(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture),u_gamma_scale:new t.Uniform1f(e,i.u_gamma_scale),u_is_halo:new t.Uniform1f(e,i.u_is_halo)}},background:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_color:new t.UniformColor(e,i.u_color)}},backgroundPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image:new t.Uniform1i(e,i.u_image),u_pattern_tl_a:new t.Uniform2f(e,i.u_pattern_tl_a),u_pattern_br_a:new t.Uniform2f(e,i.u_pattern_br_a),u_pattern_tl_b:new t.Uniform2f(e,i.u_pattern_tl_b),u_pattern_br_b:new t.Uniform2f(e,i.u_pattern_br_b),u_texsize:new t.Uniform2f(e,i.u_texsize),u_mix:new t.Uniform1f(e,i.u_mix),u_pattern_size_a:new t.Uniform2f(e,i.u_pattern_size_a),u_pattern_size_b:new t.Uniform2f(e,i.u_pattern_size_b),u_scale_a:new t.Uniform1f(e,i.u_scale_a),u_scale_b:new t.Uniform1f(e,i.u_scale_b),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_tile_units_to_pixels:new t.Uniform1f(e,i.u_tile_units_to_pixels)}}};function ji(e,i){for(var o=e.sort(function(t,e){return t.tileID.isLessThan(e.tileID)?-1:e.tileID.isLessThan(t.tileID)?1:0}),r=0;r<o.length;r++){var a={},n=o[r],s=o.slice(r+1);Vi(n.tileID.wrapped(),n.tileID,s,new t.OverscaledTileID(0,n.tileID.wrap+1,0,0,0),a),n.setMask(a,i);}}function Vi(e,i,o,r,a){for(var n=0;n<o.length;n++){var s=o[n];if(r.isLessThan(s.tileID))break;if(i.key===s.tileID.key)return;if(s.tileID.isChildOf(i)){for(var l=i.children(1/0),c=0;c<l.length;c++){Vi(e,l[c],o.slice(n),r,a);}return}}var u=i.overscaledZ-e.overscaledZ,h=new t.CanonicalTileID(u,i.canonical.x-(e.canonical.x<<u),i.canonical.y-(e.canonical.y<<u));a[h.key]=a[h.key]||h;}function qi(t,e,i,o,r){for(var a=t.context,n=a.gl,s=r?t.useProgram("collisionCircle"):t.useProgram("collisionBox"),l=0;l<o.length;l++){var c=o[l],u=e.getTile(c),h=u.getBucket(i);if(h){var p=r?h.collisionCircle:h.collisionBox;p&&s.draw(a,r?n.TRIANGLES:n.LINES,bt.disabled,wt.disabled,t.colorModeForRenderPass(),Tt.disabled,bi(c.posMatrix,t.transform,u),i.id,p.layoutVertexBuffer,p.indexBuffer,p.segments,null,t.transform.zoom,null,null,p.collisionVertexBuffer);}}}var Gi=t.identity(new Float32Array(16)),Wi=t.properties.layout;function Xi(e,i,o,r,a,n,s,l,c,u,h,p){for(var d,_,f=e.context,m=f.gl,g=e.transform,v="map"===l,y="map"===c,x=v&&"point"!==o.layout.get("symbol-placement"),b=v&&!y&&!x,w=void 0!==o.layout.get("symbol-sort-key").constantOr(1),E=e.depthModeForSublayer(0,bt.ReadOnly),T=[],I=0,C=r;I<C.length;I+=1){var S=C[I],z=i.getTile(S),L=z.getBucket(o);if(L){var P=a?L.text:L.icon;if(P&&P.segments.get().length){var D=P.programConfigurations.get(o.id),R=a||L.sdfIcons,M=a?L.textSizeData:L.iconSizeData;d||(d=e.useProgram(R?"symbolSDF":"symbolIcon",D),_=t.evaluateSizeForZoom(M,g.zoom,Wi.properties[a?"text-size":"icon-size"])),f.activeTexture.set(m.TEXTURE0);var A=void 0,k=void 0,B=void 0;if(a)k=z.glyphAtlasTexture,B=m.LINEAR,A=z.glyphAtlasTexture.size;else{var O=1!==o.layout.get("icon-size").constantOr(0)||L.iconsNeedLinear,F=y||0!==g.pitch;k=z.imageAtlasTexture,B=R||e.options.rotating||e.options.zooming||O||F?m.LINEAR:m.NEAREST,A=z.imageAtlasTexture.size;}var U=se(z,1,e.transform.zoom),N=Wt(S.posMatrix,y,v,e.transform,U),Z=Xt(S.posMatrix,y,v,e.transform,U);x&&Yt(L,S.posMatrix,e,a,N,Z,y,u);var j=e.translatePosMatrix(S.posMatrix,z,n,s),V=x?Gi:N,q=e.translatePosMatrix(Z,z,n,s,!0),G=R&&0!==o.paint.get(a?"text-halo-width":"icon-halo-width").constantOr(1),W={program:d,buffers:P,uniformValues:R?Fi(M.functionType,_,b,y,e,j,V,q,a,A,!0):Oi(M.functionType,_,b,y,e,j,V,q,a,A),atlasTexture:k,atlasInterpolation:B,isSDF:R,hasHalo:G};if(w)for(var X=0,H=P.segments.get();X<H.length;X+=1){var K=H[X];T.push({segments:new t.SegmentVector([K]),sortKey:K.sortKey,state:W});}else T.push({segments:P.segments,sortKey:0,state:W});}}}w&&T.sort(function(t,e){return t.sortKey-e.sortKey});for(var Y=0,J=T;Y<J.length;Y+=1){var Q=J[Y],$=Q.state;if($.atlasTexture.bind($.atlasInterpolation,m.CLAMP_TO_EDGE),$.isSDF){var tt=$.uniformValues;$.hasHalo&&(tt.u_is_halo=1,Hi($.buffers,Q.segments,o,e,$.program,E,h,p,tt)),tt.u_is_halo=0;}Hi($.buffers,Q.segments,o,e,$.program,E,h,p,$.uniformValues);}}function Hi(t,e,i,o,r,a,n,s,l){var c=o.context,u=c.gl;r.draw(c,u.TRIANGLES,a,n,s,Tt.disabled,l,i.id,t.layoutVertexBuffer,t.indexBuffer,e,i.paint,o.transform.zoom,t.programConfigurations.get(i.id),t.dynamicLayoutVertexBuffer,t.opacityVertexBuffer);}function Ki(t,e,i,o,r,a,n){var s,l,c,u,h,p=t.context.gl,d=i.paint.get("fill-pattern"),_=d&&d.constantOr(1),f=i.getCrossfadeParameters();n?(l=_&&!i.getPaintProperty("fill-outline-color")?"fillOutlinePattern":"fillOutline",s=p.LINES):(l=_?"fillPattern":"fill",s=p.TRIANGLES);for(var m=0,g=o;m<g.length;m+=1){var v=g[m],y=e.getTile(v);if(!_||y.patternsLoaded()){var x=y.getBucket(i);if(x){var b=x.programConfigurations.get(i.id),w=t.useProgram(l,b);_&&(t.context.activeTexture.set(p.TEXTURE0),y.imageAtlasTexture.bind(p.LINEAR,p.CLAMP_TO_EDGE),b.updatePatternPaintBuffers(f));var E=d.constantOr(null);if(E&&y.imageAtlas){var T=y.imageAtlas.patternPositions[E.to],I=y.imageAtlas.patternPositions[E.from];T&&I&&b.setConstantPatternPositions(T,I);}var C=t.translatePosMatrix(v.posMatrix,y,i.paint.get("fill-translate"),i.paint.get("fill-translate-anchor"));if(n){u=x.indexBuffer2,h=x.segments2;var S=[p.drawingBufferWidth,p.drawingBufferHeight];c="fillOutlinePattern"===l&&_?vi(C,t,f,y,S):gi(C,S);}else u=x.indexBuffer,h=x.segments,c=_?mi(C,t,f,y):fi(C);w.draw(t.context,s,r,t.stencilModeForClipping(v),a,Tt.disabled,c,i.id,x.layoutVertexBuffer,u,h,i.paint,t.transform.zoom,b);}}}}function Yi(e,i){var o=e.context,r=o.gl,a=i.viewportFrame;if(e.depthRboNeedsClear&&e.setupOffscreenDepthRenderbuffer(),!a){var n=new t.Texture(o,{width:e.width,height:e.height,data:null},r.RGBA);n.bind(r.LINEAR,r.CLAMP_TO_EDGE),(a=i.viewportFrame=o.createFramebuffer(e.width,e.height)).colorAttachment.set(n.texture);}o.bindFramebuffer.set(a.framebuffer),a.depthAttachment.set(e.depthRbo),e.depthRboNeedsClear&&(o.clear({depth:1}),e.depthRboNeedsClear=!1),o.clear({color:t.Color.transparent}),o.setStencilMode(wt.disabled),o.setDepthMode(new bt(r.LEQUAL,bt.ReadWrite,[0,1])),o.setColorMode(e.colorModeForRenderPass());}function Ji(t,e,i){var o=e.viewportFrame;if(o){var r=t.context,a=r.gl;r.activeTexture.set(a.TEXTURE0),a.bindTexture(a.TEXTURE_2D,o.colorAttachment.get()),t.useProgram("extrusionTexture").draw(r,a.TRIANGLES,bt.disabled,wt.disabled,t.colorModeForRenderPass(),Tt.disabled,_i(t,i,0),e.id,t.viewportBuffer,t.quadTriangleIndexBuffer,t.viewportSegments,e.paint,t.transform.zoom);}}function Qi(t,e,i,o,r,a){var n=t.context,s=n.gl,l=e.fbo;if(l){var c=t.useProgram("hillshade");n.activeTexture.set(s.TEXTURE0),s.bindTexture(s.TEXTURE_2D,l.colorAttachment.get());var u=Ci(t,e,i);e.maskedBoundsBuffer&&e.maskedIndexBuffer&&e.segments?c.draw(n,s.TRIANGLES,o,r,a,Tt.disabled,u,i.id,e.maskedBoundsBuffer,e.maskedIndexBuffer,e.segments):c.draw(n,s.TRIANGLES,o,r,a,Tt.disabled,u,i.id,t.rasterBoundsBuffer,t.quadTriangleIndexBuffer,t.rasterBoundsSegments);}}function $i(e,i,o,r,a,n,s){var l=e.context,c=l.gl;if(i.dem&&i.dem.data){var u=i.dem.dim,h=i.dem.stride,p=i.dem.getPixels();if(l.activeTexture.set(c.TEXTURE1),l.pixelStoreUnpackPremultiplyAlpha.set(!1),i.demTexture=i.demTexture||e.getTileTexture(h),i.demTexture){var d=i.demTexture;d.update(p,{premultiply:!1}),d.bind(c.NEAREST,c.CLAMP_TO_EDGE);}else i.demTexture=new t.Texture(l,p,c.RGBA,{premultiply:!1}),i.demTexture.bind(c.NEAREST,c.CLAMP_TO_EDGE);l.activeTexture.set(c.TEXTURE0);var _=i.fbo;if(!_){var f=new t.Texture(l,{width:u,height:u,data:null},c.RGBA);f.bind(c.LINEAR,c.CLAMP_TO_EDGE),(_=i.fbo=l.createFramebuffer(u,u)).colorAttachment.set(f.texture);}l.bindFramebuffer.set(_.framebuffer),l.viewport.set([0,0,u,u]),e.useProgram("hillshadePrepare").draw(l,c.TRIANGLES,a,n,s,Tt.disabled,Si(i,r),o.id,e.rasterBoundsBuffer,e.quadTriangleIndexBuffer,e.rasterBoundsSegments),i.needsHillshadePrepare=!1;}}function to(e,i,o,r,a){var n=r.paint.get("raster-fade-duration");if(n>0){var s=t.browser.now(),l=(s-e.timeAdded)/n,c=i?(s-i.timeAdded)/n:-1,u=o.getSource(),h=a.coveringZoomLevel({tileSize:u.tileSize,roundZoom:u.roundZoom}),p=!i||Math.abs(i.tileID.overscaledZ-h)>Math.abs(e.tileID.overscaledZ-h),d=p&&e.refreshedUponExpiration?1:t.clamp(p?l:1-c,0,1);return e.refreshedUponExpiration&&l>=1&&(e.refreshedUponExpiration=!1),i?{opacity:1,mix:1-d}:{opacity:d,mix:0}}return {opacity:1,mix:0}}function eo(e,i,o){var r=e.context,a=r.gl,n=o.posMatrix,s=e.useProgram("debug"),l=bt.disabled,c=wt.disabled,u=e.colorModeForRenderPass(),h="$debug";s.draw(r,a.LINE_STRIP,l,c,u,Tt.disabled,wi(n,t.Color.red),h,e.debugBuffer,e.tileBorderIndexBuffer,e.debugSegments);for(var p=function(t,e,i,o){o=o||1;var r,a,n,s,l,c,u,h,p=[];for(r=0,a=t.length;r<a;r++)if(l=io[t[r]]){for(h=null,n=0,s=l[1].length;n<s;n+=2)-1===l[1][n]&&-1===l[1][n+1]?h=null:(c=e+l[1][n]*o,u=i-l[1][n+1]*o,h&&p.push(h.x,h.y,c,u),h={x:c,y:u});e+=l[0]*o;}return p}(o.toString(),50,200,5),d=new t.StructArrayLayout2i4,_=new t.StructArrayLayout2ui4,f=0;f<p.length;f+=2)d.emplaceBack(p[f],p[f+1]),_.emplaceBack(f,f+1);for(var m=r.createVertexBuffer(d,Ae.members),g=r.createIndexBuffer(_),v=t.SegmentVector.simpleSegment(0,0,d.length/2,d.length/2),y=i.getTile(o).tileSize,x=t.EXTENT/(Math.pow(2,e.transform.zoom-o.overscaledZ)*y),b=[[-1,-1],[-1,1],[1,-1],[1,1]],w=0;w<b.length;w++){var E=b[w];s.draw(r,a.LINES,l,c,u,Tt.disabled,wi(t.translate([],n,[x*E[0],x*E[1],0]),t.Color.white),h,m,g,v);}s.draw(r,a.LINES,l,c,u,Tt.disabled,wi(n,t.Color.black),h,m,g,v);}var io={" ":[16,[]],"!":[10,[5,21,5,7,-1,-1,5,2,4,1,5,0,6,1,5,2]],'"':[16,[4,21,4,14,-1,-1,12,21,12,14]],"#":[21,[11,25,4,-7,-1,-1,17,25,10,-7,-1,-1,4,12,18,12,-1,-1,3,6,17,6]],$:[20,[8,25,8,-4,-1,-1,12,25,12,-4,-1,-1,17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],"%":[24,[21,21,3,0,-1,-1,8,21,10,19,10,17,9,15,7,14,5,14,3,16,3,18,4,20,6,21,8,21,10,20,13,19,16,19,19,20,21,21,-1,-1,17,7,15,6,14,4,14,2,16,0,18,0,20,1,21,3,21,5,19,7,17,7]],"&":[26,[23,12,23,13,22,14,21,14,20,13,19,11,17,6,15,3,13,1,11,0,7,0,5,1,4,2,3,4,3,6,4,8,5,9,12,13,13,14,14,16,14,18,13,20,11,21,9,20,8,18,8,16,9,13,11,10,16,3,18,1,20,0,22,0,23,1,23,2]],"'":[10,[5,19,4,20,5,21,6,20,6,18,5,16,4,15]],"(":[14,[11,25,9,23,7,20,5,16,4,11,4,7,5,2,7,-2,9,-5,11,-7]],")":[14,[3,25,5,23,7,20,9,16,10,11,10,7,9,2,7,-2,5,-5,3,-7]],"*":[16,[8,21,8,9,-1,-1,3,18,13,12,-1,-1,13,18,3,12]],"+":[26,[13,18,13,0,-1,-1,4,9,22,9]],",":[10,[6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"-":[26,[4,9,22,9]],".":[10,[5,2,4,1,5,0,6,1,5,2]],"/":[22,[20,25,2,-7]],0:[20,[9,21,6,20,4,17,3,12,3,9,4,4,6,1,9,0,11,0,14,1,16,4,17,9,17,12,16,17,14,20,11,21,9,21]],1:[20,[6,17,8,18,11,21,11,0]],2:[20,[4,16,4,17,5,19,6,20,8,21,12,21,14,20,15,19,16,17,16,15,15,13,13,10,3,0,17,0]],3:[20,[5,21,16,21,10,13,13,13,15,12,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],4:[20,[13,21,3,7,18,7,-1,-1,13,21,13,0]],5:[20,[15,21,5,21,4,12,5,13,8,14,11,14,14,13,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],6:[20,[16,18,15,20,12,21,10,21,7,20,5,17,4,12,4,7,5,3,7,1,10,0,11,0,14,1,16,3,17,6,17,7,16,10,14,12,11,13,10,13,7,12,5,10,4,7]],7:[20,[17,21,7,0,-1,-1,3,21,17,21]],8:[20,[8,21,5,20,4,18,4,16,5,14,7,13,11,12,14,11,16,9,17,7,17,4,16,2,15,1,12,0,8,0,5,1,4,2,3,4,3,7,4,9,6,11,9,12,13,13,15,14,16,16,16,18,15,20,12,21,8,21]],9:[20,[16,14,15,11,13,9,10,8,9,8,6,9,4,11,3,14,3,15,4,18,6,20,9,21,10,21,13,20,15,18,16,14,16,9,15,4,13,1,10,0,8,0,5,1,4,3]],":":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,5,2,4,1,5,0,6,1,5,2]],";":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"<":[24,[20,18,4,9,20,0]],"=":[26,[4,12,22,12,-1,-1,4,6,22,6]],">":[24,[4,18,20,9,4,0]],"?":[18,[3,16,3,17,4,19,5,20,7,21,11,21,13,20,14,19,15,17,15,15,14,13,13,12,9,10,9,7,-1,-1,9,2,8,1,9,0,10,1,9,2]],"@":[27,[18,13,17,15,15,16,12,16,10,15,9,14,8,11,8,8,9,6,11,5,14,5,16,6,17,8,-1,-1,12,16,10,14,9,11,9,8,10,6,11,5,-1,-1,18,16,17,8,17,6,19,5,21,5,23,7,24,10,24,12,23,15,22,17,20,19,18,20,15,21,12,21,9,20,7,19,5,17,4,15,3,12,3,9,4,6,5,4,7,2,9,1,12,0,15,0,18,1,20,2,21,3,-1,-1,19,16,18,8,18,6,19,5]],A:[18,[9,21,1,0,-1,-1,9,21,17,0,-1,-1,4,7,14,7]],B:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,-1,-1,4,11,13,11,16,10,17,9,18,7,18,4,17,2,16,1,13,0,4,0]],C:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5]],D:[21,[4,21,4,0,-1,-1,4,21,11,21,14,20,16,18,17,16,18,13,18,8,17,5,16,3,14,1,11,0,4,0]],E:[19,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11,-1,-1,4,0,17,0]],F:[18,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11]],G:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,18,8,-1,-1,13,8,18,8]],H:[22,[4,21,4,0,-1,-1,18,21,18,0,-1,-1,4,11,18,11]],I:[8,[4,21,4,0]],J:[16,[12,21,12,5,11,2,10,1,8,0,6,0,4,1,3,2,2,5,2,7]],K:[21,[4,21,4,0,-1,-1,18,21,4,7,-1,-1,9,12,18,0]],L:[17,[4,21,4,0,-1,-1,4,0,16,0]],M:[24,[4,21,4,0,-1,-1,4,21,12,0,-1,-1,20,21,12,0,-1,-1,20,21,20,0]],N:[22,[4,21,4,0,-1,-1,4,21,18,0,-1,-1,18,21,18,0]],O:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21]],P:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,14,17,12,16,11,13,10,4,10]],Q:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21,-1,-1,12,4,18,-2]],R:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,4,11,-1,-1,11,11,18,0]],S:[20,[17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],T:[16,[8,21,8,0,-1,-1,1,21,15,21]],U:[22,[4,21,4,6,5,3,7,1,10,0,12,0,15,1,17,3,18,6,18,21]],V:[18,[1,21,9,0,-1,-1,17,21,9,0]],W:[24,[2,21,7,0,-1,-1,12,21,7,0,-1,-1,12,21,17,0,-1,-1,22,21,17,0]],X:[20,[3,21,17,0,-1,-1,17,21,3,0]],Y:[18,[1,21,9,11,9,0,-1,-1,17,21,9,11]],Z:[20,[17,21,3,0,-1,-1,3,21,17,21,-1,-1,3,0,17,0]],"[":[14,[4,25,4,-7,-1,-1,5,25,5,-7,-1,-1,4,25,11,25,-1,-1,4,-7,11,-7]],"\\":[14,[0,21,14,-3]],"]":[14,[9,25,9,-7,-1,-1,10,25,10,-7,-1,-1,3,25,10,25,-1,-1,3,-7,10,-7]],"^":[16,[6,15,8,18,10,15,-1,-1,3,12,8,17,13,12,-1,-1,8,17,8,0]],_:[16,[0,-2,16,-2]],"`":[10,[6,21,5,20,4,18,4,16,5,15,6,16,5,17]],a:[19,[15,14,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],b:[19,[4,21,4,0,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],c:[18,[15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],d:[19,[15,21,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],e:[18,[3,8,15,8,15,10,14,12,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],f:[12,[10,21,8,21,6,20,5,17,5,0,-1,-1,2,14,9,14]],g:[19,[15,14,15,-2,14,-5,13,-6,11,-7,8,-7,6,-6,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],h:[19,[4,21,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],i:[8,[3,21,4,20,5,21,4,22,3,21,-1,-1,4,14,4,0]],j:[10,[5,21,6,20,7,21,6,22,5,21,-1,-1,6,14,6,-3,5,-6,3,-7,1,-7]],k:[17,[4,21,4,0,-1,-1,14,14,4,4,-1,-1,8,8,15,0]],l:[8,[4,21,4,0]],m:[30,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0,-1,-1,15,10,18,13,20,14,23,14,25,13,26,10,26,0]],n:[19,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],o:[19,[8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3,16,6,16,8,15,11,13,13,11,14,8,14]],p:[19,[4,14,4,-7,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],q:[19,[15,14,15,-7,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],r:[13,[4,14,4,0,-1,-1,4,8,5,11,7,13,9,14,12,14]],s:[17,[14,11,13,13,10,14,7,14,4,13,3,11,4,9,6,8,11,7,13,6,14,4,14,3,13,1,10,0,7,0,4,1,3,3]],t:[12,[5,21,5,4,6,1,8,0,10,0,-1,-1,2,14,9,14]],u:[19,[4,14,4,4,5,1,7,0,10,0,12,1,15,4,-1,-1,15,14,15,0]],v:[16,[2,14,8,0,-1,-1,14,14,8,0]],w:[22,[3,14,7,0,-1,-1,11,14,7,0,-1,-1,11,14,15,0,-1,-1,19,14,15,0]],x:[17,[3,14,14,0,-1,-1,14,14,3,0]],y:[16,[2,14,8,0,-1,-1,14,14,8,0,6,-4,4,-6,2,-7,1,-7]],z:[17,[14,14,3,0,-1,-1,3,14,14,14,-1,-1,3,0,14,0]],"{":[14,[9,25,7,24,6,23,5,21,5,19,6,17,7,16,8,14,8,12,6,10,-1,-1,7,24,6,22,6,20,7,18,8,17,9,15,9,13,8,11,4,9,8,7,9,5,9,3,8,1,7,0,6,-2,6,-4,7,-6,-1,-1,6,8,8,6,8,4,7,2,6,1,5,-1,5,-3,6,-5,7,-6,9,-7]],"|":[8,[4,25,4,-7]],"}":[14,[5,25,7,24,8,23,9,21,9,19,8,17,7,16,6,14,6,12,8,10,-1,-1,7,24,8,22,8,20,7,18,6,17,5,15,5,13,6,11,10,9,6,7,5,5,5,3,6,1,7,0,8,-2,8,-4,7,-6,-1,-1,8,8,6,6,6,4,7,2,8,1,9,-1,9,-3,8,-5,7,-6,5,-7]],"~":[24,[3,6,3,8,4,11,6,12,8,12,10,11,14,8,16,7,18,7,20,8,21,10,-1,-1,3,8,4,10,6,11,8,11,10,10,14,7,16,6,18,6,20,7,21,10,21,12]]};var oo={symbol:function(t,e,i,o){if("translucent"===t.renderPass){var r=wt.disabled,a=t.colorModeForRenderPass();0!==i.paint.get("icon-opacity").constantOr(1)&&Xi(t,e,i,o,!1,i.paint.get("icon-translate"),i.paint.get("icon-translate-anchor"),i.layout.get("icon-rotation-alignment"),i.layout.get("icon-pitch-alignment"),i.layout.get("icon-keep-upright"),r,a),0!==i.paint.get("text-opacity").constantOr(1)&&Xi(t,e,i,o,!0,i.paint.get("text-translate"),i.paint.get("text-translate-anchor"),i.layout.get("text-rotation-alignment"),i.layout.get("text-pitch-alignment"),i.layout.get("text-keep-upright"),r,a),e.map.showCollisionBoxes&&function(t,e,i,o){qi(t,e,i,o,!1),qi(t,e,i,o,!0);}(t,e,i,o);}},circle:function(t,e,i,o){if("translucent"===t.renderPass){var r=i.paint.get("circle-opacity"),a=i.paint.get("circle-stroke-width"),n=i.paint.get("circle-stroke-opacity");if(0!==r.constantOr(1)||0!==a.constantOr(1)&&0!==n.constantOr(1))for(var s=t.context,l=s.gl,c=t.depthModeForSublayer(0,bt.ReadOnly),u=wt.disabled,h=t.colorModeForRenderPass(),p=0;p<o.length;p++){var d=o[p],_=e.getTile(d),f=_.getBucket(i);if(f){var m=f.programConfigurations.get(i.id);t.useProgram("circle",m).draw(s,l.TRIANGLES,c,u,h,Tt.disabled,yi(t,d,_,i),i.id,f.layoutVertexBuffer,f.indexBuffer,f.segments,i.paint,t.transform.zoom,m);}}}},heatmap:function(e,i,o,r){if(0!==o.paint.get("heatmap-opacity"))if("offscreen"===e.renderPass){var a=e.context,n=a.gl,s=e.depthModeForSublayer(0,bt.ReadOnly),l=wt.disabled,c=new Et([n.ONE,n.ONE],t.Color.transparent,[!0,!0,!0,!0]);!function(t,e,i){var o=t.gl;t.activeTexture.set(o.TEXTURE1),t.viewport.set([0,0,e.width/4,e.height/4]);var r=i.heatmapFbo;if(r)o.bindTexture(o.TEXTURE_2D,r.colorAttachment.get()),t.bindFramebuffer.set(r.framebuffer);else{var a=o.createTexture();o.bindTexture(o.TEXTURE_2D,a),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_S,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_T,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MIN_FILTER,o.LINEAR),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MAG_FILTER,o.LINEAR),r=i.heatmapFbo=t.createFramebuffer(e.width/4,e.height/4),function t(e,i,o,r){var a=e.gl;a.texImage2D(a.TEXTURE_2D,0,a.RGBA,i.width/4,i.height/4,0,a.RGBA,e.extTextureHalfFloat?e.extTextureHalfFloat.HALF_FLOAT_OES:a.UNSIGNED_BYTE,null),r.colorAttachment.set(o),e.extTextureHalfFloat&&a.checkFramebufferStatus(a.FRAMEBUFFER)!==a.FRAMEBUFFER_COMPLETE&&(e.extTextureHalfFloat=null,r.colorAttachment.setDirty(),t(e,i,o,r));}(t,e,a,r);}}(a,e,o),a.clear({color:t.Color.transparent});for(var u=0;u<r.length;u++){var h=r[u];if(!i.hasRenderableParent(h)){var p=i.getTile(h),d=p.getBucket(o);if(d){var _=d.programConfigurations.get(o.id),f=e.useProgram("heatmap",_),m=e.transform.zoom;f.draw(a,n.TRIANGLES,s,l,c,Tt.disabled,Ti(h.posMatrix,p,m,o.paint.get("heatmap-intensity")),o.id,d.layoutVertexBuffer,d.indexBuffer,d.segments,o.paint,e.transform.zoom,_);}}}a.viewport.set([0,0,e.width,e.height]);}else"translucent"===e.renderPass&&(e.context.setColorMode(e.colorModeForRenderPass()),function(e,i){var o=e.context,r=o.gl,a=i.heatmapFbo;if(a){o.activeTexture.set(r.TEXTURE0),r.bindTexture(r.TEXTURE_2D,a.colorAttachment.get()),o.activeTexture.set(r.TEXTURE1);var n=i.colorRampTexture;n||(n=i.colorRampTexture=new t.Texture(o,i.colorRamp,r.RGBA)),n.bind(r.LINEAR,r.CLAMP_TO_EDGE),e.useProgram("heatmapTexture").draw(o,r.TRIANGLES,bt.disabled,wt.disabled,e.colorModeForRenderPass(),Tt.disabled,Ii(e,i,0,1),i.id,e.viewportBuffer,e.quadTriangleIndexBuffer,e.viewportSegments,i.paint,e.transform.zoom);}}(e,o));},line:function(e,i,o,r){if("translucent"===e.renderPass){var a=o.paint.get("line-opacity"),n=o.paint.get("line-width");if(0!==a.constantOr(1)&&0!==n.constantOr(1)){var s=e.depthModeForSublayer(0,bt.ReadOnly),l=e.colorModeForRenderPass(),c=o.paint.get("line-dasharray"),u=o.paint.get("line-pattern"),h=u.constantOr(1),p=o.paint.get("line-gradient"),d=o.getCrossfadeParameters(),_=c?"lineSDF":h?"linePattern":p?"lineGradient":"line",f=e.context,m=f.gl,g=!0;if(p){f.activeTexture.set(m.TEXTURE0);var v=o.gradientTexture;if(!o.gradient)return;v||(v=o.gradientTexture=new t.Texture(f,o.gradient,m.RGBA)),v.bind(m.LINEAR,m.CLAMP_TO_EDGE);}for(var y=0,x=r;y<x.length;y+=1){var b=x[y],w=i.getTile(b);if(!h||w.patternsLoaded()){var E=w.getBucket(o);if(E){var T=E.programConfigurations.get(o.id),I=e.context.program.get(),C=e.useProgram(_,T),S=g||C.program!==I,z=u.constantOr(null);if(z&&w.imageAtlas){var L=w.imageAtlas.patternPositions[z.to],P=w.imageAtlas.patternPositions[z.from];L&&P&&T.setConstantPatternPositions(L,P);}var D=c?Ri(e,w,o,c,d):h?Di(e,w,o,d):p?Pi(e,w,o):Li(e,w,o);c&&(S||e.lineAtlas.dirty)?(f.activeTexture.set(m.TEXTURE0),e.lineAtlas.bind(f)):h&&(f.activeTexture.set(m.TEXTURE0),w.imageAtlasTexture.bind(m.LINEAR,m.CLAMP_TO_EDGE),T.updatePatternPaintBuffers(d)),C.draw(f,m.TRIANGLES,s,e.stencilModeForClipping(b),l,Tt.disabled,D,o.id,E.layoutVertexBuffer,E.indexBuffer,E.segments,o.paint,e.transform.zoom,T),g=!1;}}}}}},fill:function(e,i,o,r){var a=o.paint.get("fill-color"),n=o.paint.get("fill-opacity");if(0!==n.constantOr(1)){var s=e.colorModeForRenderPass(),l=o.paint.get("fill-pattern").constantOr(1)||1!==a.constantOr(t.Color.transparent).a||1!==n.constantOr(0)?"translucent":"opaque";if(e.renderPass===l){var c=e.depthModeForSublayer(1,"opaque"===e.renderPass?bt.ReadWrite:bt.ReadOnly);Ki(e,i,o,r,c,s,!1);}if("translucent"===e.renderPass&&o.paint.get("fill-antialias")){var u=e.depthModeForSublayer(o.getPaintProperty("fill-outline-color")?2:0,bt.ReadOnly);Ki(e,i,o,r,u,s,!0);}}},"fill-extrusion":function(t,e,i,o){if(0!==i.paint.get("fill-extrusion-opacity"))if("offscreen"===t.renderPass){Yi(t,i);var r=new bt(t.context.gl.LEQUAL,bt.ReadWrite,[0,1]),a=wt.disabled,n=t.colorModeForRenderPass();!function(t,e,i,o,r,a,n){for(var s=t.context,l=s.gl,c=i.paint.get("fill-extrusion-pattern"),u=c.constantOr(1),h=i.getCrossfadeParameters(),p=0,d=o;p<d.length;p+=1){var _=d[p],f=e.getTile(_),m=f.getBucket(i);if(m){var g=m.programConfigurations.get(i.id),v=t.useProgram(u?"fillExtrusionPattern":"fillExtrusion",g);u&&(t.context.activeTexture.set(l.TEXTURE0),f.imageAtlasTexture.bind(l.LINEAR,l.CLAMP_TO_EDGE),g.updatePatternPaintBuffers(h));var y=c.constantOr(null);if(y&&f.imageAtlas){var x=f.imageAtlas.patternPositions[y.to],b=f.imageAtlas.patternPositions[y.from];x&&b&&g.setConstantPatternPositions(x,b);}var w=t.translatePosMatrix(_.posMatrix,f,i.paint.get("fill-extrusion-translate"),i.paint.get("fill-extrusion-translate-anchor")),E=i.paint.get("fill-extrusion-vertical-gradient"),T=u?di(w,t,E,_,h,f):pi(w,t,E);v.draw(s,s.gl.TRIANGLES,r,a,n,Tt.backCCW,T,i.id,m.layoutVertexBuffer,m.indexBuffer,m.segments,i.paint,t.transform.zoom,g);}}}(t,e,i,o,r,a,n);}else"translucent"===t.renderPass&&Ji(t,i,i.paint.get("fill-extrusion-opacity"));},hillshade:function(t,e,i,o){if("offscreen"===t.renderPass||"translucent"===t.renderPass){for(var r=t.context,a=e.getSource().maxzoom,n=t.depthModeForSublayer(0,bt.ReadOnly),s=wt.disabled,l=t.colorModeForRenderPass(),c=0,u=o;c<u.length;c+=1){var h=u[c],p=e.getTile(h);p.needsHillshadePrepare&&"offscreen"===t.renderPass?$i(t,p,i,a,n,s,l):"translucent"===t.renderPass&&Qi(t,p,i,n,s,l);}r.viewport.set([0,0,t.width,t.height]);}},raster:function(t,e,i,o){if("translucent"===t.renderPass&&0!==i.paint.get("raster-opacity"))for(var r=t.context,a=r.gl,n=e.getSource(),s=t.useProgram("raster"),l=wt.disabled,c=t.colorModeForRenderPass(),u=o.length&&o[0].overscaledZ,h=!t.options.moving,p=0,d=o;p<d.length;p+=1){var _=d[p],f=t.depthModeForSublayer(_.overscaledZ-u,1===i.paint.get("raster-opacity")?bt.ReadWrite:bt.ReadOnly,a.LESS),m=e.getTile(_),g=t.transform.calculatePosMatrix(_.toUnwrapped(),h);m.registerFadeDuration(i.paint.get("raster-fade-duration"));var v=e.findLoadedParent(_,0),y=to(m,v,e,i,t.transform),x=void 0,b=void 0,w="nearest"===i.paint.get("raster-resampling")?a.NEAREST:a.LINEAR;r.activeTexture.set(a.TEXTURE0),m.texture.bind(w,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),r.activeTexture.set(a.TEXTURE1),v?(v.texture.bind(w,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),x=Math.pow(2,v.tileID.overscaledZ-m.tileID.overscaledZ),b=[m.tileID.canonical.x*x%1,m.tileID.canonical.y*x%1]):m.texture.bind(w,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST);var E=ki(g,b||[0,0],x||1,y,i);n instanceof L?s.draw(r,a.TRIANGLES,f,l,c,Tt.disabled,E,i.id,n.boundsBuffer,t.quadTriangleIndexBuffer,n.boundsSegments):m.maskedBoundsBuffer&&m.maskedIndexBuffer&&m.segments?s.draw(r,a.TRIANGLES,f,l,c,Tt.disabled,E,i.id,m.maskedBoundsBuffer,m.maskedIndexBuffer,m.segments,i.paint,t.transform.zoom):s.draw(r,a.TRIANGLES,f,l,c,Tt.disabled,E,i.id,t.rasterBoundsBuffer,t.quadTriangleIndexBuffer,t.rasterBoundsSegments);}},background:function(t,e,i){var o=i.paint.get("background-color"),r=i.paint.get("background-opacity");if(0!==r){var a=t.context,n=a.gl,s=t.transform,l=s.tileSize,c=i.paint.get("background-pattern");if(!t.isPatternMissing(c)){var u=c||1!==o.a||1!==r?"translucent":"opaque";if(t.renderPass===u){var h=wt.disabled,p=t.depthModeForSublayer(0,"opaque"===u?bt.ReadWrite:bt.ReadOnly),d=t.colorModeForRenderPass(),_=t.useProgram(c?"backgroundPattern":"background"),f=s.coveringTiles({tileSize:l});c&&(a.activeTexture.set(n.TEXTURE0),t.imageManager.bind(t.context));for(var m=i.getCrossfadeParameters(),g=0,v=f;g<v.length;g+=1){var y=v[g],x=t.transform.calculatePosMatrix(y.toUnwrapped()),b=c?Ni(x,r,t,c,{tileID:y,tileSize:l},m):Ui(x,r,o);_.draw(a,n.TRIANGLES,p,h,d,Tt.disabled,b,i.id,t.tileExtentBuffer,t.quadTriangleIndexBuffer,t.tileExtentSegments);}}}}},debug:function(t,e,i){for(var o=0;o<i.length;o++)eo(t,e,i[o]);},custom:function(t,e,i){var o=t.context,r=i.implementation;if("offscreen"===t.renderPass){var a=r.prerender;a&&(t.setCustomLayerDefaults(),a.call(r,o.gl,t.transform.customLayerMatrix()),o.setDirty(),t.setBaseState()),"3d"===r.renderingMode&&(t.setCustomLayerDefaults(),Yi(t,i),r.render(o.gl,t.transform.customLayerMatrix()),o.setDirty(),t.setBaseState());}else if("translucent"===t.renderPass)if("3d"===r.renderingMode)Ji(t,i,1);else{t.setCustomLayerDefaults(),o.setColorMode(t.colorModeForRenderPass()),o.setStencilMode(wt.disabled);var n=t.depthModeForSublayer(0,bt.ReadOnly);o.setDepthMode(n),r.render(o.gl,t.transform.customLayerMatrix()),o.setDirty(),t.setBaseState(),o.bindFramebuffer.set(null);}}},ro=function(e,i){this.context=new It(e),this.transform=i,this._tileTextures={},this.setup(),this.numSublayers=Ct.maxUnderzooming+Ct.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.depthRboNeedsClear=!0,this.emptyProgramConfiguration=new t.ProgramConfiguration,this.crossTileSymbolIndex=new Le;};function ao(t,e){if(t.y>e.y){var i=t;t=e,e=i;}return {x0:t.x,y0:t.y,x1:e.x,y1:e.y,dx:e.x-t.x,dy:e.y-t.y}}function no(t,e,i,o,r){var a=Math.max(i,Math.floor(e.y0)),n=Math.min(o,Math.ceil(e.y1));if(t.x0===e.x0&&t.y0===e.y0?t.x0+e.dy/t.dy*t.dx<e.x1:t.x1-e.dy/t.dy*t.dx<e.x0){var s=t;t=e,e=s;}for(var l=t.dx/t.dy,c=e.dx/e.dy,u=t.dx>0,h=e.dx<0,p=a;p<n;p++){var d=l*Math.max(0,Math.min(t.dy,p+u-t.y0))+t.x0,_=c*Math.max(0,Math.min(e.dy,p+h-e.y0))+e.x0;r(Math.floor(_),Math.ceil(d),p);}}function so(t,e,i,o,r,a){var n,s=ao(t,e),l=ao(e,i),c=ao(i,t);s.dy>l.dy&&(n=s,s=l,l=n),s.dy>c.dy&&(n=s,s=c,c=n),l.dy>c.dy&&(n=l,l=c,c=n),s.dy&&no(c,s,o,r,a),l.dy&&no(c,l,o,r,a);}ro.prototype.resize=function(e,i){var o=this.context.gl;if(this.width=e*t.browser.devicePixelRatio,this.height=i*t.browser.devicePixelRatio,this.context.viewport.set([0,0,this.width,this.height]),this.style)for(var r=0,a=this.style._order;r<a.length;r+=1){var n=a[r];this.style._layers[n].resize();}this.depthRbo&&(o.deleteRenderbuffer(this.depthRbo),this.depthRbo=null);},ro.prototype.setup=function(){var e=this.context,i=new t.StructArrayLayout2i4;i.emplaceBack(0,0),i.emplaceBack(t.EXTENT,0),i.emplaceBack(0,t.EXTENT),i.emplaceBack(t.EXTENT,t.EXTENT),this.tileExtentBuffer=e.createVertexBuffer(i,Ae.members),this.tileExtentSegments=t.SegmentVector.simpleSegment(0,0,4,2);var o=new t.StructArrayLayout2i4;o.emplaceBack(0,0),o.emplaceBack(t.EXTENT,0),o.emplaceBack(0,t.EXTENT),o.emplaceBack(t.EXTENT,t.EXTENT),this.debugBuffer=e.createVertexBuffer(o,Ae.members),this.debugSegments=t.SegmentVector.simpleSegment(0,0,4,5);var r=new t.StructArrayLayout4i8;r.emplaceBack(0,0,0,0),r.emplaceBack(t.EXTENT,0,t.EXTENT,0),r.emplaceBack(0,t.EXTENT,0,t.EXTENT),r.emplaceBack(t.EXTENT,t.EXTENT,t.EXTENT,t.EXTENT),this.rasterBoundsBuffer=e.createVertexBuffer(r,t.rasterBoundsAttributes.members),this.rasterBoundsSegments=t.SegmentVector.simpleSegment(0,0,4,2);var a=new t.StructArrayLayout2i4;a.emplaceBack(0,0),a.emplaceBack(1,0),a.emplaceBack(0,1),a.emplaceBack(1,1),this.viewportBuffer=e.createVertexBuffer(a,Ae.members),this.viewportSegments=t.SegmentVector.simpleSegment(0,0,4,2);var n=new t.StructArrayLayout1ui2;n.emplaceBack(0),n.emplaceBack(1),n.emplaceBack(3),n.emplaceBack(2),n.emplaceBack(0),this.tileBorderIndexBuffer=e.createIndexBuffer(n);var s=new t.StructArrayLayout3ui6;s.emplaceBack(0,1,2),s.emplaceBack(2,1,3),this.quadTriangleIndexBuffer=e.createIndexBuffer(s);var l=this.context.gl;this.stencilClearMode=new wt({func:l.ALWAYS,mask:0},0,255,l.ZERO,l.ZERO,l.ZERO);},ro.prototype.clearStencil=function(){var e=this.context,i=e.gl,o=t.create$1();t.ortho(o,0,this.width,this.height,0,0,1),t.scale(o,o,[i.drawingBufferWidth,i.drawingBufferHeight,0]),this.useProgram("clippingMask").draw(e,i.TRIANGLES,bt.disabled,this.stencilClearMode,Et.disabled,Tt.disabled,Ei(o),"$clipping",this.viewportBuffer,this.quadTriangleIndexBuffer,this.viewportSegments);},ro.prototype._renderTileClippingMasks=function(t){var e=this.context,i=e.gl;e.setColorMode(Et.disabled),e.setDepthMode(bt.disabled);var o=this.useProgram("clippingMask"),r=1;this._tileClippingMaskIDs={};for(var a=0,n=t;a<n.length;a+=1){var s=n[a],l=this._tileClippingMaskIDs[s.key]=r++;o.draw(e,i.TRIANGLES,bt.disabled,new wt({func:i.ALWAYS,mask:0},l,255,i.KEEP,i.KEEP,i.REPLACE),Et.disabled,Tt.disabled,Ei(s.posMatrix),"$clipping",this.tileExtentBuffer,this.quadTriangleIndexBuffer,this.tileExtentSegments);}},ro.prototype.stencilModeForClipping=function(t){var e=this.context.gl;return new wt({func:e.EQUAL,mask:255},this._tileClippingMaskIDs[t.key],0,e.KEEP,e.KEEP,e.REPLACE)},ro.prototype.colorModeForRenderPass=function(){var e=this.context.gl;if(this._showOverdrawInspector){return new Et([e.CONSTANT_COLOR,e.ONE],new t.Color(1/8,1/8,1/8,0),[!0,!0,!0,!0])}return "opaque"===this.renderPass?Et.unblended:Et.alphaBlended},ro.prototype.depthModeForSublayer=function(t,e,i){var o=1-((1+this.currentLayer)*this.numSublayers+t)*this.depthEpsilon;return new bt(i||this.context.gl.LEQUAL,e,[o,o])},ro.prototype.render=function(e,i){this.style=e,this.options=i,this.lineAtlas=e.lineAtlas,this.imageManager=e.imageManager,this.glyphManager=e.glyphManager,this.symbolFadeChange=e.placement.symbolFadeChange(t.browser.now());var o=this.style._order,r=this.style.sourceCaches;for(var a in r){var n=r[a];n.used&&n.prepare(this.context);}var s,l={},c={},u={};for(var h in r){var p=r[h];l[h]=p.getVisibleCoordinates(),c[h]=l[h].slice().reverse(),u[h]=p.getVisibleCoordinates(!0).reverse();}for(var d in r){var _=r[d],f=_.getSource();if("raster"===f.type||"raster-dem"===f.type){for(var m=[],g=0,v=l[d];g<v.length;g+=1){var y=v[g];m.push(_.getTile(y));}ji(m,this.context);}}this.renderPass="offscreen",this.depthRboNeedsClear=!0;for(var x=0,b=o;x<b.length;x+=1){var w=b[x],E=this.style._layers[w];if(E.hasOffscreenPass()&&!E.isHidden(this.transform.zoom)){var T=c[E.source];("custom"===E.type||T.length)&&this.renderLayer(this,r[E.source],E,T);}}for(this.context.bindFramebuffer.set(null),this.context.clear({color:i.showOverdrawInspector?t.Color.black:t.Color.transparent,depth:1}),this._showOverdrawInspector=i.showOverdrawInspector,this.depthRange=(e._order.length+2)*this.numSublayers*this.depthEpsilon,this.renderPass="opaque",this.currentLayer=o.length-1;this.currentLayer>=0;this.currentLayer--){var I=this.style._layers[o[this.currentLayer]],C=r[I.source],S=l[I.source];I.source!==s&&C&&(this.clearStencil(),C.getSource().isTileClipped&&this._renderTileClippingMasks(S)),this.renderLayer(this,C,I,S),s=I.source;}for(this.renderPass="translucent",this.currentLayer=0,s=null;this.currentLayer<o.length;this.currentLayer++){var z=this.style._layers[o[this.currentLayer]],L=r[z.source],P=("symbol"===z.type?u:c)[z.source];z.source!==s&&L&&(this.clearStencil(),L.getSource().isTileClipped&&this._renderTileClippingMasks(l[z.source])),this.renderLayer(this,L,z,P),s=z.source;}if(this.options.showTileBoundaries)for(var D in r){oo.debug(this,r[D],l[D]);break}this.setCustomLayerDefaults();},ro.prototype.setupOffscreenDepthRenderbuffer=function(){var t=this.context;this.depthRbo||(this.depthRbo=t.createRenderbuffer(t.gl.DEPTH_COMPONENT16,this.width,this.height));},ro.prototype.renderLayer=function(t,e,i,o){i.isHidden(this.transform.zoom)||("background"===i.type||"custom"===i.type||o.length)&&(this.id=i.id,oo[i.type](t,e,i,o));},ro.prototype.translatePosMatrix=function(e,i,o,r,a){if(!o[0]&&!o[1])return e;var n=a?"map"===r?this.transform.angle:0:"viewport"===r?-this.transform.angle:0;if(n){var s=Math.sin(n),l=Math.cos(n);o=[o[0]*l-o[1]*s,o[0]*s+o[1]*l];}var c=[a?o[0]:se(i,o[0],this.transform.zoom),a?o[1]:se(i,o[1],this.transform.zoom),0],u=new Float32Array(16);return t.translate(u,e,c),u},ro.prototype.saveTileTexture=function(t){var e=this._tileTextures[t.size[0]];e?e.push(t):this._tileTextures[t.size[0]]=[t];},ro.prototype.getTileTexture=function(t){var e=this._tileTextures[t];return e&&e.length>0?e.pop():null},ro.prototype.isPatternMissing=function(t){if(!t)return !1;var e=this.imageManager.getPattern(t.from),i=this.imageManager.getPattern(t.to);return !e||!i},ro.prototype.useProgram=function(t,e){void 0===e&&(e=this.emptyProgramConfiguration),this.cache=this.cache||{};var i=""+t+(e.cacheKey||"")+(this._showOverdrawInspector?"/overdraw":"");return this.cache[i]||(this.cache[i]=new ui(this.context,li[t],e,Zi[t],this._showOverdrawInspector)),this.cache[i]},ro.prototype.setCustomLayerDefaults=function(){this.context.unbindVAO(),this.context.cullFace.setDefault(),this.context.activeTexture.setDefault(),this.context.pixelStoreUnpack.setDefault(),this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.context.pixelStoreUnpackFlipY.setDefault();},ro.prototype.setBaseState=function(){var t=this.context.gl;this.context.cullFace.set(!1),this.context.viewport.set([0,0,this.width,this.height]),this.context.blendEquation.set(t.FUNC_ADD);};var lo=function(e,i,o){this.tileSize=512,this.maxValidLatitude=85.051129,this._renderWorldCopies=void 0===o||o,this._minZoom=e||0,this._maxZoom=i||22,this.setMaxBounds(),this.width=0,this.height=0,this._center=new t.LngLat(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._unmodified=!0,this._posMatrixCache={},this._alignedPosMatrixCache={};},co={minZoom:{configurable:!0},maxZoom:{configurable:!0},renderWorldCopies:{configurable:!0},worldSize:{configurable:!0},centerPoint:{configurable:!0},size:{configurable:!0},bearing:{configurable:!0},pitch:{configurable:!0},fov:{configurable:!0},zoom:{configurable:!0},center:{configurable:!0},unmodified:{configurable:!0},point:{configurable:!0}};lo.prototype.clone=function(){var t=new lo(this._minZoom,this._maxZoom,this._renderWorldCopies);return t.tileSize=this.tileSize,t.latRange=this.latRange,t.width=this.width,t.height=this.height,t._center=this._center,t.zoom=this.zoom,t.angle=this.angle,t._fov=this._fov,t._pitch=this._pitch,t._unmodified=this._unmodified,t._calcMatrices(),t},co.minZoom.get=function(){return this._minZoom},co.minZoom.set=function(t){this._minZoom!==t&&(this._minZoom=t,this.zoom=Math.max(this.zoom,t));},co.maxZoom.get=function(){return this._maxZoom},co.maxZoom.set=function(t){this._maxZoom!==t&&(this._maxZoom=t,this.zoom=Math.min(this.zoom,t));},co.renderWorldCopies.get=function(){return this._renderWorldCopies},co.renderWorldCopies.set=function(t){void 0===t?t=!0:null===t&&(t=!1),this._renderWorldCopies=t;},co.worldSize.get=function(){return this.tileSize*this.scale},co.centerPoint.get=function(){return this.size._div(2)},co.size.get=function(){return new t.Point(this.width,this.height)},co.bearing.get=function(){return -this.angle/Math.PI*180},co.bearing.set=function(e){var i=-t.wrap(e,-180,180)*Math.PI/180;this.angle!==i&&(this._unmodified=!1,this.angle=i,this._calcMatrices(),this.rotationMatrix=t.create$2(),t.rotate(this.rotationMatrix,this.rotationMatrix,this.angle));},co.pitch.get=function(){return this._pitch/Math.PI*180},co.pitch.set=function(e){var i=t.clamp(e,0,60)/180*Math.PI;this._pitch!==i&&(this._unmodified=!1,this._pitch=i,this._calcMatrices());},co.fov.get=function(){return this._fov/Math.PI*180},co.fov.set=function(t){t=Math.max(.01,Math.min(60,t)),this._fov!==t&&(this._unmodified=!1,this._fov=t/180*Math.PI,this._calcMatrices());},co.zoom.get=function(){return this._zoom},co.zoom.set=function(t){var e=Math.min(Math.max(t,this.minZoom),this.maxZoom);this._zoom!==e&&(this._unmodified=!1,this._zoom=e,this.scale=this.zoomScale(e),this.tileZoom=Math.floor(e),this.zoomFraction=e-this.tileZoom,this._constrain(),this._calcMatrices());},co.center.get=function(){return this._center},co.center.set=function(t){t.lat===this._center.lat&&t.lng===this._center.lng||(this._unmodified=!1,this._center=t,this._constrain(),this._calcMatrices());},lo.prototype.coveringZoomLevel=function(t){return (t.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/t.tileSize))},lo.prototype.getVisibleUnwrappedCoordinates=function(e){var i=[new t.UnwrappedTileID(0,e)];if(this._renderWorldCopies)for(var o=this.pointCoordinate(new t.Point(0,0)),r=this.pointCoordinate(new t.Point(this.width,0)),a=this.pointCoordinate(new t.Point(this.width,this.height)),n=this.pointCoordinate(new t.Point(0,this.height)),s=Math.floor(Math.min(o.x,r.x,a.x,n.x)),l=Math.floor(Math.max(o.x,r.x,a.x,n.x)),c=s-1;c<=l+1;c++)0!==c&&i.push(new t.UnwrappedTileID(c,e));return i},lo.prototype.coveringTiles=function(e){var i=this.coveringZoomLevel(e),o=i;if(void 0!==e.minzoom&&i<e.minzoom)return [];void 0!==e.maxzoom&&i>e.maxzoom&&(i=e.maxzoom);var r=t.MercatorCoordinate.fromLngLat(this.center),a=Math.pow(2,i),n=new t.Point(a*r.x-.5,a*r.y-.5);return function(e,i,o,r){void 0===r&&(r=!0);var a=1<<e,n={};function s(i,s,l){var c,u,h,p;if(l>=0&&l<=a)for(c=i;c<s;c++)u=Math.floor(c/a),h=(c%a+a)%a,0!==u&&!0!==r||(p=new t.OverscaledTileID(o,u,e,h,l),n[p.key]=p);}var l=i.map(function(e){return new t.Point(e.x,e.y)._mult(a)});return so(l[0],l[1],l[2],0,a,s),so(l[2],l[3],l[0],0,a,s),Object.keys(n).map(function(t){return n[t]})}(i,[this.pointCoordinate(new t.Point(0,0)),this.pointCoordinate(new t.Point(this.width,0)),this.pointCoordinate(new t.Point(this.width,this.height)),this.pointCoordinate(new t.Point(0,this.height))],e.reparseOverscaled?o:i,this._renderWorldCopies).sort(function(t,e){return n.dist(t.canonical)-n.dist(e.canonical)})},lo.prototype.resize=function(t,e){this.width=t,this.height=e,this.pixelsToGLUnits=[2/t,-2/e],this._constrain(),this._calcMatrices();},co.unmodified.get=function(){return this._unmodified},lo.prototype.zoomScale=function(t){return Math.pow(2,t)},lo.prototype.scaleZoom=function(t){return Math.log(t)/Math.LN2},lo.prototype.project=function(e){var i=t.clamp(e.lat,-this.maxValidLatitude,this.maxValidLatitude);return new t.Point(t.mercatorXfromLng(e.lng)*this.worldSize,t.mercatorYfromLat(i)*this.worldSize)},lo.prototype.unproject=function(e){return new t.MercatorCoordinate(e.x/this.worldSize,e.y/this.worldSize).toLngLat()},co.point.get=function(){return this.project(this.center)},lo.prototype.setLocationAtPoint=function(e,i){var o=this.pointCoordinate(i),r=this.pointCoordinate(this.centerPoint),a=this.locationCoordinate(e),n=new t.MercatorCoordinate(a.x-(o.x-r.x),a.y-(o.y-r.y));this.center=this.coordinateLocation(n),this._renderWorldCopies&&(this.center=this.center.wrap());},lo.prototype.locationPoint=function(t){return this.coordinatePoint(this.locationCoordinate(t))},lo.prototype.pointLocation=function(t){return this.coordinateLocation(this.pointCoordinate(t))},lo.prototype.locationCoordinate=function(e){return t.MercatorCoordinate.fromLngLat(e)},lo.prototype.coordinateLocation=function(t){return t.toLngLat()},lo.prototype.pointCoordinate=function(e){var i=[e.x,e.y,0,1],o=[e.x,e.y,1,1];t.transformMat4(i,i,this.pixelMatrixInverse),t.transformMat4(o,o,this.pixelMatrixInverse);var r=i[3],a=o[3],n=i[0]/r,s=o[0]/a,l=i[1]/r,c=o[1]/a,u=i[2]/r,h=o[2]/a,p=u===h?0:(0-u)/(h-u);return new t.MercatorCoordinate(t.number(n,s,p)/this.worldSize,t.number(l,c,p)/this.worldSize)},lo.prototype.coordinatePoint=function(e){var i=[e.x*this.worldSize,e.y*this.worldSize,0,1];return t.transformMat4(i,i,this.pixelMatrix),new t.Point(i[0]/i[3],i[1]/i[3])},lo.prototype.getBounds=function(){return (new t.LngLatBounds).extend(this.pointLocation(new t.Point(0,0))).extend(this.pointLocation(new t.Point(this.width,0))).extend(this.pointLocation(new t.Point(this.width,this.height))).extend(this.pointLocation(new t.Point(0,this.height)))},lo.prototype.getMaxBounds=function(){return this.latRange&&2===this.latRange.length&&this.lngRange&&2===this.lngRange.length?new t.LngLatBounds([this.lngRange[0],this.latRange[0]],[this.lngRange[1],this.latRange[1]]):null},lo.prototype.setMaxBounds=function(t){t?(this.lngRange=[t.getWest(),t.getEast()],this.latRange=[t.getSouth(),t.getNorth()],this._constrain()):(this.lngRange=null,this.latRange=[-this.maxValidLatitude,this.maxValidLatitude]);},lo.prototype.calculatePosMatrix=function(e,i){void 0===i&&(i=!1);var o=e.key,r=i?this._alignedPosMatrixCache:this._posMatrixCache;if(r[o])return r[o];var a=e.canonical,n=this.worldSize/this.zoomScale(a.z),s=a.x+Math.pow(2,a.z)*e.wrap,l=t.identity(new Float64Array(16));return t.translate(l,l,[s*n,a.y*n,0]),t.scale(l,l,[n/t.EXTENT,n/t.EXTENT,1]),t.multiply(l,i?this.alignedProjMatrix:this.projMatrix,l),r[o]=new Float32Array(l),r[o]},lo.prototype.customLayerMatrix=function(){return this.mercatorMatrix.slice()},lo.prototype._constrain=function(){if(this.center&&this.width&&this.height&&!this._constraining){this._constraining=!0;var e,i,o,r,a=-90,n=90,s=-180,l=180,c=this.size,u=this._unmodified;if(this.latRange){var h=this.latRange;a=t.mercatorYfromLat(h[1])*this.worldSize,e=(n=t.mercatorYfromLat(h[0])*this.worldSize)-a<c.y?c.y/(n-a):0;}if(this.lngRange){var p=this.lngRange;s=t.mercatorXfromLng(p[0])*this.worldSize,i=(l=t.mercatorXfromLng(p[1])*this.worldSize)-s<c.x?c.x/(l-s):0;}var d=this.point,_=Math.max(i||0,e||0);if(_)return this.center=this.unproject(new t.Point(i?(l+s)/2:d.x,e?(n+a)/2:d.y)),this.zoom+=this.scaleZoom(_),this._unmodified=u,void(this._constraining=!1);if(this.latRange){var f=d.y,m=c.y/2;f-m<a&&(r=a+m),f+m>n&&(r=n-m);}if(this.lngRange){var g=d.x,v=c.x/2;g-v<s&&(o=s+v),g+v>l&&(o=l-v);}void 0===o&&void 0===r||(this.center=this.unproject(new t.Point(void 0!==o?o:d.x,void 0!==r?r:d.y))),this._unmodified=u,this._constraining=!1;}},lo.prototype._calcMatrices=function(){if(this.height){this.cameraToCenterDistance=.5/Math.tan(this._fov/2)*this.height;var e=this._fov/2,i=Math.PI/2+this._pitch,o=Math.sin(e)*this.cameraToCenterDistance/Math.sin(Math.PI-i-e),r=this.point,a=r.x,n=r.y,s=1.01*(Math.cos(Math.PI/2-this._pitch)*o+this.cameraToCenterDistance),l=new Float64Array(16);t.perspective(l,this._fov,this.width/this.height,1,s),t.scale(l,l,[1,-1,1]),t.translate(l,l,[0,0,-this.cameraToCenterDistance]),t.rotateX(l,l,this._pitch),t.rotateZ(l,l,this.angle),t.translate(l,l,[-a,-n,0]),this.mercatorMatrix=t.scale([],l,[this.worldSize,this.worldSize,this.worldSize]),t.scale(l,l,[1,1,t.mercatorZfromAltitude(1,this.center.lat)*this.worldSize,1]),this.projMatrix=l;var c=this.width%2/2,u=this.height%2/2,h=Math.cos(this.angle),p=Math.sin(this.angle),d=a-Math.round(a)+h*c+p*u,_=n-Math.round(n)+h*u+p*c,f=new Float64Array(l);if(t.translate(f,f,[d>.5?d-1:d,_>.5?_-1:_,0]),this.alignedProjMatrix=f,l=t.create$1(),t.scale(l,l,[this.width/2,-this.height/2,1]),t.translate(l,l,[1,-1,0]),this.pixelMatrix=t.multiply(new Float64Array(16),l,this.projMatrix),!(l=t.invert(new Float64Array(16),this.pixelMatrix)))throw new Error("failed to invert matrix");this.pixelMatrixInverse=l,this._posMatrixCache={},this._alignedPosMatrixCache={};}},lo.prototype.maxPitchScaleFactor=function(){if(!this.pixelMatrixInverse)return 1;var e=this.pointCoordinate(new t.Point(0,0)),i=[e.x*this.worldSize,e.y*this.worldSize,0,1];return t.transformMat4(i,i,this.pixelMatrix)[3]/this.cameraToCenterDistance},lo.prototype.getCameraPoint=function(){var e=this._pitch,i=Math.tan(e)*(this.cameraToCenterDistance||1);return this.centerPoint.add(new t.Point(0,i))},lo.prototype.getCameraQueryGeometry=function(e){var i=this.getCameraPoint();if(1===e.length)return [e[0],i];for(var o=i.x,r=i.y,a=i.x,n=i.y,s=0,l=e;s<l.length;s+=1){var c=l[s];o=Math.min(o,c.x),r=Math.min(r,c.y),a=Math.max(a,c.x),n=Math.max(n,c.y);}return [new t.Point(o,r),new t.Point(a,r),new t.Point(a,n),new t.Point(o,n),new t.Point(o,r)]},Object.defineProperties(lo.prototype,co);var uo=function(){var e,i,o,r,a;t.bindAll(["_onHashChange","_updateHash"],this),this._updateHash=(e=this._updateHashUnthrottled.bind(this),i=300,o=!1,r=0,a=function(){r=0,o&&(e(),r=setTimeout(a,i),o=!1);},function(){return o=!0,r||a(),r});};uo.prototype.addTo=function(e){return this._map=e,t.window.addEventListener("hashchange",this._onHashChange,!1),this._map.on("moveend",this._updateHash),this},uo.prototype.remove=function(){return t.window.removeEventListener("hashchange",this._onHashChange,!1),this._map.off("moveend",this._updateHash),clearTimeout(this._updateHash()),delete this._map,this},uo.prototype.getHashString=function(t){var e=this._map.getCenter(),i=Math.round(100*this._map.getZoom())/100,o=Math.ceil((i*Math.LN2+Math.log(512/360/.5))/Math.LN10),r=Math.pow(10,o),a=Math.round(e.lng*r)/r,n=Math.round(e.lat*r)/r,s=this._map.getBearing(),l=this._map.getPitch(),c="";return c+=t?"#/"+a+"/"+n+"/"+i:"#"+i+"/"+n+"/"+a,(s||l)&&(c+="/"+Math.round(10*s)/10),l&&(c+="/"+Math.round(l)),c},uo.prototype._onHashChange=function(){var e=t.window.location.hash.replace("#","").split("/");return e.length>=3&&(this._map.jumpTo({center:[+e[2],+e[1]],zoom:+e[0],bearing:+(e[3]||0),pitch:+(e[4]||0)}),!0)},uo.prototype._updateHashUnthrottled=function(){var e=this.getHashString();try{t.window.history.replaceState(t.window.history.state,"",e);}catch(t){}};var ho=function(e){function o(o,r,a,n){void 0===n&&(n={});var s=i.mousePos(r.getCanvasContainer(),a),l=r.unproject(s);e.call(this,o,t.extend({point:s,lngLat:l,originalEvent:a},n)),this._defaultPrevented=!1,this.target=r;}e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o;var r={defaultPrevented:{configurable:!0}};return o.prototype.preventDefault=function(){this._defaultPrevented=!0;},r.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(o.prototype,r),o}(t.Event),po=function(e){function o(o,r,a){var n=i.touchPos(r.getCanvasContainer(),a),s=n.map(function(t){return r.unproject(t)}),l=n.reduce(function(t,e,i,o){return t.add(e.div(o.length))},new t.Point(0,0)),c=r.unproject(l);e.call(this,o,{points:n,point:l,lngLats:s,lngLat:c,originalEvent:a}),this._defaultPrevented=!1;}e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o;var r={defaultPrevented:{configurable:!0}};return o.prototype.preventDefault=function(){this._defaultPrevented=!0;},r.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(o.prototype,r),o}(t.Event),_o=function(t){function e(e,i,o){t.call(this,e,{originalEvent:o}),this._defaultPrevented=!1;}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var i={defaultPrevented:{configurable:!0}};return e.prototype.preventDefault=function(){this._defaultPrevented=!0;},i.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(e.prototype,i),e}(t.Event),fo=function(e){this._map=e,this._el=e.getCanvasContainer(),this._delta=0,t.bindAll(["_onWheel","_onTimeout","_onScrollFrame","_onScrollFinished"],this);};fo.prototype.isEnabled=function(){return !!this._enabled},fo.prototype.isActive=function(){return !!this._active},fo.prototype.isZooming=function(){return !!this._zooming},fo.prototype.enable=function(t){this.isEnabled()||(this._enabled=!0,this._aroundCenter=t&&"center"===t.around);},fo.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},fo.prototype.onWheel=function(e){if(this.isEnabled()){var i=e.deltaMode===t.window.WheelEvent.DOM_DELTA_LINE?40*e.deltaY:e.deltaY,o=t.browser.now(),r=o-(this._lastWheelEventTime||0);this._lastWheelEventTime=o,0!==i&&i%4.000244140625==0?this._type="wheel":0!==i&&Math.abs(i)<4?this._type="trackpad":r>400?(this._type=null,this._lastValue=i,this._timeout=setTimeout(this._onTimeout,40,e)):this._type||(this._type=Math.abs(r*i)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,i+=this._lastValue)),e.shiftKey&&i&&(i/=4),this._type&&(this._lastWheelEvent=e,this._delta-=i,this.isActive()||this._start(e)),e.preventDefault();}},fo.prototype._onTimeout=function(t){this._type="wheel",this._delta-=this._lastValue,this.isActive()||this._start(t);},fo.prototype._start=function(e){if(this._delta){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),this._active=!0,this._zooming=!0,this._map.fire(new t.Event("movestart",{originalEvent:e})),this._map.fire(new t.Event("zoomstart",{originalEvent:e})),this._finishTimeout&&clearTimeout(this._finishTimeout);var o=i.mousePos(this._el,e);this._around=t.LngLat.convert(this._aroundCenter?this._map.getCenter():this._map.unproject(o)),this._aroundPoint=this._map.transform.locationPoint(this._around),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onScrollFrame));}},fo.prototype._onScrollFrame=function(){var e=this;if(this._frameId=null,this.isActive()){var i=this._map.transform;if(0!==this._delta){var o="wheel"===this._type&&Math.abs(this._delta)>4.000244140625?1/450:.01,r=2/(1+Math.exp(-Math.abs(this._delta*o)));this._delta<0&&0!==r&&(r=1/r);var a="number"==typeof this._targetZoom?i.zoomScale(this._targetZoom):i.scale;this._targetZoom=Math.min(i.maxZoom,Math.max(i.minZoom,i.scaleZoom(a*r))),"wheel"===this._type&&(this._startZoom=i.zoom,this._easing=this._smoothOutEasing(200)),this._delta=0;}var n="number"==typeof this._targetZoom?this._targetZoom:i.zoom,s=this._startZoom,l=this._easing,c=!1;if("wheel"===this._type&&s&&l){var u=Math.min((t.browser.now()-this._lastWheelEventTime)/200,1),h=l(u);i.zoom=t.number(s,n,h),u<1?this._frameId||(this._frameId=this._map._requestRenderFrame(this._onScrollFrame)):c=!0;}else i.zoom=n,c=!0;i.setLocationAtPoint(this._around,this._aroundPoint),this._map.fire(new t.Event("move",{originalEvent:this._lastWheelEvent})),this._map.fire(new t.Event("zoom",{originalEvent:this._lastWheelEvent})),c&&(this._active=!1,this._finishTimeout=setTimeout(function(){e._zooming=!1,e._map.fire(new t.Event("zoomend",{originalEvent:e._lastWheelEvent})),e._map.fire(new t.Event("moveend",{originalEvent:e._lastWheelEvent})),delete e._targetZoom;},200));}},fo.prototype._smoothOutEasing=function(e){var i=t.ease;if(this._prevEase){var o=this._prevEase,r=(t.browser.now()-o.start)/o.duration,a=o.easing(r+.01)-o.easing(r),n=.27/Math.sqrt(a*a+1e-4)*.01,s=Math.sqrt(.0729-n*n);i=t.bezier(n,s,.25,1);}return this._prevEase={start:t.browser.now(),duration:e,easing:i},i};var mo=function(e,i){this._map=e,this._el=e.getCanvasContainer(),this._container=e.getContainer(),this._clickTolerance=i.clickTolerance||1,t.bindAll(["_onMouseMove","_onMouseUp","_onKeyDown"],this);};mo.prototype.isEnabled=function(){return !!this._enabled},mo.prototype.isActive=function(){return !!this._active},mo.prototype.enable=function(){this.isEnabled()||(this._enabled=!0);},mo.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},mo.prototype.onMouseDown=function(e){this.isEnabled()&&e.shiftKey&&0===e.button&&(t.window.document.addEventListener("mousemove",this._onMouseMove,!1),t.window.document.addEventListener("keydown",this._onKeyDown,!1),t.window.document.addEventListener("mouseup",this._onMouseUp,!1),i.disableDrag(),this._startPos=this._lastPos=i.mousePos(this._el,e),this._active=!0);},mo.prototype._onMouseMove=function(t){var e=i.mousePos(this._el,t);if(!(this._lastPos.equals(e)||!this._box&&e.dist(this._startPos)<this._clickTolerance)){var o=this._startPos;this._lastPos=e,this._box||(this._box=i.create("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",t));var r=Math.min(o.x,e.x),a=Math.max(o.x,e.x),n=Math.min(o.y,e.y),s=Math.max(o.y,e.y);i.setTransform(this._box,"translate("+r+"px,"+n+"px)"),this._box.style.width=a-r+"px",this._box.style.height=s-n+"px";}},mo.prototype._onMouseUp=function(e){if(0===e.button){var o=this._startPos,r=i.mousePos(this._el,e);this._finish(),i.suppressClick(),o.x===r.x&&o.y===r.y?this._fireEvent("boxzoomcancel",e):this._map.fitScreenCoordinates(o,r,this._map.getBearing(),{linear:!0}).fire(new t.Event("boxzoomend",{originalEvent:e}));}},mo.prototype._onKeyDown=function(t){27===t.keyCode&&(this._finish(),this._fireEvent("boxzoomcancel",t));},mo.prototype._finish=function(){this._active=!1,t.window.document.removeEventListener("mousemove",this._onMouseMove,!1),t.window.document.removeEventListener("keydown",this._onKeyDown,!1),t.window.document.removeEventListener("mouseup",this._onMouseUp,!1),this._container.classList.remove("mapboxgl-crosshair"),this._box&&(i.remove(this._box),this._box=null),i.enableDrag(),delete this._startPos,delete this._lastPos;},mo.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,{originalEvent:i}))};var go=t.bezier(0,0,.25,1),vo=function(e,i){this._map=e,this._el=i.element||e.getCanvasContainer(),this._state="disabled",this._button=i.button||"right",this._bearingSnap=i.bearingSnap||0,this._pitchWithRotate=!1!==i.pitchWithRotate,t.bindAll(["onMouseDown","_onMouseMove","_onMouseUp","_onBlur","_onDragFrame"],this);};vo.prototype.isEnabled=function(){return "disabled"!==this._state},vo.prototype.isActive=function(){return "active"===this._state},vo.prototype.enable=function(){this.isEnabled()||(this._state="enabled");},vo.prototype.disable=function(){if(this.isEnabled())switch(this._state){case"active":this._state="disabled",this._unbind(),this._deactivate(),this._fireEvent("rotateend"),this._pitchWithRotate&&this._fireEvent("pitchend"),this._fireEvent("moveend");break;case"pending":this._state="disabled",this._unbind();break;default:this._state="disabled";}},vo.prototype.onMouseDown=function(e){if("enabled"===this._state){if("right"===this._button){if(this._eventButton=i.mouseButton(e),this._eventButton!==(e.ctrlKey?0:2))return}else{if(e.ctrlKey||0!==i.mouseButton(e))return;this._eventButton=0;}i.disableDrag(),t.window.document.addEventListener("mousemove",this._onMouseMove,{capture:!0}),t.window.document.addEventListener("mouseup",this._onMouseUp),t.window.addEventListener("blur",this._onBlur),this._state="pending",this._inertia=[[t.browser.now(),this._map.getBearing()]],this._startPos=this._lastPos=i.mousePos(this._el,e),this._center=this._map.transform.centerPoint,e.preventDefault();}},vo.prototype._onMouseMove=function(t){var e=i.mousePos(this._el,t);this._lastPos.equals(e)||(this._lastMoveEvent=t,this._lastPos=e,"pending"===this._state&&(this._state="active",this._fireEvent("rotatestart",t),this._fireEvent("movestart",t),this._pitchWithRotate&&this._fireEvent("pitchstart",t)),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onDragFrame)));},vo.prototype._onDragFrame=function(){this._frameId=null;var e=this._lastMoveEvent;if(e){var i=this._map.transform,o=this._startPos,r=this._lastPos,a=.8*(o.x-r.x),n=-.5*(o.y-r.y),s=i.bearing-a,l=i.pitch-n,c=this._inertia,u=c[c.length-1];this._drainInertiaBuffer(),c.push([t.browser.now(),this._map._normalizeBearing(s,u[1])]),i.bearing=s,this._pitchWithRotate&&(this._fireEvent("pitch",e),i.pitch=l),this._fireEvent("rotate",e),this._fireEvent("move",e),delete this._lastMoveEvent,this._startPos=this._lastPos;}},vo.prototype._onMouseUp=function(t){if(i.mouseButton(t)===this._eventButton)switch(this._state){case"active":this._state="enabled",i.suppressClick(),this._unbind(),this._deactivate(),this._inertialRotate(t);break;case"pending":this._state="enabled",this._unbind();}},vo.prototype._onBlur=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._fireEvent("rotateend",t),this._pitchWithRotate&&this._fireEvent("pitchend",t),this._fireEvent("moveend",t);break;case"pending":this._state="enabled",this._unbind();}},vo.prototype._unbind=function(){t.window.document.removeEventListener("mousemove",this._onMouseMove,{capture:!0}),t.window.document.removeEventListener("mouseup",this._onMouseUp),t.window.removeEventListener("blur",this._onBlur),i.enableDrag();},vo.prototype._deactivate=function(){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._lastMoveEvent,delete this._startPos,delete this._lastPos;},vo.prototype._inertialRotate=function(t){var e=this;this._fireEvent("rotateend",t),this._drainInertiaBuffer();var i=this._map,o=i.getBearing(),r=this._inertia,a=function(){Math.abs(o)<e._bearingSnap?i.resetNorth({noMoveStart:!0},{originalEvent:t}):e._fireEvent("moveend",t),e._pitchWithRotate&&e._fireEvent("pitchend",t);};if(r.length<2)a();else{var n=r[0],s=r[r.length-1],l=r[r.length-2],c=i._normalizeBearing(o,l[1]),u=s[1]-n[1],h=u<0?-1:1,p=(s[0]-n[0])/1e3;if(0!==u&&0!==p){var d=Math.abs(u*(.25/p));d>180&&(d=180);var _=d/180;c+=h*d*(_/2),Math.abs(i._normalizeBearing(c,0))<this._bearingSnap&&(c=i._normalizeBearing(0,c)),i.rotateTo(c,{duration:1e3*_,easing:go,noMoveStart:!0},{originalEvent:t});}else a();}},vo.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,i?{originalEvent:i}:{}))},vo.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>0&&i-e[0][0]>160;)e.shift();};var yo=t.bezier(0,0,.3,1),xo=function(e,i){this._map=e,this._el=e.getCanvasContainer(),this._state="disabled",this._clickTolerance=i.clickTolerance||1,t.bindAll(["_onMove","_onMouseUp","_onTouchEnd","_onBlur","_onDragFrame"],this);};xo.prototype.isEnabled=function(){return "disabled"!==this._state},xo.prototype.isActive=function(){return "active"===this._state},xo.prototype.enable=function(){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-drag-pan"),this._state="enabled");},xo.prototype.disable=function(){if(this.isEnabled())switch(this._el.classList.remove("mapboxgl-touch-drag-pan"),this._state){case"active":this._state="disabled",this._unbind(),this._deactivate(),this._fireEvent("dragend"),this._fireEvent("moveend");break;case"pending":this._state="disabled",this._unbind();break;default:this._state="disabled";}},xo.prototype.onMouseDown=function(e){"enabled"===this._state&&(e.ctrlKey||0!==i.mouseButton(e)||(i.addEventListener(t.window.document,"mousemove",this._onMove,{capture:!0}),i.addEventListener(t.window.document,"mouseup",this._onMouseUp),this._start(e)));},xo.prototype.onTouchStart=function(e){"enabled"===this._state&&(e.touches.length>1||(i.addEventListener(t.window.document,"touchmove",this._onMove,{capture:!0,passive:!1}),i.addEventListener(t.window.document,"touchend",this._onTouchEnd),this._start(e)));},xo.prototype._start=function(e){t.window.addEventListener("blur",this._onBlur),this._state="pending",this._startPos=this._mouseDownPos=this._lastPos=i.mousePos(this._el,e),this._inertia=[[t.browser.now(),this._startPos]];},xo.prototype._onMove=function(e){e.preventDefault();var o=i.mousePos(this._el,e);this._lastPos.equals(o)||"pending"===this._state&&o.dist(this._mouseDownPos)<this._clickTolerance||(this._lastMoveEvent=e,this._lastPos=o,this._drainInertiaBuffer(),this._inertia.push([t.browser.now(),this._lastPos]),"pending"===this._state&&(this._state="active",this._fireEvent("dragstart",e),this._fireEvent("movestart",e)),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onDragFrame)));},xo.prototype._onDragFrame=function(){this._frameId=null;var t=this._lastMoveEvent;if(t){var e=this._map.transform;e.setLocationAtPoint(e.pointLocation(this._startPos),this._lastPos),this._fireEvent("drag",t),this._fireEvent("move",t),this._startPos=this._lastPos,delete this._lastMoveEvent;}},xo.prototype._onMouseUp=function(t){if(0===i.mouseButton(t))switch(this._state){case"active":this._state="enabled",i.suppressClick(),this._unbind(),this._deactivate(),this._inertialPan(t);break;case"pending":this._state="enabled",this._unbind();}},xo.prototype._onTouchEnd=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._inertialPan(t);break;case"pending":this._state="enabled",this._unbind();}},xo.prototype._onBlur=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._fireEvent("dragend",t),this._fireEvent("moveend",t);break;case"pending":this._state="enabled",this._unbind();}},xo.prototype._unbind=function(){i.removeEventListener(t.window.document,"touchmove",this._onMove,{capture:!0,passive:!1}),i.removeEventListener(t.window.document,"touchend",this._onTouchEnd),i.removeEventListener(t.window.document,"mousemove",this._onMove,{capture:!0}),i.removeEventListener(t.window.document,"mouseup",this._onMouseUp),i.removeEventListener(t.window,"blur",this._onBlur);},xo.prototype._deactivate=function(){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._lastMoveEvent,delete this._startPos,delete this._mouseDownPos,delete this._lastPos;},xo.prototype._inertialPan=function(t){this._fireEvent("dragend",t),this._drainInertiaBuffer();var e=this._inertia;if(e.length<2)this._fireEvent("moveend",t);else{var i=e[e.length-1],o=e[0],r=i[1].sub(o[1]),a=(i[0]-o[0])/1e3;if(0===a||i[1].equals(o[1]))this._fireEvent("moveend",t);else{var n=r.mult(.3/a),s=n.mag();s>1400&&(s=1400,n._unit()._mult(s));var l=s/750,c=n.mult(-l/2);this._map.panBy(c,{duration:1e3*l,easing:yo,noMoveStart:!0},{originalEvent:t});}}},xo.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,i?{originalEvent:i}:{}))},xo.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>0&&i-e[0][0]>160;)e.shift();};var bo=function(e){this._map=e,this._el=e.getCanvasContainer(),t.bindAll(["_onKeyDown"],this);};function wo(t){return t*(2-t)}bo.prototype.isEnabled=function(){return !!this._enabled},bo.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("keydown",this._onKeyDown,!1),this._enabled=!0);},bo.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("keydown",this._onKeyDown),this._enabled=!1);},bo.prototype._onKeyDown=function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var e=0,i=0,o=0,r=0,a=0;switch(t.keyCode){case 61:case 107:case 171:case 187:e=1;break;case 189:case 109:case 173:e=-1;break;case 37:t.shiftKey?i=-1:(t.preventDefault(),r=-1);break;case 39:t.shiftKey?i=1:(t.preventDefault(),r=1);break;case 38:t.shiftKey?o=1:(t.preventDefault(),a=-1);break;case 40:t.shiftKey?o=-1:(a=1,t.preventDefault());break;default:return}var n=this._map,s=n.getZoom(),l={duration:300,delayEndEvents:500,easing:wo,zoom:e?Math.round(s)+e*(t.shiftKey?2:1):s,bearing:n.getBearing()+15*i,pitch:n.getPitch()+10*o,offset:[100*-r,100*-a],center:n.getCenter()};n.easeTo(l,{originalEvent:t});}};var Eo=function(e){this._map=e,t.bindAll(["_onDblClick","_onZoomEnd"],this);};Eo.prototype.isEnabled=function(){return !!this._enabled},Eo.prototype.isActive=function(){return !!this._active},Eo.prototype.enable=function(){this.isEnabled()||(this._enabled=!0);},Eo.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},Eo.prototype.onTouchStart=function(t){var e=this;this.isEnabled()&&(t.points.length>1||(this._tapped?(clearTimeout(this._tapped),this._tapped=null,this._zoom(t)):this._tapped=setTimeout(function(){e._tapped=null;},300)));},Eo.prototype.onDblClick=function(t){this.isEnabled()&&(t.originalEvent.preventDefault(),this._zoom(t));},Eo.prototype._zoom=function(t){this._active=!0,this._map.on("zoomend",this._onZoomEnd),this._map.zoomTo(this._map.getZoom()+(t.originalEvent.shiftKey?-1:1),{around:t.lngLat},t);},Eo.prototype._onZoomEnd=function(){this._active=!1,this._map.off("zoomend",this._onZoomEnd);};var To=t.bezier(0,0,.15,1),Io=function(e){this._map=e,this._el=e.getCanvasContainer(),t.bindAll(["_onMove","_onEnd","_onTouchFrame"],this);};Io.prototype.isEnabled=function(){return !!this._enabled},Io.prototype.enable=function(t){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-zoom-rotate"),this._enabled=!0,this._aroundCenter=!!t&&"center"===t.around);},Io.prototype.disable=function(){this.isEnabled()&&(this._el.classList.remove("mapboxgl-touch-zoom-rotate"),this._enabled=!1);},Io.prototype.disableRotation=function(){this._rotationDisabled=!0;},Io.prototype.enableRotation=function(){this._rotationDisabled=!1;},Io.prototype.onStart=function(e){if(this.isEnabled()&&2===e.touches.length){var o=i.mousePos(this._el,e.touches[0]),r=i.mousePos(this._el,e.touches[1]),a=o.add(r).div(2);this._startVec=o.sub(r),this._startAround=this._map.transform.pointLocation(a),this._gestureIntent=void 0,this._inertia=[],i.addEventListener(t.window.document,"touchmove",this._onMove,{passive:!1}),i.addEventListener(t.window.document,"touchend",this._onEnd);}},Io.prototype._getTouchEventData=function(t){var e=i.mousePos(this._el,t.touches[0]),o=i.mousePos(this._el,t.touches[1]),r=e.sub(o);return {vec:r,center:e.add(o).div(2),scale:r.mag()/this._startVec.mag(),bearing:this._rotationDisabled?0:180*r.angleWith(this._startVec)/Math.PI}},Io.prototype._onMove=function(e){if(2===e.touches.length){var i=this._getTouchEventData(e),o=i.vec,r=i.scale,a=i.bearing;if(!this._gestureIntent){var n=this._rotationDisabled&&1!==r||Math.abs(1-r)>.15;Math.abs(a)>10?this._gestureIntent="rotate":n&&(this._gestureIntent="zoom"),this._gestureIntent&&(this._map.fire(new t.Event(this._gestureIntent+"start",{originalEvent:e})),this._map.fire(new t.Event("movestart",{originalEvent:e})),this._startVec=o);}this._lastTouchEvent=e,this._frameId||(this._frameId=this._map._requestRenderFrame(this._onTouchFrame)),e.preventDefault();}},Io.prototype._onTouchFrame=function(){this._frameId=null;var e=this._gestureIntent;if(e){var i=this._map.transform;this._startScale||(this._startScale=i.scale,this._startBearing=i.bearing);var o=this._getTouchEventData(this._lastTouchEvent),r=o.center,a=o.bearing,n=o.scale,s=i.pointLocation(r),l=i.locationPoint(s);"rotate"===e&&(i.bearing=this._startBearing+a),i.zoom=i.scaleZoom(this._startScale*n),i.setLocationAtPoint(this._startAround,l),this._map.fire(new t.Event(e,{originalEvent:this._lastTouchEvent})),this._map.fire(new t.Event("move",{originalEvent:this._lastTouchEvent})),this._drainInertiaBuffer(),this._inertia.push([t.browser.now(),n,r]);}},Io.prototype._onEnd=function(e){i.removeEventListener(t.window.document,"touchmove",this._onMove,{passive:!1}),i.removeEventListener(t.window.document,"touchend",this._onEnd);var o=this._gestureIntent,r=this._startScale;if(this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._gestureIntent,delete this._startScale,delete this._startBearing,delete this._lastTouchEvent,o){this._map.fire(new t.Event(o+"end",{originalEvent:e})),this._drainInertiaBuffer();var a=this._inertia,n=this._map;if(a.length<2)n.snapToNorth({},{originalEvent:e});else{var s=a[a.length-1],l=a[0],c=n.transform.scaleZoom(r*s[1]),u=n.transform.scaleZoom(r*l[1]),h=c-u,p=(s[0]-l[0])/1e3,d=s[2];if(0!==p&&c!==u){var _=.15*h/p;Math.abs(_)>2.5&&(_=_>0?2.5:-2.5);var f=1e3*Math.abs(_/(12*.15)),m=c+_*f/2e3;m<0&&(m=0),n.easeTo({zoom:m,duration:f,easing:To,around:this._aroundCenter?n.getCenter():n.unproject(d),noMoveStart:!0},{originalEvent:e});}else n.snapToNorth({},{originalEvent:e});}}},Io.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>2&&i-e[0][0]>160;)e.shift();};var Co={scrollZoom:fo,boxZoom:mo,dragRotate:vo,dragPan:xo,keyboard:bo,doubleClickZoom:Eo,touchZoomRotate:Io};var So=function(e){function i(i,o){e.call(this),this._moving=!1,this._zooming=!1,this.transform=i,this._bearingSnap=o.bearingSnap,t.bindAll(["_renderFrameCallback"],this);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getCenter=function(){return this.transform.center},i.prototype.setCenter=function(t,e){return this.jumpTo({center:t},e)},i.prototype.panBy=function(e,i,o){return e=t.Point.convert(e).mult(-1),this.panTo(this.transform.center,t.extend({offset:e},i),o)},i.prototype.panTo=function(e,i,o){return this.easeTo(t.extend({center:e},i),o)},i.prototype.getZoom=function(){return this.transform.zoom},i.prototype.setZoom=function(t,e){return this.jumpTo({zoom:t},e),this},i.prototype.zoomTo=function(e,i,o){return this.easeTo(t.extend({zoom:e},i),o)},i.prototype.zoomIn=function(t,e){return this.zoomTo(this.getZoom()+1,t,e),this},i.prototype.zoomOut=function(t,e){return this.zoomTo(this.getZoom()-1,t,e),this},i.prototype.getBearing=function(){return this.transform.bearing},i.prototype.setBearing=function(t,e){return this.jumpTo({bearing:t},e),this},i.prototype.rotateTo=function(e,i,o){return this.easeTo(t.extend({bearing:e},i),o)},i.prototype.resetNorth=function(e,i){return this.rotateTo(0,t.extend({duration:1e3},e),i),this},i.prototype.snapToNorth=function(t,e){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(t,e):this},i.prototype.getPitch=function(){return this.transform.pitch},i.prototype.setPitch=function(t,e){return this.jumpTo({pitch:t},e),this},i.prototype.cameraForBounds=function(e,i){return e=t.LngLatBounds.convert(e),this._cameraForBoxAndBearing(e.getNorthWest(),e.getSouthEast(),0,i)},i.prototype._cameraForBoxAndBearing=function(e,i,o,r){if("number"==typeof(r=t.extend({padding:{top:0,bottom:0,right:0,left:0},offset:[0,0],maxZoom:this.transform.maxZoom},r)).padding){var a=r.padding;r.padding={top:a,bottom:a,right:a,left:a};}if(t.isEqual(Object.keys(r.padding).sort(function(t,e){return t<e?-1:t>e?1:0}),["bottom","left","right","top"])){var n=this.transform,s=n.project(t.LngLat.convert(e)),l=n.project(t.LngLat.convert(i)),c=s.rotate(-o*Math.PI/180),u=l.rotate(-o*Math.PI/180),h=new t.Point(Math.max(c.x,u.x),Math.max(c.y,u.y)),p=new t.Point(Math.min(c.x,u.x),Math.min(c.y,u.y)),d=h.sub(p),_=(n.width-r.padding.left-r.padding.right)/d.x,f=(n.height-r.padding.top-r.padding.bottom)/d.y;if(!(f<0||_<0)){var m=Math.min(n.scaleZoom(n.scale*Math.min(_,f)),r.maxZoom),g=t.Point.convert(r.offset),v=(r.padding.left-r.padding.right)/2,y=(r.padding.top-r.padding.bottom)/2,x=new t.Point(g.x+v,g.y+y).mult(n.scale/n.zoomScale(m));return {center:n.unproject(s.add(l).div(2).sub(x)),zoom:m,bearing:o}}t.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");}else t.warnOnce("options.padding must be a positive number, or an Object with keys 'bottom', 'left', 'right', 'top'");},i.prototype.fitBounds=function(t,e,i){return this._fitInternal(this.cameraForBounds(t,e),e,i)},i.prototype.fitScreenCoordinates=function(e,i,o,r,a){return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t.Point.convert(e)),this.transform.pointLocation(t.Point.convert(i)),o,r),r,a)},i.prototype._fitInternal=function(e,i,o){return e?(i=t.extend(e,i)).linear?this.easeTo(i,o):this.flyTo(i,o):this},i.prototype.jumpTo=function(e,i){this.stop();var o=this.transform,r=!1,a=!1,n=!1;return "zoom"in e&&o.zoom!==+e.zoom&&(r=!0,o.zoom=+e.zoom),void 0!==e.center&&(o.center=t.LngLat.convert(e.center)),"bearing"in e&&o.bearing!==+e.bearing&&(a=!0,o.bearing=+e.bearing),"pitch"in e&&o.pitch!==+e.pitch&&(n=!0,o.pitch=+e.pitch),this.fire(new t.Event("movestart",i)).fire(new t.Event("move",i)),r&&this.fire(new t.Event("zoomstart",i)).fire(new t.Event("zoom",i)).fire(new t.Event("zoomend",i)),a&&this.fire(new t.Event("rotatestart",i)).fire(new t.Event("rotate",i)).fire(new t.Event("rotateend",i)),n&&this.fire(new t.Event("pitchstart",i)).fire(new t.Event("pitch",i)).fire(new t.Event("pitchend",i)),this.fire(new t.Event("moveend",i))},i.prototype.easeTo=function(e,i){var o=this;this.stop(),!1===(e=t.extend({offset:[0,0],duration:500,easing:t.ease},e)).animate&&(e.duration=0);var r=this.transform,a=this.getZoom(),n=this.getBearing(),s=this.getPitch(),l="zoom"in e?+e.zoom:a,c="bearing"in e?this._normalizeBearing(e.bearing,n):n,u="pitch"in e?+e.pitch:s,h=r.centerPoint.add(t.Point.convert(e.offset)),p=r.pointLocation(h),d=t.LngLat.convert(e.center||p);this._normalizeCenter(d);var _,f,m=r.project(p),g=r.project(d).sub(m),v=r.zoomScale(l-a);return e.around&&(_=t.LngLat.convert(e.around),f=r.locationPoint(_)),this._zooming=l!==a,this._rotating=n!==c,this._pitching=u!==s,this._prepareEase(i,e.noMoveStart),clearTimeout(this._easeEndTimeoutID),this._ease(function(e){if(o._zooming&&(r.zoom=t.number(a,l,e)),o._rotating&&(r.bearing=t.number(n,c,e)),o._pitching&&(r.pitch=t.number(s,u,e)),_)r.setLocationAtPoint(_,f);else{var p=r.zoomScale(r.zoom-a),d=l>a?Math.min(2,v):Math.max(.5,v),y=Math.pow(d,1-e),x=r.unproject(m.add(g.mult(e*y)).mult(p));r.setLocationAtPoint(r.renderWorldCopies?x.wrap():x,h);}o._fireMoveEvents(i);},function(){e.delayEndEvents?o._easeEndTimeoutID=setTimeout(function(){return o._afterEase(i)},e.delayEndEvents):o._afterEase(i);},e),this},i.prototype._prepareEase=function(e,i){this._moving=!0,i||this.fire(new t.Event("movestart",e)),this._zooming&&this.fire(new t.Event("zoomstart",e)),this._rotating&&this.fire(new t.Event("rotatestart",e)),this._pitching&&this.fire(new t.Event("pitchstart",e));},i.prototype._fireMoveEvents=function(e){this.fire(new t.Event("move",e)),this._zooming&&this.fire(new t.Event("zoom",e)),this._rotating&&this.fire(new t.Event("rotate",e)),this._pitching&&this.fire(new t.Event("pitch",e));},i.prototype._afterEase=function(e){var i=this._zooming,o=this._rotating,r=this._pitching;this._moving=!1,this._zooming=!1,this._rotating=!1,this._pitching=!1,i&&this.fire(new t.Event("zoomend",e)),o&&this.fire(new t.Event("rotateend",e)),r&&this.fire(new t.Event("pitchend",e)),this.fire(new t.Event("moveend",e));},i.prototype.flyTo=function(e,i){var o=this;this.stop(),e=t.extend({offset:[0,0],speed:1.2,curve:1.42,easing:t.ease},e);var r=this.transform,a=this.getZoom(),n=this.getBearing(),s=this.getPitch(),l="zoom"in e?t.clamp(+e.zoom,r.minZoom,r.maxZoom):a,c="bearing"in e?this._normalizeBearing(e.bearing,n):n,u="pitch"in e?+e.pitch:s,h=r.zoomScale(l-a),p=r.centerPoint.add(t.Point.convert(e.offset)),d=r.pointLocation(p),_=t.LngLat.convert(e.center||d);this._normalizeCenter(_);var f=r.project(d),m=r.project(_).sub(f),g=e.curve,v=Math.max(r.width,r.height),y=v/h,x=m.mag();if("minZoom"in e){var b=t.clamp(Math.min(e.minZoom,a,l),r.minZoom,r.maxZoom),w=v/r.zoomScale(b-a);g=Math.sqrt(w/x*2);}var E=g*g;function T(t){var e=(y*y-v*v+(t?-1:1)*E*E*x*x)/(2*(t?y:v)*E*x);return Math.log(Math.sqrt(e*e+1)-e)}function I(t){return (Math.exp(t)-Math.exp(-t))/2}function C(t){return (Math.exp(t)+Math.exp(-t))/2}var S=T(0),z=function(t){return C(S)/C(S+g*t)},L=function(t){return v*((C(S)*(I(e=S+g*t)/C(e))-I(S))/E)/x;var e;},P=(T(1)-S)/g;if(Math.abs(x)<1e-6||!isFinite(P)){if(Math.abs(v-y)<1e-6)return this.easeTo(e,i);var D=y<v?-1:1;P=Math.abs(Math.log(y/v))/g,L=function(){return 0},z=function(t){return Math.exp(D*g*t)};}if("duration"in e)e.duration=+e.duration;else{var R="screenSpeed"in e?+e.screenSpeed/g:+e.speed;e.duration=1e3*P/R;}return e.maxDuration&&e.duration>e.maxDuration&&(e.duration=0),this._zooming=!0,this._rotating=n!==c,this._pitching=u!==s,this._prepareEase(i,!1),this._ease(function(e){var h=e*P,d=1/z(h);r.zoom=1===e?l:a+r.scaleZoom(d),o._rotating&&(r.bearing=t.number(n,c,e)),o._pitching&&(r.pitch=t.number(s,u,e));var g=1===e?_:r.unproject(f.add(m.mult(L(h))).mult(d));r.setLocationAtPoint(r.renderWorldCopies?g.wrap():g,p),o._fireMoveEvents(i);},function(){return o._afterEase(i)},e),this},i.prototype.isEasing=function(){return !!this._easeFrameId},i.prototype.stop=function(){if(this._easeFrameId&&(this._cancelRenderFrame(this._easeFrameId),delete this._easeFrameId,delete this._onEaseFrame),this._onEaseEnd){var t=this._onEaseEnd;delete this._onEaseEnd,t.call(this);}return this},i.prototype._ease=function(e,i,o){!1===o.animate||0===o.duration?(e(1),i()):(this._easeStart=t.browser.now(),this._easeOptions=o,this._onEaseFrame=e,this._onEaseEnd=i,this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback));},i.prototype._renderFrameCallback=function(){var e=Math.min((t.browser.now()-this._easeStart)/this._easeOptions.duration,1);this._onEaseFrame(this._easeOptions.easing(e)),e<1?this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback):this.stop();},i.prototype._normalizeBearing=function(e,i){e=t.wrap(e,-180,180);var o=Math.abs(e-i);return Math.abs(e-360-i)<o&&(e-=360),Math.abs(e+360-i)<o&&(e+=360),e},i.prototype._normalizeCenter=function(t){var e=this.transform;if(e.renderWorldCopies&&!e.lngRange){var i=t.lng-e.center.lng;t.lng+=i>180?-360:i<-180?360:0;}},i}(t.Evented),zo=function(e){void 0===e&&(e={}),this.options=e,t.bindAll(["_updateEditLink","_updateData","_updateCompact"],this);};zo.prototype.getDefaultPosition=function(){return "bottom-right"},zo.prototype.onAdd=function(t){var e=this.options&&this.options.compact;return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),this._innerContainer=i.create("div","mapboxgl-ctrl-attrib-inner",this._container),e&&this._container.classList.add("mapboxgl-compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("styledata",this._updateData),this._map.on("sourcedata",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===e&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container},zo.prototype.onRemove=function(){i.remove(this._container),this._map.off("styledata",this._updateData),this._map.off("sourcedata",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0;},zo.prototype._updateEditLink=function(){var e=this._editLink;e||(e=this._editLink=this._container.querySelector(".mapbox-improve-map"));var i=[{key:"owner",value:this.styleOwner},{key:"id",value:this.styleId},{key:"access_token",value:t.config.ACCESS_TOKEN}];if(e){var o=i.reduce(function(t,e,o){return e.value&&(t+=e.key+"="+e.value+(o<i.length-1?"&":"")),t},"?");e.href=t.config.FEEDBACK_URL+"/"+o+(this._map._hash?this._map._hash.getHashString(!0):"");}},zo.prototype._updateData=function(t){!t||"metadata"!==t.sourceDataType&&"style"!==t.dataType||(this._updateAttributions(),this._updateEditLink());},zo.prototype._updateAttributions=function(){if(this._map.style){var t=[];if(this.options.customAttribution&&(Array.isArray(this.options.customAttribution)?t=t.concat(this.options.customAttribution.map(function(t){return "string"!=typeof t?"":t})):"string"==typeof this.options.customAttribution&&t.push(this.options.customAttribution)),this._map.style.stylesheet){var e=this._map.style.stylesheet;this.styleOwner=e.owner,this.styleId=e.id;}var i=this._map.style.sourceCaches;for(var o in i){var r=i[o];if(r.used){var a=r.getSource();a.attribution&&t.indexOf(a.attribution)<0&&t.push(a.attribution);}}t.sort(function(t,e){return t.length-e.length}),(t=t.filter(function(e,i){for(var o=i+1;o<t.length;o++)if(t[o].indexOf(e)>=0)return !1;return !0})).length?(this._innerContainer.innerHTML=t.join(" | "),this._container.classList.remove("mapboxgl-attrib-empty")):this._container.classList.add("mapboxgl-attrib-empty"),this._editLink=null;}},zo.prototype._updateCompact=function(){this._map.getCanvasContainer().offsetWidth<=640?this._container.classList.add("mapboxgl-compact"):this._container.classList.remove("mapboxgl-compact");};var Lo=function(){t.bindAll(["_updateLogo"],this),t.bindAll(["_updateCompact"],this);};Lo.prototype.onAdd=function(t){this._map=t,this._container=i.create("div","mapboxgl-ctrl");var e=i.create("a","mapboxgl-ctrl-logo");return e.target="_blank",e.href="https://www.mapbox.com/",e.setAttribute("aria-label","Mapbox logo"),e.setAttribute("rel","noopener"),this._container.appendChild(e),this._container.style.display="none",this._map.on("sourcedata",this._updateLogo),this._updateLogo(),this._map.on("resize",this._updateCompact),this._updateCompact(),this._container},Lo.prototype.onRemove=function(){i.remove(this._container),this._map.off("sourcedata",this._updateLogo),this._map.off("resize",this._updateCompact);},Lo.prototype.getDefaultPosition=function(){return "bottom-left"},Lo.prototype._updateLogo=function(t){t&&"metadata"!==t.sourceDataType||(this._container.style.display=this._logoRequired()?"block":"none");},Lo.prototype._logoRequired=function(){if(this._map.style){var t=this._map.style.sourceCaches;for(var e in t){if(t[e].getSource().mapbox_logo)return !0}return !1}},Lo.prototype._updateCompact=function(){var t=this._container.children;if(t.length){var e=t[0];this._map.getCanvasContainer().offsetWidth<250?e.classList.add("mapboxgl-compact"):e.classList.remove("mapboxgl-compact");}};var Po=function(){this._queue=[],this._id=0,this._cleared=!1,this._currentlyRunning=!1;};Po.prototype.add=function(t){var e=++this._id;return this._queue.push({callback:t,id:e,cancelled:!1}),e},Po.prototype.remove=function(t){for(var e=this._currentlyRunning,i=0,o=e?this._queue.concat(e):this._queue;i<o.length;i+=1){var r=o[i];if(r.id===t)return void(r.cancelled=!0)}},Po.prototype.run=function(){var t=this._currentlyRunning=this._queue;this._queue=[];for(var e=0,i=t;e<i.length;e+=1){var o=i[e];if(!o.cancelled&&(o.callback(),this._cleared))break}this._cleared=!1,this._currentlyRunning=!1;},Po.prototype.clear=function(){this._currentlyRunning&&(this._cleared=!0),this._queue=[];};var Do=t.window.HTMLImageElement,Ro=t.window.HTMLElement,Mo={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:0,maxZoom:22,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,bearingSnap:7,clickTolerance:3,hash:!1,attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0,renderWorldCopies:!0,refreshExpiredTiles:!0,maxTileCacheSize:null,transformRequest:null,fadeDuration:300,crossSourceCollisions:!0},Ao=function(o){function r(e){var r=this;if(null!=(e=t.extend({},Mo,e)).minZoom&&null!=e.maxZoom&&e.minZoom>e.maxZoom)throw new Error("maxZoom must be greater than minZoom");var a=new lo(e.minZoom,e.maxZoom,e.renderWorldCopies);o.call(this,a,e),this._interactive=e.interactive,this._maxTileCacheSize=e.maxTileCacheSize,this._failIfMajorPerformanceCaveat=e.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=e.preserveDrawingBuffer,this._trackResize=e.trackResize,this._bearingSnap=e.bearingSnap,this._refreshExpiredTiles=e.refreshExpiredTiles,this._fadeDuration=e.fadeDuration,this._crossSourceCollisions=e.crossSourceCollisions,this._crossFadingFactor=1,this._collectResourceTiming=e.collectResourceTiming,this._renderTaskQueue=new Po,this._controls=[],this._mapId=t.uniqueId();var n=e.transformRequest;if(this._transformRequest=n?function(t,e){return n(t,e)||{url:t}}:function(t){return {url:t}},"string"==typeof e.container){if(this._container=t.window.document.getElementById(e.container),!this._container)throw new Error("Container '"+e.container+"' not found.")}else{if(!(e.container instanceof Ro))throw new Error("Invalid type: 'container' must be a String or HTMLElement.");this._container=e.container;}if(e.maxBounds&&this.setMaxBounds(e.maxBounds),t.bindAll(["_onWindowOnline","_onWindowResize","_contextLost","_contextRestored"],this),this._setupContainer(),this._setupPainter(),void 0===this.painter)throw new Error("Failed to initialize WebGL.");this.on("move",function(){return r._update(!1)}),this.on("moveend",function(){return r._update(!1)}),this.on("zoom",function(){return r._update(!0)}),void 0!==t.window&&(t.window.addEventListener("online",this._onWindowOnline,!1),t.window.addEventListener("resize",this._onWindowResize,!1)),function(t,e){var o=t.getCanvasContainer(),r=null,a=!1,n=null;for(var s in Co)t[s]=new Co[s](t,e),e.interactive&&e[s]&&t[s].enable(e[s]);i.addEventListener(o,"mouseout",function(e){t.fire(new ho("mouseout",t,e));}),i.addEventListener(o,"mousedown",function(r){a=!0,n=i.mousePos(o,r);var s=new ho("mousedown",t,r);t.fire(s),s.defaultPrevented||(e.interactive&&!t.doubleClickZoom.isActive()&&t.stop(),t.boxZoom.onMouseDown(r),t.boxZoom.isActive()||t.dragPan.isActive()||t.dragRotate.onMouseDown(r),t.boxZoom.isActive()||t.dragRotate.isActive()||t.dragPan.onMouseDown(r));}),i.addEventListener(o,"mouseup",function(e){var i=t.dragRotate.isActive();r&&!i&&t.fire(new ho("contextmenu",t,r)),r=null,a=!1,t.fire(new ho("mouseup",t,e));}),i.addEventListener(o,"mousemove",function(e){if(!t.dragPan.isActive()&&!t.dragRotate.isActive()){for(var i=e.target;i&&i!==o;)i=i.parentNode;i===o&&t.fire(new ho("mousemove",t,e));}}),i.addEventListener(o,"mouseover",function(e){for(var i=e.target;i&&i!==o;)i=i.parentNode;i===o&&t.fire(new ho("mouseover",t,e));}),i.addEventListener(o,"touchstart",function(i){var o=new po("touchstart",t,i);t.fire(o),o.defaultPrevented||(e.interactive&&t.stop(),t.boxZoom.isActive()||t.dragRotate.isActive()||t.dragPan.onTouchStart(i),t.touchZoomRotate.onStart(i),t.doubleClickZoom.onTouchStart(o));},{passive:!1}),i.addEventListener(o,"touchmove",function(e){t.fire(new po("touchmove",t,e));},{passive:!1}),i.addEventListener(o,"touchend",function(e){t.fire(new po("touchend",t,e));}),i.addEventListener(o,"touchcancel",function(e){t.fire(new po("touchcancel",t,e));}),i.addEventListener(o,"click",function(r){var a=i.mousePos(o,r);(a.equals(n)||a.dist(n)<e.clickTolerance)&&t.fire(new ho("click",t,r));}),i.addEventListener(o,"dblclick",function(e){var i=new ho("dblclick",t,e);t.fire(i),i.defaultPrevented||t.doubleClickZoom.onDblClick(i);}),i.addEventListener(o,"contextmenu",function(e){var i=t.dragRotate.isActive();a||i?a&&(r=e):t.fire(new ho("contextmenu",t,e)),(t.dragRotate.isEnabled()||t.listens("contextmenu"))&&e.preventDefault();}),i.addEventListener(o,"wheel",function(i){e.interactive&&t.stop();var o=new _o("wheel",t,i);t.fire(o),o.defaultPrevented||t.scrollZoom.onWheel(i);},{passive:!1});}(this,e),this._hash=e.hash&&(new uo).addTo(this),this._hash&&this._hash._onHashChange()||(this.jumpTo({center:e.center,zoom:e.zoom,bearing:e.bearing,pitch:e.pitch}),e.bounds&&(this.resize(),this.fitBounds(e.bounds,t.extend({},e.fitBoundsOptions,{duration:0})))),this.resize(),e.style&&this.setStyle(e.style,{localIdeographFontFamily:e.localIdeographFontFamily}),e.attributionControl&&this.addControl(new zo({customAttribution:e.customAttribution})),this.addControl(new Lo,e.logoPosition),this.on("style.load",function(){r.transform.unmodified&&r.jumpTo(r.style.stylesheet);}),this.on("data",function(e){r._update("style"===e.dataType),r.fire(new t.Event(e.dataType+"data",e));}),this.on("dataloading",function(e){r.fire(new t.Event(e.dataType+"dataloading",e));});}o&&(r.__proto__=o),r.prototype=Object.create(o&&o.prototype),r.prototype.constructor=r;var a={showTileBoundaries:{configurable:!0},showCollisionBoxes:{configurable:!0},showOverdrawInspector:{configurable:!0},repaint:{configurable:!0},vertices:{configurable:!0}};return r.prototype._getMapId=function(){return this._mapId},r.prototype.addControl=function(e,i){if(void 0===i&&e.getDefaultPosition&&(i=e.getDefaultPosition()),void 0===i&&(i="top-right"),!e||!e.onAdd)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));var o=e.onAdd(this);this._controls.push(e);var r=this._controlPositions[i];return -1!==i.indexOf("bottom")?r.insertBefore(o,r.firstChild):r.appendChild(o),this},r.prototype.removeControl=function(e){if(!e||!e.onRemove)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));var i=this._controls.indexOf(e);return i>-1&&this._controls.splice(i,1),e.onRemove(this),this},r.prototype.resize=function(e){var i=this._containerDimensions(),o=i[0],r=i[1];return this._resizeCanvas(o,r),this.transform.resize(o,r),this.painter.resize(o,r),this.fire(new t.Event("movestart",e)).fire(new t.Event("move",e)).fire(new t.Event("resize",e)).fire(new t.Event("moveend",e)),this},r.prototype.getBounds=function(){return this.transform.getBounds()},r.prototype.getMaxBounds=function(){return this.transform.getMaxBounds()},r.prototype.setMaxBounds=function(e){return this.transform.setMaxBounds(t.LngLatBounds.convert(e)),this._update()},r.prototype.setMinZoom=function(t){if((t=null==t?0:t)>=0&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t&&this.setZoom(t),this;throw new Error("minZoom must be between 0 and the current maxZoom, inclusive")},r.prototype.getMinZoom=function(){return this.transform.minZoom},r.prototype.setMaxZoom=function(t){if((t=null==t?22:t)>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t&&this.setZoom(t),this;throw new Error("maxZoom must be greater than the current minZoom")},r.prototype.getRenderWorldCopies=function(){return this.transform.renderWorldCopies},r.prototype.setRenderWorldCopies=function(t){return this.transform.renderWorldCopies=t,this._update()},r.prototype.getMaxZoom=function(){return this.transform.maxZoom},r.prototype.project=function(e){return this.transform.locationPoint(t.LngLat.convert(e))},r.prototype.unproject=function(e){return this.transform.pointLocation(t.Point.convert(e))},r.prototype.isMoving=function(){return this._moving||this.dragPan.isActive()||this.dragRotate.isActive()||this.scrollZoom.isActive()},r.prototype.isZooming=function(){return this._zooming||this.scrollZoom.isZooming()},r.prototype.isRotating=function(){return this._rotating||this.dragRotate.isActive()},r.prototype.on=function(t,e,i){var r=this;if(void 0===i)return o.prototype.on.call(this,t,e);var a=function(){var o;if("mouseenter"===t||"mouseover"===t){var a=!1;return {layer:e,listener:i,delegates:{mousemove:function(o){var n=r.getLayer(e)?r.queryRenderedFeatures(o.point,{layers:[e]}):[];n.length?a||(a=!0,i.call(r,new ho(t,r,o.originalEvent,{features:n}))):a=!1;},mouseout:function(){a=!1;}}}}if("mouseleave"===t||"mouseout"===t){var n=!1;return {layer:e,listener:i,delegates:{mousemove:function(o){(r.getLayer(e)?r.queryRenderedFeatures(o.point,{layers:[e]}):[]).length?n=!0:n&&(n=!1,i.call(r,new ho(t,r,o.originalEvent)));},mouseout:function(e){n&&(n=!1,i.call(r,new ho(t,r,e.originalEvent)));}}}}return {layer:e,listener:i,delegates:(o={},o[t]=function(t){var o=r.getLayer(e)?r.queryRenderedFeatures(t.point,{layers:[e]}):[];o.length&&(t.features=o,i.call(r,t),delete t.features);},o)}}();for(var n in this._delegatedListeners=this._delegatedListeners||{},this._delegatedListeners[t]=this._delegatedListeners[t]||[],this._delegatedListeners[t].push(a),a.delegates)this.on(n,a.delegates[n]);return this},r.prototype.off=function(t,e,i){if(void 0===i)return o.prototype.off.call(this,t,e);if(this._delegatedListeners&&this._delegatedListeners[t])for(var r=this._delegatedListeners[t],a=0;a<r.length;a++){var n=r[a];if(n.layer===e&&n.listener===i){for(var s in n.delegates)this.off(s,n.delegates[s]);return r.splice(a,1),this}}return this},r.prototype.queryRenderedFeatures=function(e,i){if(!this.style)return [];var o;if(void 0!==i||void 0===e||e instanceof t.Point||Array.isArray(e)||(i=e,e=void 0),i=i||{},(e=e||[[0,0],[this.transform.width,this.transform.height]])instanceof t.Point||"number"==typeof e[0])o=[t.Point.convert(e)];else{var r=t.Point.convert(e[0]),a=t.Point.convert(e[1]);o=[r,new t.Point(a.x,r.y),a,new t.Point(r.x,a.y),r];}return this.style.queryRenderedFeatures(o,i,this.transform)},r.prototype.querySourceFeatures=function(t,e){return this.style.querySourceFeatures(t,e)},r.prototype.setStyle=function(t,e){return (!e||!1!==e.diff&&!e.localIdeographFontFamily)&&this.style&&t?(this._diffStyle(t,e),this):this._updateStyle(t,e)},r.prototype._updateStyle=function(t,e){return this.style&&(this.style.setEventedParent(null),this.style._remove()),t?(this.style=new Me(this,e||{}),this.style.setEventedParent(this,{style:this.style}),"string"==typeof t?this.style.loadURL(t):this.style.loadJSON(t),this):(delete this.style,this)},r.prototype._diffStyle=function(e,i){var o=this;if("string"==typeof e){var r=t.normalizeStyleURL(e),a=this._transformRequest(r,t.ResourceType.Style);t.getJSON(a,function(e,r){e?o.fire(new t.ErrorEvent(e)):r&&o._updateDiff(r,i);});}else"object"==typeof e&&this._updateDiff(e,i);},r.prototype._updateDiff=function(e,i){try{this.style.setState(e)&&this._update(!0);}catch(o){t.warnOnce("Unable to perform style diff: "+(o.message||o.error||o)+".  Rebuilding the style from scratch."),this._updateStyle(e,i);}},r.prototype.getStyle=function(){if(this.style)return this.style.serialize()},r.prototype.isStyleLoaded=function(){return this.style?this.style.loaded():t.warnOnce("There is no style added to the map.")},r.prototype.addSource=function(t,e){return this.style.addSource(t,e),this._update(!0)},r.prototype.isSourceLoaded=function(e){var i=this.style&&this.style.sourceCaches[e];if(void 0!==i)return i.loaded();this.fire(new t.ErrorEvent(new Error("There is no source with ID '"+e+"'")));},r.prototype.areTilesLoaded=function(){var t=this.style&&this.style.sourceCaches;for(var e in t){var i=t[e]._tiles;for(var o in i){var r=i[o];if("loaded"!==r.state&&"errored"!==r.state)return !1}}return !0},r.prototype.addSourceType=function(t,e,i){return this.style.addSourceType(t,e,i)},r.prototype.removeSource=function(t){return this.style.removeSource(t),this._update(!0)},r.prototype.getSource=function(t){return this.style.getSource(t)},r.prototype.addImage=function(e,i,o){void 0===o&&(o={});var r=o.pixelRatio;void 0===r&&(r=1);var a=o.sdf;if(void 0===a&&(a=!1),i instanceof Do){var n=t.browser.getImageData(i),s=n.width,l=n.height,c=n.data;this.style.addImage(e,{data:new t.RGBAImage({width:s,height:l},c),pixelRatio:r,sdf:a});}else{if(void 0===i.width||void 0===i.height)return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));var u=i.width,h=i.height,p=i.data;this.style.addImage(e,{data:new t.RGBAImage({width:u,height:h},new Uint8Array(p)),pixelRatio:r,sdf:a});}},r.prototype.hasImage=function(e){return e?!!this.style.getImage(e):(this.fire(new t.ErrorEvent(new Error("Missing required image id"))),!1)},r.prototype.removeImage=function(t){this.style.removeImage(t);},r.prototype.loadImage=function(e,i){t.getImage(this._transformRequest(e,t.ResourceType.Image),i);},r.prototype.listImages=function(){return this.style.listImages()},r.prototype.addLayer=function(t,e){return this.style.addLayer(t,e),this._update(!0)},r.prototype.moveLayer=function(t,e){return this.style.moveLayer(t,e),this._update(!0)},r.prototype.removeLayer=function(t){return this.style.removeLayer(t),this._update(!0)},r.prototype.getLayer=function(t){return this.style.getLayer(t)},r.prototype.setFilter=function(t,e,i){return void 0===i&&(i={}),this.style.setFilter(t,e,i),this._update(!0)},r.prototype.setLayerZoomRange=function(t,e,i){return this.style.setLayerZoomRange(t,e,i),this._update(!0)},r.prototype.getFilter=function(t){return this.style.getFilter(t)},r.prototype.setPaintProperty=function(t,e,i,o){return void 0===o&&(o={}),this.style.setPaintProperty(t,e,i,o),this._update(!0)},r.prototype.getPaintProperty=function(t,e){return this.style.getPaintProperty(t,e)},r.prototype.setLayoutProperty=function(t,e,i,o){return void 0===o&&(o={}),this.style.setLayoutProperty(t,e,i,o),this._update(!0)},r.prototype.getLayoutProperty=function(t,e){return this.style.getLayoutProperty(t,e)},r.prototype.setLight=function(t,e){return void 0===e&&(e={}),this.style.setLight(t,e),this._update(!0)},r.prototype.getLight=function(){return this.style.getLight()},r.prototype.setFeatureState=function(t,e){return this.style.setFeatureState(t,e),this._update()},r.prototype.removeFeatureState=function(t,e){return this.style.removeFeatureState(t,e),this._update()},r.prototype.getFeatureState=function(t){return this.style.getFeatureState(t)},r.prototype.getContainer=function(){return this._container},r.prototype.getCanvasContainer=function(){return this._canvasContainer},r.prototype.getCanvas=function(){return this._canvas},r.prototype._containerDimensions=function(){var t=0,e=0;return this._container&&(t=this._container.clientWidth||400,e=this._container.clientHeight||300),[t,e]},r.prototype._detectMissingCSS=function(){"rgb(250, 128, 114)"!==t.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color")&&t.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");},r.prototype._setupContainer=function(){var t=this._container;t.classList.add("mapboxgl-map"),(this._missingCSSCanary=i.create("div","mapboxgl-canary",t)).style.visibility="hidden",this._detectMissingCSS();var e=this._canvasContainer=i.create("div","mapboxgl-canvas-container",t);this._interactive&&e.classList.add("mapboxgl-interactive"),this._canvas=i.create("canvas","mapboxgl-canvas",e),this._canvas.style.position="absolute",this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex","0"),this._canvas.setAttribute("aria-label","Map");var o=this._containerDimensions();this._resizeCanvas(o[0],o[1]);var r=this._controlContainer=i.create("div","mapboxgl-control-container",t),a=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach(function(t){a[t]=i.create("div","mapboxgl-ctrl-"+t,r);});},r.prototype._resizeCanvas=function(e,i){var o=t.window.devicePixelRatio||1;this._canvas.width=o*e,this._canvas.height=o*i,this._canvas.style.width=e+"px",this._canvas.style.height=i+"px";},r.prototype._setupPainter=function(){var i=t.extend({failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer},e.webGLContextAttributes),o=this._canvas.getContext("webgl",i)||this._canvas.getContext("experimental-webgl",i);o?(this.painter=new ro(o,this.transform),t.webpSupported.testSupport(o)):this.fire(new t.ErrorEvent(new Error("Failed to initialize WebGL")));},r.prototype._contextLost=function(e){e.preventDefault(),this._frame&&(this._frame.cancel(),this._frame=null),this.fire(new t.Event("webglcontextlost",{originalEvent:e}));},r.prototype._contextRestored=function(e){this._setupPainter(),this.resize(),this._update(),this.fire(new t.Event("webglcontextrestored",{originalEvent:e}));},r.prototype.loaded=function(){return !this._styleDirty&&!this._sourcesDirty&&!!this.style&&this.style.loaded()},r.prototype._update=function(t){return this.style?(this._styleDirty=this._styleDirty||t,this._sourcesDirty=!0,this.triggerRepaint(),this):this},r.prototype._requestRenderFrame=function(t){return this._update(),this._renderTaskQueue.add(t)},r.prototype._cancelRenderFrame=function(t){this._renderTaskQueue.remove(t);},r.prototype._render=function(){this.painter.context.setDirty(),this.painter.setBaseState(),this._renderTaskQueue.run();var e=!1;if(this.style&&this._styleDirty){this._styleDirty=!1;var i=this.transform.zoom,o=t.browser.now();this.style.zoomHistory.update(i,o);var r=new t.EvaluationParameters(i,{now:o,fadeDuration:this._fadeDuration,zoomHistory:this.style.zoomHistory,transition:this.style.getTransition()}),a=r.crossFadingFactor();1===a&&a===this._crossFadingFactor||(e=!0,this._crossFadingFactor=a),this.style.update(r);}return this.style&&this._sourcesDirty&&(this._sourcesDirty=!1,this.style._updateSources(this.transform)),this._placementDirty=this.style&&this.style._updatePlacement(this.painter.transform,this.showCollisionBoxes,this._fadeDuration,this._crossSourceCollisions),this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showOverdrawInspector:this._showOverdrawInspector,rotating:this.isRotating(),zooming:this.isZooming(),moving:this.isMoving(),fadeDuration:this._fadeDuration}),this.fire(new t.Event("render")),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire(new t.Event("load"))),this.style&&(this.style.hasTransitions()||e)&&(this._styleDirty=!0),this.style&&!this._placementDirty&&this.style._releaseSymbolFadeTiles(),this._sourcesDirty||this._repaint||this._styleDirty||this._placementDirty?this.triggerRepaint():!this.isMoving()&&this.loaded()&&this.fire(new t.Event("idle")),this},r.prototype.remove=function(){this._hash&&this._hash.remove();for(var e=0,i=this._controls;e<i.length;e+=1){i[e].onRemove(this);}this._controls=[],this._frame&&(this._frame.cancel(),this._frame=null),this._renderTaskQueue.clear(),this.setStyle(null),void 0!==t.window&&(t.window.removeEventListener("resize",this._onWindowResize,!1),t.window.removeEventListener("online",this._onWindowOnline,!1));var o=this.painter.context.gl.getExtension("WEBGL_lose_context");o&&o.loseContext(),ko(this._canvasContainer),ko(this._controlContainer),ko(this._missingCSSCanary),this._container.classList.remove("mapboxgl-map"),this.fire(new t.Event("remove"));},r.prototype.triggerRepaint=function(){var e=this;this.style&&!this._frame&&(this._frame=t.browser.frame(function(){e._frame=null,e._render();}));},r.prototype._onWindowOnline=function(){this._update();},r.prototype._onWindowResize=function(){this._trackResize&&this.resize()._update();},a.showTileBoundaries.get=function(){return !!this._showTileBoundaries},a.showTileBoundaries.set=function(t){this._showTileBoundaries!==t&&(this._showTileBoundaries=t,this._update());},a.showCollisionBoxes.get=function(){return !!this._showCollisionBoxes},a.showCollisionBoxes.set=function(t){this._showCollisionBoxes!==t&&(this._showCollisionBoxes=t,t?this.style._generateCollisionBoxes():this._update());},a.showOverdrawInspector.get=function(){return !!this._showOverdrawInspector},a.showOverdrawInspector.set=function(t){this._showOverdrawInspector!==t&&(this._showOverdrawInspector=t,this._update());},a.repaint.get=function(){return !!this._repaint},a.repaint.set=function(t){this._repaint!==t&&(this._repaint=t,this.triggerRepaint());},a.vertices.get=function(){return !!this._vertices},a.vertices.set=function(t){this._vertices=t,this._update();},Object.defineProperties(r.prototype,a),r}(So);function ko(t){t.parentNode&&t.parentNode.removeChild(t);}var Bo={showCompass:!0,showZoom:!0},Oo=function(e){var o=this;this.options=t.extend({},Bo,e),this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._container.addEventListener("contextmenu",function(t){return t.preventDefault()}),this.options.showZoom&&(this._zoomInButton=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in","Zoom in",function(){return o._map.zoomIn()}),this._zoomOutButton=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out","Zoom out",function(){return o._map.zoomOut()})),this.options.showCompass&&(t.bindAll(["_rotateCompassArrow"],this),this._compass=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-compass","Reset bearing to north",function(){return o._map.resetNorth()}),this._compassArrow=i.create("span","mapboxgl-ctrl-compass-arrow",this._compass));};function Fo(e,i,o){if(e=new t.LngLat(e.lng,e.lat),i){var r=new t.LngLat(e.lng-360,e.lat),a=new t.LngLat(e.lng+360,e.lat),n=o.locationPoint(e).distSqr(i);o.locationPoint(r).distSqr(i)<n?e=r:o.locationPoint(a).distSqr(i)<n&&(e=a);}for(;Math.abs(e.lng-o.center.lng)>180;){var s=o.locationPoint(e);if(s.x>=0&&s.y>=0&&s.x<=o.width&&s.y<=o.height)break;e.lng>o.center.lng?e.lng-=360:e.lng+=360;}return e}Oo.prototype._rotateCompassArrow=function(){var t="rotate("+this._map.transform.angle*(180/Math.PI)+"deg)";this._compassArrow.style.transform=t;},Oo.prototype.onAdd=function(t){return this._map=t,this.options.showCompass&&(this._map.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._handler=new vo(t,{button:"left",element:this._compass}),i.addEventListener(this._compass,"mousedown",this._handler.onMouseDown),this._handler.enable()),this._container},Oo.prototype.onRemove=function(){i.remove(this._container),this.options.showCompass&&(this._map.off("rotate",this._rotateCompassArrow),i.removeEventListener(this._compass,"mousedown",this._handler.onMouseDown),this._handler.disable(),delete this._handler),delete this._map;},Oo.prototype._createButton=function(t,e,o){var r=i.create("button",t,this._container);return r.type="button",r.title=e,r.setAttribute("aria-label",e),r.addEventListener("click",o),r};var Uo={center:"translate(-50%,-50%)",top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"};function No(t,e,i){var o=t.classList;for(var r in Uo)o.remove("mapboxgl-"+i+"-anchor-"+r);o.add("mapboxgl-"+i+"-anchor-"+e);}var Zo,jo=function(e){function o(o,r){if(e.call(this),(o instanceof t.window.HTMLElement||r)&&(o=t.extend({element:o},r)),t.bindAll(["_update","_onMove","_onUp","_addDragHandler","_onMapClick"],this),this._anchor=o&&o.anchor||"center",this._color=o&&o.color||"#3FB1CE",this._draggable=o&&o.draggable||!1,this._state="inactive",o&&o.element)this._element=o.element,this._offset=t.Point.convert(o&&o.offset||[0,0]);else{this._defaultMarker=!0,this._element=i.create("div");var a=i.createNS("http://www.w3.org/2000/svg","svg");a.setAttributeNS(null,"height","41px"),a.setAttributeNS(null,"width","27px"),a.setAttributeNS(null,"viewBox","0 0 27 41");var n=i.createNS("http://www.w3.org/2000/svg","g");n.setAttributeNS(null,"stroke","none"),n.setAttributeNS(null,"stroke-width","1"),n.setAttributeNS(null,"fill","none"),n.setAttributeNS(null,"fill-rule","evenodd");var s=i.createNS("http://www.w3.org/2000/svg","g");s.setAttributeNS(null,"fill-rule","nonzero");var l=i.createNS("http://www.w3.org/2000/svg","g");l.setAttributeNS(null,"transform","translate(3.0, 29.0)"),l.setAttributeNS(null,"fill","#000000");for(var c=0,u=[{rx:"10.5",ry:"5.25002273"},{rx:"10.5",ry:"5.25002273"},{rx:"9.5",ry:"4.77275007"},{rx:"8.5",ry:"4.29549936"},{rx:"7.5",ry:"3.81822308"},{rx:"6.5",ry:"3.34094679"},{rx:"5.5",ry:"2.86367051"},{rx:"4.5",ry:"2.38636864"}];c<u.length;c+=1){var h=u[c],p=i.createNS("http://www.w3.org/2000/svg","ellipse");p.setAttributeNS(null,"opacity","0.04"),p.setAttributeNS(null,"cx","10.5"),p.setAttributeNS(null,"cy","5.80029008"),p.setAttributeNS(null,"rx",h.rx),p.setAttributeNS(null,"ry",h.ry),l.appendChild(p);}var d=i.createNS("http://www.w3.org/2000/svg","g");d.setAttributeNS(null,"fill",this._color);var _=i.createNS("http://www.w3.org/2000/svg","path");_.setAttributeNS(null,"d","M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"),d.appendChild(_);var f=i.createNS("http://www.w3.org/2000/svg","g");f.setAttributeNS(null,"opacity","0.25"),f.setAttributeNS(null,"fill","#000000");var m=i.createNS("http://www.w3.org/2000/svg","path");m.setAttributeNS(null,"d","M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"),f.appendChild(m);var g=i.createNS("http://www.w3.org/2000/svg","g");g.setAttributeNS(null,"transform","translate(6.0, 7.0)"),g.setAttributeNS(null,"fill","#FFFFFF");var v=i.createNS("http://www.w3.org/2000/svg","g");v.setAttributeNS(null,"transform","translate(8.0, 8.0)");var y=i.createNS("http://www.w3.org/2000/svg","circle");y.setAttributeNS(null,"fill","#000000"),y.setAttributeNS(null,"opacity","0.25"),y.setAttributeNS(null,"cx","5.5"),y.setAttributeNS(null,"cy","5.5"),y.setAttributeNS(null,"r","5.4999962");var x=i.createNS("http://www.w3.org/2000/svg","circle");x.setAttributeNS(null,"fill","#FFFFFF"),x.setAttributeNS(null,"cx","5.5"),x.setAttributeNS(null,"cy","5.5"),x.setAttributeNS(null,"r","5.4999962"),v.appendChild(y),v.appendChild(x),s.appendChild(l),s.appendChild(d),s.appendChild(f),s.appendChild(g),s.appendChild(v),a.appendChild(s),this._element.appendChild(a),this._offset=t.Point.convert(o&&o.offset||[0,-14]);}this._element.classList.add("mapboxgl-marker"),this._popup=null;}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.addTo=function(t){return this.remove(),this._map=t,t.getCanvasContainer().appendChild(this._element),t.on("move",this._update),t.on("moveend",this._update),this.setDraggable(this._draggable),this._update(),this._map.on("click",this._onMapClick),this},o.prototype.remove=function(){return this._map&&(this._map.off("click",this._onMapClick),this._map.off("move",this._update),this._map.off("moveend",this._update),this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler),this._map.off("mouseup",this._onUp),this._map.off("touchend",this._onUp),delete this._map),i.remove(this._element),this._popup&&this._popup.remove(),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._popup&&this._popup.setLngLat(this._lngLat),this._update(),this},o.prototype.getElement=function(){return this._element},o.prototype.setPopup=function(t){if(this._popup&&(this._popup.remove(),this._popup=null),t){if(!("offset"in t.options)){var e=Math.sqrt(Math.pow(13.5,2)/2);t.options.offset=this._defaultMarker?{top:[0,0],"top-left":[0,0],"top-right":[0,0],bottom:[0,-38.1],"bottom-left":[e,-1*(24.6+e)],"bottom-right":[-e,-1*(24.6+e)],left:[13.5,-24.6],right:[-13.5,-24.6]}:this._offset;}this._popup=t,this._lngLat&&this._popup.setLngLat(this._lngLat);}return this},o.prototype._onMapClick=function(t){var e=t.originalEvent.target,i=this._element;this._popup&&(e===i||i.contains(e))&&this.togglePopup();},o.prototype.getPopup=function(){return this._popup},o.prototype.togglePopup=function(){var t=this._popup;return t?(t.isOpen()?t.remove():t.addTo(this._map),this):this},o.prototype._update=function(t){this._map&&(this._map.transform.renderWorldCopies&&(this._lngLat=Fo(this._lngLat,this._pos,this._map.transform)),this._pos=this._map.project(this._lngLat)._add(this._offset),t&&"moveend"!==t.type||(this._pos=this._pos.round()),i.setTransform(this._element,Uo[this._anchor]+" translate("+this._pos.x+"px, "+this._pos.y+"px)"),No(this._element,this._anchor,"marker"));},o.prototype.getOffset=function(){return this._offset},o.prototype.setOffset=function(e){return this._offset=t.Point.convert(e),this._update(),this},o.prototype._onMove=function(e){this._pos=e.point.sub(this._positionDelta),this._lngLat=this._map.unproject(this._pos),this.setLngLat(this._lngLat),this._element.style.pointerEvents="none","pending"===this._state&&(this._state="active",this.fire(new t.Event("dragstart"))),this.fire(new t.Event("drag"));},o.prototype._onUp=function(){this._element.style.pointerEvents="auto",this._positionDelta=null,this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),"active"===this._state&&this.fire(new t.Event("dragend")),this._state="inactive";},o.prototype._addDragHandler=function(t){this._element.contains(t.originalEvent.target)&&(t.preventDefault(),this._positionDelta=t.point.sub(this._pos).add(this._offset),this._state="pending",this._map.on("mousemove",this._onMove),this._map.on("touchmove",this._onMove),this._map.once("mouseup",this._onUp),this._map.once("touchend",this._onUp));},o.prototype.setDraggable=function(t){return this._draggable=!!t,this._map&&(t?(this._map.on("mousedown",this._addDragHandler),this._map.on("touchstart",this._addDragHandler)):(this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler))),this},o.prototype.isDraggable=function(){return this._draggable},o}(t.Evented),Vo={positionOptions:{enableHighAccuracy:!1,maximumAge:0,timeout:6e3},fitBoundsOptions:{maxZoom:15},trackUserLocation:!1,showUserLocation:!0};var qo=function(e){function o(i){e.call(this),this.options=t.extend({},Vo,i),t.bindAll(["_onSuccess","_onError","_finish","_setupUI","_updateCamera","_updateMarker"],this);}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.onAdd=function(e){var o;return this._map=e,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),o=this._setupUI,void 0!==Zo?o(Zo):void 0!==t.window.navigator.permissions?t.window.navigator.permissions.query({name:"geolocation"}).then(function(t){Zo="denied"!==t.state,o(Zo);}):(Zo=!!t.window.navigator.geolocation,o(Zo)),this._container},o.prototype.onRemove=function(){void 0!==this._geolocationWatchID&&(t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0),this.options.showUserLocation&&this._userLocationDotMarker&&this._userLocationDotMarker.remove(),i.remove(this._container),this._map=void 0;},o.prototype._onSuccess=function(e){if(this.options.trackUserLocation)switch(this._lastKnownPosition=e,this._watchState){case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"BACKGROUND":case"BACKGROUND_ERROR":this._watchState="BACKGROUND",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");}this.options.showUserLocation&&"OFF"!==this._watchState&&this._updateMarker(e),this.options.trackUserLocation&&"ACTIVE_LOCK"!==this._watchState||this._updateCamera(e),this.options.showUserLocation&&this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("geolocate",e)),this._finish();},o.prototype._updateCamera=function(e){var i=new t.LngLat(e.coords.longitude,e.coords.latitude),o=e.coords.accuracy;this._map.fitBounds(i.toBounds(o),this.options.fitBoundsOptions,{geolocateSource:!0});},o.prototype._updateMarker=function(t){t?this._userLocationDotMarker.setLngLat([t.coords.longitude,t.coords.latitude]).addTo(this._map):this._userLocationDotMarker.remove();},o.prototype._onError=function(e){if(this.options.trackUserLocation)if(1===e.code)this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),void 0!==this._geolocationWatchID&&this._clearWatch();else switch(this._watchState){case"WAITING_ACTIVE":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"ACTIVE_LOCK":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");break;case"BACKGROUND":this._watchState="BACKGROUND_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");}"OFF"!==this._watchState&&this.options.showUserLocation&&this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("error",e)),this._finish();},o.prototype._finish=function(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0;},o.prototype._setupUI=function(e){var o=this;!1!==e?(this._container.addEventListener("contextmenu",function(t){return t.preventDefault()}),this._geolocateButton=i.create("button","mapboxgl-ctrl-icon mapboxgl-ctrl-geolocate",this._container),this._geolocateButton.type="button",this._geolocateButton.setAttribute("aria-label","Geolocate"),this.options.trackUserLocation&&(this._geolocateButton.setAttribute("aria-pressed","false"),this._watchState="OFF"),this.options.showUserLocation&&(this._dotElement=i.create("div","mapboxgl-user-location-dot"),this._userLocationDotMarker=new jo(this._dotElement),this.options.trackUserLocation&&(this._watchState="OFF")),this._geolocateButton.addEventListener("click",this.trigger.bind(this)),this._setup=!0,this.options.trackUserLocation&&this._map.on("movestart",function(e){e.geolocateSource||"ACTIVE_LOCK"!==o._watchState||(o._watchState="BACKGROUND",o._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),o._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),o.fire(new t.Event("trackuserlocationend")));})):t.warnOnce("Geolocation support is not available, the GeolocateControl will not be visible.");},o.prototype.trigger=function(){if(!this._setup)return t.warnOnce("Geolocate control triggered before added to a map"),!1;if(this.options.trackUserLocation){switch(this._watchState){case"OFF":this._watchState="WAITING_ACTIVE",this.fire(new t.Event("trackuserlocationstart"));break;case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":case"BACKGROUND_ERROR":this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this.fire(new t.Event("trackuserlocationend"));break;case"BACKGROUND":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._lastKnownPosition&&this._updateCamera(this._lastKnownPosition),this.fire(new t.Event("trackuserlocationstart"));}switch(this._watchState){case"WAITING_ACTIVE":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_LOCK":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"BACKGROUND":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");break;case"BACKGROUND_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");}"OFF"===this._watchState&&void 0!==this._geolocationWatchID?this._clearWatch():void 0===this._geolocationWatchID&&(this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","true"),this._geolocationWatchID=t.window.navigator.geolocation.watchPosition(this._onSuccess,this._onError,this.options.positionOptions));}else t.window.navigator.geolocation.getCurrentPosition(this._onSuccess,this._onError,this.options.positionOptions),this._timeoutId=setTimeout(this._finish,1e4);return !0},o.prototype._clearWatch=function(){t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0,this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","false"),this.options.showUserLocation&&this._updateMarker(null);},o}(t.Evented),Go={maxWidth:100,unit:"metric"},Wo=function(e){this.options=t.extend({},Go,e),t.bindAll(["_onMove","setUnit"],this);};function Xo(t,e,i){var o,r,a,n,s,l,c=i&&i.maxWidth||100,u=t._container.clientHeight/2,h=(o=t.unproject([0,u]),r=t.unproject([c,u]),a=Math.PI/180,n=o.lat*a,s=r.lat*a,l=Math.sin(n)*Math.sin(s)+Math.cos(n)*Math.cos(s)*Math.cos((r.lng-o.lng)*a),6371e3*Math.acos(Math.min(l,1)));if(i&&"imperial"===i.unit){var p=3.2808*h;if(p>5280)Ho(e,c,p/5280,"mi");else Ho(e,c,p,"ft");}else if(i&&"nautical"===i.unit){Ho(e,c,h/1852,"nm");}else Ho(e,c,h,"m");}function Ho(t,e,i,o){var r,a,n,s=(r=i,a=Math.pow(10,(""+Math.floor(r)).length-1),n=(n=r/a)>=10?10:n>=5?5:n>=3?3:n>=2?2:n>=1?1:function(t){var e=Math.pow(10,Math.ceil(-Math.log(t)/Math.LN10));return Math.round(t*e)/e}(n),a*n),l=s/i;"m"===o&&s>=1e3&&(s/=1e3,o="km"),t.style.width=e*l+"px",t.innerHTML=s+o;}Wo.prototype.getDefaultPosition=function(){return "bottom-left"},Wo.prototype._onMove=function(){Xo(this._map,this._container,this.options);},Wo.prototype.onAdd=function(t){return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-scale",t.getContainer()),this._map.on("move",this._onMove),this._onMove(),this._container},Wo.prototype.onRemove=function(){i.remove(this._container),this._map.off("move",this._onMove),this._map=void 0;},Wo.prototype.setUnit=function(t){this.options.unit=t,Xo(this._map,this._container,this.options);};var Ko=function(e){this._fullscreen=!1,e&&e.container&&(e.container instanceof t.window.HTMLElement?this._container=e.container:t.warnOnce("Full screen control 'container' must be a DOM element.")),t.bindAll(["_onClickFullscreen","_changeIcon"],this),"onfullscreenchange"in t.window.document?this._fullscreenchange="fullscreenchange":"onmozfullscreenchange"in t.window.document?this._fullscreenchange="mozfullscreenchange":"onwebkitfullscreenchange"in t.window.document?this._fullscreenchange="webkitfullscreenchange":"onmsfullscreenchange"in t.window.document&&(this._fullscreenchange="MSFullscreenChange"),this._className="mapboxgl-ctrl";};Ko.prototype.onAdd=function(e){return this._map=e,this._container||(this._container=this._map.getContainer()),this._controlContainer=i.create("div",this._className+" mapboxgl-ctrl-group"),this._checkFullscreenSupport()?this._setupUI():(this._controlContainer.style.display="none",t.warnOnce("This device does not support fullscreen mode.")),this._controlContainer},Ko.prototype.onRemove=function(){i.remove(this._controlContainer),this._map=null,t.window.document.removeEventListener(this._fullscreenchange,this._changeIcon);},Ko.prototype._checkFullscreenSupport=function(){return !!(t.window.document.fullscreenEnabled||t.window.document.mozFullScreenEnabled||t.window.document.msFullscreenEnabled||t.window.document.webkitFullscreenEnabled)},Ko.prototype._setupUI=function(){var e=this._fullscreenButton=i.create("button",this._className+"-icon "+this._className+"-fullscreen",this._controlContainer);e.setAttribute("aria-label","Toggle fullscreen"),e.type="button",this._fullscreenButton.addEventListener("click",this._onClickFullscreen),t.window.document.addEventListener(this._fullscreenchange,this._changeIcon);},Ko.prototype._isFullscreen=function(){return this._fullscreen},Ko.prototype._changeIcon=function(){(t.window.document.fullscreenElement||t.window.document.mozFullScreenElement||t.window.document.webkitFullscreenElement||t.window.document.msFullscreenElement)===this._container!==this._fullscreen&&(this._fullscreen=!this._fullscreen,this._fullscreenButton.classList.toggle(this._className+"-shrink"),this._fullscreenButton.classList.toggle(this._className+"-fullscreen"));},Ko.prototype._onClickFullscreen=function(){this._isFullscreen()?t.window.document.exitFullscreen?t.window.document.exitFullscreen():t.window.document.mozCancelFullScreen?t.window.document.mozCancelFullScreen():t.window.document.msExitFullscreen?t.window.document.msExitFullscreen():t.window.document.webkitCancelFullScreen&&t.window.document.webkitCancelFullScreen():this._container.requestFullscreen?this._container.requestFullscreen():this._container.mozRequestFullScreen?this._container.mozRequestFullScreen():this._container.msRequestFullscreen?this._container.msRequestFullscreen():this._container.webkitRequestFullscreen&&this._container.webkitRequestFullscreen();};var Yo={closeButton:!0,closeOnClick:!0,className:""},Jo=function(e){function o(i){e.call(this),this.options=t.extend(Object.create(Yo),i),t.bindAll(["_update","_onClickClose","remove"],this);}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.addTo=function(e){return this._map=e,this._map.on("move",this._update),this.options.closeOnClick&&this._map.on("click",this._onClickClose),this._map.on("remove",this.remove),this._update(),this.fire(new t.Event("open")),this},o.prototype.isOpen=function(){return !!this._map},o.prototype.remove=function(){return this._content&&i.remove(this._content),this._container&&(i.remove(this._container),delete this._container),this._map&&(this._map.off("move",this._update),this._map.off("click",this._onClickClose),this._map.off("remove",this.remove),delete this._map),this.fire(new t.Event("close")),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._update(),this},o.prototype.setText=function(e){return this.setDOMContent(t.window.document.createTextNode(e))},o.prototype.setHTML=function(e){var i,o=t.window.document.createDocumentFragment(),r=t.window.document.createElement("body");for(r.innerHTML=e;i=r.firstChild;)o.appendChild(i);return this.setDOMContent(o)},o.prototype.setDOMContent=function(t){return this._createContent(),this._content.appendChild(t),this._update(),this},o.prototype._createContent=function(){this._content&&i.remove(this._content),this._content=i.create("div","mapboxgl-popup-content",this._container),this.options.closeButton&&(this._closeButton=i.create("button","mapboxgl-popup-close-button",this._content),this._closeButton.type="button",this._closeButton.setAttribute("aria-label","Close popup"),this._closeButton.innerHTML="&#215;",this._closeButton.addEventListener("click",this._onClickClose));},o.prototype._update=function(){var e=this;if(this._map&&this._lngLat&&this._content){this._container||(this._container=i.create("div","mapboxgl-popup",this._map.getContainer()),this._tip=i.create("div","mapboxgl-popup-tip",this._container),this._container.appendChild(this._content),this.options.className&&this.options.className.split(" ").forEach(function(t){return e._container.classList.add(t)})),this._map.transform.renderWorldCopies&&(this._lngLat=Fo(this._lngLat,this._pos,this._map.transform));var o=this._pos=this._map.project(this._lngLat),r=this.options.anchor,a=function e(i){if(i){if("number"==typeof i){var o=Math.round(Math.sqrt(.5*Math.pow(i,2)));return {center:new t.Point(0,0),top:new t.Point(0,i),"top-left":new t.Point(o,o),"top-right":new t.Point(-o,o),bottom:new t.Point(0,-i),"bottom-left":new t.Point(o,-o),"bottom-right":new t.Point(-o,-o),left:new t.Point(i,0),right:new t.Point(-i,0)}}if(i instanceof t.Point||Array.isArray(i)){var r=t.Point.convert(i);return {center:r,top:r,"top-left":r,"top-right":r,bottom:r,"bottom-left":r,"bottom-right":r,left:r,right:r}}return {center:t.Point.convert(i.center||[0,0]),top:t.Point.convert(i.top||[0,0]),"top-left":t.Point.convert(i["top-left"]||[0,0]),"top-right":t.Point.convert(i["top-right"]||[0,0]),bottom:t.Point.convert(i.bottom||[0,0]),"bottom-left":t.Point.convert(i["bottom-left"]||[0,0]),"bottom-right":t.Point.convert(i["bottom-right"]||[0,0]),left:t.Point.convert(i.left||[0,0]),right:t.Point.convert(i.right||[0,0])}}return e(new t.Point(0,0))}(this.options.offset);if(!r){var n,s=this._container.offsetWidth,l=this._container.offsetHeight;n=o.y+a.bottom.y<l?["top"]:o.y>this._map.transform.height-l?["bottom"]:[],o.x<s/2?n.push("left"):o.x>this._map.transform.width-s/2&&n.push("right"),r=0===n.length?"bottom":n.join("-");}var c=o.add(a[r]).round();i.setTransform(this._container,Uo[r]+" translate("+c.x+"px,"+c.y+"px)"),No(this._container,r,"popup");}},o.prototype._onClickClose=function(){this.remove();},o}(t.Evented);var Qo={version:t.version,supported:e,setRTLTextPlugin:t.setRTLTextPlugin,Map:Ao,NavigationControl:Oo,GeolocateControl:qo,AttributionControl:zo,ScaleControl:Wo,FullscreenControl:Ko,Popup:Jo,Marker:jo,Style:Me,LngLat:t.LngLat,LngLatBounds:t.LngLatBounds,Point:t.Point,MercatorCoordinate:t.MercatorCoordinate,Evented:t.Evented,config:t.config,get accessToken(){return t.config.ACCESS_TOKEN},set accessToken(e){t.config.ACCESS_TOKEN=e;},get baseApiUrl(){return t.config.API_URL},set baseApiUrl(e){t.config.API_URL=e;},get workerCount(){return Pt.workerCount},set workerCount(t){Pt.workerCount=t;},get maxParallelImageRequests(){return t.config.MAX_PARALLEL_IMAGE_REQUESTS},set maxParallelImageRequests(e){t.config.MAX_PARALLEL_IMAGE_REQUESTS=e;},workerUrl:""};return Qo});

//

return mapboxgl;

}));
//# sourceMappingURL=mapbox-gl.js.map


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "(function(){var Module={TOTAL_MEMORY:8*1024*1024,TOTAL_STACK:2*1024*1024,preRun:[],postRun:[],print:function(text){console.log(text)},printErr:function(text){text=Array.prototype.slice.call(arguments).join(\" \");if(text.indexOf(\"pre-main prep time\")>=0){return}console.error(text)}};var b;b||(b=eval(\"(function() { try { return Module || {} } catch(e) { return {} } })()\"));var g={},k;for(k in b)b.hasOwnProperty(k)&&(g[k]=b[k]);var n=!1,p=!1,r=!1,u=!1;if(b.ENVIRONMENT)if(\"WEB\"===b.ENVIRONMENT)n=!0;else if(\"WORKER\"===b.ENVIRONMENT)p=!0;else if(\"NODE\"===b.ENVIRONMENT)r=!0;else if(\"SHELL\"===b.ENVIRONMENT)u=!0;else throw Error(\"The provided Module['ENVIRONMENT'] value is not valid. It must be one of: WEB|WORKER|NODE|SHELL.\");else n=\"object\"===typeof window,p=\"function\"===typeof importScripts,r=\"object\"===typeof process&&\"function\"===typeof require&&!n&&!p,u=!n&&!r&&!p;if(r){b.print||(b.print=console.log);b.printErr||(b.printErr=console.warn);var v,x;b.read=function(a,c){v||(v=require(\"fs\"));x||(x=require(\"path\"));a=x.normalize(a);var d=v.readFileSync(a);return c?d:d.toString()};b.readBinary=function(a){a=b.read(a,!0);a.buffer||(a=new Uint8Array(a));return a};b.load=function(a){aa(read(a))};b.thisProgram||(b.thisProgram=1<process.argv.length?process.argv[1].replace(/\\\\/g,\"/\"):\"unknown-program\");b.arguments=process.argv.slice(2);\"undefined\"!==typeof module&&(module.exports=b);process.on(\"uncaughtException\",function(a){if(!(a instanceof y))throw a});b.inspect=function(){return\"[Emscripten Module object]\"}}else if(u)b.print||(b.print=print),\"undefined\"!=typeof printErr&&(b.printErr=printErr),b.read=\"undefined\"!=typeof read?read:function(){throw\"no read() available\"},b.readBinary=function(a){if(\"function\"===typeof readbuffer)return new Uint8Array(readbuffer(a));a=read(a,\"binary\");return a},\"undefined\"!=typeof scriptArgs?b.arguments=scriptArgs:\"undefined\"!=typeof arguments&&(b.arguments=arguments),\"function\"===typeof quit&&(b.quit=function(a){quit(a)}),eval(\"if (typeof gc === 'function' && gc.toString().indexOf('[native code]') > 0) var gc = undefined\");else if(n||p)b.read=function(a){var c=new XMLHttpRequest;c.open(\"GET\",a,!1);c.send(null);return c.responseText},p&&(b.readBinary=function(a){var c=new XMLHttpRequest;c.open(\"GET\",a,!1);c.responseType=\"arraybuffer\";c.send(null);return c.response}),b.readAsync=function(a,c,d){var e=new XMLHttpRequest;e.open(\"GET\",a,!0);e.responseType=\"arraybuffer\";e.onload=function(){200==e.status||0==e.status&&e.response?c(e.response):d()};e.onerror=d;e.send(null)},\"undefined\"!=typeof arguments&&(b.arguments=arguments),\"undefined\"!==typeof console?(b.print||(b.print=function(a){console.log(a)}),b.printErr||(b.printErr=function(a){console.warn(a)})):b.print||(b.print=function(){}),p&&(b.load=importScripts),\"undefined\"===typeof b.setWindowTitle&&(b.setWindowTitle=function(a){document.title=a});else throw\"Unknown runtime environment. Where are we?\";function aa(a){eval.call(null,a)}!b.load&&b.read&&(b.load=function(a){aa(b.read(a))});b.print||(b.print=function(){});b.printErr||(b.printErr=b.print);b.arguments||(b.arguments=[]);b.thisProgram||(b.thisProgram=\"./this.program\");b.quit||(b.quit=function(a,c){throw c});b.print=b.print;b.e=b.printErr;b.preRun=[];b.postRun=[];for(k in g)g.hasOwnProperty(k)&&(b[k]=g[k]);var g=void 0,A={b:function(a){return tempRet0=a},w:function(){return tempRet0},m:function(){return z},g:function(a){z=a},p:function(a){switch(a){case\"i1\":case\"i8\":return 1;case\"i16\":return 2;case\"i32\":return 4;case\"i64\":return 8;case\"float\":return 4;case\"double\":return 8;default:return\"*\"===a[a.length-1]?A.h:\"i\"===a[0]?(a=parseInt(a.substr(1)),assert_em(0===a%8),a/8):0}},v:function(a){return Math.max(A.p(a),A.h)},B:16,Q:function(a,c){\"double\"===c||\"i64\"===c?a&7&&(assert_em(4===(a&7)),a+=4):assert_em(0===(a&3));return a},K:function(a,c,d){return d||\"i64\"!=a&&\"double\"!=a?a?Math.min(c||(a?A.v(a):0),A.h):Math.min(c,8):8},j:function(a,c,d){return d&&d.length?b[\"dynCall_\"+a].apply(null,[c].concat(d)):b[\"dynCall_\"+a].call(null,c)},d:[],r:function(a){for(var c=0;c<A.d.length;c++)if(!A.d[c])return A.d[c]=a,2*(1+c);throw\"Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS.\"},A:function(a){A.d[(a-2)/2]=null},c:function(a){A.c.l||(A.c.l={});A.c.l[a]||(A.c.l[a]=1,b.e(a))},k:{},M:function(a,c){A.k[c]||(A.k[c]={});var d=A.k[c];d[a]||(d[a]=1===c.length?function(){return A.j(c,a)}:2===c.length?function(d){return A.j(c,a,[d])}:function(){return A.j(c,a,Array.prototype.slice.call(arguments))});return d[a]},L:function(){throw\"You must build with -s RETAIN_COMPILER_SETTINGS=1 for Runtime.getCompilerSetting or emscripten_get_compiler_setting to work\"},f:function(a){var c=z;z=z+a|0;z=z+15&-16;return c},q:function(a){var c=B;B=B+a|0;B=B+15&-16;return c},u:function(a){var c=C[E>>2];a=(c+a+15|0)&-16;C[E>>2]=a;return a>=F&&!ba()?(C[E>>2]=c,0):c},o:function(a,c){return Math.ceil(a/(c?c:16))*(c?c:16)},P:function(a,c,d){return d?+(a>>>0)+4294967296*+(c>>>0):+(a>>>0)+4294967296*+(c|0)},a:8,h:4,C:0};A.addFunction=A.r;A.removeFunction=A.A;var G=0;function assert_em(a,c){a||H(\"Assertion failed: \"+c)}function ca(a){var c=b[\"_\"+a];if(!c)try{c=eval(\"_\"+a)}catch(d){}return c}var da;(function(){var a={stackSave:function(){A.m()},stackRestore:function(){A.g()},arrayToC:function(a){var c=A.f(a.length);I.set(a,c);return c},stringToC:function(a){var c=0;if(null!==a&&void 0!==a&&0!==a){var f=(a.length<<2)+1,c=A.f(f);J(a,K,c,f)}return c}},c={string:a.stringToC,array:a.arrayToC};da=function(a,e,f,h,l){a=ca(a);var m=[],t=0;if(h)for(var w=0;w<h.length;w++){var q=c[f[w]];q?(0===t&&(t=A.m()),m[w]=q(h[w])):m[w]=h[w]}f=a.apply(null,m);\"string\"===e&&(f=ea(f));if(0!==t){if(l&&l.async){EmterpreterAsync.F.push(function(){A.g(t)});return}A.g(t)}return f}})();b.ccall=da;function fa(a){var c;c=\"i32\";\"*\"===c.charAt(c.length-1)&&(c=\"i32\");switch(c){case\"i1\":return I[a>>0];case\"i8\":return I[a>>0];case\"i16\":return L[a>>1];case\"i32\":return C[a>>2];case\"i64\":return C[a>>2];case\"float\":return M[a>>2];case\"double\":return N[a>>3];default:H(\"invalid type for setValue: \"+c)}return null}function O(a,c,d,e){var f,h;\"number\"===typeof a?(f=!0,h=a):(f=!1,h=a.length);var l=\"string\"===typeof c?c:null,m;4==d?m=e:m=[\"function\"===typeof P?P:A.q,A.f,A.q,A.u][void 0===d?2:d](Math.max(h,l?1:c.length));if(f){e=m;for(a=m+(h&-4);e<a;e+=4)C[e>>2]=0;for(a=m+h;e<a;)I[e++>>0]=0;return m}if(\"i8\"===l)return a.subarray||a.slice?K.set(a,m):K.set(new Uint8Array(a),m),m;e=0;for(var t,w;e<h;){var q=a[e];\"function\"===typeof q&&(q=A.N(q));d=l||c[e];if(0===d)e++;else{\"i64\"==d&&(d=\"i32\");f=m+e;var D=d,D=D||\"i8\";\"*\"===D.charAt(D.length-1)&&(D=\"i32\");switch(D){case\"i1\":I[f>>0]=q;break;case\"i8\":I[f>>0]=q;break;case\"i16\":L[f>>1]=q;break;case\"i32\":C[f>>2]=q;break;case\"i64\":tempI64=[q>>>0,(tempDouble=q,1<=+ga(tempDouble)?0<tempDouble?(ha(+ia(tempDouble/4294967296),4294967295)|0)>>>0:~~+ja((tempDouble-+(~~tempDouble>>>0))/4294967296)>>>0:0)];C[f>>2]=tempI64[0];C[f+4>>2]=tempI64[1];break;case\"float\":M[f>>2]=q;break;case\"double\":N[f>>3]=q;break;default:H(\"invalid type for setValue: \"+D)}w!==d&&(t=A.p(d),w=d);e+=t}}return m}function ea(a){var c;if(0===c||!a)return\"\";for(var d=0,e,f=0;;){e=K[a+f>>0];d|=e;if(0==e&&!c)break;f++;if(c&&f==c)break}c||(c=f);e=\"\";if(128>d){for(;0<c;)d=String.fromCharCode.apply(String,K.subarray(a,a+Math.min(c,1024))),e=e?e+d:d,a+=1024,c-=1024;return e}return b.UTF8ToString(a)}\"undefined\"!==typeof TextDecoder&&new TextDecoder(\"utf8\");function J(a,c,d,e){if(0<e){e=d+e-1;for(var f=0;f<a.length;++f){var h=a.charCodeAt(f);55296<=h&&57343>=h&&(h=65536+((h&1023)<<10)|a.charCodeAt(++f)&1023);if(127>=h){if(d>=e)break;c[d++]=h}else{if(2047>=h){if(d+1>=e)break;c[d++]=192|h>>6}else{if(65535>=h){if(d+2>=e)break;c[d++]=224|h>>12}else{if(2097151>=h){if(d+3>=e)break;c[d++]=240|h>>18}else{if(67108863>=h){if(d+4>=e)break;c[d++]=248|h>>24}else{if(d+5>=e)break;c[d++]=252|h>>30;c[d++]=128|h>>24&63}c[d++]=128|h>>18&63}c[d++]=128|h>>12&63}c[d++]=128|h>>6&63}c[d++]=128|h&63}}c[d]=0}}function ka(a){for(var c=0,d=0;d<a.length;++d){var e=a.charCodeAt(d);55296<=e&&57343>=e&&(e=65536+((e&1023)<<10)|a.charCodeAt(++d)&1023);127>=e?++c:c=2047>=e?c+2:65535>=e?c+3:2097151>=e?c+4:67108863>=e?c+5:c+6}return c}var la=\"undefined\"!==typeof TextDecoder?new TextDecoder(\"utf-16le\"):void 0;b.UTF16ToString=function(a){var c;for(c=a>>1;L[c];)++c;c<<=1;if(32<c-a&&la)return la.decode(K.subarray(a,c));c=0;for(var d=\"\";;){var e=L[a+2*c>>1];if(0==e)return d;++c;d+=String.fromCharCode(e)}};b.stringToUTF16=function(a,c,d){void 0===d&&(d=2147483647);if(2>d)return 0;d-=2;var e=c;d=d<2*a.length?d/2:a.length;for(var f=0;f<d;++f)L[c>>1]=a.charCodeAt(f),c+=2;L[c>>1]=0;return c-e};function ma(a){return a.replace(/__Z[\\w\\d_]+/g,function(a){var d;a:{var e=b.___cxa_demangle||b.__cxa_demangle;if(e)try{var f=a.substr(1),h=ka(f)+1,l=P(h);J(f,K,l,h);var m=P(4),t=e(l,0,0,m);if(0===fa(m)&&t){d=ea(t);break a}}catch(w){}finally{l&&Q(l),m&&Q(m),t&&Q(t)}else A.c(\"warning: build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling\");d=a}return a===d?a:a+\" [\"+d+\"]\"})}function na(){var a;a:{a=Error();if(!a.stack){try{throw Error(0)}catch(c){a=c}if(!a.stack){a=\"(no stack trace available)\";break a}}a=a.stack.toString()}b.extraStackTrace&&(a+=\"\\n\"+b.extraStackTrace());return ma(a)}var oa=65536,pa=16777216,qa=16777216;function ra(a,c){0<a%c&&(a+=c-a%c);return a}var buffer,I,K,L,sa,C,ta,M,N;function ua(){b.HEAP8=I=new Int8Array(buffer);b.HEAP16=L=new Int16Array(buffer);b.HEAP32=C=new Int32Array(buffer);b.HEAPU8=K=new Uint8Array(buffer);b.HEAPU16=sa=new Uint16Array(buffer);b.HEAPU32=ta=new Uint32Array(buffer);b.HEAPF32=M=new Float32Array(buffer);b.HEAPF64=N=new Float64Array(buffer)}var R,B,S,z,T,U,E;R=B=S=z=T=U=E=0;b.reallocBuffer||(b.reallocBuffer=function(a){var c;try{if(ArrayBuffer.n)c=ArrayBuffer.n(buffer,a);else{var d=I;c=new ArrayBuffer(a);new Int8Array(c).set(d)}}catch(e){return!1}return va(c)?c:!1});function ba(){var a=b.usingWasm?oa:pa,c=2147483648-a;if(C[E>>2]>c)return!1;for(F=Math.max(F,qa);F<C[E>>2];)536870912>=F?F=ra(2*F,a):F=Math.min(ra((3*F+2147483648)/4,a),c);a=b.reallocBuffer(F);if(!a||a.byteLength!=F)return!1;b.buffer=buffer=a;ua();return!0}var V;try{V=Function.prototype.call.bind(Object.getOwnPropertyDescriptor(ArrayBuffer.prototype,\"byteLength\").get),V(new ArrayBuffer(4))}catch(wa){V=function(a){return a.byteLength}}var xa=b.TOTAL_STACK||5242880,F=b.TOTAL_MEMORY||16777216;F<xa&&b.e(\"TOTAL_MEMORY should be larger than TOTAL_STACK, was \"+F+\"! (TOTAL_STACK=\"+xa+\")\");b.buffer?buffer=b.buffer:buffer=new ArrayBuffer(F);ua();C[0]=1668509029;L[1]=25459;if(115!==K[2]||99!==K[3])throw\"Runtime error: expected the system to be little-endian!\";b.HEAP=void 0;b.buffer=buffer;b.HEAP8=I;b.HEAP16=L;b.HEAP32=C;b.HEAPU8=K;b.HEAPU16=sa;b.HEAPU32=ta;b.HEAPF32=M;b.HEAPF64=N;function W(a){for(;0<a.length;){var c=a.shift();if(\"function\"==typeof c)c();else{var d=c.J;\"number\"===typeof d?void 0===c.i?b.dynCall_v(d):b.dynCall_vi(d,c.i):d(void 0===c.i?null:c.i)}}}var ya=[],za=[],Aa=[],Ba=[],Ca=[],X=!1;function Da(){var a=b.preRun.shift();ya.unshift(a)}function Ea(a){var c=Array(ka(a)+1);J(a,c,0,c.length);return c}Math.imul&&-5===Math.imul(4294967295,5)||(Math.imul=function(a,c){var d=a&65535,e=c&65535;return d*e+((a>>>16)*e+d*(c>>>16)<<16)|0});Math.O=Math.imul;Math.clz32||(Math.clz32=function(a){a=a>>>0;for(var c=0;32>c;c++)if(a&1<<31-c)return c;return 32});Math.H=Math.clz32;Math.trunc||(Math.trunc=function(a){return 0>a?Math.ceil(a):Math.floor(a)});Math.trunc=Math.trunc;var ga=Math.abs,ja=Math.ceil,ia=Math.floor,ha=Math.min;b.preloadedImages={};b.preloadedAudios={};R=A.a;B=R+69472;za.push()\n;O([20,3,0,0,159,12,1,0,24,0,0,0,0,0,0,0,20,3,0,0,76,12,1,0,40,0,0,0,0,0,0,0,236,2,0,0,109,12,1,0,20,3,0,0,122,12,1,0,8,0,0,0,0,0,0,0,20,3,0,0,229,12,1,0,24,0,0,0,0,0,0,0,20,3,0,0,193,12,1,0,64,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,89,7,1,0,20,7,1,0,76,7,1,0,83,7,1,0,200,5,1,0,176,6,1,0,195,5,1,0,232,6,1,0,236,6,1,0,20,7,1,0,76,7,1,0,83,7,1,0,107,5,1,0,176,6,1,0,195,5,1,0,232,6,1,0,80,6,1,0,128,6,1,0,195,5,1,0,195,5,1,0,248,5,1,0,40,6,1,0,195,5,1,0,195,5,1,0,200,5,1,0,147,5,1,0,195,5,1,0,195,5,1,0,107,5,1,0,147,5,1,0,195,5,1,0,195,5,1,0,0,16,0,0,0,128,0,0,0,8,0,0,0,64,0,0,0,0,0,0,72,1,0,0,136,1,0,0,124,9,1,0,28,12,1,0,106,169,0,0,186,196,0,0,0,0,0,0,168,13,0,0,140,31,0,0,160,1,40,14,0,0,0,0,0,0,0,0,0,0,17,0,48,45,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,2,0,0,16,0,0,0,240,93,0,0,120,90,0,0,26,0,0,0,32,6,0,0,192,8,0,0,192,10,1,0,240,10,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,182,2,88,0,171,0,32,0,187,0,0,0,21,34,160,2,67,34,32,1,152,34,128,2,166,34,192,2,168,34,0,3,169,34,224,2,171,34,32,3,205,34,96,0,242,34,224,1,243,34,0,2,244,34,32,2,246,34,64,2,247,34,96,2,250,34,64,1,251,34,96,1,252,34,128,1,253,34,160,1,254,34,192,1,184,41,128,0,245,41,64,0,222,42,160,0,227,42,224,0,228,42,192,0,229,42,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,80,13,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,4,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,48,0,0,0,1,0,0,0,5,0,0,0,3,0,0,0,4,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,113,6,113,6,123,6,123,6,123,6,123,6,126,6,126,6,126,6,126,6,0,0,0,0,0,0,0,0,122,6,122,6,122,6,122,6,0,0,0,0,0,0,0,0,121,6,121,6,121,6,121,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,134,6,134,6,134,6,134,6,0,0,0,0,0,0,0,0,141,6,141,6,140,6,140,6,142,6,142,6,136,6,136,6,152,6,152,6,145,6,145,6,169,6,169,6,169,6,169,6,175,6,175,6,175,6,175,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,186,6,186,6,187,6,187,6,187,6,187,6,192,6,192,6,193,6,193,6,193,6,193,6,190,6,190,6,190,6,190,6,210,6,210,6,211,6,211,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,199,6,199,6,198,6,198,6,200,6,200,6,0,0,203,6,203,6,197,6,197,6,201,6,201,6,208,6,208,6,208,6,208,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,204,6,204,6,204,6,204,6,75,6,75,6,76,6,76,6,77,6,77,6,78,6,78,6,79,6,79,6,80,6,80,6,81,6,81,6,82,6,82,6,33,6,34,6,34,6,35,6,35,6,36,6,36,6,37,6,37,6,38,6,38,6,38,6,38,6,39,6,39,6,40,6,40,6,40,6,40,6,41,6,41,6,42,6,42,6,42,6,42,6,43,6,43,6,43,6,43,6,44,6,44,6,44,6,44,6,45,6,45,6,45,6,45,6,46,6,46,6,46,6,46,6,47,6,47,6,48,6,48,6,49,6,49,6,50,6,50,6,51,6,51,6,51,6,51,6,52,6,52,6,52,6,52,6,53,6,53,6,53,6,53,6,54,6,54,6,54,6,54,6,55,6,55,6,55,6,55,6,56,6,56,6,56,6,56,6,57,6,57,6,57,6,57,6,58,6,58,6,58,6,58,6,65,6,65,6,65,6,65,6,66,6,66,6,66,6,66,6,67,6,67,6,67,6,67,6,68,6,68,6,68,6,68,6,69,6,69,6,69,6,69,6,70,6,70,6,70,6,70,6,71,6,71,6,71,6,71,6,72,6,72,6,73,6,73,6,74,6,74,6,74,6,74,6,92,6,92,6,93,6,93,6,94,6,94,6,95,6,95,6,33,17,33,19,1,21,33,23,3,25,33,29,3,31,1,35,3,37,3,41,3,45,3,49,3,53,1,57,1,59,1,61,1,63,3,65,3,69,3,73,3,77,3,81,3,85,3,89,3,93,0,0,0,0,0,0,0,0,0,0,3,0,3,97,3,101,3,105,19,109,3,113,3,117,3,121,1,125,1,127,3,129,4,1,132,1,132,1,132,1,132,1,132,1,68,3,4,1,4,7,4,8,4,8,4,1,0,0,0,0,0,0,0,0,0,0,1,133,1,135,1,137,1,139,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,6,9,0,33,0,33,0,0,0,33,0,1,0,1,0,3,0,11,22,11,14,11,2,3,0,3,0,11,6,3,0,3,0,3,0,3,0,3,0,3,0,3,0,11,42,3,0,9,56,1,0,1,0,1,0,9,52,9,50,9,54,1,0,1,0,9,60,1,0,1,0,1,0,1,0,1,0,1,0,9,58,1,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,11,62,3,0,3,0,3,0,3,0,3,0,11,66,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,9,78,11,80,3,0,3,0,11,90,3,0,9,84,11,86,1,0,1,0,1,0,9,144,9,137,9,135,9,139,9,146,1,0,9,142,11,172,1,0,3,0,3,0,11,148,3,0,9,94,9,96,78,4,86,4,94,4,102,4,126,4,134,4,142,4,150,4,158,4,166,4,172,4,180,4,188,4,196,4,204,4,212,4,218,4,226,4,234,4,242,4,245,4,253,4,5,5,13,5,21,5,29,5,25,5,33,5,41,5,49,5,54,5,62,5,70,5,78,5,82,5,90,5,98,5,106,5,114,5,122,5,118,5,126,5,131,5,139,5,145,5,153,5,161,5,169,5,177,5,185,5,193,5,201,5,206,5,214,5,217,5,225,5,233,5,241,5,247,5,255,5,254,5,6,6,14,6,22,6,38,6,30,6,46,6,110,4,110,4,62,6,70,6,54,6,86,6,88,6,96,6,78,6,112,6,118,6,126,6,104,6,142,6,148,6,156,6,134,6,172,6,178,6,186,6,164,6,202,6,208,6,216,6,194,6,232,6,240,6,248,6,224,6,8,7,14,7,22,7,0,7,38,7,44,7,52,7,30,7,68,7,73,7,81,7,60,7,97,7,104,7,112,7,89,7,250,5,120,7,128,7,110,4,136,7,144,7,152,7,110,4,160,7,168,7,176,7,181,7,189,7,196,7,204,7,110,4,185,5,212,7,220,7,228,7,236,7,70,5,252,7,244,7,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,2,8,185,5,10,8,0,8,18,8,185,5,14,8,185,5,24,8,32,8,40,8,70,5,70,5,48,8,56,8,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,61,8,69,8,185,5,185,5,77,8,85,8,93,8,101,8,109,8,185,5,117,8,125,8,133,8,149,8,185,5,157,8,159,8,167,8,141,8,185,5,170,8,190,8,178,8,186,8,198,8,185,5,206,8,212,8,220,8,228,8,185,5,244,8,252,8,4,9,236,8,110,4,110,4,20,9,23,9,31,9,12,9,47,9,39,9,185,5,54,9,185,5,69,9,62,9,77,9,85,9,110,4,93,9,101,9,238,4,109,9,112,9,118,9,125,9,112,9,21,5,133,9,158,4,158,4,158,4,158,4,141,9,158,4,158,4,158,4,157,9,165,9,173,9,181,9,189,9,193,9,201,9,149,9,225,9,233,9,209,9,217,9,241,9,249,9,1,10,9,10,33,10,17,10,25,10,41,10,49,10,64,10,69,10,56,10,77,10,77,10,77,10,77,10,77,10,77,10,77,10,77,10,85,10,93,10,220,8,96,10,104,10,111,10,116,10,124,10,220,8,130,10,129,10,146,10,149,10,220,8,220,8,138,10,220,8,220,8,220,8,220,8,220,8,164,10,172,10,156,10,220,8,220,8,220,8,177,10,220,8,220,8,220,8,220,8,220,8,220,8,220,8,183,10,191,10,220,8,199,10,206,10,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,77,10,77,10,77,10,77,10,214,10,77,10,221,10,228,10,77,10,77,10,77,10,77,10,77,10,77,10,77,10,77,10,220,8,236,10,243,10,247,10,253,10,3,11,11,11,16,11,70,5,32,11,24,11,40,11,158,4,158,4,158,4,48,11,238,4,56,11,185,5,62,11,78,11,70,11,70,11,21,5,86,11,94,11,102,11,110,4,110,11,220,8,220,8,117,11,220,8,220,8,220,8,220,8,220,8,220,8,125,11,131,11,147,11,139,11,250,5,185,5,155,11,56,8,185,5,163,11,171,11,176,11,185,5,185,5,181,11,165,5,220,8,188,11,196,11,204,11,210,11,220,8,204,11,218,11,220,8,196,11,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,226,11,185,5,185,5,185,5,234,11,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,240,11,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,245,11,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,170,8,220,8,220,8,253,11,185,5,0,12,185,5,8,12,14,12,22,12,30,12,35,12,185,5,185,5,39,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,46,12,185,5,53,12,59,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,67,12,185,5,185,5,185,5,75,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,77,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,84,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,91,12,185,5,185,5,185,5,98,12,106,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,111,12,185,5,185,5,119,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,123,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,126,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,129,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,135,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,143,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,148,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,153,12,185,5,185,5,185,5,158,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,166,12,173,12,177,12,185,5,185,5,185,5,184,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,170,8,110,4,198,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,190,12,220,8,206,12,77,9,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,211,12,219,12,158,4,235,12,227,12,185,5,185,5,243,12,251,12,11,13,158,4,16,13,24,13,30,13,110,4,3,13,38,13,46,13,185,5,54,13,70,13,73,13,62,13,81,13,14,6,89,13,96,13,104,13,86,6,120,13,112,13,128,13,185,5,136,13,144,13,152,13,185,5,160,13,168,13,176,13,184,13,192,13,196,13,204,13,238,4,238,4,185,5,212,13,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,220,13,227,13,158,8,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,185,5,185,5,185,5,251,13,185,5,185,12,2,14,7,14,185,5,185,5,185,5,15,14,185,5,185,5,169,8,110,4,37,14,21,14,29,14,185,5,185,5,45,14,53,14,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,58,14,66,14,185,5,70,14,185,5,76,14,80,14,88,14,96,14,103,14,111,14,185,5,185,5,185,5,117,14,141,14,94,4,149,14,157,14,162,14,190,8,125,14,133,14,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,235,13,184,17,184,17,248,17,56,18,120,18,176,18,240,18,48,19,104,19,168,19,212,19,20,20,84,20,100,20,164,20,216,20,24,21,72,21,136,21,200,21,216,21,12,22,68,22,132,22,196,22,4,23,56,23,100,23,164,23,220,23,248,23,56,24,128,10,192,10,0,11,59,11,123,11,64,10,187,11,64,10,221,11,64,10,64,10,64,10,64,10,29,12,219,1,219,1,93,12,157,12,64,10,64,10,64,10,64,10,221,12,253,12,64,10,64,10,61,13,125,13,189,13,253,13,61,14,125,14,189,14,244,14,219,1,219,1,24,15,76,15,219,1,116,15,219,1,219,1,219,1,219,1,161,15,219,1,219,1,219,1,219,1,219,1,219,1,219,1,181,15,219,1,237,15,45,16,219,1,56,16,64,10,64,10,64,10,64,10,64,10,120,16,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,184,16,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,64,10,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,248,16,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,0,7,248,16,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,170,14,177,14,185,14,110,4,185,5,185,5,185,5,165,5,201,14,193,14,224,14,209,14,216,14,232,14,106,11,240,14,110,4,110,4,110,4,110,4,104,13,185,5,248,14,0,15,185,5,8,15,16,15,20,15,28,15,185,5,36,15,110,4,70,5,80,5,44,15,185,5,48,15,56,15,72,15,64,15,185,5,80,15,185,5,87,15,110,4,110,4,110,4,110,4,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,78,11,170,8,76,14,110,4,110,4,110,4,110,4,103,15,95,15,106,15,114,15,190,8,122,15,110,4,130,15,138,15,146,15,110,4,110,4,185,5,162,15,170,15,154,15,186,15,193,15,178,15,201,15,209,15,110,4,225,15,217,15,185,5,228,15,236,15,244,15,252,15,4,16,110,4,110,4,185,5,185,5,12,16,110,4,70,5,20,16,238,4,28,16,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,36,16,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,52,16,239,5,60,16,44,16,47,9,68,16,76,16,82,16,106,16,90,16,98,16,110,16,47,9,126,16,118,16,134,16,150,16,142,16,110,4,110,4,157,16,165,16,17,6,173,16,189,16,178,6,197,16,181,16,110,4,110,4,110,4,110,4,185,5,205,16,213,16,110,4,185,5,221,16,229,16,110,4,110,4,110,4,110,4,110,4,185,5,237,16,245,16,110,4,185,5,253,16,5,17,13,17,185,5,29,17,21,17,110,4,45,17,37,17,110,4,110,4,110,4,110,4,110,4,110,4,70,5,238,4,53,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,185,5,61,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,83,17,88,17,69,17,77,17,104,17,96,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,169,8,110,4,110,4,110,4,120,17,128,17,136,17,112,17,185,5,185,5,185,5,185,5,185,5,185,5,144,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,152,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,154,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,61,17,190,8,162,17,110,4,110,4,66,14,170,17,185,5,186,17,194,17,202,17,178,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,185,5,185,5,210,17,215,17,223,17,110,4,110,4,231,17,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,239,17,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,247,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,255,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,185,5,185,5,185,5,7,18,12,18,20,18,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,220,8,220,8,220,8,220,8,220,8,220,8,220,8,125,11,220,8,28,18,220,8,35,18,43,18,49,18,220,8,55,18,220,8,220,8,63,18,110,4,110,4,110,4,110,4,110,4,220,8,220,8,126,10,71,18,110,4,110,4,110,4,110,4,87,18,94,18,99,18,105,18,113,18,121,18,129,18,91,18,137,18,145,18,153,18,158,18,112,18,87,18,94,18,90,18,105,18,166,18,88,18,169,18,91,18,177,18,185,18,193,18,200,18,180,18,188,18,196,18,203,18,183,18,211,18,79,18,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,21,5,227,18,21,5,234,18,241,18,219,18,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,248,18,0,19,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,185,5,185,5,185,5,185,5,185,5,185,5,8,19,110,4,70,5,24,19,16,19,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,40,19,48,19,56,19,64,19,72,19,80,19,110,4,32,19,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,220,8,88,19,220,8,220,8,117,11,93,19,97,19,125,11,105,19,110,19,220,8,88,19,220,8,54,18,110,4,118,19,126,19,130,19,138,19,110,4,110,4,110,4,110,4,110,4,220,8,220,8,220,8,220,8,220,8,220,8,220,8,146,19,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,220,8,127,10,154,19,220,8,220,8,220,8,117,11,220,8,220,8,162,19,110,4,88,19,220,8,170,19,220,8,178,19,127,11,110,4,110,4,186,19,194,19,202,19,110,4,126,11,110,4,232,14,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,210,19,185,5,185,5,217,19,185,5,185,5,185,5,225,19,185,5,233,19,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,95,12,185,5,185,5,241,19,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,249,19,1,20,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,158,12,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,8,20,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,15,20,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,22,20,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,78,11,110,4,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,26,20,185,5,185,5,185,5,185,5,185,5,185,5,48,15,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,255,17,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,185,5,185,5,185,5],\"i8\",4,A.a)\n;O([185,5,34,20,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,185,5,48,15,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,50,20,42,20,42,20,42,20,110,4,110,4,110,4,110,4,21,5,21,5,21,5,21,5,21,5,21,5,21,5,58,20,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,110,4,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,243,13,66,20,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,12,0,23,0,23,0,23,0,25,0,23,0,23,0,23,0,20,0,21,0,23,0,24,0,23,0,19,0,23,0,23,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,23,0,23,0,24,0,24,0,24,0,23,0,23,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,20,0,23,0,21,0,26,0,22,0,26,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,20,0,24,0,21,0,24,0,15,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,15,0,12,0,23,0,25,0,25,0,25,0,25,0,27,0,23,0,26,0,27,0,5,0,28,0,24,0,16,0,27,0,26,0,27,0,24,0,75,3,139,3,26,0,2,0,23,0,23,0,26,0,11,3,5,0,29,0,203,52,75,52,203,60,23,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,24,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,24,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,2,0,1,0,1,0,2,0,1,0,2,0,1,0,1,0,2,0,1,0,1,0,1,0,2,0,2,0,1,0,1,0,1,0,1,0,2,0,1,0,1,0,2,0,1,0,1,0,1,0,2,0,2,0,2,0,1,0,1,0,2,0,1,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,1,0,2,0,1,0,2,0,2,0,1,0,2,0,1,0,1,0,2,0,1,0,1,0,1,0,2,0,1,0,2,0,1,0,1,0,2,0,2,0,5,0,1,0,2,0,2,0,2,0,5,0,5,0,5,0,5,0,1,0,3,0,2,0,1,0,3,0,2,0,1,0,3,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,1,0,3,0,2,0,1,0,2,0,1,0,1,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,2,0,1,0,1,0,2,0,2,0,1,0,2,0,1,0,1,0,1,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,5,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,26,0,26,0,26,0,26,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,4,0,4,0,4,0,4,0,4,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,4,0,26,0,4,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,1,0,2,0,1,0,2,0,4,0,26,0,1,0,2,0,0,0,0,0,4,0,2,0,2,0,2,0,23,0,1,0,0,0,0,0,0,0,0,0,26,0,26,0,1,0,23,0,1,0,1,0,1,0,0,0,1,0,0,0,1,0,1,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,2,0,2,0,1,0,1,0,1,0,2,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,2,0,2,0,2,0,1,0,2,0,24,0,1,0,2,0,1,0,1,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,27,0,6,0,6,0,6,0,6,0,6,0,7,0,7,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,0,0,4,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,23,0,19,0,0,0,0,0,27,0,27,0,25,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,19,0,6,0,23,0,6,0,6,0,23,0,6,0,6,0,23,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,16,0,16,0,16,0,16,0,16,0,24,0,24,0,24,0,23,0,23,0,25,0,23,0,23,0,27,0,27,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,23,0,16,0,0,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,23,0,23,0,23,0,23,0,5,0,5,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,16,0,27,0,6,0,6,0,6,0,6,0,6,0,6,0,4,0,4,0,6,0,6,0,27,0,6,0,6,0,6,0,6,0,5,0,5,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,5,0,5,0,5,0,27,0,27,0,5,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,16,0,5,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,4,0,4,0,27,0,23,0,23,0,23,0,4,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,4,0,6,0,6,0,6,0,4,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,4,0,6,0,6,0,6,0,6,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,0,0,0,0,23,0,0,0,6,0,6,0,16,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,5,0,5,0,6,0,6,0,23,0,23,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,23,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,8,0,6,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,8,0,8,0,8,0,6,0,8,0,8,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,5,0,5,0,25,0,25,0,203,55,203,53,203,63,203,52,203,60,75,9,27,0,25,0,0,0,0,0,0,0,0,0,5,0,6,0,8,0,8,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,0,0,0,0,6,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,0,0,0,0,8,0,8,0,0,0,0,0,8,0,8,0,6,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,5,0,5,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,6,0,6,0,5,0,5,0,5,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,8,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,0,0,5,0,5,0,0,0,5,0,5,0,0,0,0,0,6,0,0,0,8,0,8,0,8,0,6,0,6,0,0,0,0,0,0,0,0,0,6,0,6,0,0,0,0,0,6,0,6,0,6,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,0,0,5,0,0,0,5,0,5,0,6,0,6,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,23,0,25,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,8,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,6,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,0,0,6,0,6,0,8,0,0,0,8,0,8,0,6,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,6,0,6,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,27,0,5,0,203,52,75,52,203,60,203,55,203,53,203,63,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,8,0,8,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,6,0,5,0,8,0,6,0,8,0,6,0,6,0,6,0,6,0,0,0,0,0,8,0,8,0,0,0,0,0,8,0,8,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,8,0,0,0,0,0,0,0,0,0,5,0,5,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,203,7,75,30,75,120,27,0,27,0,27,0,27,0,27,0,27,0,25,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,5,0,5,0,0,0,5,0,0,0,5,0,5,0,0,0,0,0,0,0,5,0,5,0,0,0,0,0,0,0,5,0,5,0,5,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,8,0,8,0,6,0,8,0,8,0,0,0,0,0,0,0,8,0,8,0,8,0,0,0,8,0,8,0,8,0,6,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,6,0,6,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,75,5,139,5,203,5,11,6,139,5,203,5,11,6,27,0,6,0,8,0,8,0,8,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,5,0,6,0,6,0,6,0,8,0,8,0,8,0,8,0,0,0,6,0,6,0,6,0,0,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,0,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,6,0,6,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,6,0,8,0,8,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,6,0,5,0,8,0,6,0,8,0,8,0,8,0,8,0,8,0,0,0,6,0,8,0,8,0,0,0,8,0,8,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,8,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,5,0,5,0,6,0,6,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,203,7,75,30,75,120,203,52,75,52,203,60,203,55,203,53,203,63,27,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,6,0,8,0,8,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,0,0,8,0,8,0,8,0,0,0,8,0,8,0,8,0,6,0,5,0,27,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,8,0,11,204,11,202,75,203,11,201,75,54,75,201,11,53,5,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,8,0,8,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,8,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,0,0,8,0,8,0,8,0,6,0,6,0,6,0,0,0,6,0,0,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,25,0,5,0,5,0,5,0,5,0,5,0,5,0,4,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,23,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,23,0,23,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,0,0,5,0,0,0,0,0,5,0,5,0,0,0,5,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,0,0,5,0,0,0,5,0,0,0,0,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,6,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,6,0,6,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,0,0,4,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,5,0,5,0,5,0,5,0,5,0,27,0,27,0,27,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,27,0,23,0,27,0,27,0,27,0,6,0,6,0,27,0,27,0,27,0,27,0,27,0,27,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,75,52,75,60,75,68,75,76,75,84,75,92,75,100,75,108,75,116,75,44,27,0,6,0,27,0,6,0,27,0,6,0,20,0,21,0,20,0,21,0,8,0,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,6,0,6,0,6,0,6,0,6,0,23,0,6,0,6,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,6,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,27,0,27,0,23,0,23,0,23,0,23,0,23,0,27,0,27,0,27,0,27,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,6,0,6,0,6,0,6,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,6,0,6,0,8,0,8,0,6,0,6,0,5,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,23,0,23,0,23,0,23,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,6,0,6,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,5,0,8,0,8,0,8,0,5,0,5,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,8,0,8,0,6,0,6,0,8,0,8,0,8,0,8,0,8,0,8,0,6,0,5,0,8,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,8,0,8,0,8,0,6,0,27,0,27,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,4,0,5,0,5,0,5,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,0,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,6,0,6,0,6,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,203,7,75,10,203,12,75,15,203,17,75,20,203,22,75,25,203,27,75,30,139,120,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,19,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,12,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,20,0,21,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,23,0,23,0,138,9,202,9,10,10,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,0,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,6,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,23,0,23,0,23,0,4,0,23,0,23,0,23,0,25,0,5,0,6,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,75,5,139,5,203,5,11,6,75,6,139,6,203,6,11,7,75,7,139,7,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,5,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,23,0,23,0,23,0,23,0,23,0,19,0,23,0,23,0,23,0,23,0,6,0,6,0,6,0,16,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,8,0,8,0,8,0,8,0,6,0,6,0,8,0,8,0,8,0,0,0,0,0,0,0,0,0,8,0,8,0,6,0,8,0,8,0,8,0,8,0,8,0,8,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,27,0,0,0,0,0,0,0,23,0,23,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,11,3,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,8,0,8,0,6,0,0,0,0,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,4,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,7,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,6,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,6,0,8,0,6,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,8,0,8,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,6,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,23,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,8,0,6,0,6,0,6,0,6,0,6,0,8,0,6,0,8,0,8],\"i8\",4,A.a+10240)\n;O([8,0,8,0,8,0,6,0,8,0,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,23,0,23,0,23,0,23,0,23,0,23,0,5,0,8,0,6,0,6,0,6,0,6,0,8,0,8,0,6,0,6,0,8,0,6,0,6,0,6,0,5,0,5,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,8,0,6,0,6,0,8,0,8,0,8,0,6,0,8,0,6,0,6,0,6,0,8,0,8,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,23,0,23,0,23,0,23,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,5,0,5,0,5,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,8,0,6,0,6,0,0,0,0,0,0,0,23,0,23,0,23,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,4,0,4,0,4,0,4,0,4,0,4,0,23,0,23,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,23,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,5,0,5,0,5,0,5,0,6,0,5,0,5,0,5,0,5,0,8,0,8,0,6,0,5,0,5,0,0,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,4,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,4,0,4,0,4,0,4,0,4,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,26,0,26,0,26,0,0,0,0,0,2,0,2,0,2,0,0,0,2,0,2,0,1,0,1,0,1,0,1,0,3,0,26,0,26,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,3,0,2,0,2,0,2,0,2,0,2,0,0,0,2,0,2,0,1,0,1,0,1,0,1,0,3,0,26,0,2,0,26,0,26,0,26,0,2,0,2,0,2,0,0,0,2,0,2,0,1,0,1,0,1,0,1,0,3,0,26,0,26,0,26,0,2,0,2,0,2,0,2,0,0,0,0,0,2,0,2,0,1,0,1,0,1,0,1,0,0,0,26,0,26,0,26,0,22,0,23,0,23,0,23,0,24,0,20,0,21,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,24,0,23,0,22,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,12,0,16,0,16,0,16,0,16,0,16,0,0,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,203,2,4,0,0,0,0,0,203,3,11,4,75,4,139,4,203,4,11,5,24,0,24,0,24,0,20,0,21,0,4,0,12,0,12,0,12,0,12,0,12,0,12,0,12,0,12,0,12,0,12,0,12,0,16,0,16,0,16,0,16,0,16,0,19,0,19,0,19,0,19,0,19,0,19,0,23,0,23,0,28,0,29,0,20,0,28,0,28,0,29,0,20,0,28,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,13,0,14,0,16,0,16,0,16,0,16,0,16,0,12,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,28,0,29,0,23,0,23,0,23,0,23,0,22,0,203,2,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,24,0,24,0,24,0,20,0,21,0,0,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,0,0,0,0,0,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,25,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,7,0,7,0,7,0,7,0,6,0,7,0,7,0,7,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,1,0,27,0,1,0,27,0,1,0,27,0,1,0,1,0,1,0,1,0,27,0,2,0,1,0,1,0,1,0,1,0,2,0,5,0,5,0,5,0,5,0,2,0,27,0,27,0,2,0,2,0,1,0,1,0,24,0,24,0,24,0,24,0,24,0,1,0,2,0,2,0,2,0,2,0,27,0,24,0,27,0,27,0,2,0,27,0,139,53,11,54,75,54,139,52,139,56,11,53,11,57,11,61,11,65,75,53,75,69,203,53,203,61,203,69,203,77,139,5,27,0,27,0,1,0,27,0,27,0,27,0,27,0,1,0,27,0,27,0,2,0,1,0,1,0,1,0,2,0,2,0,1,0,1,0,1,0,2,0,27,0,1,0,27,0,27,0,24,0,1,0,1,0,1,0,1,0,1,0,27,0,27,0,138,5,202,5,10,6,74,6,138,6,202,6,10,7,74,7,138,7,202,7,10,8,74,8,202,17,74,30,10,152,74,120,138,5,202,5,10,6,74,6,138,6,202,6,10,7,74,7,138,7,202,7,10,8,74,8,202,17,74,30,10,152,74,120,74,120,74,152,138,120,1,0,2,0,202,6,202,17,138,152,202,120,75,5,27,0,27,0,0,0,0,0,0,0,0,0,24,0,24,0,24,0,24,0,24,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,27,0,27,0,24,0,27,0,27,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,27,0,27,0,24,0,27,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,20,0,21,0,20,0,21,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,20,0,21,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,24,0,24,0,24,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,203,2,11,8,75,8,139,8,203,8,11,9,75,9,139,9,203,9,11,10,75,10,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,203,7,203,2,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,203,7,11,8,75,8,139,8,203,8,11,9,75,9,139,9,203,9,11,10,75,10,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,203,7,11,8,75,8,139,8,203,8,11,9,75,9,139,9,203,9,11,10,75,10,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,203,7,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,203,7,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,203,7,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,24,0,24,0,24,0,20,0,21,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,20,0,21,0,20,0,21,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,20,0,21,0,24,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,24,0,27,0,27,0,24,0,24,0,24,0,24,0,24,0,24,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,2,0,1,0,1,0,1,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,1,0,1,0,1,0,2,0,1,0,2,0,2,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,4,0,4,0,1,0,1,0,1,0,2,0,1,0,2,0,2,0,27,0,27,0,27,0,27,0,27,0,27,0,1,0,2,0,1,0,2,0,6,0,6,0,6,0,1,0,2,0,0,0,0,0,0,0,0,0,0,0,23,0,23,0,23,0,23,0,75,52,23,0,23,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,23,0,23,0,28,0,29,0,28,0,29,0,23,0,23,0,23,0,28,0,29,0,23,0,28,0,29,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,19,0,23,0,23,0,19,0,23,0,28,0,29,0,23,0,23,0,28,0,29,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,23,0,23,0,23,0,23,0,23,0,4,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,19,0,19,0,23,0,23,0,23,0,23,0,19,0,23,0,20,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,27,0,138,5,202,5,10,6,74,6,138,6,202,6,10,7,74,7,138,7,6,0,6,0,6,0,6,0,8,0,8,0,19,0,4,0,4,0,4,0,4,0,4,0,27,0,27,0,202,7,74,10,202,12,4,0,5,0,23,0,27,0,27,0,12,0,23,0,23,0,23,0,27,0,4,0,5,0,74,5,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,27,0,27,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,19,0,20,0,21,0,21,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,6,0,6,0,26,0,26,0,4,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,4,0,4,0,4,0,5,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,27,0,27,0,139,5,203,5,11,6,75,6,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,139,5,203,5,11,6,75,6,139,6,203,6,11,7,75,7,139,7,203,7,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,203,7,75,10,203,12,75,15,203,17,75,20,203,22,75,25,27,0,139,10,203,10,11,11,75,11,139,11,203,11,11,12,75,12,139,12,203,12,11,13,75,13,139,13,203,13,11,14,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,75,14,139,14,203,14,11,15,75,15,139,15,203,15,11,16,75,16,139,16,203,16,11,17,75,17,139,17,203,17,5,0,5,0,5,0,5,0,5,0,133,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,5,5,0,5,0,5,7,5,0,5,0,5,0,133,120,5,0,5,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,6,5,0,69,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,121,197,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,120,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,30,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,121,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,122,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,5,5,0,69,7,5,0,197,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,7,5,0,69,120,69,10,197,12,5,0,5,0,5,0,5,0,5,0,5,0,69,15,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,6,5,6,5,6,5,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,7,69,10,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,5,197,5,5,6,5,0,197,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,30,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,120,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,5,5,0,5,0,5,0,5,0,197,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,120,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,6,5,0,5,0,5,0,5,0,5,0,69,30,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,4,0,23,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,4,0,4,0,6,0,6,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,5,0,6,0,7,0,7,0,7,0,23,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,23,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,138,5,202,5,10,6,74,6,138,6,202,6,10,7,74,7,138,7,74,5,6,0,6,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,4,0,4,0,2,0,5,0,5,0,5,0,5,0,5,0,26,0,26,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,4,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,4,0,26,0,26,0,1,0,2,0,1,0,2,0,5,0,1,0,2,0,1,0,2,0,2,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,2,0,1,0,1,0,1,0,1,0,1,0,0,0,1,0,1,0,1,0,1,0,1,0,2,0,1,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,6,0,5,0,5,0,5,0,6,0,5,0,5,0,5,0,5,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,6,0,6,0,8,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,203,52,75,52,203,60,203,55,203,53,203,63,27,0,27,0,25,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,8,0,8,0,8,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,23,0,23,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,8,0,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,23,0,23,0,5,0,23,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,8,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,8,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,4,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,8,0,8,0,6,0,6,0,6,0,6,0,8,0,8,0,6,0,8,0,8,0,8,0,5,0,5,0,5,0,5,0,5,0,6,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,8,0,6,0,6,0,8,0,8,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,8,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,23,0,23,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,27,0,27,0,27,0,5,0,8,0,6,0,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,5,0,6,0,6,0,6,0,5,0,5,0,6,0,6,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,5,0,6,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,4,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,6,0,6,0,8,0,8,0,23,0,23,0,5,0,4,0,4,0,8,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,26,0,4,0,4,0,4,0,4,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,5,0,5,0,5,0,8,0,8,0,6,0,8,0,8,0,6,0,8,0,8,0,23,0,8,0,6,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,7,5,0,5,0,5,0,5,0,197,5,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,6,5,0,197,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,24,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,0,0,5,0,5,0,0,0,5,0,5,0,0,0,5],\"i8\",4,A.a+20480)\n;O([5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,5,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,26,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,21,0,20,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,25,0,27,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,20,0,21,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,23,0,19,0,19,0,22,0,22,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,20,0,21,0,23,0,23,0,20,0,21,0,23,0,23,0,23,0,23,0,22,0,22,0,22,0,23,0,23,0,23,0,0,0,23,0,23,0,23,0,23,0,19,0,20,0,21,0,20,0,21,0,20,0,21,0,23,0,23,0,23,0,24,0,19,0,24,0,24,0,24,0,0,0,23,0,25,0,23,0,23,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,16,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,0,0,0,0,0,0,25,0,25,0,24,0,26,0,27,0,25,0,25,0,0,0,27,0,24,0,24,0,24,0,24,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,16,0,16,0,27,0,27,0,0,0,0,0,0,0,23,0,23,0,23,0,25,0,23,0,23,0,23,0,20,0,21,0,23,0,24,0,23,0,19,0,23,0,23,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,23,0,23,0,24,0,24,0,24,0,23,0,26,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,20,0,24,0,21,0,24,0,20,0,21,0,23,0,20,0,21,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,4,0,4,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,11,176,11,184,75,120,75,128,75,136,75,144,75,152,75,160,75,168,75,176,75,184,139,120,139,128,139,136,139,144,139,152,139,160,139,168,139,176,139,184,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,139,5,203,5,11,6,75,6,139,6,203,6,11,7,75,7,139,7,203,7,75,10,203,12,75,15,203,17,75,20,203,22,75,25,203,27,75,30,11,128,11,136,11,144,11,152,11,160,11,168,202,7,202,7,202,7,202,7,202,7,202,12,202,17,202,17,202,17,202,17,74,30,10,136,10,152,10,152,10,152,10,152,10,152,74,120,74,152,138,6,202,17,75,52,75,52,139,56,203,60,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,75,5,203,52,27,0,27,0,27,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,202,52,74,52,138,5,138,6,202,17,10,152,74,152,138,152,138,6,202,7,202,17,74,30,10,152,74,120,74,152,138,6,202,7,202,17,74,30,10,152,74,120,138,120,138,152,202,7,138,5,138,5,138,5,202,5,202,5,202,5,202,5,138,6,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,6,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,139,5,203,5,11,6,75,6,139,6,203,6,11,7,75,7,139,7,203,7,75,10,203,12,75,15,203,17,75,20,203,22,75,25,203,27,75,30,11,128,11,136,11,144,11,152,11,160,11,168,11,176,11,184,0,0,0,0,0,0,0,0,139,5,139,6,203,7,203,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,202,27,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,10,184,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,23,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,138,5,202,5,202,7,74,10,74,30,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,0,0,0,0,0,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,23,0,139,5,203,5,11,6,203,7,75,10,75,30,75,120,139,120,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,27,0,27,0,139,5,203,5,11,6,75,6,139,6,203,7,75,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,139,5,203,5,11,6,75,6,75,6,139,6,203,7,75,10,75,30,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,139,5,139,6,203,7,75,10,75,30,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,139,5,203,7,75,10,75,30,203,5,11,6,0,0,0,0,0,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,23,0,75,160,75,168,75,176,75,184,139,120,139,128,139,136,139,144,139,152,139,160,139,168,139,176,139,184,203,120,203,128,203,136,203,144,203,152,203,160,203,168,203,176,203,184,203,54,75,53,203,52,139,52,203,70,75,52,203,78,139,56,203,60,75,69,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,203,94,75,52,5,0,5,0,139,5,203,5,11,6,75,6,139,6,203,6,11,7,75,7,139,7,203,7,75,10,203,12,75,15,203,17,75,20,203,22,0,0,0,0,75,30,11,128,11,136,11,144,11,152,11,160,11,168,11,176,11,184,75,120,75,128,75,136,75,144,75,152,11,3,75,3,139,3,203,3,203,7,75,10,75,30,75,120,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,6,0,6,0,6,0,0,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,139,5,203,17,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,139,5,203,7,75,10,5,0,5,0,5,0,5,0,5,0,6,0,6,0,0,0,0,0,0,0,0,0,139,5,139,6,203,7,75,10,75,30,23,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,27,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,139,5,203,5,11,6,75,6,203,7,75,10,75,30,75,120,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,139,5,203,5,11,6,75,6,203,7,75,10,75,30,75,120,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,139,5,203,5,11,6,75,6,203,7,75,10,75,30,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,139,5,139,6,203,7,203,17,75,30,75,120,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,203,7,75,10,203,12,75,15,203,17,75,20,203,22,75,25,203,27,75,30,11,128,11,136,11,144,11,152,11,160,11,168,11,176,11,184,75,52,203,52,139,52,139,56,0,0,75,20,203,22,75,25,203,27,75,30,75,120,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,8,0,6,0,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,203,7,75,10,203,12,75,15,203,17,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,8,0,8,0,6,0,6,0,23,0,23,0,16,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,23,0,23,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,5,0,5,0,5,0,5,0,23,0,23,0,23,0,23,0,23,0,6,0,6,0,6,0,23,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,5,0,23,0,5,0,23,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,0,0,139,5,203,5,11,6,75,6,139,6,203,6,11,7,75,7,139,7,203,7,75,10,203,12,75,15,203,17,75,20,203,22,75,25,203,27,75,30,75,120,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,8,0,8,0,6,0,8,0,6,0,6,0,23,0,23,0,23,0,23,0,23,0,23,0,6,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,0,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,8,0,8,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,8,0,8,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,5,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,8,0,8,0,8,0,8,0,0,0,0,0,8,0,8,0,0,0,0,0,8,0,8,0,8,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,8,0,6,0,6,0,6,0,8,0,6,0,5,0,5,0,5,0,5,0,23,0,23,0,23,0,23,0,23,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,23,0,0,0,23,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,6,0,8,0,8,0,8,0,8,0,6,0,6,0,8,0,6,0,6,0,5,0,5,0,23,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,0,0,0,0,8,0,8,0,8,0,8,0,6,0,6,0,8,0,6,0,6,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,5,0,5,0,5,0,5,0,6,0,6,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,8,0,6,0,8,0,6,0,6,0,23,0,23,0,23,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,8,0,6,0,8,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,8,0,6,0,6,0,6,0,6,0,8,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,203,7,75,10,23,0,23,0,23,0,27,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,6,0,6,0,6,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,203,7,75,10,203,12,75,15,203,17,75,20,203,22,75,25,203,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,139,5,203,5,11,6,75,6,139,6,203,6,11,7,75,7,139,7,203,7,75,10,203,12,75,15,203,17,75,20,203,22,75,25,203,27,75,30,0,0,0,0,0,0,23,0,23,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,8,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,8,0,6,0,6,0,8,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,202,52,74,53,202,52,202,52,74,52,138,52,138,56,74,15,202,17,74,6,138,6,202,6,10,7,74,7,138,7,0,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,202,5,10,6,74,6,138,6,202,6,10,7,74,7,138,7,10,6,74,6,138,6,202,6,10,7,74,7,138,7,74,6,138,6,202,6,10,7,74,7,138,7,138,5,202,5,10,6,74,6,138,6,202,6,10,7,74,7,138,7,138,5,202,5,10,6,74,6,138,6,202,5,10,6,10,6,74,6,138,6,202,6,10,7,74,7,138,7,138,5,202,5,10,6,10,6,74,6,138,6,138,192,138,193,138,5,202,5,10,6,10,6,74,6,138,6,10,6,10,6,74,6,74,6,74,6,74,6,202,6,10,7,10,7,10,7,74,7,74,7,138,7,138,7,138,7,138,7,202,5,10,6,74,6,138,6,202,6,138,5,202,5,10,6,74,6,74,6,138,6,138,6,202,5,10,6,138,5,202,5,138,52,138,56,74,69,138,52,138,56,202,53,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,23,0,23,0,23,0,23,0,23,0,27,0,27,0,27,0,27,0,4,0,4,0,4,0,4,0,23,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,203,7,75,30,139,120,11,121,139,121,11,122,139,122,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,8,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,27,0,6,0,6,0,23,0,16,0,16,0,16,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,8,0,8,0,6,0,6,0,6,0,27,0,27,0,27,0,8,0,8,0,8,0,8,0,8,0,8,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,27,0,27,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,6,0,6,0,6,0,6,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,6,0,6,0,6,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,139,5,203,5,11,6,75,6,139,6,203,6,11,7,75,7,139,7,203,7,75,10,203,12,75,15,203,17,75,20,203,22,75,25,203,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,73,2,137,2,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,0,0,1,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,1,0,0,0,0,0,1,0,1,0,1,0,1,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,0,0,2,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,1,0,1,0,0,0,1,0,1,0,1,0,1,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,0,0,1,0,1,0,1,0,1,0,0,0,1,0,1,0,1,0,1,0,1,0,0,0,1,0,0,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,24,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,24,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,24,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,24,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,2,0,2,0,2,0,24,0,2,0,2,0,2,0,2,0,2,0,2,0,1,0,2,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,27,0,27,0,27,0,27,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,6,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,6,0,27,0,27,0,23,0,23,0,23,0,23,0,23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,6,0,6,0,0,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,139,5,203,5,11,6,75,6,139,6,203,6,11,7,75,7,139,7,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,73,0,137,0,201,0,9,1,73,1,137,1,201,1,9,2,73,2,137,2,0,0,0,0,0,0,0,0,23,0,23,0,1,0,1,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2],\"i8\",4,A.a+30720)\n;O([2,0,2,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,0,24,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,0,0,5,0,0,0,0,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,0,0,5,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,5,0,0,0,5,0,0,0,5,0,0,0,5,0,5,0,5,0,0,0,5,0,5,0,0,0,5,0,0,0,0,0,5,0,0,0,5,0,0,0,5,0,0,0,5,0,0,0,5,0,0,0,5,0,5,0,0,0,5,0,0,0,0,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,0,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,203,2,203,2,11,3,75,3,139,3,203,3,11,4,75,4,139,4,203,4,11,5,75,5,75,5,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,26,0,26,0,26,0,26,0,26,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,0,0,0,0,0,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,27,0,0,0,5,0,5,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,12,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,15,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,15,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,197,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,69,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,133,7,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,106,3,114,3,122,3,130,3,154,3,162,3,170,3,178,3,138,3,146,3,138,3,146,3,138,3,146,3,138,3,146,3,138,3,146,3,138,3,146,3,184,3,192,3,200,3,208,3,216,3,224,3,220,3,228,3,236,3,244,3,239,3,247,3,138,3,146,3,138,3,146,3,255,3,7,4,138,3,146,3,138,3,146,3,138,3,146,3,13,4,21,4,29,4,37,4,45,4,53,4,61,4,69,4,75,4,83,4,91,4,99,4,107,4,115,4,121,4,129,4,137,4,145,4,153,4,161,4,173,4,169,4,181,4,31,4,31,4,197,4,205,4,189,4,213,4,215,4,223,4,231,4,239,4,240,4,248,4,0,5,8,5,240,4,16,5,21,5,8,5,240,4,29,5,37,5,239,4,42,5,50,5,231,4,55,5,138,3,63,5,67,5,75,5,76,5,84,5,92,5,239,4,100,5,108,5,231,4,239,4,138,3,248,4,231,4,138,3,138,3,114,5,138,3,138,3,120,5,128,5,138,3,138,3,132,5,140,5,138,3,144,5,151,5,138,3,159,5,167,5,174,5,54,5,138,3,138,3,182,5,190,5,198,5,206,5,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,214,5,138,3,222,5,138,3,138,3,138,3,230,5,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,238,5,138,3,138,3,138,3,246,5,246,5,252,4,252,4,138,3,252,5,4,6,222,5,26,6,12,6,12,6,34,6,41,6,18,6,138,3,138,3,138,3,49,6,57,6,138,3,138,3,138,3,59,6,67,6,75,6,138,3,82,6,90,6,138,3,98,6,138,3,138,3,106,6,109,6,55,5,117,6,1,4,125,6,138,3,132,6,138,3,137,6,138,3,138,3,138,3,138,3,143,6,151,6,138,3,138,3,138,3,138,3,138,3,138,3,216,3,159,6,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,167,6,175,6,179,6,203,6,209,6,187,6,195,6,217,6,225,6,229,6,177,5,237,6,245,6,253,6,138,3,5,7,67,6,67,6,67,6,21,7,29,7,37,7,45,7,50,7,58,7,66,7,13,7,74,7,82,7,138,3,88,7,95,7,67,6,67,6,101,7,67,6,98,5,106,7,67,6,114,7,138,3,138,3,64,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,122,7,67,6,67,6,67,6,67,6,67,6,128,7,67,6,67,6,136,7,144,7,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,67,6,67,6,67,6,67,6,160,7,167,7,175,7,152,7,191,7,199,7,207,7,214,7,222,7,230,7,237,7,183,7,67,6,67,6,67,6,245,7,251,7,1,8,9,8,14,8,138,3,138,3,138,3,138,3,138,3,138,3,138,3,21,8,138,3,138,3,138,3,29,8,138,3,138,3,138,3,216,3,37,8,45,8,52,8,138,3,60,8,67,6,67,6,70,6,67,6,67,6,67,6,67,6,67,6,67,6,67,8,73,8,89,8,81,8,138,3,138,3,97,8,230,5,138,3,177,3,138,3,138,3,138,3,138,3,138,3,138,3,67,6,28,8,191,3,138,3,56,8,105,8,138,3,113,8,14,8,138,3,138,3,138,3,138,3,121,8,138,3,138,3,59,6,176,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,67,6,67,6,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,56,8,67,6,98,5,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,128,8,138,3,138,3,133,8,76,5,138,3,138,3,146,5,67,6,58,6,138,3,138,3,141,8,138,3,138,3,138,3,149,8,156,8,12,6,164,8,138,3,138,3,171,8,179,8,138,3,186,8,193,8,138,3,213,4,198,8,138,3,238,4,138,3,206,8,214,8,240,4,138,3,218,8,239,4,226,8,138,3,138,3,138,3,138,3,138,3,138,3,138,3,233,8,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,253,8,241,8,245,8,137,4,137,4,137,4,137,4,137,4,137,4,137,4,137,4,137,4,137,4,137,4,137,4,137,4,137,4,5,9,137,4,137,4,137,4,137,4,13,9,17,9,25,9,33,9,37,9,45,9,137,4,137,4,137,4,49,9,57,9,122,3,65,9,73,9,138,3,138,3,138,3,81,9,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,40,14,40,14,104,14,168,14,40,14,40,14,40,14,40,14,40,14,40,14,224,14,32,15,96,15,112,15,176,15,188,15,40,14,40,14,252,15,40,14,40,14,40,14,52,16,116,16,180,16,244,16,44,17,108,17,172,17,228,17,36,18,100,18,64,10,128,10,192,10,250,10,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,35,11,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,96,11,160,1,160,1,149,11,213,11,21,12,85,12,149,12,213,12,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,85,13,101,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,21,13,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,89,9,138,3,67,6,67,6,97,9,230,5,138,3,232,4,138,3,138,3,138,3,138,3,138,3,138,3,138,3,105,9,138,3,138,3,138,3,112,9,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,120,9,31,4,31,4,31,4,31,4,31,4,31,4,31,4,128,9,132,9,31,4,31,4,31,4,31,4,148,9,140,9,31,4,156,9,31,4,31,4,164,9,170,9,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,178,9,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,239,4,173,8,186,9,193,9,1,4,196,9,138,3,138,3,213,4,204,9,138,3,210,9,1,4,215,9,248,5,138,3,138,3,223,9,138,3,138,3,138,3,138,3,29,8,231,9,1,4,240,4,75,5,238,9,138,3,138,3,138,3,138,3,138,3,173,8,246,9,138,3,138,3,250,9,2,10,138,3,138,3,138,3,138,3,138,3,138,3,6,10,14,10,138,3,138,3,22,10,75,5,50,8,138,3,30,10,138,3,138,3,214,5,38,10,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,42,10,138,3,138,3,50,10,56,10,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,62,10,138,3,68,10,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,74,10,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,9,5,82,10,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,89,10,97,10,103,10,138,3,138,3,67,6,67,6,111,10,138,3,138,3,138,3,138,3,138,3,67,6,67,6,103,7,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,113,10,138,3,120,10,138,3,116,10,138,3,123,10,138,3,131,10,135,10,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,216,3,143,10,216,3,150,10,157,10,165,10,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,173,10,181,10,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,31,4,31,4,31,4,31,4,31,4,31,4,189,10,31,4,197,10,197,10,204,10,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,137,4,137,4,137,4,137,4,137,4,137,4,137,4,212,10,31,4,31,4,31,4,31,4,31,4,31,4,31,4,31,4,67,6,220,10,67,6,67,6,70,6,225,10,229,10,67,8,237,10,138,3,138,3,243,10,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,67,6,104,7,251,10,67,6,67,6,67,6,70,6,67,6,67,6,48,8,138,3,220,10,67,6,3,11,67,6,11,11,69,8,138,3,138,3,27,11,35,11,43,11,138,3,68,8,138,3,230,5,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,19,11,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,138,3,19,11,59,11,51,11,51,11,51,11,60,11,60,11,60,11,60,11,216,3,216,3,216,3,216,3,216,3,216,3,216,3,68,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,60,11,105,3,105,3,105,3,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,8,0,7,0,8,0,9,0,7,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,7,0,7,0,7,0,8,0,9,0,10,0,10,0,4,0,4,0,4,0,10,0,10,0,10,49,10,242,10,0,3,0,6,0,3,0,6,0,6,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,6,0,10,0,10,80,10,0,10,208,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,81,10,0,10,210,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,81,10,0,10,210,10,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,18,0,18,0,18,0,18,0,18,0,7,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,6,0,10,0,4,0,4,0,4,0,4,0,10,0,10,0,10,0,10,0,0,0,10,144,10,0,178,0,10,0,10,0,4,0,4,0,2,0,2,0,10,0,0,0,10,0,10,0,10,0,2,0,0,0,10,144,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10],\"i8\",4,A.a+40960)\n;O([10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,10,0,10,0,4,0,1,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,1,0,177,0,1,0,177,0,177,0,1,0,177,0,177,0,1,0,177,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,5,0,5,0,5,0,5,0,5,0,5,0,10,0,10,0,13,0,4,0,4,0,13,0,6,0,13,0,10,0,10,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,13,0,173,8,13,0,13,0,13,0,77,0,13,0,141,0,141,0,141,0,141,0,77,0,141,0,77,0,141,0,77,0,77,0,77,0,77,0,77,0,141,0,141,0,141,0,141,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,45,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,141,0,77,0,77,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,4,0,5,0,5,0,13,0,77,0,77,0,177,0,141,0,141,0,141,0,13,0,141,0,141,0,141,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,141,0,77,0,77,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,141,0,77,0,141,0,77,0,141,0,77,0,77,0,141,0,141,0,13,0,141,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,5,0,10,0,177,0,177,0,177,0,177,0,177,0,177,0,13,0,13,0,177,0,177,0,10,0,177,0,177,0,177,0,177,0,141,0,141,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,77,0,77,0,77,0,13,0,13,0,77,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,173,0,141,0,177,0,77,0,77,0,77,0,141,0,141,0,141,0,141,0,141,0,77,0,77,0,77,0,77,0,141,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,141,0,77,0,141,0,77,0,141,0,77,0,77,0,141,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,13,0,13,0,141,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,141,0,141,0,141,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,141,0,141,0,77,0,77,0,77,0,77,0,141,0,77,0,141,0,141,0,77,0,77,0,77,0,141,0,141,0,77,0,77,0,77,0,77,0,77,0,77,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,1,0,1,0,10,0,10,0,10,0,10,0,33,0,1,0,1,0,1,0,1,0,1,0,177,0,177,0,177,0,177,0,1,0,177,0,177,0,177,0,1,0,177,0,177,0,177,0,177,0,177,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,177,0,177,0,177,0,177,0,1,0,177,0,177,0,177,0,177,0,177,0,129,0,65,0,65,0,65,0,65,0,65,0,129,0,129,0,65,0,129,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,129,0,65,0,1,0,1,0,1,0,177,0,177,0,177,0,1,0,1,0,1,0,1,0,177,0,177,0,5,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,77,0,141,0,141,0,141,0,13,0,141,0,77,0,77,0,141,0,141,0,77,0,77,0,13,0,77,0,77,0,77,0,141,0,77,0,77,0,77,0,77,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,177,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,177,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,4,0,10,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,160,0,0,0,0,0,0,0,0,0,0,0,0,0,160,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,177,0,0,0,177,0,10,49,10,242,10,49,10,242,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,49,10,242,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,177,0,0,0,0,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,177,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,74,0,10,0,10,0,42,0,177,0,177,0,177,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,0,0,177,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,177,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,177,0,177,0,0,0,0,0,0,0,177,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,0,0,10,0,10,0,10,0,10,0,6,0,10,49,10,242,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,9,0,178,0,178,0,178,0,178,0,178,0,18,0,20,8,21,8,19,8,22,8,178,0,178,0,178,0,178,0,178,0,178,0,2,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,3,0,3,0,10,0,10,49,10,242,0,0,9,0,9,0,9,0,9,0,9,0,9,0,9,0,9,0,9,0,9,0,9,0,178,0,18,4,50,4,160,8,161,8,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,9,0,7,0,171,8,174,8,176,8,172,8,175,8,6,0,4,0,4,0,4,0,4,0,4,0,10,0,10,0,10,0,10,0,10,48,10,240,10,0,10,0,10,0,10,0,10,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,3,0,3,0,10,0,10,49,10,242,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,4,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,10,0,10,0,0,0,10,0,10,0,10,0,10,0,0,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,10,0,0,0,10,0,0,0,10,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,0,0,0,0,0,0,0,0,10,16,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,0,10,0,10,48,10,240,10,144,10,144,10,144,10,16,10,144,10,144,10,16,10,16,10,144,10,144,10,144,10,144,10,144,10,16,10,0,10,16,10,16,10,16,10,16,10,0,10,0,10,0,10,112,10,112,10,112,10,176,10,176,10,176,10,0,10,0,10,0,10,16,3,0,4,0,10,0,10,144,10,16,10,0,10,0,10,0,10,16,10,16,10,16,10,16,10,0,10,16,10,16,10,16,10,16,10,0,10,16,10,0,10,16,10,0,10,0,10,0,10,0,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,0,10,0,10,0,10,0,10,0,10,16,10,0,10,16,10,48,10,240,10,16,10,16,10,16,10,16,10,16,10,144,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,48,10,240,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,16,10,16,10,0,10,16,10,0,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,0,10,0,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,16,10,0,10,0,10,48,10,240,10,48,10,240,10,0,10,0,10,0,10,0,10,0,10,144,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,0,10,0,10,144,10,16,10,144,10,144,10,16,10,144,10,16,10,16,10,16,10,16,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,16,10,0,10,0,10,0,10,0,10,0,10,16,10,16,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,48,10,240,10,144,10,0,10,0,10,48,10,240,10,0,10,0,10,0,10,0,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,49,10,242,10,49,10,242,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,16,10,16,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,49,10,242,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,16,10,0,10,0,10,48,10,240,10,49,10,242,10,0,10,48,10,240,10,0,10,80,10,16,10,208,10,0,10,0,10,0,10,0,10,0,10,16,10,16,10,48,10,240,10,0,10,0,10,0,10,0,10,0,10,16,10,48,10,240,10,0,10,0,10,0,10,48,10,240,10,48,10,240,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,16,10,0,10,16,10,16,10,16,10,0,10,0,10,16,10,16,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,16,10,144,10,16,10,16,10,48,10,240,10,0,10,0,10,49,10,242,10,0,10,0,10,0,10,0,10,0,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,113,10,50,10,241,10,178,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,0,10,0,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,144,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,16,10,16,10,48,10,240,10,0,10,0,10,0,10,16,10,0,10,0,10,0,10,0,10,16,10,48,10,240,10,48,10,240,10,0,10,48,10,240,10,0,10,0,10,49,10,242,10,49,10,242,10,16,10,0,10,0,10,0,10,0,10,0,10,16,10,144,10,144,10,144,10,16,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,16,10,0,10,0,10,0,10,0,10,16,10,0,10,0,10,0,10,48,10,240,10,48,10,240,10,16,10,0,10,16,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,16,10,0,10,16,10,16,10,16,10,16,10,0,10,0,10,16,10,0,10,16,10,0,10,0,10,16,10,0,10,48,10,240,10,48,10,240,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,0,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,16,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,16,10,16,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,0,10,0,10,0,10,0,10,16,10,16,10,16,10,16,10,0,10,16,10,16,10,0,10,0,10,16,10,16,10,0,10,0,10,0,10,0,10,48,10,240,10,16,10,16,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,16,10,16,10,16,10,16,10,16,10,16,10,48,10,240,10,16,10,16,10,16,10,16,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,16,10,16,10,16,10,16,10,48,10,240,10,16,10,0,10,0,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,0,10,48,10,240,10,16,10,16,10,48,10,240,10,16,10,16,10,16,10,16,10,16,10,16,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,16,10,16,10,16,10,16,10,16,10,16,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,48,10,240,10,0,10,0,10,0,10,0,10,0,10,16,10,0,10,144,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,10,0,10,0,10,48,10,240,10,48,10,240,10,0,10,0,10,0,10,48,10,240,10,0,10,48,10,240,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,48,10,240,10,0,10,0,10,48,10,240,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,9,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,0,10,0,10,49,10,242,10,49,10,242,10,49,10,242,10,49,10,242,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,10,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,4,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,64,0,96,0,0,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,177,0,0,0,0,0,177,0,177],\"i8\",4,A.a+51200)\n;O([177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,177,0,177,0,177,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,3,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,177,0,1,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,10,0,10,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,10,0,13,0,13,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,6,0,10,0,6,0,0,0,10,0,6,0,10,0,10,0,10,0,10,49,10,242,10,49,10,242,10,49,10,242,4,0,10,0,10,0,3,0,3,0,10,48,10,240,10,0,0,0,10,0,4,0,4,0,10,0,0,0,0,0,0,0,0,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,178,0,0,0,10,0,10,0,4,0,4,0,4,0,10,0,10,0,10,49,10,242,10,0,3,0,6,0,3,0,6,0,6,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,6,0,10,0,10,80,10,0,10,208,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,81,10,0,10,210,10,0,10,49,10,242,10,0,10,49,10,242,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,4,0,10,0,10,0,10,0,4,0,4,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,170,0,170,0,170,0,10,0,10,0,18,0,18,0,0,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,177,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,10,0,1,0,177,0,177,0,177,0,1,0,177,0,177,0,1,0,1,0,1,0,1,0,1,0,177,0,177,0,177,0,177,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,177,0,177,0,177,0,1,0,1,0,1,0,1,0,177,0,65,0,129,0,1,0,1,0,129,0,177,0,177,0,1,0,1,0,1,0,1,0,65,0,65,0,65,0,65,0,129,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,65,0,65,0,65,0,65,0,65,0,129,0,1,0,129,0,1,0,129,0,129,0,1,0,1,0,97,0,129,0,129,0,129,0,129,0,129,0,65,0,65,0,65,0,65,0,97,0,65,0,65,0,65,0,65,0,65,0,129,0,65,0,65,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,65,0,129,0,65,0,129,0,129,0,129,0,65,0,65,0,65,0,129,0,65,0,65,0,129,0,65,0,129,0,129,0,65,0,129,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,129,0,129,0,129,0,129,0,65,0,65,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,1,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,177,0,0,0,0,0,160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,0,0,177,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,177,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,0,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,178,0,178,0,178,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,177,0,177,0,177,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,0,0,177,0,177,0,0,0,177,0,177,0,177,0,177,0,177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,65,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,10,0,10,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,13,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,2,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,18,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,0,0,0,0,0,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,10,0,0,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,178,0,18,0,178,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,177,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,18,0,0,0,0,0,0,0,0,0,0,1,2,7,8,3,9,6,5,4,4,10,10,12,10,10,10,11,10,4,4,4,4,13,14,1,2,4,5,7,15,17,7,9,7,0,7,3,18,21,4,1,34,36,37,39,47,49,39,41,39,1,1,35,50,53,0,33,2,36,37,39,47,49,39,41,39,2,2,35,50,53,1,33,34,38,38,40,48,49,40,40,40,3,3,3,50,53,1,33,34,4,37,39,47,49,74,11,74,4,4,35,18,21,2,33,34,36,5,39,47,49,39,41,76,5,5,35,50,53,3,33,34,6,6,40,48,49,40,40,77,6,6,35,18,21,3,33,34,36,37,7,47,49,7,78,7,7,7,35,50,53,4,33,34,38,38,8,48,49,8,8,8,8,8,35,50,53,4,33,34,4,37,7,47,49,7,9,7,9,9,35,18,21,4,97,98,4,101,135,111,113,135,142,135,10,135,99,18,21,2,33,34,4,37,39,47,49,39,11,39,11,11,35,18,21,2,97,98,100,5,135,111,113,135,142,135,12,135,99,114,117,3,97,98,6,6,136,112,113,136,136,136,13,136,99,18,21,3,33,34,132,37,7,47,49,7,14,7,14,14,35,146,149,4,33,34,36,37,39,15,49,39,41,39,15,39,35,50,53,5,33,34,38,38,40,16,49,40,40,40,16,40,35,50,53,5,33,34,36,37,39,47,17,39,41,39,17,39,35,50,53,6,33,34,18,37,39,47,49,83,20,83,18,18,35,18,21,0,97,98,18,101,135,111,113,135,142,135,19,135,99,18,21,0,33,34,18,37,39,47,49,39,20,39,20,20,35,18,21,0,33,34,21,37,39,47,49,86,23,86,21,21,35,18,21,3,97,98,21,101,135,111,113,135,142,135,22,135,99,18,21,3,33,34,21,37,39,47,49,39,23,39,23,23,35,18,21,3,0,2,17,17,0,0,0,0,0,66,1,1,0,0,0,0,0,2,4,4,19,19,0,1,0,34,52,52,3,3,0,0,0,2,4,4,19,19,0,2,1,0,2,2,0,0,0,0,1,0,1,3,20,20,0,1,1,0,2,2,0,0,0,1,1,0,1,3,5,5,0,1,33,0,33,3,4,4,0,0,1,0,1,3,5,5,0,0,0,1,2,3,4,0,1,0,2,0,0,0,0,0,1,3,3,20,20,0,1,0,1,0,2,21,21,0,2,0,1,3,3,20,20,0,2,0,33,51,51,4,4,0,0,0,33,0,50,5,5,0,0,0,3,17,17,0,0,0,0,32,3,1,1,2,32,32,2,32,3,1,1,2,32,32,1,0,3,5,5,20,0,0,1,32,3,5,5,4,32,32,1,0,3,5,5,20,0,0,2,2,0,1,1,0,0,0,0,2,0,1,1,0,0,0,1,2,0,20,20,19,0,0,1,34,0,4,4,3,0,0,0,34,0,4,4,3,0,0,1,0,1,0,0,0,0,0,0,0,1,0,0,20,20,0,1,0,1,0,0,21,21,0,2,0,1,0,0,20,20,0,2,32,1,32,32,4,4,32,1,32,1,32,32,5,5,32,1,1,0,1,1,0,0,0,0,1,0,1,1,20,20,0,1,1,0,1,1,0,0,0,1,1,0,1,1,5,5,0,1,33,0,33,33,4,4,0,0,1,0,1,1,5,5,0,0,1,0,2,2,0,0,0,0,1,0,1,2,19,19,0,1,1,0,2,2,0,0,0,1,33,48,6,4,3,3,48,0,33,48,6,4,5,5,48,3,33,48,6,4,5,5,48,2,33,48,6,4,3,3,48,1,0,1,13,14,0,98,1,1,0,0,0,0,0,98,1,1,0,48,0,4,0,98,84,84,19,48,0,3,48,66,84,84,3,48,48,3,48,66,4,4,19,48,48,4,19,0,1,1,0,0,0,0,35,0,1,1,2,64,0,1,35,0,1,1,2,64,0,0,3,0,3,54,20,64,0,1,83,64,5,54,4,64,64,0,83,64,5,54,4,64,64,1,83,64,6,6,4,64,64,3,0,1,2,5,6,7,8,0,1,9,10,11,12,0,99,0,1,0,0,0,0,0,99,0,1,18,48,0,4,32,99,32,1,2,48,32,3,0,99,85,86,20,48,0,3,48,67,85,86,4,48,48,3,48,67,5,86,20,48,48,4,48,67,85,6,20,48,48,4,0,0,0,0,0,0,0,0,0,1,0,3,0,1,0,1,0,0,2,2,0,0,1,2,0,1,1,2,0,1,1,3,0,0,0,0,0,0,0,0,0,1,0,3,0,1,0,3,0,0,1,2,0,0,1,2,0,1,1,2,0,1,1,3,0,2,4,6,8,10,12,14,0,1,0,0,0,0,0,1,2,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,2,3,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,2,3,0,1,2,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,2,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,4,4,4,4,3,3,3,0,3,0,3,3,3,3,3,3,3,3,3,3,0,0,1,0,1,0,1,0,1,0,1,2,3,0,1,0,1,2,3,0,1,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,0,1,0,1,0,1,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,2,3,0,1,0,1,0,1,2,3,0,1,0,1,0,1,0,1,0,0,0,45,0,3,3,44,3,45,3,4,42,4,4,13,13,13,6,6,31,31,35,35,33,33,40,40,1,1,11,11,55,55,55,0,9,29,19,22,24,26,16,44,45,45,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,29,0,3,3,3,0,3,44,44,45,4,4,4,4,4,4,4,4,13,13,13,13,13,13,13,6,6,6,6,6,6,6,6,6,31,31,31,31,31,31,31,31,31,35,35,35,33,33,40,1,9,9,9,9,9,9,29,29,11,38,11,19,19,19,11,11,11,11,11,11,22,22,22,22,26,26,26,26,56,21,13,42,17,17,14,44,44,44,44,44,44,44,44,55,47,55,44,45,45,46,46,0,42,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,31,0,0,0,0,0,0,0,0,0,0,35,33,1,0,0,21,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,5,12,12,7,7,15,39,50,18,43,43,48,49,20,23,25,27,36,10,8,28,32,34,30,7,37,41,5,12,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,53,52,51,4,4,4,4,4,4,4,13,13,6,6,31,35,1,1,1,9,9,11,11,11,24,24,26,26,26,22,31,31,35,13,13,35,31,13,3,3,55,55,45,44,44,54,54,13,35,35,19,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,4,13,40,9,29,22,24,45,45,31,44,57,0,6,33,11,85,31,1,19,0,4,4,4,31,45,86,88,87,0,0,58,60,60,64,64,61,0,82,0,84,84,0,0,65,79,83,67,67,67,68,62,80,69,70,76,59,59,72,72,75,73,73,73,74,0,0,77,0,0,0,0,0,0,71,63,78,81,66,78,49,48,95,95,99,120,120,97,98,105,118,49,49,54,95,95,115,104,105,109,95,116,121,112,101,95,105,110,102,111,69,0,83,116,57,116,121,112,101,95,105,110,102,111,0,78,49,48,95,95,99,120,120,97,98,105,118,49,50,48,95,95,115,105,95,99,108,97,115,115,95,116,121,112,101,95,105,110,102,111,69,0,78,49,48,95,95,99,120,120,97,98,105,118,49,49,55,95,95,99,108,97,115,115,95,116,121,112,101,95,105,110,102,111,69,0,78,49,48,95,95,99,120,120,97,98,105,118,49,49,57,95,95,112,111,105,110,116,101,114,95,116,121,112,101,95,105,110,102,111,69,0,78,49,48,95,95,99,120,120,97,98,105,118,49,49,55,95,95,112,98,97,115,101,95,116,121,112,101,95,105,110,102,111,69,0],\"i8\",4,A.a+61464);var Fa=B;B+=16;b._sbrk=Ga;b._memset=Ha;function Ia(){return!!Ia.n}var Ja=0,Ka={};function Y(){var a=Ja;if(!a)return(A.b(0),0)|0;var c=Ka[a],d=c.type;if(!d)return(A.b(0),a)|0;var e=Array.prototype.slice.call(arguments);b.___cxa_is_pointer_type(d);Y.buffer||(Y.buffer=P(4));C[Y.buffer>>2]=a;for(var a=Y.buffer,f=0;f<e.length;f++)if(e[f]&&b.___cxa_can_catch(e[f],d,a))return a=C[a>>2],c.D=a,(A.b(e[f]),a)|0;a=C[a>>2];return(A.b(d),a)|0}b._memcpy=La;E=O(1,\"i32\",2);S=z=A.o(B);T=S+xa;U=A.o(T);C[E>>2]=U;b.s={Math:Math,Int8Array:Int8Array,Int16Array:Int16Array,Int32Array:Int32Array,Uint8Array:Uint8Array,Uint16Array:Uint16Array,Uint32Array:Uint32Array,Float32Array:Float32Array,Float64Array:Float64Array,NaN:NaN,Infinity:Infinity,byteLength:V};b.t={abort:H,assert_em:assert_em,enlargeMemory:ba,getTotalMemory:function(){return F},abortOnCannotGrowMemory:function(){H(\"Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value \"+F+\", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime but prevents some optimizations, (3) set Module.TOTAL_MEMORY to a higher value before the program runs, or (4) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 \")},invoke_viiiii:function(a,c,d,e,f,h){try{b.dynCall_viiiii(a,c,d,e,f,h)}catch(l){if(\"number\"!==typeof l&&\"longjmp\"!==l)throw l;b.setThrew(1,0)}},invoke_vi:function(a,c){try{b.dynCall_vi(a,c)}catch(d){if(\"number\"!==typeof d&&\"longjmp\"!==d)throw d;b.setThrew(1,0)}},invoke_iiii:function(a,c,d,e){try{return b.dynCall_iiii(a,c,d,e)}catch(f){if(\"number\"!==typeof f&&\"longjmp\"!==f)throw f;b.setThrew(1,0)}},invoke_viiiiii:function(a,c,d,e,f,h,l){try{b.dynCall_viiiiii(a,c,d,e,f,h,l)}catch(m){if(\"number\"!==typeof m&&\"longjmp\"!==m)throw m;b.setThrew(1,0)}},invoke_iii:function(a,c,d){try{return b.dynCall_iii(a,c,d)}catch(e){if(\"number\"!==typeof e&&\"longjmp\"!==e)throw e;b.setThrew(1,0)}},invoke_viiii:function(a,c,d,e,f){try{b.dynCall_viiii(a,c,d,e,f)}catch(h){if(\"number\"!==typeof h&&\"longjmp\"!==h)throw h;b.setThrew(1,0)}},_abort:function(){b.abort()},___setErrNo:function(a){b.___errno_location&&(C[b.___errno_location()>>2]=a);return a},_emscripten_memcpy_big:function(a,c,d){K.set(K.subarray(c,c+d),a);return a},___gxx_personality_v0:function(){},___resumeException:function(a){Ja||(Ja=a);throw a+\" - Exception catching is disabled, this exception cannot be caught. Compile with -s DISABLE_EXCEPTION_CATCHING=0 or DISABLE_EXCEPTION_CATCHING=2 to catch.\"},__ZSt18uncaught_exceptionv:Ia,___cxa_find_matching_catch:Y,DYNAMICTOP_PTR:E,tempDoublePtr:Fa,ABORT:G,STACKTOP:z,STACK_MAX:T};var Z=function(global,env,buffer){\"almost asm\";var a=global.Int8Array;var b=new a(buffer);var c=global.Int16Array;var d=new c(buffer);var e=global.Int32Array;var f=new e(buffer);var g=global.Uint8Array;var h=new g(buffer);var i=global.Uint16Array;var j=new i(buffer);var k=global.Uint32Array;var l=new k(buffer);var m=global.Float32Array;var n=new m(buffer);var o=global.Float64Array;var p=new o(buffer);var q=global.byteLength;var r=env.DYNAMICTOP_PTR|0;var s=env.tempDoublePtr|0;var t=env.ABORT|0;var u=env.STACKTOP|0;var v=env.STACK_MAX|0;var w=0;var x=0;var y=0;var z=0;var A=global.NaN,B=global.Infinity;var C=0,D=0,E=0,F=0,G=0;var H=0;var I=global.Math.floor;var J=global.Math.abs;var K=global.Math.sqrt;var L=global.Math.pow;var M=global.Math.cos;var N=global.Math.sin;var O=global.Math.tan;var P=global.Math.acos;var Q=global.Math.asin;var R=global.Math.atan;var S=global.Math.atan2;var T=global.Math.exp;var U=global.Math.log;var V=global.Math.ceil;var W=global.Math.imul;var X=global.Math.min;var Y=global.Math.max;var Z=global.Math.clz32;var _=env.abort;var $=env.assert_em;var aa=env.enlargeMemory;var ba=env.getTotalMemory;var ca=env.abortOnCannotGrowMemory;var da=env.invoke_viiiii;var ea=env.invoke_vi;var fa=env.invoke_iiii;var ga=env.invoke_viiiiii;var ha=env.invoke_iii;var ia=env.invoke_viiii;var ja=env._abort;var ka=env.___setErrNo;var la=env._emscripten_memcpy_big;var ma=env.___gxx_personality_v0;var na=env.___resumeException;var oa=env.__ZSt18uncaught_exceptionv;var pa=env.___cxa_find_matching_catch;var qa=0;function ra(newBuffer){if(q(newBuffer)&16777215||q(newBuffer)<=16777215||q(newBuffer)>2147483648)return false;b=new a(newBuffer);d=new c(newBuffer);f=new e(newBuffer);h=new g(newBuffer);j=new i(newBuffer);l=new k(newBuffer);n=new m(newBuffer);p=new o(newBuffer);buffer=newBuffer;return true}function ya(a){a=a|0;var b=0;b=u;u=u+a|0;u=u+15&-16;return b|0}function za(){return u|0}function Aa(a){a=a|0;u=a}function Ba(a,b){a=a|0;b=b|0;u=a;v=b}function Ca(a,b){a=a|0;b=b|0;if(!w){w=a;x=b}}function Da(a){a=a|0;H=a}function Ea(){return H|0}function Fa(a,b){a=a|0;b=b|0;var c=0,e=0,g=0,h=0,i=0;g=u;u=u+16|0;h=g;f[h>>2]=0;e=Cb(a,b,0,0,h)|0;i=e+1|0;f[h>>2]=0;c=fc(i<<1)|0;Cb(a,b,c,i,h)|0;if((f[h>>2]|0)>0){gc(c);c=0}else d[c+(e<<1)>>1]=0;u=g;return c|0}function Ga(a,b){a=a|0;b=b|0;var c=0,d=0,e=0;e=u;u=u+16|0;d=e;c=f[17218]|0;if(!c){c=Ja()|0;f[17218]=c}f[d>>2]=0;Oa(c,a,b,-2,d);if((f[d>>2]|0)>0)c=0;else c=mb(f[17218]|0)|0;u=e;return c|0}function Ha(a){a=a|0;var b=0,c=0,d=0;d=u;u=u+16|0;c=d+4|0;b=d;f[c>>2]=0;f[b>>2]=0;nb(f[17218]|0,a,b,c);u=d;return((f[c>>2]|0)>0?0:f[b>>2]|0)|0}function Ia(a,b){a=a|0;b=b|0;var c=0,e=0,g=0,h=0,i=0;i=u;u=u+16|0;h=i;f[h>>2]=0;e=f[17219]|0;if(!e){e=Ja()|0;f[17219]=e}sb(f[17218]|0,a,b,e,h);if((f[h>>2]|0)<=0?(g=lb(e)|0,b=g+1|0,c=fc(b<<1)|0,qb(f[17219]|0,c,b,10,h)|0,(f[h>>2]|0)<=0):0)d[c+(g<<1)>>1]=0;else c=0;u=i;return c|0}function Ja(){var a=0,b=0;b=u;u=u+16|0;a=b;f[a>>2]=0;a=Ka(a)|0;u=b;return a|0}function Ka(a){a=a|0;var c=0;do{if((a|0)!=0?(f[a>>2]|0)<=0:0){c=Rb(364)|0;if(!c){f[a>>2]=7;c=0;break}Ic(c|0,0,364)|0;f[c+4>>2]=248;b[c+72>>0]=1;b[c+73>>0]=1;if((f[a>>2]|0)>=1){Ma(c);c=0}}else c=0}while(0);return c|0}function La(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,g=0;g=f[a>>2]|0;e=c<<24>>24==0;if(!g)if(!e?(g=Rb(d)|0,f[a>>2]=g,(g|0)!=0):0){f[b>>2]=d;c=1}else c=0;else{c=(f[b>>2]|0)>=(d|0);if(!(e|c)){c=Sb(g,d)|0;if(!c)c=0;else{f[a>>2]=c;f[b>>2]=d;c=1}}else c=c&1}return c|0}function Ma(a){a=a|0;var b=0;if(a|0){f[a>>2]=0;b=f[a+48>>2]|0;if(b|0)Tb(b);b=f[a+52>>2]|0;if(b|0)Tb(b);b=f[a+56>>2]|0;if(b|0)Tb(b);b=f[a+60>>2]|0;if(b|0)Tb(b);b=f[a+64>>2]|0;if(b|0)Tb(b);b=f[a+68>>2]|0;if(b|0)Tb(b);b=f[a+348>>2]|0;if(b|0)Tb(b);Tb(a)}return}function Na(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;d=0;while(1){if((d|0)>=(a|0)){e=5;break}if((f[b+(d<<3)>>2]|0)>(c|0))break;d=d+1|0}if((e|0)==5)d=a+-1|0;return f[b+(d<<3)+4>>2]&255|0}function Oa(a,c,d,e,g){a=a|0;c=c|0;d=d|0;e=e|0;g=g|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;a:do{if(g|0?(f[g>>2]|0)<=0:0){if((a|0)==0|(c|0)==0|(d|0)<-1|e+-126<<24>>24<<24>>24>-1){f[g>>2]=1;break}if((d|0)==-1)d=Ub(c)|0;x=a+88|0;if((f[x>>2]|0)==3){Pa(a,c,d,e,g);break}f[a>>2]=0;f[a+8>>2]=c;B=a+20|0;f[B>>2]=d;f[a+12>>2]=d;l=a+16|0;f[l>>2]=d;u=a+97|0;b[u>>0]=e;i=e&1;j=i&255;m=a+120|0;f[m>>2]=j;z=a+136|0;f[z>>2]=1;k=a+76|0;f[k>>2]=0;o=a+80|0;f[o>>2]=0;f[a+228>>2]=0;A=a+336|0;f[A>>2]=0;f[a+340>>2]=0;c=(e&255)>253;v=a+98|0;b[v>>0]=c&1;n=a+124|0;e=a+224|0;if(!d){if(c){b[u>>0]=i;b[v>>0]=0}f[n>>2]=f[96+(j<<2)>>2];f[e>>2]=0;f[z>>2]=0;Qa(a);break}f[e>>2]=-1;c=f[a+60>>2]|0;y=a+140|0;f[y>>2]=(c|0)==0?a+144|0:c;c=a+48|0;e=a+72|0;if(!((La(c,a+24|0,b[e>>0]|0,d)|0)<<24>>24)){f[g>>2]=7;break}f[k>>2]=f[c>>2];if(!((Ra(a)|0)<<24>>24)){f[g>>2]=7;break}w=f[k>>2]|0;r=f[l>>2]|0;k=a+132|0;f[k>>2]=r;d=a+52|0;if(!((La(d,a+28|0,b[e>>0]|0,r)|0)<<24>>24)){f[g>>2]=7;break}f[o>>2]=f[d>>2];j=Sa(a,g)|0;if((f[g>>2]|0)<=0){i=a+244|0;d=f[i>>2]|0;do{if((d|0)>=6){d=d<<4;c=a+44|0;e=a+68|0;if((d|0)<=(f[c>>2]|0)){d=f[e>>2]|0;break}if(!((La(e,c,1,d)|0)<<24>>24)){f[g>>2]=7;break a}else{d=f[e>>2]|0;break}}else d=a+252|0}while(0);f[a+248>>2]=d;f[i>>2]=-1;f[m>>2]=j;s=a+92|0;b:do{switch(j|0){case 0:{f[k>>2]=0;break}case 1:{f[k>>2]=0;break}default:{d=a+116|0;switch(f[x>>2]|0){case 0:{c=200;t=36;break}case 1:{c=216;t=36;break}case 2:{c=184;t=36;break}case 4:{c=168;t=36;break}case 5:{c=f[s>>2]&1|0?104:120;t=36;break}case 6:{c=f[s>>2]&1|0?136:152;t=36;break}default:{}}if((t|0)==36)f[d>>2]=c;p=r+-1|0;i=f[z>>2]|0;if((i|0)<2?(f[n>>2]|0)>=0:0){do{if(b[v>>0]|0){c=f[y>>2]|0;e=f[c>>2]|0;if((e|0)>0)d=b[u>>0]|0;else d=Na(i,c,0)|0;d=d&1;if((r|0)>(e|0)){c=Na(i,c,p)|0;break}else{c=b[u>>0]|0;break}}else{d=b[u>>0]|0;c=d;d=d&1}}while(0);Ta(a,0,r,d,c&1)}else{n=f[o>>2]|0;if((b[v>>0]|0)!=0?(q=f[y>>2]|0,(f[q>>2]|0)<=0):0)d=Na(i,q,0)|0;else d=b[u>>0]|0;e=b[n>>0]|0;d=((d&255)<(e&255)?e:d)&1;m=0;while(1){if((m|0)>0?(b[w+(m+-1)>>0]|0)==7:0){do{if(!(b[v>>0]|0))t=57;else{d=f[y>>2]|0;if((m|0)<(f[d>>2]|0)){t=57;break}d=Na(f[z>>2]|0,d,m)|0}}while(0);if((t|0)==57)d=b[u>>0]|0;d=d&1}k=m;while(1){l=k+1|0;if((l|0)>=(r|0)){t=64;break}c=b[n+l>>0]|0;if(c<<24>>24==e<<24>>24){k=l;continue}if(!(1<<h[w+l>>0]&382976)){t=68;break}else k=l}c:do{if((t|0)==64){t=0;e=e&255;do{if(b[v>>0]|0){c=f[y>>2]|0;if((r|0)<=(f[c>>2]|0))break;c=Na(f[z>>2]|0,c,p)|0;j=0;break c}}while(0);c=b[u>>0]|0;j=0}else if((t|0)==68){t=0;e=e&255;j=1}}while(0);i=c&255;i=((e&127)>>>0<(i&127)>>>0?i:e)&1;if(!(e&128))Ta(a,m,l,d,i);else{d=m;while(1){q=n+d|0;b[q>>0]=b[q>>0]&127;if((d|0)<(k|0))d=d+1|0;else break}}if(j){d=i;e=c;m=l}else break}}d=f[a+344>>2]|0;if((d|0)>0){f[g>>2]=d;break a}else{Ua(a);break b}}}}while(0);d:do{if((b[v>>0]|0?f[s>>2]&1|0:0)?((f[x>>2]|0)+-5|0)>>>0<2:0){j=0;while(1){if((j|0)>=(f[z>>2]|0))break d;c=f[y>>2]|0;d=(f[c+(j<<3)>>2]|0)+-1|0;e:do{if(f[c+(j<<3)+4>>2]&255|0){if(!j)e=0;else e=f[c+(j+-1<<3)>>2]|0;c=d;while(1){if((c|0)<(e|0))break e;i=b[w+c>>0]|0;if(!(i<<24>>24))break;if(1<<(i&255)&8194|0)break e;c=c+-1|0}if((c|0)<(d|0))while(1)if((b[w+d>>0]|0)==7)d=d+-1|0;else break;Va(a,d,4)}}while(0);j=j+1|0}}}while(0);d=f[B>>2]|0;if(!(f[s>>2]&2))d=(f[A>>2]|0)+d|0;else d=d-(f[a+352>>2]|0)|0;f[B>>2]=d;Qa(a)}}}while(0);return}function Pa(a,c,d,e,g){a=a|0;c=c|0;d=d|0;e=e|0;g=g|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0;E=a+88|0;f[E>>2]=0;do{if(d){i=Rb(d*7|0)|0;if(!i){f[g>>2]=7;i=0;break}k=i+(d<<2)|0;D=k+(d<<1)|0;l=a+92|0;m=f[l>>2]|0;if(m&1|0)f[l>>2]=m&-4|2;e=e&1;Oa(a,c,d,e,g);if((f[g>>2]|0)<=0){y=ub(a,g)|0;w=a+16|0;x=f[w>>2]|0;Jc(D|0,y|0,x|0)|0;y=a+132|0;z=f[y>>2]|0;A=a+120|0;B=f[A>>2]|0;j=qb(a,k,d,2,g)|0;Bb(a,i,g);C=a+224|0;if((f[g>>2]|0)<=0){f[l>>2]=m;f[E>>2]=5;v=a+72|0;u=b[v>>0]|0;b[v>>0]=0;Oa(a,k,j,e^1,g);b[v>>0]=u;wb(a,g);a:do{if((f[g>>2]|0)<=0){q=f[C>>2]|0;o=a+228|0;p=f[o>>2]|0;k=0;e=0;g=0;while(1){if((g|0)>=(q|0))break;n=f[p+(g*12|0)+4>>2]|0;e=n-e|0;b:do{if((e|0)<2)e=k;else{j=f[p+(g*12|0)>>2]&2147483647;m=j+e|0;e=k;while(1){do{k=j;j=j+1|0;if((j|0)>=(m|0))break b;l=f[i+(j<<2)>>2]|0;k=f[i+(k<<2)>>2]|0;v=l-k|0;if((((v|0)>-1?v:0-v|0)|0)!=1)break}while((b[D+l>>0]|0)==(b[D+k>>0]|0));e=e+1|0}}}while(0);k=e;e=n;g=g+1|0}if(k){e=a+64|0;if(!((La(e,a+40|0,b[a+73>>0]|0,(k+q|0)*12|0)|0)<<24>>24))break;if((q|0)==1){v=f[e>>2]|0;f[v>>2]=f[p>>2];f[v+4>>2]=f[p+4>>2];f[v+8>>2]=f[p+8>>2]}p=f[e>>2]|0;f[o>>2]=p;f[C>>2]=(f[C>>2]|0)+k}v=p+4|0;e=q;while(1){u=e+-1|0;if((e|0)<=0)break a;s=p+(u*12|0)|0;q=p+(u*12|0)+4|0;if(!u)j=f[v>>2]|0;else j=(f[q>>2]|0)-(f[p+((e+-2|0)*12|0)+4>>2]|0)|0;e=f[s>>2]|0;t=e>>>31;e=e&2147483647;if((j|0)<2){j=u+k|0;if(!k)k=0;else{r=p+(j*12|0)|0;f[r>>2]=f[s>>2];f[r+4>>2]=f[s+4>>2];f[r+8>>2]=f[s+8>>2]}}else{m=(t|0)==0;o=j+-1+e|0;r=m?e:o;g=m?-1:1;n=p+(u*12|0)+8|0;o=m?o:e;c:while(1){e=o;while(1){if((e|0)==(r|0))break c;j=f[i+(e<<2)>>2]|0;l=e+g|0;m=f[i+(l<<2)>>2]|0;F=j-m|0;if((((F|0)>-1?F:0-F|0)|0)!=1)break;if((b[D+j>>0]|0)==(b[D+m>>0]|0))e=l;else break}m=k+u|0;F=f[i+(o<<2)>>2]|0;F=(F|0)<(j|0)?F:j;f[p+(m*12|0)>>2]=(h[D+F>>0]^t)<<31|F;f[p+(m*12|0)+4>>2]=f[q>>2];F=e-o|0;f[q>>2]=(f[q>>2]|0)+~((F|0)>-1?F:0-F|0);F=f[n>>2]|0;f[p+(m*12|0)+8>>2]=F&10;f[n>>2]=f[n>>2]&((F|-11)^10);o=l;k=k+-1|0}j=k+u|0;if(k|0){F=p+(j*12|0)|0;f[F>>2]=f[s>>2];f[F+4>>2]=f[s+4>>2];f[F+8>>2]=f[s+8>>2]}e=(f[i+(o<<2)>>2]|0)<(f[i+(r<<2)>>2]|0)?o:r}e=f[i+(e<<2)>>2]|0;f[p+(j*12|0)>>2]=(h[D+e>>0]^t)<<31|e;e=u}}}while(0);F=a+97|0;b[F>>0]=b[F>>0]^1}f[a+8>>2]=c;f[w>>2]=x;f[a+12>>2]=d;f[A>>2]=B;F=f[a+28>>2]|0;Jc(f[a+80>>2]|0,D|0,((x|0)>(F|0)?F:x)|0)|0;f[y>>2]=z;if((f[C>>2]|0)>1)f[A>>2]=2}}else{Oa(a,c,0,e,g);i=0}}while(0);Tb(i);f[E>>2]=3;return}function Qa(a){a=a|0;f[a+104>>2]=0;f[a+112>>2]=0;f[a>>2]=a;return}function Ra(a){a=a|0;var c=0,e=0,g=0,i=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0;R=u;u=u+640|0;A=R;H=R+504|0;E=f[a+8>>2]|0;F=f[a+48>>2]|0;N=f[a+12>>2]|0;P=a+97|0;O=b[P>>0]|0;c=O&255;O=(O&255)>253;if(O){D=f[a+88>>2]|0;D=(D|0)==5^(D|0)!=6}else D=1;L=a+92|0;Q=f[L>>2]|0;i=Q&2;M=a+16|0;if(Q&4|0)f[M>>2]=0;B=c&1;C=B&255;Q=a+140|0;e=(f[Q>>2]|0)+4|0;if(O){f[e>>2]=B;if((f[a+104>>2]|0)>0?(g=jb(a)|0,g<<24>>24!=10):0){f[(f[Q>>2]|0)+4>>2]=g<<24>>24!=0&1;c=C;e=0}else{c=C;e=1}}else{f[e>>2]=c;c=10;e=0}I=a+136|0;J=a+352|0;z=(i|0)==0;y=-1;g=c;i=0;n=0;G=-1;c=0;a:while(1){x=D|g<<24>>24!=1;if((i|0)>=(N|0)){K=49;break}k=i+1|0;l=j[E+(i<<1)>>1]|0;if(!((k|0)==(N|0)|(l&64512|0)!=55296)){m=j[E+(k<<1)>>1]|0;w=(m&64512|0)==56320;i=w?i+2|0:k;if(w)l=(l<<10)+-56613888+m|0}else i=k;r=Za(a,l)|0;p=r&255;r=r&255;c=1<<r|c;t=i+-1|0;q=F+t|0;b[q>>0]=p;if((l|0)>65535){b[F+(i+-2)>>0]=18;v=c|262144}else v=c;if(z)w=n;else w=(((l+-8294|0)>>>0<4|((l&-4|0)==8204|(l+-8234|0)>>>0<5))&1)+n|0;m=(y|0)<126;n=(e|0)==1;o=(e|0)==2;k=o?3:e;o=o&m;c=o?v|1048576:v;if(!r){if(!n){v=G;x=y;g=0;e=k;n=w;G=v;y=x;continue}f[(f[Q>>2]|0)+((f[I>>2]|0)+-1<<3)+4>>2]=0;t=G;x=y;g=0;e=0;n=w;c=v;G=t;y=x;continue}s=(r|0)==13;switch(p<<24>>24){case 1:case 13:{if(!n)if(o){b[F+(f[A+(y<<2)>>2]|0)>>0]=21;e=3;c=v|2097152}else{e=k;c=v}else{f[(f[Q>>2]|0)+((f[I>>2]|0)+-1<<3)+4>>2]=1;e=0;c=v}x=y;g=1;n=w;G=s?t:G;y=x;continue a}default:{}}if((r+-19|0)>>>0<3){c=y+1|0;if((c|0)<126){f[A+(c<<2)>>2]=t;b[H+c>>0]=e}if((r|0)!=19){t=G;x=g;y=c;e=3;n=w;c=v;G=t;g=x;continue}b[q>>0]=20;t=G;x=g;y=c;e=2;n=w;c=v;G=t;g=x;continue}switch(p<<24>>24){case 22:{if((y|0)<=-1){s=G;t=e;v=g;x=y;n=w;G=s;e=t;g=v;y=x;continue a}if(m)e=b[H+y>>0]|0;v=G;x=g;y=y+-1|0;n=w;G=v;g=x;continue a}case 7:break;default:{r=G;s=e;t=g;x=y;n=w;c=v;G=r;e=s;g=t;y=x;continue a}}m=(i|0)<(N|0);if((l|0)==13&m?(d[E+(i<<1)>>1]|0)==10:0){r=G;s=e;t=g;x=y;n=w;c=v;G=r;e=s;g=t;y=x;continue}c=f[Q>>2]|0;k=f[I>>2]|0;l=k+-1|0;f[c+(l<<3)>>2]=i;if(!x)f[c+(l<<3)+4>>2]=1;if(f[L>>2]&4|0){f[M>>2]=i;f[J>>2]=w}if(!m){r=G;s=e;t=g;x=y;n=w;c=v;G=r;e=s;g=t;y=x;continue}f[I>>2]=k+1;if(!((kb(a)|0)<<24>>24)){c=0;break}if(O){g=C;e=1;c=B}else{e=0;c=h[P>>0]|0}f[(f[Q>>2]|0)+((f[I>>2]|0)+-1<<3)+4>>2]=c;x=G;y=-1;n=w;c=v;G=x}\nif((K|0)==49){F=(y|0)>125;g=F?125:y;e=F?2:e;while(1){if((g|0)<=-1)break;if((e|0)==2){K=52;break}e=b[H+g>>0]|0;g=g+-1|0}if((K|0)==52)c=c|1048576;g=f[I>>2]|0;e=g+-1|0;if(f[L>>2]&4){if((f[M>>2]|0)<(N|0)){f[I>>2]=e;g=e}}else{f[(f[Q>>2]|0)+(e<<3)>>2]=N;f[J>>2]=n}if(!x)f[(f[Q>>2]|0)+(g+-1<<3)+4>>2]=1;if(O){b[P>>0]=f[(f[Q>>2]|0)+4>>2];e=0}else e=0;while(1){if((e|0)>=(g|0))break;P=f[96+((f[(f[Q>>2]|0)+(e<<3)+4>>2]&1)<<2)>>2]|c;e=e+1|0;c=P}f[a+124>>2]=(c&128|0)!=0&(b[a+96>>0]|0)!=0&1|c;f[a+128>>2]=G;c=1}u=R;return c|0}function Sa(a,c){a=a|0;c=c|0;var e=0,g=0,i=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0;W=u;u=u+5072|0;P=W+2532|0;M=W;Q=f[a+76>>2]|0;V=f[a+80>>2]|0;R=f[a+8>>2]|0;O=f[a+16>>2]|0;N=a+124|0;g=f[N>>2]|0;I=a+98|0;K=a+97|0;U=a+140|0;if((b[I>>0]|0)!=0?(e=f[U>>2]|0,(f[e>>2]|0)<=0):0)i=Na(f[a+136>>2]|0,e,0)|0;else i=b[K>>0]|0;H=a+244|0;f[H>>2]=0;a:do{if((f[c>>2]|0)<=0){e=$a(g)|0;if((e|0)==2){T=a+136|0;if((f[a+88>>2]|0)>>>0>1){i=0;while(1){if((i|0)>=(f[T>>2]|0)){e=2;break a}g=f[U>>2]|0;if(!i)e=0;else e=f[g+(i+-1<<3)>>2]|0;k=f[g+(i<<3)>>2]|0;g=f[g+(i<<3)+4>>2]&255;while(1){if((e|0)>=(k|0))break;b[V+e>>0]=g;e=e+1|0}i=i+1|0}}if(!(g&7985152)){ab(a,P);k=0;b:while(1){if((k|0)>=(f[T>>2]|0)){e=2;break}e=f[U>>2]|0;if(!k)g=0;else g=f[e+(k+-1<<3)>>2]|0;l=f[e+(k<<3)>>2]|0;i=f[e+(k<<3)+4>>2]&255;c:while(1){if((g|0)>=(l|0))break;b[V+g>>0]=i;e=g+1|0;switch(b[Q+g>>0]|0){case 18:{g=e;continue c}case 7:break;default:if(!((cb(P,g)|0)<<24>>24)){S=28;break b}else{g=e;continue c}}if((e|0)>=(O|0)){g=e;continue}if((d[R+(g<<1)>>1]|0)==13?(d[R+(e<<1)>>1]|0)==10:0){g=e;continue}bb(P,i);g=e}k=k+1|0}if((S|0)==28){f[c>>2]=7;e=0}break}ab(a,M);d[P>>1]=i&255;k=0;l=0;c=0;F=0;E=0;B=i;C=i;e=0;i=0;d:while(1){if((i|0)>=(O|0))break;x=Q+i|0;y=b[x>>0]|0;z=F+1|0;v=e|262144;D=V+i|0;A=P+(z<<1)|0;g=C&255;m=e|-2147483648;o=g&127;G=i+1|0;p=(c|0)!=0;n=g&1;q=(c|0)==0;r=(o|0)!=(B&127|0);s=g+2&126;t=(o+1|1)&255;w=(l|c|0)==0;switch(y<<24>>24){case 15:case 12:case 14:case 11:{b[D>>0]=B;e=(y+-11&255)<2?s:t;if(w&(e&255)<126){C=y<<24>>24==12|y<<24>>24==15?e|-128:e;d[A>>1]=C&255;x=B;E=i;y=c;A=l;D=k;F=z;e=v;i=G;B=x;c=y;l=A;k=D;continue d}else{w=C;x=B;y=E;z=F;A=c;D=k;l=(q&1)+l|0;e=v;i=G;C=w;B=x;E=y;F=z;c=A;k=D;continue d}}case 16:{b[D>>0]=B;if(p){t=C;w=B;x=E;y=F;z=c;A=l;D=k;e=v;i=G;C=t;B=w;E=x;F=y;c=z;l=A;k=D;continue d}if(l|0){x=C;y=B;z=E;A=F;D=k;l=l+-1|0;c=0;e=v;i=G;C=x;B=y;E=z;F=A;k=D;continue d}if(!F){y=C;z=B;A=E;D=k;l=0;c=0;F=0;e=v;i=G;C=y;B=z;E=A;k=D;continue d}e=F+-1|0;if((j[P+(F<<1)>>1]|0)>=256){x=C;y=B;z=E;A=F;D=k;l=0;c=0;e=v;i=G;C=x;B=y;E=z;F=A;k=D;continue d}A=B;E=i;D=k;l=0;c=0;F=e;C=d[P+(e<<1)>>1]&255;e=v;i=G;B=A;k=D;continue d}case 21:case 20:{e=f[96+(n<<2)>>2]|e;b[D>>0]=o;if(r){db(M,E,B,C);e=e|-2147482624}else e=e|1024;m=y<<24>>24==20?s:t;if(!(w&(m&255)<126)){b[x>>0]=9;x=C;B=C;y=E;z=F;A=l;D=k;c=c+1|0;i=G;C=x;E=y;F=z;l=A;k=D;continue d}g=k+1|0;if((k|0)>=(f[H>>2]|0))f[H>>2]=g;d[A>>1]=m&255|256;eb(M,m);B=C;E=i;A=c;D=l;k=g;F=z;C=m;e=e|1<<(y&255);i=G;c=A;l=D;continue d}case 22:{if(r){db(M,E,B,C);e=m}do{if(p){b[x>>0]=9;c=c+-1|0;i=E;g=F}else{if(!k){b[x>>0]=9;k=0;c=0;i=E;g=F;break}else g=F;do{F=g;g=g+-1|0}while((j[P+(F<<1)>>1]|0)<256);fb(M);k=k+-1|0;l=0;c=0;e=e|4194304}}while(0);F=d[P+(g<<1)>>1]|0;C=F&255;F=F&255;e=e|f[96+((F&1)<<2)>>2]|1024;b[D>>0]=F&127;F=g;E=i;B=C;i=G;continue d}case 7:{e=e|128;if((b[I>>0]|0)!=0?(J=f[U>>2]|0,(i|0)>=(f[J>>2]|0)):0)g=Na(f[T>>2]|0,J,i)|0;else g=b[K>>0]|0;b[D>>0]=g;if((G|0)>=(O|0)){v=C;w=B;x=E;y=F;z=c;A=l;D=k;i=G;C=v;B=w;E=x;F=y;c=z;l=A;k=D;continue d}if((d[R+(i<<1)>>1]|0)==13?(d[R+(G<<1)>>1]|0)==10:0){v=C;w=B;x=E;y=F;z=c;A=l;D=k;i=G;C=v;B=w;E=x;F=y;c=z;l=A;k=D;continue d}if((b[I>>0]|0)!=0?(L=f[U>>2]|0,(G|0)>=(f[L>>2]|0)):0)g=Na(f[T>>2]|0,L,G)|0;else g=b[K>>0]|0;d[P>>1]=g&255;bb(M,g);D=E;k=0;l=0;c=0;F=0;B=g;C=g;i=G;E=D;continue d}case 18:{b[D>>0]=B;t=C;w=B;x=E;y=F;z=c;A=l;D=k;e=v;i=G;C=t;B=w;E=x;F=y;c=z;l=A;k=D;continue d}default:{if(r){db(M,E,B,C);e=f[((g&128|0)==0?240:232)+(n<<2)>>2]|m}b[D>>0]=C;if(!((cb(M,i)|0)<<24>>24)){S=78;break d}v=C;B=C;w=E;y=F;z=c;A=l;D=k;e=1<<h[x>>0]|e;i=G;C=v;E=w;F=y;c=z;l=A;k=D;continue d}}}if((S|0)==78){e=-1;break}if(e&8380376)e=f[96+((b[K>>0]&1)<<2)>>2]|e;e=(e&128|0)!=0&(b[a+96>>0]|0)!=0&1|e;f[N>>2]=e;e=$a(e)|0}}else e=0}while(0);u=W;return e|0}function Ta(a,c,e,g,h){a=a|0;c=c|0;e=e|0;g=g|0;h=h|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,v=0,w=0,x=0,y=0,z=0,A=0;A=u;u=u+32|0;y=A;z=f[a+76>>2]|0;if((f[a+128>>2]|0)>(c|0)){if((b[a+98>>0]|0)!=0?(i=f[a+140>>2]|0,(f[i>>2]|0)<=(c|0)):0)i=Na(f[a+136>>2]|0,i,c)|0;else i=b[a+97>>0]|0;if(i&1)s=((f[a+88>>2]|0)+-5|0)>>>0<2;else s=0}else s=0;f[y+12>>2]=-1;f[y+16>>2]=-1;f[y+24>>2]=c;x=b[(f[a+80>>2]|0)+c>>0]|0;b[y+28>>0]=x;w=f[a+116>>2]|0;x=x&1;f[y>>2]=f[w+(x<<2)>>2];f[y+4>>2]=f[w+8+(x<<2)>>2];if((c|0)==0?(f[a+104>>2]|0)>0:0){x=Wa(a)|0;g=x<<24>>24==4?g:x}i=b[z+c>>0]|0;t=y+8|0;v=a+248|0;w=y+20|0;x=a+244|0;if(i<<24>>24==22?(j=f[x>>2]|0,(j|0)>-1):0){q=f[v>>2]|0;f[t>>2]=f[q+(j<<4)>>2];k=f[q+(j<<4)+4>>2]|0;r=d[q+(j<<4)+12>>1]|0;f[w>>2]=f[q+(j<<4)+8>>2];f[x>>2]=j+-1;j=r}else{f[t>>2]=-1;f[w>>2]=0;Xa(a,y,g,c,c);k=c;j=i<<24>>24==17?(g&255)+1&65535:0}i=e+-1|0;g=-1;l=1;m=c;r=c;a:while(1){b:while(1){q=m;n=j;c:while(1){if((q|0)>(e|0))break a;p=q+1|0;if((q|0)>=(e|0)){j=i;while(1){m=b[z+j>>0]|0;if((j|0)<=(c|0))break;if(!(1<<(m&255)&382976))break;else j=j+-1|0}if((m&-2)<<24>>24==20)break a;else{j=h;o=l}}else{j=b[z+q>>0]|0;if(j<<24>>24==7)f[x>>2]=-1;d:do{if(s){switch(j<<24>>24){case 13:{j=1;break d}case 2:break;default:break d}e:do{if((g|0)<=(q|0)){g=p;while(1){if((g|0)>=(e|0)){g=e;l=1;break e}j=b[z+g>>0]|0;switch(j<<24>>24){case 13:case 1:case 0:{l=j;break e}default:{}}g=g+1|0}}}while(0);j=l<<24>>24==13?5:2}}while(0);j=b[66514+(j&255)>>0]|0;o=l}m=n&65535;l=b[(j&255)+(66539+(m<<4))>>0]|0;j=l&31;l=(l&255)>>>5;l=(q|0)==(e|0)&l<<24>>24==0?1:l&255;if(!(l<<16>>16)){l=o;q=p;n=j;continue}switch(l&7){case 2:{l=o;m=p;r=q;continue a}case 4:break b;case 1:{n=36;break c}case 3:{n=37;break c}default:{l=o;q=p;n=j}}}if((n|0)==36){Xa(a,y,b[66539+(m<<4)+15>>0]|0,k,q);l=o;m=p;k=q;continue}else if((n|0)==37){Xa(a,y,b[66539+(m<<4)+15>>0]|0,k,r);Xa(a,y,4,r,q);l=o;m=p;k=q;continue}}Xa(a,y,b[66539+(m<<4)+15>>0]|0,k,r);k=r;l=o;m=p;r=q}j=a+16|0;if((f[j>>2]|0)==(e|0)?(f[a+112>>2]|0)>0:0){s=Ya(a)|0;h=s<<24>>24==4?h:s}while(1){g=b[z+i>>0]|0;if((i|0)<=(c|0))break;if(!(1<<(g&255)&382976))break;else i=i+-1|0}if((g&-2)<<24>>24==20?(f[j>>2]|0)>(e|0):0){z=(f[x>>2]|0)+1|0;f[x>>2]=z;y=f[v>>2]|0;d[y+(z<<4)+12>>1]=n;f[y+(z<<4)+8>>2]=f[w>>2];f[y+(z<<4)+4>>2]=k;f[y+(z<<4)>>2]=f[t>>2]}else Xa(a,y,h,e,e);u=A;return}function Ua(a){a=a|0;var c=0,d=0,e=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;m=f[a+76>>2]|0;o=f[a+80>>2]|0;a:do{if(f[a+124>>2]&8248192|0){i=a+98|0;j=a+97|0;k=a+140|0;l=(b[a+96>>0]|0)!=0;h=a+136|0;a=f[a+132>>2]|0;b:while(1){if((a|0)<=0)break a;while(1){if((a|0)<=0)break;d=a+-1|0;c=b[m+d>>0]|0;if(!(1<<(c&255)&8248192)){a=d;break}e=o+d|0;do{if(l&c<<24>>24==7)a=0;else{if(b[i>>0]|0?(n=f[k>>2]|0,(a|0)>(f[n>>2]|0)):0){a=Na(f[h>>2]|0,n,d)|0;break}a=b[j>>0]|0}}while(0);b[e>>0]=a;a=d}while(1){if((a|0)<=0)continue b;e=a+-1|0;c=b[m+e>>0]|0;d=1<<(c&255);g=o+e|0;if(d&382976|0){b[g>>0]=b[o+a>>0]|0;a=e;continue}if(l&c<<24>>24==7){a=0;break}if(!(d&384))a=e;else{q=17;break}}do{if((q|0)==17){q=0;if(b[i>>0]|0?(p=f[k>>2]|0,(a|0)>(f[p>>2]|0)):0){a=Na(f[h>>2]|0,p,e)|0;break}a=b[j>>0]|0}}while(0);b[g>>0]=a;a=e}}}while(0);return}function Va(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,g=0,h=0,i=0,j=0,k=0,l=0;j=a+332|0;d=f[j>>2]|0;k=a+344|0;l=a+348|0;do{if(!d){d=Rb(80)|0;f[l>>2]=d;if(!d){f[k>>2]=7;break}else{f[j>>2]=10;e=d;h=10;i=d;g=6;break}}else{i=f[l>>2]|0;e=i;h=d;g=6}}while(0);a:do{if((g|0)==6){a=a+336|0;d=f[a>>2]|0;do{if((d|0)>=(h|0)){e=Sb(i,h<<4)|0;f[l>>2]=e;if(!e){f[l>>2]=i;f[k>>2]=7;break a}else{f[j>>2]=f[j>>2]<<1;d=f[a>>2]|0;break}}}while(0);f[e+(d<<3)>>2]=b;f[e+(d<<3)+4>>2]=c;f[a>>2]=(f[a>>2]|0)+1}}while(0);return}function Wa(a){a=a|0;var b=0,c=0,d=0,e=0,g=0,h=0,i=0;e=f[a+100>>2]|0;b=f[a+104>>2]|0;a:while(1){if((b|0)<=0){b=4;g=6;break}d=b+-1|0;c=j[e+(d<<1)>>1]|0;if((b|0)!=1&(c&64512|0)==56320){b=b+-2|0;i=j[e+(b<<1)>>1]|0;h=(i&64512|0)==55296;c=h?c+-56613888+(i<<10)|0:c;b=h?b:d}else b=d;switch(((Za(a,c)|0)&255)<<24>>24){case 0:{b=0;g=6;break a}case 13:case 1:{g=7;break a}case 7:{b=4;break a}default:{}}}if((g|0)!=6)if((g|0)==7)b=1;return b|0}function Xa(a,c,d,e,g){a=a|0;c=c|0;d=d|0;e=e|0;g=g|0;var i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;m=f[c>>2]|0;w=f[c+4>>2]|0;y=a+80|0;z=f[y>>2]|0;x=c+20|0;k=f[x>>2]&255;j=h[(d&255)+(m+(k<<3))>>0]|0;v=j&15;f[x>>2]=v;j=b[w+(j>>>4)>>0]|0;v=b[m+(v<<3)+7>>0]|0;w=c+28|0;x=v&255;a:do{if(!(j<<24>>24))i=e;else{r=c+16|0;p=c+12|0;o=g+-1|0;u=c+8|0;q=d<<24>>24==5;i=e+-1|0;l=a+332|0;s=a+340|0;t=a+336|0;do{switch(j<<24>>24){case 1:{f[u>>2]=e;i=e;break a}case 2:{i=f[u>>2]|0;break a}case 3:{_a(f[a+76>>2]|0,z,f[u>>2]|0,e,(h[w>>0]|0)+1&255);i=e;break a}case 4:{_a(f[a+76>>2]|0,z,f[u>>2]|0,e,(h[w>>0]|0)+2&255);i=e;break a}case 5:{i=f[p>>2]|0;if((i|0)>-1)Va(a,i,1);f[p>>2]=-1;if(f[l>>2]|0?(f[t>>2]|0)>(f[s>>2]|0):0){i=f[r>>2]|0;while(1){i=i+1|0;if((i|0)>=(e|0))break;u=z+i|0;b[u>>0]=(h[u>>0]|0)+254&254}f[s>>2]=f[t>>2];f[r>>2]=-1;if(!q){i=e;break a}Va(a,e,1);f[s>>2]=f[t>>2];i=e;break a}f[r>>2]=-1;if(!(b[m+(k<<3)+7>>0]&1))i=e;else{i=f[u>>2]|0;i=(i|0)>0?i:e}if(!q)break a;Va(a,e,1);f[s>>2]=f[t>>2];break a}case 6:{if((f[l>>2]|0)>0)f[t>>2]=f[s>>2];f[u>>2]=-1;f[p>>2]=-1;f[r>>2]=o;i=e;break a}case 7:{i=f[p>>2]|0;j=(i|0)==-1;if((d<<24>>24==3?(b[(f[a+76>>2]|0)+e>>0]|0)==5:0)?(f[a+88>>2]|0)!=6:0){if(j){f[r>>2]=o;i=e;break a}if((i|0)>-1){Va(a,i,1);f[p>>2]=-2}Va(a,e,1);i=e;break a}if(!j){i=e;break a}f[p>>2]=e;i=e;break a}case 8:{f[r>>2]=o;f[u>>2]=-1;i=e;break a}case 9:{while(1){if((i|0)<=-1)break;if(b[z+i>>0]&1){n=37;break}i=i+-1|0}if((n|0)==37){Va(a,i,4);f[s>>2]=f[t>>2]}f[u>>2]=e;i=e;break a}case 10:{Va(a,e,1);Va(a,e,2);i=e;break a}case 11:{f[t>>2]=f[s>>2];if(!q){i=e;break a}Va(a,e,4);f[s>>2]=f[t>>2];i=e;break a}case 12:{l=(h[w>>0]|0)+x|0;k=l&255;l=l&255;i=f[u>>2]|0;while(1){if((i|0)>=(e|0))break;j=z+i|0;if((h[j>>0]|0)>>>0<l>>>0)b[j>>0]=k;i=i+1|0}f[s>>2]=f[t>>2];f[u>>2]=e;i=e;break a}case 13:{l=b[w>>0]|0;d=l&255;m=d+3|0;n=d+2|0;d=d+1&255;while(1){if((i|0)<(f[u>>2]|0)){i=e;break a}j=b[z+i>>0]|0;b:do{if((j&255|0)==(m|0)){while(1){if((j&255|0)!=(m|0))break;j=i+-1|0;b[z+i>>0]=d;i=j;j=b[z+j>>0]|0}while(1){k=i+-1|0;if(j<<24>>24!=l<<24>>24)break b;i=k;j=b[z+k>>0]|0}}}while(0);b[z+i>>0]=(j&255|0)==(n|0)?l:d;i=i+-1|0}}case 14:{l=(h[w>>0]|0)+1&255;while(1){if((i|0)<(f[u>>2]|0)){i=e;break a}j=z+i|0;k=h[j>>0]|0;if(k>>>0>l>>>0)b[j>>0]=k+254;i=i+-1|0}}default:{i=e;break a}}}while(0)}}while(0);c:do{if(v<<24>>24!=0|(i|0)<(e|0)){j=(h[w>>0]|0)+x&255;if((i|0)<(f[c+24>>2]|0)){_a(f[a+76>>2]|0,f[y>>2]|0,i,g,j);break}while(1){if((i|0)>=(g|0))break c;b[z+i>>0]=j;i=i+1|0}}}while(0);return}function Ya(a){a=a|0;var b=0,c=0,d=0,e=0,g=0,h=0,i=0,k=0;e=f[a+108>>2]|0;g=f[a+112>>2]|0;b=0;a:while(1){if((b|0)>=(g|0)){b=4;h=6;break}d=b+1|0;c=j[e+(b<<1)>>1]|0;if((d|0)==(g|0)|(c&64512|0)!=55296)b=d;else{k=j[e+(d<<1)>>1]|0;i=(k&64512|0)==56320;c=i?(c<<10)+-56613888+k|0:c;b=i?b+2|0:d}switch(((Za(a,c)|0)&255)<<24>>24){case 0:{b=0;h=6;break a}case 13:case 1:{h=7;break a}case 2:{h=8;break a}case 5:{b=3;break a}default:{}}}if((h|0)!=6)if((h|0)==7)b=1;else if((h|0)==8)b=2;return b|0}function Za(a,b){a=a|0;b=b|0;var c=0,d=0;d=f[a+356>>2]|0;if(!((d|0)!=0?(c=wa[d&0](f[a+360>>2]|0,b)|0,(c|0)!=23):0))c=Zb(f[a+4>>2]|0,b)|0;return(c>>>0>22?10:c)|0}function _a(a,c,d,e,f){a=a|0;c=c|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;g=0;while(1){if((d|0)>=(e|0))break;h=b[a+d>>0]|0;g=((h<<24>>24==22)<<31>>31)+g|0;if(!g)b[c+d>>0]=f;d=d+1|0;g=g+((h&-2)<<24>>24==20&1)|0}return}function $a(a){a=a|0;if((a&2154498|0)==0?(a&32|0)==0|(a&8249304|0)==0:0)a=0;else a=(a&26220581|0)==0?1:2;return a|0}function ab(a,c){a=a|0;c=c|0;var e=0,g=0,h=0,i=0;f[c>>2]=a;f[c+492>>2]=0;d[c+500>>1]=0;d[c+502>>1]=0;g=a+97|0;h=c+504|0;if((b[a+98>>0]|0)!=0?(e=f[a+140>>2]|0,(f[e>>2]|0)<=0):0){g=f[a+136>>2]|0;i=Na(g,e,0)|0;b[h>>0]=i;e=Na(g,e,0)|0}else{e=b[g>>0]|0;b[h>>0]=e}e=e&1;f[c+508>>2]=e&255;b[c+506>>0]=e;b[c+505>>0]=e;f[c+496>>2]=0;e=f[a+56>>2]|0;g=c+484|0;if(!e){f[g>>2]=c+4;e=20}else{f[g>>2]=e;e=((f[a+32>>2]|0)>>>0)/24|0}f[c+488>>2]=e;i=f[a+88>>2]|0;b[c+2528>>0]=((i|0)==1|(i|0)==6)&1;return}function bb(a,c){a=a|0;c=c|0;f[a+492>>2]=0;d[a+502>>1]=0;b[a+504>>0]=c;c=c&1;f[a+508>>2]=c&255;b[a+506>>0]=c;b[a+505>>0]=c;f[a+496>>2]=0;return}function cb(a,c){a=a|0;c=c|0;var e=0,g=0,i=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;s=f[a+492>>2]|0;l=f[a>>2]|0;q=(f[l+76>>2]|0)+c|0;e=b[q>>0]|0;r=a+496+(s<<4)+12|0;n=a+496+(s<<4)+10|0;w=a+484|0;p=a+496+(s<<4)+9|0;t=a+496+(s<<4)+6|0;v=a+496+(s<<4)+4|0;s=a+496+(s<<4)|0;a:do{if(e<<24>>24==10){g=d[(f[l+8>>2]|0)+(c<<1)>>1]|0;i=j[v>>1]|0;k=g&65535;o=j[t>>1]|0;while(1){x=o;o=o+-1|0;if((x|0)<=(i|0))break;if((f[(f[w>>2]|0)+(o*24|0)+4>>2]|0)==(k|0)){u=5;break}}if((u|0)==5){g=gb(a,o,c)|0;if(g<<24>>24==10){u=19;break}b[n>>0]=10;f[r>>2]=g&255;f[s>>2]=c;e=f[(f[a>>2]|0)+80>>2]|0;i=e+c|0;g=h[i>>0]|0;if(g&128){g=g&1;b[p>>0]=g;g=1<<g;e=j[v>>1]|0;while(1){if((e|0)>=(o|0))break;x=(f[w>>2]|0)+(e*24|0)+12|0;d[x>>1]=j[x>>1]|g;e=e+1|0}b[i>>0]=b[i>>0]&127;e=f[(f[a>>2]|0)+80>>2]|0}e=e+(f[(f[w>>2]|0)+(o*24|0)>>2]|0)|0;b[e>>0]=b[e>>0]&127;e=1;break}if((g<<16>>16!=0?(m=(dc(k)|0)&65535,m<<16>>16!=g<<16>>16):0)?(ac(f[l+4>>2]|0,k)|0)==1:0){b:do{if(m<<16>>16<12297){switch(m<<16>>16){case 9002:break;default:break b}if(!((hb(a,12297,c)|0)<<24>>24)){e=0;break a}}else{switch(m<<16>>16){case 12297:break;default:break b}if(!((hb(a,9002,c)|0)<<24>>24)){e=0;break a}}}while(0);if(!((hb(a,m,c)|0)<<24>>24))e=0;else u=19}else u=19}else u=19}while(0);c:do{if((u|0)==19){g=h[(f[(f[a>>2]|0)+80>>2]|0)+c>>0]|0;d:do{if(!(g&128))switch(e<<24>>24){case 0:case 1:case 13:{u=e<<24>>24!=0;b[n>>0]=e;b[p>>0]=e;f[r>>2]=u&1;f[s>>2]=c;e=u&1;u=34;break d}case 2:{b[n>>0]=2;g=b[p>>0]|0;if(!(g<<24>>24))if(!(b[a+2528>>0]|0)){e=0;i=23;g=0;u=28}else{e=0;g=0}else{e=1;i=g<<24>>24==13?5:24;g=1;u=28}if((u|0)==28)b[q>>0]=i;f[r>>2]=g;f[s>>2]=c;u=34;break d}case 5:{b[n>>0]=5;f[r>>2]=1;f[s>>2]=c;e=1;break d}case 17:{e=b[n>>0]|0;if(e<<24>>24!=10){u=34;break d}b[q>>0]=10;e=1;break c}default:{b[n>>0]=e;u=34;break d}}else{g=g&1;i=g&255;if((e+-8&255)>=3)b[q>>0]=i;b[n>>0]=i;b[p>>0]=i;f[r>>2]=g;f[s>>2]=c;e=i;u=34}}while(0);if((u|0)==34)switch(e<<24>>24){case 0:case 1:case 13:break;default:{e=1;break c}}k=1<<(e<<24>>24!=0&1);i=j[t>>1]|0;e=j[v>>1]|0;while(1){if((e|0)>=(i|0)){e=1;break c}g=f[w>>2]|0;if((f[g+(e*24|0)>>2]|0)<(c|0)){x=g+(e*24|0)+12|0;d[x>>1]=j[x>>1]|k}e=e+1|0}}}while(0);return e|0}function db(a,c,e,g){a=a|0;c=c|0;e=e|0;g=g|0;var i=0;i=f[a+492>>2]|0;if(!(1<<(h[(f[(f[a>>2]|0)+76>>2]|0)+c>>0]|0)&7864320)){d[a+496+(i<<4)+6>>1]=d[a+496+(i<<4)+4>>1]|0;b[a+496+(i<<4)+8>>0]=g;g=((g&127)>(e&127)?g:e)&1;f[a+496+(i<<4)+12>>2]=g&255;b[a+496+(i<<4)+10>>0]=g;b[a+496+(i<<4)+9>>0]=g;f[a+496+(i<<4)>>2]=c}return}function eb(a,c){a=a|0;c=c|0;var e=0,g=0,h=0;g=a+492|0;h=f[g>>2]|0;e=a+496+(h<<4)|0;b[a+496+(h<<4)+10>>0]=10;a=d[a+496+(h<<4)+6>>1]|0;f[g>>2]=h+1;d[e+22>>1]=a;d[e+20>>1]=a;b[e+24>>0]=c;c=c&1;f[e+28>>2]=c&255;b[e+26>>0]=c;b[e+25>>0]=c;f[e+16>>2]=0;return}function fb(a){a=a|0;var c=0,d=0;d=a+492|0;c=(f[d>>2]|0)+-1|0;f[d>>2]=c;b[a+496+(c<<4)+10>>0]=10;return}function gb(a,c,e){a=a|0;c=c|0;e=e|0;var g=0,h=0,i=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;p=f[a+492>>2]|0;q=a+484|0;o=f[q>>2]|0;g=b[a+496+(p<<4)+8>>0]&1;h=g&255;k=a+496+(p<<4)+4|0;p=a+496+(p<<4)+6|0;m=c&65535;i=j[o+(c*24|0)+12>>1]|0;do{if(g<<24>>24!=0|(i&1|0)==0)if(g<<24>>24==0|(i&2|0)==0)if(!(i&3)){d[p>>1]=m;g=10;break}else{i=f[o+(c*24|0)+16>>2]|0;g=(h|0)==(i|0)?g:i&255;i=(j[k>>1]|0|0)!=(c|0);l=6;break}else{i=0;l=6}else{g=0;i=0;l=6}}while(0);a:do{if((l|0)==6){n=o+(c*24|0)|0;b[(f[(f[a>>2]|0)+76>>2]|0)+(f[n>>2]|0)>>0]=g;b[(f[(f[a>>2]|0)+76>>2]|0)+e>>0]=g;ib(a,c,f[n>>2]|0,g);h=d[k>>1]|0;l=h&65535;if(!i){c=m;while(1){d[p>>1]=c;if((c&65535)<=(h&65535))break a;if((f[(f[q>>2]|0)+(((c&65535)+-1|0)*24|0)>>2]|0)==(f[n>>2]|0))c=c+-1<<16>>16;else break a}}a=c;k=0-e|0;h=o+(c*24|0)+4|0;while(1){f[h>>2]=k;h=a+-1|0;if((a|0)<=(l|0))break;i=f[q>>2]|0;if((f[i+(h*24|0)>>2]|0)!=(f[n>>2]|0))break;a=h;k=0;h=i+(h*24|0)+4|0}i=j[p>>1]|0;while(1){c=c+1|0;if((c|0)>=(i|0))break a;h=f[q>>2]|0;if((f[h+(c*24|0)>>2]|0)>=(e|0))break a;h=h+(c*24|0)+4|0;if((f[h>>2]|0)<=0)continue;f[h>>2]=0}}}while(0);return g|0}function hb(a,b,c){a=a|0;b=b|0;c=c|0;var e=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0;k=f[a+492>>2]|0;l=a+496+(k<<4)+6|0;g=d[l>>1]|0;e=g&65535;i=a+488|0;j=a+484|0;if((e|0)>=(f[i>>2]|0)){h=f[a>>2]|0;g=h+56|0;h=h+32|0;if(!((La(g,h,1,e*48|0)|0)<<24>>24))e=0;else{e=f[j>>2]|0;if((e|0)==(a+4|0))Jc(f[g>>2]|0,e|0,480)|0;e=f[g>>2]|0;f[j>>2]=e;f[i>>2]=((f[h>>2]|0)>>>0)/24|0;g=d[l>>1]|0;m=7}}else{e=f[j>>2]|0;m=7}if((m|0)==7){m=g&65535;f[e+(m*24|0)>>2]=c;f[e+(m*24|0)+4>>2]=b&65535;f[e+(m*24|0)+16>>2]=f[a+496+(k<<4)+12>>2];f[e+(m*24|0)+8>>2]=f[a+496+(k<<4)>>2];d[e+(m*24|0)+12>>1]=0;d[l>>1]=g+1<<16>>16;e=1}return e|0}function ib(a,c,d,e){a=a|0;c=c|0;d=d|0;e=e|0;var g=0,h=0,i=0,k=0,l=0,m=0,n=0;m=f[(f[a>>2]|0)+76>>2]|0;g=c+1|0;h=e&255;i=a+496+(f[a+492>>2]<<4)+6|0;c=(f[a+484>>2]|0)+(g*24|0)|0;while(1){if((g|0)>=(j[i>>1]|0|0))break;k=c+4|0;if((f[k>>2]|0)<=-1){if((f[c+8>>2]|0)>(d|0))break;l=f[c>>2]|0;if((l|0)>(d|0)){if((h|0)==(f[c+16>>2]|0))break;b[m+l>>0]=e;n=0-(f[k>>2]|0)|0;b[m+n>>0]=e;f[k>>2]=0;ib(a,g,l,e);ib(a,g,n,e)}}c=c+24|0;g=g+1|0}return}function jb(a){a=a|0;var b=0,c=0,d=0,e=0,g=0,h=0,i=0,k=0;g=f[a+100>>2]|0;h=f[a+104>>2]|0;c=0;e=10;a:while(1){if((c|0)>=(h|0))break;d=c+1|0;b=j[g+(c<<1)>>1]|0;if((d|0)==(h|0)|(b&64512|0)!=55296)c=d;else{k=j[g+(d<<1)>>1]|0;i=(k&64512|0)==56320;b=i?(b<<10)+-56613888+k|0:b;c=i?c+2|0:d}b=Za(a,b)|0;d=b&255;if(e<<24>>24!=10){e=(b&255|0)==7?10:e;continue}switch(d<<24>>24){case 13:case 1:case 0:break;default:{e=10;continue a}}e=d}return e|0}function kb(a){a=a|0;var b=0,c=0,d=0,e=0,g=0;c=f[a+136>>2]|0;d=a+140|0;b=f[d>>2]|0;e=a+60|0;g=a+36|0;if((b|0)==(a+144|0))if((c|0)>=11)if(!((La(e,g,1,160)|0)<<24>>24))b=0;else{c=f[e>>2]|0;f[d>>2]=c;a=c+80|0;do{f[c>>2]=f[b>>2];c=c+4|0;b=b+4|0}while((c|0)<(a|0));b=1}else b=1;else if(!((La(e,g,1,c<<4)|0)<<24>>24))b=0;else{f[d>>2]=f[e>>2];b=1}return b|0}function lb(a){a=a|0;var b=0;do{if(!a)a=0;else{b=f[a>>2]|0;if((b|0)!=(a|0)){if(!b){a=0;break}if((f[b>>2]|0)!=(b|0)){a=0;break}}a=f[a+16>>2]|0}}while(0);return a|0}function mb(a){a=a|0;var b=0;do{if(!a)a=0;else{b=f[a>>2]|0;if((b|0)!=(a|0)){if(!b){a=0;break}if((f[b>>2]|0)!=(b|0)){a=0;break}}a=f[a+136>>2]|0}}while(0);return a|0}function nb(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0;a:do{if(d|0?(f[d>>2]|0)<=0:0){do{if(a|0){e=f[a>>2]|0;if((e|0)!=(a|0)){if(!e)break;if((f[e>>2]|0)!=(e|0))break}if((b|0)>=0?(f[a+136>>2]|0)>(b|0):0){if(!c)break a;f[c>>2]=f[(f[e+140>>2]|0)+(b<<3)>>2];break a}f[d>>2]=1;break a}}while(0);f[d>>2]=27}}while(0);return}function ob(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;a:do{if((c|0)!=0?(f[c>>2]|0)<=0:0){do{if(a|0){e=f[a>>2]|0;if((e|0)!=(a|0)){if(!e)break;if((f[e>>2]|0)!=(e|0))break}if((b|0)>=0?(f[e+16>>2]|0)>(b|0):0){d=f[e+140>>2]|0;a=0;while(1)if((f[d+(a<<3)>>2]|0)>(b|0))break;else a=a+1|0;nb(e,a,0,c);break a}f[c>>2]=1;a=-1;break a}}while(0);f[c>>2]=27;a=-1}else a=-1}while(0);return a|0}function pb(a,b,c,e,g,h){a=a|0;b=b|0;c=c|0;e=e|0;g=g|0;h=h|0;var i=0,k=0,l=0,m=0,n=0,o=0,p=0;l=g&65535;g=(e|0)<(b|0);a:do{switch(l&11){case 0:{if(g){f[h>>2]=15;g=b;break a}else{k=b;g=c}while(1){i=k+-1|0;c=k+-2|0;if((k|0)>1?(d[a+(i<<1)>>1]&-1024)<<16>>16==-9216:0)i=(d[a+(c<<1)>>1]&-1024)<<16>>16==-10240?c:i;c=i;do{o=c;c=c+1|0;p=g;g=g+2|0;d[p>>1]=d[a+(o<<1)>>1]|0}while((c|0)<(k|0));if((i|0)>0)k=i;else{g=b;break}}break}case 1:{if(g){f[h>>2]=15;g=b;break a}else{h=b;e=c}while(1){c=h;while(1){i=c+-1|0;g=j[a+(i<<1)>>1]|0;if((c|0)>1&(g&64512|0)==56320){c=c+-2|0;o=j[a+(c<<1)>>1]|0;p=(o&64512|0)==55296;g=p?g+-56613888+(o<<10)|0:g;c=p?c:i}else c=i;if((c|0)<=0){k=0;break}if(!(1<<((Yb(g)|0)<<24>>24)&448)){k=1;break}}i=c;g=e;do{o=i;i=i+1|0;p=g;g=g+2|0;d[p>>1]=d[a+(o<<1)>>1]|0}while((i|0)<(h|0));if(k){h=c;e=g}else{g=b;break}}break}default:{o=(l&8|0)!=0;if(o){i=a;k=b;g=0;while(1){n=i;i=i+2|0;n=j[n>>1]|0;g=((((n+-8294|0)>>>0<4|((n&65532|0)==8204|(n+-8234|0)>>>0<5))^1)&1)+g|0;if((k|0)<=1)break;else k=k+-1|0}a=i+(0-b<<1)|0}else g=b;if((g|0)>(e|0)){f[h>>2]=15;break a}n=(l&1|0)!=0;m=(l&2|0)==0;l=b;while(1){k=l+-1|0;i=j[a+(k<<1)>>1]|0;if((l|0)>1&(i&64512|0)==56320){b=l+-2|0;e=j[a+(b<<1)>>1]|0;h=(e&64512|0)==55296;i=h?i+-56613888+(e<<10)|0:i;k=h?b:k}b:do{if(n&(k|0)>0)do{if(!(1<<((Yb(i)|0)<<24>>24)&448))break b;e=k+-1|0;i=j[a+(e<<1)>>1]|0;if((k|0)>1&(i&64512|0)==56320){k=k+-2|0;h=j[a+(k<<1)>>1]|0;b=(h&64512|0)==55296;i=b?i+-56613888+(h<<10)|0:i;k=b?k:e}else k=e}while((k|0)>0)}while(0);if(o){if((i&-4|0)!=8204)switch(i|0){case 8234:case 8235:case 8236:case 8237:case 8238:case 8294:case 8295:case 8296:case 8297:break;default:p=35}}else p=35;c:do{if((p|0)==35){p=0;if(m)i=k;else{i=cc(i)|0;if(i>>>0<65536){h=1;e=c}else{d[c>>1]=(i>>>10)+55232;h=2;i=i&1023|56320;e=c+2|0}d[e>>1]=i;i=h+k|0;c=c+(h<<1)|0}while(1){if((i|0)>=(l|0))break c;d[c>>1]=d[a+(i<<1)>>1]|0;i=i+1|0;c=c+2|0}}}while(0);if((k|0)>0)l=k;else break}}}}while(0);return g|0}function qb(a,c,e,g,i){a=a|0;c=c|0;e=e|0;g=g|0;i=i|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;C=u;u=u+16|0;A=C+4|0;B=C;a:do{if((i|0)!=0?(f[i>>2]|0)<=0:0){if(((a|0?(z=f[a+8>>2]|0,z|0):0)?(j=f[a+16>>2]|0,(j|e|0)>=0):0)?(k=(c|0)==0,!(k&(e|0)>0)):0){do{if(!k){if(!(z>>>0>=c>>>0&z>>>0<(c+(e<<1)|0)>>>0)){if(z>>>0>c>>>0)break;if((z+(f[a+12>>2]<<1)|0)>>>0<=c>>>0)break}f[i>>2]=1;j=0;break a}}while(0);if(!j){Wb(c,e,0,i)|0;j=0;break}w=vb(a,i)|0;if((f[i>>2]|0)>0){j=0;break}v=f[a+92>>2]|0;x=g&-13;x=(v&2|0)==0?(v&1|0)==0?g:x|4:x|8;x=((f[a+88>>2]|0)+-3|0)>>>0<4?x:x&-5;v=x&65535;j=(v&4|0)!=0;k=a+76|0;y=v&65533;b:do{if(!(v&16)){if(!j){l=c;j=e;m=0;while(1){if((m|0)>=(w|0))break b;v=(Ab(a,m,A,B)|0)==0;k=z+(f[A>>2]<<1)|0;g=f[B>>2]|0;if(v)k=rb(k,g,l,j,y,i)|0;else k=pb(k,g,l,j,x,i)|0;f[B>>2]=k;l=(l|0)==0?0:l+(k<<1)|0;j=j-k|0;m=m+1|0}}s=f[k>>2]|0;t=a+228|0;v=a+84|0;j=e;r=0;k=c;while(1){if((r|0)>=(w|0))break b;D=Ab(a,r,A,B)|0;l=f[A>>2]|0;q=z+(l<<1)|0;g=f[(f[t>>2]|0)+(r*12|0)+8>>2]|0;g=(g|0)>0?g:0;m=(b[v>>0]|0)!=0;o=j+-1|0;p=k+2|0;n=(j|0)<1;do{if(!D){if(m)g=(b[s+l>>0]|0)!=0|g;l=(g&1|0)==0?(g&4|0)==0?0:8207:8206;m=l<<16>>16==0;if(n|m)j=m?j:o;else{d[k>>1]=l;j=o;k=p}l=rb(q,f[B>>2]|0,k,j,y,i)|0;f[B>>2]=l;k=(k|0)==0?0:k+(l<<1)|0;j=j-l|0;if(b[v>>0]|0)g=(b[s+(l+-1+(f[A>>2]|0))>>0]|0)==0?g:g|2;if(!(g&10))break;if((j|0)>0){d[k>>1]=8207-((g&2)>>>1)<<16>>16;k=k+2|0}j=j+-1|0}else{if(m)g=(1<<h[s+(l+-1+(f[B>>2]|0))>>0]&8194|0)==0?g|4:g;l=(g&1|0)==0?(g&4|0)==0?0:8207:8206;m=l<<16>>16==0;if(n|m)j=m?j:o;else{d[k>>1]=l;j=o;k=p}D=pb(q,f[B>>2]|0,k,j,x,i)|0;f[B>>2]=D;k=(k|0)==0?0:k+(D<<1)|0;j=j-D|0;if(b[v>>0]|0)g=(1<<h[s+(f[A>>2]|0)>>0]&8194|0)==0?g|8:g;if(!(g&10))break;if((j|0)>0){d[k>>1]=8207-((g&2)>>>1)<<16>>16;k=k+2|0}j=j+-1|0}}while(0);r=r+1|0}}else{if(!j){m=c;k=w;j=e;while(1){l=k+-1|0;if((k|0)<=0)break b;D=(Ab(a,l,A,B)|0)==0;k=z+(f[A>>2]<<1)|0;g=f[B>>2]|0;if(D)g=pb(k,g,m,j,y,i)|0;else g=rb(k,g,m,j,x,i)|0;f[B>>2]=g;m=(m|0)==0?0:m+(g<<1)|0;k=l;j=j-g|0}}r=f[k>>2]|0;k=c;g=w;j=e;while(1){q=g+-1|0;if((g|0)<=0)break b;D=Ab(a,q,A,B)|0;g=f[A>>2]|0;p=z+(g<<1)|0;m=k+2|0;o=j+-1|0;l=(j|0)<1;if(!D){n=f[B>>2]|0;g=(b[r+(g+-1+n)>>0]|0)==0;if(l|g)j=g?j:o;else{d[k>>1]=8206;k=m;j=o}D=pb(p,n,k,j,y,i)|0;f[B>>2]=D;k=(k|0)==0?0:k+(D<<1)|0;j=j-D|0;if(!(b[r+(f[A>>2]|0)>>0]|0)){g=q;continue}if((j|0)>0){d[k>>1]=8206;k=k+2|0}g=q;j=j+-1|0;continue}else{g=(1<<h[r+g>>0]&8194|0)!=0;if(l|g)j=g?j:o;else{d[k>>1]=8207;k=m;j=o}D=rb(p,f[B>>2]|0,k,j,x,i)|0;f[B>>2]=D;k=(k|0)==0?0:k+(D<<1)|0;j=j-D|0;if(1<<h[r+(D+-1+(f[A>>2]|0))>>0]&8194|0){g=q;continue}if((j|0)>0){d[k>>1]=8207;k=k+2|0}g=q;j=j+-1|0;continue}}}}while(0);j=Wb(c,e,e-j|0,i)|0;break}f[i>>2]=1;j=0}else j=0}while(0);u=C;return j|0}function rb(a,b,c,e,g,h){a=a|0;b=b|0;c=c|0;e=e|0;g=g|0;h=h|0;var i=0,k=0,l=0,m=0;i=(e|0)<(b|0);a:do{switch(g&10){case 0:{if(i){f[h>>2]=15;g=b;break a}else{i=b;g=c;while(1){d[g>>1]=d[a>>1]|0;if((i|0)>1){a=a+2|0;i=i+-1|0;g=g+2|0}else{g=b;break}}}break}case 2:{if(i){f[h>>2]=15;g=b;break a}else{l=0;i=0}do{k=i+1|0;g=j[a+(i<<1)>>1]|0;if((k|0)==(b|0)|(g&64512|0)!=55296)i=k;else{h=j[a+(k<<1)>>1]|0;e=(h&64512|0)==56320;g=e?(g<<10)+-56613888+h|0:g;i=e?i+2|0:k}k=cc(g)|0;m=l+1|0;g=c+(l<<1)|0;if(k>>>0<65536)l=m;else{d[g>>1]=(k>>>10)+55232;l=l+2|0;k=k&1023|56320;g=c+(m<<1)|0}d[g>>1]=k}while((i|0)<(b|0));g=b;break}case 8:{l=e;i=b;b:while(1){k=a;a=a+2|0;k=d[k>>1]|0;c:do{if((k&-4)<<16>>16==8204)g=l;else{switch(k<<16>>16){case 8234:case 8235:case 8236:case 8237:case 8238:case 8294:case 8295:case 8296:case 8297:{g=l;break c}default:{}}g=l+-1|0;if((l|0)<1){m=15;break b}d[c>>1]=k;c=c+2|0}}while(0);if((i|0)<=1)break;else{l=g;i=i+-1|0}}d:do{if((m|0)==15){f[h>>2]=15;while(1){if((i|0)<=1)break d;h=j[a>>1]|0;g=((((h+-8294|0)>>>0<4|((h&65532|0)==8204|(h+-8234|0)>>>0<5))^1)<<31>>31)+g|0;i=i+-1|0;a=a+2|0}}}while(0);g=e-g|0;break}default:{g=0;i=e;e:while(1){k=j[a>>1]|0;if((b|0)==1|(k&64512|0)!=55296)l=1;else{m=j[a+2>>1]|0;l=(m&64512|0)==56320;k=l?(k<<10)+-56613888+m|0:k;l=l?2:1}a=a+(l<<1)|0;b=b-l|0;f:do{if((k&-4|0)!=8204){switch(k|0){case 8234:case 8235:case 8236:case 8237:case 8238:case 8294:case 8295:case 8296:case 8297:break f;default:{}}i=i-l|0;if((i|0)<0)break e;l=cc(k)|0;m=g+1|0;k=c+(g<<1)|0;if(l>>>0<65536)g=m;else{d[k>>1]=(l>>>10)+55232;g=g+2|0;l=l&1023|56320;k=c+(m<<1)|0}d[k>>1]=l}}while(0);if((b|0)<=0)break a}f[h>>2]=15;g=b;while(1){if((g|0)<=0)break;h=j[a>>1]|0;i=((((h+-8294|0)>>>0<4|((h&65532|0)==8204|(h+-8234|0)>>>0<5))^1)<<31>>31)+i|0;g=g+-1|0;a=a+2|0}g=e-i|0}}}while(0);return g|0}function sb(a,c,e,g,i){a=a|0;c=c|0;e=e|0;g=g|0;i=i|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;do{if(i|0?(f[i>>2]|0)<=0:0){if(a|0?(f[a>>2]|0)==(a|0):0){if(!((c|0)>-1&(e|0)>(c|0))){f[i>>2]=1;break}if((e|0)>=0?(f[a+16>>2]|0)>=(e|0):0){if(!g){f[i>>2]=1;break}p=ob(a,c,i)|0;if((p|0)!=(ob(a,e+-1|0,i)|0)){f[i>>2]=1;break}f[g>>2]=0;m=a+8|0;f[g+8>>2]=(f[m>>2]|0)+(c<<1);o=e-c|0;f[g+16>>2]=o;f[g+12>>2]=o;n=g+20|0;f[n>>2]=o;if((b[a+98>>0]|0)!=0?(j=f[a+140>>2]|0,(f[j>>2]|0)<=(c|0)):0){p=f[a+136>>2]|0;i=Na(p,j,c)|0;j=p}else{i=b[a+97>>0]|0;j=f[a+136>>2]|0}p=g+97|0;b[p>>0]=i;f[g+136>>2]=j;f[g+228>>2]=0;f[g+124>>2]=0;f[g+88>>2]=f[a+88>>2];f[g+92>>2]=f[a+92>>2];l=g+352|0;f[l>>2]=0;if((f[a+352>>2]|0)>0){k=c;i=0;while(1){if((k|0)>=(e|0))break;j=d[(f[m>>2]|0)+(k<<1)>>1]|0;if((j&-4)<<16>>16==8204)q=23;else switch(j<<16>>16){case 8234:case 8235:case 8236:case 8237:case 8238:case 8294:case 8295:case 8296:case 8297:{q=23;break}default:{}}if((q|0)==23){q=0;i=i+1|0;f[l>>2]=i}k=k+1|0}f[n>>2]=o-i}f[g+76>>2]=(f[a+76>>2]|0)+c;l=(f[a+80>>2]|0)+c|0;f[g+80>>2]=l;f[g+224>>2]=-1;i=f[a+120>>2]|0;m=g+120|0;n=g+132|0;a:do{if((i|0)==2){tb(g);k=f[n>>2]|0;b:do{if(!k)i=b[p>>0]&1;else{i=b[l>>0]&1;if((k|0)<(o|0)?(b[p>>0]&1)!=i<<24>>24:0){i=2;break}else j=1;while(1){if((j|0)==(k|0))break b;if((b[l+j>>0]&1)==i<<24>>24)j=j+1|0;else{i=2;break}}}}while(0);f[m>>2]=i&255;switch(i&3){case 0:{i=(h[p>>0]|0)+1&254;break}case 1:{i=b[p>>0]|1;break}default:break a}b[p>>0]=i;i=0;q=38}else{f[m>>2]=i;i=f[a+132>>2]|0;i=(i|0)>(c|0)?(i|0)<(e|0)?i-c|0:o:0;q=38}}while(0);if((q|0)==38)f[n>>2]=i;f[g>>2]=a;break}f[i>>2]=1;break}f[i>>2]=27}}while(0);return}function tb(a){a=a|0;var c=0,d=0,e=0,g=0,i=0;d=f[a+76>>2]|0;g=f[a+80>>2]|0;c=f[a+16>>2]|0;i=b[a+97>>0]|0;e=a+132|0;a:do{if((b[d+(c+-1)>>0]|0)!=7){while(1){if((c|0)<=0)break;a=c+-1|0;if(!(1<<h[d+a>>0]&8248192))break;else c=a}while(1){if((c|0)<=0)break a;a=c+-1|0;if((b[g+a>>0]|0)==i<<24>>24)c=a;else break}}}while(0);f[e>>2]=c;return}function ub(a,c){a=a|0;c=c|0;var d=0,e=0,g=0,h=0,i=0,j=0;a:do{if((c|0)!=0?(f[c>>2]|0)<=0:0){do{if(a|0){d=f[a>>2]|0;if((d|0)!=(a|0)){if(!d)break;if((f[d>>2]|0)!=(d|0))break}e=f[a+16>>2]|0;if((e|0)<1){f[c>>2]=1;d=0;break a}g=a+132|0;h=f[g>>2]|0;i=a+80|0;if((e|0)==(h|0)){d=f[i>>2]|0;break a}d=a+52|0;if(!((La(d,a+28|0,b[a+72>>0]|0,e)|0)<<24>>24)){f[c>>2]=7;d=0;break a}d=f[d>>2]|0;if((h|0)>0?(j=f[i>>2]|0,(d|0)!=(j|0)):0)Jc(d|0,j|0,h|0)|0;Ic(d+h|0,b[a+97>>0]|0,e-h|0)|0;f[g>>2]=e;f[i>>2]=d;break a}}while(0);f[c>>2]=27;d=0}else d=0}while(0);return d|0}function vb(a,b){a=a|0;b=b|0;var c=0;a:do{if((b|0)!=0?(f[b>>2]|0)<=0:0){do{if(a|0){c=f[a>>2]|0;if((c|0)!=(a|0)){if(!c)break;if((f[c>>2]|0)!=(c|0))break}wb(a,b);if((f[b>>2]|0)>0){a=-1;break a}a=f[a+224>>2]|0;break a}}while(0);f[b>>2]=27;a=-1}else a=-1}while(0);return a|0}function wb(a,c){a=a|0;c=c|0;var e=0,g=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;u=a+224|0;a:do{if((f[u>>2]|0)<=-1){s=a+97|0;v=a+228|0;t=a+16|0;do{if((f[a+120>>2]|0)==2){p=f[t>>2]|0;r=f[a+80>>2]|0;q=f[a+132>>2]|0;e=0;i=0;g=-2;while(1){j=i+1|0;if((e|0)>=(q|0))break;o=b[r+e>>0]|0;e=e+1|0;i=o<<24>>24==g<<24>>24?i:j;g=o}if((p|0)==(q|0)&(i|0)==1){xb(a,b[r>>0]|0);break}m=(p|0)>(q|0);o=m?j:i;e=a+64|0;if(!((La(e,a+40|0,b[a+73>>0]|0,o*12|0)|0)<<24>>24))break a;n=f[e>>2]|0;l=0;e=126;k=0;i=0;while(1){g=b[r+i>>0]|0;e=(g&255)<(e&255)?g:e;k=(g&255)>(k&255)?g:k;j=i;while(1){j=j+1|0;if((j|0)>=(q|0)){g=0;break}if((b[r+j>>0]|0)!=g<<24>>24){g=1;break}}f[n+(l*12|0)>>2]=i;f[n+(l*12|0)+4>>2]=j-i;f[n+(l*12|0)+8>>2]=0;l=l+1|0;if(!g)break;else i=j}if(m){f[n+(l*12|0)>>2]=q;f[n+(l*12|0)+4>>2]=p-q;q=b[s>>0]|0;e=(q&255)<(e&255)?q:e}f[v>>2]=n;f[u>>2]=o;yb(a,e,k);e=0;g=0;while(1){if((g|0)>=(o|0))break;p=n+(g*12|0)|0;q=f[p>>2]|0;f[p>>2]=h[r+q>>0]<<31|q;p=n+(g*12|0)+4|0;q=(f[p>>2]|0)+e|0;f[p>>2]=q;e=q;g=g+1|0}if((l|0)<(o|0)){r=h[s>>0]|0;s=n+((r&1|0?0:l)*12|0)|0;f[s>>2]=r<<31|f[s>>2]}}else xb(a,b[s>>0]|0)}while(0);e=f[a+336>>2]|0;b:do{if((e|0)>0){s=f[a+348>>2]|0;g=s+(e<<3)|0;e=s;while(1){if(e>>>0>=g>>>0)break b;s=zb(f[u>>2]|0,f[v>>2]|0,f[e>>2]|0,c)|0;s=(f[v>>2]|0)+(s*12|0)+8|0;f[s>>2]=f[s>>2]|f[e+4>>2];e=e+8|0}}}while(0);if((f[a+352>>2]|0)>0){e=f[a+8>>2]|0;i=e+(f[t>>2]<<1)|0;j=e;while(1){if(e>>>0>=i>>>0)break a;g=d[e>>1]|0;if((g&-4)<<16>>16==8204)w=31;else switch(g<<16>>16){case 8234:case 8235:case 8236:case 8237:case 8238:case 8294:case 8295:case 8296:case 8297:{w=31;break}default:{}}if((w|0)==31){w=0;t=zb(f[u>>2]|0,f[v>>2]|0,e-j>>1,c)|0;t=(f[v>>2]|0)+(t*12|0)+8|0;f[t>>2]=(f[t>>2]|0)+-1}e=e+2|0}}}}while(0);return}function xb(a,b){a=a|0;b=b|0;var c=0;c=a+232|0;f[a+228>>2]=c;f[a+224>>2]=1;f[c>>2]=(b&255)<<31;f[a+236>>2]=f[a+16>>2];f[a+240>>2]=0;return}function yb(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,g=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;o=u;u=u+16|0;n=o;a:do{if(((b|1)&255)<(c&255)){l=b+1<<24>>24;m=f[a+228>>2]|0;i=f[a+80>>2]|0;j=a+132|0;k=a+16|0;g=(((f[j>>2]|0)<(f[k>>2]|0))<<31>>31)+(f[a+224>>2]|0)|0;b=c;b:while(1){b=b+-1<<24>>24;if((b&255)<(l&255))break;else a=0;while(1){while(1){if((a|0)>=(g|0))continue b;if((h[i+(f[m+(a*12|0)>>2]|0)>>0]|0)>=(b&255)){c=a;break}a=a+1|0}while(1){e=c+1|0;if((e|0)>=(g|0)){d=c;break}if((h[i+(f[m+(e*12|0)>>2]|0)>>0]|0)<(b&255)){d=c;break}else c=e}while(1){if((a|0)>=(d|0))break;q=m+(a*12|0)|0;f[n>>2]=f[q>>2];f[n+4>>2]=f[q+4>>2];f[n+8>>2]=f[q+8>>2];p=m+(d*12|0)|0;f[q>>2]=f[p>>2];f[q+4>>2]=f[p+4>>2];f[q+8>>2]=f[p+8>>2];f[p>>2]=f[n>>2];f[p+4>>2]=f[n+4>>2];f[p+8>>2]=f[n+8>>2];d=d+-1|0;a=a+1|0}if((e|0)==(g|0))continue b;else a=c+2|0}}if(!(l&1)){b=(((f[j>>2]|0)==(f[k>>2]|0))<<31>>31)+g|0;a=0;while(1){if((a|0)>=(b|0))break a;p=m+(a*12|0)|0;f[n>>2]=f[p>>2];f[n+4>>2]=f[p+4>>2];f[n+8>>2]=f[p+8>>2];q=m+(b*12|0)|0;f[p>>2]=f[q>>2];f[p+4>>2]=f[q+4>>2];f[p+8>>2]=f[q+8>>2];f[q>>2]=f[n>>2];f[q+4>>2]=f[n+4>>2];f[q+8>>2]=f[n+8>>2];b=b+-1|0;a=a+1|0}}}}while(0);u=o;return}function zb(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,g=0,h=0,i=0,j=0;g=0;e=0;while(1){if((e|0)>=(a|0)){i=6;break}h=f[b+(e*12|0)+4>>2]|0;j=f[b+(e*12|0)>>2]&2147483647;if((j|0)<=(c|0)?(h-g+j|0)>(c|0):0)break;g=h;e=e+1|0}if((i|0)==6){f[d>>2]=27;e=0}return e|0}function Ab(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,g=0,h=0,i=0;i=u;u=u+16|0;e=i;f[e>>2]=0;do{if(a){g=f[a>>2]|0;if((g|0)!=(a|0)){if(!g){h=5;break}if((f[g>>2]|0)!=(g|0)){h=5;break}}wb(a,e);if((f[e>>2]|0)>0)a=0;else{if((b|0)>=0?(f[a+224>>2]|0)>(b|0):0){a=f[a+228>>2]|0\n;e=f[a+(b*12|0)>>2]|0;if(c|0)f[c>>2]=e&2147483647;if(d|0){if((b|0)>0)a=(f[a+(b*12|0)+4>>2]|0)-(f[a+((b+-1|0)*12|0)+4>>2]|0)|0;else a=f[a+4>>2]|0;f[d>>2]=a}a=e>>>31;break}f[e>>2]=1;a=0}}else h=5}while(0);if((h|0)==5){f[e>>2]=27;a=0}u=i;return a|0}function Bb(a,b,c){a=a|0;b=b|0;c=c|0;var e=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;a:do{if(c|0?(f[c>>2]|0)<=0:0){if(!b){f[c>>2]=1;break}vb(a,c)|0;if((f[c>>2]|0)<1?(p=f[a+228>>2]|0,k=a+224|0,l=p+((f[k>>2]|0)*12|0)|0,m=a+20|0,(f[m>>2]|0)>=1):0){j=p;e=0;c=b;while(1){if(j>>>0>=l>>>0)break;g=f[j>>2]|0;i=f[j+4>>2]|0;if((g|0)>-1)while(1){h=c+4|0;f[c>>2]=g;e=e+1|0;if((e|0)<(i|0)){g=g+1|0;c=h}else{c=h;break}}else{h=i-e+(g&2147483647)|0;while(1){h=h+-1|0;g=c+4|0;f[c>>2]=h;e=e+1|0;if((e|0)>=(i|0)){c=g;break}else c=g}}j=j+12|0}if((f[a+336>>2]|0)>0){e=f[k>>2]|0;g=0;c=0;while(1){if((c|0)>=(e|0))break;o=f[p+(c*12|0)+8>>2]|0;g=((o&5|0)!=0&1)+g+((o&10|0)!=0&1)|0;c=c+1|0}h=f[m>>2]|0;while(1){a=e+-1|0;if(!((e|0)>0&(g|0)>0))break a;m=f[p+(a*12|0)+8>>2]|0;c=h+-1|0;if(!(m&10))c=h;else{f[b+(c<<2)>>2]=-1;g=g+-1|0}if((e|0)>1)l=f[p+((e+-2|0)*12|0)+4>>2]|0;else l=0;k=(g|0)>0;j=f[p+(a*12|0)+4>>2]|0;while(1){e=j+-1|0;h=c+-1|0;i=b+(h<<2)|0;if(!(k&(j|0)>(l|0)))break;f[i>>2]=f[b+(e<<2)>>2];j=e;c=h}if(!(m&5)){h=c;e=a;continue}f[i>>2]=-1;e=a;g=g+-1|0}}if((f[a+352>>2]|0)>0){o=f[k>>2]|0;m=a+8|0;c=0;a=0;e=0;while(1){if((a|0)>=(o|0))break a;n=f[p+(a*12|0)+4>>2]|0;l=n-e|0;g=(f[p+(a*12|0)+8>>2]|0)==0;b:do{if((c|0)==(e|0)&g)c=l+c|0;else{if(g)while(1){if((e|0)>=(n|0))break b;f[b+(c<<2)>>2]=f[b+(e<<2)>>2];e=e+1|0;c=c+1|0}j=f[p+(a*12|0)>>2]|0;i=j&2147483647;j=(j|0)>-1;k=l+-1+i|0;h=0;while(1){if((h|0)>=(l|0))break b;e=j?h+i|0:k-h|0;g=d[(f[m>>2]|0)+(e<<1)>>1]|0;c:do{if((g&-4)<<16>>16!=8204){switch(g<<16>>16){case 8234:case 8235:case 8236:case 8237:case 8238:case 8294:case 8295:case 8296:case 8297:break c;default:{}}f[b+(c<<2)>>2]=e;c=c+1|0}}while(0);h=h+1|0}}}while(0);a=a+1|0;e=n}}}}}while(0);return}function Cb(a,b,c,e,g){a=a|0;b=b|0;c=c|0;e=e|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;o=u;u=u+656|0;j=o+32|0;l=o+56|0;m=o+28|0;n=o+24|0;k=o;if(!g){n=0;u=o;return n|0}if((Db(f[g>>2]|0)|0)<<24>>24){n=0;u=o;return n|0}if(!((a|0)==0|(b|0)<-1)?(h=(c|0)==0,!((e|0)<0|h&(e|0)!=0)):0){if((b|0)==-1)b=Ub(a)|0;if((b|0)<1){Wb(c,e,0,g)|0;n=0;u=o;return n|0}do{if(!h){if(!(a>>>0<=c>>>0&(a+(b<<1)|0)>>>0>c>>>0)?!(c>>>0<=a>>>0&(c+(e<<1)|0)>>>0>a>>>0):0)break;f[g>>2]=1;n=0;u=o;return n|0}}while(0);f[m>>2]=0;f[n>>2]=0;h=Fb(a,b)|0;if((h|0)>(e|0)){f[g>>2]=15;n=h;u=o;return n|0}h=(b|0)>(h|0)?b:h;if((h|0)>=301){i=Rb(h<<1)|0;if(!i){f[g>>2]=7;n=0;u=o;return n|0}}else{i=l;h=300}Vb(i,a,b)|0;if((h|0)>(b|0))Ic(i+(b<<1)|0,0,h-b<<1|0)|0;Gb(i,b,m,n);Hb(i,b,f[m>>2]|0,f[n>>2]|0);d[k>>1]=8203;d[k+2>>1]=0;f[k+4>>2]=3;f[k+8>>2]=2;f[k+12>>2]=262144;f[k+16>>2]=393216;f[k+20>>2]=0;f[j>>2]=f[k>>2];f[j+4>>2]=f[k+4>>2];f[j+8>>2]=f[k+8>>2];f[j+12>>2]=f[k+12>>2];f[j+16>>2]=f[k+16>>2];f[j+20>>2]=f[k+20>>2];b=Ib(i,b,g,j)|0;Gb(i,b,m,n);Hb(i,b,f[m>>2]|0,f[n>>2]|0);Vb(c,i,Qb(b,e)|0)|0;if((i|0)!=(l|0))Tb(i);if((b|0)>(e|0)){f[g>>2]=15;n=b;u=o;return n|0}else{n=Wb(c,e,b,g)|0;u=o;return n|0}}f[g>>2]=1;n=0;u=o;return n|0}function Db(a){a=a|0;return(a|0)>0|0}function Eb(a){a=a|0;var b=0;b=a&65535;if((a+-1570&65535)<178){b=d[1454+(b+-1570<<1)>>1]|0;return b|0}if(a<<16>>16==8205){b=3;return b|0}if((a+-8301&65535)<3){b=4;return b|0}if((a+1200&65535)<275){b=h[67545+(b+-64336)>>0]|0;return b|0}if((a+400&65535)>=141){b=0;return b|0}b=h[67820+(b+-65136)>>0]|0;return b|0}function Fb(a,b){a=a|0;b=b|0;var c=0,e=0,f=0,g=0,h=0;g=b+-1|0;c=0;f=b;a:while(1){do{if((c|0)>=(b|0))break a;e=d[a+(c<<1)>>1]|0;h=c;c=c+1|0;if((h|0)<(g|0)&e<<16>>16==1604?Ob(d[a+(c<<1)>>1]|0)|0:0)break}while(!(Pb(e)|0));f=f+-1|0}return f|0}function Gb(a,b,c,e){a=a|0;b=b|0;c=c|0;e=e|0;var g=0,h=0;h=0;while(1){g=(h|0)<(b|0);if(g&(d[a+(h<<1)>>1]|0)==32)h=h+1|0;else break}if(g)g=0;else{a=0;f[c>>2]=h;f[e>>2]=a;return}while(1){b=b+-1|0;if((d[a+(b<<1)>>1]|0)!=32)break;else g=g+1|0}f[c>>2]=h;f[e>>2]=g;return}function Hb(a,b,c,e){a=a|0;b=b|0;c=c|0;e=e|0;var f=0,g=0;b=b-e|0;while(1){b=b+-1|0;if((c|0)>=(b|0))break;g=a+(c<<1)|0;f=d[g>>1]|0;e=a+(b<<1)|0;d[g>>1]=d[e>>1]|0;d[e>>1]=f;c=c+1|0}return}function Ib(a,b,c,e){a=a|0;b=b|0;c=c|0;e=e|0;var g=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0;B=u;u=u+32|0;z=B;j=0;while(1){if((j|0)>=(b|0))break;k=a+(j<<1)|0;g=d[k>>1]|0;i=g&65535;if((g+1200&65535)<176){g=d[820+(i+-64336<<1)>>1]|0;if(g<<16>>16)A=7}else if((g+400&65535)<141){g=d[1172+(i+-65136<<1)>>1]|0;A=7}else A=7;if((A|0)==7){A=0;d[k>>1]=g}j=j+1|0}w=b+-1|0;y=w;m=0;p=Eb(d[a+(w<<1)>>1]|0)|0;j=0;k=0;q=0;r=0;o=0;i=-2;while(1){if((w|0)==-1)break;n=p&65535;if((n&65280|0)==0?((Eb(d[a+(w<<1)>>1]|0)|0)&4)==0:0){v=m;n=i;g=w}else A=13;do{if((A|0)==13){A=0;g=w+-1|0;v=m;x=i;a:while(1){l=(x|0)<0;i=g;while(1){if(!l)break a;if((i|0)==-1){g=-1;v=0;x=3e3;continue a}m=Eb(d[a+(i<<1)>>1]|0)|0;t=(m&4)==0;g=((t^1)<<31>>31)+i|0;if(t){v=m;x=i;continue a}else i=g}}if((j&16)==0|(n&32|0)==0){s=p;t=o;g=w}else{g=a+(w<<1)|0;i=Kb(d[g>>1]|0)|0;if(!(i<<16>>16))g=w;else{d[g>>1]=-1;d[a+(y<<1)>>1]=i;g=y}s=Eb(i)|0;j=k;t=1}if((g|0)>0){if((d[a+(g+-1<<1)>>1]|0)==32){p=d[a+(g<<1)>>1]|0;w=(Lb(p)|0)==0;q=p<<16>>16==1574&w?1:q;r=w?r:1}}else if(!g){p=d[a>>1]|0;w=(Lb(p)|0)==0;q=p<<16>>16==1574&w?1:q;r=w?r:1}m=v&65535;n=j&65535;p=s&65535;w=p&3;o=h[67473+((m&3)<<4)+((n&3)<<2)+w>>0]|0;if((w|0)!=1){l=a+(g<<1)|0;i=d[l>>1]|0;if(Mb(i)|0)if((n&2|0)==0|(m&1|0)==0|(i&-2)<<16>>16==1612)o=0;else o=n>>>4&1^1|m>>>5&1^1}else{i=a+(g<<1)|0;o=o&1;l=i;i=d[i>>1]|0}if(((i^1536)&65535)<256){if(Mb(i)|0){d[l>>1]=o+65136+(h[67537+((i&65535)+-1611)>>0]|0);p=s;o=t;n=x;break}i=p>>>8;if(p&8|0){d[l>>1]=i+64336+o;p=s;o=t;n=x;break}if((i|0)!=0&(p&4|0)==0){d[l>>1]=i+65136+o;p=s;o=t;n=x}else{p=s;o=t;n=x}}else{p=s;o=t;n=x}}}while(0);i=(p&4)==0;k=i?j:k;j=i?p:j;i=i?g:y;l=g+-1|0;if((l|0)==(n|0)){y=i;m=v;p=v;i=-2;w=l;continue}if(!g){y=i;m=v;i=n;w=l;continue}y=i;m=v;p=Eb(d[a+(l<<1)>>1]|0)|0;i=n;w=l}if(o){f[z>>2]=f[e>>2];f[z+4>>2]=f[e+4>>2];f[z+8>>2]=f[e+8>>2];f[z+12>>2]=f[e+12>>2];f[z+16>>2]=f[e+16>>2];f[z+20>>2]=f[e+20>>2];b=Nb(a,b,b,c,z)|0}if(!(q|r)){A=b;u=B;return A|0}A=Jb(b)|0;u=B;return A|0}function Jb(a){a=a|0;return a|0}function Kb(a){a=a|0;switch(a<<16>>16){case 1570:{a=1628;break}case 1571:{a=1629;break}case 1573:{a=1630;break}case 1575:{a=1631;break}default:a=0}return a|0}function Lb(a){a=a|0;return(a+-1587&65535)<4|0}function Mb(a){a=a|0;return(a+-1611&65535)<8|0}function Nb(a,b,c,e,g){a=a|0;b=b|0;c=c|0;e=e|0;g=g|0;var h=0,i=0,j=0,k=0,l=0,m=0,n=0;m=(b<<1)+2|0;n=Rb(m)|0;if(!n){f[e>>2]=7;n=0;return n|0}Ic(n|0,0,m|0)|0;c=0;h=0;e=0;while(1){if((e|0)>=(b|0))break;i=d[a+(e<<1)>>1]|0;if(i<<16>>16==-1){c=c+1|0;h=h+-1|0}else d[n+(h<<1)>>1]=i;h=h+1|0;e=e+1|0}while(1){if((c|0)<=-1)break;d[n+(e<<1)>>1]=0;e=e+-1|0;c=c+-1|0}Vb(a,n,b)|0;if(f[g+4>>2]|0){c=Ub(a)|0;if(!(f[g+12>>2]|0)){j=1;k=0;l=14}}else{j=(f[g+12>>2]|0)==0;k=1;l=14}if((l|0)==14){Ic(n|0,0,m|0)|0;c=b;e=0;i=b;while(1){if((i|0)<=-1){c=0;break}h=d[a+(i<<1)>>1]|0;if(k&h<<16>>16==-1|j&h<<16>>16==-2){c=c+1|0;e=e+1|0}else d[n+(c<<1)>>1]=h;c=c+-1|0;i=i+-1|0}while(1){if((c|0)>=(e|0))break;d[n+(c<<1)>>1]=32;c=c+1|0}Vb(a,n,b)|0;c=b}k=(f[g+8>>2]|0)==0;g=(f[g+16>>2]|0)==0;j=g|k^1;if(k|g){Ic(n|0,0,m|0)|0;h=0;c=0;e=0;while(1){if((e|0)>=(b|0))break;i=d[a+(e<<1)>>1]|0;if(k&i<<16>>16==-1|j&i<<16>>16==-2){h=h+-1|0;c=c+1|0}else d[n+(h<<1)>>1]=i;h=h+1|0;e=e+1|0}while(1){if((c|0)<=-1)break;d[n+(e<<1)>>1]=32;e=e+-1|0;c=c+-1|0}Vb(a,n,b)|0;c=b}Tb(n);n=c;return n|0}function Ob(a){a=a|0;a=a+-1570<<16>>16;if((a&65535)>=6){a=0;return a|0}a=43>>>(a&63)&1;return a|0}function Pb(a){a=a|0;return(a&-16)<<16>>16==-400|0}function Qb(a,b){a=a|0;b=b|0;return((a|0)>(b|0)?b:a)|0}function Rb(a){a=a|0;if(!a)a=68880;else a=fc(a)|0;return a|0}function Sb(a,b){a=a|0;b=b|0;do{if((a|0)!=68880)if(!b){gc(a);a=68880;break}else{a=hc(a,b)|0;break}else a=Rb(b)|0}while(0);return a|0}function Tb(a){a=a|0;if((a|0)!=68880)gc(a);return}function Ub(a){a=a|0;var b=0;b=a;while(1)if(!(d[b>>1]|0))break;else b=b+2|0;return b-a>>1|0}function Vb(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<=0)return a|0;Jc(a|0,b|0,c<<1|0)|0;return a|0}function Wb(a,b,c,e){a=a|0;b=b|0;c=c|0;e=e|0;if(!e)return c|0;if((c|0)<0|(Xb(f[e>>2]|0)|0)<<24>>24==0)return c|0;if((c|0)>=(b|0)){f[e>>2]=(c|0)==(b|0)?-124:15;return c|0}d[a+(c<<1)>>1]=0;if((f[e>>2]|0)!=-124)return c|0;f[e>>2]=0;return c|0}function Xb(a){a=a|0;return(a|0)<1|0}function Yb(a){a=a|0;var b=0,c=0,e=0;b=a>>5;c=a&31;do{if(a>>>0>=55296){if(a>>>0<65536){b=((a|0)<56320?320:0)+b|0;e=6;break}if(a>>>0>1114111)b=4536;else{b=(j[1810+((a>>>11)+2080<<1)>>1]|0)+(b&63)|0;e=6}}else e=6}while(0);if((e|0)==6)b=((j[1810+(b<<1)>>1]|0)<<2)+c|0;return d[1810+(b<<1)>>1]&31|0}function Zb(a,b){a=a|0;b=b|0;var c=0,e=0,g=0;g=f[a+20>>2]|0;c=b>>5;e=b&31;do{if(b>>>0>=55296){if(b>>>0<65536){a=((j[g+(((b|0)<56320?320:0)+c<<1)>>1]|0)<<2)+e|0;break}if(b>>>0>1114111){a=(f[a+32>>2]|0)+128|0;break}if((f[a+52>>2]|0)>(b|0)){a=((j[g+((j[g+((b>>>11)+2080<<1)>>1]|0)+(c&63)<<1)>>1]|0)<<2)+e|0;break}else{a=f[a+56>>2]|0;break}}else a=((j[g+(c<<1)>>1]|0)<<2)+e|0}while(0);return d[g+(a<<1)>>1]&31|0}function _b(a){a=a|0;var b=0,c=0,e=0;b=a>>5;c=a&31;do{if(a>>>0>=55296){if(a>>>0<65536){b=((a|0)<56320?320:0)+b|0;e=6;break}if(a>>>0>1114111)b=3624;else{b=(j[43370+((a>>>11)+2080<<1)>>1]|0)+(b&63)|0;e=6}}else e=6}while(0);if((e|0)==6)b=((j[43370+(b<<1)>>1]|0)<<2)+c|0;return $b(a,d[43370+(b<<1)>>1]|0)|0}function $b(a,b){a=a|0;b=b|0;var c=0,d=0;b=b<<16>>16>>13;a:do{if((b|0)==-4){b=0;while(1){if((b|0)>=26)break a;c=f[392+(b<<2)>>2]|0;d=c&2097151;if((d|0)==(a|0))break;if((d|0)>(a|0))break a;else b=b+1|0}a=f[392+(c>>>21<<2)>>2]&2097151}else a=b+a|0}while(0);return a|0}function ac(a,b){a=a|0;b=b|0;var c=0,e=0,g=0;g=f[a+20>>2]|0;c=b>>5;e=b&31;do{if(b>>>0>=55296){if(b>>>0<65536){a=((j[g+(((b|0)<56320?320:0)+c<<1)>>1]|0)<<2)+e|0;break}if(b>>>0>1114111){a=(f[a+32>>2]|0)+128|0;break}if((f[a+52>>2]|0)>(b|0)){a=((j[g+((j[g+((b>>>11)+2080<<1)>>1]|0)+(c&63)<<1)>>1]|0)<<2)+e|0;break}else{a=f[a+56>>2]|0;break}}else a=((j[g+(c<<1)>>1]|0)<<2)+e|0}while(0);return(d[g+(a<<1)>>1]&768)>>>8|0}function bc(a){a=a|0;var b=0,c=0,e=0;b=a>>5;c=a&31;do{if(a>>>0>=55296){if(a>>>0<65536){b=((a|0)<56320?320:0)+b|0;e=6;break}if(a>>>0>1114111)b=3624;else{b=(j[43370+((a>>>11)+2080<<1)>>1]|0)+(b&63)|0;e=6}}else e=6}while(0);if((e|0)==6)b=((j[43370+(b<<1)>>1]|0)<<2)+c|0;b=d[43370+(b<<1)>>1]|0;if(b&768)a=$b(a,b)|0;return a|0}function cc(a){a=a|0;return _b(a)|0}function dc(a){a=a|0;return bc(a)|0}function ec(){return 68904}function fc(a){a=a|0;var b=0,c=0,d=0,e=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0;K=u;u=u+16|0;n=K;do{if(a>>>0<245){o=a>>>0<11?16:a+11&-8;a=o>>>3;s=f[17242]|0;c=s>>>a;if(c&3|0){a=(c&1^1)+a|0;c=69008+(a<<1<<2)|0;d=c+8|0;e=f[d>>2]|0;g=e+8|0;h=f[g>>2]|0;do{if((c|0)!=(h|0)){if(h>>>0<(f[17246]|0)>>>0)ja();b=h+12|0;if((f[b>>2]|0)==(e|0)){f[b>>2]=c;f[d>>2]=h;break}else ja()}else f[17242]=s&~(1<<a)}while(0);J=a<<3;f[e+4>>2]=J|3;J=e+J+4|0;f[J>>2]=f[J>>2]|1;J=g;u=K;return J|0}r=f[17244]|0;if(o>>>0>r>>>0){if(c|0){i=2<<a;a=c<<a&(i|0-i);a=(a&0-a)+-1|0;i=a>>>12&16;a=a>>>i;d=a>>>5&8;a=a>>>d;g=a>>>2&4;a=a>>>g;c=a>>>1&2;a=a>>>c;b=a>>>1&1;b=(d|i|g|c|b)+(a>>>b)|0;a=69008+(b<<1<<2)|0;c=a+8|0;g=f[c>>2]|0;i=g+8|0;d=f[i>>2]|0;do{if((a|0)!=(d|0)){if(d>>>0<(f[17246]|0)>>>0)ja();e=d+12|0;if((f[e>>2]|0)==(g|0)){f[e>>2]=a;f[c>>2]=d;j=s;break}else ja()}else{j=s&~(1<<b);f[17242]=j}}while(0);h=(b<<3)-o|0;f[g+4>>2]=o|3;d=g+o|0;f[d+4>>2]=h|1;f[d+h>>2]=h;if(r|0){e=f[17247]|0;b=r>>>3;c=69008+(b<<1<<2)|0;b=1<<b;if(j&b){b=c+8|0;a=f[b>>2]|0;if(a>>>0<(f[17246]|0)>>>0)ja();else{k=a;l=b}}else{f[17242]=j|b;k=c;l=c+8|0}f[l>>2]=e;f[k+12>>2]=e;f[e+8>>2]=k;f[e+12>>2]=c}f[17244]=h;f[17247]=d;J=i;u=K;return J|0}k=f[17243]|0;if(k){a=(k&0-k)+-1|0;I=a>>>12&16;a=a>>>I;H=a>>>5&8;a=a>>>H;J=a>>>2&4;a=a>>>J;c=a>>>1&2;a=a>>>c;b=a>>>1&1;b=f[69272+((H|I|J|c|b)+(a>>>b)<<2)>>2]|0;a=(f[b+4>>2]&-8)-o|0;c=f[b+16+(((f[b+16>>2]|0)==0&1)<<2)>>2]|0;if(!c){j=b;h=a}else{do{I=(f[c+4>>2]&-8)-o|0;J=I>>>0<a>>>0;a=J?I:a;b=J?c:b;c=f[c+16+(((f[c+16>>2]|0)==0&1)<<2)>>2]|0}while((c|0)!=0);j=b;h=a}e=f[17246]|0;if(j>>>0<e>>>0)ja();i=j+o|0;if(j>>>0>=i>>>0)ja();g=f[j+24>>2]|0;c=f[j+12>>2]|0;do{if((c|0)==(j|0)){a=j+20|0;b=f[a>>2]|0;if(!b){a=j+16|0;b=f[a>>2]|0;if(!b){m=0;break}}while(1){c=b+20|0;d=f[c>>2]|0;if(d|0){b=d;a=c;continue}c=b+16|0;d=f[c>>2]|0;if(!d)break;else{b=d;a=c}}if(a>>>0<e>>>0)ja();else{f[a>>2]=0;m=b;break}}else{d=f[j+8>>2]|0;if(d>>>0<e>>>0)ja();b=d+12|0;if((f[b>>2]|0)!=(j|0))ja();a=c+8|0;if((f[a>>2]|0)==(j|0)){f[b>>2]=c;f[a>>2]=d;m=c;break}else ja()}}while(0);a:do{if(g|0){b=f[j+28>>2]|0;a=69272+(b<<2)|0;c=(m|0)==0;do{if((j|0)==(f[a>>2]|0)){f[a>>2]=m;if(c){f[17243]=k&~(1<<b);break a}}else if(g>>>0>=(f[17246]|0)>>>0){f[g+16+(((f[g+16>>2]|0)!=(j|0)&1)<<2)>>2]=m;if(c)break a;else break}else ja()}while(0);a=f[17246]|0;if(m>>>0<a>>>0)ja();f[m+24>>2]=g;b=f[j+16>>2]|0;do{if(b|0)if(b>>>0<a>>>0)ja();else{f[m+16>>2]=b;f[b+24>>2]=m;break}}while(0);b=f[j+20>>2]|0;if(b|0)if(b>>>0<(f[17246]|0)>>>0)ja();else{f[m+20>>2]=b;f[b+24>>2]=m;break}}}while(0);if(h>>>0<16){J=h+o|0;f[j+4>>2]=J|3;J=j+J+4|0;f[J>>2]=f[J>>2]|1}else{f[j+4>>2]=o|3;f[i+4>>2]=h|1;f[i+h>>2]=h;if(r|0){d=f[17247]|0;b=r>>>3;c=69008+(b<<1<<2)|0;b=1<<b;if(b&s){b=c+8|0;a=f[b>>2]|0;if(a>>>0<(f[17246]|0)>>>0)ja();else{p=a;q=b}}else{f[17242]=b|s;p=c;q=c+8|0}f[q>>2]=d;f[p+12>>2]=d;f[d+8>>2]=p;f[d+12>>2]=c}f[17244]=h;f[17247]=i}J=j+8|0;u=K;return J|0}}}else if(a>>>0<=4294967231){a=a+11|0;o=a&-8;k=f[17243]|0;if(k){d=0-o|0;a=a>>>8;if(a)if(o>>>0>16777215)i=31;else{q=(a+1048320|0)>>>16&8;C=a<<q;p=(C+520192|0)>>>16&4;C=C<<p;i=(C+245760|0)>>>16&2;i=14-(p|q|i)+(C<<i>>>15)|0;i=o>>>(i+7|0)&1|i<<1}else i=0;c=f[69272+(i<<2)>>2]|0;b:do{if(!c){c=0;a=0;C=81}else{a=0;h=o<<((i|0)==31?0:25-(i>>>1)|0);g=0;while(1){e=(f[c+4>>2]&-8)-o|0;if(e>>>0<d>>>0)if(!e){a=c;d=0;e=c;C=85;break b}else{a=c;d=e}e=f[c+20>>2]|0;c=f[c+16+(h>>>31<<2)>>2]|0;g=(e|0)==0|(e|0)==(c|0)?g:e;e=(c|0)==0;if(e){c=g;C=81;break}else h=h<<((e^1)&1)}}}while(0);if((C|0)==81){if((c|0)==0&(a|0)==0){a=2<<i;a=(a|0-a)&k;if(!a)break;q=(a&0-a)+-1|0;l=q>>>12&16;q=q>>>l;j=q>>>5&8;q=q>>>j;m=q>>>2&4;q=q>>>m;p=q>>>1&2;q=q>>>p;c=q>>>1&1;a=0;c=f[69272+((j|l|m|p|c)+(q>>>c)<<2)>>2]|0}if(!c){j=a;i=d}else{e=c;C=85}}if((C|0)==85)while(1){C=0;c=(f[e+4>>2]&-8)-o|0;q=c>>>0<d>>>0;c=q?c:d;a=q?e:a;e=f[e+16+(((f[e+16>>2]|0)==0&1)<<2)>>2]|0;if(!e){j=a;i=c;break}else{d=c;C=85}}if((j|0)!=0?i>>>0<((f[17244]|0)-o|0)>>>0:0){e=f[17246]|0;if(j>>>0<e>>>0)ja();h=j+o|0;if(j>>>0>=h>>>0)ja();g=f[j+24>>2]|0;c=f[j+12>>2]|0;do{if((c|0)==(j|0)){a=j+20|0;b=f[a>>2]|0;if(!b){a=j+16|0;b=f[a>>2]|0;if(!b){r=0;break}}while(1){c=b+20|0;d=f[c>>2]|0;if(d|0){b=d;a=c;continue}c=b+16|0;d=f[c>>2]|0;if(!d)break;else{b=d;a=c}}if(a>>>0<e>>>0)ja();else{f[a>>2]=0;r=b;break}}else{d=f[j+8>>2]|0;if(d>>>0<e>>>0)ja();b=d+12|0;if((f[b>>2]|0)!=(j|0))ja();a=c+8|0;if((f[a>>2]|0)==(j|0)){f[b>>2]=c;f[a>>2]=d;r=c;break}else ja()}}while(0);c:do{if(g){b=f[j+28>>2]|0;a=69272+(b<<2)|0;c=(r|0)==0;do{if((j|0)==(f[a>>2]|0)){f[a>>2]=r;if(c){s=k&~(1<<b);f[17243]=s;break c}}else if(g>>>0>=(f[17246]|0)>>>0){f[g+16+(((f[g+16>>2]|0)!=(j|0)&1)<<2)>>2]=r;if(c){s=k;break c}else break}else ja()}while(0);a=f[17246]|0;if(r>>>0<a>>>0)ja();f[r+24>>2]=g;b=f[j+16>>2]|0;do{if(b|0)if(b>>>0<a>>>0)ja();else{f[r+16>>2]=b;f[b+24>>2]=r;break}}while(0);b=f[j+20>>2]|0;if(b)if(b>>>0<(f[17246]|0)>>>0)ja();else{f[r+20>>2]=b;f[b+24>>2]=r;s=k;break}else s=k}else s=k}while(0);do{if(i>>>0>=16){f[j+4>>2]=o|3;f[h+4>>2]=i|1;f[h+i>>2]=i;b=i>>>3;if(i>>>0<256){c=69008+(b<<1<<2)|0;a=f[17242]|0;b=1<<b;if(a&b){b=c+8|0;a=f[b>>2]|0;if(a>>>0<(f[17246]|0)>>>0)ja();else{x=a;y=b}}else{f[17242]=a|b;x=c;y=c+8|0}f[y>>2]=h;f[x+12>>2]=h;f[h+8>>2]=x;f[h+12>>2]=c;break}b=i>>>8;if(b)if(i>>>0>16777215)b=31;else{I=(b+1048320|0)>>>16&8;J=b<<I;H=(J+520192|0)>>>16&4;J=J<<H;b=(J+245760|0)>>>16&2;b=14-(H|I|b)+(J<<b>>>15)|0;b=i>>>(b+7|0)&1|b<<1}else b=0;c=69272+(b<<2)|0;f[h+28>>2]=b;a=h+16|0;f[a+4>>2]=0;f[a>>2]=0;a=1<<b;if(!(a&s)){f[17243]=a|s;f[c>>2]=h;f[h+24>>2]=c;f[h+12>>2]=h;f[h+8>>2]=h;break}a=i<<((b|0)==31?0:25-(b>>>1)|0);d=f[c>>2]|0;while(1){if((f[d+4>>2]&-8|0)==(i|0)){C=139;break}c=d+16+(a>>>31<<2)|0;b=f[c>>2]|0;if(!b){C=136;break}else{a=a<<1;d=b}}if((C|0)==136)if(c>>>0<(f[17246]|0)>>>0)ja();else{f[c>>2]=h;f[h+24>>2]=d;f[h+12>>2]=h;f[h+8>>2]=h;break}else if((C|0)==139){b=d+8|0;a=f[b>>2]|0;J=f[17246]|0;if(a>>>0>=J>>>0&d>>>0>=J>>>0){f[a+12>>2]=h;f[b>>2]=h;f[h+8>>2]=a;f[h+12>>2]=d;f[h+24>>2]=0;break}else ja()}}else{J=i+o|0;f[j+4>>2]=J|3;J=j+J+4|0;f[J>>2]=f[J>>2]|1}}while(0);J=j+8|0;u=K;return J|0}}}else o=-1}while(0);c=f[17244]|0;if(c>>>0>=o>>>0){b=c-o|0;a=f[17247]|0;if(b>>>0>15){J=a+o|0;f[17247]=J;f[17244]=b;f[J+4>>2]=b|1;f[J+b>>2]=b;f[a+4>>2]=o|3}else{f[17244]=0;f[17247]=0;f[a+4>>2]=c|3;J=a+c+4|0;f[J>>2]=f[J>>2]|1}J=a+8|0;u=K;return J|0}h=f[17245]|0;if(h>>>0>o>>>0){H=h-o|0;f[17245]=H;J=f[17248]|0;I=J+o|0;f[17248]=I;f[I+4>>2]=H|1;f[J+4>>2]=o|3;J=J+8|0;u=K;return J|0}if(!(f[17360]|0)){f[17362]=4096;f[17361]=4096;f[17363]=-1;f[17364]=-1;f[17365]=0;f[17353]=0;a=n&-16^1431655768;f[n>>2]=a;f[17360]=a;a=4096}else a=f[17362]|0;i=o+48|0;j=o+47|0;g=a+j|0;e=0-a|0;k=g&e;if(k>>>0<=o>>>0){J=0;u=K;return J|0}a=f[17352]|0;if(a|0?(x=f[17350]|0,y=x+k|0,y>>>0<=x>>>0|y>>>0>a>>>0):0){J=0;u=K;return J|0}d:do{if(!(f[17353]&4)){c=f[17248]|0;e:do{if(c){d=69416;while(1){a=f[d>>2]|0;if(a>>>0<=c>>>0?(w=d+4|0,(a+(f[w>>2]|0)|0)>>>0>c>>>0):0)break;a=f[d+8>>2]|0;if(!a){C=163;break e}else d=a}b=g-h&e;if(b>>>0<2147483647){a=Hc(b|0)|0;if((a|0)==((f[d>>2]|0)+(f[w>>2]|0)|0)){if((a|0)!=(-1|0)){h=b;g=a;C=180;break d}}else{d=a;C=171}}else b=0}else C=163}while(0);do{if((C|0)==163){c=Hc(0)|0;if((c|0)!=(-1|0)?(b=c,t=f[17361]|0,v=t+-1|0,b=((v&b|0)==0?0:(v+b&0-t)-b|0)+k|0,t=f[17350]|0,v=b+t|0,b>>>0>o>>>0&b>>>0<2147483647):0){y=f[17352]|0;if(y|0?v>>>0<=t>>>0|v>>>0>y>>>0:0){b=0;break}a=Hc(b|0)|0;if((a|0)==(c|0)){h=b;g=c;C=180;break d}else{d=a;C=171}}else b=0}}while(0);do{if((C|0)==171){c=0-b|0;if(!(i>>>0>b>>>0&(b>>>0<2147483647&(d|0)!=(-1|0))))if((d|0)==(-1|0)){b=0;break}else{h=b;g=d;C=180;break d}a=f[17362]|0;a=j-b+a&0-a;if(a>>>0>=2147483647){h=b;g=d;C=180;break d}if((Hc(a|0)|0)==(-1|0)){Hc(c|0)|0;b=0;break}else{h=a+b|0;g=d;C=180;break d}}}while(0);f[17353]=f[17353]|4;C=178}else{b=0;C=178}}while(0);if(((C|0)==178?k>>>0<2147483647:0)?(B=Hc(k|0)|0,y=Hc(0)|0,z=y-B|0,A=z>>>0>(o+40|0)>>>0,!((B|0)==(-1|0)|A^1|B>>>0<y>>>0&((B|0)!=(-1|0)&(y|0)!=(-1|0))^1)):0){h=A?z:b;g=B;C=180}if((C|0)==180){b=(f[17350]|0)+h|0;f[17350]=b;if(b>>>0>(f[17351]|0)>>>0)f[17351]=b;k=f[17248]|0;do{if(k){b=69416;while(1){a=f[b>>2]|0;c=b+4|0;d=f[c>>2]|0;if((g|0)==(a+d|0)){C=190;break}e=f[b+8>>2]|0;if(!e)break;else b=e}if(((C|0)==190?(f[b+12>>2]&8|0)==0:0)?k>>>0<g>>>0&k>>>0>=a>>>0:0){f[c>>2]=d+h;J=k+8|0;J=(J&7|0)==0?0:0-J&7;I=k+J|0;J=(f[17245]|0)+(h-J)|0;f[17248]=I;f[17245]=J;f[I+4>>2]=J|1;f[I+J+4>>2]=40;f[17249]=f[17364];break}b=f[17246]|0;if(g>>>0<b>>>0){f[17246]=g;i=g}else i=b;c=g+h|0;b=69416;while(1){if((f[b>>2]|0)==(c|0)){C=198;break}a=f[b+8>>2]|0;if(!a)break;else b=a}if((C|0)==198?(f[b+12>>2]&8|0)==0:0){f[b>>2]=g;m=b+4|0;f[m>>2]=(f[m>>2]|0)+h;m=g+8|0;m=g+((m&7|0)==0?0:0-m&7)|0;b=c+8|0;b=c+((b&7|0)==0?0:0-b&7)|0;l=m+o|0;j=b-m-o|0;f[m+4>>2]=o|3;do{if((b|0)!=(k|0)){if((b|0)==(f[17247]|0)){J=(f[17244]|0)+j|0;f[17244]=J;f[17247]=l;f[l+4>>2]=J|1;f[l+J>>2]=J;break}a=f[b+4>>2]|0;if((a&3|0)==1){h=a&-8;e=a>>>3;f:do{if(a>>>0>=256){g=f[b+24>>2]|0;d=f[b+12>>2]|0;do{if((d|0)==(b|0)){d=b+16|0;c=d+4|0;a=f[c>>2]|0;if(!a){a=f[d>>2]|0;if(!a){H=0;break}else c=d}while(1){d=a+20|0;e=f[d>>2]|0;if(e|0){a=e;c=d;continue}d=a+16|0;e=f[d>>2]|0;if(!e)break;else{a=e;c=d}}if(c>>>0<i>>>0)ja();else{f[c>>2]=0;H=a;break}}else{e=f[b+8>>2]|0;if(e>>>0<i>>>0)ja();a=e+12|0;if((f[a>>2]|0)!=(b|0))ja();c=d+8|0;if((f[c>>2]|0)==(b|0)){f[a>>2]=d;f[c>>2]=e;H=d;break}else ja()}}while(0);if(!g)break;a=f[b+28>>2]|0;c=69272+(a<<2)|0;d=(H|0)==0;do{if((b|0)!=(f[c>>2]|0))if(g>>>0>=(f[17246]|0)>>>0){f[g+16+(((f[g+16>>2]|0)!=(b|0)&1)<<2)>>2]=H;if(d)break f;else break}else ja();else{f[c>>2]=H;if(!d)break;f[17243]=f[17243]&~(1<<a);break f}}while(0);d=f[17246]|0;if(H>>>0<d>>>0)ja();f[H+24>>2]=g;a=b+16|0;c=f[a>>2]|0;do{if(c|0)if(c>>>0<d>>>0)ja();else{f[H+16>>2]=c;f[c+24>>2]=H;break}}while(0);a=f[a+4>>2]|0;if(!a)break;if(a>>>0<(f[17246]|0)>>>0)ja();else{f[H+20>>2]=a;f[a+24>>2]=H;break}}else{c=f[b+8>>2]|0;d=f[b+12>>2]|0;a=69008+(e<<1<<2)|0;do{if((c|0)!=(a|0)){if(c>>>0<i>>>0)ja();if((f[c+12>>2]|0)==(b|0))break;ja()}}while(0);if((d|0)==(c|0)){f[17242]=f[17242]&~(1<<e);break}do{if((d|0)==(a|0))E=d+8|0;else{if(d>>>0<i>>>0)ja();a=d+8|0;if((f[a>>2]|0)==(b|0)){E=a;break}ja()}}while(0);f[c+12>>2]=d;f[E>>2]=c}}while(0);b=b+h|0;e=h+j|0}else e=j;b=b+4|0;f[b>>2]=f[b>>2]&-2;f[l+4>>2]=e|1;f[l+e>>2]=e;b=e>>>3;if(e>>>0<256){c=69008+(b<<1<<2)|0;a=f[17242]|0;b=1<<b;do{if(!(a&b)){f[17242]=a|b;I=c;J=c+8|0}else{b=c+8|0;a=f[b>>2]|0;if(a>>>0>=(f[17246]|0)>>>0){I=a;J=b;break}ja()}}while(0);f[J>>2]=l;f[I+12>>2]=l;f[l+8>>2]=I;f[l+12>>2]=c;break}b=e>>>8;do{if(!b)b=0;else{if(e>>>0>16777215){b=31;break}I=(b+1048320|0)>>>16&8;J=b<<I;H=(J+520192|0)>>>16&4;J=J<<H;b=(J+245760|0)>>>16&2;b=14-(H|I|b)+(J<<b>>>15)|0;b=e>>>(b+7|0)&1|b<<1}}while(0);d=69272+(b<<2)|0;f[l+28>>2]=b;a=l+16|0;f[a+4>>2]=0;f[a>>2]=0;a=f[17243]|0;c=1<<b;if(!(a&c)){f[17243]=a|c;f[d>>2]=l;f[l+24>>2]=d;f[l+12>>2]=l;f[l+8>>2]=l;break}a=e<<((b|0)==31?0:25-(b>>>1)|0);d=f[d>>2]|0;while(1){if((f[d+4>>2]&-8|0)==(e|0)){C=265;break}c=d+16+(a>>>31<<2)|0;b=f[c>>2]|0;if(!b){C=262;break}else{a=a<<1;d=b}}if((C|0)==262)if(c>>>0<(f[17246]|0)>>>0)ja();else{f[c>>2]=l;f[l+24>>2]=d;f[l+12>>2]=l;f[l+8>>2]=l;break}else if((C|0)==265){b=d+8|0;a=f[b>>2]|0;J=f[17246]|0;if(a>>>0>=J>>>0&d>>>0>=J>>>0){f[a+12>>2]=l;f[b>>2]=l;f[l+8>>2]=a;f[l+12>>2]=d;f[l+24>>2]=0;break}else ja()}}else{J=(f[17245]|0)+j|0;f[17245]=J;f[17248]=l;f[l+4>>2]=J|1}}while(0);J=m+8|0;u=K;return J|0}b=69416;while(1){a=f[b>>2]|0;if(a>>>0<=k>>>0?(D=a+(f[b+4>>2]|0)|0,D>>>0>k>>>0):0)break;b=f[b+8>>2]|0}e=D+-47|0;a=e+8|0;a=e+((a&7|0)==0?0:0-a&7)|0;e=k+16|0;a=a>>>0<e>>>0?k:a;b=a+8|0;c=g+8|0;c=(c&7|0)==0?0:0-c&7;J=g+c|0;c=h+-40-c|0;f[17248]=J;f[17245]=c;f[J+4>>2]=c|1;f[J+c+4>>2]=40;f[17249]=f[17364];c=a+4|0;f[c>>2]=27;f[b>>2]=f[17354];f[b+4>>2]=f[17355];f[b+8>>2]=f[17356];f[b+12>>2]=f[17357];f[17354]=g;f[17355]=h;f[17357]=0;f[17356]=b;b=a+24|0;do{J=b;b=b+4|0;f[b>>2]=7}while((J+8|0)>>>0<D>>>0);if((a|0)!=(k|0)){g=a-k|0;f[c>>2]=f[c>>2]&-2;f[k+4>>2]=g|1;f[a>>2]=g;b=g>>>3;if(g>>>0<256){c=69008+(b<<1<<2)|0;a=f[17242]|0;b=1<<b;if(a&b){b=c+8|0;a=f[b>>2]|0;if(a>>>0<(f[17246]|0)>>>0)ja();else{F=a;G=b}}else{f[17242]=a|b;F=c;G=c+8|0}f[G>>2]=k;f[F+12>>2]=k;f[k+8>>2]=F;f[k+12>>2]=c;break}b=g>>>8;if(b)if(g>>>0>16777215)c=31;else{I=(b+1048320|0)>>>16&8;J=b<<I;H=(J+520192|0)>>>16&4;J=J<<H;c=(J+245760|0)>>>16&2;c=14-(H|I|c)+(J<<c>>>15)|0;c=g>>>(c+7|0)&1|c<<1}else c=0;d=69272+(c<<2)|0;f[k+28>>2]=c;f[k+20>>2]=0;f[e>>2]=0;b=f[17243]|0;a=1<<c;if(!(b&a)){f[17243]=b|a;f[d>>2]=k;f[k+24>>2]=d;f[k+12>>2]=k;f[k+8>>2]=k;break}a=g<<((c|0)==31?0:25-(c>>>1)|0);d=f[d>>2]|0;while(1){if((f[d+4>>2]&-8|0)==(g|0)){C=292;break}c=d+16+(a>>>31<<2)|0;b=f[c>>2]|0;if(!b){C=289;break}else{a=a<<1;d=b}}if((C|0)==289)if(c>>>0<(f[17246]|0)>>>0)ja();else{f[c>>2]=k;f[k+24>>2]=d;f[k+12>>2]=k;f[k+8>>2]=k;break}else if((C|0)==292){b=d+8|0;a=f[b>>2]|0;J=f[17246]|0;if(a>>>0>=J>>>0&d>>>0>=J>>>0){f[a+12>>2]=k;f[b>>2]=k;f[k+8>>2]=a;f[k+12>>2]=d;f[k+24>>2]=0;break}else ja()}}}else{J=f[17246]|0;if((J|0)==0|g>>>0<J>>>0)f[17246]=g;f[17354]=g;f[17355]=h;f[17357]=0;f[17251]=f[17360];f[17250]=-1;b=0;do{J=69008+(b<<1<<2)|0;f[J+12>>2]=J;f[J+8>>2]=J;b=b+1|0}while((b|0)!=32);J=g+8|0;J=(J&7|0)==0?0:0-J&7;I=g+J|0;J=h+-40-J|0;f[17248]=I;f[17245]=J;f[I+4>>2]=J|1;f[I+J+4>>2]=40;f[17249]=f[17364]}}while(0);b=f[17245]|0;if(b>>>0>o>>>0){H=b-o|0;f[17245]=H;J=f[17248]|0;I=J+o|0;f[17248]=I;f[I+4>>2]=H|1;f[J+4>>2]=o|3;J=J+8|0;u=K;return J|0}}f[140]=12;J=0;u=K;return J|0}function gc(a){a=a|0;var b=0,c=0,d=0,e=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;if(!a)return;c=a+-8|0;h=f[17246]|0;if(c>>>0<h>>>0)ja();a=f[a+-4>>2]|0;b=a&3;if((b|0)==1)ja();d=a&-8;o=c+d|0;a:do{if(!(a&1)){a=f[c>>2]|0;if(!b)return;k=c+(0-a)|0;j=a+d|0;if(k>>>0<h>>>0)ja();if((k|0)==(f[17247]|0)){a=o+4|0;b=f[a>>2]|0;if((b&3|0)!=3){r=k;e=j;m=k;break}f[17244]=j;f[a>>2]=b&-2;f[k+4>>2]=j|1;f[k+j>>2]=j;return}d=a>>>3;if(a>>>0<256){b=f[k+8>>2]|0;c=f[k+12>>2]|0;a=69008+(d<<1<<2)|0;if((b|0)!=(a|0)){if(b>>>0<h>>>0)ja();if((f[b+12>>2]|0)!=(k|0))ja()}if((c|0)==(b|0)){f[17242]=f[17242]&~(1<<d);r=k;e=j;m=k;break}if((c|0)!=(a|0)){if(c>>>0<h>>>0)ja();a=c+8|0;if((f[a>>2]|0)==(k|0))g=a;else ja()}else g=c+8|0;f[b+12>>2]=c;f[g>>2]=b;r=k;e=j;m=k;break}g=f[k+24>>2]|0;c=f[k+12>>2]|0;do{if((c|0)==(k|0)){c=k+16|0;b=c+4|0;a=f[b>>2]|0;if(!a){a=f[c>>2]|0;if(!a){i=0;break}else b=c}while(1){c=a+20|0;d=f[c>>2]|0;if(d|0){a=d;b=c;continue}c=a+16|0;d=f[c>>2]|0;if(!d)break;else{a=d;b=c}}if(b>>>0<h>>>0)ja();else{f[b>>2]=0;i=a;break}}else{d=f[k+8>>2]|0;if(d>>>0<h>>>0)ja();a=d+12|0;if((f[a>>2]|0)!=(k|0))ja();b=c+8|0;if((f[b>>2]|0)==(k|0)){f[a>>2]=c;f[b>>2]=d;i=c;break}else ja()}}while(0);if(g){a=f[k+28>>2]|0;b=69272+(a<<2)|0;c=(i|0)==0;do{if((k|0)==(f[b>>2]|0)){f[b>>2]=i;if(c){f[17243]=f[17243]&~(1<<a);r=k;e=j;m=k;break a}}else if(g>>>0>=(f[17246]|0)>>>0){f[g+16+(((f[g+16>>2]|0)!=(k|0)&1)<<2)>>2]=i;if(c){r=k;e=j;m=k;break a}else break}else ja()}while(0);c=f[17246]|0;if(i>>>0<c>>>0)ja();f[i+24>>2]=g;a=k+16|0;b=f[a>>2]|0;do{if(b|0)if(b>>>0<c>>>0)ja();else{f[i+16>>2]=b;f[b+24>>2]=i;break}}while(0);a=f[a+4>>2]|0;if(a)if(a>>>0<(f[17246]|0)>>>0)ja();else{f[i+20>>2]=a;f[a+24>>2]=i;r=k;e=j;m=k;break}else{r=k;e=j;m=k}}else{r=k;e=j;m=k}}else{r=c;e=d;m=c}}while(0);if(m>>>0>=o>>>0)ja();a=o+4|0;b=f[a>>2]|0;if(!(b&1))ja();if(!(b&2)){a=f[17247]|0;if((o|0)==(f[17248]|0)){q=(f[17245]|0)+e|0;f[17245]=q;f[17248]=r;f[r+4>>2]=q|1;if((r|0)!=(a|0))return;f[17247]=0;f[17244]=0;return}if((o|0)==(a|0)){q=(f[17244]|0)+e|0;f[17244]=q;f[17247]=m;f[r+4>>2]=q|1;f[m+q>>2]=q;return}e=(b&-8)+e|0;d=b>>>3;b:do{if(b>>>0>=256){g=f[o+24>>2]|0;a=f[o+12>>2]|0;do{if((a|0)==(o|0)){c=o+16|0;b=c+4|0;a=f[b>>2]|0;if(!a){a=f[c>>2]|0;if(!a){n=0;break}else b=c}while(1){c=a+20|0;d=f[c>>2]|0;if(d|0){a=d;b=c;continue}c=a+16|0;d=f[c>>2]|0;if(!d)break;else{a=d;b=c}}if(b>>>0<(f[17246]|0)>>>0)ja();else{f[b>>2]=0;n=a;break}}else{b=f[o+8>>2]|0;if(b>>>0<(f[17246]|0)>>>0)ja();c=b+12|0;if((f[c>>2]|0)!=(o|0))ja();d=a+8|0;if((f[d>>2]|0)==(o|0)){f[c>>2]=a;f[d>>2]=b;n=a;break}else ja()}}while(0);if(g|0){a=f[o+28>>2]|0;b=69272+(a<<2)|0;c=(n|0)==0;do{if((o|0)==(f[b>>2]|0)){f[b>>2]=n;if(c){f[17243]=f[17243]&~(1<<a);break b}}else if(g>>>0>=(f[17246]|0)>>>0){f[g+16+(((f[g+16>>2]|0)!=(o|0)&1)<<2)>>2]=n;if(c)break b;else break}else ja()}while(0);c=f[17246]|0;if(n>>>0<c>>>0)ja();f[n+24>>2]=g;a=o+16|0;b=f[a>>2]|0;do{if(b|0)if(b>>>0<c>>>0)ja();else{f[n+16>>2]=b;f[b+24>>2]=n;break}}while(0);a=f[a+4>>2]|0;if(a|0)if(a>>>0<(f[17246]|0)>>>0)ja();else{f[n+20>>2]=a;f[a+24>>2]=n;break}}}else{b=f[o+8>>2]|0;c=f[o+12>>2]|0;a=69008+(d<<1<<2)|0;if((b|0)!=(a|0)){if(b>>>0<(f[17246]|0)>>>0)ja();if((f[b+12>>2]|0)!=(o|0))ja()}if((c|0)==(b|0)){f[17242]=f[17242]&~(1<<d);break}if((c|0)!=(a|0)){if(c>>>0<(f[17246]|0)>>>0)ja();a=c+8|0;if((f[a>>2]|0)==(o|0))l=a;else ja()}else l=c+8|0;f[b+12>>2]=c;f[l>>2]=b}}while(0);f[r+4>>2]=e|1;f[m+e>>2]=e;if((r|0)==(f[17247]|0)){f[17244]=e;return}}else{f[a>>2]=b&-2;f[r+4>>2]=e|1;f[m+e>>2]=e}a=e>>>3;if(e>>>0<256){c=69008+(a<<1<<2)|0;b=f[17242]|0;a=1<<a;if(b&a){a=c+8|0;b=f[a>>2]|0;if(b>>>0<(f[17246]|0)>>>0)ja();else{p=b;q=a}}else{f[17242]=b|a;p=c;q=c+8|0}f[q>>2]=r;f[p+12>>2]=r;f[r+8>>2]=p;f[r+12>>2]=c;return}a=e>>>8;if(a)if(e>>>0>16777215)a=31;else{p=(a+1048320|0)>>>16&8;q=a<<p;o=(q+520192|0)>>>16&4;q=q<<o;a=(q+245760|0)>>>16&2;a=14-(o|p|a)+(q<<a>>>15)|0;a=e>>>(a+7|0)&1|a<<1}else a=0;d=69272+(a<<2)|0;f[r+28>>2]=a;f[r+20>>2]=0;f[r+16>>2]=0;b=f[17243]|0;c=1<<a;do{if(b&c){b=e<<((a|0)==31?0:25-(a>>>1)|0);d=f[d>>2]|0;while(1){if((f[d+4>>2]&-8|0)==(e|0)){a=124;break}c=d+16+(b>>>31<<2)|0;a=f[c>>2]|0;if(!a){a=121;break}else{b=b<<1;d=a}}if((a|0)==121)if(c>>>0<(f[17246]|0)>>>0)ja();else{f[c>>2]=r;f[r+24>>2]=d;f[r+12>>2]=r;f[r+8>>2]=r;break}else if((a|0)==124){a=d+8|0;b=f[a>>2]|0;q=f[17246]|0;if(b>>>0>=q>>>0&d>>>0>=q>>>0){f[b+12>>2]=r;f[a>>2]=r;f[r+8>>2]=b;f[r+12>>2]=d;f[r+24>>2]=0;break}else ja()}}else{f[17243]=b|c;f[d>>2]=r;f[r+24>>2]=d;f[r+12>>2]=r;f[r+8>>2]=r}}while(0);r=(f[17250]|0)+-1|0;f[17250]=r;if(!r)a=69424;else return;while(1){a=f[a>>2]|0;if(!a)break;else a=a+8|0}f[17250]=-1;return}function hc(a,b){a=a|0;b=b|0;var c=0,d=0;if(!a){b=fc(b)|0;return b|0}if(b>>>0>4294967231){f[140]=12;b=0;return b|0}c=ic(a+-8|0,b>>>0<11?16:b+11&-8)|0;if(c|0){b=c+8|0;return b|0}c=fc(b)|0;if(!c){b=0;return b|0}d=f[a+-4>>2]|0;d=(d&-8)-((d&3|0)==0?8:4)|0;Jc(c|0,a|0,(d>>>0<b>>>0?d:b)|0)|0;gc(a);b=c;return b|0}function ic(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0;o=a+4|0;n=f[o>>2]|0;c=n&-8;k=a+c|0;i=f[17246]|0;d=n&3;if(!((d|0)!=1&a>>>0>=i>>>0&a>>>0<k>>>0))ja();e=f[k+4>>2]|0;if(!(e&1))ja();if(!d){if(b>>>0<256){a=0;return a|0}if(c>>>0>=(b+4|0)>>>0?(c-b|0)>>>0<=f[17362]<<1>>>0:0)return a|0;a=0;return a|0}if(c>>>0>=b>>>0){c=c-b|0;if(c>>>0<=15)return a|0;m=a+b|0;f[o>>2]=n&1|b|2;f[m+4>>2]=c|3;o=m+c+4|0;f[o>>2]=f[o>>2]|1;jc(m,c);return a|0}if((k|0)==(f[17248]|0)){m=(f[17245]|0)+c|0;c=m-b|0;d=a+b|0;if(m>>>0<=b>>>0){a=0;return a|0}f[o>>2]=n&1|b|2;f[d+4>>2]=c|1;f[17248]=d;f[17245]=c;return a|0}if((k|0)==(f[17247]|0)){e=(f[17244]|0)+c|0;if(e>>>0<b>>>0){a=0;return a|0}c=e-b|0;d=n&1;if(c>>>0>15){n=a+b|0;m=n+c|0;f[o>>2]=d|b|2;f[n+4>>2]=c|1;f[m>>2]=c;d=m+4|0;f[d>>2]=f[d>>2]&-2;d=n}else{f[o>>2]=d|e|2;d=a+e+4|0;f[d>>2]=f[d>>2]|1;d=0;c=0}f[17244]=c;f[17247]=d;return a|0}if(e&2|0){a=0;return a|0}l=(e&-8)+c|0;if(l>>>0<b>>>0){a=0;return a|0}m=l-b|0;g=e>>>3;a:do{if(e>>>0>=256){h=f[k+24>>2]|0;e=f[k+12>>2]|0;do{if((e|0)==(k|0)){e=k+16|0;d=e+4|0;c=f[d>>2]|0;if(!c){c=f[e>>2]|0;if(!c){j=0;break}else d=e}while(1){e=c+20|0;g=f[e>>2]|0;if(g|0){c=g;d=e;continue}e=c+16|0;g=f[e>>2]|0;if(!g)break;else{c=g;d=e}}if(d>>>0<i>>>0)ja();else{f[d>>2]=0;j=c;break}}else{g=f[k+8>>2]|0;if(g>>>0<i>>>0)ja();c=g+12|0;if((f[c>>2]|0)!=(k|0))ja();d=e+8|0;if((f[d>>2]|0)==(k|0)){f[c>>2]=e;f[d>>2]=g;j=e;break}else ja()}}while(0);if(h|0){c=f[k+28>>2]|0;d=69272+(c<<2)|0;e=(j|0)==0;do{if((k|0)==(f[d>>2]|0)){f[d>>2]=j;if(e){f[17243]=f[17243]&~(1<<c);break a}}else if(h>>>0>=(f[17246]|0)>>>0){f[h+16+(((f[h+16>>2]|0)!=(k|0)&1)<<2)>>2]=j;if(e)break a;else break}else ja()}while(0);e=f[17246]|0;if(j>>>0<e>>>0)ja();f[j+24>>2]=h;c=k+16|0;d=f[c>>2]|0;do{if(d|0)if(d>>>0<e>>>0)ja();else{f[j+16>>2]=d;f[d+24>>2]=j;break}}while(0);c=f[c+4>>2]|0;if(c|0)if(c>>>0<(f[17246]|0)>>>0)ja();else{f[j+20>>2]=c;f[c+24>>2]=j;break}}}else{d=f[k+8>>2]|0;e=f[k+12>>2]|0;c=69008+(g<<1<<2)|0;if((d|0)!=(c|0)){if(d>>>0<i>>>0)ja();if((f[d+12>>2]|0)!=(k|0))ja()}if((e|0)==(d|0)){f[17242]=f[17242]&~(1<<g);break}if((e|0)!=(c|0)){if(e>>>0<i>>>0)ja();c=e+8|0;if((f[c>>2]|0)==(k|0))h=c;else ja()}else h=e+8|0;f[d+12>>2]=e;f[h>>2]=d}}while(0);c=n&1;if(m>>>0<16){f[o>>2]=c|l|2;o=a+l+4|0;f[o>>2]=f[o>>2]|1;return a|0}else{n=a+b|0;f[o>>2]=c|b|2;f[n+4>>2]=m|3;o=n+m+4|0;f[o>>2]=f[o>>2]|1;jc(n,m);return a|0}return 0}function jc(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;o=a+b|0;c=f[a+4>>2]|0;a:do{if(!(c&1)){g=f[a>>2]|0;if(!(c&3))return;l=a+(0-g)|0;k=g+b|0;i=f[17246]|0;if(l>>>0<i>>>0)ja();if((l|0)==(f[17247]|0)){c=o+4|0;a=f[c>>2]|0;if((a&3|0)!=3){r=l;e=k;break}f[17244]=k;f[c>>2]=a&-2;f[l+4>>2]=k|1;f[l+k>>2]=k;return}d=g>>>3;if(g>>>0<256){c=f[l+8>>2]|0;b=f[l+12>>2]|0;a=69008+(d<<1<<2)|0;if((c|0)!=(a|0)){if(c>>>0<i>>>0)ja();if((f[c+12>>2]|0)!=(l|0))ja()}if((b|0)==(c|0)){f[17242]=f[17242]&~(1<<d);r=l;e=k;break}if((b|0)!=(a|0)){if(b>>>0<i>>>0)ja();a=b+8|0;if((f[a>>2]|0)==(l|0))h=a;else ja()}else h=b+8|0;f[c+12>>2]=b;f[h>>2]=c;r=l;e=k;break}g=f[l+24>>2]|0;b=f[l+12>>2]|0;do{if((b|0)==(l|0)){b=l+16|0;c=b+4|0;a=f[c>>2]|0;if(!a){a=f[b>>2]|0;if(!a){j=0;break}else c=b}while(1){b=a+20|0;d=f[b>>2]|0;if(d|0){a=d;c=b;continue}b=a+16|0;d=f[b>>2]|0;if(!d)break;else{a=d;c=b}}if(c>>>0<i>>>0)ja();else{f[c>>2]=0\n;j=a;break}}else{d=f[l+8>>2]|0;if(d>>>0<i>>>0)ja();a=d+12|0;if((f[a>>2]|0)!=(l|0))ja();c=b+8|0;if((f[c>>2]|0)==(l|0)){f[a>>2]=b;f[c>>2]=d;j=b;break}else ja()}}while(0);if(g){a=f[l+28>>2]|0;c=69272+(a<<2)|0;b=(j|0)==0;do{if((l|0)==(f[c>>2]|0)){f[c>>2]=j;if(b){f[17243]=f[17243]&~(1<<a);r=l;e=k;break a}}else if(g>>>0>=(f[17246]|0)>>>0){f[g+16+(((f[g+16>>2]|0)!=(l|0)&1)<<2)>>2]=j;if(b){r=l;e=k;break a}else break}else ja()}while(0);b=f[17246]|0;if(j>>>0<b>>>0)ja();f[j+24>>2]=g;a=l+16|0;c=f[a>>2]|0;do{if(c|0)if(c>>>0<b>>>0)ja();else{f[j+16>>2]=c;f[c+24>>2]=j;break}}while(0);a=f[a+4>>2]|0;if(a)if(a>>>0<(f[17246]|0)>>>0)ja();else{f[j+20>>2]=a;f[a+24>>2]=j;r=l;e=k;break}else{r=l;e=k}}else{r=l;e=k}}else{r=a;e=b}}while(0);h=f[17246]|0;if(o>>>0<h>>>0)ja();a=o+4|0;c=f[a>>2]|0;if(!(c&2)){a=f[17247]|0;if((o|0)==(f[17248]|0)){q=(f[17245]|0)+e|0;f[17245]=q;f[17248]=r;f[r+4>>2]=q|1;if((r|0)!=(a|0))return;f[17247]=0;f[17244]=0;return}if((o|0)==(a|0)){q=(f[17244]|0)+e|0;f[17244]=q;f[17247]=r;f[r+4>>2]=q|1;f[r+q>>2]=q;return}e=(c&-8)+e|0;d=c>>>3;b:do{if(c>>>0>=256){g=f[o+24>>2]|0;b=f[o+12>>2]|0;do{if((b|0)==(o|0)){b=o+16|0;c=b+4|0;a=f[c>>2]|0;if(!a){a=f[b>>2]|0;if(!a){n=0;break}else c=b}while(1){b=a+20|0;d=f[b>>2]|0;if(d|0){a=d;c=b;continue}b=a+16|0;d=f[b>>2]|0;if(!d)break;else{a=d;c=b}}if(c>>>0<h>>>0)ja();else{f[c>>2]=0;n=a;break}}else{d=f[o+8>>2]|0;if(d>>>0<h>>>0)ja();a=d+12|0;if((f[a>>2]|0)!=(o|0))ja();c=b+8|0;if((f[c>>2]|0)==(o|0)){f[a>>2]=b;f[c>>2]=d;n=b;break}else ja()}}while(0);if(g|0){a=f[o+28>>2]|0;c=69272+(a<<2)|0;b=(n|0)==0;do{if((o|0)==(f[c>>2]|0)){f[c>>2]=n;if(b){f[17243]=f[17243]&~(1<<a);break b}}else if(g>>>0>=(f[17246]|0)>>>0){f[g+16+(((f[g+16>>2]|0)!=(o|0)&1)<<2)>>2]=n;if(b)break b;else break}else ja()}while(0);b=f[17246]|0;if(n>>>0<b>>>0)ja();f[n+24>>2]=g;a=o+16|0;c=f[a>>2]|0;do{if(c|0)if(c>>>0<b>>>0)ja();else{f[n+16>>2]=c;f[c+24>>2]=n;break}}while(0);a=f[a+4>>2]|0;if(a|0)if(a>>>0<(f[17246]|0)>>>0)ja();else{f[n+20>>2]=a;f[a+24>>2]=n;break}}}else{c=f[o+8>>2]|0;b=f[o+12>>2]|0;a=69008+(d<<1<<2)|0;if((c|0)!=(a|0)){if(c>>>0<h>>>0)ja();if((f[c+12>>2]|0)!=(o|0))ja()}if((b|0)==(c|0)){f[17242]=f[17242]&~(1<<d);break}if((b|0)!=(a|0)){if(b>>>0<h>>>0)ja();a=b+8|0;if((f[a>>2]|0)==(o|0))m=a;else ja()}else m=b+8|0;f[c+12>>2]=b;f[m>>2]=c}}while(0);f[r+4>>2]=e|1;f[r+e>>2]=e;if((r|0)==(f[17247]|0)){f[17244]=e;return}}else{f[a>>2]=c&-2;f[r+4>>2]=e|1;f[r+e>>2]=e}a=e>>>3;if(e>>>0<256){b=69008+(a<<1<<2)|0;c=f[17242]|0;a=1<<a;if(c&a){a=b+8|0;c=f[a>>2]|0;if(c>>>0<(f[17246]|0)>>>0)ja();else{p=c;q=a}}else{f[17242]=c|a;p=b;q=b+8|0}f[q>>2]=r;f[p+12>>2]=r;f[r+8>>2]=p;f[r+12>>2]=b;return}a=e>>>8;if(a)if(e>>>0>16777215)a=31;else{p=(a+1048320|0)>>>16&8;q=a<<p;o=(q+520192|0)>>>16&4;q=q<<o;a=(q+245760|0)>>>16&2;a=14-(o|p|a)+(q<<a>>>15)|0;a=e>>>(a+7|0)&1|a<<1}else a=0;d=69272+(a<<2)|0;f[r+28>>2]=a;f[r+20>>2]=0;f[r+16>>2]=0;c=f[17243]|0;b=1<<a;if(!(c&b)){f[17243]=c|b;f[d>>2]=r;f[r+24>>2]=d;f[r+12>>2]=r;f[r+8>>2]=r;return}c=e<<((a|0)==31?0:25-(a>>>1)|0);d=f[d>>2]|0;while(1){if((f[d+4>>2]&-8|0)==(e|0)){a=121;break}b=d+16+(c>>>31<<2)|0;a=f[b>>2]|0;if(!a){a=118;break}else{c=c<<1;d=a}}if((a|0)==118){if(b>>>0<(f[17246]|0)>>>0)ja();f[b>>2]=r;f[r+24>>2]=d;f[r+12>>2]=r;f[r+8>>2]=r;return}else if((a|0)==121){a=d+8|0;c=f[a>>2]|0;q=f[17246]|0;if(!(c>>>0>=q>>>0&d>>>0>=q>>>0))ja();f[c+12>>2]=r;f[a>>2]=r;f[r+8>>2]=c;f[r+12>>2]=d;f[r+24>>2]=0;return}}function kc(a,b){a=a|0;b=b|0;if(a>>>0<9){b=fc(b)|0;return b|0}else{b=lc(a,b)|0;return b|0}return 0}function lc(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,g=0,h=0,i=0;a=a>>>0>16?a:16;if(a+-1&a){c=16;while(1)if(c>>>0<a>>>0)c=c<<1;else{a=c;break}}if((-64-a|0)>>>0<=b>>>0){f[140]=12;h=0;return h|0}g=b>>>0<11?16:b+11&-8;c=fc(g+12+a|0)|0;if(!c){h=0;return h|0}e=c+-8|0;do{if(c&a+-1){d=(c+a+-1&0-a)+-8|0;b=e;d=(d-b|0)>>>0>15?d:d+a|0;b=d-b|0;a=c+-4|0;i=f[a>>2]|0;c=(i&-8)-b|0;if(!(i&3)){f[d>>2]=(f[e>>2]|0)+b;f[d+4>>2]=c;a=d;b=d;break}else{i=d+4|0;f[i>>2]=c|f[i>>2]&1|2;c=d+c+4|0;f[c>>2]=f[c>>2]|1;f[a>>2]=b|f[a>>2]&1|2;f[i>>2]=f[i>>2]|1;jc(e,b);a=d;b=d;break}}else{a=e;b=e}}while(0);a=a+4|0;c=f[a>>2]|0;if(c&3|0?(h=c&-8,h>>>0>(g+16|0)>>>0):0){i=h-g|0;h=b+g|0;f[a>>2]=g|c&1|2;f[h+4>>2]=i|3;g=h+i+4|0;f[g>>2]=f[g>>2]|1;jc(h,i)}i=b+8|0;return i|0}function mc(a){a=a|0;return}function nc(a){a=a|0;Dc(a);return}function oc(a){a=a|0;return}function pc(a){a=a|0;return}function qc(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,g=0,h=0;h=u;u=u+64|0;e=h;if(!(uc(a,b)|0))if((b|0)!=0?(g=yc(b,8)|0,(g|0)!=0):0){b=e+4|0;d=b+52|0;do{f[b>>2]=0;b=b+4|0}while((b|0)<(d|0));f[e>>2]=g;f[e+8>>2]=a;f[e+12>>2]=-1;f[e+48>>2]=1;xa[f[(f[g>>2]|0)+28>>2]&3](g,e,f[c>>2]|0,1);if((f[e+24>>2]|0)==1){f[c>>2]=f[e+16>>2];b=1}else b=0}else b=0;else b=1;u=h;return b|0}function rc(a,b,c,d,e,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;g=g|0;if(uc(a,f[b+8>>2]|0)|0)xc(b,c,d,e);return}function sc(a,c,d,e,g){a=a|0;c=c|0;d=d|0;e=e|0;g=g|0;var h=0;do{if(!(uc(a,f[c+8>>2]|0)|0)){if(uc(a,f[c>>2]|0)|0){a=c+32|0;if((f[c+16>>2]|0)!=(d|0)?(h=c+20|0,(f[h>>2]|0)!=(d|0)):0){f[a>>2]=e;f[h>>2]=d;e=c+40|0;f[e>>2]=(f[e>>2]|0)+1;if((f[c+36>>2]|0)==1?(f[c+24>>2]|0)==2:0)b[c+54>>0]=1;f[c+44>>2]=4;break}if((e|0)==1)f[a>>2]=1}}else wc(c,d,e)}while(0);return}function tc(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;if(uc(a,f[b+8>>2]|0)|0)vc(b,c,d);return}function uc(a,b){a=a|0;b=b|0;return(a|0)==(b|0)|0}function vc(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,g=0,h=0,i=0;e=a+16|0;g=f[e>>2]|0;h=a+36|0;i=a+24|0;do{if(g){if((g|0)!=(c|0)){f[h>>2]=(f[h>>2]|0)+1;f[i>>2]=2;b[a+54>>0]=1;break}if((f[i>>2]|0)==2)f[i>>2]=d}else{f[e>>2]=c;f[i>>2]=d;f[h>>2]=1}}while(0);return}function wc(a,b,c){a=a|0;b=b|0;c=c|0;var d=0;if((f[a+4>>2]|0)==(b|0)?(d=a+28|0,(f[d>>2]|0)!=1):0)f[d>>2]=c;return}function xc(a,c,d,e){a=a|0;c=c|0;d=d|0;e=e|0;var g=0,h=0,i=0,j=0,k=0;b[a+53>>0]=1;do{if((f[a+4>>2]|0)==(d|0)){b[a+52>>0]=1;h=a+16|0;g=f[h>>2]|0;j=a+54|0;k=a+48|0;i=a+24|0;d=a+36|0;if(!g){f[h>>2]=c;f[i>>2]=e;f[d>>2]=1;if(!((e|0)==1&(f[k>>2]|0)==1))break;b[j>>0]=1;break}if((g|0)!=(c|0)){f[d>>2]=(f[d>>2]|0)+1;b[j>>0]=1;break}d=f[i>>2]|0;if((d|0)==2){f[i>>2]=e;d=e}if((d|0)==1&(f[k>>2]|0)==1)b[j>>0]=1}}while(0);return}function yc(a,c){a=a|0;c=c|0;var e=0,g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;q=u;u=u+64|0;n=q;p=f[a>>2]|0;o=a+(f[p+-8>>2]|0)|0;p=f[p+-4>>2]|0;f[n>>2]=c;f[n+4>>2]=a;f[n+8>>2]=24;g=n+12|0;h=n+16|0;i=n+20|0;j=n+24|0;k=n+28|0;l=n+32|0;m=n+40|0;a=uc(p,c)|0;c=g;e=c+40|0;do{f[c>>2]=0;c=c+4|0}while((c|0)<(e|0));d[g+40>>1]=0;b[g+42>>0]=0;a:do{if(a){f[n+48>>2]=1;va[f[(f[p>>2]|0)+20>>2]&3](p,n,o,o,1,0);a=(f[j>>2]|0)==1?o:0}else{sa[f[(f[p>>2]|0)+24>>2]&3](p,n,o,1,0);switch(f[n+36>>2]|0){case 0:{a=(f[m>>2]|0)==1&(f[k>>2]|0)==1&(f[l>>2]|0)==1?f[i>>2]|0:0;break a}case 1:break;default:{a=0;break a}}if((f[j>>2]|0)!=1?!((f[m>>2]|0)==0&(f[k>>2]|0)==1&(f[l>>2]|0)==1):0){a=0;break}a=f[h>>2]|0}}while(0);u=q;return a|0}function zc(a){a=a|0;Dc(a);return}function Ac(a,b,c,d,e,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;g=g|0;if(uc(a,f[b+8>>2]|0)|0)xc(b,c,d,e);else{a=f[a+8>>2]|0;va[f[(f[a>>2]|0)+20>>2]&3](a,b,c,d,e,g)}return}function Bc(a,c,d,e,g){a=a|0;c=c|0;d=d|0;e=e|0;g=g|0;var h=0,i=0,j=0,k=0;do{if(!(uc(a,f[c+8>>2]|0)|0)){h=a+8|0;if(!(uc(a,f[c>>2]|0)|0)){j=f[h>>2]|0;sa[f[(f[j>>2]|0)+24>>2]&3](j,c,d,e,g);break}a=c+32|0;if((f[c+16>>2]|0)!=(d|0)?(i=c+20|0,(f[i>>2]|0)!=(d|0)):0){f[a>>2]=e;e=c+44|0;if((f[e>>2]|0)==4)break;a=c+52|0;b[a>>0]=0;k=c+53|0;b[k>>0]=0;h=f[h>>2]|0;va[f[(f[h>>2]|0)+20>>2]&3](h,c,d,d,1,g);if(b[k>>0]|0)if(!(b[a>>0]|0)){a=3;j=11}else a=3;else{a=4;j=11}if((j|0)==11){f[i>>2]=d;k=c+40|0;f[k>>2]=(f[k>>2]|0)+1;if((f[c+36>>2]|0)==1?(f[c+24>>2]|0)==2:0)b[c+54>>0]=1}f[e>>2]=a;break}if((e|0)==1)f[a>>2]=1}else wc(c,d,e)}while(0);return}function Cc(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;if(uc(a,f[b+8>>2]|0)|0)vc(b,c,d);else{a=f[a+8>>2]|0;xa[f[(f[a>>2]|0)+28>>2]&3](a,b,c,d)}return}function Dc(a){a=a|0;gc(a);return}function Ec(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0;e=u;u=u+16|0;d=e;f[d>>2]=f[c>>2];a=ua[f[(f[a>>2]|0)+16>>2]&1](a,b,d)|0;if(a)f[c>>2]=f[d>>2];u=e;return a&1|0}function Fc(a){a=a|0;if(!a)a=0;else a=(yc(a,80)|0)!=0;return a&1|0}function Gc(){}function Hc(a){a=a|0;var b=0,c=0;c=a+15&-16|0;b=f[r>>2]|0;a=b+c|0;if((c|0)>0&(a|0)<(b|0)|(a|0)<0){ca()|0;ka(12);return-1}f[r>>2]=a;if((a|0)>(ba()|0)?(aa()|0)==0:0){ka(12);f[r>>2]=b;return-1}return b|0}function Ic(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,g=0,h=0,i=0;h=a+d|0;c=c&255;if((d|0)>=67){while(a&3){b[a>>0]=c;a=a+1|0}e=h&-4|0;g=e-64|0;i=c|c<<8|c<<16|c<<24;while((a|0)<=(g|0)){f[a>>2]=i;f[a+4>>2]=i;f[a+8>>2]=i;f[a+12>>2]=i;f[a+16>>2]=i;f[a+20>>2]=i;f[a+24>>2]=i;f[a+28>>2]=i;f[a+32>>2]=i;f[a+36>>2]=i;f[a+40>>2]=i;f[a+44>>2]=i;f[a+48>>2]=i;f[a+52>>2]=i;f[a+56>>2]=i;f[a+60>>2]=i;a=a+64|0}while((a|0)<(e|0)){f[a>>2]=i;a=a+4|0}}while((a|0)<(h|0)){b[a>>0]=c;a=a+1|0}return h-d|0}function Jc(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,g=0,h=0;if((d|0)>=8192)return la(a|0,c|0,d|0)|0;h=a|0;g=a+d|0;if((a&3)==(c&3)){while(a&3){if(!d)return h|0;b[a>>0]=b[c>>0]|0;a=a+1|0;c=c+1|0;d=d-1|0}d=g&-4|0;e=d-64|0;while((a|0)<=(e|0)){f[a>>2]=f[c>>2];f[a+4>>2]=f[c+4>>2];f[a+8>>2]=f[c+8>>2];f[a+12>>2]=f[c+12>>2];f[a+16>>2]=f[c+16>>2];f[a+20>>2]=f[c+20>>2];f[a+24>>2]=f[c+24>>2];f[a+28>>2]=f[c+28>>2];f[a+32>>2]=f[c+32>>2];f[a+36>>2]=f[c+36>>2];f[a+40>>2]=f[c+40>>2];f[a+44>>2]=f[c+44>>2];f[a+48>>2]=f[c+48>>2];f[a+52>>2]=f[c+52>>2];f[a+56>>2]=f[c+56>>2];f[a+60>>2]=f[c+60>>2];a=a+64|0;c=c+64|0}while((a|0)<(d|0)){f[a>>2]=f[c>>2];a=a+4|0;c=c+4|0}}else{d=g-4|0;while((a|0)<(d|0)){b[a>>0]=b[c>>0]|0;b[a+1>>0]=b[c+1>>0]|0;b[a+2>>0]=b[c+2>>0]|0;b[a+3>>0]=b[c+3>>0]|0;a=a+4|0;c=c+4|0}}while((a|0)<(g|0)){b[a>>0]=b[c>>0]|0;a=a+1|0;c=c+1|0}return h|0}function Kc(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;sa[a&3](b|0,c|0,d|0,e|0,f|0)}function Lc(a,b){a=a|0;b=b|0;ta[a&7](b|0)}function Mc(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;return ua[a&1](b|0,c|0,d|0)|0}function Nc(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;va[a&3](b|0,c|0,d|0,e|0,f|0,g|0)}function Oc(a,b,c){a=a|0;b=b|0;c=c|0;return wa[a&0](b|0,c|0)|0}function Pc(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;xa[a&3](b|0,c|0,d|0,e|0)}function Qc(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;_(0)}function Rc(a){a=a|0;_(1)}function Sc(a,b,c){a=a|0;b=b|0;c=c|0;_(2);return 0}function Tc(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;_(3)}function Uc(a,b){a=a|0;b=b|0;_(4);return 0}function Vc(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;_(5)}var sa=[Qc,sc,Bc,Qc];var ta=[Rc,mc,nc,oc,pc,zc,Rc,Rc];var ua=[Sc,qc];var va=[Tc,rc,Ac,Tc];var wa=[Uc];var xa=[Vc,tc,Cc,Vc];return{setThrew:Ca,_bidi_getParagraphEndIndex:Ha,___cxa_is_pointer_type:Fc,_memset:Ic,_sbrk:Hc,_memcpy:Jc,stackAlloc:ya,_ushape_arabic:Fa,_memalign:kc,getTempRet0:Ea,setTempRet0:Da,_emscripten_get_global_libc:ec,_bidi_getLine:Ia,stackSave:za,___cxa_can_catch:Ec,_free:gc,runPostSets:Gc,establishStackSpace:Ba,stackRestore:Aa,_malloc:fc,_emscripten_replace_memory:ra,_bidi_processText:Ga,stackAlloc:ya,stackSave:za,stackRestore:Aa,establishStackSpace:Ba,setThrew:Ca,setTempRet0:Da,getTempRet0:Ea,dynCall_viiiii:Kc,dynCall_vi:Lc,dynCall_iiii:Mc,dynCall_viiiiii:Nc,dynCall_iii:Oc,dynCall_viiii:Pc}}(b.s,b.t,buffer);b.setThrew=Z.setThrew;b._bidi_getParagraphEndIndex=Z._bidi_getParagraphEndIndex;b.___cxa_is_pointer_type=Z.___cxa_is_pointer_type;var Ha=b._memset=Z._memset,Ga=b._sbrk=Z._sbrk,La=b._memcpy=Z._memcpy;b.stackAlloc=Z.stackAlloc;b._ushape_arabic=Z._ushape_arabic;b._memalign=Z._memalign;b.getTempRet0=Z.getTempRet0;b.setTempRet0=Z.setTempRet0;b._emscripten_get_global_libc=Z._emscripten_get_global_libc;b._bidi_getLine=Z._bidi_getLine;b.stackSave=Z.stackSave;b.___cxa_can_catch=Z.___cxa_can_catch;var Q=b._free=Z._free;b.runPostSets=Z.runPostSets;b.establishStackSpace=Z.establishStackSpace;b.stackRestore=Z.stackRestore;var P=b._malloc=Z._malloc,va=b._emscripten_replace_memory=Z._emscripten_replace_memory;b._bidi_processText=Z._bidi_processText;b.dynCall_viiiii=Z.dynCall_viiiii;b.dynCall_vi=Z.dynCall_vi;b.dynCall_iiii=Z.dynCall_iiii;b.dynCall_viiiiii=Z.dynCall_viiiiii;b.dynCall_iii=Z.dynCall_iii;b.dynCall_viiii=Z.dynCall_viiii;A.f=b.stackAlloc;A.m=b.stackSave;A.g=b.stackRestore;A.I=b.establishStackSpace;A.b=b.setTempRet0;A.w=b.getTempRet0;b.asm=Z;function y(a){this.name=\"ExitStatus\";this.message=\"Program terminated with exit(\"+a+\")\"}y.prototype=Error();y.prototype.constructor=y;var Ma=null;b.callMain=b.G=function(a){function c(){for(var a=0;3>a;a++)e.push(0)}a=a||[];X||(X=!0,W(za));var d=a.length+1,e=[O(Ea(b.thisProgram),\"i8\",0)];c();for(var f=0;f<d-1;f+=1)e.push(O(Ea(a[f]),\"i8\",0)),c();e.push(0);e=O(e,\"i32\",0);try{var h=b._main(d,e,0);Na(h,!0)}catch(l){l instanceof y||(\"SimulateInfiniteLoop\"==l?b.noExitRuntime=!0:((a=l)&&\"object\"===typeof l&&l.stack&&(a=[l,l.stack]),b.e(\"exception thrown: \"+a),b.quit(1,l)))}finally{}};function Oa(a){function c(){if(!b.calledRun&&(b.calledRun=!0,!G)){X||(X=!0,W(za));W(Aa);if(b.onRuntimeInitialized)b.onRuntimeInitialized();b._main&&Pa&&b.callMain(a);if(b.postRun)for(\"function\"==typeof b.postRun&&(b.postRun=[b.postRun]);b.postRun.length;){var c=b.postRun.shift();Ca.unshift(c)}W(Ca)}}a=a||b.arguments;null===Ma&&(Ma=Date.now());if(b.preRun)for(\"function\"==typeof b.preRun&&(b.preRun=[b.preRun]);b.preRun.length;)Da();W(ya);b.calledRun||(b.setStatus?(b.setStatus(\"Running...\"),setTimeout(function(){setTimeout(function(){b.setStatus(\"\")},1);c()},1)):c())}b.run=b.run=Oa;function Na(a,c){if(!c||!b.noExitRuntime){if(!b.noExitRuntime&&(G=!0,z=void 0,W(Ba),b.onExit))b.onExit(a);r&&process.exit(a);b.quit(a,new y(a))}}b.exit=b.exit=Na;var Qa=[];function H(a){void 0!==a?(b.print(a),b.e(a),a=JSON.stringify(a)):a=\"\";G=!0;var c=\"abort(\"+a+\") at \"+na()+\"\\nIf this abort() is unexpected, build with -s ASSERTIONS=1 which can give more information.\";Qa&&Qa.forEach(function(d){c=d(c,a)});throw c}b.abort=b.abort=H;if(b.preInit)for(\"function\"==typeof b.preInit&&(b.preInit=[b.preInit]);0<b.preInit.length;)b.preInit.pop()();var Pa=!0;b.noInitialRun&&(Pa=!1);b.noExitRuntime=!0;Oa();\"use strict\";function applyArabicShaping(input){if(!input){return input}var nDataBytes=(input.length+1)*2;var stringInputPtr=Module._malloc(nDataBytes);Module.stringToUTF16(input,stringInputPtr,nDataBytes);var returnStringPtr=Module.ccall(\"ushape_arabic\",\"number\",[\"number\",\"number\"],[stringInputPtr,input.length]);Module._free(stringInputPtr);if(returnStringPtr===0){return input}var result=Module.UTF16ToString(returnStringPtr);Module._free(returnStringPtr);return result}function mergeParagraphLineBreakPoints(lineBreakPoints,paragraphCount){var mergedParagraphLineBreakPoints=[];for(var i=0;i<paragraphCount;i++){var paragraphEndIndex=Module.ccall(\"bidi_getParagraphEndIndex\",\"number\",[\"number\"],[i]);for(var i$1=0,list=lineBreakPoints;i$1<list.length;i$1+=1){var lineBreakPoint=list[i$1];if(lineBreakPoint<paragraphEndIndex&&(!mergedParagraphLineBreakPoints[mergedParagraphLineBreakPoints.length-1]||lineBreakPoint>mergedParagraphLineBreakPoints[mergedParagraphLineBreakPoints.length-1])){mergedParagraphLineBreakPoints.push(lineBreakPoint)}}mergedParagraphLineBreakPoints.push(paragraphEndIndex)}for(var i$2=0,list$1=lineBreakPoints;i$2<list$1.length;i$2+=1){var lineBreakPoint$1=list$1[i$2];if(lineBreakPoint$1>mergedParagraphLineBreakPoints[mergedParagraphLineBreakPoints.length-1]){mergedParagraphLineBreakPoints.push(lineBreakPoint$1)}}return mergedParagraphLineBreakPoints}function processBidirectionalText(input,lineBreakPoints){if(!input){return[input]}var nDataBytes=(input.length+1)*2;var stringInputPtr=Module._malloc(nDataBytes);Module.stringToUTF16(input,stringInputPtr,nDataBytes);var paragraphCount=Module.ccall(\"bidi_processText\",\"number\",[\"number\",\"number\"],[stringInputPtr,input.length]);if(paragraphCount===0){Module._free(stringInputPtr);return[input]}var mergedParagraphLineBreakPoints=mergeParagraphLineBreakPoints(lineBreakPoints,paragraphCount);var startIndex=0;var lines=[];for(var i=0,list=mergedParagraphLineBreakPoints;i<list.length;i+=1){var lineBreakPoint=list[i];var returnStringPtr=Module.ccall(\"bidi_getLine\",\"number\",[\"number\",\"number\"],[startIndex,lineBreakPoint]);if(returnStringPtr===0){Module._free(stringInputPtr);return[]}lines.push(Module.UTF16ToString(returnStringPtr));Module._free(returnStringPtr);startIndex=lineBreakPoint}Module._free(stringInputPtr);return lines}self.registerRTLTextPlugin({applyArabicShaping:applyArabicShaping,processBidirectionalText:processBidirectionalText})})();\n"

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(28), __webpack_require__(11), __webpack_require__(5), __webpack_require__(50), __webpack_require__(29), __webpack_require__(26), __webpack_require__(54), __webpack_require__(55)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, http, security, urlBuilder, createRequestParams, _, contentTypeConfigurer, asyncRedirectModeCallbackFactory) {

    return function (maxNoOfElementsInBatchRequest, batchEndpoints, securityKeyName) {
        return function (fields, options, originalCallback) {
            var queryParams = {},
                bodyParams = {},
                callback = originalCallback,
                rawBatchItems,
                endpoint;

            queryParams.key = utils.required(security.getKey(securityKeyName));

            rawBatchItems = utils.required(options.batchItems);

            fields = contentTypeConfigurer.setField(fields);
            bodyParams.batchItems = rawBatchItems.map(function (item) {
                var requestParams = createRequestParams(fields, contentTypeConfigurer.setValue(item)),
                    pathParams = requestParams.pathParams,
                    queryParams = requestParams.queryParams,
                    postParams = requestParams.postParams,
                    request;

                request = {
                    query: urlBuilder(batchEndpoints.single, pathParams, queryParams)
                };

                if (!_.isEmpty(postParams)) {
                    request.post = postParams;
                }

                return request;
            });

            if (bodyParams.batchItems.length <= maxNoOfElementsInBatchRequest) {
                endpoint = batchEndpoints.batchSync;
            } else {
                //If batch request is async - set redirectMode to manual and handle download of a result
                endpoint = batchEndpoints.batch;
                queryParams.redirectMode = 'manual';
                callback = asyncRedirectModeCallbackFactory(originalCallback, options);
            }

            http.post({
                url: '{protocol}://' + endpoint,
                queryParameters: queryParams,
                bodyParameters: bodyParams,
                callbackParam: 'callback',
                callback: callback,
                fail: options.fail,
                requestType: 'batch'
            });
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(28), __webpack_require__(11), __webpack_require__(5), __webpack_require__(29), __webpack_require__(26), __webpack_require__(54)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, http, security, createRequestParams, _, contentTypeConfigurer) {

    return function (endpoint, securityKeyName) {
        return function (fields, options, callback) {
            var requestParams = createRequestParams(contentTypeConfigurer.setField(fields), contentTypeConfigurer.setValue(options)),
                pathParams = requestParams.pathParams,
                queryParams = requestParams.queryParams,
                otherParams = requestParams.otherParams,
                httpOptions,
                bodyParams;

            queryParams.key = utils.or(options.key, security.getKey(securityKeyName));
            queryParams.key = utils.required(queryParams.key);

            httpOptions = {
                url: '{protocol}://' + endpoint,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callbackParam: 'callback',
                callback: callback,
                fail: otherParams.fail
            };

            bodyParams = requestParams.postParams;

            if (_.isEmpty(bodyParams)) {
                http.get(httpOptions);
            } else {
                httpOptions.bodyParameters = bodyParams;
                http.post(httpOptions);
            }
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (selector) {
    'use strict';

    return function (json) {
        return selector(json, 'copyrightsCaption');
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * Makes sure that GeopolView object returns the same view code as provided in constructor. It means that this is a
 * correct view code because otherwise GeopolView would fallback to default one.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(35)], __WEBPACK_AMD_DEFINE_RESULT__ = function (GeopolView) {
    'use strict';

    return function (geopolViewCode, serviceType, subType) {
        var geopolView = new GeopolView(geopolViewCode);
        return geopolView.getValueFor(serviceType, subType) === geopolViewCode;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(59), __webpack_require__(61)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, copyright, messageBox) {
    'use strict';

    var boundEventHandler, messageBoxInstance;

    function eventHandler(map) {
        copyright().boundingBox(map.getBounds()).callback(function (result) {
            if (messageBoxInstance) {
                messageBoxInstance.remove();
            }
            messageBoxInstance = messageBox({ content: result }).addTo(map);
        }).go();
    }

    return {
        updateEventHandler: function updateEventHandler(map) {
            var tomtomAttribution = document.querySelector('#' + map.getContainer().id + ' .tomtomAttribution');
            if (tomtomAttribution) {
                if (boundEventHandler) {
                    L.DomEvent.off(tomtomAttribution, 'click', boundEventHandler);
                }
                boundEventHandler = eventHandler.bind(this, map);
                L.DomEvent.on(tomtomAttribution, 'click', boundEventHandler);
            }
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(36), __webpack_require__(60)], __WEBPACK_AMD_DEFINE_RESULT__ = function (T, arrayMerge) {
    'use strict';

    return function (data) {
        var copyright;
        var json = data[0] || data;
        if (data.length > 1) {
            // this is edge of the world case
            json.regions = arrayMerge(data[0].regions, data[1].regions, function (first, second) {
                return first.country.ISO3 === second.country.ISO3;
            });
        }
        copyright = new T('<div id=\'copyrightMessage\'>' + '<h4>General Copyrights:</h4>' + '{{@generalCopyrights}}<p>{{=_val}}</p>{{/@generalCopyrights}}' + '{{@regions}}<h4>{{=_val.country.label}}:</h4>' + '{{_val.copyrightImages}}<img style=\'width: 200px;float:left;\' ' + 'src=\'{{=_val.copyrightImages}}\'/>{{/_val.copyrightImages}}' + '{{@_val.copyrights}}<p>{{=_val}}</p>{{/@_val.copyrights}}{{/@regions}}' + '</div>');
        return copyright.render(json);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(4), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (validators, converters, parameterApplications) {
    return {
        create: function create() {
            return {
                key: { validator: validators.string },
                boundingBox: { validator: validators.boundingBox, converter: converters.boundingBox },
                protocol: { validator: validators.oneOfValue(['http', 'https'], 'protocol') }
            };
        },
        modifyRequestOptions: function modifyRequestOptions(requestOptions) {
            var boundingBox = requestOptions.boundingBox;
            if (boundingBox) {
                requestOptions.minLon = boundingBox.minLon;
                requestOptions.maxLon = boundingBox.maxLon;
                requestOptions.minLat = boundingBox.minLat;
                requestOptions.maxLat = boundingBox.maxLat;
                delete requestOptions.boundingBox;
            }
        },
        /*
        * At this moment it's impossible to map one field to two and more output fields but we need to do this, e.g.
        * bounding box needs to be mapped to topLeft and btmRight. That's why this method tries to fix this
        */
        modifyFields: function modifyFields(fields) {
            var resultFields = Object.assign({}, fields);

            var coordinateParameterDefinition = {
                application: parameterApplications.PATH
            };

            resultFields.minLon = coordinateParameterDefinition;
            resultFields.maxLon = coordinateParameterDefinition;
            resultFields.minLat = coordinateParameterDefinition;
            resultFields.maxLat = coordinateParameterDefinition;

            return resultFields;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This layer groups functionality of
 * <a href="../classes/L.TomTomTrafficLayer.html" class="alert-link"> traffic layer </a>
 * and <a href="../classes/L.TomTomTrafficIncidentsLayer.html" class="alert-link"> traffic incidents </a>
 * In most situations you will want to use these layers together and refresh them at the same time, so
 * we are providing this layer to make your work easier.
 *
 * If you use this layer there will be only one timer and it will issue only one request to check if
 * traffic data is up to date. If you create layers on your own, each layer will have it's own timer and
 * will check for data freshness on its own. You can specify how ofter the data should be refreshed.
 *
 *
 * @class TomTomTrafficWithIncidentsLayer
 * @extends L.LayerGroup
 * @namespace L
 * @module Map
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#layergroup">Leaflet's LayerGroup</a>
 *     class allows. The additional options, which are TomTom specific, are described below.
 * @param {Object|Boolean} [options.traffic] Options which will be used for traffic and traffic incidents layers.
 * Please refer to the
 * <a href="../classes/L.TomTomTrafficLayer.html" class="alert-link"> docs </a>
 * to check what options you can use.
 * @param {Number} [options.refresh=30000] The traffic and traffic incidents information changes and needs to be updated
 *     periodically. By default, it is refreshed every 30 seconds. This parameter's value represents the time
 *     in milliseconds between each update interval. The value must be 30000 or greater.
 */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(14), __webpack_require__(131), __webpack_require__(63)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, trafficRefresher, trafficLayer, trafficIncidentsLayer) {

    L.TomTomTrafficWithIncidentsLayer = L.LayerGroup.extend({
        initialize: function initialize(options) {
            L.setOptions(this, options);
        },
        _trafficModelIdCallback: function _trafficModelIdCallback(trafficModelId) {
            this.trafficLayer.setTrafficModelId(trafficModelId);
            this.incidentsLayer.setTrafficModelId(trafficModelId);
        },
        /**
        * Name of traffic with incidents layer. It can be used to differentiate layers.
        * @property name
        * @default "trafficWithIncidents"
        * @type String
        */
        name: 'trafficWithIncidents',
        options: {
            pane: 'tilePane'
        },
        onAdd: function onAdd(map) {
            var trafficOptions = L.setOptions({ options: { _noRefresher: true } }, this.options);
            this.trafficLayer = trafficLayer(trafficOptions);
            this.incidentsLayer = trafficIncidentsLayer(trafficOptions);
            this.trafficLayerWithIncidents = L.layerGroup([this.trafficLayer, this.incidentsLayer]);
            this.trafficRefresherIntervalId = trafficRefresher.addRefresherWithModelId(undefined, this._trafficModelIdCallback, this);
            map.addLayer(this.trafficLayerWithIncidents);
        },
        onRemove: function onRemove() {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficLayerWithIncidents.remove();
        },
        updateOptions: function updateOptions(options) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficRefresherIntervalId = trafficRefresher.addRefresherWithModelId(options, this._trafficModelIdCallback, this);
            L.setOptions(this, options);
        }
    });

    L.tomTomTrafficWithIncidentsLayer = function (options) {
        return new L.TomTomTrafficWithIncidentsLayer(options);
    };

    return L.tomTomTrafficWithIncidentsLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Provides the current traffic model id which is the traffic model number needed for the Traffic API -
 * Incidents Layer, and the {{#crossLink "TrafficIncidents"}}Traffic API - Incident Details{{/crossLink}}
 * calls.
 *
 * It is updated every minute, and is valid for two minutes before it times out.
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "TrafficModelId/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "TrafficModelId/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class TrafficModelId
 * @uses Chain
 * @module Services
 * @uses KeyMixin
 * @uses ProtocolMixin
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 *
 * @example
 * ```js
 * function callbackFn(response) {
 *   console.log(response);
 * }
 * tomtom.trafficModelId()
 *   .key("<Your API key>")
 *   .go(callbackFn);
 * ```
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(129), __webpack_require__(130), __webpack_require__(8), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restTrafficViewport, model, chain, validators) {
    'use strict';

    var fields = {
        key: { validator: validators.string },
        protocol: { validator: validators.oneOfValue(['http', 'https'], 'protocol') }
    };

    var trafficViewport = restTrafficViewport();

    function handleChain(data, callback) {
        trafficViewport.trafficViewport(fields, data, function (response) {
            callback.call(this, model(response));
        });
    }

    return function (options) {
        return chain(fields, handleChain, options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(10), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    return function () {
        return {
            trafficViewport: requestFactory.single(endpoints.trafficViewport, ApiKeyNames.traffic)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (selector) {
    'use strict';

    return function (json) {
        return selector(json, 'viewpResp.trafficState.@trafficModelId') || -1;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Tile layer for Leaflet that shows styled traffic tubes using
 * [Traffic API](https://developer.tomtom.com/traffic-api)
 * from TomTom.
 *
 * @class TomTomTrafficLayer
 * @extends L.TileLayer
 * @module Map
 * @namespace L
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#tilelayer-options">Leaflet's TileLayer</a>
 *     allows.
 *     The additional options, which are TomTom specific, are described below.
 * @param {String} [options.key] API key that can be obtained from
 *     [TomTom's developer portal](https://developer.tomtom.com).
 *     This is a key for the traffic services.
 * @param {"s1"|"s2"|"s3"|"night"} [options.style="night"] The traffic layer style to use
 * @param {Number} [options.opacity=0.8] The traffic incidents layer's opacity set by default to 80%.
 *     A floating point value between `0` and `1` have to be used, where `1` means no transparency.
 * @param {Boolean} [options.noRefresh] Disables periodic updates of traffic layers.
 * @param {Number} [options.refresh=30000] The traffic incidents information changes and needs to be updated
 *     periodically. By default, it is refreshed every 30 seconds. This parameter's value represents the time
 *     in milliseconds between each update interval. The value must be 30000 or greater.
 *
 */
/**
 * Name of traffic layer. It can be used to differentiate layers.
 * @property name
 * @default "traffic"
 * @type String
 */

/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(5), __webpack_require__(11), __webpack_require__(6), __webpack_require__(14), __webpack_require__(12), __webpack_require__(37), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, security, http, endpoints, trafficRefresher, analytics, tileSetTransform, Utils) {
    'use strict';

    var trafficStyles = ['s1', 's2', 's3', 'night'];

    function getTrafficStyle(trafficLayer) {
        var style = 'night',
            i;
        if (Utils.isString(trafficLayer)) {
            for (i = 0; i < trafficStyles.length; i += 1) {
                if (trafficStyles[i] === trafficLayer.toLowerCase()) {
                    return trafficStyles[i];
                }
            }
        }
        return style;
    }

    function handleSubdomains(options) {
        if (Utils.isString(options.subdomains)) {
            options.subdomains = options.subdomains.split('');
        }
    }

    function loadAnimation() {
        var opacity = 'opacity',
            back = this._bgBuffer;
        back.style[L.DomUtil.TRANSITION] = opacity + ' 10';
        back.style[opacity] = 0.1;
        this._tileContainer.style[opacity] = this.options.opacity;
    }

    var emptyTileUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAB9JREFUGBntwQENAAAAwiD7p34ON2AAAAAAAAAAAOcCIQAAAfWivQQAAAAASUVORK5CYII='; //eslint-disable-line

    L.TomTomTrafficLayer = L.TileLayer.extend({
        options: {
            attribution: '',
            minZoom: 2,
            maxZoom: 18,
            subdomains: 'abcd',
            reuseTiles: true,
            opacity: 0.8,
            errorTileUrl: emptyTileUrl,
            detectRetina: false,
            trafficModelId: '-1',
            refresh: 30000,
            zIndex: 230
        },
        /**
         * Name of traffic layer. It can be used to differentiate layers.
         * @property name
         * @default "traffic"
         * @type String
         */
        name: 'traffic',
        initialize: function initialize(options) {
            var key;
            options = L.setOptions(this, options);
            if (options.bounds) {
                options.bounds = L.latLngBounds(options.bounds);
            }
            security.setKey('services/traffic', options.key);
            key = security.getKey('services/traffic');
            options.accessToken = key;
            this._requestUrl = http.protocol() + '://' + endpoints.trafficLayer + '?t={trafficModelId}' + (key ? '&key={accessToken}' : '');
            this._url = this._requestUrl;
            options.style = getTrafficStyle(options.style);
            handleSubdomains(options);
            options.tileSize = options.detectRetina && L.Browser.retina ? 512 : 256;
            if (options.tileSize === 512) {
                options.zoomOffset -= 1;
                options.minZoom = options.minZoom > 0 ? options.minZoom - 1 : 0;
            }
            this.setOpacity(options.opacity);

            tileSetTransform.fixTileScale.call(this);
        },
        onAdd: function onAdd(map) {
            L.TileLayer.prototype.onAdd.call(this, map);
            if (this._animated) {
                this.on('load', loadAnimation);
            }
            this._updateOpacity();
            this.trafficRefresherIntervalId = trafficRefresher.addRefresherWithModelId(undefined, this.setTrafficModelId, this);
        },
        onRemove: function onRemove(map) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            L.TileLayer.prototype.onRemove.call(this, map);
        },
        updateOptions: function updateOptions(options) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficRefresherIntervalId = trafficRefresher.addRefresherWithModelId(options, this.setTrafficModelId, this);
            L.setOptions(this, options);
        },
        setTrafficModelId: function setTrafficModelId(trafficModelId) {
            if (this.options.trafficModelId !== trafficModelId) {
                this.options.trafficModelId = trafficModelId;
                this.redraw();
            }
        },
        createTile: function createTile(coords, done) {
            var tile;
            if (this.options.trafficModelId === '-1') {
                tile = document.createElement('img');
                tile.src = emptyTileUrl;
                done(null, tile);
                return tile;
            }
            return analytics.customCreateTile(coords, done, this);
        }
    });

    L.tomTomTrafficLayer = function (options) {
        return new L.TomTomTrafficLayer(options);
    };

    return L.tomTomTrafficLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(10), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    return function () {
        return {
            incidentsDetails: requestFactory.single(endpoints.trafficIncidents, ApiKeyNames.traffic)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(60)], __WEBPACK_AMD_DEFINE_RESULT__ = function (arrayMerge) {
    'use strict';

    var _getFeature;
    var incidentCategories = {
        0: 'Unknown',
        1: 'Accident',
        2: 'Fog',
        3: 'Dangerous Conditions',
        4: 'Rain',
        5: 'Ice',
        6: 'Jam',
        7: 'Lane Closed',
        8: 'Road Closed',
        9: 'Road Works',
        10: 'Wind',
        11: 'Flooding',
        12: 'Detour',
        13: 'Cluster'
    };

    var incidentSeverities = { 0: 'unknown', 1: 'minor', 2: 'moderate', 3: 'major', 4: 'undefined' };

    function newFeature(properties, type) {
        return {
            type: 'Feature',
            geometry: { type: type, coordinates: [] },
            properties: properties
        };
    }

    function newFeatureCollection(properties) {
        var featureCollection = {
            type: 'FeatureCollection',
            features: []
        };
        if (properties) {
            featureCollection.properties = properties;
        }
        return featureCollection;
    }

    function setProperty(property, propertyName, properties) {
        if (property) {
            properties[propertyName] = property;
        }
    }

    _getFeature = function getFeature(poi, preserveCluster) {
        var feature,
            i,
            properties = {};
        properties.id = poi.id;
        if (poi.cbl && poi.ctr) {
            properties.clusterBounds = [[poi.cbl.y, poi.cbl.x], [poi.ctr.y, poi.ctr.x]];
        }
        if (poi.op) {
            properties.originalPosition = [poi.op.y, poi.op.x];
        }
        if (poi.ic) {
            properties.incidentCategory = incidentCategories[poi.ic];
        }
        if (poi.ty) {
            properties.incidentSeverity = incidentSeverities[poi.ty];
        }
        setProperty(poi.cs, 'clusterSize', properties);
        setProperty(poi.d, 'description', properties);
        setProperty(poi.c, 'incidentCause', properties);
        setProperty(poi.f, 'from', properties);
        setProperty(poi.t, 'to', properties);
        setProperty(poi.r, 'roadNumber', properties);
        setProperty(poi.dl, 'delaySeconds', properties);
        setProperty(poi.l, 'lengthMeters', properties);
        if (poi.cpoi && !preserveCluster) {
            properties.clusterCoordinates = [poi.p.x, poi.p.y];
            feature = newFeatureCollection(properties);
            for (i = 0; i < poi.cpoi.length; i += 1) {
                feature.features.push(_getFeature(poi.cpoi[i], false));
            }
        } else {
            if (poi.cpoi) {
                properties.features = poi.cpoi.map(_getFeature);
            }
            feature = newFeature(properties, 'Point');
            feature.geometry.coordinates = [poi.p.x, poi.p.y];
        }
        return feature;
    };

    return function (preserveCluster) {
        return function (data) {
            var result = newFeatureCollection(null),
                json = data[0] || data,
                i;
            if (!json || !json.tm || !json.tm.poi) {
                return result;
            }
            if (data.length > 1) {
                // this is edge of the world case
                json.tm.poi = arrayMerge(data[0].tm.poi, data[1].tm.poi, function (first, second) {
                    return first.id === second.id;
                });
            }
            for (i = 0; i < json.tm.poi.length; i += 1) {
                result.features.push(_getFeature(json.tm.poi[i], preserveCluster));
            }
            return result;
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* jshint nomen:false */
// eslint-disable-next-line no-unused-vars
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(36), __webpack_require__(65)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, T, incidentMarker) {
    'use strict';

    var clusterPopupTemplate = new T('    <div>' + '    <div><b>Incidents in this area: {{=incidentsNo}}</b></div>' + '    <hr/>' + '    <div><b>{{=features.length}} most severe incidents</b>' + '        <span style="color: lightgray">(Ordered by severity and delay)</span>' + '    </div>' + '    <hr/>' + '    <div style="font-weight: bold">' + '        <div class="cluster-popup-category-column">Category</div>' + '        <div class="cluster-popup-length-column">Length</div>' + '        <div class="cluster-popup-streets-column">Streets</div>' + '        <div style="clear: both"></div>' + '        <hr/>' + '    </div>' + '    {{@features}}' + '        <div>' + '            <div class="cluster-popup-category-column">' + '                <div class="traffic-icon">' + '                    <div class="icon-circle-{{=_val.properties.incidentSeverity}}">' + '                        <div class="icon-{{=_val.properties.icon}}-white"></div>' + '                    </div>' + '                </div>' + '            </div>' + '            <div class="cluster-popup-length-column">' + '                {{=_val.properties.formattedLength}}' + '            </div>' + '            <div class="cluster-popup-streets-column">' + '                <div><span>From:</span>{{=_val.properties.from}}</div>' + '                <div><span>To:</span>{{=_val.properties.to}}</div>' + '            </div>' + '            <div style="clear: both"></div>' + '            <hr/>' + '        </div>' + '    {{/@features}}' + '</div>');

    function compareDelays(p1, p2) {
        var d1 = p1.delaySeconds || 0;
        var d2 = p2.delaySeconds || 0;
        return d2 - d1;
    }

    function compareSeverity(p1, p2, severity) {
        var is1 = p1.incidentSeverity;
        var is2 = p2.incidentSeverity;
        if (is1 === severity) {
            return -1;
        } else if (is2 === severity) {
            return 1;
        }
        return 0;
    }

    function featuresComparator(f1, f2) {
        var severities = ['major', 'moderate', 'minor', 'unknown', 'undefined'];
        var severityComparisonResult = 0;
        var i;

        var p1 = f1.properties;
        var p2 = f2.properties;

        if (p1.incidentSeverity === p2.incidentSeverity) {
            return compareDelays(p1, p2);
        }

        for (i = 0; i < severities.length; ++i) {
            severityComparisonResult = compareSeverity(p1, p2, severities[i]);
            if (severityComparisonResult !== 0) {
                return severityComparisonResult;
            }
        }

        return severityComparisonResult;
    }

    function formatLength(lengthInMeters) {
        if (!lengthInMeters) {
            return '---';
        }

        if (lengthInMeters > 1000) {
            return (lengthInMeters / 1000).toPrecision(3) + ' km';
        }
        return lengthInMeters + ' m';
    }

    function getIconOptions(feature) {
        var severity = feature.properties.incidentSeverity || 'unknown';
        var clusterSize = feature.properties.clusterSize;

        return {
            icon: null,
            popupAnchor: [0, -5],
            background: { iconSize: [20, 20], iconAnchor: [10, 10], icon: 'icon-circle-' + severity },
            content: {
                content: clusterSize < 100 ? clusterSize : '99+',
                iconSize: [20, 20],
                iconAnchor: [0, 0],
                style: { 'color': '#fff', 'font-weight': 'bold', 'font-size': '11px' }
            }
        };
    }

    L.Marker.ClusterIncidentMarker = L.Marker.IncidentMarker.extend({
        options: {
            createPopup: true
        },
        onAdd: function onAdd(map) {
            this._map = map;
            if (!this.options.createPopup) {
                this.on('click', this._onClick, this);
            }
            L.Marker.prototype.onAdd.call(this, map);
        },
        onRemove: function onRemove(map) {
            if (!this.options.createPopup) {
                this.off('click', this._onClick, this);
            }
            L.Marker.prototype.onRemove.call(this, map);
        },
        _onClick: function _onClick() {
            if (this.feature.properties.clusterBounds) {
                this._map.fitBounds(this.feature.properties.clusterBounds);
            } else {
                this._map.setZoomAround(this.getLatLng(), this._map.getZoom() + 2);
            }
        },
        _updateIcon: function _updateIcon() {
            this.setIcon(L.svgIcon(getIconOptions(this.feature)));
        },
        _updatePopup: function _updatePopup() {
            var popupContent;
            var featuresToShow;
            if (!this.options.createPopup) {
                return;
            }

            featuresToShow = this.feature.properties.features.slice(0).sort(featuresComparator).slice(0, 4).map(function (feature) {
                var properties = Object.assign({}, feature.properties, {
                    icon: this.iconsMapping[feature.properties.incidentCategory],
                    formattedLength: formatLength(feature.properties.lengthMeters)
                });
                return Object.assign({}, feature, {
                    properties: properties
                });
            }, this);

            popupContent = clusterPopupTemplate.render({
                features: featuresToShow,
                incidentsNo: this.feature.properties.features.length
            });

            if (this.getPopup()) {
                this.setPopupContent(popupContent);
            } else {
                this.bindPopup(popupContent, { autoPan: false });
            }
        }
    });

    return function (feature, latlng, options) {
        if (!feature || !feature.properties) {
            return null;
        }

        return new L.Marker.ClusterIncidentMarker(feature, latlng, {
            createPopup: options.createPopupForCluster
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Class that represents a unit of measurement.
 *
 * @class Unit
 * @module Models
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (unitTypes) {
    'use strict';

    function Unit(unit) {
        if (!(unit in unitTypes)) {
            console.warn('Incorrect unit passed: ' + unit + '. Defaulted to metric');
            unit = unitTypes.metric;
        }
        this.unit = unit;
    }

    /**
     * Returns the label of the unit.
     * @method getLabel
     * @return {String}
     */
    Unit.prototype.getLabel = function () {
        return this.unit;
    };

    return Unit;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This is an extension to Leaflet allowing to display TomTom traffic flow layer. It is based on  the raster L.TileLayer
 * implementation. The possible options are described below.
 *
 * @class TomTomTrafficFlowLayer
 * @extends L.TileLayer
 * @namespace L
 * @module Map
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#tilelayer-options">Leaflet's TileLayer</a>
 *     allows.
 *     The additional options, which are TomTom specific, are described below.
 * @param {"absolute"|"relative"|"relative-delay"} [options.style="absolute"] The traffic flow style to be displayed.
 *     It should be set to one of the following values:
 * - `"absolute"` makes the colours of the road segments reflect a measured absolute speed.
 * - `"relative"` returns a speed relative to the free-flow traffic information, highlighting areas of congestion.
 * - `"relative-delay"` displays relative speeds only in places where they are different from the free-flow speed
 *   (no green segments shown).
 * @param {Number} [options.opacity=0.7] The traffic flow layer's opacity, set by default to 70%.
 *     A floating point value between `0` and `1` have to be used, where `1` means no transparency.
 * @param {Boolean} [options.noRefresh] Disables periodic updates of traffic flow layer.
 * @param {Number} [options.refresh=180000] The traffic flow information changes and needs to be updated periodically.
 *     By default, it is refreshed every 3 minutes. This parameter's value represents the time in milliseconds between
 *     each update interval. The value must be 30000 or greater.
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(5), __webpack_require__(11), __webpack_require__(6), __webpack_require__(66), __webpack_require__(67), __webpack_require__(14), __webpack_require__(12), __webpack_require__(37), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, security, http, endpoints, animator, optionsComplementor, trafficRefresher, analytics, tileSetTransform, Utils) {
    'use strict';

    var trafficFlowStyles = ['absolute', 'relative', 'relative-delay'];

    function getTrafficFlowStyle(trafficFlowLayer) {
        var style = 'absolute',
            i;
        if (Utils.isString(trafficFlowLayer)) {
            for (i = 0; i < trafficFlowStyles.length; i += 1) {
                if (trafficFlowStyles[i] === trafficFlowLayer.toLowerCase()) {
                    return trafficFlowStyles[i];
                }
            }
        }
        return style;
    }

    L.TomTomTrafficFlowLayer = L.TileLayer.extend({
        options: {
            attribution: '',
            minZoom: 2,
            maxZoom: 18,
            subdomains: 'abcd',
            reuseTiles: true,
            opacity: 0.7,
            style: 'absolute',
            refresh: 180000,
            errorTileUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAB9JREFUGBntwQENAAAAwiD7p34ON2AAAAAAAAAAAOcCIQAAAfWivQQAAAAASUVORK5CYII=', //eslint-disable-line
            detectRetina: false,
            zIndex: 220
        },
        /**
         * Name of traffic flow layer. It can be used to differentiate layers.
         * @property name
         * @default "trafficFlow"
         * @type String
         */
        name: 'trafficFlow',
        initialize: function initialize(options) {
            var key;
            options = L.setOptions(this, options);
            if (options.bounds) {
                options.bounds = L.latLngBounds(options.bounds);
            }
            security.setKey('services/trafficFlow', options.key);
            key = security.getKey('services/trafficFlow');
            options.accessToken = key;
            this._url = http.protocol() + '://' + endpoints.trafficFlowLayer + (key ? '?key={accessToken}' : '');
            options.style = getTrafficFlowStyle(options.style);
            optionsComplementor.fillInSubdomainsOptions(options);
            optionsComplementor.fillInTiles512Options(options);
            this.setOpacity(options.opacity);

            tileSetTransform.fixTileScale.call(this);
        },
        onAdd: function onAdd(map) {
            L.TileLayer.prototype.onAdd.call(this, map);
            if (this._animated) {
                this.on('load', animator.loadAnimationFactory(this));
            }
            this._updateOpacity();
            this.trafficRefresherIntervalId = trafficRefresher.add(this.options, this.redraw.bind(this));
        },
        onRemove: function onRemove(map) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            L.TileLayer.prototype.onRemove.call(this, map);
        },
        updateOptions: function updateOptions(options) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficRefresherIntervalId = trafficRefresher.add(options, this.redraw.bind(this));
            L.setOptions(this, options);
        },
        createTile: function createTile(coords, done) {
            return analytics.customCreateTile(coords, done, this);
        }
    });

    L.tomTomTrafficFlowLayer = function (options) {
        return new L.TomTomTrafficFlowLayer(options);
    };

    return L.tomTomTrafficFlowLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* jshint nomen:false */
/**
 * Tile layer for Leaflet that uses the
 * <a href="https://developer.tomtom.com/traffic-api/traffic-api-documentation-traffic-flow/vector-flow-tiles">
 * Vector Flow Tiles</a> from Traffic API.
 *
 * The current vector renderer implementation is based on the
 * [Mapbox GL JS library](https://www.mapbox.com/mapbox-gl-js/api/).
 *
 * @example
 * ```js
 * var ttVectorTrafficLayer = new L.TomTomVectorTrafficFlowLayer({
 *      key: '<Your Traffic Flow API key>',
 *      refresh: 30000,
 *      basePath: '<SDK base path>',
 *      style: 'relative'
 * });
 *
 * map.addLayer(ttVectorTrafficLayer);
 * ```
 *
 * @class TomTomVectorTrafficFlowLayer
 * @namespace L
 * @module Map
 * @extends L.TomTomVectorLayer
 * @constructor
 * @param {"absolute"|"relative"|"relative-delay"} [options.style="absolute"] Specifies the style and type of
 * Traffic Flow
 * @param {String} [options.key] Traffic Flow API key that can be obtained from
 *     <a href="https://developer.tomtom.com">TomTom's developer portal</a>.
 * @param {Integer} [options.refresh=30000] Traffic refresh inteval in milliseconds. The default value is 30 seconds.
 * If a lower value is provided the default value is used.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(23), __webpack_require__(24), __webpack_require__(5), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, VectorLayer, labelsLayerMixinFactory, security, ApiKeyNames) {
    'use strict';

    var TomTomVectorTrafficFlowLayer = VectorLayer.extend({
        defaultOptions: {
            refresh: 30000,
            style: 'absolute',
            basePath: '/sdk'
        },
        /**
         * Name of the vector traffic flow layer. It can be used to differentiate layers.
         * @property name
         * @default "vectorTrafficFlow"
         * @type String
         */
        name: 'vectorTrafficFlow',
        layerSourceName: 'vectorTilesTraffic',
        refreshIntervalToken: null,
        initialize: function initialize(options) {
            this.validateOptions(options);
            this.layerOptions = this.getLayerOptions(options);
            VectorLayer.prototype.initialize.call(this, this.layerOptions);
            security.setKey(ApiKeyNames.trafficFlow, this.layerOptions.key);
            this.refresh = this.refresh.bind(this);
        },
        onAdd: function onAdd(map) {
            VectorLayer.prototype.onAdd.call(this, map);
            this.bringToFront();
            this.startRefresh();
        },
        onRemove: function onRemove(map) {
            this.stopRefresh();
            VectorLayer.prototype.onRemove.call(this, map);
        },
        getLayerOptions: function getLayerOptions(opts) {
            var layer = this.defaultOptions.style;
            var options = L.extend({}, this.defaultOptions, opts);

            if (['relative', 'relative-delay'].indexOf(options.style) >= 0) {
                layer = options.style;
            }

            return L.extend({}, options, {
                style: 'vectorTrafficFlow',
                layer: layer,
                refresh: Math.max(this.defaultOptions.refresh, options.refresh),
                securityKeyName: ApiKeyNames.trafficFlow,
                vector: {
                    renderer: {
                        refreshExpiredTiles: false
                    }
                },
                styleUrlMapping: {
                    vectorTrafficFlow: {
                        'absolute': options.basePath + '/styles/flow_absolute.json',
                        'relative': options.basePath + '/styles/flow_relative.json',
                        'relative-delay': options.basePath + '/styles/flow_relative-delay.json'
                    }
                }
            });
        },
        validateOptions: function validateOptions(options) {
            if (options && options.refresh && !Number.isInteger(options.refresh)) {
                throw new Error('The refresh value must be an Integer but ' + _typeof(options.refresh) + ' was provided.');
            }
        },
        getSourceCache: function getSourceCache() {
            var cache = this._glMap && this._glMap.style && this._glMap.style.sourceCaches && this._glMap.style.sourceCaches[this.layerSourceName];
            if (!cache) {
                // we could just return cache, but this could be any falsy type
                return null;
            }
            return cache;
        },

        startRefresh: function startRefresh() {
            var refreshRate = this.layerOptions.refresh;
            this.stopRefresh();
            if (refreshRate <= 0) {
                return;
            }
            this.refreshIntervalToken = setInterval(this.refresh, refreshRate);
        },
        refresh: function refresh() {
            var i;
            var cache = this.getSourceCache();
            if (!cache) {
                // don't stop refreshing,
                // this could be recovered in the next call
                return;
            }
            // calling cache.reload() is not efficient enough,
            // because it will call _reloadTile with state different than 'expired'
            // and will not force tile to be downladed again.
            for (i in cache._tiles) {
                if (cache._tiles.hasOwnProperty(i)) {
                    cache._reloadTile(i, 'expired');
                }
            }
            cache.clearTiles();
        },
        stopRefresh: function stopRefresh() {
            if (this.refreshIntervalToken) {
                this.refreshIntervalToken = clearInterval(this.refreshIntervalToken);
            }
        },
        updateOptions: function updateOptions(options) {
            if (options.style) {
                this.layerOptions = this.getLayerOptions(options);
                VectorLayer.prototype.updateOptions.call(this, this.layerOptions);
                this.startRefresh();
            }
        }
    });

    L.TomTomVectorTrafficFlowLayer = TomTomVectorTrafficFlowLayer.extend(labelsLayerMixinFactory('vectorTrafficFlow'));

    L.tomTomVectorTrafficFlowLayer = function tomTomVectorTrafficFlowLayer(options) {
        return new L.TomTomVectorTrafficFlowLayer(options);
    };

    return L.tomTomVectorTrafficFlowLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(27)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, mapboxProvider) {

    L.MapboxGL = L.Layer.extend({

        initialize: function (options) {
            L.setOptions(this, options);

            if (options.renderer && options.renderer.accessToken) {
                mapboxProvider.getMapbox().accessToken = options.renderer.accessToken;
            } else {
                throw new Error('You should provide a Mapbox GL access token as a token option.');
            }

        },

        _getPane: function () {
            return this._parentPane || this._map.getPanes().tilePane;
        },

        _setPane: function (pane) {
            this._parentPane = pane;
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onAdd: function (map) {
            this._map = map;

            if (!this._glContainer) {
                this._initContainer();
            }

            this._getPane().appendChild(this._glContainer);

            this._initGL();

            this._offset = this._map.containerPointToLayerPoint([0, 0]);

            // work around https://github.com/mapbox/mapbox-gl-leaflet/issues/47
            if (map.options.zoomAnimation && map._proxy) {
                L.DomEvent.on(map._proxy, L.DomUtil.TRANSITION_END, this._transitionEnd, this);
            }

            this._update();
        },

        onRemove: function (map) {
            //COM
            //map._removeZoomLimit(this);
            if (this._map.options.zoomAnimation && this._map._proxy) {
                L.DomEvent.off(this._map._proxy, L.DomUtil.TRANSITION_END, this._transitionEnd, this);
            }

            this._getPane().removeChild(this._glContainer);
            this._glMap.remove();
            this._glMap = null;
        },

        getEvents: function () {
            return {
                move: this._update,
                zoomanim: this._animateZoom, // apply the zoom animation to the <canvas>
                zoom: this._pinchZoom, // animate every zoom event for smoother pinch-zooming
                zoomstart: this._zoomStart, // flag starting a zoom to disable panning
                zoomend: this._zoomEnd
            };
        },

        _initContainer: function () {
            var container = this._glContainer = L.DomUtil.create('div', 'leaflet-gl-layer');

            var size = this._map.getSize();
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
        },

        _initGL: function () {
            var center = this._map.getCenter();

            var options = L.extend({}, this.options.renderer, {
                container: this._glContainer,
                interactive: false,
                center: [center.lng, center.lat],
                zoom: this._map.getZoom() - 1,
                attributionControl: false
            });

            this._glMap = new (mapboxProvider.getMapbox()).Map(options);

            // allow GL base map to pan beyond min/max latitudes
            this._glMap.transform.latRange = null;

            if (this._glMap._canvas.canvas) {
                // older versions of mapbox-gl surfaced the canvas differently
                this._glMap._actualCanvas = this._glMap._canvas.canvas;
            } else {
                this._glMap._actualCanvas = this._glMap._canvas;
            }

            // treat child <canvas> element like L.ImageOverlay
            L.DomUtil.addClass(this._glMap._actualCanvas, 'leaflet-image-layer');
            L.DomUtil.addClass(this._glMap._actualCanvas, 'leaflet-zoom-animated');
        },

        _update: function () {
            // update the offset so we can correct for it later when we zoom
            this._offset = this._map.containerPointToLayerPoint([0, 0]);

            if (this._zooming) {
                return;
            }

            var size = this._map.getSize(),
              container = this._glContainer,
              gl = this._glMap,
              topLeft = this._map.containerPointToLayerPoint([0, 0]);

            L.DomUtil.setPosition(container, topLeft);

            var center = this._map.getCenter();

            // gl.setView([center.lat, center.lng], this._map.getZoom() - 1, 0);
            // calling setView directly causes sync issues because it uses requestAnimFrame

            var tr = gl.transform;
            tr.center = mapboxProvider.getMapbox().LngLat.convert([center.lng, center.lat]);
            tr.zoom = this._map.getZoom() - 1;

            if (gl.transform.width !== size.x || gl.transform.height !== size.y) {
                container.style.width = size.x + 'px';
                container.style.height = size.y + 'px';
                if (gl._resize !== null && gl._resize !== undefined) {
                    gl._resize();
                } else {
                    gl.resize();
                }
            } else {
                gl._update();
            }
        },

        // update the map constantly during a pinch zoom
        _pinchZoom: function (e) {
            this._glMap.jumpTo({
                zoom: this._map.getZoom() - 1,
                center: this._map.getCenter()
            });
        },

        // borrowed from L.ImageOverlay https://github.com/Leaflet/Leaflet/blob/master/src/layer/ImageOverlay.js#L139-L144
        _animateZoom: function (e) {
            var scale = this._map.getZoomScale(e.zoom),
              offset = this._map._latLngToNewLayerPoint(this._map.getBounds().getNorthWest(), e.zoom, e.center);

            L.DomUtil.setTransform(this._glMap._actualCanvas, offset.subtract(this._offset), scale);
        },

        _zoomStart: function (e) {
            this._zooming = true;
        },

        _zoomEnd: function () {
            var scale = this._map.getZoomScale(this._map.getZoom()),
              offset = this._map._latLngToNewLayerPoint(this._map.getBounds().getNorthWest(), this._map.getZoom(), this._map.getCenter());

            L.DomUtil.setTransform(this._glMap._actualCanvas, offset.subtract(this._offset), scale);
            this._zooming = false;

            this._update();
        },

        _transitionEnd: function (e) {
            L.Util.requestAnimFrame(function () {
                var zoom = this._map.getZoom(),
                  center = this._map.getCenter(),
                  offset = this._map.latLngToContainerPoint(this._map.getBounds().getNorthWest());

                // reset the scale and offset
                L.DomUtil.setTransform(this._glMap._actualCanvas, offset, 1);

                // enable panning once the gl map is ready again
                this._glMap.once('moveend', L.Util.bind(function () {
                    this._zoomEnd();
                }, this));

                // update the map position
                this._glMap.jumpTo({
                    center: center,
                    zoom: zoom - 1
                });
            }, this);
        }
    });

    L.mapboxGL = function (options) {
        return new L.MapboxGL(options);
    };

    return L.MapboxGL;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This layer groups functionality of
 * <a href="../classes/L.TomTomTrafficLayer.html" class="alert-link"> traffic layer </a>
 * and <a href="../classes/L.TomTomTrafficIncidentsLayer.html" class="alert-link"> traffic incidents </a>
 * In most situations you will want to use these layers together and refresh them at the same time, so
 * we are providing this layer to make your work easier.
 *
 * If you use this layer there will be only one timer and it will issue only one request to check if
 * traffic data is up to date. If you create layers on your own, each layer will have it's own timer and
 * will check for data freshness on its own. You can specify how ofter the data should be refreshed.
 *
 *
 * @class TomTomTrafficWithIncidentsLayer
 * @extends L.LayerGroup
 * @namespace L
 * @module Map
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#layergroup">Leaflet's LayerGroup</a>
 *     class allows. The additional options, which are TomTom specific, are described below.
 * @param {Object|Boolean} [options.traffic] Options which will be used for traffic and traffic incidents layers.
 * Please refer to the
 * <a href="../classes/L.TomTomTrafficLayer.html" class="alert-link"> docs </a>
 * to check what options you can use.
 * @param {Number} [options.refresh=30000] The traffic and traffic incidents information changes and needs to be updated
 *     periodically. By default, it is refreshed every 30 seconds. This parameter's value represents the time
 *     in milliseconds between each update interval. The value must be 30000 or greater.
 */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(14), __webpack_require__(140), __webpack_require__(63)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, trafficRefresher, vectorTrafficIncidents, trafficIncidentsLayer) {

    L.TomTomVectorTrafficWithIncidentsLayer = L.LayerGroup.extend({
        initialize: function initialize(options) {
            L.setOptions(this, options);
        },
        _trafficModelIdCallback: function _trafficModelIdCallback(trafficModelId) {
            this.vectorTrafficIncidents.setTrafficModelId(trafficModelId);
            this.incidentsLayer.setTrafficModelId(trafficModelId);
        },
        /**
        * Name of traffic with incidents layer. It can be used to differentiate layers.
        * @property name
        * @default "vectorTrafficWithIncidents"
        * @type String
        */
        name: 'vectorTrafficWithIncidents',
        options: {
            pane: 'tilePane'
        },
        onAdd: function onAdd(map) {
            var trafficOptions = L.setOptions({ options: { _noRefresher: true } }, this.options);
            this.vectorTrafficIncidents = vectorTrafficIncidents(trafficOptions);
            this.incidentsLayer = trafficIncidentsLayer(trafficOptions);
            this.trafficLayerWithIncidents = L.layerGroup([this.vectorTrafficIncidents, this.incidentsLayer]);
            this.trafficRefresherIntervalId = trafficRefresher.addRefresherWithModelId(undefined, this._trafficModelIdCallback, this);
            map.addLayer(this.trafficLayerWithIncidents);
        },
        onRemove: function onRemove() {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficLayerWithIncidents.remove();
        },
        updateOptions: function updateOptions(options) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficRefresherIntervalId = trafficRefresher.addRefresherWithModelId(options, this._trafficModelIdCallback, this);
            L.setOptions(this, options);
        }
    });

    L.tomTomVectorTrafficWithIncidentsLayer = function (options) {
        return new L.TomTomVectorTrafficWithIncidentsLayer(options);
    };

    return L.tomTomVectorTrafficWithIncidentsLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* jshint nomen:false */
/**
 * Tile layer for Leaflet that uses the
 * <a href="https://developer.tomtom.com/online-traffic/online-traffic-documentation-online-vector-traffic-incidents/
 * vector-flow-tiles">Vector Traffic Incidents</a> from TomTom Online Traffic.
 *
 * The current vector renderer implementation is based on the
 * [Mapbox GL JS library](https://www.mapbox.com/mapbox-gl-js/api/).
 *
 * @example
 * ```js
 * var ttVectorTrafficIncidents = new L.TomTomVectorTrafficIncidents({
 *      key: '<Your Traffic Flow API key>',
 *      refresh: 30000,
 *      basePath: '<SDK base path>',
 *      style: 's1'
 * });
 *
 * map.addLayer(ttVectorTrafficIncidents);
 * ```
 *
 * @class TomTomVectorTrafficIncidents
 * @namespace L
 * @module Map
 * @extends L.TomTomVectorLayer
 * @constructor
 * @param {"s1"|"s2"|"s3"|"night"} [options.style="s1"] Specifies the style and type of traffic incidents
 * @param {String} [options.key] Traffic Flow API key that can be obtained from
 *     <a href="http://developer.tomtom.com">TomTom's developer portal</a>.
 * @param {Integer} [options.refresh=30000] Traffic refresh interval in milliseconds. The default value is 30 seconds.
 * If a lower value is provided the default value is used.
**/
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(23), __webpack_require__(24), __webpack_require__(5), __webpack_require__(9), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, VectorLayer, labelsLayerMixinFactory, security, ApiKeyNames, trafficRefresher) {
    var TomTomVectorIncidentsLayer;

    function replaceTrafficModelIdInUrl(style, trafficModelId) {
        if (!style) {
            return undefined;
        }
        style.sources.vectorTilesTraffic.tiles.forEach(function (elem, index, arr) {
            var regex = /&t=[0-9]\d+$/;
            var matches = elem.search(regex);
            if (matches > -1) {
                arr[index] = elem.replace(regex, '&t=' + trafficModelId);
            } else {
                arr[index] = elem + '&t=' + trafficModelId;
            }
        }, this);
        return style;
    }

    TomTomVectorIncidentsLayer = VectorLayer.extend({
        defaultOptions: {
            refresh: 30000,
            style: 's1',
            basePath: '/sdk',
            preSetStyleCallback: function preSetStyleCallback(style) {
                return Promise.resolve(replaceTrafficModelIdInUrl(style, this.options.trafficModelId));
            }
        },
        name: 'vectorTrafficIncidents',
        layerSourceName: 'vectorTilesTraffic',
        initialize: function initialize(options) {
            options = options || {};
            if (!options.key && !security.getKey(ApiKeyNames.traffic)) {
                throw new Error('Error during Vector Incident Layer initialization - missing API key');
            }
            if (options.key) {
                security.setKey(ApiKeyNames.traffic, options.key);
            }
            this.options = L.extend(this.options, options);
            this.defaultOptions.preSetStyleCallback = this.defaultOptions.preSetStyleCallback.bind(this);
            this.layerOptions = this.getLayerOptions(options);
            VectorLayer.prototype.initialize.call(this, this.layerOptions);

            this.refresh = this.refresh.bind(this);
        },
        onAdd: function onAdd(map) {
            var that = this;
            this.startRefresh().then(function () {
                VectorLayer.prototype.onAdd.call(that, map);
                that.bringToFront();
            });
        },
        onRemove: function onRemove(map) {
            this.stopRefresh();
            VectorLayer.prototype.onRemove.call(this, map);
        },
        getLayerOptions: function getLayerOptions(opts) {
            var layer = opts && opts.style || this.defaultOptions.style;
            var options = L.extend({}, this.defaultOptions, opts);

            return L.extend({}, options, {
                style: 'vectorTrafficIncidents',
                layer: layer,
                refresh: Math.max(this.defaultOptions.refresh, options.refresh),
                securityKeyName: ApiKeyNames.traffic,
                vector: {
                    renderer: {
                        refreshExpiredTiles: false
                    }
                },
                styleUrlMapping: {
                    vectorTrafficIncidents: {
                        's1': options.basePath + '/styles/incidents_s1.json',
                        's2': options.basePath + '/styles/incidents_s2.json',
                        's3': options.basePath + '/styles/incidents_s3.json',
                        'night': options.basePath + '/styles/incidents_night.json'
                    }
                }
            });
        },
        startRefresh: function startRefresh() {
            var that = this;
            if (this.options._noRefresher) {
                return Promise.resolve();
            }
            return new Promise(function (resolve) {
                that.trafficRefresherIntervalId = trafficRefresher.addRefresherWithModelId(undefined, function (trafficModelId) {
                    that.setTrafficModelId(trafficModelId);
                    resolve();
                }, that);
            });
        },
        stopRefresh: function stopRefresh() {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
        },
        refresh: function refresh() {
            var style;
            if (this._glMap) {
                style = this._glMap.getStyle();
                if (style) {
                    style = replaceTrafficModelIdInUrl(style, this.options.trafficModelId);
                    this._glMap.setStyle(style, {
                        diff: false,
                        securityKeyName: ApiKeyNames.traffic
                    });
                }
            }
        },
        setTrafficModelId: function setTrafficModelId(trafficModelId) {
            if (this.options.trafficModelId !== trafficModelId) {
                this.options.trafficModelId = trafficModelId;
                this.refresh();
            }
        },
        updateOptions: function updateOptions(options) {
            if (options.style) {
                this.stopRefresh();
                this.layerOptions = this.getLayerOptions(options);
                VectorLayer.prototype.updateOptions.call(this, this.layerOptions);
                this.startRefresh();
            }
        }
    });

    L.TomTomVectorIncidentsLayer = TomTomVectorIncidentsLayer.extend(labelsLayerMixinFactory('vectorTrafficIncidents'));

    L.tomTomVectorIncidentsLayer = function tomTomVectorIncidentsLayer(options) {
        return new L.TomTomVectorIncidentsLayer(options);
    };

    return L.tomTomVectorIncidentsLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(70), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, tileLayer, labelsLayerMixinFactory) {
    //eslint-disable-line
    'use strict';

    var TomTomLabelsLayer;

    function layeraddHandler(event) {
        var map = event.target,
            usingRasterTiles = map.hasLayer(map._ttBaseLayers.raster),
            totalTileLayers = map._panes.tilePane.childElementCount,
            totalOverlayLayers = map._panes.overlayPane.childElementCount;
        if (usingRasterTiles && (totalTileLayers > 1 || totalOverlayLayers > 0)) {
            if (!this._container) {
                L.TomTomLayer.prototype.onAdd.call(this, map);
            }
            this.bringToFront();
        }
    }

    TomTomLabelsLayer = L.TomTomLayer.extend({
        options: {
            zIndex: 40
        },
        name: 'labels',
        initialize: function initialize(options) {
            var labelsOptions = L.extend({}, options, { layer: 'labels', opacity: 0.9 });
            L.TomTomLayer.prototype.initialize.call(this, labelsOptions);
        },
        onAdd: function onAdd(map) {
            this._layerAddHandler = layeraddHandler.bind(this);
            map.on('layeradd', this._layerAddHandler);
        },
        onRemove: function onRemove(map) {
            map.off('layeradd', this._layerAddHandler);
            if (this._container) {
                L.TomTomLayer.prototype.onRemove.call(this, map);
            }
        },
        bringToFront: function bringToFront() {
            var pane = this._map._panes.overlayPane;
            if (this._container) {
                pane.appendChild(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        _initContainer: function _initContainer() {
            var tilePane = this._map._panes.overlayPane;
            var className;

            if (!this._container) {
                this._container = L.DomUtil.create('div', 'leaflet-transparent-layer');

                this._updateZIndex();

                if (this._animated) {
                    className = 'leaflet-tile-container';

                    this._bgBuffer = L.DomUtil.create('div', className, this._container);
                    this._tileContainer = L.DomUtil.create('div', className, this._container);
                } else {
                    this._tileContainer = this._container;
                }

                tilePane.appendChild(this._container);

                if (this.options.opacity < 1) {
                    this._updateOpacity();
                }
            }
        },
        updateOptions: function updateOptions(options) {
            if (options.style) {
                if (!options.layer) {
                    options = L.extend({}, options, { layer: 'labels' });
                }
                L.TomTomLayer.prototype.updateOptions.call(this, options);
            }
        }
    });

    L.TomTomLabelsLayer = TomTomLabelsLayer.extend(labelsLayerMixinFactory('raster'));

    L.tomTomLabelsLayer = function (options) {
        return new L.TomTomLabelsLayer(options);
    };

    return L.tomTomLabelsLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(28), __webpack_require__(6), __webpack_require__(11), __webpack_require__(5), __webpack_require__(29), __webpack_require__(72), __webpack_require__(9), __webpack_require__(55)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, endpoints, http, security, createRequestParams, matrixParameters, ApiKeyNames, asyncRedirectModeCallbackFactory) {
    var fields = matrixParameters(),
        mainPostParamsName = ['origins', 'destinations'];

    function getOptionalBodyParams(postParams) {
        var optionalBodyParamsNames = Object.keys(postParams).filter(function (paramName) {
            return mainPostParamsName.indexOf(paramName) === -1;
        });

        if (!optionalBodyParamsNames.length) {
            return null;
        }

        return optionalBodyParamsNames.reduce(function (accumulator, paramName) {
            accumulator[paramName] = postParams[paramName];
            return accumulator;
        }, {});
    }

    function getBodyParams(postParams) {
        var bodyParams = {
            origins: postParams.origins,
            destinations: postParams.destinations
        },
            optionalBodyParams = getOptionalBodyParams(postParams);

        if (optionalBodyParams) {
            bodyParams.options = {
                post: optionalBodyParams
            };
        }

        return bodyParams;
    }

    return function (maxNoOfElementsInBatchRequest) {
        return function (options, originalCallback) {
            var requestParams = createRequestParams(fields, options),
                queryParams = requestParams.queryParams,
                bodyParams = getBodyParams(requestParams.postParams),
                callback = originalCallback,
                endpoint;

            queryParams.key = utils.or(options.key, security.getKey(ApiKeyNames.routing));
            queryParams.key = utils.required(queryParams.key);

            if (bodyParams.origins.length * bodyParams.destinations.length <= maxNoOfElementsInBatchRequest) {
                endpoint = endpoints.matrixSyncRouting;
            } else {
                endpoint = endpoints.matrixRouting;
                queryParams.redirectMode = 'manual';
                callback = asyncRedirectModeCallbackFactory(originalCallback, options);
            }

            http.post({
                url: '{protocol}://' + endpoint,
                queryParameters: queryParams,
                bodyParameters: bodyParams,
                callbackParam: 'callback',
                callback: callback,
                requestType: 'batch',
                fail: options.fail
            });
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    'use strict';

    function newFeature(route) {
        return {
            type: 'Feature',
            properties: { summary: route.summary, sections: route.sections, segmentSummary: [] }
        };
    }

    function getCoordinates(points) {
        var coordinates = [];
        var i;
        for (i = 0; i < points.length; i += 1) {
            coordinates.push([points[i].longitude, points[i].latitude]);
        }
        return coordinates;
    }

    return function (route) {
        var isMultiLineString = route.legs.length > 1;

        var feature = newFeature(route);
        var i;
        for (i = 0; i < route.legs.length; i += 1) {
            feature.properties.segmentSummary.push(route.legs[i].summary);

            if (route.legs[i].points) {
                feature.geometry = feature.geometry || {
                    coordinates: []
                };

                if (isMultiLineString) {
                    feature.geometry.type = 'MultiLineString';
                    feature.geometry.coordinates.push(getCoordinates(route.legs[i].points));
                } else {
                    feature.geometry.type = 'LineString';
                    feature.geometry.coordinates = getCoordinates(route.legs[i].points);
                }
            }
        }
        if (route.guidance) {
            feature.properties.guidance = route.guidance;
        }
        return feature;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(75)], __WEBPACK_AMD_DEFINE_RESULT__ = function (routingModel) {
    'use strict';

    return function (data) {
        if (!Array.isArray(data.batchItems)) {
            return null;
        }
        return data.batchItems.map(function (batchItem) {
            if (batchItem.response.error) {
                return { error: batchItem.response.error };
            } else {
                return routingModel(batchItem.response);
            }
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(76)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, mapUtils) {

    function pushToUpdatedLayers(alreadyUpdatedLayers, layer, options) {
        if (layer) {
            layer.updateOptions(options);
            alreadyUpdatedLayers.push(layer);
        }
    }

    function getTrafficLayersToSeekFor(options) {
        var layersToSeek = [];
        if (options.traffic) {
            layersToSeek.push('traffic', 'trafficIncidents', 'trafficWithIncidents');
        }

        if (options.trafficFlow) {
            layersToSeek.push('trafficFlow');
        }
        return layersToSeek;
    }

    function updateTrafficLayer(alreadyUpdatedLayers, layer, options) {
        if (layer.name === 'trafficFlow') {
            pushToUpdatedLayers(alreadyUpdatedLayers, layer, options.trafficFlow);
        } else {
            //updates if layers.name equals traffic, trafficIncidents, trafficWithIncidents
            pushToUpdatedLayers(alreadyUpdatedLayers, layer, options.traffic);
        }
    }

    function updateTrafficLayers(alreadyUpdatedLayers, options) {
        var that = this;
        var layersToSeek = getTrafficLayersToSeekFor(options);
        layersToSeek.forEach(function (layerName) {
            var layer = mapUtils.findLayersByName(layerName, that)[0];
            if (layer) {
                updateTrafficLayer(alreadyUpdatedLayers, layer, options);
            }
        });
    }

    /**
     * Updates options added currently to map (including inactive base layers).
     * Only the update of the options `style` and `layer` are supported.
     *
     * Also allows to update refresh rate option of traffic layers.
     *
     * @method updateLayersOptions
     * @param {Object} options Options to be updated
     * @param {"main"|"night"} [options.style] The new base map style to use.
     *     By default, the current style is used (i.e. no update of this property).
     * @param {"basic"|"hybrid"|"labels"} [options.layer] The new base map layer to use.
     *     By default, the current layer is used (i.e. no update of this property).
     * @param {Object|Boolean} options.traffic Options used to change refresh rate.
     * Please note that minimal refresh rate is 30000 ms, if you provide lower value it will be defaulted to 30000 ms.
     * @param {Object} options.trafficFlow Options used to change refresh rate.
     * Please note that minimal refresh rate is 30000 ms, if you provide lower value it will be defaulted to 30000 ms.
     */
    L.Map.prototype.updateLayersOptions = function (options) {
        var alreadyUpdatedLayers = [];
        pushToUpdatedLayers(alreadyUpdatedLayers, this._ttBaseLayers.raster, options);
        pushToUpdatedLayers(alreadyUpdatedLayers, this._ttBaseLayers.vector, options);
        pushToUpdatedLayers(alreadyUpdatedLayers, this._ttLabelsLayers.vector, options);
        pushToUpdatedLayers(alreadyUpdatedLayers, this._ttLabelsLayers.raster, options);
        updateTrafficLayers.call(this, alreadyUpdatedLayers, options);
        L.Util.setOptions(this, options);

        this.eachLayer(function (layer) {
            if (layer.updateOptions && alreadyUpdatedLayers.indexOf(layer) === -1) {
                layer.updateOptions(options);
            }
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(23), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, VectorLayer, labelsLayerMixinFactory) {
    'use strict';

    var TomTomVectorLabelsLayer = VectorLayer.extend({
        name: 'vectorLabels',
        onAdd: function onAdd(map) {
            VectorLayer.prototype.onAdd.call(this, map);
            this._bringToFront(map);
        },
        _bringToFront: function _bringToFront(map) {
            var pane = map._panes.overlayPane;
            this._setPane(pane);
            if (this._glContainer) {
                pane.appendChild(this._glContainer);
            }
            return this;
        },
        initialize: function initialize(options) {
            options = L.extend({}, options);
            options.layer = 'labels';
            VectorLayer.prototype.initialize.call(this, options);
        },
        updateOptions: function updateOptions(options) {
            if (options.style) {
                options = L.extend({}, options, { layer: 'labels' });
                VectorLayer.prototype.updateOptions.call(this, options);
            }
        }
    });

    L.TomTomVectorLabelsLayer = TomTomVectorLabelsLayer.extend(labelsLayerMixinFactory('vector'));

    L.tomTomVectorLabelsLayer = function (options) {
        return new L.TomTomVectorLabelsLayer(options);
    };

    return L.TomTomVectorLabelsLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This class allows you to add markers to the map. You can specify your own markers
 * or add custom ones.
 *
 * @class TomTomMarkersLayer
 * @extends L.FeatureGroup
 * @namespace L
 * @module Map
 * @constructor
 * @param {Object} options
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(21), __webpack_require__(62), __webpack_require__(77), __webpack_require__(0), __webpack_require__(78), __webpack_require__(148), __webpack_require__(20), __webpack_require__(90), __webpack_require__(93)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, SvgIcon, objectUtils, defaultIconsMappingProvider, utils, pointHTMLContentGenerator, RouteDrawer, Wrapable, nearbySearch) {
    'use strict';

    var defaultOptions = {
        background: {
            iconSize: [30, 36],
            iconAnchor: [15, 36],
            icon: 'icon-marker-black',
            noPlainSVG: false
        },
        icon: {
            iconSize: [30, 30],
            iconAnchor: [0, 0],
            icon: 'icon-flag-white',
            noPlainSVG: false
        },
        popupAnchor: [0, -30],
        opacity: 0.8
    };

    var icons = defaultIconsMappingProvider.defaultIcons;
    var singleColorIcons = defaultIconsMappingProvider.singleColorIcons;

    function shouldUseSingleColorIcon(classification) {
        return objectUtils.hasProperty(singleColorIcons, classification);
    }

    function isLowBandwidth(point) {
        return point.a2 !== undefined;
    }

    function hasClassification(point) {
        return objectUtils.hasProperty(point, 'poi') && objectUtils.hasProperty(point.poi, 'classifications');
    }

    function getClassification(point) {
        var classification = 'fallback';
        if (hasClassification(point)) {
            classification = point.poi.classifications.length > 0 ? point.poi.classifications[0].code : 'fallback';
        } else if (isLowBandwidth(point)) {
            classification = point.cst.length > 0 ? point.cst[0].cd : 'fallback';
        }
        return classification;
    }

    /**
     * @ignore
     * If marker layer options enabled support for entry points and addCounterToMainPoint property is set
     * Content with the counter is added
     * @param {Object} point
     * @param {Object} entryPointOptions
     * @return {Object|undefined}
     */
    function getContentForMainMarkerWithEntryPoints(point, entryPointOptions) {
        if (point.entryPoints && entryPointOptions && entryPointOptions.addCounterToMainPoint) {
            return {
                iconSize: [10, 10],
                iconAnchor: [-25, 5],
                content: point.entryPoints.length,
                noPlainSVG: true,
                style: {
                    'color': '#000',
                    'font-weight': 'bold',
                    'font-size': '12px'
                }
            };
        }
        return undefined;
    }

    /**
     * @ignore
     * Returns correct marker options for provided classification and color and entryPoints options
     * @param {String} classification
     * @param {Object} point
     * @param {String} color
     * @param {Object} entryPointsOptions
     * @return {Object}
     */
    function getMarkerIconOptions(classification, point, color, entryPointsOptions) {
        var iconName = icons[classification] || icons.fallback;
        var iconOptions = utils.clone(defaultOptions);
        if (shouldUseSingleColorIcon(classification)) {
            iconOptions.icon.icon = 'icon-' + iconName;
        } else {
            iconOptions.icon.icon = 'icon-' + iconName + '-' + color;
            if (color === 'black') {
                iconOptions.background.icon = 'icon-marker-white';
            }
        }
        iconOptions.content = getContentForMainMarkerWithEntryPoints(point, entryPointsOptions);
        return iconOptions;
    }

    /**
     * @ignore
     * Returns instance of Icon build for correct point classification and color
     * @param {Object} point
     * @param {String} color
     * @param {Object} entryPointsOptions
     * @return {SvgIcon}
     */
    function getDefaultIcon(point, color, entryPointsOptions) {
        var classification, iconOptions;
        classification = getClassification(point);
        iconOptions = getMarkerIconOptions(classification, point, color, entryPointsOptions);
        return new SvgIcon(iconOptions);
    }

    /**
     * @ignore
     * Returns position of the point. Used in marker creation
     * @param {Object} point
     * @return {LatLng}
     */
    function getMarkerPosition(point) {
        var latLngContainer = point;
        if (point.position) {
            latLngContainer = point.position;
        } else if (point.ps) {
            latLngContainer = point.ps.split(' ');
        }
        return utils.convertToLatLng(latLngContainer);
    }

    /**
     * @ignore
     * Calls popupHoverContent generator method if it exists and returns output. Used in marker creation.
     * @param {Object} point
     * @param {Object} options
     * @return {String|undefined}
     */
    function getMarkerPopupHoverContent(point, options) {
        return objectUtils.hasProperty(options, 'popupHoverContent') ? options.popupHoverContent(point) : undefined;
    }

    /**
     * @ignore
     * Calls popupContent generator method if it exists and returns output. Used in marker creation.
     * @param {Object} point
     * @param {Object} options
     * @param {Object} popupGenerator
     * @return {String}
     */
    function getMarkerPopupContent(point, options, popupGenerator) {
        return objectUtils.hasProperty(options, 'popupContent') ? options.popupContent(point) : popupGenerator(point);
    }

    /**
     * @ignore
     * Returns correct color for markers based on layer options
     * @param {Object} options
     * @param {Boolean} [options.useBlackIcons=false]
     * @return {String}
     */
    function getColor(options) {
        return options.useBlackIcons ? 'black' : 'white';
    }

    /**
     * @ignore
     * Returns svg icon for the typical points
     * @param {Object} point
     * @param {Object} options
     * @param {Boolean} [options.useBlackIcons]
     * @return {SvgIcon}
     */
    function getMarkerIcon(point, options) {
        return objectUtils.hasProperty(options, 'icon') ? options.icon(point) : getDefaultIcon(point, getColor(options), options.entryPoints);
    }

    /**
     * @ignore
     * Returns svg icon for the entry points
     * @param {Object} point
     * @param {Object} options
     * @return {SvgIcon}
     */
    function getEntryPointMarkerIcon(point, options) {
        var iconOptions;
        if (objectUtils.hasProperty(options, 'icon')) {
            iconOptions = options.icon(point);
        } else {
            iconOptions = utils.clone(defaultOptions);
            iconOptions.icon.icon = 'icon-ic_map_poi_109-' + getColor(options);
            iconOptions.background.icon = 'icon-marker-green';
        }
        return new SvgIcon(iconOptions);
    }

    /**
     * @ignore
     * Calls entry point getEntryPointPopupHoverContent generator method if it exists and returns output. Used in marker
     * creation.
     *
     * @param {Object} entryPoint
     * @param {Object} mainPoint
     * @param {Object} options
     * @return {String}
     */
    function getEntryPointPopupHoverContent(entryPoint, mainPoint, options) {
        return options.entryPoints.popupHoverContent ? options.entryPoints.popupHoverContent(entryPoint, mainPoint) : undefined;
    }

    /**
     * @ignore
     * Calls entry point popupContent generator method if it exists and returns output. Used in marker creation.
     * @param {Object} entryPoint
     * @param {Object} mainPoint
     * @param {Object} options
     * @param {Function} popupGenerator
     * @return {String}
     */
    function getEntryPointPopupContent(entryPoint, mainPoint, options, popupGenerator) {
        return options.entryPoints.popupContent ? options.entryPoints.popupContent(entryPoint, mainPoint) : popupGenerator(entryPoint, mainPoint);
    }

    /**
     * @ignore
     * Creates instance of L.polyline for the spider leg line
     * @param {Array} positions
     * @param {Object} options
     * @return {L.polyline}
     */
    function createSpiderLegLine(positions, options) {
        var lineOptions = {
            weight: 1.5,
            color: options.useBlackIcons ? '#ddd' : '#222',
            opacity: 0.5,
            dashArray: '5, 5'
        };
        return L.polyline(positions, lineOptions);
    }

    /**
     * @ignore
     * Creates markers for entry points
     * @param {Array} entryPoints array of entry points data
     * @param {Object} options marker layer options
     * @param {Object} mainPoint main point data object which is passed to popup and title callback for the entry points
     * @param {Function} popupGenerator
     * @return {L.Marker}
     */
    function createMarkersForEntryPoints(entryPoints, options, mainPoint, popupGenerator) {
        return entryPoints.map(function (entryPoint) {
            var entryPointMarkerLayer = L.marker(getMarkerPosition(entryPoint), {
                title: getEntryPointPopupHoverContent(entryPoint, mainPoint, options),
                popupContent: getEntryPointPopupContent(entryPoint, mainPoint, options, popupGenerator),
                icon: getEntryPointMarkerIcon(entryPoint, options)
            });
            var popupContent = entryPointMarkerLayer.options.popupContent;

            if (popupContent instanceof Wrapable) {
                entryPointMarkerLayer.bindPopup(popupContent.getHtmlElement());
                entryPointMarkerLayer.on('popupclose', popupContent.wrap.bind(popupContent));
            } else {
                entryPointMarkerLayer.bindPopup(popupContent);
            }

            return entryPointMarkerLayer;
        });
    }

    /**
     * @ignore
     * Draws lines between main point and its entrances
     * @param {Layer} mainMarkerLayer layer of marker which represents main point
     * @param {Array} entryPoints array of layers which represents entry points for the main point
     * @param {Object} options marker layer options
     */
    function drawSpiderLegLines(mainMarkerLayer, entryPoints, options) {
        if (entryPoints.length !== 0) {
            entryPoints.forEach(function (entry) {
                var line = createSpiderLegLine([entry.getLatLng(), mainMarkerLayer.options.point.position], options);
                this._markersWithEntryPointsFeatures.push(line);
                this._map.addLayer(line);
            }.bind(this));
        }
    }

    function configureMarkerToShowEntryPointOnClickIfNeeded(markerLayer, point, options) {
        var markerRemoveHandler;

        if (options.entryPoints !== undefined && point.entryPoints) {
            markerRemoveHandler = function markerRemoveHandler() {
                if (this._lastClickedMarkerWithEntries === markerLayer) {
                    this._removeEntryPoints();
                    this._lastClickedMarkerWithEntries = undefined;
                }
            };

            markerLayer.on('remove', markerRemoveHandler, this);

            markerLayer.on('click', function () {
                var entryPointsMarkers;
                this._removeEntryPoints();

                if (this._lastClickedMarkerWithEntries === markerLayer) {
                    this._lastClickedMarkerWithEntries = undefined;
                    return;
                }

                entryPointsMarkers = createMarkersForEntryPoints(point.entryPoints, options, point, this._entryPointsPopupGenerator);
                entryPointsMarkers.forEach(function (entry) {
                    this._markersWithEntryPointsFeatures.push(entry);
                    this._map.addLayer(entry);
                }.bind(this));

                drawSpiderLegLines.call(this, markerLayer, entryPointsMarkers, options);
                this._lastClickedMarkerWithEntries = markerLayer;
            }, this);
        }
    }

    function isSimplePoint(point) {
        return utils.isArray(point) && point.length === 2;
    }

    /**
     * @ignore
     * Builds marker from point data
     * @param {Object} options layer options
     * @param {Boolean} [options.useBlackIcons]
     * @param {Object} point point data to create marker from
     */
    function createMarkerFromPoint(options, point) {
        var markerLayer, popupContent;
        if (isSimplePoint(point)) {
            markerLayer = L.marker(getMarkerPosition(point), {
                point: point
            });
        } else {
            markerLayer = L.marker(getMarkerPosition(point), {
                title: getMarkerPopupHoverContent(point, options),
                popupContent: getMarkerPopupContent(point, options, this._regularPopupGenerator),
                icon: getMarkerIcon(point, options),
                point: point
            });
            popupContent = markerLayer.options.popupContent;

            if (popupContent instanceof Wrapable) {
                markerLayer.bindPopup(popupContent.getHtmlElement());
                markerLayer.on('popupclose', popupContent.wrap.bind(popupContent));
            } else {
                markerLayer.bindPopup(popupContent);
            }
        }

        this._markersLayer.addLayer(markerLayer);

        configureMarkerToShowEntryPointOnClickIfNeeded.call(this, markerLayer, point, options);
    }

    function extendEntryPointsOptions(options) {
        if (this.options.entryPoints && options.entryPoints) {
            L.Util.extend(this.options.entryPoints, options.entryPoints);
            options.entryPoints = this.options.entryPoints;
        }
    }

    function resizeEntryPointMarkerIcon(requestedEntryPoinMarkerPosition, entryPointMarkers, multiplier) {
        function multiply(value) {
            return multiplier * value;
        }
        function updatedElement(element) {
            return Object.assign({}, element, {
                iconSize: element.iconSize.map(multiply),
                iconAnchor: element.iconAnchor.map(multiply)
            });
        }
        entryPointMarkers.filter(function (entryPointMarker) {
            return entryPointMarker._latlng && !utils.isArray(entryPointMarker._latlng) && entryPointMarker._latlng.equals(requestedEntryPoinMarkerPosition) && entryPointMarker.options.icon;
        }).forEach(function (entryPointMarker) {
            var iconOptions = entryPointMarker.options.icon.options;
            entryPointMarker.refreshIconOptions({
                background: updatedElement(iconOptions.background),
                icon: updatedElement(iconOptions.icon)
            });
        });
    }

    function routableClickHandlerFactory(routeContextGetter) {
        return function (mode, point) {
            var routeContext = routeContextGetter();

            if (mode === 'start') {
                routeContext.startPoint(point);
            } else if (mode === 'end') {
                routeContext.endPoint(point);
            }
        };
    }

    function configureActionsForRegularMarkers(markerLayer, isRoutingEnabled, isSearchNearbyEnabled) {
        var actionsForRegularMarkers = null;

        function resizeEntryPoints(value) {
            return function (position) {
                resizeEntryPointMarkerIcon(position, markerLayer._markersWithEntryPointsFeatures, value);
            };
        }

        if (isRoutingEnabled) {
            actionsForRegularMarkers = {};
            actionsForRegularMarkers.routing = {
                routeFrom: true,
                routeTo: true,
                routeToEntryPoint: true,
                routeFromEntryPoint: true,
                onEntryPointMouseover: resizeEntryPoints(2),
                onEntryPointMouseout: resizeEntryPoints(0.5),
                onActionClick: routableClickHandlerFactory(markerLayer._getRoutingContext.bind(markerLayer))
            };
        }

        if (isSearchNearbyEnabled) {
            actionsForRegularMarkers = actionsForRegularMarkers || {};
            actionsForRegularMarkers.search = {
                searchNearby: true,
                onActionClick: function onActionClick(position) {
                    nearbySearch().center(position).radius(10000).go(function (data) {
                        markerLayer.setMarkersData(data).addMarkers();
                    });
                }
            };
        }

        return actionsForRegularMarkers;
    }

    function configureActionsForEntryPointMarkers(markerLayer, isRoutingEnabled) {
        var actionsForEntryPointMarkers = null;
        if (isRoutingEnabled) {
            actionsForEntryPointMarkers = {};
            actionsForEntryPointMarkers.routing = {
                routeFrom: true,
                routeTo: true,
                onActionClick: routableClickHandlerFactory(markerLayer._getRoutingContext.bind(markerLayer))
            };
        }

        return actionsForEntryPointMarkers;
    }

    function getMarkerName(point) {
        var lowBandwidthName = point.nm ? point.nm : '';
        return point.poi ? point.poi.name : lowBandwidthName;
    }

    function getPointId(point) {
        return String(getMarkerPosition(point)) + getMarkerName(point);
    }

    L.TomTomMarkersLayer = L.FeatureGroup.extend({
        options: {
            disableClusteringAtZoom: 17,
            removeOutsideVisibleBounds: false,
            enableRoutingActions: false,
            enableSearchActions: false
        },
        /**
         * Sets the markers data which will be used by the
         * {{#crossLink "L.TomTomMarkersLayer/addMarkers:method"}}{{/crossLink}} method.
         *
         * This method expects an array of points returned by one of our search calls (e.g. fuzzySearch),
         * or an array of simple points e.g. [[52.005, 25.01], [57.12, 12.06]].
         * ```javascript
         * var map = L.map('map', {key: "<YOUR_API_KEY"});
         * var markers = new L.TomTomMarkersLayer().addTo(map);
         * markers.setMarkersData([[52.005, 25.01], [57.12, 12.06]]);
         * markers.addMarkers();
         * map.fitBounds(markers.getBounds());
         * ``````
         *
         * @chainable
         * @method setMarkersData
         * @param {Array} points Array of markers data to be used by addMarkers method
         * @return {L.TomTomMarkersLayer}
         */
        setMarkersData: function setMarkersData(points) {
            var that = this;
            this._points = points.filter(function (point) {
                var pointId = getPointId(point);
                return that._allPointsIds.indexOf(pointId) === -1;
            });
            this._points.forEach(function (point) {
                var pointId = getPointId(point);
                that._allPointsIds.push(pointId);
            });
            return this;
        },

        /**
         * Adds markers to the layer using the options specified by
         * {{#crossLink "L.TomTomMarkersLayer/setMarkerOptions:method"}}{{/crossLink}} and
         * {{#crossLink "L.TomTomMarkersLayer/setPopupOptions:method"}}{{/crossLink}}.
         *
         * Please remember to add this layer instance into the map after call this method if you want
         * to visualize markers on the map.
         *
         * @chainable
         * @method addMarkers
         * @return {L.TomTomMarkersLayer}
         */
        addMarkers: function addMarkers() {
            if (this.options.noMarkerClustering) {
                if (!this._markersLayer || !(this._markersLayer instanceof L.FeatureGroup)) {
                    this._markersLayer = new L.FeatureGroup();
                }
            } else if (!this._markersLayer || !(this._markersLayer instanceof L.MarkerClusterGroup)) {
                this._markersLayer = new L.MarkerClusterGroup({
                    chunkedLoading: this.options.chunkedLoading,
                    disableClusteringAtZoom: this.options.disableClusteringAtZoom,
                    maxClusterRadius: this.options.maxClusterRadius,
                    removeOutsideVisibleBounds: this.options.removeOutsideVisibleBounds,
                    showCoverageOnHover: this.options.showCoverageOnHover,
                    spiderfyOnMaxZoom: this.options.spiderfyOnMaxZoom
                });
            }

            this._regularPopupGenerator = pointHTMLContentGenerator({
                name: true,
                address: true,
                coordinates: true,
                poi: true,
                actions: configureActionsForRegularMarkers(this, this.options.enableRoutingActions, this.options.enableSearchActions)
            });
            this._entryPointsPopupGenerator = pointHTMLContentGenerator({
                entryPoint: true,
                address: true,
                coordinates: true,
                actions: configureActionsForEntryPointMarkers(this, this.options.enableRoutingActions)
            });

            this._points.forEach(createMarkerFromPoint.bind(this, this.options));
            this.addLayer(this._markersLayer);
            return this;
        },

        /**
         * @ignore
         * Removes all entry points markers and spiders legs from the map.
         */
        _removeEntryPoints: function _removeEntryPoints() {
            this._markersWithEntryPointsFeatures.forEach(function (feature) {
                feature.remove();
            });
            this._markersWithEntryPointsFeatures = [];
        },
        /**
         * Returns an array of layers which were created by the
         * {{#crossLink "L.TomTomMarkersLayer/addMarkers:method"}}{{/crossLink}}.
         *
         * @method getMarkers
         * @return {Array} Array of marker layers.
         */
        getMarkers: function getMarkers() {
            if (!this._markersLayer) {
                return [];
            }
            return this._markersLayer.getLayers();
        },

        /**
         * Sets the marker options which will be used by the
         * {{#crossLink "L.TomTomMarkersLayer/addMarkers:method"}}{{/crossLink}} method.
         *
         * @chainable
         * @method setMarkerOptions
         * @param {Object} options Options for marker.
         * @param {Boolean} [options.useBlackIcons=false] If set to true, default icons will be black, else they will
         *     be white.
         * @param {Function} options.icon Function that will be called for every point (passed as the first argument).
         *     Should return an instance of {{#crossLink "L.Icon"}}{{/crossLink}} or any class that extends L.Icon
         *     (e.g. {{#crossLink "L.SvgIcon"}}{{/crossLink}}).
         * @param {Boolean} options.noMarkerClustering If is set to true the markers will not be clustered and the
         *     returned marker's layer will be a {{#crossLink "L.FeatureGroup"}}{{/crossLink}}.
         *     If is set to false the markers will be clustered and the returned marker's layer will be a
         *     {{#crossLink "L.MarkerClusterGroup"}}{{/crossLink}}.
         * @param {Number} [options.disableClusteringAtZoom=17] If marker clustering is turned on which zoom
         *     level should it be turned off.
         * @param {Boolean} [options.removeOutsideVisibleBounds=false] If marker clustering is turned on
         *     determines if markers which are outside of viewport should be removed.
         * @param {Object} options.entryPoints options for viewing entry points of added markers (if not provided entry
         *     points will not be visualized)
         * @param {Boolean} [options.entryPoints.addCounterToMainPoint=false] if set to true, marker with entry points
         *     will have counter
         * @param {Number} options.maxClusterRadius The maximum radius that a cluster will cover from the central
         *     marker (in pixels).
         * @param {Boolean} options.showCoverageOnHover When mouse is over a cluster it shows the bounds of its
         *     markers.
         * @param {Boolean} options.spiderfyOnMaxZoom When user click a cluster at the bottom zoom level it is
         *     spiderfied it.
         * @return {L.TomTomMarkersLayer}
         */
        setMarkerOptions: function setMarkerOptions(options) {
            extendEntryPointsOptions.call(this, options);
            L.Util.setOptions(this, options);
            return this;
        },
        /**
         * @chainable
         * @method setPopupOptions
         * @param {Object} options Options for popup.
         * @param {Function} options.popupHoverContent Function which will be called for every point (passed as first
         *     argument). It allows you to configure the popup's behavior that appears when the cursor moves over the
         *     marker. Function must return a string.
         * @param {Function} options.popupContent Function which will be called for every point (passed as first
         *     argument). It allows to configure popup content of every marker. This function should return a
         *     {{#crossLink "HTMLElement"}}{{/crossLink}}, {{#crossLink "String"}}{{/crossLink}} or Leaflet Popup
         *     element.
         * @param {Boolean} [options.enableRoutingActions=false] Enables routing actions
         *      ("Route from", "Route to", etc.)
         *      being shown in a popup
         * @param {Boolean} [options.enableSearchActions=false] Enables search actions ("Search nearby")being shown in a
         *      popup
         * @param {Function} options.entryPoints.popupHoverContent function which will be called for each entry point to
         *     create title (visible while hovering over marker). Passed parameters (entry, point)
         * @param {Function} options.entryPoints.popupContent function which will be called for each entry point to
         *     create popup for it. Passed parameters (entry, point)
         * @return {L.TomTomMarkersLayer}
         */
        setPopupOptions: function setPopupOptions(options) {
            extendEntryPointsOptions.call(this, options);
            L.Util.setOptions(this, options);
            return this;
        },
        /**
         * Removes all added markers
         *
         * @chainable
         * @method clearLayers
         * @return {L.TomTomMarkersLayer}
         */
        clearLayers: function clearLayers() {
            if (this._markersLayer) {
                this._markersLayer.clearLayers();
                this._points = null;
                this._allPointsIds = [];
            }
            L.FeatureGroup.prototype.clearLayers.call(this);
            return this;
        },
        onAdd: function onAdd(map) {
            if (this.options.enableRoutingActions) {
                this._routingContext = map._routingContext;
                this._routeDrawer.addTo(map);
            }
            this._map = map;
            L.FeatureGroup.prototype.onAdd.call(this, map);
        },
        onRemove: function onRemove(map) {
            L.FeatureGroup.prototype.onRemove.call(this, map);
            if (this.options.enableRoutingActions) {
                this._routeDrawer.remove();
            }
            this._map = null;
        },
        _getRoutingContext: function _getRoutingContext() {
            return this._routingContext;
        }
    });

    L.TomTomMarkersLayer.addInitHook(function () {
        this._allPointsIds = [];
        this._points = [];
        this._markersLayer = undefined;
        this._markersWithEntryPointsFeatures = [];
        this._lastClickedMarkerWithEntries = null;
        this._routeDrawer = new RouteDrawer();
        this._regularPopupGenerator = null;
        this._entryPointsPopupGenerator = null;
    });

    L.tomTomMarkersLayer = function (options) {
        return new L.TomTomMarkersLayer(options);
    };
    return L.tomTomMarkersLayer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * This class provides functionality of drawing routes based on provided GeoJSON object and routing context
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(78), __webpack_require__(71), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, pointHTMLContentGenerator, RoutingContext, SvgIcon) {
    'use strict';

    var startIcon = new SvgIcon({
        background: {
            iconSize: [30, 30],
            iconAnchor: [15, 15],
            icon: 'icon-shield',
            noPlainSVG: false
        },
        icon: {
            iconSize: [30, 30],
            iconAnchor: [0, 0],
            icon: 'icon-start-white',
            noPlainSVG: false
        }
    }),
        endIcon = new SvgIcon({
        background: {
            iconSize: [30, 30],
            iconAnchor: [15, 15],
            icon: 'icon-shield',
            noPlainSVG: false
        },
        icon: {
            iconSize: [30, 30],
            iconAnchor: [0, 0],
            icon: 'icon-end-white',
            noPlainSVG: false
        }
    }),
        routeOptions = {
        style: {
            color: '#00d7ff',
            opacity: 0.8
        }
    },
        supportRouteOptions = {
        color: '#00d7ff',
        opacity: 0.8,
        dashArray: [5, 5]
    };

    function updateRoutingContext(data) {
        var removedMarkerPosition = data.position;
        if (!this._routingContext) {
            return;
        }

        if (this._startMarker && this._startMarker.getLatLng().equals(removedMarkerPosition)) {
            this._routingContext.startPoint(null);
        } else if (this._endMarker && this._endMarker.getLatLng().equals(removedMarkerPosition)) {
            this._routingContext.endPoint(null);
        }
    }

    function RouteDrawer() {
        this._route = null;
        this._startMarker = null;
        this._endMarker = null;
        this._routingContext = null;
        this._supportRoutes = [];
        this._popupGenerator = pointHTMLContentGenerator({
            address: true,
            coordinates: true,
            actions: {
                remove: {
                    onActionClick: updateRoutingContext.bind(this)
                }
            }
        });
    }

    function isJsonRouteEmpty(jsonRoute) {
        return !(jsonRoute && jsonRoute.features && jsonRoute.features.length && jsonRoute.features[0].geometry && jsonRoute.features[0].geometry.coordinates && jsonRoute.features[0].geometry.coordinates.length);
    }

    function getCoordinateFromJsonRoute(jsonRoute, index) {
        var coordinates = jsonRoute.features[0].geometry.coordinates;
        coordinates = Array.prototype.slice.call(coordinates, 0);
        if (index < 0) {
            return coordinates.splice(index)[0].reverse();
        } else {
            return coordinates[index].reverse();
        }
    }

    RouteDrawer.prototype.__getStartPointFromJsonRoute = function (jsonRoute) {
        if (isJsonRouteEmpty(jsonRoute)) {
            return this._routingContext.startPoint();
        }

        return L.latLng(getCoordinateFromJsonRoute(jsonRoute, 0));
    };

    RouteDrawer.prototype.__getEndPointFromGeoJson = function (jsonRoute) {
        if (isJsonRouteEmpty(jsonRoute)) {
            return this._routingContext.endPoint();
        }

        return L.latLng(getCoordinateFromJsonRoute(jsonRoute, -1));
    };

    function areLatLngEquals(latLng1, latLng2) {
        //if latlngs are very close to each other
        //(the difference is on th 6th place after the comma) they are considered equal
        return latLng1.equals(latLng2, 0.000009);
    }

    function removeArrayOfComponents(components) {
        components.forEach(function (component) {
            component.remove();
        });
    }

    /**
     * @ignore
     * This method creates:
     * * route itself using provided jsonRoute param
     * * start and end marker using information provided by routing context
     * * supporting routes which represent routes from route start/end point to start/end marker
     *
     * @param {GeoJSON} jsonRoute GeoJson object with LineString geometry
     */
    RouteDrawer.prototype._drawRoute = function (jsonRoute) {
        var routeStartPoint, routeEndPoint;
        this._removeComponent('_route');
        removeArrayOfComponents(this._supportRoutes);
        this._supportRoutes = [];
        this._updateMarkers();
        if (isJsonRouteEmpty(jsonRoute)) {
            return;
        }
        this._route = L.geoJson(jsonRoute, routeOptions);
        routeStartPoint = this.__getStartPointFromJsonRoute(jsonRoute);
        if (!areLatLngEquals(this._routingContext.startPoint(), routeStartPoint)) {
            this._supportRoutes.push(L.polyline([routeStartPoint, this._routingContext.startPoint()], supportRouteOptions));
        }
        routeEndPoint = this.__getEndPointFromGeoJson(jsonRoute);
        if (!areLatLngEquals(this._routingContext.endPoint(), routeEndPoint)) {
            this._supportRoutes.push(L.polyline([routeEndPoint, this._routingContext.endPoint()], supportRouteOptions));
        }
    };

    RouteDrawer.prototype._removeComponent = function (componentName) {
        if (this[componentName]) {
            this[componentName].remove();
            this[componentName] = null;
        }
    };

    RouteDrawer.prototype._createMarker = function (markerName, position) {
        var options,
            icon = markerName.indexOf('start') === 1 ? startIcon : endIcon;
        if (!position) {
            return;
        }

        options = { position: { lat: position.lat, lon: position.lng }, type: 'main' };
        this[markerName] = L.marker(position, { icon: icon });
        this[markerName].bindPopup(this._popupGenerator(options).getHtmlElement());
    };

    /**
     * This method creates start/end markers based on information provided by routing context
     *
     * @ignore
     */
    RouteDrawer.prototype._updateMarkers = function () {
        this._updateMarker('_startMarker', this._routingContext.startPoint());
        this._updateMarker('_endMarker', this._routingContext.endPoint());
    };

    /**
     * @ignore
     * Attaches RouteDrawer instance to a map and its routing context. From this point RouteDrawer
     * instance will provide visual representation of any further actions taken on routing context.
     *
     * @param {L.Map} map Leaflet map
     */
    RouteDrawer.prototype.addTo = function (map) {
        this._map = map;
        this._setRoutingContext(map._routingContext);
    };

    RouteDrawer.prototype.remove = function () {
        this._map = null;
        this._routingContext.off(RoutingContext.Events.PROPERTY_VALUE_CHANGED, this._routingContextUpdatesListener);
        this._routingContextUpdatesListener = null;
        this._routingContext = null;
    };

    RouteDrawer.prototype._addAssetsToMap = function () {
        var elementsPossibleToAdd = [this._route, this._startMarker, this._endMarker].concat(this._supportRoutes),
            map = this._map;
        if (!map) {
            return;
        }

        elementsPossibleToAdd.forEach(function (elementToAdd) {
            if (elementToAdd) {
                elementToAdd.addTo(map);
            }
        });

        if (this._route) {
            map.fitBounds(this._route.getBounds(), { padding: [5, 5] });
        }
    };

    RouteDrawer.prototype._updateMarker = function (markerName, currentPosition) {
        this._removeComponent(markerName);
        this._createMarker(markerName, currentPosition);
        if (this._route) {
            this._removeComponent('_route');
            removeArrayOfComponents(this._supportRoutes);
            this._supportRoutes = [];
        }
    };

    function updateRoutingAssetsOnRoutingContextUpdate(eventData) {
        var propertyName = eventData.name,
            propertyCurrentValue = eventData.currentValue,
            pointToMarkerMapping = {
            'startPoint': '_startMarker',
            'endPoint': '_endMarker'
        };

        if (Object.keys(pointToMarkerMapping).indexOf(propertyName) !== -1) {
            this._updateMarker(pointToMarkerMapping[propertyName], propertyCurrentValue);
        } else {
            //route updated
            this._drawRoute(propertyCurrentValue);
        }
        this._addAssetsToMap();
    }

    RouteDrawer.prototype._setRoutingContext = function (routingContext) {
        this._routingContext = routingContext;
        this._routingContextUpdatesListener = updateRoutingAssetsOnRoutingContextUpdate.bind(this);
        this._routingContext.on(RoutingContext.Events.PROPERTY_VALUE_CHANGED, this._routingContextUpdatesListener);
    };

    return RouteDrawer;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(79), __webpack_require__(153), __webpack_require__(82)], __WEBPACK_AMD_DEFINE_RESULT__ = function (SearchModel, LowBandwidthSearchModel, EntryPointModel) {
    'use strict';

    function createCorrectModel(data, additionalData) {
        if (typeof data.tp !== 'undefined') {
            return new LowBandwidthSearchModel(data);
        } else if (data.type === 'main' || data.type === 'minor') {
            return new EntryPointModel(data, additionalData);
        } else {
            return new SearchModel(data);
        }
    }

    return function (json, additionalData) {
        var resultsArray = json.results || json.r;

        if (resultsArray instanceof Array) {
            return resultsArray.map(function (result) {
                return createCorrectModel(result, additionalData);
            });
        } else {
            return createCorrectModel(json, additionalData);
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ObjectModel, utils) {
    'use strict';

    var AddressRangesModel = function AddressRangesModel(json) {
        this.from = utils.convertToLatLng(json.from);
        this.to = utils.convertToLatLng(json.to);

        this.rangeLeftStart = json.rangeLeft.match(/\w+/g)[0];
        this.rangeLeftEnd = json.rangeLeft.match(/\w+/g)[1];

        this.rangeRightStart = json.rangeRight.match(/\w+/g)[0];
        this.rangeRightEnd = json.rangeRight.match(/\w+/g)[1];

        return this;
    };

    AddressRangesModel.prototype = Object.create(ObjectModel.prototype);
    AddressRangesModel.prototype.constructor = AddressRangesModel;

    AddressRangesModel.prototype.simplify = function () {
        return {
            from: { lat: this.from.lat, lon: this.from.lng },
            to: { lat: this.to.lat, lon: this.to.lng },
            rangeLeft: this.rangeLeftStart + ' - ' + this.rangeLeftEnd,
            rangeRight: this.rangeRightStart + ' - ' + this.rangeRightEnd
        };
    };

    return AddressRangesModel;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(10), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    var keyName = ApiKeyNames.search;

    return function () {
        return {
            reverseGeocode: requestFactory.single(endpoints.reverseGeocode, keyName),
            batch: requestFactory.batch(100, {
                single: endpoints.batchReverseGeocodeQuery,
                batch: endpoints.batchSearch,
                batchSync: endpoints.batchSyncSearch
            }, keyName)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(84)], __WEBPACK_AMD_DEFINE_RESULT__ = function (reverseGeocodeModel) {
    'use strict';

    return function (data) {
        if (!(data.batchItems instanceof Array)) {
            return null;
        }
        return data.batchItems.map(function (batchItem) {
            if (batchItem.response.error) {
                return { error: batchItem.response.error };
            } else {
                return reverseGeocodeModel(batchItem.response);
            }
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(80), __webpack_require__(81), __webpack_require__(79), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (AddressModel, PoiModel, SearchModel, utils) {
    'use strict';

    var LowBandwidthSearchModel = function LowBandwidthSearchModel(json) {
        this.type = json.tp;
        this.entityType = json.etp;

        this.address = new AddressModel({
            freeformAddress: json.a2
        });

        this.position = utils.convertToLatLng(json.ps.split(' '));

        this.poi = new PoiModel({
            name: json.nm,
            phone: json.ph,
            categories: json.ct,
            classifications: json.cst.map(function (classification) {
                return {
                    code: classification.cd,
                    names: classification.ns.map(function (name) {
                        return {
                            nameLocale: name.nl,
                            name: name.na
                        };
                    })
                };
            })
        });

        return this;
    };
    LowBandwidthSearchModel.prototype = Object.create(SearchModel.prototype);
    LowBandwidthSearchModel.prototype.constructor = LowBandwidthSearchModel;

    LowBandwidthSearchModel.prototype.simplify = function () {
        return {
            tp: this.type,
            etp: this.entityType,
            a2: this.address.freeformAddress,
            ps: this.position.lat + ' ' + this.position.lng,
            nm: this.poi.name,
            ph: this.poi.phone,
            ct: this.poi.categories,
            cst: this.poi.classifications.map(function (classification) {
                return {
                    cd: classification.code,
                    ns: classification.names.map(function (name) {
                        return {
                            nl: name.nameLocale,
                            na: name.name
                        };
                    })
                };
            })
        };
    };

    return LowBandwidthSearchModel;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(86)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, iconContent) {
    'use strict';

    var classes = {
        container: 'tomtom-point-content__name-container',
        name: 'tomtom-point-content__name'
    };

    return function (parentPoiData, type) {
        var div, span;

        div = L.DomUtil.create('div', classes.container);
        div.appendChild(iconContent(parentPoiData));

        span = L.DomUtil.create('span', classes.name, div);
        span.innerHTML = [parentPoiData.name, type, 'entry'].join(' ');

        return div;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(86)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, iconContent) {
    'use strict';

    var classes = {
        container: 'tomtom-point-content__name-container',
        name: 'tomtom-point-content__name'
    };

    return function (poiData) {
        var div, span;

        div = L.DomUtil.create('div', classes.container);
        div.appendChild(iconContent(poiData));

        span = L.DomUtil.create('span', classes.name, div);
        span.innerHTML = poiData.name;

        return div;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(88)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, addressContainer) {
    'use strict';

    return function (data) {
        var div = L.DomUtil.create('div', 'tomtom-point-content__address');

        if (data.address) {
            div.appendChild(addressContainer(data.address));
        } else {
            data.getAddress().then(function (data) {
                div.appendChild(addressContainer(data.address));
            });
        }
        return div;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {
    'use strict';

    return function (position) {
        var div = L.DomUtil.create('div', 'tomtom-point-content__coordinates');

        div.innerHTML = position.lat + ', ' + position.lng;
        return div;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * Generates actions for content generator based on configuration
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(89), __webpack_require__(159), __webpack_require__(160), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (actionButton, entryPointsButton, actionsChooser, Wrapable) {
    'use strict';

    var classes = {
        mainContainer: 'tomtom-point-content__actions',
        actionsContainer: 'tomtom-point-content__actions-container',
        actionsContainerVisible: 'tomtom-point-content__actions-container--visible',
        firstAction: 'tomtom-point-content__action--first',
        lastAction: 'tomtom-point-content__action--last'
    };
    function getActionsContainer(mainPanel) {
        var i, child;
        for (i = 0; i < mainPanel.children.length; ++i) {
            child = mainPanel.children[i];
            if (child.classList.contains(classes.actionsContainer)) {
                return child;
            }
        }
        return null;
    }

    function wrapComponents(wrapableComponents) {
        wrapableComponents.forEach(function (wrapableComponent) {
            wrapableComponent.wrap();
        });
    }

    function hideActions(actionsContainer, wrapableComponents) {
        actionsContainer.classList.remove(classes.actionsContainerVisible);
        wrapComponents(wrapableComponents);
    }

    function toggleActionsVisibility(actionsContainer, wrapableComponents) {
        if (actionsContainer.classList.contains(classes.actionsContainerVisible)) {
            hideActions(actionsContainer, wrapableComponents);
        } else {
            actionsContainer.classList.add(classes.actionsContainerVisible);
        }
    }

    function wrapUnwrapOnClickHandlerFactory(wrapableComponents) {
        return function (event) {
            var actionsContainer = getActionsContainer(event.currentTarget.parentElement);
            toggleActionsVisibility(actionsContainer, wrapableComponents);
        };
    }

    /**
     * @ignore
     * @param {Object} data Search smart model: either regular search result or entry point
     * @param {Object} options
     * @param {Object} [options.routing] An object grouping routing actions configuration
     * @param {Boolean} [options.routing.routeTo] A flag specifying if 'Route to' action should be generated.
     *    Coordinates for this action are taken from 'position' field associated with provided data object.
     * @param {Boolean} [options.routing.routeFrom] A flag specifying if 'Route from' action should be generated.
     *    Coordinates for this action are taken from 'position' field associated with provided data object.
     * @param {Boolean} [options.routing.routeToEntryPoint] A flag specifying if 'Route to' action for entry points
     *    should be generated. Coordinates for this action are taken from 'position' field associated with given entry
     *    point. If no entry point is available this action will not be generated.
     * @param {Boolean} [options.routing.routeFromEntryPoint] A flag specifying if 'Route from' action entry points
     *    should be generated. Coordinates for this action are taken from 'position' field associated with given entry
     *    point. If no entry point is available this action will not be generated.
     * @param {Function} [options.routing.onActionClick] 'click' event handler for all route actions. Most probably used
     *    for generating a route.
     * @param {Object} [options.search] An object grouping search actions configuration
     * @param {Boolean} [options.search.searchNearby] A flag specifying if 'NearBy' search action should be generated.
     * @param {Function} [options.search.onActionClick] 'click' event handler for all search actions.
     * @param {Object} [options.remove] An object specifying if 'Remove' action is generated.
     * @param {Function} [options.remove.onActionClick] 'click' event handler for all 'Remove' action.
     * @return {Wrapable}
     */
    return function (data, options) {
        var action,
            actionsContainer,
            mode,
            routingOnActionClicked = options.routing && options.routing.onActionClick,
            wrapUnwrapButton,
            wrapableComponents = [],
            mainPanel;

        function wrapActions() {
            wrapUnwrapButton.wrap();
            hideActions(actionsContainer, wrapableComponents);
        }

        mainPanel = L.DomUtil.create('div', classes.mainContainer);

        wrapUnwrapButton = actionsChooser(wrapUnwrapOnClickHandlerFactory(wrapableComponents));
        mainPanel.appendChild(wrapUnwrapButton.getHtmlElement());

        actionsContainer = L.DomUtil.create('div', classes.actionsContainer, mainPanel);

        if (options.routing) {
            if (options.routing.routeTo) {
                action = actionButton('icon-start-black', 'Route From', function () {
                    wrapActions();
                    if (routingOnActionClicked) {
                        routingOnActionClicked('start', data.position);
                    }
                });
                actionsContainer.appendChild(action);
            }

            if (options.routing.routeFrom) {
                action = actionButton('icon-end-black', 'Route To', function () {
                    wrapActions();
                    if (routingOnActionClicked) {
                        routingOnActionClicked('end', data.position);
                    }
                });
                actionsContainer.appendChild(action);
            }

            if (options.routing.routeToEntryPoint && data.entryPoints) {
                mode = 'start';
                action = entryPointsButton({
                    label: 'Route From Entry Point',
                    mode: mode,
                    entryPoints: data.entryPoints,
                    onEntryPointClick: function onEntryPointClick(mode, point) {
                        wrapActions();
                        if (routingOnActionClicked) {
                            routingOnActionClicked(mode, point);
                        }
                    },
                    onEntryPointsUnfold: wrapComponents.bind(null, wrapableComponents),
                    onEntryPointMouseover: options.routing.onEntryPointMouseover,
                    onEntryPointMouseout: options.routing.onEntryPointMouseout
                });
                wrapableComponents.push(action);
                actionsContainer.appendChild(action.getHtmlElement());
            }

            if (options.routing.routeFromEntryPoint && data.entryPoints) {
                mode = 'end';
                action = entryPointsButton({
                    label: 'Route To Entry Point',
                    mode: mode,
                    entryPoints: data.entryPoints,
                    onEntryPointClick: function onEntryPointClick(mode, point) {
                        wrapActions();
                        if (routingOnActionClicked) {
                            routingOnActionClicked(mode, point);
                        }
                    },
                    onEntryPointsUnfold: wrapComponents.bind(null, wrapableComponents),
                    onEntryPointMouseover: options.routing.onEntryPointMouseover,
                    onEntryPointMouseout: options.routing.onEntryPointMouseout
                });
                wrapableComponents.push(action);
                actionsContainer.appendChild(action.getHtmlElement());
            }
        }

        if (options.search && options.search.searchNearby) {
            actionsContainer.appendChild(actionButton('icon-search', 'Search nearby', function () {
                wrapActions();
                if (options.search.onActionClick) {
                    options.search.onActionClick({
                        lat: data.position.lat,
                        lon: data.position.lng
                    });
                }
            }));
        }

        if (options.remove && options.remove.onActionClick) {
            action = actionButton('icon-remove-black', 'Remove', options.remove.onActionClick.bind(null, data));
            actionsContainer.appendChild(action);
        }

        if (actionsContainer.firstChild) {
            actionsContainer.firstChild.classList.add(classes.firstAction);
        }

        if (actionsContainer.lastChild) {
            actionsContainer.lastChild.classList.add(classes.lastAction);
        }

        return new Wrapable(mainPanel, wrapActions);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * Action button representing a single entry point in the context of 'Route to entry point' and 'Route from entry point'
 * actions.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(89), __webpack_require__(88), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, actionButton, addressContainer, Wrapable) {
    'use strict';

    var classes = {
        mainPanel: 'tomtom-point-content__entry-points-action',
        entryPointsAnchorPanel: 'tomtom-point-content__anchor-panel',
        entryPointsPanel: 'tomtom-point-content__entry-points',
        entryPointsPanelHidden: 'tomtom-point-content__entry-points--hidden',
        entryPoint: 'tomtom-point-content__entry-point',
        entryPointWithBorder: 'tomtom-point-content__entry-point--with-border',
        entryPointFirst: 'tomtom-point-content__entry-point--first',
        entryPointLast: 'tomtom-point-content__entry-point--last'
    };

    function isEntryPointsListVisible(classList) {
        return !classList.contains(classes.entryPointsPanelHidden);
    }

    function hideEntryPoints(entryPointsPanel) {
        entryPointsPanel.classList.add(classes.entryPointsPanelHidden);
    }

    function toggleEntryPointsVisibility(entryPointsPanel, onEntryPointsUnfold) {
        if (isEntryPointsListVisible(entryPointsPanel.classList)) {
            hideEntryPoints(entryPointsPanel);
        } else {
            onEntryPointsUnfold();
            entryPointsPanel.classList.remove(classes.entryPointsPanelHidden);
        }
    }

    function createEntryPointsList(mode, entryPoints, entryPointClickHandler, entryPointMouseoverHandler, entryPointMouseoutHandler) {
        var addressPromises,
            entryPointsPanel = L.DomUtil.create('div', classes.entryPointsPanel),
            hideEntryPointsBound = hideEntryPoints.bind(null, entryPointsPanel);

        addressPromises = entryPoints.map(function (entryPoint) {
            return entryPoint.getAddress().then(function (addressPoint) {
                return {
                    entryPoint: entryPoint,
                    addressPoint: addressPoint
                };
            });
        });

        Promise.all(addressPromises).then(function (entryAddressPoints) {
            entryAddressPoints.reduce(function (container, entryAddressPoint, addressPointIndex) {
                var entry = addressContainer(entryAddressPoint.addressPoint.address),
                    entryPosition = entryAddressPoint.entryPoint.position;
                entry.classList.add(classes.entryPoint);

                if (addressPointIndex === 0) {
                    entry.classList.add(classes.entryPointFirst);
                } else {
                    entry.classList.add(classes.entryPointWithBorder);
                }

                if (addressPointIndex === entryAddressPoints.length - 1) {
                    entry.classList.add(classes.entryPointLast);
                }

                if (entryPointMouseoverHandler) {
                    entry.addEventListener('mouseover', entryPointMouseoverHandler.bind(entry, entryPosition));
                }

                if (entryPointMouseoutHandler) {
                    entry.addEventListener('mouseout', entryPointMouseoutHandler.bind(entry, entryPosition));
                }

                container.appendChild(entry);
                if (entryPointClickHandler) {
                    entry.addEventListener('click', function () {
                        hideEntryPointsBound();
                        entryPointClickHandler.call(entry, mode, entryPosition);
                    });
                }
                return container;
            }, entryPointsPanel);
        });

        return entryPointsPanel;
    }

    /**
     * @ignore
     * @param {Object} options
     * @param {String} options.label Text label
     * @param {String} options.mode Button routing mode. It might be either 'start' or 'end'
     * @param {Object} options.entryPoints The list of entry points.
     * @param {Function} options.onEntryPointsUnfold
     * @param {Function} options.onEntryPointClick
     * @param {Function} options.onEntryPointMouseover
     * @param {Function} options.onEntryPointMouseout
     * @return {Wrapable}
     */
    return function (options) {
        var mainPanel,
            entryPointsAnchorPanel,
            label = options.label,
            mode = options.mode,
            entryPoints = options.entryPoints,
            onEntryPointsUnfold = options.onEntryPointsUnfold,
            onEntryPointClick = options.onEntryPointClick,
            onEntryPointMouseover = options.onEntryPointMouseover,
            onEntryPointMouseout = options.onEntryPointMouseout,
            action;

        function actionsButtonClickHandler() {
            var entryPointsAlreadyAdded = Boolean(entryPointsAnchorPanel.children.length),
                entryPointsPanel,
                entryPointsPanelIndex = 0;

            if (!entryPoints || !entryPoints.length) {
                return;
            }

            if (entryPointsAlreadyAdded) {
                toggleEntryPointsVisibility(entryPointsAnchorPanel.children[entryPointsPanelIndex], onEntryPointsUnfold);
            } else {
                onEntryPointsUnfold();
                entryPointsPanel = createEntryPointsList(mode, entryPoints, onEntryPointClick, onEntryPointMouseover, onEntryPointMouseout);
                entryPointsAnchorPanel.appendChild(entryPointsPanel);
            }
        }

        action = actionButton('icon-' + mode + '-black', label, actionsButtonClickHandler);

        mainPanel = L.DomUtil.create('div', classes.mainPanel);
        mainPanel.appendChild(action);
        entryPointsAnchorPanel = L.DomUtil.create('div', classes.entryPointsAnchorPanel, mainPanel);

        return new Wrapable(mainPanel, function (mainPanel) {
            var entryPointsAnchorPanelIndex = 1,
                entryPointsPanelIndex = 0,
                entryPointsAnchorPanel = mainPanel.children[entryPointsAnchorPanelIndex],
                entryPointsAlreadyAdded = Boolean(entryPointsAnchorPanel.children.length),
                entryPointsPanel;
            if (!entryPointsAlreadyAdded) {
                return;
            }
            entryPointsPanel = entryPointsAnchorPanel.children[entryPointsPanelIndex];
            if (!entryPointsPanel.classList.contains(classes.entryPointsPanelHidden)) {
                entryPointsPanel.classList.add(classes.entryPointsPanelHidden);
            }
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * A button providing functionality of wraping/unwraping configured actions
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, Wrapable) {
    'use strict';

    var classes = {
        action: 'tomtom-point-content__action-chooser'
    },
        nonClickedText = 'Show actions',
        clickedText = 'Hide actions';

    return function (clickHandler) {
        var buttonContainer = L.DomUtil.create('div', classes.action),
            textContainer = L.DomUtil.create('span', null, buttonContainer),
            clicked = false;

        textContainer.innerHTML = nonClickedText;

        function changeButtonLabelWhenClicked() {
            clicked = !clicked;
            if (clicked) {
                textContainer.innerHTML = clickedText;
            } else {
                textContainer.innerHTML = nonClickedText;
            }
        }

        if (clickHandler) {
            buttonContainer.addEventListener('click', clickHandler);
            buttonContainer.addEventListener('click', changeButtonLabelWhenClicked);
        }

        return new Wrapable(buttonContainer, function () {
            clicked = false;
            textContainer.innerHTML = nonClickedText;
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(91)], __WEBPACK_AMD_DEFINE_RESULT__ = function (searchModel) {
    'use strict';

    return function (data) {
        if (!(data.batchItems instanceof Array)) {
            return null;
        }
        return data.batchItems.map(function (batchItem) {
            if (batchItem.response.error) {
                return { error: batchItem.response.error };
            } else {
                return searchModel(batchItem.response);
            }
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(4), __webpack_require__(44), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (validators, converters, searchTypes, parameterApplications) {

    return {
        create: function create() {
            return {
                key: { validator: validators.string },
                query: {
                    validator: validators.string, converter: converters.queryString, required: true,
                    application: parameterApplications.PATH
                },
                typeahead: { validator: validators.bool },
                limit: { validator: validators.limit },
                offset: { validator: validators.offset, name: 'ofs' },
                language: {
                    validator: validators.languageCode,
                    converter: converters.language,
                    defaultValue: 'en-GB'
                },
                countrySet: { validator: validators.countrySet },
                radius: { validator: validators.positiveInteger },
                boundingBox: { validator: validators.boundingBox, converter: converters.boundingBox },
                center: { converter: converters.point, validator: validators.point },
                type: {
                    validator: validators.string, defaultValue: searchTypes.search,
                    application: parameterApplications.PATH
                },
                bestResult: { validator: validators.bool },
                protocol: { validator: validators.oneOfValue(['http', 'https'], 'protocol') },
                extendedPostalCodesFor: { validator: validators.string },
                unwrapBbox: { validator: validators.bool, defaultValue: false, required: true },
                view: { validator: validators.geopolView('search', 'view') }
            };
        },
        modifyRequestOptions: function modifyRequestOptions(requestOptions) {
            var bestResult = Boolean(requestOptions.bestResult);
            if (bestResult) {
                requestOptions.limit = 1;
                requestOptions.offset = 0;
            }

            if (requestOptions.center) {
                requestOptions.center = requestOptions.center.split(',');
                requestOptions.lat = requestOptions.center[0];
                requestOptions.lon = requestOptions.center[1];
                delete requestOptions.center;
            }
        },

        /*
        * At this moment it's impossible to map one field to two and more output fields but we need to do this, e.g.
        * bounding box needs to be mapped to topLeft and btmRight. That's why this method tries to fix this
        */
        modifyFields: function modifyFields(fields) {
            var resultFields = Object.assign({}, fields);
            if (resultFields.boundingBox) {
                resultFields.topLeft = {};
                resultFields.btmRight = {};
                delete resultFields.boundingBox;
            }

            if (resultFields.center) {
                resultFields.lat = {};
                resultFields.lon = {};
                delete resultFields.center;
            }

            return resultFields;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Allows to make requests using the TomTom's
 * [Search API - Geocode](https://developer.tomtom.com/search-api/search-api-documentation-geocoding/geocode).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "Geocode/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "Geocode/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @example
 * ```js
 * function callbackFn(result) {
 *   console.log(result);
 * };
 * tomtom.geocode()
 *   .query('Amsterdam, The Netherlands')
 *   .callback(callbackFn)
 *   .go();
 * ```
 *
 * @class Geocode
 * @module Services
 * @uses Chain
 * @constructor
 * @uses KeyMixin
 * @uses QueryMixin
 * @uses TypeaheadMixin
 * @uses LimitMixin
 * @uses OffsetMixin
 * @uses LanguageMixin
 * @uses BoundingBoxMixin
 * @uses CenterMixin
 * @uses CountrySetMixin
 * @uses RadiusMixin
 * @uses BestResultMixin
 * @uses ProtocolMixin
 * @uses UnwrapMixin
 *
 * @param {Object} [options] Options to be passed to the geocoding call,
 *     or Array of such options objects to perform batch request.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String} [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 *
 * @param {String} options.query Text that will be searched.
 *  This parameter is required to be defined either in the options passed to the constructor or using the
 *  **query()** method.
 * @param {Boolean} [options.storeResult=false] If is enabled the query will be interpreted as a stored geocode
 *     and will be billed according to the terms of use
 * @param {Boolean}  [options.typeahead=false] If is enabled the query will be interpreted as a
 *  partial input and the **predictive** mode will be used
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {Number}   [options.offset=0] Starting offset of the returned results within the full result set
 * @param {Number[]|String|L.LatLng|Object} [options.center] Location where results should be biased
 * @param {String}   [options.countrySet] List of country codes for limit the search request to those specific
 *  political limits
 * @param {Number}   [options.radius=0] The search radius in meters using the coordinates given to the **center**
 *  option as origin.
 * @param {Object|Number[]|Object[]|String} [options.boundingBox] The bounding box is an area within the search
 *  results needs to limit to. If it is omitted then the whole world will be taken into consideration.
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {String}   [options.extendedPostalCodesFor] Represent the indexes for which extended postal codes should
 *  be included in the results
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(164), __webpack_require__(45), __webpack_require__(8), __webpack_require__(2), __webpack_require__(4), __webpack_require__(22), __webpack_require__(94), __webpack_require__(165)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restGeocode, model, chain, validators, converters, worldEdge, batchModel, geocodeParams) {
    'use strict';

    var fields = geocodeParams.create(),
        batchFields = {
        batchItems: {
            validator: validators.arrayOf(fields),
            converter: converters.arrayOf(fields)
        }
    };

    var geocode = restGeocode();

    function addBoundingBoxParameters(data, boundingBox) {
        data.topLeft = [boundingBox.maxLat, boundingBox.minLon];
        data.btmRight = [boundingBox.minLat, boundingBox.maxLon];
        return data;
    }

    function callbackBestResult(bestResult, callback) {
        return function (response) {
            callback(bestResult ? response[0] : response);
        };
    }

    function handleBatchChain(data, callback) {
        data.batchItems.forEach(geocodeParams.modifyRequestOptions);
        geocode.batch(geocodeParams.modifyFields(fields), data, function (results) {
            callback.call(this, batchModel(results));
        });
    }

    function geocodeQuery(fields) {
        return function (options, callback) {
            return geocode.geocode(geocodeParams.modifyFields(fields), options, callback);
        };
    }

    function handleChain(data, callback) {
        geocodeParams.modifyRequestOptions(data);
        worldEdge(geocodeQuery(fields), model, data, callbackBestResult(Boolean(data.bestResult), callback), addBoundingBoxParameters);
    }

    return function (options) {
        if (Array.isArray(options)) {
            return chain(batchFields, handleBatchChain, {
                batchItems: options
            });
        } else {
            return chain(fields, handleChain, options);
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(10), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    var searchApiKeyname = ApiKeyNames.search;

    return function () {
        return {
            geocode: requestFactory.single(endpoints.geocode, searchApiKeyname),
            batch: requestFactory.batch(100, {
                single: endpoints.batchGeocodeQuery,
                batchSync: endpoints.batchSyncSearch,
                batchSearch: endpoints.batchSearch
            }, searchApiKeyname)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(4), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (validators, converters, parameterApplications) {
    return {
        create: function create() {
            return {
                key: { validator: validators.string },
                query: { validator: validators.string, required: true, application: parameterApplications.PATH },

                /**
                * @class Geocode
                * @module Services
                */

                /* eslint-disable max-len */
                /**
                 * Sets or returns the value of the `storeResult` option.
                 *
                 * If this option is enabled the query will be interpreted as a stored geocode and will be billed
                 * according to the terms of use.
                 *
                 * @method storeResult
                 * @deprecated Announcement date: 1st December 2017. The previous version will be deprecated and taken off-line 1 year after the announcement. Deprecation date: 1st December 2018.
                 * @chainable
                 * @param {Boolean} [newValue] Enable or disable the option
                 * @throws {TypeError} if the given argument cannot be converted into a valid value
                 * @return {Boolean} The same service instance or the current option value if no argument was given
                 */
                /* eslint-enable max-len */
                storeResult: { validator: validators.bool },
                typeahead: { validator: validators.bool },
                limit: { validator: validators.positiveInteger },
                offset: { validator: validators.naturalInteger, name: 'ofs' },
                language: { validator: validators.languageCode },
                boundingBox: { validator: validators.boundingBox, converter: converters.boundingBox },
                center: { converter: converters.point, validator: validators.point },
                countrySet: { validator: validators.countrySet },
                radius: { validator: validators.naturalInteger },
                bestResult: { validator: validators.bool },
                protocol: { validator: validators.oneOfValue(['http', 'https'], 'protocol') },
                unwrapBbox: { validator: validators.bool, defaultValue: false, required: true }
            };
        },
        modifyRequestOptions: function modifyRequestOptions(data) {
            var bestResult = Boolean(data.bestResult);
            if (bestResult) {
                data.limit = 1;
                data.offset = 0;
            }

            if (data.center) {
                data.center = data.center.split(',');
                data.lat = data.center[0];
                data.lon = data.center[1];
                delete data.center;
            }
        },
        modifyFields: function modifyFields(fields) {
            var resultFields = Object.assign({}, fields);
            if (resultFields.boundingBox) {
                resultFields.topLeft = {};
                resultFields.btmRight = {};
                delete resultFields.boundingBox;
            }

            if (resultFields.center) {
                resultFields.lat = {};
                resultFields.lon = {};
                delete resultFields.center;
            }
            return resultFields;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Allows to make request using the TomTom's
 * [Search API - Structured Geocode](https://developer.tomtom.com/search-api/search-api-documentation-geocoding/structured-geocode).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "StructuredGeocode/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "StructuredGeocode/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class StructuredGeocode
 * @uses Chain
 * @module Services
 * @uses KeyMixin
 * @uses LimitMixin
 * @uses OffsetMixin
 * @uses LanguageMixin
 * @uses ProtocolMixin
 * @uses BestResultMixin
 * @constructor
 *
 * @param {Object} [options] Options to be passed to the structured geocoding call,
 *     or Array of such options objects to perform batch request.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.bestResult=false] Return only one result, the best match result
 *
 * @param {String} [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {String} options.countryCode 2 or 3 country code letters (e.g.: FR, ES).
 *     **This option is required** to be defined here or by using the
 *     {{#crossLink "StructuredGeocode/countryCode:method"}}{{/crossLink}} method.
 * @param {Number} [options.limit=10] Maximum number of responses that will be returned
 * @param {Number} [options.offset=0] Starting offset of the returned results within the full result set
 * @param {String} [options.language] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {String} [options.streetNumber] Street Number
 * @param {String} [options.streetName] Street name
 * @param {String} [options.crossStreet] Cross street name
 * @param {String} [options.municipality] Municipality (city/town)
 * @param {String} [options.municipalitySubdivision] Municipality subdivision (sub/super city)
 * @param {String} [options.countryTertiarySubdivision] Named area
 * @param {String} [options.countrySecondarySubdivision] County
 * @param {String} [options.countrySubdivision] State or province
 * @param {String} [options.postalCode] Zip or postal code
 *
 * @example
 * ```javascript
 * function callbackFn(result) {
 *   console.log(result);
 * };
 * tomtom.structuredGeocode()
 *   .countryCode("GB")
 *   .callback(callbackFn)
 *   .go();
 * ```
 */
/* eslint-enable max-len */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(167), __webpack_require__(45), __webpack_require__(8), __webpack_require__(2), __webpack_require__(94), __webpack_require__(4), __webpack_require__(168)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restStructuredGeocode, model, chain, validators, batchModel, converters, structureGeocodeParameters) {
    'use strict';

    var fields = structureGeocodeParameters(),
        batchFields = {
        batchItems: {
            validator: validators.arrayOf(fields),
            converter: converters.arrayOf(fields)
        }
    };

    var structuredGeocode = restStructuredGeocode();

    function checkBestResult(data) {
        var result = Boolean(data.bestResult);
        delete data.bestResult;
        return result;
    }

    function modifyRequestParams(data) {
        var bestResult = checkBestResult(data);
        if (bestResult) {
            data.limit = 1;
            data.offset = 0;
        }
    }

    function handleBatchChain(data, callback) {
        data.batchItems.forEach(modifyRequestParams);
        structuredGeocode.batch(fields, data, function (results) {
            callback.call(this, batchModel(results));
        });
    }

    function handleChain(data, callback) {
        var bestResult = Boolean(data.bestResult);
        modifyRequestParams(data);
        structuredGeocode.structuredGeocode(fields, data, function (response) {
            if (bestResult) {
                callback.call(this, model(response)[0]);
            } else {
                callback.call(this, model(response));
            }
        });
    }

    return function (options) {
        if (Array.isArray(options)) {
            return chain(batchFields, handleBatchChain, {
                batchItems: options
            });
        } else {
            return chain(fields, handleChain, options);
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(10), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    var searchKeyName = ApiKeyNames.search;

    return function () {
        return {
            structuredGeocode: requestFactory.single(endpoints.structuredGeocode, searchKeyName),
            batch: requestFactory.batch(100, {
                single: endpoints.batchStructuredGeocodeQuery,
                batch: endpoints.batchSearch,
                batchSync: endpoints.batchSyncSearch
            }, searchKeyName)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (validators) {
  return function () {
    return {
      key: { validator: validators.string },
      /**
       * Sets or returns the value of the `countryCode` option.
       *
       * Represents the country's code.
       *
       * @method countryCode
       * @chainable
       * @param {String} [newValue] 2 or 3 country code letters
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      countryCode: { validator: validators.countryCode, required: true },
      limit: { validator: validators.limit },
      offset: { validator: validators.naturalInteger, name: 'ofs' },
      language: { validator: validators.languageCode },

      /**
       * Sets or returns the value of the `streetNumber` option.
       *
       * Represents the street's number for the structured address.
       *
       * @method streetNumber
       * @chainable
       * @param {String} [newValue] Street's number
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      streetNumber: { validator: validators.string },

      /**
       * Sets or returns the value of the `streetName` option.
       *
       * Represents the street's name for the structured address.
       *
       * @method streetName
       * @chainable
       * @param {String} [newValue] Street's name
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      streetName: { validator: validators.string },

      /**
       * Sets or returns the value of the `crossStreet` option.
       *
       * Represents the cross street's name for the structured address.
       *
       * @method crossStreet
       * @chainable
       * @param {String} [newValue] Cross street's name
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      crossStreet: { validator: validators.string },

      /**
       * Sets or returns the value of the `municipality` option.
       *
       * Represents the municipality (city/town) for the structured address.
       *
       * @method municipality
       * @chainable
       * @param {String} [newValue] Municipality's name (city/town)
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      municipality: { validator: validators.string },

      /**
       * Sets or returns the value of the `municipalitySubdivision` option.
       *
       * Represents the municipality subdivision (sub/super city) for the structured address.
       *
       * @method municipalitySubdivision
       * @chainable
       * @param {String} [newValue] Municipality subdivision (sub/super city)
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      municipalitySubdivision: { validator: validators.string },

      /**
       * Sets or returns the value of the `countryTertiarySubdivision` option.
       *
       * Represents the area's name for the structured address.
       *
       * @method countryTertiarySubdivision
       * @chainable
       * @param {String} [newValue] Name of the area
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      countryTertiarySubdivision: { validator: validators.string },

      /**
       * Sets or returns the value of the `countrySecondarySubdivision` option.
       *
       * Represents the county's name for the structured address.
       *
       * @method countrySecondarySubdivision
       * @chainable
       * @param {String} [newValue] County's name
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      countrySecondarySubdivision: { validator: validators.string },

      /**
       * Sets or returns the value of the `countrySubdivision` option.
       *
       * Represents the state or province's name for the structured address.
       *
       * @method countrySubdivision
       * @chainable
       * @param {String} [newValue] State or province
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      countrySubdivision: { validator: validators.string },

      /**
       * Sets or returns the value of the `postalCode` option.
       *
       * Represents the zip code or postal code for the structured address.
       *
       * @method postalCode
       * @chainable
       * @param {String} [newValue] Zip or postal code
       * @throws {TypeError} If the given argument cannot be converted into a valid value
       * @return {String} The same service instance or the current option value if no argument was given
       */
      postalCode: { validator: validators.string },

      protocol: { validator: validators.oneOfValue(['http', 'https'], 'protocol') },
      bestResult: { validator: validators.bool }
    };
  };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * It allows to convert geographical coordinates into textual address representation using the TomTom's
 * [Search API - CrossStreet lookup](https://developer.tomtom.com/search-api/search-api-documentation-reverse-geocoding/crossstreet-lookup).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "CrossStreetLookup/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "CrossStreetLookup/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The final response from service is a JSON object with the following structure:
 *
 * ```js
 * {
 *   address: {
 *     buildingNumber: 19,
 *     streetNumber: 19,
 *     street: "N 2nd St",
 *     streetName: "N 2nd St",
 *     crossStreet: "E SANTA CLARA ST"
 *     streetNameAndNumber: "",
 *     speedLimit: "",
 *     countryCode: "US",
 *     countrySubdivision: "CA",
 *     countrySecondarySubdivision: "Santa Clara",
 *     countryTertiarySubdivision: "",
 *     municipality: "San Jose",
 *     postalCode: "95113",
 *     municipalitySubdivision: "San Francisco Bay Area",
 *     freeformAddress: "E SANTA CLARA ST &amp; N 2nd St, San Jose, CA, 95113"
 *   },
 *   position: "37.337083, -121.8898"
 * }
 * ```
 *
 * @example
 * ```js
 * tomtom.crossStreetLookup()
 *   .position('51.759,19.449')
 *   .go()
 *   .then(function(response) {
 *     console.log(response);
 *   });
 * ```
 *
 * @class CrossStreetLookup
 * @module Services
 * @uses Chain
 * @constructor
 * @uses RadiusMixin
 * @uses ProtocolMixin
 * @uses KeyMixin
 * @uses LimitMixin
 * @uses LanguageMixin
 * @uses PositionMixin
 * @uses SpatialKeysMixin
 * @uses HeadingMixin
 *
 * @param {Object} [options] Options to be passed to the cross street lookup call,
 *     or Array of such options objects to perform batch request.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 *
 * @param {String|Array|Object} [options.position] Specific longitude and latitude of the location where the address
 *     is supposed to be found.
 *     The possible formats are explained in more detail in the
 *     {{#crossLink "CrossStreetLookup/position:method"}}{{/crossLink}} method.
 *     This option is required to make the call.
 *
 * @param {Number} [options.limit=10] Maximum number of responses that should be returned
 * @param {Boolean} [options.spatialKeys=false] If is enable the response will also contain a proprietary geo-spatial
 *     key information for a specified location
 * @param {Number} [options.heading] The directional heading of the vehicle in degrees, for travel along a
 *     segment of roadway.
 *     `0` is North, `90` is East and so on, values range from `-360` to `360`.
 *     The precision can include up to one decimal place.
 * @param {Number} [options.radius=10000] The maximum distance in meters from the specified position to consider
 * @param {String} [options.language] Language to use in the response.
 *     The list with all the available codes can be found
 *     <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 */
/* eslint-enable max-len */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(83), __webpack_require__(85), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = function (reverseGeocodeBase, reverseGeocodeParams, types) {
    'use strict';

    var ReverseGeocodeBasePrototype = reverseGeocodeBase.prototype.constructor;

    function CrossStreetLookup(options) {
        ReverseGeocodeBasePrototype.call(this, options);
        this.fields = reverseGeocodeParams(types.crossStreetLookup);
    }

    CrossStreetLookup.prototype = new ReverseGeocodeBasePrototype();
    CrossStreetLookup.prototype.constructor = CrossStreetLookup;

    return function (options) {
        return new CrossStreetLookup(options).construct();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Allows to make search request using the TomTom's
 * [Search API - Points of Interest Search](https://developer.tomtom.com/search-api/search-api-documentation-search/points-interest-search).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "PoiSearch/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "PoiSearch/go:method"}}{{/crossLink}} method to handle the response.
 *
 * @example
 * ```js
 * function callbackFn(result) {
 *    console.log(result);
 * };
 *
 * // Using a callback function
 * tomtom.poiSearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query('pizza')
 *   .callback(callbackFn)
 *   .go();
 *
 * // Or using a Promise
 * tomtom.poiSearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query('pizza')
 *   .go()
 *   .then(callbackFn);
 * ```
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class PoiSearch
 * @extends Search
 * @uses ExtendedPostalCodesForMixin
 * @uses CenterMixin
 * @uses RadiusMixin
 * @uses BoundingBoxMixin
 * @uses CountrySetMixin
 * @uses OffsetMixin
 * @uses BestResultMixin
 * @uses ViewMixin
 * @uses QueryMixin
 * @uses TypeaheadMixin
 * @constructor
 * @module Services
 *
 * @param {Object}   [options] Options to be passed to the POI search call,
 *     or Array of such options objects to perform batch request.
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String} [options.view="Unified"] Geopolitical view
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String}   [options.query] Text that will be searched.
 *  This parameter is required to be defined either in the options passed to the constructor or using the
 *  **query()** method.
 * @param {Boolean}  [options.typeahead=false] Enables the **predictive** mode
 * @param {Boolean}  [options.bestResult=false] Return only one result, the best match result.
 * @param {Number[]|String|L.LatLng|Object} [options.center] Location where results should be biased
 * @param {Number}   [options.radius=0] The search radius in meters using the coordinates given to the **center**
 *  option as origin.
 *  If the radius is zero the results will not be constrained.
 * @param {Number}   [options.offset=0] Starting offset of the returned results within the full result set
 * @param {String}   [options.countrySet] List of country codes for limit the search request to those specific
 *  political limits
 * @param {Object|Number[]|Object[]|String} [options.boundingBox] The bounding box is an area within the search
 *  results needs to limit to. If it is omitted then the whole world will be taken into consideration.
 * @param {String}   [options.extendedPostalCodesFor] Represent the indexes for which extended postal codes should
 *  be included in the results
 */
/* eslint-enable */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17)], __WEBPACK_AMD_DEFINE_RESULT__ = function (search) {
    'use strict';

    var SearchPrototype = search.prototype.constructor;

    function PoiSearch(options) {
        SearchPrototype.call(this, options);

        this.fields.type = {
            defaultValue: this.TYPE.poi,
            visible: false
        };
    }

    PoiSearch.prototype = new SearchPrototype();
    PoiSearch.prototype.constructor = PoiSearch;

    return function (options) {
        return new PoiSearch(options).construct();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Allows to make search request using the TomTom's
 * [Search API - Category Search](https://developer.tomtom.com/search-api/search-api-documentation-search/category-search).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "Search/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the {{#crossLink "Search/go:method"}}{{/crossLink}}
 *    method to handle the response.
 *
 * The list of all supported category codes are available
 * [here](https://developer.tomtom.com/search-api/search-api-documentation/supported-category-codes).
 *
 * @example
 * ```js
 * function callbackFn(result) {
 *   console.log(result);
 * };
 *
 * // Using a callback function
 * tomtom.categorySearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("restaurant")
 *   .callback(callbackFn)
 *   .go();
 *
 * // Or using a Promise
 * tomtom.categorySearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("restaurant")
 *   .go()
 *   .then(callbackFn);
 * ```
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class CategorySearch
 * @extends Search
 * @uses ExtendedPostalCodesForMixin
 * @uses CenterMixin
 * @uses RadiusMixin
 * @uses BoundingBoxMixin
 * @uses CountrySetMixin
 * @uses OffsetMixin
 * @uses BestResultMixin
 * @uses QueryMixin
 * @uses ViewMixin
 * @uses TypeaheadMixin
 * @constructor
 * @module Services
 *
 * @param {Object}   [options] Options to be passed to the category search call,
 *     or Array of such options objects to perform batch request.
 * @param {String}   [options.key] An API Key issued from <a href="http://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String} [options.view="Unified"] Geopolitical view
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String}   [options.query] Text that will be searched.
 *  This parameter is required to be defined either in the options passed to the constructor or using the
 *  **query()** method.
 * @param {Boolean}  [options.typeahead=false] Enables the **predictive** mode
 * @param {Boolean}  [options.bestResult=false] Return only one result, the best match result.
 * @param {Number[]|String|L.LatLng|Object} [options.center] Location where results should be biased
 * @param {Number}   [options.radius=0] The search radius in meters using the coordinates given to the **center**
 *  option as origin.
 *  If the radius is zero the results will not be constrained.
 * @param {Number}   [options.offset=0] Starting offset of the returned results within the full result set
 * @param {String}   [options.countrySet] List of country codes for limit the search request to those specific
 *  political limits
 * @param {Object|Number[]|Object[]|String} [options.boundingBox] The bounding box is an area within the search
 *  results needs to limit to. If it is omitted then the whole world will be taken into consideration.
 * @param {String}   [options.extendedPostalCodesFor] Represent the indexes for which extended postal codes should
 *  be included in the results
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17)], __WEBPACK_AMD_DEFINE_RESULT__ = function (search) {
    'use strict';

    var SearchPrototype = search.prototype.constructor;

    function CategorySearch(options) {
        SearchPrototype.call(this, options);

        this.fields.type = {
            defaultValue: this.TYPE.category,
            visible: false
        };
    }

    CategorySearch.prototype = new SearchPrototype();
    CategorySearch.prototype.constructor = CategorySearch;

    return function (options) {
        return new CategorySearch(options).construct();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Allows to make search request using the TomTom's
 * [Search API - Geometry Search](https://developer.tomtom.com/search-api/search-api-documentation-search/geometry-search).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "GeometrySearch/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "GeometrySearch/go:method"}}{{/crossLink}} method to handle the response.
 *
 * @example
 * ```js
 * var geometryList = [
 *   {
 *     type: "POLYGON",
 *     vertices: [
 *       "37.7524152343544,-122.43576049804686",
 *       "37.70660472542312,-122.43301391601562",
 *       "37.712059855877314,-122.36434936523438",
 *       "37.75350561243041,-122.37396240234374"
 *     ]
 *   },
 *   {
 *     type: "CIRCLE",
 *     position: "37.71205,-121.36434",
 *     radius: 6000
 *   },
 *   {
 *     type: "CIRCLE",
 *     position: "37.31205,-121.36434",
 *     radius: 1000
 *   }
 * ];
 *
 * function callbackFn(results) {
 *   console.log(results);
 * }
 *
 * // Using a callback function
 * tomtom.geometrySearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .geometryList(geometryList)
 *   .query('pizza')
 *   .callback(callbackFn)
 *   .go();
 *
 * // Or using a Promise
 * tomtom.geometrySearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .geometryList(geometryList)
 *   .query('pizza')
 *   .go()
 *   .then(callbackFn);
 * ```
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class GeometrySearch
 * @extends Search
 * @uses QueryMixin
 * @uses IdxSetMixin
 * @uses ExtendedPostalCodesForMixin
 * @uses ViewMixin
 * @constructor
 * @module Services
 *
 * @param {Object}   [options] Options to be passed to the geometry search call,
 *     or Array of such options objects to perform batch request.
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 * @param {String}   options.query Text that will be searched.
 *  This parameter is required to be defined either in the options passed to the constructor or using the
 *  **query()** method.
 * @param {Array}    [options.geometryList] Represents the list of geometries for the geometry search
 * @param {String}   [options.idxSet] Specify which indexes to utilize for the search
 * @param {String}   [options.extendedPostalCodesFor] Represent the indexes for which extended postal codes should
 *  be included in the results
 * @param {String}   [options.view] Sets the geopolitical view used in the service
 */
/* eslint-enable */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17), __webpack_require__(2), __webpack_require__(4), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (search, validators, converters, parameterApplications) {
    'use strict';

    var searchPrototype = search.prototype.constructor;

    function GeometrySearch(options) {
        this.options = options;
        this.fields = {};

        this.fields.type = {
            defaultValue: this.TYPE.geometry,
            visible: false,
            application: parameterApplications.PATH
        };

        this.fields.key = {
            validator: validators.string
        };

        this.fields.query = {
            validator: validators.string,
            required: true,
            application: parameterApplications.PATH
        };

        this.fields.limit = {
            validator: validators.limit
        };

        this.fields.language = {
            validator: validators.languageCode
        };

        this.fields.view = {
            validator: validators.geopolView('search', 'view')
        };

        /**
        * Sets or gets the current value of the option "geometryList".
        *
        * Its a list of geometries to search in.
        *
        * Currently only two types of geometries are being supported:
        *  - Polygons: Groups of coordinates that describes an enclosed area
        *  - Circles: Describe a circular area using an unique coordinate and a radius in meters
        *
        * @example
        * ```js
        * // A polygon area
        * [
        *   {
        *     type: "POLYGON",
        *     vertices: [
        *       "37.7524152343544,-122.43576049804686",
        *       "37.70660472542312,-122.43301391601562",
        *       "37.712059855877314,-122.36434936523438",
        *       "37.75350561243041,-122.37396240234374"
        *     ]
        *   }
        * ];
        * ```
        *
        * @example
        * ```js
        * // A couple of circle areas
        * var geometryList = [
        *   {
        *     type: "CIRCLE",
        *     position: "37.71205,-121.36434",
        *     radius: 6000 // Unit is in meters
        *   },
        *   {
        *     type: "CIRCLE",
        *     position: "37.31205,-121.36434",
        *     radius: 1000 // Unit is in meters
        *   }
        * ];
        * ```
        *
        * @example
        * ```js
        * // Mixing polygons and circles areas
        * var geometryList = [
        *   {
        *     type: "POLYGON",
        *     vertices: [
        *       "37.7524152343544,-122.43576049804686",
        *       "37.70660472542312,-122.43301391601562",
        *       "37.712059855877314,-122.36434936523438",
        *       "37.75350561243041,-122.37396240234374"
        *     ]
        *   },
        *   {
        *     type: "CIRCLE",
        *     position: "37.71205,-121.36434",
        *     radius: 6000
        *   },
        *   {
        *     type: "CIRCLE",
        *     position: "37.31205,-121.36434",
        *     radius: 1000
        *   }
        * ];
        * ```
        *
        * @method geometryList
        * @chainable
        * @param {Object[]} [newValue] List of geometries
        * @throws {TypeError} If the given argument cannot be converted to a valid value
        * @return {Object[]} The same service instance or the current option value if no argument was given
        */
        this.fields.geometryList = {
            validator: validators.geometryList,
            converter: converters.geometryList,
            application: parameterApplications.POST
        };

        this.fields.idxSet = {
            validator: validators.string
        };

        this.fields.protocol = { validator: validators.protocol };

        this.fields.extendedPostalCodesFor = { validator: validators.string };

        this.fields.unwrapBbox = { validator: validators.bool, defaultValue: false, required: true };
    }

    GeometrySearch.prototype = searchPrototype.prototype;
    GeometrySearch.prototype.constructor = GeometrySearch;

    return function (options) {
        return new GeometrySearch(options).construct();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Allows to make search request using the TomTom's
 * [Search API - Low Bandwidth Search](https://developer.tomtom.com/search-api/search-api-documentation-search/low-bandwidth-search).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "LowBandwidthSearch/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "LowBandwidthSearch/go:method"}}{{/crossLink}} method to handle the response.
 *
 * @example
 * ```js
 * function callbackFn(results) {
 *   console.log(results);
 * }
 *
 * // Using a callback function
 * tomtom.lowBandwidthSearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("Amsterdam, The Netherlands")
 *   .callback(callbackFn)
 *   .go();
 *
 * // Or using a Promise
 * tomtom.lowBandwidthSearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("Amsterdam, The Netherlands")
 *   .go()
 *   .then(callbackFn);
 * ```
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class LowBandwidthSearch
 * @extends Search
 * @uses CenterMixin
 * @uses RadiusMixin
 * @uses BoundingBoxMixin
 * @uses CountrySetMixin
 * @uses OffsetMixin
 * @uses BestResultMixin
 * @uses ViewMixin
 * @uses QueryMixin
 * @uses TypeaheadMixin
 * @uses IdxSetMixin
 * @constructor
 * @module Services
 *
 * @param {Object}   [options]
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String} [options.view="Unified"] Geopolitical view
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String}   [options.query] Text that will be searched.
 *  This parameter is required to be defined either in the options passed to the constructor or using the
 *  **query()** method.
 * @param {Boolean}  [options.typeahead=false] Enables the **predictive** mode
 * @param {Boolean}  [options.bestResult=false] Return only one result, the best match result.
 * @param {Number[]|String|L.LatLng|Object} [options.center] Location where results should be biased
 * @param {Number}   [options.radius=0] The search radius in meters using the coordinates given to the **center**
 *  option as origin.
 *  If the radius is zero the results will not be constrained.
 * @param {Number}   [options.offset=0] Starting offset of the returned results within the full result set
 * @param {String}   [options.countrySet] List of country codes for limit the search request to those specific
 *  political limits
 * @param {Object|Number[]|Object[]|String} [options.boundingBox] The bounding box is an area within the search
 *  results needs to limit to. If it is omitted then the whole world will be taken into consideration.
 * @param {String}   [options.idxSet] Specify which indexes to utilize for the search
 */
/* eslint-enable */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(17), __webpack_require__(174), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (search, model, validators) {
    'use strict';

    var SearchPrototype = search.prototype.constructor;

    function LowBandwidthSearch(options) {
        SearchPrototype.call(this, options);

        this.model = model;
        this.fields.type = {
            defaultValue: this.TYPE.lowBandwidth,
            visible: false
        };

        this.fields.idxSet = {
            validator: validators.string
        };

        /**
         * @ignore
         * Only lowBandwidthSearch doesn't support extendedPostalCodesFor property
         * That's why related field must be removed
         */
        delete this.fields.extendedPostalCodesFor;
    }

    LowBandwidthSearch.prototype = new SearchPrototype();
    LowBandwidthSearch.prototype.constructor = LowBandwidthSearch;

    return function (options) {
        return new LowBandwidthSearch(options).construct();
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (selector) {
    'use strict';

    return function (json) {
        return selector(json, 'r', 'a1, tp, cc, a2, nm, ph, ps, gh, ct, cst, etp');
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Allows to make search request using the TomTom's
 * [Search API - Along Route Search](https://developer.tomtom.com/search-api/search-api-documentation-search/along-route-search).
 *
 * The Along Route Search endpoint allows you to perform a fuzzy search for
 * POIs along a specified route. This search is constrained by specifying
 * Detour Time limiting measure.
 *
 * To send the route points this service will use a POST request with the {{#crossLink "AlongRouteSearch/route:method"}}route{{/crossLink}} encoded as a JSON payload.
 * The minimum number of route points is 2.
 *
 * @example
 *```js
 * tomtom.alongRouteSearch({
 *     limit: 20,
 *     maxDetourTime: 120,
 *     query: 'gas station',
 *     route: [
 *         {
 *             "lat": 37.7524152343544,
 *             "lon":-122.43576049804686
 *         },
 *         {
 *             "lat": 37.70660472542312,
 *             "lon":-122.43301391601562
 *         },
 *         [37.712059855877314, -122.36434936523438], // Another valid format
 *         new L.LatLng(37.75350561243041, -122.37396240234374) // Leaflet's L.LatLng instances are also allowed
 *     ]
 *   })
 *   .go()
 *   .then(function(response) {
 *     console.log('SUMMARY:');
 *     console.table(response.summary);
 *     console.log('RESULTS:');
 *     console.table(response.results);
 *   });
 * ```
 *
 * For a list of all available format for routes read the documentation for the
 * {{#crossLink "AlongRouteSearch/route:method"}}{{/crossLink}} option.
 *
 * @class AlongRouteSearch
 * @module Services
 * @uses Chain
 * @uses KeyMixin
 * @uses LimitMixin
 * @uses ViewMixin
 * @uses QueryMixin
 * @constructor
 *
 * @param {Object} [options]
 * @param {String} [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>.
 * @param {Number} [options.limit=10] Maximum number of responses that should be returned. Maximum number is 20.
 * @param {String} [options.view="Unified"] Geopolitical view
 * @param {String} [options.maxDetourTime] Maximum detour time in seconds.
 *     This option is mandatory. For that reason needs to be defined during the instance
 *     construction or using the <a href="#method_maxDetourTime">maxDetourTime()</a> setter function.
 *     The maximum allowed value is 3600.
 * @param {String} options.query Text that will be searched.
 *     This option is mandatory. For that reason needs to be defined during the instance
 *     construction or using the <a href="#method_query">query()</a> setter function.
 * @param {Array} options.route The route representation.
 *     This option is mandatory. For that reason needs to be defined during the instance
 *     construction or using the <a href="#method_route">route()</a> setter function.
 *     <a href="#method_route">See more details</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 */
/* eslint-enable max-len */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(4), __webpack_require__(2), __webpack_require__(92), __webpack_require__(44), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (chain, converters, validators, restSearch, searchTypes, parameterApplications) {
    'use strict';

    var searchType = searchTypes.searchAlongRoute;
    var fields = {
        key: { validator: validators.string },
        /**
         * Sets or gets the maximum detour time in seconds.
         *
         * The maximum allowed value is 3600.
         *
         * @method maxDetourTime
         * @chainable
         * @param {Number} [value] New maximum detour time in seconds.
         * @throws {TypeError} If the given argument cannot be converted to a valid value.
         * @return {Number} The same service instance or the current option value if no argument was given.
         */
        maxDetourTime: { validator: validators.integerInInterval(0, 3600) },

        /**
         * Sets or gets the route to search along. The route **should have at least two points**.
         *
         * The following formats are supported:
         *
         * - **String[]**
         *   - `["52.3,4.8", "52.3,4.8"]`
         * - **Array[]**
         *   - `[ [52.3, 4.8], [52.3, 4.8] ]`
         * - **Object[]**
         *   - `{lat: 52.3, lon: 4.8}`
         *   - `{lat: 53.3, lng: 5.8}`
         *   - `{x: 53.3, y: 5.8}`
         *   - `{latitude: 53.3, longitude: 5.8}`
         *   - `{lat: Function, lng: Function}` The functions should return a numeric value
         *
         * @example
         *```js
         * tomtom.alongRouteSearch()
         *   .route([
         *     {
         *         lat: 37.7524152343544,
         *         lon:-122.43576049804686
         *     },
         *     {
         *         lat: 37.70660472542312,
         *         lon:-122.43301391601562
         *     }
         *   ])
         *   .go(callback);
         *```
         *
         * @method route
         * @chainable
         * @param {Array} [route] Route representation.
         * @throws {TypeError} If the given argument cannot be converted to a valid value.
         * @return {Array} The same service instance or the current option value if no argument was given.
         */
        route: {
            required: true,
            converter: converters.route,
            validator: validators.route,
            application: parameterApplications.POST
        },

        query: {
            required: true,
            validator: validators.string,
            converter: converters.queryString,
            application: parameterApplications.PATH
        },

        // A custom "limit" docblock is used because the max limit value differs from the used on the
        // other services (100).
        /**
         * Sets or gets the limit of the elements for the response.
         *
         * @method limit
         * @chainable
         * @param {Number} [limit] Maximum number of the elements in response. Maximum number is 20.
         * @throws {TypeError} If the given argument cannot be converted to a valid value.
         * @return {Number} The same service instance or the current option value if no argument was given.
         */
        limit: {
            validator: validators.integerInInterval(0, 20)
        },
        type: {
            validator: validators.string,
            defaultValue: searchType,
            application: parameterApplications.PATH
        }
    };

    var batchFields = {
        batchItems: {
            validator: validators.arrayOf(fields),
            converter: converters.arrayOf(fields)
        }
    };

    var search = restSearch();

    function handleChain(data, callback) {
        data.type = searchType;
        search.search(fields, data, function (response) {
            callback.call(this, response);
        });
    }

    function handleBatchChain(data, callback) {
        data.type = searchType;
        search.batch(fields, data, function (response) {
            callback.call(this, response);
        });
    }

    return function (options) {
        if (Array.isArray(options)) {
            return chain(batchFields, handleBatchChain, {
                batchItems: options
            });
        } else {
            return chain(fields, handleChain, options);
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * The Flow Segment Data service provides information about the speeds and travel times of the road
 * fragment closest to the given coordinates.
 *
 * @class TrafficFlowSegmentData
 * @module Services
 * @uses Chain
 * @uses KeyMixin
 * @param {Object} options Options to be passed to the flowSegmentData call.
 * @param {String} options.point Coordinates of the point close to the road segment.
 * @param {String} options.key Traffic Flow API key that can be obtained from
 *     <a href="https://developer.tomtom.com">TomTom's developer portal</a>.
 * @param {String} options.style The type of flow data to be displayed on the tile. Available options: absolute,
 *     relative, relative-delay.
 * @param {Number} options.zoom Zoom level. This will affect traffic incident coordinates to present both
 *     road sides separately.
 * @param {String} [options.unit=KMPH] Unit of speed. Available options: KMPH, MPH.
 * @param {Number} [options.thickness=10] Segment width multiplier. Accepts values in range from 0 to 20.
 * @param {Function} [options.fail] The callback function to be called on failure.
 * @param {Function} options.callback The callback function to be called on success.
 * @param {Boolean} options.openLr Specifies if response include OpenLR code.
 * @constructor
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(177), __webpack_require__(8), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (validators, restFlowSegmentData, chain, parameterApplications) {

   var fields = {
      key: { validator: validators.string },

      /**
      * @method zoom
      * @chainable
      * @param {Integer} zoom Zoom level. This will affect traffic incident coordinates to present both road
      * sides separately. Should be in range from 0 to 18.
      * @throws {TypeError} If the given argument cannot be converted into a valid value
      * @return {String} The same service instance or the current option value if no argument was given
      */
      zoom: { validator: validators.numberInInterval(0, 18), required: true,
         application: parameterApplications.PATH },

      /**
      * @method style
      * @chainable
      * @param {String} style The type of flow data to be displayed on the tile. Available options: absolute,
      * relative, relative-delay.
      * @throws {TypeError} If the given argument cannot be converted into a valid value
      * @return {String} The same service instance or the current option value if no argument was given
      */
      style: { validator: validators.oneOfValue(['absolute', 'relative', 'relative-delay'], 'traffic flow style'), required: true, application: parameterApplications.PATH },

      /**
      * @method point
      * @chainable
      * @param {String} point Coordinates of the point close to the road segment.
      * They have to be comma-separated and calculated using EPSG4326 projection.
      * @throws {TypeError} If the given argument cannot be converted into a valid value
      * @return {String} The same service instance or the current option value if no argument was given
      */
      point: { validator: validators.point, required: true },

      /**
      * @method unit
      * @chainable
      * @param {String} unit Unit of speed. Avilable values: KMPH, MPH.
      * @throws {TypeError} If the given argument cannot be converted into a valid value
      * @return {String} The same service instance or the current option value if no argument was given
      */
      unit: { validator: validators.oneOfValue(['KMPH', 'MPH']) },

      /**
      * @method thickness
      * @chainable
      * @param {Integer} thickness Segment width multiplier. Value should be in range from 1 to 20.
      * @throws {TypeError} If the given argument cannot be converted into a valid value
      * @return {String} The same service instance or the current option value if no argument was given
      */
      thickness: { validator: validators.numberInInterval(1, 20) },

      /**
      * @method openLr
      * @chainable
      * @param {Boolean} openLr Specifies if response include OpenLR code.
      * @throws {TypeError} If the given argument cannot be converted into a valid value
      * @return {String} The same service instance or the current option value if no argument was given
      */
      openLr: { validator: validators.bool }
   };

   var flowSegmentData = restFlowSegmentData();

   function handleChain(options, callback) {
      return flowSegmentData.flowSegmentData(fields, options, callback);
   }

   return function (options) {
      options = options || {};
      options.__serviceType = 'traffic';
      return chain(fields, handleChain, options);
   };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(10), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    return function () {
        return {
            flowSegmentData: requestFactory.single(endpoints.flowSegmentData, ApiKeyNames.traffic)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * It allows to retrieve polygons (in GeoJson format) representing administrative borders using ids related to
 * search results entities.
 *
 * @example
 * ```js
 * tomtom.fuzzySearch()
 *    .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("Amsterdam")
 *   .go()
 *   .then(function(response) {
 *      var geometryId = response.results[0].dataSources.geometry.id;
 *      tomtom.additionalData()
 *      .key(<Your API key>) // this is optional if you defined a global key earlier
 *      .geometries([geometryId])
 *      .go().then(function(adpResponse) {
 *          console.log(adpResponse);
 *      })
 *   });
 * ```
 *
 * @class AdditionalData
 * @module Services
 * @uses Chain
 * @uses KeyMixin
 * @uses ViewMixin
 * @uses GeometriesMixin
 * @uses GeometriesZoomMixin
 * @constructor
 *
 * @param {Object}   [options]
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {String} [options.view="Unified"] Geopolitical view
 * @param {String[]}  options.geometries Geometry ids
 * @param {Number}  [options.geometriesZoom] Geometries zoom
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(2), __webpack_require__(179)], __WEBPACK_AMD_DEFINE_RESULT__ = function (chain, validators, restAdditionalData) {
    'use strict';

    var fields = {
        key: {
            validator: validators.string
        },
        geometries: {
            validator: validators.arrayType,
            required: true
        },
        geometriesZoom: {
            validator: validators.geometriesZoom
        }
    };

    var additionalData = restAdditionalData();

    function handleChain(data, callback) {
        additionalData.additionalData(fields, data, callback);
    }

    return function (options) {
        return chain(fields, handleChain, options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(10), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    return function () {
        return {
            additionalData: requestFactory.single(endpoints.adp, ApiKeyNames.search)
        };
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/* jshint ignore:start */
/**
 * Calculate reachable range implementation using using the TomTom's Reachable Range API.
 *
 * Allows to make route request using the TomTom's
 * [Routing API - Calculate Reachable Range Documentation](https://developer.tomtom.com/routing-api/routing-api-documentation-routing/calculate-reachable-range).
 *
 * The Calculate Reachable Range service calculates a set of locations that can
 * be reached from the origin point, subject to the available fuel or energy
 * budget that is specified in the request.
 *
 * The information returned is a polygon boundary in counterclockwise orientation
 * and the precise polygon center (the result of map-matching the origin point).
 *
 * @class ReachableRange
 * @module Services
 * @uses KeyMixin
 * @uses Chain
 * @uses CommonRoutingParameters
 * @uses ProtocolMixin
 * @constructor
 *
 * @param {Object} [options] Options to be passed to the routing call,
 *     or Array of such options objects to perform batch request.
 * @param {String} [options.key=global API key] The API key to be used.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 * @param {Number} [options.accelerationEfficiency] Specifies the efficiency of converting chemical energy stored in
 * fuel to kinetic energy when the vehicle accelerates (i.e. KineticEnergyGained/ChemicalEnergyConsumed).
 * @param {String} [options.arriveAt] The date and time of arrival at the destination point.
 * @param {Number} [options.auxiliaryPowerInkW] Specifies the amount of power consumed for sustaining auxiliary systems, in kilowatts (kW).
 * @param {Number} [options.auxiliaryPowerInLitersPerHour] Specifies the amount of fuel consumed for sustaining
 * auxiliary systems of the vehicle, in liters per hour. It can be used to specify consumption due to devices
 * and systems such as AC systems, radio, heating, etc.
 * @param {Array|String} [options.avoid] Specifies something that the route calculation should try to avoid when
 * determining the route.
 * @param {Array} [options.constantSpeedConsumptionInLitersPerHundredkm] Colon-delimited list of
 * CombustionConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
 * @param {Array} [options.constantSpeedConsumptionInkWhPerHundredkm] Colon-delimited list of
 * ElectricConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
 * @param {Number} [options.currentChargeInkWh] Specifies the current electric energy supply in kilowatt hours (kWh).
 * @param {Number} [options.currentFuelInLiters] Current supply of fuel in liters.
 * @param {Number} [options.decelerationEfficiency] Specifies the efficiency of converting kinetic energy to saved
 * (not consumed) fuel when the vehicle decelerates (i.e. ChemicalEnergySaved/KineticEnergyLost).
 * @param {String} [options.departAt] The date and time of departure from the origin point
 *     response.
 * @param {Number} [options.downhillEfficiency] Specifies the efficiency of converting potential energy to
 * saved (not consumed) fuel when the vehicle loses elevation (i.e. ChemicalEnergySaved/PotentialEnergyLost).
 * @param {Number} [options.energyBudgetInkWh] Electric energy budget in kilowatt
 *     hours (kWh) that determines maximal range which can be travelled using the
 *     specified Electric Consumption Model. Required if vehicleEngineType is
 *     electric.
 * @param {Number} [options.fuelBudgetInLiters] Fuel budget in liters that determines
 *     maximal range which can be travelled using the specified Combustion
 *     Consumption Model. Required if vehicleEngineType is combustion.
 * @param {Number} [options.fuelEnergyDensityInMJoulesPerLiter] Specifies the amount of chemical energy stored
 * in one liter of fuel in megajoules (MJ). It is used in conjunction with the Efficiency parameters for
 * conversions between saved or consumed energy and fuel.
 * @param {String} [options.hilliness] Degree of hilliness for thrilling route.
 * @param {Number} [options.maxChargeInkWh] Specifies the maximum electric energy supply in kilowatt hours (kWh)
 * that may be stored in the vehicle's battery.
 * @param {Array|String} [options.origin] Point from which the range calculation should start.
 * @param {String} [options.protocol] Protocol's type, one of "http" or "https".
 * @param {String} [options.report] Specifies which data should be reported for diagnosis purposes. Possible values:
 * * effectiveSettings reports the effective parameters or data used when calling the API. In the case of defaulted
 * parameters the default will be reflected where the parameter was not specified by the caller.
 * @param {String} [options.routeType] The type of route requested.
 * @param {String} [options.traffic] consider all available traffic information during routing
 *     determining the route.
 * @param {Number} [options.timeBudgetInSec] Time budget in seconds that determines maximal
 * range which can be travelled using driving time.
 * @param {String} [options.travelMode] The mode of travel for the requested route.
 * @param {Number} [options.uphillEfficiency] Specifies the efficiency of converting chemical energy stored in
 * fuel to potential energy when the vehicle gains elevation (i.e. PotentialEnergyGained/ChemicalEnergyConsumed).
 * @param {Number} [options.vehicleAxleWeight] The vehicle axle weight in kg.
 * @param {Boolean} [options.vehicleCommercial] True if vehicle is used for commercial purposes.
 * @param {String} [options.vehicleEngineType] The vehicle engine type.
 * @param {Number} [options.vehicleHeight] The vehicle height in m.
 * @param {Number} [options.vehicleLength] The vehicle length in meters.
 * @param {Array|String} [options.vehicleLoadType] The array of truck cargo classification.
 * @param {Number} [options.vehicleMaxSpeed] The maximal allowed vehicle speed in km/h.
 * @param {Number} [options.vehicleWeight] The vehicle weight in kg.
 * @param {Number} [options.vehicleWidth] The vehicle width in m.
 * @param {String} [options.windingness] Level of turns for thrilling route.
 *
 * @example
 * ```javascript
 *     tomtom.reachableRange({
 *         origin: '51.776667,19.454722',
 *         fuelBudgetInLiters: 5,
 *         constantSpeedConsumptionInLitersPerHundredkm: ["10,20", "15,30"],
 *     })
 *         .go()
 *         .then(function(rangeData) {
 *             console.log(L.geoJson(rangeData));
 *         })
 *         .catch(function(error) {
 *             console.error(error);
 *         });
 * ```
 */
/* eslint-enable max-len */
/* jshint ignore:end */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41), __webpack_require__(96), __webpack_require__(181), __webpack_require__(8), __webpack_require__(2), __webpack_require__(4), __webpack_require__(182)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restRouting, reachableRange, batchReachableRangeModel, chain, validators, converters, reachableRangeParameters) {
    var batchFields;

    var routing = restRouting();
    var fields = reachableRangeParameters();

    batchFields = {
        batchItems: {
            validator: validators.arrayOf(fields),
            converter: converters.arrayOf(fields)
        }
    };

    function handleChain(data, callback) {
        routing.calculateReachableRange(fields, data, function (response) {
            callback.call(this, reachableRange(response, data));
        });
    }

    function handleBatchChain(data, callback) {
        routing.batchReachableRange(fields, data, function (response) {
            callback.call(this, batchReachableRangeModel(response));
        });
    }

    return function (options) {
        if (Array.isArray(options)) {
            return chain(batchFields, handleBatchChain, {
                batchItems: options
            });
        }
        return chain(fields, handleChain, options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(96)], __WEBPACK_AMD_DEFINE_RESULT__ = function (reachableRangeModel) {
    'use strict';

    return function (data) {
        if (!Array.isArray(data.batchItems)) {
            return null;
        }
        return data.batchItems.map(function (batchItem) {
            if (batchItem.response.error) {
                return { error: batchItem.response.error };
            } else {
                return reachableRangeModel(batchItem.response);
            }
        });
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(74), __webpack_require__(0), __webpack_require__(42), __webpack_require__(2), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (commonRoutingParameters, utils, postValidators, validators, parameterApplications) {
    var fields = {

        /**
         * Point from which the range calculation should start.
         *
         * @method origin
         * @chainable
         * @param {String} origin Point from which the range calculation should start.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {reachableRange|String} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
        origin: {
            validator: validators.routingLocation,
            application: parameterApplications.PATH
        },

        /**
        * Getter and setter for fuelBudgetInLiters.
        *
        * @method fuelBudgetInLiters
        * @chainable
        * @param {Number} fuelBudgetInLiters Fuel budget in liters that
        *     determines maximal range which can be travelled using the specified
        *     Combustion Consumption Model. Required if _vehicleEngineType_ is
        *     _combustion_.
        * @throws {TypeError} if the given argument cannot be converted to a
        *     valid value
        * @return {String} Method returns the service instance allowing chaining or current value if
        *     argument is omitted.
        */
        fuelBudgetInLiters: {
            postValidator: [postValidators.requiredBudget, postValidators.requiredWithSpecificEngineType, postValidators.notCommon]
        },

        /**
        * Getter and setter for energyBudgetInkWh.
        *
        * @method energyBudgetInkWh
        * @chainable
        * @param {Number} energyBudgetInkWh  Electric energy budget in
        * kilowatt hours (kWh) that determines maximal range which can be
        * travelled using the specified Electric Consumption Model.
        * @throws {TypeError} if the given argument cannot be converted to a
        *     valid value
        * @return {String} Method returns the service instance allowing chaining or current value if
        *     argument is omitted.
        */
        energyBudgetInkWh: {
            postValidator: [postValidators.requiredBudget, postValidators.requiredWithSpecificEngineType, postValidators.notCommon]
        },

        /**
        * Getter and setter for timeBudgetInSec.
        *
        * @method timeBudgetInSec
        * @chainable
        * @param {Number} timeBudgetInSec  Time budget in seconds that determines maximal
        * range which can be travelled using driving time.
        * The consumption parameters will only affect eco-routes and thereby indirectly the driving time.
        * @throws {TypeError} if the given argument cannot be converted to a
        *     valid value
        * @return {String} Method returns the service instance allowing chaining or current value if
        *     argument is omitted.
        */
        timeBudgetInSec: {
            postValidator: [postValidators.requiredBudget, postValidators.notCommon]
        }

    };

    fields = utils.extend(fields, commonRoutingParameters);

    return function (fieldsToSkip) {
        var result = utils.clone(fields);
        if (fieldsToSkip instanceof Array) {
            fieldsToSkip.forEach(function (field) {
                delete result[field];
            });
        }

        return result;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Matrix routing service implementation using using the TomTom's
 * [Routing API - Matrix Routing](https://developer.tomtom.com/routing-api/routing-api-documentation/matrix-routing).
 *
 * The Routing API - Matrix Routing service allows calculation of a matrix of route summaries for a set of routes
 * which are defined with origin and destination locations.
 *
 * For every given origin this service calculates
 * the cost of routing from that origin to every given destination. The set of origins and the set of destinations
 * can be thought of as the column and row headers of a table and each cell in the table contains the costs of routing
 * from the origin to the destination for that cell.
 *
 * The following costs are computed for each route:
 * - Travel times
 * - Distances
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "MatrixRouting/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "MatrixRouting/go:method"}}{{/crossLink}} method to handle the response.
 *
 * @class MatrixRouting
 * @module Services
 * @uses Chain
 * @uses KeyMixin
 *
 * @constructor
 * @param {Object} [options] Options to be passed to the routing call,
 *     or Array of such options objects to perform batch request.
 * @param {String} [options.key=global API key] An API Key issued
 *     from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {Array} [options.origins] A set of origin locations represented by coordinates (lat, lon).
 *     At least one origin is required.
 * @param {Array} options.destinations A set of destination locations represented by coordinates (lat, lon).
 *     At least one destination is required.
 * @param {String} [options.routeType] The type of route requested.
 * @param {Boolean} [options.traffic] Determines if traffic data should be used to calculate the route
 * @param {String} [options.travelMode] The travel mode for the requested route. The possible values are documented
 *     {{#crossLink "MatrixRouting/travelMode:method"}}here{{/crossLink}}.
 * @param {String} [options.avoid] Specifies something that the route calculation should try to avoid when
 *     determining the route. The possible values are documented
 *     {{#crossLink "MatrixRouting/avoid:method"}}here{{/crossLink}}.
 * @param {String} [options.departAt] The date and time of departure from the origin point
 * @param {String} [options.arriveAt] The date and time of arrival at the destination point
 *     response
 * @param {String} [options.hilliness] Degree of hilliness for thrilling route. The possible values are documented
 *     {{#crossLink "MatrixRouting/hilliness:method"}}here{{/crossLink}}.
 * @param {Number} [options.vehicleAxleWeight] The vehicle axle weight in kg.
 * @param {Boolean} [options.vehicleCommercial] True if vehicle is used for commercial purposes.
 * @param {String} [computeTravelTimeFor] Setting to _all_ provides additional information regards travel times.
 * @param {String} [options.vehicleEngineType] The vehicle engine type. One of "combustion" or "electric"
 * @param {Number} [options.vehicleHeight] The vehicle height in m.
 * @param {Number} [options.vehicleLength] The vehicle length in meters.
 * @param {Array|String} [options.vehicleLoadType] The array of truck cargo classification.
 *     The possible values are documented {{#crossLink "MatrixRouting/vehicleLoadType:method"}}here{{/crossLink}}.
 * @param {Number} [options.vehicleMaxSpeed] The maximal allowed vehicle speed in km/h.
 * @param {Number} [options.vehicleWeight] The vehicle weight in kg.
 * @param {Number} [options.vehicleWidth] The vehicle width in m.
 * @param {String} [options.windingness] Level of turns for thrilling route.
 *     The possible values are documented {{#crossLink "MatrixRouting/windingness:method"}}here{{/crossLink}}.
 * @param {String} [options.protocol] Protocol's type, one of "http" or "https".
 *
 * @example
 * ```js
 * var origins = [
 *   { point: { latitude: 51.63685, longitude: 19.4171 } },
 *   { point: { latitude: 51.63685, longitude: 19 } }
 * ];
 * var destinations = [
 *   { point: { latitude: 52.23498, longitude: 21.00849 } },
 *   { point: { latitude: 52.63685, longitude: 18 } }
 * ];
 * function callbackFn(routeGeoJson) {
 *   console.log(routeGeoJson);
 * }
 * var request = tomtom.matrixRouting({
 *   origins: origins,
 *   destinations: destinations,
 *   traffic: true
 * });
 * request.go()
 *   .then(callbackFn);
 * ```
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41), __webpack_require__(184), __webpack_require__(8), __webpack_require__(72)], __WEBPACK_AMD_DEFINE_RESULT__ = function (restRouting, matrixRoutingModel, chain, matrixParameters) {
    'use strict';

    var fields = matrixParameters();
    var routing = restRouting();

    function handleChain(data, callback) {
        routing.matrix(data, function (response) {
            callback.call(this, matrixRoutingModel(response));
        });
    }

    return function (options) {
        var opt = options || {};
        opt.__serviceType = 'routing';

        return chain(fields, handleChain, opt);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils) {
    'use strict';

    return function (data) {
        if (Utils.isString(data)) {
            try {
                data = JSON.parse(data); // aja js has problems and response is not always parsed as it should
            } catch (e) {
                return null;
            }
        }
        if (data.error) {
            return { error: data.error };
        } else if (data.matrix) {
            return data.matrix.map(function (row) {
                return row.map(function (cell) {
                    return cell.response;
                });
            });
        }
        return null;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * It creates a foldable settings control panel over the map.
 *
 * @class ControlPanel
 * @namespace L
 * @extends L.Foldable
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.className="tomtom-control-panel"]
 * @param {String} [options.title=null] Title of the container. If it's null the title will be hidden.
 * @param {Object} [options.close]
 * @param {String} [options.close.text] Text displayed in the Close button
 * @param {String} [options.close.image="sdk/images/icon-cog.svg"] Image of the Close button
 * @param {Object} [options.show]
 * @param {String} [options.show.text] Text displayed in the Show button
 * @param {String} [options.show.image="sdk/images/icon-cog.svg"] Image of the Show button
 * @param {Boolean} [options.collapsed=true] Initial state of the foldable widget
 * 
 * @example
* ```javascript
* var results = [1, 2, 3];
* var widget = new L.ControlPanel();
* widget.addTo(map);
* widget.setContent('Length: ');
* widget.addContent(results.length);
* ```
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(46)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {
    'use strict';

    var icons = {
        cog: L.Icon.Default.imagePath + '/icon-cog.svg'
    };

    L.ControlPanel = L.Foldable.extend({
        options: {
            className: 'tomtom-control-panel',
            title: null,
            close: { image: icons.cog },
            show: { image: icons.cog },
            collapsed: true
        }
    });

    return function (options) {
        return new L.ControlPanel(options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This module helps you to create a language selector.
 *
 * @class LanguageSelector
 * @static
 * @extends Object
 * @namespace L
 * @module Widgets
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {
    'use strict';

    function onPropertyChange(e) {
        var value = e.target.options[e.target.selectedIndex].value;
        e.target.localeService.setCurrentLocale(value);
    }

    function addOptions(select, values) {
        var option;
        values.forEach(function (value) {
            option = document.createElement('option');
            option.text = value.getLabel();
            option.value = value.getLanguageCode();
            select.add(option);
        });
    }

    function setCurrentLocale(select) {
        var i;
        var locale = select.localeService.getCurrentLocale();
        var langCode = locale.getLanguageCode();
        //sets selected index to correct value
        for (i = 0; i < select.options.length; ++i) {
            if (select.options[i].value === langCode) {
                select.selectedIndex = i;
                select.options[i].selected = 'selected';
            }
        }
    }

    return {
        /**
         * Returns a {{#crossLink "HTMLSelectElement"}}{{/crossLink}} filled with the supported locales.
         *
         * The element has a function bound to its <i>onchange</i> event, which updates the locale configuration
         * of the {{#crossLink "LocaleService"}}{{/crossLink}} instance given as the first argument.
         *
         * @method getHtmlElement
         * @param {LocaleService} localeService Locale service which will be bound to the generated dropdown.
         * @param {"routing"|"search"|"traffic"|"maps"} [serviceType] Determines the list of languages.
         *  - If you do not provide this parameter or you  provide an invalid one, all languages will be included.
         *  - If you pass a value, only languages specific for the given service's type will be added.
         * @return {HTMLSelectElement}
         */
        getHtmlElement: function getHtmlElement(localeService, serviceType) {
            var select;
            if (!localeService) {
                console.error('Locale service not passed to languageSelector!');
                return undefined;
            }
            select = document.createElement('select');
            select.localeService = localeService;
            select.className = 'tomtom-language-selector';
            addOptions(select, L.LocaleService.getLocalesFor(serviceType));
            setCurrentLocale(select);
            select.onchange = onPropertyChange;
            return select;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * The ResultsLit view allows to create foldable results widget on a map.
 *
 * @class ResultsList
 * @namespace L
 * @extends L.Foldable
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.className="tomtom-results-list"]
 * @param {String} [options.title="Results"]
 * @param {String} [options.close={text: "×"}]
 * @param {Boolean} [options.closeOnClick=true]
 * @param {Object} [options.show={text: "show"}]
 * @param {String} [options.content="Fill in the form on the left and press enter to run search."]
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(46)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {
    'use strict';

    L.ResultsList = L.Foldable.extend({
        options: {
            className: 'tomtom-results-list',
            title: 'Results',
            close: { text: '×' },
            closeOnClick: true,
            show: { text: 'show' },
            content: 'Fill in the form on the left and press enter to run search.'
        }
    });

    return function (options) {
        return new L.ResultsList(options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This widget allows the user to do distance measurements on the map.
 *
 * @example
 * ###### Basic example
 *
 * ```javascript
 * var map = new L.Map('map', {
 *   key: "your-key",
 *   center: [52.373154, 4.890659],
 *   zoom: 13
 * });
 * var widget = new L.DistanceMeasurement();
 * widget.addTo(map);
 * ```
 *
 * ###### Using options
 *
 * ```javascript
 * var map = new L.Map('map', {
 *   key: "your-api-key",
 *   center: [52.373154, 4.890659],
 *   zoom: 13
 * });
 * var widget = new L.DistanceMeasurement({
 *   unitScheme: 'imperial',
 *   markerColor: '#99ff99'
 * });
 * map.addControl(widget);
 * ```
 *
 * @class DistanceMeasurement
 * @namespace L
 * @extends L.Control
 * @uses L.Evented
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {"topleft"|"topright"|"bottomleft"|"bottomright"} [options.position="topright"] Decides the location
 *     of the widget
 * @param {String} [options.markerColor="#000"] Color of the markers used for each step of the ruler
 * @param {String} [options.lineColor="#000"] Color or the ruler's line
 * @param {"metric"|"imperial"|null} [options.unitScheme=null] Indicate if the imperial measurement unit should
 *     be used for calculate the distances.
 *     If the value is null the widget will use the global unit measurement configuration.
 * @param {Boolean} [options.useArc=false] Display great circle arcs instead of rect lines
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(99), __webpack_require__(189), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, MeasurementRuler, MultiMeasurementRuler, Utils) {
    'use strict';

    L.DistanceMeasurement = L.Control.extend({
        includes: L.Evented.prototype,

        options: {
            position: 'topright',
            markerColor: '#000',
            lineColor: '#000',
            unitScheme: null,
            useArc: false
        },

        statics: {
            Events: {
                /**
                 * Fired when the user press over the button to activate the widget.
                 * After the first click over the map the measurement rule and the distance counter will appear.
                 * @event Activated
                 * @type String
                 *
                 * @example
                 * ```javascript
                 *
                 * var widget = (new L.DistanceMeasurement()).addTo(map);
                 * widget.on(L.DistanceMeasurement.Events.Activated, function (eventObject) {
                 *      console.log(eventObject);
                 * });
                 * ```
                 */
                Activated: 'active',
                /**
                 * Fired when the user press over the widget's button when is already activated disabling the
                 * widget and hiding the measurement controls.
                 * @event Deactivated
                 * @type String
                 */
                Deactivated: 'inactive',
                /**
                 * Fired when a new measurement starts.
                 * The measurement starts when the user make the first click on the map.
                 * @event Started
                 * @type String
                 */
                Started: 'start',
                /**
                 * Fired when the ruler path changes (by adding more segments).
                 * @event L.DistanceMeasurement.Events.Changed
                 * @param {L.MeasurementRuler} ruler Reference to the ruler instance
                 * @param {L.LatLng} newSegment The coordinates of the last new segment added
                 * @param {Number} distance Total ruler distance in meters after adding the new segment
                 */
                Changed: 'change',
                /**
                 * Fired when the user finish an active measurement.
                 * @event L.DistanceMeasurement.Events.Finished
                 * @param {L.MeasurementRuler} ruler Reference to the ruler instance
                 * @param {Number} distance Total ruler distance in meters
                 */
                Finished: 'finish',
                /**
                 * Fired when the user decide to cancel an active measurement.
                 * @event Cancelled
                 * @type String
                 */
                Cancelled: 'cancel',
                /**
                 * Fired when all the measurements are cleared from the screen.
                 * @event Reset
                 * @type String
                 */
                Reset: 'reset',
                /**
                 * Fired when the widget is disabled using the
                 * {{#crossLink "L.DistanceMeasurement/disable:method"}}{{/crossLink}} method.
                 * @event Disabled
                 * @type String
                 */
                Disabled: 'disable',
                /**
                 * Fired when the widget is enabled (after had been disabled) using the
                 * {{#crossLink "L.DistanceMeasurement/enable:method"}}{{/crossLink}} method.
                 * @event Enabled
                 * @type String
                 */
                Enabled: 'enable'
            }
        },

        /**
         * @ignore
         * CSS class names used by the elements of this widget.
         * @type {Object}
         */
        _classnames: {
            // Class added to the map container when the widget is activated
            mapContainer: 'leaflet-with-distance-measurement',

            // Container of the widget
            container: 'leaflet-bar leaflet-distance-measurement',
            // CSS classes added to the widget container during its lifecycle
            containerActive: 'leaflet-distance-measurement--active',
            containerInProgress: 'leaflet-distance-measurement--in-progress',

            // Widget's main button
            onoffButton: 'leaflet-distance-measurement__onoff-button icon-ruler',
            onoffButtonEnabled: 'leaflet-distance-measurement__onoff-button--enabled',
            onoffButtonDisabled: 'leaflet-disabled',

            // Container of the widget actions buttons
            actionsButtons: 'leaflet-distance-measurement__actions',
            actionsButtonsVisible: 'leaflet-distance-measurement__actions--visible',

            // Action buttons
            finishButton: 'leaflet-distance-measurement__actions__finish',
            cancelButton: 'leaflet-distance-measurement__actions__cancel',

            // Class names used for the rulers and ruler labels
            markerLabel: 'leaflet-distance-measurement__ruler__label',
            previewMarkerLabel: 'leaflet-distance-measurement__ruler__label-preview',
            ruler: 'leaflet-distance-measurement__ruler',
            previewRuler: 'leaflet-distance-measurement__ruler-preview'
        },

        /**
         * @ignore
         * Leaflet layer where all the magic happen.
         * @type {L.FeatureGroup}
         */
        _layer: null,

        /**
         * @ignore
         * Object with references to the DOM elements of the widget.
         * @type {Object}
         */
        _controls: null,

        /**
         * @ignore
         * Reference to the leaflet map instance.
         * @type {L.Map}
         */
        _map: null,

        /**
         * @ignore
         * This value is TRUE if the widget has been disabled using the disable() method.
         * @type {Boolean}
         */
        _disabled: false,

        /**
         * @ignore
         * This value is TRUE if the measurement controls are visible.
         * @type {Boolean}
         */
        _isActivated: false,

        /**
         * @ignore
         * This value is TRUE if a measurement is in progress.
         * @type {Boolean}
         */
        _isMeasurementInProgress: false,

        /**
         * @ignore
         * Store the status of conflictive map features to be reactivated when this widget is deactivated.
         * @type {Object}
         */
        _previousStatusOfConflictiveFeatures: null,

        /**
         * @ignore
         * Current measurement instance.
         * @type {L.MultiMeasurementRuler}
         */
        _activeRulerLayer: null,

        /**
         * @ignore
         * Ruler used during a measurement in progress to display a preview segment when the cursor
         * moves over the map.
         * @type {L.MeasurementRuler}
         */
        _previewRulerSegment: null,

        /**
         * @ignore
         * Stack of previous measurements.
         * Each time a measurement is finished, the finished ruler is added to this array.
         * @type {L.MultiMeasurementRuler[]}
         */
        _rulerLayerStack: [],

        /**
         * @ignore
         * @type String[]
         */
        _supportedUnits: [],

        /**
         * The unit service used by the widget to display the distances.
         * @ignore
         * @type UnitService
         */
        _unitService: null,

        /**
         * Curated snapshot of the widget's options created at the beginning of each measurement and using it during
         * its lifecycle.
         * This options are used for the active and preview rulers until the measurement finish.
         * That increases stability if the widget's options changes during a measurement.
         * @ignore
         * @type Object
         */
        _activeOptions: null,

        initialize: function initialize(options) {
            L.Util.setOptions(this, options);
            this._rulerLayerStack = [];
            this._activeRulerLayer = null;
            this._previewRulerSegment = null;
            this._isMeasurementInProgress = false;
            this._isActivated = false;
            this._disabled = false;
            this._supportedUnits = L.UnitService.getSupportedUnits().map(function (unit) {
                return unit.getLabel();
            });
            // Copying static Events property to instance Events property for compatibility
            this.Events = L.DistanceMeasurement.Events;
        },

        /**
         * @ignore
         * Create the DOM elements needed and returns an object with them.
         * @return {Object}
         */
        _createControls: function _createControls() {
            var container = L.DomUtil.create('div', this._classnames.container),
                onoffButton = L.DomUtil.create('a', this._classnames.onoffButton, container),
                actionsButtons = L.DomUtil.create('ul', this._classnames.actionsButtons, container),
                finishButton = L.DomUtil.create('li', this._classnames.finishButton, actionsButtons),
                cancelButton = L.DomUtil.create('li', this._classnames.cancelButton, actionsButtons);

            // Icons
            finishButton.innerHTML = '&#10003;';
            cancelButton.innerHTML = '&times;';

            onoffButton.href = '#';

            // Labels
            onoffButton.title = 'Toggle measurement tool';
            finishButton.title = 'Finish measurement';
            cancelButton.title = 'Cancel measurement';

            // For screen readers
            onoffButton.setAttribute('role', 'button');
            onoffButton.setAttribute('aria-label', onoffButton.title);
            finishButton.setAttribute('role', 'button');
            finishButton.setAttribute('aria-label', finishButton.title);
            cancelButton.setAttribute('role', 'button');
            cancelButton.setAttribute('aria-label', cancelButton.title);

            return {
                container: container,
                actionsButtons: actionsButtons,
                finishButton: finishButton,
                cancelButton: cancelButton,
                onoffButton: onoffButton
            };
        },

        _attachDomEventHandlersToControls: function _attachDomEventHandlersToControls() {
            L.DomEvent.disableClickPropagation(this._controls.container);
            L.DomEvent.disableScrollPropagation(this._controls.container);

            L.DomEvent.on(this._controls.onoffButton, 'click', L.DomEvent.stop).on(this._controls.onoffButton, 'click', this.toggleActivation, this);
            L.DomEvent.on(this._controls.finishButton, 'click', L.DomEvent.stop).on(this._controls.finishButton, 'click', this._finishMeasurement, this);
            L.DomEvent.on(this._controls.cancelButton, 'click', L.DomEvent.stop).on(this._controls.cancelButton, 'click', this._cancelOrResetMeasurement, this);
        },

        /**
         * @ignore
         * Attach a click event listener to the given layer.
         * @param {L.Layer|Event} layerOrEvent
         */
        _layerClickListenerOn: function _layerClickListenerOn(layerOrEvent) {
            var layer = layerOrEvent.hasOwnProperty('layer') ? layerOrEvent.layer : layerOrEvent;
            layer.on('click', this._mouseClickHandler, this);
        },

        /**
         * @ignore
         * Detach the click event listener from the given layer.
         * @param {L.Layer} layer
         */
        _layerClickListenerOff: function _layerClickListenerOff(layer) {
            layer.off('click', this._mouseClickHandler, this);
        },

        /**
         * @ignore
         * Install click listeners on map and all its existing layers.
         */
        _startListenClicks: function _startListenClicks() {
            this._map.eachLayer(this._layerClickListenerOn, this);
            this._map.on('click', this._mouseClickHandler, this);
            this._map.on('layeradd', this._layerClickListenerOn, this);
        },

        /**
         * @ignore
         * Remove all the click listeners from map and its existing layers.
         */
        _stopListenClicks: function _stopListenClicks() {
            this._map.eachLayer(this._layerClickListenerOff, this);
            this._map.off('click', this._mouseClickHandler, this);
            this._map.off('layeradd', this._layerClickListenerOn, this);
        },

        /**
         * @ignore
         * Reference: https://leafletjs.com/reference-1.0.3.html#control-onadd
         * @param {L.Map} map
         * @return {HTMLElement} The control's container
         */
        onAdd: function onAdd(map) {
            this._unitService = map.getUnitService();
            this._unitService.on(L.UnitService.Events.UNIT_CHANGED, this._onMapMeasurementUnitChanged, this);
            this._controls = this._createControls();
            this._attachDomEventHandlersToControls();
            return this._controls.container;
        },

        /**
         * @ignore
         * Reference: https://leafletjs.com/reference-1.0.3.html#layer-onremove
         */
        onRemove: function onRemove() {
            this._unitService.off(L.UnitService.Events.UNIT_CHANGED, this._onMapMeasurementUnitChanged, this);
            this.deactivate();
        },

        /**
         * @ignore
         * This method is here to redraw the rulers only if the widget doesn't have a valid string in the
         * `unitScheme` option.
         */
        _onMapMeasurementUnitChanged: function _onMapMeasurementUnitChanged() {
            if (this._activeOptions && this._activeOptions.unitScheme === null) {
                this.redrawRulers();
            }
        },

        /**
         * Destroy and create again all the visible rulers with the current widget options.
         *
         * Useful when the options are changed and you need to apply them to all the previous measurements.
         *
         * @method redrawRulers
         */
        redrawRulers: function redrawRulers() {
            var that = this,
                activeLatLngs,
                lastPreviewLatLng;
            // Recreating active ruler
            if (this._activeRulerLayer) {
                activeLatLngs = this._activeRulerLayer.latLngs.slice(0);
                this._activeRulerLayer.remove();
                this._activeRulerLayer = null;
                this._startActiveRuler();
                this._activeRulerLayer.setLatLngs(activeLatLngs);
            }
            // Recreating preview ruler
            if (this._previewRulerSegment) {
                lastPreviewLatLng = this._previewRulerSegment.getLast();
                this._previewRulerSegment.remove();
                this._previewRulerSegment = null;
                this._redrawRulerPreviewSegment(lastPreviewLatLng);
            }
            // Recreating stacked rulers
            this._rulerLayerStack = this._rulerLayerStack.map(function (ruler) {
                var latLngs = ruler.latLngs.slice(0);
                var newRuler = that._createRuler();
                ruler.remove();
                newRuler.setLatLngs(latLngs);
                return newRuler.addTo(that._map);
            });
        },
        /**
         * @ignore
         * Creates a curated copy of the widget's options.
         * This copy is used across the measurement lifecycle.
         */
        _rebuildCuratedOptionsSnapshot: function _rebuildCuratedOptionsSnapshot() {
            this._activeOptions = L.Util.extend({}, this.options);

            if (Utils.isValidValue(this._activeOptions.unitScheme)) {
                if (this._supportedUnits.indexOf(this._activeOptions.unitScheme) === -1) {
                    this._activeOptions.unitScheme = null;
                    console.warn('The unit scheme given to distanceMeasurement widget is not valid');
                }
            }
        },
        /**
         * Returns the measurement unit that should be used priorizing the configuration given to this widget.
         *
         * This method doesn't validate the value of the option `unitScheme`.
         * @ignore
         * @return {String}
         */
        _getUnitScheme: function _getUnitScheme() {
            return this._activeOptions.unitScheme || this._unitService.getCurrentUnit().getLabel();
        },

        /**
         * Creates the leaflet layer where the ruler, markers and distance labels will use.
         * @ignore
         */
        _addDrawingLayer: function _addDrawingLayer() {
            this._removeDrawingLayer();
            this._layer = L.featureGroup().addTo(this._map);
        },

        _removeDrawingLayer: function _removeDrawingLayer() {
            if (this._layer) {
                this._layer.removeFrom(this._map);
                this._layer = null;
            }
        },

        /**
         * Activate the widget displaying the measurement controls and wait for the user to click over
         * the map to start the first measurement.
         *
         * This method is called automatically when the user press over the widget's main button.
         *
         * @method activate
         */
        activate: function activate() {
            var mapContainer = this._map.getContainer();

            if (this._disabled || this._isActivated) {
                return;
            }

            this._isActivated = true;

            L.DomUtil.addClass(mapContainer, this._classnames.mapContainer);
            L.DomUtil.addClass(this._controls.actionsButtons, this._classnames.actionsButtonsVisible);

            L.DomUtil.addClass(this._controls.container, this._classnames.containerActive);

            L.DomUtil.addClass(this._controls.onoffButton, this._classnames.onoffButtonEnabled);

            this._addDrawingLayer();

            this._disableConflictiveMapFeatures();

            this._startListenClicks();

            this.fire(L.DistanceMeasurement.Events.Activated);
        },

        /**
         * Deactivate the widget cleaning all the rulers over the map and hiding the measurement controls.
         *
         * If a measurement was in progress, it will be cancel first.
         *
         * @method deactivate
         */
        deactivate: function deactivate() {
            var mapContainer = this._map.getContainer();

            if (!this._isActivated) {
                return;
            }

            if (this._isMeasurementInProgress) {
                this._cancelMeasurement();
            }

            this._resetMeasurement();

            this._isActivated = false;

            L.DomUtil.removeClass(mapContainer, this._classnames.mapContainer);
            L.DomUtil.removeClass(this._controls.actionsButtons, this._classnames.actionsButtonsVisible);

            L.DomUtil.removeClass(this._controls.container, this._classnames.containerActive);

            L.DomUtil.removeClass(this._controls.onoffButton, this._classnames.onoffButtonEnabled);

            this._stopListenClicks();

            this._removeDrawingLayer();

            this._restoreConflictiveMapFeatures();

            this.fire(L.DistanceMeasurement.Events.Deactivated);

            // Re-focusing the map to restore keyboard navigation
            this._map.getContainer().focus();
        },

        /**
         * Activate or deactivate the widget depending of its current state.
         * @method toggleActivation
         * @chainable
         * @return {L.DistanceMeasurement}
         */
        toggleActivation: function toggleActivation() {
            if (this._isActivated) {
                this.deactivate();
            } else {
                this.activate();
            }
            return this;
        },

        /**
         * @ignore
         * Store the current active conflict map features status internally to be reactivate later when the widget
         * is deactivated.
         */
        _storeCurrentStatusOfConflictiveMapFeatures: function _storeCurrentStatusOfConflictiveMapFeatures() {
            this._previousStatusOfConflictiveFeatures = {
                doubleClickZoom: this._map.doubleClickZoom.enabled(),
                boxZoom: this._map.boxZoom.enabled(),
                keyboard: this._map.keyboard.enabled()
            };
        },

        /**
         * @ignore
         * Some map features are disabled during the measurement to avoid conflicts with this widget.
         * Those features should be reactivated when the widget is deactivated.
         */
        _disableConflictiveMapFeatures: function _disableConflictiveMapFeatures() {
            this._storeCurrentStatusOfConflictiveMapFeatures();
            this._map.doubleClickZoom.disable();
            this._map.boxZoom.disable();
            this._map.keyboard.disable();
        },

        /**
        * @ignore
        * Restore the map conflict features disabled by _disableConflictiveMapFeatures().
        * Only the features enabled before the activation of this widget will be reactivated.
        */
        _restoreConflictiveMapFeatures: function _restoreConflictiveMapFeatures() {
            if (this._previousStatusOfConflictiveFeatures !== null) {
                if (this._previousStatusOfConflictiveFeatures.doubleClickZoom) {
                    this._map.doubleClickZoom.enable();
                }

                if (this._previousStatusOfConflictiveFeatures.boxZoom) {
                    this._map.boxZoom.enable();
                }

                if (this._previousStatusOfConflictiveFeatures.keyboard) {
                    this._map.keyboard.enable();
                }
                this._previousStatusOfConflictiveFeatures = null;
            }
        },

        /**
         * @ignore
         * Checks if two coordinates points to the same location.
         * @param {L.LatLng} firstLatLon
         * @param {L.LatLng} secondLatLon
         * @return {Boolean}
         */
        _equalLatLng: function _equalLatLng(firstLatLon, secondLatLon) {
            if (firstLatLon === secondLatLon) {
                return true;
            }
            if (firstLatLon && secondLatLon) {
                return firstLatLon.equals(secondLatLon);
            }
            return false;
        },

        /**
         * @ignore
         * Function called when the user does a click over the map while the widget is active.
         * @param {MouseEvent} event
         */
        _mouseClickHandler: function _mouseClickHandler(event) {
            var latLng = event.latlng;

            if (latLng === undefined) {
                return;
            }

            if (!this._isMeasurementInProgress) {
                this._startMeasurement(latLng);
                this._activeRulerLayer.addLatLng(latLng);
            } else {
                if (this._equalLatLng(this._activeRulerLayer.getLast(), latLng)) {
                    return;
                }

                latLng = this._translateLatLngToAchieveClosestPath(latLng);

                this._redrawRulerPreviewSegment();
                this._activeRulerLayer.addLatLng(latLng);
                this._onChangeMeasurement(latLng);
            }
        },

        /**
         * Translate the coordinates horizontally if necessary to put them closer to the end of the current active
         * ruler.
         *
         * The active Ruler is an instance of MultiMeasurementRule which drawn several identical polylines at 360
         * longitude degrees of separation to show the same Ruler multiple times when one coordinate appears more
         * than once on the screen.
         *
         * Leaflet is not limited to 360 longitude degrees and it keeps increasing or decreasing the degrees until
         * is able to reutilize a "world copy" (the property "worldCopyJump" is set to true by default in this SDK
         * to accomplish that).
         * This means that, in the same map, the coordinates <0,10>, <-0,-350> and <0,370> all represent the exact
         * same place in the world but drawing a line between <0,10> and <0,11> will be very different to the line
         * between <0,10> and <0,371>.
         *
         * To avoid having very long polylines crossing the world, this method adds or subtracts 360 longitude
         * degrees to the given coordinates to put it closer (in pixels) to the last point of one of the active
         * ruler's polylines.
         *
         * @ignore
         * @param {L.LatLng} latLng
         * @return {L.LatLng}
         */
        _translateLatLngToAchieveClosestPath: function _translateLatLngToAchieveClosestPath(latLng) {
            var lastLatLng = this._activeRulerLayer.getLast(),
                closestLastLatLng = this._activeRulerLayer.getClosestLast(latLng),
                transOffsetDegrees = 360,
                times;

            if (Math.round(closestLastLatLng.lng) < Math.round(lastLatLng.lng)) {
                times = Math.ceil((lastLatLng.lng - closestLastLatLng.lng) / transOffsetDegrees);
                return L.latLng(latLng.lat, latLng.lng + transOffsetDegrees * times);
            } else if (Math.round(closestLastLatLng.lng) > Math.round(lastLatLng.lng)) {
                times = Math.ceil((closestLastLatLng.lng - lastLatLng.lng) / transOffsetDegrees);
                return L.latLng(latLng.lat, latLng.lng - transOffsetDegrees * times);
            }

            return latLng;
        },

        /**
         * @ignore
         * Update the temporal ruler segment line over the map.
         *
         * Calls to this function will be ignored if:
         *  - There's no active ruler on the screen (distance zero).
         *  - The coordinates given are undefined.
         *  - The coordinates given are the same as the last coordinates of the ruler.
         *
         * @param {L.LatLng} [previewLatLng=undefined] End coordinates of the possible new segment. The start
         * coordinates will be taken from the active ruler coordinates.
         */
        _redrawRulerPreviewSegment: function _redrawRulerPreviewSegment(previewLatLng) {
            var lastLatLng,
                rulerOptions = {
                rulerClassname: [this._classnames.ruler, this._classnames.previewRuler].join(' '),
                labelClassname: [this._classnames.markerLabel, this._classnames.previewMarkerLabel].join(' '),
                markerColor: this._activeOptions.markerColor,
                lineColor: this._activeOptions.lineColor,
                distanceOffset: this._activeRulerLayer.distance,
                unitScheme: this._getUnitScheme(),
                useArc: this._activeOptions.useArc
            };

            if (previewLatLng) {
                lastLatLng = this._activeRulerLayer.getClosestLast(previewLatLng);
            }

            if (lastLatLng && previewLatLng && !this._equalLatLng(lastLatLng, previewLatLng)) {
                if (!this._previewRulerSegment) {
                    this._previewRulerSegment = new MeasurementRuler(rulerOptions).addTo(this._layer);
                }
                this._previewRulerSegment.setLatLngs([lastLatLng, previewLatLng]);
            } else if (this._previewRulerSegment) {
                this._previewRulerSegment.remove();
                this._previewRulerSegment = null;
            }
        },

        /**
         * @ignore
         * Function called each time the cursor moves over the map.
         * @param {MouseEvent} event
         */
        _mouseMoveHandler: function _mouseMoveHandler(event) {
            this._redrawRulerPreviewSegment(event.latlng);
        },

        /**
         * @ignore
         * Creates a new ruler instance base it the widget options.
         * @param {L.LatLng} latLng
         * @return {L.MeasurementRuler}
         */
        _createRuler: function _createRuler() {
            var rulerOptions = {
                rulerClassname: this._classnames.ruler,
                labelClassname: this._classnames.markerLabel,
                markerColor: this._activeOptions.markerColor,
                lineColor: this._activeOptions.lineColor,
                unitScheme: this._getUnitScheme(),
                useArc: this._activeOptions.useArc
            };
            return new MultiMeasurementRuler(rulerOptions);
        },

        /**
         * Creates a new ruler and add it to the current map as an active ruler.
         * @ignore
         * @return {L.MeasurementRuler}
         */
        _startActiveRuler: function _startActiveRuler() {
            if (this._activeRulerLayer) {
                throw new Error('An active ruler already exist');
            }
            this._activeRulerLayer = this._createRuler().addTo(this._layer);
            return this._activeRulerLayer;
        },

        /**
         * Executed when the user does the first click over the map.
         * @ignore
         * @param {L.LatLng} latLng
         */
        _startMeasurement: function _startMeasurement(latLng) {
            this._rebuildCuratedOptionsSnapshot();

            this._startActiveRuler();

            this._isMeasurementInProgress = true;

            L.DomUtil.addClass(this._controls.container, this._classnames.containerInProgress);

            this.fire(L.DistanceMeasurement.Events.Started, latLng);

            this._map.on('mousemove', this._mouseMoveHandler, this);
            this._map.on('dblclick', this._finishMeasurement, this);
        },

        /**
         * @ignore
         * Executed when a new ruler segment is added to the path.
         * @param {L.LatLng} latLng New ruler segment end coordinates
         */
        _onChangeMeasurement: function _onChangeMeasurement(latLng) {
            this.fire(L.DistanceMeasurement.Events.Changed, {
                ruler: this._activeRulerLayer,
                newSegment: latLng,
                distance: this._activeRulerLayer.distance
            });
        },

        _stopMeasurement: function _stopMeasurement() {
            this._isMeasurementInProgress = false;

            L.DomUtil.removeClass(this._controls.container, this._classnames.containerInProgress);

            this._map.off('mousemove', this._mouseMoveHandler, this);
            this._map.off('dblclick', this._finishMeasurement, this);

            this._redrawRulerPreviewSegment();
        },

        /**
         * @ignore
         * Restart the measurement clearing also the ruler, markers and labels from
         * the map.
         */
        _resetMeasurement: function _resetMeasurement() {
            if (this._activeRulerLayer || this._rulerLayerStack.length > 0) {
                if (this._activeRulerLayer) {
                    this._cancelMeasurement();
                }
                if (this._rulerLayerStack.length > 0) {
                    this._rulerLayerStack.forEach(function (ruler) {
                        ruler.remove();
                    });
                    this._rulerLayerStack = [];
                }
                this.fire(L.DistanceMeasurement.Events.Reset);
            }
        },

        _moveActiveRulerToStack: function _moveActiveRulerToStack() {
            this._rulerLayerStack.push(this._activeRulerLayer);
            this._activeRulerLayer = null;
        },

        /**
         * @ignore
         * Called when the user finish the measurement.
         */
        _finishMeasurement: function _finishMeasurement() {
            if (!this._isMeasurementInProgress) {
                return;
            }

            if (this._activeRulerLayer.distance === 0) {
                // If the ruler is empty, the measurement is considered INVALID
                this._cancelMeasurement();
            } else {
                this._stopMeasurement();
                this.fire(L.DistanceMeasurement.Events.Finished, {
                    ruler: this._activeRulerLayer,
                    distance: this._activeRulerLayer.distance
                });
                this._moveActiveRulerToStack();
            }
        },

        /**
         * @ignore
         * Called when the user decide to cancel a measurement in progress.
         */
        _cancelMeasurement: function _cancelMeasurement() {
            if (this._isMeasurementInProgress) {
                this._stopMeasurement();
                this._activeRulerLayer.remove();
                this._activeRulerLayer = null;
                this.fire(L.DistanceMeasurement.Events.Cancelled);
            }
        },

        /**
         * @ignore
         * Called when the user decide to cancel a measurement in progress or reset the
         * current finished measurement.
         */
        _cancelOrResetMeasurement: function _cancelOrResetMeasurement() {
            if (this._isMeasurementInProgress) {
                this._cancelMeasurement();
            } else {
                this._resetMeasurement();
            }
        },

        /**
         * Disables the widget's instance to not allowing user interaction.
         * @method disable
         * @chainable
         * @return {L.DistanceMeasurement}
         */
        disable: function disable() {
            if (!this._disabled) {
                this.deactivate();
                this._disabled = true;
                L.DomUtil.addClass(this._controls.onoffButton, this._classnames.onoffButtonDisabled);
                this.fire(L.DistanceMeasurement.Events.Disabled);
            }
            return this;
        },

        /**
         * Re-enables the widget if was previously disabled.
         * @method enable
         * @chainable
         * @return {L.DistanceMeasurement}
         */
        enable: function enable() {
            if (this._disabled) {
                this._disabled = false;
                L.DomUtil.removeClass(this._controls.onoffButton, this._classnames.onoffButtonDisabled);
                this.fire(L.DistanceMeasurement.Events.Enabled);
            }
            return this;
        }
    });

    return function (options) {
        var distanceMeasurement = new L.DistanceMeasurement(options);
        Utils.addDeprecatedProperty(distanceMeasurement, 'EVENTS', 'Events');
        return distanceMeasurement;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * @ignore
 * It create many instances of MeasurementRuler and place the copies to the sides with 360 degrees of
 * longitude difference between each one.
 * This module has almost the same methods of MeasurementRuler to easy implementation.
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(99)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, MeasurementRuler) {
    'use strict';

    var MultiRuler = L.LayerGroup.extend({
        _rulers: [],
        initialize: function initialize(rulerOptions) {
            this._rulers = [];

            // One main rules and 4 clones (two to each side)
            this._createRuler(rulerOptions);
            this._createRuler(rulerOptions);
            this._createRuler(rulerOptions);
            this._createRuler(rulerOptions);
            this._createRuler(rulerOptions);
            L.LayerGroup.prototype.initialize.call(this, this._rulers);

            Object.defineProperty(this, 'options', {
                get: function get() {
                    // Remember that all the rules should have the same configuration
                    return this._rulers[0].options;
                }
            });

            Object.defineProperty(this, 'distance', {
                get: function get() {
                    // Remember that all the rules should have the same distance
                    return this._rulers[0].distance;
                }
            });

            Object.defineProperty(this, 'latLngs', {
                get: function get() {
                    // Remember that all the rules should have the same properties
                    return this._rulers[0].latLngs;
                }
            });
        },
        /**
         * @ignore
         * Adds a new segments to all the rules.
         * @param {L.LatLng} latLng
         */
        addLatLng: function addLatLng(latLng) {
            var i,
                offset = 360,
                len = this._rulers.length;
            this._rulers[0].addLatLng(latLng);
            for (i = 1; i + 1 < len; i = i + 2) {
                this._rulers[i].addLatLng(this._getLatLngWithLngOffset(latLng, -offset));
                this._rulers[i + 1].addLatLng(this._getLatLngWithLngOffset(latLng, offset));
                offset += 360;
            }
        },
        /**
         * @ignore
         * Set the ruler path to all the rules.
         * @param {L.LatLng[]} latLngs
         */
        setLatLngs: function setLatLngs(latLngs) {
            var i,
                offset = 360,
                len = this._rulers.length;
            this._rulers[0].setLatLngs(latLngs);
            for (i = 1; i + 1 < len; i = i + 2) {
                this._rulers[i].setLatLngs(this._getLatLngsWithLngOffset(latLngs, -offset));
                this._rulers[i + 1].setLatLngs(this._getLatLngsWithLngOffset(latLngs, offset));
                offset += 360;
            }
        },
        /**
         * @ignore
         * Returns the last coordinates added to the ruler.
         * @return {L.LatLng}
         */
        getLast: function getLast() {
            return this._rulers[0].getLast();
        },
        /**
         * @ignore
         * Returns the last coordinates of the closest ruler polyline to the given coordinates.
         * @param {L.LatLng} closerLatLng
         * @return {L.LatLng}
         */
        getClosestLast: function getClosestLast(closerLatLng) {
            var lastsLatLngs,
                closerPoint,
                map = this._map;

            closerPoint = map.latLngToContainerPoint(closerLatLng);

            lastsLatLngs = this._rulers
            // Creating a distances report
            .map(function (ruler) {
                var rulerLastLatLng = ruler.getLast(),
                    rulerLastPoint = map.latLngToContainerPoint(rulerLastLatLng);
                return { latLng: rulerLastLatLng, distance: Math.round(rulerLastPoint.distanceTo(closerPoint)) };
            })
            // Sorting points from closest to furthers
            .sort(function (a, b) {
                return a.distance - b.distance;
            });

            if (lastsLatLngs.length > 0) {
                return lastsLatLngs[0].latLng;
            }

            return null;
        },
        _createRuler: function _createRuler(rulerOptions) {
            var ruler = new MeasurementRuler(rulerOptions);
            this._rulers.push(ruler);
            return ruler;
        },
        _getLatLngsWithLngOffset: function _getLatLngsWithLngOffset(latLngs, offset) {
            return latLngs.map(function (latLng) {
                return L.latLng(latLng.lat, latLng.lng + offset);
            });
        },
        _getLatLngWithLngOffset: function _getLatLngWithLngOffset(latLng, offset) {
            return L.latLng(latLng.lat, latLng.lng + offset);
        }
    });

    return MultiRuler;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This widget allows you to manage many search boxes.
 *
 * @class RouteInputs
 * @namespace L
 * @extends L.Control
 * @uses L.Evented
 * @module Widgets
 * @constructor
 * @param {Object} [options] Options to be passed to the routeInputs control
 * @param {Number} [options.searchBoxes=2] Number of searchBoxes to be created
 * @param {"topright"|"topleft"|"bottomright"|"bottomleft"} [options.position="topleft"] Position of
 *     the control on the map
 * @param {String} [options.location=L.RouteInputs.Location.Start] Definition of place of creation location control.
 *     Should be equal to one of the values in the {{#crossLink "L.RouteInputs/Location:property"}}{{/crossLink}}
 *     property.
 * @param {String} [options.enableSearchBoxesModifcation=false] Determines whether control should expose
 *     functionality of adding or removing waypoints by internal controls
 * @param {String} [options.waypointPlacement=L.RouteInputs.WaypointPlacement.BeforeLast] Determines the place where
 *     the new waypoint will added to.
 *     Should be equal to one of the values in the
 *     {{#crossLink "L.RouteInputs/WaypointPlacement:property"}}{{/crossLink}} property.
 * @param {Object} [options.searchOptions] Options for the {{#crossLink "L.SearchBox"}}{{/crossLink}} instances
 * @param {Object} [options.searchOptions.collapsible=false] Decide if the search boxes should be collapsed
 *
 * @example
 * ```javascript
 * // Route inputs with two search boxes and location control
 * var widget = new L.RouteInputs({
 *   searchBoxes: 2,
 *   location: L.RouteInputs.Location.Start
 * })
 * widget.addTo(map);
 * ```
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0), __webpack_require__(97)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, utils) {
    'use strict';

    var EVENTS = {
        LocationsFound: 'locationsFound',
        LocationsCleared: 'locationsCleared',
        LocationError: 'locationError'
    },
        LOCATION = {
        Start: 'start',
        End: 'end'
    },
        WAYPOINT_PLACEMENT = {
        Last: 'last',
        BeforeLast: 'beforeLast'
    };
    var routeInputConstructor;

    /**
     * @ignore
     * Returns the list of selected locations.
     * @return {Array}
     */
    function getLocationsFromSearchBoxes() {
        return this.searchBoxes.map(function (searchBox) {
            return searchBox.selectedLocation;
        });
    }

    function updateSearchBoxIcons() {
        var self = this;
        self.searchBoxes.forEach(function (searchBox, index) {
            var style = self.getIconClassName(index);
            searchBox.setIcon(style);
        });
    }

    function updateLocationButton() {
        var locationIconIndex;
        this.searchBoxes.forEach(function (searchBox) {
            searchBox.removeLocationIcon();
        });
        locationIconIndex = this.options.location === LOCATION.Start ? 0 : this.searchBoxes.length - 1;
        this.searchBoxes[locationIconIndex].addLocationIcon();
    }

    function showDeleteSearchBoxButton(searchBox) {
        if (searchBox.deleteIcon === undefined) {
            searchBox.deleteIcon = L.DomUtil.create('div', 'icon-trash-black leaflet-control-routeInputs-remove');
            searchBox._container.insertBefore(searchBox.deleteIcon, searchBox.resultsContainer);
            L.DomEvent.on(searchBox.deleteIcon, 'click', function () {
                this.removeInput(searchBox);
            }, this);
        }
    }

    function hideDeleteSearchBoxButton(searchBox) {
        if (searchBox.deleteIcon !== undefined) {
            searchBox.deleteIcon.parentNode.removeChild(searchBox.deleteIcon);
            searchBox.deleteIcon = undefined;
        }
    }

    function setVisibilityForDeleteButton(callback) {
        var i;
        for (i = 0; i < this.searchBoxes.length; i += 1) {
            callback.call(this, this.searchBoxes[i]);
        }
    }

    function updateDeleteSearchBoxButtons() {
        if (this.options.enableSearchBoxesModifcation === true) {
            if (this.searchBoxes.length === this.options.searchBoxes) {
                setVisibilityForDeleteButton.call(this, hideDeleteSearchBoxButton);
            } else {
                setVisibilityForDeleteButton.call(this, showDeleteSearchBoxButton);
            }
        }
    }

    function showInsertSearchBoxButton(container) {
        if (this.insertSearchBoxButton === undefined) {
            this.insertSearchBoxButton = L.DomUtil.create('div', 'icon-add-black leaflet-control-routeInputs-add', container || this.getContainer());
            L.DomEvent.on(this.insertSearchBoxButton, 'click', this.addInput, this);
        }
    }

    function hideInsertSearchBoxButton() {
        if (this.insertSearchBoxButton !== undefined) {
            L.DomEvent.off(this.insertSearchBoxButton, 'click', this.addInput);
            this.insertSearchBoxButton.parentNode.removeChild(this.insertSearchBoxButton);
            this.insertSearchBoxButton = undefined;
        }
    }

    function updateInsertSearchBoxButton() {
        var i;
        if (this.options.enableSearchBoxesModifcation === true) {
            for (i = 0; i < this.searchBoxes.length; i += 1) {
                if (this.searchBoxes[i].input.value.length === 0) {
                    hideInsertSearchBoxButton.call(this);
                    return;
                }
            }
            showInsertSearchBoxButton.call(this, null);
        }
    }

    L.RouteInputs = L.Control.extend({

        includes: L.Evented.prototype,

        statics: {
            Events: EVENTS,
            Location: LOCATION,
            WaypointPlacement: WAYPOINT_PLACEMENT
        },

        options: {
            searchBoxes: 2,
            position: 'topleft',
            location: LOCATION.Start,
            enableSearchBoxesModifcation: false,
            waypointPlacement: WAYPOINT_PLACEMENT.BeforeLast,
            searchOptions: {
                collapsible: false
            }
        },

        initialize: function initialize(options) {
            if (options !== undefined && options.searchOptions !== undefined) {
                utils.addFields(options.searchOptions, this.options.searchOptions);
                delete options.searchOptions;
            }
            L.Util.setOptions(this, options);
            this.searchBoxes = [];
        },

        onAdd: function onAdd() {
            var i,
                container = this.createContainer();
            this.searchBoxesContainer = L.DomUtil.create('div', 'leaflet-control-search-boxes', container);
            for (i = 0; i < this.options.searchBoxes; i += 1) {
                this.searchBoxes.push(this.createSearchBox(i));
            }
            return container;
        },

        /**
         * Method used to create the container for the search boxes.
         *
         * @method createContainer
         * @return {HTMLElement} Container for search boxes
         */
        createContainer: function createContainer() {
            var container = L.DomUtil.create('div', 'leaflet-control-routeInputs');
            L.DomEvent.disableClickPropagation(container);
            L.DomEvent.disableScrollPropagation(container);
            return container;
        },

        /**
         * Method used to get search box icon's class name, depending on its position (index).
         *
         * The returned class name should be added to the input.
         *
         * @method getIconClassName
         * @param {Number} index
         * @return {String}
         */
        getIconClassName: function getIconClassName(index) {
            var className = 'icon-flag-black',
                minimumBoxesAchieved = this.options.searchBoxes > this.searchBoxes.length,
                lastSearchBoxIndex = minimumBoxesAchieved ? this.options.searchBoxes - 1 : this.searchBoxes.length - 1;
            if (index === 0) {
                className = 'icon-start-black';
            } else if (index === lastSearchBoxIndex) {
                className = 'icon-end-black';
            }
            return className;
        },

        /**
         * Method used to initialize search box by adding element to the container and applying event handlers on
         * it.
         *
         * @method createSearchBox
         * @param {Number} index Index of the search box (starting from `0`)
         * @return {L.SearchBox} Modified search box object
         */
        createSearchBox: function createSearchBox(index) {
            var searchBoxInstance;
            var options = utils.clone(this.options.searchOptions);
            options.location = this.needsLocationIcon(index);
            options.icon = this.getIconClassName(index);
            options.searchOnDragEnd = 'open';
            searchBoxInstance = new L.SearchBox(options).addTo(this._map);

            this.searchBoxesContainer.insertBefore(searchBoxInstance.getContainer(), this.searchBoxesContainer.childNodes[index]);
            this.addSearchBoxEventHandlers(searchBoxInstance);
            return searchBoxInstance;
        },

        /**
         * Method used to remove given search box from the view by specific index.
         *
         * @method removeSearchBox
         * @param {Number} index Index of the search box (starting from `0`)
         * @return {L.SearchBox} Modified search box object
         */
        removeSearchBox: function removeSearchBox(index) {
            var searchBox = this.searchBoxesContainer.childNodes[index];
            searchBox.parentNode.removeChild(searchBox);
            return searchBox;
        },

        /**
         * Method used to check if search box needs location element.
         *
         * @method needsLocationIcon
         * @param {Number} searchBoxIndex Index of the given search box (starting from `0`)
         * @return {Boolean} Returns information of presence of location element
         */
        needsLocationIcon: function needsLocationIcon(searchBoxIndex) {
            var first = this.options.location === LOCATION.Start && searchBoxIndex === 0,
                last = this.options.location === LOCATION.End && searchBoxIndex === this.options.searchBoxes - 1;
            return first || last;
        },

        /**
         * Method used to add handlers for given search box. If obtaining user's current location fails,
         * {{#crossLink "L.RouteInputs/LocationError:event"}}{{/crossLink}} is fired.
         *
         * @method addSearchBoxEventHandlers
         * @param {L.SearchBox} searchBox Search box instance used to add handlers on it
         */
        addSearchBoxEventHandlers: function addSearchBoxEventHandlers(searchBox) {
            var that = this;
            searchBox.on(searchBox.Events.ResultClicked, function (eventObject) {
                that.onLocationChange(eventObject);
            });
            searchBox.on(searchBox.Events.ClearButtonClicked, function (eventObject) {
                that.onLocationChange(eventObject);
                updateInsertSearchBoxButton.call(that);
            });
            searchBox.on(searchBox.Events.SearchInputChanged, function () {
                updateInsertSearchBoxButton.call(that);
            });
            if (searchBox.getLocation()) {
                searchBox.getLocation().on(searchBox.getLocation().Events.LocationError, function (eventObject) {
                    that.fire(this.Events.LocationError, eventObject);
                });
            }
        },

        /**
         * Method used to manage changing state of search boxes. Depending on the content of the searchBox, there might
         * be fired one of these two events:
         *  - {{#crossLink "L.RouteInputs/LocationsFound:event"}}{{/crossLink}} or
         *  - {{#crossLink "L.RouteInputs/LocationsCleared:event"}}{{/crossLink}}
         *
         * @method onLocationChange
         * @param {Object} eventObject Object that contains event's information
         * @param {L.SearchBox} eventObject.target Box instance
         * @param {Object} eventObject.data
         * @param {Number} eventObject.data.position Position of the box
         */
        onLocationChange: function onLocationChange(eventObject) {
            var searchBox = eventObject.target;
            searchBox.selectedLocation = eventObject.data ? eventObject.data.position : undefined;

            this.fire(eventObject.data ? this.Events.LocationsFound : this.Events.LocationsCleared, {
                points: getLocationsFromSearchBoxes.call(this)
            });
        },

        /**
         * Method used to show notification when looking for current location fails.
         *
         * @method showLocationNotFoundMessageBox
         */
        showLocationNotFoundMessageBox: function showLocationNotFoundMessageBox() {
            L.messageBox({ closeAfter: 1500 }).openOn(this._map).setContent('Could not find your location');
        },

        /**
         * Method used to add searchBox to the specific position (index).
         *
         * @method addInput
         * @param {Number} [index] Represents position where search box should be added to.
         *     Not passing any index will cause adding a searchBox at the end of list or just before the last
         *     search box.
         *
         * @example
         * ```javascript
         * var widget = new L.RouteInputs();
         * widget.addTo(map);
         * widget.addInput(0);
         * widget.addInput();
         * ```
         */
        addInput: function addInput(index) {
            if (!isFinite(index)) {
                index = this.searchBoxes.length;
                if (this.options.waypointPlacement === WAYPOINT_PLACEMENT.BeforeLast) {
                    index -= 1;
                }
            }
            this.searchBoxes.splice(index, 0, this.createSearchBox(index));
            updateSearchBoxIcons.call(this);
            updateLocationButton.call(this);
            updateDeleteSearchBoxButtons.call(this);
            updateInsertSearchBoxButton.call(this);
        },

        /**
         * Method used to remove searchBox from the specific position (index).
         *
         * @method removeInput
         * @param {Number|L.SearchBox} searchBox The index of the searchBox to be deleted or the box instance itself
         *
         * @example
         * ```javascript
         * var widget = new L.RouteInputs();
         * widget.addTo(map)
         * widget.removeInput(0);
         * widget.removeInput();
         * ```
         */
        removeInput: function removeInput(searchBox) {
            var nodeList;
            if (searchBox === undefined) {
                searchBox = this.searchBoxes.length - 1;
            } else if ((typeof searchBox === 'undefined' ? 'undefined' : _typeof(searchBox)) === 'object') {
                nodeList = Array.prototype.slice.call(this.searchBoxesContainer.children);
                searchBox = nodeList.indexOf(searchBox.getContainer());
            }
            this.removeSearchBox(searchBox);
            this.searchBoxes.splice(searchBox, 1);
            updateSearchBoxIcons.call(this);
            updateLocationButton.call(this);
            updateDeleteSearchBoxButtons.call(this);
            updateInsertSearchBoxButton.call(this);

            this.fire(this.Events.LocationsCleared, { points: getLocationsFromSearchBoxes.call(this) });
        },

        /**
         * Event that is fired when locations in all searchBoxes are changing.
         *
         * @event LocationsFound
         * @param {Array} points Array of points that represents locations from all searchBoxes, even if they are
         *     undefined.
         * @param {String} [type="locationsFound"] Event's name
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         * var routeInputInstance = (new L.RouteInputs()).addTo(map);
         * routeInputInstance.on(L.RouteInputs.Events.LocationsFound, function (eventObject) {
         *      console.log(eventObject.points);
         * });
         * ```
         */

        /**
         * Event that is fired when locations in all searchBoxes are being removed.
         *
         * @event LocationsCleared
         * @param {Array} points Array of points that represents locations from all searchBoxes, even if they are
         *     undefined.
         * @param {String} [type="locationsCleared"] Event's name
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         * var widget = new L.RouteInputs();
         * widget.addTo(map);
         * widget.on(L.RouteInputs.Events.LocationsCleared, function (eventObject) {
         *   console.log(eventObject.points);
         * });
         * ```
         */

        /**
         * Event that is fired when obtaining user's current location fails.
         *
         * @event LocationError
         * @param {Object} eventObject All failure information
         * @param {String} [type="locationError"] Event's name
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         * var widget = new L.RouteInputs();
         * widget.addTo(map);
         * widget.on(L.RouteInputs.Events.LocationError, function (eventObject) {
         *   console.log(eventObject);
         * });
         * ```
         */
        Events: EVENTS
    });

    routeInputConstructor = function routeInputConstructor(options) {
        var routeInputs = new L.RouteInputs(options);
        utils.addDeprecatedProperty(routeInputs, 'Event', 'Events');
        return routeInputs;
    };

    /**
     * Determines the position that location icon will be added to.
     *
     * Possible options are:
     *
     * * `Location.Start` - location will be added to the first searchBox in the list.
     * * `Location.End` - location will be added to the last searchBox in the list.
     *
     * @property {Object} Location
     *
     * @example
     * ```javascript
     * var widget = new L.RouteInputs({
     *   location: L.RouteInputs.Location.Start
     * });
     * widget.addTo(map);
     * ```
     */
    routeInputConstructor.Location = LOCATION;

    /**
     * Determines the position where waypoint will be added to.
     *
     * Possible options are:
     *
     * * `WaypointPlacement.BeforeLast` - new waypoint will be added before the last searchBox.
     * * `WaypointPlacement.Last` - new waypoint will be added as the last element in the list.
     *
     * @property {Object} WaypointPlacement
     *
     * @example
     * ```javascript
     * var widget = new L.RouteInputs({
     *   waypointPlacement: L.RouteInputs.WaypointPlacement.BeforeLast
     * });
     * widget.addTo(map);
     * ```
     */
    routeInputConstructor.WaypointPlacement = WAYPOINT_PLACEMENT;

    return routeInputConstructor;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This widget displays a panel with route instructions over the map.
 * 
 * This widget requires route data to work correcly. For more information please refer to our 
 * <a href="https://developer.tomtom.com/maps-sdk-web/functional-examples#routing_ab_instructions" target="_blank">
 * Routing example</a>.
 *
 * @class RouteInstructions
 * @namespace L
 * @extends L.Control
 * @module Widgets
 * @constructor
 * @param {Object} [options] Options to configure the widget
 * @param {Number[]} [options.size=[320, 320]] Size of panel. The first element of the array is the width
 *     and the second the maximum height. It will fit to the size of the instructions.
 * @param {"topright"|"topleft"|"bottomright"|"bottomleft"} [options.position="topleft"] Location of the
 *     widget
 * @param {Boolean} [options.instructionGroupsCollapsed=false] Should instruction groups be collapsed on init
 * @param {Boolean} [options.showInstructionGroups=true] Should instruction groups be displayed
 * @param {Boolean} [options.imperialDistance=null] Set this option if you want to use a specific unit
 *     measurement system for the new instance of the widget instead of use the default unit
 *
 * @example
 * ```javascript
 * var routeInstructionsInstance = new L.RouteInstructions({
 *     size: [270, 268],
 *     position: "topleft"
 * })
 * routeInstructionsInstance.addTo(map);
 * ```
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(15), __webpack_require__(16), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, unitFormatConverter, unitTypes, Utils) {
    'use strict';

    var EVENTS = {
        InstructionClickedSelect: 'instructionClickedSelect',
        InstructionClickedDeselect: 'instructionClickedDeselect',
        InstructionHoverOn: 'instructionHoverOn',
        InstructionHoverOff: 'instructionHoverOff',
        InstructionGroupClickedCollapse: 'instructionGroupClickedCollapse',
        InstructionGroupClickedExpand: 'instructionGroupClickedExpand',
        InstructionGroupHoverOn: 'instructionGroupHoverOn',
        InstructionGroupHoverOff: 'instructionGroupHoverOff'
    },
        CSS_CLASS_NAME = 'leaflet-control-route-instructions',
        MANOUVERS_WITH_LEFT_DRIVING_SIDE_VERSIONS = ['MAKE_UTURN', 'TRY_MAKE_UTURN', 'ROUNDABOUT_RIGHT', 'ROUNDABOUT_LEFT', 'ROUNDABOUT_CROSS', 'ROUNDABOUT_BACK'],
        iconsMap = {
        'ARRIVE': 'icon-end-black',
        'ARRIVE_LEFT': 'icon-end-black',
        'ARRIVE_RIGHT': 'icon-end-black',
        'DEPART': 'icon-start-black',
        'STRAIGHT': 'icon-follow',
        'KEEP_RIGHT': 'icon-keep_right',
        'BEAR_RIGHT': 'icon-bear_right',
        'TURN_RIGHT': 'icon-turn_right',
        'SHARP_RIGHT': 'icon-sharp_right',
        'KEEP_LEFT': 'icon-keep_left',
        'BEAR_LEFT': 'icon-bear_left',
        'TURN_LEFT': 'icon-turn_left',
        'SHARP_LEFT': 'icon-sharp_left',
        'MAKE_UTURN': 'icon-make_uturn',
        'MAKE_UTURN_LEFT_DRIVING_SIDE': 'icon-make_uturn_left_driving_side',
        'ENTER_MOTORWAY': 'icon-freeway',
        'ENTER_FREEWAY': 'icon-freeway',
        'ENTER_HIGHWAY': 'icon-freeway',
        'TAKE_EXIT': 'icon-follow',
        'MOTORWAY_EXIT_LEFT': 'icon-keep_left',
        'MOTORWAY_EXIT_RIGHT': 'icon-keep_right',
        'TAKE_FERRY': 'icon-ferry',
        'ROUNDABOUT_CROSS': 'icon-roundabout_cross',
        'ROUNDABOUT_CROSS_45': 'icon-roundabout_cross_45',
        'ROUNDABOUT_RIGHT_135': 'icon-roundabout_right_135',
        'ROUNDABOUT_CROSS_MINUS_45': 'icon-roundabout_cross_minus_45',
        'ROUNDABOUT_LEFT_MINUS_135': 'icon-roundabout_left_minus_135',
        'ROUNDABOUT_RIGHT': 'icon-roundabout_right',
        'ROUNDABOUT_LEFT': 'icon-roundabout_left',
        'ROUNDABOUT_BACK': 'icon-roundabout_back',
        'TRY_MAKE_UTURN': 'make_uturn',
        'TRY_MAKE_UTURN_LEFT_DRIVING_SIDE': 'icon-make_uturn_left_driving_side',
        'ROUNDABOUT_CROSS_LEFT_DRIVING_SIDE': 'icon-roundabout_cross_left_driving_side',
        'ROUNDABOUT_CROSS_45_LEFT_DRIVING_SIDE': 'icon-roundabout_cross_45_left_driving_side',
        'ROUNDABOUT_RIGHT_135_LEFT_DRIVING_SIDE': 'icon-roundabout_right_135_left_driving_side',
        'ROUNDABOUT_CROSS_MINUS_45_LEFT_DRIVING_SIDE': 'icon-roundabout_cross_minus_45_left_driving_side',
        'ROUNDABOUT_LEFT_MINUS_135_LEFT_DRIVING_SIDE': 'icon-roundabout_left_minus_135_left_driving_side',
        'ROUNDABOUT_RIGHT_LEFT_DRIVING_SIDE': 'icon-roundabout_right_left_driving_side',
        'ROUNDABOUT_LEFT_LEFT_DRIVING_SIDE': 'icon-roundabout_left_left_driving_side',
        'ROUNDABOUT_BACK_LEFT_DRIVING_SIDE': 'icon-roundabout_back_left_driving_side',
        'FOLLOW': 'icon-follow',
        'WAYPOINT_LEFT': 'icon-flag-black',
        'WAYPOINT_RIGHT': 'icon-flag-black',
        'WAYPOINT_REACHED': 'icon-flag-black'
    };

    /**
     * @ignore
     * @param {HTMLElement} control
     * @return {HTMLElement}
     */
    function createDOMElements(control) {
        var container = L.DomUtil.create('div', CSS_CLASS_NAME + ' leaflet-control');
        control.container = container;
        container.style.width = control.options.size[0] + 'px';
        container.style.maxHeight = control.options.size[1] + 'px';

        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);

        container.style.visibility = 'hidden';

        return container;
    }

    /**
     * @ignore
     * @param {HTMLElement} control
     */
    function clearDOMElements(control) {
        control.container.innerHTML = '';
    }

    function createCollapseIconDiv(isInstructionGroupsCollapsed) {
        var collapseIconClass = isInstructionGroupsCollapsed ? 'icon-expand' : 'icon-collapse';
        return L.DomUtil.create('div', CSS_CLASS_NAME + '-collapse-icon ' + collapseIconClass);
    }

    function createGroupMessageDiv(instructionGroup) {
        var groupMessageDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-group-message');
        groupMessageDiv.innerHTML = instructionGroup.groupMessage;
        return groupMessageDiv;
    }

    function createSeparatorDiv(divToSeparate, instructionDistance, isImperialDistance, separatorCssClass, isInstructionGroup) {

        var separatorDistanceDiv, autoLengthSeparatorDiv, instructionSeparatorDiv, distanceDiv;
        if (instructionDistance === 0) {
            return;
        }
        separatorDistanceDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-separator-distance', divToSeparate);
        if (isInstructionGroup) {
            L.DomUtil.addClass(separatorDistanceDiv, CSS_CLASS_NAME + '-group-separator-distance');
        }
        autoLengthSeparatorDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-auto-length-separator', separatorDistanceDiv);
        instructionSeparatorDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-separator', autoLengthSeparatorDiv);
        L.DomUtil.addClass(instructionSeparatorDiv, separatorCssClass);
        distanceDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-distance', separatorDistanceDiv);
        distanceDiv.innerHTML = unitFormatConverter.formatDistance(instructionDistance, isImperialDistance);
    }

    function getIconPathKey(instruction) {
        var iconKey = instruction.maneuver;
        if (instruction.maneuver === 'ROUNDABOUT_CROSS') {
            if (instruction.turnAngleInDecimalDegrees >= 22 && instruction.turnAngleInDecimalDegrees <= 68) {
                iconKey += '_45';
            } else if (instruction.turnAngleInDecimalDegrees <= -22 && instruction.turnAngleInDecimalDegrees >= -68) {
                iconKey += '_MINUS_45';
            }
        }
        if (instruction.maneuver === 'ROUNDABOUT_RIGHT' && instruction.turnAngleInDecimalDegrees >= 122 && instruction.turnAngleInDecimalDegrees <= 158) {
            iconKey += '_135';
        }
        if (instruction.maneuver === 'ROUNDABOUT_LEFT' && instruction.turnAngleInDecimalDegrees >= -158 && instruction.turnAngleInDecimalDegrees <= -122) {
            iconKey += '_MINUS_135';
        }
        if (instruction.drivingSide === 'LEFT' && MANOUVERS_WITH_LEFT_DRIVING_SIDE_VERSIONS.indexOf(instruction.maneuver) !== -1) {
            iconKey += '_LEFT_DRIVING_SIDE';
        }
        return iconKey;
    }

    function createInstructionElement(instruction) {
        var messageDiv;
        var instructionElementDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-instruction-element');
        var messageWithIconDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-message-with-icon', instructionElementDiv);
        L.DomUtil.create('div', CSS_CLASS_NAME + '-icon ' + iconsMap[getIconPathKey(instruction)], messageWithIconDiv);
        messageDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-message', messageWithIconDiv);
        messageDiv.innerHTML = instruction.message;
        return instructionElementDiv;
    }

    function createEventObject(instructionPoints, instructionMessage) {
        var eventObject = {};
        if (instructionPoints.constructor.toString().indexOf('Array') > -1) {
            eventObject.points = instructionPoints;
        } else {
            eventObject.point = instructionPoints;
        }
        if (instructionMessage) {
            eventObject.message = instructionMessage;
        }

        return eventObject;
    }

    function toggleCssClasses(htmlElement, cssClassesArray) {
        cssClassesArray.forEach(function (className) {
            if (L.DomUtil.hasClass(htmlElement, className)) {
                L.DomUtil.removeClass(htmlElement, className);
            } else {
                L.DomUtil.addClass(htmlElement, className);
            }
        });
    }

    function deselectInstruction(container, selectedInstructionClass, control) {
        var selectedInstruction = container.getElementsByClassName(selectedInstructionClass)[0];
        if (selectedInstruction) {
            L.DomUtil.removeClass(selectedInstruction, selectedInstructionClass);
            control.fire(control.Events.InstructionClickedDeselect);
        }
    }

    function registerHandlersForInstruction(control, instructionElement, instruction) {
        L.DomEvent.on(instructionElement, 'mouseenter', function () {
            control.fire(control.Events.InstructionHoverOn, createEventObject(instruction.point, instruction.message));
        });
        L.DomEvent.on(instructionElement, 'mouseleave', function () {
            control.fire(control.Events.InstructionHoverOff);
        });
        L.DomEvent.on(instructionElement, 'click', function () {
            var selectedInstructionClass;
            control.container.focus();
            selectedInstructionClass = ['selected-instruction'];

            if (L.DomUtil.hasClass(instructionElement, selectedInstructionClass)) {
                control.fire(control.Events.InstructionClickedDeselect);
            } else {
                deselectInstruction(control.container, selectedInstructionClass, control);
                control.fire(control.Events.InstructionClickedSelect, createEventObject(instruction.point, instruction.message));
            }

            toggleCssClasses(instructionElement, selectedInstructionClass);
        });
    }

    function createInstructions(control, divForInstructions, instructionList, instructionNextToGroup) {
        var nextInstructionOffset = 0;
        var instructionPoints = [];
        var instructionIndex,
            currentInstruction,
            nextInstruction,
            instructionElementDiv,
            separatorCssClassName,
            isImperialDistance = control._shouldUseImperialDistance();

        for (instructionIndex = 0; instructionIndex < instructionList.length; instructionIndex += 1) {
            currentInstruction = instructionList[instructionIndex];
            instructionPoints.push(currentInstruction.point);
            nextInstruction = instructionList[instructionIndex + 1];
            instructionElementDiv = createInstructionElement(currentInstruction);
            divForInstructions.appendChild(instructionElementDiv);
            separatorCssClassName = 'separator-between-instructions';

            if (nextInstruction !== undefined) {
                nextInstructionOffset = nextInstruction.routeOffsetInMeters;
            } else if (instructionNextToGroup) {
                nextInstructionOffset = instructionNextToGroup.routeOffsetInMeters;
                separatorCssClassName = 'separator-end-group';
            }

            createSeparatorDiv(instructionElementDiv, nextInstructionOffset - currentInstruction.routeOffsetInMeters, isImperialDistance, separatorCssClassName, false);
            registerHandlersForInstruction(control, instructionElementDiv, currentInstruction);
        }

        return instructionPoints;
    }

    function registerHandlersForGroup(params) {
        L.DomEvent.on(params.groupElementDiv, 'mouseenter', function () {
            params.control.fire(params.control.Events.InstructionGroupHoverOn, createEventObject(params.groupedInstructionPoints, params.groupMessage));
        });
        L.DomEvent.on(params.groupElementDiv, 'mouseleave', function () {
            params.control.fire(params.control.Events.InstructionGroupHoverOff);
        });
        L.DomEvent.on(params.groupElementDiv, 'click', function () {
            var separator;
            params.control.container.focus();
            separator = params.groupElementDiv.getElementsByClassName('leaflet-control-route-instructions-separator')[0];
            toggleCssClasses(separator, ['separator-between-instructions', 'separator-end-group']);
            toggleCssClasses(params.collapseIconDiv, ['icon-collapse', 'icon-expand']);

            if (params.groupedInstructionsDiv.style.display === 'none') {
                params.groupedInstructionsDiv.style.display = '';
                params.control.fire(params.control.Events.InstructionGroupClickedExpand, createEventObject(params.groupedInstructionPoints, null));
            } else {
                params.groupedInstructionsDiv.style.display = 'none';
                params.control.fire(params.control.Events.InstructionGroupClickedCollapse, createEventObject(params.allInstructionsPoints, null));
            }
        });
    }

    /**
     * @ignore
     * @param {HTMLElement} control
     * @param {Object} guidance
     */
    function createInstructionsWithGroups(control, guidance) {
        var container = control.container;
        var allInstructionsPoints = [];
        var instructionIndex,
            groupIndex,
            instructionGroup,
            groupElementDiv,
            groupedInstructionsDiv,
            groupMessageWithIconDiv,
            collapseIconDiv,
            groupMessageDiv,
            separatorCssClassName,
            instructionListForGroup,
            groupedInstructionPoints,
            isImperialDistance = control._shouldUseImperialDistance();

        for (instructionIndex = 0; instructionIndex < guidance.instructions.length; instructionIndex += 1) {
            allInstructionsPoints.push(guidance.instructions[instructionIndex].point);
        }

        for (groupIndex = 0; groupIndex < guidance.instructionGroups.length; groupIndex += 1) {
            instructionGroup = guidance.instructionGroups[groupIndex];
            groupElementDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-group-element', container);
            groupedInstructionsDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-grouped-instructions', container);

            groupMessageWithIconDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-group-message-with-icon', groupElementDiv);
            collapseIconDiv = createCollapseIconDiv(control.options.instructionGroupsCollapsed);
            groupMessageDiv = createGroupMessageDiv(instructionGroup);
            groupMessageWithIconDiv.appendChild(collapseIconDiv);
            groupMessageWithIconDiv.appendChild(groupMessageDiv);

            separatorCssClassName = control.options.instructionGroupsCollapsed ? 'separator-end-group' : 'separator-between-instructions';
            createSeparatorDiv(groupElementDiv, instructionGroup.groupLengthInMeters, isImperialDistance, separatorCssClassName, true);

            instructionListForGroup = guidance.instructions.slice(instructionGroup.firstInstructionIndex, instructionGroup.lastInstructionIndex + 1);
            groupedInstructionPoints = createInstructions(control, groupedInstructionsDiv, instructionListForGroup, guidance.instructions[instructionGroup.lastInstructionIndex + 1]);

            registerHandlersForGroup({
                control: control,
                groupElementDiv: groupElementDiv,
                groupMessage: instructionGroup.groupMessage,
                groupedInstructionPoints: groupedInstructionPoints,
                collapseIconDiv: collapseIconDiv,
                groupedInstructionsDiv: groupedInstructionsDiv,
                allInstructionsPoints: allInstructionsPoints
            });

            if (control.options.instructionGroupsCollapsed) {
                groupedInstructionsDiv.style.display = 'none';
            }
        }
    }

    /**
     * @ignore
     * @param {HTMLElement} control
     */
    function updateDOMElements(control) {
        clearDOMElements(control);
        if (control.options.showInstructionGroups) {
            createInstructionsWithGroups(control, control.guidanceData);
        } else {
            createInstructions(control, control.container, control.guidanceData.instructions, null);
        }
    }

    function handleUnitChange(event) {
        this.options.imperialDistance = event.unit === 'imperial';
        this._redraw(true);
    }

    L.RouteInstructions = L.Control.extend({

        includes: L.Evented.prototype,

        statics: {
            Events: EVENTS
        },

        options: {
            size: [320, 320],
            position: 'topleft',
            instructionGroupsCollapsed: false,
            showInstructionGroups: true,
            imperialDistance: null
        },

        /**
         * Leaflet init method executed when adding control to map.
         *
         * Options will be stored inside control.
         *
         * @ignore
         * @method initialize
         * @param {Object} [options] Options to setup control.
         */
        initialize: function initialize(options) {
            L.Util.setOptions(this, options);
        },

        /**
         * Leaflet method executed when adding control to map.
         * Map will be stored inside control.
         *
         * @ignore
         * @method onAdd
         * @param {L.Map} map
         * @return {HTMLElement} The main HTML element containing the widget.
         */
        onAdd: function onAdd(map) {
            this.unitService = map.getUnitService();
            this.unitService.on(L.UnitService.Events.UNIT_CHANGED, handleUnitChange, this);
            return createDOMElements(this);
        },

        onRemove: function onRemove() {
            this.unitService.off(L.UnitService.Events.UNIT_CHANGED, handleUnitChange, this);
        },

        /**
         * Shows route instructions.
         *
         * By default the instructions will be hidden.
         * Use this method to show the control after data is ready.
         *
         * @method show
         */
        show: function show() {
            if (this.guidanceData) {
                this.container.style.visibility = '';
            }
        },

        /**
         * Hides the route instructions.
         *
         * By default instructions will be hidden.
         *
         * @method hide
         */
        hide: function hide() {
            this.container.style.visibility = 'hidden';
        },

        /**
         * @ignore
         * First check the configuration for this instance and then the global configuration.
         * The instance configuration has priority.
         *
         * @return {Boolean}
         */
        _shouldUseImperialDistance: function _shouldUseImperialDistance() {
            if (typeof this.options.imperialDistance === 'boolean') {
                return this.options.imperialDistance;
            }
            if (typeof this.isImperialDistance === 'boolean') {
                return this.isImperialDistance;
            }
            return this.unitService.getCurrentUnit().getLabel() === unitTypes.imperial;
        },

        _redraw: function _redraw() {
            if (this.guidanceData) {
                updateDOMElements(this);
                this.show();
            } else {
                this.hide();
            }
        },

        /**
         * Display the route instructions or update the already displayed content.
         *
         * This method should be called to update the instructions displayed after each route calculation.
         *
         * @method updateGuidanceData
         * @param {Object} guidanceData The routing properties object containing instruction groups
         *     and instructions.
         * @param {Boolean} [imperial] Display distance using imperial units
         */
        updateGuidanceData: function updateGuidanceData(guidanceData, imperial) {
            this.guidanceData = guidanceData || this.guidanceData;
            this.isImperialDistance = imperial;
            this._redraw();
        },

        /**
         * Method to show instructions with groups if there are any.
         * @method showInstructionGroups
         */
        showInstructionGroups: function showInstructionGroups() {
            if (this.guidanceData && !this.options.showInstructionGroups) {
                this.options.showInstructionGroups = true;
                updateDOMElements(this);
            }
        },

        /**
         * Method to hide instructions groups.
         *
         * Use this method to disable groups. Only instructions will be visible.
         * @method hideInstructionGroups
         */
        hideInstructionGroups: function hideInstructionGroups() {
            if (this.guidanceData && this.options.showInstructionGroups) {
                this.options.showInstructionGroups = false;
                updateDOMElements(this);
            }
        },

        /**
         * Event that is fired when instruction is clicked and is not selected.
         *
         * In this case clicked instruction will
         * be marked as selected (selected-instruction css class will be added).
         * If any other instruction is selected,
         * it will be deselect.
         *
         * @event InstructionClickedSelect
         * @param {Object} point Object of point that represents latitude and longitude of instruction location
         * @param {String} message Instruction message
         * @param {String} [type="instructionClickedDeselect"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.RouteInstructions())).addTo(map);
         * widget.on(L.RouteInstructions.Events.InstructionClickedSelect, function(event) {
         *      console.log(event);
         * });
         * ```
         */
        /**
         * Event that is fired when instruction is clicked and is selected. In this case clicked instruction will
         * be deselect (selected-instruction css class will be removed).
         *
         * @event InstructionClickedDeselect
         * @param {String} [type="instructionClickedDeselect"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.RouteInstructions())).addTo(map);
         * widget.on(L.RouteInstructions.Events.InstructionClickedDeselect, function(event) {
         *      console.log(event);
         * });
         * ```
         */
        /**
         * Event that is fired when cursor is moving into instruction.
         *
         * @event InstructionHoverOn
         * @param {Object} point Object of point that represents latitude and longitude of instruction location
         * @param {String} message Instruction message
         * @param {String} [type="instructionHoverOn"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.RouteInstructions())).addTo(map);
         * widget.on(L.RouteInstructions.Events.InstructionHoverOn, function(event) {
         *      console.log(event);
         * });
         * ```
         */
        /**
         * Event that is fired when cursor is moving out of instruction.
         *
         * @event InstructionHoverOff
         * @param {String} [type="instructionHoverOff"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.RouteInstructions())).addTo(map);
         * widget.on(L.RouteInstructions.Events.InstructionHoverOff, function(event) {
         *      console.log(event);
         * });
         * ```
         */
        /**
         * Event that is fired when group of instructions is clicking and related instructions are collapsing.
         *
         * @event InstructionGroupClickedCollapse
         * @param {Object} points Object with points that represents latitude and longitude of all instruction
         * locations in route
         * @param {String} [type="instructionGroupClickedCollapse"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.RouteInstructions())).addTo(map);
         * widget.on(L.RouteInstructions.Events.InstructionGroupClickedCollapse, function(event) {
         *      console.log(event);
         * });
         * ```
         */
        /**
         * Event that is fired when group of instructions is clicking and related instructions are expanding.
         *
         * @event InstructionGroupClickedExpand
         * @param {Object} points Object with points that represents latitude and longitude of all instruction
         * locations in group
         * @param {String} [type="instructionGroupClickedExpand"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.RouteInstructions())).addTo(map);
         * widget.on(L.RouteInstructions.Events.InstructionGroupClickedExpand, function(event) {
         *      console.log(event);
         * });
         * ```
         */
        /**
         * Event that is fired when cursor is moving into group of instructions.
         *
         * @event InstructionGroupHoverOn
         * @param {Array} points Array of objects that contains points (latitude and longitude) of all instructions
         * from this group
         * @param {String} message Group message
         * @param {String} [type="instructionGroupHoverOn"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.RouteInstructions())).addTo(map);
         * widget.on(L.RouteInstructions.Events.InstructionGroupHoverOn, function(event) {
         *      console.log(event);
         * });
         * ```
         */
        /**
         * Event that is fired when cursor is moving out of group of instructions.
         *
         * @event InstructionGroupHoverOff
         * @param {String} [type="instructionGroupHoverOff"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.RouteInstructions())).addTo(map);
         * widget.on(L.RouteInstructions.Events.InstructionGroupHoverOff, function(event) {
         *      console.log(event);
         * });
         * ```
         */
        Events: EVENTS
    });

    return function (options) {
        var routeInstructions = new L.RouteInstructions(options);
        Utils.addDeprecatedProperty(routeInstructions, 'Event', 'Events');

        return routeInstructions;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This module helps you to create a unit measurement selector.
 *
 * @class UnitSelector
 * @static
 * @namespace L
 * @extends Object
 * @module Widgets
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {
    'use strict';

    function onPropertyChange(e) {
        var value = e.target.options[e.target.selectedIndex].value;
        this.unitService.setCurrentUnit(value);
    }

    function addOptions(select, values) {
        var option;
        values.forEach(function (value) {
            option = document.createElement('option');
            option.text = value.getLabel();
            option.value = value.getLabel();
            select.add(option);
        });
    }

    function setCurrentUnit(select) {
        var i;
        var currentUnit = select.unitService.getCurrentUnit();
        var unitVal = currentUnit.getLabel();
        for (i = 0; i < select.options.length; ++i) {
            if (select.options[i].value === unitVal) {
                select.selectedIndex = i;
            }
        }
    }

    return {
        /**
         * Returns a {{#crossLink "HTMLSelectElement"}}{{/crossLink}} filled with the supported measurement units.
         *
         * The element has a function bound to its <i>onchange</i> event, which updates the units configuration
         * of the {{#crossLink "UnitService"}}{{/crossLink}} instance given as argument.
         *
         * @method getHtmlElement
         * @param {UnitService} unitService Unit service instance which will be bound to the generated dropdown.
         *     That means, that if you change value in this select, bound unitService will be updated.
         * @return {HTMLSelectElement}
         */
        getHtmlElement: function getHtmlElement(unitService) {
            var select;
            if (!unitService) {
                console.error('Unit service not passed to unitSelector!');
                return undefined;
            }
            select = document.createElement('select');
            select.unitService = unitService;
            select.className = 'tomtom-unit-selector';
            addOptions(select, L.UnitService.getSupportedUnits());
            setCurrentUnit(select);
            select.onchange = onPropertyChange;
            return select;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {
    function onPropertyChange(e) {
        this.geopolViewService.setCurrentGeopolView(e.target.value);
    }

    function addOptions(select, values) {
        var option;
        values.forEach(function (value) {
            option = document.createElement('option');
            option.text = value.getLabel();
            option.value = value.getCode();
            select.add(option);
        });
    }

    function setCurrentGeopolView(select) {
        var i;
        var geopolViewVal = select.geopolViewService.current.code;
        for (i = 0; i < select.options.length; ++i) {
            if (select.options[i].value === geopolViewVal) {
                select.selectedIndex = i;
            }
        }
    }
    /**
     * A module, which helps you to create language selector
     * @module Widgets
     * @class geopolViewSelector
     */
    return {
        /**
         * Options are set for supported geopolViews, onchange event has a bound function,
         * which updates global geopolView for the system (which is stored in GeopolViewService.
         * Refer to https://developer.mozilla.org/en/docs/Web/API/HTMLSelectElement for additional information.
         * @method getHtmlElement
         * @param {GeopolViewService} [geopolViewService] GeopolViewService which will be bound to this select element.
         * That means, that if you change value in this select, bound geopolViewService will be updated. You can provide
         * globalGeopolViewService or geopolViewServices which are bound to map instances.
         * @param {"search"|"maps"|"geopolViewSelector"} serviceType
         * @param {"raster"|"vector"} [subType] Used to specify the subType of a service,
         * @returns {HTMLSelectElement}
         */
        getHtmlElement: function getHtmlElement(geopolViewService, serviceType, subType) {
            var select;
            if (!geopolViewService) {
                console.error('GeopolViewService not passed to geopolViewSelector!');
                return undefined;
            }
            select = document.createElement('select');
            select.geopolViewService = geopolViewService;
            select.className = 'tomtom-geopol-view-selector';
            addOptions(select, L.GeopolViewService.getSupportedViews(serviceType, subType));
            setCurrentGeopolView(select);
            select.addEventListener('change', onPropertyChange);
            return select;
        }
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * The MarkersLayer allows you to display search service results on a map. It is based on Leaflet's
 * [marker cluster plugin](https://github.com/Leaflet/Leaflet.markercluster).
 *
 * The default plugin functionality is enhanced for handling TomTom services responses and
 * {{#crossLink "L.SearchBox"}}{{/crossLink}} widget events.
 *
 * @example
 * ```javascript
 * tomtom.key("<your-tomtom-API-key>");
 * tomtom.searchKey("<your-tomtom-search-key>");
 * 
 * var map = tomtom.map("map");
 * var searchBoxInstance = (new L.SearchBox()).addTo(map);
 * var markersLayer = (new L.MarkersLayer()).addTo(map);
 *
 * searchBoxInstance.on(L.SearchBox.Events.ResultsFound, function (results) {
 *     markersLayer.clearLayers();
 *     markersLayer.add(results);
 * });
 * ```
 *
 * @deprecated Please use the
 *  <a href="../classes/L.TomTomMarkersLayer.html" class="alert-link">TomTomMarkersLayer</a> class instead.
 * @class MarkersLayer
 * @namespace L
 * @module Widgets
 * @extends L.MarkerClusterGroup
 * @constructor
 * @param {Object} [options]
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(93)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L) {
    'use strict';

    function isArray(array) {
        return array && array.constructor.toString().indexOf('Array') > -1;
    }

    function hasDataArray(points) {
        return (typeof points === 'undefined' ? 'undefined' : _typeof(points)) === 'object' && isArray(points.data);
    }

    function convertPoints(points) {
        if (hasDataArray(points)) {
            return points.data;
        }
        if (isArray(points)) {
            return points;
        }
        return [points];
    }

    function getFreeFormAddress(object) {
        return object.address ? object.address.freeformAddress : null;
    }

    function getTextContent(object) {
        return object.element ? object.element.textContent : null;
    }

    function oneOf(first, second, third) {
        return first || second || third;
    }

    function getPoiName(object) {
        if (object.poi && object.poi.name) {
            return object.poi.name + ' ';
        }
        return '';
    }

    function getText(object) {
        var freeformAddress = getFreeFormAddress(object),
            textContent = getTextContent(object),
            text = oneOf(object.text, freeformAddress, textContent),
            poiName = getPoiName(object);
        return poiName + text;
    }

    function hadDataPosition(object) {
        return object.data && object.data.position;
    }

    function getObjectType(object) {
        return object.data ? object.data.type : object.type || 'unknown';
    }

    function getPointGeometry(object) {
        var result = {},
            poiObject;
        if (isArray(object.point)) {
            result.position = { lat: object.point[0], lng: object.point[1] };
        } else if (object.position) {
            result.position = { lat: object.position.lat, lng: object.position.lon };
        } else if (hadDataPosition(object)) {
            result.position = { lat: object.data.position.lat, lng: object.data.position.lon };
        }
        result.type = getObjectType(object.data || object);

        poiObject = (object.data || object).poi;
        if (poiObject) {
            if (poiObject.categories) {
                result.poiCategories = poiObject.categories;
            }

            if (poiObject.classifications) {
                result.poiClassifications = poiObject.classifications;
            }
        }

        return result;
    }

    function convertPoint(object) {
        var result, text;
        if (!object) {
            return {};
        }
        result = getPointGeometry(object);
        text = getText(object);

        if (text) {
            result.text = text;
        }
        return result;
    }

    function isEachIconAFunction(options) {
        return options && options.eachIcon && typeof options.eachIcon === 'function';
    }

    function createMarker(object, options) {
        var point = convertPoint(object);
        var marker;
        if (!point || !point.position) {
            return null;
        }
        if (isEachIconAFunction(options)) {
            options.icon = options.eachIcon(point);
        }
        marker = L.marker(point.position, options);
        if (point.text) {
            marker.bindPopup(point.text);
        }
        return marker;
    }

    L.MarkersLayer = L.MarkerClusterGroup.extend({
        _onMapUnload: function _onMapUnload() {
            this._mapUnloads = true;
        },
        onAdd: function onAdd(map) {
            L.MarkerClusterGroup.prototype.onAdd.apply(this, arguments);
            map.on('unload', this._onMapUnload, this);
        },
        onRemove: function onRemove(map) {
            L.MarkerClusterGroup.prototype.onRemove.apply(this, arguments);
            map.off('unload', this._onMapUnload, this);
        },
        /**
         * Clear all the markers.
         *
         * It is equivalent of {{#crossLink "L.LayerGroup"}}{{/crossLink}}'s clearLayers method.
         *
         * @method remove
         * @chainable
         * @return {L.MarkersLayer}
         */
        remove: function remove() {
            if (this._mapUnloads) {
                return L.MarkerClusterGroup.prototype.remove.apply(this, arguments);
            }
            this.clearLayers();
            return this;
        },
        /**
         * Method used to add new markers based on the TomTom search service response.
         *
         * [Further reference](http://leafletjs.com/reference-${leaflet.version}.html#marker-options)
         *
         * @method add
         * @chainable
         * @param {Object} points The response from search service or event from searchBox widget.
         * @param {Object} [options] The options to be used when creating a marker.
         * @param {Function} [options.eachIcon] The function called to create each icon. It has one argument which is
         *     the point - object containing text, position, type,
         *     poiCategories (deprecated, use poiClassifications) if the type is _poi_,
         *     and poiClassifications if the type is _poi_
         * @return {L.MarkersLayer}
         */
        add: function add(points, options) {
            var data = convertPoints(points),
                i,
                marker;
            for (i = 0; i < data.length; i += 1) {
                marker = createMarker(data[i], options);
                if (marker) {
                    this.addLayer(marker);
                }
            }
            return this;
        }
    });

    return function (options) {
        return new L.MarkersLayer(options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * The RouteOnMap view allows you to display a route on the map.
 * 
 * This widget requires route data to work correcly. For more information please refer to our 
 * <a href="https://developer.tomtom.com/maps-sdk-web/functional-examples#routing_ab_instructions" target="_blank">
 * Routing example</a>.
 *
 * @class RouteOnMap
 * @namespace L
 * @extends L.LayerGroup
 * @module Widgets
 * @uses L.Evented
 * @constructor
 * @param {Object} [options] Options to be passed to the routing view
 * @param {Object} [options.generalMarker] General marker options that applies on all markers
 * @param {L.Icon} [options.generalMarker.icon=default] Default icon for every marker
 * @param {Boolean} [options.generalMarker.draggable=false] Determines default drag behaviour for every marker
 * @param {Object} [options.startMarker] Marker options for starting marker
 * @param {L.Icon} [options.startMarker.icon=default] Icon for start marker
 * @param {Boolean} [options.startMarker.draggable=false] Determines whether start marker should be draggable
 * @param {Object} [options.waypointMarker] Marker options for markers between start and end points
 * @param {L.Icon} [options.waypointMarker.icon=default] Icon for markers between start and end points
 * @param {Boolean} [options.waypointMarker.draggable=false] Determines whether start marker should be draggable
 * @param {Object} [options.endMarker] Marker options for end marker
 * @param {L.Icon} [options.endMarker.icon=default] Icon for end marker
 * @param {Boolean} [options.endMarker.draggable=false] Determines whether end marker should be draggable
 * @param {"topleft"|"topright"|"bottomleft"|"bottomright"} [options.position="topleft"]
 * @param {Object} [options.routeStyle={color: '#00d7ff', opacity: 0.8}] A style object used for drawing the
 *     polyline route. All the <a href="https://leafletjs.com/reference-${leaflet.version}.html#path">L.Path</a>
 *     options are accepted.
 * @param {Object[]} [options.alternativeStyles=[{color: '#ff00d2', opacity: 0.8}, {color: '#b922ff',opacity: 0.8}]]
 * If the option to display alternatives is passed to the service options then there is a need to pass array of
 *     <a href="https://leafletjs.com/reference-${leaflet.version}.html#path">L.Path</a> style's options for each
 *     alternative route
 * @param {Number} [options.routingDelay=1000] Determines the time in milliseconds that within routing service will
 *     be called. Used when user is dragging a marker
 * @param {Function} [options.onEachFeature] A function that will be called for each feature, it takes feature
 *     and layer as the attributes. Can be used in example to bind popup to the route
 * @param {Object} [options.serviceOptions] Options to be passed to the routing service. For details check
 *     routingService documentation
 *
 * @example
 * ```javascript
 * var routeOnMapView = new L.RouteOnMap({
 *   generalMarker: {
 *     draggable: true
 *   },
 *   startMarker: {
 *     background: {
 *       iconSize: [30, 36],
 *       iconAnchor: [15, 36],
 *       icon: 'marker'
 *     },
 *     icon: {
 *       iconSize: [30, 30],
 *       iconAnchor: [0, 0],
 *       icon: 'flag-white'
 *     },
 *   },
 *   waypointMarker: {
 *     icon: L.icon({
 *       iconUrl: 'waypoint.png',
 *       iconSize: [30, 30],
 *       iconAnchor: [15, 15]
 *     })
 *   },
 *   endMarker: {
 *     icon: L.icon({
 *       iconUrl: 'end.png',
 *       iconSize: [30, 30],
 *       iconAnchor: [15, 15]
 *     })
 *   },
 *   routeStyle: {
 *     color: "#00d7ff",
 *     opacity: 0.8
 *   }
 * });
 * routeOnMapView.addTo(map);
 * ```
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(40), __webpack_require__(25), __webpack_require__(4), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, routingService, reverseGeocodeService, converters, utils) {
    'use strict';

    var EVENTS = {
        MarkerDragEnd: 'markerDragEnd',
        Draw: 'draw',
        RouteChanged: 'routeChanged',
        RouteNotFound: 'routeNotFound'
    };

    /**
     * @param {String} [type]
     * @return {Object}
     */
    function createMarkerIcon(type) {
        var generalMarkerIcon = {
            background: {
                iconSize: L.Browser.retina ? [34, 34] : [20, 20],
                iconAnchor: L.Browser.retina ? [17, 17] : [10, 10],
                icon: 'icon-shield'
            },
            icon: {
                iconSize: L.Browser.retina ? [30, 30] : [18, 18],
                iconAnchor: L.Browser.retina ? [-2, -2] : [-1, -1],
                icon: 'icon-flag-white'
            }
        };
        if (type === 'start') {
            generalMarkerIcon.icon.icon = 'icon-start-white';
        } else if (type === 'end') {
            generalMarkerIcon.icon.icon = 'icon-end-white';
        }
        return generalMarkerIcon;
    }

    function getRouteStyle(style) {
        var styleIndex = 0;
        return function () {
            styleIndex += 1;
            return style[styleIndex % style.length] || style;
        };
    }

    function convertPoints(points) {
        var point, i;
        for (i = 0; i < points.length; i++) {
            point = points[i];
            points[i] = point ? L.latLng(converters.point(point).split(',')) : undefined;
        }
        return points;
    }

    function getIconOptions(points, index, options) {
        var iconOptions = utils.clone(options.generalMarker);
        if (index === 0) {
            utils.addFields(options.startMarker, iconOptions);
            iconOptions.icon = options.startMarker.icon;
        } else if (index === points.length - 1) {
            utils.addFields(options.endMarker, iconOptions);
            iconOptions.icon = options.endMarker.icon;
        } else {
            utils.addFields(options.waypointMarker, iconOptions);
            iconOptions.icon = options.waypointMarker.icon;
        }
        if (options.generalMarker.zIndexOffset) {
            iconOptions.zIndexOffset = options.generalMarker.zIndexOffset;
        }
        return iconOptions;
    }

    function onDragListener(points, e, markers, callback) {
        var index = markers.indexOf(e.target);
        points[index] = e.target.getLatLng();
        callback.call(this, points, index);
    }

    function getAllFilledLocations(points) {
        var filledLocations = [],
            i;
        for (i = 0; i < points.length; i++) {
            if (points[i] !== undefined) {
                filledLocations.push(points[i]);
            }
        }
        return filledLocations;
    }

    function isAtLeastPairOfPoints(points) {
        return points && points.length && points.length > 1;
    }

    L.RouteOnMap = L.LayerGroup.extend({
        includes: L.Evented.prototype,
        statics: {
            Events: EVENTS
        },
        options: {
            generalMarker: {
                icon: L.svgIcon(createMarkerIcon()),
                draggable: false
            },
            startMarker: {
                icon: L.svgIcon(createMarkerIcon('start')),
                draggable: false
            },
            waypointMarker: {
                icon: L.svgIcon(createMarkerIcon('waypoint')),
                draggable: false
            },
            endMarker: {
                icon: L.svgIcon(createMarkerIcon('end')),
                draggable: false
            },
            position: 'topleft',
            routeStyle: {
                color: '#00d7ff',
                opacity: 0.8
            },
            alternativeStyles: [{
                color: '#ff00d2',
                opacity: 0.8
            }, {
                color: '#b922ff',
                opacity: 0.8
            }],
            routingDelay: 1000,
            serviceOptions: {}
        },

        initialize: function initialize(options) {
            L.Util.setOptions(this, options);
        },

        /**
         * Method used to create markers on a map, basing on given points.
         *
         * @method createMarkers
         * @param {Object[]} points List of points to create markers onto
         */
        createMarkers: function createMarkers(points) {
            var that = this,
                markers = [],
                iconOptions,
                marker,
                point,
                i;

            var dragEndHandler = function dragEndHandler(event) {
                if (!isAtLeastPairOfPoints(points)) {
                    return;
                }
                onDragListener.call(that, points, event, markers, that.onDragEnd);
            };

            var dragHandler = function dragHandler(event) {
                if (!isAtLeastPairOfPoints(points)) {
                    return;
                }
                onDragListener.call(that, points, event, markers, that.onDrag);
            };

            for (i = 0; i < points.length; i++) {
                point = points[i];

                if (point !== undefined) {
                    iconOptions = getIconOptions(points, i, this.options);
                    marker = L.marker(point, iconOptions);
                    markers.push(marker);

                    if (iconOptions.draggable) {
                        marker.on('dragend', dragEndHandler);
                        marker.on('drag', dragHandler);
                    }
                }
            }

            delete this.markers;
            if (markers.length > 0) {
                this.markers = L.featureGroup(markers);
                this.markers.addTo(this._map);
            }
        },

        /**
         * Draws a route on the map between given points.
         *
         * This method executes TomTom Routing Service to get a route.
         * If a route is found, it will draws it on the map. If not, a proper notification will be show.
         *
         * @method createRoute
         * @param {String[]|String} points List of points to create a route between.
         * The format expected is:
         *  - ["52.37245,4.89406", "51.37245,5.89406"]
         *  - "52.37245,4.89406:51.37245,5.89406"
         *
         * Read the Routing Service documentation to get more information about this property format options.
         */
        createRoute: function createRoute(points) {
            var that = this;
            this.options.serviceOptions.locations = points;
            routingService(this.options.serviceOptions).go().then(function (routeGeoJson) {
                if (routeGeoJson.features.length > 0) {
                    that.drawRouteWithGeoJson(routeGeoJson);
                } else {
                    that.clearRoute();
                    L.messageBox({
                        closeAfter: 1500
                    }).openOn(that._map).setContent('Could not find a route. <br/>You might trying to route between continents.');
                }
            }).catch(function (reason) {
                that.fire(that.Events.RouteNotFound, reason);
            });
        },

        /**
         * Method executed when the user drag a marker.
         *
         * Allows to look for routes while dragging a marker and within delay
         * equal to the value passed in the option `routingDelay`.
         *
         * @method onDrag
         * @param {String[]|String} points List of points to create a route within.
         * This value will be passed to {{#crossLink "L.RouteOnMap/createRoute:method"}}{{/crossLink}}
         * for create the new route.
         */
        onDrag: function onDrag(points) {
            var that = this;
            if (this.recalculateRoute === true) {
                setTimeout(function () {
                    that.clearRoute();
                    that.createRoute(points);
                    that.recalculateRoute = true;
                }, this.options.routingDelay);
                this.recalculateRoute = false;
            }
        },

        /**
         * Method executed when the user drops a marker (equal to dragEnd event).
         *
         * Redraws route according to given points
         * and executes TomTom Reverse Geocode Service to get human-readable location when marker was dropped. That
         * fires the {{#crossLink "L.RouteOnMap/L.RouteOnMap.Events.MarkerDragEnd:event"}}{{/crossLink}} event with
         * service's call result and index of a marker.
         *
         * @method onDragEnd
         * @param {String[]|String} points List of points.
         * The expected format is:
         *  - ["52.37245,4.89406", "51.37245,5.89406"]
         *  - "52.37245,4.89406:51.37245,5.89406"
         * @param {Number} index Index of the marker that was dropped
         */
        onDragEnd: function onDragEnd(points, index) {
            var that = this;
            this.clearRoute();
            this.createRoute(points);
            this.once(this.Events.RouteChanged, this.fitMapBoundsToRoute, this);

            reverseGeocodeService().position(points[index]).go().then(function (result) {
                that.fire(that.Events.MarkerDragEnd, {
                    object: result,
                    markerIndex: index
                });
            });
        },

        /**
         * Method that removes all markers.
         *
         * @method clearMarkers
         */
        clearMarkers: function clearMarkers() {
            if (this.markers) {
                this.markers.clearLayers();
            }
            this.markers = undefined;
        },

        /**
         * Method that clears shown route.
         *
         * @method clearMarkers
         */
        clearRoute: function clearRoute() {
            if (this.routeOnMapLayer) {
                this._map.removeLayer(this.routeOnMapLayer);
            }
            this.routeOnMapLayer = undefined;
        },

        /**
         * Method that fits map to the drawn route.
         *
         * @method fitMapBoundsToRoute
         */
        fitMapBoundsToRoute: function fitMapBoundsToRoute() {
            var areaToBoundTo = this.routeOnMapLayer || this.markers;
            if (areaToBoundTo) {
                this._map.fitBounds(areaToBoundTo.getBounds(), {
                    padding: [5, 5]
                });
            }
        },

        /**
         * Method that draws a route basing on a passed geoJson. Fires the
         * {{#crossLink "L.RouteOnMap/L.RouteOnMap.Events.RouteChanged:event"}}{{/crossLink}} event.
         *
         * @method drawRouteWithGeoJson
         * @param {Object} geoJson Represents geoJson data of a route
         */
        drawRouteWithGeoJson: function drawRouteWithGeoJson(geoJson) {
            this.clearRoute();
            this.routeOnMapLayer = L.geoJson(geoJson, {
                onEachFeature: this.options.onEachFeature,
                style: getRouteStyle(this.options.serviceOptions.maxAlternatives > 0 ? this.options.alternativeStyles.concat([this.options.routeStyle]) : this.options.routeStyle)
            });
            this._map.addLayer(this.routeOnMapLayer);
            this.fire(this.Events.RouteChanged, {
                object: geoJson.features[0].properties.summary,
                instructions: geoJson.features[0].properties.guidance,
                geoJson: geoJson
            });
        },

        /**
         * Method that takes care of redrawing markers and a route.
         *
         * @method drawRoute
         * @param {String[]|String} points List of points to draw a route between.
         * The format expected is:
         *  - ["52.37245,4.89406", "51.37245,5.89406"]
         *  - "52.37245,4.89406:51.37245,5.89406"
         */
        drawRoute: function drawRoute(points) {
            this.clear();
            this.recalculateRoute = true;
            this.createMarkers(points);

            if (points.length >= 2) {
                this.createRoute(points);
            }
        },

        /**
         * The method to draw a route between two or more points.
         *
         * @method draw
         * @param {Object[]} points Array of geographical locations that between route will be drawn. There are
         *     multiple formats supported (see more at e.g. _Search_ page in _center_ method). This method also
         *     fires the {{#crossLink "L.RouteOnMap/L.RouteOnMap.Events.Draw:event"}}{{/crossLink}} event that
         *     announces that route is drawn.
         * @example
         * ```javascript
         * var startPoint = {lat: 49.29917, lon: 19.94902};
         * var waypoint = {lat: 42.25917, lon: 19.98902};
         * var endPoint = {lat: 52.23498, lon: 21.00849};
         * var points = [startPoint, waypoint, endPoint];
         * var routeOnMapView = (new L.RouteOnMap()).addTo(map);
         * routeOnMapView.draw(points);
         * ```
         */
        draw: function draw(points) {
            points = convertPoints(points);
            points = getAllFilledLocations(points);
            this.drawRoute(points);
            this.fitMapBoundsToRoute();
            this.once(this.Events.RouteChanged, this.fitMapBoundsToRoute, this);
            this.fire(this.Events.Draw, {});
        },

        /**
         * The method to clear a route and markers.
         *
         * @method clear
         * @example
         * ```javascript
         * var routeOnMapView = (new L.RouteOnMap(optionsForRouteOnMapView)).addTo(map);
         * routeOnMapView.clear();
         * ```
         */
        clear: function clear() {
            this.clearMarkers();
            this.clearRoute();
        },

        /**
         * Event that is fired after dropping the marker. Contains information about marker's position.
         *
         * @event MarkerDragEnd
         * @param {Object} object Information of dropped marker's position (got from reverse geocode service)
         * @param {Number} markerIndex Index of the marker on a map
         * @param {String} [type="markerDragEnd"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var routeOnMapView = routeOnMap().addTo(map);
         * routeOnMapView.on(L.RouteOnMap.Events.MarkerDragEnd, function(eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired after drawing a route on a map.
         *
         * @event Draw
         * @param {String} [type="draw"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var routeOnMapView = (new L.RouteOnMap()).addTo(map);
         * routeOnMapView.on(L.RouteOnMap.Events.Draw, function(eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when route was changed.
         *
         * @event RouteChanged
         * @param {Object} object Route summary that contains arrival time, departure time, route length, traffic
         *      and travel time.
         * @param {String} [type="routeChanged"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var routeOnMapView = (new L.RouteOnMap()).addTo(map);
         * routeOnMapView.on(L.RouteOnMap.Events.RouteChanged, function(eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        Events: EVENTS
    });

    return function (options) {
        var routeOnMap = new L.RouteOnMap(options);
        utils.addDeprecatedProperty(routeOnMap, 'Event', 'Events');
        return routeOnMap;
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Widget to display additional route information in a panel over the map.
 *
 * The panel contains an icon, distance and arrival time for the route.
 * 
 * This widget requires route data to work correcly. For more information please refer to our 
 * <a href="https://developer.tomtom.com/maps-sdk-web/functional-examples#routing_ab_summary" target="_blank">
 * Routing with summary example</a>.
 *
 * @example
 * ```javascript
 * var widget = new L.RouteSummary({
 *   size: [270, 268],
 *   position: 'topleft'
 * });
 * widget.addTo(map);
 * ```
 *
 * @class RouteSummary
 * @namespace L
 * @extends L.Control
 * @module Widgets
 * @constructor
 * @method routeSummary
 * @param {Object} [options] Options to setup control
 * @param {Number[]} [options.size=[320,320]]  Width and height in pixels for the panel
 * @param {"topleft"|"topright"|"bottomleft"|"bottomright"} [options.position="topleft"] Where to add view
 * @param {Boolean} [options.imperialDistance=null] Set this option if you want to use a specific unit measurement
 *     system for the new instance of the widget.
 *     If no unit system is defined upon, the widget will use the global unit measurement configuration.
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(15), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, unitFormatConverter, unitTypes) {
    'use strict';

    function initPanelResult(className, control) {
        var divPanelRouteResultWrapper = L.DomUtil.create('div', className + '-route-result-wrapper', control.divPanelRouteResult);
        control.divPanelRouteResult = L.DomUtil.create('div', className + '-route-result', control._container);
        control.divPanelRouteDeparture = L.DomUtil.create('div', className + '-leave', control.divPanelRouteResult);
        control.divPanelRouteDeparture.innerHTML = 'Leave: now';
        control.divPanelRouteCostModel = L.DomUtil.create('div', className + '-route-cost-model', divPanelRouteResultWrapper);
        control.divPanelRouteTime = L.DomUtil.create('div', className + '-route-time', divPanelRouteResultWrapper);

        control.divPanelRouteTrafficDelay = L.DomUtil.create('div', className + '-route-traffic-delay', divPanelRouteResultWrapper);
    }

    function createPanelArriveDistance(className, control, parent) {
        var divPanelRouteArriveDistance = L.DomUtil.create('div', className + '-route-arrive-row', parent);
        var divPanelRouteArriveDistanceLabel = L.DomUtil.create('div', className + '-route-arrive-cell-left', divPanelRouteArriveDistance);
        divPanelRouteArriveDistanceLabel.innerHTML = 'Distance:';
        control.divPanelRouteArriveDistanceValue = L.DomUtil.create('div', className + '-route-arrive-cell-right', divPanelRouteArriveDistance);
    }

    function createPanelArriveTime(className, control, parent) {
        var divPanelRouteArriveTime = L.DomUtil.create('div', className + '-route-arrive-row', parent);
        var divPanelRouteArriveTimeLabel = L.DomUtil.create('div', className + '-route-arrive-cell-left', divPanelRouteArriveTime);

        divPanelRouteArriveTimeLabel.innerHTML = 'Arrive:';

        control.divPanelRouteArriveTimeValue = L.DomUtil.create('div', className + '-route-arrive-cell-right', divPanelRouteArriveTime);
    }

    function initPanelArrive(className, control) {
        var divPanelRouteArrive = L.DomUtil.create('div', className + '-arrive', control._container);
        createPanelArriveDistance(className, control, divPanelRouteArrive);
        createPanelArriveTime(className, control, divPanelRouteArrive);
    }

    function createDOMElements(control) {
        var className = 'leaflet-control-route-summary',
            container = L.DomUtil.create('div', className + ' leaflet-control'),
            divHeading = L.DomUtil.create('div', className + '-heading', container);
        container.style.width = control.options.size[0] + 'px';
        container.style.height = control.options.size[1] + 'px';
        divHeading.innerHTML = 'Route summary';
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);
        control._container = container;
        initPanelResult(className, control);
        initPanelArrive(className, control);
        container.style.visibility = 'hidden';

        return container;
    }

    L.RouteSummary = L.Control.extend({
        includes: L.Evented.prototype,

        options: {
            size: [320, 320],
            position: 'topleft',
            imperialDistance: null
        },

        /**
         * @ignore
         * This store the route summary data currently visible in the widget.
         * @type {Object}
         */
        _currentData: null,

        /**
         * @ignore
         * @type {Boolean}
         */
        _currentDataShouldBeImperial: null,

        /**
         * Leaflet init method executed when adding control to map.
         * Options will be stored inside control.
         *
         * @ignore
         * @method initialize
         * @param {Object} [options] Options to setup control
         */
        initialize: function initialize(options) {
            L.Util.setOptions(this, options);
            this._attributions = {};
        },

        /**
         * Leaflet method executed when adding control to map.
         * Map will be stored inside control.
         *
         * @ignore
         * @method onAdd
         * @param {Object} map The map instance to which control is added.
         * @return {HTMLElement}
         */
        onAdd: function onAdd(map) {
            this.unitService = map.getUnitService();
            this.unitService.on(L.UnitService.Events.UNIT_CHANGED, this._redraw, this);
            return createDOMElements(this);
        },

        /**
         * @ignore
         */
        onRemove: function onRemove() {
            this.unitService.off(L.UnitService.Events.UNIT_CHANGED, this._redraw, this);
        },

        /**
         * Hides the route summary.
         *
         * By default the summary will be hidden until the method
         * {{#crossLink "L.RouteSummary/updateSummaryData:method"}}{{/crossLink}} is called.
         *
         * @method hide
         */
        hide: function hide() {
            this._container.style.visibility = 'hidden';
        },

        /**
         * Shows the route summary.
         *
         * By default summary will be hidden.
         * Use this method to show the control after data is ready.
         *
         * @method show
         */
        show: function show() {
            this._container.style.visibility = '';
        },

        /**
         * Method to update data after route is recalculated.
         *
         * Use this method to update data after each route calculation.
         *
         * @method updateSummaryData
         * @param {Object} routeSummary Routing properties object
         * @param {Number} routeSummary.travelTimeInSeconds
         * @param {Number} routeSummary.trafficDelayInSeconds
         * @param {Number} routeSummary.lengthInMeters
         * @param {String|Number} routeSummary.arrivalTime Date in milliseconds or a string in RFC-3339 format
         * @param {Boolean} [useImperial=null] If you set this parameter the unit system will be forced
         *     but only for this data
         */
        updateSummaryData: function updateSummaryData(routeSummary, useImperial) {
            this._currentData = routeSummary;
            this._currentDataShouldBeImperial = useImperial;
            this._redraw();
        },

        _redraw: function _redraw() {
            var data = this._currentData,
                useImperial = this._shouldUseImperialDistance(),
                converter = unitFormatConverter;
            if (typeof this._currentDataShouldBeImperial === 'boolean') {
                useImperial = this._currentDataShouldBeImperial;
            }
            if (data) {
                this.divPanelRouteTime.innerHTML = converter.formatTime(data.travelTimeInSeconds);
                this.divPanelRouteTrafficDelay.innerHTML = converter.formatTime(data.trafficDelayInSeconds) + ' traffic';
                this.divPanelRouteArriveDistanceValue.innerHTML = converter.formatDistance(data.lengthInMeters, useImperial);
                this.divPanelRouteArriveTimeValue.innerHTML = converter.formatHourAndMinute(data.arrivalTime);
                this.show();
            } else {
                this.hide();
            }
        },

        /**
         * @ignore
         * First check the configuration for this instance and then the global configuration.
         * The instance configuration has priority.
         *
         * @return {Boolean}
         */
        _shouldUseImperialDistance: function _shouldUseImperialDistance() {
            if (typeof this.options.imperialDistance === 'boolean') {
                return this.options.imperialDistance;
            }
            return this.unitService.getCurrentUnit().getLabel() === unitTypes.imperial;
        }
    });

    return function (options) {
        return new L.RouteSummary(options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * The MiniMap allows you to show a smaller map with low zoom level at a corner of the main map.
 *
 * It is based on [Leaflet-MiniMap plugin](https://github.com/Norkart/Leaflet-MiniMap).
 *
 * The default plugin functionality is integrated with TomTom SDK.
 * 
 * If you want to use vector source in the MiniMap the basePath must be specified. 
 * Keep this in mind when you switch from raster to vector source, for example when opening our examples in CodePen, 
 * otherwise the MiniMap will not render properly.
 *
 * @example
 * ```javascript
 * tomtom.key("<your-tomtom-API-key>");
 * var miniMapOptions = {height: 90, width: 120};
 * var map = new L.Map("map");
 * var miniMapControl = new L.TomTomMinimap(miniMapOptions);
 * miniMapControl.addTo(map);
 * ```
 *
 * @example
 * ```javascript
 * var widget = new L.TomTomMinimap({
 *   height: 90,
 *   width: 120,
 *   // zoom difference between the main map and minimaps (defaults to -8)
 *   zoomLevelOffset: -8,
 *
 *   // below options have default values:
 *   toggleDisplay: true,     // show a button to hide/show mini-map
 *   zoomAnimation: true,     // animate zoom changes
 *   autoToggleDisplay: true, // hide mini-map automatically if it's not needed
 *   mapOptions: {
 *     source: ["raster", "vector"],
 *     minZoom: 2, // min zoom of mini-map
 *     maxZoom: 4  // max zoom of mini-map
 *     basePath: 'basePath/sdk' // used for vector maps
 *   }
 * });
 * widget.addTo(map);
 * ```
 *
 * @class TomTomMinimap
 * @namespace L
 * @extends L.Control.MiniMap
 * @module Widgets
 * @constructor
 * @param {Object} [options] Options to be passed to the MiniMap
 * @param {String} [options.position="bottomright"] The standard Leaflet.Control position parameter,
 *     used like all the other controls. Defaults to 'bottomright'.
 * @param {Number} [options.width=150] The width of the minimap in pixels
 * @param {Number} [options.height=150] The height of the minimap in pixels
 * @param {Number} [options.collapsedWidth=19] The width in pixels of the toggle marker and the minimap
 *     when collapsed
 * @param {Number} [options.collapsedHeight=19] The height in pixels of the toggle marker and the minimap
 *     when collapsed
 * @param {Number} [options.zoomLevelOffset=-8] The offset applied to the zoom in the minimap compared
 *     to the zoom of the main map. Can be positive or negative.
 * @param {Number} [options.zoomLevelFixed=null] Overrides the offset to apply a fixed zoom level
 *     to the minimap regardless of the main map zoom. Set it to any valid zoom level.
 *     If unset `zoomLevelOffset` is used instead.
 * @param {Boolean} [options.centerFixed=false] Applies a fixed position to the minimap regardless
 *     of the main map's view / position. Prevents panning the minimap, but does allow zooming
 *     (both in the minimap and the main map). If the minimap is zoomed, it will always
 *     zoom around the centerFixed point. You can pass in a LatLng-equivalent object.
 * @param {Boolean} [options.zoomAnimation=false] Sets whether the minimap should have an animated zoom.
 *     (Will cause it to lag a bit after the movement of the main map.)
 * @param {Boolean} [options.toggleDisplay=false] Sets whether the minimap should have a button to minimize it
 * @param {Boolean} [options.autoToggleDisplay=false] Sets whether the minimap should hide automatically
 *     if the parent map bounds does not fit within the minimap bounds.
 *     Especially useful when `zoomLevelFixed` is set.
 * @param {Boolean} [options.minimized=false] Sets whether the minimap should start in a minimized position
 * @param {Object} [options.aimingRectOptions] Sets the style of the aiming rectangle by passing in
 *     a <a href="http://leafletjs.com/reference-${leaflet.version}.html#path-options">Path.Options object</a>.
 *     (Clickable will always be overridden and set to `false`).
 * @param {Object} [options.shadowRectOptions] Sets the style of the aiming shadow rectangle by passing in a
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#path-options">Path.Options object</a>.
 *     (Clickable will always be overridden and set to `false`).
 * @param {Object} [options.strings] Overrides the default strings allowing for translation
 * @param {Object} [options.mapOptions] Sets Leaflet options for the MiniMap.
 *     It does not override the MiniMap default map options but extends them.
 *     See regular map options for more details.
 * @param {String} [options.basePath = '/sdk'] Base path for sdk. It will be used in relative paths - it is 
 * especially important for maps with vector sources. For instance, if you set this option to `"/myPath"`, 
 * default urls for styles will be set to `/myPath/styles/basic_main.json`
 */
/* jshint nomen:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(198)], __WEBPACK_AMD_DEFINE_RESULT__ = function (L, MiniMap) {
    'use strict';

    var MAP_LAYER_DEFAULT_OPTIONS = {
        zoom: 2,
        minZoom: 2,
        maxZoom: 10
    },
        CONTROL_DEFAULT_OPTIONS = {
        toggleDisplay: true,
        zoomAnimation: true,
        autoToggleDisplay: true,
        zoomLevelOffset: -5
    };

    L.TomTomMinimap = MiniMap.extend({
        /**
         * Returns current zoom level of the mini map.
         *
         * @method getZoom
         * @return {Number}
         */
        getZoom: function getZoom() {
            return this._miniMap.getZoom();
        },
        /**
         * Add listeners for a particular event type. Event handlers for events with 'map-' prefix
         * are added to minimap map instance directly.
         *
         * @method on
         * @param {String} eventName
         * @param {Function} eventHandler
         * @return {Object} Returns reference to current instance of minimap widget
         */
        on: function on(eventName, eventHandler) {
            var regexMatch, mapEventName;
            if (!eventName || !eventHandler) {
                return this;
            }
            regexMatch = /^map-(.+)$/.exec(eventName);
            if (regexMatch) {
                mapEventName = regexMatch[1];
                this._miniMap.on(mapEventName, eventHandler);
            }
            return this;
        },
        _getMinimapBaseLayer: function _getMinimapBaseLayer(source) {
            return this._miniMap.getBaseLayers()[source || this.options.mapOptions.source[0]];
        },
        /**
         * Change a source data for the current mini map. It should be one of the sources provided
         * at creation in a property <b>options.mapOptions.source</b>.
         *
         * @method setMapSource
         * @param {String} source A source of data for the mini map. It has to be one of the
         *     {{#crossLink "L.Map"}}{{/crossLink}} supported sources.
         */
        setMapSource: function setMapSource(source) {
            this._miniMap.removeLayer(this._layer);
            this._miniMap.setMapSource(source);
            this._layer = this._getMinimapBaseLayer(source);
        },
        initialize: function initialize(options) {
            /*
               This `dummyLayer` requires few words of explanation. Although it doesn't look like it this is the
               cleanest way to move decision about layer configuration from this file to map.js instance created
               inside MiniMap.onAdd method. Unfortunately, MiniMap plugin requires that a layer needs to be provided
               that's the reason behind this `dummyLayer`. This change was caused by LNS-16272.
             */
            var dummyLayer = new L.LayerGroup();
            MiniMap.prototype.initialize.call(this, dummyLayer, options);
        }
    });

    return function (options) {

        if (!options) {
            options = {};
        }

        options.mapOptions = L.extend(MAP_LAYER_DEFAULT_OPTIONS, options.mapOptions);
        options = L.extend(CONTROL_DEFAULT_OPTIONS, options);

        if (options.mapOptions.minZoom > options.mapOptions.maxZoom) {
            options.mapOptions.minZoom = options.mapOptions.maxZoom;
        }

        return new L.TomTomMinimap(options);
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(factory,window){if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof exports==="object"){module.exports=factory(require("leaflet"))}if(typeof window!=="undefined"&&window.L){window.L.Control.MiniMap=factory(L);window.L.control.minimap=function(layer,options){return new window.L.Control.MiniMap(layer,options)}}})(function(L){var MiniMap=L.Control.extend({includes:L.Evented?L.Evented.prototype:L.Mixin.Events,options:{position:"bottomright",toggleDisplay:false,zoomLevelOffset:-5,zoomLevelFixed:false,centerFixed:false,zoomAnimation:false,autoToggleDisplay:false,minimized:false,width:150,height:150,collapsedWidth:19,collapsedHeight:19,aimingRectOptions:{color:"#ff7800",weight:1,clickable:false},shadowRectOptions:{color:"#000000",weight:1,clickable:false,opacity:0,fillOpacity:0},strings:{hideText:"Hide MiniMap",showText:"Show MiniMap"},mapOptions:{}},initialize:function(layer,options){L.Util.setOptions(this,options);this.options.aimingRectOptions.clickable=false;this.options.shadowRectOptions.clickable=false;this._layer=layer},onAdd:function(map){this._mainMap=map;this._container=L.DomUtil.create("div","leaflet-control-minimap");this._container.style.width=this.options.width+"px";this._container.style.height=this.options.height+"px";L.DomEvent.disableClickPropagation(this._container);L.DomEvent.on(this._container,"mousewheel",L.DomEvent.stopPropagation);var mapOptions={attributionControl:false,dragging:!this.options.centerFixed,zoomControl:false,zoomAnimation:this.options.zoomAnimation,autoToggleDisplay:this.options.autoToggleDisplay,touchZoom:this.options.centerFixed?"center":!this._isZoomLevelFixed(),scrollWheelZoom:this.options.centerFixed?"center":!this._isZoomLevelFixed(),doubleClickZoom:this.options.centerFixed?"center":!this._isZoomLevelFixed(),boxZoom:!this._isZoomLevelFixed(),crs:map.options.crs};mapOptions=L.Util.extend(this.options.mapOptions,mapOptions);this._miniMap=new L.Map(this._container,mapOptions);this._miniMap.addLayer(this._layer);this._mainMapMoving=false;this._miniMapMoving=false;this._userToggledDisplay=false;this._minimized=false;if(this.options.toggleDisplay){this._addToggleButton()}this._miniMap.whenReady(L.Util.bind(function(){this._aimingRect=L.rectangle(this._mainMap.getBounds(),this.options.aimingRectOptions).addTo(this._miniMap);this._shadowRect=L.rectangle(this._mainMap.getBounds(),this.options.shadowRectOptions).addTo(this._miniMap);this._mainMap.on("moveend",this._onMainMapMoved,this);this._mainMap.on("move",this._onMainMapMoving,this);this._miniMap.on("movestart",this._onMiniMapMoveStarted,this);this._miniMap.on("move",this._onMiniMapMoving,this);this._miniMap.on("moveend",this._onMiniMapMoved,this)},this));return this._container},addTo:function(map){L.Control.prototype.addTo.call(this,map);var center=this.options.centerFixed||this._mainMap.getCenter();this._miniMap.setView(center,this._decideZoom(true));this._setDisplay(this.options.minimized);return this},onRemove:function(map){this._mainMap.off("moveend",this._onMainMapMoved,this);this._mainMap.off("move",this._onMainMapMoving,this);this._miniMap.off("moveend",this._onMiniMapMoved,this);this._miniMap.removeLayer(this._layer)},changeLayer:function(layer){this._miniMap.removeLayer(this._layer);this._layer=layer;this._miniMap.addLayer(this._layer)},_addToggleButton:function(){this._toggleDisplayButton=this.options.toggleDisplay?this._createButton("",this._toggleButtonInitialTitleText(),"leaflet-control-minimap-toggle-display leaflet-control-minimap-toggle-display-"+this.options.position,this._container,this._toggleDisplayButtonClicked,this):undefined;this._toggleDisplayButton.style.width=this.options.collapsedWidth+"px";this._toggleDisplayButton.style.height=this.options.collapsedHeight+"px"},_toggleButtonInitialTitleText:function(){if(this.options.minimized){return this.options.strings.showText}else{return this.options.strings.hideText}},_createButton:function(html,title,className,container,fn,context){var link=L.DomUtil.create("a",className,container);link.innerHTML=html;link.href="#";link.title=title;var stop=L.DomEvent.stopPropagation;L.DomEvent.on(link,"click",stop).on(link,"mousedown",stop).on(link,"dblclick",stop).on(link,"click",L.DomEvent.preventDefault).on(link,"click",fn,context);return link},_toggleDisplayButtonClicked:function(){this._userToggledDisplay=true;if(!this._minimized){this._minimize()}else{this._restore()}},_setDisplay:function(minimize){if(minimize!==this._minimized){if(!this._minimized){this._minimize()}else{this._restore()}}},_minimize:function(){if(this.options.toggleDisplay){this._container.style.width=this.options.collapsedWidth+"px";this._container.style.height=this.options.collapsedHeight+"px";this._toggleDisplayButton.className+=" minimized-"+this.options.position;this._toggleDisplayButton.title=this.options.strings.showText}else{this._container.style.display="none"}this._minimized=true;this._onToggle()},_restore:function(){if(this.options.toggleDisplay){this._container.style.width=this.options.width+"px";this._container.style.height=this.options.height+"px";this._toggleDisplayButton.className=this._toggleDisplayButton.className.replace("minimized-"+this.options.position,"");this._toggleDisplayButton.title=this.options.strings.hideText}else{this._container.style.display="block"}this._minimized=false;this._onToggle()},_onMainMapMoved:function(e){if(!this._miniMapMoving){var center=this.options.centerFixed||this._mainMap.getCenter();this._mainMapMoving=true;this._miniMap.setView(center,this._decideZoom(true));this._setDisplay(this._decideMinimized())}else{this._miniMapMoving=false}this._aimingRect.setBounds(this._mainMap.getBounds())},_onMainMapMoving:function(e){this._aimingRect.setBounds(this._mainMap.getBounds())},_onMiniMapMoveStarted:function(e){if(!this.options.centerFixed){var lastAimingRect=this._aimingRect.getBounds();var sw=this._miniMap.latLngToContainerPoint(lastAimingRect.getSouthWest());var ne=this._miniMap.latLngToContainerPoint(lastAimingRect.getNorthEast());this._lastAimingRectPosition={sw:sw,ne:ne}}},_onMiniMapMoving:function(e){if(!this.options.centerFixed){if(!this._mainMapMoving&&this._lastAimingRectPosition){this._shadowRect.setBounds(new L.LatLngBounds(this._miniMap.containerPointToLatLng(this._lastAimingRectPosition.sw),this._miniMap.containerPointToLatLng(this._lastAimingRectPosition.ne)));this._shadowRect.setStyle({opacity:1,fillOpacity:.3})}}},_onMiniMapMoved:function(e){if(!this._mainMapMoving){this._miniMapMoving=true;this._mainMap.setView(this._miniMap.getCenter(),this._decideZoom(false));this._shadowRect.setStyle({opacity:0,fillOpacity:0})}else{this._mainMapMoving=false}},_isZoomLevelFixed:function(){var zoomLevelFixed=this.options.zoomLevelFixed;return this._isDefined(zoomLevelFixed)&&this._isInteger(zoomLevelFixed)},_decideZoom:function(fromMaintoMini){if(!this._isZoomLevelFixed()){if(fromMaintoMini){return this._mainMap.getZoom()+this.options.zoomLevelOffset}else{var currentDiff=this._miniMap.getZoom()-this._mainMap.getZoom();var proposedZoom=this._miniMap.getZoom()-this.options.zoomLevelOffset;var toRet;if(currentDiff>this.options.zoomLevelOffset&&this._mainMap.getZoom()<this._miniMap.getMinZoom()-this.options.zoomLevelOffset){if(this._miniMap.getZoom()>this._lastMiniMapZoom){toRet=this._mainMap.getZoom()+1;this._miniMap.setZoom(this._miniMap.getZoom()-1)}else{toRet=this._mainMap.getZoom()}}else{toRet=proposedZoom}this._lastMiniMapZoom=this._miniMap.getZoom();return toRet}}else{if(fromMaintoMini){return this.options.zoomLevelFixed}else{return this._mainMap.getZoom()}}},_decideMinimized:function(){if(this._userToggledDisplay){return this._minimized}if(this.options.autoToggleDisplay){if(this._mainMap.getBounds().contains(this._miniMap.getBounds())){return true}return false}return this._minimized},_isInteger:function(value){return typeof value==="number"},_isDefined:function(value){return typeof value!=="undefined"},_onToggle:function(){L.Util.requestAnimFrame(function(){L.DomEvent.on(this._container,"transitionend",this._fireToggleEvents,this);if(!L.Browser.any3d){L.Util.requestAnimFrame(this._fireToggleEvents,this)}},this)},_fireToggleEvents:function(){L.DomEvent.off(this._container,"transitionend",this._fireToggleEvents,this);var data={minimized:this._minimized};this.fire(this._minimized?"minimize":"restore",data);this.fire("toggle",data)}});L.Map.mergeOptions({miniMapControl:false});L.Map.addInitHook(function(){if(this.options.miniMapControl){this.miniMapControl=(new MiniMap).addTo(this)}});return MiniMap},window);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// tomtom.min.js